/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * An Amazon Resource Number used to identify an AWS ACM certificate.
   * Validation regex: /^arn:aws:acm:us-east-1:[0-9]+:certificate\/[\d\w+=,.@-]+$/
   */
  AcmArn: any;
  AdditionalDeclarationTypeCode: any;
  /** Any type that passes the value through */
  Any: any;
  AtfCategoryCode: any;
  /** Custom scalar for flexible values: string, number, boolean, string[], number[] */
  AttributeValue: any;
  /**
   * AWS Account Id
   * Validation regex: /^\d{12}$/
   */
  AwsAccountId: any;
  /**
   * A base 64 encoded image string.
   * Validation regex: /data:image\/([a-zA-Z]*);base64,([^\"]*)/
   */
  Base64ImageString: any;
  /** BusinessRuleValue */
  BusinessRuleValue: any;
  /**
   * Case Number
   * Validation regex: /^[AC]\d{9}$/
   */
  CaseNumber: any;
  /**
   * A CBP Assigned Importer of Record number.
   * Validation regex: /^\d{6}-\d{5}$/
   */
  CbpAssignedNumber: any;
  ClassificationIdentificationTypeCode: any;
  /** Validate the character limitation of container description. */
  ContainerDescription: any;
  /** Validate the character limitation of conveyance name. */
  ConveyanceName: any;
  /** An 2-letter ISO 3166-1 alpha-2 country code. https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 */
  CountryCode: any;
  /** An 2-letter ISO 3166-1 alpha-2 country code. https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 or N/A */
  CountryCodeOrNotApplicable: any;
  /**  An  ISO 3166-2 country subdivision code. https://en.wikipedia.org/wiki/ISO_3166-2 */
  CountrySubdivisionCode: any;
  /**
   * Three-letter uppercase culture code.
   * Validation regex: /^[A-Z]{3}$/
   */
  CultureCode: any;
  /** A 3-letter ISO 4217 currency code https://en.wikipedia.org/wiki/ISO_4217 */
  CurrencyCode: any;
  /**
   * A Dun & Bradstreet Data Universal Numbering System number https://www.dnb.com/duns-number.htm
   * Validation regex: /^\d{9}|UNK$/
   */
  DUNS: any;
  Date: any;
  DateTime: any;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime__patched_over_by_INLT: any;
  /**
   * Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State
   * Validation regex: /^[a-z|A-Z]{2}\w{0,15}$/
   */
  DeEori: any;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country
   * Validation regex: /^(de|DE)([1-9]\d{8}$)/
   */
  DeVatNumber: any;
  /**
   * Defines the type of content within the document, also known as the MIME type (e.g. text/html). Will be inferred from the file extension if not provided.
   * Validation regex: /^[a-z0-9/\.\-+]+$/
   */
  DocumentContentType: any;
  /**
   * Path of the field, expected to be dot-separated with optional array indices
   * Validation regex: /^(\[\d+\])?(\w+(\[\d+\])?(\.\w+(\[\d+\])?)*)$/
   */
  DotSeparatedPathWithIndicesValue: any;
  DutyTaxFeeTypeCode: any;
  /**
   * An email address string.
   * Validation regex: /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/
   */
  Email: any;
  /**
   * A business's EIN number provided by the IRS.
   * Validation regex: /^\d{2}-\d{7}$/
   */
  EmployeeIdentificationNumber: any;
  /** A 4 digit alpha-numeric identifier assigned by US CBP to any bonded facility. */
  FirmsCode: any;
  /**
   * Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State
   * Validation regex: /^[a-z|A-Z]{2}\w{0,15}$/
   */
  FrEori: any;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country
   * Validation regex: /^(fr|FR)[0-9A-Za-z]{2}[0-9]{9}$/
   */
  FrVatNumber: any;
  /**
   * All-numeric Global Trade Item Number that can be 8, 12, 13, or 14 digits long.
   * Validation regex: /^(?:\d{8}|\d{12,14})$/
   */
  GTIN: any;
  /**
   * Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State
   * Validation regex: /^(GB|gb|XI|xi|XU|xu)\d{0,15}$/
   */
  GbEori: any;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country
   * Validation regex: /^(GB)[0-9]{3} *[0-9]{4} *[0-9]{2}$/i
   */
  GbVatNumber: any;
  /**
   * An 4, 6 or 8-10 digit classification number assigned by the Harmonized Tariff Schedule classifies based on a good's name, use, and/or the material used in its construction.
   * Validation regex: /^\d{4}\.?(\d{2})?\.?(\d{2}){0,2}$/
   */
  HtsNumber: any;
  /** A code representing the International Organization for Standardization (ISO) country of origin edit code. This code is either an ISO country code, a code of 01 indicating the country of origin is a country eligible for the general column 1 duty rate, or a code of 02 indicating the country of origin is a country listed in General Note 3(a)(iv)(b) of the HTS and is eligible for the Column 2 rate. */
  HtsRestrictionCountryOfOriginEditCode: any;
  /**
   * An Amazon Resource Number used to identify an AWS IAM role.
   * Validation regex: /^arn:aws:iam::[0-9]{12}:role(\/[\w+=,.@-]+)+$/
   */
  IamRoleArn: any;
  /**
   * 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split.
   * Validation regex: /^[0-9]{2}[A-Za-z]{2}[0-9A-Za-z]{14}$|^[A-Za-z]{2}[0-9]{9}[A-Za-z]{2}$/
   */
  ImportEntryNumber: any;
  /**
   * An INLT U.S. In-Bond Number is constructed via an 8 digit number followed by a "check" digit which is computed by taking the first 8 digits modulo 7
   * Validation regex: /^\d{8}[0-6]{1}$/
   */
  InltUsInBondNumber: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /**
   * A name to identify the kinesis data stream
   * Validation regex: /^[a-zA-Z0-9_.-]+$/
   */
  KinesisStreamName: any;
  MOTCode: any;
  Month: any;
  /**
   * Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State
   * Validation regex: /^[a-z|A-Z]{2}\w{0,15}$/
   */
  NlEori: any;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country
   * Validation regex: /(^(NL)(\d{9}B\d{2}$))|(^(DE)([1-9]\d{8}$))/i
   */
  NlVatNumber: any;
  /**
   * The numerical code used to identify a Passport.
   * Validation regex: /^[A-Z0-9]*$/
   */
  PassportNumber: any;
  Percentage: any;
  /**
   * A PGA (Partner Government Agency) Flag
   * Validation regex: /^[A-Z]{2}[0-9]$/
   */
  PgaFlag: any;
  /**
   * Precise Date Time
   * Validation regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/
   */
  PreciseDateTime: any;
  /**
   * Amazon Standard Identification Number associated with the product
   * Validation regex: /^[A-Za-z0-9]{10}$/
   */
  ProductAsinIdentifier: any;
  /**
   * Query Case Number
   * Validation regex: /^[AC]\d{6}(\d{3}){0,1}$/
   */
  QueryCaseNumber: any;
  ReleaseBillDispositionCode: any;
  ReleaseDispositionCode: any;
  ReleaseOriginCode: any;
  /**
   * Standard Carrier Alpha Code
   * Validation regex: /^([A-Z]{2,5}|[0-9]{1}[A-Z]{1}|[A-Z]{1}[0-9]{1})$/
   */
  SCACCode: any;
  /**
   * Shipment Client Identifier does not accept line feed, tab character, form feed or vertical tab character
   * Validation regex: /^[^\n\t\f\v]+$/
   */
  ShipmentClientIdentifier: any;
  /**
   * An Amazon Resource Number used to identify an AWS SNS topic.
   * Validation regex: /^arn:aws:sns:[a-z0-9\-]+:[0-9]+:[a-zA-Z0-9\-\_]+(|\.fifo)$/
   */
  SnsArn: any;
  /**
   * A Social Security Number.
   * Validation regex: /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/
   */
  SocialSecurityNumber: any;
  /**
   * Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State
   * Validation regex: /^(GB|gb|XI|xi|XU|xu)\d{0,15}$/, /^[a-z|A-Z]{2}\w{0,15}$/
   */
  SupportedCountryEori: any;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country
   * Validation regex: /^(GB)[0-9]{3} *[0-9]{4} *[0-9]{2}$/i, /(^(NL)(\d{9}B\d{2}$))|(^(DE)([1-9]\d{8}$))/i, /^(de|DE)([1-9]\d{8}$)/, /^(fr|FR)[0-9A-Za-z]{2}[0-9]{9}$/, /^(IT)[0-9]{11}$/, /^(ES)([0-9]{8}[A-Z]|[A-Z][0-9]{7}[0-9A-Z])$/, /^(PL)\d{10}$/, /^(ATU)\d{8}$/, /^(CZ)\d{8,10}$/
   */
  SupportedCountryVatNumber: any;
  TaxClassCode: any;
  /** The value should be a string with length no greater than 10000. */
  TextSearchCriteriaInputValue: any;
  /**
   * Section 301 (Trump Tariffs) list number.
   * Validation regex: /(1|2|3|4A|4B)/
   */
  TrumpList: any;
  /**
   * Uniform Resource Locator (web address)
   * Validation regex: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
   */
  URL: any;
  /**
   * Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State
   * Validation regex: /^(GB|gb|XI|xi|XU|xu)\d{0,15}$/
   */
  UkEori: any;
  UnLocode: any;
  /**
   * Uniform Resource Locator (web address)
   * Validation regex: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
   */
  Url: any;
  UsBondTypeCode: any;
  UsBondWaiverReasonCode: any;
  UsCbpEntryPaymentType: any;
  UsCbpEntryTypeCode: any;
  /**
   * A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes
   * Validation regex: /^[A-Z0-9]{3}$/
   */
  UsCbpFilerCode: any;
  UsCbpForeignPortCode: any;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  UsCbpMid: any;
  /**
   * The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection.
   * Validation regex: /^\d{6}$/
   */
  UsCbpPayerUnitNumber: any;
  UsCbpPortCode: any;
  UsConsumptionEntryFeeCode: any;
  /** A number with up to 2 decimal places representing an amount in US Dollars ($). */
  UsDollars: any;
  UsDrawbackAccountingClassCode: any;
  UsDrawbackAccountingMethodCode: any;
  UsDrawbackProvisionCode: any;
  UsDrawbackUnitOfMeasureCode: any;
  /**
   * Us Entry Number
   * Validation regex: /^[A-Z0-9]{11}$/
   */
  UsEntryNumber: any;
  /**
   * A U.S. In-Bond Number is alphanumeric with a max length of 12
   * Validation regex: /^[a-zA-Z0-9]{1,12}$/
   */
  UsInBondNumber: any;
  /**
   * Importer of Record number registered with US CBP. Can be an Employee Identification Number, Social Security Number, or a CBP Assigned Number.
   * Validation regex: /^\d{2}-\d{7}[A-Z0-9]{2}$|^\d{3}-\d{2}-\d{4}$|^\d{6}-\d{5}$/
   */
  UsIorNumberValue: any;
  /**
   * The ISF number that generated by the US Customs ACE ABI Interface for each ISF.
   * Validation regex: /^[A-Z0-9]{3}-*\d{11}$/
   */
  UsIsfNumber: any;
  /**
   * Record number of Non-Reimbursement Certificate on file with CBP
   * Validation regex: /^[a-zA-Z0-9]{10}$/
   */
  UsNrbsRecordNumber: any;
  UsPgaProcessingTypeCodes: any;
  UsPgaSourceTypeCode: any;
  /** A code that identifies the reason that the submitted header data is being changed for a PSC */
  UsPostSummaryCorrectionHeaderReason: any;
  /** A code that identifies the reason that the submitted line data is being changed for a PSC. */
  UsPostSummaryCorrectionLineReason: any;
  /**
   * US Principal Case Number
   * Validation regex: /^[AC]\d{6}$/
   */
  UsPrincipalCaseNumber: any;
  /** A code indicating if a tariff number is subject to a special program. */
  UsSpecialProgramIndicator: any;
  /** 2 character standard ISO 3166 US state code. https://en.wikipedia.org/wiki/List_of_U.S._state_abbreviations */
  UsStateCode: any;
  /**
   * mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry.
   * Validation regex: /^[A-Za-z0-9]{5}$/
   */
  VendorCode: any;
  /** Source that triggered the milestone generation. */
  WorkOrderMilestoneSource: any;
  /**
   * The name of a Work Order State
   * Validation regex: /^[A-Z]+[a-zA-Z0-9_]+$/
   */
  WorkOrderStateName: any;
  Year: any;
};

export type AEOMutualRecognitionParty = {
  __typename?: 'AEOMutualRecognitionParty';
  /** Identification of the AEO mutual recognition party. */
  identification?: Maybe<Scalars['String']>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry?: Maybe<Scalars['String']>;
  /** Type of identification */
  identificationType?: Maybe<Scalars['String']>;
  /** Code specifying the role of a party. */
  role?: Maybe<Scalars['String']>;
  /** Sequence number for the AEOMutualRecognitionParty. */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

export type AEOMutualRecognitionPartyInput = {
  /** Identification of the AEO mutual recognition party. */
  identification?: InputMaybe<Scalars['String']>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry?: InputMaybe<Scalars['String']>;
  /** Type of identification */
  identificationType?: InputMaybe<Scalars['String']>;
  /** Code specifying the role of a party. */
  role?: InputMaybe<Scalars['String']>;
  /** Sequence number for the AEOMutualRecognitionParty. */
  sequenceNumber?: InputMaybe<Scalars['Float']>;
};

/** Information related to an ABI Exchange Message. */
export type AbiExchangeMessage = {
  __typename?: 'AbiExchangeMessage';
  /** The message in EDI format. */
  edi: Scalars['String'];
  /** The message in JSON format. */
  json: Scalars['JSONObject'];
  /** A code that gives business context to the request/response between CBP. */
  key: Scalars['String'];
  /** The time that the Exchange Message was created in S3. */
  time: Scalars['DateTime'];
};

export type Account = {
  /** Account details */
  accountDetails?: Maybe<AccountDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type AccountCreditDetails = {
  __typename?: 'AccountCreditDetails';
  /** Credit limit for billing party. */
  creditLimit: Cost;
};

export type AccountCreditDetailsInput = {
  /** Credit limit for billing party. */
  creditLimit: CostInput;
};

export type AccountDetails = {
  __typename?: 'AccountDetails';
  /** When the acccount was created */
  created: RecordAction;
  /** Teams within the account */
  teams: Array<Team>;
};

export type AccountTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<OnboardingAccountType>>;
};

export type AccountingPointOfContact = {
  __typename?: 'AccountingPointOfContact';
  /** Recipients who will receive a copy of the invoice email. */
  accountingCcEmails?: Maybe<Array<Scalars['Email']>>;
  /** Address. */
  address?: Maybe<Address>;
  /** Generic address that is WCO Data Model v4.0.0 compliant. */
  addressV2?: Maybe<AddressV2>;
  /** Point of Contact details */
  pointOfContact?: Maybe<PointOfContact>;
};

export type AccountingPointOfContactInput = {
  /** Recipients who will receive a copy of the invoice email. */
  accountingCcEmails?: InputMaybe<Array<Scalars['Email']>>;
  /** Address. */
  address?: InputMaybe<AddressInput>;
  /** Generic address that is WCO Data Model v4.0.0 compliant. */
  addressV2?: InputMaybe<AddressV2Input>;
  /** Point of Contact details */
  pointOfContact?: InputMaybe<PointOfContactInput>;
};

export type AccountingSystemCustomerReference = {
  __typename?: 'AccountingSystemCustomerReference';
  /** Accounting system customer reference type: qboId, qboSyncToken etc. */
  type: AccountingSystemReferenceType;
  /** Accounting system customer reference value. */
  value: Scalars['String'];
};

export type AccountingSystemCustomerReferencesInput = {
  /** Accounting system customer reference type: qboId, qboSyncToken etc. */
  type: AccountingSystemReferenceType;
  /** Accounting system customer reference value. */
  value: Scalars['String'];
};

export type AccountingSystemDetail = {
  __typename?: 'AccountingSystemDetail';
  /** Accounting system references */
  references: Array<AccountingSystemReference>;
};

export type AccountingSystemDetailInput = {
  /** Accounting system references */
  references: Array<AccountingSystemReferenceInput>;
};

export type AccountingSystemReference = {
  __typename?: 'AccountingSystemReference';
  /** Accounting system reference type. */
  type: AccountingSystemReferenceType;
  /** Accounting system reference value. */
  value: Scalars['String'];
};

export type AccountingSystemReferenceInput = {
  /** Accounting system reference type. */
  type: AccountingSystemReferenceType;
  /** Accounting system reference value. */
  value: Scalars['String'];
};

/** Accounting system reference type */
export enum AccountingSystemReferenceType {
  AR_CUSTOMER_ID = 'AR_CUSTOMER_ID',
  AR_INVOICE_ID = 'AR_INVOICE_ID',
  AR_ONBOARDING_COUNTRY = 'AR_ONBOARDING_COUNTRY',
  CLAIM_ID = 'CLAIM_ID',
  QBO_CUSTOMER_ID = 'QBO_CUSTOMER_ID',
  QBO_DOC_NUMBER = 'QBO_DOC_NUMBER',
  QBO_ID = 'QBO_ID',
  QBO_PAYMENT_ID = 'QBO_PAYMENT_ID',
  QBO_SYNC_TOKEN = 'QBO_SYNC_TOKEN'
}

/** Accounting Type (AR/AP) */
export enum AccountingType {
  ACCOUNTS_PAYABLE = 'ACCOUNTS_PAYABLE',
  ACCOUNTS_RECEIVABLE = 'ACCOUNTS_RECEIVABLE'
}

/** Accounts Payable Status */
export enum AccountsPayableStatus {
  AWAITING_CREATE = 'AWAITING_CREATE',
  CREATED = 'CREATED'
}

export type AccountsPayableStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<AccountsPayableStatus>>;
};

export type AccoutingTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<AccountingType>>;
};

/** The US CBP ABI transaction to update a US In-Bond, CATAIR appCode: WP/WT. */
export type ActionInBondCbpInput = {
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type ActionInBondCbpPayload = {
  __typename?: 'ActionInBondCbpPayload';
  /** The Transaction. */
  transaction: ActionInBondCbpTransaction;
};

/** The US CBP ABI transaction to update a US In-Bond, CATAIR appCode: WP/WT. */
export type ActionInBondCbpTransaction = Record & UsInBondCbpTransaction & {
  __typename?: 'ActionInBondCbpTransaction';
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US In-Bond */
  usInBond: UsInBond;
  /** The record's version */
  version: Scalars['Int'];
};

/** The type of action that the AuditLog represents. */
export enum ActionType {
  ASSIGNED = 'ASSIGNED',
  AUTHORIZED = 'AUTHORIZED',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  INQUIRED = 'INQUIRED',
  SUBMITTED = 'SUBMITTED',
  UPDATED = 'UPDATED',
  UPLOADED = 'UPLOADED'
}

export type ActivateUserPayload = {
  __typename?: 'ActivateUserPayload';
  /** Status of the activation */
  success: Scalars['Boolean'];
  /** The activated user */
  user: User;
};

/** Activation status of party */
export enum ActivationStatus {
  ACTIVATED = 'ACTIVATED',
  DELETED = 'DELETED',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  PENDING_CERT = 'PENDING_CERT',
  PENDING_DIRECT = 'PENDING_DIRECT',
  PENDING_DIRECT_CERT = 'PENDING_DIRECT_CERT',
  PENDING_INQUIRY = 'PENDING_INQUIRY',
  PENDING_MASTER = 'PENDING_MASTER',
  PENDING_MASTER_CERT = 'PENDING_MASTER_CERT',
  PENDING_MASTER_SUB = 'PENDING_MASTER_SUB',
  PENDING_MASTER_SUB_CERT = 'PENDING_MASTER_SUB_CERT',
  PENDING_SUB = 'PENDING_SUB',
  PENDING_SUB_CERT = 'PENDING_SUB_CERT',
  REJECTED = 'REJECTED'
}

/** IOR activation status */
export type ActivationStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ActivationStatus>>;
};

/** Represents a US CBP Anti-Dumping or Countervailing Duty Case. */
export type AdCvdCase = Record & {
  __typename?: 'AdCvdCase';
  /** Official Case name */
  bondOrCash: Array<CaseBondOrCash>;
  /** AD/CVD Case number */
  caseNumber: Scalars['CaseNumber'];
  /** The country of origin where the Case applies */
  countryCode: Scalars['CountryCode'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
  /** AD/CVD Case event history */
  events: Array<CaseEvent>;
  /** Unique ID */
  id: Scalars['ID'];
  /** AD/CVD Case liquidation suspension history */
  liquidationSuspensions: Array<CaseLiquidationSuspension>;
  /** The manufacturer the Case applies to */
  manufacturerName?: Maybe<Scalars['String']>;
  /** Official Case name */
  name: Scalars['String'];
  /** AD/CVD Case duty rates */
  rates: Array<CaseRate>;
  /** Link to the scope decision of the case */
  scopeUrl?: Maybe<Scalars['Url']>;
  /** The seller (foreign exporter) the Case applies to */
  sellerName?: Maybe<Scalars['String']>;
  /** Status of Case */
  status: AdCvdCaseStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** AD/CVD Case Tariff */
  tariffs: Array<CaseTariff>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** AD/CVD Case criteria request fields: AND logic for each field. User has to provide date or countryCode besides status */
export type AdCvdCaseCriteriaQuery = {
  __typename?: 'AdCvdCaseCriteriaQuery';
  /** Country code in the CBP AD/CVD case criteria query request */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** Date Since Last Update in the CBP AD/CVD case criteria query request */
  date?: Maybe<Scalars['Date']>;
  /** Company Case Status in the CBP AD/CVD case criteria query request */
  status: AdCvdCaseStatus;
};

export type AdCvdCaseCriteriaQueryInput = {
  /** Country code in the CBP AD/CVD case criteria query request */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Date Since Last Update in the CBP AD/CVD case criteria query request */
  date?: InputMaybe<Scalars['Date']>;
  /** Company Case Status in the CBP AD/CVD case criteria query request */
  status: AdCvdCaseStatus;
};

export type AdCvdCaseEdge = ConnectionEdge & {
  __typename?: 'AdCvdCaseEdge';
  cursor: Scalars['ID'];
  node: AdCvdCase;
};

/** The entry summary suspension action */
export enum AdCvdCaseLiquidationSuspensionAction {
  START = 'START',
  STOP = 'STOP'
}

export enum AdCvdCasePaymentMethod {
  BOND = 'BOND',
  CASH = 'CASH'
}

/** The type of payment accepted for the AdCvdCase */
export enum AdCvdCasePaymentOption {
  BOND_OR_CASH = 'BOND_OR_CASH',
  CASH_ONLY = 'CASH_ONLY',
  NA = 'NA'
}

export type AdCvdCaseSearchCriteria = {
  /** AD/CVD Case number */
  caseNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Hts numbers associated with the case number. */
  htsNumbers?: InputMaybe<HtsSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** AdCvdCase search table row. */
export type AdCvdCaseSearchTableRow = RecordSearchTableRow & {
  __typename?: 'AdCvdCaseSearchTableRow';
  /** AD/CVD Case number */
  caseNumber: Scalars['CaseNumber'];
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Status for a AdCvdCase. */
export enum AdCvdCaseStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE_COMPANY_DEACTIVATED = 'INACTIVE_COMPANY_DEACTIVATED',
  INACTIVE_COMPANY_LOST_SEPARATE_RATE = 'INACTIVE_COMPANY_LOST_SEPARATE_RATE',
  INACTIVE_COMPANY_REVOKED = 'INACTIVE_COMPANY_REVOKED',
  INACTIVE_DEACTIVATED = 'INACTIVE_DEACTIVATED',
  INACTIVE_FINAL_EXCLUSION = 'INACTIVE_FINAL_EXCLUSION',
  INACTIVE_ORDER_REVOKED = 'INACTIVE_ORDER_REVOKED',
  INACTIVE_SUSPENSION_NOT_ON = 'INACTIVE_SUSPENSION_NOT_ON',
  INACTIVE_TERMINATION = 'INACTIVE_TERMINATION'
}

export type AdCvdCasesConnection = Connection & {
  __typename?: 'AdCvdCasesConnection';
  edges: Array<AdCvdCaseEdge>;
  nodes: Array<AdCvdCase>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Disclaimer code for a AdCvdCase. */
export enum AdCvdDisclaimerCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export type AddPendingUpdatesPayload = {
  __typename?: 'AddPendingUpdatesPayload';
  /** The work order id. */
  id: Scalars['String'];
};

export type AdditionalHts = {
  __typename?: 'AdditionalHts';
  /** The additional HTS record required on the Line if addtional duties are required (AD/CVD). Used only on 8541.40.60 (solar Cells / Modules). */
  additionalDutiesHts?: Maybe<Hts>;
  /** The additional HTS number required on the Line if additional duties are required (AD/CVD). Used only on 8541.40.60 (solar Cells / Modules). */
  additionalDutiesNumber?: Maybe<Scalars['String']>;
  /** Description of Additional Tariff Type */
  additionalTypeDescription?: Maybe<Scalars['String']>;
  /** Unique ID for HTS component. */
  chargeId?: Maybe<Scalars['String']>;
  /** End (expiration) date for HTS component. */
  endDate?: Maybe<Scalars['Date']>;
  /** The countries of origin exempt from the additional HTS number requirement. Only one of includedCountryCodes and excludedCountryCodes will be used. */
  exclude?: Maybe<Array<Scalars['CountryCode']>>;
  /** String passed by upstream to identify countries applicable to additional HTS */
  exportGroup?: Maybe<Scalars['String']>;
  /** Export group code applicable to additional HTS */
  exportGroupCode?: Maybe<HsExportGroupCode>;
  /** The additional HTS record required on the Line */
  hts?: Maybe<Hts>;
  /** The countries of origin subject to the additional HTS number requirement. Only one of includedCountryCodes and excludedCountryCodes will be used. */
  include?: Maybe<Array<Scalars['CountryCode']>>;
  /** Note related to HTS component. */
  note?: Maybe<Scalars['String']>;
  /** The additional HTS number required on the Line */
  number: Scalars['String'];
  /** The additional HTS record required on the Line if over quota */
  overQuotaHts?: Maybe<Hts>;
  /** The additional HTS number required on the Line if over quota */
  overQuotaNumber?: Maybe<Scalars['String']>;
  /** Start (effective) date for HTS component. */
  startDate?: Maybe<Scalars['Date']>;
  /** The reason for the additional HTS requirement */
  type?: Maybe<AdditionalHtsType>;
};

export type AdditionalHtsInput = {
  /** The additional HTS number required on the Line if additional duties are required (AD/CVD). Used only on 8541.40.60 (solar Cells / Modules). */
  additionalDutiesNumber?: InputMaybe<Scalars['String']>;
  /** Description of Additional Tariff Type */
  additionalTypeDescription?: InputMaybe<Scalars['String']>;
  /** Unique ID for HTS component. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** End (expiration) date for HTS component. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The countries of origin exempt from the additional HTS number requirement. Only one of includedCountryCodes and excludedCountryCodes will be used. */
  exclude?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** String passed by upstream to identify countries applicable to additional HTS */
  exportGroup?: InputMaybe<Scalars['String']>;
  /** Export group code applicable to additional HTS */
  exportGroupCode?: InputMaybe<HsExportGroupCode>;
  /** The countries of origin subject to the additional HTS number requirement. Only one of includedCountryCodes and excludedCountryCodes will be used. */
  include?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** Note related to HTS component. */
  note?: InputMaybe<Scalars['String']>;
  /** The additional HTS number required on the Line */
  number: Scalars['String'];
  /** The additional HTS number required on the Line if over quota */
  overQuotaNumber?: InputMaybe<Scalars['String']>;
  /** Start (effective) date for HTS component. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The reason for the additional HTS requirement */
  type?: InputMaybe<AdditionalHtsType>;
};

/** Type of additional HTS classification required */
export enum AdditionalHtsType {
  DIGITAL_SERVICES_SECTION_301_AUSTRIA = 'DIGITAL_SERVICES_SECTION_301_AUSTRIA',
  DIGITAL_SERVICES_SECTION_301_FRANCE = 'DIGITAL_SERVICES_SECTION_301_FRANCE',
  DIGITAL_SERVICES_SECTION_301_INDIA = 'DIGITAL_SERVICES_SECTION_301_INDIA',
  DIGITAL_SERVICES_SECTION_301_ITALY = 'DIGITAL_SERVICES_SECTION_301_ITALY',
  DIGITAL_SERVICES_SECTION_301_SPAIN = 'DIGITAL_SERVICES_SECTION_301_SPAIN',
  DIGITAL_SERVICES_SECTION_301_TURKEY = 'DIGITAL_SERVICES_SECTION_301_TURKEY',
  DIGITAL_SERVICES_SECTION_301_UK = 'DIGITAL_SERVICES_SECTION_301_UK',
  EU_LARGE_CIVIL_AIRCRAFT_SECTION_301 = 'EU_LARGE_CIVIL_AIRCRAFT_SECTION_301',
  IEEPA_FENTANYL = 'IEEPA_FENTANYL',
  RECIPROCAL_POLICY = 'RECIPROCAL_POLICY',
  RECIPROCAL_POLICY_EXCLUSION = 'RECIPROCAL_POLICY_EXCLUSION',
  RECIPROCAL_POLICY_INDIA = 'RECIPROCAL_POLICY_INDIA',
  RECIPROCAL_POLICY_MEXICO = 'RECIPROCAL_POLICY_MEXICO',
  RUSSIA_ALUMINUM = 'RUSSIA_ALUMINUM',
  RUSSIA_ALUMINUM_PRIVILEGED = 'RUSSIA_ALUMINUM_PRIVILEGED',
  SECTION_122_GLOBAL = 'SECTION_122_GLOBAL',
  SECTION_201_SOLAR_CELLS = 'SECTION_201_SOLAR_CELLS',
  SECTION_201_WASHER_FINISHED_GOODS = 'SECTION_201_WASHER_FINISHED_GOODS',
  SECTION_201_WASHER_PARTS = 'SECTION_201_WASHER_PARTS',
  SECTION_232_ALUMINIUM = 'SECTION_232_ALUMINIUM',
  SECTION_232_AUTO_PARTS = 'SECTION_232_AUTO_PARTS',
  SECTION_232_COPPER = 'SECTION_232_COPPER',
  SECTION_232_STEEL = 'SECTION_232_STEEL',
  SECTION_301_LIST_1 = 'SECTION_301_LIST_1',
  SECTION_301_LIST_2 = 'SECTION_301_LIST_2',
  SECTION_301_LIST_3 = 'SECTION_301_LIST_3',
  SECTION_301_LIST_4A = 'SECTION_301_LIST_4A',
  SECTION_301_LIST_4B = 'SECTION_301_LIST_4B',
  SECTION_301_LIST_9 = 'SECTION_301_LIST_9'
}

export type AdditionalProcedure = {
  __typename?: 'AdditionalProcedure';
  /** Code specifying an additional procedure. */
  procedure?: Maybe<Scalars['String']>;
  /** Sequential number of the additional procedure. */
  sequence?: Maybe<Scalars['Float']>;
};

export type AdditionalProcedureInput = {
  /** Code specifying an additional procedure. */
  procedure?: InputMaybe<Scalars['String']>;
  /** Sequential number of the additional procedure. */
  sequence?: InputMaybe<Scalars['Float']>;
};

export type AdditionalReference = {
  __typename?: 'AdditionalReference';
  /** Identification of the reference providing additional information. */
  identification?: Maybe<Scalars['String']>;
  /** Code specifying the name of an additional reference. */
  type?: Maybe<Scalars['String']>;
};

export type AdditionalReferenceInput = {
  /** Identification of the reference providing additional information. */
  identification?: InputMaybe<Scalars['String']>;
  /** Code specifying the name of an additional reference. */
  type?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  /** A street address. */
  address?: Maybe<Scalars['String']>;
  /** Apartment, suite, unit number, or other address designation that is not part of the physical address. */
  address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town of the address. */
  city?: Maybe<Scalars['String']>;
  /** The country code of the address as defined in ISO 3166-1 alpha-2. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** The zip or postal code of the address. */
  postalCode?: Maybe<Scalars['String']>;
  /** The province, state, or district of the address as defined in ISO 3166-2. */
  stateCode?: Maybe<Scalars['String']>;
};

export type AddressEmail = {
  __typename?: 'AddressEmail';
  EmailAddress: Scalars['String'];
  MailboxDisplayName?: Maybe<Scalars['String']>;
};

export type AddressEmailInput = {
  EmailAddress: Scalars['String'];
  MailboxDisplayName?: InputMaybe<Scalars['String']>;
};

export type AddressEmailProfile = {
  __typename?: 'AddressEmailProfile';
  CopyEmails?: Maybe<Array<AddressEmail>>;
  PrimaryEmail: AddressEmail;
};

export type AddressEmailProfileInput = {
  CopyEmails?: InputMaybe<Array<AddressEmailInput>>;
  PrimaryEmail: AddressEmailInput;
};

export type AddressInput = {
  /** A street address. */
  address?: InputMaybe<Scalars['String']>;
  /** Apartment, suite, unit number, or other address designation that is not part of the physical address. */
  address2?: InputMaybe<Scalars['String']>;
  /** The name of the city, district, village, or town of the address. */
  city?: InputMaybe<Scalars['String']>;
  /** The country code of the address as defined in ISO 3166-1 alpha-2. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The zip or postal code of the address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The province, state, or district of the address as defined in ISO 3166-2. */
  stateCode?: InputMaybe<Scalars['String']>;
};

export type AddressPhone = {
  __typename?: 'AddressPhone';
  Label?: Maybe<Scalars['String']>;
  PhoneNumber: Scalars['String'];
};

export type AddressPhoneInput = {
  Label?: InputMaybe<Scalars['String']>;
  PhoneNumber: Scalars['String'];
};

export type AddressReference = {
  __typename?: 'AddressReference';
  /** Customer id linked to address in AddressService. */
  customerId?: Maybe<Scalars['String']>;
  /** Reference id in AddressService */
  id: Scalars['String'];
};

export type AddressReferenceInput = {
  /** Customer id linked to address in AddressService. */
  customerId?: InputMaybe<Scalars['String']>;
  /** Reference id in AddressService */
  id: Scalars['String'];
};

export type AddressResponse = {
  __typename?: 'AddressResponse';
  AddressId?: Maybe<Scalars['String']>;
  AddressLabel?: Maybe<Scalars['String']>;
  AddressType?: Maybe<Scalars['String']>;
  CompanyName?: Maybe<Scalars['String']>;
  CustomerId?: Maybe<Scalars['String']>;
  EmailAddresses?: Maybe<AddressEmailProfile>;
  Instructions?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  LegacyAddressId?: Maybe<Scalars['String']>;
  MailingAddress: MailingAddress;
  MarketplaceId?: Maybe<Scalars['String']>;
  ValidationStatus?: Maybe<Scalars['String']>;
  VoicePhones?: Maybe<AddressVoicePhoneProfile>;
};

/** Generic address that is WCO Data Model v4.0.0 compliant */
export type AddressV2 = {
  __typename?: 'AddressV2';
  /** Name of a city. */
  cityName?: Maybe<Scalars['String']>;
  /** Code specifying the name of the country or other geographical entity as specified in ISO 3166 and UN/ECE Rec 3. */
  country?: Maybe<Scalars['String']>;
  /** Code specifying the name of a country subdivision. ISO 3166-2 OR User codes. */
  countrySubDivision?: Maybe<Scalars['String']>;
  /** Name of a country subdivision. */
  countrySubDivisionName?: Maybe<Scalars['String']>;
  /** Address service reference information. */
  externalReference?: Maybe<AddressReference>;
  /** Identification of a house by number. */
  houseNumber?: Maybe<Scalars['String']>;
  /** Identification of a house by additional number. */
  houseNumberAddition?: Maybe<Scalars['String']>;
  /** Specification of the postal delivery point such as street and number or post office box. Not to be used in combination with Street name, House number, House number addition and P.O. Box */
  line?: Maybe<Scalars['String']>;
  /** A second line for additional address information */
  line2?: Maybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  postCode?: Maybe<Scalars['String']>;
  /** P.O. box identifier. */
  postOfficeBox?: Maybe<Scalars['String']>;
  /** Name of street. */
  streetName?: Maybe<Scalars['String']>;
  /** Code specifying the type of address, code list: UN/EDIFACT 3131. */
  type?: Maybe<Scalars['String']>;
};

/** Generic address that is WCO Data Model v4.0.0 compliant */
export type AddressV2Input = {
  /** Name of a city. */
  cityName?: InputMaybe<Scalars['String']>;
  /** Code specifying the name of the country or other geographical entity as specified in ISO 3166 and UN/ECE Rec 3. */
  country?: InputMaybe<Scalars['String']>;
  /** Code specifying the name of a country subdivision. ISO 3166-2 OR User codes. */
  countrySubDivision?: InputMaybe<Scalars['String']>;
  /** Name of a country subdivision. */
  countrySubDivisionName?: InputMaybe<Scalars['String']>;
  /** Address service reference information. */
  externalReference?: InputMaybe<AddressReferenceInput>;
  /** Identification of a house by number. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Identification of a house by additional number. */
  houseNumberAddition?: InputMaybe<Scalars['String']>;
  /** Specification of the postal delivery point such as street and number or post office box. Not to be used in combination with Street name, House number, House number addition and P.O. Box */
  line?: InputMaybe<Scalars['String']>;
  /** A second line for additional address information */
  line2?: InputMaybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  postCode?: InputMaybe<Scalars['String']>;
  /** P.O. box identifier. */
  postOfficeBox?: InputMaybe<Scalars['String']>;
  /** Name of street. */
  streetName?: InputMaybe<Scalars['String']>;
  /** Code specifying the type of address, code list: UN/EDIFACT 3131. */
  type?: InputMaybe<Scalars['String']>;
};

export type AddressVoicePhoneProfile = {
  __typename?: 'AddressVoicePhoneProfile';
  PrimaryPhone: AddressPhone;
  SecondaryPhone?: Maybe<AddressPhone>;
};

export type AddressVoicePhoneProfileInput = {
  PrimaryPhone: AddressPhoneInput;
  SecondaryPhone?: InputMaybe<AddressPhoneInput>;
};

export type Addresses = {
  __typename?: 'Addresses';
  /** A mailing address */
  mailing?: Maybe<Address>;
  /** The address of a physical location */
  physical?: Maybe<Address>;
};

export type AddressesInput = {
  /** A mailing address */
  mailing?: InputMaybe<AddressInput>;
  /** The address of a physical location */
  physical?: InputMaybe<AddressInput>;
};

export type Agent = {
  /** Code specifying the capacity in which the agent is acting. */
  function?: Maybe<Scalars['String']>;
  /** Code specifying where quality assurance level of the agent should be used. */
  qualityAssurance?: Maybe<Scalars['String']>;
};

/** The info provided from calculating the amendment */
export type Amendment = {
  __typename?: 'Amendment';
  /** Message explaining the status to be displayed to the user */
  message?: Maybe<Scalars['String']>;
  /** The new duties fees (sum of the following cbpCharges: taxes + fees + duties) */
  newDutiesFees?: Maybe<Scalars['Float']>;
  /** The new duties fees (sum of the following cbpCharges: taxes + fees + duties) */
  oldDutiesFees?: Maybe<Scalars['Float']>;
  /** The resulting status after calculating the amendment */
  status: CalculateAmendmentResultStatus;
  /** Title of the status to be displayed to the user */
  title?: Maybe<Scalars['String']>;
};

export type AmsQueryReference = {
  __typename?: 'AmsQueryReference';
  /** Type of the input in AMS query */
  type: AmsQueryReferenceType;
  /** Value of the input in AMS query */
  value: Scalars['String'];
};

export type AmsQueryReferenceInput = {
  /** Type of the input in AMS query */
  type: AmsQueryReferenceType;
  /** Value of the input in AMS query */
  value: Scalars['String'];
};

/** Ams query input reference type */
export enum AmsQueryReferenceType {
  AIRWAY_BILL_NUMBER = 'AIRWAY_BILL_NUMBER',
  BILL_OF_LADING_NUMBER = 'BILL_OF_LADING_NUMBER',
  ENTRY_NUMBER = 'ENTRY_NUMBER',
  HOUSE_AIRWAY_BILL_NUMBER = 'HOUSE_AIRWAY_BILL_NUMBER',
  IN_BOND_NUMBER = 'IN_BOND_NUMBER'
}

export type AmsQueryTransaction = QueryAmsTransaction | QueryAmsUsConsumptionEntryTransaction | QueryAmsUsInBondTransaction | QueryAmsUsIsfTransaction | QueryAmsUsType86EntryTransaction;

export type AndraClientConnectionInput = {
  apiArgs?: InputMaybe<Scalars['JSONObject']>;
  apiName: SupportedAndraAPI;
  sessionName?: InputMaybe<Scalars['String']>;
};

export type AndraClientConnectionPayload = {
  __typename?: 'AndraClientConnectionPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSONObject']>;
};

export type ApiAuthorization = {
  __typename?: 'ApiAuthorization';
  /** Allowed Operations */
  allowedOperations?: Maybe<Array<Scalars['String']>>;
};

export type ApiAuthorizationInput = {
  /** Allowed Operations */
  allowedOperations?: InputMaybe<Array<Scalars['String']>>;
};

export type ArrivalLocation = {
  __typename?: 'ArrivalLocation';
  /** Identification of the arrival location. This would be a port for sea, airport for air and border post for land crossing. */
  identification?: Maybe<Scalars['String']>;
  /** Name of the arrival location. This would be a port for sea, airport for air and border post for land crossing. */
  name?: Maybe<Scalars['String']>;
};

export type ArrivalLocationInput = {
  /** Identification of the arrival location. This would be a port for sea, airport for air and border post for land crossing. */
  identification?: InputMaybe<Scalars['String']>;
  /** Name of the arrival location. This would be a port for sea, airport for air and border post for land crossing. */
  name?: InputMaybe<Scalars['String']>;
};

export type AsinComplianceRecommendationSubmissionResult = ComplianceRecommendationSubmissionResult & {
  __typename?: 'AsinComplianceRecommendationSubmissionResult';
  byAsin: AsinIdentification;
  destinationCountryCode: Scalars['String'];
  recommendations: Array<ComplianceRecommendation>;
};

export type AsinIdentification = {
  __typename?: 'AsinIdentification';
  asin: Scalars['String'];
  marketplaceId: Scalars['Int'];
};

export type AsinInput = {
  asin: Scalars['String'];
  marketplaceId: Scalars['Int'];
};

export type AssetSource = {
  __typename?: 'AssetSource';
  /** The type of asset hosted by the Custom Domain */
  type: CustomDomainAssetSourceType;
  /** The value of the asset. */
  value: Scalars['String'];
};

export type AssetSourceInput = {
  /** The type of asset hosted by the Custom Domain */
  type: CustomDomainAssetSourceType;
  /** The value of the asset. */
  value: Scalars['String'];
};

export type AssignmentConfig = {
  __typename?: 'AssignmentConfig';
  /** Task level configration for assignment */
  taskConfigs: Array<TaskConfig>;
};

export type AssignmentConfigInput = {
  /** Task level configration for assignment */
  taskConfigs: Array<TaskConfigInput>;
};

export type AssignmentRule = {
  __typename?: 'AssignmentRule';
  /** The assignment team for the for the case assignment */
  assignmentTeam?: Maybe<AssignmentTeam>;
  /** The common role assignment patterns for connectPro case assignment */
  pattern: RoleAssignmentPattern;
  /** The work order task types for the assignment rule if we use WOT assignee pattern */
  workOrderTaskTypes?: Maybe<Array<WorkOrderTaskType>>;
};

export type AssignmentRuleInput = {
  /** The assignment team for the for the case assignment */
  assignmentTeam?: InputMaybe<IdInput>;
  /** The common role assignment patterns for connectPro case assignment */
  pattern: RoleAssignmentPattern;
  /** The work order task types for the assignment rule if we use WOT assignee pattern */
  workOrderTaskTypes?: InputMaybe<Array<WorkOrderTaskType>>;
};

export type AssignmentTeam = Record & UserTeam & {
  __typename?: 'AssignmentTeam';
  /** The type of this assignment team */
  assignmentTeamTypes?: Maybe<Array<AssignmentTeamType>>;
  /** The backup team for this assignment team */
  backupTeam?: Maybe<AssignmentTeam>;
  /** The case attributes for this assignment team */
  caseAttributes?: Maybe<Array<AssignmentTeamCaseAttributes>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Team's customs broker */
  customsBroker?: Maybe<CustomsBroker>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The User Team's name */
  name: Scalars['String'];
  operator: Operator;
  /** A Operator User linked to this AssignmentTeam */
  operatorUser: AssignmentTeamOperatorUserRelationship;
  /** Operator Users linked to this Assignment Team. */
  operatorUsers: AssignmentTeamOperatorUsersConnection;
  /** The associated SME team for this assignment team */
  subjectMatterExpertTeam?: Maybe<SubjectMatterExpertTeam>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The verticals this assignment team is responsible for */
  verticals?: Maybe<Array<AssignmentTeamVertical>>;
  /** The work order task types associated with this assignment team */
  workOrderTaskTypes: Array<WorkOrderTaskType>;
  /** The work order types associated with this assignment team */
  workOrderTypes: Array<WorkOrderType>;
};


export type AssignmentTeamoperatorUserArgs = {
  operatorUserId: Scalars['ID'];
};


export type AssignmentTeamoperatorUsersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type AssignmentTeamAccess = {
  __typename?: 'AssignmentTeamAccess';
  /** The assignmentTeam to be configured for case category access permission */
  assignmentTeam: AssignmentTeam;
  /** The business types (e.g. FBA/RETAIL) to be configured for case category access permission */
  businessTypes: Array<BusinessType>;
  /** The resource types (e.g. READ/WRITE) to be configured for case category access permission */
  resourceTypes: Array<PermissionResourceType>;
};

export type AssignmentTeamAccessInput = {
  /** The assignmentTeam to be configured for case category access permission */
  assignmentTeam: IdInput;
  /** The business types (e.g. FBA/RETAIL) to be configured for case category access permission */
  businessTypes: Array<BusinessType>;
  /** The resource types (e.g. READ/WRITE) to be configured for case category access permission */
  resourceTypes: Array<PermissionResourceType>;
};

export type AssignmentTeamCaseAttributes = {
  __typename?: 'AssignmentTeamCaseAttributes';
  /** The business area for this assignment team */
  businessArea: BusinessArea;
  /** The country code for this assignment team. */
  countryCode: ExtendedCountryAbbreviation;
  /** The timezone for this assignment team */
  timeZone: TimeZone;
};

export type AssignmentTeamCaseAttributesInput = {
  /** The business area for this assignment team */
  businessArea: BusinessArea;
  /** The country code for this assignment team. */
  countryCode: ExtendedCountryAbbreviation;
  /** The timezone for this assignment team */
  timeZone: TimeZone;
};

export type AssignmentTeamEdge = ConnectionEdge & {
  __typename?: 'AssignmentTeamEdge';
  cursor: Scalars['ID'];
  node: AssignmentTeam;
};

export type AssignmentTeamMemberInput = {
  /** The User's groups in this Assignment Team */
  groups?: InputMaybe<Array<AssignmentTeamOperatorGroupInput>>;
  /** The User's roles in this Assignment Team */
  roles: Array<OperatorUserTeamRole>;
  /** The User's unique ID */
  userId: Scalars['ID'];
};

export type AssignmentTeamOperatorGroup = {
  __typename?: 'AssignmentTeamOperatorGroup';
  /** The User's group number */
  groupNumber: Scalars['Int'];
  /** The User's roles in this Group */
  roles: Array<OperatorUserTeamRole>;
};

export type AssignmentTeamOperatorGroupInput = {
  /** The User's group number */
  groupNumber: Scalars['Int'];
  /** The User's roles in this Group */
  roles: Array<OperatorUserTeamRole>;
};

export type AssignmentTeamOperatorUserEdge = ConnectionEdge & {
  __typename?: 'AssignmentTeamOperatorUserEdge';
  cursor: Scalars['ID'];
  /** The linked Operator User. */
  node?: Maybe<OperatorUser>;
  /** The data on the link between the Assignment Team and Operator User. */
  relationship?: Maybe<AssignmentTeamOperatorUserRelationship>;
};

export type AssignmentTeamOperatorUserRelationship = Record & {
  __typename?: 'AssignmentTeamOperatorUserRelationship';
  /** The linked Assignment Team. */
  assignmentTeam: AssignmentTeam;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The User's groups in this Team */
  groups?: Maybe<Array<AssignmentTeamOperatorGroup>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Operator User. */
  operatorUser: OperatorUser;
  /** The User's roles in this Team */
  roles: Array<OperatorUserTeamRole>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type AssignmentTeamOperatorUserRelationshipBase = Record & {
  __typename?: 'AssignmentTeamOperatorUserRelationshipBase';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The User's groups in this Team */
  groups?: Maybe<Array<AssignmentTeamOperatorGroup>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The User's roles in this Team */
  roles: Array<OperatorUserTeamRole>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type AssignmentTeamOperatorUserRelationshipInput = {
  /** The User's groups in this Team */
  groups?: InputMaybe<Array<AssignmentTeamOperatorGroupInput>>;
  /** The User's roles in this Team */
  roles: Array<OperatorUserTeamRole>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type AssignmentTeamOperatorUsersConnection = Connection & {
  __typename?: 'AssignmentTeamOperatorUsersConnection';
  edges: Array<AssignmentTeamOperatorUserEdge>;
  nodes: Array<OperatorUser>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type AssignmentTeamSearchCriteriaInput = {
  /** The type of this assignment team */
  assignmentTeamType?: InputMaybe<AssignmentTeamTypeSearchCriteriaInput>;
  /** The ID of the backup team for this assignment team */
  backupTeamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the backup team for this assignment team */
  backupTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The business area for this assignment team */
  businessArea?: InputMaybe<BusinessAreaSearchCriteriaInput>;
  /** The ID of the associated commodity group for this assignment team */
  commodityGroupId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the associated commodity group for this assignment team */
  commodityGroupName?: InputMaybe<TextSearchCriteriaInput>;
  /** The country code for this assignment team. Must be a valid CountryAbbreviation value. */
  countryCode?: InputMaybe<CountryAbbreviationSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of customs broker linked to this assignment team */
  customsBrokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Customs Broker's name linked to this assignment team */
  customsBrokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the forwarder in this team's verticals */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the forwarder in this team's verticals */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The load type in this team's verticals */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** The mode of transport in this team's verticals */
  modeOfTransport?: InputMaybe<ModeOfTransportSearchCriteriaInput>;
  /** The User Team's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Operator's name */
  operatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The product type in this team's verticals */
  productType?: InputMaybe<ProductTypeSearchCriteriaInput>;
  /** The ID of the associated SME team for this assignment team */
  subjectMatterExpertTeamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the associated SME team for this assignment team */
  subjectMatterExpertTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The timezone for this assignment team */
  timeZone?: InputMaybe<TimezoneSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The work order task type associated with this assignment team */
  workOrderTaskType?: InputMaybe<WorkOrderTaskTypeSearchCriteriaInput>;
  /** The work order type associated with this assignment team */
  workOrderType?: InputMaybe<WorkOrderTypeSearchCriteriaInput>;
};

export type AssignmentTeamSearchTableRow = RecordSearchTableRow & UserTeamSearchTableRow & {
  __typename?: 'AssignmentTeamSearchTableRow';
  /** The type of this assignment team */
  assignmentTeamType?: Maybe<Array<AssignmentTeamType>>;
  /** The ID of the backup team for this assignment team */
  backupTeamId?: Maybe<Scalars['ID']>;
  /** The name of the backup team for this assignment team */
  backupTeamName?: Maybe<Scalars['String']>;
  /** The business area for this assignment team */
  businessArea?: Maybe<BusinessArea>;
  /** The Ids of the commodity group in this team's verticals */
  commodityGroupId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the commodity group in this team's verticals */
  commodityGroupName?: Maybe<Array<Scalars['String']>>;
  /** The country code for this assignment team. Must be a valid CountryAbbreviation value. */
  countryCode?: Maybe<ExtendedCountryAbbreviation>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of customs broker linked to this assignment team */
  customsBrokerId?: Maybe<Scalars['ID']>;
  /** The Customs Broker's name linked to this assignment team */
  customsBrokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The Ids of the forwarders in this team's verticals */
  forwarderId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the forwarders in this team's verticals */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The load types in this team's verticals */
  loadType?: Maybe<Array<LoadType>>;
  /** The number of members on this assignment team */
  memberCount: Scalars['Int'];
  /** The modes of transport in this team's verticals */
  modeOfTransport?: Maybe<Array<ModeOfTransport>>;
  /** The User Team's name */
  name?: Maybe<Scalars['String']>;
  /** The Operator that owns this Record */
  operatorId: Scalars['String'];
  /** The Operator's name */
  operatorName: Scalars['String'];
  /** The product types in this team's verticals */
  productType?: Maybe<Array<ProductType>>;
  /** The ID of the associated SME team for this assignment team */
  subjectMatterExpertTeamId?: Maybe<Scalars['ID']>;
  /** The name of the associated SME team for this assignment team */
  subjectMatterExpertTeamName?: Maybe<Scalars['String']>;
  /** The timezone for this assignment team */
  timeZone?: Maybe<TimeZone>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The work order task types associated with this assignment team */
  workOrderTaskType: Array<WorkOrderTaskType>;
  /** The work order types associated with this assignment team */
  workOrderType: Array<WorkOrderType>;
};

export type AssignmentTeamStaticMapping = Record & {
  __typename?: 'AssignmentTeamStaticMapping';
  /** The assignment team for the mapping. */
  assignmentTeam?: Maybe<AssignmentTeam>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The mapped operator in this assignment team. */
  member?: Maybe<OperatorUser>;
  /** The entity reference to which the member is being mapped to. e.g., if the memberAssignedToType is XBT_SHIPPER_ID, then this field should be the xbtShipperId in format of string. */
  memberAssignedToReference: Scalars['String'];
  /** The type of member being assigned (e.g., "XBT_SHIPPER_ID"). */
  memberAssignedToType: MemberAssignedToType;
  operator: Operator;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type AssignmentTeamStaticMappingEdge = ConnectionEdge & {
  __typename?: 'AssignmentTeamStaticMappingEdge';
  cursor: Scalars['ID'];
  node: AssignmentTeamStaticMapping;
};

export type AssignmentTeamStaticMappingSearchCriteriaInput = {
  /** The assignment team ID. */
  assignmentTeamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The assignment team Name. */
  assignmentTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The entity reference to which the member is assigned (e.g., the xbtShipperId). */
  memberAssignedToReference?: InputMaybe<TextSearchCriteriaInput>;
  /** The type of member being assigned (e.g., "XBT_SHIPPER_ID"). */
  memberAssignedToType?: InputMaybe<MemberAssignedToTypeSearchCriteriaInput>;
  /** The email of the operator user member. */
  memberEmail?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the operator user member. */
  memberId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the operator user member. */
  memberName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Operator's name */
  operatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** The Assignment Team Static Mapping's table search row. */
export type AssignmentTeamStaticMappingSearchTableRow = RecordSearchTableRow & {
  __typename?: 'AssignmentTeamStaticMappingSearchTableRow';
  /** The ID of the assignment team. */
  assignmentTeamId: Scalars['ID'];
  /** The name of the assignment team */
  assignmentTeamName: Scalars['String'];
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The entity reference to which the member is assigned (e.g., the xbtShipperId). */
  memberAssignedToReference: Scalars['String'];
  /** The type of member being assigned (e.g., "XBT_SHIPPER_ID"). */
  memberAssignedToType: MemberAssignedToType;
  /** The email of the operator user member */
  memberEmail: Scalars['String'];
  /** The ID of the operator user member. */
  memberId: Scalars['ID'];
  /** The name of the operator user member */
  memberName: Scalars['String'];
  /** The Operator that owns this Record */
  operatorId: Scalars['String'];
  /** The Operator's name */
  operatorName: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type AssignmentTeamStaticMappingsConnection = Connection & {
  __typename?: 'AssignmentTeamStaticMappingsConnection';
  edges: Array<AssignmentTeamStaticMappingEdge>;
  nodes: Array<AssignmentTeamStaticMapping>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The type of the assignment team. If CASE is the only value provided, the team should be excluded for WOT assignment. */
export enum AssignmentTeamType {
  CASE = 'CASE',
  WORK_ORDER_TASK = 'WORK_ORDER_TASK'
}

export type AssignmentTeamTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<AssignmentTeamType>>;
};

export type AssignmentTeamVertical = {
  __typename?: 'AssignmentTeamVertical';
  /** The commodity groups for this vertical */
  commodityGroup?: Maybe<Array<CommodityGroup>>;
  /** The freight forwarders for this vertical */
  forwarders?: Maybe<Array<Forwarder>>;
  /** The importers for this vertical */
  iors?: Maybe<Array<Ior>>;
  /** The load types for this vertical */
  loadTypes?: Maybe<Array<LoadType>>;
  /** The mode of transport for this vertical */
  modeOfTransport?: Maybe<ModeOfTransport>;
  /** The product types for this vertical */
  productTypes?: Maybe<Array<ProductType>>;
  /** The shippers for this vertical */
  shippers?: Maybe<Array<Shipper>>;
};

export type AssignmentTeamVerticalInput = {
  /** The commodity groups for this vertical */
  commodityGroup?: InputMaybe<Array<IdInput>>;
  /** The freight forwarders for this vertical */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The importers for this vertical */
  iors?: InputMaybe<Array<IdInput>>;
  /** The load types for this vertical */
  loadTypes?: InputMaybe<Array<LoadType>>;
  /** The mode of transport for this vertical */
  modeOfTransport?: InputMaybe<ModeOfTransport>;
  /** The product types for this vertical */
  productTypes?: InputMaybe<Array<ProductType>>;
  /** The shippers for this vertical */
  shippers?: InputMaybe<Array<IdInput>>;
};

export type AssignmentTeamsConnection = Connection & {
  __typename?: 'AssignmentTeamsConnection';
  edges: Array<AssignmentTeamEdge>;
  nodes: Array<AssignmentTeam>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String'];
  value: Scalars['AttributeValue'];
};

/** Represents an attribute with key-value pairs for customization. */
export type AttributeInput = {
  key: Scalars['String'];
  value: Scalars['AttributeValue'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Details of changes between all versions of a record */
  diff: Array<DiffDetail>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The record that the AuditLog is related to */
  record?: Maybe<Record>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type AuditLogEdge = ConnectionEdge & {
  __typename?: 'AuditLogEdge';
  cursor: Scalars['ID'];
  node: AuditLog;
};

export type AuditLogSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record ID. */
  recordId: Scalars['ID'];
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type AuditLogsConnection = Connection & {
  __typename?: 'AuditLogsConnection';
  edges: Array<AuditLogEdge>;
  nodes: Array<AuditLog>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type AuthenticationContext = {
  /** Hash used for intercom */
  intercomHash?: Maybe<Scalars['String']>;
};

export type AuthenticationContextPayload = {
  __typename?: 'AuthenticationContextPayload';
  /** The actor context of the calling user. */
  authenticatedUserContext?: Maybe<AuthenticationContext>;
};

/** A record that represents an authentication token */
export type AuthenticationToken = Record & {
  __typename?: 'AuthenticationToken';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type Authorization = {
  __typename?: 'Authorization';
  /** Details related to the holder of the authorization. */
  authorizationHolder?: Maybe<AuthorizationHolder>;
  /** Identification of an authorization necessary for the declaration or notification. */
  identification?: Maybe<Scalars['String']>;
  /** Code specifying the type of authorization necessary for the declaration or notification. */
  type?: Maybe<Scalars['String']>;
};

export type AuthorizationHolder = {
  __typename?: 'AuthorizationHolder';
  /** Identification of the person being the holder of the authorization. */
  identification?: Maybe<Scalars['String']>;
  /** Type of identification for the authorization holder. */
  identificationType?: Maybe<Scalars['String']>;
};

export type AuthorizationHolderInput = {
  /** Identification of the person being the holder of the authorization. */
  identification?: InputMaybe<Scalars['String']>;
  /** Type of identification for the authorization holder. */
  identificationType?: InputMaybe<Scalars['String']>;
};

export type AuthorizationInput = {
  /** Details related to the holder of the authorization. */
  authorizationHolder?: InputMaybe<AuthorizationHolderInput>;
  /** Identification of an authorization necessary for the declaration or notification. */
  identification?: InputMaybe<Scalars['String']>;
  /** Code specifying the type of authorization necessary for the declaration or notification. */
  type?: InputMaybe<Scalars['String']>;
};

export type AuthorizeCbpEntryStatementDebitTransaction = AuthorizeUsCbpEntryDailyStatementDebitTransaction;

/** Input parameters to submit an ACH debit authorization to US CBP. */
export type AuthorizeUsCbpEntryDailyStatementDebitInput = {
  /** The CBP Daily Statement number. */
  dailyStatementNumber: Scalars['String'];
  /** Whether this transaction is a negation of a previous ACH debit authorization (must be done within the same day). */
  negation?: InputMaybe<Scalars['Boolean']>;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber: Scalars['UsCbpPayerUnitNumber'];
  /** Statement amount to authorize for ACH debit in US Dollars. */
  paymentAmount: Scalars['UsDollars'];
  /** CBP entry payment type */
  paymentType: Scalars['UsCbpEntryPaymentType'];
};

/** The payload returned from triggering the Transaction. */
export type AuthorizeUsCbpEntryDailyStatementDebitPayload = {
  __typename?: 'AuthorizeUsCbpEntryDailyStatementDebitPayload';
  /** The Transaction. */
  transaction: AuthorizeUsCbpEntryDailyStatementDebitTransaction;
};

/** The US CBP ABI transaction to authorize a Daily Statment for ACH Debit, CATAIR appCode: RM(legacy),PN/PZ. */
export type AuthorizeUsCbpEntryDailyStatementDebitTransaction = Record & {
  __typename?: 'AuthorizeUsCbpEntryDailyStatementDebitTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The CBP Daily Statement number. */
  dailyStatementNumber: Scalars['String'];
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether this transaction is a negation of a previous ACH debit authorization (must be done within the same day). */
  negation?: Maybe<Scalars['Boolean']>;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber: Scalars['UsCbpPayerUnitNumber'];
  /** Statement amount to authorize for ACH debit in US Dollars. */
  paymentAmount: Scalars['UsDollars'];
  /** CBP entry payment type */
  paymentType: Scalars['UsCbpEntryPaymentType'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type AutoAssignmentConfig = {
  __typename?: 'AutoAssignmentConfig';
  /** The assignment rules which runs in order to determine the case assignee */
  assignmentRules: Array<AssignmentRule>;
  /** The matching attributes to be used for matching assignment rules */
  matchingAttributes?: Maybe<MatchingAttributes>;
};

export type AutoAssignmentConfigInput = {
  /** The assignment rules which runs in order to determine the case assignee */
  assignmentRules: Array<AssignmentRuleInput>;
  /** The matching attributes to be used for matching assignment rules */
  matchingAttributes?: InputMaybe<MatchingAttributesInput>;
};

export type AutoSetReadyRequirements = {
  __typename?: 'AutoSetReadyRequirements';
  /** Document specific requirements for auto marking the work order as ready */
  documents?: Maybe<Array<DocumentsRequirement>>;
};

export type AutoSetReadyRequirementsInput = {
  /** Document specific requirements for auto marking the work order as ready */
  documents?: InputMaybe<Array<DocumentRequirementsInput>>;
};

export type AwsAccountIdSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['AwsAccountId']>>;
};

export type BaseEntryWarning = {
  /** The warning code from CBP */
  warningCode?: Maybe<WarningCode>;
  /** The source of warnings */
  warningSource?: Maybe<WarningSource>;
  /** The status of warning from CBP */
  warningStatus?: Maybe<WarningStatus>;
};

/** Payload for baselineOperatorUsers operation */
export type BaselineOperatorUsersPayload = {
  __typename?: 'BaselineOperatorUsersPayload';
  /** Created operator users */
  createdOperatorUsers: Array<OperatorUser>;
  /** Deleted operator users */
  deletedOperatorUsers: Array<OperatorUser>;
  /** Updated operator users */
  updatedOperatorUsers: Array<OperatorUser>;
};

export type BatchInformation = {
  /** The number of milestones to be created as part of this batch */
  batchSize: Scalars['Int'];
  /** The starting index from where the creation starts */
  startIndex: Scalars['Int'];
};

/** Payload returned from the batchUpsertProducts mutation. */
export type BatchUpsertProductsPayload = {
  __typename?: 'BatchUpsertProductsPayload';
  /** A list of failed Product upserts. */
  failedUpserts: Array<Product>;
  /** A list of successful Product upserts. */
  successfulUpserts: Array<Product>;
};

/** Payload returned from the batchUpsertSuppliers mutation. */
export type BatchUpsertSuppliersPayload = {
  __typename?: 'BatchUpsertSuppliersPayload';
  /** A list of failed Supplier upserts. */
  failedUpserts: Array<Supplier>;
  /** A list of successful Supplier upserts. */
  successfulUpserts: Array<Supplier>;
};

export type BillInfo = {
  __typename?: 'BillInfo';
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  number?: Maybe<Scalars['String']>;
  /** When adding an in-bond to an existing Bill of Lading, this field is used when the in-bond quantity is less than the full Bill quantity of the previously transmitted Bill of Lading. If not provided, the in-bond quantity will automatically be assumed to be full Bill quantity. */
  quantity?: Maybe<Scalars['Float']>;
  /** The status of the CbpInBondBill */
  status?: Maybe<CbpInBondBillStatus>;
};

export type BillInfoInput = {
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  number?: InputMaybe<Scalars['String']>;
  /** When adding an in-bond to an existing Bill of Lading, this field is used when the in-bond quantity is less than the full Bill quantity of the previously transmitted Bill of Lading. If not provided, the in-bond quantity will automatically be assumed to be full Bill quantity. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** The status of the CbpInBondBill */
  status?: InputMaybe<CbpInBondBillStatus>;
};

/** The status of the ISF (SA) bill match. */
export enum BillMatchStatus {
  MATCHED = 'MATCHED',
  NOT_MATCHED = 'NOT_MATCHED',
  NO_BILL_MATCH_DUPLICATE_ISF_ON_FILE = 'NO_BILL_MATCH_DUPLICATE_ISF_ON_FILE',
  NO_BILL_MATCH_NOT_ON_FILE = 'NO_BILL_MATCH_NOT_ON_FILE',
  NO_BILL_MATCH_WRONG_TYPE = 'NO_BILL_MATCH_WRONG_TYPE'
}

export type BillingDetails = {
  __typename?: 'BillingDetails';
  /** Document tags related to documents that should be attached to invoice emails. */
  accountingDocs?: Maybe<Array<DocumentTag>>;
  /** Accounting Point of contacts for the billing party. If none are provided the BillingParty's point of contact will be used */
  accountingPointofContacts?: Maybe<Array<AccountingPointOfContact>>;
  /** Accounting system customer reference: qboId, qboSyncToken etc */
  accountingSystemCustomerReferences?: Maybe<Array<AccountingSystemCustomerReference>>;
  /** Credit related details for the billing party. */
  creditDetails?: Maybe<AccountCreditDetails>;
  /** Custom configuration to be used when calculate invoice amount. */
  customFeeConfig?: Maybe<CustomFeeConfiguration>;
  /** Custom fee configuration to add to invoice lines. */
  customFees?: Maybe<Array<InvoiceFeeDetails>>;
  /** If disbursement is true, customer will get 3% disbursement fee on certain outlayed charges. */
  disbursement?: Maybe<Scalars['Boolean']>;
  /** Invoice configuration applicable to all work orders */
  invoiceConfiguration?: Maybe<BillingPartyInvoiceConfiguration>;
  /** Additional amounts to add to invoice lines, to be reimbursed monthly */
  markups?: Maybe<Array<InvoiceFeeDetails>>;
  /** External customer onboarding request */
  onboardingRequest?: Maybe<OnboardingRequest>;
  /** Payment method. eg: Credit Card, Check. */
  paymentMethod?: Maybe<PaymentMethod>;
  /** Account status for the billing party. */
  status?: Maybe<BillingPartyAccountStatus>;
  /** The program plan payment period preference. */
  subscriptionPaymentPeriod?: Maybe<SubscriptionPaymentPeriod>;
  /** The program plan with the Operator. */
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  /** The program plan payment period preference. */
  trialEndTime?: Maybe<Scalars['DateTime']>;
  /** The invoice configuration for a specific type of work order. */
  workOrderInvoiceConfiguration?: Maybe<BillingPartyWorkOrderInvoiceConfiguration>;
};

export type BillingDetailsInput = {
  /** Document tags related to documents that should be attached to invoice emails. */
  accountingDocs?: InputMaybe<Array<DocumentTag>>;
  /** Accounting Point of contacts for the billing party. If none are provided the BillingParty's point of contact will be used */
  accountingPointofContacts?: InputMaybe<Array<AccountingPointOfContactInput>>;
  /** Accounting system customer reference: qboId, qboSyncToken etc */
  accountingSystemCustomerReferences?: InputMaybe<Array<AccountingSystemCustomerReferencesInput>>;
  /** Credit related details for the billing party. */
  creditDetails?: InputMaybe<AccountCreditDetailsInput>;
  /** Custom configuration to be used when calculate invoice amount. */
  customFeeConfig?: InputMaybe<CustomFeeConfigurationInput>;
  /** Custom fee configuration to add to invoice lines. */
  customFees?: InputMaybe<Array<InvoiceFeeDetailsInput>>;
  /** If disbursement is true, customer will get 3% disbursement fee on certain outlayed charges. */
  disbursement?: InputMaybe<Scalars['Boolean']>;
  /** Invoice configuration applicable to all work orders */
  invoiceConfiguration?: InputMaybe<BillingPartyInvoiceConfigurationInput>;
  /** Additional amounts to add to invoice lines, to be reimbursed monthly */
  markups?: InputMaybe<Array<InvoiceFeeDetailsInput>>;
  /** External customer onboarding request */
  onboardingRequest?: InputMaybe<IdInput>;
  /** Payment method. eg: Credit Card, Check. */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** Account status for the billing party. */
  status?: InputMaybe<BillingPartyAccountStatus>;
  /** The program plan payment period preference. */
  subscriptionPaymentPeriod?: InputMaybe<SubscriptionPaymentPeriod>;
  /** The program plan with the Operator. */
  subscriptionPlan?: InputMaybe<SubscriptionPlan>;
  /** The program plan payment period preference. */
  trialEndTime?: InputMaybe<Scalars['DateTime']>;
  /** The invoice configuration for a specific type of work order. */
  workOrderInvoiceConfiguration?: InputMaybe<BillingPartyWorkOrderInvoiceConfigurationInput>;
};

export type BillingParty = {
  /** Party addresses */
  addresses?: Maybe<Addresses>;
  /** Billing related details. */
  billingDetails?: Maybe<BillingDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party name */
  name: Scalars['String'];
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Indicates the paying customers account status. */
export enum BillingPartyAccountStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED'
}

/** Billing party configurations for work order invoice. */
export type BillingPartyInvoiceConfiguration = {
  __typename?: 'BillingPartyInvoiceConfiguration';
  /** Setting this field will override the payments terms with `x` number of calendar days from when the invoice gets generated. Since this field represent `x` number of calendar days, this must be a positive integer */
  overridePaymentTerms?: Maybe<Scalars['Int']>;
};

export type BillingPartyInvoiceConfigurationInput = {
  /** Setting this field will override the payments terms with `x` number of calendar days from when the invoice gets generated. Since this field represent `x` number of calendar days, this must be a positive integer */
  overridePaymentTerms?: InputMaybe<Scalars['Int']>;
};

/** Some setting configurations for usConsumptionEntry. */
export type BillingPartyUsConsumptionEntryInvoiceConfiguration = {
  __typename?: 'BillingPartyUsConsumptionEntryInvoiceConfiguration';
  /** Whether to exempt entry fee or not. */
  exemptFromEntryFee?: Maybe<Scalars['Boolean']>;
  /** Work order milestone names which trigger usConsumption entry invoice generation */
  trigger?: Maybe<UsConsumptionEntryInvoiceTriggerMilestoneName>;
};

export type BillingPartyUsConsumptionEntryInvoiceConfigurationInput = {
  /** Whether to exempt entry fee or not. */
  exemptFromEntryFee?: InputMaybe<Scalars['Boolean']>;
  /** Work order milestone names which trigger usConsumption entry invoice generation */
  trigger?: InputMaybe<UsConsumptionEntryInvoiceTriggerMilestoneName>;
};

/** Some setting configurations for usIsf. */
export type BillingPartyUsIsfInvoiceConfiguration = {
  __typename?: 'BillingPartyUsIsfInvoiceConfiguration';
  /** Whether to exempt isf fee or not. */
  exemptFromIsfFee?: Maybe<Scalars['Boolean']>;
};

export type BillingPartyUsIsfInvoiceConfigurationInput = {
  /** Whether to exempt isf fee or not. */
  exemptFromIsfFee?: InputMaybe<Scalars['Boolean']>;
};

/** Billing party configurations for work order invoice. */
export type BillingPartyWorkOrderInvoiceConfiguration = {
  __typename?: 'BillingPartyWorkOrderInvoiceConfiguration';
  /** Billing party configurations for usConsumptionEntry invoice. */
  usConsumptionEntry?: Maybe<BillingPartyUsConsumptionEntryInvoiceConfiguration>;
  /** Billing party configurations for usIsf invoice. */
  usIsf?: Maybe<BillingPartyUsIsfInvoiceConfiguration>;
};

export type BillingPartyWorkOrderInvoiceConfigurationInput = {
  /** Billing party configurations for usConsumptionEntry invoice. */
  usConsumptionEntry?: InputMaybe<BillingPartyUsConsumptionEntryInvoiceConfigurationInput>;
  /** Billing party configurations for usIsf invoice. */
  usIsf?: InputMaybe<BillingPartyUsIsfInvoiceConfigurationInput>;
};

/** Information collected when an importer applies for a customs bond through Amazon. */
export type BondApplicationInformation = {
  __typename?: 'BondApplicationInformation';
  /** Status of the bond application (e.g., DRAFT, PENDING, APPROVED, REJECTED). */
  customBondApplicationStatus?: Maybe<Scalars['String']>;
  /** Expected import duties, taxes, and fees for the next calendar year. */
  expectedDutiesRange?: Maybe<Scalars['String']>;
  /** Primary country or territory the importer imports from. */
  importsFrom?: Maybe<Scalars['String']>;
  /** Expected import duties, taxes, and fees for the previous calendar year. */
  previousAnnualFeesRange?: Maybe<Scalars['String']>;
  /** Description of products/commodities the importer will be importing. */
  productDescription?: Maybe<Scalars['String']>;
  /** Whether commodities are subject to anti-dumping or countervailing duties. */
  supplementaryDutyFlagType?: Maybe<Scalars['String']>;
};

/** Information collected when an importer applies for a customs bond through Amazon. */
export type BondApplicationInformationInput = {
  /** Status of the bond application (e.g., DRAFT, PENDING, APPROVED, REJECTED). */
  customBondApplicationStatus?: InputMaybe<Scalars['String']>;
  /** Expected import duties, taxes, and fees for the next calendar year. */
  expectedDutiesRange?: InputMaybe<Scalars['String']>;
  /** Primary country or territory the importer imports from. */
  importsFrom?: InputMaybe<Scalars['String']>;
  /** Expected import duties, taxes, and fees for the previous calendar year. */
  previousAnnualFeesRange?: InputMaybe<Scalars['String']>;
  /** Description of products/commodities the importer will be importing. */
  productDescription?: InputMaybe<Scalars['String']>;
  /** Whether commodities are subject to anti-dumping or countervailing duties. */
  supplementaryDutyFlagType?: InputMaybe<Scalars['String']>;
};

/** An indication of the status for bond user in IOR number query response. */
export enum BondUserStatusIndicator {
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED'
}

export type BookingParty = Forwarder | Supplier;

/** Boolean Operator */
export enum BooleanOperator {
  AND = 'AND',
  OR = 'OR'
}

export type BooleanSearchCriteriaInput = {
  /** The Operators available for boolean search criteria. */
  operator: BooleanSearchOperator;
};

/** Operators used for boolean based search operations. */
export enum BooleanSearchOperator {
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  EXISTS = 'EXISTS'
}

export type BorderTransportMeans = {
  __typename?: 'BorderTransportMeans';
  /** Date and time of arrival (actual or scheduled) of the means of transport at the first port (e.g. seaport, airport, freight terminal, rail station). */
  arrival?: Maybe<Scalars['DateTime']>;
  /** Details related to the first arrival location. */
  arrivalLocation?: Maybe<Array<ArrivalLocation>>;
  /** Date and time of departure of the means of transport. */
  departure?: Maybe<Scalars['DateTime']>;
  /** Details related to departure location. */
  departureLocation?: Maybe<Array<DepartureLocation>>;
  /** Code specifying type of identifier of the means of transport used for the carriage of the goods in crossing the border. */
  identificationType?: Maybe<Scalars['String']>;
  /** Identification of the journey of a means of transport, for example voyage number, flight number, trip number. */
  journey?: Maybe<Scalars['String']>;
  /** Name to identify the means of transport used for the carriage of the goods in crossing the border. */
  name?: Maybe<Scalars['String']>;
};

export type BorderTransportMeansInput = {
  /** Date and time of arrival (actual or scheduled) of the means of transport at the first port (e.g. seaport, airport, freight terminal, rail station). */
  arrival?: InputMaybe<Scalars['DateTime']>;
  /** Details related to the first arrival location. */
  arrivalLocation?: InputMaybe<Array<ArrivalLocationInput>>;
  /** Date and time of departure of the means of transport. */
  departure?: InputMaybe<Scalars['DateTime']>;
  /** Details related to departure location. */
  departureLocation?: InputMaybe<Array<DepartureLocationInput>>;
  /** Code specifying type of identifier of the means of transport used for the carriage of the goods in crossing the border. */
  identificationType?: InputMaybe<Scalars['String']>;
  /** Identification of the journey of a means of transport, for example voyage number, flight number, trip number. */
  journey?: InputMaybe<Scalars['String']>;
  /** Name to identify the means of transport used for the carriage of the goods in crossing the border. */
  name?: InputMaybe<Scalars['String']>;
};

export type Broker = Agent & CustomsBroker & Party & Record & {
  __typename?: 'Broker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Code specifying the capacity in which the agent is acting. */
  function?: Maybe<Scalars['String']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Code specifying the issuing country of the party's identifiers.  Complies to ISO 3166-1 alpha 2. */
  identificationIssuingCountry?: Maybe<Scalars['CountryCode']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Code specifying where quality assurance level of the agent should be used. */
  qualityAssurance?: Maybe<Scalars['String']>;
  /** A Shipper linked to this Broker */
  shipper: ShipperBrokerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: BrokerShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type BrokermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type BrokershipperArgs = {
  shipperId: Scalars['ID'];
};


export type BrokershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type BrokerEdge = ConnectionEdge & {
  __typename?: 'BrokerEdge';
  cursor: Scalars['ID'];
  node: Broker;
};

/** Current Broker list INLT, REGIONAL_EXPRESS, ZENITH, AVASK and DELOITTE */
export enum BrokerEntityName {
  AVASK = 'AVASK',
  DELOITTE = 'DELOITTE',
  INLT = 'INLT',
  REGIONAL_EXPRESS = 'REGIONAL_EXPRESS',
  ZENITH = 'ZENITH'
}

/** Broker-level configurations relating to IOR activations involving this broker. */
export type BrokerIorActivationConfig = {
  __typename?: 'BrokerIorActivationConfig';
  /** Whether IOR activations involving this broker should be automatically approved. */
  shouldAutoApproveIorActivation?: Maybe<Scalars['Boolean']>;
};

/** Broker-level configurations relating to IOR activations involving this broker. */
export type BrokerIorActivationConfigInput = {
  /** Whether IOR activations involving this broker should be automatically approved. */
  shouldAutoApproveIorActivation?: InputMaybe<Scalars['Boolean']>;
};

/** Reason why broker rejected the IOR */
export enum BrokerRejectionReason {
  ADDITIONAL_INFORMATION_MATERIALS_REQUIRED_FOR_PRODUCT_LIST = 'ADDITIONAL_INFORMATION_MATERIALS_REQUIRED_FOR_PRODUCT_LIST',
  AMAZON_WILL_CONTACT_FOR_DETAILED_REJECT_REASONS = 'AMAZON_WILL_CONTACT_FOR_DETAILED_REJECT_REASONS',
  BLR_DOCUMENTS_INCORRECT = 'BLR_DOCUMENTS_INCORRECT',
  BUSINESS_LICENSE_DOCUMENT_EXPIRED = 'BUSINESS_LICENSE_DOCUMENT_EXPIRED',
  BUSINESS_LICENSE_DOCUMENT_MISSING_OR_INVALID = 'BUSINESS_LICENSE_DOCUMENT_MISSING_OR_INVALID',
  BUSINESS_TYPE_IN_POA_NOT_ALIGNED_US = 'BUSINESS_TYPE_IN_POA_NOT_ALIGNED_US',
  C7500_FORM_INFORMATION_INCOMPLETE = 'C7500_FORM_INFORMATION_INCOMPLETE',
  C7500_FORM_INFORMATION_NOT_CORRECT = 'C7500_FORM_INFORMATION_NOT_CORRECT',
  C7500_FORM_NEEDS_NON_EDITABLE_FORMAT = 'C7500_FORM_NEEDS_NON_EDITABLE_FORMAT',
  C7500_FORM_TEMPLATE_NOT_CORRECT_OR_COMPLETE = 'C7500_FORM_TEMPLATE_NOT_CORRECT_OR_COMPLETE',
  C7500_FORM_UNCLEAR_ILLEGIBLE = 'C7500_FORM_UNCLEAR_ILLEGIBLE',
  COMPANY_ADDRESS_INCORRECT = 'COMPANY_ADDRESS_INCORRECT',
  COMPANY_ADDRESS_MISMATCH_BETWEEN_POA_AND_IOR_PROFILE = 'COMPANY_ADDRESS_MISMATCH_BETWEEN_POA_AND_IOR_PROFILE',
  COMPANY_NAME_INCORRECT = 'COMPANY_NAME_INCORRECT',
  COMPANY_NAME_MISMATCH_BETWEEN_VAT_AND_EORI = 'COMPANY_NAME_MISMATCH_BETWEEN_VAT_AND_EORI',
  COMPANY_STAMP_MISSING = 'COMPANY_STAMP_MISSING',
  COMPLIANCE_RC_ACCOUNT_FROZEN = 'COMPLIANCE_RC_ACCOUNT_FROZEN',
  COMPLIANCE_RC_ADDL_PASSPORT_INFO_REQUIRED = 'COMPLIANCE_RC_ADDL_PASSPORT_INFO_REQUIRED',
  COMPLIANCE_RC_COMPANY_EMAIL_AT_SIGNS = 'COMPLIANCE_RC_COMPANY_EMAIL_AT_SIGNS',
  COMPLIANCE_RC_CONTACT_ADDRESS_INVALID = 'COMPLIANCE_RC_CONTACT_ADDRESS_INVALID',
  COMPLIANCE_RC_CONTACT_EMAIL_AT_SIGNS = 'COMPLIANCE_RC_CONTACT_EMAIL_AT_SIGNS',
  COMPLIANCE_RC_CONTACT_SSN_ONFILE = 'COMPLIANCE_RC_CONTACT_SSN_ONFILE',
  COMPLIANCE_RC_CONTACT_SSN_REQUIRED = 'COMPLIANCE_RC_CONTACT_SSN_REQUIRED',
  COMPLIANCE_RC_DOC_ESIGN_EXPIRED_30DAYS = 'COMPLIANCE_RC_DOC_ESIGN_EXPIRED_30DAYS',
  COMPLIANCE_RC_EXCEEDS_MAX_PO_BOX_LENGTH = 'COMPLIANCE_RC_EXCEEDS_MAX_PO_BOX_LENGTH',
  COMPLIANCE_RC_IMPORTER_ACCOUNT_IS_INACTIVE = 'COMPLIANCE_RC_IMPORTER_ACCOUNT_IS_INACTIVE',
  COMPLIANCE_RC_IMPORTER_NAME_BLANK = 'COMPLIANCE_RC_IMPORTER_NAME_BLANK',
  COMPLIANCE_RC_IMPORTER_PHYS_ADDRESS_INVALID = 'COMPLIANCE_RC_IMPORTER_PHYS_ADDRESS_INVALID',
  COMPLIANCE_RC_IMPTYPES_REQUIRE_US = 'COMPLIANCE_RC_IMPTYPES_REQUIRE_US',
  COMPLIANCE_RC_IMPTYPE_REQUIRED_FOR_US = 'COMPLIANCE_RC_IMPTYPE_REQUIRED_FOR_US',
  COMPLIANCE_RC_INVALID_CANADIAN_MAIL_PROVINCE_CODE = 'COMPLIANCE_RC_INVALID_CANADIAN_MAIL_PROVINCE_CODE',
  COMPLIANCE_RC_INVALID_CANADIAN_MAIL_ZIP_FORMAT = 'COMPLIANCE_RC_INVALID_CANADIAN_MAIL_ZIP_FORMAT',
  COMPLIANCE_RC_INVALID_CANADIAN_PHYS_PROVINCE_CODE = 'COMPLIANCE_RC_INVALID_CANADIAN_PHYS_PROVINCE_CODE',
  COMPLIANCE_RC_INVALID_CANADIAN_PHYS_ZIP_FORMAT = 'COMPLIANCE_RC_INVALID_CANADIAN_PHYS_ZIP_FORMAT',
  COMPLIANCE_RC_INVALID_COUNTRY_CODE = 'COMPLIANCE_RC_INVALID_COUNTRY_CODE',
  COMPLIANCE_RC_INVALID_DATA_FORMAT = 'COMPLIANCE_RC_INVALID_DATA_FORMAT',
  COMPLIANCE_RC_INVALID_FILER_CODE = 'COMPLIANCE_RC_INVALID_FILER_CODE',
  COMPLIANCE_RC_INVALID_IMPORTER_NUMBER = 'COMPLIANCE_RC_INVALID_IMPORTER_NUMBER',
  COMPLIANCE_RC_INVALID_IMPORTER_NUM_FORMAT = 'COMPLIANCE_RC_INVALID_IMPORTER_NUM_FORMAT',
  COMPLIANCE_RC_INVALID_MAIL_ADDRESS = 'COMPLIANCE_RC_INVALID_MAIL_ADDRESS',
  COMPLIANCE_RC_INVALID_MAIL_ALPHABETIC = 'COMPLIANCE_RC_INVALID_MAIL_ALPHABETIC',
  COMPLIANCE_RC_INVALID_MAIL_STATE_CODE = 'COMPLIANCE_RC_INVALID_MAIL_STATE_CODE',
  COMPLIANCE_RC_INVALID_MAIL_ZIP_CODE = 'COMPLIANCE_RC_INVALID_MAIL_ZIP_CODE',
  COMPLIANCE_RC_INVALID_PHYADDR_ALPHABETIC = 'COMPLIANCE_RC_INVALID_PHYADDR_ALPHABETIC',
  COMPLIANCE_RC_INVALID_PHYADDR_TYPE = 'COMPLIANCE_RC_INVALID_PHYADDR_TYPE',
  COMPLIANCE_RC_INVALID_PHYS_ISO_COUNTRY_CODE = 'COMPLIANCE_RC_INVALID_PHYS_ISO_COUNTRY_CODE',
  COMPLIANCE_RC_INVALID_PHYS_STATE_CODE = 'COMPLIANCE_RC_INVALID_PHYS_STATE_CODE',
  COMPLIANCE_RC_INVALID_PHYS_ZIP_CODE = 'COMPLIANCE_RC_INVALID_PHYS_ZIP_CODE',
  COMPLIANCE_RC_INVALID_RELATED_BUSINESS_IR_NUMBER = 'COMPLIANCE_RC_INVALID_RELATED_BUSINESS_IR_NUMBER',
  COMPLIANCE_RC_IOR_DPS_DENIED_PARTY = 'COMPLIANCE_RC_IOR_DPS_DENIED_PARTY',
  COMPLIANCE_RC_LINE1_MAIL_MISSING = 'COMPLIANCE_RC_LINE1_MAIL_MISSING',
  COMPLIANCE_RC_MAILING_ADDRESS_EXPLANATION_REQUIRED = 'COMPLIANCE_RC_MAILING_ADDRESS_EXPLANATION_REQUIRED',
  COMPLIANCE_RC_MAIL_CITY_MISSING = 'COMPLIANCE_RC_MAIL_CITY_MISSING',
  COMPLIANCE_RC_MAIL_COUNTRYCODE_MISSING = 'COMPLIANCE_RC_MAIL_COUNTRYCODE_MISSING',
  COMPLIANCE_RC_MAIL_STATE_MISSING = 'COMPLIANCE_RC_MAIL_STATE_MISSING',
  COMPLIANCE_RC_MAIL_ZIP_CODE_REQUIRED = 'COMPLIANCE_RC_MAIL_ZIP_CODE_REQUIRED',
  COMPLIANCE_RC_NEWREQUEST_ADDR_USED = 'COMPLIANCE_RC_NEWREQUEST_ADDR_USED',
  COMPLIANCE_RC_NOT_PROVIDE_IMPORTER_NUMBER = 'COMPLIANCE_RC_NOT_PROVIDE_IMPORTER_NUMBER',
  COMPLIANCE_RC_ONFILE_IMPORTER_NUMBER = 'COMPLIANCE_RC_ONFILE_IMPORTER_NUMBER',
  COMPLIANCE_RC_OTHER_MAILING_ADDRTYPE_MISMATCH = 'COMPLIANCE_RC_OTHER_MAILING_ADDRTYPE_MISMATCH',
  COMPLIANCE_RC_OTHER_PHYSICAL_ADDRTYPE_MISMATCH = 'COMPLIANCE_RC_OTHER_PHYSICAL_ADDRTYPE_MISMATCH',
  COMPLIANCE_RC_PERSON_ADDRESS_INVALID = 'COMPLIANCE_RC_PERSON_ADDRESS_INVALID',
  COMPLIANCE_RC_PHYADDR_CITY_MISSING = 'COMPLIANCE_RC_PHYADDR_CITY_MISSING',
  COMPLIANCE_RC_PHYADDR_COUNTRYCODE_MISSING = 'COMPLIANCE_RC_PHYADDR_COUNTRYCODE_MISSING',
  COMPLIANCE_RC_PHYADDR_STATE_MISSING = 'COMPLIANCE_RC_PHYADDR_STATE_MISSING',
  COMPLIANCE_RC_PHYSICAL_ADDRESS_EXPLANATION_REQUIRED = 'COMPLIANCE_RC_PHYSICAL_ADDRESS_EXPLANATION_REQUIRED',
  COMPLIANCE_RC_PHYSICAL_ADDRESS_TYPE_REQUIRED = 'COMPLIANCE_RC_PHYSICAL_ADDRESS_TYPE_REQUIRED',
  COMPLIANCE_RC_PHYS_ADDR_MISSING = 'COMPLIANCE_RC_PHYS_ADDR_MISSING',
  COMPLIANCE_RC_PHYS_ZIP_CODE_REQUIRED = 'COMPLIANCE_RC_PHYS_ZIP_CODE_REQUIRED',
  COMPLIANCE_RC_PO_BOX_MAILING_DDRTYPE_MISMATCH = 'COMPLIANCE_RC_PO_BOX_MAILING_DDRTYPE_MISMATCH',
  COMPLIANCE_RC_REASON_CODE_MISSING = 'COMPLIANCE_RC_REASON_CODE_MISSING',
  COMPLIANCE_RC_REASON_NOT_ALLOWED = 'COMPLIANCE_RC_REASON_NOT_ALLOWED',
  COMPLIANCE_RC_RELATED_BUSINESS_NAME_MISMATCH = 'COMPLIANCE_RC_RELATED_BUSINESS_NAME_MISMATCH',
  COMPLIANCE_RC_VOIDED_IMPORTER_NUMBER = 'COMPLIANCE_RC_VOIDED_IMPORTER_NUMBER',
  CONTACT_INFORMATION_INCORRECT = 'CONTACT_INFORMATION_INCORRECT',
  CONTACT_PERSON_INFORMATION_NOT_CORRECT = 'CONTACT_PERSON_INFORMATION_NOT_CORRECT',
  COPY_OF_ID_PASSPORT_INCORRECT = 'COPY_OF_ID_PASSPORT_INCORRECT',
  CUSTOMER_CALL_CS_TO_WITHDRAW = 'CUSTOMER_CALL_CS_TO_WITHDRAW',
  CUSTOMS_BROKER_REJECTED_IOR = 'CUSTOMS_BROKER_REJECTED_IOR',
  CUSTOMS_CREDITS_INCORRECT = 'CUSTOMS_CREDITS_INCORRECT',
  DOCUMENTS_WILL_EXPIRE_IN_45_DAYS = 'DOCUMENTS_WILL_EXPIRE_IN_45_DAYS',
  DPS_DENIED_PARTY = 'DPS_DENIED_PARTY',
  ENGLISH_NAME_NOT_ADDED_ON_BUSINESS_LICENSE = 'ENGLISH_NAME_NOT_ADDED_ON_BUSINESS_LICENSE',
  ENGLISH_NAME_NOT_SIGNED_ON_BUSINESS_LICENSE = 'ENGLISH_NAME_NOT_SIGNED_ON_BUSINESS_LICENSE',
  EORI_MISMATCH_BETWEEN_POA_AND_IOR_PROFILE = 'EORI_MISMATCH_BETWEEN_POA_AND_IOR_PROFILE',
  EORI_NOT_VALID_OR_NOT_ALIGNED_EU = 'EORI_NOT_VALID_OR_NOT_ALIGNED_EU',
  ESIGNATURE_PERSON_NAME_NOT_ALIGNED = 'ESIGNATURE_PERSON_NAME_NOT_ALIGNED',
  ESIGNATURE_PERSON_TITLE_NOT_ALIGNED = 'ESIGNATURE_PERSON_TITLE_NOT_ALIGNED',
  EUK_IOR_VAT_EORI_INVALID_OR_MISALIGNED = 'EUK_IOR_VAT_EORI_INVALID_OR_MISALIGNED',
  GOODS_IMPORT_EXCEEDS_BROKER_COMPLIANCE_RISK_THRESHOLD = 'GOODS_IMPORT_EXCEEDS_BROKER_COMPLIANCE_RISK_THRESHOLD',
  GOODS_IMPORT_OUTSIDE_OF_BROKER_BUSINESS_SCOPE = 'GOODS_IMPORT_OUTSIDE_OF_BROKER_BUSINESS_SCOPE',
  IMPORTER_COMPANY_ADDRESS_INCORRECT = 'IMPORTER_COMPANY_ADDRESS_INCORRECT',
  IMPORTER_COMPANY_ADDRESS_IN_POA_NOT_ALIGNED = 'IMPORTER_COMPANY_ADDRESS_IN_POA_NOT_ALIGNED',
  IMPORTER_COMPANY_ADDRESS_MAILING_INCORRECT = 'IMPORTER_COMPANY_ADDRESS_MAILING_INCORRECT',
  IMPORTER_COMPANY_ADDRESS_NOT_ALIGNED_WITH_NAME = 'IMPORTER_COMPANY_ADDRESS_NOT_ALIGNED_WITH_NAME',
  IMPORTER_COMPANY_BUSINESS_TYPE_NOT_CORRECT_US = 'IMPORTER_COMPANY_BUSINESS_TYPE_NOT_CORRECT_US',
  IMPORTER_COMPANY_NAME_INCORRECT = 'IMPORTER_COMPANY_NAME_INCORRECT',
  IMPORTER_COMPANY_NAME_IN_POA_NOT_ALIGNED = 'IMPORTER_COMPANY_NAME_IN_POA_NOT_ALIGNED',
  IMPORTER_COMPANY_NAME_NOT_CORRECT = 'IMPORTER_COMPANY_NAME_NOT_CORRECT',
  IMPORTER_COMPANY_RESIDENT_STATUS_NOT_CORRECT = 'IMPORTER_COMPANY_RESIDENT_STATUS_NOT_CORRECT',
  IMPORTER_ENTITY_IS_RESTRICTED_PARTY = 'IMPORTER_ENTITY_IS_RESTRICTED_PARTY',
  IMPORTER_NUMBER_NOT_VALID = 'IMPORTER_NUMBER_NOT_VALID',
  IMPORTER_PRIMARY_CONTACT_INFORMATION_INCORRECT = 'IMPORTER_PRIMARY_CONTACT_INFORMATION_INCORRECT',
  INCOMPLETE_MASTER_POA = 'INCOMPLETE_MASTER_POA',
  INCOMPLETE_SUB_POA = 'INCOMPLETE_SUB_POA',
  INCOMPLETE_SUPPORTING_DOCUMENTATION = 'INCOMPLETE_SUPPORTING_DOCUMENTATION',
  INCORRECT_IMPORTER_COMPANY_NAME = 'INCORRECT_IMPORTER_COMPANY_NAME',
  INSUFFICIENT_INFORMATION_FOR_DUE_DILIGENCE_CHECKS = 'INSUFFICIENT_INFORMATION_FOR_DUE_DILIGENCE_CHECKS',
  INSUFFICIENT_MASTER_POA_SIGNATORY_TITLE = 'INSUFFICIENT_MASTER_POA_SIGNATORY_TITLE',
  INSUFFICIENT_SUB_POA_SIGNATORY_TITLE = 'INSUFFICIENT_SUB_POA_SIGNATORY_TITLE',
  INVALID_CAIN_NUMBER = 'INVALID_CAIN_NUMBER',
  INVALID_EIN_NUMBER = 'INVALID_EIN_NUMBER',
  INVALID_EORI_NUMBER = 'INVALID_EORI_NUMBER',
  INVALID_MASTER_POA_SIGNATURE = 'INVALID_MASTER_POA_SIGNATURE',
  INVALID_SUB_POA_SIGNATURE = 'INVALID_SUB_POA_SIGNATURE',
  INVALID_VAT_NUMBER = 'INVALID_VAT_NUMBER',
  IRS_DOCUMENTS_INCORRECT = 'IRS_DOCUMENTS_INCORRECT',
  JAPAN_CUSTOMS_REJECTED_IOR = 'JAPAN_CUSTOMS_REJECTED_IOR',
  JP_IOR_ALL_PRODUCTS_NOT_ELIGIBLE_FOR_ACP_CLEARANCE = 'JP_IOR_ALL_PRODUCTS_NOT_ELIGIBLE_FOR_ACP_CLEARANCE',
  JP_IOR_C7500_INCORRECT = 'JP_IOR_C7500_INCORRECT',
  JP_IOR_CLIENT_REGISTRATION_INQUIRY_FORM_DOCUMENT_INCORRECT = 'JP_IOR_CLIENT_REGISTRATION_INQUIRY_FORM_DOCUMENT_INCORRECT',
  JP_IOR_CORPORATION_NUMBER_BLR_NUMBER_JCT_NUMBER_INVALID_OR_MISALIGNED = 'JP_IOR_CORPORATION_NUMBER_BLR_NUMBER_JCT_NUMBER_INVALID_OR_MISALIGNED',
  JP_IOR_PRODUCT_LIST_INCORRECT = 'JP_IOR_PRODUCT_LIST_INCORRECT',
  JP_IOR_STORE_INFORMATION_MISMATCH_WITH_BLR = 'JP_IOR_STORE_INFORMATION_MISMATCH_WITH_BLR',
  LLC_MEMBER_LIST_NOT_COMPLETE = 'LLC_MEMBER_LIST_NOT_COMPLETE',
  LLC_MEMBER_LIST_NOT_SIGNED = 'LLC_MEMBER_LIST_NOT_SIGNED',
  MASTER_POA_INFORMATION_INCORRECT = 'MASTER_POA_INFORMATION_INCORRECT',
  MASTER_POA_SIGNATURE_NOT_IN_ENGLISH = 'MASTER_POA_SIGNATURE_NOT_IN_ENGLISH',
  MISSING_COPY_ID_CARD_POA_SIGNATORY_PERSON_ES = 'MISSING_COPY_ID_CARD_POA_SIGNATORY_PERSON_ES',
  MISSING_EMPOWERMENT_LETTER_POA_SIGNATORY_PERSON_ES = 'MISSING_EMPOWERMENT_LETTER_POA_SIGNATORY_PERSON_ES',
  MISSING_GOVERNMENT_PRE_PRINTED_NAME_ADDRESS_DOCUMENTATION = 'MISSING_GOVERNMENT_PRE_PRINTED_NAME_ADDRESS_DOCUMENTATION',
  MISSING_KBIS_FILE_FRANCE_ONLY = 'MISSING_KBIS_FILE_FRANCE_ONLY',
  MISSING_LLC_LIST_DOCUMENT = 'MISSING_LLC_LIST_DOCUMENT',
  MISSING_NRCC = 'MISSING_NRCC',
  MISSING_PARTNERSHIP_AGREEMENT_DOCUMENT = 'MISSING_PARTNERSHIP_AGREEMENT_DOCUMENT',
  MISSING_REQUIRED_AUDIT_DOCUMENTS = 'MISSING_REQUIRED_AUDIT_DOCUMENTS',
  MISSING_REQUIRED_DOCUMENTS = 'MISSING_REQUIRED_DOCUMENTS',
  NECESSARY_INFORMATION_OR_DOCUMENTS_NOT_CORRECT = 'NECESSARY_INFORMATION_OR_DOCUMENTS_NOT_CORRECT',
  NON_COMPLIANCE_WITH_GOVERNMENT_RULES_OR_REGULATIONS = 'NON_COMPLIANCE_WITH_GOVERNMENT_RULES_OR_REGULATIONS',
  NRCC_CAPACITY_OR_TITLE_INVALID = 'NRCC_CAPACITY_OR_TITLE_INVALID',
  NRCC_COMPANY_NAME_ADDRESS_NOT_ALIGNED = 'NRCC_COMPANY_NAME_ADDRESS_NOT_ALIGNED',
  NRCC_ESIGN_INFORMATION_INCONSISTENT = 'NRCC_ESIGN_INFORMATION_INCONSISTENT',
  NRCC_FORM_NO_LOGO_OR_COMPANY_STAMP = 'NRCC_FORM_NO_LOGO_OR_COMPANY_STAMP',
  OTHER = 'OTHER',
  PARTNERSHIP_AGREEMENT_DOCUMENT_INCORRECT = 'PARTNERSHIP_AGREEMENT_DOCUMENT_INCORRECT',
  PARTNERSHIP_DOCUMENT_NOT_COMPLETE = 'PARTNERSHIP_DOCUMENT_NOT_COMPLETE',
  POA_ESIGN_INFORMATION_INCONSISTENT = 'POA_ESIGN_INFORMATION_INCONSISTENT',
  POA_FILE_NEEDS_NON_EDITABLE_FORMAT = 'POA_FILE_NEEDS_NON_EDITABLE_FORMAT',
  POA_FILE_UNCLEAR_ILLEGIBLE = 'POA_FILE_UNCLEAR_ILLEGIBLE',
  POA_INFORMATION_INCOMPLETE = 'POA_INFORMATION_INCOMPLETE',
  POA_INFORMATION_NOT_CORRECT = 'POA_INFORMATION_NOT_CORRECT',
  POA_PLATFORM_INFORMATION_INCORRECT = 'POA_PLATFORM_INFORMATION_INCORRECT',
  POA_SIGNATORY_NAME_NOT_ALIGNED_WITH_IMPORTER_ENTITY = 'POA_SIGNATORY_NAME_NOT_ALIGNED_WITH_IMPORTER_ENTITY',
  POA_SIGNATORY_NAME_OR_TITLE_INVALID = 'POA_SIGNATORY_NAME_OR_TITLE_INVALID',
  POA_SIGNATORY_PERSON_NAME_NOT_COMPLETED = 'POA_SIGNATORY_PERSON_NAME_NOT_COMPLETED',
  POA_SIGNATORY_PERSON_TITLE_NOT_CORRECT = 'POA_SIGNATORY_PERSON_TITLE_NOT_CORRECT',
  POA_SIGNATORY_TITLE_NOT_ALIGNED_WITH_JOB_TITLE = 'POA_SIGNATORY_TITLE_NOT_ALIGNED_WITH_JOB_TITLE',
  POA_TEMPLATE_INCORRECT = 'POA_TEMPLATE_INCORRECT',
  POA_TEMPLATE_INFORMATION_INCORRECT = 'POA_TEMPLATE_INFORMATION_INCORRECT',
  POA_TEMPLATE_NOT_CORRECT_OR_COMPLETE = 'POA_TEMPLATE_NOT_CORRECT_OR_COMPLETE',
  POA_WILL_EXPIRE_IN_45_DAYS = 'POA_WILL_EXPIRE_IN_45_DAYS',
  PRINTED_NAME_NOT_IN_ENGLISH_OR_NOT_COMPLETE = 'PRINTED_NAME_NOT_IN_ENGLISH_OR_NOT_COMPLETE',
  PRODUCT_LIST_CONTAINS_INELIGIBLE_ASINS = 'PRODUCT_LIST_CONTAINS_INELIGIBLE_ASINS',
  PRODUCT_LIST_INFORMATION_INCOMPLETE = 'PRODUCT_LIST_INFORMATION_INCOMPLETE',
  PRODUCT_LIST_TEMPLATE_NOT_CORRECT_OR_COMPLETE = 'PRODUCT_LIST_TEMPLATE_NOT_CORRECT_OR_COMPLETE',
  PVA_DOCUMENT_INCORRECT = 'PVA_DOCUMENT_INCORRECT',
  PVA_INFORMATION_INCORRECT = 'PVA_INFORMATION_INCORRECT',
  REQUIRED_INFORMATION_MATERIALS_MISSING_FOR_IMPORTER_REGISTRATION = 'REQUIRED_INFORMATION_MATERIALS_MISSING_FOR_IMPORTER_REGISTRATION',
  SELLER_CANCELED_IMPORTER_COMPLIANCE_ONBOARDING_APPLICATION = 'SELLER_CANCELED_IMPORTER_COMPLIANCE_ONBOARDING_APPLICATION',
  SELLER_NOT_ELIGIBLE_FOR_IOR_APPLICATION = 'SELLER_NOT_ELIGIBLE_FOR_IOR_APPLICATION',
  SIGNATORY_INFORMATION_INCORRECT = 'SIGNATORY_INFORMATION_INCORRECT',
  SIGNATORY_POSITION_INCORRECT = 'SIGNATORY_POSITION_INCORRECT',
  SIREN_NUMBER_INCORRECT = 'SIREN_NUMBER_INCORRECT',
  SUB_POA_SIGNATURE_NOT_IN_ENGLISH = 'SUB_POA_SIGNATURE_NOT_IN_ENGLISH',
  SYSTEM_ISSUE = 'SYSTEM_ISSUE',
  US_IOR_BOND_STATUS_INFORMATION_INCORRECT = 'US_IOR_BOND_STATUS_INFORMATION_INCORRECT',
  US_IOR_BUSINESS_TYPE_INCORRECT = 'US_IOR_BUSINESS_TYPE_INCORRECT',
  US_IOR_DBA_INFORMATION_INCORRECT = 'US_IOR_DBA_INFORMATION_INCORRECT',
  US_IOR_NRCC_PLATFORM_INFORMATION_INCORRECT = 'US_IOR_NRCC_PLATFORM_INFORMATION_INCORRECT',
  US_IOR_STATE_OF_INCORPORATION_INCORRECT = 'US_IOR_STATE_OF_INCORPORATION_INCORRECT',
  VALID_IDENTIFIER_ID_MISSING_JP = 'VALID_IDENTIFIER_ID_MISSING_JP',
  VALID_POA_SIGNATURE_OR_COMPANY_STAMP_MISSING = 'VALID_POA_SIGNATURE_OR_COMPANY_STAMP_MISSING',
  VALID_POA_SIGNATURE_OR_COMPANY_STAMP_MISSING_C7500 = 'VALID_POA_SIGNATURE_OR_COMPANY_STAMP_MISSING_C7500',
  VAT_DOCUMENT_INCORRECT = 'VAT_DOCUMENT_INCORRECT',
  VAT_EORI_INFORMATION_INCORRECT = 'VAT_EORI_INFORMATION_INCORRECT',
  VAT_MISMATCH_BETWEEN_POA_AND_IOR_PROFILE = 'VAT_MISMATCH_BETWEEN_POA_AND_IOR_PROFILE',
  VAT_NOT_VALID_OR_NOT_ALIGNED_EU = 'VAT_NOT_VALID_OR_NOT_ALIGNED_EU'
}

/** Broker representation for the Importer */
export enum BrokerRepresentation {
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT'
}

export type BrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Code specifying the issuing country of the party's identifiers.  Complies to ISO 3166-1 alpha 2. */
  identificationIssuingCountry?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** Search Broker by associated identifier e.g. vat number, eori number, ein, cbp assigned etc */
  identifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type BrokerSearchTableRow = {
  __typename?: 'BrokerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Code specifying the issuing country of the party's identifiers.  Complies to ISO 3166-1 alpha 2. */
  identificationIssuingCountry?: Maybe<Scalars['CountryCode']>;
  /** Search Broker by associated identifier e.g. vat number, eori number, ein, cbp assigned etc */
  identifier?: Maybe<Scalars['String']>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type BrokerShipperEdge = ConnectionEdge & {
  __typename?: 'BrokerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Broker. */
  relationship: ShipperBrokerRelationship;
};

export type BrokerShippersConnection = Connection & {
  __typename?: 'BrokerShippersConnection';
  edges: Array<BrokerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type BrokersConnection = Connection & {
  __typename?: 'BrokersConnection';
  edges: Array<BrokerEdge>;
  nodes: Array<Broker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type BulkChargesUploadRequest = Record & {
  __typename?: 'BulkChargesUploadRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The document associated with the request  */
  document: Document;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** All the records and their failure reasons in the request */
  results?: Maybe<Array<BulkChargesUploaderResult>>;
  /**  The status of BulkUpload Request */
  status?: Maybe<BulkUploadStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Total number of failed rows */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Total number of creation requests in the document */
  totalRows?: Maybe<Scalars['Int']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type BulkChargesUploadRequestEdge = ConnectionEdge & {
  __typename?: 'BulkChargesUploadRequestEdge';
  cursor: Scalars['ID'];
  node: BulkChargesUploadRequest;
};

export type BulkChargesUploadRequestSearchCriteriaInput = {
  /** The id of the customs broker linked to the request */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The document associated with the request  */
  documentId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /**  The status of BulkUpload Request */
  status?: InputMaybe<BulkUploadStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Bulk Charge Upload search table row */
export type BulkChargesUploadRequestSearchTableRow = RecordSearchTableRow & {
  __typename?: 'BulkChargesUploadRequestSearchTableRow';
  /** The id of the customs broker linked to the request */
  brokerId?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The document associated with the request  */
  documentId?: Maybe<Scalars['ID']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The operator who owns this request  */
  operatorId?: Maybe<Scalars['ID']>;
  /** The current status of the request */
  status?: Maybe<Scalars['String']>;
  /** The number of failures in request */
  totalFailures?: Maybe<Scalars['Int']>;
  /** The number of rows in request */
  totalRows?: Maybe<Scalars['Int']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type BulkChargesUploadRequestsConnection = Connection & {
  __typename?: 'BulkChargesUploadRequestsConnection';
  edges: Array<BulkChargesUploadRequestEdge>;
  nodes: Array<BulkChargesUploadRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type BulkChargesUploaderFields = {
  __typename?: 'BulkChargesUploaderFields';
  /** The amount in the request */
  amount?: Maybe<Scalars['Float']>;
  /** The type of charge in the request */
  charge?: Maybe<Scalars['String']>;
  /** The type of currency the charge will be paid in */
  currency?: Maybe<Scalars['String']>;
  /** The identifier in the request */
  identifier?: Maybe<Scalars['String']>;
  /** The type of identifier in the request */
  identifierType?: Maybe<Scalars['String']>;
};

export type BulkChargesUploaderFieldsInput = {
  /** The amount in the request */
  amount?: InputMaybe<Scalars['Float']>;
  /** The type of charge in the request */
  charge?: InputMaybe<Scalars['String']>;
  /** The type of currency the charge will be paid in */
  currency?: InputMaybe<Scalars['String']>;
  /** The identifier in the request */
  identifier?: InputMaybe<Scalars['String']>;
  /** The type of identifier in the request */
  identifierType?: InputMaybe<Scalars['String']>;
};

export type BulkChargesUploaderResult = {
  __typename?: 'BulkChargesUploaderResult';
  /** The reason for failure */
  failureReason?: Maybe<Scalars['String']>;
  /** The fields in this request */
  fields?: Maybe<BulkChargesUploaderFields>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

export type BulkChargesUploaderResultInput = {
  /** The reason for failure */
  failureReason?: InputMaybe<Scalars['String']>;
  /** The fields in this request */
  fields?: InputMaybe<BulkChargesUploaderFieldsInput>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

export type BulkComplianceUploadRequest = Record & {
  __typename?: 'BulkComplianceUploadRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The document associated with the request  */
  document: Document;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** All the records and their failure reasons in the request */
  results?: Maybe<Array<BulkComplianceUploaderResult>>;
  /**  The status of BulkUpload Request */
  status?: Maybe<BulkUploadStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Total number of failed rows */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Total number of creation requests in the document */
  totalRows?: Maybe<Scalars['Int']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type BulkComplianceUploadRequestEdge = ConnectionEdge & {
  __typename?: 'BulkComplianceUploadRequestEdge';
  cursor: Scalars['ID'];
  node: BulkComplianceUploadRequest;
};

export type BulkComplianceUploadRequestSearchCriteriaInput = {
  /** The id of the customs broker linked to the request */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The document associated with the request  */
  documentId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /**  The status of BulkUpload Request */
  status?: InputMaybe<BulkUploadStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Bulk Compliance Upload search table row */
export type BulkComplianceUploadRequestSearchTableRow = RecordSearchTableRow & {
  __typename?: 'BulkComplianceUploadRequestSearchTableRow';
  /** The customs broker id of the user who created the request. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The document associated with the request  */
  documentId?: Maybe<Scalars['ID']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The operator who owns this request  */
  operatorId?: Maybe<Scalars['ID']>;
  /** The current status of the request */
  status?: Maybe<BulkUploadStatus>;
  /** The number of failures in request */
  totalFailures?: Maybe<Scalars['Int']>;
  /** The number of rows in request */
  totalRows?: Maybe<Scalars['Int']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type BulkComplianceUploadRequestsConnection = Connection & {
  __typename?: 'BulkComplianceUploadRequestsConnection';
  edges: Array<BulkComplianceUploadRequestEdge>;
  nodes: Array<BulkComplianceUploadRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type BulkComplianceUploaderFields = {
  __typename?: 'BulkComplianceUploaderFields';
  /** The identifier in the request */
  identifier?: Maybe<Scalars['String']>;
  /** The type of identifier in the request.  Currently only bookingId (AL0 reference) is supported */
  identifierType?: Maybe<Scalars['String']>;
  /** The importEntryNumber tied to the given identifier */
  importEntryNumber?: Maybe<Scalars['String']>;
};

export type BulkComplianceUploaderFieldsInput = {
  /** The identifier in the request */
  identifier?: InputMaybe<Scalars['String']>;
  /** The type of identifier in the request.  Currently only bookingId (AL0 reference) is supported */
  identifierType?: InputMaybe<Scalars['String']>;
  /** The importEntryNumber tied to the given identifier */
  importEntryNumber?: InputMaybe<Scalars['String']>;
};

export type BulkComplianceUploaderResult = {
  __typename?: 'BulkComplianceUploaderResult';
  /** The reason for failure */
  failureReason?: Maybe<Scalars['String']>;
  /** The fields in this request */
  fields?: Maybe<BulkComplianceUploaderFields>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

export type BulkComplianceUploaderResultInput = {
  /** The reason for failure */
  failureReason?: InputMaybe<Scalars['String']>;
  /** The fields in this request */
  fields?: InputMaybe<BulkComplianceUploaderFieldsInput>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

export type BulkMilestoneUploadRequest = Record & {
  __typename?: 'BulkMilestoneUploadRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The document associated with the request  */
  document: Document;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** All the records and their failure reasons in the request */
  results?: Maybe<Array<BulkMilestoneUploaderResult>>;
  /**  The status of BulkUpload Request */
  status?: Maybe<BulkUploadStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Total number of failed rows */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Total number of creation requests in the document */
  totalRows?: Maybe<Scalars['Int']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type BulkMilestoneUploadRequestEdge = ConnectionEdge & {
  __typename?: 'BulkMilestoneUploadRequestEdge';
  cursor: Scalars['ID'];
  node: BulkMilestoneUploadRequest;
};

export type BulkMilestoneUploadRequestSearchCriteriaInput = {
  /** The id of the customs broker linked to the request */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The document associated with the request  */
  documentId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /**  The status of BulkUpload Request */
  status?: InputMaybe<BulkUploadStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Bulk Milestone Upload search table row */
export type BulkMilestoneUploadRequestSearchTableRow = RecordSearchTableRow & {
  __typename?: 'BulkMilestoneUploadRequestSearchTableRow';
  /** The customs broker id of the user who created the request. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The document associated with the request  */
  documentId?: Maybe<Scalars['ID']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The operator who owns this request  */
  operatorId?: Maybe<Scalars['ID']>;
  /** The current status of the request */
  status?: Maybe<Scalars['String']>;
  /** The number of failures in request */
  totalFailures?: Maybe<Scalars['Int']>;
  /** The number of rows in request */
  totalRows?: Maybe<Scalars['Int']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type BulkMilestoneUploadRequestsConnection = Connection & {
  __typename?: 'BulkMilestoneUploadRequestsConnection';
  edges: Array<BulkMilestoneUploadRequestEdge>;
  nodes: Array<BulkMilestoneUploadRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type BulkMilestoneUploaderFields = {
  __typename?: 'BulkMilestoneUploaderFields';
  /** The identifier in the request */
  identifier?: Maybe<Scalars['String']>;
  /** The type of identifier in the request */
  identifierType?: Maybe<Scalars['String']>;
  /** The name of the milestone in the request */
  milestoneName?: Maybe<WorkOrderMilestoneName>;
  /** The occurence time of milestone in the request */
  occurenceTime?: Maybe<Scalars['String']>;
};

export type BulkMilestoneUploaderFieldsInput = {
  /** The identifier in the request */
  identifier?: InputMaybe<Scalars['String']>;
  /** The type of identifier in the request */
  identifierType?: InputMaybe<Scalars['String']>;
  /** The name of the milestone in the request */
  milestoneName?: InputMaybe<WorkOrderMilestoneName>;
  /** The occurence time of milestone in the request */
  occurenceTime?: InputMaybe<Scalars['String']>;
};

export type BulkMilestoneUploaderResult = {
  __typename?: 'BulkMilestoneUploaderResult';
  /** The reason for failure */
  failureReason?: Maybe<Scalars['String']>;
  /** The fields in this request */
  fields?: Maybe<BulkMilestoneUploaderFields>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

export type BulkMilestoneUploaderResultInput = {
  /** The reason for failure */
  failureReason?: InputMaybe<Scalars['String']>;
  /** The fields in this request */
  fields?: InputMaybe<BulkMilestoneUploaderFieldsInput>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

export type BulkMilestonesPayload = {
  __typename?: 'BulkMilestonesPayload';
  /** The Response payload of the mutation */
  results: Array<BulkMilestonesResponsePayload>;
};

export type BulkMilestonesResponsePayload = {
  __typename?: 'BulkMilestonesResponsePayload';
  /** The Milestone in the request */
  milestone?: Maybe<WorkOrderMilestone>;
  /** The status of an Upload Request */
  status: BulkUploadResponseStatus;
};

/** When this request is created, CBMS will generate a Excel template document to be filled and later re-uploaded in the bulk product upload workflow. */
export type BulkProductUploadTemplateDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'BulkProductUploadTemplateDocumentGenerationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The options present in the bulk product upload template. */
  options?: Maybe<BulkProductUploadTemplateDocumentGenerationRequestOptions>;
  /** The owner of the bulk product upload template. This will also be the same owner of the products which get create/update as a result of the bulk upload handling. */
  productOwner: ProductOwner;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type BulkProductUploadTemplateDocumentGenerationRequestOptions = {
  __typename?: 'BulkProductUploadTemplateDocumentGenerationRequestOptions';
  /** The IOR options present in the IOR Name drop down select. If not provided, this will be all IORs associated with the Product Owner. */
  iors?: Maybe<Array<Ior>>;
  /** The Supplier options present in the Supplier Name drop down select. If not provided, this will be all Suppliers associated with the Product Owner. */
  suppliers?: Maybe<Array<Supplier>>;
};

export type BulkProductUploadTemplateDocumentGenerationRequestOptionsInput = {
  /** The IOR options present in the IOR Name drop down select. If not provided, this will be all IORs associated with the Product Owner. */
  iors?: InputMaybe<Array<IdInput>>;
  /** The Supplier options present in the Supplier Name drop down select. If not provided, this will be all Suppliers associated with the Product Owner. */
  suppliers?: InputMaybe<Array<IdInput>>;
};

/** The status of an Upload Request */
export enum BulkUploadResponseStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED'
}

/**  The status of BulkUpload Request */
export enum BulkUploadStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED'
}

export type BulkUploadStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<BulkUploadStatus>>;
};

/** The business area that the entity focuses on */
export enum BusinessArea {
  DESTINATION = 'DESTINATION',
  ORIGIN = 'ORIGIN'
}

export type BusinessAreaSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<BusinessArea>>;
};

export type BusinessRule = {
  __typename?: 'BusinessRule';
  /** Criteria of the business rule. */
  criteria: BusinessRuleCriteria;
  /** The currency code for the value based rule. */
  currency?: Maybe<Scalars['CurrencyCode']>;
  /** The logical operator of the rule. */
  logicalOperator: LogicalOperator;
  /** Value for the rule. */
  values: Array<Scalars['BusinessRuleValue']>;
};

/** Criteria of the business rule. */
export enum BusinessRuleCriteria {
  DUTY_AMOUNT = 'DUTY_AMOUNT',
  DUTY_RATE = 'DUTY_RATE'
}

/** Group of BusinessRuleSet */
export type BusinessRuleGroup = {
  __typename?: 'BusinessRuleGroup';
  /** Boolean operator between the BusinessRuleSet. */
  booleanOperator: BooleanOperator;
  /** Group of BusinessRuleSet */
  ruleSets: Array<BusinessRuleSet>;
};

export type BusinessRuleGroupInput = {
  /** Boolean operator between the BusinessRuleSet. */
  booleanOperator: BooleanOperator;
  /** Group of BusinessRuleSet */
  ruleSets: Array<BusinessRuleSetInput>;
};

export type BusinessRuleInput = {
  /** Criteria of the business rule. */
  criteria: BusinessRuleCriteria;
  /** The currency code for the value based rule. */
  currency?: InputMaybe<Scalars['CurrencyCode']>;
  /** The logical operator of the rule. */
  logicalOperator: LogicalOperator;
  /** Value for the rule. */
  values: Array<Scalars['BusinessRuleValue']>;
};

/** Set of BusinessRule */
export type BusinessRuleSet = {
  __typename?: 'BusinessRuleSet';
  /** Boolean operator between the BusinessRule. */
  booleanOperator: BooleanOperator;
  /** Set of BusinessRule. */
  rules: Array<BusinessRule>;
};

export type BusinessRuleSetInput = {
  /** Boolean operator between the BusinessRule. */
  booleanOperator: BooleanOperator;
  /** Set of BusinessRule. */
  rules: Array<BusinessRuleInput>;
};

/** The structure of the business. */
export enum BusinessStructure {
  CORPORATION = 'CORPORATION',
  INDIVIDUAL = 'INDIVIDUAL',
  LLC = 'LLC',
  LLP = 'LLP',
  LP = 'LP',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR'
}

export type BusinessSupportTeam = Record & UserTeam & {
  __typename?: 'BusinessSupportTeam';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The User Team's name */
  name: Scalars['String'];
  operator: Operator;
  /** A Operator User linked to this BusinessSupportTeam */
  operatorUser: BusinessSupportTeamOperatorUserRelationship;
  /** Operator Users linked to this Business Support Team. */
  operatorUsers: BusinessSupportTeamOperatorUsersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type BusinessSupportTeamoperatorUserArgs = {
  operatorUserId: Scalars['ID'];
};


export type BusinessSupportTeamoperatorUsersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type BusinessSupportTeamEdge = ConnectionEdge & {
  __typename?: 'BusinessSupportTeamEdge';
  cursor: Scalars['ID'];
  node: BusinessSupportTeam;
};

export type BusinessSupportTeamMemberInput = {
  /** The User's unique ID */
  userId: Scalars['ID'];
};

export type BusinessSupportTeamOperatorUserEdge = ConnectionEdge & {
  __typename?: 'BusinessSupportTeamOperatorUserEdge';
  cursor: Scalars['ID'];
  /** The linked Operator User. */
  node?: Maybe<OperatorUser>;
  /** The data on the link between the Business Support Team and Operator User. */
  relationship?: Maybe<BusinessSupportTeamOperatorUserRelationship>;
};

export type BusinessSupportTeamOperatorUserRelationship = Record & {
  __typename?: 'BusinessSupportTeamOperatorUserRelationship';
  /** The linked Business Support Team. */
  businessSupportTeam: BusinessSupportTeam;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Operator User. */
  operatorUser: OperatorUser;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type BusinessSupportTeamOperatorUserRelationshipBase = Record & {
  __typename?: 'BusinessSupportTeamOperatorUserRelationshipBase';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type BusinessSupportTeamOperatorUserRelationshipInput = {
  tags?: InputMaybe<Array<TagInput>>;
};

export type BusinessSupportTeamOperatorUsersConnection = Connection & {
  __typename?: 'BusinessSupportTeamOperatorUsersConnection';
  edges: Array<BusinessSupportTeamOperatorUserEdge>;
  nodes: Array<OperatorUser>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type BusinessSupportTeamSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The User Team's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Operator's name */
  operatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type BusinessSupportTeamSearchTableRow = RecordSearchTableRow & UserTeamSearchTableRow & {
  __typename?: 'BusinessSupportTeamSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The number of members on this team */
  memberCount: Scalars['Int'];
  /** The User Team's name */
  name?: Maybe<Scalars['String']>;
  /** The Operator that owns this Record */
  operatorId: Scalars['String'];
  /** The Operator's name */
  operatorName: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type BusinessSupportTeamsConnection = Connection & {
  __typename?: 'BusinessSupportTeamsConnection';
  edges: Array<BusinessSupportTeamEdge>;
  nodes: Array<BusinessSupportTeam>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The business type for connectPro case */
export enum BusinessType {
  FBA = 'FBA',
  RETAIL = 'RETAIL'
}

/** CalculateUsConsumptionEntryAmendment status */
export enum CalculateAmendmentResultStatus {
  BROKER_DOES_NOT_PAY_DUTY = 'BROKER_DOES_NOT_PAY_DUTY',
  LINE_NOT_CREATED = 'LINE_NOT_CREATED',
  NOT_NECESSARY = 'NOT_NECESSARY',
  NO_DUTY_CHANGE = 'NO_DUTY_CHANGE',
  UNKNOWN_INVOICE_STATUS = 'UNKNOWN_INVOICE_STATUS',
  WILL_ISSUE_CREDIT_FOR_DIFF = 'WILL_ISSUE_CREDIT_FOR_DIFF',
  WILL_ISSUE_INVOICE_FOR_DIFF = 'WILL_ISSUE_INVOICE_FOR_DIFF',
  WILL_UPDATE_UPCOMING = 'WILL_UPDATE_UPCOMING',
  WILL_VOID_AND_REPLACE = 'WILL_VOID_AND_REPLACE'
}

/** Payload returned from the cancelShipment mutation. */
export type CancelShipmentPayload = {
  __typename?: 'CancelShipmentPayload';
  record: Shipment;
};

/** Payload returned from the cancelShipper mutation. */
export type CancelShipperPayload = {
  __typename?: 'CancelShipperPayload';
  record: Shipper;
};

export type CancelUsIorContinuousBondRequestRenewalPayload = {
  __typename?: 'CancelUsIorContinuousBondRequestRenewalPayload';
  /** The updated UsIorContinuousBondRequest */
  usIorContinuousBondRequest: UsIorContinuousBondRequest;
};

/** Payload returned from the cancelUsIor mutation. */
export type CancelUsIorPayload = {
  __typename?: 'CancelUsIorPayload';
  record: UsIor;
};

/** Payload returned from the cancelWorkOrderGroup mutation. */
export type CancelWorkOrderGroupPayload = {
  __typename?: 'CancelWorkOrderGroupPayload';
  record: WorkOrderGroup;
};

/** Payload returned from the cancelWorkOrder mutation. */
export type CancelWorkOrderPayload = {
  __typename?: 'CancelWorkOrderPayload';
  record: WorkOrder;
};

/** Payload returned from the cancelWorkOrderTask mutation. */
export type CancelWorkOrderTaskPayload = {
  __typename?: 'CancelWorkOrderTaskPayload';
  record: WorkOrderTask;
};

/** Cancelation reason for cancellation request */
export type CancellationReason = {
  /** Replacement number associated with the cancellation reason, could be in-bond number, entry number etc used by deleteUsConsumptionEntryReleaseCbp */
  replacementReferenceNumber?: InputMaybe<Scalars['String']>;
  /** Text associated with the cancellation reason */
  text?: InputMaybe<Scalars['String']>;
};

export type CaseAssignmentResult = {
  __typename?: 'CaseAssignmentResult';
  /** The operatorUser ID */
  operatorUserId: Scalars['ID'];
  /** Operator user login extracted from email prefix */
  operatorUserLogin: Scalars['String'];
  /** Operator user name */
  operatorUserName: Scalars['String'];
  /** Case Assignment team business area */
  teamBusinessArea: Scalars['String'];
  /** Case Assignment team country code abbreviation */
  teamCountryCode: Scalars['String'];
  /** Case Assignment team ID */
  teamId: Scalars['ID'];
  /** Case Assignment team name */
  teamName: Scalars['String'];
  /** Case Assignment team time zone */
  teamTimeZone: Scalars['String'];
};

export type CaseAssignmentTeam = {
  __typename?: 'CaseAssignmentTeam';
  /** The case assignment team business area */
  businessArea: Scalars['String'];
  /** The case assignment team country code */
  countryCode: Scalars['String'];
  /** The case assignment team ID */
  id: Scalars['ID'];
  /** The case assignment team name */
  name: Scalars['String'];
  /** The case assignment team time zone */
  timeZone: Scalars['String'];
};

/** AD/CVD Case payment options: Bond or Cash */
export type CaseBondOrCash = {
  __typename?: 'CaseBondOrCash';
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
  /** Bond/Cash Indicator */
  indicator: AdCvdCasePaymentOption;
};

export type CaseBondOrCashInput = {
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
  /** Bond/Cash Indicator */
  indicator: AdCvdCasePaymentOption;
};

export type CaseCategoryConfig = Record & {
  __typename?: 'CaseCategoryConfig';
  /** Assignment team access configuration */
  assignmentTeamAccess: Array<AssignmentTeamAccess>;
  /** Auto assignment configuration */
  autoAssignmentConfig?: Maybe<Array<AutoAssignmentConfig>>;
  /** The unique case category id */
  caseCategoryId: Scalars['ID'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Manual assignment teams */
  manualAssignmentTeams?: Maybe<Array<AssignmentTeam>>;
  operator: Operator;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** Work order types associated with the case category */
  workOrderTypes?: Maybe<Array<WorkOrderType>>;
};

export type CaseCategoryConfigEdge = ConnectionEdge & {
  __typename?: 'CaseCategoryConfigEdge';
  cursor: Scalars['ID'];
  node: CaseCategoryConfig;
};

export type CaseCategoryConfigSearchCriteriaInput = {
  /** The unique Case Category ID provided by CP. */
  caseCategoryId: IdIndexSearchCriteriaInput;
};

export type CaseCategoryConfigsConnection = Connection & {
  __typename?: 'CaseCategoryConfigsConnection';
  edges: Array<CaseCategoryConfigEdge>;
  nodes: Array<CaseCategoryConfig>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** AD/CVD Case event history */
export type CaseEvent = {
  __typename?: 'CaseEvent';
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** Determination */
  determination?: Maybe<Scalars['String']>;
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
  /** Name of the event */
  event: Scalars['String'];
  /** Citation in the Federal Register */
  federalRegisterCitation?: Maybe<Scalars['String']>;
  /** Inactivated date */
  inactivatedDate?: Maybe<Scalars['DateTime']>;
};

export type CaseEventInput = {
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** Determination */
  determination?: InputMaybe<Scalars['String']>;
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
  /** Name of the event */
  event: Scalars['String'];
  /** Citation in the Federal Register */
  federalRegisterCitation?: InputMaybe<Scalars['String']>;
  /** Inactivated date */
  inactivatedDate?: InputMaybe<Scalars['DateTime']>;
};

/** AD/CVD Case liquidation history */
export type CaseLiquidationSuspension = {
  __typename?: 'CaseLiquidationSuspension';
  /** The entry summary suspension action */
  action: AdCvdCaseLiquidationSuspensionAction;
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
};

export type CaseLiquidationSuspensionInput = {
  /** The entry summary suspension action */
  action: AdCvdCaseLiquidationSuspensionAction;
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
};

/** AD/CVD Case duty rate */
export type CaseRate = {
  __typename?: 'CaseRate';
  /** The ad valorem (percent) duty rate */
  adValorem?: Maybe<Scalars['Float']>;
  /** Added date */
  addedDate: Scalars['Date'];
  /** Effective date */
  effectiveDate: Scalars['Date'];
  /** Inactivated date */
  inactivatedDate?: Maybe<Scalars['Date']>;
  /** The specific duty rate, per unit of measure */
  specific?: Maybe<Scalars['Float']>;
  /** Unit of measure that the specific duty rate is multiplied by */
  uom?: Maybe<Scalars['String']>;
  /** Unit of measure description, used if uom is Other */
  uomDescription?: Maybe<Scalars['String']>;
};

export type CaseRateInput = {
  /** The ad valorem (percent) duty rate */
  adValorem?: InputMaybe<Scalars['Float']>;
  /** Added date */
  addedDate: Scalars['Date'];
  /** Effective date */
  effectiveDate: Scalars['Date'];
  /** Inactivated date */
  inactivatedDate?: InputMaybe<Scalars['Date']>;
  /** The specific duty rate, per unit of measure */
  specific?: InputMaybe<Scalars['Float']>;
  /** Unit of measure that the specific duty rate is multiplied by */
  uom?: InputMaybe<Scalars['String']>;
  /** Unit of measure description, used if uom is Other */
  uomDescription?: InputMaybe<Scalars['String']>;
};

/** 10-digit level AD/CVD Case reference */
export type CaseReference = {
  __typename?: 'CaseReference';
  /** Complete 10-digit case number */
  caseNumber: Scalars['CaseNumber'];
  /** Record Id for the full case */
  id: Scalars['ID'];
  /** Status of the full case */
  status: AdCvdCaseStatus;
};

export type CaseReferenceInput = {
  /** Complete 10-digit case number */
  caseNumber: Scalars['CaseNumber'];
  /** Record Id for the full case */
  id: Scalars['ID'];
  /** Status of the full case */
  status: AdCvdCaseStatus;
};

/** AD/CVD Case Tariff */
export type CaseTariff = {
  __typename?: 'CaseTariff';
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** HTS Number that the Case applies to */
  htsNumber: Scalars['HtsNumber'];
};

export type CaseTariffInput = {
  /** Added date */
  addedDate: Scalars['DateTime'];
  /** HTS Number that the Case applies to */
  htsNumber: Scalars['HtsNumber'];
};

export type CbpInBond = {
  __typename?: 'CbpInBond';
  /** The actions taken for this CbpInBond */
  actions: Array<CbpInBondAction>;
  /** Reference identifications as defined for particular qualifiers. */
  additionalReferenceIdentifiers: Array<CbpInBondAdditionalReferenceIdentifier>;
  /** The associated bills of lading for this CbpInBond */
  bills: Array<CbpInBondBill>;
  /** The carrier information for the CbpInBond */
  carrier?: Maybe<CbpInBondCarrier>;
  /** The UsConsignee associated with the CbpInBond. Returns the latest version and the information we need for the UsInBond. */
  consignee?: Maybe<CbpInBondConsignee>;
  /** The type of in-bond movement */
  entryType?: Maybe<CbpInBondEntryType>;
  /** The port of destination for a T&E ‘62’ or IE ‘63’ entries. */
  foreignPortOfDestination?: Maybe<Scalars['UsCbpForeignPortCode']>;
  /** The FIRMS code representing where the goods are at right now */
  goodsNowAt?: Maybe<Scalars['FirmsCode']>;
  /** The importing conveyance arrival port for the CbpInBond */
  importingConveyanceArrivalPort?: Maybe<Scalars['UsCbpPortCode']>;
  /** The mode of transport for the CbpInBond */
  modeOfTransport?: Maybe<ModeOfTransport>;
  /** The INLT CBP in-bond Number identifying the in-bond movement, a 9 digit number made up of an 8 digit "base" number followed by a "check" digit */
  number?: Maybe<Scalars['InltUsInBondNumber']>;
  /** The previous CbpInBond information */
  previousCbpInBond?: Maybe<PreviousCbpInBond>;
  /** The status of the CbpInBond */
  status?: Maybe<CbpInBondStatus>;
  /** Whether the cargo is subject to U.S. Food and Drug Administration Bioterrorism Act of 2002 reporting requirements. */
  subjectToFdaBioterrorismAct?: Maybe<Scalars['Boolean']>;
  /** The port of termination for an IT ‘61’ entry, or the port of exportation for a T&E ‘62’ entry, or the port of arrival for an IT ‘63’entry. */
  usPortOfDestination?: Maybe<Scalars['UsCbpPortCode']>;
  /** The value of the goods in whole dollars of the in-bond movement. Twenty dollars per kilo may be used if the value is unknown. */
  valueOfGoods?: Maybe<Scalars['UsDollars']>;
};

export type CbpInBondAction = {
  __typename?: 'CbpInBondAction';
  /** A date representing the date of actual arrival or export at the destination port or the date of transfer of in-bond liability. */
  actualDate?: Maybe<Scalars['Date']>;
  /** The port of destination for the in-bond movement */
  arrivalPort?: Maybe<Scalars['UsCbpPortCode']>;
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  billNumber?: Maybe<Scalars['String']>;
  /** The carrier information for the CbpInBondAction */
  carrier?: Maybe<CbpInBondCarrier>;
  /** The name of the city where the transfer of liability occurs. */
  city?: Maybe<Scalars['String']>;
  /** The FIRMS location must be on file and match the Port of In-bond Arrival given in the CBP Port field. Not required for an Air in-bond arrival. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** If a city name is supplied, the corresponding state code must also be provided. */
  stateCode?: Maybe<Scalars['UsStateCode']>;
  /** The status of the CbpInBondAction */
  status?: Maybe<CbpInBondActionStatus>;
  /** The type of action being taken for the CbpInBond */
  type?: Maybe<CbpInBondActionType>;
};

export type CbpInBondActionInput = {
  /** A date representing the date of actual arrival or export at the destination port or the date of transfer of in-bond liability. */
  actualDate?: InputMaybe<Scalars['Date']>;
  /** The port of destination for the in-bond movement */
  arrivalPort?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  billNumber?: InputMaybe<Scalars['String']>;
  /** The carrier information for the CbpInBondAction */
  carrier?: InputMaybe<CbpInBondCarrierInput>;
  /** The name of the city where the transfer of liability occurs. */
  city?: InputMaybe<Scalars['String']>;
  /** The FIRMS location must be on file and match the Port of In-bond Arrival given in the CBP Port field. Not required for an Air in-bond arrival. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** If a city name is supplied, the corresponding state code must also be provided. */
  stateCode?: InputMaybe<Scalars['UsStateCode']>;
  /** The type of action being taken for the CbpInBond */
  type?: InputMaybe<CbpInBondActionType>;
};

/** The CBP In-Bond action status. */
export enum CbpInBondActionStatus {
  AUTHORIZED = 'AUTHORIZED',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

/** The CBP In-Bond type of action. */
export enum CbpInBondActionType {
  ARRIVE_BILL_OF_LADING = 'ARRIVE_BILL_OF_LADING',
  ARRIVE_CONTAINER = 'ARRIVE_CONTAINER',
  ARRIVE_ENTIRE_IN_BOND = 'ARRIVE_ENTIRE_IN_BOND',
  EXPORT_BILL_OF_LADING = 'EXPORT_BILL_OF_LADING',
  EXPORT_CONTAINER = 'EXPORT_CONTAINER',
  EXPORT_ENTIRE_IN_BOND = 'EXPORT_ENTIRE_IN_BOND',
  REQUEST_DIVERSION = 'REQUEST_DIVERSION',
  TRANSFER_ENTIRE_IN_BOND_LIABILITY = 'TRANSFER_ENTIRE_IN_BOND_LIABILITY'
}

export type CbpInBondAdditionalReferenceIdentifier = {
  __typename?: 'CbpInBondAdditionalReferenceIdentifier';
  /** A code of up to three alpha/numeric characters indicating the type of Reference Identifier. */
  qualifier?: Maybe<CbpInBondAdditionalReferenceIdentifierQualifier>;
  /** Reference identification as defined for a particular qualifier. */
  referenceIdentifier?: Maybe<Scalars['String']>;
};

export type CbpInBondAdditionalReferenceIdentifierInput = {
  /** A code of up to three alpha/numeric characters indicating the type of Reference Identifier. */
  qualifier?: InputMaybe<CbpInBondAdditionalReferenceIdentifierQualifier>;
  /** Reference identification as defined for a particular qualifier. */
  referenceIdentifier?: InputMaybe<Scalars['String']>;
};

/** The CBP In-Bond additional identifier qualifier. */
export enum CbpInBondAdditionalReferenceIdentifierQualifier {
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  CG = 'CG',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CSK = 'CSK',
  CUB = 'CUB',
  CX = 'CX',
  ED = 'ED',
  FEN = 'FEN',
  FN = 'FN',
  FP = 'FP',
  GB = 'GB',
  GR = 'GR',
  HS = 'HS',
  IN = 'IN',
  LT = 'LT',
  MA = 'MA',
  MB = 'MB',
  OM = 'OM',
  OW = 'OW',
  PK = 'PK',
  PN = 'PN',
  PO = 'PO',
  RC = 'RC',
  S7 = 'S7',
  SI = 'SI',
  SO = 'SO',
  ST = 'ST',
  SW = 'SW',
  UT = 'UT',
  VA = 'VA',
  WU = 'WU',
  WY = 'WY',
  XC = 'XC',
  XP = 'XP',
  ZE = 'ZE',
  ZZ = 'ZZ',
  _2K = '_2K'
}

export type CbpInBondBill = {
  __typename?: 'CbpInBondBill';
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  number?: Maybe<Scalars['String']>;
  /** When adding an in-bond to an existing Bill of Lading, this field is used when the in-bond quantity is less than the full Bill quantity of the previously transmitted Bill of Lading. If not provided, the in-bond quantity will automatically be assumed to be full Bill quantity. */
  quantity?: Maybe<Scalars['Float']>;
  /** The status of the CbpInBondBill */
  status?: Maybe<CbpInBondBillStatus>;
};

export type CbpInBondBillInput = {
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  number?: InputMaybe<Scalars['String']>;
  /** When adding an in-bond to an existing Bill of Lading, this field is used when the in-bond quantity is less than the full Bill quantity of the previously transmitted Bill of Lading. If not provided, the in-bond quantity will automatically be assumed to be full Bill quantity. */
  quantity?: InputMaybe<Scalars['Float']>;
};

/** The CBP In-Bond bill status. */
export enum CbpInBondBillStatus {
  AUTHORIZED = 'AUTHORIZED',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type CbpInBondCarrier = {
  __typename?: 'CbpInBondCarrier';
  /** The CBP Assigned number of the bonded carrier of the CbpInBond */
  cain?: Maybe<Scalars['CbpAssignedNumber']>;
  /** The SCAC code for the carrier of the CbpInBond */
  code?: Maybe<Scalars['SCACCode']>;
  /** The EIN number of the bonded carrier of the CbpInBond */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** The Trucker carrying the goods for the CbpInBond. Returns the latest version. */
  trucker?: Maybe<CbpInBondCarrierTrucker>;
};

export type CbpInBondCarrierInput = {
  /** The CBP Assigned number of the bonded carrier of the CbpInBond */
  cain?: InputMaybe<Scalars['CbpAssignedNumber']>;
  /** The SCAC code for the carrier of the CbpInBond */
  code?: InputMaybe<Scalars['SCACCode']>;
  /** The EIN number of the bonded carrier of the CbpInBond */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** The Trucker carrying the goods for the CbpInBond. Returns the latest version. */
  trucker?: InputMaybe<CbpInBondCarrierTruckerInput>;
};

export type CbpInBondCarrierTrucker = {
  __typename?: 'CbpInBondCarrierTrucker';
  /** The name of the trucker. */
  name?: Maybe<Scalars['String']>;
  /** Trucker details */
  trucker: Trucker;
};

export type CbpInBondCarrierTruckerInput = {
  /** The name of the trucker. */
  name?: InputMaybe<Scalars['String']>;
  /** Id version of the Trucker */
  trucker: IdVersionInput;
};

export type CbpInBondConsignee = {
  __typename?: 'CbpInBondConsignee';
  /** Party addresses */
  addresses?: Maybe<Addresses>;
  /** The name of the UsConsignee. */
  name?: Maybe<Scalars['String']>;
  /** UsConsignee details */
  usConsignee: CbpInBondUsConsignee;
};

export type CbpInBondConsigneeInput = {
  /** Party addresses */
  addresses?: InputMaybe<AddressesInput>;
  /** The name of the UsConsignee. */
  name?: InputMaybe<Scalars['String']>;
  /** Id version of the UsConsignee */
  usConsignee: IdVersionInput;
};

/** The type of CBP In-Bond movement. */
export enum CbpInBondEntryType {
  IMMEDIATE_EXPORTATION = 'IMMEDIATE_EXPORTATION',
  IMMEDIATE_TRANSPORTATION = 'IMMEDIATE_TRANSPORTATION',
  TRANSPORTATION_AND_EXPORTATION = 'TRANSPORTATION_AND_EXPORTATION'
}

/** The type of in-bond movement */
export type CbpInBondEntryTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<CbpInBondEntryType>>;
};

export type CbpInBondInput = {
  /** The actions taken for this CbpInBond */
  actions?: InputMaybe<Array<CbpInBondActionInput>>;
  /** Reference identifications as defined for particular qualifiers. */
  additionalReferenceIdentifiers?: InputMaybe<Array<CbpInBondAdditionalReferenceIdentifierInput>>;
  /** The associated bills of lading for this CbpInBond */
  bills?: InputMaybe<Array<CbpInBondBillInput>>;
  /** The carrier information for the CbpInBond */
  carrier?: InputMaybe<CbpInBondCarrierInput>;
  /** The UsConsignee associated with the CbpInBond. Returns the latest version and the information we need for the UsInBond. */
  consignee?: InputMaybe<CbpInBondConsigneeInput>;
  /** The type of in-bond movement */
  entryType?: InputMaybe<CbpInBondEntryType>;
  /** The port of destination for a T&E ‘62’ or IE ‘63’ entries. */
  foreignPortOfDestination?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
  /** The FIRMS code representing where the goods are at right now */
  goodsNowAt?: InputMaybe<Scalars['FirmsCode']>;
  /** The importing conveyance arrival port for the CbpInBond */
  importingConveyanceArrivalPort?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The mode of transport for the CbpInBond */
  modeOfTransport?: InputMaybe<ModeOfTransport>;
  /** The previous CbpInBond information */
  previousCbpInBond?: InputMaybe<PreviousCbpInBondInput>;
  /** Whether the cargo is subject to U.S. Food and Drug Administration Bioterrorism Act of 2002 reporting requirements. */
  subjectToFdaBioterrorismAct?: InputMaybe<Scalars['Boolean']>;
  /** The port of termination for an IT ‘61’ entry, or the port of exportation for a T&E ‘62’ entry, or the port of arrival for an IT ‘63’entry. */
  usPortOfDestination?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The value of the goods in whole dollars of the in-bond movement. Twenty dollars per kilo may be used if the value is unknown. */
  valueOfGoods?: InputMaybe<Scalars['UsDollars']>;
};

export type CbpInBondResponseData = {
  __typename?: 'CbpInBondResponseData';
  /** The actionCode in the response data */
  actionCode?: Maybe<Scalars['String']>;
  /** The appCode in the response data */
  appCode?: Maybe<Scalars['String']>;
  /** The disposition messages (found inside each billOfLading via `disposition.message`) in the response data */
  billsOfLadingDispositionMessages?: Maybe<Array<Scalars['String']>>;
  /** The detail info in the response data */
  detail?: Maybe<CbpInBondResponseDataDetail>;
  /** The header info in the response data */
  header?: Maybe<CbpInBondResponseDataHeader>;
  /** The number inside the inBond field in the response data */
  inBondNumber?: Maybe<Scalars['String']>;
  /** The number in the response data */
  number?: Maybe<Scalars['String']>;
  /** The remarks (found via as the remarks key in each remark) in the response data */
  remarks?: Maybe<Array<Scalars['String']>>;
  /** The time that the In-Bond response EDI message was received from CBP's ABI */
  time: Scalars['DateTime'];
};

export type CbpInBondResponseDataDetail = {
  __typename?: 'CbpInBondResponseDataDetail';
  /** The value of the actual dispositionCode (found via `dispositionCode.code` in the `detail` JSON) */
  dispositionCode?: Maybe<Scalars['String']>;
  /** The masterBillIssuerCode in the detail */
  masterBillIssuerCode?: Maybe<Scalars['String']>;
  /** The masterBillIssuerSequence in the detail */
  masterBillIssuerSequence?: Maybe<Scalars['String']>;
  /** The quantity in the detail */
  quantity?: Maybe<Scalars['Float']>;
};

export type CbpInBondResponseDataDetailInput = {
  /** The value of the actual dispositionCode (found via `dispositionCode.code` in the `detail` JSON) */
  dispositionCode?: InputMaybe<Scalars['String']>;
  /** The masterBillIssuerCode in the detail */
  masterBillIssuerCode?: InputMaybe<Scalars['String']>;
  /** The masterBillIssuerSequence in the detail */
  masterBillIssuerSequence?: InputMaybe<Scalars['String']>;
  /** The quantity in the detail */
  quantity?: InputMaybe<Scalars['Float']>;
};

export type CbpInBondResponseDataHeader = {
  __typename?: 'CbpInBondResponseDataHeader';
  /** The actionCode in the header */
  actionCode?: Maybe<Scalars['String']>;
  /** The inBondNumber in the header */
  number?: Maybe<Scalars['String']>;
};

export type CbpInBondResponseDataHeaderInput = {
  /** The actionCode in the header */
  actionCode?: InputMaybe<Scalars['String']>;
  /** The inBondNumber in the header */
  number?: InputMaybe<Scalars['String']>;
};

export type CbpInBondResponseDataInput = {
  /** The actionCode in the response data */
  actionCode?: InputMaybe<Scalars['String']>;
  /** The appCode in the response data */
  appCode?: InputMaybe<Scalars['String']>;
  /** The disposition messages (found inside each billOfLading via `disposition.message`) in the response data */
  billsOfLadingDispositionMessages?: InputMaybe<Array<Scalars['String']>>;
  /** The detail info in the response data */
  detail?: InputMaybe<CbpInBondResponseDataDetailInput>;
  /** The header info in the response data */
  header?: InputMaybe<CbpInBondResponseDataHeaderInput>;
  /** The number inside the inBond field in the response data */
  inBondNumber?: InputMaybe<Scalars['String']>;
  /** The number in the response data */
  number?: InputMaybe<Scalars['String']>;
  /** The remarks (found via as the remarks key in each remark) in the response data */
  remarks?: InputMaybe<Array<Scalars['String']>>;
  /** The time that the In-Bond response EDI message was received from CBP's ABI */
  time: Scalars['DateTime'];
};

/** The CBP In-Bond status. */
export enum CbpInBondStatus {
  AUTHORIZED = 'AUTHORIZED',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

/** The status of the CbpInBond */
export type CbpInBondStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<CbpInBondStatus>>;
};

export type CbpInBondUsConsignee = UsConsignee | UsIor;

/** The override codes apply to the census warning condition */
export enum CensusOverrideCode {
  ASSIST = 'ASSIST',
  BEGINNING_TO_IMPORT_NEW_PRODUCT_LINE = 'BEGINNING_TO_IMPORT_NEW_PRODUCT_LINE',
  CHARTERED_TRANSPORTATION = 'CHARTERED_TRANSPORTATION',
  CORRECT_AS_ENTERED = 'CORRECT_AS_ENTERED',
  COUNTRY_OF_EXPORT_VERIFIED_AS_CORRECT = 'COUNTRY_OF_EXPORT_VERIFIED_AS_CORRECT',
  COUNTRY_VERIFIED_AS_CORRECT = 'COUNTRY_VERIFIED_AS_CORRECT',
  ENTERED_UNDER_SPECIAL_CONDITIONS = 'ENTERED_UNDER_SPECIAL_CONDITIONS',
  EXCEPTION_TO_EMBARGO = 'EXCEPTION_TO_EMBARGO',
  EXPERIMENTAL_DRUG = 'EXPERIMENTAL_DRUG',
  FTZ_WITHDRAWAL_LOW_FOREIGN_VALUE = 'FTZ_WITHDRAWAL_LOW_FOREIGN_VALUE',
  INSURANCE_COSTS_VERY_HIGH = 'INSURANCE_COSTS_VERY_HIGH',
  LESS_THAN_PERFECT = 'LESS_THAN_PERFECT',
  LOWER_QUALITY_MATERIAL = 'LOWER_QUALITY_MATERIAL',
  MARKET_CONDITIONS = 'MARKET_CONDITIONS',
  MASS_PRODUCED = 'MASS_PRODUCED',
  MILITARY_APPLICATION = 'MILITARY_APPLICATION',
  NON_PRODUCT_LINE_ITEM_NEEDED_TO_CONDUCT_BUSINESS = 'NON_PRODUCT_LINE_ITEM_NEEDED_TO_CONDUCT_BUSINESS',
  ONE_OF_A_KIND = 'ONE_OF_A_KIND',
  PACKAGING_HEAVIER_THAN_NORMAL = 'PACKAGING_HEAVIER_THAN_NORMAL',
  PACKAGING_LIGHTER_THAN_NORMAL = 'PACKAGING_LIGHTER_THAN_NORMAL',
  PARAMETER_CHANGE_REQUEST_PENDING = 'PARAMETER_CHANGE_REQUEST_PENDING',
  PRECISION_MADE = 'PRECISION_MADE',
  PROTOTYPE = 'PROTOTYPE',
  RUSH_DELIVERY = 'RUSH_DELIVERY',
  SAMPLE = 'SAMPLE',
  SPECIAL_HANDLING_REQUIRED = 'SPECIAL_HANDLING_REQUIRED',
  TIMING_OF_EMBARGO = 'TIMING_OF_EMBARGO',
  UNIQUE_MATERIAL = 'UNIQUE_MATERIAL',
  WEIGHT_OF_ARTICLE_HEAVIER_THAN_NORMAL = 'WEIGHT_OF_ARTICLE_HEAVIER_THAN_NORMAL',
  WEIGHT_OF_ARTICLE_LIGHTER_THAN_NORMAL = 'WEIGHT_OF_ARTICLE_LIGHTER_THAN_NORMAL'
}

/** Certificate declaration indicating certification status (PG22) */
export type CertificateDeclaration = {
  __typename?: 'CertificateDeclaration';
  /** Indicates certification of finished product(s) - CPY (Yes) or CPN (No) */
  certified: Scalars['Boolean'];
};

/** Certificate declaration indicating certification status (PG22) */
export type CertificateDeclarationInput = {
  /** Indicates certification of finished product(s) - CPY (Yes) or CPN (No) */
  certified: Scalars['Boolean'];
};

/** Changelog about a record. */
export type Changelog = Record & {
  __typename?: 'Changelog';
  /** The action performed by the user */
  action: Scalars['String'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator?: Maybe<Operator>;
  /** The previous version of the record related to the ChangeLog */
  previousRecordVersion?: Maybe<Scalars['Int']>;
  /** The record that the changelog is related to */
  record: Record;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ChangelogEdge = ConnectionEdge & {
  __typename?: 'ChangelogEdge';
  cursor: Scalars['ID'];
  node: Changelog;
};

/** Primary class used to represent a Changelog search input */
export type ChangelogSearchCriteriaInput = {
  /** The Record ID. If set, no other criteria can be set. */
  recordId: IdIndexSearchCriteriaInput;
};

export type ChangelogsConnection = Connection & {
  __typename?: 'ChangelogsConnection';
  edges: Array<ChangelogEdge>;
  nodes: Array<Changelog>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Product characteristic type */
export enum CharacteristicType {
  /** Model Color */
  COLOR = 'COLOR',
  /** Model Description */
  DESCRIPTION = 'DESCRIPTION',
  /** Model Style */
  STYLE = 'STYLE'
}

/** Invoice Charge code */
export enum ChargeCode {
  ACP_FEE_PER_CLEARANCE = 'ACP_FEE_PER_CLEARANCE',
  ADDITIONAL_CUSTOMS_HANDLING_FEE = 'ADDITIONAL_CUSTOMS_HANDLING_FEE',
  ADDITIONAL_CUSTOMS_INVOICE = 'ADDITIONAL_CUSTOMS_INVOICE',
  ADDITIONAL_CUSTOMS_LINE = 'ADDITIONAL_CUSTOMS_LINE',
  ADDITIONAL_DESTINATION_PORT_INFRASTRUCTURE_FEE = 'ADDITIONAL_DESTINATION_PORT_INFRASTRUCTURE_FEE',
  AD_DUTY = 'AD_DUTY',
  AGENCY_FEE = 'AGENCY_FEE',
  AGRICULTURE_EXAM_FEE = 'AGRICULTURE_EXAM_FEE',
  AIR_BASE_RATE = 'AIR_BASE_RATE',
  AMENDMENT_FEE = 'AMENDMENT_FEE',
  AMS_QUERY = 'AMS_QUERY',
  AT_CET_EXAM_FEE = 'AT_CET_EXAM_FEE',
  BOND_SETUP_FEE = 'BOND_SETUP_FEE',
  CANADIAN_ENTRY_FEE = 'CANADIAN_ENTRY_FEE',
  CANCELATION_FEE = 'CANCELATION_FEE',
  CARBON_BORDER_ADJUSTMENT_MECHANISM = 'CARBON_BORDER_ADJUSTMENT_MECHANISM',
  CLASSIFICATION = 'CLASSIFICATION',
  COMPLIANCE_CONSULTING = 'COMPLIANCE_CONSULTING',
  CONSOLIDATED_ENTRY_FEE = 'CONSOLIDATED_ENTRY_FEE',
  CONTINUOUS_BOND = 'CONTINUOUS_BOND',
  COURIER_FEE = 'COURIER_FEE',
  CPSC_EXAM_FEE = 'CPSC_EXAM_FEE',
  CROSS_BORDER_CLEARANCE = 'CROSS_BORDER_CLEARANCE',
  CUSTOMS_FINES_PASSTHROUGH = 'CUSTOMS_FINES_PASSTHROUGH',
  CV_DUTY = 'CV_DUTY',
  DANGEROUS_GOODS = 'DANGEROUS_GOODS',
  DEMURRAGE = 'DEMURRAGE',
  DESTINATION_CFS_ADDITIONAL_CHARGE = 'DESTINATION_CFS_ADDITIONAL_CHARGE',
  DESTINATION_DELIVERY = 'DESTINATION_DELIVERY',
  DESTINATION_PORT_INFRASTRUCTURE_FEE = 'DESTINATION_PORT_INFRASTRUCTURE_FEE',
  DESTINATION_PORT_SECURITY_FEE = 'DESTINATION_PORT_SECURITY_FEE',
  DESTRUCTION_FEE = 'DESTRUCTION_FEE',
  DIRECT_TRADER_INPUT_FEE = 'DIRECT_TRADER_INPUT_FEE',
  DISBURSEMENT_FEE = 'DISBURSEMENT_FEE',
  DUTY = 'DUTY',
  DUTY_DAILY = 'DUTY_DAILY',
  DUTY_PMS = 'DUTY_PMS',
  ENTRY_FEE = 'ENTRY_FEE',
  EXAM_FEE = 'EXAM_FEE',
  EXAM_HANDLING = 'EXAM_HANDLING',
  EXAM_SITE_STORAGE = 'EXAM_SITE_STORAGE',
  EXPORT_CLEARANCE_FEE = 'EXPORT_CLEARANCE_FEE',
  FDA_EXAMS = 'FDA_EXAMS',
  FUEL_CHARGE = 'FUEL_CHARGE',
  HAZMAT = 'HAZMAT',
  HOT_ENTRY_FEE = 'HOT_ENTRY_FEE',
  HOT_IN_BOND_FEE = 'HOT_IN_BOND_FEE',
  HOT_ISF_FEE = 'HOT_ISF_FEE',
  HTS_CLASSIFICATION_ADDITIONAL_TARRIF_HEADINGS = 'HTS_CLASSIFICATION_ADDITIONAL_TARRIF_HEADINGS',
  IBET_EXAM_FEE = 'IBET_EXAM_FEE',
  IMPORTER_SURCHARGE = 'IMPORTER_SURCHARGE',
  IMPORT_CUSTOMS_CLEARANCE = 'IMPORT_CUSTOMS_CLEARANCE',
  IMPORT_DUTY_TAX = 'IMPORT_DUTY_TAX',
  IMPORT_VALUE_ADDED_TAX = 'IMPORT_VALUE_ADDED_TAX',
  IN_BOND_FEE = 'IN_BOND_FEE',
  ISF_BOND = 'ISF_BOND',
  ISF_FEE = 'ISF_FEE',
  MANAGEMENT_FEE = 'MANAGEMENT_FEE',
  MANUAL_CREATION_FEE = 'MANUAL_CREATION_FEE',
  MERCHANDISE_PROCESSING_FEE = 'MERCHANDISE_PROCESSING_FEE',
  MERCHANT_FEE = 'MERCHANT_FEE',
  MET_EXAM_FEE = 'MET_EXAM_FEE',
  MISCELLANEOUS = 'MISCELLANEOUS',
  ONSITE_FEE = 'ONSITE_FEE',
  ORIGIN_PICKUP = 'ORIGIN_PICKUP',
  PALLETIZATION_DESTINATION_FEE = 'PALLETIZATION_DESTINATION_FEE',
  PALLET_EXCHANGE_CHARGE = 'PALLET_EXCHANGE_CHARGE',
  PARTNER_GOVERNMENT_AGENCY_FEE = 'PARTNER_GOVERNMENT_AGENCY_FEE',
  PARTNER_GOVERNMENT_AGENCY_HANDLING_FEE = 'PARTNER_GOVERNMENT_AGENCY_HANDLING_FEE',
  PIERPASS_ADMIN = 'PIERPASS_ADMIN',
  PIERPASS_TMF = 'PIERPASS_TMF',
  POA_SETUP_FEE = 'POA_SETUP_FEE',
  POST_SUMMARY_CORRECTION_FEE = 'POST_SUMMARY_CORRECTION_FEE',
  PROTEST_FEE = 'PROTEST_FEE',
  RECONDITIONING_FEES = 'RECONDITIONING_FEES',
  SECURITY_CHARGE = 'SECURITY_CHARGE',
  SELF_FILED_ENTRY_FEE = 'SELF_FILED_ENTRY_FEE',
  SELF_FILED_IN_BOND_FEE = 'SELF_FILED_IN_BOND_FEE',
  SELF_FILED_ISF_FEE = 'SELF_FILED_ISF_FEE',
  SELLER_SUPPORT_FEE = 'SELLER_SUPPORT_FEE',
  SINGLE_ENTRY_BOND = 'SINGLE_ENTRY_BOND',
  SUBSCRIPTION_FEE = 'SUBSCRIPTION_FEE',
  TAX = 'TAX',
  TERMINAL_FEES = 'TERMINAL_FEES',
  TRUCKING = 'TRUCKING',
  UNCATEGORIZED_CHARGE = 'UNCATEGORIZED_CHARGE',
  VACIS_EXAM_FEE = 'VACIS_EXAM_FEE',
  VALUE_ADDED_TAX = 'VALUE_ADDED_TAX',
  WEEKEND_FEE = 'WEEKEND_FEE'
}

export type ChargeCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ChargeCode>>;
};

export type ChargeDeduction = {
  __typename?: 'ChargeDeduction';
  /** Code specifying the type of charge or deduction. */
  chargesType?: Maybe<Scalars['String']>;
  /** Amount added or subtracted from the total invoice price (depending on the trade terms) not previously taken into account when determining the customs value. */
  otherChargeDeduction?: Maybe<Cost>;
  /** Sequence number for ChargeDeduction. */
  sequence?: Maybe<Scalars['Int']>;
};

export type ChargeDeductionInput = {
  /** Code specifying the type of charge or deduction. */
  chargesType?: InputMaybe<Scalars['String']>;
  /** Amount added or subtracted from the total invoice price (depending on the trade terms) not previously taken into account when determining the customs value. */
  otherChargeDeduction?: InputMaybe<CostInput>;
  /** Sequence number for ChargeDeduction. */
  sequence?: InputMaybe<Scalars['Int']>;
};

export type ChargeInput = {
  /** Charge amount */
  amount: CostInput;
  /** Charge type */
  type: ChargeCode;
};

/** Citation to consumer product safety rule */
export type Citation = {
  __typename?: 'Citation';
  /** Citation code for the consumer product safety rule */
  code: Scalars['String'];
  /** Human-readable description of the citation */
  description: Scalars['String'];
};

/** Citation to consumer product safety rule */
export type CitationInput = {
  /** Citation code for the consumer product safety rule */
  code: Scalars['String'];
  /** Human-readable description of the citation */
  description: Scalars['String'];
};

export type Classification = {
  __typename?: 'Classification';
  /** The non-commercial categorization of a commodity by a standard-setting organization */
  identification?: Maybe<Scalars['String']>;
  /** A qualifier to describe the commodity classification, e.g. Harmonized Tariff Schedule (HTS) */
  identificationType?: Maybe<Scalars['ClassificationIdentificationTypeCode']>;
  /** Sequence number for classifications */
  sequence?: Maybe<Scalars['Int']>;
};

export type ClassificationInput = {
  /** The non-commercial categorization of a commodity by a standard-setting organization */
  identification?: InputMaybe<Scalars['String']>;
  /** A qualifier to describe the commodity classification, e.g. Harmonized Tariff Schedule (HTS) */
  identificationType?: InputMaybe<Scalars['ClassificationIdentificationTypeCode']>;
  /** Sequence number for classifications */
  sequence?: InputMaybe<Scalars['Int']>;
};

export type ClassifyUsCustomsFilingArrivalInput = {
  /** Arrival country code */
  country: Scalars['CountryCode'];
  /** Arrival date */
  date: Scalars['DateTime__patched_over_by_INLT'];
};

export type ClassifyUsCustomsFilingCommercialInvoiceInput = {
  /** The product in this invoice */
  products: Array<ClassifyUsProductInput>;
};

export type ClassifyUsCustomsFilingInput = {
  /** The arrival information */
  arrival: ClassifyUsCustomsFilingArrivalInput;
  /** The commercial invoices */
  commercialInvoices: Array<ClassifyUsCustomsFilingCommercialInvoiceInput>;
  /** CBMS Work Order IDs to exclude from calculations */
  excludedCbmsWorkOrderIds?: InputMaybe<Array<Scalars['String']>>;
  /** Determines if AD/CVD and PGA fee disclaims should be considered */
  ignoreAdCvdAndFees?: InputMaybe<Scalars['Boolean']>;
  /** The importer of record */
  iorNumber: UsIorNumberInput;
  /** The master bills */
  masterBills?: InputMaybe<Array<ClassifyUsCustomsFilingMasterBillInput>>;
};

export type ClassifyUsCustomsFilingMasterBillInput = {
  /** The master bill number */
  number: Scalars['String'];
};

export type ClassifyUsCustomsFilingPayload = {
  __typename?: 'ClassifyUsCustomsFilingPayload';
  /** Recommended filing classifications given the input */
  classifications: Array<UsCustomsFilingClassification>;
  /** Ineligible filing types if any, and reasons, given the input */
  ineligibilities: Array<UsCustomsFililingIneligibility>;
};

export type ClassifyUsProductInput = {
  /** The compliance details for this product */
  complianceDetails: Array<UsComplianceDetailsInput>;
  /** Quantity of the product */
  quantity: Scalars['Int'];
};

export type ClientApiKey = {
  /** API Key used to authenticate with CBMS. */
  apiKey: Scalars['ID'];
};

/** References provided by client */
export type ClientReferences = {
  __typename?: 'ClientReferences';
  /** client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** FBA shipment id */
  fbaShipmentId?: Maybe<Scalars['String']>;
  /** Booking ID of the original booking corresponding to split booking in AMP2.0 project */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Shipment arn */
  shipmentArn?: Maybe<Scalars['String']>;
};

export type ClientReferencesInput = {
  /** client booking id */
  bookingId?: InputMaybe<Scalars['String']>;
  /** FBA shipment id */
  fbaShipmentId?: InputMaybe<Scalars['String']>;
  /** Booking ID of the original booking corresponding to split booking in AMP2.0 project */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Shipment arn */
  shipmentArn?: InputMaybe<Scalars['String']>;
};

export type ClientSystem = RecordActionSource & {
  __typename?: 'ClientSystem';
  /** The name of a Client system. */
  name: ClientSystemName;
  /** A string representing the version of the Client's source system. */
  version?: Maybe<Scalars['String']>;
};

/** The name of a Client system. */
export enum ClientSystemName {
  FORWARDER_SYSTEM = 'FORWARDER_SYSTEM',
  LEGACY_DATA_MIGRATION = 'LEGACY_DATA_MIGRATION'
}

/** Input for the CloneWorkOrder API, defining any additions to the newly created duplicate Work Order. */
export type CloneWorkOrderInput = {
  /** The Work Order Badge to add to the duplicate Work Order. */
  badge?: InputMaybe<WorkOrderBadge>;
};

/** Payload for the CloneWorkOrder API. */
export type CloneWorkOrderPayload = {
  __typename?: 'CloneWorkOrderPayload';
  /** The newly cloned Work Order. */
  clonedWorkOrder: WorkOrder;
};

/** User details from the Cognito User Pool. */
export type CognitoUserDetails = {
  __typename?: 'CognitoUserDetails';
  /** The Cognito Federated Identity Pool ID. */
  id?: Maybe<Scalars['ID']>;
  /** The Cognito User Pool sub field. */
  sub: Scalars['ID'];
};

export type Commodity = {
  __typename?: 'Commodity';
  /** Information about commodity classification for tax/duty purposes. */
  classification?: Maybe<Array<Classification>>;
  /**
   * Plain language description of the nature of a goods item sufficient to identify it for cross-border regulatory purposes such as customs,
   * phytosanitary, statistical or transport.
   */
  description?: Maybe<Scalars['String']>;
  /** Details related to calculation of one instance of one duty, one tax, and/or one fee. */
  dutyTaxFees?: Maybe<Array<DutyTaxFee>>;
  /** Details related to the invoice line for the commodity. */
  goodsItemInvoiceLine?: Maybe<GoodsItemInvoiceLine>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
};

/** Commodity characteristic. Used by APHIS, FWS. */
export type CommodityCharacteristic = {
  __typename?: 'CommodityCharacteristic';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  qualifier?: Maybe<Scalars['String']>;
};

/** Commodity characteristic. Used by APHIS, FWS. */
export type CommodityCharacteristicInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
};

export type CommodityGroup = Record & {
  __typename?: 'CommodityGroup';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The description of the commodities part of this group */
  description: Scalars['String'];
  /** Hts chapters associated with this commodity group */
  htsChapters?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the commodity group */
  name: Scalars['String'];
  /** PGAs associated with this commodity group */
  pgas?: Maybe<Array<Scalars['String']>>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type CommodityGroupEdge = ConnectionEdge & {
  __typename?: 'CommodityGroupEdge';
  cursor: Scalars['ID'];
  node: CommodityGroup;
};

/** Primary class used to represent a commodity group search input */
export type CommodityGroupSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Hts chapters associated with this commodity group */
  htsChapters?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the commodity group */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** PGAs associated with this commodity group */
  pgas?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Primary class used to represent a commodity group */
export type CommodityGroupSearchTableRow = RecordSearchTableRow & {
  __typename?: 'CommodityGroupSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The description of the commodities part of this group */
  description?: Maybe<Scalars['String']>;
  /** Hts chapters associated with this commodity group */
  htsChapters?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the commodity group */
  name?: Maybe<Scalars['String']>;
  /** PGAs associated with this commodity group */
  pgas?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type CommodityGroupsConnection = Connection & {
  __typename?: 'CommodityGroupsConnection';
  edges: Array<CommodityGroupEdge>;
  nodes: Array<CommodityGroup>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type CommodityInput = {
  /** Information about commodity classification for tax/duty purposes. */
  classification?: InputMaybe<Array<ClassificationInput>>;
  /**
   * Plain language description of the nature of a goods item sufficient to identify it for cross-border regulatory purposes such as customs,
   * phytosanitary, statistical or transport.
   */
  description?: InputMaybe<Scalars['String']>;
  /** Details related to calculation of one instance of one duty, one tax, and/or one fee. */
  dutyTaxFees?: InputMaybe<Array<DutyTaxFeeInput>>;
  /** Details related to the invoice line for the commodity. */
  goodsItemInvoiceLine?: InputMaybe<GoodsItemInvoiceLineInput>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
};

/** Onboarding request company details */
export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  /** Accounting email */
  accountingEmail?: Maybe<Scalars['Email']>;
  /** Company addresses. */
  addresses?: Maybe<Addresses>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name for onboarding request */
  name?: Maybe<Scalars['String']>;
  /** Company phone number */
  phone?: Maybe<Phone>;
};

/** Onboarding request company details */
export type CompanyDetailsInput = {
  /** Accounting email */
  accountingEmail?: InputMaybe<Scalars['Email']>;
  /** Company addresses. */
  addresses?: InputMaybe<AddressesInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name for onboarding request */
  name?: InputMaybe<Scalars['String']>;
  /** Company phone number */
  phone?: InputMaybe<PhoneInput>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  address?: Maybe<AddressV2>;
  name?: Maybe<Scalars['String']>;
};

export type CompanyInfoInput = {
  address?: InputMaybe<AddressV2Input>;
  name?: InputMaybe<Scalars['String']>;
};

export type ComplianceRecommendation = {
  availability: Scalars['String'];
  result?: Maybe<RecommendationResult>;
};

export type ComplianceRecommendationRequest = {
  byAsin: AsinInput;
  destinationCountryCode?: InputMaybe<Scalars['CountryCode']>;
  tariffFlagCodes: Array<Scalars['String']>;
};

export type ComplianceRecommendationSubmissionResult = {
  destinationCountryCode: Scalars['String'];
  recommendations: Array<ComplianceRecommendation>;
};

export type ConfirmBulkUploadPayload = {
  __typename?: 'ConfirmBulkUploadPayload';
  record: ImportProductsFromBulkUploadRequest;
};

/** The current status for the processing of this confirmable upload request */
export enum ConfirmableBulkUploadStatus {
  AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING_CONFIRMATION_DETAILS = 'PENDING_CONFIRMATION_DETAILS',
  READY = 'READY',
  REJECTED = 'REJECTED'
}

export type Connection = {
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ConnectionEdge = {
  cursor: Scalars['ID'];
};

/** Channel Connection Status */
export enum ConnectionStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  UNKNOWN = 'UNKNOWN'
}

/** Information related to a connection status update. */
export type ConnectionStatusUpdate = {
  __typename?: 'ConnectionStatusUpdate';
  /** The connection status. */
  status: Scalars['String'];
  /** The time of connection status change. */
  time: Scalars['DateTime__patched_over_by_INLT'];
};

export type Consignee = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Party name */
  name: Scalars['String'];
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type Consignment = {
  __typename?: 'Consignment';
  /** Details related to the means of transport crossing the border of the Customs territory. */
  borderTransportationMean?: Maybe<Array<BorderTransportMeans>>;
  /** Code specifying whether or not goods are transported in a container. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** Details related to the consignment which corresponds to one transport contract. (Known as consignment by the Transport group). */
  transportContractDocument?: Maybe<Array<TransportContractDocument>>;
  /** Details related to transport equipment used for the consignment. */
  transportEquipment?: Maybe<Array<TransportEquipment>>;
  /** Amount declared for customs purposes of those goods in a consignment whether or not they are subject to the same customs procedure, tariff/statistical heading, country information and duty regime. */
  value?: Maybe<Scalars['Float']>;
};

export type ConsignmentInput = {
  /** Details related to the means of transport crossing the border of the Customs territory. */
  borderTransportationMean?: InputMaybe<Array<BorderTransportMeansInput>>;
  /** Code specifying whether or not goods are transported in a container. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** Details related to the consignment which corresponds to one transport contract. (Known as consignment by the Transport group). */
  transportContractDocument?: InputMaybe<Array<TransportContractDocumentInput>>;
  /** Details related to transport equipment used for the consignment. */
  transportEquipment?: InputMaybe<Array<TransportEquipmentInput>>;
  /** Amount declared for customs purposes of those goods in a consignment whether or not they are subject to the same customs procedure, tariff/statistical heading, country information and duty regime. */
  value?: InputMaybe<Scalars['Float']>;
};

export type Consolidator = Facility | Supplier;

export type ConstituentElement = {
  __typename?: 'ConstituentElement';
  /** Description code as defined by FWS. */
  fwsDescriptionCode?: Maybe<Scalars['String']>;
  /** Identifies each country in which a plant was harvested. */
  harvestCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Whether the constituent element is an active ingredient */
  isActiveIngredient?: Maybe<Scalars['Boolean']>;
  /** Name of the constituent element. */
  name?: Maybe<Scalars['String']>;
  /** The percentage (1-100) of the recycled material in the product/component. If the percent varies please indicate the average amount of recycled material. Only used for Paper, pulp, and paperboard. */
  percentageRecycled?: Maybe<Scalars['Float']>;
  /** Quantity of the constituent element. */
  quantity?: Maybe<Quantity>;
  /** Scientific name of the constituent element. */
  scientificName?: Maybe<Scalars['String']>;
};

export type ConstituentElementInput = {
  /** Description code as defined by FWS. */
  fwsDescriptionCode?: InputMaybe<Scalars['String']>;
  /** Identifies each country in which a plant was harvested. */
  harvestCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Whether the constituent element is an active ingredient */
  isActiveIngredient?: InputMaybe<Scalars['Boolean']>;
  /** Name of the constituent element. */
  name?: InputMaybe<Scalars['String']>;
  /** The percentage (1-100) of the recycled material in the product/component. If the percent varies please indicate the average amount of recycled material. Only used for Paper, pulp, and paperboard. */
  percentageRecycled?: InputMaybe<Scalars['Float']>;
  /** Quantity of the constituent element. */
  quantity?: InputMaybe<QuantityInput>;
  /** Scientific name of the constituent element. */
  scientificName?: InputMaybe<Scalars['String']>;
};

export type Cost = {
  __typename?: 'Cost';
  /** The currency code for the amount/cost. */
  currency: Scalars['CurrencyCode'];
  /** The value of the amount/cost. */
  value: Scalars['Float'];
};

export type CostInput = {
  /** The currency code for the amount/cost. */
  currency: Scalars['CurrencyCode'];
  /** The value of the amount/cost. */
  value: Scalars['Float'];
};

export type CountryAbbreviationSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ExtendedCountryAbbreviation>>;
};

export type CountryCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['CountryCode']>>;
};

export type CountrySpecificData = {
  __typename?: 'CountrySpecificData';
  /** Country specific data. */
  us?: Maybe<UsSpecificData>;
};

export type CountrySpecificDataInput = {
  /** Country specific data. */
  us?: InputMaybe<UsSpecificDataInput>;
};

/** CPSC Certificate types for regulated products */
export enum CpscCertificateType {
  /** Children's Product Certificate - For products age 12 and under */
  CPC = 'CPC',
  /** General Certificate of Conformity - For general consumer products */
  GCC = 'GCC'
}

/** Type of CPSC citation code */
export enum CpscCitationCodeType {
  EXCLUSION = 'EXCLUSION',
  INCLUSION = 'INCLUSION'
}

/** Response containing a presigned URL for CPSC citation codes operations */
export type CpscCitationCodeUrlResponse = {
  __typename?: 'CpscCitationCodeUrlResponse';
  /** The type of citation code */
  codeType: CpscCitationCodeType;
  /** Time in seconds until the presigned URL expires */
  expiresIn: Scalars['Int'];
  /** Presigned URL for the citation codes JSON file (GET for download, PUT for upload) */
  url: Scalars['String'];
};

/** CPSC Entity representing a party role in the certificate */
export type CpscEntity = {
  __typename?: 'CpscEntity';
  /** Entity identification code (e.g., SBM for Small Batch Manufacturer) */
  entityIdentificationCode?: Maybe<EntityIdentificationCode>;
  /** CPSC Lab ID or Small Batch Manufacturer Registry ID */
  entityNumber?: Maybe<Scalars['String']>;
  /** Entity role code (MF, CE, ITL, LAB, NOL, PK) */
  entityRoleCode: EntityRoleCode;
  /** Facility reference for the entity. Required for CE, LAB, MF, PK. Not required for ITL and NOL. */
  facility?: Maybe<Facility>;
  /** Lab test report information (for ITL/LAB) */
  testReports?: Maybe<Array<TestReport>>;
  /** Citations for testing exclusions - rules exempt from testing (for NOL) */
  testingExclusions?: Maybe<Array<Citation>>;
  /** Citations for rules the product was tested against (for ITL/LAB) */
  testingInclusions?: Maybe<Array<Citation>>;
};

/** CPSC Entity representing a party role in the certificate */
export type CpscEntityInput = {
  /** Entity identification code (e.g., SBM for Small Batch Manufacturer) */
  entityIdentificationCode?: InputMaybe<EntityIdentificationCode>;
  /** CPSC Lab ID or Small Batch Manufacturer Registry ID */
  entityNumber?: InputMaybe<Scalars['String']>;
  /** Entity role code (MF, CE, ITL, LAB, NOL, PK) */
  entityRoleCode: EntityRoleCode;
  /** Facility reference for the entity. Required for CE, LAB, MF, PK. Not required for ITL and NOL. */
  facility?: InputMaybe<IdInput>;
  /** Lab test report information (for ITL/LAB) */
  testReports?: InputMaybe<Array<TestReportInput>>;
  /** Citations for testing exclusions - rules exempt from testing (for NOL) */
  testingExclusions?: InputMaybe<Array<CitationInput>>;
  /** Citations for rules the product was tested against (for ITL/LAB) */
  testingInclusions?: InputMaybe<Array<CitationInput>>;
};

/** CPSC global product identifier type */
export enum CpscGlobalIdentifierType {
  /** GS1 Global Trade Item Number (GTIN) - 14-digit number (EDI code: SRV) */
  GTIN = 'GTIN',
  /** Universal Product Code (UPC) - Point-of-sale barcode number (EDI code: AI) */
  UPC = 'UPC'
}

/** CPSC Item representing a product or component (PG02) */
export type CpscItem = {
  __typename?: 'CpscItem';
  /** Certifying entity if not IOR. */
  certifyingEntities?: Maybe<Array<CpscEntity>>;
  /** Product characteristics (color, description, style). Optional */
  characteristics?: Maybe<Array<ProductCharacteristic>>;
  /** Commercial description of the item (max 70 chars) */
  description?: Maybe<Scalars['String']>;
  /** Item identifiers (MN/SE/RN/ALT). Required if no globalIdentifier or SKU provided */
  itemIdentifiers?: Maybe<Array<ItemIdentifier>>;
  /** Item type - PRODUCT (Finished Product) or COMPONENT */
  itemType: CpscItemType;
  /** Lab testing date. If multiple labs, provide latest test date. Optional */
  labTestingInfo?: Maybe<LabTestingInfo>;
  /** Laboratory entities (ITL/LAB/NOL). At least one required for FULL type, optional for REF type */
  laboratories?: Maybe<Array<CpscEntity>>;
  /** Lot information (lot number, production dates). Optional */
  lotInformation?: Maybe<Array<LotInformation>>;
  /** Manufacture date in MM-YYYY format (e.g., 01-2024). Required for FULL type, optional for REF type */
  manufactureDate?: Maybe<Scalars['String']>;
  /** Manufacturer entity. Required for FULL type, optional for REF type */
  manufacturers?: Maybe<Array<CpscEntity>>;
  /** Point of contact for test records if not IOR. */
  pointOfContacts?: Maybe<Array<CpscEntity>>;
  /** Product codes (SKU). Required if no globalIdentifier or itemIdentifiers provided */
  productCodes?: Maybe<Array<ProductCode>>;
  /** Product name (max 15 chars). Required for FULL type, optional for REF type */
  productName?: Maybe<Scalars['String']>;
  /** Reference to Product Registry. Required for REF processing type, null for FULL type */
  productRegistryReference?: Maybe<ProductRegistryReference>;
  /** Trade name or brand name (max 35 chars) */
  tradeName?: Maybe<Scalars['String']>;
};

/** CPSC Item representing a product or component (PG02) */
export type CpscItemInput = {
  /** Certifying entity if not IOR. */
  certifyingEntities?: InputMaybe<Array<CpscEntityInput>>;
  /** Product characteristics (color, description, style). Optional */
  characteristics?: InputMaybe<Array<ProductCharacteristicInput>>;
  /** Commercial description of the item (max 70 chars) */
  description?: InputMaybe<Scalars['String']>;
  /** Item identifiers (MN/SE/RN/ALT). Required if no globalIdentifier or SKU provided */
  itemIdentifiers?: InputMaybe<Array<ItemIdentifierInput>>;
  /** Item type - PRODUCT (Finished Product) or COMPONENT */
  itemType: CpscItemType;
  /** Lab testing date. If multiple labs, provide latest test date. Optional */
  labTestingInfo?: InputMaybe<LabTestingInfoInput>;
  /** Laboratory entities (ITL/LAB/NOL). At least one required for FULL type, optional for REF type */
  laboratories?: InputMaybe<Array<CpscEntityInput>>;
  /** Lot information (lot number, production dates). Optional */
  lotInformation?: InputMaybe<Array<LotInformationInput>>;
  /** Manufacture date in MM-YYYY format (e.g., 01-2024). Required for FULL type, optional for REF type */
  manufactureDate?: InputMaybe<Scalars['String']>;
  /** Manufacturer entity. Required for FULL type, optional for REF type */
  manufacturers?: InputMaybe<Array<CpscEntityInput>>;
  /** Point of contact for test records if not IOR. */
  pointOfContacts?: InputMaybe<Array<CpscEntityInput>>;
  /** Product codes (SKU). Required if no globalIdentifier or itemIdentifiers provided */
  productCodes?: InputMaybe<Array<ProductCodeInput>>;
  /** Product name (max 15 chars). Required for FULL type, optional for REF type */
  productName?: InputMaybe<Scalars['String']>;
  /** Reference to Product Registry. Required for REF processing type, null for FULL type */
  productRegistryReference?: InputMaybe<ProductRegistryReferenceInput>;
  /** Trade name or brand name (max 35 chars) */
  tradeName?: InputMaybe<Scalars['String']>;
};

/** CPSC item type for products and components */
export enum CpscItemType {
  /** Component - Future support for component-level reporting (EDI code: C) */
  COMPONENT = 'COMPONENT',
  /** Finished Product - Currently the only type supported (EDI code: P) */
  PRODUCT = 'PRODUCT'
}

/** CPSC processing types for regulated products */
export enum CpscProcessingType {
  /** Disclaimer - CPSC Disclaimer Data Set */
  DISCLAIM = 'DISCLAIM',
  /** Full - CPSC Full Data Set for Regulated Products */
  FULL = 'FULL',
  /** Reference - CPSC Reference Data Set */
  REF = 'REF'
}

/** Represents a US CBP Anti-Dumping or Countervailing Duty Case. */
export type CreateAdCvdCaseInput = {
  /** Official Case name */
  bondOrCash?: InputMaybe<Array<CaseBondOrCashInput>>;
  /** AD/CVD Case number */
  caseNumber: Scalars['CaseNumber'];
  /** The country of origin where the Case applies */
  countryCode: Scalars['CountryCode'];
  /** Effective date */
  effectiveDate: Scalars['DateTime'];
  /** AD/CVD Case event history */
  events: Array<CaseEventInput>;
  /** AD/CVD Case liquidation suspension history */
  liquidationSuspensions?: InputMaybe<Array<CaseLiquidationSuspensionInput>>;
  /** The manufacturer the Case applies to */
  manufacturerName?: InputMaybe<Scalars['String']>;
  /** Official Case name */
  name: Scalars['String'];
  /** AD/CVD Case duty rates */
  rates?: InputMaybe<Array<CaseRateInput>>;
  /** Link to the scope decision of the case */
  scopeUrl?: InputMaybe<Scalars['Url']>;
  /** The seller (foreign exporter) the Case applies to */
  sellerName?: InputMaybe<Scalars['String']>;
  /** Status of Case */
  status: AdCvdCaseStatus;
  tags?: InputMaybe<Array<TagInput>>;
  /** AD/CVD Case Tariff */
  tariffs?: InputMaybe<Array<CaseTariffInput>>;
};

/** Payload returned from the createAdCvdCase mutation. */
export type CreateAdCvdCasePayload = {
  __typename?: 'CreateAdCvdCasePayload';
  record: AdCvdCase;
};

export type CreateAddressInput = {
  MarketplaceId: Scalars['String'];
  NewAddressRequest: CreateAddressRequestInput;
};

export type CreateAddressMailingAddressInput = {
  AddressLine1: Scalars['String'];
  AddressLine2?: InputMaybe<Scalars['String']>;
  City: Scalars['String'];
  CompanyName?: InputMaybe<Scalars['String']>;
  CountryCode: Scalars['String'];
  PostalCode: Scalars['String'];
  StateOrRegion: Scalars['String'];
};

export type CreateAddressNameInput = {
  FullName: Scalars['String'];
};

export type CreateAddressPayload = {
  __typename?: 'CreateAddressPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<CreateAddressResponse>;
};

export type CreateAddressRequestInput = {
  MailingAddress: CreateAddressMailingAddressInput;
  Name: CreateAddressNameInput;
  OwnerCustomerId: Scalars['String'];
};

export type CreateAddressResponse = {
  __typename?: 'CreateAddressResponse';
  addressId?: Maybe<Scalars['String']>;
};

export type CreateAssignmentTeamInput = {
  /** The type of this assignment team */
  assignmentTeamTypes?: InputMaybe<Array<AssignmentTeamType>>;
  /** The backup team for this assignment team */
  backupTeam?: InputMaybe<IdInput>;
  /** The case attributes for this assignment team */
  caseAttributes?: InputMaybe<Array<AssignmentTeamCaseAttributesInput>>;
  /** Team's customs broker */
  customsBroker?: InputMaybe<IdInput>;
  /** Additonal input for the assignment team and operator user relationship */
  members?: InputMaybe<Array<AssignmentTeamMemberInput>>;
  /** The User Team's name */
  name: Scalars['String'];
  operator: IdInput;
  /** The associated SME team for this assignment team */
  subjectMatterExpertTeam?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The verticals this assignment team is responsible for */
  verticals?: InputMaybe<Array<AssignmentTeamVerticalInput>>;
  /** The work order task types associated with this assignment team */
  workOrderTaskTypes: Array<WorkOrderTaskType>;
  /** The work order types associated with this assignment team */
  workOrderTypes: Array<WorkOrderType>;
};

/** The payload returned from the createAssignmentTeamOperatorUserRelationship mutation. */
export type CreateAssignmentTeamOperatorUserRelationshipPayload = {
  __typename?: 'CreateAssignmentTeamOperatorUserRelationshipPayload';
  /** The relationship created from linking the Assignment Team and Operator User Records. */
  relationship: AssignmentTeamOperatorUserRelationship;
};

/** Payload returned from the createAssignmentTeam mutation. */
export type CreateAssignmentTeamPayload = {
  __typename?: 'CreateAssignmentTeamPayload';
  record: AssignmentTeam;
};

/** Create Assignment Team Static Mapping Input */
export type CreateAssignmentTeamStaticMappingInput = {
  /** The assignment team for the mapping. */
  assignmentTeam: IdInput;
  /** The mapped operator in this assignment team. */
  member: IdInput;
  /** The entity reference to which the member is being mapped to. e.g., if the memberAssignedToType is XBT_SHIPPER_ID, then this field should be the xbtShipperId in format of string. */
  memberAssignedToReference: Scalars['String'];
  /** The type of member being assigned (e.g., "XBT_SHIPPER_ID"). */
  memberAssignedToType: MemberAssignedToType;
  operator: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createAssignmentTeamStaticMapping mutation. */
export type CreateAssignmentTeamStaticMappingPayload = {
  __typename?: 'CreateAssignmentTeamStaticMappingPayload';
  record: AssignmentTeamStaticMapping;
};

export type CreateAuditLogInput = {
  /** Details of changes between all versions of a record */
  diff: Array<DiffDetailInput>;
  /** The record that the AuditLog is related to */
  record?: InputMaybe<IdVersionInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type CreateAuditLogPayload = {
  __typename?: 'CreateAuditLogPayload';
  auditLog?: Maybe<AuditLog>;
  presignedUrl?: Maybe<Scalars['String']>;
};

/** Create authentication token input */
export type CreateAuthenticationTokenInput = {
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createAuthenticationToken mutation. */
export type CreateAuthenticationTokenPayload = {
  __typename?: 'CreateAuthenticationTokenPayload';
  record: AuthenticationToken;
};

export type CreateBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Code specifying the capacity in which the agent is acting. */
  function?: InputMaybe<Scalars['String']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Code specifying the issuing country of the party's identifiers.  Complies to ISO 3166-1 alpha 2. */
  identificationIssuingCountry?: InputMaybe<Scalars['CountryCode']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Code specifying where quality assurance level of the agent should be used. */
  qualityAssurance?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the createBroker mutation. */
export type CreateBrokerPayload = {
  __typename?: 'CreateBrokerPayload';
  record: Broker;
};

export type CreateBulkChargesUploadRequestInput = {
  /** The document associated with the request  */
  document: IdInput;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /**  The status of BulkUpload Request */
  status?: BulkUploadStatus;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createBulkChargesUploadRequest mutation. */
export type CreateBulkChargesUploadRequestPayload = {
  __typename?: 'CreateBulkChargesUploadRequestPayload';
  record: BulkChargesUploadRequest;
};

export type CreateBulkComplianceUploadRequestInput = {
  /** The document associated with the request  */
  document: IdInput;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /**  The status of BulkUpload Request */
  status?: BulkUploadStatus;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createBulkComplianceUploadRequest mutation. */
export type CreateBulkComplianceUploadRequestPayload = {
  __typename?: 'CreateBulkComplianceUploadRequestPayload';
  record: BulkComplianceUploadRequest;
};

export type CreateBulkMilestoneUploadRequestInput = {
  /** The document associated with the request  */
  document: IdInput;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /**  The status of BulkUpload Request */
  status?: BulkUploadStatus;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createBulkMilestoneUploadRequest mutation. */
export type CreateBulkMilestoneUploadRequestPayload = {
  __typename?: 'CreateBulkMilestoneUploadRequestPayload';
  record: BulkMilestoneUploadRequest;
};

export type CreateBulkProductUploadTemplateDocumentGenerationRequestInput = {
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The options present in the bulk product upload template. */
  options?: InputMaybe<BulkProductUploadTemplateDocumentGenerationRequestOptionsInput>;
  /** The owner of the bulk product upload template. This will also be the same owner of the products which get create/update as a result of the bulk upload handling. */
  productOwner: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createBulkProductUploadTemplateDocumentGenerationRequest mutation. */
export type CreateBulkProductUploadTemplateDocumentGenerationRequestPayload = {
  __typename?: 'CreateBulkProductUploadTemplateDocumentGenerationRequestPayload';
  record: BulkProductUploadTemplateDocumentGenerationRequest;
};

export type CreateBusinessSupportTeamInput = {
  /** The members belonging to this support team */
  members?: InputMaybe<Array<BusinessSupportTeamMemberInput>>;
  /** The User Team's name */
  name: Scalars['String'];
  operator: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** The payload returned from the createBusinessSupportTeamOperatorUserRelationship mutation. */
export type CreateBusinessSupportTeamOperatorUserRelationshipPayload = {
  __typename?: 'CreateBusinessSupportTeamOperatorUserRelationshipPayload';
  /** The relationship created from linking the Business Support Team and Operator User Records. */
  relationship: BusinessSupportTeamOperatorUserRelationship;
};

/** Payload returned from the createBusinessSupportTeam mutation. */
export type CreateBusinessSupportTeamPayload = {
  __typename?: 'CreateBusinessSupportTeamPayload';
  record: BusinessSupportTeam;
};

/** Create Case Category Config Input */
export type CreateCaseCategoryConfigInput = {
  /** Assignment team access configuration */
  assignmentTeamAccess: Array<AssignmentTeamAccessInput>;
  /** Auto assignment configuration */
  autoAssignmentConfig?: InputMaybe<Array<AutoAssignmentConfigInput>>;
  /** The unique case category id */
  caseCategoryId: Scalars['ID'];
  /** Manual assignment teams */
  manualAssignmentTeams?: InputMaybe<Array<IdInput>>;
  operator: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** Work order types associated with the case category */
  workOrderTypes?: InputMaybe<Array<WorkOrderType>>;
};

/** Payload returned from the createCaseCategoryConfig mutation. */
export type CreateCaseCategoryConfigPayload = {
  __typename?: 'CreateCaseCategoryConfigPayload';
  record: CaseCategoryConfig;
};

/** Create Changelog input */
export type CreateChangelogInput = {
  /** The action performed by the user */
  action: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The previous version of the record related to the ChangeLog */
  previousRecordVersion?: InputMaybe<Scalars['Int']>;
  /** The record that the changelog is related to */
  record: IdVersionInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createChangelog mutation. */
export type CreateChangelogPayload = {
  __typename?: 'CreateChangelogPayload';
  record: Changelog;
};

export type CreateChargesPayload = {
  __typename?: 'CreateChargesPayload';
  record: InvoiceLinesRequest;
};

export type CreateCommodityGroupInput = {
  /** The description of the commodities part of this group */
  description: Scalars['String'];
  /** Hts chapters associated with this commodity group */
  htsChapters?: InputMaybe<Array<Scalars['String']>>;
  /** The name of the commodity group */
  name: Scalars['String'];
  /** PGAs associated with this commodity group */
  pgas?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createCommodityGroup mutation. */
export type CreateCommodityGroupPayload = {
  __typename?: 'CreateCommodityGroupPayload';
  record: CommodityGroup;
};

/** The input payload used to create a Custom Domain. */
export type CreateCustomDomainInput = {
  account?: InputMaybe<IdInput>;
  /** The source of the assets to host. */
  assetSource: AssetSourceInput;
  /** The SSL certificate. */
  certificate?: InputMaybe<CustomDomainCertificateInput>;
  /** The custom domain url */
  domain: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The tab title */
  tabTitle: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createCustomDomain mutation. */
export type CreateCustomDomainPayload = {
  __typename?: 'CreateCustomDomainPayload';
  record: CustomDomain;
};

export type CreateCustomsAgentInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the createCustomsAgent mutation. */
export type CreateCustomsAgentPayload = {
  __typename?: 'CreateCustomsAgentPayload';
  record: CustomsAgent;
};

export type CreateCustomsDeclarationInput = {
  /** Details related to the party authorized to act on behalf of another party. */
  agent?: InputMaybe<Array<IdInput>>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** Reference for large goodsItem data stored in S3. */
  goodsItemReference?: InputMaybe<GoodsItemReferenceInput>;
  /** Details related to the movement and the handling of goods shipped together on one or more means of transport between original consignor and final consignee. */
  goodsShipment?: InputMaybe<Array<GoodsShipmentInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Identification of a specific document. */
  identification?: InputMaybe<Scalars['String']>;
  /** Amount indicating the total of all invoice amounts in a single declaration. */
  invoice?: InputMaybe<Scalars['Float']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createCustomsDeclaration mutation. */
export type CreateCustomsDeclarationPayload = {
  __typename?: 'CreateCustomsDeclarationPayload';
  record: CustomsDeclaration;
};

export type CreateCustomsNotificationMessageInput = {
  /** Message content. */
  content: Scalars['String'];
};

/** The output payload for createCustomsMessage operation. */
export type CreateCustomsNotificationPayload = {
  __typename?: 'CreateCustomsNotificationPayload';
  /** Message Identifier created in CBMS. */
  messageId?: Maybe<Scalars['String']>;
};

export type CreateDeConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createDeConsignee mutation. */
export type CreateDeConsigneePayload = {
  __typename?: 'CreateDeConsigneePayload';
  record: DeConsignee;
};

export type CreateDeCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['DeEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the createDeCustomsBroker mutation. */
export type CreateDeCustomsBrokerPayload = {
  __typename?: 'CreateDeCustomsBrokerPayload';
  record: DeCustomsBroker;
};

export type CreateDeCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: DeCustomsEntryCustomsBrokerInput;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<DeCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyanceInput;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<DeCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<DeCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the createDeCustomsEntry mutation. */
export type CreateDeCustomsEntryPayload = {
  __typename?: 'CreateDeCustomsEntryPayload';
  record: DeCustomsEntry;
};

export type CreateDeIorActivationInput = {
  /** DE Customs Broker associated with the activation. */
  broker: DeIorActivationBrokerInput;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** DE IOR to be activated. */
  ior?: InputMaybe<DeIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createDeIorActivation mutation. */
export type CreateDeIorActivationPayload = {
  __typename?: 'CreateDeIorActivationPayload';
  record: DeIorActivation;
};

export type CreateDeIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['DeEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['DeVatNumber']>;
};

/** Payload returned from the createDeIor mutation. */
export type CreateDeIorPayload = {
  __typename?: 'CreateDeIorPayload';
  record: DeIor;
};

/** Create Delivery Order document generation request input. */
export type CreateDeliveryOrderDocumentGenerationRequestInput = {
  /** Additional Fields */
  additionalFields?: InputMaybe<ExamDeliveryOrderAdditionalFieldsInput>;
  /** Agent (forwarder or broker) details responsible for delivery order */
  agent?: InputMaybe<DeliveryOrderAgentInput>;
  /** arrival Date */
  arrivalDate?: InputMaybe<Scalars['Date']>;
  /** The entity to whom the delivery order is supposed to be billed to */
  billTo?: InputMaybe<Scalars['String']>;
  /** carrier on which the goods are being transported */
  carrierCode?: InputMaybe<Scalars['String']>;
  /** Commodity of products in the delivery order */
  commodity?: InputMaybe<Scalars['String']>;
  /** Containers associated with the delivery order. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information */
  conveyance: DeliveryOrderConveyanceInput;
  /** The type of delivery order that should be generated. */
  deliveryOrderType?: InputMaybe<DeliveryOrderDocumentGenerationType>;
  /** Delivery order destination details */
  destination: DeliveryOrderDocumentDestinationInput;
  /** The entry number for the delivery order */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** House bill for the delivery order */
  houseBill?: InputMaybe<Scalars['String']>;
  /** Date of the import */
  importDate?: InputMaybe<Scalars['Date']>;
  /** Name of the importer */
  importerName?: InputMaybe<Scalars['String']>;
  /** In-bond number associated with the bill */
  inBondNumber?: InputMaybe<Scalars['String']>;
  /** Master bill for the delivery order */
  masterBill?: InputMaybe<Scalars['String']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Overflow Bills for the delivery order */
  overflowBills?: InputMaybe<Array<Scalars['String']>>;
  /** Delivery order pickup details */
  pickup: DeliveryOrderDocumentPickupInput;
  /** Date of the release */
  releaseDate?: InputMaybe<Scalars['Date']>;
  /** ID of the shipment for which the delivery order is generated */
  shipmentId?: InputMaybe<Scalars['String']>;
  /** Steam Ship Line SCAC Code */
  steamShipLineScac?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The name of the trucker to whom the delivery order is assigned */
  truckerName: Scalars['String'];
};

/** Payload returned from the createDeliveryOrderDocumentGenerationRequest mutation. */
export type CreateDeliveryOrderDocumentGenerationRequestPayload = {
  __typename?: 'CreateDeliveryOrderDocumentGenerationRequestPayload';
  record: DeliveryOrderDocumentGenerationRequest;
};

export type CreateDeliveryOrderInput = {
  /** bill to party info. */
  billTo?: InputMaybe<IdInput>;
  /** Containers associated with the delivery order. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Destination Location */
  destination?: InputMaybe<DeliveryOrderDestinationInput>;
  /** The details of the optional email notifications */
  email?: InputMaybe<DeliveryOrderEmailInfoInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Details about the pick up  */
  pickup?: InputMaybe<DeliveryOrderPickupInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The Trucker carrying the goods */
  trucker?: InputMaybe<DeliveryOrderTruckerInput>;
};

/** Payload returned from the createDeliveryOrder mutation. */
export type CreateDeliveryOrderPayload = {
  __typename?: 'CreateDeliveryOrderPayload';
  record: DeliveryOrder;
};

/** Create document input */
export type CreateDocumentInput = {
  /** Set on new documents once they have been through a ClamAV anti-virus scan. */
  antivirusScanStatus?: InputMaybe<DocumentAntivirusScanStatus>;
  /** Defines the type of content within the document, also known as the MIME type (e.g. text/html). Will be inferred from the file extension if not provided. */
  contentType?: InputMaybe<Scalars['DocumentContentType']>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags?: InputMaybe<Array<DocumentTag>>;
  /** The expiration date of the document. */
  expirationDate?: InputMaybe<Scalars['Date']>;
  /** The file extension of the document. Always uppercase. */
  extension: DocumentFileExtension;
  /** External document reference. */
  externalDocumentReference?: InputMaybe<ExternalDocumentReferenceInput>;
  /** Extracted document content. */
  extractedDocumentContent?: InputMaybe<ExtractedDocumentContentInput>;
  /** Name of the document. */
  fileName: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Indicates if a document is password protected. */
  passwordStatus?: InputMaybe<DocumentPasswordStatus>;
  /** A public document is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for document objects to prevent duplication. */
  sha1?: InputMaybe<Scalars['String']>;
  /** The size of the document in bytes. */
  size?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createDocument mutation. */
export type CreateDocumentPayload = {
  __typename?: 'CreateDocumentPayload';
  record: Document;
};

/** Create DocumentTemplate input. */
export type CreateDocumentTemplateInput = {
  /** Account owning this template. i.e. Forwarder, shipper etc. */
  account: IdInput;
  /** The template HTML */
  html: Scalars['String'];
  /** The JSON representation of the template HTML. */
  jsonHtml: Scalars['JSONObject'];
  /** The name of the template. */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The overall structure of the template (e.g. Master Power of Attorney). */
  templateType: TemplateType;
};

/** Payload returned from the createDocumentTemplate mutation. */
export type CreateDocumentTemplatePayload = {
  __typename?: 'CreateDocumentTemplatePayload';
  record: DocumentTemplate;
};

export type CreateDpsRecordInput = {
  /** Current DPS screening status */
  dpsStatus?: InputMaybe<DpsStatusInput>;
  /** Unique identifier for the entity being screened. */
  entityId: Scalars['String'];
  /** Unique identifier for this screening session. */
  entityScreeningId?: InputMaybe<Scalars['String']>;
  /** Version number of the entity being screened. */
  entityVersion: Scalars['Float'];
  /** Error message if DPS screening failed (optional). */
  errorMessage?: InputMaybe<Scalars['String']>;
  /** Resolution details for the DPS screening result (optional). */
  resolution?: InputMaybe<DpsResolutionInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createDpsRecord mutation. */
export type CreateDpsRecordPayload = {
  __typename?: 'CreateDpsRecordPayload';
  record: DpsRecord;
};

export type CreateErrorDefinitionInput = {
  /** The description of what the error is but can also include an SOP. */
  description: Scalars['String'];
  /** The name of the error which is associated with "name" field from processingError. */
  errorName: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createErrorDefinition mutation. */
export type CreateErrorDefinitionPayload = {
  __typename?: 'CreateErrorDefinitionPayload';
  record: ErrorDefinition;
};

export type CreateEuHsInput = {
  /** Effective descriptions with locale support */
  descriptions?: InputMaybe<Array<HsDescriptionInput>>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: InputMaybe<HsNumberType>;
  /** Main duty rates */
  mainDutyRates?: InputMaybe<Array<HsRateInput>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createEuHs mutation. */
export type CreateEuHsPayload = {
  __typename?: 'CreateEuHsPayload';
  record: EuHs;
};

/** Excel template document generation request input. */
export type CreateExcelTemplateDocumentGenerationRequestInput = {
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The workbook containing the sheets in this excel file. */
  workbook: ExcelWorkbookInput;
};

/** Payload returned from the createExcelTemplateDocumentGenerationRequest mutation. */
export type CreateExcelTemplateDocumentGenerationRequestPayload = {
  __typename?: 'CreateExcelTemplateDocumentGenerationRequestPayload';
  record: ExcelTemplateDocumentGenerationRequest;
};

/** The input used to create an ExchangeMessage. */
export type CreateExchangeMessageInput = {
  /** Additional metadata for Email ExchangeMessages. */
  inboxMetadata?: InputMaybe<InboxMetadataInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Represents the intended recipient of the message. */
  receiver: MessagingPartner;
  /** Represents the source entity of the message. */
  sender: MessagingPartner;
  /** Indicates if the document transformation is to be skipped. Defaults to false. */
  skipTransformation?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Indicates the amount of document transmission delay to be introduced while exchanging message with a partner. */
  transmissionDelaySeconds?: InputMaybe<Scalars['Int']>;
  /** The type of document or message to be exchanged. */
  type: ExchangeMessageType;
};

/** Payload returned from the createExchangeMessage mutation. */
export type CreateExchangeMessagePayload = {
  __typename?: 'CreateExchangeMessagePayload';
  record: ExchangeMessage;
};

export type CreateFacilityInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Compliance details for customs purposes. */
  complianceDetails?: InputMaybe<FacilityComplianceDetailsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** A point of contact for receiving goods */
  receivingPointOfContact?: InputMaybe<PointOfContactInput>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createFacility mutation. */
export type CreateFacilityPayload = {
  __typename?: 'CreateFacilityPayload';
  record: Facility;
};

/** Create FeatureFlag Input */
export type CreateFeatureFlagInput = {
  /** Additional attributes for the feature flag. */
  attributes?: InputMaybe<Array<AttributeInput>>;
  /** The cleanup reminder date for the feature flag. */
  cleanupReminderDate?: InputMaybe<Scalars['DateTime']>;
  /** The dial-up percentage for the feature flag. */
  dialUpPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Whether the feature flag is enabled. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The name of the feature flag. */
  featureFlagName: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createFeatureFlag mutation. */
export type CreateFeatureFlagPayload = {
  __typename?: 'CreateFeatureFlagPayload';
  record: FeatureFlag;
};

export type CreateForwarderInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Billing related details. */
  billingDetails?: InputMaybe<BillingDetailsInput>;
  /** Forwarder Cargowise One integration details. */
  cargowise?: InputMaybe<ForwarderCargowiseIntegrationDetailsInput>;
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: InputMaybe<CustomerDefaultWorkOrdersConfigInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Features disabled for forwarder. */
  disabledFeatures?: InputMaybe<ForwarderDisabledFeaturesInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References to this external system in external integrations. */
  externalIntegrationReferences?: InputMaybe<Array<PartyExternalIntegrationReferenceInput>>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The Party that has invited this Party to the CBMS platform. */
  invitingParty?: InputMaybe<IdInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** Indicates whether the forwarder overrides ior POA - Direct or Master/Sub. */
  poaMethod?: InputMaybe<POAMethod>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The configuration for this party's product library */
  productLibraryConfiguration?: InputMaybe<ProductLibraryConfigurationInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<Scalars['SCACCode']>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: InputMaybe<CustomerSelfFiledWorkOrdersConfigInput>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  /** Indicates whether the forwarder supports importing personal effects. */
  supportsPersonalEffects?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: InputMaybe<ForwarderWorkOrderConfigInput>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: InputMaybe<Array<ForwarderWorkOrderConfirmationConfigurationInput>>;
};

/** Payload returned from the createForwarder mutation. */
export type CreateForwarderPayload = {
  __typename?: 'CreateForwarderPayload';
  record: Forwarder;
};

/** Create ForwarderSystem Input */
export type CreateForwarderSystemInput = {
  /** API Authorization Details. */
  authorization?: InputMaybe<ApiAuthorizationInput>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration?: InputMaybe<ExternalSystemAwsIntegrationDetailsInput>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: InputMaybe<ExternalSystemIntegrationDetailsInput>;
  forwarder: IdInput;
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications?: InputMaybe<Array<ExternalSystemNotificationPreferenceInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** URL to recieve events via webhook. */
  webhookUrl?: InputMaybe<Scalars['URL']>;
};

/** Payload returned from the createForwarderSystem mutation. */
export type CreateForwarderSystemPayload = {
  __typename?: 'CreateForwarderSystemPayload';
  record: ForwarderSystem;
};

/** Create Forwarder User Input */
export type CreateForwarderUserInput = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: InputMaybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: InputMaybe<Scalars['Boolean']>;
  /** Forwarder User Cargowise One integration details. */
  cargowise?: InputMaybe<ForwarderUserCargowiseIntegrationDetailsInput>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References to this forwarder user in external integrations. */
  externalIntegrationReferences?: InputMaybe<Array<ExternalIntegrationReferenceInput>>;
  forwarder: IdInput;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: InputMaybe<Scalars['Boolean']>;
  /** A mobile phone number. */
  mobilePhone?: InputMaybe<PhoneInput>;
  /** External client name. */
  name: Scalars['String'];
  /** The forwarder's notification preferences. */
  notifications?: InputMaybe<Array<ForwarderUserNotificationPreferenceInput>>;
  /** A office phone number. */
  officePhone?: InputMaybe<PhoneInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The forwarder's permission. */
  permissions?: InputMaybe<ForwarderUserPermissionsInput>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The teams the user is on */
  teams?: InputMaybe<Array<IdInput>>;
  /** Title of the user */
  title: Scalars['String'];
};

/** Payload returned from the createForwarderUser mutation. */
export type CreateForwarderUserPayload = {
  __typename?: 'CreateForwarderUserPayload';
  record: ForwarderUser;
};

export type CreateFrConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createFrConsignee mutation. */
export type CreateFrConsigneePayload = {
  __typename?: 'CreateFrConsigneePayload';
  record: FrConsignee;
};

export type CreateFrCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['FrEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the createFrCustomsBroker mutation. */
export type CreateFrCustomsBrokerPayload = {
  __typename?: 'CreateFrCustomsBrokerPayload';
  record: FrCustomsBroker;
};

export type CreateFrCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: FrCustomsEntryCustomsBrokerInput;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<FrCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyanceInput;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<FrCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<FrCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the createFrCustomsEntry mutation. */
export type CreateFrCustomsEntryPayload = {
  __typename?: 'CreateFrCustomsEntryPayload';
  record: FrCustomsEntry;
};

export type CreateFrIorActivationInput = {
  /** FR Customs Broker associated with the activation. */
  broker: FrIorActivationBrokerInput;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** FR IOR to be activated. */
  ior?: InputMaybe<FrIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createFrIorActivation mutation. */
export type CreateFrIorActivationPayload = {
  __typename?: 'CreateFrIorActivationPayload';
  record: FrIorActivation;
};

export type CreateFrIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['FrEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['FrVatNumber']>;
};

/** Payload returned from the createFrIor mutation. */
export type CreateFrIorPayload = {
  __typename?: 'CreateFrIorPayload';
  record: FrIor;
};

export type CreateGbConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createGbConsignee mutation. */
export type CreateGbConsigneePayload = {
  __typename?: 'CreateGbConsigneePayload';
  record: GbConsignee;
};

export type CreateGbCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: GbCustomsEntryCustomsBrokerInput;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<GbCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyanceInput;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: InputMaybe<Array<Scalars['ImportEntryNumber']>>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<GbCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<GbCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the createGbCustomsEntry mutation. */
export type CreateGbCustomsEntryPayload = {
  __typename?: 'CreateGbCustomsEntryPayload';
  record: GbCustomsEntry;
};

export type CreateGbIorActivationInput = {
  /** GB Customs Broker associated with the activation. */
  broker: UkIorActivationBrokerInput;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** GB IOR to be activated. */
  ior?: InputMaybe<GbIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createGbIorActivation mutation. */
export type CreateGbIorActivationPayload = {
  __typename?: 'CreateGbIorActivationPayload';
  record: GbIorActivation;
};

export type CreateGbIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['GbEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['GbVatNumber']>;
};

/** Payload returned from the createGbIor mutation. */
export type CreateGbIorPayload = {
  __typename?: 'CreateGbIorPayload';
  record: GbIor;
};

/** Input for creating a generic document generation request */
export type CreateGenericDocumentGenerationRequestInput = {
  /** Tag indicating which type of document should be generated (e.g., COMMERCIAL_INVOICE, PACKING_LIST) */
  documentTag: DocumentTag;
  /** CBMS internal identifier of the record this document generation request is tied to (e.g., UsConsumptionEntry, Shipment, ImporterEntity). */
  entityId?: InputMaybe<Scalars['ID']>;
  /** External document template used for document generation (e.g., CDA1, CDA2) */
  externalDocumentTemplate: ExternalDocumentTemplateType;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createGenericDocumentGenerationRequest mutation. */
export type CreateGenericDocumentGenerationRequestPayload = {
  __typename?: 'CreateGenericDocumentGenerationRequestPayload';
  record: GenericDocumentGenerationRequest;
};

export type CreateGlobalConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry: Scalars['CountryCode'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createGlobalConsignee mutation. */
export type CreateGlobalConsigneePayload = {
  __typename?: 'CreateGlobalConsigneePayload';
  record: GlobalConsignee;
};

/** Create HTML document generation request input. */
export type CreateHtmlDocumentGenerationRequestInput = {
  /** The TemplateDocumentSignRequest associated with this HtmlDocumentGenerationRequest. */
  documentSignRequest?: InputMaybe<IdInput>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The data-filled template in HTML. */
  html: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createHtmlDocumentGenerationRequest mutation. */
export type CreateHtmlDocumentGenerationRequestPayload = {
  __typename?: 'CreateHtmlDocumentGenerationRequestPayload';
  record: HtmlDocumentGenerationRequest;
};

export type CreateHtsInput = {
  /** May be subject to anti-dumping duties. */
  ad?: InputMaybe<Scalars['Boolean']>;
  /** Anti-dumping and Countervailing duty (ADD/CVD) active case Ids */
  adCvdCases?: InputMaybe<Array<IdInput>>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additional?: InputMaybe<Array<AdditionalHtsInput>>;
  /** Additional Tariff may be required. */
  additionalHTS?: InputMaybe<Scalars['Boolean']>;
  /** The additional HTS number that may be required. */
  additionalHtsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additionalHtssApplicable?: InputMaybe<Array<AdditionalHtsInput>>;
  /** The effective end date provided by ACE CATAIR. It may differ from the top-level endDate. */
  cbpEndDate?: InputMaybe<Scalars['Date']>;
  /** The effective start date provided by ACE CATAIR. It may differ from the top-level startDate. */
  cbpStartDate?: InputMaybe<Scalars['Date']>;
  /** Compliance notes */
  complianceNotes?: InputMaybe<Array<HtsComplianceNoteInput>>;
  /** May be subject to countervailing duties. */
  cv?: InputMaybe<Scalars['Boolean']>;
  /** Longer description of Tariff. */
  description?: InputMaybe<Scalars['String']>;
  /** Descriptions of Tariff. */
  descriptions?: InputMaybe<Array<HtsDescriptionInput>>;
  /** Duty code */
  duty?: InputMaybe<Scalars['String']>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Fees required, also used for taxes. */
  fees?: InputMaybe<Array<HtsFeeInput>>;
  /** Is HS number fully qualified. */
  fullyQualified?: InputMaybe<Scalars['Boolean']>;
  /** Country of origin codes not permitted to use with the Generalized System of Preferences SPI (A*). */
  gspExcluded?: InputMaybe<Array<Scalars['String']>>;
  /** License data potentially required on an entry. */
  license?: InputMaybe<HtsLicenseInput>;
  /** License code required on Line. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** Column one rate object used to calculate duty that may apply to HS during different time intervals. */
  mainDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Partner Government Agency data potentially required on an entry. */
  pga?: InputMaybe<Array<PgaRequirementInput>>;
  /** May be subject to a quota. */
  quota?: InputMaybe<Scalars['Boolean']>;
  /** Rate object used to calculate duty. */
  rate?: InputMaybe<HtsRateInput>;
  /** Restrictions on HTS number usage. */
  restriction?: InputMaybe<HtsRestrictionInput>;
  /** Column two rate object used to calculate duty that may apply to HS during different time intervals. */
  secondaryDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Special Program Indicators available to use, subject to country of origin. */
  spi?: InputMaybe<Array<SpiInput>>;
  /** Special rates based on different SPIs. */
  spiRates?: InputMaybe<Array<HtsSpiRateInput>>;
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Description of Tariff. */
  text?: InputMaybe<Scalars['String']>;
  /** Textile code. */
  textile?: InputMaybe<Scalars['String']>;
  /** Truncated description of Tariff. */
  truncatedDescription?: InputMaybe<Scalars['String']>;
  /** Required unit of measure reporting quantities. */
  uom?: InputMaybe<Array<Scalars['String']>>;
};

/** Payload returned from the createHts mutation. */
export type CreateHtsPayload = {
  __typename?: 'CreateHtsPayload';
  record: Hts;
};

export type CreateImportProductsFromBulkUploadRequestInput = {
  /** The document containing the data to be processed. */
  document: IdInput;
  /** Indicates the behavior that the API should emulate when deciding how to handle record duplicates */
  duplicateAction?: InputMaybe<SpreadsheetActionType>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The product owner that owns this request. */
  owner: IdInput;
  requireConfirmation?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createImportProductsFromBulkUploadRequest mutation. */
export type CreateImportProductsFromBulkUploadRequestPayload = {
  __typename?: 'CreateImportProductsFromBulkUploadRequestPayload';
  record: ImportProductsFromBulkUploadRequest;
};

export type CreateImportProductsFromCustomsEntriesRequestInput = {
  /** Customs entries created this many days before today will be included in the list which creates product records. */
  createdDaysAgo: Scalars['Float'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The product owner that owns this request. */
  owner: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createImportProductsFromCustomsEntriesRequest mutation. */
export type CreateImportProductsFromCustomsEntriesRequestPayload = {
  __typename?: 'CreateImportProductsFromCustomsEntriesRequestPayload';
  record: ImportProductsFromCustomsEntriesRequest;
};

export type CreateImporterEntityActivationInput = {
  /** Broker associated with the activation. */
  broker?: InputMaybe<IdInput>;
  /** Code specifying the country of this importer entity activation. It uses ISO 3166 standard. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Importer Entity activation request in a given country. */
  importerEntity?: InputMaybe<IdOptionalVersionInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** US Importer of Record reference. */
  usIor?: InputMaybe<IdOptionalVersionInput>;
};

/** Payload returned from the createImporterEntityActivation mutation. */
export type CreateImporterEntityActivationPayload = {
  __typename?: 'CreateImporterEntityActivationPayload';
  record: ImporterEntityActivation;
};

export type CreateImporterEntityInput = {
  /** Activation input. */
  activations?: InputMaybe<Array<UpsertImporterEntityActivationInput>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** A list of the Importer's customs bonds for importing in the country. */
  bonds?: InputMaybe<CustomsBondsInput>;
  /** Country Code in which importer entity is operating. */
  countryCode: Scalars['CountryCode'];
  /** Importer Entity's country specific data. */
  countrySpecificData?: InputMaybe<CountrySpecificDataInput>;
  /** Identifier for DocReadiness status of IE in ShipDocs system */
  docReadinessId?: InputMaybe<Scalars['String']>;
  /** The code for the Importer's expected import volume in the country. */
  entriesPerYearCode?: InputMaybe<EntriesPerYear>;
  /** Importer Entity entry summary email addresses. */
  entrySummaryContactEmails?: InputMaybe<Array<Scalars['Email']>>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References provided by external client. */
  externalClientReferences?: InputMaybe<Array<Scalars['String']>>;
  /** A list of external validation results for this ImporterEntity's identifiers. */
  externalValidations?: InputMaybe<Array<ExternalValidationInput>>;
  /** Indicate whether the importer entity has imported before. */
  hasImportedBefore?: InputMaybe<Scalars['Boolean']>;
  /** Indicate whether the IOR entity has own duty and tax account. */
  hasOwnDutyAndTaxAccount?: InputMaybe<Scalars['Boolean']>;
  /** Importer country exclusive identifiers list. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The parent Importer record of this importer entity. */
  importer: IdInput;
  /** Indicate whether the IOR entity is a resident importer. */
  isResident?: InputMaybe<Scalars['Boolean']>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Importer Entity point of contact. */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** Details of Programs associated with the Importer Entity. */
  program?: InputMaybe<Array<ProgramDetailsInput>>;
  /** Source channel identifier */
  sourceChannel?: InputMaybe<SourceChannel>;
  /** Source portal identifier */
  sourcePortal?: InputMaybe<SourcePortal>;
  /** The status of the Importer Entity. */
  status?: InputMaybe<ImporterEntityStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createImporterEntity mutation. */
export type CreateImporterEntityPayload = {
  __typename?: 'CreateImporterEntityPayload';
  record: ImporterEntity;
};

/** The payload returned from the createImporterImporterEntityRelationship mutation. */
export type CreateImporterImporterEntityRelationshipPayload = {
  __typename?: 'CreateImporterImporterEntityRelationshipPayload';
  /** The relationship created from linking the Importer and Importer Entity Records. */
  relationship: ImporterImporterEntityRelationship;
};

export type CreateImporterInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The description of the Importer's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<GlobalBusinessStructure>;
  /** Importer business website */
  businessWebsite?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Identifier for DocReadiness status of Importer in ShipDocs system */
  docReadinessId?: InputMaybe<Scalars['String']>;
  /** Importer Level Doc Readinesses */
  docReadinesses?: InputMaybe<Array<ImporterDocReadinessInput>>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References provided by external client. */
  externalClientReferences?: InputMaybe<Array<Scalars['String']>>;
  /** Extracted business license data */
  extractedBusinessLicense?: InputMaybe<ExtractedBusinessLicenseInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the Importer */
  industry?: InputMaybe<Vertical>;
  /** The legal representative of the Importer */
  legalRepresentative?: InputMaybe<PointOfContactInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Identifiers of customers with ownership of IOR */
  owners?: InputMaybe<Array<ImporterOwnerInput>>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The secondary officer of the Importer */
  secondaryOfficer?: InputMaybe<PointOfContactInput>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** translated business license data */
  translatedBusinessLicense?: InputMaybe<TranslatedBusinessLicenseInput>;
};

/** Payload returned from the createImporter mutation. */
export type CreateImporterPayload = {
  __typename?: 'CreateImporterPayload';
  record: Importer;
};

/** InBondNotes document generation request input. */
export type CreateInBondNotesDocumentGenerationRequestInput = {
  /** The bills for the CbpInBond */
  bills: Array<BillInfoInput>;
  /** Each CbpInBondResponseData for the CbpInBond. The messages provided should be for the inBondNumber provided. */
  cbpInBondResponses: Array<CbpInBondResponseDataInput>;
  /** The INLT US In-Bond number for the CbpInBond */
  inBondNumber: Scalars['InltUsInBondNumber'];
  /** The mode of transport for the CbpInBond */
  modeOfTransport: ModeOfTransport;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The previous CbpInBond US In-Bond number */
  previousCbpInBondNumber?: InputMaybe<Scalars['UsInBondNumber']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createInBondNotesDocumentGenerationRequest mutation. */
export type CreateInBondNotesDocumentGenerationRequestPayload = {
  __typename?: 'CreateInBondNotesDocumentGenerationRequestPayload';
  record: InBondNotesDocumentGenerationRequest;
};

export type CreateInvitedShipperPayload = {
  __typename?: 'CreateInvitedShipperPayload';
  globalLogisticsProfileId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  operatorId: Scalars['String'];
};

/** Input fields for creating an invoice credit note document generation request */
export type CreateInvoiceCreditNoteDocumentGenerationRequestInput = {
  /** Invoice credit note reference that will be queried in DGW */
  invoiceCreditNote: IdVersionInput;
  /** The type of invoice credit note PDF that should be generated. If not provided, DGW will infer the PDF that should be used. */
  invoiceCreditNoteType?: InputMaybe<InvoiceCreditNoteDocumentGenerationType>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createInvoiceCreditNoteDocumentGenerationRequest mutation. */
export type CreateInvoiceCreditNoteDocumentGenerationRequestPayload = {
  __typename?: 'CreateInvoiceCreditNoteDocumentGenerationRequestPayload';
  record: InvoiceCreditNoteDocumentGenerationRequest;
};

export type CreateInvoiceCreditNoteInput = {
  /** The time that the credit note was applied by AR */
  creditTime?: InputMaybe<Scalars['DateTime']>;
  /** Context behind the purpose of the credit note */
  description?: InputMaybe<Scalars['String']>;
  /** Invoice ID associated with this credit note */
  invoice: IdInput;
  /** The itemized lines that will be refunded */
  lines: Array<InvoiceCreditNoteLineInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createInvoiceCreditNote mutation. */
export type CreateInvoiceCreditNotePayload = {
  __typename?: 'CreateInvoiceCreditNotePayload';
  record: InvoiceCreditNote;
};

/** Invoice document generation request input. */
export type CreateInvoiceDocumentGenerationRequestInput = {
  /** Invoice bill to party info. */
  billToParty: InvoiceDocumentBillToPartyInfoInput;
  /** Labels to classify the type of invoice document (e.g. IOR invoice). */
  documentTags?: InputMaybe<Array<DocumentTag>>;
  /**  The due date of the invoice. */
  dueDate: Scalars['DateTime'];
  /**  Invoice date. */
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  /** Invoice status. */
  invoiceStatus: InvoiceStatus;
  /** The type of invoice PDF that should be generated. If not provided, DGW will infer the PDF that should be used. */
  invoiceType?: InputMaybe<InvoiceDocumentGenerationType>;
  /** Invoice line details */
  lines: Array<InvoiceDocumentLineInfoInput>;
  /** Invoice number printed on the doc */
  number: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Invoice related references. */
  references: InvoiceDocumentReferenceInfoInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** Total amount due in US Dollars. */
  total: CostInput;
};

/** Payload returned from the createInvoiceDocumentGenerationRequest mutation. */
export type CreateInvoiceDocumentGenerationRequestPayload = {
  __typename?: 'CreateInvoiceDocumentGenerationRequestPayload';
  record: InvoiceDocumentGenerationRequest;
};

export type CreateInvoiceInput = {
  /** Accounting System details */
  accountingSystemDetails?: InputMaybe<AccountingSystemDetailInput>;
  /** Billing party details of bill to party. */
  billToParty: IdVersionInput;
  /** The sending history of the invoice */
  deliveries?: InputMaybe<Array<InvoiceDeliveryInput>>;
  /**  The due date of the invoice */
  dueTime?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  The time of the invoicing */
  invoicedTime?: InputMaybe<Scalars['DateTime']>;
  /** The individual charges on the invoice */
  lines?: InputMaybe<Array<InvoiceLineInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /**  The payment method for this invoice */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** The current status of the invoice */
  status: InvoiceStatus;
  tags?: InputMaybe<Array<TagInput>>;
  /** The type of invoice, eg: WorkOrderGroup, sub */
  type: InvoiceType;
  /** The work order group details associated with Invoice if invoice type is work order group */
  workOrderGroup?: InputMaybe<IdInput>;
};

export type CreateInvoiceLinesRequestInput = {
  /** Accounting type of the Invoice Lines Request */
  accountingType?: InputMaybe<AccountingType>;
  /** Status of the Accounts Payable (AP) associated with the Invoice Lines Request */
  accountsPayableStatus?: InputMaybe<AccountsPayableStatus>;
  /** The party details used for subscription invoice line request. */
  billToParty?: InputMaybe<IdInput>;
  /** The documents associated with the InvoiceLinesRequest. */
  documents?: InputMaybe<Array<IdInput>>;
  /** An optional dueDate that will be used rather than the default configuration */
  dueDate?: InputMaybe<Scalars['Date']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** External references associated with the claim */
  externalReference?: InputMaybe<ExternalFinanceReferenceInput>;
  /** Flag to determine if invoice is ready to generate. */
  invoiceImmediately?: InputMaybe<Scalars['Boolean']>;
  /** Lines that need to add to the invoice. */
  lines?: InputMaybe<Array<InvoiceRequestLineInput>>;
  /** The operation to apply (e.g. amend) on lines of the InvoiceLinesRequest for an invoice. */
  operation?: InputMaybe<InvoiceLinesRequestOperation>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: InputMaybe<Scalars['SCACCode']>;
  /** InvoiceLinesRequest review status */
  reviewStatus?: InputMaybe<ReviewStatus>;
  /** Service types of the Invoice Lines Request */
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  /** Source of the Invoice Lines Request */
  source?: InputMaybe<InvoiceLinesRequestSource>;
  /** Status of the Invoice Lines Request */
  status?: InputMaybe<InvoiceLinesRequestStatus>;
  /** Status reason for review status */
  statusReason?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The type of invoice line request. */
  type: InvoiceType;
  /** The work order details associated with invoice line request.  */
  workOrder?: InputMaybe<IdInput>;
};

/** Payload returned from the createInvoiceLinesRequest mutation. */
export type CreateInvoiceLinesRequestPayload = {
  __typename?: 'CreateInvoiceLinesRequestPayload';
  record: InvoiceLinesRequest;
};

/** Payload returned from the createInvoice mutation. */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  record: Invoice;
};

export type CreateInvoicePaymentInput = {
  /** Accounting System details */
  accountingSystemDetail?: InputMaybe<AccountingSystemDetailInput>;
  /** Billing party details of customer. */
  customer: IdVersionInput;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Invoice paid time */
  paidTime?: InputMaybe<Scalars['DateTime']>;
  /** Payment method */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** The reference number for the payment received. For example, Check # for a check. */
  referenceNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Indicates the total amount of the payment. This includes the total of all the transactions. */
  totalAmount?: InputMaybe<CostInput>;
  /** The individual payment line on the invoice payment */
  transactions?: InputMaybe<Array<InvoicePaymentTransactionInput>>;
  /** Indicates the amount that has not been applied to pay amounts owed for sales transactions. This amount is total payment amount - the sum of applied payments. The unapplied amount can be applied for future invoices which belongs to the same customer. */
  unappliedAmount?: InputMaybe<CostInput>;
};

/** Payload returned from the createInvoicePayment mutation. */
export type CreateInvoicePaymentPayload = {
  __typename?: 'CreateInvoicePaymentPayload';
  record: InvoicePayment;
};

/** Create memo input */
export type CreateMemoInput = {
  /** Indicates if the memo should be visible to other parties. If isPublic is not true (by default), then only users with the same Account (forwarder/operator/shipper) can see it. Otherwise, both customers and operators can see the memo. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The text contained within the memo. */
  text: Scalars['String'];
};

/** Payload returned from the createMemo mutation. */
export type CreateMemoPayload = {
  __typename?: 'CreateMemoPayload';
  record: Memo;
};

export type CreateNlConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createNlConsignee mutation. */
export type CreateNlConsigneePayload = {
  __typename?: 'CreateNlConsigneePayload';
  record: NlConsignee;
};

export type CreateNlCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['NlEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the createNlCustomsBroker mutation. */
export type CreateNlCustomsBrokerPayload = {
  __typename?: 'CreateNlCustomsBrokerPayload';
  record: NlCustomsBroker;
};

export type CreateNlCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: NlCustomsEntryCustomsBrokerInput;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<NlCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyanceInput;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<NlCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<NlCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the createNlCustomsEntry mutation. */
export type CreateNlCustomsEntryPayload = {
  __typename?: 'CreateNlCustomsEntryPayload';
  record: NlCustomsEntry;
};

export type CreateNlIorActivationInput = {
  /** NL Customs Broker associated with the activation. */
  broker: NlIorActivationBrokerInput;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** NL IOR to be activated. */
  ior?: InputMaybe<NlIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createNlIorActivation mutation. */
export type CreateNlIorActivationPayload = {
  __typename?: 'CreateNlIorActivationPayload';
  record: NlIorActivation;
};

export type CreateNlIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['NlEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['NlVatNumber']>;
};

/** Payload returned from the createNlIor mutation. */
export type CreateNlIorPayload = {
  __typename?: 'CreateNlIorPayload';
  record: NlIor;
};

/** Create Onboarding Request Input */
export type CreateOnboardingRequestInput = {
  /** Onboarding account type */
  accountType: OnboardingAccountType;
  /** User email */
  email: Scalars['Email'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createOnboardingRequest mutation. */
export type CreateOnboardingRequestPayload = {
  __typename?: 'CreateOnboardingRequestPayload';
  record: OnboardingRequest;
};

export type CreateOperatorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createOperator mutation. */
export type CreateOperatorPayload = {
  __typename?: 'CreateOperatorPayload';
  record: Operator;
};

/** Create OperatorSystem Input */
export type CreateOperatorSystemInput = {
  /** API Authorization Details. */
  authorization?: InputMaybe<ApiAuthorizationInput>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration?: InputMaybe<ExternalSystemAwsIntegrationDetailsInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: InputMaybe<ExternalSystemIntegrationDetailsInput>;
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications?: InputMaybe<Array<ExternalSystemNotificationPreferenceInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** URL to recieve events via webhook. */
  webhookUrl?: InputMaybe<Scalars['URL']>;
};

/** Payload returned from the createOperatorSystem mutation. */
export type CreateOperatorSystemPayload = {
  __typename?: 'CreateOperatorSystemPayload';
  record: OperatorSystem;
};

/** Create Operator User Input */
export type CreateOperatorUserInput = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: InputMaybe<Scalars['DateTime']>;
  assignmentConfig?: InputMaybe<AssignmentConfigInput>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: InputMaybe<Scalars['Boolean']>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Daily work order task completion goal set by managers */
  dailyGoal?: InputMaybe<Scalars['Int']>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: InputMaybe<Scalars['Boolean']>;
  /** A mobile phone number. */
  mobilePhone?: InputMaybe<PhoneInput>;
  /** External client name. */
  name: Scalars['String'];
  /** The operator's notification preferences. */
  notifications?: InputMaybe<Array<OperatorUserNotificationPreferenceInput>>;
  /** A office phone number. */
  officePhone?: InputMaybe<PhoneInput>;
  operator: IdInput;
  /** The operator's permission. */
  permissions?: InputMaybe<OperatorUserPermissionsInput>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: InputMaybe<Scalars['Boolean']>;
  /** Skill level of operator users which will be assigned by managers */
  skillLevel?: InputMaybe<SkillLevel>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Used to specify the teamProperties of OperatorUser */
  teamProperties?: InputMaybe<Array<OperatorUserTeamPropertyInput>>;
  /** The teams the user is on */
  teams?: InputMaybe<Array<IdInput>>;
  /** Title of the user */
  title: Scalars['String'];
  workingHours?: InputMaybe<UserWorkingHoursInput>;
};

/** Payload returned from the createOperatorUser mutation. */
export type CreateOperatorUserPayload = {
  __typename?: 'CreateOperatorUserPayload';
  record: OperatorUser;
};

export type CreatePayableInvoiceInput = {
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** External references associated with the invoice */
  externalReference?: InputMaybe<ExternalFinanceReferenceInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party which is to be paid. */
  payee?: InputMaybe<IdInput>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: InputMaybe<Scalars['SCACCode']>;
  /** Service type of the invoice */
  serviceType: PayableInvoiceServiceType;
  /** The current status of the invoice */
  status?: InputMaybe<PayableInvoiceStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The work order group details associated with the Invoice */
  workOrderGroup: IdInput;
};

/** Payload returned from the createPayableInvoice mutation. */
export type CreatePayableInvoicePayload = {
  __typename?: 'CreatePayableInvoicePayload';
  record: PayableInvoice;
};

export type CreateProcessingErrorInput = {
  /** The IDs of records affected by the error. */
  affectedRecordIds?: InputMaybe<Array<Scalars['String']>>;
  /** The error message */
  message: Scalars['String'];
  /** The name of the error. */
  name: Scalars['String'];
  operator: IdInput;
  /** The source service that threw the error. */
  source?: InputMaybe<SystemType>;
  /** The stack trace of the error. */
  stack?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The event that triggered the error. */
  triggeringEvent?: InputMaybe<Scalars['JSONObject']>;
};

/** Payload returned from the createProcessingError mutation. */
export type CreateProcessingErrorPayload = {
  __typename?: 'CreateProcessingErrorPayload';
  record: ProcessingError;
};

export type CreateProductInput = {
  /** The ASIN for this product */
  asin?: InputMaybe<Scalars['String']>;
  /** Client identifier for the product (eg, sku, asin, etc). */
  clientIdentifier: Scalars['String'];
  /** Client identifier Version for the product (eg, sku, asin, etc). */
  clientIdentifierVersion?: InputMaybe<Scalars['Int']>;
  /** Compliance details for importing the product, per country. */
  complianceDetails?: InputMaybe<ProductComplianceDetailsInput>;
  /** The country for which this product originates from - its manufacturing country. This field is used to determine product uniqueness. */
  countryOfOrigin?: InputMaybe<Scalars['CountryCode']>;
  /** The dimensions of the product. */
  dimensions?: InputMaybe<DimensionsInput>;
  /** Global Trade Item Number for the product. */
  gtin?: InputMaybe<Scalars['GTIN']>;
  ior?: InputMaybe<ProductIorInput>;
  /** Details of a product per locale.  */
  localizedDetails?: InputMaybe<Array<LocalizedProductDetailInput>>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Additional product notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The party who owns this product record. */
  owner?: InputMaybe<IdInput>;
  /** Units per packing. */
  packingUnits?: InputMaybe<Scalars['Float']>;
  /** Set of additional secondary identifiers that the client might want to associate with the product (eg: ASIN). */
  secondaryIdentifiers?: InputMaybe<Array<ProductSecondaryIdentifierInput>>;
  /** The identifier of shipper importing the product. */
  shipper: IdInput;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status?: InputMaybe<ProductStatus>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplier?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Universal Product Code for the product. */
  upc?: InputMaybe<Scalars['String']>;
  /** The weight of the product */
  weight?: InputMaybe<WeightInput>;
};

/** Payload returned from the createProduct mutation. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  record: Product;
};

export type CreateProgramInput = {
  /** List of associated Customs Brokers under this program. */
  brokers: Array<IdInput>;
  /** The country codes associated with this program (e.g., US, GB, IN). */
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  /** The name of the program (e.g., CRIS). */
  programName: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createProgram mutation. */
export type CreateProgramPayload = {
  __typename?: 'CreateProgramPayload';
  record: Program;
};

/** Create Release Note Input */
export type CreateReleaseNoteInput = {
  /** The description of the release note, supports markdown and hyperlinks. */
  description: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
  /** The countries for which the release note should be shown */
  targetCountries: Array<Scalars['String']>;
  /** Number of thumbs down reactions. */
  thumbsDown?: Scalars['Int'];
  /** Number of thumbs up reactions. */
  thumbsUp?: Scalars['Int'];
  /** The title of the release note. */
  title: Scalars['String'];
};

/** Payload returned from the createReleaseNote mutation. */
export type CreateReleaseNotePayload = {
  __typename?: 'CreateReleaseNotePayload';
  record: ReleaseNote;
};

export type CreateReportReconciliationRequestInput = {
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The records create input of report reconciliation */
  reports: Array<ReportReconciliationInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createReportReconciliationRequest mutation. */
export type CreateReportReconciliationRequestPayload = {
  __typename?: 'CreateReportReconciliationRequestPayload';
  record: ReportReconciliationRequest;
};

export type CreateShipmentCommercialInvoiceDetailInput = {
  /** List of invoices with their items and compliance details. */
  commercialInvoices?: InputMaybe<Array<ShipmentCommercialInvoiceInput>>;
  /** Shipment commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines. */
  commercialInvoicesReference?: InputMaybe<ShipmentCommercialInvoicesReferenceInput>;
  /** External document references. */
  externalDocumentReferences?: InputMaybe<Array<ExternalDocumentReferenceInput>>;
  /** The shipment leg index. */
  legIndex: Scalars['Int'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The shipment associated with this record. */
  shipment: IdInput;
  /** The source that caused the shipment commercial invoice to be updated */
  source?: InputMaybe<ShipmentCommercialInvoiceSourceInput>;
  /** The status of shipment commercial invoice detail */
  status: ShipmentCommercialInvoiceDetailStatus;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createShipmentCommercialInvoiceDetail mutation. */
export type CreateShipmentCommercialInvoiceDetailPayload = {
  __typename?: 'CreateShipmentCommercialInvoiceDetailPayload';
  record: ShipmentCommercialInvoiceDetail;
};

export type CreateShipmentDocumentProcessingRequestInput = {
  /** Shipment processing request documents. */
  documents?: InputMaybe<Array<ShipmentProcessingRequestDocumentInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Status values for tracking document processing status for a shipment */
  status?: InputMaybe<ShipmentDocumentProcessingStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createShipmentDocumentProcessingRequest mutation. */
export type CreateShipmentDocumentProcessingRequestPayload = {
  __typename?: 'CreateShipmentDocumentProcessingRequestPayload';
  record: ShipmentDocumentProcessingRequest;
};

export type CreateShipmentInput = {
  /** Badges related to a shipment e.g. HOT, PREMIUM */
  badges?: InputMaybe<Array<ShipmentBadge>>;
  /** Buyer is the party that buys the goods from overseas sellers. Name and address are required. */
  buyer?: InputMaybe<ShipmentBuyerInput>;
  /** Represents if the customer is to be charged for creating the shipment manually */
  chargeManualCreationFee?: InputMaybe<Scalars['Boolean']>;
  /** The client's identifier for the shipment */
  clientIdentifier?: InputMaybe<Scalars['ShipmentClientIdentifier']>;
  /** Client references for the shipment: booking id, shipment id etc */
  clientReferences?: InputMaybe<ClientReferencesInput>;
  /** Consolidator is the party responsible for consolidation of the goods. Name and address are required. */
  consolidator?: InputMaybe<ShipmentConsolidatorInput>;
  /** External document references. */
  externalDocumentReferences?: InputMaybe<Array<ExternalDocumentReferenceInput>>;
  /** References to this shipment in external integrations. */
  externalIntegrationReferences?: InputMaybe<Array<ShipmentExternalIntegrationReferenceInput>>;
  /** The freight forwarders related to the Shipment. */
  forwarders?: InputMaybe<Array<ShipmentForwarderInput>>;
  /** Represents the different legs that make up a shipment. */
  legs: Array<ShipmentLegInput>;
  /** Manufacturers associated with the shipment. Name and address are required. */
  manufacturers?: InputMaybe<Array<ShipmentManufacturerInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Service type for AMP2.0 bookings, defaults to STANDARD for non-AMP2.0 bookings */
  placementType?: InputMaybe<PlacementType>;
  /** Preferred duty charge party type */
  preferredDutyCollectPartyType?: InputMaybe<PreferredDutyCollectPartyType>;
  /** Each provided WorkOrderType will be created automatically when the shipment is created/updated */
  requestedWorkOrders?: InputMaybe<Array<WorkOrderType>>;
  /** Sellers are indicated as the sellers of the goods. Name and address are required. */
  sellers?: InputMaybe<Array<ShipmentSellerInput>>;
  /** Destination associated with the shipment. */
  shipTo?: InputMaybe<ShipmentShipToInput>;
  /** Shipper is the party responsible for the shipment. */
  shipper: ShipmentShipperInput;
  /** Container stuffing location associated with the shipment. Name and address are required. */
  stuffingLocation?: InputMaybe<ShipmentStuffingLocationInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createShipment mutation. */
export type CreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload';
  record: Shipment;
};

/** The payload returned from the createShipperBrokerRelationship mutation. */
export type CreateShipperBrokerRelationshipPayload = {
  __typename?: 'CreateShipperBrokerRelationshipPayload';
  /** The relationship created from linking the Shipper and Broker Records. */
  relationship: ShipperBrokerRelationship;
};

/** The payload returned from the createShipperCustomsAgentRelationship mutation. */
export type CreateShipperCustomsAgentRelationshipPayload = {
  __typename?: 'CreateShipperCustomsAgentRelationshipPayload';
  /** The relationship created from linking the Shipper and Customs Agent Records. */
  relationship: ShipperCustomsAgentRelationship;
};

/** The payload returned from the createShipperDeConsigneeRelationship mutation. */
export type CreateShipperDeConsigneeRelationshipPayload = {
  __typename?: 'CreateShipperDeConsigneeRelationshipPayload';
  /** The relationship created from linking the Shipper and DE Consignee Records. */
  relationship: ShipperDeConsigneeRelationship;
};

/** The payload returned from the createShipperDeCustomsBrokerRelationship mutation. */
export type CreateShipperDeCustomsBrokerRelationshipPayload = {
  __typename?: 'CreateShipperDeCustomsBrokerRelationshipPayload';
  /** The relationship created from linking the Shipper and De Customs Broker Records. */
  relationship: ShipperDeCustomsBrokerRelationship;
};

/** The payload returned from the createShipperDeIorRelationship mutation. */
export type CreateShipperDeIorRelationshipPayload = {
  __typename?: 'CreateShipperDeIorRelationshipPayload';
  /** The relationship created from linking the Shipper and DE IOR Records. */
  relationship: ShipperDeIorRelationship;
};

/** The payload returned from the createShipperFacilityRelationship mutation. */
export type CreateShipperFacilityRelationshipPayload = {
  __typename?: 'CreateShipperFacilityRelationshipPayload';
  /** The relationship created from linking the Shipper and Facility Records. */
  relationship: ShipperFacilityRelationship;
};

/** The payload returned from the createShipperForwarderRelationship mutation. */
export type CreateShipperForwarderRelationshipPayload = {
  __typename?: 'CreateShipperForwarderRelationshipPayload';
  /** The relationship created from linking the Shipper and Freight Forwarder Records. */
  relationship: ShipperForwarderRelationship;
};

/** The payload returned from the createShipperFrConsigneeRelationship mutation. */
export type CreateShipperFrConsigneeRelationshipPayload = {
  __typename?: 'CreateShipperFrConsigneeRelationshipPayload';
  /** The relationship created from linking the Shipper and FR Consignee Records. */
  relationship: ShipperFrConsigneeRelationship;
};

/** The payload returned from the createShipperFrCustomsBrokerRelationship mutation. */
export type CreateShipperFrCustomsBrokerRelationshipPayload = {
  __typename?: 'CreateShipperFrCustomsBrokerRelationshipPayload';
  /** The relationship created from linking the Shipper and FR Customs Broker Records. */
  relationship: ShipperFrCustomsBrokerRelationship;
};

/** The payload returned from the createShipperFrIorRelationship mutation. */
export type CreateShipperFrIorRelationshipPayload = {
  __typename?: 'CreateShipperFrIorRelationshipPayload';
  /** The relationship created from linking the Shipper and FR IOR Records. */
  relationship: ShipperFrIorRelationship;
};

/** The payload returned from the createShipperGbConsigneeRelationship mutation. */
export type CreateShipperGbConsigneeRelationshipPayload = {
  __typename?: 'CreateShipperGbConsigneeRelationshipPayload';
  /** The relationship created from linking the Shipper and GB Consignee Records. */
  relationship: ShipperGbConsigneeRelationship;
};

/** The payload returned from the createShipperGbIorRelationship mutation. */
export type CreateShipperGbIorRelationshipPayload = {
  __typename?: 'CreateShipperGbIorRelationshipPayload';
  /** The relationship created from linking the Shipper and GB IOR Records. */
  relationship: ShipperGbIorRelationship;
};

/** The payload returned from the createShipperGlobalConsigneeRelationship mutation. */
export type CreateShipperGlobalConsigneeRelationshipPayload = {
  __typename?: 'CreateShipperGlobalConsigneeRelationshipPayload';
  /** The relationship created from linking the Shipper and Global Consignee Records. */
  relationship: ShipperGlobalConsigneeRelationship;
};

/** The payload returned from the createShipperImporterRelationship mutation. */
export type CreateShipperImporterRelationshipPayload = {
  __typename?: 'CreateShipperImporterRelationshipPayload';
  /** The relationship created from linking the Shipper and Importer Records. */
  relationship: ShipperImporterRelationship;
};

export type CreateShipperInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Billing related details. */
  billingDetails?: InputMaybe<BillingDetailsInput>;
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: InputMaybe<CustomerDefaultWorkOrdersConfigInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The Party that has invited this Party to the CBMS platform. */
  invitingParty?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The configuration for this party's product library */
  productLibraryConfiguration?: InputMaybe<ProductLibraryConfigurationInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: InputMaybe<CustomerSelfFiledWorkOrdersConfigInput>;
  /** An array of seller details coming from an external source */
  shipperExternallySourcedDetails?: InputMaybe<Array<ShipperExternallySourcedDetailsInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: InputMaybe<ShipperWorkOrderConfigInput>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: InputMaybe<Array<WorkOrderConfirmConfigurationDetailsInput>>;
};

/** The payload returned from the createShipperNlConsigneeRelationship mutation. */
export type CreateShipperNlConsigneeRelationshipPayload = {
  __typename?: 'CreateShipperNlConsigneeRelationshipPayload';
  /** The relationship created from linking the Shipper and NL Consignee Records. */
  relationship: ShipperNlConsigneeRelationship;
};

/** The payload returned from the createShipperNlCustomsBrokerRelationship mutation. */
export type CreateShipperNlCustomsBrokerRelationshipPayload = {
  __typename?: 'CreateShipperNlCustomsBrokerRelationshipPayload';
  /** The relationship created from linking the Shipper and NL Customs Broker Records. */
  relationship: ShipperNlCustomsBrokerRelationship;
};

/** The payload returned from the createShipperNlIorRelationship mutation. */
export type CreateShipperNlIorRelationshipPayload = {
  __typename?: 'CreateShipperNlIorRelationshipPayload';
  /** The relationship created from linking the Shipper and NL IOR Records. */
  relationship: ShipperNlIorRelationship;
};

/** Payload returned from the createShipper mutation. */
export type CreateShipperPayload = {
  __typename?: 'CreateShipperPayload';
  record: Shipper;
};

/** The payload returned from the createShipperSupplierRelationship mutation. */
export type CreateShipperSupplierRelationshipPayload = {
  __typename?: 'CreateShipperSupplierRelationshipPayload';
  /** The relationship created from linking the Shipper and Supplier Records. */
  relationship: ShipperSupplierRelationship;
};

/** Create ShipperSystem Input. */
export type CreateShipperSystemInput = {
  /** API Authorization Details. */
  authorization?: InputMaybe<ApiAuthorizationInput>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration?: InputMaybe<ExternalSystemAwsIntegrationDetailsInput>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: InputMaybe<ExternalSystemIntegrationDetailsInput>;
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications?: InputMaybe<Array<ExternalSystemNotificationPreferenceInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Shipper associated with the system. */
  shipper: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** URL to recieve events via webhook. */
  webhookUrl?: InputMaybe<Scalars['URL']>;
};

/** Payload returned from the createShipperSystem mutation. */
export type CreateShipperSystemPayload = {
  __typename?: 'CreateShipperSystemPayload';
  record: ShipperSystem;
};

/** The payload returned from the createShipperTruckerRelationship mutation. */
export type CreateShipperTruckerRelationshipPayload = {
  __typename?: 'CreateShipperTruckerRelationshipPayload';
  /** The relationship created from linking the Shipper and Trucker Records. */
  relationship: ShipperTruckerRelationship;
};

/** The payload returned from the createShipperUkCustomsBrokerRelationship mutation. */
export type CreateShipperUkCustomsBrokerRelationshipPayload = {
  __typename?: 'CreateShipperUkCustomsBrokerRelationshipPayload';
  /** The relationship created from linking the Shipper and UK Customs Broker Records. */
  relationship: ShipperUkCustomsBrokerRelationship;
};

/** The payload returned from the createShipperUsConsigneeRelationship mutation. */
export type CreateShipperUsConsigneeRelationshipPayload = {
  __typename?: 'CreateShipperUsConsigneeRelationshipPayload';
  /** The relationship created from linking the Shipper and US Consignee Records. */
  relationship: ShipperUsConsigneeRelationship;
};

/** The payload returned from the createShipperUsCustomsBrokerRelationship mutation. */
export type CreateShipperUsCustomsBrokerRelationshipPayload = {
  __typename?: 'CreateShipperUsCustomsBrokerRelationshipPayload';
  /** The relationship created from linking the Shipper and US Customs Broker Records. */
  relationship: ShipperUsCustomsBrokerRelationship;
};

/** The payload returned from the createShipperUsIorRelationship mutation. */
export type CreateShipperUsIorRelationshipPayload = {
  __typename?: 'CreateShipperUsIorRelationshipPayload';
  /** The relationship created from linking the Shipper and US IOR Records. */
  relationship: ShipperUsIorRelationship;
};

/** Create ShipperUser Input */
export type CreateShipperUserInput = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: InputMaybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: InputMaybe<Scalars['Boolean']>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: InputMaybe<Scalars['Boolean']>;
  /** A mobile phone number. */
  mobilePhone?: InputMaybe<PhoneInput>;
  /** External client name. */
  name: Scalars['String'];
  /** The shipper's notification preferences. */
  notifications?: InputMaybe<Array<ShipperUserNotificationPreferenceInput>>;
  /** A office phone number. */
  officePhone?: InputMaybe<PhoneInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The shipper's permission. */
  permissions?: InputMaybe<ShipperUserPermissionsInput>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: InputMaybe<Scalars['Boolean']>;
  shipper: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** The teams the user is on */
  teams?: InputMaybe<Array<IdInput>>;
  /** Title of the user */
  title: Scalars['String'];
};

/** Payload returned from the createShipperUser mutation. */
export type CreateShipperUserPayload = {
  __typename?: 'CreateShipperUserPayload';
  record: ShipperUser;
};

export type CreateSingleUseAddressInput = {
  NewSingleUseAddressRequest: CreateSingleUseAddressRequestInput;
};

export type CreateSingleUseAddressRequestInput = {
  EmailAddresses?: InputMaybe<AddressEmailProfileInput>;
  MailingAddress: CreateAddressMailingAddressInput;
  Name: CreateAddressNameInput;
  VoicePhones?: InputMaybe<AddressVoicePhoneProfileInput>;
};

/** Create stamp document generation request input. */
export type CreateStampDocumentGenerationRequestInput = {
  /** Document that needs to be stamped. Supported format: pdf. */
  document: IdInput;
  /** The StampDocumentSignRequest associated with this StampDocumentGenerationRequest. */
  documentSignRequest?: InputMaybe<IdInput>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Stamps that needs to added in the document. */
  stamps: Array<DocumentStampInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createStampDocumentGenerationRequest mutation. */
export type CreateStampDocumentGenerationRequestPayload = {
  __typename?: 'CreateStampDocumentGenerationRequestPayload';
  record: StampDocumentGenerationRequest;
};

/** Create Stamp document sign request input. */
export type CreateStampDocumentSignRequestInput = {
  /** Document assocated with the sign request. */
  document: IdInput;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** Client provided domain for the sign link URL. Defaults to CBMS's importsign domain. */
  domain?: InputMaybe<Scalars['String']>;
  /** The sign request expires after the designated amount of minutes. If not set default is 1 year. */
  expireMinutes?: InputMaybe<Scalars['Int']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The coordinates associated with the document signature. */
  signaturePositions: Array<DocumentSignaturePositionInput>;
  /** Name of officer signing the document. */
  signerName?: InputMaybe<Scalars['String']>;
  /** Title of officer signing the document. */
  signerTitle?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createStampDocumentSignRequest mutation. */
export type CreateStampDocumentSignRequestPayload = {
  __typename?: 'CreateStampDocumentSignRequestPayload';
  record: StampDocumentSignRequest;
};

export type CreateSubjectMatterExpertTeamInput = {
  /** Team's customs broker */
  customsBroker?: InputMaybe<IdInput>;
  /** Additonal input for the SME team and operator user relationship */
  members?: InputMaybe<Array<SubjectMatterExpertTeamMemberInput>>;
  /** The User Team's name */
  name: Scalars['String'];
  operator: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** The payload returned from the createSubjectMatterExpertTeamOperatorUserRelationship mutation. */
export type CreateSubjectMatterExpertTeamOperatorUserRelationshipPayload = {
  __typename?: 'CreateSubjectMatterExpertTeamOperatorUserRelationshipPayload';
  /** The relationship created from linking the Subject Matter Expert Team and Operator User Records. */
  relationship: SubjectMatterExpertTeamOperatorUserRelationship;
};

/** Payload returned from the createSubjectMatterExpertTeam mutation. */
export type CreateSubjectMatterExpertTeamPayload = {
  __typename?: 'CreateSubjectMatterExpertTeamPayload';
  record: SubjectMatterExpertTeam;
};

export type CreateSupplierInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Compliance details for customs purposes. */
  complianceDetails?: InputMaybe<SupplierComplianceDetailsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createSupplier mutation. */
export type CreateSupplierPayload = {
  __typename?: 'CreateSupplierPayload';
  record: Supplier;
};

/** Create Table Filter Input */
export type CreateTableFilterInput = {
  /** Name of the custom filter */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Record table filter is applied on */
  recordTable: RecordType;
  /** Custom table filter search criterias */
  tableFilterCriteria: Array<TableFilterCriterionInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Record table visible columns */
  visibleColumns?: InputMaybe<Array<Scalars['String']>>;
};

/** Payload returned from the createTableFilter mutation. */
export type CreateTableFilterPayload = {
  __typename?: 'CreateTableFilterPayload';
  record: TableFilter;
};

export type CreateTeamInput = {
  /** The Account this Team belongs to. */
  account: IdInput;
  /** Team name */
  name?: InputMaybe<Scalars['String']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createTeam mutation. */
export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  record: Team;
};

/** Create Document template sign request input. */
export type CreateTemplateDocumentSignRequestInput = {
  /** JSON with additional fields defined by the document template. */
  additionalFields?: InputMaybe<Scalars['JSONObject']>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** Client provided domain for the sign link URL. Defaults to CBMS's importsign domain. */
  domain?: InputMaybe<Scalars['String']>;
  /** The sign request expires after the designated amount of minutes. If not set default is 1 year. */
  expireMinutes?: InputMaybe<Scalars['Int']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Document template assocated with the sign request. Defaults to CBMS's default template. */
  template?: InputMaybe<IdOptionalVersionInput>;
};

/** Payload returned from the createTemplateDocumentSignRequest mutation. */
export type CreateTemplateDocumentSignRequestPayload = {
  __typename?: 'CreateTemplateDocumentSignRequestPayload';
  record: TemplateDocumentSignRequest;
};

export type CreateTradeAdvisoryRequestInput = {
  /** The product owner (shipper or forwarder) that owns this trade advisory request */
  owner: IdInput;
  /** List of product IDs for trade advisory consultation */
  products?: InputMaybe<Array<IdInput>>;
  /** Additional details about the trade advisory request */
  requestDetails?: InputMaybe<Scalars['String']>;
  /** Trade advisory request identifier */
  requestId?: InputMaybe<Scalars['String']>;
  /** Selected trade advisory service type */
  selectedService: TradeAdvisoryRequestService;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createTradeAdvisoryRequest mutation. */
export type CreateTradeAdvisoryRequestPayload = {
  __typename?: 'CreateTradeAdvisoryRequestPayload';
  record: TradeAdvisoryRequest;
};

export type CreateTruckerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** A CBP Assigned Importer of Record number. */
  cain?: InputMaybe<Scalars['CbpAssignedNumber']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** A point of contact for trucker dispatch */
  dispatchPointOfContact?: InputMaybe<PointOfContactInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<Scalars['SCACCode']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createTrucker mutation. */
export type CreateTruckerPayload = {
  __typename?: 'CreateTruckerPayload';
  record: Trucker;
};

export type CreateUkCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['UkEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the createUkCustomsBroker mutation. */
export type CreateUkCustomsBrokerPayload = {
  __typename?: 'CreateUkCustomsBrokerPayload';
  record: UkCustomsBroker;
};

export type CreateUkHsInput = {
  /** Effective descriptions */
  descriptions?: InputMaybe<Array<HsDescriptionInput>>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: InputMaybe<HsNumberType>;
  /** Main duty rates */
  mainDutyRates?: InputMaybe<Array<HsRateInput>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createUkHs mutation. */
export type CreateUkHsPayload = {
  __typename?: 'CreateUkHsPayload';
  record: UkHs;
};

/** Create UsCargoRelease document generation request input. */
export type CreateUsCargoReleaseDocumentGenerationRequestInput = {
  /** Cargo arrival date. */
  arrivalTime?: InputMaybe<Scalars['DateTime']>;
  /** Bill disposition associated with the cargo release. */
  billDispositions: Array<UsCargoReleaseBillDispositionInfoInput>;
  /** Broker associated with cargo release. */
  broker: UsCargoReleaseBrokerInfoInput;
  /** Carrier code (SCAC) associated with the cargo release. */
  carrierCode: Scalars['SCACCode'];
  /** Entry information associated with the cargo release. */
  entry: UsCargoReleaseEntryInfoInput;
  /** FirmsCode associated with the cargo release. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** Importer associated with cargo release. */
  importer?: InputMaybe<UsCargoReleaseImporterInfoInput>;
  /** Inlt shipment id associated with the cargo release. */
  inltShipmentId?: InputMaybe<Scalars['String']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Release disposition associated with the cargo release. */
  releaseDispositions: Array<UsCargoReleaseDispositionInfoInput>;
  /** Shipment associated with cargo release */
  shipment: UsCargoReleaseShipmentInfoInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** The shipment's voyage, flight, or trip number associated with the cargo release. */
  tripNumber?: InputMaybe<Scalars['String']>;
  /** The name of the vessel associated with the cargo release. */
  vesselName?: InputMaybe<Scalars['String']>;
};

/** Payload returned from the createUsCargoReleaseDocumentGenerationRequest mutation. */
export type CreateUsCargoReleaseDocumentGenerationRequestPayload = {
  __typename?: 'CreateUsCargoReleaseDocumentGenerationRequestPayload';
  record: UsCargoReleaseDocumentGenerationRequest;
};

/** Create US Cbp5106 document generation request input. */
export type CreateUsCbp5106DocumentGenerationRequestInput = {
  /** IOR addresses */
  addresses: AddressesInput;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: InputMaybe<UsCbp5106BankDetailsInput>;
  /** Description of IOR's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructure>;
  /** The mailing address type. */
  cbpMailingAddressType: UsCbp5106AddressTypeInput;
  /** The physical address type. */
  cbpPhysicalAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** A trade name, trading name, or business name is a pseudonym used by companies that do not operate under their registered company name. */
  doingBusinessAs?: InputMaybe<Scalars['String']>;
  /** IOR DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** IOR email */
  email?: InputMaybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: InputMaybe<UsCbp5106EntriesPerYearCode>;
  /** IOR web site */
  fax?: InputMaybe<Scalars['String']>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: InputMaybe<Array<UsCbp5106IndividualInput>>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: InputMaybe<Scalars['String']>;
  /** IOR name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** IOR phone number */
  phone?: InputMaybe<PhoneInput>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: InputMaybe<Array<UsCbpImporterProgramCode>>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: InputMaybe<Array<UsCbp5106RelatedBusinessInput>>;
  /** Date on which this document is signed */
  signerDate: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
  /** IOR web site */
  website?: InputMaybe<Scalars['String']>;
};

/** Payload returned from the createUsCbp5106DocumentGenerationRequest mutation. */
export type CreateUsCbp5106DocumentGenerationRequestPayload = {
  __typename?: 'CreateUsCbp5106DocumentGenerationRequestPayload';
  record: UsCbp5106DocumentGenerationRequest;
};

/** Create US Cbp7501 document generation request input. */
export type CreateUsCbp7501DocumentGenerationRequestInput = {
  /** The 1-digit code representing bond type. */
  bondType?: InputMaybe<Scalars['String']>;
  /** The broker associated with the cbp 7501. */
  broker: UsCbp7501BrokerInfoInput;
  /** Consignee related fields required to generate UsCbp7501 document. */
  consignee: UsCbp7501ConsigneeInfoInput;
  /** Entry details associated with the cbp 7501. */
  entry: UsCbp7501EntryInfoInput;
  /** Export information associated with cbp 7501. */
  export: UsCbp7501ExportInfoInput;
  /** Facilities Information and Resources Management code. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** 'Schedule K' foreign port for the merchandise arriving by vessel. */
  foreignPortOfLading?: InputMaybe<Scalars['String']>;
  /** Where the entry summary serves as entry/entry summary, record the pier or site where the goods are available for examination.  For air shipments, record the flight number.  Where the Facilities Information and Resources Management (FIRMS) codes are available, they must be used in lieu of pier/site. */
  goNumber?: InputMaybe<Scalars['String']>;
  /** Import information associated with cbp 7501. */
  import: UsCbp7501ImportInfoInput;
  /** The importer associated with the cbp 7501. */
  importer: UsCbp7501ImporterInfoInput;
  /** In-Bond information associated with cbp 7501. */
  inBond?: InputMaybe<UsCbp7501InBondInfoInput>;
  /** Line items associated with cbp 7501. */
  invoices?: InputMaybe<Array<UsCbp7501InvoiceInfoInput>>;
  /** Whether the entry has been accepted by CBP. Considered it draft if not set. */
  isCertified?: InputMaybe<Scalars['Boolean']>;
  /** Manifest information associated with cbp 7501. */
  manifests: Array<UsCbp7501ManifestInfoInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Signing information associated with the cbp 7501. */
  sign: UsCbp7501SignInfoInput;
  /** Date on which the entry summary is filed with CBP. */
  summaryTime?: InputMaybe<Scalars['DateTime']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. */
  suretyNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Summary of duty, tax, and fee of all the line items. */
  totalCosts: UsCbp7501FeeInfoInput;
};

/** Payload returned from the createUsCbp7501DocumentGenerationRequest mutation. */
export type CreateUsCbp7501DocumentGenerationRequestPayload = {
  __typename?: 'CreateUsCbp7501DocumentGenerationRequestPayload';
  record: UsCbp7501DocumentGenerationRequest;
};

/** Create US Cbp7512 document generation request input. */
export type CreateUsCbp7512DocumentGenerationRequestInput = {
  /** The associated bills of lading for this CbpInBond */
  bills?: InputMaybe<Array<UsCbp7512BillInfoInput>>;
  /** The carrier information for the CbpInBond */
  carrier?: InputMaybe<UsCbp7512CarrierInfoInput>;
  /** The type of in-bond movement */
  cbpInBondEntryType?: InputMaybe<CbpInBondEntryType>;
  /** The INLT CBP in-bond Number identifying the in-bond movement, a 9 digit number made up of an 8 digit "base" number followed by a "check" digit */
  cbpInBondNumber?: InputMaybe<Scalars['InltUsInBondNumber']>;
  /** The UsConsignee associated with the CbpInBond. Returns the latest version. */
  consignee?: InputMaybe<UsCbp7512ConsigneeInfoInput>;
  /** The port of destination for a T&E ‘62’ or IE ‘63’ entries. */
  foreignPortOfDestination?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
  /** The FIRMS code representing where the goods are at right now */
  goodsNowAt?: InputMaybe<Scalars['FirmsCode']>;
  /** Importer related fields required to generate UsCbp7512 document. */
  importer?: InputMaybe<UsCbp7512ImporterInfoInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The previous CbpInBond information */
  previousCbpInBond?: InputMaybe<UsCbp7512PreviousCbpInBondInfoInput>;
  /** Shipment related fields required to generate UsCbp7512 document. */
  shipment?: InputMaybe<UsCbp7512ShipmentInfoInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The port of termination for an IT ‘61’ entry, or the port of exportation for a T&E ‘62’ entry, or the port of arrival for an IT ‘63’entry. */
  usPortOfDestination?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The value of the goods in whole dollars of the in-bond movement. Twenty dollars per kilo may be used if the value is unknown. */
  valueOfGoods?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the createUsCbp7512DocumentGenerationRequest mutation. */
export type CreateUsCbp7512DocumentGenerationRequestPayload = {
  __typename?: 'CreateUsCbp7512DocumentGenerationRequestPayload';
  record: UsCbp7512DocumentGenerationRequest;
};

/** The payload returned from triggering the Transaction. */
export type CreateUsConsigneeCbp5106Payload = {
  __typename?: 'CreateUsConsigneeCbp5106Payload';
  /** The Transaction. */
  transaction: CreateUsConsigneeCbp5106Transaction;
};

/** The US CBP ABI transaction for adding a 5106 profile of a US Consignee. */
export type CreateUsConsigneeCbp5106Transaction = Record & UsConsigneeCbpTransaction & {
  __typename?: 'CreateUsConsigneeCbp5106Transaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consignee */
  usConsignee: UsConsignee;
  /** The record's version */
  version: Scalars['Int'];
};

export type CreateUsConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: InputMaybe<UsCbp5106BankDetailsInput>;
  /** A description of the Importer's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructure>;
  /** Error details of the latest US CBP 5106 rejection. */
  cbp5106RejectionReasons?: InputMaybe<Array<UsCbp5106RejectedReasonInput>>;
  /** The mailing address type. */
  cbpMailingAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** If an IOR number is requested from CBP, set it to true */
  cbpNumberHelp?: InputMaybe<Scalars['Boolean']>;
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons?: InputMaybe<Array<UsIorCbpAssignedNumberReason>>;
  /** The physical address type. */
  cbpPhysicalAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** The US IOR's status with CBP. */
  cbpStatus?: InputMaybe<UsIorCbpStatus>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: InputMaybe<UsCbp5106EntriesPerYearCode>;
  /** Business establishment details on the Importer's US CBP 5106 form. */
  establishment?: InputMaybe<UsCbp5106EstablishmentDetailsInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: InputMaybe<Array<UsCbp5106IndividualInput>>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: InputMaybe<Scalars['String']>;
  /** Party name */
  name: Scalars['String'];
  /** An officer of the company authorized to assign power of attorney. */
  officer?: InputMaybe<PointOfContactInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: InputMaybe<Array<UsCbpImporterProgramCode>>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: InputMaybe<Array<UsCbp5106RelatedBusinessInput>>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the createUsConsignee mutation. */
export type CreateUsConsigneePayload = {
  __typename?: 'CreateUsConsigneePayload';
  record: UsConsignee;
};

export type CreateUsConsumptionEntryInput = {
  /** Accelerate the liquidation of the entry. */
  acceleratedLiquidation?: InputMaybe<Scalars['Boolean']>;
  /** The reason for amending the entry. */
  amendmentReason?: InputMaybe<UsConsumptionEntryAmendmentReason>;
  /** Arrival information */
  arrival?: InputMaybe<UsConsumptionEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<UsConsumptionEntryBadge>>;
  /** US Customs Broker associated with this entry. */
  broker: UsConsumptionEntryBrokerInput;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  /** US Buyer associated with this entry. */
  buyer?: InputMaybe<UsConsumptionEntryBuyerInput>;
  /** Provided reason for canceling the entry with CBP. */
  cbpCancellationReason?: InputMaybe<DeleteUsCbpEntryReleaseReason>;
  cbpCharges?: InputMaybe<UsCbpEntryChargesInput>;
  cbpLiquidatedCharges?: InputMaybe<UsCbpEntryLiquidatedChargesInput>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** Indicates census warning status of the US entry summary. */
  censusHeaderStatus?: InputMaybe<UsCbpEntryCensusHeaderStatusCode>;
  /** CBP collection date */
  collectionDate?: InputMaybe<Scalars['String']>;
  /** CBP collection status */
  collectionStatus?: InputMaybe<Scalars['String']>;
  /** US Consignee associated with this entry. */
  consignee?: InputMaybe<UsConsumptionEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Indicates the control status of the US entry summary. */
  controlStatus?: InputMaybe<UsCbpEntryControlStatusCode>;
  /** Conveyance information. */
  conveyance: UsConsumptionEntryConveyanceInput;
  /** CBP entry Daily Statement. */
  dailyStatement?: InputMaybe<UsCbpEntryDailyStatementInput>;
  /** Departure information. */
  departure?: InputMaybe<UsConsumptionEntryDepartureInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** Exam details associated with the entry. */
  exam?: InputMaybe<UsConsumptionEntryExamInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Indicates the filing timeliness of the US entry summary. */
  filingTimeliness?: InputMaybe<UsCbpEntryFilingTimeliness>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Indicates whether immediate delivery is enabled for the entry. */
  immediateDeliveryIndicator?: InputMaybe<UsCbpEntryReleaseImmediateDelivery>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<UsConsumptionEntryCommercialInvoiceInput>>;
  /** Commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines */
  invoicesReference?: InputMaybe<UsConsumptionEntryCommercialInvoicesReferenceInput>;
  /** US IOR associated with this entry. */
  ior?: InputMaybe<UsConsumptionEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine if CBMS authorized payment within 10 business days of most recent cargo release date */
  isTimelyPayment?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<UsConsumptionEntryMasterBillInput>>;
  /** How the imported merchandise will be used. */
  merchandiseUse?: InputMaybe<UsCbpEntryMerchandiseUse>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** CBP entry payment type */
  paymentType?: InputMaybe<Scalars['UsCbpEntryPaymentType']>;
  /** CBP entry Periodic Monthly Statement. */
  periodicMonthlyStatement?: InputMaybe<UsCbpEntryPeriodicMonthlyStatementInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDispositions?: InputMaybe<Array<UsCbpEntryPgaDispositionInput>>;
  /** The placement type for UsConsumptionEntry */
  placementType?: InputMaybe<PlacementType>;
  /** Purchase order (PO) number(s) associated with the work order. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Date by which other regulatory clearances are completed. For example, FCC for Devices shipments. This impacts the work order deadline and entry submission. */
  regulatoryReadyDate?: InputMaybe<Scalars['DateTime']>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: InputMaybe<Scalars['Date']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDispositions?: InputMaybe<Array<UsCbpEntryReleaseDispositionInput>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReasons?: InputMaybe<Array<UsCbpEntryReleaseRejectionReasonInput>>;
  /** Replacement number associated with delete release from cbp */
  releaseReplacementNumber?: InputMaybe<Scalars['String']>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: InputMaybe<UsCbpEntryReleaseStatus>;
  /** US Entry single transaction bond details. */
  singleTransactionBond?: InputMaybe<UsEntrySingleTransactionBondInput>;
  /** Indicates how to release split shipments. */
  splitShipmentReleaseMethod?: InputMaybe<UsCbpSplitShipmentReleaseMethod>;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotification?: InputMaybe<UsCbpEntryNotificationInput>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReasons?: InputMaybe<Array<UsCbpEntrySummaryRejectionReasonInput>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<UsCbpEntrySummaryStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to US CBP. */
  totalAssist?: InputMaybe<Scalars['UsDollars']>;
  /** Sum of all invoice product lines count, useful in task estimation. */
  totalInvoiceLineCount?: InputMaybe<Scalars['Int']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the createUsConsumptionEntry mutation. */
export type CreateUsConsumptionEntryPayload = {
  __typename?: 'CreateUsConsumptionEntryPayload';
  record: UsConsumptionEntry;
};

/** The payload returned from triggering the Transaction. */
export type CreateUsConsumptionEntryReleaseCbpPayload = {
  __typename?: 'CreateUsConsumptionEntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: CreateUsConsumptionEntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to create a US Consumption Entry Release, CATAIR appCode: SE/SX. */
export type CreateUsConsumptionEntryReleaseCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'CreateUsConsumptionEntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

export type CreateUsCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein: Scalars['EmployeeIdentificationNumber'];
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes */
  filerCode: Scalars['UsCbpFilerCode'];
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the createUsCustomsBroker mutation. */
export type CreateUsCustomsBrokerPayload = {
  __typename?: 'CreateUsCustomsBrokerPayload';
  record: UsCustomsBroker;
};

/** The payload returned from triggering the Transaction. */
export type CreateUsDrawbackClaimCbpPayload = {
  __typename?: 'CreateUsDrawbackClaimCbpPayload';
  /** The Transaction. */
  transaction: CreateUsDrawbackClaimCbpTransaction;
};

/** The US CBP ABI transaction to create a US Drawback Claim, CATAIR appcode: DE/DX. */
export type CreateUsDrawbackClaimCbpTransaction = Record & UsDrawbackClaimCbpTransaction & {
  __typename?: 'CreateUsDrawbackClaimCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Drawback Claim */
  usDrawbackClaim: UsDrawbackClaim;
  /** The record's version */
  version: Scalars['Int'];
};

/** Create Us Drawback Claim document generation request input. */
export type CreateUsDrawbackClaimDocumentGenerationRequestInput = {
  /** Broker associated with US Drawback Claim. */
  bond: UsDrawbackDocumentClaimBondInput;
  /** Broker associated with US Drawback Claim. */
  broker: UsDrawbackClaimBrokerInfoInput;
  /** List of rejection reasons */
  cbpRejectionReasons?: InputMaybe<Array<UsDrawbackClaimRejectionReasonInput>>;
  /** Drawback Claim CBP Status */
  cbpStatus?: InputMaybe<UsDrawbackClaimDocumentStatus>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: InputMaybe<Scalars['String']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Date on which the Drawback Claim Response is received. */
  responseReceiveDate?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createUsDrawbackClaimDocumentGenerationRequest mutation. */
export type CreateUsDrawbackClaimDocumentGenerationRequestPayload = {
  __typename?: 'CreateUsDrawbackClaimDocumentGenerationRequestPayload';
  record: UsDrawbackClaimDocumentGenerationRequest;
};

export type CreateUsDrawbackClaimInput = {
  /** Export Entries should match the CBP Data. */
  TFTEAExportDestroyArticles?: InputMaybe<Array<UsDrawbackClaimExportDestroyArticleInput>>;
  /** Requesting Accelerated Payment and Bond is required. If filing a Drawback claim with the Accelerated Payment Request Indicator, please be informed that accelerated refunds will be paid on the first successfully accepted version of the claim without bond related errors. If updates are made to the claimed amount after the first successfully accepted version, the updated amount will be paid upon liquidation. */
  acceleratedPayment?: InputMaybe<Scalars['Boolean']>;
  /** Bond Details */
  bond?: InputMaybe<UsDrawbackClaimBondInput>;
  /** An indication that the bond has been waived in accordance with regulation. */
  bondWaiverIndicator?: InputMaybe<Scalars['Boolean']>;
  /** A code explaining the reason the bond has been waived in accordance with regulation(s). */
  bondWaiverReasonCode?: InputMaybe<Scalars['UsBondWaiverReasonCode']>;
  /** US Customs Broker associated with this entry. */
  broker?: InputMaybe<UsDrawbackClaimBrokerInput>;
  /** The broker reference number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  /** List of rejection reasons */
  cbpRejectionReasons?: InputMaybe<Array<UsCbpDrawbackClaimRejectionReasonInput>>;
  /** Drawback Claim CBP Status */
  cbpStatus?: InputMaybe<UsCbpDrawbackClaimStatus>;
  /** Claimant */
  claimant?: InputMaybe<UsIorNumberInput>;
  /** Drawback Claim reference for Imports, TFTEAExportDestroyArticles and cbpRejectionReasons. */
  drawbackClaimReference?: InputMaybe<DrawbackClaimReferenceInput>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: InputMaybe<Scalars['String']>;
  /** The drawback provision code. */
  drawbackProvision?: InputMaybe<Scalars['UsDrawbackProvisionCode']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Import Entries should match the CBP Data. */
  imports?: InputMaybe<Array<UsDrawbackClaimImportInput>>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** For Core and TFTEA Drawback, the approval letter must be provided or provide the date of the OTW application submission to CBP on company letterhead and upload it to DIS. Use the following format: “The OTW application was filed on [date] at the port of [insert port name].” */
  oneTimeWaiverIndicator?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Waiver Prior Notice. */
  waiverPriorNotice?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the createUsDrawbackClaim mutation. */
export type CreateUsDrawbackClaimPayload = {
  __typename?: 'CreateUsDrawbackClaimPayload';
  record: UsDrawbackClaim;
};

export type CreateUsHtsInput = {
  /** May be subject to anti-dumping duties. */
  ad?: InputMaybe<Scalars['Boolean']>;
  /** Anti-dumping and Countervailing duty (ADD/CVD) active case Ids */
  adCvdCases?: InputMaybe<Array<IdInput>>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additional?: InputMaybe<Array<AdditionalHtsInput>>;
  /** Additional Tariff may be required. */
  additionalHTS?: InputMaybe<Scalars['Boolean']>;
  /** The additional HTS number that may be required. */
  additionalHtsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additionalHtssApplicable?: InputMaybe<Array<AdditionalHtsInput>>;
  /** The type of HTS when used as an additional tariff. */
  additionalTariffType?: InputMaybe<AdditionalHtsType>;
  /** The effective end date provided by ACE CATAIR. It may differ from the top-level endDate. */
  cbpEndDate?: InputMaybe<Scalars['Date']>;
  /** The effective start date provided by ACE CATAIR. It may differ from the top-level startDate. */
  cbpStartDate?: InputMaybe<Scalars['Date']>;
  /** Compliance notes */
  complianceNotes?: InputMaybe<Array<HtsComplianceNoteInput>>;
  /** May be subject to countervailing duties. */
  cv?: InputMaybe<Scalars['Boolean']>;
  /** Longer description of Tariff. */
  description?: InputMaybe<Scalars['String']>;
  /** Descriptions of Tariff. */
  descriptions?: InputMaybe<Array<HtsDescriptionInput>>;
  /** Duty code */
  duty?: InputMaybe<Scalars['String']>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Fees required, also used for taxes. */
  fees?: InputMaybe<Array<HtsFeeInput>>;
  /** Is HS number fully qualified. */
  fullyQualified?: InputMaybe<Scalars['Boolean']>;
  /** Country of origin codes not permitted to use with the Generalized System of Preferences SPI (A*). */
  gspExcluded?: InputMaybe<Array<Scalars['String']>>;
  /** License data potentially required on an entry. */
  license?: InputMaybe<HtsLicenseInput>;
  /** License code required on Line. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** Column one rate object used to calculate duty that may apply to HS during different time intervals. */
  mainDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Partner Government Agency data potentially required on an entry. */
  pga?: InputMaybe<Array<PgaRequirementInput>>;
  /** 7 digit US Principal ADD and CVD cases */
  principalAdCvdCases?: InputMaybe<Array<IdInput>>;
  /** May be subject to a quota. */
  quota?: InputMaybe<Scalars['Boolean']>;
  /** Rate object used to calculate duty. */
  rate?: InputMaybe<HtsRateInput>;
  /** Restrictions on HTS number usage. */
  restriction?: InputMaybe<HtsRestrictionInput>;
  /** Column two rate object used to calculate duty that may apply to HS during different time intervals. */
  secondaryDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Section 301 Exclusion */
  section301Exclusion?: InputMaybe<Section301ExclusionInput>;
  /** Special Program Indicators available to use, subject to country of origin. */
  spi?: InputMaybe<Array<SpiInput>>;
  /** Special rates based on different SPIs. */
  spiRates?: InputMaybe<Array<HtsSpiRateInput>>;
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Description of Tariff. */
  text?: InputMaybe<Scalars['String']>;
  /** Textile code. */
  textile?: InputMaybe<Scalars['String']>;
  /** Section 301 (Trump Tariffs) list number. */
  trumpList?: InputMaybe<Scalars['TrumpList']>;
  /** Truncated description of Tariff. */
  truncatedDescription?: InputMaybe<Scalars['String']>;
  /** Required unit of measure reporting quantities. */
  uom?: InputMaybe<Array<Scalars['String']>>;
};

/** Payload returned from the createUsHts mutation. */
export type CreateUsHtsPayload = {
  __typename?: 'CreateUsHtsPayload';
  record: UsHts;
};

export type CreateUsInBondInput = {
  /** The arrival information */
  arrival?: InputMaybe<UsInBondArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<UsInBondBadge>>;
  /** US Customs Broker associated with this UsInBond. */
  broker: UsInBondBrokerInput;
  /** Consignee associated with this UsInBond. */
  consignee?: InputMaybe<UsInBondConsigneeInput>;
  /** The container numbers for the UsInBond */
  containerNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** The conveyance information */
  conveyance?: InputMaybe<UsInBondConveyanceInput>;
  /** The departure information */
  departure?: InputMaybe<UsInBondDepartureInput>;
  /** The date of entry for the UsInBond */
  entryDate?: InputMaybe<Scalars['Date']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** IOR associated with this UsInBond. */
  ior?: InputMaybe<UsInBondIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the shipment. */
  masterBills?: InputMaybe<Array<UsInBondMasterBillInput>>;
  /** The mode of transport for the shipment */
  modeOfTransport: ModeOfTransport;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createUsInBond mutation. */
export type CreateUsInBondPayload = {
  __typename?: 'CreateUsInBondPayload';
  record: UsInBond;
};

export type CreateUsIorActivationInput = {
  /** US Customs Broker associated with the activation. */
  broker: UsIorActivationBrokerInput;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** US IOR to be activated. */
  ior?: InputMaybe<UsIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createUsIorActivation mutation. */
export type CreateUsIorActivationPayload = {
  __typename?: 'CreateUsIorActivationPayload';
  record: UsIorActivation;
};

/** The payload returned from triggering the Transaction. */
export type CreateUsIorCbp5106Payload = {
  __typename?: 'CreateUsIorCbp5106Payload';
  /** The Transaction. */
  transaction: CreateUsIorCbp5106Transaction;
};

/** The US CBP ABI transaction for adding a 5106 profile of a US IOR. */
export type CreateUsIorCbp5106Transaction = Record & UsIorCbpTransaction & {
  __typename?: 'CreateUsIorCbp5106Transaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US IOR */
  usIor: UsIor;
  /** The record's version */
  version: Scalars['Int'];
};

export type CreateUsIorContinuousBondRequestInput = {
  /** The amount of the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  bondAmount?: InputMaybe<Scalars['UsDollars']>;
  /** The date that the bond can start to be used for US customs entry filings. */
  bondEffectiveDate?: InputMaybe<Scalars['Date']>;
  /** The unique number identifying the usIor's customs bond. */
  bondNumber?: InputMaybe<Scalars['String']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  bondSuretyCode?: InputMaybe<Scalars['String']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Estimated duties, taxes, and fees paid in the next 12 months (used to determine if it will exceed $500,000). */
  nextYearShippingValueEstimate?: InputMaybe<Scalars['UsDollars']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Estimated duties, taxes, and fees paid in the pervious 12 months (used to determine if it will exceed $500,000). */
  previousYearShippingValueEstimate?: InputMaybe<Scalars['UsDollars']>;
  /** A short description of each product being imported. */
  productDescriptions?: InputMaybe<Array<Scalars['String']>>;
  /** The country codes from which goods originate. */
  productOriginCountryCodes?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** The ARN of the dacia schedule for the renewal. The `cancelUsIorContinuousBondRequestRenewal` mutation must be used to cancel it. */
  renewalScheduleArn?: InputMaybe<Scalars['String']>;
  /** The amount requested for the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  requestedBondAmount?: InputMaybe<Scalars['UsDollars']>;
  /** Bond risk details for the continuous bond */
  risk?: InputMaybe<UsIorContinuousBondRequestBondRiskInput>;
  /** The Shipper associated with the UsIorContinuousBondRequest. Returns the latest version. */
  shipper: IdInput;
  /** Reference number provided by the surety and sent back in the BS ABI message. This can be used to tie this ABI message to the initial bond request. */
  suretyReferenceNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The UsIor associated with the UsIorContinuousBondRequest. Returns the latest version. */
  usIor: IdInput;
  /** Whether incentive pricing should be used on this continuous bond */
  useIncentivePricing?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the createUsIorContinuousBondRequest mutation. */
export type CreateUsIorContinuousBondRequestPayload = {
  __typename?: 'CreateUsIorContinuousBondRequestPayload';
  record: UsIorContinuousBondRequest;
};

export type CreateUsIorInput = {
  /** Indicate whether the filer is paying duties to U.S CBP using ACH(Automated Clearinghouse) Credit method or not. */
  achCredit?: InputMaybe<Scalars['Boolean']>;
  /** Activation status of US IOR. */
  activationStatus?: InputMaybe<UsIorActivationStatus>;
  /** Activation time of US IOR. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: InputMaybe<UsCbp5106BankDetailsInput>;
  /** Information collected when the importer applies for a bond through Amazon. */
  bondApplicationInformation?: InputMaybe<BondApplicationInformationInput>;
  /** A description of the Importer's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructure>;
  /** Importer business website */
  businessWebsite?: InputMaybe<Scalars['String']>;
  /** Error details of the latest US CBP 5106 rejection. */
  cbp5106RejectionReasons?: InputMaybe<Array<UsCbp5106RejectedReasonInput>>;
  /** The mailing address type. */
  cbpMailingAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** If an IOR number is requested from CBP, set it to true */
  cbpNumberHelp?: InputMaybe<Scalars['Boolean']>;
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons?: InputMaybe<Array<UsIorCbpAssignedNumberReason>>;
  /** The physical address type. */
  cbpPhysicalAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** The US IOR's status with CBP. */
  cbpStatus?: InputMaybe<UsIorCbpStatus>;
  /** Details for manifest confidentiality */
  confidentiality?: InputMaybe<UsIorConfidentialityInput>;
  /** A list of the IOR's continuous customs bonds. */
  continuousBonds?: InputMaybe<UsContinuousCustomsBondsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Identifier for DocReadiness status of Importer in ShipDocs system */
  docReadinessId?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: InputMaybe<UsCbp5106EntriesPerYearCode>;
  /** US IOR entry summary email addresses. */
  entrySummaryContactEmails?: InputMaybe<Array<Scalars['Email']>>;
  /** Business establishment details on the Importer's US CBP 5106 form. */
  establishment?: InputMaybe<UsCbp5106EstablishmentDetailsInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Is it the first time the Importer of Record has been used in the US? */
  firstTimeStatus?: InputMaybe<UsIorFirstTimeStatus>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The linked Importer. */
  importer?: InputMaybe<IdInput>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: InputMaybe<Array<UsCbp5106IndividualInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Indicate whether the IOR is a resident importer. */
  isResident?: InputMaybe<Scalars['Boolean']>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: InputMaybe<Scalars['Boolean']>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: InputMaybe<Scalars['String']>;
  /** Party name */
  name: Scalars['String'];
  /** Non resident signing officer email. */
  nrccOfficerEmail?: InputMaybe<Scalars['Email']>;
  /** An officer of the company authorized to assign power of attorney. */
  officer?: InputMaybe<PointOfContactInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber?: InputMaybe<Scalars['UsCbpPayerUnitNumber']>;
  /** Payment terms offered to US IOR */
  paymentTerms?: InputMaybe<UsIorPaymentTerms>;
  /** A US IOR individual's personal effects information. */
  personalEffects?: InputMaybe<UsIorPersonalEffectsInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** Time at which the PMS was activated. This is not null only when pmsRequestedTime is not null and pmsStatus === ACTIVE */
  pmsActivationTime?: InputMaybe<Scalars['DateTime']>;
  /** Time at which the PMS activation Request was sent. */
  pmsRequestedTime?: InputMaybe<Scalars['DateTime']>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: InputMaybe<UsIorPmsStatus>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: InputMaybe<POAMethod>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The US IORs preferred payment method on an entry */
  preferredCbpEntryPaymentMethod?: InputMaybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: InputMaybe<Array<UsCbpImporterProgramCode>>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: InputMaybe<Array<UsCbp5106RelatedBusinessInput>>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  /** Source channel identifier */
  sourceChannel?: InputMaybe<SourceChannel>;
  /** Source portal identifier */
  sourcePortal?: InputMaybe<SourcePortal>;
  /** The status of a US Ior e.g. ACTIVE, CANCELED */
  status?: InputMaybe<UsIorStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
  /** Us customs broker id assosiated with this usIor */
  usCustomsBroker?: InputMaybe<IdInput>;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCodes?: InputMaybe<Array<Scalars['VendorCode']>>;
};

/** Payload returned from the createUsIor mutation. */
export type CreateUsIorPayload = {
  __typename?: 'CreateUsIorPayload';
  record: UsIor;
};

/** The payload returned from triggering the Transaction. */
export type CreateUsIsfCbpPayload = {
  __typename?: 'CreateUsIsfCbpPayload';
  /** The Transaction. */
  transaction: CreateUsIsfCbpTransaction;
};

/** The US CBP ABI transaction to create a US ISF, CATAIR appcode: SF/SN. */
export type CreateUsIsfCbpTransaction = Record & UsIsfCbpTransaction & {
  __typename?: 'CreateUsIsfCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US ISF */
  usIsf: UsIsf;
  /** The record's version */
  version: Scalars['Int'];
};

export type CreateUsIsfInput = {
  /** Estimated time of shipment arrival */
  arrivalTime?: InputMaybe<Scalars['Date']>;
  /** Booking party when file ISF 5 */
  bookingParty?: InputMaybe<UsIsfBookingPartyInput>;
  /** US Customs Broker associated with this ISF. */
  broker: UsIsfBrokerInput;
  /** The ISF buyer */
  buyer?: InputMaybe<UsIsfBuyerInput>;
  /** Isf status from Cbp */
  cbpStatus?: InputMaybe<UsIsfCbpStatus>;
  /** CBP type code includes ISF type and shipment type */
  cbpTypeCode?: InputMaybe<UsIsfCbpTypeCodeInput>;
  /** The ISF consignee */
  consignee?: InputMaybe<UsIsfConsigneeInput>;
  /** The ISF consolidator */
  consolidator?: InputMaybe<UsIsfConsolidatorInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Informal shipment details */
  informal?: InputMaybe<UsIsfInformalDetailsInput>;
  /** Us IOR associated with this ISF */
  ior?: InputMaybe<UsIsfIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Isf number */
  isfNumber?: InputMaybe<Scalars['UsIsfNumber']>;
  /** CBP ISF type code */
  isfType?: IsfType;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Manufactures associated with this isf */
  manufacturers?: InputMaybe<Array<UsIsfManufacturerInput>>;
  /** Masterbill information */
  masterBills?: InputMaybe<Array<UsIsfMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Delivery place of the shipment, this is needed for ISF-5 */
  placeOfDelivery?: InputMaybe<Scalars['String']>;
  /** Code for port of unlading, this is needed for ISF-5 */
  portOfUnladingCode?: InputMaybe<Scalars['String']>;
  /** The ISF sellers */
  sellers?: InputMaybe<Array<UsIsfSellerInput>>;
  /** The ISF ship to party */
  shipTo?: InputMaybe<UsIsfShipToInput>;
  /** CBP ISF Shipment type code */
  shipmentTypeCode?: InputMaybe<UsIsfShipmentTypeCode>;
  /** US ISF single transaction bond details. */
  singleTransactionBond?: InputMaybe<UsIsfSingleTransactionBondInput>;
  /** The ISF stuffing location */
  stuffingLocation?: InputMaybe<UsIsfStuffingLocationInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createUsIsf mutation. */
export type CreateUsIsfPayload = {
  __typename?: 'CreateUsIsfPayload';
  record: UsIsf;
};

export type CreateUsPostSummaryCorrectionInput = {
  /** Accelerate the liquidation of the entry. */
  acceleratedLiquidation?: InputMaybe<Scalars['Boolean']>;
  /** The reason for amending the entry. */
  amendmentReason?: InputMaybe<UsPostSummaryCorrectionAmendmentReason>;
  /** Arrival information */
  arrival?: InputMaybe<UsPostSummaryCorrectionArrivalInput>;
  /** US Customs Broker associated with this entry. */
  broker: UsPostSummaryCorrectionBrokerInput;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  cbpCharges?: InputMaybe<UsCbpEntryChargesInput>;
  cbpLiquidatedCharges?: InputMaybe<UsCbpEntryLiquidatedChargesInput>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** US Consignee associated with this entry. */
  consignee?: InputMaybe<UsPostSummaryCorrectionConsigneeInput>;
  /** Conveyance information. */
  conveyance: UsPostSummaryCorrectionConveyanceInput;
  /** Departure information. */
  departure?: InputMaybe<UsPostSummaryCorrectionDepartureInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** A text line of the PSC filing explanation. */
  explanation?: InputMaybe<Scalars['String']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** A code that identifies the reason that the submitted header data is being changed for a PSC */
  headerReasons?: InputMaybe<Array<Scalars['UsPostSummaryCorrectionHeaderReason']>>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<UsPostSummaryCorrectionCommercialInvoiceInput>>;
  /** US IOR associated with this entry. */
  ior?: InputMaybe<UsPostSummaryCorrectionIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<UsPostSummaryCorrectionMasterBillInput>>;
  /** How the imported merchandise will be used. */
  merchandiseUse?: InputMaybe<UsCbpEntryMerchandiseUse>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the work order. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** The Shipper associated with the Group of Work Orders. Returns the latest version. */
  shipper?: InputMaybe<IdInput>;
  /** US Entry single transaction bond details. */
  singleTransactionBond?: InputMaybe<UsEntrySingleTransactionBondInput>;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotification?: InputMaybe<UsCbpEntryNotificationInput>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReasons?: InputMaybe<Array<UsCbpEntrySummaryRejectionReasonInput>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<UsCbpEntrySummaryStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to US CBP. */
  totalAssist?: InputMaybe<Scalars['UsDollars']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the createUsPostSummaryCorrection mutation. */
export type CreateUsPostSummaryCorrectionPayload = {
  __typename?: 'CreateUsPostSummaryCorrectionPayload';
  record: UsPostSummaryCorrection;
};

/** Represents a US CBP Anti-Dumping or Countervailing Duty Case. */
export type CreateUsPrincipalAdCvdCaseInput = {
  /** The country of origin where the Case applies */
  countryCode: Scalars['CountryCode'];
  /** Full 10-digit case numbers */
  fullCaseNumbers?: InputMaybe<Array<CaseReferenceInput>>;
  /** Official Case name */
  name?: InputMaybe<Scalars['String']>;
  /** Principal AD/CVD Case number */
  principalCaseNumber: Scalars['UsPrincipalCaseNumber'];
  /** Link to the scope decision of the case */
  scopeUrl?: InputMaybe<Scalars['Url']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createUsPrincipalAdCvdCase mutation. */
export type CreateUsPrincipalAdCvdCasePayload = {
  __typename?: 'CreateUsPrincipalAdCvdCasePayload';
  record: UsPrincipalAdCvdCase;
};

export type CreateUsType86EntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<UsType86EntryArrivalInput>;
  /** US Customs Broker associated with this entry. */
  broker: UsType86EntryBrokerInput;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  /** US Buyer associated with this entry. */
  buyer?: InputMaybe<UsType86EntryBuyerInput>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** Indicates census warning status of the US entry release. */
  censusHeaderStatus?: InputMaybe<UsCbpEntryCensusHeaderStatusCode>;
  /** CBP collection status */
  collectionStatus?: InputMaybe<Scalars['String']>;
  /** US Consignee associated with this entry. */
  consignee?: InputMaybe<UsType86EntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Indicates the control status of the US entry release. */
  controlStatus?: InputMaybe<UsCbpEntryControlStatusCode>;
  /** Conveyance information. */
  conveyance: UsType86EntryConveyanceInput;
  /** Departure information. */
  departure?: InputMaybe<UsType86EntryDepartureInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** The estimated CBP charges if this entry had been filed as a US Consumption Entry */
  estimatedCustomsChargedSaved?: InputMaybe<UsCbpEntryChargesInput>;
  /** Exam details associated with the entry. */
  exam?: InputMaybe<UsType86EntryExamInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Indicates the filing timeliness of the US entry release. */
  filingTimeliness?: InputMaybe<UsCbpEntryFilingTimeliness>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<UsType86EntryCommercialInvoiceInput>>;
  /** US IOR associated with this entry. */
  ior?: InputMaybe<UsType86EntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<UsType86EntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDispositions?: InputMaybe<Array<UsCbpEntryPgaDispositionInput>>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: InputMaybe<Scalars['Date']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDispositions?: InputMaybe<Array<UsCbpEntryReleaseDispositionInput>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReasons?: InputMaybe<Array<UsCbpEntryReleaseRejectionReasonInput>>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: InputMaybe<UsCbpEntryReleaseStatus>;
  /** Indicates how to release split shipments. */
  splitShipmentReleaseMethod?: InputMaybe<UsCbpSplitShipmentReleaseMethod>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total value of the merchandise reported to US CBP. */
  totalAssist?: InputMaybe<Scalars['UsDollars']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the createUsType86Entry mutation. */
export type CreateUsType86EntryPayload = {
  __typename?: 'CreateUsType86EntryPayload';
  record: UsType86Entry;
};

/** The payload returned from triggering the Transaction. */
export type CreateUsType86EntryReleaseCbpPayload = {
  __typename?: 'CreateUsType86EntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: CreateUsType86EntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to update a US Type86 Entry Release, CATAIR appCode: SE/SX. */
export type CreateUsType86EntryReleaseCbpTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'CreateUsType86EntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Create User Release Note View Input */
export type CreateUserReleaseNoteViewInput = {
  /** The rating given to the release note by the user. */
  rating?: InputMaybe<RatingEnum>;
  /** The ID of the viewed release note. */
  releaseNote: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** The user who viewed the release note. */
  user: IdInput;
};

/** Payload returned from the createUserReleaseNoteView mutation. */
export type CreateUserReleaseNoteViewPayload = {
  __typename?: 'CreateUserReleaseNoteViewPayload';
  record: UserReleaseNoteView;
};

/** Confirmation  to customer on work order before transaction. */
export type CreateWorkOrderConfirmationInput = {
  /** If not approved after approveAfterMinutes, auto approve the confirmation and file the transaction. */
  approveAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Transaction to be performed once the confirmation is approved. */
  transaction?: InputMaybe<WorkOrderConfirmationTransactionInput>;
  /** The Work Order the confirmation occurs on. */
  workOrder: IdVersionInput;
};

/** Payload returned from the createWorkOrderConfirmation mutation. */
export type CreateWorkOrderConfirmationPayload = {
  __typename?: 'CreateWorkOrderConfirmationPayload';
  record: WorkOrderConfirmation;
};

export type CreateWorkOrderDocumentProcessingRequestInput = {
  /** WorkOrder processing request documents. */
  documents?: InputMaybe<Array<WorkOrderProcessingRequestDocumentInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Status values for tracking document processing status for a workOrder */
  status?: InputMaybe<WorkOrderDocumentProcessingStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createWorkOrderDocumentProcessingRequest mutation. */
export type CreateWorkOrderDocumentProcessingRequestPayload = {
  __typename?: 'CreateWorkOrderDocumentProcessingRequestPayload';
  record: WorkOrderDocumentProcessingRequest;
};

export type CreateWorkOrderGroupInput = {
  /** The Customs Broker associated with the Group of Work Orders. Returns the latest version. */
  customsBroker?: InputMaybe<IdInput>;
  /** The Forwarders associated with the Group of Work Orders. Returns the latest version. */
  forwarders?: InputMaybe<Array<WorkOrderGroupForwarderInput>>;
  /** The Operator fulfilling the Group of Work Orders. Returns the latest version. */
  operator: IdInput;
  /** The Shipper associated with the Group of Work Orders. Returns the latest version. */
  shipper?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the createWorkOrderGroup mutation. */
export type CreateWorkOrderGroupPayload = {
  __typename?: 'CreateWorkOrderGroupPayload';
  record: WorkOrderGroup;
};

/** A significant Work Order event. */
export type CreateWorkOrderMilestoneInput = {
  /** If it is true, we allow duplicate milestones. If not, we should not allow duplicate milestones creation */
  allowDuplicate: Scalars['Boolean'];
  /** The location where the milestone occured. */
  location?: InputMaybe<MilestoneLocationInput>;
  /** The name of the milestone */
  name: WorkOrderMilestoneName;
  /** The real time the milestone occured, possibly before its creation in the system. Defaults to the time of creation. */
  occurenceTime?: InputMaybe<Scalars['PreciseDateTime']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** A number used to refer to a shipment, customs declartion, or other work order. */
  referenceNumbers?: InputMaybe<Array<ReferenceNumberInput>>;
  /** The source which triggered the milestone, can be CBP, any Partner Government Agency, or system generated. */
  source?: InputMaybe<Scalars['WorkOrderMilestoneSource']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The Work Order the milestone occurs on. */
  workOrder: IdVersionInput;
};

/** Payload returned from the createWorkOrderMilestone mutation. */
export type CreateWorkOrderMilestonePayload = {
  __typename?: 'CreateWorkOrderMilestonePayload';
  record: WorkOrderMilestone;
};

/** A State Machine composed of the states and tasks required to execute a Work Order. */
export type CreateWorkOrderStateMachineInput = {
  /** The countries the state machine supports. If not provided, all countries are supported. */
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** The Customs Brokers the state machine supports. */
  customsBrokers?: InputMaybe<Array<IdInput>>;
  /** Description of the Work Order State Machine. */
  description: Scalars['String'];
  /** The Forwarders associated with the state machine. Returns the latest version. */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The mode of transports the state machine supports. If not provided, all mode of transports are supported. */
  modeOfTransports?: InputMaybe<Array<ModeOfTransport>>;
  /** Name of the Work Order State Machine */
  name: Scalars['String'];
  /** Operator ID */
  operator: IdInput;
  /** The Placement Type of the state machine */
  placementType?: InputMaybe<PlacementType>;
  /** The starting state. */
  start: Scalars['WorkOrderStateName'];
  /** The steps of the task. */
  states: Array<WorkOrderStateInput>;
  tags?: InputMaybe<Array<TagInput>>;
  workOrderType: WorkOrderType;
};

/** Payload returned from the createWorkOrderStateMachine mutation. */
export type CreateWorkOrderStateMachinePayload = {
  __typename?: 'CreateWorkOrderStateMachinePayload';
  record: WorkOrderStateMachine;
};

/** The definition for a Work Order Task */
export type CreateWorkOrderTaskDefinitionInput = {
  /** The custom fields definitions */
  customFields?: InputMaybe<Array<WorkOrderTaskCustomFieldDefinitionInput>>;
  /** Overview of the task */
  description: Scalars['String'];
  /** Estimated time in minutes to complete the task by an operator user. Defaulted to 15 mins */
  estimatedDuration?: InputMaybe<Scalars['Int']>;
  /** Whether this work order task is an exception task outside of the normal task workflow. */
  isException?: InputMaybe<Scalars['Boolean']>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: InputMaybe<SkillLevel>;
  /** Name of the task */
  name: Scalars['String'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The steps of the task. */
  steps: Array<WorkOrderTaskDefinitionStepInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The type of work order task to be completed. */
  workOrderTaskType: WorkOrderTaskType;
  /** The type of Work Order this task is used on. */
  workOrderType: WorkOrderType;
};

/** Payload returned from the createWorkOrderTaskDefinition mutation. */
export type CreateWorkOrderTaskDefinitionPayload = {
  __typename?: 'CreateWorkOrderTaskDefinitionPayload';
  record: WorkOrderTaskDefinition;
};

export type CreateWorkOrderTaskEscalationMessageInput = {
  /** Details about the task escalation */
  escalationDetails?: InputMaybe<TaskEscalationDetailsInput>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Details about the task resolution */
  resolutionDetails?: InputMaybe<TaskResolutionDetailsInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The Work Order Task ID this Escalation Message belongs to. */
  workOrderTask: IdInput;
};

/** Payload returned from the createWorkOrderTaskEscalationMessage mutation. */
export type CreateWorkOrderTaskEscalationMessagePayload = {
  __typename?: 'CreateWorkOrderTaskEscalationMessagePayload';
  record: WorkOrderTaskEscalationMessage;
};

export type CreateWorkOrderTaskInput = {
  /** The User assigned to this Work Order Task. Returns the version at the time of assignment. */
  assignee?: InputMaybe<IdInput>;
  /** The associated assignment team for the task. */
  assignmentTeam?: InputMaybe<IdInput>;
  /** The custom fields  */
  customFields?: InputMaybe<Array<WorkOrderTaskCustomFieldInput>>;
  /** Deadline for the Work Order Task to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** The Work Order Task Definition ID and version this Task was created from. */
  definition: IdVersionInput;
  /** All the empty fields in the current work order task */
  emptyFieldsNames?: InputMaybe<Array<Scalars['String']>>;
  /** Work order task escalation details. */
  escalations?: InputMaybe<Array<WorkOrderTaskEscalationInput>>;
  /** The estimatedDuration of one work order task, calculated in minutes */
  estimatedDuration?: InputMaybe<Scalars['Float']>;
  /** Work order task execution result. */
  executionResult?: InputMaybe<WorkOrderTaskExecutionResultInput>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: InputMaybe<SkillLevel>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Work order task team. */
  teamId?: InputMaybe<Scalars['ID']>;
  /** The Work Order ID this task belongs to. */
  workOrder: IdInput;
};

/** Payload returned from the createWorkOrderTask mutation. */
export type CreateWorkOrderTaskPayload = {
  __typename?: 'CreateWorkOrderTaskPayload';
  record: WorkOrderTask;
};

export type CursorPagination = {
  __typename?: 'CursorPagination';
  /** Cursor of the last evaluated result. May be set even if no results were returned in the current page, due to internal filtering. Use as afterCursor for the next page of results. */
  endCursor?: Maybe<Scalars['ID']>;
  /** Whether thare are more pages in the result. May be true even if no results were returned in the current page, due to internal filtering. If true, endCusor should be used as afterCursor in a subsequent query. */
  hasNextPage: Scalars['Boolean'];
  /** Cursor of the first result, if there is any result. May be different from the afterCursor provided in the input, since there maybe internal filtering of results. If used as the afterCursor in a subsequent query, there is no guarantee the order of results will be the same. */
  startCursor?: Maybe<Scalars['ID']>;
};

export type CursorPaginationInput = {
  /** Exclusive starting cursor, meaning it includes results after the cursor. Set as the endCursor of the previous paginated response. */
  afterCursor?: InputMaybe<Scalars['ID']>;
  /** Included deleted results. Default is false. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Maximum number of results to return. Default is unlimited up to the maximum dataset size of 1MB. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type CustomDisbursementFeeConfiguration = {
  __typename?: 'CustomDisbursementFeeConfiguration';
  /** Custom disbursement fee rate. */
  rate: Scalars['Float'];
};

export type CustomDisbursementFeeConfigurationInput = {
  /** Custom disbursement fee rate. */
  rate: Scalars['Float'];
};

/** The primary entity used to represent a Custom Domain. */
export type CustomDomain = Record & {
  __typename?: 'CustomDomain';
  account?: Maybe<Account>;
  /** The source of the assets to host. */
  assetSource: AssetSource;
  /** The Content Distribution Network for the Custom Domain. */
  cdn: CustomDomainCdn;
  /** The SSL certificate. */
  certificate: CustomDomainCertificate;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The list of DNS records required to setup the domain. */
  dnsRecords: Array<CustomDomainDnsRecord>;
  /** The custom domain url */
  domain: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The tab title */
  tabTitle: Scalars['String'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The type of asset hosted by the Custom Domain */
export enum CustomDomainAssetSourceType {
  S3 = 'S3'
}

export type CustomDomainCdn = {
  __typename?: 'CustomDomainCdn';
  /** The CloudFront domain. NULL if status = CREATING. */
  cloudFrontDomain?: Maybe<Scalars['String']>;
  /** The CloudFront ID. NULL if status = CREATING. */
  cloudFrontId?: Maybe<Scalars['ID']>;
  /** The status of the CloudFront distribution */
  status: CustomDomainCdnStatus;
};

export type CustomDomainCdnInput = {
  /** The CloudFront domain. NULL if status = CREATING. */
  cloudFrontDomain?: InputMaybe<Scalars['String']>;
  /** The CloudFront ID. NULL if status = CREATING. */
  cloudFrontId?: InputMaybe<Scalars['ID']>;
};

/** The CDN status of the SSL certificate */
export enum CustomDomainCdnStatus {
  CREATING = 'CREATING',
  DEPLOYED = 'DEPLOYED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type CustomDomainCertificate = {
  __typename?: 'CustomDomainCertificate';
  /** The ARN of the certificate. If not provded, one will be created with DNS validation options. NULL if status = CREATING */
  arn?: Maybe<Scalars['AcmArn']>;
  /** The SSL certificate renewal status. NULL if it must be manually renewed. */
  renewalStatus?: Maybe<CustomDomainCertificateRenewalStatus>;
  /** The SSL certificate status. */
  status: CustomDomainCertificateStatus;
  /** The SSL certificate validation status. NULL if the certificate ARN was provided by the client on create. */
  validationStatus?: Maybe<CustomDomainCertificateValidationStatus>;
};

export type CustomDomainCertificateInput = {
  /** The ARN of the certificate. If not provded, one will be created with DNS validation options. NULL if status = CREATING */
  arn?: InputMaybe<Scalars['AcmArn']>;
};

/** The renewal status of the SSL certificate */
export enum CustomDomainCertificateRenewalStatus {
  FAILED = 'FAILED',
  PENDING_AUTO_RENEWAL = 'PENDING_AUTO_RENEWAL',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  SUCCESS = 'SUCCESS'
}

/** The status of the SSL certificate */
export enum CustomDomainCertificateStatus {
  CREATING = 'CREATING',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  INACTIVE = 'INACTIVE',
  ISSUED = 'ISSUED',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  REVOKED = 'REVOKED',
  VALIDATION_TIMED_OUT = 'VALIDATION_TIMED_OUT'
}

/** The validation status of the SSL certificate */
export enum CustomDomainCertificateValidationStatus {
  FAILED = 'FAILED',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  SUCCESS = 'SUCCESS'
}

export type CustomDomainCriteriaInput = {
  /** Account ID of Custom Domain. */
  accountId?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** Asset source value of Custom Domain. */
  assetSourceValue?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** Domain name of Custom Domain.. */
  domain?: InputMaybe<IdIndexSearchCriteriaInput>;
};

export type CustomDomainDnsRecord = {
  __typename?: 'CustomDomainDnsRecord';
  /** Required value of the DNS record. */
  expectedValue: Scalars['String'];
  /** Name of the DNS record. */
  name: Scalars['String'];
  /** Whether the resolved value matches the expected value. */
  resolved: Scalars['Boolean'];
  /** The resolved value. Null if no value resolved. */
  resolvedValue?: Maybe<Scalars['String']>;
  /** The type of DNS record. */
  type: DnsRecordType;
};

export type CustomDomainEdge = ConnectionEdge & {
  __typename?: 'CustomDomainEdge';
  cursor: Scalars['ID'];
  node: CustomDomain;
};

/** The key and value of an environment variable used by an instance of a Custom Domain. */
export type CustomDomainEnvironmentVariable = {
  __typename?: 'CustomDomainEnvironmentVariable';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** The data required by an instance of a Custom Domain at runtime. */
export type CustomDomainRuntimeInfo = {
  __typename?: 'CustomDomainRuntimeInfo';
  /** The Custom Domain associated with the origin */
  customDomain: CustomDomain;
  /** A list of environment variables */
  environmentVariables: Array<CustomDomainEnvironmentVariable>;
};

export type CustomDomainsConnection = Connection & {
  __typename?: 'CustomDomainsConnection';
  edges: Array<CustomDomainEdge>;
  nodes: Array<CustomDomain>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type CustomFeeConfiguration = {
  __typename?: 'CustomFeeConfiguration';
  /** User custom disbursement fee configuration. */
  disbursement?: Maybe<CustomDisbursementFeeConfiguration>;
  /** User custom single entry bond configuration. */
  singleEntryBond?: Maybe<CustomSingleEntryBondFeeConfiguration>;
};

export type CustomFeeConfigurationInput = {
  /** User custom disbursement fee configuration. */
  disbursement?: InputMaybe<CustomDisbursementFeeConfigurationInput>;
  /** User custom single entry bond configuration. */
  singleEntryBond?: InputMaybe<CustomSingleEntryBondFeeConfigurationInput>;
};

export type CustomSingleEntryBondFeeConfiguration = {
  __typename?: 'CustomSingleEntryBondFeeConfiguration';
  /** Custom single entry bond minimum. */
  minimum: Scalars['Float'];
  /** Custom single entry bond rate. */
  rate: Scalars['Float'];
};

export type CustomSingleEntryBondFeeConfigurationInput = {
  /** Custom single entry bond minimum. */
  minimum: Scalars['Float'];
  /** Custom single entry bond rate. */
  rate: Scalars['Float'];
};

/** Sub-type of Party that can be an Amazon Customs Brokerage customer */
export type Customer = {
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: Maybe<CustomerDefaultWorkOrdersConfig>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: Maybe<CustomerSelfFiledWorkOrdersConfig>;
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: Maybe<CustomerWorkOrderConfig>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: Maybe<Array<CustomerWorkOrderConfirmationConfiguration>>;
};

export type CustomerCustomsDeclarationConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type CustomerDeCustomsEntryConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

/** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation. */
export type CustomerDefaultWorkOrdersByModeOfTransportConfig = {
  __typename?: 'CustomerDefaultWorkOrdersByModeOfTransportConfig';
  /** The mode of transports for the configuration. If not defined, the configuration would apply for all the mode of transports. */
  modesOfTransport?: Maybe<Array<ModeOfTransport>>;
  /** Work orders to be generated by default (if applicable). */
  workOrderTypes: Array<WorkOrderType>;
};

/** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation. */
export type CustomerDefaultWorkOrdersByModeOfTransportConfigInput = {
  /** The mode of transports for the configuration. If not defined, the configuration would apply for all the mode of transports. */
  modesOfTransport?: InputMaybe<Array<ModeOfTransport>>;
  /** Work orders to be generated by default (if applicable). */
  workOrderTypes: Array<WorkOrderType>;
};

/** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
export type CustomerDefaultWorkOrdersConfig = {
  __typename?: 'CustomerDefaultWorkOrdersConfig';
  /** Default WOs configuration for US. */
  us: Array<CustomerDefaultWorkOrdersByModeOfTransportConfig>;
};

/** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
export type CustomerDefaultWorkOrdersConfigInput = {
  /** Default WOs configuration for US. */
  us: Array<CustomerDefaultWorkOrdersByModeOfTransportConfigInput>;
};

export type CustomerDeliveryOrderConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<DeliveryOrderServiceLevelAgreement>>;
};

export type CustomerFrCustomsEntryConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type CustomerGbCustomsEntryConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type CustomerNlCustomsEntryConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

/** Work orders a customer can file by themself in US */
export enum CustomerSelfFilableUsWorkOrderType {
  UsInBond = 'UsInBond',
  UsIsf = 'UsIsf'
}

/** The cofiguration dictating the work orders filed by the party themselves per geography. */
export type CustomerSelfFiledWorkOrdersConfig = {
  __typename?: 'CustomerSelfFiledWorkOrdersConfig';
  /** Work Orders filed by the party themselves for US. */
  us: Array<CustomerSelfFilableUsWorkOrderType>;
};

/** The cofiguration dictating the work orders filed by the party themselves per geography. */
export type CustomerSelfFiledWorkOrdersConfigInput = {
  /** Work Orders filed by the party themselves for US. */
  us: Array<CustomerSelfFilableUsWorkOrderType>;
};

export type CustomerUsConsumptionEntryConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsConsumptionEntryServiceLevelAgreement>>;
};

export type CustomerUsIorContinuousBondRequestConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsIorContinuousBondRequestServiceLevelAgreement>>;
};

export type CustomerUsIsfConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsIsfServiceLevelAgreement>>;
};

export type CustomerUsType86EntryConfig = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsType86EntryServiceLevelAgreement>>;
};

/** WorkOrderConfig for the customer */
export type CustomerWorkOrderConfig = {
  /** Configuration of Customs Declaration for the customer */
  customsDeclaration?: Maybe<CustomerCustomsDeclarationConfig>;
  /** Configuration of De Customs Entry for the customer */
  deCustomsEntry?: Maybe<CustomerDeCustomsEntryConfig>;
  /** Configuration of delivery order for the customer */
  deliveryOrder?: Maybe<CustomerDeliveryOrderConfig>;
  /** Configuration of Fr Customs Entry for the customer */
  frCustomsEntry?: Maybe<CustomerFrCustomsEntryConfig>;
  /** Configuration of Gb Customs Entry for the customer */
  gbCustomsEntry?: Maybe<CustomerGbCustomsEntryConfig>;
  /** Configuration of Nl Customs Entry for the customer */
  nlCustomsEntry?: Maybe<CustomerNlCustomsEntryConfig>;
  /** Configuration of US Consumption Entry for the customer */
  usConsumptionEntry?: Maybe<CustomerUsConsumptionEntryConfig>;
  /** Configuration of US IOR Continuous Bond Request for the customer */
  usIorContinuousBondRequest?: Maybe<CustomerUsIorContinuousBondRequestConfig>;
  /** Configuration of US Isf for the customer */
  usIsf?: Maybe<CustomerUsIsfConfig>;
  /** Configuration of US Type86 Entry for the customer */
  usType86Entry?: Maybe<CustomerUsType86EntryConfig>;
};

/** Detailed WorkOrderConfig settings for the customer. */
export type CustomerWorkOrderConfigDetails = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<ServiceLevelAgreement>>;
};

export type CustomerWorkOrderConfirmationConfiguration = {
  /** Duration of minutes to wait for the response until auto approve. Never auto approve if not defined. */
  approveAfterMinutes?: Maybe<Scalars['Int']>;
  /** Documents to send along with entry summary confirmation request so the client more information about the entry. */
  includedDocuments?: Maybe<Array<DocumentTag>>;
  /** Rules for work order confirmation setting. Always request confirmation if not defined. */
  ruleGroup?: Maybe<BusinessRuleGroup>;
  /** Type of work order associated with the confirmation. */
  workOrderType: WorkOrderType;
};

export type CustomsAgent = Party & Record & {
  __typename?: 'CustomsAgent';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this Customs Agent */
  shipper: ShipperCustomsAgentRelationship;
  /** Shipper connection used to paginate results. */
  shippers: CustomsAgentShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: Maybe<Scalars['Boolean']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type CustomsAgentmemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type CustomsAgentshipperArgs = {
  shipperId: Scalars['ID'];
};


export type CustomsAgentshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type CustomsAgentEdge = ConnectionEdge & {
  __typename?: 'CustomsAgentEdge';
  cursor: Scalars['ID'];
  node: CustomsAgent;
};

export type CustomsAgentSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type CustomsAgentSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'CustomsAgentSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type CustomsAgentShipperEdge = ConnectionEdge & {
  __typename?: 'CustomsAgentShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Customs Agent. */
  relationship: ShipperCustomsAgentRelationship;
};

export type CustomsAgentShippersConnection = Connection & {
  __typename?: 'CustomsAgentShippersConnection';
  edges: Array<CustomsAgentShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type CustomsAgentsConnection = Connection & {
  __typename?: 'CustomsAgentsConnection';
  edges: Array<CustomsAgentEdge>;
  nodes: Array<CustomsAgent>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** A customs bond for an IOR. */
export type CustomsBond = {
  __typename?: 'CustomsBond';
  /** The amount indicating the total value of the guarantee. */
  amount: Scalars['UsDollars'];
  /** Date and time of effectiveness of the document (e.g. license, visa, permit, certificate, or bond). */
  effectiveDate: Scalars['Date'];
  /** The unique reference identification of the undertaking given as a written guarantee in cash, bond, or by other such means. */
  referenceIdentifier: Scalars['String'];
  /** Date and time of the scheduled renewal of the document (e.g. license, visa, permit, certificate, or bond). */
  renewalDate?: Maybe<Scalars['Date']>;
  /** Details related to the surety company that underwrites customs bonds for importers, guaranteeing payment to customs authorities. */
  surety?: Maybe<Surety>;
  /** Date and time of termination of the document (e.g. license, visa, permit, certificate, or bond). */
  terminationDate?: Maybe<Scalars['Date']>;
  /** The type code of the customs bond (Example: cbp bond type code). */
  typeCode: Scalars['String'];
};

/** A customs bond for an IOR. */
export type CustomsBondInput = {
  /** The amount indicating the total value of the guarantee. */
  amount: Scalars['UsDollars'];
  /** Date and time of effectiveness of the document (e.g. license, visa, permit, certificate, or bond). */
  effectiveDate: Scalars['Date'];
  /** The unique reference identification of the undertaking given as a written guarantee in cash, bond, or by other such means. */
  referenceIdentifier: Scalars['String'];
  /** Date and time of the scheduled renewal of the document (e.g. license, visa, permit, certificate, or bond). */
  renewalDate?: InputMaybe<Scalars['Date']>;
  /** Details related to the surety company that underwrites customs bonds for importers, guaranteeing payment to customs authorities. */
  surety?: InputMaybe<SuretyInput>;
  /** Date and time of termination of the document (e.g. license, visa, permit, certificate, or bond). */
  terminationDate?: InputMaybe<Scalars['Date']>;
  /** The type code of the customs bond (Example: cbp bond type code). */
  typeCode: Scalars['String'];
};

/** Past, present, and future customs bond information. */
export type CustomsBonds = {
  __typename?: 'CustomsBonds';
  /** The customs bond that has been acquired but goes into effect in the future. */
  future?: Maybe<CustomsBond>;
  /** A list of customs bonds that are no longer active. */
  past?: Maybe<Array<CustomsBond>>;
  /** The active customs bond. */
  present?: Maybe<CustomsBond>;
};

/** Past, present, and future customs bond information. */
export type CustomsBondsInput = {
  /** The customs bond that has been acquired but goes into effect in the future. */
  future?: InputMaybe<CustomsBondInput>;
  /** A list of customs bonds that are no longer active. */
  past?: InputMaybe<Array<CustomsBondInput>>;
  /** The active customs bond. */
  present?: InputMaybe<CustomsBondInput>;
};

export type CustomsBroker = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};

/** Base search table row for customs broker */
export type CustomsBrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type CustomsDeclaration = Record & WorkOrder & {
  __typename?: 'CustomsDeclaration';
  /** Details related to the party authorized to act on behalf of another party. */
  agent?: Maybe<Array<CustomsBroker>>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the Customs Declaration . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Reference for large goodsItem data stored in S3. */
  goodsItemReference?: Maybe<GoodsItemReference>;
  /** Details related to the movement and the handling of goods shipped together on one or more means of transport between original consignor and final consignee. */
  goodsShipment?: Maybe<Array<GoodsShipment>>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** Identification of a specific document. */
  identification?: Maybe<Scalars['String']>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Amount indicating the total of all invoice amounts in a single declaration. */
  invoice?: Maybe<Scalars['Float']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: Maybe<Array<Reference>>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type CustomsDeclarationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type CustomsDeclarationEdge = ConnectionEdge & {
  __typename?: 'CustomsDeclarationEdge';
  cursor: Scalars['ID'];
  node: CustomsDeclaration;
};

/** The mode of transport for the goods being entered. */
export type CustomsDeclarationEntryModeOfTransportSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ModeOfTransport>>;
};

export type CustomsDeclarationSearchCriteriaInput = {
  /** The shipment's port of unlading. */
  arrivalLocationIdentification?: InputMaybe<TextSearchCriteriaInput>;
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  borderTransportationMeanIdentificationType?: InputMaybe<CustomsDeclarationEntryModeOfTransportSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  borderTransportationMeanJourney?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  borderTransportationMeanName?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The port code representing the shipment's foreign port of lading. */
  departureLocationIdentification?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The country to which the articles were shipped from the origin country, having last been a part of the commerce of that country. */
  importCountryCode?: InputMaybe<TextSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The id of the importer linked to the work order */
  importerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the importer linked to the work order */
  importerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: InputMaybe<ReferenceErrorCodeSearchCriteriaInput>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: InputMaybe<ReferenceProcessingStatusSearchCriteriaInput>;
  /** The type of reference */
  referenceType?: InputMaybe<ReferenceTypeSearchCriteriaInput>;
  /** The reference value */
  referenceValue?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  transportEquipmentFullness?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  transportEquipmentIdentification?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Customs Declaration Search Table Row */
export type CustomsDeclarationSearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'CustomsDeclarationSearchTableRow';
  /** The shipment's port of unlading. */
  arrivalLocationIdentification?: Maybe<Array<Scalars['String']>>;
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The mode of transport for the goods being entered. */
  borderTransportationMeanIdentificationType?: Maybe<Array<ModeOfTransport>>;
  /** The shipment's voyage, flight, or trip number. */
  borderTransportationMeanJourney?: Maybe<Array<Scalars['String']>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  borderTransportationMeanName?: Maybe<Array<Scalars['String']>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The port code representing the shipment's foreign port of lading. */
  departureLocationIdentification?: Maybe<Array<Scalars['String']>>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Array<Scalars['String']>>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The country to which the articles were shipped from the origin country, having last been a part of the commerce of that country. */
  importCountryCode?: Maybe<Array<Scalars['String']>>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** The id of the importer linked to the work order */
  importerId?: Maybe<Array<Scalars['ID']>>;
  /** The name of the importer linked to the work order */
  importerName?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: Maybe<Array<EntryReferenceErrorCode>>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: Maybe<Array<EntryReferenceProcessingStatus>>;
  /** The type of reference */
  referenceType?: Maybe<Array<ReferenceType>>;
  /** The reference value */
  referenceValue?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The Load Type e.g. FCL, LCL */
  transportEquipmentFullness?: Maybe<Array<LoadType>>;
  /** The name of the conveyance or vessel. */
  transportEquipmentIdentification?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type CustomsDeclarationsConnection = Connection & {
  __typename?: 'CustomsDeclarationsConnection';
  edges: Array<CustomsDeclarationEdge>;
  nodes: Array<CustomsDeclaration>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type CustomsEntriesConnection = Connection & {
  __typename?: 'CustomsEntriesConnection';
  edges: Array<CustomsEntryEdge>;
  nodes: Array<CustomsEntry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type CustomsEntry = Record & WorkOrder & {
  __typename?: 'CustomsEntry';
  /** Arrival information */
  arrival?: Maybe<CustomsEntryArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: CustomsEntryCustomsBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Consignee associated with this entry. */
  consignee?: Maybe<CustomsEntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<CustomsEntryDeparture>;
  /** The documents associated with the Customs Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: Maybe<Array<Scalars['ImportEntryNumber']>>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<CustomsEntryCommercialInvoice>>;
  /** IOR associated with this entry. */
  ior?: Maybe<CustomsEntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<CustomsEntryMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: Maybe<Array<Reference>>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: Maybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: Maybe<Scalars['Float']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type CustomsEntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type CustomsEntryArrival = {
  __typename?: 'CustomsEntryArrival';
  /** Arrival country of the entry. */
  country: Scalars['CountryCode'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['Date']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: Maybe<PortCode>;
};

export type CustomsEntryArrivalInput = {
  /** Arrival country of the entry. */
  country: Scalars['CountryCode'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<Scalars['Date']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: InputMaybe<PortCodeInput>;
};

export type CustomsEntryBuyer = {
  __typename?: 'CustomsEntryBuyer';
  /** Party address */
  address?: Maybe<Address>;
  /** Buyer party info which is stored in the record */
  buyer?: Maybe<Facility>;
  /** EORI (Economic Operators Registration and Identification) number */
  eori?: Maybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: Maybe<Scalars['SupportedCountryVatNumber']>;
};

export type CustomsEntryBuyerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Buyer party info which is stored in the record */
  buyer?: InputMaybe<IdOptionalVersionInput>;
  /** EORI (Economic Operators Registration and Identification) number */
  eori?: InputMaybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: InputMaybe<Scalars['SupportedCountryVatNumber']>;
};

export type CustomsEntryCommercialInvoice = {
  __typename?: 'CustomsEntryCommercialInvoice';
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: Maybe<CustomsEntryBuyer>;
  /** Conveyance associated with the particular product. */
  conveyance?: Maybe<CustomsEntryConveyance>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: Maybe<Cost>;
  /** Commercial Invoice date */
  invoiceDate?: Maybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: Maybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<CustomsEntryProduct>>;
  /** Reason For Export */
  reasonsForExport?: Maybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<CustomsEntrySeller>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: Maybe<Cost>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: Maybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: Maybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type CustomsEntryCommercialInvoiceInput = {
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: InputMaybe<CustomsEntryBuyerInput>;
  /** Conveyance associated with the particular product. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: InputMaybe<CostInput>;
  /** Commercial Invoice date */
  invoiceDate?: InputMaybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: InputMaybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<CustomsEntryProductInput>>;
  /** Reason For Export */
  reasonsForExport?: InputMaybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<CustomsEntrySellerInput>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: InputMaybe<CostInput>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: InputMaybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type CustomsEntryConsignee = {
  __typename?: 'CustomsEntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Consignee details */
  consignee?: Maybe<Consignee>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: Maybe<Scalars['String']>;
};

export type CustomsEntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id version of the Consignee */
  consignee?: InputMaybe<IdVersionInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type CustomsEntryConveyance = {
  __typename?: 'CustomsEntryConveyance';
  /** Whether the goods are containerized. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
  /** Mode of transportation of shipment */
  modeOfTransport: Scalars['String'];
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
};

export type CustomsEntryConveyanceInput = {
  /** Whether the goods are containerized. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** Mode of transportation of shipment */
  modeOfTransport: Scalars['String'];
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type CustomsEntryCustomsBroker = {
  __typename?: 'CustomsEntryCustomsBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type CustomsEntryCustomsBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type CustomsEntryDeparture = {
  __typename?: 'CustomsEntryDeparture';
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['Date']>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: Maybe<PortCode>;
};

export type CustomsEntryDepartureInput = {
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<Scalars['Date']>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: InputMaybe<PortCodeInput>;
};

export type CustomsEntryEdge = ConnectionEdge & {
  __typename?: 'CustomsEntryEdge';
  cursor: Scalars['ID'];
  node: CustomsEntry;
};

export type CustomsEntryIor = {
  __typename?: 'CustomsEntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['SupportedCountryEori']>;
  /** Ior party info which is stored in the record */
  ior?: Maybe<Ior>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['SupportedCountryVatNumber']>;
};

export type CustomsEntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['SupportedCountryEori']>;
  /** Ior party info which is stored in the record */
  ior?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['SupportedCountryVatNumber']>;
};

export type CustomsEntryLine = {
  __typename?: 'CustomsEntryLine';
  /** The line assist value. */
  assist?: Maybe<Cost>;
  /** The line assist percentage. */
  assistPercentage?: Maybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<CustomsEntrySupplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<CustomsEntryTariff>>;
  /** The line value. */
  value?: Maybe<Cost>;
};

export type CustomsEntryLineInput = {
  /** The line assist value. */
  assist?: InputMaybe<CostInput>;
  /** The line assist percentage. */
  assistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<CustomsEntrySupplierInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<CustomsEntryTariffInput>>;
  /** The line value. */
  value?: InputMaybe<CostInput>;
};

export type CustomsEntryMasterBill = {
  __typename?: 'CustomsEntryMasterBill';
  /** House bills */
  houseBills?: Maybe<Array<HouseBill>>;
  /** Masterbill number */
  number?: Maybe<Scalars['String']>;
};

export type CustomsEntryMasterBillInput = {
  /** House bills */
  houseBills?: InputMaybe<Array<HouseBillInput>>;
  /** Masterbill number */
  number?: InputMaybe<Scalars['String']>;
};

/** The mode of transport for the goods being entered. */
export type CustomsEntryModeOfTransportSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ModeOfTransport>>;
};

export type CustomsEntryProduct = {
  __typename?: 'CustomsEntryProduct';
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: Maybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Line items within the Product. */
  lines?: Maybe<Array<CustomsEntryLine>>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type CustomsEntryProductInput = {
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<CustomsEntryLineInput>>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

/** The review status for the Customs Entry */
export enum CustomsEntryReviewStatus {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT'
}

export type CustomsEntrySearchCriteriaInput = {
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<CustomsEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's port of unlading. */
  portOfUnlading?: InputMaybe<TextSearchCriteriaInput>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: InputMaybe<ReferenceErrorCodeSearchCriteriaInput>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: InputMaybe<ReferenceProcessingStatusSearchCriteriaInput>;
  /** The type of reference */
  referenceType?: InputMaybe<ReferenceTypeSearchCriteriaInput>;
  /** The reference value */
  referenceValue?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Generic Customs Entry Search Table Row */
export type CustomsEntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'CustomsEntrySearchTableRow';
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: Maybe<Scalars['String']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: Maybe<Scalars['String']>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: Maybe<Array<EntryReferenceErrorCode>>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: Maybe<Array<EntryReferenceProcessingStatus>>;
  /** The type of reference */
  referenceType?: Maybe<Array<ReferenceType>>;
  /** The reference value */
  referenceValue?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Array<Scalars['String']>>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type CustomsEntrySeller = {
  __typename?: 'CustomsEntrySeller';
  /** Party address */
  address?: Maybe<Address>;
  /** EORI (Economic Operators Registration and Identification number) */
  eori?: Maybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Seller party info which is stored in the record */
  seller?: Maybe<Supplier>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: Maybe<Scalars['SupportedCountryVatNumber']>;
};

export type CustomsEntrySellerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** EORI (Economic Operators Registration and Identification number) */
  eori?: InputMaybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Seller party info which is stored in the record */
  seller?: InputMaybe<IdOptionalVersionInput>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: InputMaybe<Scalars['SupportedCountryVatNumber']>;
};

export type CustomsEntryServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'CustomsEntryServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: Maybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: Maybe<CustomsEntryServiceLevelAgreementMatchingCriteria>;
};

export type CustomsEntryServiceLevelAgreementInput = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: InputMaybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: InputMaybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: InputMaybe<CustomsEntryServiceLevelAgreementMatchingCriteriaInput>;
};

export type CustomsEntryServiceLevelAgreementMatchingCriteria = {
  __typename?: 'CustomsEntryServiceLevelAgreementMatchingCriteria';
  /** Badges specified by an SLA */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: Maybe<Array<ModeOfTransport>>;
};

export type CustomsEntryServiceLevelAgreementMatchingCriteriaInput = {
  /** Badges specified by an SLA */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: InputMaybe<Array<ModeOfTransport>>;
};

export type CustomsEntrySupplier = {
  __typename?: 'CustomsEntrySupplier';
  /** Party address */
  address?: Maybe<Address>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The Supplier record */
  supplier?: Maybe<Supplier>;
};

export type CustomsEntrySupplierInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The Supplier record */
  supplier?: InputMaybe<IdInput>;
};

export type CustomsEntryTariff = {
  __typename?: 'CustomsEntryTariff';
  /** The HTS record. */
  hts?: Maybe<Hts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type CustomsEntryTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type CustomsValuation = {
  __typename?: 'CustomsValuation';
  /** Charge deduction details */
  chargeDeduction?: Maybe<Array<ChargeDeduction>>;
  /** Amount indicating the total costs incurred by the shipper in moving goods, by whatever means, from one place to another under the terms of the contract of carriage. In addition to transport costs, this may include such elements as packing, documentation, loading, unloading, and insurance (i.e., to the extent that they relate to the freight cost). */
  freightCharge?: Maybe<Cost>;
  /** Amount of premium paid/payable to the insurance company for insuring the goods. */
  insurance?: Maybe<Cost>;
  /** Code specifying the method on which the customs value is determined */
  method?: Maybe<Scalars['String']>;
};

export type CustomsValuationInput = {
  /** Charge deduction details */
  chargeDeduction?: InputMaybe<Array<ChargeDeductionInput>>;
  /** Amount indicating the total costs incurred by the shipper in moving goods, by whatever means, from one place to another under the terms of the contract of carriage. In addition to transport costs, this may include such elements as packing, documentation, loading, unloading, and insurance (i.e., to the extent that they relate to the freight cost). */
  freightCharge?: InputMaybe<CostInput>;
  /** Amount of premium paid/payable to the insurance company for insuring the goods. */
  insurance?: InputMaybe<CostInput>;
  /** Code specifying the method on which the customs value is determined */
  method?: InputMaybe<Scalars['String']>;
};

export type DNSRecord = {
  __typename?: 'DNSRecord';
  /** Name of the DNS record. */
  name: Scalars['String'];
  /** Type of the DNS record. */
  type: Scalars['String'];
  /** Value of the DNS record. */
  value: Scalars['String'];
};

/** Data Source Type */
export enum DataSourceType {
  AMS_QUERY = 'AMS_QUERY',
  EXTERNAL_CLIENT = 'EXTERNAL_CLIENT',
  OPERATOR = 'OPERATOR',
  SELLING_PARTNER = 'SELLING_PARTNER',
  SHIP_DOCS_EXTRACTION = 'SHIP_DOCS_EXTRACTION'
}

/** The configurations and data validations present in a particular cell in this column */
export type DataValidationInput = {
  /** The options to choose from in a drop-down list style */
  dropDown?: InputMaybe<Array<Scalars['String']>>;
};

export type DateSearchCriteriaInput = {
  /** The maximum value when requesting a range operation */
  max?: InputMaybe<Scalars['Date']>;
  /** The minimum value when requesting a range operation */
  min?: InputMaybe<Scalars['Date']>;
  /** Operators available when searcing for date and number data types. */
  operator: DateSearchOperator;
  /** The value for non-range operations. */
  value?: InputMaybe<Scalars['Date']>;
};

/** Operators used for date based search operations. */
export enum DateSearchOperator {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE',
  BETWEEN = 'BETWEEN',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  EQUALS = 'EQUALS',
  EXISTS = 'EXISTS',
  NOT_BETWEEN = 'NOT_BETWEEN'
}

export type DateTimeSearchCriteriaInput = {
  /** The maximum value when requesting a range operation */
  max?: InputMaybe<Scalars['DateTime']>;
  /** The minimum value when requesting a range operation */
  min?: InputMaybe<Scalars['DateTime']>;
  /** Operators available when searcing for date and number data types. */
  operator: DateSearchOperator;
  /** The value for non-range operations. */
  value?: InputMaybe<Scalars['DateTime']>;
};

export type DeConsignee = Consignee & Party & Record & {
  __typename?: 'DeConsignee';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this DE Consignee */
  shipper: ShipperDeConsigneeRelationship;
  /** Shipper connection used to paginate results. */
  shippers: DeConsigneeShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type DeConsigneememosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type DeConsigneeshipperArgs = {
  shipperId: Scalars['ID'];
};


export type DeConsigneeshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type DeConsigneeEdge = ConnectionEdge & {
  __typename?: 'DeConsigneeEdge';
  cursor: Scalars['ID'];
  node: DeConsignee;
};

export type DeConsigneeSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type DeConsigneeSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'DeConsigneeSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type DeConsigneeShipperEdge = ConnectionEdge & {
  __typename?: 'DeConsigneeShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and DE Consignee. */
  relationship: ShipperDeConsigneeRelationship;
};

export type DeConsigneeShippersConnection = Connection & {
  __typename?: 'DeConsigneeShippersConnection';
  edges: Array<DeConsigneeShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeConsigneesConnection = Connection & {
  __typename?: 'DeConsigneesConnection';
  edges: Array<DeConsigneeEdge>;
  nodes: Array<DeConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeCustomsBroker = CustomsBroker & Party & Record & {
  __typename?: 'DeCustomsBroker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['DeEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this De Customs Broker */
  shipper: ShipperDeCustomsBrokerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: DeCustomsBrokerShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type DeCustomsBrokermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type DeCustomsBrokershipperArgs = {
  shipperId: Scalars['ID'];
};


export type DeCustomsBrokershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type DeCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'DeCustomsBrokerEdge';
  cursor: Scalars['ID'];
  node: DeCustomsBroker;
};

export type DeCustomsBrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<DeEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type DeCustomsBrokerSearchTableRow = {
  __typename?: 'DeCustomsBrokerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['DeEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type DeCustomsBrokerShipperEdge = ConnectionEdge & {
  __typename?: 'DeCustomsBrokerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and De Customs Broker. */
  relationship: ShipperDeCustomsBrokerRelationship;
};

export type DeCustomsBrokerShippersConnection = Connection & {
  __typename?: 'DeCustomsBrokerShippersConnection';
  edges: Array<DeCustomsBrokerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeCustomsBrokersConnection = Connection & {
  __typename?: 'DeCustomsBrokersConnection';
  edges: Array<DeCustomsBrokerEdge>;
  nodes: Array<DeCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeCustomsEntriesConnection = Connection & {
  __typename?: 'DeCustomsEntriesConnection';
  edges: Array<DeCustomsEntryEdge>;
  nodes: Array<DeCustomsEntry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeCustomsEntry = Record & WorkOrder & {
  __typename?: 'DeCustomsEntry';
  /** Arrival information */
  arrival?: Maybe<CustomsEntryArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: DeCustomsEntryCustomsBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Consignee associated with this entry. */
  consignee?: Maybe<DeCustomsEntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<CustomsEntryDeparture>;
  /** The documents associated with the De Customs Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<DeCustomsEntryCommercialInvoice>>;
  /** IOR associated with this entry. */
  ior?: Maybe<DeCustomsEntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<CustomsEntryMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: Maybe<Array<Reference>>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: Maybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: Maybe<Scalars['Float']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type DeCustomsEntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type DeCustomsEntryCommercialInvoice = {
  __typename?: 'DeCustomsEntryCommercialInvoice';
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: Maybe<CustomsEntryBuyer>;
  /** Conveyance associated with the particular product. */
  conveyance?: Maybe<CustomsEntryConveyance>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: Maybe<Cost>;
  /** Commercial Invoice date */
  invoiceDate?: Maybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: Maybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<DeCustomsEntryProduct>>;
  /** Reason For Export */
  reasonsForExport?: Maybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<CustomsEntrySeller>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: Maybe<Cost>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: Maybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: Maybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type DeCustomsEntryCommercialInvoiceInput = {
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: InputMaybe<CustomsEntryBuyerInput>;
  /** Conveyance associated with the particular product. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: InputMaybe<CostInput>;
  /** Commercial Invoice date */
  invoiceDate?: InputMaybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: InputMaybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<DeCustomsEntryProductInput>>;
  /** Reason For Export */
  reasonsForExport?: InputMaybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<CustomsEntrySellerInput>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: InputMaybe<CostInput>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: InputMaybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type DeCustomsEntryConsignee = {
  __typename?: 'DeCustomsEntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Consignee details */
  consignee?: Maybe<Consignee>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: Maybe<Scalars['String']>;
};

export type DeCustomsEntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id version of the Consignee */
  consignee?: InputMaybe<IdVersionInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type DeCustomsEntryCustomsBroker = {
  __typename?: 'DeCustomsEntryCustomsBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type DeCustomsEntryCustomsBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type DeCustomsEntryEdge = ConnectionEdge & {
  __typename?: 'DeCustomsEntryEdge';
  cursor: Scalars['ID'];
  node: DeCustomsEntry;
};

export type DeCustomsEntryIor = {
  __typename?: 'DeCustomsEntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['DeEori']>;
  /** Ior party info which is stored in the record */
  ior?: Maybe<Ior>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['DeVatNumber']>;
};

export type DeCustomsEntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['DeEori']>;
  /** Ior party info which is stored in the record */
  ior?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['DeVatNumber']>;
};

export type DeCustomsEntryLine = {
  __typename?: 'DeCustomsEntryLine';
  /** The line assist value. */
  assist?: Maybe<Cost>;
  /** The line assist percentage. */
  assistPercentage?: Maybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<CustomsEntrySupplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<DeCustomsEntryTariff>>;
  /** The line value. */
  value?: Maybe<Cost>;
};

export type DeCustomsEntryLineInput = {
  /** The line assist value. */
  assist?: InputMaybe<CostInput>;
  /** The line assist percentage. */
  assistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<CustomsEntrySupplierInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<DeCustomsEntryTariffInput>>;
  /** The line value. */
  value?: InputMaybe<CostInput>;
};

export type DeCustomsEntryProduct = {
  __typename?: 'DeCustomsEntryProduct';
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: Maybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Line items within the Product. */
  lines?: Maybe<Array<DeCustomsEntryLine>>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type DeCustomsEntryProductInput = {
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<DeCustomsEntryLineInput>>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type DeCustomsEntrySearchCriteriaInput = {
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<CustomsEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's port of unlading. */
  portOfUnlading?: InputMaybe<TextSearchCriteriaInput>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: InputMaybe<ReferenceErrorCodeSearchCriteriaInput>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: InputMaybe<ReferenceProcessingStatusSearchCriteriaInput>;
  /** The type of reference */
  referenceType?: InputMaybe<ReferenceTypeSearchCriteriaInput>;
  /** The reference value */
  referenceValue?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** De Customs Entry Search Table Row */
export type DeCustomsEntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'DeCustomsEntrySearchTableRow';
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: Maybe<Scalars['String']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: Maybe<Scalars['String']>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: Maybe<Array<EntryReferenceErrorCode>>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: Maybe<Array<EntryReferenceProcessingStatus>>;
  /** The type of reference */
  referenceType?: Maybe<Array<ReferenceType>>;
  /** The reference value */
  referenceValue?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Array<Scalars['String']>>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type DeCustomsEntryTariff = {
  __typename?: 'DeCustomsEntryTariff';
  /** The HTS record. */
  hts?: Maybe<Hts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type DeCustomsEntryTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

/** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
export type DeEoriSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['DeEori']>>;
};

export type DeIor = EuIor & Ior & Party & Record & {
  __typename?: 'DeIor';
  /** Broker activations details of DeIor. */
  activations?: Maybe<Array<DeIorActivationDetails>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<BusinessStructure>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the DE IOR. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: Maybe<Scalars['DeEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this DE IOR */
  shipper: ShipperDeIorRelationship;
  /** Shipper connection used to paginate results. */
  shippers: DeIorShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['DeVatNumber']>;
  /** The record's version */
  version: Scalars['Int'];
};


export type DeIordocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type DeIormemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type DeIorshipperArgs = {
  shipperId: Scalars['ID'];
};


export type DeIorshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type DeIorActivation = Record & WorkOrder & {
  __typename?: 'DeIorActivation';
  /** DE Customs Broker associated with the activation. */
  broker: DeIorActivationBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the DE IOR Activation . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** DE IOR to be activated. */
  ior?: Maybe<DeIorActivationIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type DeIorActivationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type DeIorActivationBroker = {
  __typename?: 'DeIorActivationBroker';
  /** DE Customs Broker */
  customsBroker: DeCustomsBroker;
};

export type DeIorActivationBrokerInput = {
  /** ID of the DE Customs Broker */
  customsBroker: IdInput;
};

export type DeIorActivationDetails = {
  __typename?: 'DeIorActivationDetails';
  /** Importer activation meta data. */
  activated?: Maybe<RecordAction>;
  /** Broker representation for the Importer. */
  brokerRepresentation?: Maybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: DeCustomsBroker;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: Maybe<ExternalBrokerReference>;
  /** External Importer references. */
  externalIorReferences?: Maybe<Array<ExternalIorReference>>;
  /** Importer rejection meta data. */
  rejected?: Maybe<RecordAction>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: Maybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type DeIorActivationEdge = ConnectionEdge & {
  __typename?: 'DeIorActivationEdge';
  cursor: Scalars['ID'];
  node: DeIorActivation;
};

export type DeIorActivationIor = {
  __typename?: 'DeIorActivationIor';
  /** DeIor details */
  ior: DeIor;
};

export type DeIorActivationIorInput = {
  /** DeIor details */
  ior: IdOptionalVersionInput;
};

export type DeIorActivationSearchCriteriaInput = {
  /** IOR Activation Status. */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** Activation time of IOR. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The IOR ID */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Ior Name */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** DE IOR Activation search result */
export type DeIorActivationSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'DeIorActivationSearchTableRow';
  /** Activation status of EU IOR. */
  activationStatus?: Maybe<ActivationStatus>;
  /** Activation time of EU IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** The IOR ID */
  iorId?: Maybe<Scalars['ID']>;
  /** Ior Name */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type DeIorActivationsConnection = Connection & {
  __typename?: 'DeIorActivationsConnection';
  edges: Array<DeIorActivationEdge>;
  nodes: Array<DeIorActivation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeIorEdge = ConnectionEdge & {
  __typename?: 'DeIorEdge';
  cursor: Scalars['ID'];
  node: DeIor;
};

export type DeIorSearchCriteriaInput = {
  /** IOR activation status */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** IOR activation time */
  activationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<DeEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<DeVatNumberSearchCriteriaInput>;
};

export type DeIorSearchTableRow = {
  __typename?: 'DeIorSearchTableRow';
  /** IOR Activation status */
  activationStatus?: Maybe<Array<ActivationStatus>>;
  /** IOR Activation time */
  activationTime?: Maybe<Array<Scalars['DateTime']>>;
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['DeEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The type industry of the Ior. */
  industry?: Maybe<Vertical>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber: Scalars['DeVatNumber'];
  /** Version */
  version: Scalars['Int'];
};

export type DeIorShipperEdge = ConnectionEdge & {
  __typename?: 'DeIorShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and DE IOR. */
  relationship: ShipperDeIorRelationship;
};

export type DeIorShippersConnection = Connection & {
  __typename?: 'DeIorShippersConnection';
  edges: Array<DeIorShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DeIorsConnection = Connection & {
  __typename?: 'DeIorsConnection';
  edges: Array<DeIorEdge>;
  nodes: Array<DeIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
export type DeVatNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['DeVatNumber']>>;
};

/** Product search table row including supporting data not indexed to product record. */
export type DecoratedProductSearchTableRow = RecordSearchTableRow & {
  __typename?: 'DecoratedProductSearchTableRow';
  /** ASIN for this Product */
  asin?: Maybe<Scalars['String']>;
  /** The Product's description. */
  cbpDescription?: Maybe<Scalars['String']>;
  /** Client identifier for the product (eg, SKU, ASIN, etc). */
  clientIdentifier?: Maybe<Scalars['String']>;
  /** The country of origin of the Product. */
  countryName?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The country specific HS # of the Product in the form of country:HsNumber. */
  hsNumber?: Maybe<Array<Scalars['String']>>;
  /** The US HTS # of the Product. */
  htsNumber?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Importer of Record name. */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** The Product's name. */
  name?: Maybe<Scalars['String']>;
  /** Partner Government Agencies which apply to this Product's HTS codes. */
  pgaAgencyCode?: Maybe<Array<Scalars['String']>>;
  /** The Product's name. */
  productName?: Maybe<Scalars['String']>;
  /** The Shipper's name. */
  shipperName?: Maybe<Scalars['String']>;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status?: Maybe<Scalars['String']>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplierId?: Maybe<Array<Scalars['ID']>>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplierName?: Maybe<Array<Scalars['String']>>;
  /** The Product's name. */
  unitValue?: Maybe<Array<Scalars['Float']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type DecryptLoginPayload = {
  __typename?: 'DecryptLoginPayload';
  /** Decrypted email of the user */
  email: Scalars['String'];
  /** Decrypted password of the user */
  password: Scalars['String'];
};

/** Payload returned from the deleteAdCvdCase mutation. */
export type DeleteAdCvdCasePayload = {
  __typename?: 'DeleteAdCvdCasePayload';
  record: AdCvdCase;
};

/** The payload returned from the deleteAssignmentTeamOperatorUserRelationship mutation. */
export type DeleteAssignmentTeamOperatorUserRelationshipPayload = {
  __typename?: 'DeleteAssignmentTeamOperatorUserRelationshipPayload';
  /** The link deleted from unlinking the Assignment Team and Operator User Records. */
  relationship: AssignmentTeamOperatorUserRelationship;
};

/** Payload returned from the deleteAssignmentTeam mutation. */
export type DeleteAssignmentTeamPayload = {
  __typename?: 'DeleteAssignmentTeamPayload';
  record: AssignmentTeam;
};

/** Payload returned from the deleteAssignmentTeamStaticMapping mutation. */
export type DeleteAssignmentTeamStaticMappingPayload = {
  __typename?: 'DeleteAssignmentTeamStaticMappingPayload';
  record: AssignmentTeamStaticMapping;
};

/** Payload returned from the deleteAuthenticationToken mutation. */
export type DeleteAuthenticationTokenPayload = {
  __typename?: 'DeleteAuthenticationTokenPayload';
  record: AuthenticationToken;
};

/** Payload returned from the deleteBroker mutation. */
export type DeleteBrokerPayload = {
  __typename?: 'DeleteBrokerPayload';
  record: Broker;
};

/** Payload returned from the deleteBulkChargesUploadRequest mutation. */
export type DeleteBulkChargesUploadRequestPayload = {
  __typename?: 'DeleteBulkChargesUploadRequestPayload';
  record: BulkChargesUploadRequest;
};

/** Payload returned from the deleteBulkComplianceUploadRequest mutation. */
export type DeleteBulkComplianceUploadRequestPayload = {
  __typename?: 'DeleteBulkComplianceUploadRequestPayload';
  record: BulkComplianceUploadRequest;
};

/** Payload returned from the deleteBulkMilestoneUploadRequest mutation. */
export type DeleteBulkMilestoneUploadRequestPayload = {
  __typename?: 'DeleteBulkMilestoneUploadRequestPayload';
  record: BulkMilestoneUploadRequest;
};

/** Payload returned from the deleteBulkProductUploadTemplateDocumentGenerationRequest mutation. */
export type DeleteBulkProductUploadTemplateDocumentGenerationRequestPayload = {
  __typename?: 'DeleteBulkProductUploadTemplateDocumentGenerationRequestPayload';
  record: BulkProductUploadTemplateDocumentGenerationRequest;
};

/** The payload returned from the deleteBusinessSupportTeamOperatorUserRelationship mutation. */
export type DeleteBusinessSupportTeamOperatorUserRelationshipPayload = {
  __typename?: 'DeleteBusinessSupportTeamOperatorUserRelationshipPayload';
  /** The link deleted from unlinking the Business Support Team and Operator User Records. */
  relationship: BusinessSupportTeamOperatorUserRelationship;
};

/** Payload returned from the deleteBusinessSupportTeam mutation. */
export type DeleteBusinessSupportTeamPayload = {
  __typename?: 'DeleteBusinessSupportTeamPayload';
  record: BusinessSupportTeam;
};

/** Payload returned from the deleteCaseCategoryConfig mutation. */
export type DeleteCaseCategoryConfigPayload = {
  __typename?: 'DeleteCaseCategoryConfigPayload';
  record: CaseCategoryConfig;
};

/** Payload returned from the deleteCommodityGroup mutation. */
export type DeleteCommodityGroupPayload = {
  __typename?: 'DeleteCommodityGroupPayload';
  record: CommodityGroup;
};

/** Payload returned from the deleteCustomDomain mutation. */
export type DeleteCustomDomainPayload = {
  __typename?: 'DeleteCustomDomainPayload';
  record: CustomDomain;
};

/** Payload returned from the deleteCustomsAgent mutation. */
export type DeleteCustomsAgentPayload = {
  __typename?: 'DeleteCustomsAgentPayload';
  record: CustomsAgent;
};

/** Payload returned from the deleteCustomsDeclaration mutation. */
export type DeleteCustomsDeclarationPayload = {
  __typename?: 'DeleteCustomsDeclarationPayload';
  record: CustomsDeclaration;
};

/** Payload returned from the deleteCustomsEntry mutation. */
export type DeleteCustomsEntryPayload = {
  __typename?: 'DeleteCustomsEntryPayload';
  record: CustomsEntry;
};

/** Payload returned from the deleteDeConsignee mutation. */
export type DeleteDeConsigneePayload = {
  __typename?: 'DeleteDeConsigneePayload';
  record: DeConsignee;
};

/** Payload returned from the deleteDeCustomsBroker mutation. */
export type DeleteDeCustomsBrokerPayload = {
  __typename?: 'DeleteDeCustomsBrokerPayload';
  record: DeCustomsBroker;
};

/** Payload returned from the deleteDeCustomsEntry mutation. */
export type DeleteDeCustomsEntryPayload = {
  __typename?: 'DeleteDeCustomsEntryPayload';
  record: DeCustomsEntry;
};

/** Payload returned from the deleteDeIorActivation mutation. */
export type DeleteDeIorActivationPayload = {
  __typename?: 'DeleteDeIorActivationPayload';
  record: DeIorActivation;
};

/** Payload returned from the deleteDeIor mutation. */
export type DeleteDeIorPayload = {
  __typename?: 'DeleteDeIorPayload';
  record: DeIor;
};

/** Payload returned from the deleteDeliveryOrderDocumentGenerationRequest mutation. */
export type DeleteDeliveryOrderDocumentGenerationRequestPayload = {
  __typename?: 'DeleteDeliveryOrderDocumentGenerationRequestPayload';
  record: DeliveryOrderDocumentGenerationRequest;
};

/** Payload returned from the deleteDeliveryOrder mutation. */
export type DeleteDeliveryOrderPayload = {
  __typename?: 'DeleteDeliveryOrderPayload';
  record: DeliveryOrder;
};

/** Payload returned from the deleteDocument mutation. */
export type DeleteDocumentPayload = {
  __typename?: 'DeleteDocumentPayload';
  record: Document;
};

/** Payload returned from the deleteDocumentTemplate mutation. */
export type DeleteDocumentTemplatePayload = {
  __typename?: 'DeleteDocumentTemplatePayload';
  record: DocumentTemplate;
};

/** Payload returned from the deleteDpsRecord mutation. */
export type DeleteDpsRecordPayload = {
  __typename?: 'DeleteDpsRecordPayload';
  record: DpsRecord;
};

/** Payload returned from the deleteEuHs mutation. */
export type DeleteEuHsPayload = {
  __typename?: 'DeleteEuHsPayload';
  record: EuHs;
};

/** Payload returned from the deleteExcelTemplateDocumentGenerationRequest mutation. */
export type DeleteExcelTemplateDocumentGenerationRequestPayload = {
  __typename?: 'DeleteExcelTemplateDocumentGenerationRequestPayload';
  record: ExcelTemplateDocumentGenerationRequest;
};

/** Payload returned from the deleteExchangeMessage mutation. */
export type DeleteExchangeMessagePayload = {
  __typename?: 'DeleteExchangeMessagePayload';
  record: ExchangeMessage;
};

/** Payload returned from the deleteFacility mutation. */
export type DeleteFacilityPayload = {
  __typename?: 'DeleteFacilityPayload';
  record: Facility;
};

/** Payload returned from the deleteFeatureFlag mutation. */
export type DeleteFeatureFlagPayload = {
  __typename?: 'DeleteFeatureFlagPayload';
  record: FeatureFlag;
};

/** Payload returned from the deleteForwarder mutation. */
export type DeleteForwarderPayload = {
  __typename?: 'DeleteForwarderPayload';
  record: Forwarder;
};

/** Payload returned from the deleteForwarderSystem mutation. */
export type DeleteForwarderSystemPayload = {
  __typename?: 'DeleteForwarderSystemPayload';
  record: ForwarderSystem;
};

/** Payload returned from the deleteForwarderUser mutation. */
export type DeleteForwarderUserPayload = {
  __typename?: 'DeleteForwarderUserPayload';
  record: ForwarderUser;
};

/** Payload returned from the deleteFrConsignee mutation. */
export type DeleteFrConsigneePayload = {
  __typename?: 'DeleteFrConsigneePayload';
  record: FrConsignee;
};

/** Payload returned from the deleteFrCustomsBroker mutation. */
export type DeleteFrCustomsBrokerPayload = {
  __typename?: 'DeleteFrCustomsBrokerPayload';
  record: FrCustomsBroker;
};

/** Payload returned from the deleteFrCustomsEntry mutation. */
export type DeleteFrCustomsEntryPayload = {
  __typename?: 'DeleteFrCustomsEntryPayload';
  record: FrCustomsEntry;
};

/** Payload returned from the deleteFrIorActivation mutation. */
export type DeleteFrIorActivationPayload = {
  __typename?: 'DeleteFrIorActivationPayload';
  record: FrIorActivation;
};

/** Payload returned from the deleteFrIor mutation. */
export type DeleteFrIorPayload = {
  __typename?: 'DeleteFrIorPayload';
  record: FrIor;
};

/** Payload returned from the deleteGbConsignee mutation. */
export type DeleteGbConsigneePayload = {
  __typename?: 'DeleteGbConsigneePayload';
  record: GbConsignee;
};

/** Payload returned from the deleteGbCustomsEntry mutation. */
export type DeleteGbCustomsEntryPayload = {
  __typename?: 'DeleteGbCustomsEntryPayload';
  record: GbCustomsEntry;
};

/** Payload returned from the deleteGbIorActivation mutation. */
export type DeleteGbIorActivationPayload = {
  __typename?: 'DeleteGbIorActivationPayload';
  record: GbIorActivation;
};

/** Payload returned from the deleteGbIor mutation. */
export type DeleteGbIorPayload = {
  __typename?: 'DeleteGbIorPayload';
  record: GbIor;
};

/** Payload returned from the deleteGenericDocumentGenerationRequest mutation. */
export type DeleteGenericDocumentGenerationRequestPayload = {
  __typename?: 'DeleteGenericDocumentGenerationRequestPayload';
  record: GenericDocumentGenerationRequest;
};

/** Payload returned from the deleteGlobalConsignee mutation. */
export type DeleteGlobalConsigneePayload = {
  __typename?: 'DeleteGlobalConsigneePayload';
  record: GlobalConsignee;
};

/** Payload returned from the deleteHtmlDocumentGenerationRequest mutation. */
export type DeleteHtmlDocumentGenerationRequestPayload = {
  __typename?: 'DeleteHtmlDocumentGenerationRequestPayload';
  record: HtmlDocumentGenerationRequest;
};

/** Payload returned from the deleteHts mutation. */
export type DeleteHtsPayload = {
  __typename?: 'DeleteHtsPayload';
  record: Hts;
};

/** Payload returned from the deleteImportProductsFromBulkUploadRequest mutation. */
export type DeleteImportProductsFromBulkUploadRequestPayload = {
  __typename?: 'DeleteImportProductsFromBulkUploadRequestPayload';
  record: ImportProductsFromBulkUploadRequest;
};

/** Payload returned from the deleteImportProductsFromCustomsEntriesRequest mutation. */
export type DeleteImportProductsFromCustomsEntriesRequestPayload = {
  __typename?: 'DeleteImportProductsFromCustomsEntriesRequestPayload';
  record: ImportProductsFromCustomsEntriesRequest;
};

/** Payload returned from the deleteImporterEntityActivation mutation. */
export type DeleteImporterEntityActivationPayload = {
  __typename?: 'DeleteImporterEntityActivationPayload';
  record: ImporterEntityActivation;
};

/** Payload returned from the deleteImporterEntity mutation. */
export type DeleteImporterEntityPayload = {
  __typename?: 'DeleteImporterEntityPayload';
  record: ImporterEntity;
};

/** The payload returned from the deleteImporterImporterEntityRelationship mutation. */
export type DeleteImporterImporterEntityRelationshipPayload = {
  __typename?: 'DeleteImporterImporterEntityRelationshipPayload';
  /** The link deleted from unlinking the Importer and Importer Entity Records. */
  relationship: ImporterImporterEntityRelationship;
};

/** Payload returned from the deleteImporter mutation. */
export type DeleteImporterPayload = {
  __typename?: 'DeleteImporterPayload';
  record: Importer;
};

/** The US CBP ABI transaction to delete a US In-Bond, CATAIR appCode: QP(actionCode: B)/QT. */
export type DeleteInBondBillCbpInput = {
  /** The index of the CbpInBondBill in the bills array of the CbpInBond the transaction is being created for. If we provide a cbpInBondBillIndex, the transaction is for that specific bill */
  cbpInBondBillIndex: Scalars['Int'];
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type DeleteInBondBillCbpPayload = {
  __typename?: 'DeleteInBondBillCbpPayload';
  /** The Transaction. */
  transaction: DeleteInBondBillCbpTransaction;
};

/** The US CBP ABI transaction to delete a US In-Bond, CATAIR appCode: QP(actionCode: B)/QT. */
export type DeleteInBondBillCbpTransaction = Record & UsInBondCbpTransaction & {
  __typename?: 'DeleteInBondBillCbpTransaction';
  /** The index of the CbpInBondBill in the bills array of the CbpInBond the transaction is being created for. If we provide a cbpInBondBillIndex, the transaction is for that specific bill */
  cbpInBondBillIndex: Scalars['Int'];
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US In-Bond */
  usInBond: UsInBond;
  /** The record's version */
  version: Scalars['Int'];
};

/** The US CBP ABI transaction to delete a US In-Bond, CATAIR appCode: QP(actionCode: D)/QT. */
export type DeleteInBondCbpInput = {
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type DeleteInBondCbpPayload = {
  __typename?: 'DeleteInBondCbpPayload';
  /** The Transaction. */
  transaction: DeleteInBondCbpTransaction;
};

/** The US CBP ABI transaction to delete a US In-Bond, CATAIR appCode: QP(actionCode: D)/QT. */
export type DeleteInBondCbpTransaction = Record & UsInBondCbpTransaction & {
  __typename?: 'DeleteInBondCbpTransaction';
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US In-Bond */
  usInBond: UsInBond;
  /** The record's version */
  version: Scalars['Int'];
};

/** Payload returned from the deleteInBondNotesDocumentGenerationRequest mutation. */
export type DeleteInBondNotesDocumentGenerationRequestPayload = {
  __typename?: 'DeleteInBondNotesDocumentGenerationRequestPayload';
  record: InBondNotesDocumentGenerationRequest;
};

/** Payload returned from the deleteInvoiceCreditNoteDocumentGenerationRequest mutation. */
export type DeleteInvoiceCreditNoteDocumentGenerationRequestPayload = {
  __typename?: 'DeleteInvoiceCreditNoteDocumentGenerationRequestPayload';
  record: InvoiceCreditNoteDocumentGenerationRequest;
};

/** Payload returned from the deleteInvoiceCreditNote mutation. */
export type DeleteInvoiceCreditNotePayload = {
  __typename?: 'DeleteInvoiceCreditNotePayload';
  record: InvoiceCreditNote;
};

/** Payload returned from the deleteInvoiceDocumentGenerationRequest mutation. */
export type DeleteInvoiceDocumentGenerationRequestPayload = {
  __typename?: 'DeleteInvoiceDocumentGenerationRequestPayload';
  record: InvoiceDocumentGenerationRequest;
};

/** Payload returned from the deleteInvoiceLinesRequest mutation. */
export type DeleteInvoiceLinesRequestPayload = {
  __typename?: 'DeleteInvoiceLinesRequestPayload';
  record: InvoiceLinesRequest;
};

/** Payload returned from the deleteInvoice mutation. */
export type DeleteInvoicePayload = {
  __typename?: 'DeleteInvoicePayload';
  record: Invoice;
};

/** Payload returned from the deleteInvoicePayment mutation. */
export type DeleteInvoicePaymentPayload = {
  __typename?: 'DeleteInvoicePaymentPayload';
  record: InvoicePayment;
};

/** Payload returned from the deleteMemo mutation. */
export type DeleteMemoPayload = {
  __typename?: 'DeleteMemoPayload';
  record: Memo;
};

/** Payload returned from the deleteNlConsignee mutation. */
export type DeleteNlConsigneePayload = {
  __typename?: 'DeleteNlConsigneePayload';
  record: NlConsignee;
};

/** Payload returned from the deleteNlCustomsBroker mutation. */
export type DeleteNlCustomsBrokerPayload = {
  __typename?: 'DeleteNlCustomsBrokerPayload';
  record: NlCustomsBroker;
};

/** Payload returned from the deleteNlCustomsEntry mutation. */
export type DeleteNlCustomsEntryPayload = {
  __typename?: 'DeleteNlCustomsEntryPayload';
  record: NlCustomsEntry;
};

/** Payload returned from the deleteNlIorActivation mutation. */
export type DeleteNlIorActivationPayload = {
  __typename?: 'DeleteNlIorActivationPayload';
  record: NlIorActivation;
};

/** Payload returned from the deleteNlIor mutation. */
export type DeleteNlIorPayload = {
  __typename?: 'DeleteNlIorPayload';
  record: NlIor;
};

/** Payload returned from the deleteOnboardingRequest mutation. */
export type DeleteOnboardingRequestPayload = {
  __typename?: 'DeleteOnboardingRequestPayload';
  record: OnboardingRequest;
};

/** Payload returned from the deleteOperator mutation. */
export type DeleteOperatorPayload = {
  __typename?: 'DeleteOperatorPayload';
  record: Operator;
};

/** Payload returned from the deleteOperatorSystem mutation. */
export type DeleteOperatorSystemPayload = {
  __typename?: 'DeleteOperatorSystemPayload';
  record: OperatorSystem;
};

/** Payload returned from the deleteOperatorUser mutation. */
export type DeleteOperatorUserPayload = {
  __typename?: 'DeleteOperatorUserPayload';
  record: OperatorUser;
};

/** Payload returned from the deletePayableInvoice mutation. */
export type DeletePayableInvoicePayload = {
  __typename?: 'DeletePayableInvoicePayload';
  record: PayableInvoice;
};

/** Payload returned from the deleteProduct mutation. */
export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  record: Product;
};

/** Payload returned from the deleteReleaseNote mutation. */
export type DeleteReleaseNotePayload = {
  __typename?: 'DeleteReleaseNotePayload';
  record: ReleaseNote;
};

/** Payload returned from the deleteReportReconciliationRequest mutation. */
export type DeleteReportReconciliationRequestPayload = {
  __typename?: 'DeleteReportReconciliationRequestPayload';
  record: ReportReconciliationRequest;
};

/** Payload returned from the deleteShipmentCommercialInvoiceDetail mutation. */
export type DeleteShipmentCommercialInvoiceDetailPayload = {
  __typename?: 'DeleteShipmentCommercialInvoiceDetailPayload';
  record: ShipmentCommercialInvoiceDetail;
};

/** Payload returned from the deleteShipmentDocumentProcessingRequest mutation. */
export type DeleteShipmentDocumentProcessingRequestPayload = {
  __typename?: 'DeleteShipmentDocumentProcessingRequestPayload';
  record: ShipmentDocumentProcessingRequest;
};

/** Payload returned from the deleteShipment mutation. */
export type DeleteShipmentPayload = {
  __typename?: 'DeleteShipmentPayload';
  record: Shipment;
};

/** The payload returned from the deleteShipperBrokerRelationship mutation. */
export type DeleteShipperBrokerRelationshipPayload = {
  __typename?: 'DeleteShipperBrokerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Broker Records. */
  relationship: ShipperBrokerRelationship;
};

/** The payload returned from the deleteShipperCustomsAgentRelationship mutation. */
export type DeleteShipperCustomsAgentRelationshipPayload = {
  __typename?: 'DeleteShipperCustomsAgentRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Customs Agent Records. */
  relationship: ShipperCustomsAgentRelationship;
};

/** The payload returned from the deleteShipperDeConsigneeRelationship mutation. */
export type DeleteShipperDeConsigneeRelationshipPayload = {
  __typename?: 'DeleteShipperDeConsigneeRelationshipPayload';
  /** The link deleted from unlinking the Shipper and DE Consignee Records. */
  relationship: ShipperDeConsigneeRelationship;
};

/** The payload returned from the deleteShipperDeCustomsBrokerRelationship mutation. */
export type DeleteShipperDeCustomsBrokerRelationshipPayload = {
  __typename?: 'DeleteShipperDeCustomsBrokerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and De Customs Broker Records. */
  relationship: ShipperDeCustomsBrokerRelationship;
};

/** The payload returned from the deleteShipperDeIorRelationship mutation. */
export type DeleteShipperDeIorRelationshipPayload = {
  __typename?: 'DeleteShipperDeIorRelationshipPayload';
  /** The link deleted from unlinking the Shipper and DE IOR Records. */
  relationship: ShipperDeIorRelationship;
};

/** The payload returned from the deleteShipperFacilityRelationship mutation. */
export type DeleteShipperFacilityRelationshipPayload = {
  __typename?: 'DeleteShipperFacilityRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Facility Records. */
  relationship: ShipperFacilityRelationship;
};

/** The payload returned from the deleteShipperForwarderRelationship mutation. */
export type DeleteShipperForwarderRelationshipPayload = {
  __typename?: 'DeleteShipperForwarderRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Freight Forwarder Records. */
  relationship: ShipperForwarderRelationship;
};

/** The payload returned from the deleteShipperFrConsigneeRelationship mutation. */
export type DeleteShipperFrConsigneeRelationshipPayload = {
  __typename?: 'DeleteShipperFrConsigneeRelationshipPayload';
  /** The link deleted from unlinking the Shipper and FR Consignee Records. */
  relationship: ShipperFrConsigneeRelationship;
};

/** The payload returned from the deleteShipperFrCustomsBrokerRelationship mutation. */
export type DeleteShipperFrCustomsBrokerRelationshipPayload = {
  __typename?: 'DeleteShipperFrCustomsBrokerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and FR Customs Broker Records. */
  relationship: ShipperFrCustomsBrokerRelationship;
};

/** The payload returned from the deleteShipperFrIorRelationship mutation. */
export type DeleteShipperFrIorRelationshipPayload = {
  __typename?: 'DeleteShipperFrIorRelationshipPayload';
  /** The link deleted from unlinking the Shipper and FR IOR Records. */
  relationship: ShipperFrIorRelationship;
};

/** The payload returned from the deleteShipperGbConsigneeRelationship mutation. */
export type DeleteShipperGbConsigneeRelationshipPayload = {
  __typename?: 'DeleteShipperGbConsigneeRelationshipPayload';
  /** The link deleted from unlinking the Shipper and GB Consignee Records. */
  relationship: ShipperGbConsigneeRelationship;
};

/** The payload returned from the deleteShipperGbIorRelationship mutation. */
export type DeleteShipperGbIorRelationshipPayload = {
  __typename?: 'DeleteShipperGbIorRelationshipPayload';
  /** The link deleted from unlinking the Shipper and GB IOR Records. */
  relationship: ShipperGbIorRelationship;
};

/** The payload returned from the deleteShipperGlobalConsigneeRelationship mutation. */
export type DeleteShipperGlobalConsigneeRelationshipPayload = {
  __typename?: 'DeleteShipperGlobalConsigneeRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Global Consignee Records. */
  relationship: ShipperGlobalConsigneeRelationship;
};

/** The payload returned from the deleteShipperImporterRelationship mutation. */
export type DeleteShipperImporterRelationshipPayload = {
  __typename?: 'DeleteShipperImporterRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Importer Records. */
  relationship: ShipperImporterRelationship;
};

/** The payload returned from the deleteShipperNlConsigneeRelationship mutation. */
export type DeleteShipperNlConsigneeRelationshipPayload = {
  __typename?: 'DeleteShipperNlConsigneeRelationshipPayload';
  /** The link deleted from unlinking the Shipper and NL Consignee Records. */
  relationship: ShipperNlConsigneeRelationship;
};

/** The payload returned from the deleteShipperNlCustomsBrokerRelationship mutation. */
export type DeleteShipperNlCustomsBrokerRelationshipPayload = {
  __typename?: 'DeleteShipperNlCustomsBrokerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and NL Customs Broker Records. */
  relationship: ShipperNlCustomsBrokerRelationship;
};

/** The payload returned from the deleteShipperNlIorRelationship mutation. */
export type DeleteShipperNlIorRelationshipPayload = {
  __typename?: 'DeleteShipperNlIorRelationshipPayload';
  /** The link deleted from unlinking the Shipper and NL IOR Records. */
  relationship: ShipperNlIorRelationship;
};

/** Payload returned from the deleteShipper mutation. */
export type DeleteShipperPayload = {
  __typename?: 'DeleteShipperPayload';
  record: Shipper;
};

/** The payload returned from the deleteShipperSupplierRelationship mutation. */
export type DeleteShipperSupplierRelationshipPayload = {
  __typename?: 'DeleteShipperSupplierRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Supplier Records. */
  relationship: ShipperSupplierRelationship;
};

/** Payload returned from the deleteShipperSystem mutation. */
export type DeleteShipperSystemPayload = {
  __typename?: 'DeleteShipperSystemPayload';
  record: ShipperSystem;
};

/** The payload returned from the deleteShipperTruckerRelationship mutation. */
export type DeleteShipperTruckerRelationshipPayload = {
  __typename?: 'DeleteShipperTruckerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and Trucker Records. */
  relationship: ShipperTruckerRelationship;
};

/** The payload returned from the deleteShipperUkCustomsBrokerRelationship mutation. */
export type DeleteShipperUkCustomsBrokerRelationshipPayload = {
  __typename?: 'DeleteShipperUkCustomsBrokerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and UK Customs Broker Records. */
  relationship: ShipperUkCustomsBrokerRelationship;
};

/** The payload returned from the deleteShipperUsConsigneeRelationship mutation. */
export type DeleteShipperUsConsigneeRelationshipPayload = {
  __typename?: 'DeleteShipperUsConsigneeRelationshipPayload';
  /** The link deleted from unlinking the Shipper and US Consignee Records. */
  relationship: ShipperUsConsigneeRelationship;
};

/** The payload returned from the deleteShipperUsCustomsBrokerRelationship mutation. */
export type DeleteShipperUsCustomsBrokerRelationshipPayload = {
  __typename?: 'DeleteShipperUsCustomsBrokerRelationshipPayload';
  /** The link deleted from unlinking the Shipper and US Customs Broker Records. */
  relationship: ShipperUsCustomsBrokerRelationship;
};

/** The payload returned from the deleteShipperUsIorRelationship mutation. */
export type DeleteShipperUsIorRelationshipPayload = {
  __typename?: 'DeleteShipperUsIorRelationshipPayload';
  /** The link deleted from unlinking the Shipper and US IOR Records. */
  relationship: ShipperUsIorRelationship;
};

/** Payload returned from the deleteShipperUser mutation. */
export type DeleteShipperUserPayload = {
  __typename?: 'DeleteShipperUserPayload';
  record: ShipperUser;
};

/** Payload returned from the deleteStampDocumentGenerationRequest mutation. */
export type DeleteStampDocumentGenerationRequestPayload = {
  __typename?: 'DeleteStampDocumentGenerationRequestPayload';
  record: StampDocumentGenerationRequest;
};

/** Payload returned from the deleteStampDocumentSignRequest mutation. */
export type DeleteStampDocumentSignRequestPayload = {
  __typename?: 'DeleteStampDocumentSignRequestPayload';
  record: StampDocumentSignRequest;
};

/** The payload returned from the deleteSubjectMatterExpertTeamOperatorUserRelationship mutation. */
export type DeleteSubjectMatterExpertTeamOperatorUserRelationshipPayload = {
  __typename?: 'DeleteSubjectMatterExpertTeamOperatorUserRelationshipPayload';
  /** The link deleted from unlinking the Subject Matter Expert Team and Operator User Records. */
  relationship: SubjectMatterExpertTeamOperatorUserRelationship;
};

/** Payload returned from the deleteSubjectMatterExpertTeam mutation. */
export type DeleteSubjectMatterExpertTeamPayload = {
  __typename?: 'DeleteSubjectMatterExpertTeamPayload';
  record: SubjectMatterExpertTeam;
};

/** Payload returned from the deleteSupplier mutation. */
export type DeleteSupplierPayload = {
  __typename?: 'DeleteSupplierPayload';
  record: Supplier;
};

/** Payload returned from the deleteTableFilter mutation. */
export type DeleteTableFilterPayload = {
  __typename?: 'DeleteTableFilterPayload';
  record: TableFilter;
};

/** Payload returned from the deleteTeam mutation. */
export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  record: Team;
};

/** Payload returned from the deleteTemplateDocumentSignRequest mutation. */
export type DeleteTemplateDocumentSignRequestPayload = {
  __typename?: 'DeleteTemplateDocumentSignRequestPayload';
  record: TemplateDocumentSignRequest;
};

/** Payload returned from the deleteTradeAdvisoryRequest mutation. */
export type DeleteTradeAdvisoryRequestPayload = {
  __typename?: 'DeleteTradeAdvisoryRequestPayload';
  record: TradeAdvisoryRequest;
};

/** Payload returned from the deleteTrucker mutation. */
export type DeleteTruckerPayload = {
  __typename?: 'DeleteTruckerPayload';
  record: Trucker;
};

/** Payload returned from the deleteUkCustomsBroker mutation. */
export type DeleteUkCustomsBrokerPayload = {
  __typename?: 'DeleteUkCustomsBrokerPayload';
  record: UkCustomsBroker;
};

/** Payload returned from the deleteUkHs mutation. */
export type DeleteUkHsPayload = {
  __typename?: 'DeleteUkHsPayload';
  record: UkHs;
};

/** Payload returned from the deleteUsCargoReleaseDocumentGenerationRequest mutation. */
export type DeleteUsCargoReleaseDocumentGenerationRequestPayload = {
  __typename?: 'DeleteUsCargoReleaseDocumentGenerationRequestPayload';
  record: UsCargoReleaseDocumentGenerationRequest;
};

/** Payload returned from the deleteUsCbp5106DocumentGenerationRequest mutation. */
export type DeleteUsCbp5106DocumentGenerationRequestPayload = {
  __typename?: 'DeleteUsCbp5106DocumentGenerationRequestPayload';
  record: UsCbp5106DocumentGenerationRequest;
};

/** Payload returned from the deleteUsCbp7501DocumentGenerationRequest mutation. */
export type DeleteUsCbp7501DocumentGenerationRequestPayload = {
  __typename?: 'DeleteUsCbp7501DocumentGenerationRequestPayload';
  record: UsCbp7501DocumentGenerationRequest;
};

/** Payload returned from the deleteUsCbp7512DocumentGenerationRequest mutation. */
export type DeleteUsCbp7512DocumentGenerationRequestPayload = {
  __typename?: 'DeleteUsCbp7512DocumentGenerationRequestPayload';
  record: UsCbp7512DocumentGenerationRequest;
};

/** The reason the entry release is being deleted. */
export enum DeleteUsCbpEntryReleaseReason {
  CLERICAL_ERROR = 'CLERICAL_ERROR',
  MERCHANDISE_DESTROYED = 'MERCHANDISE_DESTROYED',
  MERCHANDISE_SEIZED = 'MERCHANDISE_SEIZED',
  NON_ARRIVAL = 'NON_ARRIVAL',
  NOT_AUTHORIZED_FOR_IMPORT = 'NOT_AUTHORIZED_FOR_IMPORT',
  NO_FOREIGN_STATUS_GOOD_REMOVED_FROM_FTZ = 'NO_FOREIGN_STATUS_GOOD_REMOVED_FROM_FTZ',
  REFUSED_BY_IMPORTER = 'REFUSED_BY_IMPORTER',
  REPLACED_BY_FORMAL_ENTRY = 'REPLACED_BY_FORMAL_ENTRY',
  REPLACED_BY_FTZ_ADMISSION = 'REPLACED_BY_FTZ_ADMISSION',
  REPLACED_BY_INFORMAL_ENTRY = 'REPLACED_BY_INFORMAL_ENTRY',
  REPLACED_BY_IN_BOND = 'REPLACED_BY_IN_BOND',
  SYSTEM_ERROR = 'SYSTEM_ERROR'
}

/** Payload returned from the deleteUsConsignee mutation. */
export type DeleteUsConsigneePayload = {
  __typename?: 'DeleteUsConsigneePayload';
  record: UsConsignee;
};

/** Payload returned from the deleteUsConsumptionEntry mutation. */
export type DeleteUsConsumptionEntryPayload = {
  __typename?: 'DeleteUsConsumptionEntryPayload';
  record: UsConsumptionEntry;
};

/** Input parameters to submit a delete entry request to US CBP. */
export type DeleteUsConsumptionEntryReleaseCbpInput = {
  /** The reason required by CBP to delete the entry release (SE) data. */
  reason: DeleteUsCbpEntryReleaseReason;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_FORMAL_ENTRY. */
  replacementEntryNumber?: InputMaybe<Scalars['String']>;
  /** FTZ Admission number that replaces the entry. Required if reason is REPLACED_BY_FTZ_ADMISSION. */
  replacementFtzAdmissionNumber?: InputMaybe<Scalars['String']>;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_IN_BOND. */
  replacementInBondNumber?: InputMaybe<Scalars['String']>;
};

/** The payload returned from triggering the Transaction. */
export type DeleteUsConsumptionEntryReleaseCbpPayload = {
  __typename?: 'DeleteUsConsumptionEntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: DeleteUsConsumptionEntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to delete a US Consumption Entry Release, CATAIR appCode: SE/SX. */
export type DeleteUsConsumptionEntryReleaseCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'DeleteUsConsumptionEntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The reason required by CBP to delete the entry release (SE) data. */
  reason: DeleteUsCbpEntryReleaseReason;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_FORMAL_ENTRY. */
  replacementEntryNumber?: Maybe<Scalars['String']>;
  /** FTZ Admission number that replaces the entry. Required if reason is REPLACED_BY_FTZ_ADMISSION. */
  replacementFtzAdmissionNumber?: Maybe<Scalars['String']>;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_IN_BOND. */
  replacementInBondNumber?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type DeleteUsConsumptionEntrySummaryCbpPayload = {
  __typename?: 'DeleteUsConsumptionEntrySummaryCbpPayload';
  /** The Transaction. */
  transaction: DeleteUsConsumptionEntrySummaryCbpTransaction;
};

/** The US CBP ABI transaction to delete a US Consumption Entry Summary, CATAIR appCode: AE/AX, actionCode: D */
export type DeleteUsConsumptionEntrySummaryCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'DeleteUsConsumptionEntrySummaryCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Payload returned from the deleteUsCustomsBroker mutation. */
export type DeleteUsCustomsBrokerPayload = {
  __typename?: 'DeleteUsCustomsBrokerPayload';
  record: UsCustomsBroker;
};

/** Payload returned from the deleteUsDrawbackClaimDocumentGenerationRequest mutation. */
export type DeleteUsDrawbackClaimDocumentGenerationRequestPayload = {
  __typename?: 'DeleteUsDrawbackClaimDocumentGenerationRequestPayload';
  record: UsDrawbackClaimDocumentGenerationRequest;
};

/** Payload returned from the deleteUsDrawbackClaim mutation. */
export type DeleteUsDrawbackClaimPayload = {
  __typename?: 'DeleteUsDrawbackClaimPayload';
  record: UsDrawbackClaim;
};

/** Payload returned from the deleteUsHts mutation. */
export type DeleteUsHtsPayload = {
  __typename?: 'DeleteUsHtsPayload';
  record: UsHts;
};

/** Payload returned from the deleteUsInBond mutation. */
export type DeleteUsInBondPayload = {
  __typename?: 'DeleteUsInBondPayload';
  record: UsInBond;
};

/** Payload returned from the deleteUsIorActivation mutation. */
export type DeleteUsIorActivationPayload = {
  __typename?: 'DeleteUsIorActivationPayload';
  record: UsIorActivation;
};

/** Payload returned from the deleteUsIorContinuousBondRequest mutation. */
export type DeleteUsIorContinuousBondRequestPayload = {
  __typename?: 'DeleteUsIorContinuousBondRequestPayload';
  record: UsIorContinuousBondRequest;
};

/** Payload returned from the deleteUsIor mutation. */
export type DeleteUsIorPayload = {
  __typename?: 'DeleteUsIorPayload';
  record: UsIor;
};

/** The payload returned from triggering the Transaction. */
export type DeleteUsIsfCbpPayload = {
  __typename?: 'DeleteUsIsfCbpPayload';
  /** The Transaction. */
  transaction: DeleteUsIsfCbpTransaction;
};

/** The US CBP ABI transaction to delete a US ISF, CATAIR appcode: SF/SN. */
export type DeleteUsIsfCbpTransaction = Record & UsIsfCbpTransaction & {
  __typename?: 'DeleteUsIsfCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US ISF */
  usIsf: UsIsf;
  /** The record's version */
  version: Scalars['Int'];
};

/** Payload returned from the deleteUsIsf mutation. */
export type DeleteUsIsfPayload = {
  __typename?: 'DeleteUsIsfPayload';
  record: UsIsf;
};

/** Payload returned from the deleteUsPostSummaryCorrection mutation. */
export type DeleteUsPostSummaryCorrectionPayload = {
  __typename?: 'DeleteUsPostSummaryCorrectionPayload';
  record: UsPostSummaryCorrection;
};

/** Payload returned from the deleteUsPrincipalAdCvdCase mutation. */
export type DeleteUsPrincipalAdCvdCasePayload = {
  __typename?: 'DeleteUsPrincipalAdCvdCasePayload';
  record: UsPrincipalAdCvdCase;
};

/** Payload returned from the deleteUsType86Entry mutation. */
export type DeleteUsType86EntryPayload = {
  __typename?: 'DeleteUsType86EntryPayload';
  record: UsType86Entry;
};

/** Input parameters to submit a delete entry request to US CBP. */
export type DeleteUsType86EntryReleaseCbpInput = {
  /** The reason required by CBP to delete the entry release (SE) data. */
  reason: DeleteUsCbpEntryReleaseReason;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_FORMAL_ENTRY. */
  replacementEntryNumber?: InputMaybe<Scalars['String']>;
  /** FTZ Admission number that replaces the entry. Required if reason is REPLACED_BY_FTZ_ADMISSION. */
  replacementFtzAdmissionNumber?: InputMaybe<Scalars['String']>;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_IN_BOND. */
  replacementInBondNumber?: InputMaybe<Scalars['String']>;
};

/** The payload returned from triggering the Transaction. */
export type DeleteUsType86EntryReleaseCbpPayload = {
  __typename?: 'DeleteUsType86EntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: DeleteUsType86EntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to delete a US Type86 Entry Release, CATAIR appCode: SE/SX. */
export type DeleteUsType86EntryReleaseCbpTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'DeleteUsType86EntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The reason required by CBP to delete the entry release (SE) data. */
  reason: DeleteUsCbpEntryReleaseReason;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_FORMAL_ENTRY. */
  replacementEntryNumber?: Maybe<Scalars['String']>;
  /** FTZ Admission number that replaces the entry. Required if reason is REPLACED_BY_FTZ_ADMISSION. */
  replacementFtzAdmissionNumber?: Maybe<Scalars['String']>;
  /** In-bond number that replaces the entry. Required if reason is REPLACED_BY_IN_BOND. */
  replacementInBondNumber?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Payload returned from the deleteUserReleaseNoteView mutation. */
export type DeleteUserReleaseNoteViewPayload = {
  __typename?: 'DeleteUserReleaseNoteViewPayload';
  record: UserReleaseNoteView;
};

/** Payload returned from the deleteWorkOrderConfirmation mutation. */
export type DeleteWorkOrderConfirmationPayload = {
  __typename?: 'DeleteWorkOrderConfirmationPayload';
  record: WorkOrderConfirmation;
};

/** Payload returned from the deleteWorkOrderDocumentProcessingRequest mutation. */
export type DeleteWorkOrderDocumentProcessingRequestPayload = {
  __typename?: 'DeleteWorkOrderDocumentProcessingRequestPayload';
  record: WorkOrderDocumentProcessingRequest;
};

/** Payload returned from the deleteWorkOrderGroup mutation. */
export type DeleteWorkOrderGroupPayload = {
  __typename?: 'DeleteWorkOrderGroupPayload';
  record: WorkOrderGroup;
};

/** Payload returned from the deleteWorkOrderMilestone mutation. */
export type DeleteWorkOrderMilestonePayload = {
  __typename?: 'DeleteWorkOrderMilestonePayload';
  record: WorkOrderMilestone;
};

/** Payload returned from the deleteWorkOrderStateMachine mutation. */
export type DeleteWorkOrderStateMachinePayload = {
  __typename?: 'DeleteWorkOrderStateMachinePayload';
  record: WorkOrderStateMachine;
};

/** Payload returned from the deleteWorkOrderTaskDefinition mutation. */
export type DeleteWorkOrderTaskDefinitionPayload = {
  __typename?: 'DeleteWorkOrderTaskDefinitionPayload';
  record: WorkOrderTaskDefinition;
};

/** Payload returned from the deleteWorkOrderTaskEscalationMessage mutation. */
export type DeleteWorkOrderTaskEscalationMessagePayload = {
  __typename?: 'DeleteWorkOrderTaskEscalationMessagePayload';
  record: WorkOrderTaskEscalationMessage;
};

/** Payload returned from the deleteWorkOrderTask mutation. */
export type DeleteWorkOrderTaskPayload = {
  __typename?: 'DeleteWorkOrderTaskPayload';
  record: WorkOrderTask;
};

export type DeliveryOrder = Record & WorkOrder & {
  __typename?: 'DeliveryOrder';
  /** bill to party info. */
  billTo?: Maybe<Account>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Containers associated with the delivery order. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Destination Location */
  destination?: Maybe<DeliveryOrderDestination>;
  /** The documents associated with the Delivery Order. This is an eventually consistent query. */
  documents: Array<Document>;
  /** The details of the optional email notifications */
  email?: Maybe<DeliveryOrderEmailInfo>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Details about the pick up  */
  pickup?: Maybe<DeliveryOrderPickup>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The Trucker carrying the goods */
  trucker?: Maybe<DeliveryOrderTrucker>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type DeliveryOrderdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type DeliveryOrderAgent = {
  __typename?: 'DeliveryOrderAgent';
  /** Address of the agent */
  addresses?: Maybe<Addresses>;
  /** Name of the agent */
  agentName?: Maybe<Scalars['String']>;
  /** Support email address of the agent */
  email?: Maybe<Scalars['Email']>;
  /** Logo to be applied to the delivery order doc. */
  logo?: Maybe<Document>;
  /** Support phone number of the agent */
  phone?: Maybe<Phone>;
  /** Name of the point of contact for the agent */
  pointOfContactName?: Maybe<Scalars['String']>;
  /** signature to be applied to the delivery order doc. */
  pointOfContactSign?: Maybe<Document>;
};

export type DeliveryOrderAgentInput = {
  /** Address of the agent */
  addresses?: InputMaybe<AddressesInput>;
  /** Name of the agent */
  agentName?: InputMaybe<Scalars['String']>;
  /** Support email address of the agent */
  email?: InputMaybe<Scalars['Email']>;
  /** Logo for the agent */
  logo?: InputMaybe<IdInput>;
  /** Support phone number of the agent */
  phone?: InputMaybe<PhoneInput>;
  /** Name of the point of contact for the agent */
  pointOfContactName?: InputMaybe<Scalars['String']>;
  /** Signature for the point of contact */
  pointOfContactSign?: InputMaybe<IdInput>;
};

export type DeliveryOrderConveyance = {
  __typename?: 'DeliveryOrderConveyance';
  /** Vessel Name for the delivery order */
  name?: Maybe<Scalars['String']>;
  /** Trip Number for the voyage */
  tripNumber?: Maybe<Scalars['String']>;
};

export type DeliveryOrderConveyanceInput = {
  /** Vessel Name for the delivery order */
  name?: InputMaybe<Scalars['String']>;
  /** Trip Number for the voyage */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type DeliveryOrderDestination = {
  __typename?: 'DeliveryOrderDestination';
  /** deliveryLocationDescription */
  location: Facility;
  /** The name of the receiver. */
  name?: Maybe<Scalars['String']>;
  /** The email of the receiver. */
  receivingEmail?: Maybe<Scalars['Email']>;
  /** The phone of the receiver. */
  receivingPhone?: Maybe<Phone>;
};

export type DeliveryOrderDestinationInput = {
  /** deliveryLocationDescription */
  location: IdInput;
  /** The name of the receiver. */
  name?: InputMaybe<Scalars['String']>;
  /** The email of the receiver. */
  receivingEmail?: InputMaybe<Scalars['Email']>;
  /** The phone of the receiver. */
  receivingPhone?: InputMaybe<PhoneInput>;
};

export type DeliveryOrderDocumentDestination = {
  __typename?: 'DeliveryOrderDocumentDestination';
  /** Address at which the delivery is to be made */
  address?: Maybe<Address>;
  /** Name of the destination facility */
  facilityName?: Maybe<Scalars['String']>;
  /** Email of the point of contact for receiving */
  receivingEmail?: Maybe<Scalars['Email']>;
  /** Name of the of the receiving point of contact */
  receivingName?: Maybe<Scalars['String']>;
  /** Phone of the point of contact for receiving */
  receivingPhone?: Maybe<Phone>;
};

export type DeliveryOrderDocumentDestinationInput = {
  /** Address at which the delivery is to be made */
  address?: InputMaybe<AddressInput>;
  /** Name of the destination facility */
  facilityName?: InputMaybe<Scalars['String']>;
  /** Email of the point of contact for receiving */
  receivingEmail?: InputMaybe<Scalars['Email']>;
  /** Name of the of the receiving point of contact */
  receivingName?: InputMaybe<Scalars['String']>;
  /** Phone of the point of contact for receiving */
  receivingPhone?: InputMaybe<PhoneInput>;
};

/** DeliveryOrder document generation request. */
export type DeliveryOrderDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'DeliveryOrderDocumentGenerationRequest';
  /** Additional Fields */
  additionalFields?: Maybe<ExamDeliveryOrderAdditionalFields>;
  /** Agent (forwarder or broker) details responsible for delivery order */
  agent?: Maybe<DeliveryOrderAgent>;
  /** arrival Date */
  arrivalDate?: Maybe<Scalars['Date']>;
  /** The entity to whom the delivery order is supposed to be billed to */
  billTo?: Maybe<Scalars['String']>;
  /** carrier on which the goods are being transported */
  carrierCode?: Maybe<Scalars['String']>;
  /** Commodity of products in the delivery order */
  commodity?: Maybe<Scalars['String']>;
  /** Containers associated with the delivery order. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance information */
  conveyance: DeliveryOrderConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The type of delivery order that should be generated. */
  deliveryOrderType?: Maybe<DeliveryOrderDocumentGenerationType>;
  /** Delivery order destination details */
  destination: DeliveryOrderDocumentDestination;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** The entry number for the delivery order */
  entryNumber?: Maybe<Scalars['String']>;
  /** House bill for the delivery order */
  houseBill?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Date of the import */
  importDate?: Maybe<Scalars['Date']>;
  /** Name of the importer */
  importerName?: Maybe<Scalars['String']>;
  /** In-bond number associated with the bill */
  inBondNumber?: Maybe<Scalars['String']>;
  /** Master bill for the delivery order */
  masterBill?: Maybe<Scalars['String']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Overflow Bills for the delivery order */
  overflowBills?: Maybe<Array<Scalars['String']>>;
  /** Delivery order pickup details */
  pickup: DeliveryOrderDocumentPickup;
  /** Date of the release */
  releaseDate?: Maybe<Scalars['Date']>;
  /** ID of the shipment for which the delivery order is generated */
  shipmentId?: Maybe<Scalars['String']>;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Steam Ship Line SCAC Code */
  steamShipLineScac?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The name of the trucker to whom the delivery order is assigned */
  truckerName: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The type of delivery order being generated */
export enum DeliveryOrderDocumentGenerationType {
  DELIVERY_ORDER_WORK_ORDER = 'DELIVERY_ORDER_WORK_ORDER',
  EXAM_DELIVERY_ORDER = 'EXAM_DELIVERY_ORDER'
}

export type DeliveryOrderDocumentPickup = {
  __typename?: 'DeliveryOrderDocumentPickup';
  /** FirmsCode associated with the pickup location for the delivery order */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** Last free date when the delivery order can be completed */
  lastFreeDate?: Maybe<Scalars['Date']>;
  /** Pickup number for the delivery order */
  pickupNumber?: Maybe<Scalars['String']>;
  /** Special Instructions for the delivery order */
  specialInstructions?: Maybe<Scalars['String']>;
};

export type DeliveryOrderDocumentPickupInput = {
  /** FirmsCode associated with the pickup location for the delivery order */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** Last free date when the delivery order can be completed */
  lastFreeDate?: InputMaybe<Scalars['Date']>;
  /** Pickup number for the delivery order */
  pickupNumber?: InputMaybe<Scalars['String']>;
  /** Special Instructions for the delivery order */
  specialInstructions?: InputMaybe<Scalars['String']>;
};

export type DeliveryOrderEdge = ConnectionEdge & {
  __typename?: 'DeliveryOrderEdge';
  cursor: Scalars['ID'];
  node: DeliveryOrder;
};

export type DeliveryOrderEmailInfo = {
  __typename?: 'DeliveryOrderEmailInfo';
  /** Should attach the packing list */
  attachPackingList?: Maybe<Scalars['Boolean']>;
  /** list of email addresses to be CC'ed for the optional email */
  ccEmails?: Maybe<Array<Scalars['Email']>>;
  /** list of parties to be CC'ed for the optional email */
  ccParties?: Maybe<Array<Party>>;
  /** Should an email be sent */
  sendEmail?: Maybe<Scalars['Boolean']>;
  /** Subject for the optional Email to be sent. */
  subject?: Maybe<Scalars['String']>;
};

export type DeliveryOrderEmailInfoInput = {
  /** Should attach the packing list */
  attachPackingList?: InputMaybe<Scalars['Boolean']>;
  /** list of email addresses to be CC'ed for the optional email */
  ccEmails?: InputMaybe<Array<Scalars['Email']>>;
  /** list of parties to be CC'ed for the optional email */
  ccParties?: InputMaybe<Array<IdInput>>;
  /** Should an email be sent */
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  /** Subject for the optional Email to be sent. */
  subject?: InputMaybe<Scalars['String']>;
};

export type DeliveryOrderPickup = {
  __typename?: 'DeliveryOrderPickup';
  /** FirmsCode of the pickup location */
  firmsCode: Scalars['FirmsCode'];
  /** The last date on which the delivery order can be completed for free */
  lastFreeDate?: Maybe<Scalars['Date']>;
  /** Pick up number of the delivery order */
  pickupNumber?: Maybe<Scalars['String']>;
  /** Special instructions for the delivery */
  specialInstructions?: Maybe<Scalars['String']>;
};

export type DeliveryOrderPickupInput = {
  /** FirmsCode of the pickup location */
  firmsCode: Scalars['FirmsCode'];
  /** The last date on which the delivery order can be completed for free */
  lastFreeDate?: InputMaybe<Scalars['Date']>;
  /** Pick up number of the delivery order */
  pickupNumber?: InputMaybe<Scalars['String']>;
  /** Special instructions for the delivery */
  specialInstructions?: InputMaybe<Scalars['String']>;
};

export type DeliveryOrderSearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Destination Location */
  deliveryLocation?: InputMaybe<TextSearchCriteriaInput>;
  /** Email Address of the dispatch */
  dispatchEmail?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Phone Number of the dispatch */
  dispatchPhone?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The status for the customs entry for this shipment */
  entryStatus?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** FirmsCode of the pickup location */
  pickupLocation?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Pick up number of the delivery order */
  pickupNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Name of the trucker */
  truckerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** TBD */
export type DeliveryOrderSearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'DeliveryOrderSearchTableRow';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Destination Location */
  deliveryLocation?: Maybe<Scalars['String']>;
  /** Email Address of the dispatch */
  dispatchEmail?: Maybe<Scalars['String']>;
  /** The Phone Number of the dispatch */
  dispatchPhone?: Maybe<Scalars['String']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** The status for the customs entry for this shipment */
  entryStatus?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<Array<Scalars['UsIorNumberValue']>>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** FirmsCode of the pickup location */
  pickupLocation?: Maybe<Scalars['String']>;
  /** Pick up number of the delivery order */
  pickupNumber?: Maybe<Scalars['String']>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: Maybe<Scalars['String']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Id of the trucker */
  truckerId?: Maybe<Scalars['String']>;
  /** Name of the trucker */
  truckerName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type DeliveryOrderServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'DeliveryOrderServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
};

export type DeliveryOrderServiceLevelAgreementInput = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: InputMaybe<Scalars['Float']>;
};

export type DeliveryOrderTrucker = {
  __typename?: 'DeliveryOrderTrucker';
  /** The email of the dispatch. */
  dispatchEmail?: Maybe<Scalars['Email']>;
  /** The phone of the dispatch. */
  dispatchPhone?: Maybe<Phone>;
  /** DeliveryOrderTrucker details */
  trucker?: Maybe<Trucker>;
};

export type DeliveryOrderTruckerInput = {
  /** The email of the dispatch. */
  dispatchEmail?: InputMaybe<Scalars['Email']>;
  /** The phone of the dispatch. */
  dispatchPhone?: InputMaybe<PhoneInput>;
  /** Id of the DeliveryOrderTrucker */
  trucker?: InputMaybe<IdInput>;
};

export type DeliveryOrdersConnection = Connection & {
  __typename?: 'DeliveryOrdersConnection';
  edges: Array<DeliveryOrderEdge>;
  nodes: Array<DeliveryOrder>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DepartureLocation = {
  __typename?: 'DepartureLocation';
  /** Code specifying the country of Departure. */
  country?: Maybe<Scalars['CountryCode']>;
  /** Name of the country of departure. */
  countryName?: Maybe<Scalars['String']>;
  /** Identification of the Departure location. This would be a port for sea, airport for air and border post for land crossing. */
  identification?: Maybe<Scalars['String']>;
  /** Name of the departure location. */
  name?: Maybe<Scalars['String']>;
  /** Identification of a country's subdivision of departure. */
  region?: Maybe<Scalars['String']>;
};

export type DepartureLocationInput = {
  /** Code specifying the country of Departure. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** Name of the country of departure. */
  countryName?: InputMaybe<Scalars['String']>;
  /** Identification of the Departure location. This would be a port for sea, airport for air and border post for land crossing. */
  identification?: InputMaybe<Scalars['String']>;
  /** Name of the departure location. */
  name?: InputMaybe<Scalars['String']>;
  /** Identification of a country's subdivision of departure. */
  region?: InputMaybe<Scalars['String']>;
};

/** AWS AppConfig deployment strategies */
export enum DeploymentStrategy {
  AllAtOnce = 'AllAtOnce',
  Canary10Percent5Minutes = 'Canary10Percent5Minutes',
  Canary10Percent10Minutes = 'Canary10Percent10Minutes',
  Canary10Percent30Minutes = 'Canary10Percent30Minutes',
  Linear10PercentEvery10Minutes = 'Linear10PercentEvery10Minutes',
  Linear50PercentEvery30Minutes = 'Linear50PercentEvery30Minutes'
}

export type DestinationLocation = {
  __typename?: 'DestinationLocation';
  /** Code specifying the country of destination. */
  country?: Maybe<Scalars['String']>;
};

export type DestinationLocationInput = {
  /** Code specifying the country of destination. */
  country?: InputMaybe<Scalars['String']>;
};

export type DiffDetail = {
  __typename?: 'DiffDetail';
  /** The agent responsible for initiating the AuditLog. */
  changedBy?: Maybe<ExternalClient>;
  /** The agent name who is responsible for initiating the AuditLog. */
  changedByName: Scalars['String'];
  /** The time of the change. */
  changedTime: Scalars['DateTime'];
  /** List of field changes */
  changes: Array<FieldChange>;
};

export type DiffDetailInput = {
  /** The agent responsible for initiating the AuditLog. */
  changedBy?: InputMaybe<IdVersionInput>;
  /** The agent name who is responsible for initiating the AuditLog. */
  changedByName: Scalars['String'];
  /** The time of the change. */
  changedTime: Scalars['DateTime'];
  /** List of field changes */
  changes: Array<FieldChangeInput>;
};

export type DiiCustomsAgent = {
  __typename?: 'DiiCustomsAgent';
  /** Customs agent address */
  address?: Maybe<Address>;
  /** Customs agent party info */
  customsAgent?: Maybe<CustomsAgent>;
  /** Customs agent name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
};

export type DiiCustomsAgentInput = {
  /** Customs agent address */
  address?: InputMaybe<AddressInput>;
  /** Id version of customs agent */
  customsAgent?: InputMaybe<IdVersionInput>;
  /** Customs agent name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
};

/** Represents an aspect of dimension (length/height/width) of an object. */
export type Dimension = {
  __typename?: 'Dimension';
  /** Represents the unit of measure. */
  unit: DimensionUnit;
  /** Represents the measure (value). */
  value: Scalars['Float'];
};

/** Represents an aspect of dimension (length/height/width) of an object. */
export type DimensionInput = {
  /** Represents the unit of measure. */
  unit: DimensionUnit;
  /** Represents the measure (value). */
  value: Scalars['Float'];
};

/** Represents the unit of measure for dimension. */
export enum DimensionUnit {
  CENTIMETRE = 'CENTIMETRE',
  INCH = 'INCH'
}

export type Dimensions = {
  __typename?: 'Dimensions';
  /** Captures the diameter. */
  diameter?: Maybe<Dimension>;
  /** Captures the height. */
  height?: Maybe<Dimension>;
  /** Captures the length. */
  length?: Maybe<Dimension>;
  /** Captures the width. */
  width?: Maybe<Dimension>;
};

export type DimensionsInput = {
  /** Captures the diameter. */
  diameter?: InputMaybe<DimensionInput>;
  /** Captures the height. */
  height?: InputMaybe<DimensionInput>;
  /** Captures the length. */
  length?: InputMaybe<DimensionInput>;
  /** Captures the width. */
  width?: InputMaybe<DimensionInput>;
};

export type DisSubmission = {
  __typename?: 'DisSubmission';
  /** CBP tag the document was submitted as */
  disDocName: Scalars['String'];
  /** Dis submission status */
  disStatus: DisSubmissionStatus;
  /** DIS submit transaction */
  transaction: SubmitDisTransaction;
};

export type DisSubmissionInput = {
  /** CBP tag the document was submitted as */
  disDocName: Scalars['String'];
  /** Dis submission status */
  disStatus: DisSubmissionStatus;
  /** DIS submit transaction */
  transaction: IdTypeNameInput;
};

/** Dis submission status */
export enum DisSubmissionStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type DmsClientConnectionInput = {
  apiArgs?: InputMaybe<Scalars['JSONObject']>;
  apiName: SupportedDMSAPI;
  sessionName?: InputMaybe<Scalars['String']>;
};

export type DmsClientConnectionPayload = {
  __typename?: 'DmsClientConnectionPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSONObject']>;
};

/** The type of DNS record */
export enum DnsRecordType {
  CNAME = 'CNAME',
  MX = 'MX',
  TXT = 'TXT'
}

export type DocReadiness = {
  __typename?: 'DocReadiness';
  /** Doc Readiness ID */
  id: Scalars['String'];
  /** Doc Readiness type */
  type?: Maybe<Scalars['String']>;
};

export type DocReadinessInput = {
  /** Doc Readiness ID */
  id: Scalars['String'];
  /** Doc Readiness type */
  type?: InputMaybe<Scalars['String']>;
};

/** Specify criteria for documents required */
export enum DocRequirementCriteria {
  REQUIRED_ALL = 'REQUIRED_ALL',
  REQUIRED_ANY = 'REQUIRED_ANY',
  REQUIRED_NONE = 'REQUIRED_NONE'
}

/** Primary class used to represent a document */
export type Document = Record & {
  __typename?: 'Document';
  /** Set on new documents once they have been through a ClamAV anti-virus scan. */
  antivirusScanStatus?: Maybe<DocumentAntivirusScanStatus>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Contains download/upload links for getting/retrieving documents. */
  content: UrlContent;
  /** Defines the type of content within the document, also known as the MIME type (e.g. text/html). Will be inferred from the file extension if not provided. */
  contentType: Scalars['DocumentContentType'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Captures all instances of the document being submitted electronically to U.S. Customs via DIS. */
  disSubmissions?: Maybe<Array<DisSubmission>>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The expiration date of the document. */
  expirationDate?: Maybe<Scalars['Date']>;
  /** The file extension of the document. Always uppercase. */
  extension: DocumentFileExtension;
  /** External document reference. */
  externalDocumentReference?: Maybe<ExternalDocumentReference>;
  /** Extracted document content. */
  extractedDocumentContent?: Maybe<ExtractedDocumentContent>;
  /** Name of the document. */
  fileName: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Indicates if a document is password protected. */
  passwordStatus?: Maybe<DocumentPasswordStatus>;
  /** Contains download/upload links for getting/retrieving preview of document. */
  preview: UrlPreview;
  /** Indicates the document preview thumbnail generation status. */
  previewStatus: DocumentPreviewStatus;
  /** A public document is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['Boolean']>;
  /** The version of a system generated document, not used if uploaded by the client. */
  revisionNumber?: Maybe<Scalars['Int']>;
  /** A unique identifier for document objects to prevent duplication. */
  sha1?: Maybe<Scalars['String']>;
  /** The size of the document in bytes. */
  size?: Maybe<Scalars['Int']>;
  /** Indicates the upload status of the content of the document. */
  status: DocumentStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The status of an anti-virus scan for a document */
export enum DocumentAntivirusScanStatus {
  CLEAN = 'CLEAN',
  INFECTED = 'INFECTED',
  UNSCANNED = 'UNSCANNED'
}

export type DocumentBulkDownloadInput = {
  /** The id list of all items that do not have any associated documents. */
  itemsWithoutDocuments: Array<Scalars['ID']>;
  /** An array of record ids and their associated document ids */
  recordsToDocuments: Array<RecordToDocuments>;
  /** The prefix name for the zip folder downloaded (ex. invoices_TIMESTAMP) */
  zipPrefixName?: InputMaybe<Scalars['String']>;
};

export type DocumentBulkDownloadPayload = {
  __typename?: 'DocumentBulkDownloadPayload';
  /** The pre-signed url which links to the zip file located on the s3 bucket. */
  presignedUrl: Scalars['String'];
};

export type DocumentContentTypeSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['DocumentContentType']>>;
};

export type DocumentEdge = ConnectionEdge & {
  __typename?: 'DocumentEdge';
  cursor: Scalars['ID'];
  node: Document;
};

/** File extension of the document. */
export enum DocumentFileExtension {
  BMP = 'BMP',
  CSV = 'CSV',
  DOC = 'DOC',
  DOCX = 'DOCX',
  GIF = 'GIF',
  HTML = 'HTML',
  JPEG = 'JPEG',
  JPG = 'JPG',
  JSON = 'JSON',
  PDF = 'PDF',
  PNG = 'PNG',
  RTF = 'RTF',
  TIF = 'TIF',
  TIFF = 'TIFF',
  TXT = 'TXT',
  XLS = 'XLS',
  XLSM = 'XLSM',
  XLSX = 'XLSX',
  XML = 'XML'
}

export type DocumentFileExtensionSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentFileExtension>>;
};

export type DocumentGenerationRequest = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Status of Document Generation Request */
export enum DocumentGenerationStatus {
  FAILED = 'FAILED',
  GENERATED = 'GENERATED',
  PROCESSING = 'PROCESSING'
}

export type DocumentImageSystemDocument = {
  __typename?: 'DocumentImageSystemDocument';
  /** CBP Label that user chose when send DIS documents */
  cbpLabel: Scalars['String'];
  /** Document */
  document: Document;
};

export type DocumentImageSystemDocumentInput = {
  /** CBP Label that user chose when send DIS documents */
  cbpLabel: Scalars['String'];
  /** Document Id */
  document: IdInput;
};

/** Indicates if a file is password protected */
export enum DocumentPasswordStatus {
  PROTECTED = 'PROTECTED',
  UNPROTECTED = 'UNPROTECTED'
}

/** Indicates the status of the document preview generation. */
export enum DocumentPreviewStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  SKIPPED = 'SKIPPED',
  UPLOADED = 'UPLOADED'
}

export type DocumentPreviewStatusSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentPreviewStatus>>;
};

/** Type of service that the external document is referencing */
export enum DocumentReferenceType {
  ANDRA = 'ANDRA',
  DGIE = 'DGIE',
  DMS = 'DMS',
  SCALE_AI = 'SCALE_AI'
}

export type DocumentRequirementsInput = {
  /** Specify criteria for documents required */
  criteria: DocRequirementCriteria;
  /** Document types that are required to mark the work order as ready */
  documentTags: Array<DocumentTag>;
  /** Mode of transport for which this requirement */
  modeOfTransport: ModeOfTransport;
  /** Program Id for which this requirement is applicable */
  programId?: InputMaybe<Scalars['String']>;
};

/** Primary class used to represent a document search input */
export type DocumentSearchCriteriaInput = {
  /** The content type (MIME) of the document. */
  contentType?: InputMaybe<DocumentContentTypeSearchCritieraInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The document tags. */
  documentTags?: InputMaybe<DocumentTagSearchCritieraInput>;
  /** The file extension. */
  extension?: InputMaybe<DocumentFileExtensionSearchCritieraInput>;
  /** The external reference Id associated with document */
  externalDocumentReferenceId?: InputMaybe<IdSearchCriteriaInput>;
  /** File name */
  fileName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The document preview status. */
  previewStatus?: InputMaybe<DocumentPreviewStatusSearchCritieraInput>;
  /** The size of the document in bytes. */
  size?: InputMaybe<IntSearchCriteriaInput>;
  /** The document status. */
  status?: InputMaybe<DocumentStatusSearchCritieraInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Primary class used to represent a document search input */
export type DocumentSearchTableRow = RecordSearchTableRow & {
  __typename?: 'DocumentSearchTableRow';
  /** Defines the type of content within the document, also known as the MIME type (e.g. text/html). Will be inferred from the file extension if not provided. */
  contentType: Scalars['DocumentContentType'];
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The file extension of the document. Always uppercase. */
  extension: DocumentFileExtension;
  /** Name of the document. */
  fileName: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Document preview status */
  previewStatus: DocumentPreviewStatus;
  /** The size of the document in bytes. */
  size?: Maybe<Scalars['Int']>;
  /** The Document status */
  status: DocumentStatus;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type DocumentSignRequest = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The sign request expires after the designated amount of minutes. */
  expireAfterMinutes: Scalars['Int'];
  /** The UTC date & time the request will expire. */
  expireTime: Scalars['DateTime'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Data related to the document signature. */
  signature?: Maybe<DocumentSignature>;
  /** Information about when & where the document sign request was signed. */
  signed?: Maybe<RecordAction>;
  /** Birth date of officer signing the document */
  signerBirthDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Name of officer signing the document. */
  signerName?: Maybe<Scalars['String']>;
  /** Title of officer signing the document. */
  signerTitle?: Maybe<Scalars['String']>;
  /** Status of Document Sign Request */
  status: DocumentSignRequestStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The link provided to clients with the purpose of signing. */
  url: Scalars['String'];
  /** The record's version */
  version: Scalars['Int'];
};

/** Document sign request status to be updated during the signing process. */
export enum DocumentSignRequestStatus {
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  SIGNED = 'SIGNED',
  VOID = 'VOID'
}

export type DocumentSignRequestStatusSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentSignRequestStatus>>;
};

/** Document signature associated with the document sign request. */
export type DocumentSignature = {
  __typename?: 'DocumentSignature';
  /** Base64 encoded image. */
  data?: Maybe<Scalars['Base64ImageString']>;
  /** The document signature type. */
  method: DocumentSignatureMethod;
  /** The typed name. */
  typedSignature?: Maybe<Scalars['String']>;
};

/** Document signature associated with the document sign request. */
export type DocumentSignatureInput = {
  /** Base64 encoded image. */
  data?: InputMaybe<Scalars['Base64ImageString']>;
  /** The document signature type. */
  method: DocumentSignatureMethod;
  /** The typed name. */
  typedSignature?: InputMaybe<Scalars['String']>;
};

/** Document signing methods. */
export enum DocumentSignatureMethod {
  DRAW = 'DRAW',
  TYPE = 'TYPE',
  UPLOAD = 'UPLOAD'
}

export type DocumentSignatureMethodSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentSignatureMethod>>;
};

/** The top-left signature coordinates of the document. Signature will be offset and stamped on document. */
export type DocumentSignaturePosition = {
  __typename?: 'DocumentSignaturePosition';
  /** The height of the stamped signature in pt(point) format, 1 pt = 1/72 inch. */
  height: Scalars['Int'];
  /** The page number of the document sign coordinate. */
  pageNumber: Scalars['Int'];
  /** The width of the stamped signature in pt(point) format, 1 pt = 1/72 inch. */
  width: Scalars['Int'];
  /** Bottom-left X coordinate of the signature w.r.t bottom-left of page in pt(point) format, 1 pt = 1/72 inch. */
  xCoordinate: Scalars['Int'];
  /** Bottom-left Y coordinate of the signature w.r.t bottom-left of page in pt(point) format, 1 pt = 1/72 inch. */
  yCoordinate: Scalars['Int'];
};

/** The top-left signature coordinates of the document. Signature will be offset and stamped on document. */
export type DocumentSignaturePositionInput = {
  /** The height of the stamped signature in pt(point) format, 1 pt = 1/72 inch. */
  height: Scalars['Int'];
  /** The page number of the document sign coordinate. */
  pageNumber: Scalars['Int'];
  /** The width of the stamped signature in pt(point) format, 1 pt = 1/72 inch. */
  width: Scalars['Int'];
  /** Bottom-left X coordinate of the signature w.r.t bottom-left of page in pt(point) format, 1 pt = 1/72 inch. */
  xCoordinate: Scalars['Int'];
  /** Bottom-left Y coordinate of the signature w.r.t bottom-left of page in pt(point) format, 1 pt = 1/72 inch. */
  yCoordinate: Scalars['Int'];
};

/** Document Stamp details in text or base 64 encoded image format. */
export type DocumentStamp = {
  __typename?: 'DocumentStamp';
  /** Stamp in base64 encoded image format - png/jpeg are supported types. */
  image?: Maybe<ImageStamp>;
  /** Stamp in plain text format. */
  text?: Maybe<TextStamp>;
};

/** Document Stamp details in text or base 64 encoded image format. */
export type DocumentStampInput = {
  /** Stamp in base64 encoded image format - png/jpeg are supported types. */
  image?: InputMaybe<ImageStampInput>;
  /** Stamp in plain text format. */
  text?: InputMaybe<TextStampInput>;
};

/** Indicates the status of a document or preview */
export enum DocumentStatus {
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  PROCESSED = 'PROCESSED',
  UPLOADED = 'UPLOADED'
}

export type DocumentStatusSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentStatus>>;
};

/** Tags used to label documents */
export enum DocumentTag {
  APH_DOCUMENT = 'APH_DOCUMENT',
  APPROVED_DOCUMENT = 'APPROVED_DOCUMENT',
  ARRIVAL_NOTICE = 'ARRIVAL_NOTICE',
  ASIN_LIST = 'ASIN_LIST',
  ASSEMBLERS_DECLARATION = 'ASSEMBLERS_DECLARATION',
  BEEF_EXPORT = 'BEEF_EXPORT',
  BILL_OF_ENTRY = 'BILL_OF_ENTRY',
  BILL_OF_LADING = 'BILL_OF_LADING',
  BIS_PRODUCT_REGISTRATION = 'BIS_PRODUCT_REGISTRATION',
  BOND_APPLICATION = 'BOND_APPLICATION',
  BROCHURE = 'BROCHURE',
  BROKER_OF_RECORD_CHANGE_LETTER = 'BROKER_OF_RECORD_CHANGE_LETTER',
  BULK_MILESTONE = 'BULK_MILESTONE',
  BULK_PRODUCT_UPLOAD_TEMPLATE = 'BULK_PRODUCT_UPLOAD_TEMPLATE',
  BUSINESS_LICENSE_OR_PERMIT = 'BUSINESS_LICENSE_OR_PERMIT',
  CARGO_RELEASE = 'CARGO_RELEASE',
  CARRIER_CONFIRMATION = 'CARRIER_CONFIRMATION',
  CBMA_CONTROLLED_GROUP = 'CBMA_CONTROLLED_GROUP',
  CBMA_IMPORTER_SPREADSHEET = 'CBMA_IMPORTER_SPREADSHEET',
  CBMA_PRODUCER_CERTIFICATE = 'CBMA_PRODUCER_CERTIFICATE',
  CBPF_3229 = 'CBPF_3229',
  CBPF_4647 = 'CBPF_4647',
  CERTIFICATE_OF_CONFORMITY = 'CERTIFICATE_OF_CONFORMITY',
  CERTIFICATE_OF_ORIGIN = 'CERTIFICATE_OF_ORIGIN',
  CF_28 = 'CF_28',
  CF_29_ACTION_TAKEN = 'CF_29_ACTION_TAKEN',
  CF_29_PROPOSED_ACTION = 'CF_29_PROPOSED_ACTION',
  CHILDREN_PRODUCT_CERTIFICATE = 'CHILDREN_PRODUCT_CERTIFICATE',
  COMMERCIAL_INVOICE = 'COMMERCIAL_INVOICE',
  COMMUNICATION_HISTORY = 'COMMUNICATION_HISTORY',
  CONFIDENTIAL = 'CONFIDENTIAL',
  CONTINUOUS_BOND = 'CONTINUOUS_BOND',
  CONTRACT_ORDER = 'CONTRACT_ORDER',
  CORPORATE_CERTIFICATION = 'CORPORATE_CERTIFICATION',
  COST_ALLOCATION = 'COST_ALLOCATION',
  COST_SUBMISSION = 'COST_SUBMISSION',
  CREDIT_NOTE_INVOICE = 'CREDIT_NOTE_INVOICE',
  CREDIT_REPORT = 'CREDIT_REPORT',
  CUSTOM = 'CUSTOM',
  CUSTOMS_DECLARATION = 'CUSTOMS_DECLARATION',
  CUSTOMS_ENTRY = 'CUSTOMS_ENTRY',
  CUSTOMS_ENTRY_DRAFT = 'CUSTOMS_ENTRY_DRAFT',
  DAILY_STATEMENT = 'DAILY_STATEMENT',
  DANGEROUS_GOODS_DECLARATION = 'DANGEROUS_GOODS_DECLARATION',
  DECLARATION_BY_IMPORTER = 'DECLARATION_BY_IMPORTER',
  DELIVERY_ORDER_FORM = 'DELIVERY_ORDER_FORM',
  DIRECT_POWER_OF_ATTORNEY = 'DIRECT_POWER_OF_ATTORNEY',
  DIRECT_REP_POWER_OF_ATTORNEY = 'DIRECT_REP_POWER_OF_ATTORNEY',
  DRAFT_CUSTOMS_DECLARATION = 'DRAFT_CUSTOMS_DECLARATION',
  DRAFT_ENTRY_SUMMARY_7501 = 'DRAFT_ENTRY_SUMMARY_7501',
  DRAFT_ENTRY_SUMMARY_7501_PSC = 'DRAFT_ENTRY_SUMMARY_7501_PSC',
  DRAWBACK_CLAIM_RESPONSE = 'DRAWBACK_CLAIM_RESPONSE',
  DSN_LIST = 'DSN_LIST',
  DUIMP_HEADER = 'DUIMP_HEADER',
  DUIMP_ITEMS = 'DUIMP_ITEMS',
  DUTY_DAILY_STATEMENT = 'DUTY_DAILY_STATEMENT',
  DUTY_FREE_ENTRY = 'DUTY_FREE_ENTRY',
  DUTY_MONTHLY_STATEMENT = 'DUTY_MONTHLY_STATEMENT',
  DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER = 'DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER',
  DUTY_REQUEST_FORM = 'DUTY_REQUEST_FORM',
  EDK_FORM = 'EDK_FORM',
  EIN_VERIFICATION = 'EIN_VERIFICATION',
  ENTRY_SUMMARY_7501 = 'ENTRY_SUMMARY_7501',
  ENTRY_SUMMARY_7501_PSC = 'ENTRY_SUMMARY_7501_PSC',
  ENTRY_SUMMARY_PACKAGE = 'ENTRY_SUMMARY_PACKAGE',
  EPA_3520_1 = 'EPA_3520_1',
  EPA_3520_21 = 'EPA_3520_21',
  EPA_3540_01 = 'EPA_3540_01',
  EPA_CERTIFICATE_OF_ANALYSIS = 'EPA_CERTIFICATE_OF_ANALYSIS',
  EPA_DOCUMENT = 'EPA_DOCUMENT',
  EPA_IMPORT_OF_ODS = 'EPA_IMPORT_OF_ODS',
  EPA_NON_OBJECTION_NOTICE = 'EPA_NON_OBJECTION_NOTICE',
  EPA_PESTICIDE = 'EPA_PESTICIDE',
  EPA_TSCA = 'EPA_TSCA',
  EPA_V_E_EXEMPTION = 'EPA_V_E_EXEMPTION',
  EQUIPMENT_TYPE_APPROVAL = 'EQUIPMENT_TYPE_APPROVAL',
  EXAM_CHARGES = 'EXAM_CHARGES',
  EXPORT_LICENSE = 'EXPORT_LICENSE',
  E_CHALLAN = 'E_CHALLAN',
  FDA_2877 = 'FDA_2877',
  FDA_CERTIFICATION_OF_REGISTRATION = 'FDA_CERTIFICATION_OF_REGISTRATION',
  FDA_DEVICE_INITIAL_IMPORTER_INFORMATION = 'FDA_DEVICE_INITIAL_IMPORTER_INFORMATION',
  FDA_DOCUMENT = 'FDA_DOCUMENT',
  FDA_NOTICE = 'FDA_NOTICE',
  FINANCIAL_STATEMENTS = 'FINANCIAL_STATEMENTS',
  FISH_AND_WILDLIFE_IMPORT_LICENSE = 'FISH_AND_WILDLIFE_IMPORT_LICENSE',
  FORWARDERS_CARGO_RECEIPT = 'FORWARDERS_CARGO_RECEIPT',
  FREE_ENTRY_OF_RETURNED_AMERICAN_PROD = 'FREE_ENTRY_OF_RETURNED_AMERICAN_PROD',
  FREIGHT_SNAPSHOT = 'FREIGHT_SNAPSHOT',
  FUMIGATION_CERTIFICATE = 'FUMIGATION_CERTIFICATE',
  GATEPASS = 'GATEPASS',
  GENERAL_CERTIFICATE_OF_CONFORMITY = 'GENERAL_CERTIFICATE_OF_CONFORMITY',
  GENERAL_INDEMNITY_AGREEMENT = 'GENERAL_INDEMNITY_AGREEMENT',
  GENERIC_DOCUMENT = 'GENERIC_DOCUMENT',
  GOVERNMENT_ISSUED_PHOTO_ID = 'GOVERNMENT_ISSUED_PHOTO_ID',
  HOUSE_BILL_OF_LADING = 'HOUSE_BILL_OF_LADING',
  HS_7 = 'HS_7',
  IMPORTER_AGENT = 'IMPORTER_AGENT',
  IMPORT_FILE = 'IMPORT_FILE',
  IMPORT_PERMIT = 'IMPORT_PERMIT',
  INLT_SUBSCRIPTION = 'INLT_SUBSCRIPTION',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  INTERIM_FOOTWEAR_INVOICE = 'INTERIM_FOOTWEAR_INVOICE',
  INVOICE = 'INVOICE',
  INVOICE_WORKSHEET = 'INVOICE_WORKSHEET',
  IN_BOND_7512 = 'IN_BOND_7512',
  IN_BOND_NOTES = 'IN_BOND_NOTES',
  IOR_INVOICE = 'IOR_INVOICE',
  ISF_BOND_TYPE_16 = 'ISF_BOND_TYPE_16',
  ISF_WORKSHEET = 'ISF_WORKSHEET',
  LABEL_APPROVAL = 'LABEL_APPROVAL',
  LACEY_ACT = 'LACEY_ACT',
  LETTER_OF_CREDIT = 'LETTER_OF_CREDIT',
  LIQUIDATED_DAMAGES = 'LIQUIDATED_DAMAGES',
  MANIFEST_CONFIDENTIALITY_APPLICATION = 'MANIFEST_CONFIDENTIALITY_APPLICATION',
  MANUFACTURER_STATAEMENT_OF_USE = 'MANUFACTURER_STATAEMENT_OF_USE',
  MASTER_BILL_OF_LADING = 'MASTER_BILL_OF_LADING',
  MASTER_POWER_OF_ATTORNEY = 'MASTER_POWER_OF_ATTORNEY',
  MONTHLY_DUTY_REPORT = 'MONTHLY_DUTY_REPORT',
  MSDS = 'MSDS',
  NFE_DATA_FILE = 'NFE_DATA_FILE',
  NFE_DATA_FILE_CHUNK = 'NFE_DATA_FILE_CHUNK',
  NFE_DATA_FILE_STAMPED = 'NFE_DATA_FILE_STAMPED',
  NON_COMMERCIAL_INVOICE = 'NON_COMMERCIAL_INVOICE',
  NON_REIMBURSEMENT_STATEMENT_CERTIFICATE = 'NON_REIMBURSEMENT_STATEMENT_CERTIFICATE',
  NON_REIMBURSEMENT_STATEMENT_FORM = 'NON_REIMBURSEMENT_STATEMENT_FORM',
  OFFICER_VERIFICATION = 'OFFICER_VERIFICATION',
  OTHER = 'OTHER',
  OTHER_PGA_DOCUMENT = 'OTHER_PGA_DOCUMENT',
  OUT_OF_CHARGE_BILL_OF_ENTRY = 'OUT_OF_CHARGE_BILL_OF_ENTRY',
  PACKING_LIST = 'PACKING_LIST',
  PARTNERSHIP_VERIFICATION = 'PARTNERSHIP_VERIFICATION',
  PASSPORT_DL_GOVT_ISSUED_ID = 'PASSPORT_DL_GOVT_ISSUED_ID',
  PERIODIC_MONTHLY_STATEMENT_APPLICATION = 'PERIODIC_MONTHLY_STATEMENT_APPLICATION',
  PERSONAL_EFFECTS = 'PERSONAL_EFFECTS',
  PHOTOGRAPH = 'PHOTOGRAPH',
  PHYTOSANITARY_CERTIFICATES = 'PHYTOSANITARY_CERTIFICATES',
  POST_ENTRY_IMPORT_DATA_FILE = 'POST_ENTRY_IMPORT_DATA_FILE',
  PPQ_587 = 'PPQ_587',
  PRE_ENTRY_IMPORT_DATA_FILE = 'PRE_ENTRY_IMPORT_DATA_FILE',
  PROCESSING_DECLARATION = 'PROCESSING_DECLARATION',
  PRODUCT_INFORMATION = 'PRODUCT_INFORMATION',
  PRODUCT_LIST = 'PRODUCT_LIST',
  PROFORMA_INVOICE = 'PROFORMA_INVOICE',
  PROOF_OF_PRODUCT_COMPLIANCE = 'PROOF_OF_PRODUCT_COMPLIANCE',
  PROOF_OF_VALUE = 'PROOF_OF_VALUE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  PVA = 'PVA',
  PVA_DOCUMENT = 'PVA_DOCUMENT',
  REQUEST_FOR_PAYMENT = 'REQUEST_FOR_PAYMENT',
  SAFETY_DATA_SHEET = 'SAFETY_DATA_SHEET',
  SELLER_PAYMENT_BACK_SLIP = 'SELLER_PAYMENT_BACK_SLIP',
  SELLER_PAYMENT_BANK_SLIP = 'SELLER_PAYMENT_BANK_SLIP',
  SERVICES_STATEMENT = 'SERVICES_STATEMENT',
  SHIPMENT_INVOICE = 'SHIPMENT_INVOICE',
  SHIPPING_INSTRUCTIONS = 'SHIPPING_INSTRUCTIONS',
  SPEC_SHEET = 'SPEC_SHEET',
  STEEL_IMPORT_LICENSE = 'STEEL_IMPORT_LICENSE',
  SUB_POWER_OF_ATTORNEY = 'SUB_POWER_OF_ATTORNEY',
  SUB_POWER_OF_ATTORNEY_AUTHORITY = 'SUB_POWER_OF_ATTORNEY_AUTHORITY',
  TECH_PACK = 'TECH_PACK',
  TESTING_CERTIFICATE = 'TESTING_CERTIFICATE',
  TSCA_DECLARATION = 'TSCA_DECLARATION',
  UNPLANNED_CHARGE_PROOF = 'UNPLANNED_CHARGE_PROOF',
  USDA_VS_16_3 = 'USDA_VS_16_3',
  VALUATION_BREAKDOWN = 'VALUATION_BREAKDOWN',
  VERIFIED_GROSS_MASS_CERTIFICATE = 'VERIFIED_GROSS_MASS_CERTIFICATE',
  VOSTOK_CI_XML = 'VOSTOK_CI_XML',
  WORK_ORDER_GROUP_INVOICE = 'WORK_ORDER_GROUP_INVOICE'
}

export type DocumentTagSearchCritieraInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentTag>>;
};

/** Primary class representing a DocumentTemplate. */
export type DocumentTemplate = Record & {
  __typename?: 'DocumentTemplate';
  /** Account owning this template. i.e. Forwarder, shipper etc. */
  account: Account;
  /** Captures the activation status of the template. */
  activated?: Maybe<RecordAction>;
  /** Captures the approval status of the template. */
  approved?: Maybe<RecordAction>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The template HTML */
  html: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The JSON representation of the template HTML. */
  jsonHtml: Scalars['JSONObject'];
  /** The name of the template. */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Captures the rejection status of the template. */
  rejected?: Maybe<RecordAction>;
  /** Status of the document template */
  status: DocumentTemplateStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The overall structure of the template (e.g. Master Power of Attorney). */
  templateType: TemplateType;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type DocumentTemplateEdge = ConnectionEdge & {
  __typename?: 'DocumentTemplateEdge';
  cursor: Scalars['ID'];
  node: DocumentTemplate;
};

export type DocumentTemplateSearchCriteriaInput = {
  /** The Account id that owns this Record. */
  accountId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Account name that owns this Record. */
  accountName?: InputMaybe<TextSearchCriteriaInput>;
  /** The document template activated time. */
  activatedTime?: InputMaybe<DateSearchCriteriaInput>;
  /** The document template approved time. */
  approvedTime?: InputMaybe<DateSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The document template rejected time. */
  rejectedTime?: InputMaybe<DateSearchCriteriaInput>;
  /** The document template status. */
  status?: InputMaybe<DocumentTemplateStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The document template type. */
  templateType?: InputMaybe<DocumentTemplateTypeSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Document template search table row. */
export type DocumentTemplateSearchTableRow = RecordSearchTableRow & {
  __typename?: 'DocumentTemplateSearchTableRow';
  /** The Account name that owns this Record. */
  accountName?: Maybe<Scalars['String']>;
  /** The document template activated time. */
  activatedTime?: Maybe<Scalars['String']>;
  /** The document template approved time. */
  approvedTime?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The document template rejected time. */
  rejectedTime?: Maybe<Scalars['String']>;
  /** The document template status. */
  status?: Maybe<Scalars['String']>;
  /** The document template type. */
  templateType?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Status of document template used to determine whether it can be used or not. */
export enum DocumentTemplateStatus {
  ACTIVATED = 'ACTIVATED',
  APPROVED = 'APPROVED',
  DEACTIVATED = 'DEACTIVATED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type DocumentTemplateStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<DocumentTemplateStatus>>;
};

export type DocumentTemplateTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<TemplateType>>;
};

export type DocumentTemplatesConnection = Connection & {
  __typename?: 'DocumentTemplatesConnection';
  edges: Array<DocumentTemplateEdge>;
  nodes: Array<DocumentTemplate>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DocumentsConnection = Connection & {
  __typename?: 'DocumentsConnection';
  edges: Array<DocumentEdge>;
  nodes: Array<Document>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type DocumentsRequirement = {
  __typename?: 'DocumentsRequirement';
  /** Specify criteria for documents required */
  criteria: DocRequirementCriteria;
  /** Document types that are required to mark the work order as ready */
  documentTags: Array<DocumentTag>;
  /** Mode of transport for which this requirement */
  modeOfTransport: ModeOfTransport;
  /** Program Id for which this requirement is applicable */
  programId?: Maybe<Scalars['String']>;
};

/** Department of Transportation conformance bond. */
export type DotBond = {
  __typename?: 'DotBond';
  /** The value of the DOT bond in whole US dollars. Used by: NHTSA */
  amount?: Maybe<Scalars['Float']>;
  /** A code representing the valid DOT bond type. Used by: NHTSA */
  qualifier?: Maybe<DotBondQualifier>;
  /** The surety bond tracking number. Used by: NHTSA */
  serialNumber?: Maybe<Scalars['String']>;
  /** The three-digit surety code assigned to the surety company that underwrites the DOT conformance bond. Used by: NHTSA */
  suretyCode?: Maybe<Scalars['String']>;
};

/** Department of Transportation conformance bond. */
export type DotBondInput = {
  /** The value of the DOT bond in whole US dollars. Used by: NHTSA */
  amount?: InputMaybe<Scalars['Float']>;
  /** A code representing the valid DOT bond type. Used by: NHTSA */
  qualifier?: InputMaybe<DotBondQualifier>;
  /** The surety bond tracking number. Used by: NHTSA */
  serialNumber?: InputMaybe<Scalars['String']>;
  /** The three-digit surety code assigned to the surety company that underwrites the DOT conformance bond. Used by: NHTSA */
  suretyCode?: InputMaybe<Scalars['String']>;
};

export enum DotBondQualifier {
  CONTINUOUS = 'CONTINUOUS',
  SINGLE = 'SINGLE'
}

export type DpsRecord = Record & {
  __typename?: 'DpsRecord';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Current DPS screening status */
  dpsStatus?: Maybe<DpsStatus>;
  /** Unique identifier for the entity being screened. */
  entityId: Scalars['String'];
  /** Unique identifier for this screening session. */
  entityScreeningId?: Maybe<Scalars['String']>;
  /** Version number of the entity being screened. */
  entityVersion: Scalars['Float'];
  /** Error message if DPS screening failed (optional). */
  errorMessage?: Maybe<Scalars['String']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Overall DPS status for this record */
  overallDpsStatus?: Maybe<Scalars['String']>;
  /** Resolution details for the DPS screening result (optional). */
  resolution?: Maybe<DpsResolution>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type DpsRecordEdge = ConnectionEdge & {
  __typename?: 'DpsRecordEdge';
  cursor: Scalars['ID'];
  node: DpsRecord;
};

export type DpsRecordSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** DPS status search criteria */
  dpsStatus?: InputMaybe<TextSearchCriteriaInput>;
  /** Entity ID search criteria */
  entityId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Entity screening ID search criteria */
  entityScreeningId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type DpsRecordSearchTableRow = RecordSearchTableRow & {
  __typename?: 'DpsRecordSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** DPS status code */
  dpsStatus?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId?: Maybe<Scalars['String']>;
  /** Entity screening ID */
  entityScreeningId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type DpsRecordsConnection = Connection & {
  __typename?: 'DpsRecordsConnection';
  edges: Array<DpsRecordEdge>;
  nodes: Array<DpsRecord>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Resolution details for DPS screening result. */
export type DpsResolution = {
  __typename?: 'DpsResolution';
  /** Final resolution decision (ALLOW or BLOCK). */
  dpsResolution: DpsResolutionStatusCode;
  /** Timestamp when the resolution was made. */
  dpsResolutionTime: Scalars['DateTime'];
};

/** Resolution details for DPS screening result. */
export type DpsResolutionInput = {
  /** Final resolution decision (ALLOW or BLOCK). */
  dpsResolution: DpsResolutionStatusCode;
  /** Timestamp when the resolution was made. */
  dpsResolutionTime: Scalars['DateTime'];
};

/** Final resolution status for DPS screening (ALLOW or BLOCK). */
export enum DpsResolutionStatusCode {
  ALLOW = 'ALLOW',
  BLOCK = 'BLOCK'
}

/** Current DPS screening status */
export type DpsStatus = {
  __typename?: 'DpsStatus';
  /** Current DPS screening status code. */
  code: DpsStatusCode;
  /** Timestamp when the DPS status was last updated. */
  time?: Maybe<Scalars['DateTime']>;
};

/** Current DPS screening status code. */
export enum DpsStatusCode {
  CLEARED = 'CLEARED',
  ERROR = 'ERROR',
  POTENTIAL_MATCH = 'POTENTIAL_MATCH',
  REJECTED = 'REJECTED',
  UNDER_REVIEW = 'UNDER_REVIEW'
}

/** Current DPS screening status */
export type DpsStatusInput = {
  /** Current DPS screening status code. */
  code?: InputMaybe<DpsStatusCode>;
  /** Timestamp when the DPS status was last updated. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type DrawbackClaimReference = {
  __typename?: 'DrawbackClaimReference';
  /** Drawback Claim data in form of presigned Link to download data from */
  downloadLink: Scalars['String'];
  /** Drawback Claim S3 Reference/path */
  referenceKey: Scalars['String'];
};

export type DrawbackClaimReferenceInput = {
  /** Drawback Claim S3 Reference/path */
  referenceKey: Scalars['String'];
};

export type DunsSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['DUNS']>>;
};

export type DutyTaxFee = {
  __typename?: 'DutyTaxFee';
  /** Code specifying a type of duty regime. */
  dutyRegime?: Maybe<Scalars['String']>;
  /** Details related to payment details. */
  payment?: Maybe<Payment>;
  /** Identification of an order specifying a quota. */
  quotaOrder?: Maybe<Scalars['String']>;
  /** Tax base information for this duty/tax/fee */
  taxBase?: Maybe<TaxBase>;
  /** A qualifier to describe the duty/tax/fee type, e.g. VAT, GST, etc. */
  type?: Maybe<Scalars['DutyTaxFeeTypeCode']>;
};

export type DutyTaxFeeInput = {
  /** Code specifying a type of duty regime. */
  dutyRegime?: InputMaybe<Scalars['String']>;
  /** Details related to payment details. */
  payment?: InputMaybe<PaymentInput>;
  /** Identification of an order specifying a quota. */
  quotaOrder?: InputMaybe<Scalars['String']>;
  /** Tax base information for this duty/tax/fee */
  taxBase?: InputMaybe<TaxBaseInput>;
  /** A qualifier to describe the duty/tax/fee type, e.g. VAT, GST, etc. */
  type?: InputMaybe<Scalars['DutyTaxFeeTypeCode']>;
};

export type EffectiveEuHs = EffectiveHs & {
  __typename?: 'EffectiveEuHs';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The effective description for this HS object. */
  description?: Maybe<HsDescription>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The effective main duty rate for this HS object. */
  mainDutyRate?: Maybe<HsRate>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type EffectiveEuHssInput = {
  /** The three-letter culture code for which descriptions will be returned. */
  cultureCode?: InputMaybe<Scalars['CultureCode']>;
  /** The date in ISO 8601 format for which the query will return effective data. */
  effectiveDate: Scalars['Date'];
  /** The HS record numbers to query. The strings should only include digits. */
  hsNumbers: Array<Scalars['HtsNumber']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type EffectiveHs = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The effective description for this HS object. */
  description?: Maybe<HsDescription>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The effective main duty rate for this HS object. */
  mainDutyRate?: Maybe<HsRate>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type EffectiveUkHs = EffectiveHs & {
  __typename?: 'EffectiveUkHs';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The effective description for this HS object. */
  description?: Maybe<HsDescription>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The effective main duty rate for this HS object. */
  mainDutyRate?: Maybe<HsRate>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type EffectiveUkHssInput = {
  /** The three-letter culture code for which descriptions will be returned. */
  cultureCode?: InputMaybe<Scalars['CultureCode']>;
  /** The date in ISO 8601 format for which the query will return effective data. */
  effectiveDate: Scalars['Date'];
  /** The HS record numbers to query. The strings should only include digits. */
  hsNumbers: Array<Scalars['HtsNumber']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type EffectiveUsHtssInput = {
  /** The date in ISO 8601 format for which the query will return effective data */
  effectiveDate: Scalars['Date'];
  /** The HTS record numbers to query. The strings should only include digits */
  htsNumbers: Array<Scalars['HtsNumber']>;
};

export type EmbeddedRecord = {
  /** Information relating to the creation of the Embedded Record */
  created: RecordAction;
  /** Unique ID */
  id: Scalars['ID'];
  /** Information relating to the last update of the Embedded Record */
  updated: RecordAction;
};

export type EmployeeIdentificationNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['EmployeeIdentificationNumber']>>;
};

export type EnrichmentEntity = {
  __typename?: 'EnrichmentEntity';
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  tags?: Maybe<Array<Tag>>;
};

export type EnrichmentResultGQL = {
  __typename?: 'EnrichmentResultGQL';
  entities: Array<EnrichmentEntity>;
};

/** Entity identification code for CPSC PG19 record */
export enum EntityIdentificationCode {
  /** Small Batch Manufacturer - Has testing exclusion */
  SBM = 'SBM'
}

/** Entity role code for CPSC PG19 record */
export enum EntityRoleCode {
  /** Certifying Entity - If different from Importer of Record */
  CE = 'CE',
  /** Independent Third Party Laboratory - CPSC-Accredited lab */
  ITL = 'ITL',
  /** Laboratory - Non-accredited testing lab */
  LAB = 'LAB',
  /** Manufacturer - Entity that manufactures the product */
  MF = 'MF',
  /** No Lab Testing Required - Testing exclusion applies */
  NOL = 'NOL',
  /** Point of Contact - Individual maintaining test result records */
  PK = 'PK'
}

/** The code for the Importer's expected import volume in the country. */
export enum EntriesPerYear {
  DO_NOT_INTEND_TO_IMPORT = 'DO_NOT_INTEND_TO_IMPORT',
  FIVE_TO_TWENTY_FIVE = 'FIVE_TO_TWENTY_FIVE',
  INFREQUENT_PERSONAL_SHIPMENTS = 'INFREQUENT_PERSONAL_SHIPMENTS',
  ONE_TO_FOUR = 'ONE_TO_FOUR',
  TWENTY_FIVE_OR_MORE = 'TWENTY_FIVE_OR_MORE'
}

/** The error code of processing failure for the reference */
export enum EntryReferenceErrorCode {
  DEPENDENCY_FAILURE_EXCEPTION = 'DEPENDENCY_FAILURE_EXCEPTION',
  IEN_NOT_REQUIRED_EXCEPTION = 'IEN_NOT_REQUIRED_EXCEPTION',
  INTERNAL_SERVICE_EXCEPTION = 'INTERNAL_SERVICE_EXCEPTION',
  INVALID_IEN_FORMAT_EXCEPTION = 'INVALID_IEN_FORMAT_EXCEPTION',
  INVALID_MERCHANT_ID_EXCEPTION = 'INVALID_MERCHANT_ID_EXCEPTION',
  INVALID_REQUEST_EXCEPTION = 'INVALID_REQUEST_EXCEPTION',
  OPTIMISTIC_LOCK_EXCEPTION = 'OPTIMISTIC_LOCK_EXCEPTION',
  UNKNOWN_IEN_EXCEPTION = 'UNKNOWN_IEN_EXCEPTION',
  VALIDATION_EXCEPTION = 'VALIDATION_EXCEPTION'
}

/** The processing status of the reference number */
export enum EntryReferenceProcessingStatus {
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED',
  SUCCESS = 'SUCCESS'
}

export type ErrorDefinition = Record & {
  __typename?: 'ErrorDefinition';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The description of what the error is but can also include an SOP. */
  description: Scalars['String'];
  /** The name of the error which is associated with "name" field from processingError. */
  errorName: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ErrorDefinitionSearchCriteria = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The name of the error which is associated with "name" field from processingError. */
  errorName: TextSearchCriteriaInput;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Type of escalation */
export type EscalatationTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderTaskEscalationType>>;
};

export type EscalateWorkOrderTaskPayload = {
  __typename?: 'EscalateWorkOrderTaskPayload';
  /** The updated Work Order Task with the latest escalation. */
  workOrderTask: WorkOrderTask;
};

/** Reason Category for task escalation. */
export enum EscalationReasonCategory {
  AD_CVD = 'AD_CVD',
  CLASSIFICATION = 'CLASSIFICATION',
  COO_FTA = 'COO_FTA',
  GENERAL_ISSUE = 'GENERAL_ISSUE',
  MULTIPLE_ISSUES = 'MULTIPLE_ISSUES',
  PGA = 'PGA',
  VALUATION = 'VALUATION'
}

/** Type of escalated reason category */
export type EscalationReasonCategoryTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<EscalationReasonCategory>>;
};

/** Sub Category for task escalation. */
export enum EscalationReasonSubCategory {
  AGRICULTURE_AND_PREPARED_PRODUCTS = 'AGRICULTURE_AND_PREPARED_PRODUCTS',
  APHIS = 'APHIS',
  APPAREL_FOOTWEAR_AND_TEXTILES = 'APPAREL_FOOTWEAR_AND_TEXTILES',
  AUTOMOTIVE_AND_AEROSPACE = 'AUTOMOTIVE_AND_AEROSPACE',
  BASE_METALS = 'BASE_METALS',
  CONSUMER_PRODUCTS_AND_MASS_MERCHANDISING = 'CONSUMER_PRODUCTS_AND_MASS_MERCHANDISING',
  DATA_INPUT_ISSUE = 'DATA_INPUT_ISSUE',
  ELECTRONICS = 'ELECTRONICS',
  ENTRY_SUBMISSION_ISSUE = 'ENTRY_SUBMISSION_ISSUE',
  EPA = 'EPA',
  FDA = 'FDA',
  FWS = 'FWS',
  INDUSTRIAL_AND_MANUFACTURING_MATERIALS = 'INDUSTRIAL_AND_MANUFACTURING_MATERIALS',
  MACHINERY = 'MACHINERY',
  NHTSA = 'NHTSA',
  PETROLEUM_NATURAL_GAS_AND_MINERALS = 'PETROLEUM_NATURAL_GAS_AND_MINERALS',
  PHARMACEUTICALS_HEALTH_AND_CHEMICALS = 'PHARMACEUTICALS_HEALTH_AND_CHEMICALS'
}

/** Type of escalated reason sub category */
export type EscalationReasonSubCategoryTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<EscalationReasonSubCategory>>;
};

/** Type of escalated resolution code */
export type EscalationResolutionReasonTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ResolutionReasonCode>>;
};

/** Represents a European Union Harmonized System record */
export type EuHs = Hs & Record & {
  __typename?: 'EuHs';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Hierarchical description combining parent HS descriptions with current record description */
  description?: Maybe<HsDescription>;
  /** Effective descriptions with locale support */
  descriptions?: Maybe<Array<HsDescription>>;
  /** Ending effective date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Main duty rates */
  mainDutyRates?: Maybe<Array<HsRate>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Beginning effective date. */
  startDate?: Maybe<Scalars['Date']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** Represents a European Union Harmonized System record */
export type EuHsdescriptionArgs = {
  cultureCode?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
};

export type EuHsEdge = ConnectionEdge & {
  __typename?: 'EuHsEdge';
  cursor: Scalars['ID'];
  node: EuHs;
};

export type EuHsSearchCriteria = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The effective end date. */
  endDate?: InputMaybe<DateSearchCriteriaInput>;
  /** HS number type. */
  hsNumberType?: InputMaybe<HsNumberTypeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** HS number. */
  number?: InputMaybe<TextSearchCriteriaInput>;
  /** The effective start date. */
  startDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** EU HS search results. */
export type EuHsSearchTableRow = HsSearchTableRow & RecordSearchTableRow & {
  __typename?: 'EuHsSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The effective end date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type. */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** HTS number. */
  number: Scalars['HtsNumber'];
  /** The effective start date. */
  startDate?: Maybe<Scalars['Date']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type EuHssConnection = Connection & {
  __typename?: 'EuHssConnection';
  edges: Array<EuHsEdge>;
  nodes: Array<EuHs>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type EuIor = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<BusinessStructure>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ExamDeliveryOrderAdditionalFields = {
  __typename?: 'ExamDeliveryOrderAdditionalFields';
  /** Tracker Number for the delivery order */
  tracker?: Maybe<Scalars['String']>;
};

export type ExamDeliveryOrderAdditionalFieldsInput = {
  /** Tracker Number for the delivery order */
  tracker?: InputMaybe<Scalars['String']>;
};

/** The status of the exam being conducted on the entry. */
export type ExamStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntryExamStatus>>;
};

/** The specific type of exam conducted on the entry. */
export type ExamSubTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntryExamSubType>>;
};

/** The type of the exam conducted on the entry. */
export type ExamTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntryExamType>>;
};

export type ExcelColumn = {
  __typename?: 'ExcelColumn';
  /** The configurations and data validations present in a particular cell in this column */
  configuration?: Maybe<ExcelColumnConfiguration>;
  /** The name of the column */
  name: Scalars['String'];
};

/** The configurations and data validations present in a particular cell in this column */
export type ExcelColumnConfiguration = {
  __typename?: 'ExcelColumnConfiguration';
  /** The options to choose from in a drop-down list style */
  dropDown?: Maybe<Array<Scalars['String']>>;
};

export type ExcelColumnInput = {
  /** The configurations and data validations present in a particular cell in this column */
  configuration?: InputMaybe<DataValidationInput>;
  /** The name of the column */
  name: Scalars['String'];
};

/** Excel template document generation request. */
export type ExcelTemplateDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'ExcelTemplateDocumentGenerationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The workbook containing the sheets in this excel file. */
  workbook: ExcelWorkbook;
};

export type ExcelWorkbook = {
  __typename?: 'ExcelWorkbook';
  /** The worksheets contained within this workbook. */
  worksheets: Array<ExcelWorksheet>;
};

export type ExcelWorkbookInput = {
  /** The worksheets contained within this workbook. */
  worksheets: Array<ExcelWorksheetInput>;
};

export type ExcelWorksheet = {
  __typename?: 'ExcelWorksheet';
  /** The columns present in the excel template, ordered from left (beginning of list) to right (end of list) */
  columns: Array<ExcelColumn>;
  /** The name of the worksheet */
  name: Scalars['String'];
};

export type ExcelWorksheetInput = {
  /** The columns present in the excel template, ordered from left (beginning of list) to right (end of list) */
  columns: Array<ExcelColumnInput>;
  /** The name of the worksheet */
  name: Scalars['String'];
};

export type ExceptionReferenceInput = {
  /** The qualifer of the reconciliation exception reference type */
  qualifer?: InputMaybe<ReportReconciliationExceptionReferenceQualifer>;
  /** The reference id of reconciliation exception reference */
  refId?: InputMaybe<Scalars['ID']>;
  /** The reconciliation exception reference type for the report row */
  type: ReportReconciliationExceptionReferenceType;
  /** The value of the reconciliation exception reference */
  value?: InputMaybe<Scalars['String']>;
};

/** The primary entity used to represent a message exchange. */
export type ExchangeMessage = Record & {
  __typename?: 'ExchangeMessage';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the Exchange Message. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Additional metadata for Email ExchangeMessages. */
  inboxMetadata?: Maybe<InboxMetadata>;
  /** Represents the payload to be transmitted in its raw form received as input. */
  input: ExchangeMessageContent;
  /** The Operator that owns this Record. */
  operator?: Maybe<Operator>;
  /** Represents the final payload to be transmitted. */
  output?: Maybe<ExchangeMessageContent>;
  /** Represents the intended recipient of the message. */
  receiver: MessagingPartner;
  /** Represents the source entity of the message. */
  sender: MessagingPartner;
  /** Indicates if the document transformation is to be skipped. Defaults to false. */
  skipTransformation?: Maybe<Scalars['Boolean']>;
  /** Represents the status of the message exchange request. */
  status: ExchangeMessageStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Indicates the amount of document transmission delay to be introduced while exchanging message with a partner. */
  transmissionDelaySeconds?: Maybe<Scalars['Int']>;
  /** The type of document or message to be exchanged. */
  type: ExchangeMessageType;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** The primary entity used to represent a message exchange. */
export type ExchangeMessagedocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Captures the document payload (content). */
export type ExchangeMessageContent = {
  __typename?: 'ExchangeMessageContent';
  /** The url to fetch the document payload present only if the payload is present (already uploaded) */
  downloadLink?: Maybe<Scalars['URL']>;
  /** The url to upload the document payload present only if the payload is pending upload. */
  uploadLink?: Maybe<Scalars['URL']>;
};

export type ExchangeMessageEdge = ConnectionEdge & {
  __typename?: 'ExchangeMessageEdge';
  cursor: Scalars['ID'];
  node: ExchangeMessage;
};

/** The output payload for mutation operations encapsulating an ExchangeMessage.  */
export type ExchangeMessagePayload = {
  __typename?: 'ExchangeMessagePayload';
  /** The latest exchange message after mutation */
  record: ExchangeMessage;
};

/** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
export type ExchangeMessageSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Email address of the source entity of the message. */
  from?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Some preview of human-readable ExchangeMessage content, e.g. the first 100 characters of an email body. */
  preview?: InputMaybe<TextSearchCriteriaInput>;
  /** Represents the intended recipient of the message. */
  receiver?: InputMaybe<MessagingPartnerSearchCriteriaInput>;
  /** Represents the source entity of the message. */
  sender?: InputMaybe<MessagingPartnerSearchCriteriaInput>;
  /** Represents the status of the message exchange request. */
  status?: InputMaybe<ExchangeMessageStatusSearchCriteriaInput>;
  /** Subject line of the recieved email. */
  subject?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Email addresses of the intended recipient of the message. */
  to?: InputMaybe<TextSearchCriteriaInput>;
  /** The type of document or message to be exchanged. */
  type?: InputMaybe<ExchangeMessageTypeSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The work order this email exchange message is assigned to. */
  workOrderId?: InputMaybe<TextSearchCriteriaInput>;
};

/** Exchange message search table row. */
export type ExchangeMessageSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ExchangeMessageSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Email address of the source entity of the message. */
  from?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Some preview of human-readable ExchangeMessage content, e.g. the first 100 characters of an email body. */
  preview?: Maybe<Scalars['String']>;
  /** Represents the intended recipient of the message. */
  receiver: MessagingPartner;
  /** Represents the source entity of the message. */
  sender: MessagingPartner;
  /** Represents the status of the message exchange request. */
  status: ExchangeMessageStatus;
  /** Subject line of the recieved email. */
  subject?: Maybe<Scalars['String']>;
  /** Email addresses of the intended recipient of the message. */
  to?: Maybe<Array<Scalars['String']>>;
  /** The type of document or message to be exchanged. */
  type: ExchangeMessageType;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The work order this email exchange message is assigned to. */
  workOrderId?: Maybe<Scalars['String']>;
};

export enum ExchangeMessageStatus {
  COMPLETED = 'COMPLETED',
  PENDING_INPUT_UPLOAD = 'PENDING_INPUT_UPLOAD',
  PENDING_OUTPUT_UPLOAD = 'PENDING_OUTPUT_UPLOAD',
  PROCESSING = 'PROCESSING',
  TRANSFORMED = 'TRANSFORMED',
  TRANSFORM_FAILED = 'TRANSFORM_FAILED',
  TRANSMISSION_FAILED = 'TRANSMISSION_FAILED',
  TRANSMITTED = 'TRANSMITTED'
}

export type ExchangeMessageStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ExchangeMessageStatus>>;
};

export enum ExchangeMessageType {
  CAMIR = 'CAMIR',
  CATAIR = 'CATAIR',
  CHAIN_IO_JSON = 'CHAIN_IO_JSON',
  DIS = 'DIS',
  DOCUMENT = 'DOCUMENT',
  EMAIL = 'EMAIL',
  NOTIFICATION = 'NOTIFICATION',
  WCO_DM = 'WCO_DM',
  WEBHOOK = 'WEBHOOK',
  X12 = 'X12'
}

export type ExchangeMessageTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ExchangeMessageType>>;
};

export type ExchangeMessagesConnection = Connection & {
  __typename?: 'ExchangeMessagesConnection';
  edges: Array<ExchangeMessageEdge>;
  nodes: Array<ExchangeMessage>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ExpertiseCategory = {
  __typename?: 'ExpertiseCategory';
  /** Used to specify categories if this is a SME role */
  category: SubjectMatterCategory;
  /** Used to specify sub categories if this is a SME role */
  subCategories?: Maybe<Array<SubjectMatterSubCategory>>;
};

export type ExpertiseCategoryInput = {
  /** Used to specify categories if this is a SME role */
  category: SubjectMatterCategory;
  /** Used to specify sub categories if this is a SME role */
  subCategories?: InputMaybe<Array<SubjectMatterSubCategory>>;
};

export type ExportCountry = {
  __typename?: 'ExportCountry';
  /** Code specifying the country from which the goods are originally exported without any commercial transaction taken place in intermediate countries. */
  country?: Maybe<Scalars['CountryCode']>;
  /** Region of export identifier */
  region?: Maybe<Scalars['String']>;
};

export type ExportCountryInput = {
  /** Code specifying the country from which the goods are originally exported without any commercial transaction taken place in intermediate countries. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** Region of export identifier */
  region?: InputMaybe<Scalars['String']>;
};

/** Country codes including both standard and extended support */
export enum ExtendedCountryAbbreviation {
  AT = 'AT',
  AU = 'AU',
  BR = 'BR',
  CN = 'CN',
  CZ = 'CZ',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  IN = 'IN',
  IT = 'IT',
  JP = 'JP',
  NL = 'NL',
  PL = 'PL',
  UK = 'UK',
  US = 'US'
}

/** Reference to broker in the external system/client. */
export type ExternalBrokerReference = {
  __typename?: 'ExternalBrokerReference';
  /** Unique id to identify broker in both CBMS and external system. */
  id: Scalars['ID'];
  /** Version of the broker record in external system. */
  version?: Maybe<Scalars['String']>;
};

export type ExternalBrokerReferenceInput = {
  /** Unique id to identify broker in both CBMS and external system. */
  id: Scalars['ID'];
  /** Version of the broker record in external system. */
  version?: InputMaybe<Scalars['String']>;
};

/** An automated (System) or human (User) External Client of CBMS. */
export type ExternalClient = {
  /** Unique ID */
  id: Scalars['ID'];
  /** External client name. */
  name: Scalars['String'];
  /** The record's version */
  version: Scalars['Int'];
};

export type ExternalComplianceReference = {
  __typename?: 'ExternalComplianceReference';
  /** Stock Keeping Unit used by shippers to identify and track its inventory, or stock. */
  sku: Scalars['ID'];
  /** Version of the compliance details. */
  skuComplianceVersion?: Maybe<Scalars['Int']>;
  /** Snapshot Id of the compliance details. Would be FBA Shipment for FBA. */
  snapshotId?: Maybe<Scalars['ID']>;
  /** The source of the reference. */
  source?: Maybe<ExternalComplianceReferenceSource>;
};

export type ExternalComplianceReferenceInput = {
  /** Stock Keeping Unit used by shippers to identify and track its inventory, or stock. */
  sku: Scalars['ID'];
  /** Version of the compliance details. */
  skuComplianceVersion?: InputMaybe<Scalars['Int']>;
  /** Snapshot Id of the compliance details. Would be FBA Shipment for FBA. */
  snapshotId?: InputMaybe<Scalars['ID']>;
  /** The source of the reference. */
  source?: InputMaybe<ExternalComplianceReferenceSource>;
};

export enum ExternalComplianceReferenceSource {
  AFT = 'AFT'
}

/** Reference to external document */
export type ExternalDocumentReference = {
  __typename?: 'ExternalDocumentReference';
  /** Parition in the external service that the external document is referencing. */
  externalReferencePartition?: Maybe<Scalars['String']>;
  /** Type of service that the external document is referencing. */
  externalReferenceType?: Maybe<DocumentReferenceType>;
  /** Unique document reference identification number. */
  id: Scalars['ID'];
  /** Version of the document reference. */
  version?: Maybe<Scalars['String']>;
};

export type ExternalDocumentReferenceInput = {
  /** Parition in the external service that the external document is referencing. */
  externalReferencePartition?: InputMaybe<Scalars['String']>;
  /** Type of service that the external document is referencing. */
  externalReferenceType?: InputMaybe<DocumentReferenceType>;
  /** Unique document reference identification number. */
  id: Scalars['ID'];
  /** Version of the document reference. */
  version?: InputMaybe<Scalars['String']>;
};

/** Type of templates supported for external document generation. */
export enum ExternalDocumentTemplateType {
  CDA1 = 'CDA1',
  CDA2 = 'CDA2'
}

export type ExternalFinanceReference = {
  __typename?: 'ExternalFinanceReference';
  /** Primary ID of the data referenced from an external system. */
  id: Scalars['ID'];
  /** Name of the source. */
  source: ExternalFinanceReferenceSource;
  /** Version of the data in the external system. */
  version?: Maybe<Scalars['Int']>;
};

export type ExternalFinanceReferenceInput = {
  /** Primary ID of the data referenced from an external system. */
  id: Scalars['ID'];
  /** Name of the source. */
  source: ExternalFinanceReferenceSource;
  /** Version of the data in the external system. */
  version?: InputMaybe<Scalars['Int']>;
};

/** Source for external finance reference. */
export enum ExternalFinanceReferenceSource {
  AGL_BILL_CLAIM = 'AGL_BILL_CLAIM',
  AGL_EXTERNAL_PAYMENT_REQUEST = 'AGL_EXTERNAL_PAYMENT_REQUEST',
  AGL_PAYMENT_MANIFEST = 'AGL_PAYMENT_MANIFEST'
}

/** External clients that we have established an integration with. */
export enum ExternalIntegrationPartner {
  CENTURY_DISTRIBUTION = 'CENTURY_DISTRIBUTION',
  CHAIN_IO = 'CHAIN_IO'
}

export type ExternalIntegrationReference = {
  __typename?: 'ExternalIntegrationReference';
  /** The external client we have developed an integration with. */
  externalIntegrationPartner: ExternalIntegrationPartner;
  /** The type of the external integration. */
  externalIntegrationType: ExternalIntegrationType;
  /** A unique ID for the record within the external reference. */
  id: Scalars['ID'];
};

export type ExternalIntegrationReferenceInput = {
  /** The external client we have developed an integration with. */
  externalIntegrationPartner: ExternalIntegrationPartner;
  /** The type of the external integration. */
  externalIntegrationType: ExternalIntegrationType;
  /** A unique ID for the record within the external reference. */
  id: Scalars['ID'];
};

/** The type of the external integration. */
export enum ExternalIntegrationType {
  SNS = 'SNS',
  TRANSPORTATION_MANAGEMENT_SYSTEM = 'TRANSPORTATION_MANAGEMENT_SYSTEM'
}

/** Reference to Importer document in the external system/client. */
export type ExternalIorDocumentReference = {
  __typename?: 'ExternalIorDocumentReference';
  /** Document tag in CBMS system helps to identify document type. CBMS maintains a list of document tags. */
  documentTag?: Maybe<DocumentTag>;
  /** External document reference. */
  externalReference: ExternalDocumentReference;
};

export type ExternalIorDocumentReferenceInput = {
  /** Document tag in CBMS system helps to identify document type. CBMS maintains a list of document tags. */
  documentTag?: InputMaybe<DocumentTag>;
  /** External document reference. */
  externalReference: ExternalDocumentReferenceInput;
};

/** Reference to Importer in the external system. */
export type ExternalIorReference = {
  __typename?: 'ExternalIorReference';
  /** External document references. */
  documents?: Maybe<Array<ExternalIorDocumentReference>>;
  /**  Importer identifier in external system. */
  id: Scalars['ID'];
  /** External entity onboarding the Importer. */
  referenceType?: Maybe<ExternalIorReferenceType>;
  /** Version of the Importer record in external system. */
  version?: Maybe<Scalars['String']>;
};

export type ExternalIorReferenceInput = {
  /** External document references. */
  documents?: InputMaybe<Array<ExternalIorDocumentReferenceInput>>;
  /**  Importer identifier in external system. */
  id: Scalars['ID'];
  /** External entity onboarding the Importer. */
  referenceType?: InputMaybe<ExternalIorReferenceType>;
  /** Version of the Importer record in external system. */
  version?: InputMaybe<Scalars['String']>;
};

/** External IOR system/client reference. */
export enum ExternalIorReferenceType {
  FBA = 'FBA'
}

export type ExternalSystem = {
  /** API Authorization Details. */
  authorization?: Maybe<ApiAuthorization>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration: ExternalSystemAwsIntegrationDetails;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: Maybe<ExternalSystemIntegrationDetails>;
  /** Unique ID */
  id: Scalars['ID'];
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications: Array<ExternalSystemNotificationPreference>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** URL to recieve events via webhook. */
  webhookUrl?: Maybe<Scalars['URL']>;
};

/** Details related to the AWS integration between CBMS and the External System. */
export type ExternalSystemAwsIntegrationDetails = {
  __typename?: 'ExternalSystemAwsIntegrationDetails';
  /** List of AWS Account ids of the External System which are granted permission to call CBMS API. */
  accountIds?: Maybe<Array<Scalars['AwsAccountId']>>;
  /** AWS IAM Role assumed by the External System to sign requests to the CBMS API. */
  iamRole?: Maybe<ExternalSystemAwsIntegrationIamRole>;
  /** AWS Kinesis Stream used to send notifications from CBMS to the External System. */
  kinesisStream?: Maybe<ExternalSystemAwsIntegrationKinesisStream>;
  /** AWS SNS topic used to send events from CBMS to the External System. */
  snsTopic?: Maybe<ExternalSystemAwsIntegrationSnsTopic>;
  /** The status of the AWS integration with the External System. */
  status: ExternalSystemAwsIntegrationStatus;
};

/** Details related to the AWS integration between CBMS and the External System. */
export type ExternalSystemAwsIntegrationDetailsInput = {
  /** List of AWS Account ids of the External System which are granted permission to call CBMS API. */
  accountIds?: InputMaybe<Array<Scalars['AwsAccountId']>>;
  /** AWS IAM Role assumed by the External System to sign requests to the CBMS API. */
  iamRole?: InputMaybe<ExternalSystemAwsIntegrationIamRoleInput>;
  /** AWS Kinesis Stream used to send notifications from CBMS to the External System. */
  kinesisStream?: InputMaybe<ExternalSystemAwsIntegrationKinesisStreamInput>;
  /** AWS SNS topic used to send events from CBMS to the External System. */
  snsTopic?: InputMaybe<ExternalSystemAwsIntegrationSnsTopicInput>;
  /** The status of the AWS integration with the External System. */
  status?: InputMaybe<ExternalSystemAwsIntegrationStatus>;
};

/** AWS IAM Role assumed by the External System to sign requests to the CBMS API. */
export type ExternalSystemAwsIntegrationIamRole = {
  __typename?: 'ExternalSystemAwsIntegrationIamRole';
  /** 12-digit AWS Account ID where the External System calls the CBMS API. Passed by the client to setup the integration. */
  accountId?: Maybe<Scalars['AwsAccountId']>;
  /** IAM Role ARN (Amazon Resource Number) assumed by the External System to sign requests to the CBMS API. */
  arn?: Maybe<Scalars['String']>;
  /** IAM Role name assumed by the External System to sign requests to the CBMS API. */
  name?: Maybe<Scalars['String']>;
};

/** AWS IAM Role assumed by the External System to sign requests to the CBMS API. */
export type ExternalSystemAwsIntegrationIamRoleInput = {
  /** 12-digit AWS Account ID where the External System calls the CBMS API. Passed by the client to setup the integration. */
  accountId?: InputMaybe<Scalars['AwsAccountId']>;
  /** IAM Role ARN (Amazon Resource Number) assumed by the External System to sign requests to the CBMS API. */
  arn?: InputMaybe<Scalars['String']>;
  /** IAM Role name assumed by the External System to sign requests to the CBMS API. */
  name?: InputMaybe<Scalars['String']>;
};

/** AWS Kinesis Stream used to send notifications from CBMS to the External System. */
export type ExternalSystemAwsIntegrationKinesisStream = {
  __typename?: 'ExternalSystemAwsIntegrationKinesisStream';
  /** IAM Role ARN (Amazon Resource Number) used to send notifications from CBMS to the Kinesis stream. */
  iamRoleArn: Scalars['IamRoleArn'];
  /** The name of Kinesis stream for receiving notifications from CBMS. */
  kinesisStreamName: Scalars['KinesisStreamName'];
  /** The AWS region where the Kinesis stream is located. */
  region: Scalars['String'];
};

/** AWS Kinesis Stream used to send notifications from CBMS to the External System. */
export type ExternalSystemAwsIntegrationKinesisStreamInput = {
  /** IAM Role ARN (Amazon Resource Number) used to send notifications from CBMS to the Kinesis stream. */
  iamRoleArn: Scalars['IamRoleArn'];
  /** The name of Kinesis stream for receiving notifications from CBMS. */
  kinesisStreamName: Scalars['KinesisStreamName'];
  /** The AWS region where the Kinesis stream is located. */
  region: Scalars['String'];
};

/** AWS SNS topic used to send events from CBMS to the External System. */
export type ExternalSystemAwsIntegrationSnsTopic = {
  __typename?: 'ExternalSystemAwsIntegrationSnsTopic';
  /** 12-digit AWS Account ID where the External System subscribes to the SNS topic. Passed by the client to setup the integration. */
  accountId: Scalars['AwsAccountId'];
  /** 12-digit AWS Account IDs where the External System subscribes to the SNS topic. Passed by the client to setup the integration. */
  accountIds?: Maybe<Array<Scalars['AwsAccountId']>>;
  /** SNS topic ARN (Amazon Resource Number) used to send events from CBMS to the External System. */
  arn?: Maybe<Scalars['SnsArn']>;
};

/** AWS SNS topic used to send events from CBMS to the External System. */
export type ExternalSystemAwsIntegrationSnsTopicInput = {
  /** 12-digit AWS Account ID where the External System subscribes to the SNS topic. Passed by the client to setup the integration. */
  accountId: Scalars['AwsAccountId'];
  /** 12-digit AWS Account IDs where the External System subscribes to the SNS topic. Passed by the client to setup the integration. */
  accountIds?: InputMaybe<Array<Scalars['AwsAccountId']>>;
  /** SNS topic ARN (Amazon Resource Number) used to send events from CBMS to the External System. */
  arn?: InputMaybe<Scalars['SnsArn']>;
};

/** The status of the AWS integration with the External System. */
export enum ExternalSystemAwsIntegrationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PROCESSING = 'PROCESSING'
}

/** Configuration for non-AWS integrations */
export type ExternalSystemIntegrationDetails = {
  __typename?: 'ExternalSystemIntegrationDetails';
  /** IRIS integration details */
  iris?: Maybe<ExternalSystemIrisIntegration>;
};

/** Configuration for non-AWS integrations */
export type ExternalSystemIntegrationDetailsInput = {
  /** IRIS integration details */
  iris?: InputMaybe<ExternalSystemIrisIntegrationInput>;
};

/** Configuration related to the IRIS integration */
export type ExternalSystemIrisIntegration = {
  __typename?: 'ExternalSystemIrisIntegration';
  /** Customer specific value for IRIS to identify client for data transmission */
  passthroughId: Scalars['ID'];
};

/** Configuration related to the IRIS integration */
export type ExternalSystemIrisIntegrationInput = {
  /** Customer specific value for IRIS to identify client for data transmission */
  passthroughId: Scalars['ID'];
};

/** The notification method for an external system. */
export enum ExternalSystemNotificationMethod {
  KINESIS = 'KINESIS',
  SNS = 'SNS',
  WEBHOOK = 'WEBHOOK'
}

export type ExternalSystemNotificationPreference = {
  __typename?: 'ExternalSystemNotificationPreference';
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<ExternalSystemNotificationMethod>;
  /** The type of the notification. */
  type: ExternalSystemNotificationType;
  /** Work order milestones that external systems are subscribed to. */
  workOrderMilestoneSubscriptions?: Maybe<Array<WorkOrderMilestoneName>>;
};

export type ExternalSystemNotificationPreferenceInput = {
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<ExternalSystemNotificationMethod>;
  /** The type of the notification. */
  type: ExternalSystemNotificationType;
  /** Work order milestones that external systems are subscribed to. */
  workOrderMilestoneSubscriptions?: InputMaybe<Array<WorkOrderMilestoneName>>;
};

/** The notification type for an external system. */
export enum ExternalSystemNotificationType {
  CUSTOMS_FILING_MILESTONE = 'CUSTOMS_FILING_MILESTONE',
  ENTRY_CONFIRMATION = 'ENTRY_CONFIRMATION',
  IMPORTER_OF_RECORD_ACTIVATION = 'IMPORTER_OF_RECORD_ACTIVATION',
  PENDING_INQUIRY = 'PENDING_INQUIRY',
  SHIPMENT_DOCUMENT_UPLOAD = 'SHIPMENT_DOCUMENT_UPLOAD'
}

export type ExternalSystemSearchCriteriaInput = {
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: InputMaybe<AwsAccountIdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Notification preference for external system */
  externalSystemNotificationTypes?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The AWS IAM Role Name assumed by the External System to sign requests to the CBMS API. */
  iamRoleName?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External System. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** External system search results. */
export type ExternalSystemSearchTableRow = {
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the External System. */
  name?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ExternalValidation = {
  __typename?: 'ExternalValidation';
  identification: PartyIdentification;
  response: ExternalValidationResponse;
  validationDate: Scalars['DateTime'];
};

export type ExternalValidationInput = {
  identification: PartyIdentificationInput;
  response: ExternalValidationResponseInput;
  validationDate: Scalars['DateTime'];
};

export type ExternalValidationResponse = {
  __typename?: 'ExternalValidationResponse';
  companyDetails?: Maybe<CompanyInfo>;
  errorMessage?: Maybe<Scalars['String']>;
  invalidReason?: Maybe<InvalidExternalValidationReason>;
  validationResult: ExternalValidationResult;
};

export type ExternalValidationResponseInput = {
  companyDetails?: InputMaybe<CompanyInfoInput>;
  errorMessage?: InputMaybe<Scalars['String']>;
  invalidReason?: InputMaybe<InvalidExternalValidationReason>;
  validationResult: ExternalValidationResult;
};

/** The result of an identifier's external validation. */
export enum ExternalValidationResult {
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN',
  VALID = 'VALID'
}

export type ExtractedBusinessLicense = {
  __typename?: 'ExtractedBusinessLicense';
  /** Business address from extracted license */
  address?: Maybe<AddressV2>;
  /** Business name from extracted license */
  name?: Maybe<Scalars['String']>;
};

export type ExtractedBusinessLicenseInput = {
  /** Business address from extracted license */
  address?: InputMaybe<AddressV2Input>;
  /** Business name from extracted license */
  name?: InputMaybe<Scalars['String']>;
};

/** Contains data extracted from the document. */
export type ExtractedDocumentContent = {
  __typename?: 'ExtractedDocumentContent';
  /** External document reference. */
  externalDocumentReference?: Maybe<ExternalDocumentReference>;
};

export type ExtractedDocumentContentInput = {
  /** External document reference. */
  externalDocumentReference?: InputMaybe<ExternalDocumentReferenceInput>;
};

export type ExtractionReference = {
  __typename?: 'ExtractionReference';
  /** The S3 Link to download extracted results. */
  downloadLink: Scalars['String'];
  /** The shipment commercial invoice extraction S3 reference/path. */
  referenceKey: Scalars['String'];
};

export type ExtractionReferenceInput = {
  /** The shipment commercial invoice extraction S3 reference/path. */
  referenceKey: Scalars['String'];
};

export type FacilitiesConnection = Connection & {
  __typename?: 'FacilitiesConnection';
  edges: Array<FacilityEdge>;
  nodes: Array<Facility>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type Facility = Party & Record & {
  __typename?: 'Facility';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Compliance details for customs purposes. */
  complianceDetails?: Maybe<FacilityComplianceDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the Facility. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A point of contact for receiving goods */
  receivingPointOfContact?: Maybe<PointOfContact>;
  /** A Shipper linked to this Facility */
  shipper: ShipperFacilityRelationship;
  /** Shipper connection used to paginate results. */
  shippers: FacilityShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type FacilitydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type FacilitymemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type FacilityshipperArgs = {
  shipperId: Scalars['ID'];
};


export type FacilityshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type FacilityComplianceDetails = {
  __typename?: 'FacilityComplianceDetails';
  /** Facility related US customs compliance details. */
  us?: Maybe<FacilityUsComplianceDetails>;
};

export type FacilityComplianceDetailsInput = {
  /** Facility related US customs compliance details. */
  us?: InputMaybe<FacilityUsComplianceDetailsInput>;
};

export type FacilityEdge = ConnectionEdge & {
  __typename?: 'FacilityEdge';
  cursor: Scalars['ID'];
  node: Facility;
};

export type FacilitySearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<EmployeeIdentificationNumberSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  firmsCode?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type FacilitySearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'FacilitySearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: Maybe<Scalars['String']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type FacilityShipperEdge = ConnectionEdge & {
  __typename?: 'FacilityShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Facility. */
  relationship: ShipperFacilityRelationship;
};

export type FacilityShippersConnection = Connection & {
  __typename?: 'FacilityShippersConnection';
  edges: Array<FacilityShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FacilityUsComplianceDetails = {
  __typename?: 'FacilityUsComplianceDetails';
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: Maybe<Scalars['String']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
};

export type FacilityUsComplianceDetailsInput = {
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: InputMaybe<Scalars['String']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
};

/** Feature flag object representing a specific feature's status and settings. */
export type FeatureFlag = Record & {
  __typename?: 'FeatureFlag';
  /** Additional attributes for the feature flag. */
  attributes?: Maybe<Array<Attribute>>;
  /** The cleanup reminder date for the feature flag. */
  cleanupReminderDate?: Maybe<Scalars['DateTime']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The dial-up percentage for the feature flag. */
  dialUpPercentage?: Maybe<Scalars['Percentage']>;
  /** Whether the feature flag is enabled. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The name of the feature flag. */
  featureFlagName: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type FeatureFlagEdge = ConnectionEdge & {
  __typename?: 'FeatureFlagEdge';
  cursor: Scalars['ID'];
  node: FeatureFlag;
};

export type FeatureFlagsConnection = Connection & {
  __typename?: 'FeatureFlagsConnection';
  edges: Array<FeatureFlagEdge>;
  nodes: Array<FeatureFlag>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FederatedShipperUser = FederatedUser & {
  __typename?: 'FederatedShipperUser';
  /** The operator the user belongs to. */
  operator: Operator;
  /** Whether the actor is the root actor of the party it belongs to. */
  root?: Maybe<Scalars['Boolean']>;
  /** The shipper party the user belongs to. */
  shipper: Shipper;
};

export type FederatedUser = {
  /** Whether the actor is the root actor of the party it belongs to. */
  root?: Maybe<Scalars['Boolean']>;
};

export type FederatedUserContext = AuthenticationContext & {
  __typename?: 'FederatedUserContext';
  /** Hash used for intercom */
  intercomHash?: Maybe<Scalars['String']>;
  /** The federated user details */
  user?: Maybe<FederatedUser>;
};

export type FeeDetail = {
  __typename?: 'FeeDetail';
  /** Class Code for this fee set by US CBP */
  classCode: Scalars['String'];
  /** Rate for this fee set by US CBP */
  display: Scalars['String'];
  fee: Scalars['UsDollars'];
};

export type FeeDetailInput = {
  /** Class Code for this fee set by US CBP */
  classCode: Scalars['String'];
  /** Rate for this fee set by US CBP */
  display: Scalars['String'];
  fee: Scalars['UsDollars'];
};

/** Payload of FetchEuHsHierarchy */
export type FetchEuHsHierarchyPayload = {
  __typename?: 'FetchEuHsHierarchyPayload';
  /** The S3 download link for retrieving HsHierarchyMap */
  downloadUrl: Scalars['URL'];
  /** S3 object version of the hierarchy file */
  versionId: Scalars['String'];
};

export type FetchForwarderMailFromPayload = {
  __typename?: 'FetchForwarderMailFromPayload';
  /** DKIM verification status. */
  dkimStatus: Scalars['String'];
  /** Email DNS records to be provided to DNS. */
  dns: Array<DNSRecord>;
  /**  MAIL FROM Domain verification status. */
  domainStatus: Scalars['String'];
  /** 'fromMail' verification status. */
  emailVerificationStatus: Scalars['String'];
  /** Forwarder ID */
  id: Scalars['ID'];
  /** Forwarder email white labeling details.  */
  mailFrom: ForwarderMailFrom;
};

/** Payload of FetchUkHsHierarchy */
export type FetchUkHsHierarchyPayload = {
  __typename?: 'FetchUkHsHierarchyPayload';
  /** The S3 download link for retrieving HsHierarchyMap */
  downloadUrl: Scalars['URL'];
  /** S3 object version of the hierarchy file */
  versionId: Scalars['String'];
};

/** Payload of FetchUsHtsHierarchy */
export type FetchUsHtsHierarchyPayload = {
  __typename?: 'FetchUsHtsHierarchyPayload';
  /** The S3 download link for retrieving HsHierarchyMap */
  downloadUrl: Scalars['URL'];
  /** S3 object version of the hierarchy file */
  versionId: Scalars['String'];
};

export type FieldChange = {
  __typename?: 'FieldChange';
  /** Action performed, based on the field */
  action: ActionType;
  /** Value after the change */
  changedToValue?: Maybe<Scalars['String']>;
  /** Path of the field */
  fieldPath: Scalars['DotSeparatedPathWithIndicesValue'];
  /** Value before the change */
  originalValue?: Maybe<Scalars['String']>;
};

export type FieldChangeInput = {
  /** Action performed, based on the field */
  action: ActionType;
  /** Value after the change */
  changedToValue?: InputMaybe<Scalars['String']>;
  /** Path of the field */
  fieldPath: Scalars['DotSeparatedPathWithIndicesValue'];
  /** Value before the change */
  originalValue?: InputMaybe<Scalars['String']>;
};

export type FirmsCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['FirmsCode']>>;
};

export type FlipWorkOrderPayload = {
  __typename?: 'FlipWorkOrderPayload';
  /** New work order created from input work order */
  record: WorkOrder;
};

export type FloatSearchCriteriaInput = {
  /** The maximum value when requesting a range operation */
  max?: InputMaybe<Scalars['Float']>;
  /** The minimum value when requesting a range operation */
  min?: InputMaybe<Scalars['Float']>;
  /** Operators available when searcing for number data types. */
  operator: NumberSearchOperator;
  /** The value for non-range operations. */
  value?: InputMaybe<Scalars['Float']>;
};

export enum FoodFacilityRegistrationExemption {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  K = 'K'
}

export type Forwarder = Account & BillingParty & Customer & Party & ProductOwner & Record & {
  __typename?: 'Forwarder';
  /** Account details */
  accountDetails?: Maybe<AccountDetails>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Billing related details. */
  billingDetails?: Maybe<BillingDetails>;
  /** Forwarder Cargowise One integration details. */
  cargowise?: Maybe<ForwarderCargowiseIntegrationDetails>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: Maybe<CustomerDefaultWorkOrdersConfig>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Features disabled for forwarder. */
  disabledFeatures?: Maybe<ForwarderDisabledFeatures>;
  /** The document sign request associated with the Forwarder. This is an eventually consistent query. */
  documentSignRequests: Array<DocumentSignRequest>;
  /** The documents associated with the Forwarder. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** References to this external system in external integrations. */
  externalIntegrationReferences?: Maybe<Array<PartyExternalIntegrationReference>>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The Forwarder or Shipper that has invited this Forwarder to the CBMS platform. */
  invitingParty?: Maybe<ForwarderInvitingParty>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Forwarder email white labeling details */
  mailFrom?: Maybe<ForwarderMailFrom>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** Indicates whether the forwarder overrides ior POA - Direct or Master/Sub. */
  poaMethod?: Maybe<POAMethod>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** The configuration for this party's product library */
  productLibraryConfiguration?: Maybe<ProductLibraryConfiguration>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: Maybe<Scalars['SCACCode']>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: Maybe<CustomerSelfFiledWorkOrdersConfig>;
  /** A Shipper linked to this Freight Forwarder */
  shipper: ShipperForwarderRelationship;
  /** Shipper connection used to paginate results. */
  shippers: ForwarderShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Indicates whether the forwarder supports importing personal effects. */
  supportsPersonalEffects?: Maybe<Scalars['Boolean']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: Maybe<ForwarderWorkOrderConfig>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: Maybe<Array<ForwarderWorkOrderConfirmationConfiguration>>;
};


export type ForwarderdocumentSignRequestsArgs = {
  statuses?: InputMaybe<Array<DocumentSignRequestStatus>>;
};


export type ForwarderdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ForwardermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ForwardershipperArgs = {
  shipperId: Scalars['ID'];
};


export type ForwardershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

/** Forwarder Cargowise One integration details. */
export type ForwarderCargowiseIntegrationDetails = {
  __typename?: 'ForwarderCargowiseIntegrationDetails';
  /** The ID representing  the Forwarder's Cargowise One instance. */
  cargowiseId: Scalars['ID'];
  /** The email address to receive emails when the integration encounters a business logic error. */
  errorEmail: Scalars['Email'];
  /** The recipient ID on inbound messages to the platform from CW1, and the sendID used on outbound messages from the platform to CW1. */
  messageId: Scalars['ID'];
  /** The Cargowise eAdaptor password. Gives authentication to request documents from the account. */
  password: Scalars['String'];
  /** The Cargowise eAdaptor username. Gives authentication to request documents from the account. */
  username: Scalars['String'];
};

/** Forwarder Cargowise One integration details. */
export type ForwarderCargowiseIntegrationDetailsInput = {
  /** The ID representing  the Forwarder's Cargowise One instance. */
  cargowiseId: Scalars['ID'];
  /** The email address to receive emails when the integration encounters a business logic error. */
  errorEmail: Scalars['Email'];
  /** The recipient ID on inbound messages to the platform from CW1, and the sendID used on outbound messages from the platform to CW1. */
  messageId: Scalars['ID'];
  /** The Cargowise eAdaptor password. Gives authentication to request documents from the account. */
  password: Scalars['String'];
  /** The Cargowise eAdaptor username. Gives authentication to request documents from the account. */
  username: Scalars['String'];
};

export type ForwarderCustomsDeclarationConfig = CustomerCustomsDeclarationConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderCustomsDeclarationConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ForwarderCustomsDeclarationConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ForwarderDeCustomsEntryConfig = CustomerDeCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderDeCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ForwarderDeCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ForwarderDeliveryOrderConfig = CustomerDeliveryOrderConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderDeliveryOrderConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<DeliveryOrderServiceLevelAgreement>>;
};

export type ForwarderDeliveryOrderConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<DeliveryOrderServiceLevelAgreementInput>>;
};

/** Features disabled for forwarder. */
export type ForwarderDisabledFeatures = {
  __typename?: 'ForwarderDisabledFeatures';
  /** If set to true, IOR activation work order will be disabled during IOR onboarding. */
  iorActivationWorkOrder?: Maybe<Scalars['Boolean']>;
  /** If set to true, POA esign link generation will be disabled during IOR creation. */
  poaLinkOnIorCreation?: Maybe<Scalars['Boolean']>;
  /** If set to true, the unit assist percentage will box will not be editable. */
  unitAssistPercentage?: Maybe<Scalars['Boolean']>;
  /** If set to true, the unit assist value will box will not be editable. */
  unitAssistValue?: Maybe<Scalars['Boolean']>;
};

/** Features disabled for forwarder. */
export type ForwarderDisabledFeaturesInput = {
  /** If set to true, IOR activation work order will be disabled during IOR onboarding. */
  iorActivationWorkOrder?: InputMaybe<Scalars['Boolean']>;
  /** If set to true, POA esign link generation will be disabled during IOR creation. */
  poaLinkOnIorCreation?: InputMaybe<Scalars['Boolean']>;
  /** If set to true, the unit assist percentage will box will not be editable. */
  unitAssistPercentage?: InputMaybe<Scalars['Boolean']>;
  /** If set to true, the unit assist value will box will not be editable. */
  unitAssistValue?: InputMaybe<Scalars['Boolean']>;
};

export type ForwarderEdge = ConnectionEdge & {
  __typename?: 'ForwarderEdge';
  cursor: Scalars['ID'];
  node: Forwarder;
};

export type ForwarderFrCustomsEntryConfig = CustomerFrCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderFrCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ForwarderFrCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ForwarderGbCustomsEntryConfig = CustomerGbCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderGbCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ForwarderGbCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ForwarderInvitingParty = Forwarder | Shipper;

/** Forwarder email white labeling details */
export type ForwarderMailFrom = {
  __typename?: 'ForwarderMailFrom';
  /** Email address that the forwarder wish to set as 'fromEmail' to its own customers. */
  fromEmail: Scalars['Email'];
  /** Email signature that the forwarder wish to use. */
  fromSignature: Scalars['String'];
  /** Title of the email that the forwarder wish to use. */
  fromTitle: Scalars['String'];
};

export type ForwarderNlCustomsEntryConfig = CustomerNlCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderNlCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ForwarderNlCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ForwarderSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The party's AR customer id */
  arCustomerId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Country code (ISO 3166) that the AR customer has been onboarded to */
  arOnboardingCountry?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<EmployeeIdentificationNumberSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** A unique ID for the record within the external reference. */
  externalIntegrationReferenceId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the party that invited this party to CBMS. */
  invitingPartyId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Importer of Record ID for the Forwarder. */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Importer of Record for the Forwarder. */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<ScacSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The party's subscription plan */
  subscriptionPlan?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type ForwarderSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'ForwarderSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The party's AR customer id */
  arCustomerId?: Maybe<Scalars['String']>;
  /** Country code (ISO 3166) that the AR customer has been onboarded to */
  arOnboardingCountry?: Maybe<Array<Scalars['CountryCode']>>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The ID of the party that invited this party to CBMS. */
  invitingPartyId?: Maybe<Scalars['ID']>;
  /** The Importer of Record Id for the Forwarder. */
  iorId?: Maybe<Array<Scalars['String']>>;
  /** The Importer of Record for the Forwarder. */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: Maybe<Scalars['SCACCode']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The party's subscription plan */
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ForwarderShipperEdge = ConnectionEdge & {
  __typename?: 'ForwarderShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Freight Forwarder. */
  relationship: ShipperForwarderRelationship;
};

export type ForwarderShippersConnection = Connection & {
  __typename?: 'ForwarderShippersConnection';
  edges: Array<ForwarderShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** External Client's Freight Forwarding System. */
export type ForwarderSystem = ExternalClient & ExternalSystem & Record & {
  __typename?: 'ForwarderSystem';
  /** API Authorization Details. */
  authorization?: Maybe<ApiAuthorization>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration: ExternalSystemAwsIntegrationDetails;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: Maybe<ExternalSystemIntegrationDetails>;
  forwarder: Forwarder;
  /** Unique ID */
  id: Scalars['ID'];
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications: Array<ExternalSystemNotificationPreference>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** URL to recieve events via webhook. */
  webhookUrl?: Maybe<Scalars['URL']>;
};

export type ForwarderSystemEdge = ConnectionEdge & {
  __typename?: 'ForwarderSystemEdge';
  cursor: Scalars['ID'];
  node: ForwarderSystem;
};

export type ForwarderSystemSearchCriteriaInput = {
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: InputMaybe<AwsAccountIdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Notification preference for external system */
  externalSystemNotificationTypes?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Forwarder's ID. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Forwarder's name. */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** The AWS IAM Role Name assumed by the External System to sign requests to the CBMS API. */
  iamRoleName?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External System. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** External Client's Freight Forwarding System. */
export type ForwarderSystemSearchTableRow = ExternalSystemSearchTableRow & RecordSearchTableRow & {
  __typename?: 'ForwarderSystemSearchTableRow';
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the External System. */
  name?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ForwarderSystemsConnection = Connection & {
  __typename?: 'ForwarderSystemsConnection';
  edges: Array<ForwarderSystemEdge>;
  nodes: Array<ForwarderSystem>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ForwarderUsConsumptionEntryConfig = CustomerUsConsumptionEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderUsConsumptionEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsConsumptionEntryServiceLevelAgreement>>;
};

export type ForwarderUsConsumptionEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsConsumptionEntryServiceLevelAgreementInput>>;
};

export type ForwarderUsIorContinuousBondRequestConfig = CustomerUsIorContinuousBondRequestConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderUsIorContinuousBondRequestConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** If set, the Shipper will be set as the billToParty for US IOR Continuous Bond Requests */
  invoiceShipper?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsIorContinuousBondRequestServiceLevelAgreement>>;
};

export type ForwarderUsIorContinuousBondRequestConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** If set, the Shipper will be set as the billToParty for US IOR Continuous Bond Requests */
  invoiceShipper?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsIorContinuousBondRequestServiceLevelAgreementInput>>;
};

export type ForwarderUsIsfConfig = CustomerUsIsfConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderUsIsfConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsIsfServiceLevelAgreement>>;
};

export type ForwarderUsIsfConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsIsfServiceLevelAgreementInput>>;
};

export type ForwarderUsType86EntryConfig = CustomerUsType86EntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ForwarderUsType86EntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsType86EntryServiceLevelAgreement>>;
};

export type ForwarderUsType86EntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsType86EntryServiceLevelAgreementInput>>;
};

/** User of a Forwarder */
export type ForwarderUser = ExternalClient & Record & User & {
  __typename?: 'ForwarderUser';
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: Maybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: Maybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: Maybe<Scalars['Boolean']>;
  /** Forwarder User Cargowise One integration details. */
  cargowise?: Maybe<ForwarderUserCargowiseIntegrationDetails>;
  /** User details from the Cognito User Pool. */
  cognito?: Maybe<CognitoUserDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the ForwarderUser. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** References to this forwarder user in external integrations. */
  externalIntegrationReferences?: Maybe<Array<ExternalIntegrationReference>>;
  forwarder: Forwarder;
  /** Unique ID */
  id: Scalars['ID'];
  /** Identity information provided by an external IDP such as Auth Portal */
  identity?: Maybe<Identity>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: Maybe<Scalars['Boolean']>;
  /** Link returned to the user after they have created a new account, granting the ability to reset their password and login for the first time. */
  loginLink?: Maybe<Scalars['URL']>;
  /** A mobile phone number. */
  mobilePhone?: Maybe<Phone>;
  /** External client name. */
  name: Scalars['String'];
  /** The forwarder's notification preferences. */
  notifications: Array<ForwarderUserNotificationPreference>;
  /** A office phone number. */
  officePhone?: Maybe<Phone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The forwarder's permissions. */
  permissions?: Maybe<ForwarderUserPermissions>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: Maybe<Scalars['Boolean']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The teams the user is on */
  teams?: Maybe<Array<Team>>;
  /** Title of the user */
  title: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** User of a Forwarder */
export type ForwarderUserdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ForwarderUserBulkChargesUploadRequestPermission = {
  __typename?: 'ForwarderUserBulkChargesUploadRequestPermission';
  /** The name of permission. */
  name: ForwarderUserBulkChargesUploadRequestPermissionName;
};

export type ForwarderUserBulkChargesUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserBulkChargesUploadRequestPermissionName;
};

export enum ForwarderUserBulkChargesUploadRequestPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ForwarderUserBulkComplianceUploadRequestPermission = {
  __typename?: 'ForwarderUserBulkComplianceUploadRequestPermission';
  /** The name of permission. */
  name: ForwarderUserBulkComplianceUploadRequestPermissionName;
};

export type ForwarderUserBulkComplianceUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserBulkComplianceUploadRequestPermissionName;
};

export enum ForwarderUserBulkComplianceUploadRequestPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ForwarderUserBulkMilestoneUploadRequestPermission = {
  __typename?: 'ForwarderUserBulkMilestoneUploadRequestPermission';
  /** The name of permission. */
  name: ForwarderUserBulkMilestoneUploadRequestPermissionName;
};

export type ForwarderUserBulkMilestoneUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserBulkMilestoneUploadRequestPermissionName;
};

export enum ForwarderUserBulkMilestoneUploadRequestPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ForwarderUserBulkProductUploadTemplateDocumentGenerationRequestPermission = {
  __typename?: 'ForwarderUserBulkProductUploadTemplateDocumentGenerationRequestPermission';
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export type ForwarderUserBulkProductUploadTemplateDocumentGenerationRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

/** Forwarder User Cargowise One integration details. */
export type ForwarderUserCargowiseIntegrationDetails = {
  __typename?: 'ForwarderUserCargowiseIntegrationDetails';
  /** The ID representing the User in the Forwarder's Cargowise One instance. */
  cargowiseId: Scalars['ID'];
};

/** Forwarder User Cargowise One integration details. */
export type ForwarderUserCargowiseIntegrationDetailsInput = {
  /** The ID representing the User in the Forwarder's Cargowise One instance. */
  cargowiseId: Scalars['ID'];
};

export type ForwarderUserCompanyPermission = {
  __typename?: 'ForwarderUserCompanyPermission';
  /** The name of permission. */
  name: ForwarderUserCompanyPermissionName;
};

export type ForwarderUserCompanyPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserCompanyPermissionName;
};

export enum ForwarderUserCompanyPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserCustomsAgentPermission = {
  __typename?: 'ForwarderUserCustomsAgentPermission';
  /** The name of permission. */
  name: ForwarderUserCustomsAgentPermissionName;
};

export type ForwarderUserCustomsAgentPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserCustomsAgentPermissionName;
};

export enum ForwarderUserCustomsAgentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserCustomsBrokerPermission = {
  __typename?: 'ForwarderUserCustomsBrokerPermission';
  /** The name of permission. */
  name: ForwarderUserCustomsBrokerPermissionName;
};

export type ForwarderUserCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserCustomsBrokerPermissionName;
};

export enum ForwarderUserCustomsBrokerPermissionName {
  READ = 'READ'
}

export type ForwarderUserDeCustomsEntryPermission = {
  __typename?: 'ForwarderUserDeCustomsEntryPermission';
  /** The name of permission. */
  name: ForwarderUserDeCustomsEntryPermissionName;
};

export type ForwarderUserDeCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserDeCustomsEntryPermissionName;
};

export enum ForwarderUserDeCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserDeliveryOrderPermission = {
  __typename?: 'ForwarderUserDeliveryOrderPermission';
  /** The name of permission. */
  name: ForwarderUserDeliveryOrderPermissionName;
};

export type ForwarderUserDeliveryOrderPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserDeliveryOrderPermissionName;
};

export enum ForwarderUserDeliveryOrderPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserDocumentPermission = {
  __typename?: 'ForwarderUserDocumentPermission';
  /** The name of permission. */
  name: ForwarderUserDocumentPermissionName;
};

export type ForwarderUserDocumentPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserDocumentPermissionName;
};

export enum ForwarderUserDocumentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserDocumentTemplatePermission = {
  __typename?: 'ForwarderUserDocumentTemplatePermission';
  /** The name of permission. */
  name: ForwarderUserDocumentTemplatePermissionName;
};

export type ForwarderUserDocumentTemplatePermissionInput = {
  /** The name of permission. */
  name: ForwarderUserDocumentTemplatePermissionName;
};

export enum ForwarderUserDocumentTemplatePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserEdge = ConnectionEdge & {
  __typename?: 'ForwarderUserEdge';
  cursor: Scalars['ID'];
  node: ForwarderUser;
};

export type ForwarderUserFacilityPermission = {
  __typename?: 'ForwarderUserFacilityPermission';
  /** The name of permission. */
  name: ForwarderUserFacilityPermissionName;
};

export type ForwarderUserFacilityPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserFacilityPermissionName;
};

export enum ForwarderUserFacilityPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserForwarderUserPermission = {
  __typename?: 'ForwarderUserForwarderUserPermission';
  /** The name of permission. */
  name: ForwarderUserForwarderUserPermissionName;
};

export type ForwarderUserForwarderUserPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserForwarderUserPermissionName;
};

export enum ForwarderUserForwarderUserPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserFrCustomsEntryPermission = {
  __typename?: 'ForwarderUserFrCustomsEntryPermission';
  /** The name of permission. */
  name: ForwarderUserFrCustomsEntryPermissionName;
};

export type ForwarderUserFrCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserFrCustomsEntryPermissionName;
};

export enum ForwarderUserFrCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserGbCustomsEntryPermission = {
  __typename?: 'ForwarderUserGbCustomsEntryPermission';
  /** The name of permission. */
  name: ForwarderUserGbCustomsEntryPermissionName;
};

export type ForwarderUserGbCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserGbCustomsEntryPermissionName;
};

export enum ForwarderUserGbCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserImportProductsFromBulkUploadRequestPermission = {
  __typename?: 'ForwarderUserImportProductsFromBulkUploadRequestPermission';
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export type ForwarderUserImportProductsFromBulkUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export type ForwarderUserImportProductsFromCustomsEntriesRequestPermission = {
  __typename?: 'ForwarderUserImportProductsFromCustomsEntriesRequestPermission';
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export type ForwarderUserImportProductsFromCustomsEntriesRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export type ForwarderUserInvoicePermission = {
  __typename?: 'ForwarderUserInvoicePermission';
  /** The name of permission. */
  name: ForwarderUserInvoicePermissionName;
};

export type ForwarderUserInvoicePermissionInput = {
  /** The name of permission. */
  name: ForwarderUserInvoicePermissionName;
};

export enum ForwarderUserInvoicePermissionName {
  READ = 'READ'
}

export type ForwarderUserNlCustomsEntryPermission = {
  __typename?: 'ForwarderUserNlCustomsEntryPermission';
  /** The name of permission. */
  name: ForwarderUserNlCustomsEntryPermissionName;
};

export type ForwarderUserNlCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserNlCustomsEntryPermissionName;
};

export enum ForwarderUserNlCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

/** The notification method for a forwarder user. */
export enum ForwarderUserNotificationMethod {
  CBMS_WEBSITE = 'CBMS_WEBSITE',
  EMAIL = 'EMAIL'
}

export type ForwarderUserNotificationPreference = {
  __typename?: 'ForwarderUserNotificationPreference';
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<ForwarderUserNotificationMethod>;
  /** The type of the notification. */
  type: ForwarderUserNotificationType;
};

export type ForwarderUserNotificationPreferenceInput = {
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<ForwarderUserNotificationMethod>;
  /** The type of the notification. */
  type: ForwarderUserNotificationType;
};

/** The notification type for a forwarder user. */
export enum ForwarderUserNotificationType {
  BULK_DOCUMENT_DOWNLOAD = 'BULK_DOCUMENT_DOWNLOAD',
  DAILY_STATEMENT = 'DAILY_STATEMENT',
  DO_ISSUED = 'DO_ISSUED',
  ENTRY_CONFIRMATION = 'ENTRY_CONFIRMATION',
  FDA_NOTICE = 'FDA_NOTICE',
  FDA_NOTICE_CLEARED = 'FDA_NOTICE_CLEARED',
  FORWARDER_ONBOARDED = 'FORWARDER_ONBOARDED',
  INQUIRE_SHIPMENT_DOCUMENT = 'INQUIRE_SHIPMENT_DOCUMENT',
  MONTHLY_STATEMENT = 'MONTHLY_STATEMENT',
  PMS_APPROVED = 'PMS_APPROVED',
  POA_REMINDER = 'POA_REMINDER',
  REJECT_SHIPMENT_DOCUMENT = 'REJECT_SHIPMENT_DOCUMENT',
  REQUEST_SHIPMENT_DOCUMENTS = 'REQUEST_SHIPMENT_DOCUMENTS',
  SHIPMENT_CANCELED = 'SHIPMENT_CANCELED',
  SHIPMENT_CREATED = 'SHIPMENT_CREATED',
  SHIPMENT_CREATED_NO_ACTION = 'SHIPMENT_CREATED_NO_ACTION',
  SHIPMENT_FORWARDER_TAGGED = 'SHIPMENT_FORWARDER_TAGGED',
  SHIPMENT_UPDATED = 'SHIPMENT_UPDATED',
  USER_INVITED = 'USER_INVITED',
  USER_INVITE_ACCEPTED = 'USER_INVITE_ACCEPTED',
  US_CONSUMPTION_ENTRY_CBP_EXAM = 'US_CONSUMPTION_ENTRY_CBP_EXAM',
  US_CONSUMPTION_ENTRY_CBP_HOLD = 'US_CONSUMPTION_ENTRY_CBP_HOLD',
  US_CONSUMPTION_ENTRY_CBP_RELEASE = 'US_CONSUMPTION_ENTRY_CBP_RELEASE',
  US_CONSUMPTION_ENTRY_FILED = 'US_CONSUMPTION_ENTRY_FILED',
  US_CONSUMPTION_ENTRY_PGA_HOLD = 'US_CONSUMPTION_ENTRY_PGA_HOLD',
  US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_CONSUMPTION_ENTRY_PGA_REJECTED = 'US_CONSUMPTION_ENTRY_PGA_REJECTED',
  US_CONSUMPTION_ENTRY_PGA_RELEASE = 'US_CONSUMPTION_ENTRY_PGA_RELEASE',
  US_CONSUMPTION_ENTRY_REVISED = 'US_CONSUMPTION_ENTRY_REVISED',
  US_CONTINUOUS_BOND_ONBOARDING = 'US_CONTINUOUS_BOND_ONBOARDING',
  US_IN_BOND_ARRIVED = 'US_IN_BOND_ARRIVED',
  US_IN_BOND_AUTHORIZED = 'US_IN_BOND_AUTHORIZED',
  US_IN_BOND_BILL_ARRIVED = 'US_IN_BOND_BILL_ARRIVED',
  US_IN_BOND_BILL_EXPORTED = 'US_IN_BOND_BILL_EXPORTED',
  US_IN_BOND_CONTAINER_ARRIVED = 'US_IN_BOND_CONTAINER_ARRIVED',
  US_IN_BOND_CONTAINER_EXPORTED = 'US_IN_BOND_CONTAINER_EXPORTED',
  US_IN_BOND_DIVERSION = 'US_IN_BOND_DIVERSION',
  US_IN_BOND_TRANSFERRED = 'US_IN_BOND_TRANSFERRED',
  US_ISF_BILL_MATCH = 'US_ISF_BILL_MATCH',
  US_ISF_FILED = 'US_ISF_FILED',
  US_ISF_NO_BILL_MATCH = 'US_ISF_NO_BILL_MATCH',
  US_ISF_REJECTED = 'US_ISF_REJECTED',
  US_POST_SUMMARY_CORRECTION_APPROVED = 'US_POST_SUMMARY_CORRECTION_APPROVED',
  US_POST_SUMMARY_CORRECTION_CREATED = 'US_POST_SUMMARY_CORRECTION_CREATED',
  US_POST_SUMMARY_CORRECTION_FILED = 'US_POST_SUMMARY_CORRECTION_FILED',
  US_POST_SUMMARY_CORRECTION_REJECTED = 'US_POST_SUMMARY_CORRECTION_REJECTED',
  US_POST_SUMMARY_CORRECTION_SUBMITTED = 'US_POST_SUMMARY_CORRECTION_SUBMITTED',
  US_TYPE86_ENTRY_CBP_EXAM = 'US_TYPE86_ENTRY_CBP_EXAM',
  US_TYPE86_ENTRY_CBP_HOLD = 'US_TYPE86_ENTRY_CBP_HOLD',
  US_TYPE86_ENTRY_CBP_RELEASE = 'US_TYPE86_ENTRY_CBP_RELEASE',
  US_TYPE86_ENTRY_FILED = 'US_TYPE86_ENTRY_FILED',
  US_TYPE86_ENTRY_PGA_HOLD = 'US_TYPE86_ENTRY_PGA_HOLD',
  US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_TYPE86_ENTRY_PGA_REJECTED = 'US_TYPE86_ENTRY_PGA_REJECTED',
  US_TYPE86_ENTRY_PGA_RELEASE = 'US_TYPE86_ENTRY_PGA_RELEASE',
  WORK_ORDER_GROUP_INVOICE_CREATED = 'WORK_ORDER_GROUP_INVOICE_CREATED',
  WORK_ORDER_GROUP_INVOICE_VOIDED = 'WORK_ORDER_GROUP_INVOICE_VOIDED'
}

export type ForwarderUserPermissions = {
  __typename?: 'ForwarderUserPermissions';
  /** The Forwarder's permission to bulkChargesUploadRequest. */
  bulkChargesUploadRequest?: Maybe<Array<ForwarderUserBulkChargesUploadRequestPermission>>;
  /** The Forwarder's permission to bulkComplianceUploadRequest. */
  bulkComplianceUploadRequest?: Maybe<Array<ForwarderUserBulkComplianceUploadRequestPermission>>;
  /** The Forwarder's permission to bulkMilestoneUploadRequest. */
  bulkMilestoneUploadRequest?: Maybe<Array<ForwarderUserBulkMilestoneUploadRequestPermission>>;
  /** The Forwarder's permission to BulkProductUploadTemplateDocumentGenerationRequest. */
  bulkProductUploadTemplateDocumentGenerationRequest?: Maybe<Array<ForwarderUserBulkProductUploadTemplateDocumentGenerationRequestPermission>>;
  /** The Forwarder's permission to Forwarder. */
  company?: Maybe<Array<ForwarderUserCompanyPermission>>;
  /** The Forwarder's permission to CustomsAgent. */
  customsAgent?: Maybe<Array<ForwarderUserCustomsAgentPermission>>;
  /** The Forwarder's permission to CustomsBroker. */
  customsBroker?: Maybe<Array<ForwarderUserCustomsBrokerPermission>>;
  /** The Forwarder's permission to DeCustomsEntry. */
  deCustomsEntry?: Maybe<Array<ForwarderUserDeCustomsEntryPermission>>;
  /** The Forwarder's permission to DeliverOrder. */
  deliveryOrder?: Maybe<Array<ForwarderUserDeliveryOrderPermission>>;
  /** The Forwarder's permission to Document. */
  document?: Maybe<Array<ForwarderUserDocumentPermission>>;
  /** The Forwarder's permission to DocumentTemplate. */
  documentTemplate?: Maybe<Array<ForwarderUserDocumentTemplatePermission>>;
  /** The Forwarder's permission to Facility. */
  facility?: Maybe<Array<ForwarderUserFacilityPermission>>;
  /** The Forwarder's permission to User. */
  forwarderUser?: Maybe<Array<ForwarderUserForwarderUserPermission>>;
  /** The Forwarder's permission to FrCustomsEntry. */
  frCustomsEntry?: Maybe<Array<ForwarderUserFrCustomsEntryPermission>>;
  /** The Forwarder's permission to GbCustomsEntry. */
  gbCustomsEntry?: Maybe<Array<ForwarderUserGbCustomsEntryPermission>>;
  /** The Forwarder's permission to ImportProductsFromBulkUploadRequest. */
  importProductsFromBulkUploadRequest?: Maybe<Array<ForwarderUserImportProductsFromBulkUploadRequestPermission>>;
  /** The Forwarder's permission to ImportProductsFromCustomsEntriesRequest. */
  importProductsFromCustomsEntriesRequest?: Maybe<Array<ForwarderUserImportProductsFromCustomsEntriesRequestPermission>>;
  /** The Forwarder's permission to Invoice. */
  invoice?: Maybe<Array<ForwarderUserInvoicePermission>>;
  /** The Forwarder's permission to NlCustomsEntry. */
  nlCustomsEntry?: Maybe<Array<ForwarderUserNlCustomsEntryPermission>>;
  /** The Forwarder's permission to Product. */
  product?: Maybe<Array<ForwarderUserProductPermission>>;
  /** The Forwarder's permission to ReleaseNote. */
  releaseNote?: Maybe<Array<ForwarderUserReleaseNotePermission>>;
  /** The Forwarder's permission to Shipment. */
  shipment?: Maybe<Array<ForwarderUserShipmentPermission>>;
  /** The Forwarder's permission to Shipper. */
  shipper?: Maybe<Array<ForwarderUserShipperPermission>>;
  /** The Forwarder's permission to Supplier. */
  supplier?: Maybe<Array<ForwarderUserSupplierPermission>>;
  /** The Forwarder's permission to Trucker. */
  trucker?: Maybe<Array<ForwarderUserSupplierPermission>>;
  /** The Forwarder's permission to UsConsignee. */
  usConsignee?: Maybe<Array<ForwarderUserUsConsigneePermission>>;
  /** The Forwarder's permission to UsConsumptionEntry. */
  usConsumptionEntry?: Maybe<Array<ForwarderUserUsConsumptionEntryPermission>>;
  /** The Forwarder's permission to UsCustomsBroker. */
  usCustomsBroker?: Maybe<Array<ForwarderUserUsCustomsBrokerPermission>>;
  /** The Forwarder's permission to UsDrawbackClaim. */
  usDrawbackClaim?: Maybe<Array<ForwarderUserUsDrawbackClaimPermission>>;
  /** The Forwarder's permission to UsInBond. */
  usInBond?: Maybe<Array<ForwarderUserUsInBondPermission>>;
  /** The Forwarder's permission to UsIor. */
  usIor?: Maybe<Array<ForwarderUserUsIorPermission>>;
  /** The Forwarder's permission to UsIorActivation. */
  usIorActivation?: Maybe<Array<ForwarderUserUsIorActivationPermission>>;
  /** The Forwarder's permission to UsIorContinuousBondRequest. */
  usIorContinuousBondRequest?: Maybe<Array<ForwarderUserUsIorContinuousBondRequestPermission>>;
  /** The Forwarder's permission to UsIsf. */
  usIsf?: Maybe<Array<ForwarderUserUsIsfPermission>>;
  /** The Forwarder's permission to UsPostSummaryCorrection. */
  usPostSummaryCorrection?: Maybe<Array<ForwarderUserPostSummaryCorrectionPermission>>;
  /** The Forwarder's permission to UsType86Entry. */
  usType86Entry?: Maybe<Array<ForwarderUserUsType86EntryPermission>>;
  /** The Forwarder's permission to UserReleaseNoteView. */
  userReleaseNoteView?: Maybe<Array<ForwarderUserUserReleaseNoteViewPermission>>;
};

export type ForwarderUserPermissionsInput = {
  /** The Forwarder's permission to bulkChargesUploadRequest. */
  bulkChargesUploadRequest?: InputMaybe<Array<ForwarderUserBulkChargesUploadRequestPermissionInput>>;
  /** The Forwarder's permission to bulkComplianceUploadRequest. */
  bulkComplianceUploadRequest?: InputMaybe<Array<ForwarderUserBulkComplianceUploadRequestPermissionInput>>;
  /** The Forwarder's permission to bulkMilestoneUploadRequest. */
  bulkMilestoneUploadRequest?: InputMaybe<Array<ForwarderUserBulkMilestoneUploadRequestPermissionInput>>;
  /** The Forwarder's permission to BulkProductUploadTemplateDocumentGenerationRequest. */
  bulkProductUploadTemplateDocumentGenerationRequest?: InputMaybe<Array<ForwarderUserBulkProductUploadTemplateDocumentGenerationRequestPermissionInput>>;
  /** The Forwarder's permission to Forwarder. */
  company?: InputMaybe<Array<ForwarderUserCompanyPermissionInput>>;
  /** The Forwarder's permission to CustomsAgent. */
  customsAgent?: InputMaybe<Array<ForwarderUserCustomsAgentPermissionInput>>;
  /** The Forwarder's permission to CustomsBroker. */
  customsBroker?: InputMaybe<Array<ForwarderUserCustomsBrokerPermissionInput>>;
  /** The Forwarder's permission to DeCustomsEntry. */
  deCustomsEntry?: InputMaybe<Array<ForwarderUserDeCustomsEntryPermissionInput>>;
  /** The Forwarder's permission to DeliverOrder. */
  deliveryOrder?: InputMaybe<Array<ForwarderUserDeliveryOrderPermissionInput>>;
  /** The Forwarder's permission to Document. */
  document?: InputMaybe<Array<ForwarderUserDocumentPermissionInput>>;
  /** The Forwarder's permission to DocumentTemplate. */
  documentTemplate?: InputMaybe<Array<ForwarderUserDocumentTemplatePermissionInput>>;
  /** The Forwarder's permission to Facility. */
  facility?: InputMaybe<Array<ForwarderUserFacilityPermissionInput>>;
  /** The Forwarder's permission to User. */
  forwarderUser?: InputMaybe<Array<ForwarderUserForwarderUserPermissionInput>>;
  /** The Forwarder's permission to FrCustomsEntry. */
  frCustomsEntry?: InputMaybe<Array<ForwarderUserFrCustomsEntryPermissionInput>>;
  /** The Forwarder's permission to GbCustomsEntry. */
  gbCustomsEntry?: InputMaybe<Array<ForwarderUserGbCustomsEntryPermissionInput>>;
  /** The Forwarder's permission to ImportProductsFromBulkUploadRequest. */
  importProductsFromBulkUploadRequest?: InputMaybe<Array<ForwarderUserImportProductsFromBulkUploadRequestPermissionInput>>;
  /** The Forwarder's permission to ImportProductsFromCustomsEntriesRequest. */
  importProductsFromCustomsEntriesRequest?: InputMaybe<Array<ForwarderUserImportProductsFromCustomsEntriesRequestPermissionInput>>;
  /** The Forwarder's permission to Invoice. */
  invoice?: InputMaybe<Array<ForwarderUserInvoicePermissionInput>>;
  /** The Forwarder's permission to NlCustomsEntry. */
  nlCustomsEntry?: InputMaybe<Array<ForwarderUserNlCustomsEntryPermissionInput>>;
  /** The Forwarder's permission to Product. */
  product?: InputMaybe<Array<ForwarderUserProductPermissionInput>>;
  /** The Forwarder's permission to ReleaseNote. */
  releaseNote?: InputMaybe<Array<ForwarderUserReleaseNotePermissionInput>>;
  /** The Forwarder's permission to Shipment. */
  shipment?: InputMaybe<Array<ForwarderUserShipmentPermissionInput>>;
  /** The Forwarder's permission to Shipper. */
  shipper?: InputMaybe<Array<ForwarderUserShipperPermissionInput>>;
  /** The Forwarder's permission to Supplier. */
  supplier?: InputMaybe<Array<ForwarderUserSupplierPermissionInput>>;
  /** The Forwarder's permission to Trucker. */
  trucker?: InputMaybe<Array<ForwarderUserSupplierPermissionInput>>;
  /** The Forwarder's permission to UsConsignee. */
  usConsignee?: InputMaybe<Array<ForwarderUserUsConsigneePermissionInput>>;
  /** The Forwarder's permission to UsConsumptionEntry. */
  usConsumptionEntry?: InputMaybe<Array<ForwarderUserUsConsumptionEntryPermissionInput>>;
  /** The Forwarder's permission to UsCustomsBroker. */
  usCustomsBroker?: InputMaybe<Array<ForwarderUserUsCustomsBrokerPermissionInput>>;
  /** The Forwarder's permission to UsDrawbackClaim. */
  usDrawbackClaim?: InputMaybe<Array<ForwarderUserUsDrawbackClaimPermissionInput>>;
  /** The Forwarder's permission to UsInBond. */
  usInBond?: InputMaybe<Array<ForwarderUserUsInBondPermissionInput>>;
  /** The Forwarder's permission to UsIor. */
  usIor?: InputMaybe<Array<ForwarderUserUsIorPermissionInput>>;
  /** The Forwarder's permission to UsIorActivation. */
  usIorActivation?: InputMaybe<Array<ForwarderUserUsIorActivationPermissionInput>>;
  /** The Forwarder's permission to UsIorContinuousBondRequest. */
  usIorContinuousBondRequest?: InputMaybe<Array<ForwarderUserUsIorContinuousBondRequestPermissionInput>>;
  /** The Forwarder's permission to UsIsf. */
  usIsf?: InputMaybe<Array<ForwarderUserUsIsfPermissionNameInput>>;
  /** The Forwarder's permission to UsPostSummaryCorrection. */
  usPostSummaryCorrection?: InputMaybe<Array<ForwarderUserPostSummaryCorrectionPermissionInput>>;
  /** The Forwarder's permission to UsType86Entry. */
  usType86Entry?: InputMaybe<Array<ForwarderUserUsType86EntryPermissionInput>>;
  /** The Forwarder's permission to UserReleaseNoteView. */
  userReleaseNoteView?: InputMaybe<Array<ForwarderUserUserReleaseNoteViewPermissionInput>>;
};

export type ForwarderUserPostSummaryCorrectionPermission = {
  __typename?: 'ForwarderUserPostSummaryCorrectionPermission';
  /** The name of permission. */
  name: ForwarderUserPostSummaryCorrectionPermissionName;
};

export type ForwarderUserPostSummaryCorrectionPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserPostSummaryCorrectionPermissionName;
};

export enum ForwarderUserPostSummaryCorrectionPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ForwarderUserProductPermission = {
  __typename?: 'ForwarderUserProductPermission';
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export type ForwarderUserProductPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserProductPermissionName;
};

export enum ForwarderUserProductPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserReleaseNotePermission = {
  __typename?: 'ForwarderUserReleaseNotePermission';
  /** The name of permission. */
  name: ForwarderUserReleaseNotePermissionName;
};

export type ForwarderUserReleaseNotePermissionInput = {
  /** The name of permission. */
  name: ForwarderUserReleaseNotePermissionName;
};

export enum ForwarderUserReleaseNotePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserSearchCriteriaInput = {
  /** The User's Cognito Identity ID. */
  cognitoId?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's email. */
  email?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** A unique ID for the record within the external reference. */
  externalIntegrationReferenceId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Forwarder's ID. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Forwarder's name. */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Whether or not a User is logged in. */
  loggedIn?: InputMaybe<BooleanSearchCriteriaInput>;
  /** The name of the User. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The IDs of the teams the user is on */
  teamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the teams the user is on */
  teamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The title of the User. */
  title?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's unique identifier provided by an IDP. */
  userIdentifier?: InputMaybe<IdIndexSearchCriteriaInput>;
};

/** Forwarder user's table search row. */
export type ForwarderUserSearchTableRow = RecordSearchTableRow & UserSearchTableRow & {
  __typename?: 'ForwarderUserSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The User's email. */
  email?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The forwarder's name */
  forwarderName?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether or not a User is logged in. */
  loggedIn?: Maybe<Scalars['Boolean']>;
  /** Whether or not a User has Multi-Factor Authentication (MFA) enabled. */
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  /** The name of the User. */
  name?: Maybe<Scalars['String']>;
  /** The IDs of the teams the user is on */
  teamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the teams the user is on */
  teamName?: Maybe<Array<Scalars['String']>>;
  /** The title of the User. */
  title?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ForwarderUserShipmentPermission = {
  __typename?: 'ForwarderUserShipmentPermission';
  /** The name of permission. */
  name: ForwarderUserShipmentPermissionName;
};

export type ForwarderUserShipmentPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserShipmentPermissionName;
};

export enum ForwarderUserShipmentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserShipperPermission = {
  __typename?: 'ForwarderUserShipperPermission';
  /** The name of permission. */
  name: ForwarderUserShipperPermissionName;
};

export type ForwarderUserShipperPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserShipperPermissionName;
};

export enum ForwarderUserShipperPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserSupplierPermission = {
  __typename?: 'ForwarderUserSupplierPermission';
  /** The name of permission. */
  name: ForwarderUserSupplierPermissionName;
};

export type ForwarderUserSupplierPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserSupplierPermissionName;
};

export enum ForwarderUserSupplierPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsConsigneePermission = {
  __typename?: 'ForwarderUserUsConsigneePermission';
  /** The name of permission. */
  name: ForwarderUserUsConsigneePermissionName;
};

export type ForwarderUserUsConsigneePermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsConsigneePermissionName;
};

export enum ForwarderUserUsConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsConsumptionEntryPermission = {
  __typename?: 'ForwarderUserUsConsumptionEntryPermission';
  /** The name of permission. */
  name: ForwarderUserUsConsumptionEntryPermissionName;
};

export type ForwarderUserUsConsumptionEntryPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsConsumptionEntryPermissionName;
};

export enum ForwarderUserUsConsumptionEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsCustomsBrokerPermission = {
  __typename?: 'ForwarderUserUsCustomsBrokerPermission';
  /** The name of permission. */
  name: ForwarderUserUsCustomsBrokerPermissionName;
};

export type ForwarderUserUsCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsCustomsBrokerPermissionName;
};

export enum ForwarderUserUsCustomsBrokerPermissionName {
  READ = 'READ'
}

export type ForwarderUserUsDrawbackClaimPermission = {
  __typename?: 'ForwarderUserUsDrawbackClaimPermission';
  /** The name of permission. */
  name: ForwarderUserUsDrawbackClaimPermissionName;
};

export type ForwarderUserUsDrawbackClaimPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsDrawbackClaimPermissionName;
};

export enum ForwarderUserUsDrawbackClaimPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsInBondPermission = {
  __typename?: 'ForwarderUserUsInBondPermission';
  /** The name of permission. */
  name: ForwarderUserUsInBondPermissionName;
};

export type ForwarderUserUsInBondPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsInBondPermissionName;
};

export enum ForwarderUserUsInBondPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  IN_BOND_DELETE_BILL_CBP_TRANSACTION = 'IN_BOND_DELETE_BILL_CBP_TRANSACTION',
  IN_BOND_DELETE_CBP_TRANSACTION = 'IN_BOND_DELETE_CBP_TRANSACTION',
  IN_BOND_SUBMIT_ACTION_CBP_TRANSACTION = 'IN_BOND_SUBMIT_ACTION_CBP_TRANSACTION',
  IN_BOND_SUBMIT_CBP_TRANSACTION = 'IN_BOND_SUBMIT_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsIorActivationPermission = {
  __typename?: 'ForwarderUserUsIorActivationPermission';
  /** The name of permission. */
  name: ForwarderUserUsIorActivationPermissionName;
};

export type ForwarderUserUsIorActivationPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsIorActivationPermissionName;
};

export enum ForwarderUserUsIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsIorContinuousBondRequestPermission = {
  __typename?: 'ForwarderUserUsIorContinuousBondRequestPermission';
  /** The name of permission. */
  name: ForwarderUserUsIorContinuousBondRequestPermissionName;
};

export type ForwarderUserUsIorContinuousBondRequestPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsIorContinuousBondRequestPermissionName;
};

export enum ForwarderUserUsIorContinuousBondRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsIorPermission = {
  __typename?: 'ForwarderUserUsIorPermission';
  /** The name of permission. */
  name: ForwarderUserUsIorPermissionName;
};

export type ForwarderUserUsIorPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsIorPermissionName;
};

export enum ForwarderUserUsIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  SUB_POA_AUTHORITY = 'SUB_POA_AUTHORITY',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUsIsfPermission = {
  __typename?: 'ForwarderUserUsIsfPermission';
  /** The name of permission. */
  name: ForwarderUserUsIsfPermissionName;
};

export enum ForwarderUserUsIsfPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  CREATE_CBP_TRANSACTION = 'CREATE_CBP_TRANSACTION',
  DELETE = 'DELETE',
  DELETE_CBP_TRANSACTION = 'DELETE_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPDATE_CBP_TRANSACTION = 'UPDATE_CBP_TRANSACTION'
}

export type ForwarderUserUsIsfPermissionNameInput = {
  /** The name of permission. */
  name: ForwarderUserUsIsfPermissionName;
};

export type ForwarderUserUsType86EntryPermission = {
  __typename?: 'ForwarderUserUsType86EntryPermission';
  /** The name of permission. */
  name: ForwarderUserUsType86EntryPermissionName;
};

export type ForwarderUserUsType86EntryPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUsType86EntryPermissionName;
};

export enum ForwarderUserUsType86EntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUserUserReleaseNoteViewPermission = {
  __typename?: 'ForwarderUserUserReleaseNoteViewPermission';
  /** The name of permission. */
  name: ForwarderUserUserReleaseNoteViewPermissionName;
};

export type ForwarderUserUserReleaseNoteViewPermissionInput = {
  /** The name of permission. */
  name: ForwarderUserUserReleaseNoteViewPermissionName;
};

export enum ForwarderUserUserReleaseNoteViewPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ForwarderUsersConnection = Connection & {
  __typename?: 'ForwarderUsersConnection';
  edges: Array<ForwarderUserEdge>;
  nodes: Array<ForwarderUser>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** WorkOrderConfig for the forwarder */
export type ForwarderWorkOrderConfig = CustomerWorkOrderConfig & {
  __typename?: 'ForwarderWorkOrderConfig';
  /** Configuration of Customs Declaration for the customer */
  customsDeclaration?: Maybe<ForwarderCustomsDeclarationConfig>;
  /** Configuration of De Customs Entry for the customer */
  deCustomsEntry?: Maybe<ForwarderDeCustomsEntryConfig>;
  /** Configuration of delivery order for the customer */
  deliveryOrder?: Maybe<ForwarderDeliveryOrderConfig>;
  /** Configuration of Fr Customs Entry for the customer */
  frCustomsEntry?: Maybe<ForwarderFrCustomsEntryConfig>;
  /** Configuration of Gb Customs Entry for the customer */
  gbCustomsEntry?: Maybe<ForwarderGbCustomsEntryConfig>;
  /** Configuration of Nl Customs Entry for the customer */
  nlCustomsEntry?: Maybe<ForwarderNlCustomsEntryConfig>;
  /** Configuration of US Consumption Entry for the customer */
  usConsumptionEntry?: Maybe<ForwarderUsConsumptionEntryConfig>;
  /** Configuration of US IOR Continuous Bond Request for the customer */
  usIorContinuousBondRequest?: Maybe<ForwarderUsIorContinuousBondRequestConfig>;
  /** Configuration of US Isf for the customer */
  usIsf?: Maybe<ForwarderUsIsfConfig>;
  /** Configuration of US Type86 Entry for the customer */
  usType86Entry?: Maybe<ForwarderUsType86EntryConfig>;
};

/** WorkOrderConfig for the forwarder */
export type ForwarderWorkOrderConfigInput = {
  /** Configuration of Customs Declaration for the customer */
  customsDeclaration?: InputMaybe<ForwarderCustomsDeclarationConfigInput>;
  /** Configuration of De Customs Entry for the customer */
  deCustomsEntry?: InputMaybe<ForwarderDeCustomsEntryConfigInput>;
  /** Configuration of delivery order for the customer */
  deliveryOrder?: InputMaybe<ForwarderDeliveryOrderConfigInput>;
  /** Configuration of Fr Customs Entry for the customer */
  frCustomsEntry?: InputMaybe<ForwarderFrCustomsEntryConfigInput>;
  /** Configuration of Gb Customs Entry for the customer */
  gbCustomsEntry?: InputMaybe<ForwarderGbCustomsEntryConfigInput>;
  /** Configuration of Nl Customs Entry for the customer */
  nlCustomsEntry?: InputMaybe<ForwarderNlCustomsEntryConfigInput>;
  /** Configuration of US Consumption Entry for the customer */
  usConsumptionEntry?: InputMaybe<ForwarderUsConsumptionEntryConfigInput>;
  /** Configuration of US IOR Continuous Bond Request for the customer */
  usIorContinuousBondRequest?: InputMaybe<ForwarderUsIorContinuousBondRequestConfigInput>;
  /** Configuration of US Isf for the customer */
  usIsf?: InputMaybe<ForwarderUsIsfConfigInput>;
  /** Configuration of US Type86 Entry for the customer */
  usType86Entry?: InputMaybe<ForwarderUsType86EntryConfigInput>;
};

/** Work Order Confirmation Configuration Details. */
export type ForwarderWorkOrderConfirmationConfiguration = CustomerWorkOrderConfirmationConfiguration & {
  __typename?: 'ForwarderWorkOrderConfirmationConfiguration';
  /** Duration of minutes to wait for the response until auto approve. Never auto approve if not defined. */
  approveAfterMinutes?: Maybe<Scalars['Int']>;
  /** Documents to send along with entry summary confirmation request so the client more information about the entry. */
  includedDocuments?: Maybe<Array<DocumentTag>>;
  /** Rules for work order confirmation setting. Always request confirmation if not defined. */
  ruleGroup?: Maybe<BusinessRuleGroup>;
  /** Type of work order associated with the confirmation. */
  workOrderType: WorkOrderType;
};

/** Work Order Confirmation Configuration Details. */
export type ForwarderWorkOrderConfirmationConfigurationInput = {
  /** Duration of minutes to wait for the response until auto approve. Never auto approve if not defined. */
  approveAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** Documents to send along with entry summary confirmation request so the client more information about the entry. */
  includedDocuments?: InputMaybe<Array<DocumentTag>>;
  /** Rules for work order confirmation setting. Always request confirmation if not defined. */
  ruleGroup?: InputMaybe<BusinessRuleGroupInput>;
  /** Type of work order associated with the confirmation. */
  workOrderType: WorkOrderType;
};

export type ForwardersConnection = Connection & {
  __typename?: 'ForwardersConnection';
  edges: Array<ForwarderEdge>;
  nodes: Array<Forwarder>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrConsignee = Consignee & Party & Record & {
  __typename?: 'FrConsignee';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this FR Consignee */
  shipper: ShipperFrConsigneeRelationship;
  /** Shipper connection used to paginate results. */
  shippers: FrConsigneeShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type FrConsigneememosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type FrConsigneeshipperArgs = {
  shipperId: Scalars['ID'];
};


export type FrConsigneeshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type FrConsigneeEdge = ConnectionEdge & {
  __typename?: 'FrConsigneeEdge';
  cursor: Scalars['ID'];
  node: FrConsignee;
};

export type FrConsigneeSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type FrConsigneeSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'FrConsigneeSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type FrConsigneeShipperEdge = ConnectionEdge & {
  __typename?: 'FrConsigneeShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and FR Consignee. */
  relationship: ShipperFrConsigneeRelationship;
};

export type FrConsigneeShippersConnection = Connection & {
  __typename?: 'FrConsigneeShippersConnection';
  edges: Array<FrConsigneeShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrConsigneesConnection = Connection & {
  __typename?: 'FrConsigneesConnection';
  edges: Array<FrConsigneeEdge>;
  nodes: Array<FrConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrCustomsBroker = CustomsBroker & Party & Record & {
  __typename?: 'FrCustomsBroker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['FrEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this FR Customs Broker */
  shipper: ShipperFrCustomsBrokerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: FrCustomsBrokerShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type FrCustomsBrokermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type FrCustomsBrokershipperArgs = {
  shipperId: Scalars['ID'];
};


export type FrCustomsBrokershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type FrCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'FrCustomsBrokerEdge';
  cursor: Scalars['ID'];
  node: FrCustomsBroker;
};

export type FrCustomsBrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<FrEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type FrCustomsBrokerSearchTableRow = {
  __typename?: 'FrCustomsBrokerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['FrEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type FrCustomsBrokerShipperEdge = ConnectionEdge & {
  __typename?: 'FrCustomsBrokerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and FR Customs Broker. */
  relationship: ShipperFrCustomsBrokerRelationship;
};

export type FrCustomsBrokerShippersConnection = Connection & {
  __typename?: 'FrCustomsBrokerShippersConnection';
  edges: Array<FrCustomsBrokerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrCustomsBrokersConnection = Connection & {
  __typename?: 'FrCustomsBrokersConnection';
  edges: Array<FrCustomsBrokerEdge>;
  nodes: Array<FrCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrCustomsEntriesConnection = Connection & {
  __typename?: 'FrCustomsEntriesConnection';
  edges: Array<FrCustomsEntryEdge>;
  nodes: Array<FrCustomsEntry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrCustomsEntry = Record & WorkOrder & {
  __typename?: 'FrCustomsEntry';
  /** Arrival information */
  arrival?: Maybe<CustomsEntryArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: FrCustomsEntryCustomsBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Consignee associated with this entry. */
  consignee?: Maybe<FrCustomsEntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<CustomsEntryDeparture>;
  /** The documents associated with the Fr Customs Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<FrCustomsEntryCommercialInvoice>>;
  /** IOR associated with this entry. */
  ior?: Maybe<FrCustomsEntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<CustomsEntryMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: Maybe<Array<Reference>>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: Maybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: Maybe<Scalars['Float']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type FrCustomsEntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type FrCustomsEntryCommercialInvoice = {
  __typename?: 'FrCustomsEntryCommercialInvoice';
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: Maybe<CustomsEntryBuyer>;
  /** Conveyance associated with the particular product. */
  conveyance?: Maybe<CustomsEntryConveyance>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: Maybe<Cost>;
  /** Commercial Invoice date */
  invoiceDate?: Maybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: Maybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<FrCustomsEntryProduct>>;
  /** Reason For Export */
  reasonsForExport?: Maybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<CustomsEntrySeller>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: Maybe<Cost>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: Maybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: Maybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type FrCustomsEntryCommercialInvoiceInput = {
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: InputMaybe<CustomsEntryBuyerInput>;
  /** Conveyance associated with the particular product. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: InputMaybe<CostInput>;
  /** Commercial Invoice date */
  invoiceDate?: InputMaybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: InputMaybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<FrCustomsEntryProductInput>>;
  /** Reason For Export */
  reasonsForExport?: InputMaybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<CustomsEntrySellerInput>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: InputMaybe<CostInput>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: InputMaybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type FrCustomsEntryConsignee = {
  __typename?: 'FrCustomsEntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Consignee details */
  consignee?: Maybe<Consignee>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: Maybe<Scalars['String']>;
};

export type FrCustomsEntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id version of the Consignee */
  consignee?: InputMaybe<IdVersionInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type FrCustomsEntryCustomsBroker = {
  __typename?: 'FrCustomsEntryCustomsBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type FrCustomsEntryCustomsBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type FrCustomsEntryEdge = ConnectionEdge & {
  __typename?: 'FrCustomsEntryEdge';
  cursor: Scalars['ID'];
  node: FrCustomsEntry;
};

export type FrCustomsEntryIor = {
  __typename?: 'FrCustomsEntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['FrEori']>;
  /** Ior party info which is stored in the record */
  ior?: Maybe<Ior>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['FrVatNumber']>;
};

export type FrCustomsEntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['FrEori']>;
  /** Ior party info which is stored in the record */
  ior?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['FrVatNumber']>;
};

export type FrCustomsEntryLine = {
  __typename?: 'FrCustomsEntryLine';
  /** The line assist value. */
  assist?: Maybe<Cost>;
  /** The line assist percentage. */
  assistPercentage?: Maybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<CustomsEntrySupplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<FrCustomsEntryTariff>>;
  /** The line value. */
  value?: Maybe<Cost>;
};

export type FrCustomsEntryLineInput = {
  /** The line assist value. */
  assist?: InputMaybe<CostInput>;
  /** The line assist percentage. */
  assistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<CustomsEntrySupplierInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<FrCustomsEntryTariffInput>>;
  /** The line value. */
  value?: InputMaybe<CostInput>;
};

export type FrCustomsEntryProduct = {
  __typename?: 'FrCustomsEntryProduct';
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: Maybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Line items within the Product. */
  lines?: Maybe<Array<FrCustomsEntryLine>>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type FrCustomsEntryProductInput = {
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<FrCustomsEntryLineInput>>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type FrCustomsEntrySearchCriteriaInput = {
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<CustomsEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's port of unlading. */
  portOfUnlading?: InputMaybe<TextSearchCriteriaInput>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: InputMaybe<ReferenceErrorCodeSearchCriteriaInput>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: InputMaybe<ReferenceProcessingStatusSearchCriteriaInput>;
  /** The type of reference */
  referenceType?: InputMaybe<ReferenceTypeSearchCriteriaInput>;
  /** The reference value */
  referenceValue?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Fr Customs Entry Search Table Row */
export type FrCustomsEntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'FrCustomsEntrySearchTableRow';
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: Maybe<Scalars['String']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: Maybe<Scalars['String']>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: Maybe<Array<EntryReferenceErrorCode>>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: Maybe<Array<EntryReferenceProcessingStatus>>;
  /** The type of reference */
  referenceType?: Maybe<Array<ReferenceType>>;
  /** The reference value */
  referenceValue?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Array<Scalars['String']>>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type FrCustomsEntryTariff = {
  __typename?: 'FrCustomsEntryTariff';
  /** The HTS record. */
  hts?: Maybe<Hts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type FrCustomsEntryTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

/** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
export type FrEoriSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['FrEori']>>;
};

export type FrIor = EuIor & Ior & Party & Record & {
  __typename?: 'FrIor';
  /** Broker activations details of FrIor. */
  activations?: Maybe<Array<FrIorActivationDetails>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<BusinessStructure>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the FR IOR. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: Maybe<Scalars['FrEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this FR IOR */
  shipper: ShipperFrIorRelationship;
  /** Shipper connection used to paginate results. */
  shippers: FrIorShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['FrVatNumber']>;
  /** The record's version */
  version: Scalars['Int'];
};


export type FrIordocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type FrIormemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type FrIorshipperArgs = {
  shipperId: Scalars['ID'];
};


export type FrIorshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type FrIorActivation = Record & WorkOrder & {
  __typename?: 'FrIorActivation';
  /** FR Customs Broker associated with the activation. */
  broker: FrIorActivationBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the FR IOR Activation . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** FR IOR to be activated. */
  ior?: Maybe<FrIorActivationIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type FrIorActivationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type FrIorActivationBroker = {
  __typename?: 'FrIorActivationBroker';
  /** FR Customs Broker */
  customsBroker: FrCustomsBroker;
};

export type FrIorActivationBrokerInput = {
  /** ID of the FR Customs Broker */
  customsBroker: IdInput;
};

export type FrIorActivationDetails = {
  __typename?: 'FrIorActivationDetails';
  /** Importer activation meta data. */
  activated?: Maybe<RecordAction>;
  /** Broker representation for the Importer. */
  brokerRepresentation?: Maybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: FrCustomsBroker;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: Maybe<ExternalBrokerReference>;
  /** External Importer references. */
  externalIorReferences?: Maybe<Array<ExternalIorReference>>;
  /** Importer rejection meta data. */
  rejected?: Maybe<RecordAction>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: Maybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type FrIorActivationEdge = ConnectionEdge & {
  __typename?: 'FrIorActivationEdge';
  cursor: Scalars['ID'];
  node: FrIorActivation;
};

export type FrIorActivationIor = {
  __typename?: 'FrIorActivationIor';
  /** FrIor details */
  ior: FrIor;
};

export type FrIorActivationIorInput = {
  /** FrIor details */
  ior: IdOptionalVersionInput;
};

export type FrIorActivationSearchCriteriaInput = {
  /** IOR Activation Status. */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** Activation time of IOR. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The IOR ID */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Ior Name */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** FR IOR Activation search result */
export type FrIorActivationSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'FrIorActivationSearchTableRow';
  /** Activation status of EU IOR. */
  activationStatus?: Maybe<ActivationStatus>;
  /** Activation time of EU IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** The IOR ID */
  iorId?: Maybe<Scalars['ID']>;
  /** Ior Name */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type FrIorActivationsConnection = Connection & {
  __typename?: 'FrIorActivationsConnection';
  edges: Array<FrIorActivationEdge>;
  nodes: Array<FrIorActivation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrIorEdge = ConnectionEdge & {
  __typename?: 'FrIorEdge';
  cursor: Scalars['ID'];
  node: FrIor;
};

export type FrIorSearchCriteriaInput = {
  /** IOR activation status */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** IOR activation time */
  activationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<FrEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<FrVatNumberSearchCriteriaInput>;
};

export type FrIorSearchTableRow = {
  __typename?: 'FrIorSearchTableRow';
  /** IOR Activation status */
  activationStatus?: Maybe<Array<ActivationStatus>>;
  /** IOR Activation time */
  activationTime?: Maybe<Array<Scalars['DateTime']>>;
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['FrEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The type industry of the Ior. */
  industry?: Maybe<Vertical>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber: Scalars['FrVatNumber'];
  /** Version */
  version: Scalars['Int'];
};

export type FrIorShipperEdge = ConnectionEdge & {
  __typename?: 'FrIorShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and FR IOR. */
  relationship: ShipperFrIorRelationship;
};

export type FrIorShippersConnection = Connection & {
  __typename?: 'FrIorShippersConnection';
  edges: Array<FrIorShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type FrIorsConnection = Connection & {
  __typename?: 'FrIorsConnection';
  edges: Array<FrIorEdge>;
  nodes: Array<FrIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
export type FrVatNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['FrVatNumber']>>;
};

export type FsvpCustomsAgent = {
  __typename?: 'FsvpCustomsAgent';
  /** Customs agent address */
  address?: Maybe<Address>;
  /** Customs agent party info */
  customsAgent?: Maybe<CustomsAgent>;
  /** Customs agent DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Customs agent name */
  name?: Maybe<Scalars['String']>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** If the customs agent DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
};

export type FsvpCustomsAgentInput = {
  /** Customs agent address */
  address?: InputMaybe<AddressInput>;
  /** Id version of customs agent */
  customsAgent?: InputMaybe<IdVersionInput>;
  /** Customs agent DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Customs agent name */
  name?: InputMaybe<Scalars['String']>;
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** If the customs agent DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

export type GbConsignee = Consignee & Party & Record & {
  __typename?: 'GbConsignee';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this GB Consignee */
  shipper: ShipperGbConsigneeRelationship;
  /** Shipper connection used to paginate results. */
  shippers: GbConsigneeShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type GbConsigneememosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type GbConsigneeshipperArgs = {
  shipperId: Scalars['ID'];
};


export type GbConsigneeshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type GbConsigneeEdge = ConnectionEdge & {
  __typename?: 'GbConsigneeEdge';
  cursor: Scalars['ID'];
  node: GbConsignee;
};

export type GbConsigneeSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type GbConsigneeSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'GbConsigneeSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type GbConsigneeShipperEdge = ConnectionEdge & {
  __typename?: 'GbConsigneeShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and GB Consignee. */
  relationship: ShipperGbConsigneeRelationship;
};

export type GbConsigneeShippersConnection = Connection & {
  __typename?: 'GbConsigneeShippersConnection';
  edges: Array<GbConsigneeShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type GbConsigneesConnection = Connection & {
  __typename?: 'GbConsigneesConnection';
  edges: Array<GbConsigneeEdge>;
  nodes: Array<GbConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type GbCustomsEntriesConnection = Connection & {
  __typename?: 'GbCustomsEntriesConnection';
  edges: Array<GbCustomsEntryEdge>;
  nodes: Array<GbCustomsEntry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type GbCustomsEntry = Record & WorkOrder & {
  __typename?: 'GbCustomsEntry';
  /** Arrival information */
  arrival?: Maybe<CustomsEntryArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: GbCustomsEntryCustomsBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Consignee associated with this entry. */
  consignee?: Maybe<GbCustomsEntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<CustomsEntryDeparture>;
  /** The documents associated with the Gb Customs Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: Maybe<Array<Scalars['ImportEntryNumber']>>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<GbCustomsEntryCommercialInvoice>>;
  /** IOR associated with this entry. */
  ior?: Maybe<GbCustomsEntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<CustomsEntryMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: Maybe<Array<Reference>>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: Maybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: Maybe<Scalars['Float']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type GbCustomsEntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type GbCustomsEntryCommercialInvoice = {
  __typename?: 'GbCustomsEntryCommercialInvoice';
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: Maybe<CustomsEntryBuyer>;
  /** Conveyance associated with the particular product. */
  conveyance?: Maybe<CustomsEntryConveyance>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: Maybe<Cost>;
  /** Commercial Invoice date */
  invoiceDate?: Maybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: Maybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<GbCustomsEntryProduct>>;
  /** Reason For Export */
  reasonsForExport?: Maybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<CustomsEntrySeller>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: Maybe<Cost>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: Maybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: Maybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type GbCustomsEntryCommercialInvoiceInput = {
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: InputMaybe<CustomsEntryBuyerInput>;
  /** Conveyance associated with the particular product. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: InputMaybe<CostInput>;
  /** Commercial Invoice date */
  invoiceDate?: InputMaybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: InputMaybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<GbCustomsEntryProductInput>>;
  /** Reason For Export */
  reasonsForExport?: InputMaybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<CustomsEntrySellerInput>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: InputMaybe<CostInput>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: InputMaybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type GbCustomsEntryConsignee = {
  __typename?: 'GbCustomsEntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Consignee details */
  consignee?: Maybe<Consignee>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: Maybe<Scalars['String']>;
};

export type GbCustomsEntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id version of the Consignee */
  consignee?: InputMaybe<IdVersionInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type GbCustomsEntryCustomsBroker = {
  __typename?: 'GbCustomsEntryCustomsBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type GbCustomsEntryCustomsBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type GbCustomsEntryEdge = ConnectionEdge & {
  __typename?: 'GbCustomsEntryEdge';
  cursor: Scalars['ID'];
  node: GbCustomsEntry;
};

export type GbCustomsEntryIor = {
  __typename?: 'GbCustomsEntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['GbEori']>;
  /** Ior party info which is stored in the record */
  ior?: Maybe<Ior>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['GbVatNumber']>;
};

export type GbCustomsEntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['GbEori']>;
  /** Ior party info which is stored in the record */
  ior?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['GbVatNumber']>;
};

export type GbCustomsEntryLine = {
  __typename?: 'GbCustomsEntryLine';
  /** The line assist value. */
  assist?: Maybe<Cost>;
  /** The line assist percentage. */
  assistPercentage?: Maybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<CustomsEntrySupplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<GbCustomsEntryTariff>>;
  /** The line value. */
  value?: Maybe<Cost>;
};

export type GbCustomsEntryLineInput = {
  /** The line assist value. */
  assist?: InputMaybe<CostInput>;
  /** The line assist percentage. */
  assistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<CustomsEntrySupplierInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<GbCustomsEntryTariffInput>>;
  /** The line value. */
  value?: InputMaybe<CostInput>;
};

export type GbCustomsEntryProduct = {
  __typename?: 'GbCustomsEntryProduct';
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: Maybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Line items within the Product. */
  lines?: Maybe<Array<GbCustomsEntryLine>>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type GbCustomsEntryProductInput = {
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<GbCustomsEntryLineInput>>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type GbCustomsEntrySearchCriteriaInput = {
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: InputMaybe<TextSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<CustomsEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's port of unlading. */
  portOfUnlading?: InputMaybe<TextSearchCriteriaInput>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: InputMaybe<ReferenceErrorCodeSearchCriteriaInput>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: InputMaybe<ReferenceProcessingStatusSearchCriteriaInput>;
  /** The type of reference */
  referenceType?: InputMaybe<ReferenceTypeSearchCriteriaInput>;
  /** The reference value */
  referenceValue?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Gb Customs Entry Search Table Row */
export type GbCustomsEntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'GbCustomsEntrySearchTableRow';
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: Maybe<Array<Scalars['ImportEntryNumber']>>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: Maybe<Scalars['String']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: Maybe<Scalars['String']>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: Maybe<Array<EntryReferenceErrorCode>>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: Maybe<Array<EntryReferenceProcessingStatus>>;
  /** The type of reference */
  referenceType?: Maybe<Array<ReferenceType>>;
  /** The reference value */
  referenceValue?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Array<Scalars['String']>>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type GbCustomsEntryTariff = {
  __typename?: 'GbCustomsEntryTariff';
  /** The HTS record. */
  hts?: Maybe<Hts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type GbCustomsEntryTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

/** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
export type GbEoriSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['GbEori']>>;
};

export type GbIor = EuIor & Ior & Party & Record & {
  __typename?: 'GbIor';
  /** Broker activations details of GbIor. */
  activations?: Maybe<Array<GbIorActivationDetails>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<BusinessStructure>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the GB IOR. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: Maybe<Scalars['GbEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this GB IOR */
  shipper: ShipperGbIorRelationship;
  /** Shipper connection used to paginate results. */
  shippers: GbIorShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['GbVatNumber']>;
  /** The record's version */
  version: Scalars['Int'];
};


export type GbIordocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type GbIormemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type GbIorshipperArgs = {
  shipperId: Scalars['ID'];
};


export type GbIorshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type GbIorActivation = Record & WorkOrder & {
  __typename?: 'GbIorActivation';
  /** GB Customs Broker associated with the activation. */
  broker: UkIorActivationBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the GB IOR Activation . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** GB IOR to be activated. */
  ior?: Maybe<GbIorActivationIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type GbIorActivationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type GbIorActivationDetails = {
  __typename?: 'GbIorActivationDetails';
  /** Importer activation meta data. */
  activated?: Maybe<RecordAction>;
  /** Broker representation for the Importer. */
  brokerRepresentation?: Maybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: UkCustomsBroker;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: Maybe<ExternalBrokerReference>;
  /** External Importer references. */
  externalIorReferences?: Maybe<Array<ExternalIorReference>>;
  /** Importer rejection meta data. */
  rejected?: Maybe<RecordAction>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: Maybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type GbIorActivationEdge = ConnectionEdge & {
  __typename?: 'GbIorActivationEdge';
  cursor: Scalars['ID'];
  node: GbIorActivation;
};

export type GbIorActivationIor = {
  __typename?: 'GbIorActivationIor';
  /** GbIor details */
  ior: GbIor;
};

export type GbIorActivationIorInput = {
  /** GbIor details */
  ior: IdOptionalVersionInput;
};

export type GbIorActivationSearchCriteriaInput = {
  /** IOR Activation Status. */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** Activation time of IOR. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The IOR ID */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Ior Name */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** GB IOR Activation search result */
export type GbIorActivationSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'GbIorActivationSearchTableRow';
  /** Activation status of EU IOR. */
  activationStatus?: Maybe<ActivationStatus>;
  /** Activation time of EU IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** The IOR ID */
  iorId?: Maybe<Scalars['ID']>;
  /** Ior Name */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type GbIorActivationsConnection = Connection & {
  __typename?: 'GbIorActivationsConnection';
  edges: Array<GbIorActivationEdge>;
  nodes: Array<GbIorActivation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type GbIorEdge = ConnectionEdge & {
  __typename?: 'GbIorEdge';
  cursor: Scalars['ID'];
  node: GbIor;
};

export type GbIorSearchCriteriaInput = {
  /** IOR activation status */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** IOR activation time */
  activationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<GbEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<GbVatNumberSearchCriteriaInput>;
};

export type GbIorSearchTableRow = {
  __typename?: 'GbIorSearchTableRow';
  /** IOR Activation status */
  activationStatus?: Maybe<Array<ActivationStatus>>;
  /** IOR Activation time */
  activationTime?: Maybe<Array<Scalars['DateTime']>>;
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['GbEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The type industry of the Ior. */
  industry?: Maybe<Vertical>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber: Scalars['GbVatNumber'];
  /** Version */
  version: Scalars['Int'];
};

export type GbIorShipperEdge = ConnectionEdge & {
  __typename?: 'GbIorShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and GB IOR. */
  relationship: ShipperGbIorRelationship;
};

export type GbIorShippersConnection = Connection & {
  __typename?: 'GbIorShippersConnection';
  edges: Array<GbIorShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type GbIorsConnection = Connection & {
  __typename?: 'GbIorsConnection';
  edges: Array<GbIorEdge>;
  nodes: Array<GbIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
export type GbVatNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['GbVatNumber']>>;
};

export type GenerateDeliveryOrderPayload = {
  __typename?: 'GenerateDeliveryOrderPayload';
  /** Delivery Order Document Generation */
  deliveryOrderDocumentGenerationRequestId: Scalars['ID'];
};

/** Payload returned from generateDraftEntrySummaryPayload mutation */
export type GenerateDraftEntrySummaryPayload = {
  __typename?: 'GenerateDraftEntrySummaryPayload';
  /** Document generation request */
  documentGenerationRequest: UsCbp7501DocumentGenerationRequest;
};

export type GenerateUsConsumptionEntryNumberPayload = {
  __typename?: 'GenerateUsConsumptionEntryNumberPayload';
  /** True if a new entry number was generated, or false if the entry already had an entry number. */
  newNumberGenerated: Scalars['Boolean'];
  /** The latest US Consumption Entry with brokerNumber and entryNumber included. */
  usConsumptionEntry: UsConsumptionEntry;
};

export type GenerateUsDrawbackClaimEntryNumberPayload = {
  __typename?: 'GenerateUsDrawbackClaimEntryNumberPayload';
  /** True if a new entry number was generated, or false if the entry already had an entry number. */
  newNumberGenerated: Scalars['Boolean'];
  /** The latest US Drawback Entry with brokerNumber and entryNumber included. */
  usDrawbackClaim: UsDrawbackClaim;
};

export type GenerateUsType86EntryNumberPayload = {
  __typename?: 'GenerateUsType86EntryNumberPayload';
  /** True if a new entry number was generated, or false if the entry already had an entry number. */
  newNumberGenerated: Scalars['Boolean'];
  /** The latest US type86 Entry with brokerNumber and entryNumber included. */
  usType86Entry: UsType86Entry;
};

/** Generic document generation request */
export type GenericDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'GenericDocumentGenerationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Tag indicating which type of document should be generated (e.g., COMMERCIAL_INVOICE, PACKING_LIST) */
  documentTag: DocumentTag;
  /** CBMS internal identifier of the record this document generation request is tied to (e.g., UsConsumptionEntry, Shipment, ImporterEntity). */
  entityId?: Maybe<Scalars['ID']>;
  /** External document template used for document generation (e.g., CDA1, CDA2) */
  externalDocumentTemplate: ExternalDocumentTemplateType;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The output payload for query operations encapsulating an ExchangeMessage. */
export type GetAbiPayload = {
  __typename?: 'GetAbiPayload';
  /** An array of messages containing the EDI/JSON format, creation time, and CBP app code. */
  messages: Array<AbiExchangeMessage>;
  /** An object with pagination details. */
  paginationInfo: SearchPagination;
};

export type GetAddressByIdInput = {
  addressId: Scalars['String'];
  marketplaceId?: InputMaybe<Scalars['String']>;
  userCustomerId?: InputMaybe<Scalars['String']>;
};

export type GetAddressByIdPayload = {
  __typename?: 'GetAddressByIdPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<AddressResponse>;
};

export type GetAsinProductDetailsRequest = {
  asin: Scalars['String'];
  marketplaceId: Scalars['Int'];
};

export type GetAsinProductDetailsResponse = {
  __typename?: 'GetAsinProductDetailsResponse';
  asin: Scalars['String'];
  asinAttributes?: Maybe<Scalars['JSONObject']>;
  categoryInfo?: Maybe<Scalars['JSONObject']>;
  imageUrl?: Maybe<Scalars['JSONObject']>;
  marketplaceId: Scalars['Int'];
};

export type GetLinkedMerchantIdsInput = {
  shipperProfileId: Scalars['String'];
};

export type GetLinkedMerchantIdsPayload = {
  __typename?: 'GetLinkedMerchantIdsPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<GetLinkedMerchantIdsResponse>;
};

export type GetLinkedMerchantIdsResponse = {
  __typename?: 'GetLinkedMerchantIdsResponse';
  merchantMarketplaces: Array<MerchantMarketplace>;
};

/** The structure of the business. */
export enum GlobalBusinessStructure {
  CORPORATION = 'CORPORATION',
  FOREIGN_GOVERNMENT = 'FOREIGN_GOVERNMENT',
  INDIVIDUAL = 'INDIVIDUAL',
  LLC = 'LLC',
  LLP = 'LLP',
  LP = 'LP',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
  STATE_GOVERNMENT = 'STATE_GOVERNMENT',
  US_GOVERNMENT = 'US_GOVERNMENT'
}

export type GlobalBusinessStructureSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<GlobalBusinessStructure>>;
};

/** Details related to the party to which goods are consigned. */
export type GlobalConsignee = Consignee & Party & Record & {
  __typename?: 'GlobalConsignee';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry: Scalars['CountryCode'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this Global Consignee */
  shipper: ShipperGlobalConsigneeRelationship;
  /** Shipper connection used to paginate results. */
  shippers: GlobalConsigneeShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** Details related to the party to which goods are consigned. */
export type GlobalConsigneememosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Details related to the party to which goods are consigned. */
export type GlobalConsigneeshipperArgs = {
  shipperId: Scalars['ID'];
};


/** Details related to the party to which goods are consigned. */
export type GlobalConsigneeshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type GlobalConsigneeEdge = ConnectionEdge & {
  __typename?: 'GlobalConsigneeEdge';
  cursor: Scalars['ID'];
  node: GlobalConsignee;
};

export type GlobalConsigneeSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** Search GlobalConsignee by associated identifier e.g. VAT number, EORI number, EIN, CBP Assigned, etc. */
  identifier?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type GlobalConsigneeSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'GlobalConsigneeSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry?: Maybe<Scalars['CountryCode']>;
  /** GlobalConsignee's identifiers */
  identifier: Array<PartyIdentification>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type GlobalConsigneeShipperEdge = ConnectionEdge & {
  __typename?: 'GlobalConsigneeShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Global Consignee. */
  relationship: ShipperGlobalConsigneeRelationship;
};

export type GlobalConsigneeShippersConnection = Connection & {
  __typename?: 'GlobalConsigneeShippersConnection';
  edges: Array<GlobalConsigneeShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type GlobalConsigneesConnection = Connection & {
  __typename?: 'GlobalConsigneesConnection';
  edges: Array<GlobalConsigneeEdge>;
  nodes: Array<GlobalConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Global product identifier (GTIN/UPC) for CPSC filing */
export type GlobalProductIdentifier = {
  __typename?: 'GlobalProductIdentifier';
  /** Global identifier code */
  code: Scalars['String'];
  /** Type of global identifier (GTIN or UPC) */
  type: CpscGlobalIdentifierType;
};

/** Global product identifier (GTIN/UPC) for CPSC filing */
export type GlobalProductIdentifierInput = {
  /** Global identifier code */
  code: Scalars['String'];
  /** Type of global identifier (GTIN or UPC) */
  type: CpscGlobalIdentifierType;
};

export type GlobalSearchInput = {
  /** query string */
  query: Scalars['String'];
  /** user id */
  userId: Scalars['String'];
};

/** Search payload */
export type GlobalSearchPayload = {
  __typename?: 'GlobalSearchPayload';
  results: Array<GlobalSearchResult>;
};

/** Global search result */
export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  /** Whether the record has been deleted/canceled */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Matched field name */
  field?: Maybe<Scalars['String']>;
  /** Matched field value with highlighted string */
  highlight?: Maybe<Scalars['String']>;
  /** CBMS ID */
  id: Scalars['ID'];
  /** Record type */
  recordType: RecordType;
  /** Title field of record */
  title?: Maybe<Scalars['ID']>;
};

export type GoodsItem = {
  __typename?: 'GoodsItem';
  /** Additional references providing supplementary information. */
  additionalReference?: Maybe<Array<AdditionalReference>>;
  /** Details related to the role of the further parties in the supply chain having obtained a trusted trader certificate but otherwise not being identified in the declarations (e.g. warehouse keeper, freight forwarder). */
  aeoMutualRecognitionParty?: Maybe<Array<AEOMutualRecognitionParty>>;
  /** Details related to the authorization necessary for the declaration or notification. */
  authorization?: Maybe<Array<Authorization>>;
  /** Details related to the commodity. */
  commodity?: Maybe<Commodity>;
  /** Details related to the customs valuation of the goods. */
  customsValuation?: Maybe<CustomsValuation>;
  /** Amount declared for customs purposes of those goods in a consignment which are subject to the same customs procedure, and have the same tariff/statistical heading, country information and duty regime. */
  customsValue?: Maybe<Cost>;
  /** Details related to the destination location. */
  destinationLocation?: Maybe<DestinationLocation>;
  /** Code specifying the country from which goods were initially dispatched to the country in which the goods are located at the time of their release into the customs procedure. */
  dispatchCountry?: Maybe<Scalars['String']>;
  /** External reference for the goods item. */
  externalReference?: Maybe<ExternalComplianceReference>;
  /** Details related to the measurement of goods. */
  goodsMeasure?: Maybe<GoodsMeasure>;
  /** Code specifying the status of goods as identified by customs for regulation purposes or as a result of an action by the declarant or government agency. */
  goodsStatus?: Maybe<Scalars['String']>;
  /** Details related to the government procedure. */
  governmentProcedure?: Maybe<Array<GovernmentProcedure>>;
  /** Invoice-related information for the goods item. */
  invoice?: Maybe<InvoiceDetails>;
  /** Details related to the origin of the goods. */
  origin?: Maybe<Origin>;
  /** Details related to packaging. */
  packaging?: Maybe<Array<Packaging>>;
  /** Details related to the party selling merchandise to a buyer. */
  seller?: Maybe<Supplier>;
  /** Number indicating the position in a sequence. */
  sequence?: Maybe<Scalars['Int']>;
  /** Amount indicating the value declared for statistical purposes of those goods in a consignment which have the same statistical heading. */
  statisticalValue?: Maybe<Cost>;
  /** Code specifying the nature of a transaction associated with a shipment. First digit indicates WCO code table value; Second digit can be used as additional User code to further define first digit. */
  transactionNature?: Maybe<Scalars['String']>;
  /** Details related to the Unique Consignment Reference. */
  ucr?: Maybe<UCR>;
  /** Details related to the valuation adjustments. */
  valuationAdjustment?: Maybe<Array<ValuationAdjustment>>;
};

export type GoodsItemInput = {
  /** Additional references providing supplementary information. */
  additionalReference?: InputMaybe<Array<AdditionalReferenceInput>>;
  /** Details related to the role of the further parties in the supply chain having obtained a trusted trader certificate but otherwise not being identified in the declarations (e.g. warehouse keeper, freight forwarder). */
  aeoMutualRecognitionParty?: InputMaybe<Array<AEOMutualRecognitionPartyInput>>;
  /** Details related to the authorization necessary for the declaration or notification. */
  authorization?: InputMaybe<Array<AuthorizationInput>>;
  /** Details related to the commodity. */
  commodity?: InputMaybe<CommodityInput>;
  /** Details related to the customs valuation of the goods. */
  customsValuation?: InputMaybe<CustomsValuationInput>;
  /** Amount declared for customs purposes of those goods in a consignment which are subject to the same customs procedure, and have the same tariff/statistical heading, country information and duty regime. */
  customsValue?: InputMaybe<CostInput>;
  /** Details related to the destination location. */
  destinationLocation?: InputMaybe<DestinationLocationInput>;
  /** Code specifying the country from which goods were initially dispatched to the country in which the goods are located at the time of their release into the customs procedure. */
  dispatchCountry?: InputMaybe<Scalars['String']>;
  /** External reference for the goods item. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** Details related to the measurement of goods. */
  goodsMeasure?: InputMaybe<GoodsMeasureInput>;
  /** Code specifying the status of goods as identified by customs for regulation purposes or as a result of an action by the declarant or government agency. */
  goodsStatus?: InputMaybe<Scalars['String']>;
  /** Details related to the government procedure. */
  governmentProcedure?: InputMaybe<Array<GovernmentProcedureInput>>;
  /** Invoice-related information for the goods item. */
  invoice?: InputMaybe<InvoiceDetailsInput>;
  /** Details related to the origin of the goods. */
  origin?: InputMaybe<OriginInput>;
  /** Details related to packaging. */
  packaging?: InputMaybe<Array<PackagingInput>>;
  /** Details related to the party selling merchandise to a buyer. */
  seller?: InputMaybe<IdInput>;
  /** Number indicating the position in a sequence. */
  sequence?: InputMaybe<Scalars['Int']>;
  /** Amount indicating the value declared for statistical purposes of those goods in a consignment which have the same statistical heading. */
  statisticalValue?: InputMaybe<CostInput>;
  /** Code specifying the nature of a transaction associated with a shipment. First digit indicates WCO code table value; Second digit can be used as additional User code to further define first digit. */
  transactionNature?: InputMaybe<Scalars['String']>;
  /** Details related to the Unique Consignment Reference. */
  ucr?: InputMaybe<UCRInput>;
  /** Details related to the valuation adjustments. */
  valuationAdjustment?: InputMaybe<Array<ValuationAdjustmentInput>>;
};

export type GoodsItemInvoiceLine = {
  __typename?: 'GoodsItemInvoiceLine';
  /** Amount due for each chargeable item of goods or services. */
  itemCharge?: Maybe<Cost>;
};

export type GoodsItemInvoiceLineInput = {
  /** Amount due for each chargeable item of goods or services. */
  itemCharge?: InputMaybe<CostInput>;
};

export type GoodsItemReference = {
  __typename?: 'GoodsItemReference';
  /** Presigned URL to download the data from S3. */
  downloadLink: Scalars['String'];
  /** S3 reference key/path for the data. */
  referenceKey: Scalars['String'];
};

export type GoodsItemReferenceInput = {
  /** S3 reference key/path for the data. */
  referenceKey: Scalars['String'];
};

export type GoodsMeasure = {
  __typename?: 'GoodsMeasure';
  /** Code specifying the purpose of the measurement. */
  function?: Maybe<Scalars['String']>;
  /** Weight of goods including packing but excluding carrier's equipment. */
  grossWeight?: Maybe<Quantity>;
  /** Weight of the goods themselves without any packing. */
  netNetWeight?: Maybe<Quantity>;
  /** Quantity specifying the goods in the unit as required by customs for tariff, statistical, fiscal purposes or as indicated in "type". */
  tariff?: Maybe<Scalars['Float']>;
};

export type GoodsMeasureInput = {
  /** Code specifying the purpose of the measurement. */
  function?: InputMaybe<Scalars['String']>;
  /** Weight of goods including packing but excluding carrier's equipment. */
  grossWeight?: InputMaybe<QuantityInput>;
  /** Weight of the goods themselves without any packing. */
  netNetWeight?: InputMaybe<QuantityInput>;
  /** Quantity specifying the goods in the unit as required by customs for tariff, statistical, fiscal purposes or as indicated in "type". */
  tariff?: InputMaybe<Scalars['Float']>;
};

export type GoodsShipment = {
  __typename?: 'GoodsShipment';
  /** Details related to the party which, by contract with a carrier, consigns or sends goods with the carrier, or has them conveyed by him. */
  Consignor?: Maybe<Array<Shipper>>;
  /** Details related to the party to which merchandise or services are sold. */
  buyer?: Maybe<Array<Facility>>;
  /** Details related to the party to which goods are consigned. */
  consignee?: Maybe<Array<Consignee>>;
  /** Details related to the transport between a consignor and a consignee as specified in the transport contract document. */
  consignment?: Maybe<Array<Consignment>>;
  /** Details related to the export country. */
  exportCountry?: Maybe<Array<ExportCountry>>;
  /** Details related to the goods item as declared to Government Agency. */
  goodsItem?: Maybe<Array<GoodsItem>>;
  /** Details related to the import country. */
  importCountry?: Maybe<Array<ImportCountry>>;
  /** Details related to the party who makes - or on whose behalf a customs clearing agent or other authorized person makes - an import declaration. */
  importer?: Maybe<Array<Ior>>;
  /** Details related to trade terms. */
  tradeTerms?: Maybe<Array<TradeTerms>>;
};

export type GoodsShipmentInput = {
  /** Details related to the party which, by contract with a carrier, consigns or sends goods with the carrier, or has them conveyed by him. */
  Consignor?: InputMaybe<Array<IdInput>>;
  /** Details related to the party to which merchandise or services are sold. */
  buyer?: InputMaybe<Array<IdInput>>;
  /** Details related to the party to which goods are consigned. */
  consignee?: InputMaybe<Array<IdInput>>;
  /** Details related to the transport between a consignor and a consignee as specified in the transport contract document. */
  consignment?: InputMaybe<Array<ConsignmentInput>>;
  /** Details related to the export country. */
  exportCountry?: InputMaybe<Array<ExportCountryInput>>;
  /** Details related to the goods item as declared to Government Agency. */
  goodsItem?: InputMaybe<Array<GoodsItemInput>>;
  /** Details related to the import country. */
  importCountry?: InputMaybe<Array<ImportCountryInput>>;
  /** Details related to the party who makes - or on whose behalf a customs clearing agent or other authorized person makes - an import declaration. */
  importer?: InputMaybe<Array<IdInput>>;
  /** Details related to trade terms. */
  tradeTerms?: InputMaybe<Array<TradeTermsInput>>;
};

export type GovernmentProcedure = {
  __typename?: 'GovernmentProcedure';
  /** Details of additional procedures. */
  additionalProcedure?: Maybe<Array<AdditionalProcedure>>;
  /** Code specifying a procedure. */
  current?: Maybe<Scalars['String']>;
  /** Description of a government procedure. */
  description?: Maybe<Scalars['String']>;
  /** Code specifying the government procedure, if any, which has been applied to the goods prior to the application of a different government procedure. */
  previous?: Maybe<Scalars['String']>;
  /** Details related to the responsible government agency. */
  responsibleGovernmentAgency?: Maybe<Array<ResponsibleGovernmentAgency>>;
};

export type GovernmentProcedureInput = {
  /** Details of additional procedures. */
  additionalProcedure?: InputMaybe<Array<AdditionalProcedureInput>>;
  /** Code specifying a procedure. */
  current?: InputMaybe<Scalars['String']>;
  /** Description of a government procedure. */
  description?: InputMaybe<Scalars['String']>;
  /** Code specifying the government procedure, if any, which has been applied to the goods prior to the application of a different government procedure. */
  previous?: InputMaybe<Scalars['String']>;
  /** Details related to the responsible government agency. */
  responsibleGovernmentAgency?: InputMaybe<Array<ResponsibleGovernmentAgencyInput>>;
};

export type GssAccountLinkingClientConnectionInput = {
  apiArgs?: InputMaybe<Scalars['JSONObject']>;
  apiName: SupportedGssAccountLinkingAPI;
};

export type GssAccountLinkingClientConnectionPayload = {
  __typename?: 'GssAccountLinkingClientConnectionPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSONObject']>;
};

export type HouseBill = {
  __typename?: 'HouseBill';
  /** House Bill number */
  number: Scalars['String'];
};

export type HouseBillInput = {
  /** House Bill number */
  number: Scalars['String'];
};

/** Represents a Harmonized System record */
export type Hs = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Ending effective date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Beginning effective date. */
  startDate?: Maybe<Scalars['Date']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type HsDescription = {
  __typename?: 'HsDescription';
  /** Culture code for the description */
  cultureCode: Scalars['CultureCode'];
  /** End date for this Hs component */
  endDate?: Maybe<Scalars['String']>;
  /** Start date for this Hs component */
  startDate: Scalars['String'];
  /** Description text */
  text: Scalars['String'];
};

export type HsDescriptionInput = {
  /** Culture code for the description */
  cultureCode?: InputMaybe<Scalars['CultureCode']>;
  /** End date for this Hs component */
  endDate?: InputMaybe<Scalars['String']>;
  /** Start date for this Hs component */
  startDate: Scalars['String'];
  /** Description text */
  text: Scalars['String'];
};

/** Export group code applicable to component */
export enum HsExportGroupCode {
  ALL = 'ALL',
  USALDUTY = 'USALDUTY',
  USALLC = 'USALLC',
  USALLC_AL = 'USALLC_AL',
  USAUTOPARTSDUTY = 'USAUTOPARTSDUTY',
  USCA_AL = 'USCA_AL',
  USCNHK = 'USCNHK',
  USEU301S_1 = 'USEU301S_1',
  USEU301S_2 = 'USEU301S_2',
  USEU301S_3 = 'USEU301S_3',
  USEU301S_4 = 'USEU301S_4',
  USEU301S_5 = 'USEU301S_5',
  USEU301S_6 = 'USEU301S_6',
  USEU301S_7 = 'USEU301S_7',
  USEU301S_8 = 'USEU301S_8',
  USEU301S_9 = 'USEU301S_9',
  USEU301S_10 = 'USEU301S_10',
  USEU301S_11 = 'USEU301S_11',
  USEU301S_12 = 'USEU301S_12',
  USEU301S_13 = 'USEU301S_13',
  USEU301S_14 = 'USEU301S_14',
  USEU301S_15 = 'USEU301S_15',
  USEU301S_16 = 'USEU301S_16',
  USEU301S_17 = 'USEU301S_17',
  USEU301S_18 = 'USEU301S_18',
  USEU301S_19 = 'USEU301S_19',
  USSTEELDUTY = 'USSTEELDUTY'
}

/** Type of HS Number */
export enum HsNumberType {
  HEADING = 'HEADING',
  HTS = 'HTS',
  PRODUCT = 'PRODUCT',
  SUBHEADING = 'SUBHEADING'
}

/** HS Number type search criteria input. */
export type HsNumberTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<HsNumberType>>;
};

export type HsRate = {
  __typename?: 'HsRate';
  /** Unique identifier for the charge */
  chargeId: Scalars['String'];
  /** End date for this Hs component */
  endDate?: Maybe<Scalars['String']>;
  /** Rate calculation formula */
  formula?: Maybe<Scalars['String']>;
  /** Formula type code for rate calculation */
  formulaTypeCode: Scalars['String'];
  /** Primary rate value */
  rateA?: Maybe<Scalars['Float']>;
  /** Mathematical operator for rate A */
  rateAMath?: Maybe<Scalars['String']>;
  /** Unit of measure for rate A */
  rateAUom?: Maybe<Scalars['String']>;
  /** Unit amount for rate A */
  rateAUomAmount?: Maybe<Scalars['Float']>;
  /** Secondary rate value */
  rateB?: Maybe<Scalars['Float']>;
  /** Mathematical operator for rate B */
  rateBMath?: Maybe<Scalars['String']>;
  /** Unit of measure for rate B */
  rateBUom?: Maybe<Scalars['String']>;
  /** Unit amount for rate B */
  rateBUomAmount?: Maybe<Scalars['Float']>;
  /** Tertiary rate value */
  rateC?: Maybe<Scalars['Float']>;
  /** Mathematical operator for rate C */
  rateCMath?: Maybe<Scalars['String']>;
  /** Unit of measure for rate C */
  rateCUom?: Maybe<Scalars['String']>;
  /** Unit amount for rate C */
  rateCUomAmount?: Maybe<Scalars['Float']>;
  /** Start date for this Hs component */
  startDate: Scalars['String'];
};

export type HsRateInput = {
  /** Unique identifier for the charge */
  chargeId: Scalars['String'];
  /** End date for this Hs component */
  endDate?: InputMaybe<Scalars['String']>;
  /** Rate calculation formula */
  formula?: InputMaybe<Scalars['String']>;
  /** Formula type code for rate calculation */
  formulaTypeCode: Scalars['String'];
  /** Primary rate value */
  rateA?: InputMaybe<Scalars['Float']>;
  /** Mathematical operator for rate A */
  rateAMath?: InputMaybe<Scalars['String']>;
  /** Unit of measure for rate A */
  rateAUom?: InputMaybe<Scalars['String']>;
  /** Unit amount for rate A */
  rateAUomAmount?: InputMaybe<Scalars['Float']>;
  /** Secondary rate value */
  rateB?: InputMaybe<Scalars['Float']>;
  /** Mathematical operator for rate B */
  rateBMath?: InputMaybe<Scalars['String']>;
  /** Unit of measure for rate B */
  rateBUom?: InputMaybe<Scalars['String']>;
  /** Unit amount for rate B */
  rateBUomAmount?: InputMaybe<Scalars['Float']>;
  /** Tertiary rate value */
  rateC?: InputMaybe<Scalars['Float']>;
  /** Mathematical operator for rate C */
  rateCMath?: InputMaybe<Scalars['String']>;
  /** Unit of measure for rate C */
  rateCUom?: InputMaybe<Scalars['String']>;
  /** Unit amount for rate C */
  rateCUomAmount?: InputMaybe<Scalars['Float']>;
  /** Start date for this Hs component */
  startDate: Scalars['String'];
};

/** HS search results. */
export type HsSearchTableRow = {
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The effective end date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type. */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** HTS number. */
  number: Scalars['HtsNumber'];
  /** The effective start date. */
  startDate?: Maybe<Scalars['Date']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Create HTML document generation request. */
export type HtmlDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'HtmlDocumentGenerationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** The TemplateDocumentSignRequest associated with this HtmlDocumentGenerationRequest. */
  documentSignRequest?: Maybe<TemplateDocumentSignRequest>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The data-filled template in HTML. */
  html: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Represents a Harmonized Tariff Schedule record */
export type Hts = Hs & {
  __typename?: 'Hts';
  /** May be subject to anti-dumping duties. */
  ad?: Maybe<Scalars['Boolean']>;
  /** Anti-dumping and Countervailing duty (ADD/CVD) active case Ids */
  adCvdCases?: Maybe<Array<AdCvdCase>>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additional?: Maybe<Array<AdditionalHts>>;
  /** Additional Tariff may be required. */
  additionalHTS?: Maybe<Scalars['Boolean']>;
  /** The additional HTS number that may be required. */
  additionalHtsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additionalHtssApplicable?: Maybe<Array<AdditionalHts>>;
  /** The effective end date provided by ACE CATAIR. It may differ from the top-level endDate. */
  cbpEndDate?: Maybe<Scalars['Date']>;
  /** The effective start date provided by ACE CATAIR. It may differ from the top-level startDate. */
  cbpStartDate?: Maybe<Scalars['Date']>;
  /** Compliance notes */
  complianceNotes?: Maybe<Array<HtsComplianceNote>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** May be subject to countervailing duties. */
  cv?: Maybe<Scalars['Boolean']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Longer description of Tariff. */
  description?: Maybe<Scalars['String']>;
  /** Descriptions of Tariff. */
  descriptions?: Maybe<Array<HtsDescription>>;
  /** Ending effective date. */
  endDate?: Maybe<Scalars['Date']>;
  /** Fees required, also used for taxes. */
  fees?: Maybe<Array<HtsFee>>;
  /** Country of origin codes not permitted to use with the Generalized System of Preferences SPI (A*). */
  gspExcluded?: Maybe<Array<Scalars['String']>>;
  /** HS number type */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** License data potentially required on an entry. */
  license?: Maybe<HtsLicense>;
  /** License code required on Line. */
  licenseCode?: Maybe<Scalars['String']>;
  /** License name required on Line */
  licenseName?: Maybe<Scalars['String']>;
  /** Column one rate object used to calculate duty that may apply to HS during different time intervals. */
  mainDutyRates?: Maybe<Array<HtsRate>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Partner Government Agency data potentially required on an entry. */
  pga?: Maybe<Array<PgaRequirement>>;
  /** May be subject to a quota. */
  quota?: Maybe<Scalars['Boolean']>;
  /** Rate object used to calculate duty. */
  rate?: Maybe<HtsRate>;
  /** Duty computation code. */
  rateCode?: Maybe<Scalars['String']>;
  /** Readable duty calculation formula. */
  rateString?: Maybe<Scalars['String']>;
  /** Restrictions on HTS number usage. */
  restriction?: Maybe<HtsRestriction>;
  /** Column two rate object used to calculate duty that may apply to HS during different time intervals. */
  secondaryDutyRates?: Maybe<Array<HtsRate>>;
  /** Special Program Indicators available to use, subject to country of origin. */
  spi?: Maybe<Array<Spi>>;
  /** Special rates based on different SPIs. */
  spiRates?: Maybe<Array<HtsSpiRate>>;
  /** Beginning effective date. */
  startDate?: Maybe<Scalars['Date']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Description of Tariff. */
  text?: Maybe<Scalars['String']>;
  /** Textile code. */
  textile?: Maybe<Scalars['String']>;
  /** Truncated description of Tariff. */
  truncatedDescription?: Maybe<Scalars['String']>;
  /** Required unit of measure reporting quantities. */
  uom?: Maybe<Array<Scalars['String']>>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** Represents a Harmonized Tariff Schedule record */
export type HtsadditionalHtssApplicableArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']>;
};

/** HTS Compliance note. */
export type HtsComplianceNote = {
  __typename?: 'HtsComplianceNote';
  /** Applicable Country code */
  applicableCountryCode?: Maybe<Array<Scalars['CountryCode']>>;
  /** String representing control type. */
  controlType?: Maybe<Scalars['String']>;
  /** End (expiration) date for HTS control. */
  endDate?: Maybe<Scalars['Date']>;
  /** Compliance Note */
  note?: Maybe<Scalars['String']>;
  /** Start (effective) date for HTS control. */
  startDate?: Maybe<Scalars['Date']>;
};

export type HtsComplianceNoteInput = {
  /** Applicable Country code */
  applicableCountryCode?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** String representing control type. */
  controlType?: InputMaybe<Scalars['String']>;
  /** End (expiration) date for HTS control. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Compliance Note */
  note?: InputMaybe<Scalars['String']>;
  /** Start (effective) date for HTS control. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Base class for HTS description. */
export type HtsDescription = {
  __typename?: 'HtsDescription';
  /** End (expiration) date for HTS control. */
  endDate?: Maybe<Scalars['Date']>;
  /** Start (effective) date for HTS control. */
  startDate?: Maybe<Scalars['Date']>;
  /** HTS Description. */
  text?: Maybe<Scalars['String']>;
};

export type HtsDescriptionInput = {
  /** End (expiration) date for HTS control. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Start (effective) date for HTS control. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** HTS Description. */
  text?: InputMaybe<Scalars['String']>;
};

export type HtsEdge = ConnectionEdge & {
  __typename?: 'HtsEdge';
  cursor: Scalars['ID'];
  node: Hts;
};

/** Entry date restrictions on an HTS number. */
export type HtsEntryDateRestriction = {
  __typename?: 'HtsEntryDateRestriction';
  /** A numeric date in MMDD (month and day) format representing the first begin restriction date used in the edit. */
  beginDate?: Maybe<Scalars['Date']>;
  /** A code representing the first entry date restriction code. */
  code?: Maybe<Scalars['String']>;
  /** A numeric date in MMDD (month and day) format representing the first end restriction date used in the edit. */
  endDate?: Maybe<Scalars['Date']>;
};

/** Entry date restrictions on an HTS number. */
export type HtsEntryDateRestrictionInput = {
  /** A numeric date in MMDD (month and day) format representing the first begin restriction date used in the edit. */
  beginDate?: InputMaybe<Scalars['Date']>;
  /** A code representing the first entry date restriction code. */
  code?: InputMaybe<Scalars['String']>;
  /** A numeric date in MMDD (month and day) format representing the first end restriction date used in the edit. */
  endDate?: InputMaybe<Scalars['Date']>;
};

/** Tax or fee required by an HTS number. See https://help.inlt.com/customs-brokerage/duties-taxes-and-fees. */
export type HtsFee = {
  __typename?: 'HtsFee';
  /** Unique ID for HTS component. */
  chargeId?: Maybe<Scalars['String']>;
  /** Fee class code defined in CATAIR. */
  class?: Maybe<Scalars['String']>;
  /** End (expiration) date for HTS component. */
  endDate?: Maybe<Scalars['Date']>;
  /** Fee name. */
  name?: Maybe<Scalars['String']>;
  /** Note related to HTS component. */
  note?: Maybe<Scalars['String']>;
  /** Rate object used to calculate fee. */
  rate?: Maybe<HtsRate>;
  /** Fee computation code. */
  rateCode?: Maybe<Scalars['String']>;
  /** Readable fee calculation formula. */
  rateString?: Maybe<Scalars['String']>;
  /** Whether the fee is required or may be disclaimed. */
  required?: Maybe<Scalars['Boolean']>;
  /** Start (effective) date for HTS component. */
  startDate?: Maybe<Scalars['Date']>;
  /** Whether the fee is considered a tax or fee by CBP. */
  type?: Maybe<HtsFeeType>;
};

export type HtsFeeInput = {
  /** Unique ID for HTS component. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Fee class code defined in CATAIR. */
  class?: InputMaybe<Scalars['String']>;
  duty?: InputMaybe<Scalars['String']>;
  /** End (expiration) date for HTS component. */
  endDate?: InputMaybe<Scalars['Date']>;
  feeAdValorem?: InputMaybe<Scalars['Float']>;
  feeOther?: InputMaybe<Scalars['Float']>;
  feeSpecific?: InputMaybe<Scalars['Float']>;
  flag?: InputMaybe<Scalars['String']>;
  /** Note related to HTS component. */
  note?: InputMaybe<Scalars['String']>;
  /** Start (effective) date for HTS component. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** The type of Fee */
export enum HtsFeeType {
  FEE = 'FEE',
  TAX = 'TAX'
}

/** HTS license data. */
export type HtsLicense = {
  __typename?: 'HtsLicense';
  /** License code required on Line. */
  code?: Maybe<Scalars['String']>;
  /** End (expiration) date for HTS control. */
  endDate?: Maybe<Scalars['Date']>;
  /** License name required on Line */
  name?: Maybe<Scalars['String']>;
  /** Start (effective) date for HTS control. */
  startDate?: Maybe<Scalars['Date']>;
};

export type HtsLicenseInput = {
  /** License code required on Line. */
  code?: InputMaybe<Scalars['String']>;
  /** End (expiration) date for HTS control. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Start (effective) date for HTS control. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Quantity code and bounds for an HTS number. */
export type HtsQuantityRestriction = {
  __typename?: 'HtsQuantityRestriction';
  /** Restricted by quantity code. */
  code?: Maybe<Scalars['String']>;
  /** Maximum allowed quantity. */
  highBounds?: Maybe<Scalars['Float']>;
  /** Minimum allowed quantity. */
  lowBounds?: Maybe<Scalars['Float']>;
};

/** Quantity code and bounds for an HTS number. */
export type HtsQuantityRestrictionInput = {
  /** Restricted by quantity code. */
  code?: InputMaybe<Scalars['String']>;
  /** Maximum allowed quantity. */
  highBounds?: InputMaybe<Scalars['Float']>;
  /** Minimum allowed quantity. */
  lowBounds?: InputMaybe<Scalars['Float']>;
};

/** Types of rates used to calculate duty */
export type HtsRate = {
  __typename?: 'HtsRate';
  /** Percent rate of duty in decimal form, used by multiplying the Lines total value. */
  adValorem?: Maybe<Scalars['Float']>;
  /** Unique ID for HTS component. */
  chargeId?: Maybe<Scalars['String']>;
  /** End (expiration) date for HTS component. */
  endDate?: Maybe<Scalars['Date']>;
  /** Note related to HTS component. */
  note?: Maybe<Scalars['String']>;
  /** Other rate of duty, used in various ways. */
  other?: Maybe<Scalars['Float']>;
  /** Duty computation code. */
  rateCode?: Maybe<Scalars['String']>;
  /** Specific rate of duty, used by multiplying a unit of measure quantity. */
  specific?: Maybe<Scalars['Float']>;
  /** Start (effective) date for HTS component. */
  startDate?: Maybe<Scalars['Date']>;
};

export type HtsRateInput = {
  /** Percent rate of duty in decimal form, used by multiplying the Lines total value. */
  adValorem?: InputMaybe<Scalars['Float']>;
  /** Unique ID for HTS component. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** End (expiration) date for HTS component. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Note related to HTS component. */
  note?: InputMaybe<Scalars['String']>;
  /** Other rate of duty, used in various ways. */
  other?: InputMaybe<Scalars['Float']>;
  /** Duty computation code. */
  rateCode?: InputMaybe<Scalars['String']>;
  /** Specific rate of duty, used by multiplying a unit of measure quantity. */
  specific?: InputMaybe<Scalars['Float']>;
  /** Start (effective) date for HTS component. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Restrictions on using an HTS Number */
export type HtsRestriction = {
  __typename?: 'HtsRestriction';
  /** Restricted by country of origin. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** Restricted by ISO Country of Origin Edit Code */
  countryOfOriginEditCode?: Maybe<Scalars['HtsRestrictionCountryOfOriginEditCode']>;
  /** Restricted by entry dates. */
  entryDates?: Maybe<Array<HtsEntryDateRestriction>>;
  /** Restricted by hts quantity code or bounds. */
  quantity?: Maybe<HtsQuantityRestriction>;
  /** Restricted by quantity code. */
  quantityCode?: Maybe<Scalars['String']>;
  /** Maximum allowed quantity. */
  quantityHighBounds?: Maybe<Scalars['Float']>;
  /** Minimum allowed quantity. */
  quantityLowBounds?: Maybe<Scalars['Float']>;
  /** Restricted by hts value code or bounds. */
  value?: Maybe<HtsValueRestriction>;
  /** Restricted by value code. */
  valueCode?: Maybe<Scalars['String']>;
  /** Maximum allowed value. */
  valueHighBounds?: Maybe<Scalars['Float']>;
  /** Minimum allowed value. */
  valueLowBounds?: Maybe<Scalars['Float']>;
};

/** Restrictions on using an HTS Number */
export type HtsRestrictionInput = {
  /** Restricted by country of origin. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Restricted by ISO Country of Origin Edit Code */
  countryOfOriginEditCode?: InputMaybe<Scalars['HtsRestrictionCountryOfOriginEditCode']>;
  /** Restricted by entry dates. */
  entryDates?: InputMaybe<Array<HtsEntryDateRestrictionInput>>;
  /** Restricted by hts quantity code or bounds. */
  quantity?: InputMaybe<HtsQuantityRestrictionInput>;
  /** Restricted by quantity code. */
  quantityCode?: InputMaybe<Scalars['String']>;
  /** Maximum allowed quantity. */
  quantityHighBounds?: InputMaybe<Scalars['Float']>;
  /** Minimum allowed quantity. */
  quantityLowBounds?: InputMaybe<Scalars['Float']>;
  /** Restricted by hts value code or bounds. */
  value?: InputMaybe<HtsValueRestrictionInput>;
  /** Restricted by value code. */
  valueCode?: InputMaybe<Scalars['String']>;
  /** Maximum allowed value. */
  valueHighBounds?: InputMaybe<Scalars['Float']>;
  /** Minimum allowed value. */
  valueLowBounds?: InputMaybe<Scalars['Float']>;
};

export type HtsSearchCriteria = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The effective end date. */
  endDate?: InputMaybe<DateSearchCriteriaInput>;
  /** HS number type. */
  hsNumberType?: InputMaybe<HsNumberTypeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** HS number. */
  number?: InputMaybe<TextSearchCriteriaInput>;
  /** The effective start date. */
  startDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type HtsSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['HtsNumber']>>;
};

/** HTS search results. */
export type HtsSearchTableRow = {
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The effective end date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type. */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** HTS number. */
  number: Scalars['HtsNumber'];
  /** The effective start date. */
  startDate?: Maybe<Scalars['Date']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Unique SPI rate per country. */
export type HtsSpiRate = {
  __typename?: 'HtsSpiRate';
  /** Percent rate of duty in decimal form, used by multiplying the Lines total value. */
  adValorem?: Maybe<Scalars['Float']>;
  /** Unique ID for HTS component. */
  chargeId?: Maybe<Scalars['String']>;
  /** Code used on the entry Line. */
  code?: Maybe<Scalars['String']>;
  /** Country associated with the SPI special rate. */
  country?: Maybe<Scalars['CountryCode']>;
  /** End (expiration) date for HTS component. */
  endDate?: Maybe<Scalars['Date']>;
  /** Note related to HTS component. */
  note?: Maybe<Scalars['String']>;
  /** Other rate of duty, used in various ways. */
  other?: Maybe<Scalars['Float']>;
  /** Duty computation code. */
  rateCode?: Maybe<Scalars['String']>;
  /** Specific rate of duty, used by multiplying a unit of measure quantity. */
  specific?: Maybe<Scalars['Float']>;
  /** Start (effective) date for HTS component. */
  startDate?: Maybe<Scalars['Date']>;
};

export type HtsSpiRateInput = {
  /** Percent rate of duty in decimal form, used by multiplying the Lines total value. */
  adValorem?: InputMaybe<Scalars['Float']>;
  /** Unique ID for HTS component. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Code used on the entry Line. */
  code?: InputMaybe<Scalars['String']>;
  /** Country associated with the SPI special rate. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** End (expiration) date for HTS component. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Note related to HTS component. */
  note?: InputMaybe<Scalars['String']>;
  /** Other rate of duty, used in various ways. */
  other?: InputMaybe<Scalars['Float']>;
  /** Duty computation code. */
  rateCode?: InputMaybe<Scalars['String']>;
  /** Specific rate of duty, used by multiplying a unit of measure quantity. */
  specific?: InputMaybe<Scalars['Float']>;
  /** Start (effective) date for HTS component. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Value code and bounds for an HTS number. */
export type HtsValueRestriction = {
  __typename?: 'HtsValueRestriction';
  /** Restricted by value code. */
  code?: Maybe<Scalars['String']>;
  /** Maximum allowed value. */
  highBounds?: Maybe<Scalars['Float']>;
  /** Minimum allowed value. */
  lowBounds?: Maybe<Scalars['Float']>;
};

/** Value code and bounds for an HTS number. */
export type HtsValueRestrictionInput = {
  /** Restricted by value code. */
  code?: InputMaybe<Scalars['String']>;
  /** Maximum allowed value. */
  highBounds?: InputMaybe<Scalars['Float']>;
  /** Minimum allowed value. */
  lowBounds?: InputMaybe<Scalars['Float']>;
};

export type HtssConnection = Connection & {
  __typename?: 'HtssConnection';
  edges: Array<HtsEdge>;
  nodes: Array<Hts>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type IdIndexSearchCriteriaInput = {
  /** Operators available when searcing on an index field (only EQUALS). */
  operator?: InputMaybe<IndexSearchOperator>;
  /** The field's scalar values to be searched for. */
  values: Array<Scalars['ID']>;
};

/** ID of a Record. */
export type IdInput = {
  /** The unique ID of a Record */
  id: Scalars['ID'];
};

/** ID and optional version of a Record. */
export type IdOptionalVersionInput = {
  /** The unique ID of a Record */
  id: Scalars['ID'];
  /** Optional version of a Record. If not provided the latest version is returned. */
  version?: InputMaybe<Scalars['Int']>;
};

export type IdSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['ID']>>;
};

/** ID and type name of a Record. */
export type IdTypeNameInput = {
  /** The unique ID of a Record */
  id: Scalars['ID'];
  /** GQL type name of a Record. */
  typeName: Scalars['String'];
};

export type IdVersion = {
  __typename?: 'IdVersion';
  /** Record ID */
  id: Scalars['ID'];
  /** Record version */
  version: Scalars['Int'];
};

/** ID and version of a Record. */
export type IdVersionInput = {
  /** The unique ID of a Record */
  id: Scalars['ID'];
  /** Version of a Record. */
  version: Scalars['Int'];
};

/** The type of identifier to externally validate. */
export enum IdentifierType {
  EU_EORI = 'EU_EORI',
  EU_VAT = 'EU_VAT',
  UK_EORI = 'UK_EORI',
  UK_VAT = 'UK_VAT'
}

/** Identity provided by external provider */
export type Identity = {
  __typename?: 'Identity';
  /** The unique identifier for this user from the specified provider */
  identifier: Scalars['String'];
  /** The IDP used to authenticate this user */
  provider: IdentityProvider;
};

/** Name of IDP used to identity a user */
export enum IdentityProvider {
  MONS = 'MONS'
}

/** Image based document stamp details. */
export type ImageStamp = {
  __typename?: 'ImageStamp';
  /** Stamp in base64 encoded image format - png/jpeg are supported types. */
  data: Scalars['Base64ImageString'];
  /** Positions where image needs to be stamped in document. */
  stampPositions: Array<ImageStampPosition>;
};

/** Image based document stamp details. */
export type ImageStampInput = {
  /** Stamp in base64 encoded image format - png/jpeg are supported types. */
  data: Scalars['Base64ImageString'];
  /** Positions where image needs to be stamped in document. */
  stampPositions: Array<ImageStampPositionInput>;
};

/** Details about the position in the input document where image will be stamped. */
export type ImageStampPosition = {
  __typename?: 'ImageStampPosition';
  /** Co-ordinates of the position in the document where stamp needs to be added. For PDF, the co-ordinates are relative to bottom-left corner of pdf. */
  coordinates: StampCoordinates;
  /** Details about the position in the input document where stamped will be added. */
  dimensions: StampDimensions;
  /** The page number of the document which needs to be stamped. */
  pageNumber: Scalars['Int'];
};

/** Details about the position in the input document where image will be stamped. */
export type ImageStampPositionInput = {
  /** Co-ordinates of the position in the document where stamp needs to be added. For PDF, the co-ordinates are relative to bottom-left corner of pdf. */
  coordinates: StampCoordinatesInput;
  /** Details about the position in the input document where stamped will be added. */
  dimensions: StampDimensionsInput;
  /** The page number of the document which needs to be stamped. */
  pageNumber: Scalars['Int'];
};

export type ImportCountry = {
  __typename?: 'ImportCountry';
  /** Code specifying the country from which the goods are originally imported without any commercial transaction taken place in intermediate countries. */
  country?: Maybe<Scalars['CountryCode']>;
  /** Region of Import identifier */
  region?: Maybe<Scalars['String']>;
};

export type ImportCountryInput = {
  /** Code specifying the country from which the goods are originally imported without any commercial transaction taken place in intermediate countries. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** Region of Import identifier */
  region?: InputMaybe<Scalars['String']>;
};

export type ImportProductsFromBulkUploadRequest = {
  __typename?: 'ImportProductsFromBulkUploadRequest';
  /** The details to be reviewed by the user when determining whether or not to accept or reject the bulk upload processing. */
  confirmationDetails?: Maybe<ProductBulkUploadConfirmationDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The document containing the data to be processed. */
  document: Document;
  /** Indicates the behavior that the API should emulate when deciding how to handle record duplicates */
  duplicateAction: SpreadsheetActionType;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The product owner that owns this request. */
  owner: ProductOwner;
  /** The current status for the processing of this confirmable upload request */
  status: ConfirmableBulkUploadStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ImportProductsFromBulkUploadRequestEdge = ConnectionEdge & {
  __typename?: 'ImportProductsFromBulkUploadRequestEdge';
  cursor: Scalars['ID'];
  node: ImportProductsFromBulkUploadRequest;
};

export type ImportProductsFromBulkUploadRequestsConnection = Connection & {
  __typename?: 'ImportProductsFromBulkUploadRequestsConnection';
  edges: Array<ImportProductsFromBulkUploadRequestEdge>;
  nodes: Array<ImportProductsFromBulkUploadRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ImportProductsFromCustomsEntriesRequest = {
  __typename?: 'ImportProductsFromCustomsEntriesRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Customs entries created this many days before today will be included in the list which creates product records. */
  createdDaysAgo: Scalars['Float'];
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The product owner that owns this request. */
  owner: ProductOwner;
  /** The status of the processing for this request. Will be updated with either COMPLETED or FAILED accordingly. */
  status: ImportProductsStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ImportProductsFromCustomsEntriesRequestEdge = ConnectionEdge & {
  __typename?: 'ImportProductsFromCustomsEntriesRequestEdge';
  cursor: Scalars['ID'];
  node: ImportProductsFromCustomsEntriesRequest;
};

export type ImportProductsFromCustomsEntriesRequestsConnection = Connection & {
  __typename?: 'ImportProductsFromCustomsEntriesRequestsConnection';
  edges: Array<ImportProductsFromCustomsEntriesRequestEdge>;
  nodes: Array<ImportProductsFromCustomsEntriesRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The current status for this import product request */
export enum ImportProductsStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  READY = 'READY'
}

/** Importer of Record (IOR) or Importer profile. */
export type Importer = Ior & Party & Record & {
  __typename?: 'Importer';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The description of the Importer's business */
  businessDescription?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<GlobalBusinessStructure>;
  /** Importer business website */
  businessWebsite?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Identifier for DocReadiness status of Importer in ShipDocs system */
  docReadinessId?: Maybe<Scalars['String']>;
  /** Importer Level Doc Readinesses */
  docReadinesses?: Maybe<Array<ImporterDocReadiness>>;
  /** The documents associated with the Importer. This is an eventually consistent query. */
  documents: Array<Document>;
  /** DPS record for this importer */
  dpsRecord?: Maybe<DpsRecord>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** References provided by external client. */
  externalClientReferences?: Maybe<Array<Scalars['String']>>;
  /** Extracted business license data */
  extractedBusinessLicense?: Maybe<ExtractedBusinessLicense>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Importer Entitys linked to this Importer. */
  importerEntities: ImporterImporterEntitysConnection;
  /** A Importer Entity linked to this Importer */
  importerEntity: ImporterImporterEntityRelationship;
  /** The industry of the Importer */
  industry?: Maybe<Vertical>;
  /** The legal representative of the Importer */
  legalRepresentative?: Maybe<PointOfContact>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Identifiers of customers with ownership of IOR */
  owners?: Maybe<Array<ImporterOwner>>;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** The secondary officer of the Importer */
  secondaryOfficer?: Maybe<PointOfContact>;
  /** A Shipper linked to this Importer */
  shipper: ShipperImporterRelationship;
  /** Shipper connection used to paginate results. */
  shippers: ImporterShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** translated business license data */
  translatedBusinessLicense?: Maybe<TranslatedBusinessLicense>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The linked Importer. */
  usIor?: Maybe<UsIor>;
  /** The record's version */
  version: Scalars['Int'];
};


/** Importer of Record (IOR) or Importer profile. */
export type ImporterdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Importer of Record (IOR) or Importer profile. */
export type ImporterimporterEntitiesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


/** Importer of Record (IOR) or Importer profile. */
export type ImporterimporterEntityArgs = {
  importerEntityId: Scalars['ID'];
};


/** Importer of Record (IOR) or Importer profile. */
export type ImportermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Importer of Record (IOR) or Importer profile. */
export type ImportershipperArgs = {
  shipperId: Scalars['ID'];
};


/** Importer of Record (IOR) or Importer profile. */
export type ImportershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type ImporterDocReadiness = {
  __typename?: 'ImporterDocReadiness';
  /** Doc Readiness ID */
  id: Scalars['String'];
  /** Identifier of program type. */
  programType?: Maybe<ImporterDocReadinessProgramType>;
  /** Doc Readiness type */
  type?: Maybe<Scalars['String']>;
};

export type ImporterDocReadinessInput = {
  /** Doc Readiness ID */
  id: Scalars['String'];
  /** Identifier of program type. */
  programType?: InputMaybe<ImporterDocReadinessProgramType>;
  /** Doc Readiness type */
  type?: InputMaybe<Scalars['String']>;
};

/** The type of Importer Doc Readiness */
export enum ImporterDocReadinessProgramType {
  FBA_EU_UK = 'FBA_EU_UK'
}

export type ImporterEdge = ConnectionEdge & {
  __typename?: 'ImporterEdge';
  cursor: Scalars['ID'];
  node: Importer;
};

export type ImporterEntitiesConnection = Connection & {
  __typename?: 'ImporterEntitiesConnection';
  edges: Array<ImporterEntityEdge>;
  nodes: Array<ImporterEntity>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Importer Entity in a specific country responsible for complying with customs regulations. */
export type ImporterEntity = Record & {
  __typename?: 'ImporterEntity';
  /** Broker review request and activation status details for a given country. */
  activations?: Maybe<Array<ImporterEntityActivationDetails>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** A list of the Importer's customs bonds for importing in the country. */
  bonds?: Maybe<CustomsBonds>;
  /** Time importer entity was activated with broker. */
  brokerActivationTime?: Maybe<Scalars['DateTime']>;
  /** Country Code in which importer entity is operating. */
  countryCode: Scalars['CountryCode'];
  /** Importer Entity's country specific data. */
  countrySpecificData?: Maybe<CountrySpecificData>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Identifier for DocReadiness status of IE in ShipDocs system */
  docReadinessId?: Maybe<Scalars['String']>;
  /** The documents associated with the Importer Entity. This is an eventually consistent query. */
  documents: Array<Document>;
  /** DPS record for this importer entity */
  dpsRecord?: Maybe<DpsRecord>;
  /** The code for the Importer's expected import volume in the country. */
  entriesPerYearCode?: Maybe<EntriesPerYear>;
  /** Importer Entity entry summary email addresses. */
  entrySummaryContactEmails?: Maybe<Array<Scalars['Email']>>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** References provided by external client. */
  externalClientReferences?: Maybe<Array<Scalars['String']>>;
  /** A list of external validation results for this ImporterEntity's identifiers. */
  externalValidations?: Maybe<Array<ExternalValidation>>;
  /** Indicate whether the importer entity has imported before. */
  hasImportedBefore?: Maybe<Scalars['Boolean']>;
  /** Indicate whether the IOR entity has own duty and tax account. */
  hasOwnDutyAndTaxAccount?: Maybe<Scalars['Boolean']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Importer country exclusive identifiers list. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Parent Importer record. */
  importer?: Maybe<Importer>;
  /** Indicate whether the IOR entity is a resident importer. */
  isResident?: Maybe<Scalars['Boolean']>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: Maybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Importer Entity point of contact. */
  pointOfContact?: Maybe<PointOfContact>;
  /** Details of Programs associated with the Importer Entity. */
  program?: Maybe<Array<ProgramDetails>>;
  /** Source channel identifier */
  sourceChannel?: Maybe<SourceChannel>;
  /** Source portal identifier */
  sourcePortal?: Maybe<SourcePortal>;
  /** The status of the Importer Entity. */
  status?: Maybe<ImporterEntityStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** Importer Entity in a specific country responsible for complying with customs regulations. */
export type ImporterEntitydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ImporterEntityActivation = Record & WorkOrder & {
  __typename?: 'ImporterEntityActivation';
  /** Broker associated with the activation. */
  broker?: Maybe<CustomsBroker>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Code specifying the country of this importer entity activation. It uses ISO 3166 standard. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the Importer Entity Activation . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** Importer Entity activation request in a given country. */
  importerEntity?: Maybe<ImporterEntity>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** US Importer of Record reference. */
  usIor?: Maybe<UsIor>;
  /** The record's version */
  version: Scalars['Int'];
};


export type ImporterEntityActivationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ImporterEntityActivationDetails = {
  __typename?: 'ImporterEntityActivationDetails';
  /** Importer activation meta data. */
  activated?: Maybe<RecordAction>;
  /** Broker representation for the Importer. */
  brokerRepresentation?: Maybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: CustomsBroker;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: Maybe<ExternalBrokerReference>;
  /** External Importer references. */
  externalIorReferences?: Maybe<Array<ExternalIorReference>>;
  /** Importer rejection meta data. */
  rejected?: Maybe<RecordAction>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: Maybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type ImporterEntityActivationEdge = ConnectionEdge & {
  __typename?: 'ImporterEntityActivationEdge';
  cursor: Scalars['ID'];
  node: ImporterEntityActivation;
};

export type ImporterEntityActivationSearchCriteriaInput = {
  /** IOR Activation Status. */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** Activation time of Importer. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Code specifying the country of this importer entity activation. It uses ISO 3166 standard */
  countryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The IOR's status with customs authorities (e.g., CBP for US, HMRC for GB) */
  customsStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Entity rejection reasons from the latest activation */
  entityRejectionReasons?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Importer Entity ID */
  importerEntityId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Importer ID */
  importerId?: InputMaybe<IdSearchCriteriaInput>;
  /** Importer Name */
  importerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The related IOR's ID. */
  iorId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** IOR or Importer Entity identifiers (e.g., tax IDs, registration numbers) */
  iorIdentifiers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** The related Shipper's Global Logistics Profile ID */
  shipperProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Source channel identifier */
  sourceChannel?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Source portal identifier */
  sourcePortal?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The US IOR ID */
  usIorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Importer Activation search result */
export type ImporterEntityActivationSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'ImporterEntityActivationSearchTableRow';
  /** Activation status of Importer. */
  activationStatus?: Maybe<ActivationStatus>;
  /** Activation time of Importer. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** Assignee Names */
  assigneeName?: Maybe<Array<Scalars['String']>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** Business License Number */
  businessLicenseNumber?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** CBP Assigned Number */
  cbpAssignedNumber?: Maybe<Scalars['String']>;
  /** Corporate ID Number */
  corporateIdNumber?: Maybe<Scalars['String']>;
  /** Code specifying the country of this importer entity activation. It uses ISO 3166 standard */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The IOR's status with customs authorities (e.g., CBP for US, HMRC for GB) */
  customsStatus?: Maybe<Scalars['String']>;
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** DUNS */
  duns?: Maybe<Scalars['String']>;
  /** EIN */
  ein?: Maybe<Scalars['String']>;
  /** Entity rejection reasons from the latest activation */
  entityRejectionReasons?: Maybe<Array<Scalars['String']>>;
  /** Entity status - returns importerEntity status for non-US countries, usIor status for US */
  entityStatus?: Maybe<Scalars['String']>;
  /** EORI */
  eori?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Importer Entity ID */
  importerEntityId?: Maybe<Scalars['ID']>;
  /** Importer Exporter Code */
  importerExporterCode?: Maybe<Scalars['String']>;
  /** The Importer ID */
  importerId?: Maybe<Scalars['ID']>;
  /** Importer Name */
  importerName?: Maybe<Scalars['String']>;
  /** The related IOR's ID. */
  iorId?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Is Submitted Before */
  isSubmittedBefore?: Maybe<Scalars['Boolean']>;
  /** JCT ID */
  jctId?: Maybe<Scalars['String']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** NAICS */
  naics?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** The related Shipper's Global Logistics Profile ID */
  shipperProfileId?: Maybe<Scalars['String']>;
  /** Source Channel */
  sourceChannel?: Maybe<Scalars['String']>;
  /** Source Portal */
  sourcePortal?: Maybe<Scalars['String']>;
  /** SSN */
  ssn?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** The US IOR ID */
  usIorId?: Maybe<Scalars['ID']>;
  /** VAT Number */
  vatNumber?: Maybe<Scalars['String']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
  /** Work Order ID associated with this activation */
  workOrderId?: Maybe<Scalars['String']>;
};

export type ImporterEntityActivationsConnection = Connection & {
  __typename?: 'ImporterEntityActivationsConnection';
  edges: Array<ImporterEntityActivationEdge>;
  nodes: Array<ImporterEntityActivation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ImporterEntityEdge = ConnectionEdge & {
  __typename?: 'ImporterEntityEdge';
  cursor: Scalars['ID'];
  node: ImporterEntity;
};

export type ImporterEntitySearchCriteriaInput = {
  /** Search ImporterEntity by activation status */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** Search ImporterEntity by activation time */
  activationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** ImporterEntity's bond Anniversary date. */
  bondAnniversary?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** ImporterEntity's bond expiration date. */
  bondExpirationDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** ImporterEntity's bond number. */
  bondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Search ImporterEntity by country code */
  countryCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Search ImporterEntity by external client references */
  externalClientReferences?: InputMaybe<KeywordSearchCriteriaInput>;
  /** ImporterEntity is currently in bond or not */
  hasActiveBond?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Search ImporterEntity by associated identifier e.g. vat number, eori number, ein, cbp assigned etc */
  identifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Search ImporterEntities by Shipper id having relationship to parent Importer profile */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Search ImporterEntities by Shipper name having relationship to parent Importer profile */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Importer Entity status */
  status?: InputMaybe<ImporterEntityStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type ImporterEntitySearchTableRow = {
  __typename?: 'ImporterEntitySearchTableRow';
  /** Importer Activation status */
  activationStatus?: Maybe<Array<ActivationStatus>>;
  /** Importer Activation time */
  activationTime?: Maybe<Array<Scalars['DateTime']>>;
  /** Importer Entity's bond anniversary date. */
  bondAnniversary?: Maybe<Scalars['DateTime']>;
  /** Importer Entity's bond expiration date. */
  bondExpirationDate?: Maybe<Scalars['DateTime']>;
  /** Importer Entity's bond number. */
  bondNumber?: Maybe<Array<Scalars['String']>>;
  /** ImporterEntity's country code */
  countryCode: Scalars['CountryCode'];
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Search ImporterEntity by external client references */
  externalClientReferences?: Maybe<Array<Scalars['String']>>;
  /** ImporterEntity is currently in bond or not */
  hasActiveBond?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** ImporterEntity's identifiers */
  identifier: Array<PartyIdentification>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Importer Entity status */
  status?: Maybe<ImporterEntityStatus>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** The status of the Importer Entity. */
export enum ImporterEntityStatus {
  APPROVED = 'APPROVED',
  DEACTIVATED = 'DEACTIVATED',
  DRAFT = 'DRAFT',
  PENDING_BROKER_VETTING = 'PENDING_BROKER_VETTING',
  PENDING_ESIGN = 'PENDING_ESIGN',
  PENDING_INTERNAL_VETTING = 'PENDING_INTERNAL_VETTING',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  SUBMITTED = 'SUBMITTED'
}

export type ImporterEntityStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ImporterEntityStatus>>;
};

export type ImporterImporterEntityEdge = ConnectionEdge & {
  __typename?: 'ImporterImporterEntityEdge';
  cursor: Scalars['ID'];
  /** The linked Importer Entity. */
  node?: Maybe<ImporterEntity>;
  /** The data on the link between the Importer and Importer Entity. */
  relationship?: Maybe<ImporterImporterEntityRelationship>;
};

export type ImporterImporterEntityRelationship = Record & {
  __typename?: 'ImporterImporterEntityRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Importer. */
  importer: Importer;
  /** The linked Importer Entity. */
  importerEntity: ImporterEntity;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ImporterImporterEntitysConnection = Connection & {
  __typename?: 'ImporterImporterEntitysConnection';
  edges: Array<ImporterImporterEntityEdge>;
  nodes: Array<ImporterEntity>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ImporterNameAndId = {
  __typename?: 'ImporterNameAndId';
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ImporterOwner = {
  __typename?: 'ImporterOwner';
  /** Identifier of customer. */
  customerId?: Maybe<Scalars['String']>;
  /** Type of customer id. */
  type?: Maybe<Scalars['String']>;
};

export type ImporterOwnerInput = {
  /** Identifier of customer. */
  customerId?: InputMaybe<Scalars['String']>;
  /** Type of customer id. */
  type?: InputMaybe<Scalars['String']>;
};

export type ImporterSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The structure of the business */
  businessStructure?: InputMaybe<GlobalBusinessStructureSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Importer email */
  email?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Search Importer by external client references */
  externalClientReferences?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Search Importer by associated identifier e.g. vat number, eori number, ein, cbp assigned etc */
  identifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The industry/vertical of the importer */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type ImporterSearchTableRow = {
  __typename?: 'ImporterSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<GlobalBusinessStructure>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Importer email */
  email?: Maybe<Scalars['Email']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Search Importer by external client references */
  externalClientReferences?: Maybe<Array<Scalars['String']>>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Search Importer by associated identifier e.g. vat number, eori number, ein, cbp assigned etc */
  identifier?: Maybe<Scalars['String']>;
  /** The type industry of the Ior. */
  industry?: Maybe<Vertical>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ImporterShipperEdge = ConnectionEdge & {
  __typename?: 'ImporterShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Importer. */
  relationship: ShipperImporterRelationship;
};

export enum ImporterShipperRelationshipStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type ImporterShippersConnection = Connection & {
  __typename?: 'ImporterShippersConnection';
  edges: Array<ImporterShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ImportersConnection = Connection & {
  __typename?: 'ImportersConnection';
  edges: Array<ImporterEdge>;
  nodes: Array<Importer>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Create InBondNotes document generation request. */
export type InBondNotesDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'InBondNotesDocumentGenerationRequest';
  /** The bills for the CbpInBond */
  bills: Array<BillInfo>;
  /** Each CbpInBondResponseData for the CbpInBond. The messages provided should be for the inBondNumber provided. */
  cbpInBondResponses: Array<CbpInBondResponseData>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The INLT US In-Bond number for the CbpInBond */
  inBondNumber: Scalars['InltUsInBondNumber'];
  /** The mode of transport for the CbpInBond */
  modeOfTransport: ModeOfTransport;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The previous CbpInBond US In-Bond number */
  previousCbpInBondNumber?: Maybe<Scalars['UsInBondNumber']>;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type InboxMetadata = {
  __typename?: 'InboxMetadata';
  /** The body content of the received email. */
  body?: Maybe<Scalars['String']>;
  /** Email address of the source entity of the message. */
  from?: Maybe<Scalars['String']>;
  /** Some preview of human-readable ExchangeMessage content, e.g. the first 100 characters of an email body. */
  preview?: Maybe<Scalars['String']>;
  /** Subject line of the recieved email. */
  subject?: Maybe<Scalars['String']>;
  /** Email addresses of the intended recipient of the message. */
  to?: Maybe<Array<Scalars['String']>>;
  /** The work order this email exchange message is assigned to. */
  workOrderId?: Maybe<Scalars['String']>;
};

/** Additional metadata for Email ExchangeMessages. */
export type InboxMetadataInput = {
  /** The body content of the received email. */
  body?: InputMaybe<Scalars['String']>;
  /** Email address of the source entity of the message. */
  from?: InputMaybe<Scalars['String']>;
  /** Some preview of human-readable ExchangeMessage content, e.g. the first 100 characters of an email body. */
  preview?: InputMaybe<Scalars['String']>;
  /** Subject line of the recieved email. */
  subject?: InputMaybe<Scalars['String']>;
  /** Email addresses of the intended recipient of the message. */
  to?: InputMaybe<Array<Scalars['String']>>;
  /** The work order this email exchange message is assigned to. */
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type IncrementUsEntryBrokerNumberPayload = {
  __typename?: 'IncrementUsEntryBrokerNumberPayload';
  /** The current broker number for the US Broker. */
  brokerNumber: Scalars['Int'];
};

/** Operators used for index based search operations (only EQUALS). */
export enum IndexSearchOperator {
  EQUALS = 'EQUALS'
}

export type InquireWorkOrderInput = {
  /** The documents attached to the email */
  attachDocuments?: InputMaybe<Array<IdInput>>;
  /** The documents that need more information noted in this inquiry */
  clarifyDocuments?: InputMaybe<Array<IdInput>>;
  /** The description for this inquiry */
  description?: InputMaybe<Scalars['String']>;
  /** The ProductLevelInquiries for this inquiry */
  productLevelInquiries?: InputMaybe<Array<ProductLevelInquiryInput>>;
  /** The WorkOrderInquiryReasonCodes for this inquiry */
  reasonCodes?: InputMaybe<Array<WorkOrderInquiryReasonCode>>;
  /** The requested documents (documents currently missing) noted in this inquiry */
  requestDocuments?: InputMaybe<Array<DocumentTag>>;
  /** The task that is blocked by this inquiry. If a task is not provided the most recent in progress task (if there is one in progress) will be marked blocked by this inquiry */
  task?: InputMaybe<IdInput>;
};

export type InquireWorkOrderPayload = {
  __typename?: 'InquireWorkOrderPayload';
  /** The updated Work Order with the latest inquiry. */
  workOrder: WorkOrder;
};

export type IntSearchCriteriaInput = {
  /** The maximum value when requesting a range operation */
  max?: InputMaybe<Scalars['Int']>;
  /** The minimum value when requesting a range operation */
  min?: InputMaybe<Scalars['Int']>;
  /** Operators available when searcing for number data types. */
  operator: NumberSearchOperator;
  /** The value for non-range operations. */
  value?: InputMaybe<Scalars['Int']>;
};

/** Intended use information for the product. Used by: CPSC */
export type IntendedUse = {
  __typename?: 'IntendedUse';
  /** Intended use code (e.g., "130.001" for infant products) */
  code: Scalars['String'];
  /** Intended use description - Required if code is "980.000" (For Other Use) */
  description?: Maybe<Scalars['String']>;
};

/** Intended use information for the product. Used by: CPSC */
export type IntendedUseInput = {
  /** Intended use code (e.g., "130.001" for infant products) */
  code: Scalars['String'];
  /** Intended use description - Required if code is "980.000" (For Other Use) */
  description?: InputMaybe<Scalars['String']>;
};

export type InternalSystem = RecordActionSource & {
  __typename?: 'InternalSystem';
  /** The name of an internal component of CBMS. */
  name: InternalSystemName;
  /** A string representing the version of the Client's source system. */
  version?: Maybe<Scalars['String']>;
};

/** The name of an internal component of CBMS. */
export enum InternalSystemName {
  AS2_ADAPTER = 'AS2_ADAPTER',
  AUDIT_LOG_AUTHORITY = 'AUDIT_LOG_AUTHORITY',
  AUDIT_LOG_WORKFLOW = 'AUDIT_LOG_WORKFLOW',
  CARGOWISE_ADAPTER = 'CARGOWISE_ADAPTER',
  CARGOWISE_WORKFLOW = 'CARGOWISE_WORKFLOW',
  CLIENT_AUTHORITY = 'CLIENT_AUTHORITY',
  CLIENT_WORKFLOW = 'CLIENT_WORKFLOW',
  CUSTOM_DOMAIN_AUTHORITY = 'CUSTOM_DOMAIN_AUTHORITY',
  CUSTOM_DOMAIN_WORKFLOW = 'CUSTOM_DOMAIN_WORKFLOW',
  DEV_TOOLS = 'DEV_TOOLS',
  DOCUMENT_AUTHORITY = 'DOCUMENT_AUTHORITY',
  DOCUMENT_GENERATION_WORKFLOW = 'DOCUMENT_GENERATION_WORKFLOW',
  DOCUMENT_INGEST_WORKFLOW = 'DOCUMENT_INGEST_WORKFLOW',
  DOCUMENT_SIGN_WORKFLOW = 'DOCUMENT_SIGN_WORKFLOW',
  ERROR_AUTHORITY = 'ERROR_AUTHORITY',
  ERROR_WORKFLOW = 'ERROR_WORKFLOW',
  EXTERNAL_GATEWAY = 'EXTERNAL_GATEWAY',
  FINANCE_AUTHORITY = 'FINANCE_AUTHORITY',
  FINANCE_WORKFLOW = 'FINANCE_WORKFLOW',
  GATEWAY = 'GATEWAY',
  GTNEXUS_WORKFLOW = 'GTNEXUS_WORKFLOW',
  LAMBDA_LAYERS = 'LAMBDA_LAYERS',
  LEGACY_INLT = 'LEGACY_INLT',
  LIVE_PIPELINE = 'LIVE_PIPELINE',
  MESSAGE_EXCHANGE_AUTHORITY = 'MESSAGE_EXCHANGE_AUTHORITY',
  MESSAGE_EXCHANGE_LISTENER = 'MESSAGE_EXCHANGE_LISTENER',
  MESSAGE_EXCHANGE_WORKFLOW = 'MESSAGE_EXCHANGE_WORKFLOW',
  MQ_ADAPTER = 'MQ_ADAPTER',
  NOTIFICATION_WORKFLOW = 'NOTIFICATION_WORKFLOW',
  PARTY_AUTHORITY = 'PARTY_AUTHORITY',
  PARTY_WORKFLOW = 'PARTY_WORKFLOW',
  PRODUCT_AUTHORITY = 'PRODUCT_AUTHORITY',
  PRODUCT_WORKFLOW = 'PRODUCT_WORKFLOW',
  QBO_ADAPTER = 'QBO_ADAPTER',
  SEARCH_SERVICE = 'SEARCH_SERVICE',
  SFTP_ADAPTER = 'SFTP_ADAPTER',
  SHARED = 'SHARED',
  SHIPMENT_AUTHORITY = 'SHIPMENT_AUTHORITY',
  SHIPMENT_WORKFLOW = 'SHIPMENT_WORKFLOW',
  TRADE_DATA_AUTHORITY = 'TRADE_DATA_AUTHORITY',
  TRADE_DATA_WORKFLOW = 'TRADE_DATA_WORKFLOW',
  VYOS_VPN = 'VYOS_VPN',
  WORK_ORDER_AUTHORITY = 'WORK_ORDER_AUTHORITY',
  WORK_ORDER_MESSAGE_WORKFLOW = 'WORK_ORDER_MESSAGE_WORKFLOW',
  WORK_ORDER_MILESTONE_WORKFLOW = 'WORK_ORDER_MILESTONE_WORKFLOW',
  WORK_ORDER_WORKFLOW = 'WORK_ORDER_WORKFLOW'
}

export type InternalWebsite = ClientApiKey & RecordActionSource & {
  __typename?: 'InternalWebsite';
  /** API Key used to authenticate with CBMS. */
  apiKey: Scalars['ID'];
  /** The name of a website of CBMS. */
  name: InternalWebsiteName;
  /** A string representing the version of the Client's source system. */
  version?: Maybe<Scalars['String']>;
};

/** The name of a website of CBMS. */
export enum InternalWebsiteName {
  APP = 'APP',
  DEEPTHOUGHT = 'DEEPTHOUGHT',
  DOCUMENTATION = 'DOCUMENTATION',
  IMPORTSIGN = 'IMPORTSIGN',
  IOR_ONBOARDING = 'IOR_ONBOARDING',
  MARKETING = 'MARKETING',
  PROCHECK = 'PROCHECK'
}

/** The reason for an invalid result. */
export enum InvalidExternalValidationReason {
  BUSINESS_NOT_FOUND = 'BUSINESS_NOT_FOUND',
  INVALID_INPUT_FORMAT = 'INVALID_INPUT_FORMAT'
}

/** The primary entity used to represent a Invoice. */
export type Invoice = Record & {
  __typename?: 'Invoice';
  /** Accounting System details */
  accountingSystemDetails?: Maybe<AccountingSystemDetail>;
  /** Billing party details of bill to party. */
  billToParty: BillingParty;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The invoice credit notes associated with the invoice. This is an eventually consistent query. */
  creditNotes?: Maybe<Array<InvoiceCreditNote>>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The sending history of the invoice */
  deliveries?: Maybe<Array<InvoiceDelivery>>;
  /** The documents associated with the Invoice. This is an eventually consistent query. */
  documents: Array<Document>;
  /**  The due date of the invoice */
  dueTime?: Maybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /**  The time of the invoicing */
  invoicedTime?: Maybe<Scalars['DateTime']>;
  /** The individual charges on the invoice */
  lines?: Maybe<Array<InvoiceLine>>;
  /**  The invoice number printed on the PDF */
  number?: Maybe<Scalars['ID']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /**  The payment method for this invoice */
  paymentMethod?: Maybe<PaymentMethod>;
  /** The invoice payments associated with the Invoice. This is an eventually consistent query. */
  payments?: Maybe<Array<InvoicePayment>>;
  /** The current status of the invoice */
  status: InvoiceStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Total amount due in US Dollars */
  total?: Maybe<Cost>;
  /** The type of invoice, eg: WorkOrderGroup, sub */
  type: InvoiceType;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /**  The time the invoice was voided */
  voidTime?: Maybe<Scalars['DateTime']>;
  /** The work order group details associated with Invoice if invoice type is work order group */
  workOrderGroup?: Maybe<WorkOrderGroup>;
};


/** The primary entity used to represent a Invoice. */
export type InvoicedocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type InvoiceCharge = {
  __typename?: 'InvoiceCharge';
  /** Amount of the charge. */
  amount: Cost;
  /** Charge code or type of the charge. */
  type: ChargeCode;
};

/** The primary entity used to represent an Invoice Credit Note */
export type InvoiceCreditNote = Record & {
  __typename?: 'InvoiceCreditNote';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The time that the credit note was applied by AR */
  creditTime?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Context behind the purpose of the credit note */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the Invoice Credit Note. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The invoice that the credit note is related to */
  invoice: Invoice;
  /** The itemized lines that will be refunded */
  lines: Array<InvoiceCreditNoteLine>;
  /**  The invoice credit note number printed on the PDF */
  number?: Maybe<Scalars['ID']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The current working status of the credit note */
  status: InvoiceCreditNoteStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The sum of the credits for the line charges on the credit note */
  totalCredit?: Maybe<Cost>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** The primary entity used to represent an Invoice Credit Note */
export type InvoiceCreditNotedocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Object type that defines an InvoiceCreditNoteDocumentGenerationRequest */
export type InvoiceCreditNoteDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'InvoiceCreditNoteDocumentGenerationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Invoice credit note reference that will be queried in DGW */
  invoiceCreditNote: IdVersion;
  /** The type of invoice credit note PDF that should be generated. If not provided, DGW will infer the PDF that should be used. */
  invoiceCreditNoteType?: Maybe<InvoiceCreditNoteDocumentGenerationType>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The type of invoice credit note being generated */
export enum InvoiceCreditNoteDocumentGenerationType {
  BROKER_BILLING_PARTY_CREDIT_NOTE = 'BROKER_BILLING_PARTY_CREDIT_NOTE',
  EXTERNAL_CREDIT_NOTE = 'EXTERNAL_CREDIT_NOTE',
  REQUEST_FOR_PAYMENT_CREDIT_NOTE = 'REQUEST_FOR_PAYMENT_CREDIT_NOTE'
}

export type InvoiceCreditNoteEdge = ConnectionEdge & {
  __typename?: 'InvoiceCreditNoteEdge';
  cursor: Scalars['ID'];
  node: InvoiceCreditNote;
};

export type InvoiceCreditNoteLine = EmbeddedRecord & {
  __typename?: 'InvoiceCreditNoteLine';
  /** Charge amount */
  amount: Cost;
  /** Information relating to the creation of the Embedded Record */
  created: RecordAction;
  /** Unique ID */
  id: Scalars['ID'];
  /** The ID of the invoice line that will be credited */
  invoiceLineId: Scalars['ID'];
  /** Amount to be reimbursed */
  reimburseAmount?: Maybe<Cost>;
  /** Reimbursed time */
  reimbursedTime?: Maybe<Scalars['DateTime']>;
  /** Tags for the invoice line */
  tags?: Maybe<Array<Tag>>;
  /** Invoice charge code for the line */
  type: ChargeCode;
  /** Information relating to the last update of the Embedded Record */
  updated: RecordAction;
  /** The work order details associated with Invoice line if invoice type is work order group */
  workOrder?: Maybe<WorkOrder>;
};

export type InvoiceCreditNoteLineInput = {
  /** Charge amount */
  amount: CostInput;
  /** Invoice line id associate with invoice line. */
  id?: InputMaybe<Scalars['ID']>;
  /** The ID of the invoice line that will be credited */
  invoiceLineId: Scalars['ID'];
  /** Amount to be reimbursed */
  reimburseAmount?: InputMaybe<CostInput>;
  /** Reimbursed time */
  reimbursedTime?: InputMaybe<Scalars['DateTime']>;
  /** Tags for the invoice line */
  tags?: InputMaybe<Array<TagInput>>;
  /** Invoice charge code for the line */
  type: ChargeCode;
  /** The work order details associated with Invoice line if invoice type is work order group */
  workOrder?: InputMaybe<IdInput>;
};

export type InvoiceCreditNoteSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Invoice ID associated with the credit note */
  invoiceId?: InputMaybe<IdSearchCriteriaInput>;
  /** The invoice credit note number printed on the PDF */
  number?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Status of the credit note */
  status?: InputMaybe<InvoiceCreditNoteStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Invoice credit note search table row */
export type InvoiceCreditNoteSearchTableRow = RecordSearchTableRow & {
  __typename?: 'InvoiceCreditNoteSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Invoice ID associated with the credit note */
  invoiceId?: Maybe<Scalars['String']>;
  /** The invoice credit note number printed on the PDF */
  number?: Maybe<Scalars['String']>;
  /** Status of the credit note */
  status?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** The current working status of the credit note */
export enum InvoiceCreditNoteStatus {
  ACCEPTED = 'ACCEPTED',
  AWAITING_CREATE = 'AWAITING_CREATE',
  PROCESSING = 'PROCESSING'
}

export type InvoiceCreditNoteStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<InvoiceCreditNoteStatus>>;
};

export type InvoiceCreditNotesConnection = Connection & {
  __typename?: 'InvoiceCreditNotesConnection';
  edges: Array<InvoiceCreditNoteEdge>;
  nodes: Array<InvoiceCreditNote>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type InvoiceDelivery = {
  __typename?: 'InvoiceDelivery';
  exchangeMessage: ExchangeMessage;
};

export type InvoiceDeliveryInput = {
  exchangeMessage: IdInput;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  /** Border transport means information for the invoice. */
  borderTransportMeans?: Maybe<BorderTransportMeans>;
  /** Gross volume at invoice level from conveyance. */
  invoiceGrossVolume?: Maybe<Volume>;
  /** Gross weight at invoice level from conveyance. */
  invoiceGrossWeight?: Maybe<Scalars['Float']>;
  /** Invoice number associated with the goods item. */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Indicates if the invoice is split for the goods item. */
  splitInvoice?: Maybe<Scalars['Boolean']>;
};

export type InvoiceDetailsInput = {
  /** Border transport means information for the invoice. */
  borderTransportMeans?: InputMaybe<BorderTransportMeansInput>;
  /** Gross volume at invoice level from conveyance. */
  invoiceGrossVolume?: InputMaybe<VolumeInput>;
  /** Gross weight at invoice level from conveyance. */
  invoiceGrossWeight?: InputMaybe<Scalars['Float']>;
  /** Invoice number associated with the goods item. */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Indicates if the invoice is split for the goods item. */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
};

export type InvoiceDocumentBillToPartyInfo = {
  __typename?: 'InvoiceDocumentBillToPartyInfo';
  /** Address of the party. */
  address: Address;
  /** Name of invoice document party */
  name: Scalars['String'];
};

export type InvoiceDocumentBillToPartyInfoInput = {
  /** Address of the party. */
  address: AddressInput;
  /** Name of invoice document party */
  name: Scalars['String'];
};

/** Create Invoice document generation request. */
export type InvoiceDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'InvoiceDocumentGenerationRequest';
  /** Invoice bill to party info. */
  billToParty: InvoiceDocumentBillToPartyInfo;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Labels to classify the type of invoice document (e.g. IOR invoice). */
  documentTags?: Maybe<Array<DocumentTag>>;
  /**  The due date of the invoice. */
  dueDate: Scalars['DateTime'];
  /** Unique ID */
  id: Scalars['ID'];
  /**  Invoice date. */
  invoiceDate?: Maybe<Scalars['DateTime']>;
  /** Invoice status. */
  invoiceStatus: InvoiceStatus;
  /** The type of invoice PDF that should be generated. If not provided, DGW will infer the PDF that should be used. */
  invoiceType?: Maybe<InvoiceDocumentGenerationType>;
  /** Invoice line details */
  lines: Array<InvoiceDocumentLineInfo>;
  /** Invoice number printed on the doc */
  number: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Invoice related references. */
  references: InvoiceDocumentReferenceInfo;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Total amount due in US Dollars. */
  total: Cost;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The type of invoice being generated */
export enum InvoiceDocumentGenerationType {
  AMAZON_GLOBAL_LOGISTICS_INVOICE = 'AMAZON_GLOBAL_LOGISTICS_INVOICE',
  BROKER_BILLING_PARTY_INVOICE = 'BROKER_BILLING_PARTY_INVOICE',
  EXTERNAL_INVOICE = 'EXTERNAL_INVOICE',
  REQUEST_FOR_PAYMENT = 'REQUEST_FOR_PAYMENT'
}

export type InvoiceDocumentLineInfo = {
  __typename?: 'InvoiceDocumentLineInfo';
  /** Amount to charge. */
  amount: Cost;
  /** Type of charge. */
  type: Scalars['String'];
};

export type InvoiceDocumentLineInfoInput = {
  /** Amount to charge. */
  amount: CostInput;
  /** Type of charge. */
  type: Scalars['String'];
};

export type InvoiceDocumentReferenceInfo = {
  __typename?: 'InvoiceDocumentReferenceInfo';
  /** User who created shipment in the CBMS system */
  createdBy?: Maybe<Scalars['String']>;
  /** Invoice link on UI. */
  invoiceUrl?: Maybe<Scalars['String']>;
  /** IOR name associated with the invoice */
  iorName?: Maybe<Scalars['String']>;
  /** List of numbers used to refer to a shipment, customs declartion, or other work order. */
  referenceNumbers?: Maybe<Array<ReferenceNumber>>;
  /** The shipment's voyage, flight, or trip number associated with the invoice. */
  tripNumber?: Maybe<Scalars['String']>;
  /** A unique ID assigned to EU/UK entities for paying value added tax (VAT) to the government */
  vatNumber?: Maybe<Scalars['ID']>;
  /** The name of the vessel associated with the invoice. */
  vesselName?: Maybe<Scalars['String']>;
};

export type InvoiceDocumentReferenceInfoInput = {
  /** User who created shipment in the CBMS system */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Invoice link on UI. */
  invoiceUrl?: InputMaybe<Scalars['String']>;
  /** IOR name associated with the invoice */
  iorName?: InputMaybe<Scalars['String']>;
  /** List of numbers used to refer to a shipment, customs declartion, or other work order. */
  referenceNumbers?: InputMaybe<Array<ReferenceNumberInput>>;
  /** The shipment's voyage, flight, or trip number associated with the invoice. */
  tripNumber?: InputMaybe<Scalars['String']>;
  /** A unique ID assigned to EU/UK entities for paying value added tax (VAT) to the government */
  vatNumber?: InputMaybe<Scalars['ID']>;
  /** The name of the vessel associated with the invoice. */
  vesselName?: InputMaybe<Scalars['String']>;
};

export type InvoiceEdge = ConnectionEdge & {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['ID'];
  node: Invoice;
};

export type InvoiceFeeDetails = {
  __typename?: 'InvoiceFeeDetails';
  /** Charge code for the invoice fee. */
  type: ChargeCode;
  /** Cost amount. */
  value: Cost;
};

export type InvoiceFeeDetailsInput = {
  /** Charge code for the invoice fee. */
  type: ChargeCode;
  /** Cost amount. */
  value: CostInput;
};

export type InvoiceLine = EmbeddedRecord & {
  __typename?: 'InvoiceLine';
  /** Charge amount */
  amount: Cost;
  /** Information relating to the creation of the Embedded Record */
  created: RecordAction;
  /** Unique ID */
  id: Scalars['ID'];
  /** Amount to be reimbursed */
  reimburseAmount?: Maybe<Cost>;
  /** Reimbursed time */
  reimbursedTime?: Maybe<Scalars['DateTime']>;
  /** Tags for the invoice line */
  tags?: Maybe<Array<Tag>>;
  /** Invoice charge code for the line */
  type: ChargeCode;
  /** Information relating to the last update of the Embedded Record */
  updated: RecordAction;
  /** The work order details associated with Invoice line if invoice type is work order group */
  workOrder?: Maybe<WorkOrder>;
};

export type InvoiceLineInput = {
  /** Charge amount */
  amount: CostInput;
  /** Invoice line id associate with invoice line. */
  id?: InputMaybe<Scalars['ID']>;
  /** Amount to be reimbursed */
  reimburseAmount?: InputMaybe<CostInput>;
  /** Reimbursed time */
  reimbursedTime?: InputMaybe<Scalars['DateTime']>;
  /** Tags for the invoice line */
  tags?: InputMaybe<Array<TagInput>>;
  /** Invoice charge code for the line */
  type: ChargeCode;
  /** The work order details associated with Invoice line if invoice type is work order group */
  workOrder?: InputMaybe<IdInput>;
};

/** The invoice lines request to generate a Invoice. */
export type InvoiceLinesRequest = Record & {
  __typename?: 'InvoiceLinesRequest';
  /** Accounting type of the Invoice Lines Request */
  accountingType?: Maybe<AccountingType>;
  /** Status of the Accounts Payable (AP) associated with the Invoice Lines Request */
  accountsPayableStatus?: Maybe<AccountsPayableStatus>;
  /** The party details used for subscription invoice line request. */
  billToParty?: Maybe<BillingParty>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the InvoiceLinesRequest. */
  documents?: Maybe<Array<Document>>;
  /** An optional dueDate that will be used rather than the default configuration */
  dueDate?: Maybe<Scalars['Date']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** External references associated with the claim */
  externalReference?: Maybe<ExternalFinanceReference>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Flag to determine if invoice is ready to generate. */
  invoiceImmediately?: Maybe<Scalars['Boolean']>;
  /** Lines that need to add to the invoice. */
  lines?: Maybe<Array<InvoiceRequestLine>>;
  /** The operation to apply (e.g. amend) on lines of the InvoiceLinesRequest for an invoice. */
  operation?: Maybe<InvoiceLinesRequestOperation>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: Maybe<Scalars['SCACCode']>;
  /** InvoiceLinesRequest review status */
  reviewStatus?: Maybe<ReviewStatus>;
  /** Service types of the Invoice Lines Request */
  serviceTypes?: Maybe<Array<ServiceType>>;
  /** Source of the Invoice Lines Request */
  source?: Maybe<InvoiceLinesRequestSource>;
  /** Status of the Invoice Lines Request */
  status?: Maybe<InvoiceLinesRequestStatus>;
  /** Status reason for review status */
  statusReason?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The type of invoice line request. */
  type: InvoiceType;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The work order details associated with invoice line request.  */
  workOrder?: Maybe<WorkOrder>;
};

/** The operation to apply (e.g. amend) on lines of the InvoiceLinesRequest for an invoice. */
export enum InvoiceLinesRequestOperation {
  AMEND = 'AMEND'
}

export type InvoiceLinesRequestReviewStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ReviewStatus>>;
};

export type InvoiceLinesRequestSearchCriteriaInput = {
  /** Accounting type of the Invoice Lines Request */
  accountingType?: InputMaybe<AccoutingTypeSearchCriteriaInput>;
  /** Status of the Payment Manifest associated with the Invoice Lines Request */
  accountsPayableStatus?: InputMaybe<AccountsPayableStatusSearchCriteriaInput>;
  /** The charge code associated with the invoice lines request */
  chargeCode?: InputMaybe<ChargeCodeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** External reference associated with invoice lines request */
  externalReferenceId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Review status of the invoice lines request */
  reviewStatus?: InputMaybe<InvoiceLinesRequestReviewStatusSearchCriteriaInput>;
  /** Service type of the Invoice Lines Request */
  serviceType?: InputMaybe<ServiceTypeSearchCriteriaInput>;
  /** Source of the invoice lines request */
  source?: InputMaybe<InvoiceLinesRequestSourceSearchCriteriaInput>;
  /** Status of the invoice lines request */
  status?: InputMaybe<InvoiceLinesRequestStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Work order group id associated with invoice lines request. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Work order id associated with invoice lines request. */
  workOrderId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Source of InvoiceLinesRequest */
export enum InvoiceLinesRequestSource {
  PAYMENT_AUTHORIZED = 'PAYMENT_AUTHORIZED'
}

export type InvoiceLinesRequestSourceSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<InvoiceLinesRequestSource>>;
};

/** InvoiceLinesRequest status */
export enum InvoiceLinesRequestStatus {
  OBSOLETE = 'OBSOLETE',
  PROCESSING = 'PROCESSING',
  READY = 'READY'
}

export type InvoiceLinesRequestStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<InvoiceLinesRequestStatus>>;
};

/** The primary entity used to represent a Invoice Payment. */
export type InvoicePayment = Record & {
  __typename?: 'InvoicePayment';
  /** Accounting System details */
  accountingSystemDetail?: Maybe<AccountingSystemDetail>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Billing party details of customer. */
  customer: BillingParty;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Invoice paid time */
  paidTime?: Maybe<Scalars['DateTime']>;
  /** Payment method */
  paymentMethod?: Maybe<PaymentMethod>;
  /** The reference number for the payment received. For example, Check # for a check. */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Indicates the total amount of the payment. This includes the total of all the transactions. */
  totalAmount?: Maybe<Cost>;
  /** The individual payment line on the invoice payment */
  transactions?: Maybe<Array<InvoicePaymentTransaction>>;
  /** Indicates the amount that has not been applied to pay amounts owed for sales transactions. This amount is total payment amount - the sum of applied payments. The unapplied amount can be applied for future invoices which belongs to the same customer. */
  unappliedAmount?: Maybe<Cost>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type InvoicePaymentEdge = ConnectionEdge & {
  __typename?: 'InvoicePaymentEdge';
  cursor: Scalars['ID'];
  node: InvoicePayment;
};

export type InvoicePaymentSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The invoice id associated with invocie payment */
  invoiceId?: InputMaybe<IdSearchCriteriaInput>;
  /** The QBO payment Id */
  qboPaymentId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Invoice Payment search table row */
export type InvoicePaymentSearchTableRow = RecordSearchTableRow & {
  __typename?: 'InvoicePaymentSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The invoice id associated with invocie payment */
  invoiceId?: Maybe<Scalars['String']>;
  /** The QBO payment Id. */
  qboPaymentId?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type InvoicePaymentTransaction = {
  __typename?: 'InvoicePaymentTransaction';
  /** Payment transaction amount */
  amount: Cost;
  /** Invoice associated with this invoice payment transaction */
  invoice: Invoice;
};

export type InvoicePaymentTransactionInput = {
  /** Payment transaction amount */
  amount: CostInput;
  /** Invoice id associated with this invoice payment transaction */
  invoice: IdInput;
};

export type InvoicePaymentsConnection = Connection & {
  __typename?: 'InvoicePaymentsConnection';
  edges: Array<InvoicePaymentEdge>;
  nodes: Array<InvoicePayment>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type InvoiceRequestLine = {
  __typename?: 'InvoiceRequestLine';
  /** Charge amount */
  amount?: Maybe<Cost>;
  /** The party details used for billing the invoice request line */
  billToParty?: Maybe<BillingParty>;
  /** Tags for the invoice lines request lines */
  tags?: Maybe<Array<Tag>>;
  /** Invoice charge code for the line */
  type?: Maybe<ChargeCode>;
};

export type InvoiceRequestLineInput = {
  /** Charge amount */
  amount?: InputMaybe<CostInput>;
  /** The party details used for billing the invoice request line */
  billToParty?: InputMaybe<IdInput>;
  /** Tags for the invoice lines request lines */
  tags?: InputMaybe<Array<TagInput>>;
  /** Invoice charge code for the line */
  type?: InputMaybe<ChargeCode>;
};

export type InvoiceSearchCriteriaInput = {
  /** AR invoice id associated with invoice */
  arInvoiceId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The bill to party id of the invoice */
  billToPartyId?: InputMaybe<IdSearchCriteriaInput>;
  /** The bill to party name of the invoice */
  billToPartyName?: InputMaybe<TextSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The charge code associated with the invoice */
  chargeCode?: InputMaybe<ChargeCodeSearchCriteriaInput>;
  /** Claim id associated with invoice */
  claimId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The customer name associated with Invoice(same as shipperName) */
  customerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The due date of the invoice */
  dueTime?: InputMaybe<DateSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The forwarder id associated with Invoice */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The forwarder name associated with Invoice */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number. */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time of the invoicing */
  invoicedTime?: InputMaybe<DateSearchCriteriaInput>;
  /** The ior associated with the invoice */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number. */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The invoice number printed on the PDF */
  number?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /**  The payment method for this invoice */
  paymentMethod?: InputMaybe<PaymentMethodSearchCriteriaInput>;
  /** PO number of the work order group associated with this invoice */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** QBO id associated with invoice */
  qboId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** QBO Doc number associated with invoice */
  qboNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipment friendly id */
  shipmentFriendlyId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipper id associated with Invoice */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The shipper name associated with Invoice */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** The current status of the invoice */
  status?: InputMaybe<InvoiceStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Total amount due in US Dollars */
  total?: InputMaybe<FloatSearchCriteriaInput>;
  /** The type of invoice, eg: WorkOrderGroup */
  type?: InputMaybe<InvoiceTypeSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Work order group id associate with invoice. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Invoice search table row */
export type InvoiceSearchTableRow = RecordSearchTableRow & {
  __typename?: 'InvoiceSearchTableRow';
  /** AR invoice id associated with invoice */
  arInvoiceId?: Maybe<Scalars['String']>;
  /** The bill to party name of the invoice */
  billToPartyId?: Maybe<Scalars['ID']>;
  /** The bill to party name of the invoice */
  billToPartyName?: Maybe<Scalars['String']>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The charge code associated with the invoice */
  chargeCode?: Maybe<Array<ChargeCode>>;
  /** Claim id associated with invoice */
  claimId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The customer name associated with Invoice(same as shipperName) */
  customerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The due date of the invoice */
  dueTime?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The forwarder names associated with Invoice */
  forwarderId?: Maybe<Array<Scalars['ID']>>;
  /** The forwarder names associated with Invoice */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** House bill of lading number. */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time of the invoicing */
  invoicedTime?: Maybe<Scalars['String']>;
  /** The importer associated with the invoice */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<Array<LoadType>>;
  /** Master bill of lading number. */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The invoice number printed on the PDF */
  number?: Maybe<Scalars['String']>;
  /** The payment method for this invoice */
  paymentMethod?: Maybe<Scalars['String']>;
  /** PO number of the work order group associated with this invoice */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** QBO id associated with invoice */
  qboId?: Maybe<Scalars['String']>;
  /** QBO Doc number associated with invoice */
  qboNumber?: Maybe<Scalars['String']>;
  /** Shipment friendly id */
  shipmentFriendlyId?: Maybe<Scalars['String']>;
  /** The shipper id associated with Invoice */
  shipperId?: Maybe<Scalars['ID']>;
  /** The shipper name associated with Invoice */
  shipperName?: Maybe<Scalars['String']>;
  /** The current status of the invoice */
  status?: Maybe<Scalars['String']>;
  /** Total amount due in US Dollars */
  total?: Maybe<Scalars['Float']>;
  /** The type of invoice, eg: WorkOrderGroup */
  type?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** Work order group id associate with invoice. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

/** Invoice Status */
export enum InvoiceStatus {
  AWAITING_CREATE = 'AWAITING_CREATE',
  CREDITED = 'CREDITED',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PENDING_VOID = 'PENDING_VOID',
  PROCESSING = 'PROCESSING',
  UNPAID = 'UNPAID',
  UPCOMING = 'UPCOMING',
  VOID = 'VOID'
}

export type InvoiceStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<InvoiceStatus>>;
};

/** Invoice Type */
export enum InvoiceType {
  JURY_PAYMENT = 'JURY_PAYMENT',
  SUB = 'SUB',
  WORK_ORDER_GROUP = 'WORK_ORDER_GROUP'
}

export type InvoiceTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<InvoiceType>>;
};

export type InvoicesConnection = Connection & {
  __typename?: 'InvoicesConnection';
  edges: Array<InvoiceEdge>;
  nodes: Array<Invoice>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type Ior = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Isf Type */
export enum IsfType {
  ISF_5 = 'ISF_5',
  ISF_10 = 'ISF_10'
}

export type ItemClassificationInput = {
  apiArgs: Scalars['JSONObject'];
  apiName: ItemClassificationOperation;
};

/** Supported operations for the Item Classification service */
export enum ItemClassificationOperation {
  CreateClassificationRequest = 'CreateClassificationRequest',
  GetClassificationRequest = 'GetClassificationRequest',
  ListClassificationRequests = 'ListClassificationRequests',
  SubmitClassificationAnswers = 'SubmitClassificationAnswers',
  SubmitClassificationFeedback = 'SubmitClassificationFeedback'
}

export type ItemClassificationPayload = {
  __typename?: 'ItemClassificationPayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSONObject']>;
};

/** Individual item identifier from PG07 record (Model/Serial/Registered/Alternate) */
export type ItemIdentifier = {
  __typename?: 'ItemIdentifier';
  /** Item identifier number (max 17 chars) */
  number: Scalars['String'];
  /** Type of identifier (MN, SE, RN, or ALT) */
  type: ItemIdentifierType;
};

/** Individual item identifier from PG07 record (Model/Serial/Registered/Alternate) */
export type ItemIdentifierInput = {
  /** Item identifier number (max 17 chars) */
  number: Scalars['String'];
  /** Type of identifier (MN, SE, RN, or ALT) */
  type: ItemIdentifierType;
};

/** CPSC item identifier type for PG07 record */
export enum ItemIdentifierType {
  /** Alternate Identifier - A unique identifier not matching other categories */
  ALT = 'ALT',
  /** Model Number - The model number of the product */
  MN = 'MN',
  /** Registered Number */
  RN = 'RN',
  /** Serial Number - Identification number distinguishing this specific item */
  SE = 'SE'
}

/** The unique identity for the item. Used by: APHIS */
export type ItemIdentity = {
  __typename?: 'ItemIdentity';
  /** The qualifier indicates the type of number that is used to identify the item. Used by: APHIS */
  qualifierCode?: Maybe<Scalars['String']>;
  /** The unique identity value for the item. Used by: APHIS */
  value?: Maybe<Scalars['String']>;
};

/** The unique identity for the item. Used by: APHIS */
export type ItemIdentityInput = {
  /** The qualifier indicates the type of number that is used to identify the item. Used by: APHIS */
  qualifierCode?: InputMaybe<Scalars['String']>;
  /** The unique identity value for the item. Used by: APHIS */
  value?: InputMaybe<Scalars['String']>;
};

export type KeywordSearchCriteriaInput = {
  /** The operator applied for the given values. Defaults to equals. */
  operator?: InputMaybe<KeywordSearchOperator>;
  /** The values of the keyword search criteria. Required for operators with the exception of the "Exist" type operators. Value of length 1 is required for "Equals" type operators. */
  values?: InputMaybe<Array<Scalars['String']>>;
};

/** Operators used for keyword based search operations. */
export enum KeywordSearchOperator {
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  EQUALS = 'EQUALS',
  EXISTS = 'EXISTS',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_ONE_OF = 'NOT_ONE_OF',
  ONE_OF = 'ONE_OF'
}

/** Lab testing date information */
export type LabTestingInfo = {
  __typename?: 'LabTestingInfo';
  /** Laboratory testing date. For multiple labs, use the latest test date */
  testDate: Scalars['DateTime__patched_over_by_INLT'];
};

/** Lab testing date information */
export type LabTestingInfoInput = {
  /** Laboratory testing date. For multiple labs, use the latest test date */
  testDate: Scalars['DateTime__patched_over_by_INLT'];
};

export type LinkActionPayload = {
  __typename?: 'LinkActionPayload';
  /** The message explaining more information about the result */
  message?: Maybe<Scalars['String']>;
  /** Link action type */
  type: LinkActions;
};

/** Link action types. */
export enum LinkActions {
  CONFIRM_ENTRY = 'CONFIRM_ENTRY'
}

export type LinkForwarderToIorInput = {
  /** Whether to generate a master power of attorney. This will override the poaMethod provided */
  generateMasterPoa?: InputMaybe<Scalars['Boolean']>;
  /** The poaMethod to generate. Must be provided */
  poaMethod?: InputMaybe<POAMethod>;
  /** The Importer of Record that needs to be terminated (if there is one). The most common use case is if a new Importer of Record with the same IOR number of an existing activated Importer of Record has been created so we need to terminate this new one. */
  terminateIorId?: InputMaybe<Scalars['String']>;
};

export type LinkForwarderToIorPayload = {
  __typename?: 'LinkForwarderToIorPayload';
  /** Whether the forwarder was linked to the Importer of Record */
  linked: Scalars['Boolean'];
  /** The Template Document Sign Request (if one was created) */
  templateDocumentSignRequest?: Maybe<TemplateDocumentSignRequest>;
};

/** Live Animal Tag Range. Used by APHIS. */
export type LiveAnimalTagRange = {
  __typename?: 'LiveAnimalTagRange';
  endTag: Scalars['String'];
  startTag: Scalars['String'];
};

/** Live Animal Tag Range. Used by APHIS. */
export type LiveAnimalTagRangeInput = {
  endTag: Scalars['String'];
  startTag: Scalars['String'];
};

/** The Load Type e.g. FCL, LCL */
export enum LoadType {
  AIR_FREIGHT = 'AIR_FREIGHT',
  FCL = 'FCL',
  FTL = 'FTL',
  LCL = 'LCL',
  LTL = 'LTL',
  PALLET = 'PALLET',
  SMALL_PARCEL = 'SMALL_PARCEL'
}

export type LoadTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<LoadType>>;
};

/** Enum for Locale. */
export enum Locale {
  EN_US = 'EN_US'
}

/** Represents the Product Detail in a particular locale.  */
export type LocalizedProductDetail = {
  __typename?: 'LocalizedProductDetail';
  /** Product description. */
  description?: Maybe<Scalars['String']>;
  /** Locale used to describe the product. Defaults to EN_US */
  locale?: Maybe<Locale>;
  /** Product display name. */
  name?: Maybe<Scalars['String']>;
};

/** Represents the Product Detail in a particular locale.  */
export type LocalizedProductDetailInput = {
  /** Product description. */
  description?: InputMaybe<Scalars['String']>;
  /** Locale used to describe the product. Defaults to EN_US */
  locale?: InputMaybe<Locale>;
  /** Product display name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Logical Operator */
export enum LogicalOperator {
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_EQUALS = 'GREATER_THAN_EQUALS',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUALS = 'LESS_THAN_EQUALS'
}

export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** Hash used for intercom */
  intercomHash?: Maybe<Scalars['String']>;
  /** The logged in User. */
  user: User;
};

/** Lot identification and production date information */
export type LotInformation = {
  __typename?: 'LotInformation';
  /** Lot number assigned to the product. Mandatory when lotNumberAssigner is provided */
  lotNumber?: Maybe<Scalars['String']>;
  /** Entity that assigned the lot number (manufacturer or seller) */
  lotNumberAssigner?: Maybe<LotNumberAssigner>;
  /** Date when production for the lot ended */
  productionEndDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Date when production for the lot started */
  productionStartDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
};

/** Lot identification and production date information */
export type LotInformationInput = {
  /** Lot number assigned to the product. Mandatory when lotNumberAssigner is provided */
  lotNumber?: InputMaybe<Scalars['String']>;
  /** Entity that assigned the lot number (manufacturer or seller) */
  lotNumberAssigner?: InputMaybe<LotNumberAssigner>;
  /** Date when production for the lot ended */
  productionEndDate?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Date when production for the lot started */
  productionStartDate?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
};

/** Entity that assigned the lot number */
export enum LotNumberAssigner {
  /** Lot number assigned by manufacturer */
  MANUFACTURER = 'MANUFACTURER',
  /** Lot number assigned by seller */
  SELLER = 'SELLER'
}

/** Represents Licenses, Permits, Certificates or Other (LPCO) issued by PGA and other government entities. */
export type Lpco = {
  __typename?: 'Lpco';
  /** Identifies the location of the issuer of the LPCO. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** Identifies the date of the LPCO in MMDDCCYY (month, day, century, year) format. This date is either an expiration date, effective date, date issued or signed, or date application received. */
  date?: Maybe<Scalars['DateTime']>;
  /** Indicates the reason for exemption from LPCO. See Appendix PGA for valid codes. */
  exemptionCode?: Maybe<LpcoExemptionCode>;
  /** Identifies the entity that issued the LPCO. */
  issuer?: Maybe<Scalars['String']>;
  /** Identifies the foreign country location of the foreign government issuer of the LPCO. */
  issuerLocation?: Maybe<Scalars['CountryCode']>;
  /** Identifies the number assigned to the LPCO. */
  number?: Maybe<Scalars['String']>;
  /** Identifies the quantity from the LPCO. Four decimal places are implied. */
  quantity?: Maybe<Scalars['Float']>;
  /** Free form regional description of the location within a country, of the agency issuing the LPCO. */
  regionDescription?: Maybe<Scalars['String']>;
  /** Unit Of Measure, associated with quantity. */
  uomCode?: Maybe<Scalars['String']>;
};

export enum LpcoExemptionCode {
  TTBEX1 = 'TTBEX1',
  TTBEX2 = 'TTBEX2',
  TTBEX3 = 'TTBEX3',
  TTBEX4 = 'TTBEX4',
  TTBEX5 = 'TTBEX5',
  TTBEX6 = 'TTBEX6',
  TTBEX7 = 'TTBEX7',
  TTBEX8 = 'TTBEX8',
  TTBEX9 = 'TTBEX9',
  TTBEX10 = 'TTBEX10',
  TTBEX11 = 'TTBEX11',
  TTBEX12 = 'TTBEX12',
  TTBEX13 = 'TTBEX13',
  TTBEX14 = 'TTBEX14',
  TTBEX15 = 'TTBEX15'
}

/** Represents Licenses, Permits, Certificates or Other (LPCO) issued by PGA and other government entities. */
export type LpcoInput = {
  /** Identifies the location of the issuer of the LPCO. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Identifies the date of the LPCO in MMDDCCYY (month, day, century, year) format. This date is either an expiration date, effective date, date issued or signed, or date application received. */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Indicates the reason for exemption from LPCO. See Appendix PGA for valid codes. */
  exemptionCode?: InputMaybe<LpcoExemptionCode>;
  /** Identifies the entity that issued the LPCO. */
  issuer?: InputMaybe<Scalars['String']>;
  /** Identifies the foreign country location of the foreign government issuer of the LPCO. */
  issuerLocation?: InputMaybe<Scalars['CountryCode']>;
  /** Identifies the number assigned to the LPCO. */
  number?: InputMaybe<Scalars['String']>;
  /** Identifies the quantity from the LPCO. Four decimal places are implied. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** Free form regional description of the location within a country, of the agency issuing the LPCO. */
  regionDescription?: InputMaybe<Scalars['String']>;
  /** Unit Of Measure, associated with quantity. */
  uomCode?: InputMaybe<Scalars['String']>;
};

export type MailingAddress = {
  __typename?: 'MailingAddress';
  AddressLine1?: Maybe<Scalars['String']>;
  AddressLine2?: Maybe<Scalars['String']>;
  AddressLine3?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  CompanyName?: Maybe<Scalars['String']>;
  CountryCode?: Maybe<Scalars['String']>;
  County?: Maybe<Scalars['String']>;
  District?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  StateOrRegion?: Maybe<Scalars['String']>;
};

export type MarkWorkOrderTaskStepCompletePayload = {
  __typename?: 'MarkWorkOrderTaskStepCompletePayload';
  /** The updated Work Order Task */
  workOrderTask: WorkOrderTask;
};

export type MarkWorkOrderTaskStepIncompletePayload = {
  __typename?: 'MarkWorkOrderTaskStepIncompletePayload';
  /** The updated Work Order Task */
  workOrderTask: WorkOrderTask;
};

export type MasterBill = {
  __typename?: 'MasterBill';
  /** House bills */
  houseBills?: Maybe<Array<HouseBill>>;
  /** Masterbill number */
  number?: Maybe<Scalars['String']>;
};

export type MasterBillInput = {
  /** House bills */
  houseBills?: InputMaybe<Array<HouseBillInput>>;
  /** Masterbill number */
  number?: InputMaybe<Scalars['String']>;
};

export type MatchingAttributes = {
  __typename?: 'MatchingAttributes';
  /** Case initiator team business area */
  caseInitiatorTeamBusinessArea?: Maybe<Scalars['String']>;
  /** Destination country codes */
  destinationCountry?: Maybe<Array<Scalars['String']>>;
  /** Forwarder reference */
  forwarder?: Maybe<Forwarder>;
  /** If true, this config matches when there is no shipment data (no work order) */
  isFallback?: Maybe<Scalars['Boolean']>;
  /** Milestone settings for assignment rule matching */
  milestoneConfig?: Maybe<MilestoneMatching>;
};

export type MatchingAttributesInput = {
  /** Case initiator team business area */
  caseInitiatorTeamBusinessArea?: InputMaybe<Scalars['String']>;
  /** Destination country codes */
  destinationCountry?: InputMaybe<Array<Scalars['String']>>;
  /** Forwarder reference */
  forwarder?: InputMaybe<IdInput>;
  /** If true, this config matches when there is no shipment data (no work order) */
  isFallback?: InputMaybe<Scalars['Boolean']>;
  /** Milestone settings for assignment rule matching */
  milestoneConfig?: InputMaybe<MilestoneMatchingInput>;
};

/** The type of the static mapping */
export enum MemberAssignedToType {
  XBT_SHIPPER_ID = 'XBT_SHIPPER_ID'
}

export type MemberAssignedToTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<MemberAssignedToType>>;
};

/** A written message about a record. */
export type Memo = Record & {
  __typename?: 'Memo';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Indicates if the memo should be visible to other parties. If isPublic is not true (by default), then only users with the same Account (forwarder/operator/shipper) can see it. Otherwise, both customers and operators can see the memo. */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The text contained within the memo. */
  text: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type MemoEdge = ConnectionEdge & {
  __typename?: 'MemoEdge';
  cursor: Scalars['ID'];
  node: Memo;
};

/** Primary class used to represent a memo search input */
export type MemoSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Primary class used to represent a memo table search input */
export type MemoSearchTableRow = {
  __typename?: 'MemoSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type MemosConnection = Connection & {
  __typename?: 'MemosConnection';
  edges: Array<MemoEdge>;
  nodes: Array<Memo>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type MerchantMarketplace = {
  __typename?: 'MerchantMarketplace';
  encryptedMarketplaceId: Scalars['String'];
  encryptedMerchantId: Scalars['String'];
};

export enum MessagingPartner {
  AMZN = 'AMZN',
  CHAIN_IO = 'CHAIN_IO',
  DGIE = 'DGIE',
  E2_OPEN = 'E2_OPEN',
  EMAIL = 'EMAIL',
  GTN_NEXUS = 'GTN_NEXUS',
  HMRC = 'HMRC',
  INLT = 'INLT',
  IRIS = 'IRIS',
  MAEU = 'MAEU',
  OPS_INBOX = 'OPS_INBOX',
  US_CBP = 'US_CBP'
}

export type MessagingPartnerSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<MessagingPartner>>;
};

export type MigrateUserPayload = {
  __typename?: 'MigrateUserPayload';
  /** Status of the migration */
  success: Scalars['Boolean'];
  /** Status of the migration */
  user: User;
};

export type Milestone = {
  /** An event code representing the milestone. */
  codes: Array<MilestoneEventCode>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The location where the milestone occured. */
  location?: Maybe<MilestoneLocation>;
  /** The real time the milestone occured, possibly before its creation in the system. Defaults to the time of creation. */
  occurenceTime: Scalars['PreciseDateTime'];
  /** A number used to refer to a shipment, customs declartion, or other work order. */
  referenceNumbers: Array<ReferenceNumber>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** An event code representing the milestone. */
export type MilestoneEventCode = {
  __typename?: 'MilestoneEventCode';
  /** The type of the event code. */
  type: MilestoneEventCodeType;
  /** The value of the event code. */
  value: Scalars['String'];
};

/** The type of event code. */
export enum MilestoneEventCodeType {
  AMAZON_SHIP_TRACK = 'AMAZON_SHIP_TRACK'
}

/** The location where the milestone occured. */
export type MilestoneLocation = {
  __typename?: 'MilestoneLocation';
  /** The address of the location. */
  address?: Maybe<Address>;
};

/** The location where the milestone occured. */
export type MilestoneLocationInput = {
  /** The address of the location. */
  address?: InputMaybe<AddressInput>;
};

export type MilestoneMatching = {
  __typename?: 'MilestoneMatching';
  /** Operator for checking milestones */
  milestoneOperator: KeywordSearchOperator;
  /** Milestones used in matching attributes */
  milestones: Array<WorkOrderMilestoneName>;
};

export type MilestoneMatchingInput = {
  /** Operator for checking milestones */
  milestoneOperator: KeywordSearchOperator;
  /** Milestones used in matching attributes */
  milestones: Array<WorkOrderMilestoneName>;
};

/** Minimum Skill Level of Operator required to complete the task. */
export type MinimumSkillRequiredSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<SkillLevel>>;
};

/** Mode of transportation */
export enum ModeOfTransport {
  AIR = 'AIR',
  OCEAN = 'OCEAN',
  RAIL = 'RAIL',
  TRUCK = 'TRUCK'
}

export type ModeOfTransportSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ModeOfTransport>>;
};

/** A work order task step to mark as complete or incomplete. */
export type ModifiedWorkOrderTaskStepInput = {
  /** Indicates if the work order task step should be marked as complete or incomplete. */
  isCompleted: Scalars['Boolean'];
  /** Work order task step ID. */
  stepId: Scalars['ID'];
};

export type ModifyWorkOrderTaskStepsCompletionPayload = {
  __typename?: 'ModifyWorkOrderTaskStepsCompletionPayload';
  /** The updated Work Order Task */
  workOrderTask: WorkOrderTask;
};

/** Indicates the mutable status of the document preview generation. */
export enum MutableDocumentPreviewStatus {
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export type MutateActionInBondCbpTransaction = ActionInBondCbpTransaction;

export type MutateCbpDrawbackClaimTransaction = CreateUsDrawbackClaimCbpTransaction | UpdateUsDrawbackClaimCbpTransaction;

export type MutateCbpEntryPgaTransaction = UpdateUsConsumptionEntryPgaCbpTransaction | UpdateUsType86EntryPgaCbpTransaction;

export type MutateCbpEntryReleaseTransaction = CreateUsConsumptionEntryReleaseCbpTransaction | DeleteUsConsumptionEntryReleaseCbpTransaction | ReplaceUsConsumptionEntryReleaseCbpTransaction | UpdateUsConsumptionEntryReleaseCbpTransaction | UpsertUsConsumptionEntrySummaryCbpTransaction;

export type MutateCbpEntrySummaryTransaction = DeleteUsConsumptionEntrySummaryCbpTransaction | UpsertUsConsumptionEntrySummaryCbpTransaction | UpsertUsPostSummaryCorrectionCbpTransaction;

export type MutateCbpIsfTransaction = CreateUsIsfCbpTransaction | DeleteUsIsfCbpTransaction | UpdateUsIsfCbpTransaction;

export type MutateInBondCbpTransaction = DeleteInBondBillCbpTransaction | DeleteInBondCbpTransaction | SubmitInBondCbpTransaction;

export type MutateUsType86EntryCbpReleaseTransaction = CreateUsType86EntryReleaseCbpTransaction | DeleteUsType86EntryReleaseCbpTransaction | ReplaceUsType86EntryReleaseCbpTransaction | UpdateUsType86EntryReleaseCbpTransaction;

export type Mutation = {
  __typename?: 'Mutation';
  acceptImportProductsFromBulkUploadRequest: ConfirmBulkUploadPayload;
  /** TODO */
  actionInBondCbp: ActionInBondCbpPayload;
  activateUser: ActivateUserPayload;
  addPendingUpdates: AddPendingUpdatesPayload;
  assignUsInBondNumber: UsInBondPayload;
  /** TODO */
  authorizeUsCbpEntryDailyStatementDebit: AuthorizeUsCbpEntryDailyStatementDebitPayload;
  baselineOperatorUsers: BaselineOperatorUsersPayload;
  batchUpsertProducts: BatchUpsertProductsPayload;
  batchUpsertSuppliers: BatchUpsertSuppliersPayload;
  cancelShipment: CancelShipmentPayload;
  cancelShipper: CancelShipperPayload;
  cancelUsIor: CancelUsIorPayload;
  cancelUsIorContinuousBondRequestRenewal: CancelUsIorContinuousBondRequestRenewalPayload;
  cancelWorkOrder: CancelWorkOrderPayload;
  cancelWorkOrderGroup: CancelWorkOrderGroupPayload;
  cancelWorkOrderTask: CancelWorkOrderTaskPayload;
  cloneWorkOrder: CloneWorkOrderPayload;
  createAdCvdCase: CreateAdCvdCasePayload;
  /** Api to create address using address service */
  createAddress: CreateAddressPayload;
  createAssignmentTeam: CreateAssignmentTeamPayload;
  createAssignmentTeamOperatorUserRelationship: CreateAssignmentTeamOperatorUserRelationshipPayload;
  createAssignmentTeamStaticMapping: CreateAssignmentTeamStaticMappingPayload;
  createAuditLog: CreateAuditLogPayload;
  createAuthenticationToken: CreateAuthenticationTokenPayload;
  /** To create a batch of milestones for one or more workOrders */
  createBatchWorkOrderMilestones: BulkMilestonesPayload;
  createBroker: CreateBrokerPayload;
  createBulkChargesUploadRequest: CreateBulkChargesUploadRequestPayload;
  createBulkComplianceUploadRequest: CreateBulkComplianceUploadRequestPayload;
  createBulkMilestoneUploadRequest: CreateBulkMilestoneUploadRequestPayload;
  createBulkProductUploadTemplateDocumentGenerationRequest: CreateBulkProductUploadTemplateDocumentGenerationRequestPayload;
  createBusinessSupportTeam: CreateBusinessSupportTeamPayload;
  createBusinessSupportTeamOperatorUserRelationship: CreateBusinessSupportTeamOperatorUserRelationshipPayload;
  createCaseCategoryConfig: CreateCaseCategoryConfigPayload;
  createChangelog: CreateChangelogPayload;
  /** Simplified API to create charges for external systems */
  createCharges: CreateChargesPayload;
  createCommodityGroup: CreateCommodityGroupPayload;
  /** Create a presigned URL to upload/update CPSC citation codes JSON file. Restricted to operators and internal systems. */
  createCpscCitationCodesPresignedUrl: CpscCitationCodeUrlResponse;
  createCustomDomain: CreateCustomDomainPayload;
  createCustomsAgent: CreateCustomsAgentPayload;
  createCustomsDeclaration: CreateCustomsDeclarationPayload;
  /** Wrapper API for external partners to create customs declaration exchange message. */
  createCustomsMessage: CreateCustomsNotificationPayload;
  createDeConsignee: CreateDeConsigneePayload;
  createDeCustomsBroker: CreateDeCustomsBrokerPayload;
  createDeCustomsEntry: CreateDeCustomsEntryPayload;
  createDeIor: CreateDeIorPayload;
  createDeIorActivation: CreateDeIorActivationPayload;
  createDeliveryOrder: CreateDeliveryOrderPayload;
  createDeliveryOrderDocumentGenerationRequest: CreateDeliveryOrderDocumentGenerationRequestPayload;
  createDocument: CreateDocumentPayload;
  createDocumentTemplate: CreateDocumentTemplatePayload;
  createDpsRecord: CreateDpsRecordPayload;
  createErrorDefinition: CreateErrorDefinitionPayload;
  createEuHs: CreateEuHsPayload;
  createExcelTemplateDocumentGenerationRequest: CreateExcelTemplateDocumentGenerationRequestPayload;
  createExchangeMessage: CreateExchangeMessagePayload;
  createFacility: CreateFacilityPayload;
  createFeatureFlag: CreateFeatureFlagPayload;
  createForwarder: CreateForwarderPayload;
  createForwarderSystem: CreateForwarderSystemPayload;
  createForwarderUser: CreateForwarderUserPayload;
  createFrConsignee: CreateFrConsigneePayload;
  createFrCustomsBroker: CreateFrCustomsBrokerPayload;
  createFrCustomsEntry: CreateFrCustomsEntryPayload;
  createFrIor: CreateFrIorPayload;
  createFrIorActivation: CreateFrIorActivationPayload;
  createGbConsignee: CreateGbConsigneePayload;
  createGbCustomsEntry: CreateGbCustomsEntryPayload;
  createGbIor: CreateGbIorPayload;
  createGbIorActivation: CreateGbIorActivationPayload;
  createGenericDocumentGenerationRequest: CreateGenericDocumentGenerationRequestPayload;
  createGlobalConsignee: CreateGlobalConsigneePayload;
  createHtmlDocumentGenerationRequest: CreateHtmlDocumentGenerationRequestPayload;
  createHts: CreateHtsPayload;
  createImportProductsFromBulkUploadRequest: CreateImportProductsFromBulkUploadRequestPayload;
  createImportProductsFromCustomsEntriesRequest: CreateImportProductsFromCustomsEntriesRequestPayload;
  createImporter: CreateImporterPayload;
  createImporterEntity: CreateImporterEntityPayload;
  createImporterEntityActivation: CreateImporterEntityActivationPayload;
  createImporterImporterEntityRelationship: CreateImporterImporterEntityRelationshipPayload;
  createInBondNotesDocumentGenerationRequest: CreateInBondNotesDocumentGenerationRequestPayload;
  createInvitedShipper: CreateInvitedShipperPayload;
  createInvoice: CreateInvoicePayload;
  createInvoiceCreditNote: CreateInvoiceCreditNotePayload;
  createInvoiceCreditNoteDocumentGenerationRequest: CreateInvoiceCreditNoteDocumentGenerationRequestPayload;
  createInvoiceDocumentGenerationRequest: CreateInvoiceDocumentGenerationRequestPayload;
  createInvoiceLinesRequest: CreateInvoiceLinesRequestPayload;
  createInvoicePayment: CreateInvoicePaymentPayload;
  createMemo: CreateMemoPayload;
  createNlConsignee: CreateNlConsigneePayload;
  createNlCustomsBroker: CreateNlCustomsBrokerPayload;
  createNlCustomsEntry: CreateNlCustomsEntryPayload;
  createNlIor: CreateNlIorPayload;
  createNlIorActivation: CreateNlIorActivationPayload;
  createOnboardingRequest: CreateOnboardingRequestPayload;
  createOperator: CreateOperatorPayload;
  createOperatorSystem: CreateOperatorSystemPayload;
  createOperatorUser: CreateOperatorUserPayload;
  createPayableInvoice: CreatePayableInvoicePayload;
  createProcessingError: CreateProcessingErrorPayload;
  createProduct: CreateProductPayload;
  createProgram: CreateProgramPayload;
  createReleaseNote: CreateReleaseNotePayload;
  createReportReconciliationRequest: CreateReportReconciliationRequestPayload;
  createShipment: CreateShipmentPayload;
  createShipmentCommercialInvoiceDetail: CreateShipmentCommercialInvoiceDetailPayload;
  createShipmentDocumentProcessingRequest: CreateShipmentDocumentProcessingRequestPayload;
  createShipper: CreateShipperPayload;
  createShipperBrokerRelationship: CreateShipperBrokerRelationshipPayload;
  createShipperCustomsAgentRelationship: CreateShipperCustomsAgentRelationshipPayload;
  createShipperDeConsigneeRelationship: CreateShipperDeConsigneeRelationshipPayload;
  createShipperDeCustomsBrokerRelationship: CreateShipperDeCustomsBrokerRelationshipPayload;
  createShipperDeIorRelationship: CreateShipperDeIorRelationshipPayload;
  createShipperFacilityRelationship: CreateShipperFacilityRelationshipPayload;
  createShipperForwarderRelationship: CreateShipperForwarderRelationshipPayload;
  createShipperFrConsigneeRelationship: CreateShipperFrConsigneeRelationshipPayload;
  createShipperFrCustomsBrokerRelationship: CreateShipperFrCustomsBrokerRelationshipPayload;
  createShipperFrIorRelationship: CreateShipperFrIorRelationshipPayload;
  createShipperGbConsigneeRelationship: CreateShipperGbConsigneeRelationshipPayload;
  createShipperGbIorRelationship: CreateShipperGbIorRelationshipPayload;
  createShipperGlobalConsigneeRelationship: CreateShipperGlobalConsigneeRelationshipPayload;
  createShipperImporterRelationship: CreateShipperImporterRelationshipPayload;
  createShipperNlConsigneeRelationship: CreateShipperNlConsigneeRelationshipPayload;
  createShipperNlCustomsBrokerRelationship: CreateShipperNlCustomsBrokerRelationshipPayload;
  createShipperNlIorRelationship: CreateShipperNlIorRelationshipPayload;
  createShipperSupplierRelationship: CreateShipperSupplierRelationshipPayload;
  createShipperSystem: CreateShipperSystemPayload;
  createShipperTruckerRelationship: CreateShipperTruckerRelationshipPayload;
  createShipperUkCustomsBrokerRelationship: CreateShipperUkCustomsBrokerRelationshipPayload;
  createShipperUsConsigneeRelationship: CreateShipperUsConsigneeRelationshipPayload;
  createShipperUsCustomsBrokerRelationship: CreateShipperUsCustomsBrokerRelationshipPayload;
  createShipperUsIorRelationship: CreateShipperUsIorRelationshipPayload;
  createShipperUser: CreateShipperUserPayload;
  /** Api to create single-use address using address service */
  createSingleUseAddress: CreateAddressPayload;
  createStampDocumentGenerationRequest: CreateStampDocumentGenerationRequestPayload;
  createStampDocumentSignRequest: CreateStampDocumentSignRequestPayload;
  createSubjectMatterExpertTeam: CreateSubjectMatterExpertTeamPayload;
  createSubjectMatterExpertTeamOperatorUserRelationship: CreateSubjectMatterExpertTeamOperatorUserRelationshipPayload;
  createSupplier: CreateSupplierPayload;
  createTableFilter: CreateTableFilterPayload;
  createTeam: CreateTeamPayload;
  createTemplateDocumentSignRequest: CreateTemplateDocumentSignRequestPayload;
  createTradeAdvisoryRequest: CreateTradeAdvisoryRequestPayload;
  createTrucker: CreateTruckerPayload;
  createUkCustomsBroker: CreateUkCustomsBrokerPayload;
  createUkHs: CreateUkHsPayload;
  createUsCargoReleaseDocumentGenerationRequest: CreateUsCargoReleaseDocumentGenerationRequestPayload;
  createUsCbp5106DocumentGenerationRequest: CreateUsCbp5106DocumentGenerationRequestPayload;
  createUsCbp7501DocumentGenerationRequest: CreateUsCbp7501DocumentGenerationRequestPayload;
  createUsCbp7512DocumentGenerationRequest: CreateUsCbp7512DocumentGenerationRequestPayload;
  createUsConsignee: CreateUsConsigneePayload;
  /** TODO */
  createUsConsigneeCbp5106: CreateUsConsigneeCbp5106Payload;
  createUsConsumptionEntry: CreateUsConsumptionEntryPayload;
  /** TODO */
  createUsConsumptionEntryReleaseCbp: CreateUsConsumptionEntryReleaseCbpPayload;
  createUsCustomsBroker: CreateUsCustomsBrokerPayload;
  createUsDrawbackClaim: CreateUsDrawbackClaimPayload;
  /** TODO */
  createUsDrawbackClaimCbp: CreateUsDrawbackClaimCbpPayload;
  createUsDrawbackClaimDocumentGenerationRequest: CreateUsDrawbackClaimDocumentGenerationRequestPayload;
  createUsHts: CreateUsHtsPayload;
  createUsInBond: CreateUsInBondPayload;
  createUsIor: CreateUsIorPayload;
  createUsIorActivation: CreateUsIorActivationPayload;
  /** TODO */
  createUsIorCbp5106: CreateUsIorCbp5106Payload;
  createUsIorContinuousBondRequest: CreateUsIorContinuousBondRequestPayload;
  createUsIsf: CreateUsIsfPayload;
  /** TODO */
  createUsIsfCbp: CreateUsIsfCbpPayload;
  createUsPostSummaryCorrection: CreateUsPostSummaryCorrectionPayload;
  createUsPrincipalAdCvdCase: CreateUsPrincipalAdCvdCasePayload;
  createUsType86Entry: CreateUsType86EntryPayload;
  /** TODO */
  createUsType86EntryReleaseCbp: CreateUsType86EntryReleaseCbpPayload;
  createUserReleaseNoteView: CreateUserReleaseNoteViewPayload;
  createWorkOrderConfirmation: CreateWorkOrderConfirmationPayload;
  createWorkOrderDocumentProcessingRequest: CreateWorkOrderDocumentProcessingRequestPayload;
  createWorkOrderGroup: CreateWorkOrderGroupPayload;
  createWorkOrderMilestone: CreateWorkOrderMilestonePayload;
  createWorkOrderPresignedUrl: WorkOrderPresignedUrlResponse;
  createWorkOrderStateMachine: CreateWorkOrderStateMachinePayload;
  createWorkOrderTask: CreateWorkOrderTaskPayload;
  createWorkOrderTaskDefinition: CreateWorkOrderTaskDefinitionPayload;
  createWorkOrderTaskEscalationMessage: CreateWorkOrderTaskEscalationMessagePayload;
  deleteAdCvdCase: DeleteAdCvdCasePayload;
  deleteAssignmentTeam: DeleteAssignmentTeamPayload;
  deleteAssignmentTeamOperatorUserRelationship: DeleteAssignmentTeamOperatorUserRelationshipPayload;
  deleteAssignmentTeamStaticMapping: DeleteAssignmentTeamStaticMappingPayload;
  deleteAuthenticationToken: DeleteAuthenticationTokenPayload;
  deleteBroker: DeleteBrokerPayload;
  deleteBulkChargesUploadRequest: DeleteBulkChargesUploadRequestPayload;
  deleteBulkComplianceUploadRequest: DeleteBulkComplianceUploadRequestPayload;
  deleteBulkMilestoneUploadRequest: DeleteBulkMilestoneUploadRequestPayload;
  deleteBulkProductUploadTemplateDocumentGenerationRequest: DeleteBulkProductUploadTemplateDocumentGenerationRequestPayload;
  deleteBusinessSupportTeam: DeleteBusinessSupportTeamPayload;
  deleteBusinessSupportTeamOperatorUserRelationship: DeleteBusinessSupportTeamOperatorUserRelationshipPayload;
  deleteCaseCategoryConfig: DeleteCaseCategoryConfigPayload;
  deleteCommodityGroup: DeleteCommodityGroupPayload;
  deleteCustomDomain: DeleteCustomDomainPayload;
  deleteCustomsAgent: DeleteCustomsAgentPayload;
  deleteCustomsDeclaration: DeleteCustomsDeclarationPayload;
  deleteCustomsEntry: DeleteCustomsEntryPayload;
  deleteDeConsignee: DeleteDeConsigneePayload;
  deleteDeCustomsBroker: DeleteDeCustomsBrokerPayload;
  deleteDeCustomsEntry: DeleteDeCustomsEntryPayload;
  deleteDeIor: DeleteDeIorPayload;
  deleteDeIorActivation: DeleteDeIorActivationPayload;
  deleteDeliveryOrder: DeleteDeliveryOrderPayload;
  deleteDeliveryOrderDocumentGenerationRequest: DeleteDeliveryOrderDocumentGenerationRequestPayload;
  deleteDocument: DeleteDocumentPayload;
  deleteDocumentTemplate: DeleteDocumentTemplatePayload;
  deleteDpsRecord: DeleteDpsRecordPayload;
  deleteEuHs: DeleteEuHsPayload;
  deleteExcelTemplateDocumentGenerationRequest: DeleteExcelTemplateDocumentGenerationRequestPayload;
  deleteExchangeMessage: DeleteExchangeMessagePayload;
  deleteFacility: DeleteFacilityPayload;
  deleteFeatureFlag: DeleteFeatureFlagPayload;
  deleteForwarder: DeleteForwarderPayload;
  deleteForwarderSystem: DeleteForwarderSystemPayload;
  deleteForwarderUser: DeleteForwarderUserPayload;
  deleteFrConsignee: DeleteFrConsigneePayload;
  deleteFrCustomsBroker: DeleteFrCustomsBrokerPayload;
  deleteFrCustomsEntry: DeleteFrCustomsEntryPayload;
  deleteFrIor: DeleteFrIorPayload;
  deleteFrIorActivation: DeleteFrIorActivationPayload;
  deleteGbConsignee: DeleteGbConsigneePayload;
  deleteGbCustomsEntry: DeleteGbCustomsEntryPayload;
  deleteGbIor: DeleteGbIorPayload;
  deleteGbIorActivation: DeleteGbIorActivationPayload;
  deleteGenericDocumentGenerationRequest: DeleteGenericDocumentGenerationRequestPayload;
  deleteGlobalConsignee: DeleteGlobalConsigneePayload;
  deleteHtmlDocumentGenerationRequest: DeleteHtmlDocumentGenerationRequestPayload;
  deleteHts: DeleteHtsPayload;
  deleteImportProductsFromBulkUploadRequest: DeleteImportProductsFromBulkUploadRequestPayload;
  deleteImportProductsFromCustomsEntriesRequest: DeleteImportProductsFromCustomsEntriesRequestPayload;
  deleteImporter: DeleteImporterPayload;
  deleteImporterEntity: DeleteImporterEntityPayload;
  deleteImporterEntityActivation: DeleteImporterEntityActivationPayload;
  deleteImporterImporterEntityRelationship: DeleteImporterImporterEntityRelationshipPayload;
  /** TODO */
  deleteInBondBillCbp: DeleteInBondBillCbpPayload;
  /** TODO */
  deleteInBondCbp: DeleteInBondCbpPayload;
  deleteInBondNotesDocumentGenerationRequest: DeleteInBondNotesDocumentGenerationRequestPayload;
  deleteInvoice: DeleteInvoicePayload;
  deleteInvoiceCreditNote: DeleteInvoiceCreditNotePayload;
  deleteInvoiceCreditNoteDocumentGenerationRequest: DeleteInvoiceCreditNoteDocumentGenerationRequestPayload;
  deleteInvoiceDocumentGenerationRequest: DeleteInvoiceDocumentGenerationRequestPayload;
  deleteInvoiceLinesRequest: DeleteInvoiceLinesRequestPayload;
  deleteInvoicePayment: DeleteInvoicePaymentPayload;
  deleteMemo: DeleteMemoPayload;
  deleteNlConsignee: DeleteNlConsigneePayload;
  deleteNlCustomsBroker: DeleteNlCustomsBrokerPayload;
  deleteNlCustomsEntry: DeleteNlCustomsEntryPayload;
  deleteNlIor: DeleteNlIorPayload;
  deleteNlIorActivation: DeleteNlIorActivationPayload;
  deleteOnboardingRequest: DeleteOnboardingRequestPayload;
  deleteOperator: DeleteOperatorPayload;
  deleteOperatorSystem: DeleteOperatorSystemPayload;
  deleteOperatorUser: DeleteOperatorUserPayload;
  deletePayableInvoice: DeletePayableInvoicePayload;
  deleteProduct: DeleteProductPayload;
  deleteReleaseNote: DeleteReleaseNotePayload;
  deleteReportReconciliationRequest: DeleteReportReconciliationRequestPayload;
  deleteShipment: DeleteShipmentPayload;
  deleteShipmentCommercialInvoiceDetail: DeleteShipmentCommercialInvoiceDetailPayload;
  deleteShipmentDocumentProcessingRequest: DeleteShipmentDocumentProcessingRequestPayload;
  deleteShipper: DeleteShipperPayload;
  deleteShipperBrokerRelationship: DeleteShipperBrokerRelationshipPayload;
  deleteShipperCustomsAgentRelationship: DeleteShipperCustomsAgentRelationshipPayload;
  deleteShipperDeConsigneeRelationship: DeleteShipperDeConsigneeRelationshipPayload;
  deleteShipperDeCustomsBrokerRelationship: DeleteShipperDeCustomsBrokerRelationshipPayload;
  deleteShipperDeIorRelationship: DeleteShipperDeIorRelationshipPayload;
  deleteShipperFacilityRelationship: DeleteShipperFacilityRelationshipPayload;
  deleteShipperForwarderRelationship: DeleteShipperForwarderRelationshipPayload;
  deleteShipperFrConsigneeRelationship: DeleteShipperFrConsigneeRelationshipPayload;
  deleteShipperFrCustomsBrokerRelationship: DeleteShipperFrCustomsBrokerRelationshipPayload;
  deleteShipperFrIorRelationship: DeleteShipperFrIorRelationshipPayload;
  deleteShipperGbConsigneeRelationship: DeleteShipperGbConsigneeRelationshipPayload;
  deleteShipperGbIorRelationship: DeleteShipperGbIorRelationshipPayload;
  deleteShipperGlobalConsigneeRelationship: DeleteShipperGlobalConsigneeRelationshipPayload;
  deleteShipperImporterRelationship: DeleteShipperImporterRelationshipPayload;
  deleteShipperNlConsigneeRelationship: DeleteShipperNlConsigneeRelationshipPayload;
  deleteShipperNlCustomsBrokerRelationship: DeleteShipperNlCustomsBrokerRelationshipPayload;
  deleteShipperNlIorRelationship: DeleteShipperNlIorRelationshipPayload;
  deleteShipperSupplierRelationship: DeleteShipperSupplierRelationshipPayload;
  deleteShipperSystem: DeleteShipperSystemPayload;
  deleteShipperTruckerRelationship: DeleteShipperTruckerRelationshipPayload;
  deleteShipperUkCustomsBrokerRelationship: DeleteShipperUkCustomsBrokerRelationshipPayload;
  deleteShipperUsConsigneeRelationship: DeleteShipperUsConsigneeRelationshipPayload;
  deleteShipperUsCustomsBrokerRelationship: DeleteShipperUsCustomsBrokerRelationshipPayload;
  deleteShipperUsIorRelationship: DeleteShipperUsIorRelationshipPayload;
  deleteShipperUser: DeleteShipperUserPayload;
  deleteStampDocumentGenerationRequest: DeleteStampDocumentGenerationRequestPayload;
  deleteStampDocumentSignRequest: DeleteStampDocumentSignRequestPayload;
  deleteSubjectMatterExpertTeam: DeleteSubjectMatterExpertTeamPayload;
  deleteSubjectMatterExpertTeamOperatorUserRelationship: DeleteSubjectMatterExpertTeamOperatorUserRelationshipPayload;
  deleteSupplier: DeleteSupplierPayload;
  deleteTableFilter: DeleteTableFilterPayload;
  deleteTeam: DeleteTeamPayload;
  deleteTemplateDocumentSignRequest: DeleteTemplateDocumentSignRequestPayload;
  deleteTradeAdvisoryRequest: DeleteTradeAdvisoryRequestPayload;
  deleteTrucker: DeleteTruckerPayload;
  deleteUkCustomsBroker: DeleteUkCustomsBrokerPayload;
  deleteUkHs: DeleteUkHsPayload;
  deleteUsCargoReleaseDocumentGenerationRequest: DeleteUsCargoReleaseDocumentGenerationRequestPayload;
  deleteUsCbp5106DocumentGenerationRequest: DeleteUsCbp5106DocumentGenerationRequestPayload;
  deleteUsCbp7501DocumentGenerationRequest: DeleteUsCbp7501DocumentGenerationRequestPayload;
  deleteUsCbp7512DocumentGenerationRequest: DeleteUsCbp7512DocumentGenerationRequestPayload;
  deleteUsConsignee: DeleteUsConsigneePayload;
  deleteUsConsumptionEntry: DeleteUsConsumptionEntryPayload;
  /** TODO */
  deleteUsConsumptionEntryReleaseCbp: DeleteUsConsumptionEntryReleaseCbpPayload;
  /** TODO */
  deleteUsConsumptionEntrySummaryCbp: DeleteUsConsumptionEntrySummaryCbpPayload;
  deleteUsCustomsBroker: DeleteUsCustomsBrokerPayload;
  deleteUsDrawbackClaim: DeleteUsDrawbackClaimPayload;
  deleteUsDrawbackClaimDocumentGenerationRequest: DeleteUsDrawbackClaimDocumentGenerationRequestPayload;
  deleteUsHts: DeleteUsHtsPayload;
  deleteUsInBond: DeleteUsInBondPayload;
  deleteUsIor: DeleteUsIorPayload;
  deleteUsIorActivation: DeleteUsIorActivationPayload;
  deleteUsIorContinuousBondRequest: DeleteUsIorContinuousBondRequestPayload;
  deleteUsIsf: DeleteUsIsfPayload;
  /** TODO */
  deleteUsIsfCbp: DeleteUsIsfCbpPayload;
  deleteUsPostSummaryCorrection: DeleteUsPostSummaryCorrectionPayload;
  deleteUsPrincipalAdCvdCase: DeleteUsPrincipalAdCvdCasePayload;
  deleteUsType86Entry: DeleteUsType86EntryPayload;
  /** TODO */
  deleteUsType86EntryReleaseCbp: DeleteUsType86EntryReleaseCbpPayload;
  deleteUserReleaseNoteView: DeleteUserReleaseNoteViewPayload;
  deleteWorkOrderConfirmation: DeleteWorkOrderConfirmationPayload;
  deleteWorkOrderDocumentProcessingRequest: DeleteWorkOrderDocumentProcessingRequestPayload;
  deleteWorkOrderGroup: DeleteWorkOrderGroupPayload;
  deleteWorkOrderMilestone: DeleteWorkOrderMilestonePayload;
  deleteWorkOrderStateMachine: DeleteWorkOrderStateMachinePayload;
  deleteWorkOrderTask: DeleteWorkOrderTaskPayload;
  deleteWorkOrderTaskDefinition: DeleteWorkOrderTaskDefinitionPayload;
  deleteWorkOrderTaskEscalationMessage: DeleteWorkOrderTaskEscalationMessagePayload;
  /** Retrieve and zip all provided documents to perform a bulk download. */
  downloadDocumentBulkRequest: DocumentBulkDownloadPayload;
  escalateWorkOrderTask: EscalateWorkOrderTaskPayload;
  flipWorkOrder: FlipWorkOrderPayload;
  generateDeliveryOrder: GenerateDeliveryOrderPayload;
  generateDraftEntrySummary: GenerateDraftEntrySummaryPayload;
  generateUsConsumptionEntryNumber: GenerateUsConsumptionEntryNumberPayload;
  generateUsDrawbackClaimNumber: GenerateUsDrawbackClaimEntryNumberPayload;
  generateUsType86EntryNumber: GenerateUsType86EntryNumberPayload;
  /** Api to get address by ID from address service */
  getAddressById: GetAddressByIdPayload;
  /** Increments, then returns, the latest entry broker number for a US Customs Broker. Currently called only by the generateUsConsumptionEntryNumber mutation in Work Order Authority. */
  incrementUsEntryBrokerNumber: IncrementUsEntryBrokerNumberPayload;
  inquireWorkOrder: InquireWorkOrderPayload;
  /** Api to call Andra APIs with given args */
  invokeAndraApi: AndraClientConnectionPayload;
  /** Api to call DMS APIs with given api name and input */
  invokeDmsApi: DmsClientConnectionPayload;
  /** Api to call GSS Account Linking APIs with given api name and input */
  invokeGssAccountLinkingApi: GssAccountLinkingClientConnectionPayload;
  /** Invoke an Item Classification operation with the given input */
  invokeItemClassificationApi: ItemClassificationPayload;
  linkAction: LinkActionPayload;
  linkForwarderToUsIor: LinkForwarderToIorPayload;
  /** This mutation should be called as part of the deleteInBond transaction. If the cbpInBond has a status that allows it to be deleted, it will mark the usInBondNumber as AVAILABLE again, mark the cbpInBond DELETED by setting the status to DELETED and mark the cbpInBond's bills' as DELETED by setting their status to DELETED */
  markCbpInBondDeleted: UsInBondPayload;
  /** Mutation API for changing the status of the Exchange Message to Transmitted, once the message has been sent to the intended party. */
  markExchangeMessageAsTransmitted: ExchangeMessagePayload;
  markWorkOrderTaskStepComplete: MarkWorkOrderTaskStepCompletePayload;
  markWorkOrderTaskStepIncomplete: MarkWorkOrderTaskStepIncompletePayload;
  migrateUser: MigrateUserPayload;
  modifyWorkOrderTaskStepsCompletion: ModifyWorkOrderTaskStepsCompletionPayload;
  /** Request to pay reimbursement with giving pay reimbursement input. */
  payReimbursements: ReimbursementPayload;
  /** Publish redrive event back to error source and update processingError status to REDRIVEN. */
  publishRedriveEventToErrorSource: PublishRedriveEventToErrorSourcePayload;
  /** TODO */
  queryAdCvdCaseCbp: QueryAdCvdCaseCbpPayload;
  /** TODO */
  queryAms: QueryAmsPayload;
  /** TODO */
  queryAmsUsConsumptionEntry: QueryAmsUsConsumptionEntryPayload;
  /** TODO */
  queryAmsUsInBond: QueryAmsUsInBondPayload;
  /** TODO */
  queryAmsUsIsf: QueryAmsUsIsfPayload;
  /** TODO */
  queryAmsUsType86Entry: QueryAmsUsType86EntryPayload;
  /** TODO */
  queryCarrierCodeCbp: QueryCarrierCodeCbpPayload;
  /** TODO */
  queryCbpByIorNumber: QueryCbpByIorNumberPayload;
  /** TODO */
  queryEntryNumberCbp: QueryEntryNumberCbpPayload;
  /** TODO */
  queryFirmsCodeCbp: QueryFirmsCodeCbpPayload;
  /** TODO */
  queryHtsCbp: QueryHtsCbpPayload;
  /** TODO */
  queryUsConsigneeCbp: QueryUsConsigneeCbpPayload;
  /** TODO */
  queryUsConsumptionEntrySummaryCbp: QueryUsConsumptionEntrySummaryCbpPayload;
  /** TODO */
  queryUsIorCbp: QueryUsIorCbpPayload;
  /** TODO */
  queryUsPostSummaryCorrectionCbp: QueryUsPostSummaryCorrectionCbpPayload;
  /** TODO */
  queryUsType86EntryReleaseCbp: QueryUsType86EntryReleaseCbpPayload;
  reassignWorkOrderTask: ReassignWorkOrderTaskPayload;
  rejectImportProductsFromBulkUploadRequest: ConfirmBulkUploadPayload;
  /** TODO */
  replaceUsConsumptionEntryReleaseCbp: ReplaceUsConsumptionEntryReleaseCbpPayload;
  /** TODO */
  replaceUsType86EntryReleaseCbp: ReplaceUsType86EntryReleaseCbpPayload;
  replyWorkOrderTaskEscalation: TaskEscalationReplyPayload;
  /** TODO */
  requestUsIorCbpAssignedNumber: RequestUsIorCbpAssignedNumberPayload;
  resetForwarderUserPassword: ResetPasswordPayload;
  resetShipperUserPassword: ResetPasswordPayload;
  resolveWorkOrderTaskEscalation: ResolveWorkOrderTaskEscalationPayload;
  reviewCustomsEntry: ReviewCustomsEntryPayload;
  reviewWorkOrderConfirmation: ReviewWorkOrderConfirmationPayload;
  /** TODO */
  sendWorkOrderDocumentsTo3p: SendWorkOrderDocumentsTo3pPayload;
  /** TODO */
  sendWorkOrderDocumentsToExternalSystem: SendWorkOrderDocumentsToExternalSystemPayload;
  /** Validates the cbpInBondAction status attempting to be set can be set, then updates the status and saves the WorkOrder */
  setCbpInBondActionStatus: UsInBondPayload;
  /** Validates the cbpInBondBill status attempting to be set can be set, then updates the status and saves the WorkOrder */
  setCbpInBondBillStatus: UsInBondPayload;
  /** Validates the cbpInBond status attempting to be set can be set, then updates the status and saves the WorkOrder */
  setCbpInBondStatus: UsInBondPayload;
  submitComplianceRecommendationRequest: TariffFlagDisclaimSubmission;
  submitForwarderMailFrom: SubmitForwarderMailFromPayload;
  /** TODO */
  submitInBondCbp: SubmitInBondCbpPayload;
  /** TODO */
  submitUsConsumptionEntryDis: SubmitUsConsumptionEntryDisPayload;
  /** TODO */
  submitUsDrawbackClaimDis: SubmitUsDrawbackClaimDisPayload;
  /** TODO */
  submitUsType86EntryDis: SubmitUsType86EntryDisPayload;
  toggleAssumedUser: ToggleAssumedUserPayload;
  unblockShipmentInquiries: UnblockShipmentInquiriesPayload;
  unblockWorkOrder: UnblockWorkOrderPayload;
  uncancelShipment: UncancelShipmentPayload;
  uncancelShipper: UncancelShipperPayload;
  uncancelUsIor: UncancelUsIorPayload;
  uncancelWorkOrder: UncancelWorkOrderPayload;
  uncancelWorkOrderGroup: UncancelWorkOrderGroupPayload;
  uncancelWorkOrderTask: UncancelWorkOrderTaskPayload;
  updateAdCvdCase: UpdateAdCvdCasePayload;
  updateAssignmentTeam: UpdateAssignmentTeamPayload;
  updateAssignmentTeamOperatorUserRelationship: UpdateAssignmentTeamOperatorUserRelationshipPayload;
  updateAssignmentTeamStaticMapping: UpdateAssignmentTeamStaticMappingPayload;
  updateAuthenticationToken: UpdateAuthenticationTokenPayload;
  updateBroker: UpdateBrokerPayload;
  updateBulkChargesUploadRequest: UpdateBulkChargesUploadRequestPayload;
  updateBulkComplianceUploadRequest: UpdateBulkComplianceUploadRequestPayload;
  updateBulkMilestoneUploadRequest: UpdateBulkMilestoneUploadRequestPayload;
  /** Update document generation request with document id. */
  updateBulkProductUploadTemplateDocumentGenerationRequestWithDocumentId: UpdateBulkProductUploadTemplateDocumentGenerationRequestWithDocumentIdPayload;
  updateBusinessSupportTeam: UpdateBusinessSupportTeamPayload;
  updateBusinessSupportTeamOperatorUserRelationship: UpdateBusinessSupportTeamOperatorUserRelationshipPayload;
  updateCaseCategoryConfig: UpdateCaseCategoryConfigPayload;
  updateCommodityGroup: UpdateCommodityGroupPayload;
  updateCustomDomain: UpdateCustomDomainPayload;
  updateCustomsAgent: UpdateCustomsAgentPayload;
  updateCustomsDeclaration: UpdateCustomsDeclarationPayload;
  updateCustomsEntry: UpdateCustomsEntryPayload;
  updateDeConsignee: UpdateDeConsigneePayload;
  updateDeCustomsBroker: UpdateDeCustomsBrokerPayload;
  updateDeCustomsEntry: UpdateDeCustomsEntryPayload;
  updateDeIor: UpdateDeIorPayload;
  updateDeIorActivation: UpdateDeIorActivationPayload;
  updateDeIorActivationStatus: UpdateDeIorActivationStatusPayload;
  updateDeliveryOrder: UpdateDeliveryOrderPayload;
  /** Update document generation request with delivery order document id. */
  updateDeliveryOrderDocumentGenerationRequestWithDocumentId: UpdateDeliveryOrderDocumentGenerationRequestWithDocumentIdPayload;
  updateDocument: UpdateDocumentPayload;
  /** Updates the previewStatus on a document and returns the upload URL. */
  updateDocumentPreviewStatus: UpdateDocumentPreviewStatusPayload;
  updateDocumentTemplate: UpdateDocumentTemplatePayload;
  updateDocumentTemplateStatus: UpdateDocumentTemplateStatusPayload;
  updateDpsRecord: UpdateDpsRecordPayload;
  updateErrorDefinition: UpdateErrorDefinitionPayload;
  updateEuHs: UpdateEuHsPayload;
  /** Mutation for 3P clients to update EU/UK entries or Customs Declarations. Version is required. */
  updateEuUkCustomsDeclaration: UpdateEuUkCustomsDeclarationPayload;
  /** Update document generation request with document id. */
  updateExcelTemplateDocumentGenerationRequestWithDocumentId: UpdateExcelTemplateDocumentGenerationRequestWithDocumentIdPayload;
  updateExchangeMessage: UpdateExchangeMessagePayload;
  /** Mutation API for updating the output of already created message. The output document payload needs to be uploaded to the payloadUrl obtained as the response to this api call. */
  updateExchangeMessageOutput: ExchangeMessagePayload;
  updateFacility: UpdateFacilityPayload;
  updateFeatureFlag: UpdateFeatureFlagPayload;
  updateForwarder: UpdateForwarderPayload;
  updateForwarderSystem: UpdateForwarderSystemPayload;
  updateForwarderUser: UpdateForwarderUserPayload;
  updateFrConsignee: UpdateFrConsigneePayload;
  updateFrCustomsBroker: UpdateFrCustomsBrokerPayload;
  updateFrCustomsEntry: UpdateFrCustomsEntryPayload;
  updateFrIor: UpdateFrIorPayload;
  updateFrIorActivation: UpdateFrIorActivationPayload;
  updateFrIorActivationStatus: UpdateFrIorActivationStatusPayload;
  updateGbConsignee: UpdateGbConsigneePayload;
  updateGbCustomsEntry: UpdateGbCustomsEntryPayload;
  updateGbIor: UpdateGbIorPayload;
  updateGbIorActivation: UpdateGbIorActivationPayload;
  updateGbIorActivationStatus: UpdateGbIorActivationStatusPayload;
  /** Update document DGR with generated document ID */
  updateGenericDocumentGenerationRequestWithDocumentId: UpdateGenericDocumentGenerationRequestWithDocumentIdPayload;
  updateGlobalConsignee: UpdateGlobalConsigneePayload;
  /** Update HTML document generation request with generated document ID. */
  updateHtmlDocumentGenerationRequestWithDocumentId: UpdateHtmlDocumentGenerationRequestWithDocumentIdPayload;
  updateHts: UpdateHtsPayload;
  updateImportProductsFromBulkUploadRequest: UpdateImportProductsFromBulkUploadRequestPayload;
  updateImportProductsFromCustomsEntriesRequest: UpdateImportProductsFromCustomsEntriesRequestPayload;
  updateImporter: UpdateImporterPayload;
  updateImporterEntity: UpdateImporterEntityPayload;
  updateImporterEntityActivation: UpdateImporterEntityActivationPayload;
  /** Update document generation request with InBondNotes document id. */
  updateInBondNotesDocumentGenerationRequestWithDocumentId: UpdateInBondNotesDocumentGenerationRequestWithDocumentIdPayload;
  updateInvoice: UpdateInvoicePayload;
  updateInvoiceCreditNote: UpdateInvoiceCreditNotePayload;
  /** Update document DGR with invoice credit note document ID */
  updateInvoiceCreditNoteDocumentGenerationRequestWithDocumentId: UpdateInvoiceCreditNoteDocumentGenerationRequestWithDocumentIdPayload;
  /** Update document generation request with invocie document id. */
  updateInvoiceDocumentGenerationRequestWithDocumentId: UpdateInvoiceDocumentGenerationRequestWithDocumentIdPayload;
  updateInvoiceLinesRequest: UpdateInvoiceLinesRequestPayload;
  updateInvoicePayment: UpdateInvoicePaymentPayload;
  updateMemo: UpdateMemoPayload;
  updateNlConsignee: UpdateNlConsigneePayload;
  updateNlCustomsBroker: UpdateNlCustomsBrokerPayload;
  updateNlCustomsEntry: UpdateNlCustomsEntryPayload;
  updateNlIor: UpdateNlIorPayload;
  updateNlIorActivation: UpdateNlIorActivationPayload;
  updateNlIorActivationStatus: UpdateNlIorActivationStatusPayload;
  updateOnboardingRequest: UpdateOnboardingRequestPayload;
  updateOperator: UpdateOperatorPayload;
  updateOperatorSystem: UpdateOperatorSystemPayload;
  updateOperatorUser: UpdateOperatorUserPayload;
  updatePayableInvoice: UpdatePayableInvoicePayload;
  updateProcessingError: UpdateProcessingErrorPayload;
  updateProduct: UpdateProductPayload;
  updateProgram: UpdateProgramPayload;
  updateQueryCbpByIorNumberTransaction: QueryCbpByIorNumberPayload;
  updateReleaseNote: UpdateReleaseNotePayload;
  updateReleaseNoteRatingCounts: ReleaseNote;
  updateReportReconciliationRequest: UpdateReportReconciliationRequestPayload;
  updateShipment: UpdateShipmentPayload;
  updateShipmentCommercialInvoiceDetail: UpdateShipmentCommercialInvoiceDetailPayload;
  updateShipmentDocumentProcessingRequest: UpdateShipmentDocumentProcessingRequestPayload;
  updateShipper: UpdateShipperPayload;
  updateShipperImporterRelationship: UpdateShipperImporterRelationshipPayload;
  updateShipperSupplierRelationship: UpdateShipperSupplierRelationshipPayload;
  updateShipperSystem: UpdateShipperSystemPayload;
  updateShipperUser: UpdateShipperUserPayload;
  /** Update stamp document generation request with final stamped document id. */
  updateStampDocumentGenerationRequestWithDocumentId: UpdateStampDocumentGenerationRequestWithDocumentIdPayload;
  updateStampDocumentSignRequest: UpdateStampDocumentSignRequestPayload;
  /** Update document sign request with signature data. */
  updateStampDocumentSignRequestWithSignature: UpdateStampDocumentSignRequestWithSignaturePayload;
  /** Update document sign request with signed document id. */
  updateStampDocumentSignRequestWithSignedDocument: UpdateStampDocumentSignRequestWithSignedDocumentPayload;
  updateSubjectMatterExpertTeam: UpdateSubjectMatterExpertTeamPayload;
  updateSubjectMatterExpertTeamOperatorUserRelationship: UpdateSubjectMatterExpertTeamOperatorUserRelationshipPayload;
  updateSupplier: UpdateSupplierPayload;
  updateTableFilter: UpdateTableFilterPayload;
  updateTeam: UpdateTeamPayload;
  updateTemplateDocumentSignRequest: UpdateTemplateDocumentSignRequestPayload;
  /** Update document sign request with signature data. */
  updateTemplateDocumentSignRequestWithSignature: UpdateTemplateDocumentSignRequestWithSignaturePayload;
  /** Update document sign request with signed document id. */
  updateTemplateDocumentSignRequestWithSignedDocument: UpdateTemplateDocumentSignRequestWithSignedDocumentPayload;
  /** Update document sign requests with signature data */
  updateTemplateDocumentSignRequestsWithSignatures: UpdateTemplateDocumentSignRequestsWithSignaturesPayload;
  updateTradeAdvisoryRequest: UpdateTradeAdvisoryRequestPayload;
  updateTrucker: UpdateTruckerPayload;
  updateUkCustomsBroker: UpdateUkCustomsBrokerPayload;
  updateUkHs: UpdateUkHsPayload;
  /** Update document generation request with cargo release document id. */
  updateUsCargoReleaseDocumentGenerationRequestWithDocumentId: UpdateUsCargoReleaseDocumentGenerationRequestWithDocumentIdPayload;
  /** Update document generation request with cbp 5106 document id. */
  updateUsCbp5106DocumentGenerationRequestWithDocumentId: UpdateUsCbp5106DocumentGenerationRequestWithDocumentIdPayload;
  /** Update document generation request with cbp 7501 document id. */
  updateUsCbp7501DocumentGenerationRequestWithDocumentId: UpdateUsCbp7501DocumentGenerationRequestWithDocumentIdPayload;
  /** Update document generation request with cbp 7512 document id. */
  updateUsCbp7512DocumentGenerationRequestWithDocumentId: UpdateUsCbp7512DocumentGenerationRequestWithDocumentIdPayload;
  updateUsConsignee: UpdateUsConsigneePayload;
  /** TODO */
  updateUsConsigneeCbp5106: UpdateUsConsigneeCbp5106Payload;
  updateUsConsumptionEntry: UpdateUsConsumptionEntryPayload;
  /** TODO */
  updateUsConsumptionEntryPgaCbp: UpdateUsConsumptionEntryPgaCbpPayload;
  /** TODO */
  updateUsConsumptionEntryReleaseCbp: UpdateUsConsumptionEntryReleaseCbpPayload;
  /** TODO */
  updateUsConsumptionEntryStatementCbp: UpdateUsConsumptionEntryStatementCbpPayload;
  updateUsCustomsBroker: UpdateUsCustomsBrokerPayload;
  updateUsDrawbackClaim: UpdateUsDrawbackClaimPayload;
  /** TODO */
  updateUsDrawbackClaimCbp: UpdateUsDrawbackClaimCbpPayload;
  /** Update document generation request with us drawback document id. */
  updateUsDrawbackClaimDocumentGenerationRequestWithDocumentId: UpdateUsDrawbackClaimDocumentGenerationRequestWithDocumentIdPayload;
  updateUsHts: UpdateUsHtsPayload;
  updateUsInBond: UpdateUsInBondPayload;
  updateUsIor: UpdateUsIorPayload;
  updateUsIorActivation: UpdateUsIorActivationPayload;
  updateUsIorActivationStatus: UpdateUsIorActivationStatusPayload;
  /** TODO */
  updateUsIorCbp5106: UpdateUsIorCbp5106Payload;
  updateUsIorContinuousBondRequest: UpdateUsIorContinuousBondRequestPayload;
  updateUsIsf: UpdateUsIsfPayload;
  /** TODO */
  updateUsIsfCbp: UpdateUsIsfCbpPayload;
  updateUsPostSummaryCorrection: UpdateUsPostSummaryCorrectionPayload;
  updateUsPrincipalAdCvdCase: UpdateUsPrincipalAdCvdCasePayload;
  updateUsType86Entry: UpdateUsType86EntryPayload;
  /** TODO */
  updateUsType86EntryPgaCbp: UpdateUsType86EntryPgaCbpPayload;
  /** TODO */
  updateUsType86EntryReleaseCbp: UpdateUsType86EntryReleaseCbpPayload;
  updateUserReleaseNoteView: UpdateUserReleaseNoteViewPayload;
  updateWorkOrder: UpdateWorkOrderPayload;
  updateWorkOrderDocumentProcessingRequest: UpdateWorkOrderDocumentProcessingRequestPayload;
  updateWorkOrderGroup: UpdateWorkOrderGroupPayload;
  updateWorkOrderGroupStatus: UpdateWorkOrderGroupStatusPayload;
  updateWorkOrderStateMachine: UpdateWorkOrderStateMachinePayload;
  updateWorkOrderTask: UpdateWorkOrderTaskPayload;
  updateWorkOrderTaskDefinition: UpdateWorkOrderTaskDefinitionPayload;
  updateWorkOrderTaskEscalationMessage: UpdateWorkOrderTaskEscalationMessagePayload;
  upsertImporterEntityActivation: UpsertImporterEntityActivationPayload;
  /** TODO */
  upsertSupplierCbpMid: UpsertSupplierCbpMidPayload;
  /** TODO */
  upsertUsConsumptionEntrySummaryCbp: UpsertUsConsumptionEntrySummaryCbpPayload;
  /** TODO */
  upsertUsPostSummaryCorrectionCbp: UpsertUsPostSummaryCorrectionCbpPayload;
  userReacts: Scalars['Boolean'];
};


export type MutationacceptImportProductsFromBulkUploadRequestArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationactionInBondCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: ActionInBondCbpInput;
  usInBondId: Scalars['ID'];
};


export type MutationactivateUserArgs = {
  linkHash: Scalars['String'];
};


export type MutationaddPendingUpdatesArgs = {
  id: Scalars['ID'];
  pendingUpdates: Array<WorkOrderPendingUpdateInput>;
  version: Scalars['Int'];
};


export type MutationassignUsInBondNumberArgs = {
  cbpInBondIndex: Scalars['Int'];
  usInBondId: Scalars['ID'];
};


export type MutationauthorizeUsCbpEntryDailyStatementDebitArgs = {
  idempotencyKey: Scalars['String'];
  input: AuthorizeUsCbpEntryDailyStatementDebitInput;
};


export type MutationbatchUpsertProductsArgs = {
  idempotencyKey: Scalars['String'];
  upserts: Array<UpsertProductInput>;
};


export type MutationbatchUpsertSuppliersArgs = {
  idempotencyKey: Scalars['String'];
  upserts: Array<UpsertSupplierInput>;
};


export type MutationcancelShipmentArgs = {
  cancellationReason: CancellationReason;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcancelShipperArgs = {
  cancellationReason: CancellationReason;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcancelUsIorArgs = {
  cancellationReason: CancellationReason;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcancelUsIorContinuousBondRequestRenewalArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcancelWorkOrderArgs = {
  cancellationReason: CancellationReason;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcancelWorkOrderGroupArgs = {
  cancellationReason: CancellationReason;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcancelWorkOrderTaskArgs = {
  cancellationReason: CancellationReason;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationcloneWorkOrderArgs = {
  id: Scalars['ID'];
  input: CloneWorkOrderInput;
};


export type MutationcreateAdCvdCaseArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateAdCvdCaseInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationcreateAssignmentTeamArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateAssignmentTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateAssignmentTeamOperatorUserRelationshipArgs = {
  assignmentTeamId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<AssignmentTeamOperatorUserRelationshipInput>;
  operatorUserId: Scalars['ID'];
};


export type MutationcreateAssignmentTeamStaticMappingArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateAssignmentTeamStaticMappingInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateAuditLogArgs = {
  input: CreateAuditLogInput;
};


export type MutationcreateAuthenticationTokenArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateAuthenticationTokenInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBatchWorkOrderMilestonesArgs = {
  batchInformation: BatchInformation;
  idempotencyKey: Scalars['String'];
  milestoneRequests: Array<CreateWorkOrderMilestoneInput>;
};


export type MutationcreateBrokerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBulkChargesUploadRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateBulkChargesUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBulkComplianceUploadRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateBulkComplianceUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBulkMilestoneUploadRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateBulkMilestoneUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBulkProductUploadTemplateDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateBulkProductUploadTemplateDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBusinessSupportTeamArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateBusinessSupportTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateBusinessSupportTeamOperatorUserRelationshipArgs = {
  businessSupportTeamId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<BusinessSupportTeamOperatorUserRelationshipInput>;
  operatorUserId: Scalars['ID'];
};


export type MutationcreateCaseCategoryConfigArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateCaseCategoryConfigInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateChangelogArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateChangelogInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateChargesArgs = {
  charges: Array<ChargeInput>;
  documents?: InputMaybe<Array<IdInput>>;
  idempotencyKey: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
  workOrderId: Scalars['String'];
};


export type MutationcreateCommodityGroupArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateCommodityGroupInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateCpscCitationCodesPresignedUrlArgs = {
  codeType: CpscCitationCodeType;
};


export type MutationcreateCustomDomainArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateCustomDomainInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateCustomsAgentArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateCustomsAgentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateCustomsDeclarationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateCustomsDeclarationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateCustomsMessageArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateCustomsNotificationMessageInput;
};


export type MutationcreateDeConsigneeArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDeCustomsBrokerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDeCustomsEntryArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDeIorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDeIorActivationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDeliveryOrderArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeliveryOrderInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDeliveryOrderDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDeliveryOrderDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDocumentArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDocumentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDocumentTemplateArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDocumentTemplateInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateDpsRecordArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateDpsRecordInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateErrorDefinitionArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateErrorDefinitionInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateEuHsArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateEuHsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateExcelTemplateDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateExcelTemplateDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateExchangeMessageArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateExchangeMessageInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFacilityArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFacilityInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFeatureFlagArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFeatureFlagInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateForwarderArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateForwarderInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateForwarderSystemArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateForwarderSystemInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateForwarderUserArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateForwarderUserInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFrConsigneeArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFrConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFrCustomsBrokerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFrCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFrCustomsEntryArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFrCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFrIorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFrIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateFrIorActivationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateFrIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateGbConsigneeArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateGbConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateGbCustomsEntryArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateGbCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateGbIorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateGbIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateGbIorActivationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateGbIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateGenericDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateGenericDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateGlobalConsigneeArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateGlobalConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateHtmlDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateHtmlDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateHtsArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateHtsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateImportProductsFromBulkUploadRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateImportProductsFromBulkUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateImportProductsFromCustomsEntriesRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateImportProductsFromCustomsEntriesRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateImporterArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateImporterInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateImporterEntityArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateImporterEntityInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateImporterEntityActivationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateImporterEntityActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateImporterImporterEntityRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  importerEntityId: Scalars['ID'];
  importerId: Scalars['ID'];
};


export type MutationcreateInBondNotesDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInBondNotesDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateInvitedShipperArgs = {
  input: CreateShipperInput;
};


export type MutationcreateInvoiceArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInvoiceInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateInvoiceCreditNoteArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInvoiceCreditNoteInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateInvoiceCreditNoteDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInvoiceCreditNoteDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateInvoiceDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInvoiceDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateInvoiceLinesRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInvoiceLinesRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateInvoicePaymentArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateInvoicePaymentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateMemoArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateMemoInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateNlConsigneeArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateNlConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateNlCustomsBrokerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateNlCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateNlCustomsEntryArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateNlCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateNlIorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateNlIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateNlIorActivationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateNlIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateOnboardingRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateOnboardingRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateOperatorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateOperatorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateOperatorSystemArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateOperatorSystemInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateOperatorUserArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateOperatorUserInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreatePayableInvoiceArgs = {
  idempotencyKey: Scalars['String'];
  input: CreatePayableInvoiceInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateProcessingErrorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateProcessingErrorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateProductArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateProductInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateProgramArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateProgramInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateReleaseNoteArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateReleaseNoteInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateReportReconciliationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateReportReconciliationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateShipmentArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateShipmentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateShipmentCommercialInvoiceDetailArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateShipmentCommercialInvoiceDetailInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateShipmentDocumentProcessingRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateShipmentDocumentProcessingRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateShipperArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateShipperInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateShipperBrokerRelationshipArgs = {
  brokerId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperCustomsAgentRelationshipArgs = {
  customsAgentId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperDeConsigneeRelationshipArgs = {
  deConsigneeId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperDeCustomsBrokerRelationshipArgs = {
  deCustomsBrokerId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperDeIorRelationshipArgs = {
  deIorId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperFacilityRelationshipArgs = {
  facilityId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperForwarderRelationshipArgs = {
  forwarderId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperFrConsigneeRelationshipArgs = {
  frConsigneeId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperFrCustomsBrokerRelationshipArgs = {
  frCustomsBrokerId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperFrIorRelationshipArgs = {
  frIorId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperGbConsigneeRelationshipArgs = {
  gbConsigneeId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperGbIorRelationshipArgs = {
  gbIorId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperGlobalConsigneeRelationshipArgs = {
  globalConsigneeId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperImporterRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  importerId: Scalars['ID'];
  input?: InputMaybe<ShipperImporterRelationshipInput>;
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperNlConsigneeRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  nlConsigneeId: Scalars['ID'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperNlCustomsBrokerRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  nlCustomsBrokerId: Scalars['ID'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperNlIorRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  nlIorId: Scalars['ID'];
  shipperId: Scalars['ID'];
};


export type MutationcreateShipperSupplierRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<ShipperSupplierRelationshipInput>;
  shipperId: Scalars['ID'];
  supplierId: Scalars['ID'];
};


export type MutationcreateShipperSystemArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateShipperSystemInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateShipperTruckerRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
  truckerId: Scalars['ID'];
};


export type MutationcreateShipperUkCustomsBrokerRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
  ukCustomsBrokerId: Scalars['ID'];
};


export type MutationcreateShipperUsConsigneeRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
  usConsigneeId: Scalars['ID'];
};


export type MutationcreateShipperUsCustomsBrokerRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
  usCustomsBrokerId: Scalars['ID'];
};


export type MutationcreateShipperUsIorRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  shipperId: Scalars['ID'];
  usIorId: Scalars['ID'];
};


export type MutationcreateShipperUserArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateShipperUserInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateSingleUseAddressArgs = {
  input: CreateSingleUseAddressInput;
};


export type MutationcreateStampDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateStampDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateStampDocumentSignRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateStampDocumentSignRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateSubjectMatterExpertTeamArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateSubjectMatterExpertTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateSubjectMatterExpertTeamOperatorUserRelationshipArgs = {
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<SubjectMatterExpertTeamOperatorUserRelationshipInput>;
  operatorUserId: Scalars['ID'];
  subjectMatterExpertTeamId: Scalars['ID'];
};


export type MutationcreateSupplierArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateSupplierInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateTableFilterArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateTableFilterInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateTeamArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateTemplateDocumentSignRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateTemplateDocumentSignRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateTradeAdvisoryRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateTradeAdvisoryRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateTruckerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateTruckerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUkCustomsBrokerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUkCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUkHsArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUkHsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsCargoReleaseDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsCargoReleaseDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsCbp5106DocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsCbp5106DocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsCbp7501DocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsCbp7501DocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsCbp7512DocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsCbp7512DocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsConsigneeArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsConsigneeCbp5106Args = {
  idempotencyKey: Scalars['String'];
  usConsigneeId: Scalars['ID'];
};


export type MutationcreateUsConsumptionEntryArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsConsumptionEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsConsumptionEntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationcreateUsCustomsBrokerArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsDrawbackClaimArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsDrawbackClaimInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsDrawbackClaimCbpArgs = {
  idempotencyKey: Scalars['String'];
  usDrawbackClaimId: Scalars['ID'];
};


export type MutationcreateUsDrawbackClaimDocumentGenerationRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsDrawbackClaimDocumentGenerationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsHtsArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsHtsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsInBondArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsInBondInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsIorArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsIorActivationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsIorCbp5106Args = {
  idempotencyKey: Scalars['String'];
  usIorId: Scalars['ID'];
};


export type MutationcreateUsIorContinuousBondRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsIorContinuousBondRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsIsfArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsIsfInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsIsfCbpArgs = {
  idempotencyKey: Scalars['String'];
  usIsfId: Scalars['ID'];
};


export type MutationcreateUsPostSummaryCorrectionArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsPostSummaryCorrectionInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsPrincipalAdCvdCaseArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsPrincipalAdCvdCaseInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsType86EntryArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUsType86EntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateUsType86EntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usType86EntryId: Scalars['ID'];
};


export type MutationcreateUserReleaseNoteViewArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateUserReleaseNoteViewInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderConfirmationArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderConfirmationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderDocumentProcessingRequestArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderDocumentProcessingRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderGroupArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderGroupInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderMilestoneArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderMilestoneInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderStateMachineArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderStateMachineInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderTaskArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderTaskInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderTaskDefinitionArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderTaskDefinitionInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationcreateWorkOrderTaskEscalationMessageArgs = {
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderTaskEscalationMessageInput;
  reason?: InputMaybe<RecordActionReasonInput>;
};


export type MutationdeleteAdCvdCaseArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteAssignmentTeamArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteAssignmentTeamOperatorUserRelationshipArgs = {
  assignmentTeamId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  operatorUserId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteAssignmentTeamStaticMappingArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteAuthenticationTokenArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBrokerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBulkChargesUploadRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBulkComplianceUploadRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBulkMilestoneUploadRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBulkProductUploadTemplateDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBusinessSupportTeamArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteBusinessSupportTeamOperatorUserRelationshipArgs = {
  businessSupportTeamId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  operatorUserId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteCaseCategoryConfigArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteCommodityGroupArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteCustomDomainArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteCustomsAgentArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteCustomsDeclarationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteCustomsEntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeConsigneeArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeCustomsBrokerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeCustomsEntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeIorArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeIorActivationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeliveryOrderArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDeliveryOrderDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDocumentArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDocumentTemplateArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteDpsRecordArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteEuHsArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteExcelTemplateDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteExchangeMessageArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFacilityArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFeatureFlagArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteForwarderArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteForwarderSystemArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteForwarderUserArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFrConsigneeArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFrCustomsBrokerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFrCustomsEntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFrIorArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteFrIorActivationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteGbConsigneeArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteGbCustomsEntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteGbIorArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteGbIorActivationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteGenericDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteGlobalConsigneeArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteHtmlDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteHtsArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteImportProductsFromBulkUploadRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteImportProductsFromCustomsEntriesRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteImporterArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteImporterEntityArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteImporterEntityActivationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteImporterImporterEntityRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  importerEntityId?: InputMaybe<Scalars['ID']>;
  importerId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInBondBillCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: DeleteInBondBillCbpInput;
  usInBondId: Scalars['ID'];
};


export type MutationdeleteInBondCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: DeleteInBondCbpInput;
  usInBondId: Scalars['ID'];
};


export type MutationdeleteInBondNotesDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInvoiceArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInvoiceCreditNoteArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInvoiceCreditNoteDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInvoiceDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInvoiceLinesRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteInvoicePaymentArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteMemoArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteNlConsigneeArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteNlCustomsBrokerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteNlCustomsEntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteNlIorArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteNlIorActivationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteOnboardingRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteOperatorArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteOperatorSystemArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteOperatorUserArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeletePayableInvoiceArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteProductArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteReleaseNoteArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteReportReconciliationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipmentArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipmentCommercialInvoiceDetailArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipmentDocumentProcessingRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperBrokerRelationshipArgs = {
  brokerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperCustomsAgentRelationshipArgs = {
  customsAgentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperDeConsigneeRelationshipArgs = {
  deConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperDeCustomsBrokerRelationshipArgs = {
  deCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperDeIorRelationshipArgs = {
  deIorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperFacilityRelationshipArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperForwarderRelationshipArgs = {
  forwarderId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperFrConsigneeRelationshipArgs = {
  frConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperFrCustomsBrokerRelationshipArgs = {
  frCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperFrIorRelationshipArgs = {
  frIorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperGbConsigneeRelationshipArgs = {
  gbConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperGbIorRelationshipArgs = {
  gbIorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperGlobalConsigneeRelationshipArgs = {
  globalConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperImporterRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  importerId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperNlConsigneeRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  nlConsigneeId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperNlCustomsBrokerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  nlCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperNlIorRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  nlIorId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperSupplierRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperSystemArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperTruckerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  truckerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperUkCustomsBrokerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  ukCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperUsConsigneeRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  usConsigneeId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperUsCustomsBrokerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  usCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperUsIorRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  usIorId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteShipperUserArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteStampDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteStampDocumentSignRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteSubjectMatterExpertTeamArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteSubjectMatterExpertTeamOperatorUserRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  operatorUserId?: InputMaybe<Scalars['ID']>;
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  subjectMatterExpertTeamId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteSupplierArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteTableFilterArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteTeamArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteTemplateDocumentSignRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteTradeAdvisoryRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteTruckerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUkCustomsBrokerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUkHsArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsCargoReleaseDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsCbp5106DocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsCbp7501DocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsCbp7512DocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsConsigneeArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsConsumptionEntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsConsumptionEntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: DeleteUsConsumptionEntryReleaseCbpInput;
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationdeleteUsConsumptionEntrySummaryCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationdeleteUsCustomsBrokerArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsDrawbackClaimArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsDrawbackClaimDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsHtsArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsInBondArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsIorArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsIorActivationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsIorContinuousBondRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsIsfArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsIsfCbpArgs = {
  idempotencyKey: Scalars['String'];
  usIsfId: Scalars['ID'];
};


export type MutationdeleteUsPostSummaryCorrectionArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsPrincipalAdCvdCaseArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsType86EntryArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteUsType86EntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: DeleteUsType86EntryReleaseCbpInput;
  usType86EntryId: Scalars['ID'];
};


export type MutationdeleteUserReleaseNoteViewArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderConfirmationArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderDocumentProcessingRequestArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderGroupArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderMilestoneArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderStateMachineArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderTaskArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderTaskDefinitionArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdeleteWorkOrderTaskEscalationMessageArgs = {
  id: Scalars['ID'];
  permanentDelete?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationdownloadDocumentBulkRequestArgs = {
  input: DocumentBulkDownloadInput;
};


export type MutationescalateWorkOrderTaskArgs = {
  input: WorkOrderTaskEscalationInput;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationflipWorkOrderArgs = {
  id: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  outputType: WorkOrderType;
};


export type MutationgenerateDeliveryOrderArgs = {
  deliveryOrderId: Scalars['ID'];
};


export type MutationgenerateDraftEntrySummaryArgs = {
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationgenerateUsConsumptionEntryNumberArgs = {
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationgenerateUsDrawbackClaimNumberArgs = {
  usDrawbackClaimId: Scalars['ID'];
};


export type MutationgenerateUsType86EntryNumberArgs = {
  usType86EntryId: Scalars['ID'];
};


export type MutationgetAddressByIdArgs = {
  input: GetAddressByIdInput;
};


export type MutationincrementUsEntryBrokerNumberArgs = {
  usCustomsBrokerId: Scalars['ID'];
};


export type MutationinquireWorkOrderArgs = {
  id: Scalars['ID'];
  input: InquireWorkOrderInput;
  version: Scalars['Int'];
};


export type MutationinvokeAndraApiArgs = {
  input: AndraClientConnectionInput;
};


export type MutationinvokeDmsApiArgs = {
  input: DmsClientConnectionInput;
};


export type MutationinvokeGssAccountLinkingApiArgs = {
  input: GssAccountLinkingClientConnectionInput;
};


export type MutationinvokeItemClassificationApiArgs = {
  input: ItemClassificationInput;
};


export type MutationlinkActionArgs = {
  hashKey: Scalars['String'];
};


export type MutationlinkForwarderToUsIorArgs = {
  customsBrokerId: Scalars['ID'];
  forwarderId: Scalars['ID'];
  id: Scalars['ID'];
  input?: InputMaybe<LinkForwarderToIorInput>;
  version: Scalars['Int'];
};


export type MutationmarkCbpInBondDeletedArgs = {
  cbpInBondIndex: Scalars['Int'];
  usInBondId: Scalars['ID'];
};


export type MutationmarkExchangeMessageAsTransmittedArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationmarkWorkOrderTaskStepCompleteArgs = {
  stepId: Scalars['ID'];
  taskId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationmarkWorkOrderTaskStepIncompleteArgs = {
  stepId: Scalars['ID'];
  taskId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationmigrateUserArgs = {
  jwt: Scalars['String'];
};


export type MutationmodifyWorkOrderTaskStepsCompletionArgs = {
  steps: Array<ModifiedWorkOrderTaskStepInput>;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationpayReimbursementsArgs = {
  payReimbursementInput: PayReimbursementInput;
};


export type MutationpublishRedriveEventToErrorSourceArgs = {
  id: Scalars['ID'];
};


export type MutationqueryAdCvdCaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryAdCvdCaseCbpInput;
};


export type MutationqueryAmsArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryAmsInput;
};


export type MutationqueryAmsUsConsumptionEntryArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryAmsUsConsumptionEntryInput;
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationqueryAmsUsInBondArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryAmsUsInBondInput;
  usInBondId: Scalars['ID'];
};


export type MutationqueryAmsUsIsfArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryAmsUsIsfInput;
  usIsfId: Scalars['ID'];
};


export type MutationqueryAmsUsType86EntryArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryAmsUsType86EntryInput;
  usType86EntryId: Scalars['ID'];
};


export type MutationqueryCarrierCodeCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryCarrierCodeCbpCreateInput;
};


export type MutationqueryCbpByIorNumberArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryCbpByIorNumberCreateInput;
};


export type MutationqueryEntryNumberCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryEntryNumberCbpCreateInput;
};


export type MutationqueryFirmsCodeCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryFirmsCodeCbpCreateInput;
};


export type MutationqueryHtsCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: QueryHtsCbpInput;
};


export type MutationqueryUsConsigneeCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsigneeId: Scalars['ID'];
};


export type MutationqueryUsConsumptionEntrySummaryCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationqueryUsIorCbpArgs = {
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<QueryUsIorCbpCreateInput>;
  usIorId: Scalars['ID'];
};


export type MutationqueryUsPostSummaryCorrectionCbpArgs = {
  idempotencyKey: Scalars['String'];
  usPostSummaryCorrectionId: Scalars['ID'];
};


export type MutationqueryUsType86EntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usType86EntryId: Scalars['ID'];
};


export type MutationreassignWorkOrderTaskArgs = {
  operatorUserId: Scalars['ID'];
  operatorUserVersion: Scalars['Int'];
};


export type MutationrejectImportProductsFromBulkUploadRequestArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationreplaceUsConsumptionEntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationreplaceUsType86EntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usType86EntryId: Scalars['ID'];
};


export type MutationreplyWorkOrderTaskEscalationArgs = {
  input: TaskEscalationReplyDetailsInput;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationrequestUsIorCbpAssignedNumberArgs = {
  idempotencyKey: Scalars['String'];
  input: RequestUsIorCbpAssignedNumberInput;
  usIorId: Scalars['ID'];
};


export type MutationresetForwarderUserPasswordArgs = {
  id: Scalars['ID'];
};


export type MutationresetShipperUserPasswordArgs = {
  id: Scalars['ID'];
};


export type MutationresolveWorkOrderTaskEscalationArgs = {
  input: TaskResolutionDetailsInput;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationreviewCustomsEntryArgs = {
  id: Scalars['ID'];
  input: ReviewCustomsEntryInput;
};


export type MutationreviewWorkOrderConfirmationArgs = {
  additionalComments?: InputMaybe<Scalars['String']>;
  disputedReason?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status: WorkOrderConfirmationReviewApprovalStatus;
};


export type MutationsendWorkOrderDocumentsTo3pArgs = {
  idempotencyKey: Scalars['String'];
  input: SendWorkOrderDocumentsTo3pInput;
  workOrderId: Scalars['ID'];
};


export type MutationsendWorkOrderDocumentsToExternalSystemArgs = {
  idempotencyKey: Scalars['String'];
  input: SendWorkOrderDocumentsToExternalSystemInput;
  workOrderId: Scalars['ID'];
};


export type MutationsetCbpInBondActionStatusArgs = {
  cbpInBondIndex: Scalars['Int'];
  newActionStatus: CbpInBondActionStatus;
  usInBondId: Scalars['ID'];
};


export type MutationsetCbpInBondBillStatusArgs = {
  cbpInBondBillIndex?: InputMaybe<Scalars['Int']>;
  cbpInBondIndex: Scalars['Int'];
  newBillStatus: CbpInBondBillStatus;
  usInBondId: Scalars['ID'];
};


export type MutationsetCbpInBondStatusArgs = {
  cbpInBondIndex: Scalars['Int'];
  newStatus: CbpInBondStatus;
  usInBondId: Scalars['ID'];
};


export type MutationsubmitComplianceRecommendationRequestArgs = {
  input: SubmitComplianceRecommendationRequestInput;
};


export type MutationsubmitForwarderMailFromArgs = {
  fromEmail: Scalars['Email'];
  fromSignature?: InputMaybe<Scalars['String']>;
  fromTitle: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationsubmitInBondCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: SubmitInBondCbpInput;
  usInBondId: Scalars['ID'];
};


export type MutationsubmitUsConsumptionEntryDisArgs = {
  idempotencyKey: Scalars['String'];
  input: SubmitUsConsumptionEntryDisInput;
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationsubmitUsDrawbackClaimDisArgs = {
  idempotencyKey: Scalars['String'];
  input: SubmitUsDrawbackClaimDisInput;
  usDrawbackClaimId: Scalars['ID'];
};


export type MutationsubmitUsType86EntryDisArgs = {
  idempotencyKey: Scalars['String'];
  input: SubmitUsType86EntryDisInput;
  usType86EntryId: Scalars['ID'];
};


export type MutationtoggleAssumedUserArgs = {
  assumedUser?: InputMaybe<IdInput>;
  id: Scalars['ID'];
};


export type MutationunblockShipmentInquiriesArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationunblockWorkOrderArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationuncancelShipmentArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationuncancelShipperArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationuncancelUsIorArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationuncancelWorkOrderArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationuncancelWorkOrderGroupArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationuncancelWorkOrderTaskArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateAdCvdCaseArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateAdCvdCaseInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateAssignmentTeamArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateAssignmentTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateAssignmentTeamOperatorUserRelationshipArgs = {
  assignmentTeamId: Scalars['ID'];
  input: AssignmentTeamOperatorUserRelationshipInput;
  operatorUserId: Scalars['ID'];
  shouldUndelete?: InputMaybe<Scalars['Boolean']>;
};


export type MutationupdateAssignmentTeamStaticMappingArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateAssignmentTeamStaticMappingInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateAuthenticationTokenArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateAuthenticationTokenInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateBrokerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateBulkChargesUploadRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateBulkChargesUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateBulkComplianceUploadRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateBulkComplianceUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateBulkMilestoneUploadRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateBulkMilestoneUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateBulkProductUploadTemplateDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateBusinessSupportTeamArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateBusinessSupportTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateBusinessSupportTeamOperatorUserRelationshipArgs = {
  businessSupportTeamId: Scalars['ID'];
  input: BusinessSupportTeamOperatorUserRelationshipInput;
  operatorUserId: Scalars['ID'];
  shouldUndelete?: InputMaybe<Scalars['Boolean']>;
};


export type MutationupdateCaseCategoryConfigArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateCaseCategoryConfigInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateCommodityGroupArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateCommodityGroupInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateCustomDomainArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateCustomDomainInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateCustomsAgentArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateCustomsAgentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateCustomsDeclarationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateCustomsDeclarationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateCustomsEntryArgs = {
  id: Scalars['ID'];
  input: UpdateCustomsEntryInput;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationupdateDeConsigneeArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDeConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDeCustomsBrokerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDeCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDeCustomsEntryArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDeCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDeIorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDeIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDeIorActivationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDeIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDeIorActivationStatusArgs = {
  id: Scalars['ID'];
  input: UpdateDeIorActivationStatusInput;
  version: Scalars['Int'];
};


export type MutationupdateDeliveryOrderArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDeliveryOrderInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDeliveryOrderDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateDocumentArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDocumentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDocumentPreviewStatusArgs = {
  id: Scalars['ID'];
  input: UpdateDocumentPreviewStatusInput;
  version: Scalars['Int'];
};


export type MutationupdateDocumentTemplateArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDocumentTemplateInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateDocumentTemplateStatusArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  status: DocumentTemplateStatus;
  version: Scalars['Int'];
};


export type MutationupdateDpsRecordArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateDpsRecordInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateErrorDefinitionArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateErrorDefinitionInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateEuHsArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateEuHsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateEuUkCustomsDeclarationArgs = {
  id: Scalars['ID'];
  input: UpdateCustomsDeclarationInput;
  version: Scalars['Int'];
};


export type MutationupdateExcelTemplateDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateExchangeMessageArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateExchangeMessageInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateExchangeMessageOutputArgs = {
  id: Scalars['ID'];
  tags?: InputMaybe<Array<TagInput>>;
  version: Scalars['Int'];
};


export type MutationupdateFacilityArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFacilityInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFeatureFlagArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFeatureFlagInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateForwarderArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateForwarderInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateForwarderSystemArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateForwarderSystemInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateForwarderUserArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateForwarderUserInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFrConsigneeArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFrConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFrCustomsBrokerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFrCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFrCustomsEntryArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFrCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFrIorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFrIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFrIorActivationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateFrIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateFrIorActivationStatusArgs = {
  id: Scalars['ID'];
  input: UpdateFrIorActivationStatusInput;
  version: Scalars['Int'];
};


export type MutationupdateGbConsigneeArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateGbConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateGbCustomsEntryArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateGbCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateGbIorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateGbIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateGbIorActivationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateGbIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateGbIorActivationStatusArgs = {
  id: Scalars['ID'];
  input: UpdateGbIorActivationStatusInput;
  version: Scalars['Int'];
};


export type MutationupdateGenericDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  status?: InputMaybe<DocumentGenerationStatus>;
  version: Scalars['Int'];
};


export type MutationupdateGlobalConsigneeArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateGlobalConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateHtmlDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateHtsArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateHtsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateImportProductsFromBulkUploadRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateImportProductsFromBulkUploadRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateImportProductsFromCustomsEntriesRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateImportProductsFromCustomsEntriesRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateImporterArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateImporterInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateImporterEntityArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateImporterEntityInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateImporterEntityActivationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateImporterEntityActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateInBondNotesDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateInvoiceArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateInvoiceInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateInvoiceCreditNoteArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateInvoiceCreditNoteInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateInvoiceCreditNoteDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateInvoiceDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateInvoiceLinesRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateInvoiceLinesRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateInvoicePaymentArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateInvoicePaymentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateMemoArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateMemoInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateNlConsigneeArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateNlConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateNlCustomsBrokerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateNlCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateNlCustomsEntryArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateNlCustomsEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateNlIorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateNlIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateNlIorActivationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateNlIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateNlIorActivationStatusArgs = {
  id: Scalars['ID'];
  input: UpdateNlIorActivationStatusInput;
  version: Scalars['Int'];
};


export type MutationupdateOnboardingRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateOnboardingRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateOperatorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateOperatorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateOperatorSystemArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateOperatorSystemInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateOperatorUserArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateOperatorUserInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdatePayableInvoiceArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdatePayableInvoiceInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateProcessingErrorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateProcessingErrorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateProductArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateProductInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateProgramArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateProgramInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateQueryCbpByIorNumberTransactionArgs = {
  id: Scalars['ID'];
  input: QueryCbpByIorNumberUpdateInput;
  version: Scalars['Float'];
};


export type MutationupdateReleaseNoteArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateReleaseNoteInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateReleaseNoteRatingCountsArgs = {
  releaseNoteId: Scalars['String'];
  thumbsDownChange: Scalars['Float'];
  thumbsUpChange: Scalars['Float'];
};


export type MutationupdateReportReconciliationRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateReportReconciliationRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateShipmentArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateShipmentInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateShipmentCommercialInvoiceDetailArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateShipmentCommercialInvoiceDetailInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateShipmentDocumentProcessingRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateShipmentDocumentProcessingRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateShipperArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateShipperInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateShipperImporterRelationshipArgs = {
  importerId: Scalars['ID'];
  input: ShipperImporterRelationshipInput;
  shipperId: Scalars['ID'];
  shouldUndelete?: InputMaybe<Scalars['Boolean']>;
};


export type MutationupdateShipperSupplierRelationshipArgs = {
  input: ShipperSupplierRelationshipInput;
  shipperId: Scalars['ID'];
  shouldUndelete?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
};


export type MutationupdateShipperSystemArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateShipperSystemInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateShipperUserArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateShipperUserInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateStampDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateStampDocumentSignRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateStampDocumentSignRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateStampDocumentSignRequestWithSignatureArgs = {
  id: Scalars['ID'];
  signature: DocumentSignatureInput;
  signerName: Scalars['String'];
  signerTitle: Scalars['String'];
  version: Scalars['Int'];
};


export type MutationupdateStampDocumentSignRequestWithSignedDocumentArgs = {
  id: Scalars['ID'];
  signedDocument: IdInput;
  version: Scalars['Int'];
};


export type MutationupdateSubjectMatterExpertTeamArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateSubjectMatterExpertTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateSubjectMatterExpertTeamOperatorUserRelationshipArgs = {
  input: SubjectMatterExpertTeamOperatorUserRelationshipInput;
  operatorUserId: Scalars['ID'];
  shouldUndelete?: InputMaybe<Scalars['Boolean']>;
  subjectMatterExpertTeamId: Scalars['ID'];
};


export type MutationupdateSupplierArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateSupplierInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateTableFilterArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateTableFilterInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateTeamArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateTeamInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateTemplateDocumentSignRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateTemplateDocumentSignRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateTemplateDocumentSignRequestWithSignatureArgs = {
  additionalFields: Scalars['JSONObject'];
  id: Scalars['ID'];
  signature: DocumentSignatureInput;
  signerBirthDate?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
  signerName: Scalars['String'];
  signerTitle: Scalars['String'];
  version: Scalars['Int'];
};


export type MutationupdateTemplateDocumentSignRequestWithSignedDocumentArgs = {
  id: Scalars['ID'];
  signedDocument: IdInput;
  version: Scalars['Int'];
};


export type MutationupdateTemplateDocumentSignRequestsWithSignaturesArgs = {
  input: UpdateTemplateDocumentSignRequestsWithSignaturesInput;
};


export type MutationupdateTradeAdvisoryRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateTradeAdvisoryRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateTruckerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateTruckerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUkCustomsBrokerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUkCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUkHsArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUkHsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsCargoReleaseDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateUsCbp5106DocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateUsCbp7501DocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateUsCbp7512DocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateUsConsigneeArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsConsigneeInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsConsigneeCbp5106Args = {
  idempotencyKey: Scalars['String'];
  usConsigneeId: Scalars['ID'];
};


export type MutationupdateUsConsumptionEntryArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsConsumptionEntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsConsumptionEntryPgaCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationupdateUsConsumptionEntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationupdateUsConsumptionEntryStatementCbpArgs = {
  idempotencyKey: Scalars['String'];
  input: UpdateUsConsumptionEntryStatementCbpInput;
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationupdateUsCustomsBrokerArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsCustomsBrokerInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsDrawbackClaimArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsDrawbackClaimInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsDrawbackClaimCbpArgs = {
  idempotencyKey: Scalars['String'];
  usDrawbackClaimId: Scalars['ID'];
};


export type MutationupdateUsDrawbackClaimDocumentGenerationRequestWithDocumentIdArgs = {
  document: IdInput;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateUsHtsArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsHtsInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsInBondArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsInBondInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsIorArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsIorInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsIorActivationArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsIorActivationInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsIorActivationStatusArgs = {
  activationStatus: ActivationStatus;
  id: Scalars['ID'];
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  usCustomsBrokerId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationupdateUsIorCbp5106Args = {
  idempotencyKey: Scalars['String'];
  usIorId: Scalars['ID'];
};


export type MutationupdateUsIorContinuousBondRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsIorContinuousBondRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsIsfArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsIsfInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsIsfCbpArgs = {
  idempotencyKey: Scalars['String'];
  usIsfId: Scalars['ID'];
};


export type MutationupdateUsPostSummaryCorrectionArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsPostSummaryCorrectionInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsPrincipalAdCvdCaseArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsPrincipalAdCvdCaseInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsType86EntryArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUsType86EntryInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateUsType86EntryPgaCbpArgs = {
  idempotencyKey: Scalars['String'];
  usType86EntryId: Scalars['ID'];
};


export type MutationupdateUsType86EntryReleaseCbpArgs = {
  idempotencyKey: Scalars['String'];
  usType86EntryId: Scalars['ID'];
};


export type MutationupdateUserReleaseNoteViewArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateUserReleaseNoteViewInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderArgs = {
  id: Scalars['ID'];
  input: UpdateWorkOrderInput;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderDocumentProcessingRequestArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateWorkOrderDocumentProcessingRequestInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderGroupArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateWorkOrderGroupInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderGroupStatusArgs = {
  id: Scalars['ID'];
  status: WorkOrderGroupStatus;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderStateMachineArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateWorkOrderStateMachineInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderTaskArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateWorkOrderTaskInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderTaskDefinitionArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateWorkOrderTaskDefinitionInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupdateWorkOrderTaskEscalationMessageArgs = {
  customDataSource?: InputMaybe<DataSourceType>;
  id: Scalars['ID'];
  input: UpdateWorkOrderTaskEscalationMessageInput;
  reason?: InputMaybe<RecordActionReasonInput>;
  version: Scalars['Int'];
};


export type MutationupsertImporterEntityActivationArgs = {
  id: Scalars['ID'];
  input: UpsertImporterEntityActivationInput;
  version: Scalars['Int'];
};


export type MutationupsertSupplierCbpMidArgs = {
  idempotencyKey: Scalars['String'];
  supplierId: Scalars['ID'];
};


export type MutationupsertUsConsumptionEntrySummaryCbpArgs = {
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<UpsertUsConsumptionEntrySummaryCbpInput>;
  usConsumptionEntryId: Scalars['ID'];
};


export type MutationupsertUsPostSummaryCorrectionCbpArgs = {
  idempotencyKey: Scalars['String'];
  input?: InputMaybe<UpsertUsPostSummaryCorrectionCbpInput>;
  usPostSummaryCorrectionId: Scalars['ID'];
};


export type MutationuserReactsArgs = {
  rating: Scalars['String'];
  releaseNoteId: Scalars['String'];
  userId: Scalars['String'];
};

export type NlConsignee = Consignee & Party & Record & {
  __typename?: 'NlConsignee';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this NL Consignee */
  shipper: ShipperNlConsigneeRelationship;
  /** Shipper connection used to paginate results. */
  shippers: NlConsigneeShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type NlConsigneememosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type NlConsigneeshipperArgs = {
  shipperId: Scalars['ID'];
};


export type NlConsigneeshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type NlConsigneeEdge = ConnectionEdge & {
  __typename?: 'NlConsigneeEdge';
  cursor: Scalars['ID'];
  node: NlConsignee;
};

export type NlConsigneeSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type NlConsigneeSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'NlConsigneeSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type NlConsigneeShipperEdge = ConnectionEdge & {
  __typename?: 'NlConsigneeShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and NL Consignee. */
  relationship: ShipperNlConsigneeRelationship;
};

export type NlConsigneeShippersConnection = Connection & {
  __typename?: 'NlConsigneeShippersConnection';
  edges: Array<NlConsigneeShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlConsigneesConnection = Connection & {
  __typename?: 'NlConsigneesConnection';
  edges: Array<NlConsigneeEdge>;
  nodes: Array<NlConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlCustomsBroker = CustomsBroker & Party & Record & {
  __typename?: 'NlCustomsBroker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['NlEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this NL Customs Broker */
  shipper: ShipperNlCustomsBrokerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: NlCustomsBrokerShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type NlCustomsBrokermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type NlCustomsBrokershipperArgs = {
  shipperId: Scalars['ID'];
};


export type NlCustomsBrokershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type NlCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'NlCustomsBrokerEdge';
  cursor: Scalars['ID'];
  node: NlCustomsBroker;
};

export type NlCustomsBrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<NlEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type NlCustomsBrokerSearchTableRow = {
  __typename?: 'NlCustomsBrokerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['NlEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type NlCustomsBrokerShipperEdge = ConnectionEdge & {
  __typename?: 'NlCustomsBrokerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and NL Customs Broker. */
  relationship: ShipperNlCustomsBrokerRelationship;
};

export type NlCustomsBrokerShippersConnection = Connection & {
  __typename?: 'NlCustomsBrokerShippersConnection';
  edges: Array<NlCustomsBrokerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlCustomsBrokersConnection = Connection & {
  __typename?: 'NlCustomsBrokersConnection';
  edges: Array<NlCustomsBrokerEdge>;
  nodes: Array<NlCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlCustomsEntriesConnection = Connection & {
  __typename?: 'NlCustomsEntriesConnection';
  edges: Array<NlCustomsEntryEdge>;
  nodes: Array<NlCustomsEntry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlCustomsEntry = Record & WorkOrder & {
  __typename?: 'NlCustomsEntry';
  /** Arrival information */
  arrival?: Maybe<CustomsEntryArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker: NlCustomsEntryCustomsBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Consignee associated with this entry. */
  consignee?: Maybe<NlCustomsEntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance information. */
  conveyance: CustomsEntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<CustomsEntryDeparture>;
  /** The documents associated with the Nl Customs Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<NlCustomsEntryCommercialInvoice>>;
  /** IOR associated with this entry. */
  ior?: Maybe<NlCustomsEntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<CustomsEntryMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: Maybe<Array<Reference>>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: Maybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: Maybe<Scalars['Float']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type NlCustomsEntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type NlCustomsEntryCommercialInvoice = {
  __typename?: 'NlCustomsEntryCommercialInvoice';
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: Maybe<CustomsEntryBuyer>;
  /** Conveyance associated with the particular product. */
  conveyance?: Maybe<CustomsEntryConveyance>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: Maybe<Cost>;
  /** Commercial Invoice date */
  invoiceDate?: Maybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: Maybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<NlCustomsEntryProduct>>;
  /** Reason For Export */
  reasonsForExport?: Maybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<CustomsEntrySeller>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: Maybe<Cost>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: Maybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: Maybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type NlCustomsEntryCommercialInvoiceInput = {
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The Buyer of the products on the Commercial Invoice. */
  buyer?: InputMaybe<CustomsEntryBuyerInput>;
  /** Conveyance associated with the particular product. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: InputMaybe<CostInput>;
  /** Commercial Invoice date */
  invoiceDate?: InputMaybe<Scalars['Date']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: InputMaybe<Scalars['Int']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<NlCustomsEntryProductInput>>;
  /** Reason For Export */
  reasonsForExport?: InputMaybe<Array<ReasonForExport>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<CustomsEntrySellerInput>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: InputMaybe<CostInput>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: InputMaybe<Array<TermsOfSale>>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<Scalars['String']>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type NlCustomsEntryConsignee = {
  __typename?: 'NlCustomsEntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Consignee details */
  consignee?: Maybe<Consignee>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: Maybe<Scalars['String']>;
};

export type NlCustomsEntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id version of the Consignee */
  consignee?: InputMaybe<IdVersionInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. */
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type NlCustomsEntryCustomsBroker = {
  __typename?: 'NlCustomsEntryCustomsBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type NlCustomsEntryCustomsBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type NlCustomsEntryEdge = ConnectionEdge & {
  __typename?: 'NlCustomsEntryEdge';
  cursor: Scalars['ID'];
  node: NlCustomsEntry;
};

export type NlCustomsEntryIor = {
  __typename?: 'NlCustomsEntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Economic Operators Registration and Identification number. */
  eori?: Maybe<Scalars['NlEori']>;
  /** Ior party info which is stored in the record */
  ior?: Maybe<Ior>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['NlVatNumber']>;
};

export type NlCustomsEntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Economic Operators Registration and Identification number. */
  eori?: InputMaybe<Scalars['NlEori']>;
  /** Ior party info which is stored in the record */
  ior?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['NlVatNumber']>;
};

export type NlCustomsEntryLine = {
  __typename?: 'NlCustomsEntryLine';
  /** The line assist value. */
  assist?: Maybe<Cost>;
  /** The line assist percentage. */
  assistPercentage?: Maybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<CustomsEntrySupplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<NlCustomsEntryTariff>>;
  /** The line value. */
  value?: Maybe<Cost>;
};

export type NlCustomsEntryLineInput = {
  /** The line assist value. */
  assist?: InputMaybe<CostInput>;
  /** The line assist percentage. */
  assistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<CustomsEntrySupplierInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<NlCustomsEntryTariffInput>>;
  /** The line value. */
  value?: InputMaybe<CostInput>;
};

export type NlCustomsEntryProduct = {
  __typename?: 'NlCustomsEntryProduct';
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: Maybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Line items within the Product. */
  lines?: Maybe<Array<NlCustomsEntryLine>>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type NlCustomsEntryProductInput = {
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Containers associated with the particular product. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<NlCustomsEntryLineInput>>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type NlCustomsEntrySearchCriteriaInput = {
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the destination country. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<CustomsEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's port of unlading. */
  portOfUnlading?: InputMaybe<TextSearchCriteriaInput>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: InputMaybe<ReferenceErrorCodeSearchCriteriaInput>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: InputMaybe<ReferenceProcessingStatusSearchCriteriaInput>;
  /** The type of reference */
  referenceType?: InputMaybe<ReferenceTypeSearchCriteriaInput>;
  /** The reference value */
  referenceValue?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Nl Customs Entry Search Table Row */
export type NlCustomsEntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'NlCustomsEntrySearchTableRow';
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the destination country. */
  importDate?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port code representing the shipment's foreign port of lading. */
  portOfLading?: Maybe<Scalars['String']>;
  /** The shipment's port of unlading. */
  portOfUnlading?: Maybe<Scalars['String']>;
  /** The error code of processing failure for the reference */
  referenceErrorCode?: Maybe<Array<EntryReferenceErrorCode>>;
  /** The processing status of the reference number */
  referenceProcessingStatus?: Maybe<Array<EntryReferenceProcessingStatus>>;
  /** The type of reference */
  referenceType?: Maybe<Array<ReferenceType>>;
  /** The reference value */
  referenceValue?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Name of the service used for international transportation. For e.g. ATS, UPS */
  transportationServiceName?: Maybe<Array<Scalars['String']>>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumbers?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type NlCustomsEntryTariff = {
  __typename?: 'NlCustomsEntryTariff';
  /** The HTS record. */
  hts?: Maybe<Hts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type NlCustomsEntryTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

/** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
export type NlEoriSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['NlEori']>>;
};

export type NlIor = EuIor & Ior & Party & Record & {
  __typename?: 'NlIor';
  /** Broker activations details of NlIor. */
  activations?: Maybe<Array<NlIorActivationDetails>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: Maybe<BusinessStructure>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the NL IOR. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: Maybe<Scalars['NlEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this NL IOR */
  shipper: ShipperNlIorRelationship;
  /** Shipper connection used to paginate results. */
  shippers: NlIorShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: Maybe<Scalars['NlVatNumber']>;
  /** The record's version */
  version: Scalars['Int'];
};


export type NlIordocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type NlIormemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type NlIorshipperArgs = {
  shipperId: Scalars['ID'];
};


export type NlIorshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type NlIorActivation = Record & WorkOrder & {
  __typename?: 'NlIorActivation';
  /** NL Customs Broker associated with the activation. */
  broker: NlIorActivationBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the NL IOR Activation . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** NL IOR to be activated. */
  ior?: Maybe<NlIorActivationIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type NlIorActivationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type NlIorActivationBroker = {
  __typename?: 'NlIorActivationBroker';
  /** NL Customs Broker */
  customsBroker: NlCustomsBroker;
};

export type NlIorActivationBrokerInput = {
  /** ID of the NL Customs Broker */
  customsBroker: IdInput;
};

export type NlIorActivationDetails = {
  __typename?: 'NlIorActivationDetails';
  /** Importer activation meta data. */
  activated?: Maybe<RecordAction>;
  /** Broker representation for the Importer. */
  brokerRepresentation?: Maybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: NlCustomsBroker;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: Maybe<ExternalBrokerReference>;
  /** External Importer references. */
  externalIorReferences?: Maybe<Array<ExternalIorReference>>;
  /** Importer rejection meta data. */
  rejected?: Maybe<RecordAction>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: Maybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type NlIorActivationEdge = ConnectionEdge & {
  __typename?: 'NlIorActivationEdge';
  cursor: Scalars['ID'];
  node: NlIorActivation;
};

export type NlIorActivationIor = {
  __typename?: 'NlIorActivationIor';
  /** NlIor details */
  ior: NlIor;
};

export type NlIorActivationIorInput = {
  /** NlIor details */
  ior: IdOptionalVersionInput;
};

export type NlIorActivationSearchCriteriaInput = {
  /** IOR Activation Status. */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** Activation time of IOR. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The IOR ID */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Ior Name */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** NL IOR Activation search result */
export type NlIorActivationSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'NlIorActivationSearchTableRow';
  /** Activation status of EU IOR. */
  activationStatus?: Maybe<ActivationStatus>;
  /** Activation time of EU IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** The IOR ID */
  iorId?: Maybe<Scalars['ID']>;
  /** Ior Name */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type NlIorActivationsConnection = Connection & {
  __typename?: 'NlIorActivationsConnection';
  edges: Array<NlIorActivationEdge>;
  nodes: Array<NlIorActivation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlIorEdge = ConnectionEdge & {
  __typename?: 'NlIorEdge';
  cursor: Scalars['ID'];
  node: NlIor;
};

export type NlIorSearchCriteriaInput = {
  /** IOR activation status */
  activationStatus?: InputMaybe<ActivationStatusSearchCriteriaInput>;
  /** IOR activation time */
  activationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<NlEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<NlVatNumberSearchCriteriaInput>;
};

export type NlIorSearchTableRow = {
  __typename?: 'NlIorSearchTableRow';
  /** IOR Activation status */
  activationStatus?: Maybe<Array<ActivationStatus>>;
  /** IOR Activation time */
  activationTime?: Maybe<Array<Scalars['DateTime']>>;
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['NlEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The type industry of the Ior. */
  industry?: Maybe<Vertical>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber: Scalars['NlVatNumber'];
  /** Version */
  version: Scalars['Int'];
};

export type NlIorShipperEdge = ConnectionEdge & {
  __typename?: 'NlIorShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and NL IOR. */
  relationship: ShipperNlIorRelationship;
};

export type NlIorShippersConnection = Connection & {
  __typename?: 'NlIorShippersConnection';
  edges: Array<NlIorShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type NlIorsConnection = Connection & {
  __typename?: 'NlIorsConnection';
  edges: Array<NlIorEdge>;
  nodes: Array<NlIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
export type NlVatNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['NlVatNumber']>>;
};

/** Operators used for number based search operations. */
export enum NumberSearchOperator {
  BETWEEN = 'BETWEEN',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  EQUALS = 'EQUALS',
  EXISTS = 'EXISTS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  NOT_BETWEEN = 'NOT_BETWEEN'
}

/** Onboarding account type: shipper, forwarder. */
export enum OnboardingAccountType {
  FORWARDER = 'FORWARDER',
  SHIPPER = 'SHIPPER'
}

/** Onboarding Request of a External Customer */
export type OnboardingRequest = Record & {
  __typename?: 'OnboardingRequest';
  /** Onboarding account type */
  accountType: OnboardingAccountType;
  /** Avartar document (aka profile picture). */
  avatarDoc?: Maybe<Document>;
  /** User details from the Cognito User Pool. */
  cognito: CognitoUserDetails;
  /** Company related details. */
  companyDetails?: Maybe<CompanyDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Link returned to the user after they have created a new account, granting the ability to reset their password and login for the first time. */
  loginLink?: Maybe<Scalars['URL']>;
  /** Onboarding status. */
  onboardingStatus?: Maybe<OnboardingStatus>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Onboarding customer profile. */
  profileDetails?: Maybe<ProfileDetails>;
  /** Onboarding customer subscription plan details. */
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type OnboardingRequestEdge = ConnectionEdge & {
  __typename?: 'OnboardingRequestEdge';
  cursor: Scalars['ID'];
  node: OnboardingRequest;
};

export type OnboardingRequestSearchCriteriaInput = {
  /** Onboarding account type */
  accountType?: InputMaybe<AccountTypeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User email */
  email?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Customer name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** Onboarding status. */
  onboardingStatus?: InputMaybe<OnboardingStatusSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Customer title */
  title?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** The Onboarding customer's table search row. */
export type OnboardingRequestSearchTableRow = RecordSearchTableRow & UserSearchTableRow & {
  __typename?: 'OnboardingRequestSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The User's email. */
  email?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether or not a User is logged in. */
  loggedIn?: Maybe<Scalars['Boolean']>;
  /** Whether or not a User has Multi-Factor Authentication (MFA) enabled. */
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  /** The name of the User. */
  name?: Maybe<Scalars['String']>;
  /** The IDs of the teams the user is on */
  teamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the teams the user is on */
  teamName?: Maybe<Array<Scalars['String']>>;
  /** The title of the User. */
  title?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type OnboardingRequestsConnection = Connection & {
  __typename?: 'OnboardingRequestsConnection';
  edges: Array<OnboardingRequestEdge>;
  nodes: Array<OnboardingRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The status of customer's onboarding request. */
export enum OnboardingStatus {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED'
}

export type OnboardingStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<OnboardingStatus>>;
};

export type Operator = Account & Party & Record & {
  __typename?: 'Operator';
  /** Account details */
  accountDetails?: Maybe<AccountDetails>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type OperatormemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type OperatorEdge = ConnectionEdge & {
  __typename?: 'OperatorEdge';
  cursor: Scalars['ID'];
  node: Operator;
};

export type OperatorSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type OperatorSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'OperatorSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** External Client's Operator System. */
export type OperatorSystem = ExternalClient & ExternalSystem & Record & {
  __typename?: 'OperatorSystem';
  /** API Authorization Details. */
  authorization?: Maybe<ApiAuthorization>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration: ExternalSystemAwsIntegrationDetails;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: Maybe<ExternalSystemIntegrationDetails>;
  /** Unique ID */
  id: Scalars['ID'];
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications: Array<ExternalSystemNotificationPreference>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** URL to recieve events via webhook. */
  webhookUrl?: Maybe<Scalars['URL']>;
};

export type OperatorSystemEdge = ConnectionEdge & {
  __typename?: 'OperatorSystemEdge';
  cursor: Scalars['ID'];
  node: OperatorSystem;
};

export type OperatorSystemSearchCriteriaInput = {
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: InputMaybe<AwsAccountIdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The CustomsBroker's ID. */
  customsBrokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The CustomsBroker's name. */
  customsBrokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Notification preference for external system */
  externalSystemNotificationTypes?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The AWS IAM Role Name assumed by the External System to sign requests to the CBMS API. */
  iamRoleName?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External System. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** External Client's Operator System. */
export type OperatorSystemSearchTableRow = ExternalSystemSearchTableRow & RecordSearchTableRow & {
  __typename?: 'OperatorSystemSearchTableRow';
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the External System. */
  name?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type OperatorSystemsConnection = Connection & {
  __typename?: 'OperatorSystemsConnection';
  edges: Array<OperatorSystemEdge>;
  nodes: Array<OperatorSystem>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** User of a Operator */
export type OperatorUser = ExternalClient & Record & User & {
  __typename?: 'OperatorUser';
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: Maybe<Scalars['DateTime']>;
  assignmentConfig?: Maybe<AssignmentConfig>;
  /** A Assignment Team linked to this Operator User */
  assignmentTeam: AssignmentTeamOperatorUserRelationship;
  /** AssignmentTeam connection used to paginate results. */
  assignmentTeams: OperatorUserAssignmentTeamsConnection;
  /** User that operatorUser assume. Set null to stop assuming user. */
  assumedUser?: Maybe<User>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: Maybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: Maybe<Scalars['Boolean']>;
  /** A Business Support Team linked to this Operator User */
  businessSupportTeam: BusinessSupportTeamOperatorUserRelationship;
  /** BusinessSupportTeam connection used to paginate results. */
  businessSupportTeams: OperatorUserBusinessSupportTeamsConnection;
  /** User details from the Cognito User Pool. */
  cognito?: Maybe<CognitoUserDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Daily work order task completion goal set by managers */
  dailyGoal?: Maybe<Scalars['Int']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the OperatorUser. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Identity information provided by an external IDP such as Auth Portal */
  identity?: Maybe<Identity>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: Maybe<Scalars['Boolean']>;
  /** Link returned to the user after they have created a new account, granting the ability to reset their password and login for the first time. */
  loginLink?: Maybe<Scalars['URL']>;
  /** A mobile phone number. */
  mobilePhone?: Maybe<Phone>;
  /** External client name. */
  name: Scalars['String'];
  /** The operator's notification preferences. */
  notifications: Array<OperatorUserNotificationPreference>;
  /** A office phone number. */
  officePhone?: Maybe<Phone>;
  operator: Operator;
  /** The operator's permissions. */
  permissions?: Maybe<OperatorUserPermissions>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: Maybe<Scalars['Boolean']>;
  /** Skill level of operator users which will be assigned by managers */
  skillLevel?: Maybe<SkillLevel>;
  /** A Subject Matter Expert Team linked to this Operator User */
  subjectMatterExpertTeam: SubjectMatterExpertTeamOperatorUserRelationship;
  /** SubjectMatterExpertTeam connection used to paginate results. */
  subjectMatterExpertTeams: OperatorUserSubjectMatterExpertTeamsConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Used to specify the teamProperties of OperatorUser */
  teamProperties?: Maybe<Array<OperatorUserTeamProperty>>;
  /** The teams the user is on */
  teams?: Maybe<Array<Team>>;
  /** Title of the user */
  title: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  workingHours?: Maybe<UserWorkingHours>;
};


/** User of a Operator */
export type OperatorUserassignmentTeamArgs = {
  assignmentTeamId: Scalars['ID'];
};


/** User of a Operator */
export type OperatorUserassignmentTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


/** User of a Operator */
export type OperatorUserbusinessSupportTeamArgs = {
  businessSupportTeamId: Scalars['ID'];
};


/** User of a Operator */
export type OperatorUserbusinessSupportTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


/** User of a Operator */
export type OperatorUserdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** User of a Operator */
export type OperatorUsersubjectMatterExpertTeamArgs = {
  subjectMatterExpertTeamId: Scalars['ID'];
};


/** User of a Operator */
export type OperatorUsersubjectMatterExpertTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type OperatorUserAssignmentTeamEdge = ConnectionEdge & {
  __typename?: 'OperatorUserAssignmentTeamEdge';
  cursor: Scalars['ID'];
  /** The linked Assignment Team. */
  node: AssignmentTeam;
  /** The data on the link between the Assignment Team and Operator User. */
  relationship: AssignmentTeamOperatorUserRelationship;
};

export type OperatorUserAssignmentTeamPermission = {
  __typename?: 'OperatorUserAssignmentTeamPermission';
  /** The name of permission. */
  name: OperatorUserAssignmentTeamPermissionName;
};

export type OperatorUserAssignmentTeamPermissionInput = {
  /** The name of permission. */
  name: OperatorUserAssignmentTeamPermissionName;
};

export enum OperatorUserAssignmentTeamPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserAssignmentTeamStaticMappingPermission = {
  __typename?: 'OperatorUserAssignmentTeamStaticMappingPermission';
  /** The name of permission. */
  name: OperatorUserAssignmentTeamStaticMappingPermissionName;
};

export type OperatorUserAssignmentTeamStaticMappingPermissionInput = {
  /** The name of permission. */
  name: OperatorUserAssignmentTeamStaticMappingPermissionName;
};

export enum OperatorUserAssignmentTeamStaticMappingPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserAssignmentTeamsConnection = Connection & {
  __typename?: 'OperatorUserAssignmentTeamsConnection';
  edges: Array<OperatorUserAssignmentTeamEdge>;
  nodes: Array<AssignmentTeam>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type OperatorUserBrokerPermission = {
  __typename?: 'OperatorUserBrokerPermission';
  /** The name of permission. */
  name: OperatorUserBrokerPermissionName;
};

export type OperatorUserBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserBrokerPermissionName;
};

export enum OperatorUserBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserBulkChargesUploadRequestPermission = {
  __typename?: 'OperatorUserBulkChargesUploadRequestPermission';
  /** The name of permission. */
  name: OperatorUserBulkChargesUploadRequestPermissionName;
};

export type OperatorUserBulkChargesUploadRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserBulkChargesUploadRequestPermissionName;
};

export enum OperatorUserBulkChargesUploadRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserBulkComplianceUploadRequestPermission = {
  __typename?: 'OperatorUserBulkComplianceUploadRequestPermission';
  /** The name of permission. */
  name: OperatorUserBulkComplianceUploadRequestPermissionName;
};

export type OperatorUserBulkComplianceUploadRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserBulkComplianceUploadRequestPermissionName;
};

export enum OperatorUserBulkComplianceUploadRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserBulkMilestoneUploadRequestPermission = {
  __typename?: 'OperatorUserBulkMilestoneUploadRequestPermission';
  /** The name of permission. */
  name: OperatorUserBulkMilestoneUploadRequestPermissionName;
};

export type OperatorUserBulkMilestoneUploadRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserBulkMilestoneUploadRequestPermissionName;
};

export enum OperatorUserBulkMilestoneUploadRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserBulkProductUploadTemplateDocumentGenerationRequestPermission = {
  __typename?: 'OperatorUserBulkProductUploadTemplateDocumentGenerationRequestPermission';
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserBulkProductUploadTemplateDocumentGenerationRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserBusinessSupportTeamEdge = ConnectionEdge & {
  __typename?: 'OperatorUserBusinessSupportTeamEdge';
  cursor: Scalars['ID'];
  /** The linked Business Support Team. */
  node: BusinessSupportTeam;
  /** The data on the link between the Business Support Team and Operator User. */
  relationship: BusinessSupportTeamOperatorUserRelationship;
};

export type OperatorUserBusinessSupportTeamPermission = {
  __typename?: 'OperatorUserBusinessSupportTeamPermission';
  /** The name of permission. */
  name: OperatorUserBusinessSupportTeamPermissionName;
};

export type OperatorUserBusinessSupportTeamPermissionInput = {
  /** The name of permission. */
  name: OperatorUserBusinessSupportTeamPermissionName;
};

export enum OperatorUserBusinessSupportTeamPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserBusinessSupportTeamsConnection = Connection & {
  __typename?: 'OperatorUserBusinessSupportTeamsConnection';
  edges: Array<OperatorUserBusinessSupportTeamEdge>;
  nodes: Array<BusinessSupportTeam>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type OperatorUserCommodityGroupPermission = {
  __typename?: 'OperatorUserCommodityGroupPermission';
  /** The name of permission. */
  name: OperatorUserCommodityGroupPermissionName;
};

export type OperatorUserCommodityGroupPermissionInput = {
  /** The name of permission. */
  name: OperatorUserCommodityGroupPermissionName;
};

export enum OperatorUserCommodityGroupPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserCompanyPermission = {
  __typename?: 'OperatorUserCompanyPermission';
  /** The name of permission. */
  name: OperatorUserCompanyPermissionName;
};

export type OperatorUserCompanyPermissionInput = {
  /** The name of permission. */
  name: OperatorUserCompanyPermissionName;
};

export enum OperatorUserCompanyPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserCustomsAgentPermission = {
  __typename?: 'OperatorUserCustomsAgentPermission';
  /** The name of permission. */
  name: OperatorUserCustomsAgentPermissionName;
};

export type OperatorUserCustomsAgentPermissionInput = {
  /** The name of permission. */
  name: OperatorUserCustomsAgentPermissionName;
};

export enum OperatorUserCustomsAgentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserCustomsBrokerPermission = {
  __typename?: 'OperatorUserCustomsBrokerPermission';
  /** The name of permission. */
  name: OperatorUserCustomsBrokerPermissionName;
};

export type OperatorUserCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserCustomsBrokerPermissionName;
};

export enum OperatorUserCustomsBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserCustomsDeclarationPermission = {
  __typename?: 'OperatorUserCustomsDeclarationPermission';
  /** The name of permission. */
  name: OperatorUserCustomsDeclarationPermissionName;
};

export type OperatorUserCustomsDeclarationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserCustomsDeclarationPermissionName;
};

export enum OperatorUserCustomsDeclarationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserCustomsEntryPermission = {
  __typename?: 'OperatorUserCustomsEntryPermission';
  /** The name of permission. */
  name: OperatorUserCustomsEntryPermissionName;
};

export type OperatorUserCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserCustomsEntryPermissionName;
};

export enum OperatorUserCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDeConsigneePermission = {
  __typename?: 'OperatorUserDeConsigneePermission';
  /** The name of permission. */
  name: OperatorUserDeConsigneePermissionName;
};

export type OperatorUserDeConsigneePermissionInput = {
  /** The name of permission. */
  name: OperatorUserDeConsigneePermissionName;
};

export enum OperatorUserDeConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDeCustomsBrokerPermission = {
  __typename?: 'OperatorUserDeCustomsBrokerPermission';
  /** The name of permission. */
  name: OperatorUserDeCustomsBrokerPermissionName;
};

export type OperatorUserDeCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserDeCustomsBrokerPermissionName;
};

export enum OperatorUserDeCustomsBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDeCustomsEntryPermission = {
  __typename?: 'OperatorUserDeCustomsEntryPermission';
  /** The name of permission. */
  name: OperatorUserDeCustomsEntryPermissionName;
};

export type OperatorUserDeCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserDeCustomsEntryPermissionName;
};

export enum OperatorUserDeCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDeIorActivationPermission = {
  __typename?: 'OperatorUserDeIorActivationPermission';
  /** The name of permission. */
  name: OperatorUserDeIorActivationPermissionName;
};

export type OperatorUserDeIorActivationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserDeIorActivationPermissionName;
};

export enum OperatorUserDeIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDeIorPermission = {
  __typename?: 'OperatorUserDeIorPermission';
  /** The name of permission. */
  name: OperatorUserDeIorPermissionName;
};

export type OperatorUserDeIorPermissionInput = {
  /** The name of permission. */
  name: OperatorUserDeIorPermissionName;
};

export enum OperatorUserDeIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDeliveryOrderPermission = {
  __typename?: 'OperatorUserDeliveryOrderPermission';
  /** The name of permission. */
  name: OperatorUserDeliveryOrderPermissionName;
};

export type OperatorUserDeliveryOrderPermissionInput = {
  /** The name of permission. */
  name: OperatorUserDeliveryOrderPermissionName;
};

export enum OperatorUserDeliveryOrderPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDocumentPermission = {
  __typename?: 'OperatorUserDocumentPermission';
  /** The name of permission. */
  name: OperatorUserDocumentPermissionName;
};

export type OperatorUserDocumentPermissionInput = {
  /** The name of permission. */
  name: OperatorUserDocumentPermissionName;
};

export enum OperatorUserDocumentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserDocumentTemplatePermission = {
  __typename?: 'OperatorUserDocumentTemplatePermission';
  /** The name of permission. */
  name: OperatorUserDocumentTemplatePermissionName;
};

export type OperatorUserDocumentTemplatePermissionInput = {
  /** The name of permission. */
  name: OperatorUserDocumentTemplatePermissionName;
};

export enum OperatorUserDocumentTemplatePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserEdge = ConnectionEdge & {
  __typename?: 'OperatorUserEdge';
  cursor: Scalars['ID'];
  node: OperatorUser;
};

export type OperatorUserExchangeMessagePermission = {
  __typename?: 'OperatorUserExchangeMessagePermission';
  /** The name of permission. */
  name: OperatorUserExchangeMessagePermissionName;
};

export type OperatorUserExchangeMessagePermissionInput = {
  /** The name of permission. */
  name: OperatorUserExchangeMessagePermissionName;
};

export enum OperatorUserExchangeMessagePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserFacilityPermission = {
  __typename?: 'OperatorUserFacilityPermission';
  /** The name of permission. */
  name: OperatorUserFacilityPermissionName;
};

export type OperatorUserFacilityPermissionInput = {
  /** The name of permission. */
  name: OperatorUserFacilityPermissionName;
};

export enum OperatorUserFacilityPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserForwarderPermission = {
  __typename?: 'OperatorUserForwarderPermission';
  /** The name of permission. */
  name: OperatorUserForwarderPermissionName;
};

export type OperatorUserForwarderPermissionInput = {
  /** The name of permission. */
  name: OperatorUserForwarderPermissionName;
};

export enum OperatorUserForwarderPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserFrConsigneePermission = {
  __typename?: 'OperatorUserFrConsigneePermission';
  /** The name of permission. */
  name: OperatorUserFrConsigneePermissionName;
};

export type OperatorUserFrConsigneePermissionInput = {
  /** The name of permission. */
  name: OperatorUserFrConsigneePermissionName;
};

export enum OperatorUserFrConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserFrCustomsBrokerPermission = {
  __typename?: 'OperatorUserFrCustomsBrokerPermission';
  /** The name of permission. */
  name: OperatorUserFrCustomsBrokerPermissionName;
};

export type OperatorUserFrCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserFrCustomsBrokerPermissionName;
};

export enum OperatorUserFrCustomsBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserFrCustomsEntryPermission = {
  __typename?: 'OperatorUserFrCustomsEntryPermission';
  /** The name of permission. */
  name: OperatorUserFrCustomsEntryPermissionName;
};

export type OperatorUserFrCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserFrCustomsEntryPermissionName;
};

export enum OperatorUserFrCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserFrIorActivationPermission = {
  __typename?: 'OperatorUserFrIorActivationPermission';
  /** The name of permission. */
  name: OperatorUserFrIorActivationPermissionName;
};

export type OperatorUserFrIorActivationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserFrIorActivationPermissionName;
};

export enum OperatorUserFrIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserFrIorPermission = {
  __typename?: 'OperatorUserFrIorPermission';
  /** The name of permission. */
  name: OperatorUserFrIorPermissionName;
};

export type OperatorUserFrIorPermissionInput = {
  /** The name of permission. */
  name: OperatorUserFrIorPermissionName;
};

export enum OperatorUserFrIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserGbConsigneePermission = {
  __typename?: 'OperatorUserGbConsigneePermission';
  /** The name of permission. */
  name: OperatorUserGbConsigneePermissionName;
};

export type OperatorUserGbConsigneePermissionInput = {
  /** The name of permission. */
  name: OperatorUserGbConsigneePermissionName;
};

export enum OperatorUserGbConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserGbCustomsEntryPermission = {
  __typename?: 'OperatorUserGbCustomsEntryPermission';
  /** The name of permission. */
  name: OperatorUserGbCustomsEntryPermissionName;
};

export type OperatorUserGbCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserGbCustomsEntryPermissionName;
};

export enum OperatorUserGbCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserGbIorActivationPermission = {
  __typename?: 'OperatorUserGbIorActivationPermission';
  /** The name of permission. */
  name: OperatorUserGbIorActivationPermissionName;
};

export type OperatorUserGbIorActivationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserGbIorActivationPermissionName;
};

export enum OperatorUserGbIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserGbIorPermission = {
  __typename?: 'OperatorUserGbIorPermission';
  /** The name of permission. */
  name: OperatorUserGbIorPermissionName;
};

export type OperatorUserGbIorPermissionInput = {
  /** The name of permission. */
  name: OperatorUserGbIorPermissionName;
};

export enum OperatorUserGbIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserGlobalConsigneePermission = {
  __typename?: 'OperatorUserGlobalConsigneePermission';
  /** The name of permission. */
  name: OperatorUserGlobalConsigneePermissionName;
};

export type OperatorUserGlobalConsigneePermissionInput = {
  /** The name of permission. */
  name: OperatorUserGlobalConsigneePermissionName;
};

export enum OperatorUserGlobalConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserImportProductsFromBulkUploadRequestPermission = {
  __typename?: 'OperatorUserImportProductsFromBulkUploadRequestPermission';
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserImportProductsFromBulkUploadRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserImportProductsFromCustomsEntriesRequestPermission = {
  __typename?: 'OperatorUserImportProductsFromCustomsEntriesRequestPermission';
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserImportProductsFromCustomsEntriesRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserImporterEntityActivationPermission = {
  __typename?: 'OperatorUserImporterEntityActivationPermission';
  /** The name of permission. */
  name: OperatorUserImporterEntityActivationPermissionName;
};

export type OperatorUserImporterEntityActivationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserImporterEntityActivationPermissionName;
};

export enum OperatorUserImporterEntityActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserImporterEntityPermission = {
  __typename?: 'OperatorUserImporterEntityPermission';
  /** The name of permission. */
  name: OperatorUserImporterEntityPermissionName;
};

export type OperatorUserImporterEntityPermissionInput = {
  /** The name of permission. */
  name: OperatorUserImporterEntityPermissionName;
};

export enum OperatorUserImporterEntityPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserImporterPermission = {
  __typename?: 'OperatorUserImporterPermission';
  /** The name of permission. */
  name: OperatorUserImporterPermissionName;
};

export type OperatorUserImporterPermissionInput = {
  /** The name of permission. */
  name: OperatorUserImporterPermissionName;
};

export enum OperatorUserImporterPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserInvoiceLinesRequestPermission = {
  __typename?: 'OperatorUserInvoiceLinesRequestPermission';
  /** The name of permission. */
  name: OperatorUserInvoiceLinesRequestPermissionName;
};

export type OperatorUserInvoiceLinesRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserInvoiceLinesRequestPermissionName;
};

export enum OperatorUserInvoiceLinesRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserInvoicePermission = {
  __typename?: 'OperatorUserInvoicePermission';
  /** The name of permission. */
  name: OperatorUserInvoicePermissionName;
};

export type OperatorUserInvoicePermissionInput = {
  /** The name of permission. */
  name: OperatorUserInvoicePermissionName;
};

export enum OperatorUserInvoicePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserMemoPermission = {
  __typename?: 'OperatorUserMemoPermission';
  /** The name of permission. */
  name: OperatorUserMemoPermissionName;
};

export enum OperatorUserMemoPermissionName {
  DELETE = 'DELETE',
  READ = 'READ'
}

export type OperatorUserMemoPermissionNameInput = {
  /** The name of permission. */
  name: OperatorUserMemoPermissionName;
};

export type OperatorUserNlConsigneePermission = {
  __typename?: 'OperatorUserNlConsigneePermission';
  /** The name of permission. */
  name: OperatorUserNlConsigneePermissionName;
};

export type OperatorUserNlConsigneePermissionInput = {
  /** The name of permission. */
  name: OperatorUserNlConsigneePermissionName;
};

export enum OperatorUserNlConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserNlCustomsBrokerPermission = {
  __typename?: 'OperatorUserNlCustomsBrokerPermission';
  /** The name of permission. */
  name: OperatorUserNlCustomsBrokerPermissionName;
};

export type OperatorUserNlCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserNlCustomsBrokerPermissionName;
};

export enum OperatorUserNlCustomsBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserNlCustomsEntryPermission = {
  __typename?: 'OperatorUserNlCustomsEntryPermission';
  /** The name of permission. */
  name: OperatorUserNlCustomsEntryPermissionName;
};

export type OperatorUserNlCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserNlCustomsEntryPermissionName;
};

export enum OperatorUserNlCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserNlIorActivationPermission = {
  __typename?: 'OperatorUserNlIorActivationPermission';
  /** The name of permission. */
  name: OperatorUserNlIorActivationPermissionName;
};

export type OperatorUserNlIorActivationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserNlIorActivationPermissionName;
};

export enum OperatorUserNlIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserNlIorPermission = {
  __typename?: 'OperatorUserNlIorPermission';
  /** The name of permission. */
  name: OperatorUserNlIorPermissionName;
};

export type OperatorUserNlIorPermissionInput = {
  /** The name of permission. */
  name: OperatorUserNlIorPermissionName;
};

export enum OperatorUserNlIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

/** The notification method for an operator user. */
export enum OperatorUserNotificationMethod {
  CBMS_WEBSITE = 'CBMS_WEBSITE',
  EMAIL = 'EMAIL'
}

export type OperatorUserNotificationPreference = {
  __typename?: 'OperatorUserNotificationPreference';
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<OperatorUserNotificationMethod>;
  /** The type of the notification. */
  type: OperatorUserNotificationType;
};

export type OperatorUserNotificationPreferenceInput = {
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<OperatorUserNotificationMethod>;
  /** The type of the notification. */
  type: OperatorUserNotificationType;
};

/** The notification type for an operator user. */
export enum OperatorUserNotificationType {
  BULK_DOCUMENT_DOWNLOAD = 'BULK_DOCUMENT_DOWNLOAD',
  DAILY_STATEMENT = 'DAILY_STATEMENT',
  DIS_STATUS_UPDATE = 'DIS_STATUS_UPDATE',
  DO_ISSUED = 'DO_ISSUED',
  FORWARDER_INVITE_ACCEPTED = 'FORWARDER_INVITE_ACCEPTED',
  MONTHLY_STATEMENT = 'MONTHLY_STATEMENT',
  PMS_APPROVED = 'PMS_APPROVED',
  SHIPMENT_CANCELED = 'SHIPMENT_CANCELED',
  SHIPMENT_CREATED = 'SHIPMENT_CREATED',
  SHIPMENT_CREATED_NO_ACTION = 'SHIPMENT_CREATED_NO_ACTION',
  SHIPMENT_FORWARDER_TAGGED = 'SHIPMENT_FORWARDER_TAGGED',
  SHIPMENT_UPDATED = 'SHIPMENT_UPDATED',
  TRIAL_ABOUT_TO_END = 'TRIAL_ABOUT_TO_END',
  USER_INVITED = 'USER_INVITED',
  USER_INVITE_ACCEPTED = 'USER_INVITE_ACCEPTED',
  US_CONSUMPTION_ENTRY_CBP_EXAM = 'US_CONSUMPTION_ENTRY_CBP_EXAM',
  US_CONSUMPTION_ENTRY_CBP_HOLD = 'US_CONSUMPTION_ENTRY_CBP_HOLD',
  US_CONSUMPTION_ENTRY_CBP_RELEASE = 'US_CONSUMPTION_ENTRY_CBP_RELEASE',
  US_CONSUMPTION_ENTRY_FILED = 'US_CONSUMPTION_ENTRY_FILED',
  US_CONSUMPTION_ENTRY_PGA_HOLD = 'US_CONSUMPTION_ENTRY_PGA_HOLD',
  US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_CONSUMPTION_ENTRY_PGA_REJECTED = 'US_CONSUMPTION_ENTRY_PGA_REJECTED',
  US_CONSUMPTION_ENTRY_PGA_RELEASE = 'US_CONSUMPTION_ENTRY_PGA_RELEASE',
  US_CONSUMPTION_ENTRY_REJECTED_REASONS = 'US_CONSUMPTION_ENTRY_REJECTED_REASONS',
  US_CONSUMPTION_ENTRY_REVISED = 'US_CONSUMPTION_ENTRY_REVISED',
  US_IN_BOND_ARRIVED = 'US_IN_BOND_ARRIVED',
  US_IN_BOND_AUTHORIZED = 'US_IN_BOND_AUTHORIZED',
  US_IN_BOND_BILL_ARRIVED = 'US_IN_BOND_BILL_ARRIVED',
  US_IN_BOND_BILL_EXPORTED = 'US_IN_BOND_BILL_EXPORTED',
  US_IN_BOND_CONTAINER_ARRIVED = 'US_IN_BOND_CONTAINER_ARRIVED',
  US_IN_BOND_CONTAINER_EXPORTED = 'US_IN_BOND_CONTAINER_EXPORTED',
  US_IN_BOND_DIVERSION = 'US_IN_BOND_DIVERSION',
  US_IN_BOND_TRANSFERRED = 'US_IN_BOND_TRANSFERRED',
  US_ISF_BILL_MATCH = 'US_ISF_BILL_MATCH',
  US_ISF_FILED = 'US_ISF_FILED',
  US_ISF_NO_BILL_MATCH = 'US_ISF_NO_BILL_MATCH',
  US_ISF_REJECTED = 'US_ISF_REJECTED',
  US_POST_SUMMARY_CORRECTION_APPROVED = 'US_POST_SUMMARY_CORRECTION_APPROVED',
  US_POST_SUMMARY_CORRECTION_CREATED = 'US_POST_SUMMARY_CORRECTION_CREATED',
  US_POST_SUMMARY_CORRECTION_FILED = 'US_POST_SUMMARY_CORRECTION_FILED',
  US_POST_SUMMARY_CORRECTION_REJECTED = 'US_POST_SUMMARY_CORRECTION_REJECTED',
  US_POST_SUMMARY_CORRECTION_SUBMITTED = 'US_POST_SUMMARY_CORRECTION_SUBMITTED',
  US_TYPE86_ENTRY_CBP_EXAM = 'US_TYPE86_ENTRY_CBP_EXAM',
  US_TYPE86_ENTRY_CBP_HOLD = 'US_TYPE86_ENTRY_CBP_HOLD',
  US_TYPE86_ENTRY_CBP_RELEASE = 'US_TYPE86_ENTRY_CBP_RELEASE',
  US_TYPE86_ENTRY_FILED = 'US_TYPE86_ENTRY_FILED',
  US_TYPE86_ENTRY_PGA_HOLD = 'US_TYPE86_ENTRY_PGA_HOLD',
  US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_TYPE86_ENTRY_PGA_REJECTED = 'US_TYPE86_ENTRY_PGA_REJECTED',
  US_TYPE86_ENTRY_PGA_RELEASE = 'US_TYPE86_ENTRY_PGA_RELEASE'
}

export type OperatorUserOperatorUserPermission = {
  __typename?: 'OperatorUserOperatorUserPermission';
  /** The name of permission. */
  name: OperatorUserOperatorUserPermissionName;
};

export type OperatorUserOperatorUserPermissionInput = {
  /** The name of permission. */
  name: OperatorUserOperatorUserPermissionName;
};

export enum OperatorUserOperatorUserPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserPayableInvoicePermission = {
  __typename?: 'OperatorUserPayableInvoicePermission';
  /** The name of permission. */
  name: OperatorUserPayableInvoicePermissionName;
};

export type OperatorUserPayableInvoicePermissionInput = {
  /** The name of permission. */
  name: OperatorUserPayableInvoicePermissionName;
};

export enum OperatorUserPayableInvoicePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserPermissions = {
  __typename?: 'OperatorUserPermissions';
  /** The operator's permission to Team. */
  assignmentTeam?: Maybe<Array<OperatorUserAssignmentTeamPermission>>;
  /** The operator's permission to AssignmentTeamStaticMapping. */
  assignmentTeamStaticMapping?: Maybe<Array<OperatorUserAssignmentTeamStaticMappingPermission>>;
  /** The operator's permission to Broker. */
  broker?: Maybe<Array<OperatorUserBrokerPermission>>;
  /** The operator's permission to bulkChargesUploadRequest. */
  bulkChargesUploadRequest?: Maybe<Array<OperatorUserBulkChargesUploadRequestPermission>>;
  /** The operator's permission to bulkComplianceUploadRequest. */
  bulkComplianceUploadRequest?: Maybe<Array<OperatorUserBulkComplianceUploadRequestPermission>>;
  /** The operator's permission to bulkMilestoneUploadRequest. */
  bulkMilestoneUploadRequest?: Maybe<Array<OperatorUserBulkMilestoneUploadRequestPermission>>;
  /** The operator's permission to BulkProductUploadTemplateDocumentGenerationRequest. */
  bulkProductUploadTemplateDocumentGenerationRequest?: Maybe<Array<OperatorUserBulkProductUploadTemplateDocumentGenerationRequestPermission>>;
  /** The operator's permission to Team. */
  businessSupportTeam?: Maybe<Array<OperatorUserBusinessSupportTeamPermission>>;
  /** The operator's permission to CommodityGroup. */
  commodityGroup?: Maybe<Array<OperatorUserCommodityGroupPermission>>;
  /** The operator's permission to Operator. */
  company?: Maybe<Array<OperatorUserCompanyPermission>>;
  /** The operator's permission to CustomsAgent. */
  customsAgent?: Maybe<Array<OperatorUserCustomsAgentPermission>>;
  /** The operator's permission to CustomsBroker. */
  customsBroker?: Maybe<Array<OperatorUserCustomsBrokerPermission>>;
  /** The operator's permission to CustomsDeclaration. */
  customsDeclaration?: Maybe<Array<OperatorUserCustomsDeclarationPermission>>;
  /** The operator's permission to CustomsEntry. */
  customsEntry?: Maybe<Array<OperatorUserCustomsEntryPermission>>;
  /** The operator's permission to DeConsignee. */
  deConsignee?: Maybe<Array<OperatorUserDeConsigneePermission>>;
  /** The operator's permission to DeCustomsBroker. */
  deCustomsBroker?: Maybe<Array<OperatorUserDeCustomsBrokerPermission>>;
  /** The operator's permission to DeCustomsEntry. */
  deCustomsEntry?: Maybe<Array<OperatorUserDeCustomsEntryPermission>>;
  /** The operator's permission to DeIor. */
  deIor?: Maybe<Array<OperatorUserDeIorPermission>>;
  /** The operator's permission to DeIorActivation. */
  deIorActivation?: Maybe<Array<OperatorUserDeIorActivationPermission>>;
  /** The operator's permission to DeliveryOrder. */
  deliveryOrder?: Maybe<Array<OperatorUserDeliveryOrderPermission>>;
  /** The operator's permission to Document. */
  document?: Maybe<Array<OperatorUserDocumentPermission>>;
  /** The operator's permission to DocumentTemplate. */
  documentTemplate?: Maybe<Array<OperatorUserDocumentTemplatePermission>>;
  /** The operator's permission to exchangeMessage. */
  exchangeMessage?: Maybe<Array<OperatorUserExchangeMessagePermission>>;
  /** The operator's permission to Facility. */
  facility?: Maybe<Array<OperatorUserFacilityPermission>>;
  /** The operator's permission to Forwarder. */
  forwarder?: Maybe<Array<OperatorUserForwarderPermission>>;
  /** The operator's permission to FrConsignee. */
  frConsignee?: Maybe<Array<OperatorUserFrConsigneePermission>>;
  /** The operator's permission to FrCustomsBroker. */
  frCustomsBroker?: Maybe<Array<OperatorUserFrCustomsBrokerPermission>>;
  /** The operator's permission to FrCustomsEntry. */
  frCustomsEntry?: Maybe<Array<OperatorUserFrCustomsEntryPermission>>;
  /** The operator's permission to FrIor. */
  frIor?: Maybe<Array<OperatorUserFrIorPermission>>;
  /** The operator's permission to FrIorActivation. */
  frIorActivation?: Maybe<Array<OperatorUserFrIorActivationPermission>>;
  /** The operator's permission to GbConsignee. */
  gbConsignee?: Maybe<Array<OperatorUserGbConsigneePermission>>;
  /** The operator's permission to GbCustomsEntry. */
  gbCustomsEntry?: Maybe<Array<OperatorUserGbCustomsEntryPermission>>;
  /** The operator's permission to GbIor. */
  gbIor?: Maybe<Array<OperatorUserGbIorPermission>>;
  /** The operator's permission to GbIorActivation. */
  gbIorActivation?: Maybe<Array<OperatorUserGbIorActivationPermission>>;
  /** The operator's permission to GlobalConsignee. */
  globalConsignee?: Maybe<Array<OperatorUserGlobalConsigneePermission>>;
  /** The operator's permission to ImportProductsFromBulkUploadRequest. */
  importProductsFromBulkUploadRequest?: Maybe<Array<OperatorUserImportProductsFromBulkUploadRequestPermission>>;
  /** The operator's permission to ImportProductsFromCustomsEntriesRequest. */
  importProductsFromCustomsEntriesRequest?: Maybe<Array<OperatorUserImportProductsFromCustomsEntriesRequestPermission>>;
  /** The operator's permission to Importer. */
  importer?: Maybe<Array<OperatorUserImporterPermission>>;
  /** The operator's permission to ImporterEntity. */
  importerEntity?: Maybe<Array<OperatorUserImporterEntityPermission>>;
  /** The operator's permission to ImporterEntityActivation. */
  importerEntityActivation?: Maybe<Array<OperatorUserImporterEntityActivationPermission>>;
  /** The operator's permission to Invoice. */
  invoice?: Maybe<Array<OperatorUserInvoicePermission>>;
  /** The operator's permission to InvoiceLinesRequest. */
  invoiceLinesRequest?: Maybe<Array<OperatorUserInvoiceLinesRequestPermission>>;
  /** The operator's permission to Memo. */
  memo?: Maybe<Array<OperatorUserMemoPermission>>;
  /** The operator's permission to NlConsignee. */
  nlConsignee?: Maybe<Array<OperatorUserNlConsigneePermission>>;
  /** The operator's permission to NlCustomsBroker. */
  nlCustomsBroker?: Maybe<Array<OperatorUserNlCustomsBrokerPermission>>;
  /** The operator's permission to NlCustomsEntry. */
  nlCustomsEntry?: Maybe<Array<OperatorUserNlCustomsEntryPermission>>;
  /** The operator's permission to NlIor. */
  nlIor?: Maybe<Array<OperatorUserNlIorPermission>>;
  /** The operator's permission to NlIorActivation. */
  nlIorActivation?: Maybe<Array<OperatorUserNlIorActivationPermission>>;
  /** The operator's permission to User. */
  operatorUser?: Maybe<Array<OperatorUserOperatorUserPermission>>;
  /** The operator's permission to PayableInvoice. */
  payableInvoice?: Maybe<Array<OperatorUserPayableInvoicePermission>>;
  /** The operator's permission to Product. */
  product?: Maybe<Array<OperatorUserProductPermission>>;
  /** The operator's permission to ReleaseNote. */
  releaseNote?: Maybe<Array<OperatorUserReleaseNotePermission>>;
  /** The operator's permission to reportReconciliationRequest. */
  reportReconciliationRequest?: Maybe<Array<OperatorUserReportReconciliationRequestPermission>>;
  /** The operator's permission to Shipment. */
  shipment?: Maybe<Array<OperatorUserShipmentPermission>>;
  /** The operator's permission to Shipper. */
  shipper?: Maybe<Array<OperatorUserShipperPermission>>;
  /** The operator's permission to Supplier. */
  supplier?: Maybe<Array<OperatorUserSupplierPermission>>;
  /** The operator's permission to Trucker. */
  trucker?: Maybe<Array<OperatorUserSupplierPermission>>;
  /** The operator's permission to UkCustomsBroker. */
  ukCustomsBroker?: Maybe<Array<OperatorUserUkCustomsBrokerPermission>>;
  /** The operator's permission to UsConsignee. */
  usConsignee?: Maybe<Array<OperatorUserUsConsigneePermission>>;
  /** The operator's permission to UsConsumptionEntry. */
  usConsumptionEntry?: Maybe<Array<OperatorUserUsConsumptionEntryPermission>>;
  /** The operator's permission to UsCustomsBroker. */
  usCustomsBroker?: Maybe<Array<OperatorUserUsCustomsBrokerPermission>>;
  /** The operator's permission to UsDrawbackClaim. */
  usDrawbackClaim?: Maybe<Array<OperatorUserUsDrawbackClaimPermission>>;
  /** The operator's permission to UsHts. */
  usHts?: Maybe<Array<OperatorUserUsHtsPermission>>;
  /** The operator's permission to UsInBond. */
  usInBond?: Maybe<Array<OperatorUserUsInBondPermission>>;
  /** The operator's permission to UsIor. */
  usIor?: Maybe<Array<OperatorUserUsIorPermission>>;
  /** The operator's permission to UsIorActivation. */
  usIorActivation?: Maybe<Array<OperatorUserUsIorActivationPermission>>;
  /** The operator's permission to UsIorContinuousBondRequest. */
  usIorContinuousBondRequest?: Maybe<Array<OperatorUserUsIorContinuousBondRequestPermission>>;
  /** The operator's permission to UsIsf. */
  usIsf?: Maybe<Array<OperatorUserUsIsfPermission>>;
  /** The operator's permission to UsPostSummaryCorrection. */
  usPostSummaryCorrection?: Maybe<Array<OperatorUserUsPostSummaryCorrectionPermission>>;
  /** The operator's permission to UsType86Entry. */
  usType86Entry?: Maybe<Array<OperatorUserUsType86EntryPermission>>;
  /** The operator's permission to UserReleaseNoteView. */
  userReleaseNoteView?: Maybe<Array<OperatorUserUserReleaseNoteViewPermission>>;
  /** The operator's permission to WorkOrderTask. */
  workOrderTask?: Maybe<Array<OperatorUserWorkOrderTaskPermission>>;
  /** The operator's permission to workOrderTaskEcalationMessage. */
  workOrderTaskEscalationMessage?: Maybe<Array<OperatorUserWorkOrderTaskEscalationMessagePermission>>;
};

export type OperatorUserPermissionsInput = {
  /** The operator's permission to Team. */
  assignmentTeam?: InputMaybe<Array<OperatorUserAssignmentTeamPermissionInput>>;
  /** The operator's permission to AssignmentTeamStaticMapping. */
  assignmentTeamStaticMapping?: InputMaybe<Array<OperatorUserAssignmentTeamStaticMappingPermissionInput>>;
  /** The operator's permission to Broker. */
  broker?: InputMaybe<Array<OperatorUserBrokerPermissionInput>>;
  /** The operator's permission to bulkChargesUploadRequest. */
  bulkChargesUploadRequest?: InputMaybe<Array<OperatorUserBulkChargesUploadRequestPermissionInput>>;
  /** The operator's permission to bulkComplianceUploadRequest. */
  bulkComplianceUploadRequest?: InputMaybe<Array<OperatorUserBulkComplianceUploadRequestPermissionInput>>;
  /** The operator's permission to bulkMilestoneUploadRequest. */
  bulkMilestoneUploadRequest?: InputMaybe<Array<OperatorUserBulkMilestoneUploadRequestPermissionInput>>;
  /** The operator's permission to BulkProductUploadTemplateDocumentGenerationRequest. */
  bulkProductUploadTemplateDocumentGenerationRequest?: InputMaybe<Array<OperatorUserBulkProductUploadTemplateDocumentGenerationRequestPermissionInput>>;
  /** The operator's permission to Team. */
  businessSupportTeam?: InputMaybe<Array<OperatorUserBusinessSupportTeamPermissionInput>>;
  /** The operator's permission to CommodityGroup. */
  commodityGroup?: InputMaybe<Array<OperatorUserCommodityGroupPermissionInput>>;
  /** The operator's permission to Operator. */
  company?: InputMaybe<Array<OperatorUserCompanyPermissionInput>>;
  /** The operator's permission to CustomsAgent. */
  customsAgent?: InputMaybe<Array<OperatorUserCustomsAgentPermissionInput>>;
  /** The operator's permission to CustomsBroker. */
  customsBroker?: InputMaybe<Array<OperatorUserCustomsBrokerPermissionInput>>;
  /** The operator's permission to CustomsDeclaration. */
  customsDeclaration?: InputMaybe<Array<OperatorUserCustomsDeclarationPermissionInput>>;
  /** The operator's permission to CustomsEntry. */
  customsEntry?: InputMaybe<Array<OperatorUserCustomsEntryPermissionInput>>;
  /** The operator's permission to DeConsignee. */
  deConsignee?: InputMaybe<Array<OperatorUserDeConsigneePermissionInput>>;
  /** The operator's permission to DeCustomsBroker. */
  deCustomsBroker?: InputMaybe<Array<OperatorUserDeCustomsBrokerPermissionInput>>;
  /** The operator's permission to DeCustomsEntry. */
  deCustomsEntry?: InputMaybe<Array<OperatorUserDeCustomsEntryPermissionInput>>;
  /** The operator's permission to DeIor. */
  deIor?: InputMaybe<Array<OperatorUserDeIorPermissionInput>>;
  /** The operator's permission to DeIorActivation. */
  deIorActivation?: InputMaybe<Array<OperatorUserDeIorActivationPermissionInput>>;
  /** The operator's permission to DeliveryOrder. */
  deliveryOrder?: InputMaybe<Array<OperatorUserDeliveryOrderPermissionInput>>;
  /** The operator's permission to Document. */
  document?: InputMaybe<Array<OperatorUserDocumentPermissionInput>>;
  /** The operator's permission to DocumentTemplate. */
  documentTemplate?: InputMaybe<Array<OperatorUserDocumentTemplatePermissionInput>>;
  /** The operator's permission to exchangeMessage. */
  exchangeMessage?: InputMaybe<Array<OperatorUserExchangeMessagePermissionInput>>;
  /** The operator's permission to Facility. */
  facility?: InputMaybe<Array<OperatorUserFacilityPermissionInput>>;
  /** The operator's permission to Forwarder. */
  forwarder?: InputMaybe<Array<OperatorUserForwarderPermissionInput>>;
  /** The operator's permission to FrConsignee. */
  frConsignee?: InputMaybe<Array<OperatorUserFrConsigneePermissionInput>>;
  /** The operator's permission to FrCustomsBroker. */
  frCustomsBroker?: InputMaybe<Array<OperatorUserFrCustomsBrokerPermissionInput>>;
  /** The operator's permission to FrCustomsEntry. */
  frCustomsEntry?: InputMaybe<Array<OperatorUserFrCustomsEntryPermissionInput>>;
  /** The operator's permission to FrIor. */
  frIor?: InputMaybe<Array<OperatorUserFrIorPermissionInput>>;
  /** The operator's permission to FrIorActivation. */
  frIorActivation?: InputMaybe<Array<OperatorUserFrIorActivationPermissionInput>>;
  /** The operator's permission to GbConsignee. */
  gbConsignee?: InputMaybe<Array<OperatorUserGbConsigneePermissionInput>>;
  /** The operator's permission to GbCustomsEntry. */
  gbCustomsEntry?: InputMaybe<Array<OperatorUserGbCustomsEntryPermissionInput>>;
  /** The operator's permission to GbIor. */
  gbIor?: InputMaybe<Array<OperatorUserGbIorPermissionInput>>;
  /** The operator's permission to GbIorActivation. */
  gbIorActivation?: InputMaybe<Array<OperatorUserGbIorActivationPermissionInput>>;
  /** The operator's permission to GlobalConsignee. */
  globalConsignee?: InputMaybe<Array<OperatorUserGlobalConsigneePermissionInput>>;
  /** The operator's permission to ImportProductsFromBulkUploadRequest. */
  importProductsFromBulkUploadRequest?: InputMaybe<Array<OperatorUserImportProductsFromBulkUploadRequestPermissionInput>>;
  /** The operator's permission to ImportProductsFromCustomsEntriesRequest. */
  importProductsFromCustomsEntriesRequest?: InputMaybe<Array<OperatorUserImportProductsFromCustomsEntriesRequestPermissionInput>>;
  /** The operator's permission to Importer. */
  importer?: InputMaybe<Array<OperatorUserImporterPermissionInput>>;
  /** The operator's permission to ImporterEntity. */
  importerEntity?: InputMaybe<Array<OperatorUserImporterEntityPermissionInput>>;
  /** The operator's permission to ImporterEntityActivation. */
  importerEntityActivation?: InputMaybe<Array<OperatorUserImporterEntityActivationPermissionInput>>;
  /** The operator's permission to Invoice. */
  invoice?: InputMaybe<Array<OperatorUserInvoicePermissionInput>>;
  /** The operator's permission to InvoiceLinesRequest. */
  invoiceLinesRequest?: InputMaybe<Array<OperatorUserInvoiceLinesRequestPermissionInput>>;
  /** The operator's permission to Memo. */
  memo?: InputMaybe<Array<OperatorUserMemoPermissionNameInput>>;
  /** The operator's permission to NlConsignee. */
  nlConsignee?: InputMaybe<Array<OperatorUserNlConsigneePermissionInput>>;
  /** The operator's permission to NlCustomsBroker. */
  nlCustomsBroker?: InputMaybe<Array<OperatorUserNlCustomsBrokerPermissionInput>>;
  /** The operator's permission to NlCustomsEntry. */
  nlCustomsEntry?: InputMaybe<Array<OperatorUserNlCustomsEntryPermissionInput>>;
  /** The operator's permission to NlIor. */
  nlIor?: InputMaybe<Array<OperatorUserNlIorPermissionInput>>;
  /** The operator's permission to NlIorActivation. */
  nlIorActivation?: InputMaybe<Array<OperatorUserNlIorActivationPermissionInput>>;
  /** The operator's permission to User. */
  operatorUser?: InputMaybe<Array<OperatorUserOperatorUserPermissionInput>>;
  /** The operator's permission to PayableInvoice. */
  payableInvoice?: InputMaybe<Array<OperatorUserPayableInvoicePermissionInput>>;
  /** The operator's permission to Product. */
  product?: InputMaybe<Array<OperatorUserProductPermissionInput>>;
  /** The operator's permission to ReleaseNote. */
  releaseNote?: InputMaybe<Array<OperatorUserReleaseNotePermissionInput>>;
  /** The operator's permission to reportReconciliationRequest. */
  reportReconciliationRequest?: InputMaybe<Array<OperatorUserReportReconciliationRequestPermissionInput>>;
  /** The operator's permission to Shipment. */
  shipment?: InputMaybe<Array<OperatorUserShipmentPermissionInput>>;
  /** The operator's permission to Shipper. */
  shipper?: InputMaybe<Array<OperatorUserShipperPermissionInput>>;
  /** The operator's permission to Supplier. */
  supplier?: InputMaybe<Array<OperatorUserSupplierPermissionInput>>;
  /** The operator's permission to Trucker. */
  trucker?: InputMaybe<Array<OperatorUserSupplierPermissionInput>>;
  /** The operator's permission to UkCustomsBroker. */
  ukCustomsBroker?: InputMaybe<Array<OperatorUserUkCustomsBrokerPermissionInput>>;
  /** The operator's permission to UsConsignee. */
  usConsignee?: InputMaybe<Array<OperatorUserUsConsigneePermissionInput>>;
  /** The operator's permission to UsConsumptionEntry. */
  usConsumptionEntry?: InputMaybe<Array<OperatorUserUsConsumptionEntryPermissionInput>>;
  /** The operator's permission to UsCustomsBroker. */
  usCustomsBroker?: InputMaybe<Array<OperatorUserUsCustomsBrokerPermissionInput>>;
  /** The operator's permission to UsDrawbackClaim. */
  usDrawbackClaim?: InputMaybe<Array<OperatorUserUsDrawbackClaimPermissionInput>>;
  /** The operator's permission to UsHts. */
  usHts?: InputMaybe<Array<OperatorUserUsHtsPermissionInput>>;
  /** The operator's permission to UsInBond. */
  usInBond?: InputMaybe<Array<OperatorUserUsInBondPermissionInput>>;
  /** The operator's permission to UsIor. */
  usIor?: InputMaybe<Array<OperatorUserUsIorPermissionInput>>;
  /** The operator's permission to UsIorActivation. */
  usIorActivation?: InputMaybe<Array<OperatorUserUsIorActivationPermissionInput>>;
  /** The operator's permission to UsIorContinuousBondRequest. */
  usIorContinuousBondRequest?: InputMaybe<Array<OperatorUserUsIorContinuousBondRequestPermissionInput>>;
  /** The operator's permission to UsIsf. */
  usIsf?: InputMaybe<Array<OperatorUserUsIsfPermissionInput>>;
  /** The operator's permission to UsPostSummaryCorrection. */
  usPostSummaryCorrection?: InputMaybe<Array<OperatorUserUsPostSummaryCorrectionPermissionInput>>;
  /** The operator's permission to UsType86Entry. */
  usType86Entry?: InputMaybe<Array<OperatorUserUsType86EntryPermissionInput>>;
  /** The operator's permission to UserReleaseNoteView. */
  userReleaseNoteView?: InputMaybe<Array<OperatorUserUserReleaseNoteViewPermissionInput>>;
  /** The operator's permission to WorkOrderTask. */
  workOrderTask?: InputMaybe<Array<OperatorUserWorkOrderTaskPermissionInput>>;
  /** The operator's permission to workOrderTaskEcalationMessage. */
  workOrderTaskEscalationMessage?: InputMaybe<Array<OperatorUserWorkOrderTaskEscalationMessagePermissionInput>>;
};

export type OperatorUserProductPermission = {
  __typename?: 'OperatorUserProductPermission';
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export type OperatorUserProductPermissionInput = {
  /** The name of permission. */
  name: OperatorUserProductPermissionName;
};

export enum OperatorUserProductPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserReleaseNotePermission = {
  __typename?: 'OperatorUserReleaseNotePermission';
  /** The name of permission. */
  name: OperatorUserReleaseNotePermissionName;
};

export type OperatorUserReleaseNotePermissionInput = {
  /** The name of permission. */
  name: OperatorUserReleaseNotePermissionName;
};

export enum OperatorUserReleaseNotePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserReportReconciliationRequestPermission = {
  __typename?: 'OperatorUserReportReconciliationRequestPermission';
  /** The name of permission. */
  name: OperatorUserReportReconciliationRequestPermissionName;
};

export type OperatorUserReportReconciliationRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserReportReconciliationRequestPermissionName;
};

export enum OperatorUserReportReconciliationRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserSearchCriteriaInput = {
  /** The ID of the assignment teams the user is on */
  assignmentTeamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the assignment teams the user is on */
  assignmentTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the business support teams the user is on */
  businessSupportTeamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the business support teams the user is on */
  businessSupportTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The User's Cognito Identity ID. */
  cognitoId?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of customs broker linked to this Operator User. */
  customsBrokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Customs Broker's name linked to this Operator User. */
  customsBrokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's email. */
  email?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Whether or not a User is logged in. */
  loggedIn?: InputMaybe<BooleanSearchCriteriaInput>;
  /** The name of the User. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Operator's name. */
  operatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Skill level of operator user. */
  skillLevel?: InputMaybe<SkillLevelSearchCriteriaInput>;
  /** The ID of the subject matter expert teams the user is on */
  subjectMatterExpertTeamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the subject matter expert teams the user is on */
  subjectMatterExpertTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The IDs of the teams the user is on */
  teamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the teams the user is on */
  teamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The title of the User. */
  title?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's unique identifier provided by an IDP. */
  userIdentifier?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The vertical(s) the Operator User is responsible for. */
  vertical?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The ID of the Work Order Task Defintion linked to this Operator User. */
  workOrderTaskDefinitionId?: InputMaybe<IdSearchCriteriaInput>;
};

/** Operator user's table search row. */
export type OperatorUserSearchTableRow = RecordSearchTableRow & UserSearchTableRow & {
  __typename?: 'OperatorUserSearchTableRow';
  /** The IDs of the assignment teams the user is on */
  assignmentTeamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the assignment teams the user is on */
  assignmentTeamName?: Maybe<Array<Scalars['String']>>;
  /** The IDs of the business support teams the user is on */
  businessSupportTeamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the business support teams the user is on */
  businessSupportTeamName?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of customs broker linked to this Operator User. */
  customsBrokerId?: Maybe<Scalars['ID']>;
  /** The Customs Broker's name linked to this Operator User. */
  customsBrokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The User's email. */
  email?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether or not a User is logged in. */
  loggedIn?: Maybe<Scalars['Boolean']>;
  /** Whether or not a User has Multi-Factor Authentication (MFA) enabled. */
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  /** The name of the User. */
  name?: Maybe<Scalars['String']>;
  /** The operator's name. */
  operatorName?: Maybe<Scalars['String']>;
  /** Skill level of operator user. */
  skillLevel?: Maybe<SkillLevel>;
  /** The IDs of the subject matter expert teams the user is on */
  subjectMatterExpertTeamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the subject matter expert teams the user is on */
  subjectMatterExpertTeamName?: Maybe<Array<Scalars['String']>>;
  /** The IDs of the teams the user is on */
  teamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the teams the user is on */
  teamName?: Maybe<Array<Scalars['String']>>;
  /** The title of the User. */
  title?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The industry verticals for which the operator is responsible. */
  vertical?: Maybe<Array<Vertical>>;
};

export type OperatorUserShipmentPermission = {
  __typename?: 'OperatorUserShipmentPermission';
  /** The name of permission. */
  name: OperatorUserShipmentPermissionName;
};

export type OperatorUserShipmentPermissionInput = {
  /** The name of permission. */
  name: OperatorUserShipmentPermissionName;
};

export enum OperatorUserShipmentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserShipperPermission = {
  __typename?: 'OperatorUserShipperPermission';
  /** The name of permission. */
  name: OperatorUserShipperPermissionName;
};

export type OperatorUserShipperPermissionInput = {
  /** The name of permission. */
  name: OperatorUserShipperPermissionName;
};

export enum OperatorUserShipperPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserSubjectMatterExpertTeamEdge = ConnectionEdge & {
  __typename?: 'OperatorUserSubjectMatterExpertTeamEdge';
  cursor: Scalars['ID'];
  /** The linked Subject Matter Expert Team. */
  node: SubjectMatterExpertTeam;
  /** The data on the link between the Subject Matter Expert Team and Operator User. */
  relationship: SubjectMatterExpertTeamOperatorUserRelationship;
};

export type OperatorUserSubjectMatterExpertTeamsConnection = Connection & {
  __typename?: 'OperatorUserSubjectMatterExpertTeamsConnection';
  edges: Array<OperatorUserSubjectMatterExpertTeamEdge>;
  nodes: Array<SubjectMatterExpertTeam>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type OperatorUserSupplierPermission = {
  __typename?: 'OperatorUserSupplierPermission';
  /** The name of permission. */
  name: OperatorUserSupplierPermissionName;
};

export type OperatorUserSupplierPermissionInput = {
  /** The name of permission. */
  name: OperatorUserSupplierPermissionName;
};

export enum OperatorUserSupplierPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPSERT_CBP_MID_TRANSACTION = 'UPSERT_CBP_MID_TRANSACTION'
}

export type OperatorUserTeamProperty = {
  __typename?: 'OperatorUserTeamProperty';
  /** Role of the OperatorUser in a team. Ex: PRIMARY TEAM LEAD */
  role: OperatorUserTeamRole;
  /** Used to specify categories if this is a SME role */
  subjectMatterProperties?: Maybe<Array<SubjectMatterProperty>>;
  /** The team the user is on */
  team: Team;
};

export type OperatorUserTeamPropertyInput = {
  /** Role of the OperatorUser in a team. Ex: PRIMARY TEAM LEAD */
  role: OperatorUserTeamRole;
  /** Used to specify categories if this is a SME role */
  subjectMatterProperties?: InputMaybe<Array<SubjectMatterPropertyInput>>;
  /** The team the user is on */
  team: IdInput;
};

/** Role of the OperatorUser in a team. Ex: PRIMARY TEAM LEAD */
export enum OperatorUserTeamRole {
  OPERATOR = 'OPERATOR',
  PRIMARY_TEAM_LEAD = 'PRIMARY_TEAM_LEAD',
  SECONDARY_TEAM_LEAD = 'SECONDARY_TEAM_LEAD',
  SUBJECT_MATTER_EXPERT = 'SUBJECT_MATTER_EXPERT',
  VIEWER = 'VIEWER'
}

export type OperatorUserUkCustomsBrokerPermission = {
  __typename?: 'OperatorUserUkCustomsBrokerPermission';
  /** The name of permission. */
  name: OperatorUserUkCustomsBrokerPermissionName;
};

export type OperatorUserUkCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUkCustomsBrokerPermissionName;
};

export enum OperatorUserUkCustomsBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsConsigneePermission = {
  __typename?: 'OperatorUserUsConsigneePermission';
  /** The name of permission. */
  name: OperatorUserUsConsigneePermissionName;
};

export type OperatorUserUsConsigneePermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsConsigneePermissionName;
};

export enum OperatorUserUsConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  CREATE_US_CBP_5106_TRANSACTION = 'CREATE_US_CBP_5106_TRANSACTION',
  DELETE = 'DELETE',
  QUERY_US__CBP_TRANSACTION = 'QUERY_US__CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPDATE_US_CBP_5106_TRANSACTION = 'UPDATE_US_CBP_5106_TRANSACTION'
}

export type OperatorUserUsConsumptionEntryPermission = {
  __typename?: 'OperatorUserUsConsumptionEntryPermission';
  /** The name of permission. */
  name: OperatorUserUsConsumptionEntryPermissionName;
};

export type OperatorUserUsConsumptionEntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsConsumptionEntryPermissionName;
};

export enum OperatorUserUsConsumptionEntryPermissionName {
  ADMIN = 'ADMIN',
  AUTHORIZE_STATEMENT_CBP_TRANSACTION = 'AUTHORIZE_STATEMENT_CBP_TRANSACTION',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  DELETE_CBP_TRANSACTION = 'DELETE_CBP_TRANSACTION',
  DELETE_RELEASE_CBP_TRANSACTION = 'DELETE_RELEASE_CBP_TRANSACTION',
  QUERY_CBP_TRANSACTION = 'QUERY_CBP_TRANSACTION',
  READ = 'READ',
  REPLACE_RELEASE_CBP_TRANSACTION = 'REPLACE_RELEASE_CBP_TRANSACTION',
  UPDATE = 'UPDATE',
  UPDATE_PGA_CBP_TRANSACTION = 'UPDATE_PGA_CBP_TRANSACTION',
  UPDATE_RELEASE_CBP_TRANSACTION = 'UPDATE_RELEASE_CBP_TRANSACTION',
  UPDATE_STATEMENT_CBP_TRANSACTION = 'UPDATE_STATEMENT_CBP_TRANSACTION',
  UPSERT_CBP_TRANSACTION = 'UPSERT_CBP_TRANSACTION'
}

export type OperatorUserUsCustomsBrokerPermission = {
  __typename?: 'OperatorUserUsCustomsBrokerPermission';
  /** The name of permission. */
  name: OperatorUserUsCustomsBrokerPermissionName;
};

export type OperatorUserUsCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsCustomsBrokerPermissionName;
};

export enum OperatorUserUsCustomsBrokerPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsDrawbackClaimPermission = {
  __typename?: 'OperatorUserUsDrawbackClaimPermission';
  /** The name of permission. */
  name: OperatorUserUsDrawbackClaimPermissionName;
};

export type OperatorUserUsDrawbackClaimPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsDrawbackClaimPermissionName;
};

export enum OperatorUserUsDrawbackClaimPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsHtsPermission = {
  __typename?: 'OperatorUserUsHtsPermission';
  /** The name of permission. */
  name: OperatorUserUsHtsPermissionName;
};

export type OperatorUserUsHtsPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsHtsPermissionName;
};

export enum OperatorUserUsHtsPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsInBondPermission = {
  __typename?: 'OperatorUserUsInBondPermission';
  /** The name of permission. */
  name: OperatorUserUsInBondPermissionName;
};

export type OperatorUserUsInBondPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsInBondPermissionName;
};

export enum OperatorUserUsInBondPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  IN_BOND_DELETE_BILL_CBP_TRANSACTION = 'IN_BOND_DELETE_BILL_CBP_TRANSACTION',
  IN_BOND_DELETE_CBP_TRANSACTION = 'IN_BOND_DELETE_CBP_TRANSACTION',
  IN_BOND_SUBMIT_ACTION_CBP_TRANSACTION = 'IN_BOND_SUBMIT_ACTION_CBP_TRANSACTION',
  IN_BOND_SUBMIT_CBP_TRANSACTION = 'IN_BOND_SUBMIT_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsIorActivationPermission = {
  __typename?: 'OperatorUserUsIorActivationPermission';
  /** The name of permission. */
  name: OperatorUserUsIorActivationPermissionName;
};

export type OperatorUserUsIorActivationPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsIorActivationPermissionName;
};

export enum OperatorUserUsIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsIorContinuousBondRequestPermission = {
  __typename?: 'OperatorUserUsIorContinuousBondRequestPermission';
  /** The name of permission. */
  name: OperatorUserUsIorContinuousBondRequestPermissionName;
};

export type OperatorUserUsIorContinuousBondRequestPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsIorContinuousBondRequestPermissionName;
};

export enum OperatorUserUsIorContinuousBondRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserUsIorPermission = {
  __typename?: 'OperatorUserUsIorPermission';
  /** The name of permission. */
  name: OperatorUserUsIorPermissionName;
};

export type OperatorUserUsIorPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsIorPermissionName;
};

export enum OperatorUserUsIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  CREATE_CBP_5106_TRANSACTION = 'CREATE_CBP_5106_TRANSACTION',
  DELETE = 'DELETE',
  QUERY_CBP_TRANSACTION = 'QUERY_CBP_TRANSACTION',
  READ = 'READ',
  REQUEST_CBP_ASSIGNED_NUMBER_TRANSACTION = 'REQUEST_CBP_ASSIGNED_NUMBER_TRANSACTION',
  UPDATE = 'UPDATE',
  UPDATE_CBP_5106_TRANSACTION = 'UPDATE_CBP_5106_TRANSACTION'
}

export type OperatorUserUsIsfPermission = {
  __typename?: 'OperatorUserUsIsfPermission';
  /** The name of permission. */
  name: OperatorUserUsIsfPermissionName;
};

export type OperatorUserUsIsfPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsIsfPermissionName;
};

export enum OperatorUserUsIsfPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  CREATE_CBP_TRANSACTION = 'CREATE_CBP_TRANSACTION',
  DELETE = 'DELETE',
  DELETE_CBP_TRANSACTION = 'DELETE_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPDATE_CBP_TRANSACTION = 'UPDATE_CBP_TRANSACTION'
}

export type OperatorUserUsPostSummaryCorrectionPermission = {
  __typename?: 'OperatorUserUsPostSummaryCorrectionPermission';
  /** The name of permission. */
  name: OperatorUserUsPostSummaryCorrectionPermissionName;
};

export type OperatorUserUsPostSummaryCorrectionPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsPostSummaryCorrectionPermissionName;
};

export enum OperatorUserUsPostSummaryCorrectionPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPSERT_CBP_TRANSACTION = 'UPSERT_CBP_TRANSACTION'
}

export type OperatorUserUsType86EntryPermission = {
  __typename?: 'OperatorUserUsType86EntryPermission';
  /** The name of permission. */
  name: OperatorUserUsType86EntryPermissionName;
};

export type OperatorUserUsType86EntryPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUsType86EntryPermissionName;
};

export enum OperatorUserUsType86EntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  CREATE_RELEASE_CBP_TRANSACTION = 'CREATE_RELEASE_CBP_TRANSACTION',
  DELETE = 'DELETE',
  DELETE_RELEASE_CBP_TRANSACTION = 'DELETE_RELEASE_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPDATE_PGA_CBP_TRANSACTION = 'UPDATE_PGA_CBP_TRANSACTION',
  UPDATE_RELEASE_CBP_TRANSACTION = 'UPDATE_RELEASE_CBP_TRANSACTION'
}

export type OperatorUserUserReleaseNoteViewPermission = {
  __typename?: 'OperatorUserUserReleaseNoteViewPermission';
  /** The name of permission. */
  name: OperatorUserUserReleaseNoteViewPermissionName;
};

export type OperatorUserUserReleaseNoteViewPermissionInput = {
  /** The name of permission. */
  name: OperatorUserUserReleaseNoteViewPermissionName;
};

export enum OperatorUserUserReleaseNoteViewPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserWorkOrderTaskEscalationMessagePermission = {
  __typename?: 'OperatorUserWorkOrderTaskEscalationMessagePermission';
  /** The name of permission. */
  name: OperatorUserWorkOrderTaskEscalationMessagePermissionName;
};

export type OperatorUserWorkOrderTaskEscalationMessagePermissionInput = {
  /** The name of permission. */
  name: OperatorUserWorkOrderTaskEscalationMessagePermissionName;
};

export enum OperatorUserWorkOrderTaskEscalationMessagePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUserWorkOrderTaskPermission = {
  __typename?: 'OperatorUserWorkOrderTaskPermission';
  /** The name of permission. */
  name: OperatorUserWorkOrderTaskPermissionName;
};

export type OperatorUserWorkOrderTaskPermissionInput = {
  /** The name of permission. */
  name: OperatorUserWorkOrderTaskPermissionName;
};

export enum OperatorUserWorkOrderTaskPermissionName {
  ADMIN = 'ADMIN',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type OperatorUsersConnection = Connection & {
  __typename?: 'OperatorUsersConnection';
  edges: Array<OperatorUserEdge>;
  nodes: Array<OperatorUser>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type OperatorsConnection = Connection & {
  __typename?: 'OperatorsConnection';
  edges: Array<OperatorEdge>;
  nodes: Array<Operator>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type Origin = {
  __typename?: 'Origin';
  /** Code specifying the country in which the goods have been produced or manufactured, according to criteria laid down for the application of the Customs tariff or quantitative restrictions, or any measure related to trade. */
  country?: Maybe<Scalars['String']>;
  /** Sequence number for Origin */
  sequence?: Maybe<Scalars['Int']>;
  /** Code specifying the differentiation between different types of origin (e.g. preferential and non-preferential country of origin codes). */
  type?: Maybe<Scalars['String']>;
};

export type OriginInput = {
  /** Code specifying the country in which the goods have been produced or manufactured, according to criteria laid down for the application of the Customs tariff or quantitative restrictions, or any measure related to trade. */
  country?: InputMaybe<Scalars['String']>;
  /** Sequence number for Origin */
  sequence?: InputMaybe<Scalars['Int']>;
  /** Code specifying the differentiation between different types of origin (e.g. preferential and non-preferential country of origin codes). */
  type?: InputMaybe<Scalars['String']>;
};

/** Power of Attorney Method */
export enum POAMethod {
  DIRECT = 'DIRECT',
  MASTER_SUB = 'MASTER_SUB'
}

/** The type industry of the Ior. */
export type POAMethodSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<POAMethod>>;
};

export type Packaging = {
  __typename?: 'Packaging';
  /** Marks and or numbers on a transport unit or package. */
  marksNumbers?: Maybe<Scalars['String']>;
  /** Quantity specifying the number of individual items packaged in such a way that they cannot be divided without first undoing the packing. */
  quantity?: Maybe<Scalars['Int']>;
  /** Number indicating the position in a sequence. */
  sequence?: Maybe<Scalars['Int']>;
  /** Code specifying the type of package of an item. */
  type?: Maybe<Scalars['String']>;
};

export type PackagingInput = {
  /** Marks and or numbers on a transport unit or package. */
  marksNumbers?: InputMaybe<Scalars['String']>;
  /** Quantity specifying the number of individual items packaged in such a way that they cannot be divided without first undoing the packing. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Number indicating the position in a sequence. */
  sequence?: InputMaybe<Scalars['Int']>;
  /** Code specifying the type of package of an item. */
  type?: InputMaybe<Scalars['String']>;
};

export type Party = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type PartymemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type PartyExternalIntegrationReference = {
  __typename?: 'PartyExternalIntegrationReference';
  /** An email address for the party that can be contacted about the external integration. */
  email?: Maybe<Scalars['Email']>;
  /** The external client we have developed an integration with. */
  externalIntegrationPartner: ExternalIntegrationPartner;
  /** The type of the external integration. */
  externalIntegrationType: ExternalIntegrationType;
  /** A unique ID for the record within the external reference. */
  id: Scalars['ID'];
  /** SNS details of the external integration. */
  snsDetails?: Maybe<Array<SnsDetails>>;
};

export type PartyExternalIntegrationReferenceInput = {
  /** An email address for the party that can be contacted about the external integration. */
  email?: InputMaybe<Scalars['Email']>;
  /** The external client we have developed an integration with. */
  externalIntegrationPartner: ExternalIntegrationPartner;
  /** The type of the external integration. */
  externalIntegrationType: ExternalIntegrationType;
  /** A unique ID for the record within the external reference. */
  id: Scalars['ID'];
  /** SNS details of the external integration. */
  snsDetails?: InputMaybe<Array<SnsDetailsInput>>;
};

/** Identification assigned by a government agency to party e.g. vat number, ein, duns etc */
export type PartyIdentification = {
  __typename?: 'PartyIdentification';
  /** Identification value. */
  identification: Scalars['String'];
  /** Identification Type */
  identificationType: PartyIdentificationType;
};

export type PartyIdentificationInput = {
  /** Identification value. */
  identification: Scalars['String'];
  /** Identification Type */
  identificationType: PartyIdentificationType;
};

/** Party identification type such as VAT, EIN etc */
export enum PartyIdentificationType {
  BUSINESS_LICENSE_NUMBER = 'BUSINESS_LICENSE_NUMBER',
  CBP_ASSIGNED_NUMBER = 'CBP_ASSIGNED_NUMBER',
  CORPORATE_ID_NUMBER = 'CORPORATE_ID_NUMBER',
  DUNS = 'DUNS',
  EIN = 'EIN',
  EORI = 'EORI',
  IMPORTER_EXPORTER_CODE = 'IMPORTER_EXPORTER_CODE',
  JCT_ID = 'JCT_ID',
  NAICS = 'NAICS',
  SSN = 'SSN',
  VAT_NUMBER = 'VAT_NUMBER'
}

export type PartySearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type PartySearchTableRow = {
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Passport information. */
export type Passport = {
  __typename?: 'Passport';
  /** The ISO 3166-1 alpha-2 country code where the Passport was issued. */
  countryCode: Scalars['CountryCode'];
  /** The date in which the Passport expires. */
  expiration?: Maybe<Scalars['Date']>;
  /** The numerical code used to identify a Passport. */
  number: Scalars['PassportNumber'];
  /** The type of Passport issued. */
  type?: Maybe<PassportType>;
};

/** Passport information. */
export type PassportInput = {
  /** The ISO 3166-1 alpha-2 country code where the Passport was issued. */
  countryCode: Scalars['CountryCode'];
  /** The date in which the Passport expires. */
  expiration?: InputMaybe<Scalars['Date']>;
  /** The numerical code used to identify a Passport. */
  number: Scalars['PassportNumber'];
  /** The type of Passport issued. */
  type?: InputMaybe<PassportType>;
};

/** The type of Passport issued. */
export enum PassportType {
  DIPLOMATIC = 'DIPLOMATIC',
  OFFICIAL = 'OFFICIAL',
  PASSPORT_CARD = 'PASSPORT_CARD',
  REGULAR = 'REGULAR'
}

export type PayReimbursementInput = {
  lines: Array<ReimbursementLineInput>;
};

/** The primary entity used to represent the Payable Invoice. */
export type PayableInvoice = Record & {
  __typename?: 'PayableInvoice';
  /** The individual charges on the invoice */
  charges: Array<InvoiceCharge>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** External references associated with the invoice */
  externalReference?: Maybe<ExternalFinanceReference>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party which is to be paid. */
  payee?: Maybe<CustomsBroker>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: Maybe<Scalars['SCACCode']>;
  /** Service type of the invoice */
  serviceType: PayableInvoiceServiceType;
  /** The current status of the invoice */
  status?: Maybe<PayableInvoiceStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The work order group details associated with the Invoice */
  workOrderGroup: WorkOrderGroup;
};

export type PayableInvoiceSearchCriteriaInput = {
  /** The charge code associated with the invoice */
  chargeCode?: InputMaybe<ChargeCodeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** External reference associated with invoice */
  externalReferenceId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payee id associate with invoice. */
  payeeId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: InputMaybe<ScacSearchCriteriaInput>;
  /** The service type for the invoice */
  serviceType?: InputMaybe<PayableInvoiceServiceTypeCriteriaInput>;
  /** The current status of the invoice */
  status?: InputMaybe<PayableInvoiceStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Work order group id associated with invoice. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Payable Invoice search table row */
export type PayableInvoiceSearchTableRow = RecordSearchTableRow & {
  __typename?: 'PayableInvoiceSearchTableRow';
  /** The charge code associated with the payable invoice */
  chargeCode?: Maybe<Array<ChargeCode>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** External reference id associated with invoice */
  externalReferenceId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The party id to which invoice amount needs to be paid */
  payToPartyId?: Maybe<Scalars['ID']>;
  /** The party name to which invoice amount needs to be paid */
  payToPartyName?: Maybe<Scalars['String']>;
  /** The Scac code of the party to whom payment is to be made */
  payToPartyScac?: Maybe<Scalars['SCACCode']>;
  /** Service type of the invoice */
  serviceType?: Maybe<PayableInvoiceServiceType>;
  /** The current status of the invoice */
  status?: Maybe<PayableInvoiceStatus>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** Work order group id associate with invoice. */
  workOrderGroupId?: Maybe<Scalars['ID']>;
};

/** PayableInvoice service type */
export enum PayableInvoiceServiceType {
  BOND_MANAGEMENT = 'BOND_MANAGEMENT',
  CUSTOMS_CLEARANCE = 'CUSTOMS_CLEARANCE',
  CUSTOMS_DUTIES = 'CUSTOMS_DUTIES',
  PORT_BROKERING = 'PORT_BROKERING'
}

export type PayableInvoiceServiceTypeCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<PayableInvoiceServiceType>>;
};

/** PayableInvoice status */
export enum PayableInvoiceStatus {
  ACCEPTED = 'ACCEPTED',
  PAID = 'PAID'
}

export type PayableInvoiceStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<PayableInvoiceStatus>>;
};

export type Payment = {
  __typename?: 'Payment';
  /** Duty/tax payment method code. */
  method?: Maybe<Scalars['String']>;
  /** Amount paid for the duty, tax or fee. */
  payment?: Maybe<Cost>;
  /** Amount of assessed duty, tax or fee due (includes all types of charges and duties) and amount of reduction (if applicable). Assessed per duty, tax or fee type by item and/or declaration. */
  taxAssessed?: Maybe<Cost>;
};

export type PaymentInput = {
  /** Duty/tax payment method code. */
  method?: InputMaybe<Scalars['String']>;
  /** Amount paid for the duty, tax or fee. */
  payment?: InputMaybe<CostInput>;
  /** Amount of assessed duty, tax or fee due (includes all types of charges and duties) and amount of reduction (if applicable). Assessed per duty, tax or fee type by item and/or declaration. */
  taxAssessed?: InputMaybe<CostInput>;
};

/** Payment method */
export enum PaymentMethod {
  ACH_DEBIT = 'ACH_DEBIT',
  CHECK = 'CHECK',
  CREDIT_CARD = 'CREDIT_CARD',
  WIRE = 'WIRE'
}

export type PaymentMethodSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<PaymentMethod>>;
};

/** The resource type for permission token */
export enum PermissionResourceType {
  READ = 'READ',
  WRITE = 'WRITE'
}

/** Type of container used in PGA. */
export enum PgaContainerType {
  NOT_REFRIGERATED = 'NOT_REFRIGERATED',
  REFRIGERATED = 'REFRIGERATED'
}

/** A code disclaiming the requirement to report data to the Partner Government Agency */
export enum PgaDisclaimerCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type PgaProcessingCode = {
  __typename?: 'PgaProcessingCode';
  /** PGA processing code */
  code: Scalars['String'];
  /** PGA processing code name */
  name?: Maybe<Scalars['String']>;
};

export type PgaProgram = {
  __typename?: 'PgaProgram';
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  processingCodes?: Maybe<Array<PgaProcessingCode>>;
};

/** Partner Government Agency HTS flag. */
export type PgaRequirement = {
  __typename?: 'PgaRequirement';
  /** Agency code */
  agencyCode?: Maybe<Scalars['String']>;
  /** Description of the requirement. */
  description?: Maybe<Scalars['String']>;
  /** Disclaimer codes available for this PGA flag, if disclaimable. */
  disclaimerCodes?: Maybe<Array<PgaDisclaimerCode>>;
  /** End (expiration) date for HTS control. */
  endDate?: Maybe<Scalars['Date']>;
  /** Data needed if using PGA flag */
  fields?: Maybe<Array<SupplementalField>>;
  /** Unique flag for HTS requirement. */
  flag: Scalars['PgaFlag'];
  /** If set, the HTS number implies that this PGA requirement can likely be disclaimed using this code */
  likelyDisclaimerCode?: Maybe<Scalars['String']>;
  /** If set, the HTS number implies that this PGA processing code is likely correct for the agency and program */
  likelyProcessingCode?: Maybe<Scalars['String']>;
  /** If set, the HTS number implies that this PGA program code is likely correct for the agency */
  likelyProgramCode?: Maybe<Scalars['String']>;
  /** Program codes available to use. */
  programCodes?: Maybe<Array<Scalars['String']>>;
  /** Programs and processing codes available to use */
  programs?: Maybe<Array<PgaProgram>>;
  /** Whether the PGA data is required or may be disclaimed. */
  required?: Maybe<Scalars['Boolean']>;
  /** Start (effective) date for HTS control. */
  startDate?: Maybe<Scalars['Date']>;
};

export type PgaRequirementInput = {
  /** End (expiration) date for HTS control. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Unique flag for HTS requirement. */
  flag: Scalars['PgaFlag'];
  /** Start (effective) date for HTS control. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Contact phone number. */
export type Phone = {
  __typename?: 'Phone';
  /** The country calling code as defined in ITU-T E.123 and E.164. */
  country?: Maybe<Scalars['String']>;
  /** An optional phone number extension. */
  extension?: Maybe<Scalars['String']>;
  /** The portion of the phone number excluding the country code and the extension. */
  number: Scalars['String'];
};

/** Contact phone number. */
export type PhoneInput = {
  /** The country calling code as defined in ITU-T E.123 and E.164. */
  country?: InputMaybe<Scalars['String']>;
  /** An optional phone number extension. */
  extension?: InputMaybe<Scalars['String']>;
  /** The portion of the phone number excluding the country code and the extension. */
  number: Scalars['String'];
};

/** Placement type for the entities. This can be used to determine different workflow to be executed. */
export enum PlacementType {
  AMPOS_INBOUND = 'AMPOS_INBOUND',
  AMPOS_OUTBOUND = 'AMPOS_OUTBOUND',
  AOI_ORIGINAL = 'AOI_ORIGINAL',
  AOI_SPLIT = 'AOI_SPLIT',
  STANDARD = 'STANDARD'
}

/** Service type for AMP2.0 bookings, defaults to STANDARD for non-AMP2.0 bookings */
export type PlacementTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<PlacementType>>;
};

/** A person or department that can be approached for information. */
export type PointOfContact = {
  __typename?: 'PointOfContact';
  /** A contact email address. */
  email?: Maybe<Scalars['Email']>;
  /** The point of contact's name. */
  name: Scalars['String'];
  /** A contact phone number. */
  phone?: Maybe<Phone>;
  /** The official title of the point of contact. */
  title?: Maybe<Scalars['String']>;
  /** The User associated with the point of contact. */
  user?: Maybe<User>;
};

/** A person or department that can be approached for information. */
export type PointOfContactInput = {
  /** A contact email address. */
  email?: InputMaybe<Scalars['Email']>;
  /** The point of contact's name. */
  name: Scalars['String'];
  /** A contact phone number. */
  phone?: InputMaybe<PhoneInput>;
  /** The official title of the point of contact. */
  title?: InputMaybe<Scalars['String']>;
  /** The User associated with the point of contact. */
  user?: InputMaybe<IdInput>;
};

export type PortCode = {
  __typename?: 'PortCode';
  /** Type of PortCode */
  type: PortCodeType;
  /** Value of PortCode */
  value: Scalars['String'];
};

export type PortCodeInput = {
  /** Type of PortCode */
  type: PortCodeType;
  /** Value of PortCode */
  value: Scalars['String'];
};

/** Port Code Type */
export enum PortCodeType {
  CBP = 'CBP',
  IATA = 'IATA',
  UNLOCODE = 'UNLOCODE'
}

/** The type of charge party */
export enum PreferredDutyCollectPartyType {
  BROKER = 'BROKER',
  CUSTOMS = 'CUSTOMS',
  FORWARDER = 'FORWARDER'
}

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  url: Scalars['String'];
};

export type PreviousCbpInBond = {
  __typename?: 'PreviousCbpInBond';
  /** The previous CbpInBond date */
  date?: Maybe<Scalars['Date']>;
  /** The previous CbpInBond UsInBondNumber */
  number?: Maybe<Scalars['UsInBondNumber']>;
  /** The previous CbpInBond origin port */
  port?: Maybe<Scalars['UsCbpPortCode']>;
};

export type PreviousCbpInBondInput = {
  /** The previous CbpInBond date */
  date?: InputMaybe<Scalars['Date']>;
  /** The previous CbpInBond UsInBondNumber */
  number?: InputMaybe<Scalars['UsInBondNumber']>;
  /** The previous CbpInBond origin port */
  port?: InputMaybe<Scalars['UsCbpPortCode']>;
};

export type ProcessingError = Record & {
  __typename?: 'ProcessingError';
  /** The IDs of records affected by the error. */
  affectedRecordIds?: Maybe<Array<Scalars['String']>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The error message */
  message: Scalars['String'];
  /** The name of the error. */
  name: Scalars['String'];
  operator: Operator;
  /** The source service that threw the error. */
  source?: Maybe<SystemType>;
  /** The stack trace of the error. */
  stack?: Maybe<Scalars['String']>;
  /** The status of the error. */
  status: ProcessingErrorStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The event that triggered the error. */
  triggeringEvent?: Maybe<Scalars['JSONObject']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ProcessingErrorSearchCriteria = {
  /** The IDs of records affected by the error. */
  affectedRecordIds?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the error. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The operator id that owns the records affected by the error. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The source service that threw the error. */
  source?: InputMaybe<ProcessingErrorSourceSearchCriteriaInput>;
  /** The status of the error. */
  status?: InputMaybe<ProcessingErrorStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Processing Error search table row. */
export type ProcessingErrorSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ProcessingErrorSearchTableRow';
  /** The IDs of records affected by the error. */
  affectedRecordIds?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The error message */
  message?: Maybe<Scalars['String']>;
  /** The name of the error. */
  name: Scalars['String'];
  /** The source service that threw the error. */
  source?: Maybe<SystemType>;
  /** The status of the error. */
  status?: Maybe<ProcessingErrorStatus>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** ProcessingErrorStatus search criteria input. */
export type ProcessingErrorSourceSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<SystemType>>;
};

/** Status of the processing error. */
export enum ProcessingErrorStatus {
  CREATED = 'CREATED',
  REDRIVEN = 'REDRIVEN',
  RESOLVED = 'RESOLVED'
}

/** ProcessingErrorStatus search criteria input. */
export type ProcessingErrorStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ProcessingErrorStatus>>;
};

export type Product = Record & {
  __typename?: 'Product';
  /** The ASIN for this product */
  asin?: Maybe<Scalars['String']>;
  /** Client identifier for the product (eg, sku, asin, etc). */
  clientIdentifier: Scalars['String'];
  /** Client identifier Version for the product (eg, sku, asin, etc). */
  clientIdentifierVersion?: Maybe<Scalars['Int']>;
  /** Compliance details for importing the product, per country. */
  complianceDetails?: Maybe<ProductComplianceDetails>;
  /** The country for which this product originates from - its manufacturing country. This field is used to determine product uniqueness. */
  countryOfOrigin?: Maybe<Scalars['CountryCode']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The dimensions of the product. */
  dimensions?: Maybe<Dimensions>;
  /** The documents associated with the Product. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Global Trade Item Number for the product. */
  gtin?: Maybe<Scalars['GTIN']>;
  /** Unique ID */
  id: Scalars['ID'];
  ior?: Maybe<ProductIor>;
  /** Details of a product per locale.  */
  localizedDetails?: Maybe<Array<LocalizedProductDetail>>;
  /** The materials the Product contains. */
  materials?: Maybe<Array<Scalars['String']>>;
  /** Additional product notes. */
  notes?: Maybe<Scalars['String']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The party who owns this product record. */
  owner: ProductOwner;
  /** Units per packing. */
  packingUnits?: Maybe<Scalars['Float']>;
  /** Set of additional secondary identifiers that the client might want to associate with the product (eg: ASIN). */
  secondaryIdentifiers?: Maybe<Array<ProductSecondaryIdentifier>>;
  /** The identifier of shipper importing the product. */
  shipper: Shipper;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status: ProductStatus;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplier?: Maybe<Supplier>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Universal Product Code for the product. */
  upc?: Maybe<Scalars['String']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The weight of the product */
  weight?: Maybe<Weight>;
};


export type ProductdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProductBulkUploadConfirmationDetailError = {
  __typename?: 'ProductBulkUploadConfirmationDetailError';
  /** The error message. */
  reasons: Array<Scalars['String']>;
  /** The row this error occurred in. */
  row: Scalars['Float'];
};

export type ProductBulkUploadConfirmationDetailErrorInput = {
  /** The error message. */
  reasons: Array<Scalars['String']>;
  /** The row this error occurred in. */
  row: Scalars['Float'];
};

export type ProductBulkUploadConfirmationDetails = {
  __typename?: 'ProductBulkUploadConfirmationDetails';
  /** The errors that occurred during excel sheet validation. */
  errors?: Maybe<Array<ProductBulkUploadConfirmationDetailError>>;
  /** The number of products that will be created as a result of this processing. */
  numProductsToCreate: Scalars['Float'];
  /** The number of products that will be merged as a result of this processing. */
  numProductsToMerge: Scalars['Float'];
  /** The number of products that will be overwritten as a result of this processing. */
  numProductsToOverwrite: Scalars['Float'];
  /** The number of products that will be skipped as a result of this processing. */
  numProductsToSkip: Scalars['Float'];
};

export type ProductBulkUploadConfirmationDetailsInput = {
  /** The errors that occurred during excel sheet validation. */
  errors?: InputMaybe<Array<ProductBulkUploadConfirmationDetailErrorInput>>;
  /** The number of products that will be created as a result of this processing. */
  numProductsToCreate: Scalars['Float'];
  /** The number of products that will be merged as a result of this processing. */
  numProductsToMerge: Scalars['Float'];
  /** The number of products that will be overwritten as a result of this processing. */
  numProductsToOverwrite: Scalars['Float'];
  /** The number of products that will be skipped as a result of this processing. */
  numProductsToSkip: Scalars['Float'];
};

/** Product characteristic with type and description */
export type ProductCharacteristic = {
  __typename?: 'ProductCharacteristic';
  /** Characteristic description (max 57 chars) */
  description: Scalars['String'];
  /** Type of characteristic (COLOR, DESCRIPTION, or STYLE) */
  type: CharacteristicType;
};

/** Product characteristic with type and description */
export type ProductCharacteristicInput = {
  /** Characteristic description (max 57 chars) */
  description: Scalars['String'];
  /** Type of characteristic (COLOR, DESCRIPTION, or STYLE) */
  type: CharacteristicType;
};

/** Product code from PG02 record (SKU) */
export type ProductCode = {
  __typename?: 'ProductCode';
  /** Product code value (max 19 chars) */
  code: Scalars['String'];
  /** Type of product code (currently only SKU) */
  type: ProductCodeType;
};

/** Product code from PG02 record (SKU) */
export type ProductCodeInput = {
  /** Product code value (max 19 chars) */
  code: Scalars['String'];
  /** Type of product code (currently only SKU) */
  type: ProductCodeType;
};

/** CPSC product code type for PG02 record */
export enum ProductCodeType {
  /** Stock Keeping Unit - Manufacturer's internal product reference */
  SKU = 'SKU'
}

export type ProductComplianceDetails = {
  __typename?: 'ProductComplianceDetails';
  /** Customs compliance details for importing into Germany */
  de?: Maybe<ProductDeComplianceDetails>;
  /** Customs compliance details for importing into France */
  fr?: Maybe<ProductFrComplianceDetails>;
  /** Customs compliance details for importing into Great Britain */
  gb?: Maybe<ProductGbComplianceDetails>;
  /** Customs compliance details for importing into Netherland */
  nl?: Maybe<ProductNlComplianceDetails>;
  /** Customs compliance details for importing into United States */
  us?: Maybe<ProductUsComplianceDetails>;
};

export type ProductComplianceDetailsInput = {
  /** Customs compliance details for importing into Germany */
  de?: InputMaybe<ProductDeComplianceDetailsInput>;
  /** Customs compliance details for importing into France */
  fr?: InputMaybe<ProductFrComplianceDetailsInput>;
  /** Customs compliance details for importing into Great Britain */
  gb?: InputMaybe<ProductGbComplianceDetailsInput>;
  /** Customs compliance details for importing into Netherland */
  nl?: InputMaybe<ProductNlComplianceDetailsInput>;
  /** Customs compliance details for importing into United States */
  us?: InputMaybe<ProductUsComplianceDetailsInput>;
};

export type ProductDeComplianceDetails = {
  __typename?: 'ProductDeComplianceDetails';
  /** Entry lines. */
  entryLines?: Maybe<Array<ProductDeEntryLine>>;
};

export type ProductDeComplianceDetailsInput = {
  /** Entry lines. */
  entryLines?: InputMaybe<Array<ProductDeEntryLineInput>>;
};

export type ProductDeEntryLine = {
  __typename?: 'ProductDeEntryLine';
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<Supplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs associated with the line item. */
  tariffs?: Maybe<Array<ProductDeTariff>>;
};

export type ProductDeEntryLineInput = {
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<IdInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs associated with the line item. */
  tariffs?: InputMaybe<Array<ProductDeTariffInput>>;
};

/** Tariff associated with a line item. */
export type ProductDeTariff = {
  __typename?: 'ProductDeTariff';
  /** The HTS record. */
  hts?: Maybe<EuHs>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

/** Tariff associated with a line item. */
export type ProductDeTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type ProductEdge = ConnectionEdge & {
  __typename?: 'ProductEdge';
  cursor: Scalars['ID'];
  node: Product;
};

export type ProductEntryLineOrigin = {
  __typename?: 'ProductEntryLineOrigin';
  /** The origin country code. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** The origin state code.  */
  stateCode?: Maybe<Scalars['String']>;
};

export type ProductEntryLineOriginInput = {
  /** The origin country code. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The origin state code.  */
  stateCode?: InputMaybe<Scalars['String']>;
};

export type ProductFrComplianceDetails = {
  __typename?: 'ProductFrComplianceDetails';
  /** Entry lines. */
  entryLines?: Maybe<Array<ProductFrEntryLine>>;
};

export type ProductFrComplianceDetailsInput = {
  /** Entry lines. */
  entryLines?: InputMaybe<Array<ProductFrEntryLineInput>>;
};

export type ProductFrEntryLine = {
  __typename?: 'ProductFrEntryLine';
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<Supplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs associated with the line item. */
  tariffs?: Maybe<Array<ProductFrTariff>>;
};

export type ProductFrEntryLineInput = {
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<IdInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs associated with the line item. */
  tariffs?: InputMaybe<Array<ProductFrTariffInput>>;
};

/** Tariff associated with a line item. */
export type ProductFrTariff = {
  __typename?: 'ProductFrTariff';
  /** The HTS record. */
  hts?: Maybe<EuHs>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

/** Tariff associated with a line item. */
export type ProductFrTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type ProductGbComplianceDetails = {
  __typename?: 'ProductGbComplianceDetails';
  /** Entry lines. */
  entryLines?: Maybe<Array<ProductGbEntryLine>>;
};

export type ProductGbComplianceDetailsInput = {
  /** Entry lines. */
  entryLines?: InputMaybe<Array<ProductGbEntryLineInput>>;
};

export type ProductGbEntryLine = {
  __typename?: 'ProductGbEntryLine';
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<Supplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs associated with the line item. */
  tariffs?: Maybe<Array<ProductGbTariff>>;
};

export type ProductGbEntryLineInput = {
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<IdInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs associated with the line item. */
  tariffs?: InputMaybe<Array<ProductGbTariffInput>>;
};

/** Tariff associated with a line item. */
export type ProductGbTariff = {
  __typename?: 'ProductGbTariff';
  /** The HTS record. */
  hts?: Maybe<UkHs>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

/** Tariff associated with a line item. */
export type ProductGbTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type ProductIor = {
  __typename?: 'ProductIor';
  usIor?: Maybe<UsIor>;
};

export type ProductIorInput = {
  usIor?: InputMaybe<IdInput>;
};

/** Product Level Inquiry for this inquiry. */
export type ProductLevelInquiry = {
  __typename?: 'ProductLevelInquiry';
  /** Amazon Standard Identification Number associated with the product */
  asin?: Maybe<Scalars['ProductAsinIdentifier']>;
  /** Client identifier for the product (SKU) */
  clientIdentifier: Scalars['String'];
  /** Version of the client identifier (SKU) used for this product */
  clientIdentifierVersion?: Maybe<Scalars['Float']>;
  /** List of issues along with suggestions to fix */
  feedback?: Maybe<Array<ProductLevelInquiryFeedback>>;
};

/** Reason code for the product line inquiry along with suggestion to fix */
export type ProductLevelInquiryFeedback = {
  __typename?: 'ProductLevelInquiryFeedback';
  /** The ProductLevelInquiryReasonCode for this product */
  reasonCode: ProductLevelInquiryReasonCode;
  /** Suggestion to help shipper fix the product level issue */
  suggestionToFix?: Maybe<Scalars['String']>;
};

/** Reason code for the product line inquiry along with suggestion to fix */
export type ProductLevelInquiryFeedbackInput = {
  /** The ProductLevelInquiryReasonCode for this product */
  reasonCode: ProductLevelInquiryReasonCode;
  /** Suggestion to help shipper fix the product level issue */
  suggestionToFix?: InputMaybe<Scalars['String']>;
};

/** Product Level Inquiry for this inquiry. */
export type ProductLevelInquiryInput = {
  /** Amazon Standard Identification Number associated with the product */
  asin?: InputMaybe<Scalars['ProductAsinIdentifier']>;
  /** Client identifier for the product (SKU) */
  clientIdentifier: Scalars['String'];
  /** Version of the client identifier (SKU) used for this product */
  clientIdentifierVersion?: InputMaybe<Scalars['Float']>;
  /** List of issues along with suggestions to fix */
  feedback?: InputMaybe<Array<ProductLevelInquiryFeedbackInput>>;
};

/** The reason code for the work order product level inquiry */
export enum ProductLevelInquiryReasonCode {
  GOODS_DESCRIPTION_INACCURATE = 'GOODS_DESCRIPTION_INACCURATE',
  INCORRECT_COUNTRY_OF_ORIGIN = 'INCORRECT_COUNTRY_OF_ORIGIN',
  INCORRECT_HS_CODE = 'INCORRECT_HS_CODE',
  INCORRECT_VALUATION = 'INCORRECT_VALUATION',
  OTHER = 'OTHER',
  REQUIRES_FURTHER_DOCUMENTATION = 'REQUIRES_FURTHER_DOCUMENTATION',
  REQUIRES_SUPPLEMENTARY_UNITS = 'REQUIRES_SUPPLEMENTARY_UNITS'
}

export type ProductLibraryConfiguration = {
  __typename?: 'ProductLibraryConfiguration';
  saveBack?: Maybe<SaveBackConfiguration>;
};

export type ProductLibraryConfigurationInput = {
  saveBack?: InputMaybe<SaveBackConfigurationInput>;
};

export type ProductNlComplianceDetails = {
  __typename?: 'ProductNlComplianceDetails';
  /** Entry lines. */
  entryLines?: Maybe<Array<ProductNlEntryLine>>;
};

export type ProductNlComplianceDetailsInput = {
  /** Entry lines. */
  entryLines?: InputMaybe<Array<ProductNlEntryLineInput>>;
};

export type ProductNlEntryLine = {
  __typename?: 'ProductNlEntryLine';
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<Supplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** Tariffs associated with the line item. */
  tariffs?: Maybe<Array<ProductNlTariff>>;
};

export type ProductNlEntryLineInput = {
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<IdInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** Tariffs associated with the line item. */
  tariffs?: InputMaybe<Array<ProductNlTariffInput>>;
};

/** Tariff associated with a line item. */
export type ProductNlTariff = {
  __typename?: 'ProductNlTariff';
  /** The HTS record. */
  hts?: Maybe<EuHs>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

/** Tariff associated with a line item. */
export type ProductNlTariffInput = {
  /** The HTS record. */
  hts?: InputMaybe<IdInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type ProductOwner = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Product owner's name. */
  name: Scalars['String'];
  /** The configuration for this party's product library */
  productLibraryConfiguration?: Maybe<ProductLibraryConfiguration>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Reference to CPSC Product Registry for REF message set (PG02 + PG14) */
export type ProductRegistryReference = {
  __typename?: 'ProductRegistryReference';
  /** Certifier ID for the Product Registry */
  certifierId: Scalars['String'];
  /** Product ID in CPSC Product Registry (PRI type) */
  productId: Scalars['String'];
  /** Version ID in CPSC Product Registry (PRIV type) */
  versionId: Scalars['String'];
};

/** Reference to CPSC Product Registry for REF message set (PG02 + PG14) */
export type ProductRegistryReferenceInput = {
  /** Certifier ID for the Product Registry */
  certifierId: Scalars['String'];
  /** Product ID in CPSC Product Registry (PRI type) */
  productId: Scalars['String'];
  /** Version ID in CPSC Product Registry (PRIV type) */
  versionId: Scalars['String'];
};

/** The fields and their values used to search Products. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
export type ProductSearchCriteriaInput = {
  /** ASIN for this Product */
  asin?: InputMaybe<TextSearchCriteriaInput>;
  /** The Product's description. */
  cbpDescription?: InputMaybe<TextSearchCriteriaInput>;
  /** Client identifier for the product (eg, SKU, ASIN, etc). */
  clientIdentifier?: InputMaybe<TextSearchCriteriaInput>;
  /** The country of origin of the Product. */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country specific HS # of the Product in the form of country:HsNumber. */
  hsNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The US HTS # of the Product. */
  htsNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Importer of Record for the Product. */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Product's name. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Product's name. */
  productName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Shipper moving the Product. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Shipper moving the Product. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status?: InputMaybe<TextSearchCriteriaInput>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplierId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplierName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The unit value of the Product. */
  unitValue?: InputMaybe<FloatSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Product search table row. */
export type ProductSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ProductSearchTableRow';
  /** ASIN for this Product */
  asin?: Maybe<Scalars['String']>;
  /** The Product's description. */
  cbpDescription?: Maybe<Scalars['String']>;
  /** Client identifier for the product (eg, SKU, ASIN, etc). */
  clientIdentifier?: Maybe<Scalars['String']>;
  /** The country of origin of the Product. */
  countryName?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The country specific HS # of the Product in the form of country:HsNumber. */
  hsNumber?: Maybe<Array<Scalars['String']>>;
  /** The US HTS # of the Product. */
  htsNumber?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Importer of Record name. */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** The Product's name. */
  name?: Maybe<Scalars['String']>;
  /** The Product's name. */
  productName?: Maybe<Scalars['String']>;
  /** The Shipper's name. */
  shipperName?: Maybe<Scalars['String']>;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status?: Maybe<Scalars['String']>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplierId?: Maybe<Array<Scalars['ID']>>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplierName?: Maybe<Array<Scalars['String']>>;
  /** The Product's name. */
  unitValue?: Maybe<Array<Scalars['Float']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Represents additional secondary identifier and its types for a product.  */
export type ProductSecondaryIdentifier = {
  __typename?: 'ProductSecondaryIdentifier';
  /** The type of additional identifer. */
  type: ProductSecondaryIdentifierType;
  /** The secondary identifer/value. */
  value: Scalars['String'];
};

/** Represents additional secondary identifier and its types for a product.  */
export type ProductSecondaryIdentifierInput = {
  /** The type of additional identifer. */
  type: ProductSecondaryIdentifierType;
  /** The secondary identifer/value. */
  value: Scalars['String'];
};

export enum ProductSecondaryIdentifierType {
  ASIN = 'ASIN'
}

export type ProductSpreadsheetPreviewInput = {
  /** A map of the CBMS column name to column letter in the spreadsheet (e.g. { "name": "A" } where "name" is the label for column "A" in the spreadsheet). */
  columns: Scalars['JSONObject'];
  /** Indicates the behavior that the API should emulate when deciding how to handle record duplicates. */
  duplicateAction: SpreadsheetActionType;
  /** Indicates whether the spreadsheet contains headers or not. */
  hasHeaders?: InputMaybe<Scalars['Boolean']>;
  /** Rows of spreadsheet data contained in the uploaded spreadsheet (e.g. { "A": "123" } where "A" is column "A"). */
  rows: Array<Scalars['JSONObject']>;
  /** The shipper related to the records being uploaded in the spreadsheet. */
  shipper: IdInput;
  /** The manufacturer of the products being uploaded in the spreadsheet. */
  supplier?: InputMaybe<IdVersionInput>;
};

export type ProductSpreadsheetPreviewPayload = {
  __typename?: 'ProductSpreadsheetPreviewPayload';
  /** A preview of the number of unique records that will be created in CBMS based on the data contained in the spreadsheet. */
  numberOfCreates: Scalars['Int'];
  /** A preview of the number of unique records that will be updated in CBMS based on the data contained in the spreadsheet. */
  numberOfMerges: Scalars['Int'];
  /** The number of records that that will fallback to the CBMS record if it is already owned by the shipper in CBMS. */
  numberOfOverwrites: Scalars['Int'];
  /** The number of rows in the uploaded spreadsheet that were skipped due to missing information. */
  numberOfSkips: Scalars['Int'];
  /** Total number of records uploaded in the spreadsheet. */
  numberOfUploadedRecords: Scalars['Int'];
  /** An array of objects containing data from the uploaded spreadsheet. All objects in this array are unique depending on the record type. */
  spreadsheetRows: Array<Scalars['JSONObject']>;
  /** An array of objects containing data from the uploaded spreadsheet. May or may not contain duplicate data depending on what was uploaded. */
  spreadsheetRowsWithDuplicates: Array<Scalars['JSONObject']>;
  /** An object that contains arrays of errors we may have encountered while processing the spreadsheet. */
  warnings: Scalars['JSONObject'];
};

/** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
export enum ProductStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INTERNAL = 'INTERNAL'
}

/** The product type */
export enum ProductType {
  HOT = 'HOT',
  NON_HOT = 'NON_HOT',
  NON_PREMIUM = 'NON_PREMIUM',
  NON_REFILE = 'NON_REFILE',
  PREMIUM = 'PREMIUM',
  REFILE = 'REFILE'
}

export type ProductTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ProductType>>;
};

export type ProductUsComplianceDetails = {
  __typename?: 'ProductUsComplianceDetails';
  /** Entry lines. */
  entryLines?: Maybe<Array<ProductUsEntryLine>>;
  /** Whether the lines in this product represent a set. */
  isSet?: Maybe<Scalars['Boolean']>;
};

export type ProductUsComplianceDetailsInput = {
  /** Entry lines. */
  entryLines?: InputMaybe<Array<ProductUsEntryLineInput>>;
  /** Whether the lines in this product represent a set. */
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type ProductUsEntryLine = {
  __typename?: 'ProductUsEntryLine';
  /** The Anti-Dumping Case record. */
  adCase?: Maybe<AdCvdCase>;
  /** The Anti-Dumping Case record. */
  adCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: Maybe<Cost>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: Maybe<UsAluminumRequirements>;
  /** The Countervailing Case record. */
  cvCase?: Maybe<AdCvdCase>;
  /** The Countervailing Case record. */
  cvCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: Maybe<Cost>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: Maybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: Maybe<Scalars['Boolean']>;
  feeOptions?: Maybe<Array<UsCbpEntryLineFeeOption>>;
  /** The license code. */
  licenseCode?: Maybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: Maybe<Scalars['String']>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<Supplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** The purchase order (PO) number of the line item */
  poNumber?: Maybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: Maybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: Maybe<UsProductEntryLineRuling>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: Maybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: Maybe<UsSteelRequirements>;
  /** Tariffs associated with the line item. */
  tariffs?: Maybe<Array<ProductUsTariff>>;
  taxOptions?: Maybe<Array<UsCbpEntryLineTaxOption>>;
};

export type ProductUsEntryLineInput = {
  /** The Anti-Dumping Case record. */
  adCase?: InputMaybe<IdInput>;
  /** The Anti-Dumping Case record. */
  adCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: InputMaybe<CostInput>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: InputMaybe<UsAluminumRequirementsInput>;
  /** The Countervailing Case record. */
  cvCase?: InputMaybe<IdInput>;
  /** The Countervailing Case record. */
  cvCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: InputMaybe<CostInput>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: InputMaybe<Scalars['Boolean']>;
  feeOptions?: InputMaybe<Array<UsCbpEntryLineFeeOptionInput>>;
  /** The license code. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<IdInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** The purchase order (PO) number of the line item */
  poNumber?: InputMaybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: InputMaybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: InputMaybe<UsProductEntryLineRulingInput>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: InputMaybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: InputMaybe<UsSteelRequirementsInput>;
  /** Tariffs associated with the line item. */
  tariffs?: InputMaybe<Array<ProductUsTariffInput>>;
  taxOptions?: InputMaybe<Array<UsCbpEntryLineTaxOptionInput>>;
};

/** Data requirements reported to a US CBP Partner Government Agency. */
export type ProductUsPga = {
  __typename?: 'ProductUsPga';
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: Maybe<Scalars['String']>;
  /** A distinct and legible mark, properly applied with a freeze brand, hot iron, or other method, and easily visible on the live animal and on the carcass before skinning. Used by APHIS. */
  animalBrand?: Maybe<Scalars['String']>;
  /** Number that characterizes the commercial product or component. Used by: APHIS */
  aphProductCode?: Maybe<Scalars['String']>;
  /** APHIS VS 17-32. Application for Inspection and Dipping. */
  applicationForInspectionAndDipping?: Maybe<Lpco>;
  /** Category code for weapons. Used by: ATF */
  atfCategory?: Maybe<Scalars['AtfCategoryCode']>;
  /** A permit that authorizes the importation of firearms, ammunitions, and implements of war into the United States or any possession thereof, except for certain exempt importations presecribed in 27 CFR parts 447, 478 and 479. Used by: ATF */
  atfImportPermit?: Maybe<Lpco>;
  /** Registered importers of firearms, ammunition firearms parts or implements of war other, than sporting shotguns, shotgun shells, or shotgun parts, must also register under the Arms Export Control Act of 1976. Used by: ATF */
  atfImporterRegistration?: Maybe<Lpco>;
  /** Identification method often used on aves (birds). Used by APHIS. */
  band?: Maybe<Scalars['String']>;
  /** Cut Flowers Bouquet Grouping Code. Used by APHIS. */
  bouquetGroupingCode?: Maybe<Scalars['String']>;
  /** APHIS BRS Acknowledgement letter */
  brsAcknowledgementLetter?: Maybe<Lpco>;
  /** APHIS BRS Notification. */
  brsNotification?: Maybe<Lpco>;
  /** Chemical Abstract Service Number. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  casNumber?: Maybe<Scalars['String']>;
  /** Commodity category code used to further describe the reported item. Used by: APHIS, NHTSA, ATF */
  categoryCode?: Maybe<Scalars['String']>;
  /** Category type code used to describe the reported item. Used by: APHIS. */
  categoryTypeCode?: Maybe<Scalars['String']>;
  /** US TTB Certificate of Label Approval Number Used by: TTB */
  certificateOfLabelApproval?: Maybe<UsTtbCertificateOfLabelApproval>;
  /** Certificate of Origin. Used by APHIS. */
  certificateOfOrigin?: Maybe<Lpco>;
  /** PGA source and processing data Used by: APHIS, FDA */
  characteristics?: Maybe<Array<CommodityCharacteristic>>;
  /** Chemical Abstract Service Numbers. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  chemicalAbstractServiceNumbers?: Maybe<Array<Scalars['String']>>;
  /** This number corresponds to the box number from DOT HS-7 Required by: NHTSA */
  conformanceDeclaration?: Maybe<Scalars['String']>;
  /** Constituent elements of the product/component. Required for: APHIS (Lacey Act), DEA. Used by: FWS. Optional for: EPA, FDA */
  constituentElements?: Maybe<Array<ConstituentElement>>;
  /** APHIS PPQ587-41. Permit to Import Plants and Plant Products Regulated by 7CFR319.41 (Indian Corn or Maize, Broomcorn, etc.) */
  cornPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-8. Permit to Import Plants and Plant Products Regulated by 7CFR319.8 (Foreign Cotton or Covers) */
  cottonPermit?: Maybe<Lpco>;
  /** Crop Grower. Supplier type. Required for Cut flowers (Category Type Code AP0800). Used by APHIS. */
  cropGrower?: Maybe<Supplier>;
  /** APHIS VS 17-29. Declaration of Importation. */
  declarationOfImportation?: Maybe<Lpco>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the US manufacturer. Should always be the domestic firm registration number associated with the U.S. manufacturer and not the foreign manufacturer. Used by: FDA (medical devices) */
  deviceDomesticManufacturer?: Maybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the exporter who exports or offers for export to the United States (U.S.), a device manufactured or processed by another individual, partnership, corporation or association in a foreign country, as well as devices originally manufactured in the United States. Used by: FDA (medical devices) */
  deviceForeignExporter?: Maybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the foreign manufacturer. Should always be the foreign firm registration number associated with the foreign manufacturer and not the US specifications developer. Used by: FDA (medical devices) */
  deviceForeignManufacturer?: Maybe<Scalars['String']>;
  /** Defines whether a radiation emitting product is a finished product or just a component */
  deviceForm?: Maybe<UsFdaRadiationEmittingDeviceForm>;
  /** Device Initial Importer. Where the IOR is a US entity, DII will default to the IOR. If the IOR is a non-resident, then ops will have to select the DII. */
  deviceInitialImporter?: Maybe<DiiCustomsAgent>;
  /** Device Listing Number provided by CDRH Used by: FDA (medical devices) */
  deviceListingNumber?: Maybe<Scalars['String']>;
  /** Device Premarket Approval Number or Device Premarket Notification Number (510(K))/DeNovo number issued by CDRH (Center for Devices and Radiological Health) or CBER. This also includes Humanitarian Device Exemption (HDE). Premarket number should always be the number that is on the listing record. Used by: FDA (medical devices) */
  devicePremarketNumber?: Maybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: Maybe<UsPgaDisclaimerCode>;
  /** APHIS 7040B/7040C. Import Permit for Dogs. */
  dogsPermit?: Maybe<Lpco>;
  /** Department of Transportation conformance bond. Used by: NHTSA */
  dotBond?: Maybe<DotBond>;
  /** The placement of the driver's seat in a vehicle Used by: NHTSA */
  driveSide?: Maybe<VehicleDriveSide>;
  /** New Drug (NDA), Abbreviated New Drug (AND/ANDA), or Therapeutic Biologic Application Number issued by CBER or CDER. Used by: FDA (drugs) */
  drugApplicationNumber?: Maybe<Scalars['String']>;
  /** Defines whether a drug is an active pharmaceutical ingredient (API) / bulk drug substance, or a finished drug form (e.g. tablet, capsule, solution). */
  drugForm?: Maybe<UsFdaDrugForm>;
  /** Drug Listing Number (DLS), for a bulk Active Pharmaceutical Ingredient (API), or National Drug Code (NDC), for finished drugs, issued by FDA. The first segment of numbers is the labeler code. This number identifies the manufacturer of the product. Declare without dashes. Used by: FDA (drugs) */
  drugListingNumber?: Maybe<Scalars['String']>;
  /** Drug Registration Number issued by Center for Drug Evaluation and Research (CDER), Center for Veterinary Medicine (CVM), or Center for Biologics Evaluation and Research (CBER) for the manufacturer. The Federal Food, Drug, and Cosmetic Act (FFD&C) requires most establishments that manufacturer, prepare, propagate, compound, or process a drug or drugs, to register with the FDA. Currently, the establishment registration number is the Dun & Bradstreet Data Universal Numbering System number (DUNS) for CDER and CVM. The establishment registration number can be the FDA Establishment Identification (FEI) or DUNS for CBER. Used by: FDA (drugs)   */
  drugRegistrationNumber?: Maybe<Scalars['String']>;
  /** Device (Electrode) Lead Wire or Patient Cable, used when importing electrode lead wires, patient cables, or devices that use them. The affirmation indicates either (1) the device shipment does not contain any pre-wired electrodes, electrode lead wires, or patient (transducer) cables, or (2) any pre-wired electrodes, electrode lead wires or patient cables comply with 21 CFR 898, Performance Standard for Electrode Lead Wires and Patient Cables. Used by: FDA (medical devices) */
  electrode?: Maybe<Scalars['Boolean']>;
  /** The two-letter ISO country code that identifies the Importer’s Embassy Used by: NHTSA */
  embassyCountryCode?: Maybe<Scalars['CountryCode']>;
  /** EPA Vehicles and Engines Engine Power Rating Used by: EPA */
  enginePowerRating?: Maybe<Quantity>;
  /** Engine data. Used by: EPA */
  engines?: Maybe<Array<UsPgaEngine>>;
  /** See https://www.epa.gov/compliance/pesticide-establishment-registration-and-reporting Used by: EPA */
  epaProducerEstablishmentNumber?: Maybe<Lpco>;
  /** The EPA Reg. No. of a product for primary registrants consists of two set of numbers separated by a hyphen, for example EPA Reg. No. 12345-12. The first set of numbers refers to the registrant’s company identification number, and the second set of numbers represents the product number. Used by: EPA */
  epaRegistrationNumber?: Maybe<Lpco>;
  /** EPA Vehicles and Engines Test Group Name/Number Used by: EPA */
  epaTestGroup?: Maybe<Scalars['String']>;
  /** The FDA product code of the product/component. Required by: FDA */
  fdaProductCode?: Maybe<Scalars['String']>;
  /** A license or permit issued to anyone who wishes to transport, ship, and cause to be transported, or receive explosives materials under 27 CFR 555.41. Used by: ATF */
  federalExplosiveLicense?: Maybe<Lpco>;
  /** Federal firearms license issued under the provisions of the Gun Control Act (GCA) to manufacture, import or  in firearms and/or ammunition. Used by: ATF */
  federalFirearmsLicense?: Maybe<Lpco>;
  /** Food Canning Establishment Number (FCE) that identifies a site-specific manufacturer of acidified and/or low-acid canned food products. Form FDA 2541 is  used for the manufacturing firm registration. See the SID and VOL Affirmation Code definitions below Used by: FDA (LACF/AF food) */
  foodCanningEstablishmentNumber?: Maybe<Scalars['String']>;
  /** Food container dimensions. Required by: FDA (LACF and AF Food) */
  foodContainerDimensions?: Maybe<Dimensions>;
  foodFacilityRegistration?: Maybe<UsFdaFoodFacilityRegistration>;
  /** Acidified & Low-Acid Canned Foods (LACF/AF) Volume. May be used to communicate the container volume and unit of measure of an Acidified Food (AF) or Low-Acid Food (LACF) product that is packaged in a container that does not have a traditional size/dimension. The filer should verify with the importer whether  the container size/dimensions or volume were supplied to FDA by the manufacturer. Use of this field instead of the Container Size/Dimension, when  Container Size/Dimension is part of the scheduled process, will result in a failure of the automated data base look-up. Used by: FDA (LACF/AF food) */
  foodVolume?: Maybe<Scalars['String']>;
  /** The foreign certificate for imported distilled spirits and wine. Used by: TTB */
  foreignCertificate?: Maybe<Lpco>;
  /** APHIS PPQ 203. Foreign Site Certificate of Inspection and/or treatment. */
  foreignSiteCertificateOfInspection?: Maybe<Lpco>;
  /** Foreign Supplier Verification Program Importer. Where the IOR is a US entity, FSVP will default to the IOR. If the IOR is a non-resident, then ops will have to select the FSVP. */
  foreignSupplierVerificationProgram?: Maybe<FsvpCustomsAgent>;
  /** APHIS PPQ587-56. Permit to Import Plants and Plant Products Regulated by 7CFR319.56 (Fruits and Vegetables). */
  fruitsAndVegetablesPermit?: Maybe<Lpco>;
  /** A NHTSA-assigned code identifying the glazing manufacturer. Formatted N or NN or NNN or NNNN (e.g., 1234) Used by: NHTSA */
  glazingManufacturerCode?: Maybe<Scalars['String']>;
  /** GS1 Global Product Classification Brick Code (GPCB). An 8-digit number designating a set of products with similar characteristics as defined by GS1 at http://www.gs1.org/gsmp/kc/gpc. Used by APHIS. */
  globalProductClassificationBrickCode?: Maybe<Scalars['String']>;
  /** APHIS BRS 2000. Application for Permit or Courtesy Permit for Movement or Release of Genetically Engineered Organisms. */
  gmoPermit?: Maybe<Lpco>;
  /** Health Certificate. Used by APHIS. */
  healthCertificate?: Maybe<Lpco>;
  /** Device Impact Resistance Lens Certification, used to certify that the filer has, on hand, the test results or a certificate that shows that the product has met the standards for impact resistance lenses. FDA has the authority to ask for copies of the actual test results. Each batch within the shipment must have its own test results. Used by: FDA (medical devices) */
  impactResistanceLensCertification?: Maybe<Scalars['Boolean']>;
  /** APHIS 2006. Importation of Veterinary Biological Products. */
  importationOfVeterinaryBiologicalProducts?: Maybe<Lpco>;
  /** Data pertaining to an inspection. Used by: APHIS, FWS */
  inspection?: Maybe<UsPgaInspection>;
  /** The intended use code of the product/component. Required by: APHIS, FDA, EPA Used by: FWS */
  intendedUse?: Maybe<Scalars['String']>;
  /** Describes the intended use of the product/component. Used by: FWS */
  intendedUseDescription?: Maybe<Scalars['String']>;
  /** Investigational New Drug Application Number issued by CBER or CDER. Investigational drugs are new drugs intended solely for investigational use by  experts qualified by scientific training and experiences to investigate the safety and effectiveness of drugs. The Federal Food, Drug, and Cosmetic Act (FFD&C) Act requires that a drug be the subject of an approved marketing application before it is transported or distributed across state lines (including import). A sponsor who wants to ship the investigational drug to clinical investigators must seek an exemption from that legal requirement. Used by: FDA (investigational new drugs) */
  investigationNewDrugApplicationNumber?: Maybe<Scalars['String']>;
  /** Investigational Device Exemption Number issued by CBER or CDRH. Devices that qualified experts use on human subjects, to conduct investigations of their safety and effectiveness, are considered investigational devices. For devices destined for non-significant risk study (NSR), an Institutional Review Boards(IRB) letter affirming NSR must be provided to FDA. In such case, provide 'NSR'. Used by: FDA (medical devices) */
  investigationalDeviceExemptionNumber?: Maybe<Scalars['String']>;
  /** The importer is an original manufacturer of motor vehicles (or a wholly owned subsidiary thereof) that is certified to conform to all applicable Federal Motor Vehicle Safety Standards (FMVSS). Use on the public roads must be authorized specifically. [591.6(f )(1) or (2)]; Used by: NHTSA */
  iorIsVehicleManufacturer?: Maybe<Scalars['Boolean']>;
  /** Internal Revenue Code (IRC) registry number for the distilled spirits plant, bonded wine cellar, or brewery. Used by: TTB */
  ircRegistryNumber?: Maybe<Lpco>;
  /** Indicates that information should be treated as confidential. Used by: DEA, FWS */
  isConfidentialInformation?: Maybe<Scalars['Boolean']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) Used by: APHIS, EPA, NHTSA, FWS */
  isImageSubmitted?: Maybe<Scalars['Boolean']>;
  /** Identifies Toxic Substance Control Act positive or negative certification. Positive – I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA. Negative – I certify that all chemicals in this shipment are not subject to TSCA. Used by: EPA */
  isTscaCompliant?: Maybe<Scalars['Boolean']>;
  /** The unique identity for the item. Used by: APHIS */
  itemIdentity?: Maybe<ItemIdentity>;
  /** APHIS PPQ587-75. Permit to Import Plants and Plant Products Regulated by 7CFR319.75 (Khapra Beetle). */
  khapraBeetlePermit?: Maybe<Lpco>;
  /** The tariffs associated Independent Third Party Laboratory or Clinical Site. Required for investigational drugs. Required by: FDA (investigational new drugs) */
  laboratory?: Maybe<Facility>;
  /** The type of laboratory. Required by: FDA (investigational new drugs) */
  laboratoryTypeCode?: Maybe<UsFdaLaboratoryType>;
  /** Live Animal Tag Ranges. Used by APHIS. */
  liveAnimalTagRanges?: Maybe<Array<LiveAnimalTagRange>>;
  /** Live Animal Tag. Used by APHIS. */
  liveAnimalTags?: Maybe<Array<Scalars['String']>>;
  /** APHIS VS 17-135. Permit to Import Live Animals. */
  liveAnimalsPermit?: Maybe<Lpco>;
  /** Manufacturer assigned lot number for the product. Required by: FDA (prior notice LACF/AF food, infant formula) */
  lotNumber?: Maybe<Scalars['String']>;
  /** LPCO Authorized Party. Location type. Required if at least one LPCO is used. Used by APHIS. */
  lpcoAuthorizedParty?: Maybe<Facility>;
  /** Location of the manufacture date of the vehicle or engine. Used by: EPA */
  manufactureDateLocation?: Maybe<Scalars['String']>;
  /** Meat Certificate. Meat Certificate required by APHIS/FSIS to document sanitary condition and wholesomeness of animal or meat products. (Note: Meat and Sanitary Certificates can be “one and the same”). */
  meatCertificate?: Maybe<Lpco>;
  /** Microchip. Used by APHIS. */
  microchip?: Maybe<Scalars['String']>;
  /** NMFS Tag Number. The individual tag number of the fish. Used by APHIS. */
  nmfsTagNumber?: Maybe<Scalars['String']>;
  /** Free form information found in box 18 of EPA Form 3540-01. Required if EPA Registration number not provided. */
  noticeOfArrival?: Maybe<Scalars['String']>;
  /** USDA APHIS PPQ Notice Of Arrival */
  noticeOfArrivalPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-37. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Nursery Stock, Plants, Roots, Bulbs, Seeds). */
  nurseryPlantsPermit?: Maybe<Lpco>;
  /** Offical Animal Number. Unique number given by a national authority to identify an animal individually. Used by APHIS. */
  officialAnimalNumber?: Maybe<Scalars['String']>;
  /** Original country where routing to the US began. Required for: APHIS Used by: FWS */
  originCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Packaging associated with a PGA. Required if subject to FDA Prior Notice or a Performance Standard Used by: FDA, APHIS, EPA */
  packaging?: Maybe<Array<Quantity>>;
  /** Quantity of cigarette tubes or papers. Used by: TTB */
  paperOrTubeQuantity?: Maybe<Scalars['Int']>;
  /** Two-letter ISO country code of the country that issued the passport. Used by: NHTSA */
  passportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Government issued passport number to certify the identity and nationality of the person importing the product. Used by: NHTSA */
  passportNumber?: Maybe<Scalars['String']>;
  /** Pesticide Control Number Used by: EPA */
  pcNumber?: Maybe<Scalars['String']>;
  /** Subject to a performance standard: FDA */
  performanceStandard?: Maybe<Scalars['Boolean']>;
  /** A letter issued by NHTSA permitting a nonconforming vehicle to be imported pursuant to 49 CFR 591.5(j) or 591(I). Formatted as NN-NNNN-NNNN. Used by: NHTSA */
  permissionLetter?: Maybe<Lpco>;
  /** Permitted Destination. Location type. Required if a Veterinary Biologics product (Category Code 307). Used by APHIS. */
  permittedDestination?: Maybe<Facility>;
  /** Phytosanitary Certificate. Phytosanitary certificate required by APHIS to document the cleanliness (pest and disease) of Plant products. */
  phytosanitaryCertificate?: Maybe<Lpco>;
  /** APHIS PPQ 526. Permit to Move Live Plant Pests or Noxious Weeds. */
  plantPestsPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-37CAN. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Canadian-Origin). */
  plantsOfCanadianOriginPermit?: Maybe<Lpco>;
  /** The name of the political subunit, e.g. state, province, or region through which goods are routed between the country of original departure and the country of final destination. Used by: APHIS */
  politicalSubunitName?: Maybe<Scalars['String']>;
  /** APHIS PPQ 546. Post-entry Quarantine Permit. */
  postEntryQuarantinePermit?: Maybe<Lpco>;
  /** US FDA Prior Notice data requirements. */
  priorNotice?: Maybe<UsFdaPriorNotice>;
  /** Code indicating the specific PGA processing requirements for which the data set is related. */
  processingCode?: Maybe<Scalars['String']>;
  /** A code indicating the type of product number used to characterize the product or component. Used by: APHIS */
  productQualifierCode?: Maybe<Scalars['String']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: Maybe<Scalars['String']>;
  /** APHIS PPQ 588. Permit to Import Prohibited Plant Material For Research Purposes. */
  prohibitedPlantForResearchPermit?: Maybe<Lpco>;
  /** APHIS PPQ 621. Protected Plant Permit to Engage in the Business of Importing, Exporting, or Re-exporting Terrestrial Plants or Plant Products that are Protected and Regulated by 50CFR17.12 or 50CFR23.23 (CITES: Threatened or Endangered Species). */
  protectedPlantPermit?: Maybe<Lpco>;
  /** Rabies Vaccination Certificate. Used by APHIS. */
  rabiesVaccinationCertifcate?: Maybe<Lpco>;
  radiationDeclaration?: Maybe<RadiationDeclaration>;
  /** Rail car numbers Used by: FDA (prior notice food arriving via rail/containerized rail.) */
  railCarNumbers?: Maybe<Array<Scalars['String']>>;
  /** Country that has refused the shipment. Used by: FDA */
  refusalCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Number assigned by NHTSA to a person or business entity specially registered with NHTSA as an importer of nonconforming motor vehicles pursuant to 49 CFR Part 592. Formatted as A-NN-NNN. Used by: NHTSA */
  registeredImporterNumber?: Maybe<Lpco>;
  /** Radio Frequency Identification. Used by APHIS. */
  rfid?: Maybe<Scalars['String']>;
  /** APHIS PPQ587-55. Permit to Import Plants and Plant Products Regulated by 7CFR319.55 (Rice). */
  ricePermit?: Maybe<Lpco>;
  /** LACF/AF Submission/Scheduled Process Identifier Number (SID) Used by: FDA (LACF/AF food) */
  scheduleIdentifierNumber?: Maybe<Scalars['String']>;
  /** APHIS Seed Analysis Certificate (PPQ Form 925, CFIA Form 5289, CFIA Form 5309 or similar form) */
  seedAnalysisCertificate?: Maybe<Lpco>;
  /** Country from where the product/component shipped. Required by: FDA (Food subject to Prior Notice) */
  shipmentCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Slaughter Number. Unique number given by a slaughterhouse to an animal or a group of animals of the same breed. Used by APHIS. */
  slaughterNumber?: Maybe<Scalars['String']>;
  /** APHIS PPQ 525B. Soil Permit. */
  soilPermit?: Maybe<Lpco>;
  /** PGA source and processing data Used by: APHIS, FDA */
  source?: Maybe<UsPgaSource>;
  /** USDA APHIS VS STAT Documents (Statements) (e.g. Manufacturer’s Statement, Owner/Importer Statements, Producer Statements) */
  statementsPermit?: Maybe<Lpco>;
  /** The storage location of the vehicle or engine. Used by: EPA */
  storageLocation?: Maybe<Facility>;
  /** APHIS PPQ587-15. Permit to Import Plants and Plant Products Regulated by 7CFR319.15 (Sugarcane) */
  sugarcanePermit?: Maybe<Lpco>;
  /** Taxonomic Serial Number (TSN). A unique serial number assigned to a taxonomic unit by the Integrated Taxonomic Informational System at http://www.itis.gov. Used by APHIS. */
  taxonomicSerialNumber?: Maybe<Scalars['String']>;
  /** APHIS PPQ 585. Permit to Import Timber or Timber Products */
  timberPermit?: Maybe<Lpco>;
  /** A NHTSA-assigned code identifying the tire manufacturer. Formatted ANAN or ANANAN (e.g., 1B or ABC) Used by: NHTSA */
  tireManufacturerCode?: Maybe<Scalars['String']>;
  /** The Trade Name of the product/component. Used by: EPA, FDA, NHTSA */
  tradeName?: Maybe<Scalars['String']>;
  /** Country through which goods or passengers are routed between the country of original departure and final destination. Used by: APHIS */
  transitCountryCode?: Maybe<Scalars['CountryCode']>;
  /** APHIS PPQ 586. Permit to Transit Plants and/or Plant Products, Plant Pests, and/or Associated Soil. */
  transitPlantsPermit?: Maybe<Lpco>;
  /** Country where goods are to be or have been transferred from one means of transport to another during the course of one transport operation. Used by: APHIS */
  transshipmentCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Treatment Certificate. Used by APHIS. */
  treatmentCertificate?: Maybe<Lpco>;
  /** TTB-issued permit number indicating the IRC-bonded facility, manufacturer, or export warehouse proprietor. Used by: TTB */
  ttbFacilityPermitNumber?: Maybe<Lpco>;
  /** The importer's permit number assigned by TTB Used by: TTB */
  ttbImporterPermitNumber?: Maybe<Lpco>;
  /** UN Standard Products and Services Code (UNSPSC) Commodity Code. An 8-digit number designating a set of products with similar characteristics as defined by the United Nations at http://www.unspsc.org. Used by APHIS. */
  unpscCommodityCode?: Maybe<Scalars['String']>;
  /** Vehicle data. Used by: EPA, NHT */
  vehicle?: Maybe<UsPgaVehicle>;
  /** NHTSA-assigned number to identify a vehicle that is not certified to the Federal motor vehicle safety standards as being eligible for importation by a registered importer under a DOT conformance bond pursuant to 49 CFR Part 591.5(f). Formatted as AAA-NNN. */
  vehicleEligibilityNumber?: Maybe<Lpco>;
  /** APHIS VS 16-6A. Veterinary Permit to Import Controlled Materials and Organisms and Vectors. */
  veterinaryPermitToImportControlledMaterials?: Maybe<Lpco>;
  /** EPA Vehicles and Engines Bond Exemption Used by: EPA */
  vneBondExemptionNumber?: Maybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number Used by: EPA */
  vneBondNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number Used by: EPA */
  vneExemptionNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code Used by: EPA */
  vneImportCode?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code Used by: EPA */
  vneIndustryCode?: Maybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. Used by: EPA */
  vneOtherExemptionRegulation?: Maybe<Scalars['String']>;
  /** Measurements of the weapon(s) being imported. Used by: ATF */
  weaponMeasurements?: Maybe<WeaponMeasurements>;
};

/** Data requirements reported to a US CBP Partner Government Agency. */
export type ProductUsPgaInput = {
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: InputMaybe<Scalars['String']>;
  /** A distinct and legible mark, properly applied with a freeze brand, hot iron, or other method, and easily visible on the live animal and on the carcass before skinning. Used by APHIS. */
  animalBrand?: InputMaybe<Scalars['String']>;
  /** Number that characterizes the commercial product or component. Used by: APHIS */
  aphProductCode?: InputMaybe<Scalars['String']>;
  /** APHIS VS 17-32. Application for Inspection and Dipping. */
  applicationForInspectionAndDipping?: InputMaybe<LpcoInput>;
  /** Category code for weapons. Used by: ATF */
  atfCategory?: InputMaybe<Scalars['AtfCategoryCode']>;
  /** A permit that authorizes the importation of firearms, ammunitions, and implements of war into the United States or any possession thereof, except for certain exempt importations presecribed in 27 CFR parts 447, 478 and 479. Used by: ATF */
  atfImportPermit?: InputMaybe<LpcoInput>;
  /** Registered importers of firearms, ammunition firearms parts or implements of war other, than sporting shotguns, shotgun shells, or shotgun parts, must also register under the Arms Export Control Act of 1976. Used by: ATF */
  atfImporterRegistration?: InputMaybe<LpcoInput>;
  /** Identification method often used on aves (birds). Used by APHIS. */
  band?: InputMaybe<Scalars['String']>;
  /** Cut Flowers Bouquet Grouping Code. Used by APHIS. */
  bouquetGroupingCode?: InputMaybe<Scalars['String']>;
  /** APHIS BRS Acknowledgement letter */
  brsAcknowledgementLetter?: InputMaybe<LpcoInput>;
  /** APHIS BRS Notification. */
  brsNotification?: InputMaybe<LpcoInput>;
  /** Chemical Abstract Service Number. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  casNumber?: InputMaybe<Scalars['String']>;
  /** Commodity category code used to further describe the reported item. Used by: APHIS, NHTSA, ATF */
  categoryCode?: InputMaybe<Scalars['String']>;
  /** Category type code used to describe the reported item. Used by: APHIS. */
  categoryTypeCode?: InputMaybe<Scalars['String']>;
  /** US TTB Certificate of Label Approval Number Used by: TTB */
  certificateOfLabelApproval?: InputMaybe<UsTtbCertificateOfLabelApprovalInput>;
  /** Certificate of Origin. Used by APHIS. */
  certificateOfOrigin?: InputMaybe<LpcoInput>;
  /** PGA source and processing data Used by: APHIS, FDA */
  characteristics?: InputMaybe<Array<CommodityCharacteristicInput>>;
  /** Chemical Abstract Service Numbers. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  chemicalAbstractServiceNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** This number corresponds to the box number from DOT HS-7 Required by: NHTSA */
  conformanceDeclaration?: InputMaybe<Scalars['String']>;
  /** Constituent elements of the product/component. Required for: APHIS (Lacey Act), DEA. Used by: FWS. Optional for: EPA, FDA */
  constituentElements?: InputMaybe<Array<ConstituentElementInput>>;
  /** APHIS PPQ587-41. Permit to Import Plants and Plant Products Regulated by 7CFR319.41 (Indian Corn or Maize, Broomcorn, etc.) */
  cornPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-8. Permit to Import Plants and Plant Products Regulated by 7CFR319.8 (Foreign Cotton or Covers) */
  cottonPermit?: InputMaybe<LpcoInput>;
  /** Crop Grower. Supplier type. Required for Cut flowers (Category Type Code AP0800). Used by APHIS. */
  cropGrower?: InputMaybe<IdInput>;
  /** APHIS VS 17-29. Declaration of Importation. */
  declarationOfImportation?: InputMaybe<LpcoInput>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the US manufacturer. Should always be the domestic firm registration number associated with the U.S. manufacturer and not the foreign manufacturer. Used by: FDA (medical devices) */
  deviceDomesticManufacturer?: InputMaybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the exporter who exports or offers for export to the United States (U.S.), a device manufactured or processed by another individual, partnership, corporation or association in a foreign country, as well as devices originally manufactured in the United States. Used by: FDA (medical devices) */
  deviceForeignExporter?: InputMaybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the foreign manufacturer. Should always be the foreign firm registration number associated with the foreign manufacturer and not the US specifications developer. Used by: FDA (medical devices) */
  deviceForeignManufacturer?: InputMaybe<Scalars['String']>;
  /** Defines whether a radiation emitting product is a finished product or just a component */
  deviceForm?: InputMaybe<UsFdaRadiationEmittingDeviceForm>;
  /** Device Initial Importer. Where the IOR is a US entity, DII will default to the IOR. If the IOR is a non-resident, then ops will have to select the DII. */
  deviceInitialImporter?: InputMaybe<DiiCustomsAgentInput>;
  /** Device Listing Number provided by CDRH Used by: FDA (medical devices) */
  deviceListingNumber?: InputMaybe<Scalars['String']>;
  /** Device Premarket Approval Number or Device Premarket Notification Number (510(K))/DeNovo number issued by CDRH (Center for Devices and Radiological Health) or CBER. This also includes Humanitarian Device Exemption (HDE). Premarket number should always be the number that is on the listing record. Used by: FDA (medical devices) */
  devicePremarketNumber?: InputMaybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: InputMaybe<UsPgaDisclaimerCode>;
  /** APHIS 7040B/7040C. Import Permit for Dogs. */
  dogsPermit?: InputMaybe<LpcoInput>;
  /** Department of Transportation conformance bond. Used by: NHTSA */
  dotBond?: InputMaybe<DotBondInput>;
  /** The placement of the driver's seat in a vehicle Used by: NHTSA */
  driveSide?: InputMaybe<VehicleDriveSide>;
  /** New Drug (NDA), Abbreviated New Drug (AND/ANDA), or Therapeutic Biologic Application Number issued by CBER or CDER. Used by: FDA (drugs) */
  drugApplicationNumber?: InputMaybe<Scalars['String']>;
  /** Defines whether a drug is an active pharmaceutical ingredient (API) / bulk drug substance, or a finished drug form (e.g. tablet, capsule, solution). */
  drugForm?: InputMaybe<UsFdaDrugForm>;
  /** Drug Listing Number (DLS), for a bulk Active Pharmaceutical Ingredient (API), or National Drug Code (NDC), for finished drugs, issued by FDA. The first segment of numbers is the labeler code. This number identifies the manufacturer of the product. Declare without dashes. Used by: FDA (drugs) */
  drugListingNumber?: InputMaybe<Scalars['String']>;
  /** Drug Registration Number issued by Center for Drug Evaluation and Research (CDER), Center for Veterinary Medicine (CVM), or Center for Biologics Evaluation and Research (CBER) for the manufacturer. The Federal Food, Drug, and Cosmetic Act (FFD&C) requires most establishments that manufacturer, prepare, propagate, compound, or process a drug or drugs, to register with the FDA. Currently, the establishment registration number is the Dun & Bradstreet Data Universal Numbering System number (DUNS) for CDER and CVM. The establishment registration number can be the FDA Establishment Identification (FEI) or DUNS for CBER. Used by: FDA (drugs)   */
  drugRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** Device (Electrode) Lead Wire or Patient Cable, used when importing electrode lead wires, patient cables, or devices that use them. The affirmation indicates either (1) the device shipment does not contain any pre-wired electrodes, electrode lead wires, or patient (transducer) cables, or (2) any pre-wired electrodes, electrode lead wires or patient cables comply with 21 CFR 898, Performance Standard for Electrode Lead Wires and Patient Cables. Used by: FDA (medical devices) */
  electrode?: InputMaybe<Scalars['Boolean']>;
  /** The two-letter ISO country code that identifies the Importer’s Embassy Used by: NHTSA */
  embassyCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** EPA Vehicles and Engines Engine Power Rating Used by: EPA */
  enginePowerRating?: InputMaybe<QuantityInput>;
  /** Engine data. Used by: EPA */
  engines?: InputMaybe<Array<UsPgaEngineInput>>;
  /** See https://www.epa.gov/compliance/pesticide-establishment-registration-and-reporting Used by: EPA */
  epaProducerEstablishmentNumber?: InputMaybe<LpcoInput>;
  /** The EPA Reg. No. of a product for primary registrants consists of two set of numbers separated by a hyphen, for example EPA Reg. No. 12345-12. The first set of numbers refers to the registrant’s company identification number, and the second set of numbers represents the product number. Used by: EPA */
  epaRegistrationNumber?: InputMaybe<LpcoInput>;
  /** EPA Vehicles and Engines Test Group Name/Number Used by: EPA */
  epaTestGroup?: InputMaybe<Scalars['String']>;
  /** The FDA product code of the product/component. Required by: FDA */
  fdaProductCode?: InputMaybe<Scalars['String']>;
  /** A license or permit issued to anyone who wishes to transport, ship, and cause to be transported, or receive explosives materials under 27 CFR 555.41. Used by: ATF */
  federalExplosiveLicense?: InputMaybe<LpcoInput>;
  /** Federal firearms license issued under the provisions of the Gun Control Act (GCA) to manufacture, import or  in firearms and/or ammunition. Used by: ATF */
  federalFirearmsLicense?: InputMaybe<LpcoInput>;
  /** Food Canning Establishment Number (FCE) that identifies a site-specific manufacturer of acidified and/or low-acid canned food products. Form FDA 2541 is  used for the manufacturing firm registration. See the SID and VOL Affirmation Code definitions below Used by: FDA (LACF/AF food) */
  foodCanningEstablishmentNumber?: InputMaybe<Scalars['String']>;
  /** Food container dimensions. Required by: FDA (LACF and AF Food) */
  foodContainerDimensions?: InputMaybe<DimensionsInput>;
  foodFacilityRegistration?: InputMaybe<UsFdaFoodFacilityRegistrationInput>;
  /** Acidified & Low-Acid Canned Foods (LACF/AF) Volume. May be used to communicate the container volume and unit of measure of an Acidified Food (AF) or Low-Acid Food (LACF) product that is packaged in a container that does not have a traditional size/dimension. The filer should verify with the importer whether  the container size/dimensions or volume were supplied to FDA by the manufacturer. Use of this field instead of the Container Size/Dimension, when  Container Size/Dimension is part of the scheduled process, will result in a failure of the automated data base look-up. Used by: FDA (LACF/AF food) */
  foodVolume?: InputMaybe<Scalars['String']>;
  /** The foreign certificate for imported distilled spirits and wine. Used by: TTB */
  foreignCertificate?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 203. Foreign Site Certificate of Inspection and/or treatment. */
  foreignSiteCertificateOfInspection?: InputMaybe<LpcoInput>;
  /** Foreign Supplier Verification Program Importer. Where the IOR is a US entity, FSVP will default to the IOR. If the IOR is a non-resident, then ops will have to select the FSVP. */
  foreignSupplierVerificationProgram?: InputMaybe<FsvpCustomsAgentInput>;
  /** APHIS PPQ587-56. Permit to Import Plants and Plant Products Regulated by 7CFR319.56 (Fruits and Vegetables). */
  fruitsAndVegetablesPermit?: InputMaybe<LpcoInput>;
  /** A NHTSA-assigned code identifying the glazing manufacturer. Formatted N or NN or NNN or NNNN (e.g., 1234) Used by: NHTSA */
  glazingManufacturerCode?: InputMaybe<Scalars['String']>;
  /** GS1 Global Product Classification Brick Code (GPCB). An 8-digit number designating a set of products with similar characteristics as defined by GS1 at http://www.gs1.org/gsmp/kc/gpc. Used by APHIS. */
  globalProductClassificationBrickCode?: InputMaybe<Scalars['String']>;
  /** APHIS BRS 2000. Application for Permit or Courtesy Permit for Movement or Release of Genetically Engineered Organisms. */
  gmoPermit?: InputMaybe<LpcoInput>;
  /** Health Certificate. Used by APHIS. */
  healthCertificate?: InputMaybe<LpcoInput>;
  /** Device Impact Resistance Lens Certification, used to certify that the filer has, on hand, the test results or a certificate that shows that the product has met the standards for impact resistance lenses. FDA has the authority to ask for copies of the actual test results. Each batch within the shipment must have its own test results. Used by: FDA (medical devices) */
  impactResistanceLensCertification?: InputMaybe<Scalars['Boolean']>;
  /** APHIS 2006. Importation of Veterinary Biological Products. */
  importationOfVeterinaryBiologicalProducts?: InputMaybe<LpcoInput>;
  /** Data pertaining to an inspection. Used by: APHIS, FWS */
  inspection?: InputMaybe<UsPgaInspectionInput>;
  /** The intended use code of the product/component. Required by: APHIS, FDA, EPA Used by: FWS */
  intendedUse?: InputMaybe<Scalars['String']>;
  /** Describes the intended use of the product/component. Used by: FWS */
  intendedUseDescription?: InputMaybe<Scalars['String']>;
  /** Investigational New Drug Application Number issued by CBER or CDER. Investigational drugs are new drugs intended solely for investigational use by  experts qualified by scientific training and experiences to investigate the safety and effectiveness of drugs. The Federal Food, Drug, and Cosmetic Act (FFD&C) Act requires that a drug be the subject of an approved marketing application before it is transported or distributed across state lines (including import). A sponsor who wants to ship the investigational drug to clinical investigators must seek an exemption from that legal requirement. Used by: FDA (investigational new drugs) */
  investigationNewDrugApplicationNumber?: InputMaybe<Scalars['String']>;
  /** Investigational Device Exemption Number issued by CBER or CDRH. Devices that qualified experts use on human subjects, to conduct investigations of their safety and effectiveness, are considered investigational devices. For devices destined for non-significant risk study (NSR), an Institutional Review Boards(IRB) letter affirming NSR must be provided to FDA. In such case, provide 'NSR'. Used by: FDA (medical devices) */
  investigationalDeviceExemptionNumber?: InputMaybe<Scalars['String']>;
  /** The importer is an original manufacturer of motor vehicles (or a wholly owned subsidiary thereof) that is certified to conform to all applicable Federal Motor Vehicle Safety Standards (FMVSS). Use on the public roads must be authorized specifically. [591.6(f )(1) or (2)]; Used by: NHTSA */
  iorIsVehicleManufacturer?: InputMaybe<Scalars['Boolean']>;
  /** Internal Revenue Code (IRC) registry number for the distilled spirits plant, bonded wine cellar, or brewery. Used by: TTB */
  ircRegistryNumber?: InputMaybe<LpcoInput>;
  /** Indicates that information should be treated as confidential. Used by: DEA, FWS */
  isConfidentialInformation?: InputMaybe<Scalars['Boolean']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) Used by: APHIS, EPA, NHTSA, FWS */
  isImageSubmitted?: InputMaybe<Scalars['Boolean']>;
  /** Identifies Toxic Substance Control Act positive or negative certification. Positive – I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA. Negative – I certify that all chemicals in this shipment are not subject to TSCA. Used by: EPA */
  isTscaCompliant?: InputMaybe<Scalars['Boolean']>;
  /** The unique identity for the item. Used by: APHIS */
  itemIdentity?: InputMaybe<ItemIdentityInput>;
  /** APHIS PPQ587-75. Permit to Import Plants and Plant Products Regulated by 7CFR319.75 (Khapra Beetle). */
  khapraBeetlePermit?: InputMaybe<LpcoInput>;
  /** The tariffs associated Independent Third Party Laboratory or Clinical Site. Required for investigational drugs. Required by: FDA (investigational new drugs) */
  laboratory?: InputMaybe<IdInput>;
  /** The type of laboratory. Required by: FDA (investigational new drugs) */
  laboratoryTypeCode?: InputMaybe<UsFdaLaboratoryType>;
  /** Live Animal Tag Ranges. Used by APHIS. */
  liveAnimalTagRanges?: InputMaybe<Array<LiveAnimalTagRangeInput>>;
  /** Live Animal Tag. Used by APHIS. */
  liveAnimalTags?: InputMaybe<Array<Scalars['String']>>;
  /** APHIS VS 17-135. Permit to Import Live Animals. */
  liveAnimalsPermit?: InputMaybe<LpcoInput>;
  /** Manufacturer assigned lot number for the product. Required by: FDA (prior notice LACF/AF food, infant formula) */
  lotNumber?: InputMaybe<Scalars['String']>;
  /** LPCO Authorized Party. Location type. Required if at least one LPCO is used. Used by APHIS. */
  lpcoAuthorizedParty?: InputMaybe<IdInput>;
  /** Location of the manufacture date of the vehicle or engine. Used by: EPA */
  manufactureDateLocation?: InputMaybe<Scalars['String']>;
  /** Meat Certificate. Meat Certificate required by APHIS/FSIS to document sanitary condition and wholesomeness of animal or meat products. (Note: Meat and Sanitary Certificates can be “one and the same”). */
  meatCertificate?: InputMaybe<LpcoInput>;
  /** Microchip. Used by APHIS. */
  microchip?: InputMaybe<Scalars['String']>;
  /** NMFS Tag Number. The individual tag number of the fish. Used by APHIS. */
  nmfsTagNumber?: InputMaybe<Scalars['String']>;
  /** Free form information found in box 18 of EPA Form 3540-01. Required if EPA Registration number not provided. */
  noticeOfArrival?: InputMaybe<Scalars['String']>;
  /** USDA APHIS PPQ Notice Of Arrival */
  noticeOfArrivalPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-37. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Nursery Stock, Plants, Roots, Bulbs, Seeds). */
  nurseryPlantsPermit?: InputMaybe<LpcoInput>;
  /** Offical Animal Number. Unique number given by a national authority to identify an animal individually. Used by APHIS. */
  officialAnimalNumber?: InputMaybe<Scalars['String']>;
  /** Original country where routing to the US began. Required for: APHIS Used by: FWS */
  originCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Packaging associated with a PGA. Required if subject to FDA Prior Notice or a Performance Standard Used by: FDA, APHIS, EPA */
  packaging?: InputMaybe<Array<QuantityInput>>;
  /** Quantity of cigarette tubes or papers. Used by: TTB */
  paperOrTubeQuantity?: InputMaybe<Scalars['Int']>;
  /** Two-letter ISO country code of the country that issued the passport. Used by: NHTSA */
  passportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Government issued passport number to certify the identity and nationality of the person importing the product. Used by: NHTSA */
  passportNumber?: InputMaybe<Scalars['String']>;
  /** Pesticide Control Number Used by: EPA */
  pcNumber?: InputMaybe<Scalars['String']>;
  /** Subject to a performance standard: FDA */
  performanceStandard?: InputMaybe<Scalars['Boolean']>;
  /** A letter issued by NHTSA permitting a nonconforming vehicle to be imported pursuant to 49 CFR 591.5(j) or 591(I). Formatted as NN-NNNN-NNNN. Used by: NHTSA */
  permissionLetter?: InputMaybe<LpcoInput>;
  /** Permitted Destination. Location type. Required if a Veterinary Biologics product (Category Code 307). Used by APHIS. */
  permittedDestination?: InputMaybe<IdInput>;
  /** Phytosanitary Certificate. Phytosanitary certificate required by APHIS to document the cleanliness (pest and disease) of Plant products. */
  phytosanitaryCertificate?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 526. Permit to Move Live Plant Pests or Noxious Weeds. */
  plantPestsPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-37CAN. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Canadian-Origin). */
  plantsOfCanadianOriginPermit?: InputMaybe<LpcoInput>;
  /** The name of the political subunit, e.g. state, province, or region through which goods are routed between the country of original departure and the country of final destination. Used by: APHIS */
  politicalSubunitName?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 546. Post-entry Quarantine Permit. */
  postEntryQuarantinePermit?: InputMaybe<LpcoInput>;
  /** US FDA Prior Notice data requirements. */
  priorNotice?: InputMaybe<UsFdaPriorNoticeInput>;
  /** Code indicating the specific PGA processing requirements for which the data set is related. */
  processingCode?: InputMaybe<Scalars['String']>;
  /** A code indicating the type of product number used to characterize the product or component. Used by: APHIS */
  productQualifierCode?: InputMaybe<Scalars['String']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 588. Permit to Import Prohibited Plant Material For Research Purposes. */
  prohibitedPlantForResearchPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 621. Protected Plant Permit to Engage in the Business of Importing, Exporting, or Re-exporting Terrestrial Plants or Plant Products that are Protected and Regulated by 50CFR17.12 or 50CFR23.23 (CITES: Threatened or Endangered Species). */
  protectedPlantPermit?: InputMaybe<LpcoInput>;
  /** Rabies Vaccination Certificate. Used by APHIS. */
  rabiesVaccinationCertifcate?: InputMaybe<LpcoInput>;
  radiationDeclaration?: InputMaybe<RadiationDeclarationInput>;
  /** Rail car numbers Used by: FDA (prior notice food arriving via rail/containerized rail.) */
  railCarNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Country that has refused the shipment. Used by: FDA */
  refusalCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Number assigned by NHTSA to a person or business entity specially registered with NHTSA as an importer of nonconforming motor vehicles pursuant to 49 CFR Part 592. Formatted as A-NN-NNN. Used by: NHTSA */
  registeredImporterNumber?: InputMaybe<LpcoInput>;
  /** Radio Frequency Identification. Used by APHIS. */
  rfid?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ587-55. Permit to Import Plants and Plant Products Regulated by 7CFR319.55 (Rice). */
  ricePermit?: InputMaybe<LpcoInput>;
  /** LACF/AF Submission/Scheduled Process Identifier Number (SID) Used by: FDA (LACF/AF food) */
  scheduleIdentifierNumber?: InputMaybe<Scalars['String']>;
  /** APHIS Seed Analysis Certificate (PPQ Form 925, CFIA Form 5289, CFIA Form 5309 or similar form) */
  seedAnalysisCertificate?: InputMaybe<LpcoInput>;
  /** Country from where the product/component shipped. Required by: FDA (Food subject to Prior Notice) */
  shipmentCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Slaughter Number. Unique number given by a slaughterhouse to an animal or a group of animals of the same breed. Used by APHIS. */
  slaughterNumber?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 525B. Soil Permit. */
  soilPermit?: InputMaybe<LpcoInput>;
  /** PGA source and processing data Used by: APHIS, FDA */
  source?: InputMaybe<UsPgaSourceInput>;
  /** USDA APHIS VS STAT Documents (Statements) (e.g. Manufacturer’s Statement, Owner/Importer Statements, Producer Statements) */
  statementsPermit?: InputMaybe<LpcoInput>;
  /** The storage location of the vehicle or engine. Used by: EPA */
  storageLocation?: InputMaybe<IdInput>;
  /** APHIS PPQ587-15. Permit to Import Plants and Plant Products Regulated by 7CFR319.15 (Sugarcane) */
  sugarcanePermit?: InputMaybe<LpcoInput>;
  /** Taxonomic Serial Number (TSN). A unique serial number assigned to a taxonomic unit by the Integrated Taxonomic Informational System at http://www.itis.gov. Used by APHIS. */
  taxonomicSerialNumber?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 585. Permit to Import Timber or Timber Products */
  timberPermit?: InputMaybe<LpcoInput>;
  /** A NHTSA-assigned code identifying the tire manufacturer. Formatted ANAN or ANANAN (e.g., 1B or ABC) Used by: NHTSA */
  tireManufacturerCode?: InputMaybe<Scalars['String']>;
  /** The Trade Name of the product/component. Used by: EPA, FDA, NHTSA */
  tradeName?: InputMaybe<Scalars['String']>;
  /** Country through which goods or passengers are routed between the country of original departure and final destination. Used by: APHIS */
  transitCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** APHIS PPQ 586. Permit to Transit Plants and/or Plant Products, Plant Pests, and/or Associated Soil. */
  transitPlantsPermit?: InputMaybe<LpcoInput>;
  /** Country where goods are to be or have been transferred from one means of transport to another during the course of one transport operation. Used by: APHIS */
  transshipmentCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Treatment Certificate. Used by APHIS. */
  treatmentCertificate?: InputMaybe<LpcoInput>;
  /** TTB-issued permit number indicating the IRC-bonded facility, manufacturer, or export warehouse proprietor. Used by: TTB */
  ttbFacilityPermitNumber?: InputMaybe<LpcoInput>;
  /** The importer's permit number assigned by TTB Used by: TTB */
  ttbImporterPermitNumber?: InputMaybe<LpcoInput>;
  /** UN Standard Products and Services Code (UNSPSC) Commodity Code. An 8-digit number designating a set of products with similar characteristics as defined by the United Nations at http://www.unspsc.org. Used by APHIS. */
  unpscCommodityCode?: InputMaybe<Scalars['String']>;
  /** Vehicle data. Used by: EPA, NHT */
  vehicle?: InputMaybe<UsPgaVehicleInput>;
  /** NHTSA-assigned number to identify a vehicle that is not certified to the Federal motor vehicle safety standards as being eligible for importation by a registered importer under a DOT conformance bond pursuant to 49 CFR Part 591.5(f). Formatted as AAA-NNN. */
  vehicleEligibilityNumber?: InputMaybe<LpcoInput>;
  /** APHIS VS 16-6A. Veterinary Permit to Import Controlled Materials and Organisms and Vectors. */
  veterinaryPermitToImportControlledMaterials?: InputMaybe<LpcoInput>;
  /** EPA Vehicles and Engines Bond Exemption Used by: EPA */
  vneBondExemptionNumber?: InputMaybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number Used by: EPA */
  vneBondNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number Used by: EPA */
  vneExemptionNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code Used by: EPA */
  vneImportCode?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code Used by: EPA */
  vneIndustryCode?: InputMaybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. Used by: EPA */
  vneOtherExemptionRegulation?: InputMaybe<Scalars['String']>;
  /** Measurements of the weapon(s) being imported. Used by: ATF */
  weaponMeasurements?: InputMaybe<WeaponMeasurementsInput>;
};

export type ProductUsPgaRequirements = {
  __typename?: 'ProductUsPgaRequirements';
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM3?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM4?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM6?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM7?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM8?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  ATF?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  CP1?: Maybe<UsCpscPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DE1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP3?: Maybe<VehiclesAndEnginesUsPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP4?: Maybe<VehiclesAndEnginesUsPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP5?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP6?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP7?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP8?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD3?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD4?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS3?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS4?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW3?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM3?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM4?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM5?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM6?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM8?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB1?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB2?: Maybe<ProductUsPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB3?: Maybe<ProductUsPga>;
};

export type ProductUsPgaRequirementsInput = {
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM3?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM4?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM6?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM7?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM8?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  ATF?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  CP1?: InputMaybe<UsCpscPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DE1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP3?: InputMaybe<VehiclesAndEnginesUsPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP4?: InputMaybe<VehiclesAndEnginesUsPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP5?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP6?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP7?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP8?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD3?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD4?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS3?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS4?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW3?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM3?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM4?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM5?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM6?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM8?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB1?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB2?: InputMaybe<ProductUsPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB3?: InputMaybe<ProductUsPgaInput>;
};

/** Tariff associated with a line item. */
export type ProductUsTariff = {
  __typename?: 'ProductUsTariff';
  /** Additional optional PGA requirements. */
  extraPgaFlags?: Maybe<Array<UsPgaFlag>>;
  /** The HTS record. */
  hts?: Maybe<UsHts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Partner Government Agency data requirements. */
  pga?: Maybe<ProductUsPgaRequirements>;
  /** The description of the tariff reported to the PGA. */
  pgaDescription?: Maybe<UsTariffPgaDescription>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

/** Tariff associated with a line item. */
export type ProductUsTariffInput = {
  /** Additional optional PGA requirements. */
  extraPgaFlags?: InputMaybe<Array<UsPgaFlag>>;
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Partner Government Agency data requirements. */
  pga?: InputMaybe<ProductUsPgaRequirementsInput>;
  /** The description of the tariff reported to the PGA. */
  pgaDescription?: InputMaybe<UsTariffPgaDescriptionInput>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type ProductsConnection = Connection & {
  __typename?: 'ProductsConnection';
  edges: Array<ProductEdge>;
  nodes: Array<Product>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Onboarding request profile details. */
export type ProfileDetails = {
  __typename?: 'ProfileDetails';
  /** Customer email */
  email?: Maybe<Scalars['Email']>;
  /** Customer name */
  name?: Maybe<Scalars['String']>;
  /** Customer official phone number */
  officialPhone?: Maybe<Phone>;
  /** Customer phone number */
  phone?: Maybe<Phone>;
  /** Customer title */
  title?: Maybe<Scalars['String']>;
};

/** Onboarding request profile details. */
export type ProfileDetailsInput = {
  /** Customer email */
  email?: InputMaybe<Scalars['Email']>;
  /** Customer name */
  name?: InputMaybe<Scalars['String']>;
  /** Customer official phone number */
  officialPhone?: InputMaybe<PhoneInput>;
  /** Customer phone number */
  phone?: InputMaybe<PhoneInput>;
  /** Customer title */
  title?: InputMaybe<Scalars['String']>;
};

export type Program = Record & {
  __typename?: 'Program';
  /** List of associated Customs Brokers under this program. */
  brokers?: Maybe<Array<CustomsBroker>>;
  /** The country codes associated with this program (e.g., US, GB, IN). */
  countryCodes?: Maybe<Array<Scalars['String']>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the program (e.g., CRIS). */
  programName: Scalars['String'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ProgramDetails = {
  __typename?: 'ProgramDetails';
  /** Doc Readiness for Program. */
  docReadiness?: Maybe<DocReadiness>;
  /** Program associated with the Importer Entity. */
  program: Program;
};

export type ProgramDetailsInput = {
  /** Doc Readiness for Program. */
  docReadiness?: InputMaybe<DocReadinessInput>;
  /** ID of the associated Program. */
  program: IdInput;
};

export type PublishRedriveEventToErrorSourcePayload = {
  __typename?: 'PublishRedriveEventToErrorSourcePayload';
  /** String id to identify the processingError */
  id: Scalars['String'];
};

export type Quantity = {
  __typename?: 'Quantity';
  /** Unit of measure for quantity for compliance details. */
  unit?: Maybe<Scalars['String']>;
  /** Quantity for compliance details. */
  value?: Maybe<Scalars['Float']>;
};

export type QuantityInput = {
  /** Unit of measure for quantity for compliance details. */
  unit?: InputMaybe<Scalars['String']>;
  /** Quantity for compliance details. */
  value?: InputMaybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  WorkOrderTaskAssignmentRequest: WorkOrderTaskAssignmentRequestPayload;
  adCvdCase: AdCvdCase;
  adCvdCases: Array<AdCvdCase>;
  allAdCvdCases: AdCvdCasesConnection;
  allAssignmentTeamStaticMappings: AssignmentTeamStaticMappingsConnection;
  allAssignmentTeams: AssignmentTeamsConnection;
  allAuditLogs: AuditLogsConnection;
  allBrokers: BrokersConnection;
  allBulkChargesUploadRequests: BulkChargesUploadRequestsConnection;
  allBulkComplianceUploadRequests: BulkComplianceUploadRequestsConnection;
  allBulkMilestoneUploadRequests: BulkMilestoneUploadRequestsConnection;
  allBusinessSupportTeams: BusinessSupportTeamsConnection;
  allCaseCategoryConfigs: CaseCategoryConfigsConnection;
  allChangelogs: ChangelogsConnection;
  allCommodityGroups: CommodityGroupsConnection;
  allCustomDomains: CustomDomainsConnection;
  allCustomsAgents: CustomsAgentsConnection;
  allCustomsDeclarations: CustomsDeclarationsConnection;
  allCustomsEntries: CustomsEntriesConnection;
  allDeConsignees: DeConsigneesConnection;
  allDeCustomsBrokers: DeCustomsBrokersConnection;
  allDeCustomsEntries: DeCustomsEntriesConnection;
  allDeIorActivations: DeIorActivationsConnection;
  allDeIors: DeIorsConnection;
  allDeliveryOrders: DeliveryOrdersConnection;
  allDocumentTemplates: DocumentTemplatesConnection;
  allDocuments: DocumentsConnection;
  allDpsRecords: DpsRecordsConnection;
  allEuHss: EuHssConnection;
  allExchangeMessages: ExchangeMessagesConnection;
  allFacilities: FacilitiesConnection;
  allFeatureFlags: FeatureFlagsConnection;
  allForwarderSystems: ForwarderSystemsConnection;
  allForwarderUsers: ForwarderUsersConnection;
  allForwarders: ForwardersConnection;
  allFrConsignees: FrConsigneesConnection;
  allFrCustomsBrokers: FrCustomsBrokersConnection;
  allFrCustomsEntries: FrCustomsEntriesConnection;
  allFrIorActivations: FrIorActivationsConnection;
  allFrIors: FrIorsConnection;
  allGbConsignees: GbConsigneesConnection;
  allGbCustomsEntries: GbCustomsEntriesConnection;
  allGbIorActivations: GbIorActivationsConnection;
  allGbIors: GbIorsConnection;
  allGlobalConsignees: GlobalConsigneesConnection;
  allHtss: HtssConnection;
  allImportProductsFromBulkUploadRequests: ImportProductsFromBulkUploadRequestsConnection;
  allImportProductsFromCustomsEntriesRequests: ImportProductsFromCustomsEntriesRequestsConnection;
  allImporterEntities: ImporterEntitiesConnection;
  allImporterEntityActivations: ImporterEntityActivationsConnection;
  allImporters: ImportersConnection;
  allInvoiceCreditNotes: InvoiceCreditNotesConnection;
  allInvoicePayments: InvoicePaymentsConnection;
  allInvoices: InvoicesConnection;
  allMemos: MemosConnection;
  allNlConsignees: NlConsigneesConnection;
  allNlCustomsBrokers: NlCustomsBrokersConnection;
  allNlCustomsEntries: NlCustomsEntriesConnection;
  allNlIorActivations: NlIorActivationsConnection;
  allNlIors: NlIorsConnection;
  allOnboardingRequests: OnboardingRequestsConnection;
  allOperatorSystems: OperatorSystemsConnection;
  allOperatorUsers: OperatorUsersConnection;
  allOperators: OperatorsConnection;
  allProducts: ProductsConnection;
  /** The query API used to retrieve the reimbursement with giving entity id. */
  allReimbursements: ReimbursementPayload;
  allReleaseNotes: ReleaseNotesConnection;
  allShipmentCommercialInvoiceDetails: ShipmentCommercialInvoiceDetailsConnection;
  allShipmentDocumentProcessingRequests: ShipmentDocumentProcessingRequestsConnection;
  allShipments: ShipmentsConnection;
  allShipperSystems: ShipperSystemsConnection;
  allShipperUsers: ShipperUsersConnection;
  allShippers: ShippersConnection;
  allStampDocumentSignRequests: StampDocumentSignRequestsConnection;
  allSubjectMatterExpertTeams: SubjectMatterExpertTeamsConnection;
  allSuppliers: SuppliersConnection;
  allTableFilters: TableFiltersConnection;
  allTeams: TeamsConnection;
  allTemplateDocumentSignRequests: TemplateDocumentSignRequestsConnection;
  allTradeAdvisoryRequests: TradeAdvisoryRequestsConnection;
  allTruckers: TruckersConnection;
  allUkCustomsBrokers: UkCustomsBrokersConnection;
  allUkHss: UkHssConnection;
  allUsConsignees: UsConsigneesConnection;
  allUsConsumptionEntries: UsConsumptionEntriesConnection;
  allUsCustomsBrokers: UsCustomsBrokersConnection;
  allUsDrawbackClaims: UsDrawbackClaimsConnection;
  allUsHtss: UsHtssConnection;
  allUsInBonds: UsInBondsConnection;
  allUsIorActivations: UsIorActivationsConnection;
  allUsIorContinuousBondRequests: UsIorContinuousBondRequestsConnection;
  allUsIors: UsIorsConnection;
  allUsIsfs: UsIsfsConnection;
  allUsPostSummaryCorrections: UsPostSummaryCorrectionsConnection;
  allUsPrincipalAdCvdCases: UsPrincipalAdCvdCasesConnection;
  allUsType86Entries: UsType86EntriesConnection;
  allUserReleaseNoteViews: UserReleaseNoteViewsConnection;
  allWorkOrderConfirmations: WorkOrderConfirmationsConnection;
  allWorkOrderDocumentProcessingRequests: WorkOrderDocumentProcessingRequestsConnection;
  allWorkOrderGroups: WorkOrderGroupsConnection;
  allWorkOrderMilestones: WorkOrderMilestonesConnection;
  allWorkOrderStateMachines: WorkOrderStateMachinesConnection;
  allWorkOrderTaskDefinitions: WorkOrderTaskDefinitionsConnection;
  allWorkOrderTaskEscalationMessages: WorkOrderTaskEscalationMessagesConnection;
  allWorkOrderTasks: WorkOrderTasksConnection;
  /** A request and response transaction with a 3P system. */
  amsQueryTransaction: AmsQueryTransaction;
  appTradeDataCodes: TradeDataCodes;
  assignmentTeam: AssignmentTeam;
  assignmentTeamOperatorUserRelationship: AssignmentTeamOperatorUserRelationship;
  assignmentTeamStaticMapping: AssignmentTeamStaticMapping;
  assignmentTeamStaticMappings: Array<AssignmentTeamStaticMapping>;
  assignmentTeams: Array<AssignmentTeam>;
  auditLog: AuditLog;
  auditLogs: Array<AuditLog>;
  authenticationContext: AuthenticationContextPayload;
  authenticationToken: AuthenticationToken;
  authenticationTokens: Array<AuthenticationToken>;
  /** A request and response transaction with a 3P system. */
  authorizeCbpEntryStatementDebitTransaction: AuthorizeCbpEntryStatementDebitTransaction;
  broker: Broker;
  brokers: Array<Broker>;
  bulkChargesUploadRequest: BulkChargesUploadRequest;
  bulkChargesUploadRequests: Array<BulkChargesUploadRequest>;
  bulkComplianceUploadRequest: BulkComplianceUploadRequest;
  bulkComplianceUploadRequests: Array<BulkComplianceUploadRequest>;
  bulkMilestoneUploadRequest: BulkMilestoneUploadRequest;
  bulkMilestoneUploadRequests: Array<BulkMilestoneUploadRequest>;
  bulkProductUploadTemplateDocumentGenerationRequest: BulkProductUploadTemplateDocumentGenerationRequest;
  businessSupportTeam: BusinessSupportTeam;
  businessSupportTeamOperatorUserRelationship: BusinessSupportTeamOperatorUserRelationship;
  businessSupportTeams: Array<BusinessSupportTeam>;
  caseCategoryConfig: CaseCategoryConfig;
  caseCategoryConfigs: Array<CaseCategoryConfig>;
  changelog: Changelog;
  changelogs: Array<Changelog>;
  classifyUsCustomsFiling: ClassifyUsCustomsFilingPayload;
  clientApiKey: ClientApiKey;
  commodityGroup: CommodityGroup;
  commodityGroups: Array<CommodityGroup>;
  customDomain: CustomDomain;
  customDomainRuntimeInfo?: Maybe<CustomDomainRuntimeInfo>;
  customDomains: Array<CustomDomain>;
  customsAgent: CustomsAgent;
  customsAgents: Array<CustomsAgent>;
  customsDeclaration: CustomsDeclaration;
  customsDeclarations: Array<CustomsDeclaration>;
  customsEntries: Array<CustomsEntry>;
  customsEntry: CustomsEntry;
  deConsignee: DeConsignee;
  deConsignees: Array<DeConsignee>;
  deCustomsBroker: DeCustomsBroker;
  deCustomsBrokers: Array<DeCustomsBroker>;
  deCustomsEntries: Array<DeCustomsEntry>;
  deCustomsEntry: DeCustomsEntry;
  deIor: DeIor;
  deIorActivation: DeIorActivation;
  deIorActivations: Array<DeIorActivation>;
  deIors: Array<DeIor>;
  decryptLoginLink: DecryptLoginPayload;
  deliveryOrder: DeliveryOrder;
  deliveryOrderDocumentGenerationRequest: DeliveryOrderDocumentGenerationRequest;
  deliveryOrders: Array<DeliveryOrder>;
  document: Document;
  documentTemplate: DocumentTemplate;
  documentTemplates: Array<DocumentTemplate>;
  documents: Array<Document>;
  dpsRecord: DpsRecord;
  /** API to retrieve effectiveEuHss for maximum 500 hsNumbers */
  effectiveEuHss: Array<EffectiveEuHs>;
  /** API to retrieve effectiveUkHss for maximum 500 hsNumbers */
  effectiveUkHss: Array<EffectiveUkHs>;
  /** API to retrieve effectiveUsHtss for maximum 500 htsNumbers */
  effectiveUsHtss: Array<UsHts>;
  /** Enrich supporting entities for cases. */
  enrichSupportingEntities: EnrichmentResultGQL;
  errorDefinition: ErrorDefinition;
  euHs: EuHs;
  euHss: Array<EuHs>;
  /** Query for 3P clients to query EU/UK entry data in the form of a customs declaration, or a customs declaration directly. Always returns the latest version. */
  euUkCustomsDeclaration: CustomsDeclaration;
  excelTemplateDocumentGenerationRequest: ExcelTemplateDocumentGenerationRequest;
  exchangeMessage: ExchangeMessage;
  exchangeMessages: Array<ExchangeMessage>;
  facilities: Array<Facility>;
  facility: Facility;
  featureFlag: FeatureFlag;
  featureFlags: Array<FeatureFlag>;
  fetchEuHsHierarchy: FetchEuHsHierarchyPayload;
  /** Returns custom MAIL FROM configuration for a given Forwarder. */
  fetchForwarderMailFrom: FetchForwarderMailFromPayload;
  fetchHtsHierarchy: FetchUsHtsHierarchyPayload;
  fetchUkHsHierarchy: FetchUkHsHierarchyPayload;
  forwarder: Forwarder;
  forwarderSystem: ForwarderSystem;
  forwarderSystems: Array<ForwarderSystem>;
  forwarderUser: ForwarderUser;
  forwarderUsers: Array<ForwarderUser>;
  forwarders: Array<Forwarder>;
  frConsignee: FrConsignee;
  frConsignees: Array<FrConsignee>;
  frCustomsBroker: FrCustomsBroker;
  frCustomsBrokers: Array<FrCustomsBroker>;
  frCustomsEntries: Array<FrCustomsEntry>;
  frCustomsEntry: FrCustomsEntry;
  frIor: FrIor;
  frIorActivation: FrIorActivation;
  frIorActivations: Array<FrIorActivation>;
  frIors: Array<FrIor>;
  gbConsignee: GbConsignee;
  gbConsignees: Array<GbConsignee>;
  gbCustomsEntries: Array<GbCustomsEntry>;
  gbCustomsEntry: GbCustomsEntry;
  gbIor: GbIor;
  gbIorActivation: GbIorActivation;
  gbIorActivations: Array<GbIorActivation>;
  gbIors: Array<GbIor>;
  /** Generate role assignment for given assignmentTeam */
  generateAssignmentResult: Scalars['String'];
  /** Generate JWT for given login */
  generateJWT: Scalars['String'];
  genericDocumentGenerationRequest: GenericDocumentGenerationRequest;
  /** Query API for retrieving ABI data provided in CATAIR requests/responses. The data is formatted before it is sent to the UI. */
  getAbiExchangeMessages: GetAbiPayload;
  getAsinProductDetails: GetAsinProductDetailsResponse;
  getAuditLogPresignedUrl: PresignedUrlResponse;
  getCaseAssignmentByTeam?: Maybe<CaseAssignmentResult>;
  getCaseAssignmentTeamById?: Maybe<CaseAssignmentTeam>;
  getCaseAssignmentTeams: Array<CaseAssignmentTeam>;
  getCaseAutoAssignment?: Maybe<CaseAssignmentResult>;
  /** Get a presigned URL to download CPSC citation codes JSON file */
  getCpscCitationCodesPresignedUrl: CpscCitationCodeUrlResponse;
  getLatestReleaseNote?: Maybe<ReleaseNote>;
  getLatestViewedReleaseNoteByUser?: Maybe<UserReleaseNoteView>;
  /** Api to call GSS Account Linking APIs with given api name and input */
  getLinkedMerchantIdsForShipperId: GetLinkedMerchantIdsPayload;
  /** Returns pending POA sign requests for a given forwarder ID */
  getPendingSubPoas: Array<SubPoaLinks>;
  getShipmentComplianceDetails: getShipmentComplianceDetailsPayload;
  globalConsignee: GlobalConsignee;
  globalConsignees: Array<GlobalConsignee>;
  /** Global search for INLT records */
  globalSearch: GlobalSearchPayload;
  htmlDocumentGenerationRequest: HtmlDocumentGenerationRequest;
  hts: Hts;
  htss: Array<Hts>;
  importProductsFromBulkUploadRequest: ImportProductsFromBulkUploadRequest;
  importProductsFromBulkUploadRequests: Array<ImportProductsFromBulkUploadRequest>;
  importProductsFromCustomsEntriesRequest: ImportProductsFromCustomsEntriesRequest;
  importProductsFromCustomsEntriesRequests: Array<ImportProductsFromCustomsEntriesRequest>;
  importer: Importer;
  importerEntities: Array<ImporterEntity>;
  importerEntity: ImporterEntity;
  importerEntityActivation: ImporterEntityActivation;
  importerEntityActivations: Array<ImporterEntityActivation>;
  importerImporterEntityRelationship: ImporterImporterEntityRelationship;
  importers: Array<Importer>;
  inBondNotesDocumentGenerationRequest: InBondNotesDocumentGenerationRequest;
  invoice: Invoice;
  invoiceCreditNote: InvoiceCreditNote;
  invoiceCreditNoteDocumentGenerationRequest: InvoiceCreditNoteDocumentGenerationRequest;
  invoiceCreditNotes: Array<InvoiceCreditNote>;
  invoiceDocumentGenerationRequest: InvoiceDocumentGenerationRequest;
  invoiceLinesRequest: InvoiceLinesRequest;
  invoicePayment: InvoicePayment;
  invoicePayments: Array<InvoicePayment>;
  invoices: Array<Invoice>;
  login: LoginPayload;
  memo: Memo;
  memos: Array<Memo>;
  /** A request and response transaction with a 3P system. */
  mutateActionInBondCbpTransaction: MutateActionInBondCbpTransaction;
  /** A request and response transaction with a 3P system. */
  mutateCbpDrawbackClaimTransaction: MutateCbpDrawbackClaimTransaction;
  /** A request and response transaction with a 3P system. */
  mutateCbpEntryPgaTransaction: MutateCbpEntryPgaTransaction;
  /** A request and response transaction with a 3P system. */
  mutateCbpEntryReleaseTransaction: MutateCbpEntryReleaseTransaction;
  /** A request and response transaction with a 3P system. */
  mutateCbpEntrySummaryTransaction: MutateCbpEntrySummaryTransaction;
  /** A request and response transaction with a 3P system. */
  mutateCbpIsfTransaction: MutateCbpIsfTransaction;
  /** A request and response transaction with a 3P system. */
  mutateInBondCbpTransaction: MutateInBondCbpTransaction;
  /** A request and response transaction with a 3P system. */
  mutateUsType86EntryCbpReleaseTransaction: MutateUsType86EntryCbpReleaseTransaction;
  nlConsignee: NlConsignee;
  nlConsignees: Array<NlConsignee>;
  nlCustomsBroker: NlCustomsBroker;
  nlCustomsBrokers: Array<NlCustomsBroker>;
  nlCustomsEntries: Array<NlCustomsEntry>;
  nlCustomsEntry: NlCustomsEntry;
  nlIor: NlIor;
  nlIorActivation: NlIorActivation;
  nlIorActivations: Array<NlIorActivation>;
  nlIors: Array<NlIor>;
  onboardingRequest: OnboardingRequest;
  onboardingRequests: Array<OnboardingRequest>;
  operator: Operator;
  operatorSystem: OperatorSystem;
  operatorSystems: Array<OperatorSystem>;
  operatorUser: OperatorUser;
  operatorUsers: Array<OperatorUser>;
  operators: Array<Operator>;
  payableInvoice: PayableInvoice;
  processingError: ProcessingError;
  product: Product;
  productSpreadsheetPreview: ProductSpreadsheetPreviewPayload;
  products: Array<Product>;
  program: Program;
  programs: Array<Program>;
  publicTradeDataCodes: TradeDataCodes;
  /** A request and response transaction with a 3P system. */
  queryCbpAdCvdCaseTransaction: QueryCbpAdCvdCaseTransaction;
  /** A request and response transaction with a 3P system. */
  queryCbpCarrierCodeTransaction: QueryCbpCarrierCodeTransaction;
  /** A request and response transaction with a 3P system. */
  queryCbpEntryNumberTransaction: QueryCbpEntryNumberTransaction;
  /** A request and response transaction with a 3P system. */
  queryCbpEntrySummaryTransaction: QueryCbpEntrySummaryTransaction;
  /** A request and response transaction with a 3P system. */
  queryCbpFirmsCodeTransaction: QueryCbpFirmsCodeTransaction;
  /** A request and response transaction with a 3P system. */
  queryCbpHtsTransaction: QueryCbpHtsTransaction;
  /** A request and response transaction with a 3P system. */
  queryCbpIorTransaction: QueryCbpIorTransaction;
  queryChannelConnectionStatus: QueryChannelConnectionStatusPayload;
  /** A request and response transaction with a 3P system. */
  queryUsType86EntryCbpReleaseTransaction: QueryUsType86EntryCbpReleaseTransaction;
  releaseNote: ReleaseNote;
  releaseNotes: Array<ReleaseNote>;
  reportReconciliationRequest: ReportReconciliationRequest;
  reportReconciliationRequests: Array<ReportReconciliationRequest>;
  searchAdCvdCaseTable: SearchAdCvdCaseTablePayload;
  searchAdCvdCases: SearchAdCvdCasePayload;
  searchAllImportersByName: SearchAllImportersByNamePayload;
  searchAssignmentTeamStaticMappingTable: SearchAssignmentTeamStaticMappingTablePayload;
  searchAssignmentTeamStaticMappings: SearchAssignmentTeamStaticMappingPayload;
  searchAssignmentTeamTable: SearchAssignmentTeamTablePayload;
  searchAssignmentTeams: SearchAssignmentTeamPayload;
  searchAuditLogs: SearchAuditLogPayload;
  searchBrokerTable: SearchBrokerTablePayload;
  searchBrokers: SearchBrokerPayload;
  searchBulkChargesUploadRequestTable: SearchBulkChargesUploadRequestTablePayload;
  searchBulkChargesUploadRequests: SearchBulkChargesUploadRequestPayload;
  searchBulkComplianceUploadRequestTable: SearchBulkComplianceUploadRequestTablePayload;
  searchBulkComplianceUploadRequests: SearchBulkComplianceUploadRequestPayload;
  searchBulkMilestoneUploadRequestTable: SearchBulkMilestoneUploadRequestTablePayload;
  searchBulkMilestoneUploadRequests: SearchBulkMilestoneUploadRequestPayload;
  searchBusinessSupportTeamTable: SearchBusinessSupportTeamTablePayload;
  searchBusinessSupportTeams: SearchBusinessSupportTeamPayload;
  searchCaseCategoryConfigs: SearchCaseCategoryConfigPayload;
  searchChangelogs: SearchChangelogPayload;
  searchCommodityGroupTable: SearchCommodityGroupTablePayload;
  searchCommodityGroups: SearchCommodityGroupPayload;
  searchCustomDomains: SearchCustomDomainPayload;
  searchCustomsAgentTable: SearchCustomsAgentTablePayload;
  searchCustomsAgents: SearchCustomsAgentPayload;
  searchCustomsBrokerTable: SearchCustomsBrokerTablePayload;
  searchCustomsBrokers: SearchCustomsBrokerPayload;
  searchCustomsDeclarationTable: SearchCustomsDeclarationTablePayload;
  searchCustomsDeclarations: SearchCustomsDeclarationPayload;
  searchCustomsEntries: SearchCustomsEntriesPayload;
  searchCustomsEntryTable: SearchCustomsEntryTablePayload;
  searchDeConsigneeTable: SearchDeConsigneeTablePayload;
  searchDeConsignees: SearchDeConsigneePayload;
  searchDeCustomsBrokerTable: SearchDeCustomsBrokerTablePayload;
  searchDeCustomsBrokers: SearchDeCustomsBrokerPayload;
  searchDeCustomsEntries: SearchDeCustomsEntryPayload;
  searchDeCustomsEntryTable: SearchDeCustomsEntryTablePayload;
  searchDeIorActivationTable: SearchDeIorActivationTablePayload;
  searchDeIorActivations: SearchDeIorActivationPayload;
  searchDeIorTable: SearchDeIorTablePayload;
  searchDeIors: SearchDeIorPayload;
  searchDecoratedProductTable: SearchDecoratedProductTablePayload;
  searchDeliveryOrderTable: SearchDeliveryOrderTablePayload;
  searchDeliveryOrders: SearchDeliveryOrderPayload;
  searchDocumentTable: SearchDocumentTablePayload;
  searchDocumentTemplateTable: SearchDocumentTemplateTablePayload;
  searchDocumentTemplates: SearchDocumentTemplatePayload;
  searchDocuments: SearchDocumentPayload;
  searchDpsRecordTable: SearchDpsRecordTablePayload;
  searchDpsRecords: SearchDpsRecordPayload;
  searchErrorDefinitions: SearchErrorDefinitionPayload;
  searchEuHsTable: SearchEuHsTablePayload;
  searchEuHss: SearchEuHsPayload;
  searchExchangeMessageTable: SearchExchangeMessageTablePayload;
  searchExchangeMessages: SearchExchangeMessagePayload;
  searchExternalSystemTable: SearchExternalSystemTablePayload;
  searchExternalSystems: SearchExternalSystemPayload;
  searchFacilities: SearchFacilityPayload;
  searchFacilityTable: SearchFacilityTablePayload;
  searchForwarderSystemTable: SearchForwarderSystemTablePayload;
  searchForwarderSystems: SearchForwarderSystemPayload;
  searchForwarderTable: SearchForwarderTablePayload;
  searchForwarderUserTable: SearchForwarderUserTablePayload;
  searchForwarderUsers: SearchForwarderUserPayload;
  searchForwarders: SearchForwarderPayload;
  searchFrConsigneeTable: SearchFrConsigneeTablePayload;
  searchFrConsignees: SearchFrConsigneePayload;
  searchFrCustomsBrokerTable: SearchFrCustomsBrokerTablePayload;
  searchFrCustomsBrokers: SearchFrCustomsBrokerPayload;
  searchFrCustomsEntries: SearchFrCustomsEntryPayload;
  searchFrCustomsEntryTable: SearchFrCustomsEntryTablePayload;
  searchFrIorActivationTable: SearchFrIorActivationTablePayload;
  searchFrIorActivations: SearchFrIorActivationPayload;
  searchFrIorTable: SearchFrIorTablePayload;
  searchFrIors: SearchFrIorPayload;
  searchGbConsigneeTable: SearchGbConsigneeTablePayload;
  searchGbConsignees: SearchGbConsigneePayload;
  searchGbCustomsEntries: SearchGbCustomsEntryPayload;
  searchGbCustomsEntryTable: SearchGbCustomsEntryTablePayload;
  searchGbIorActivationTable: SearchGbIorActivationTablePayload;
  searchGbIorActivations: SearchGbIorActivationPayload;
  searchGbIorTable: SearchGbIorTablePayload;
  searchGbIors: SearchGbIorPayload;
  searchGlobalConsigneeTable: SearchGlobalConsigneeTablePayload;
  searchGlobalConsignees: SearchGlobalConsigneePayload;
  searchHtsTable: SearchHtsTablePayload;
  searchHtss: SearchHtsPayload;
  searchImporterEntities: SearchImporterEntityPayload;
  searchImporterEntityActivationTable: SearchImporterEntityActivationTablePayload;
  searchImporterEntityActivations: SearchImporterEntityActivationPayload;
  searchImporterEntityTable: SearchImporterEntityTablePayload;
  searchImporterTable: SearchImporterTablePayload;
  searchImporters: SearchImporterPayload;
  searchInvoiceCreditNoteTable: SearchInvoiceCreditNoteTablePayload;
  searchInvoiceCreditNotes: SearchInvoiceCreditNotePayload;
  searchInvoiceLinesRequests: SearchInvoiceLinesRequestPayload;
  searchInvoicePaymentTable: SearchInvoicePaymentTablePayload;
  searchInvoicePayments: SearchInvoicePaymentPayload;
  searchInvoiceTable: SearchInvoiceTablePayload;
  searchInvoices: SearchInvoicePayload;
  searchMemoTable: SearchMemoTablePayload;
  searchMemos: SearchMemoPayload;
  searchNlConsigneeTable: SearchNlConsigneeTablePayload;
  searchNlConsignees: SearchNlConsigneePayload;
  searchNlCustomsBrokerTable: SearchNlCustomsBrokerTablePayload;
  searchNlCustomsBrokers: SearchNlCustomsBrokerPayload;
  searchNlCustomsEntries: SearchNlCustomsEntryPayload;
  searchNlCustomsEntryTable: SearchNlCustomsEntryTablePayload;
  searchNlIorActivationTable: SearchNlIorActivationTablePayload;
  searchNlIorActivations: SearchNlIorActivationPayload;
  searchNlIorTable: SearchNlIorTablePayload;
  searchNlIors: SearchNlIorPayload;
  searchOnboardingRequestTable: SearchOnboardingRequestTablePayload;
  searchOnboardingRequests: SearchOnboardingRequestPayload;
  searchOperatorSystemTable: SearchOperatorSystemTablePayload;
  searchOperatorSystems: SearchOperatorSystemPayload;
  searchOperatorTable: SearchOperatorTablePayload;
  searchOperatorUserTable: SearchOperatorUserTablePayload;
  searchOperatorUsers: SearchOperatorUserPayload;
  searchOperators: SearchOperatorPayload;
  searchParties: SearchPartyPayload;
  searchPartyTable: SearchPartyTablePayload;
  searchPayableInvoiceTable: SearchPayableInvoiceTablePayload;
  searchPayableInvoices: SearchPayableInvoicePayload;
  searchProcessingErrorTable: SearchProcessingErrorTablePayload;
  searchProcessingErrors: SearchProcessingErrorPayload;
  searchProductTable: SearchProductTablePayload;
  searchProducts: SearchProductPayload;
  searchReleaseNoteTable: SearchReleaseNoteTablePayload;
  searchReleaseNotes: SearchReleaseNotePayload;
  searchReportReconciliationRequestTable: SearchReportReconciliationRequestTablePayload;
  searchReportReconciliationRequests: SearchReportReconciliationRequestPayload;
  searchShipmentCommercialInvoiceDetailTable: SearchShipmentCommercialInvoiceDetailTablePayload;
  searchShipmentCommercialInvoiceDetails: SearchShipmentCommercialInvoiceDetailPayload;
  searchShipmentDocumentProcessingRequestTable: SearchShipmentDocumentProcessingRequestTablePayload;
  searchShipmentDocumentProcessingRequests: SearchShipmentDocumentProcessingRequestPayload;
  searchShipmentTable: SearchShipmentTablePayload;
  searchShipments: SearchShipmentPayload;
  searchShipperSystemTable: SearchShipperSystemTablePayload;
  searchShipperSystems: SearchShipperSystemPayload;
  searchShipperTable: SearchShipperTablePayload;
  searchShipperUserTable: SearchShipperUserTablePayload;
  searchShipperUsers: SearchShipperUserPayload;
  searchShippers: SearchShipperPayload;
  searchStampDocumentSignRequestTable: SearchStampDocumentSignRequestTablePayload;
  searchStampDocumentSignRequests: SearchStampDocumentSignRequestPayload;
  searchSubjectMatterExpertTeamTable: SearchSubjectMatterExpertTeamTablePayload;
  searchSubjectMatterExpertTeams: SearchSubjectMatterExpertTeamPayload;
  searchSupplierTable: SearchSupplierTablePayload;
  searchSuppliers: SearchSupplierPayload;
  searchTableFilterTable: SearchTableFilterTablePayload;
  searchTableFilters: SearchTableFilterPayload;
  searchTeamTable: SearchTeamTablePayload;
  searchTeams: SearchTeamPayload;
  searchTemplateDocumentSignRequestTable: SearchTemplateDocumentSignRequestTablePayload;
  searchTemplateDocumentSignRequests: SearchTemplateDocumentSignRequestPayload;
  searchTradeAdvisoryRequestTable: SearchTradeAdvisoryRequestTablePayload;
  searchTradeAdvisoryRequests: SearchTradeAdvisoryRequestPayload;
  searchTruckerTable: SearchTruckerTablePayload;
  searchTruckers: SearchTruckerPayload;
  searchUkCustomsBrokerTable: SearchUkCustomsBrokerTablePayload;
  searchUkCustomsBrokers: SearchUkCustomsBrokerPayload;
  searchUkHsTable: SearchUkHsTablePayload;
  searchUkHss: SearchUkHsPayload;
  searchUsConsigneeTable: SearchUsConsigneeTablePayload;
  searchUsConsignees: SearchUsConsigneePayload;
  searchUsConsumptionEntries: SearchUsConsumptionEntryPayload;
  searchUsConsumptionEntryTable: SearchUsConsumptionEntryTablePayload;
  searchUsCustomsBrokerTable: SearchUsCustomsBrokerTablePayload;
  searchUsCustomsBrokers: SearchUsCustomsBrokerPayload;
  searchUsDrawbackClaimTable: SearchUsDrawbackClaimTablePayload;
  searchUsDrawbackClaims: SearchUsDrawbackClaimPayload;
  searchUsHtsTable: SearchUsHtsTablePayload;
  searchUsHtss: SearchUsHtsPayload;
  searchUsInBondTable: SearchUsInBondTablePayload;
  searchUsInBonds: SearchUsInBondPayload;
  searchUsIorActivationTable: SearchUsIorActivationTablePayload;
  searchUsIorActivations: SearchUsIorActivationPayload;
  searchUsIorContinuousBondRequestTable: SearchUsIorContinuousBondRequestTablePayload;
  searchUsIorContinuousBondRequests: SearchUsIorContinuousBondRequestPayload;
  searchUsIorTable: SearchUsIorTablePayload;
  searchUsIors: SearchUsIorPayload;
  searchUsIsfTable: SearchUsIsfTablePayload;
  searchUsIsfs: SearchUsIsfPayload;
  searchUsPostSummaryCorrectionTable: SearchUsPostSummaryCorrectionTablePayload;
  searchUsPostSummaryCorrections: SearchUsPostSummaryCorrectionPayload;
  searchUsPrincipalAdCvdCaseTable: SearchUsPrincipalAdCvdCaseTablePayload;
  searchUsPrincipalAdCvdCases: SearchUsPrincipalAdCvdCasePayload;
  searchUsType86Entries: SearchUsType86EntryPayload;
  searchUsType86EntryTable: SearchUsType86EntryTablePayload;
  searchUserReleaseNoteViewTable: SearchUserReleaseNoteViewTablePayload;
  searchUserReleaseNoteViews: SearchUserReleaseNoteViewPayload;
  searchUserTable: SearchUserTablePayload;
  searchUserTeamTable: SearchUserTeamTablePayload;
  searchUserTeams: SearchUserTeamPayload;
  searchUsers: SearchUserPayload;
  searchWorkOrderDocumentProcessingRequestTable: SearchWorkOrderDocumentProcessingRequestTablePayload;
  searchWorkOrderDocumentProcessingRequests: SearchWorkOrderDocumentProcessingRequestPayload;
  searchWorkOrderGroupTable: SearchWorkOrderGroupTablePayload;
  searchWorkOrderGroups: SearchWorkOrderGroupPayload;
  searchWorkOrderStateMachineTable: SearchWorkOrderStateMachineTablePayload;
  searchWorkOrderStateMachines: SearchWorkOrderStateMachinePayload;
  searchWorkOrderTable: SearchWorkOrderTablePayload;
  searchWorkOrderTaskDefinitionTable: SearchWorkOrderTaskDefinitionTablePayload;
  searchWorkOrderTaskDefinitions: SearchWorkOrderTaskDefinitionPayload;
  searchWorkOrderTaskEscalationMessageTable: SearchWorkOrderTaskEscalationMessageTablePayload;
  searchWorkOrderTaskEscalationMessages: SearchWorkOrderTaskEscalationMessagePayload;
  searchWorkOrderTaskTable: SearchWorkOrderTaskTablePayload;
  searchWorkOrderTasks: SearchWorkOrderTaskPayload;
  searchWorkOrders: SearchWorkOrderPayload;
  shipment: Shipment;
  shipmentCommercialInvoiceDetail: ShipmentCommercialInvoiceDetail;
  shipmentCommercialInvoiceDetails: Array<ShipmentCommercialInvoiceDetail>;
  shipmentDocumentProcessingRequest: ShipmentDocumentProcessingRequest;
  shipmentDocumentProcessingRequests: Array<ShipmentDocumentProcessingRequest>;
  shipments: Array<Shipment>;
  shipper: Shipper;
  shipperBrokerRelationship: ShipperBrokerRelationship;
  shipperCustomsAgentRelationship: ShipperCustomsAgentRelationship;
  shipperDeConsigneeRelationship: ShipperDeConsigneeRelationship;
  shipperDeCustomsBrokerRelationship: ShipperDeCustomsBrokerRelationship;
  shipperDeIorRelationship: ShipperDeIorRelationship;
  shipperFacilityRelationship: ShipperFacilityRelationship;
  shipperForwarderRelationship: ShipperForwarderRelationship;
  shipperFrConsigneeRelationship: ShipperFrConsigneeRelationship;
  shipperFrCustomsBrokerRelationship: ShipperFrCustomsBrokerRelationship;
  shipperFrIorRelationship: ShipperFrIorRelationship;
  shipperGbConsigneeRelationship: ShipperGbConsigneeRelationship;
  shipperGbIorRelationship: ShipperGbIorRelationship;
  shipperGlobalConsigneeRelationship: ShipperGlobalConsigneeRelationship;
  shipperImporterRelationship: ShipperImporterRelationship;
  shipperNlConsigneeRelationship: ShipperNlConsigneeRelationship;
  shipperNlCustomsBrokerRelationship: ShipperNlCustomsBrokerRelationship;
  shipperNlIorRelationship: ShipperNlIorRelationship;
  shipperSupplierRelationship: ShipperSupplierRelationship;
  shipperSystem: ShipperSystem;
  shipperSystems: Array<ShipperSystem>;
  shipperTruckerRelationship: ShipperTruckerRelationship;
  shipperUkCustomsBrokerRelationship: ShipperUkCustomsBrokerRelationship;
  shipperUsConsigneeRelationship: ShipperUsConsigneeRelationship;
  shipperUsCustomsBrokerRelationship: ShipperUsCustomsBrokerRelationship;
  shipperUsIorRelationship: ShipperUsIorRelationship;
  shipperUser: ShipperUser;
  shipperUsers: Array<ShipperUser>;
  shippers: Array<Shipper>;
  stampDocumentGenerationRequest: StampDocumentGenerationRequest;
  stampDocumentSignRequest: StampDocumentSignRequest;
  stampDocumentSignRequests: Array<StampDocumentSignRequest>;
  subjectMatterExpertTeam: SubjectMatterExpertTeam;
  subjectMatterExpertTeamOperatorUserRelationship: SubjectMatterExpertTeamOperatorUserRelationship;
  subjectMatterExpertTeams: Array<SubjectMatterExpertTeam>;
  /** A request and response transaction with a 3P system. */
  submitDisTransaction: SubmitDisTransaction;
  supplier: Supplier;
  supplierSpreadsheetPreview: SupplierSpreadsheetPreviewPayload;
  suppliers: Array<Supplier>;
  tableFilter: TableFilter;
  tableFilters: Array<TableFilter>;
  team: Team;
  teams: Array<Team>;
  templateDocumentSignRequest: TemplateDocumentSignRequest;
  templateDocumentSignRequests: Array<TemplateDocumentSignRequest>;
  tradeAdvisoryRequest: TradeAdvisoryRequest;
  tradeAdvisoryRequests: Array<TradeAdvisoryRequest>;
  trucker: Trucker;
  truckers: Array<Trucker>;
  ukCustomsBroker: UkCustomsBroker;
  ukCustomsBrokers: Array<UkCustomsBroker>;
  ukHs: UkHs;
  ukHss: Array<UkHs>;
  /** A request and response transaction with a 3P system. */
  updateCbp5106Transaction: UpdateCbp5106Transaction;
  /** A request and response transaction with a 3P system. */
  updateCbpEntryStatementTransaction: UpdateCbpEntryStatementTransaction;
  /** A request and response transaction with a 3P system. */
  upsertCbpMidTransaction: UpsertCbpMidTransaction;
  usCargoReleaseDocumentGenerationRequest: UsCargoReleaseDocumentGenerationRequest;
  usCbp5106DocumentGenerationRequest: UsCbp5106DocumentGenerationRequest;
  usCbp7501DocumentGenerationRequest: UsCbp7501DocumentGenerationRequest;
  usCbp7512DocumentGenerationRequest: UsCbp7512DocumentGenerationRequest;
  usConsignee: UsConsignee;
  usConsignees: Array<UsConsignee>;
  usConsumptionEntries: Array<UsConsumptionEntry>;
  usConsumptionEntry: UsConsumptionEntry;
  usCustomsBroker: UsCustomsBroker;
  usCustomsBrokers: Array<UsCustomsBroker>;
  usDrawbackClaim: UsDrawbackClaim;
  usDrawbackClaimDocumentGenerationRequest: UsDrawbackClaimDocumentGenerationRequest;
  usDrawbackClaims: Array<UsDrawbackClaim>;
  usHts: UsHts;
  usHtss: Array<UsHts>;
  usInBond: UsInBond;
  usInBonds: Array<UsInBond>;
  usIor: UsIor;
  usIorActivation: UsIorActivation;
  usIorActivations: Array<UsIorActivation>;
  usIorContinuousBondRequest: UsIorContinuousBondRequest;
  usIorContinuousBondRequests: Array<UsIorContinuousBondRequest>;
  usIors: Array<UsIor>;
  usIsf: UsIsf;
  usIsfs: Array<UsIsf>;
  usPostSummaryCorrection: UsPostSummaryCorrection;
  usPostSummaryCorrections: Array<UsPostSummaryCorrection>;
  usPrincipalAdCvdCase: UsPrincipalAdCvdCase;
  usPrincipalAdCvdCases: Array<UsPrincipalAdCvdCase>;
  usType86Entries: Array<UsType86Entry>;
  usType86Entry: UsType86Entry;
  userReleaseNoteView: UserReleaseNoteView;
  userReleaseNoteViews: Array<UserReleaseNoteView>;
  validateIdentifierNumber: ExternalValidationResponse;
  validateUsCommercialInvoices: ValidateUsCommercialInvoicesPayload;
  validateUsConsumptionEntry: ValidateUsConsumptionEntryPayload;
  validateUsConsumptionEntryRelease: ValidateUsConsumptionEntryReleasePayload;
  validateUsIsf: ValidateUsIsfPayload;
  validateUsPostSummaryCorrection: ValidateUsPostSummaryCorrectionPayload;
  validateUsType86: ValidateUsType86EntryPayload;
  validateWorkOrderTask: ValidateWorkOrderTaskPayload;
  workOrder: WorkOrder;
  workOrderConfirmation: WorkOrderConfirmation;
  workOrderConfirmations: Array<WorkOrderConfirmation>;
  workOrderDocumentProcessingRequest: WorkOrderDocumentProcessingRequest;
  workOrderDocumentProcessingRequests: Array<WorkOrderDocumentProcessingRequest>;
  workOrderGroup: WorkOrderGroup;
  workOrderGroups: Array<WorkOrderGroup>;
  workOrderMilestone: WorkOrderMilestone;
  workOrderStateMachine: WorkOrderStateMachine;
  workOrderStateMachines: Array<WorkOrderStateMachine>;
  workOrderTask: WorkOrderTask;
  workOrderTaskDefinition: WorkOrderTaskDefinition;
  workOrderTaskDefinitions: Array<WorkOrderTaskDefinition>;
  workOrderTaskEscalationMessage: WorkOrderTaskEscalationMessage;
  workOrderTaskEscalationMessages: Array<WorkOrderTaskEscalationMessage>;
  workOrderTasks: Array<WorkOrderTask>;
  /** Get XBT shipper profile by ID from XBTUserService */
  xbtShipperProfile: XbtShipperProfilePayload;
};


export type QueryWorkOrderTaskAssignmentRequestArgs = {
  operatorUserId: Scalars['ID'];
  operatorUserVersion: Scalars['Int'];
};


export type QueryadCvdCaseArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryadCvdCasesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryallAdCvdCasesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallAssignmentTeamStaticMappingsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallAssignmentTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallAuditLogsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallBulkChargesUploadRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallBulkComplianceUploadRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallBulkMilestoneUploadRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallBusinessSupportTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallCaseCategoryConfigsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallChangelogsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallCommodityGroupsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallCustomDomainsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallCustomsAgentsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallCustomsDeclarationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallCustomsEntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDeConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDeCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDeCustomsEntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDeIorActivationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDeIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDeliveryOrdersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDocumentTemplatesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDocumentsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallDpsRecordsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallEuHssArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallExchangeMessagesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFacilitiesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFeatureFlagsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallForwarderSystemsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallForwarderUsersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallForwardersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFrConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFrCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFrCustomsEntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFrIorActivationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallFrIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallGbConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallGbCustomsEntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallGbIorActivationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallGbIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallGlobalConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallHtssArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallImportProductsFromBulkUploadRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallImportProductsFromCustomsEntriesRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallImporterEntitiesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallImporterEntityActivationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallImportersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallInvoiceCreditNotesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallInvoicePaymentsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallInvoicesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallMemosArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallNlConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallNlCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallNlCustomsEntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallNlIorActivationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallNlIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallOnboardingRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallOperatorSystemsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallOperatorUsersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallOperatorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallProductsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallReimbursementsArgs = {
  id: Scalars['ID'];
  version: Scalars['Float'];
};


export type QueryallReleaseNotesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallShipmentCommercialInvoiceDetailsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallShipmentDocumentProcessingRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallShipmentsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallShipperSystemsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallShipperUsersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallShippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallStampDocumentSignRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallSubjectMatterExpertTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallSuppliersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallTableFiltersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallTeamsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallTemplateDocumentSignRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallTradeAdvisoryRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallTruckersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUkCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUkHssArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsConsumptionEntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsDrawbackClaimsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsHtssArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsInBondsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsIorActivationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsIorContinuousBondRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsIsfsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsPostSummaryCorrectionsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsPrincipalAdCvdCasesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUsType86EntriesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallUserReleaseNoteViewsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderConfirmationsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderDocumentProcessingRequestsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderGroupsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderMilestonesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderStateMachinesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderTaskDefinitionsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderTaskEscalationMessagesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryallWorkOrderTasksArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type QueryamsQueryTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryassignmentTeamArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryassignmentTeamOperatorUserRelationshipArgs = {
  assignmentTeamId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  operatorUserId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryassignmentTeamStaticMappingArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryassignmentTeamStaticMappingsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryassignmentTeamsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryauditLogArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryauditLogsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryauthenticationTokenArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryauthenticationTokensArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryauthorizeCbpEntryStatementDebitTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerybrokerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybrokersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerybulkChargesUploadRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybulkChargesUploadRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerybulkComplianceUploadRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybulkComplianceUploadRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerybulkMilestoneUploadRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybulkMilestoneUploadRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerybulkProductUploadTemplateDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybusinessSupportTeamArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybusinessSupportTeamOperatorUserRelationshipArgs = {
  businessSupportTeamId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  operatorUserId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerybusinessSupportTeamsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerycaseCategoryConfigArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerycaseCategoryConfigsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerychangelogArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerychangelogsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryclassifyUsCustomsFilingArgs = {
  input: ClassifyUsCustomsFilingInput;
};


export type QueryclientApiKeyArgs = {
  clientApiKey: Scalars['ID'];
};


export type QuerycommodityGroupArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerycommodityGroupsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerycustomDomainArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomDomainsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerycustomsAgentArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomsAgentsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerycustomsDeclarationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomsDeclarationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerycustomsEntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerycustomsEntryArgs = {
  id: Scalars['ID'];
};


export type QuerydeConsigneeArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeConsigneesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydeCustomsBrokerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeCustomsBrokersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydeCustomsEntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydeCustomsEntryArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeIorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeIorActivationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeIorActivationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydeIorsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydecryptLoginLinkArgs = {
  linkHash: Scalars['String'];
};


export type QuerydeliveryOrderArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeliveryOrderDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydeliveryOrdersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydocumentArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydocumentTemplateArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerydocumentTemplatesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydocumentsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerydpsRecordArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryeffectiveEuHssArgs = {
  input: EffectiveEuHssInput;
};


export type QueryeffectiveUkHssArgs = {
  input: EffectiveUkHssInput;
};


export type QueryeffectiveUsHtssArgs = {
  input: EffectiveUsHtssInput;
};


export type QueryenrichSupportingEntitiesArgs = {
  entityType: Scalars['String'];
  entityValue: Scalars['String'];
  supportingEntitiesToBeEnriched: Array<Scalars['String']>;
};


export type QueryerrorDefinitionArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryeuHsArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryeuHssArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryeuUkCustomsDeclarationArgs = {
  id: Scalars['ID'];
};


export type QueryexcelTemplateDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryexchangeMessageArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryexchangeMessagesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfacilitiesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfacilityArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfeatureFlagArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfeatureFlagsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfetchForwarderMailFromArgs = {
  id: Scalars['ID'];
};


export type QueryforwarderArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryforwarderSystemArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryforwarderSystemsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryforwarderUserArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryforwarderUsersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryforwardersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfrConsigneeArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfrConsigneesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfrCustomsBrokerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfrCustomsBrokersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfrCustomsEntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfrCustomsEntryArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfrIorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfrIorActivationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryfrIorActivationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryfrIorsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerygbConsigneeArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerygbConsigneesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerygbCustomsEntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerygbCustomsEntryArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerygbIorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerygbIorActivationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerygbIorActivationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerygbIorsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerygenerateAssignmentResultArgs = {
  assignmentTeamId: Scalars['String'];
};


export type QuerygenerateJWTArgs = {
  login: Scalars['String'];
};


export type QuerygenericDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerygetAbiExchangeMessagesArgs = {
  input: ExchangeMessageSearchCriteriaInput;
  recordType?: InputMaybe<RecordType>;
  searchPaginationInput?: InputMaybe<SearchPaginationInput>;
};


export type QuerygetAsinProductDetailsArgs = {
  input: GetAsinProductDetailsRequest;
};


export type QuerygetAuditLogPresignedUrlArgs = {
  entryId: Scalars['String'];
};


export type QuerygetCaseAssignmentByTeamArgs = {
  assignmentTeamId: Scalars['String'];
};


export type QuerygetCaseAssignmentTeamByIdArgs = {
  assignmentTeamId: Scalars['String'];
};


export type QuerygetCaseAssignmentTeamsArgs = {
  caseCategoryId?: InputMaybe<Scalars['String']>;
  includeAll?: InputMaybe<Scalars['Boolean']>;
  operatorUserLogin?: InputMaybe<Scalars['String']>;
};


export type QuerygetCaseAutoAssignmentArgs = {
  additionalAttributes?: InputMaybe<Scalars['String']>;
  bookingId?: InputMaybe<Scalars['String']>;
  caseCategoryId: Scalars['String'];
  workOrderId?: InputMaybe<Scalars['String']>;
};


export type QuerygetCpscCitationCodesPresignedUrlArgs = {
  codeType: CpscCitationCodeType;
};


export type QuerygetLatestViewedReleaseNoteByUserArgs = {
  userId: Scalars['String'];
};


export type QuerygetLinkedMerchantIdsForShipperIdArgs = {
  input: GetLinkedMerchantIdsInput;
};


export type QuerygetPendingSubPoasArgs = {
  forwarderId: Scalars['ID'];
};


export type QuerygetShipmentComplianceDetailsArgs = {
  commercialInvoicesIndex: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
  shipmentId: Scalars['ID'];
  shipmentLegIndex: Scalars['Int'];
  shipmentVersion: Scalars['Int'];
};


export type QueryglobalConsigneeArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryglobalConsigneesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryglobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryhtmlDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryhtsArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryhtssArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryimportProductsFromBulkUploadRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryimportProductsFromBulkUploadRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryimportProductsFromCustomsEntriesRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryimportProductsFromCustomsEntriesRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryimporterArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryimporterEntitiesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryimporterEntityArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryimporterEntityActivationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryimporterEntityActivationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryimporterImporterEntityRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  importerEntityId?: InputMaybe<Scalars['ID']>;
  importerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryimportersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryinBondNotesDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoiceArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoiceCreditNoteArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoiceCreditNoteDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoiceCreditNotesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryinvoiceDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoiceLinesRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoicePaymentArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryinvoicePaymentsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryinvoicesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryloginArgs = {
  cognitoSub?: InputMaybe<Scalars['ID']>;
};


export type QuerymemoArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerymemosArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerymutateActionInBondCbpTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateCbpDrawbackClaimTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateCbpEntryPgaTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateCbpEntryReleaseTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateCbpEntrySummaryTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateCbpIsfTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateInBondCbpTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerymutateUsType86EntryCbpReleaseTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerynlConsigneeArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerynlConsigneesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerynlCustomsBrokerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerynlCustomsBrokersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerynlCustomsEntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerynlCustomsEntryArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerynlIorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerynlIorActivationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerynlIorActivationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerynlIorsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryonboardingRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryonboardingRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryoperatorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryoperatorSystemArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryoperatorSystemsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryoperatorUserArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryoperatorUsersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryoperatorsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerypayableInvoiceArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryprocessingErrorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryproductArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryproductSpreadsheetPreviewArgs = {
  input: ProductSpreadsheetPreviewInput;
};


export type QueryproductsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryprogramArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryprogramsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryqueryCbpAdCvdCaseTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryCbpCarrierCodeTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryCbpEntryNumberTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryCbpEntrySummaryTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryCbpFirmsCodeTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryCbpHtsTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryCbpIorTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryqueryChannelConnectionStatusArgs = {
  input: QueryChannelConnectionStatusInput;
};


export type QueryqueryUsType86EntryCbpReleaseTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryreleaseNoteArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryreleaseNotesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryreportReconciliationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryreportReconciliationRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerysearchAdCvdCaseTableArgs = {
  input: SearchAdCvdCaseTableInput;
};


export type QuerysearchAdCvdCasesArgs = {
  input: SearchAdCvdCaseInput;
};


export type QuerysearchAllImportersByNameArgs = {
  importerName: Scalars['String'];
};


export type QuerysearchAssignmentTeamStaticMappingTableArgs = {
  input: SearchAssignmentTeamStaticMappingTableInput;
};


export type QuerysearchAssignmentTeamStaticMappingsArgs = {
  input: SearchAssignmentTeamStaticMappingInput;
};


export type QuerysearchAssignmentTeamTableArgs = {
  input: SearchAssignmentTeamTableInput;
};


export type QuerysearchAssignmentTeamsArgs = {
  input: SearchAssignmentTeamInput;
};


export type QuerysearchAuditLogsArgs = {
  input: SearchAuditLogInput;
};


export type QuerysearchBrokerTableArgs = {
  input: SearchBrokerTableInput;
};


export type QuerysearchBrokersArgs = {
  input: SearchBrokerInput;
};


export type QuerysearchBulkChargesUploadRequestTableArgs = {
  input: SearchBulkChargesUploadRequestTableInput;
};


export type QuerysearchBulkChargesUploadRequestsArgs = {
  input: SearchBulkChargesUploadRequestInput;
};


export type QuerysearchBulkComplianceUploadRequestTableArgs = {
  input: SearchBulkComplianceUploadRequestTableInput;
};


export type QuerysearchBulkComplianceUploadRequestsArgs = {
  input: SearchBulkComplianceUploadRequestInput;
};


export type QuerysearchBulkMilestoneUploadRequestTableArgs = {
  input: SearchBulkMilestoneUploadRequestTableInput;
};


export type QuerysearchBulkMilestoneUploadRequestsArgs = {
  input: SearchBulkMilestoneUploadRequestInput;
};


export type QuerysearchBusinessSupportTeamTableArgs = {
  input: SearchBusinessSupportTeamTableInput;
};


export type QuerysearchBusinessSupportTeamsArgs = {
  input: SearchBusinessSupportTeamInput;
};


export type QuerysearchCaseCategoryConfigsArgs = {
  input: SearchCaseCategoryConfigInput;
};


export type QuerysearchChangelogsArgs = {
  input: SearchChangelogInput;
};


export type QuerysearchCommodityGroupTableArgs = {
  input: SearchCommodityGroupTableInput;
};


export type QuerysearchCommodityGroupsArgs = {
  input: SearchCommodityGroupInput;
};


export type QuerysearchCustomDomainsArgs = {
  input: SearchCustomDomainInput;
};


export type QuerysearchCustomsAgentTableArgs = {
  input: SearchCustomsAgentTableInput;
};


export type QuerysearchCustomsAgentsArgs = {
  input: SearchCustomsAgentInput;
};


export type QuerysearchCustomsBrokerTableArgs = {
  input: SearchCustomsBrokerTableInput;
};


export type QuerysearchCustomsBrokersArgs = {
  input: SearchCustomsBrokerInput;
};


export type QuerysearchCustomsDeclarationTableArgs = {
  input: SearchCustomsDeclarationTableInput;
};


export type QuerysearchCustomsDeclarationsArgs = {
  input: SearchCustomsDeclarationInput;
};


export type QuerysearchCustomsEntriesArgs = {
  input: SearchCustomsEntriesInput;
};


export type QuerysearchCustomsEntryTableArgs = {
  input: SearchCustomsEntryTableInput;
};


export type QuerysearchDeConsigneeTableArgs = {
  input: SearchDeConsigneeTableInput;
};


export type QuerysearchDeConsigneesArgs = {
  input: SearchDeConsigneeInput;
};


export type QuerysearchDeCustomsBrokerTableArgs = {
  input: SearchDeCustomsBrokerTableInput;
};


export type QuerysearchDeCustomsBrokersArgs = {
  input: SearchDeCustomsBrokerInput;
};


export type QuerysearchDeCustomsEntriesArgs = {
  input: SearchDeCustomsEntryInput;
};


export type QuerysearchDeCustomsEntryTableArgs = {
  input: SearchDeCustomsEntryTableInput;
};


export type QuerysearchDeIorActivationTableArgs = {
  input: SearchDeIorActivationTableInput;
};


export type QuerysearchDeIorActivationsArgs = {
  input: SearchDeIorActivationInput;
};


export type QuerysearchDeIorTableArgs = {
  input: SearchDeIorTableInput;
};


export type QuerysearchDeIorsArgs = {
  input: SearchDeIorInput;
};


export type QuerysearchDecoratedProductTableArgs = {
  input: SearchDecoratedProductInput;
};


export type QuerysearchDeliveryOrderTableArgs = {
  input: SearchDeliveryOrderTableInput;
};


export type QuerysearchDeliveryOrdersArgs = {
  input: SearchDeliveryOrderInput;
};


export type QuerysearchDocumentTableArgs = {
  input: SearchDocumentTableInput;
};


export type QuerysearchDocumentTemplateTableArgs = {
  input: SearchDocumentTemplateTableInput;
};


export type QuerysearchDocumentTemplatesArgs = {
  input: SearchDocumentTemplateInput;
};


export type QuerysearchDocumentsArgs = {
  input: SearchDocumentInput;
};


export type QuerysearchDpsRecordTableArgs = {
  input: SearchDpsRecordTableInput;
};


export type QuerysearchDpsRecordsArgs = {
  input: SearchDpsRecordInput;
};


export type QuerysearchErrorDefinitionsArgs = {
  input: SearchErrorDefinitionInput;
};


export type QuerysearchEuHsTableArgs = {
  input: SearchEuHsTableInput;
};


export type QuerysearchEuHssArgs = {
  input: SearchEuHsInput;
};


export type QuerysearchExchangeMessageTableArgs = {
  input: SearchExchangeMessageTableInput;
};


export type QuerysearchExchangeMessagesArgs = {
  input: SearchExchangeMessageInput;
};


export type QuerysearchExternalSystemTableArgs = {
  input: SearchExternalSystemTableInput;
};


export type QuerysearchExternalSystemsArgs = {
  input: SearchExternalSystemInput;
};


export type QuerysearchFacilitiesArgs = {
  input: SearchFacilityInput;
};


export type QuerysearchFacilityTableArgs = {
  input: SearchFacilityTableInput;
};


export type QuerysearchForwarderSystemTableArgs = {
  input: SearchForwarderSystemTableInput;
};


export type QuerysearchForwarderSystemsArgs = {
  input: SearchForwarderSystemInput;
};


export type QuerysearchForwarderTableArgs = {
  input: SearchForwarderTableInput;
};


export type QuerysearchForwarderUserTableArgs = {
  input: SearchForwarderUserTableInput;
};


export type QuerysearchForwarderUsersArgs = {
  input: SearchForwarderUserInput;
};


export type QuerysearchForwardersArgs = {
  input: SearchForwarderInput;
};


export type QuerysearchFrConsigneeTableArgs = {
  input: SearchFrConsigneeTableInput;
};


export type QuerysearchFrConsigneesArgs = {
  input: SearchFrConsigneeInput;
};


export type QuerysearchFrCustomsBrokerTableArgs = {
  input: SearchFrCustomsBrokerTableInput;
};


export type QuerysearchFrCustomsBrokersArgs = {
  input: SearchFrCustomsBrokerInput;
};


export type QuerysearchFrCustomsEntriesArgs = {
  input: SearchFrCustomsEntryInput;
};


export type QuerysearchFrCustomsEntryTableArgs = {
  input: SearchFrCustomsEntryTableInput;
};


export type QuerysearchFrIorActivationTableArgs = {
  input: SearchFrIorActivationTableInput;
};


export type QuerysearchFrIorActivationsArgs = {
  input: SearchFrIorActivationInput;
};


export type QuerysearchFrIorTableArgs = {
  input: SearchFrIorTableInput;
};


export type QuerysearchFrIorsArgs = {
  input: SearchFrIorInput;
};


export type QuerysearchGbConsigneeTableArgs = {
  input: SearchGbConsigneeTableInput;
};


export type QuerysearchGbConsigneesArgs = {
  input: SearchGbConsigneeInput;
};


export type QuerysearchGbCustomsEntriesArgs = {
  input: SearchGbCustomsEntryInput;
};


export type QuerysearchGbCustomsEntryTableArgs = {
  input: SearchGbCustomsEntryTableInput;
};


export type QuerysearchGbIorActivationTableArgs = {
  input: SearchGbIorActivationTableInput;
};


export type QuerysearchGbIorActivationsArgs = {
  input: SearchGbIorActivationInput;
};


export type QuerysearchGbIorTableArgs = {
  input: SearchGbIorTableInput;
};


export type QuerysearchGbIorsArgs = {
  input: SearchGbIorInput;
};


export type QuerysearchGlobalConsigneeTableArgs = {
  input: SearchGlobalConsigneeTableInput;
};


export type QuerysearchGlobalConsigneesArgs = {
  input: SearchGlobalConsigneeInput;
};


export type QuerysearchHtsTableArgs = {
  input: SearchHtsTableInput;
};


export type QuerysearchHtssArgs = {
  input: SearchHtsInput;
};


export type QuerysearchImporterEntitiesArgs = {
  input: SearchImporterEntityInput;
};


export type QuerysearchImporterEntityActivationTableArgs = {
  input: SearchImporterEntityActivationTableInput;
};


export type QuerysearchImporterEntityActivationsArgs = {
  input: SearchImporterEntityActivationInput;
};


export type QuerysearchImporterEntityTableArgs = {
  input: SearchImporterEntityTableInput;
};


export type QuerysearchImporterTableArgs = {
  input: SearchImporterTableInput;
};


export type QuerysearchImportersArgs = {
  input: SearchImporterInput;
};


export type QuerysearchInvoiceCreditNoteTableArgs = {
  input: SearchInvoiceCreditNoteTableInput;
};


export type QuerysearchInvoiceCreditNotesArgs = {
  input: SearchInvoiceCreditNoteInput;
};


export type QuerysearchInvoiceLinesRequestsArgs = {
  input: SearchInvoiceLinesRequestInput;
};


export type QuerysearchInvoicePaymentTableArgs = {
  input: SearchInvoicePaymentTableInput;
};


export type QuerysearchInvoicePaymentsArgs = {
  input: SearchInvoicePaymentInput;
};


export type QuerysearchInvoiceTableArgs = {
  input: SearchInvoiceTableInput;
};


export type QuerysearchInvoicesArgs = {
  input: SearchInvoiceInput;
};


export type QuerysearchMemoTableArgs = {
  input: SearchMemoTableInput;
};


export type QuerysearchMemosArgs = {
  input: SearchMemoInput;
};


export type QuerysearchNlConsigneeTableArgs = {
  input: SearchNlConsigneeTableInput;
};


export type QuerysearchNlConsigneesArgs = {
  input: SearchNlConsigneeInput;
};


export type QuerysearchNlCustomsBrokerTableArgs = {
  input: SearchNlCustomsBrokerTableInput;
};


export type QuerysearchNlCustomsBrokersArgs = {
  input: SearchNlCustomsBrokerInput;
};


export type QuerysearchNlCustomsEntriesArgs = {
  input: SearchNlCustomsEntryInput;
};


export type QuerysearchNlCustomsEntryTableArgs = {
  input: SearchNlCustomsEntryTableInput;
};


export type QuerysearchNlIorActivationTableArgs = {
  input: SearchNlIorActivationTableInput;
};


export type QuerysearchNlIorActivationsArgs = {
  input: SearchNlIorActivationInput;
};


export type QuerysearchNlIorTableArgs = {
  input: SearchNlIorTableInput;
};


export type QuerysearchNlIorsArgs = {
  input: SearchNlIorInput;
};


export type QuerysearchOnboardingRequestTableArgs = {
  input: SearchOnboardingRequestTableInput;
};


export type QuerysearchOnboardingRequestsArgs = {
  input: SearchOnboardingRequestInput;
};


export type QuerysearchOperatorSystemTableArgs = {
  input: SearchOperatorSystemTableInput;
};


export type QuerysearchOperatorSystemsArgs = {
  input: SearchOperatorSystemInput;
};


export type QuerysearchOperatorTableArgs = {
  input: SearchOperatorTableInput;
};


export type QuerysearchOperatorUserTableArgs = {
  input: SearchOperatorUserTableInput;
};


export type QuerysearchOperatorUsersArgs = {
  input: SearchOperatorUserInput;
};


export type QuerysearchOperatorsArgs = {
  input: SearchOperatorInput;
};


export type QuerysearchPartiesArgs = {
  input: SearchPartyInput;
};


export type QuerysearchPartyTableArgs = {
  input: SearchPartyTableInput;
};


export type QuerysearchPayableInvoiceTableArgs = {
  input: SearchPayableInvoiceTableInput;
};


export type QuerysearchPayableInvoicesArgs = {
  input: SearchPayableInvoiceInput;
};


export type QuerysearchProcessingErrorTableArgs = {
  input: SearchProcessingErrorTableInput;
};


export type QuerysearchProcessingErrorsArgs = {
  input: SearchProcessingErrorInput;
};


export type QuerysearchProductTableArgs = {
  input: SearchProductTableInput;
};


export type QuerysearchProductsArgs = {
  input: SearchProductInput;
};


export type QuerysearchReleaseNoteTableArgs = {
  input: SearchReleaseNoteTableInput;
};


export type QuerysearchReleaseNotesArgs = {
  input: SearchReleaseNoteInput;
};


export type QuerysearchReportReconciliationRequestTableArgs = {
  input: SearchReportReconciliationRequestTableInput;
};


export type QuerysearchReportReconciliationRequestsArgs = {
  input: SearchReportReconciliationRequestInput;
};


export type QuerysearchShipmentCommercialInvoiceDetailTableArgs = {
  input: SearchShipmentCommercialInvoiceDetailTableInput;
};


export type QuerysearchShipmentCommercialInvoiceDetailsArgs = {
  input: SearchShipmentCommercialInvoiceDetailInput;
};


export type QuerysearchShipmentDocumentProcessingRequestTableArgs = {
  input: SearchShipmentDocumentProcessingRequestTableInput;
};


export type QuerysearchShipmentDocumentProcessingRequestsArgs = {
  input: SearchShipmentDocumentProcessingRequestInput;
};


export type QuerysearchShipmentTableArgs = {
  input: SearchShipmentTableInput;
};


export type QuerysearchShipmentsArgs = {
  input: SearchShipmentInput;
};


export type QuerysearchShipperSystemTableArgs = {
  input: SearchShipperSystemTableInput;
};


export type QuerysearchShipperSystemsArgs = {
  input: SearchShipperSystemInput;
};


export type QuerysearchShipperTableArgs = {
  input: SearchShipperTableInput;
};


export type QuerysearchShipperUserTableArgs = {
  input: SearchShipperUserTableInput;
};


export type QuerysearchShipperUsersArgs = {
  input: SearchShipperUserInput;
};


export type QuerysearchShippersArgs = {
  input: SearchShipperInput;
};


export type QuerysearchStampDocumentSignRequestTableArgs = {
  input: SearchStampDocumentSignRequestTableInput;
};


export type QuerysearchStampDocumentSignRequestsArgs = {
  input: SearchStampDocumentSignRequestInput;
};


export type QuerysearchSubjectMatterExpertTeamTableArgs = {
  input: SearchSubjectMatterExpertTeamTableInput;
};


export type QuerysearchSubjectMatterExpertTeamsArgs = {
  input: SearchSubjectMatterExpertTeamInput;
};


export type QuerysearchSupplierTableArgs = {
  input: SearchSupplierTableInput;
};


export type QuerysearchSuppliersArgs = {
  input: SearchSupplierInput;
};


export type QuerysearchTableFilterTableArgs = {
  input: SearchTableFilterTableInput;
};


export type QuerysearchTableFiltersArgs = {
  input: SearchTableFilterInput;
};


export type QuerysearchTeamTableArgs = {
  input: SearchTeamTableInput;
};


export type QuerysearchTeamsArgs = {
  input: SearchTeamInput;
};


export type QuerysearchTemplateDocumentSignRequestTableArgs = {
  input: SearchTemplateDocumentSignRequestTableInput;
};


export type QuerysearchTemplateDocumentSignRequestsArgs = {
  input: SearchTemplateDocumentSignRequestInput;
};


export type QuerysearchTradeAdvisoryRequestTableArgs = {
  input: SearchTradeAdvisoryRequestTableInput;
};


export type QuerysearchTradeAdvisoryRequestsArgs = {
  input: SearchTradeAdvisoryRequestInput;
};


export type QuerysearchTruckerTableArgs = {
  input: SearchTruckerTableInput;
};


export type QuerysearchTruckersArgs = {
  input: SearchTruckerInput;
};


export type QuerysearchUkCustomsBrokerTableArgs = {
  input: SearchUkCustomsBrokerTableInput;
};


export type QuerysearchUkCustomsBrokersArgs = {
  input: SearchUkCustomsBrokerInput;
};


export type QuerysearchUkHsTableArgs = {
  input: SearchUkHsTableInput;
};


export type QuerysearchUkHssArgs = {
  input: SearchUkHsInput;
};


export type QuerysearchUsConsigneeTableArgs = {
  input: SearchUsConsigneeTableInput;
};


export type QuerysearchUsConsigneesArgs = {
  input: SearchUsConsigneeInput;
};


export type QuerysearchUsConsumptionEntriesArgs = {
  input: SearchUsConsumptionEntryInput;
};


export type QuerysearchUsConsumptionEntryTableArgs = {
  input: SearchUsConsumptionEntryTableInput;
};


export type QuerysearchUsCustomsBrokerTableArgs = {
  input: SearchUsCustomsBrokerTableInput;
};


export type QuerysearchUsCustomsBrokersArgs = {
  input: SearchUsCustomsBrokerInput;
};


export type QuerysearchUsDrawbackClaimTableArgs = {
  input: SearchUsDrawbackClaimTableInput;
};


export type QuerysearchUsDrawbackClaimsArgs = {
  input: SearchUsDrawbackClaimInput;
};


export type QuerysearchUsHtsTableArgs = {
  input: SearchUsHtsTableInput;
};


export type QuerysearchUsHtssArgs = {
  input: SearchUsHtsInput;
};


export type QuerysearchUsInBondTableArgs = {
  input: SearchUsInBondTableInput;
};


export type QuerysearchUsInBondsArgs = {
  input: SearchUsInBondInput;
};


export type QuerysearchUsIorActivationTableArgs = {
  input: SearchUsIorActivationTableInput;
};


export type QuerysearchUsIorActivationsArgs = {
  input: SearchUsIorActivationInput;
};


export type QuerysearchUsIorContinuousBondRequestTableArgs = {
  input: SearchUsIorContinuousBondRequestTableInput;
};


export type QuerysearchUsIorContinuousBondRequestsArgs = {
  input: SearchUsIorContinuousBondRequestInput;
};


export type QuerysearchUsIorTableArgs = {
  input: SearchUsIorTableInput;
};


export type QuerysearchUsIorsArgs = {
  input: SearchUsIorInput;
};


export type QuerysearchUsIsfTableArgs = {
  input: SearchUsIsfTableInput;
};


export type QuerysearchUsIsfsArgs = {
  input: SearchUsIsfInput;
};


export type QuerysearchUsPostSummaryCorrectionTableArgs = {
  input: SearchUsPostSummaryCorrectionTableInput;
};


export type QuerysearchUsPostSummaryCorrectionsArgs = {
  input: SearchUsPostSummaryCorrectionInput;
};


export type QuerysearchUsPrincipalAdCvdCaseTableArgs = {
  input: SearchUsPrincipalAdCvdCaseTableInput;
};


export type QuerysearchUsPrincipalAdCvdCasesArgs = {
  input: SearchUsPrincipalAdCvdCaseInput;
};


export type QuerysearchUsType86EntriesArgs = {
  input: SearchUsType86EntryInput;
};


export type QuerysearchUsType86EntryTableArgs = {
  input: SearchUsType86EntryTableInput;
};


export type QuerysearchUserReleaseNoteViewTableArgs = {
  input: SearchUserReleaseNoteViewTableInput;
};


export type QuerysearchUserReleaseNoteViewsArgs = {
  input: SearchUserReleaseNoteViewInput;
};


export type QuerysearchUserTableArgs = {
  input: SearchUserTableInput;
};


export type QuerysearchUserTeamTableArgs = {
  input: SearchUserTeamTableInput;
};


export type QuerysearchUserTeamsArgs = {
  input: SearchUserTeamInput;
};


export type QuerysearchUsersArgs = {
  input: SearchUserInput;
};


export type QuerysearchWorkOrderDocumentProcessingRequestTableArgs = {
  input: SearchWorkOrderDocumentProcessingRequestTableInput;
};


export type QuerysearchWorkOrderDocumentProcessingRequestsArgs = {
  input: SearchWorkOrderDocumentProcessingRequestInput;
};


export type QuerysearchWorkOrderGroupTableArgs = {
  input: SearchWorkOrderGroupTableInput;
};


export type QuerysearchWorkOrderGroupsArgs = {
  input: SearchWorkOrderGroupInput;
};


export type QuerysearchWorkOrderStateMachineTableArgs = {
  input: SearchWorkOrderStateMachineTableInput;
};


export type QuerysearchWorkOrderStateMachinesArgs = {
  input: SearchWorkOrderStateMachineInput;
};


export type QuerysearchWorkOrderTableArgs = {
  input: SearchWorkOrderTableInput;
};


export type QuerysearchWorkOrderTaskDefinitionTableArgs = {
  input: SearchWorkOrderTaskDefinitionTableInput;
};


export type QuerysearchWorkOrderTaskDefinitionsArgs = {
  input: SearchWorkOrderTaskDefinitionInput;
};


export type QuerysearchWorkOrderTaskEscalationMessageTableArgs = {
  input: SearchWorkOrderTaskEscalationMessageTableInput;
};


export type QuerysearchWorkOrderTaskEscalationMessagesArgs = {
  input: SearchWorkOrderTaskEscalationMessageInput;
};


export type QuerysearchWorkOrderTaskTableArgs = {
  input: SearchWorkOrderTaskTableInput;
};


export type QuerysearchWorkOrderTasksArgs = {
  input: SearchWorkOrderTaskInput;
};


export type QuerysearchWorkOrdersArgs = {
  input: SearchWorkOrderInput;
};


export type QueryshipmentArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipmentCommercialInvoiceDetailArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipmentCommercialInvoiceDetailsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryshipmentDocumentProcessingRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipmentDocumentProcessingRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryshipmentsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryshipperArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperBrokerRelationshipArgs = {
  brokerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperCustomsAgentRelationshipArgs = {
  customsAgentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperDeConsigneeRelationshipArgs = {
  deConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperDeCustomsBrokerRelationshipArgs = {
  deCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperDeIorRelationshipArgs = {
  deIorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperFacilityRelationshipArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperForwarderRelationshipArgs = {
  forwarderId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperFrConsigneeRelationshipArgs = {
  frConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperFrCustomsBrokerRelationshipArgs = {
  frCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperFrIorRelationshipArgs = {
  frIorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperGbConsigneeRelationshipArgs = {
  gbConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperGbIorRelationshipArgs = {
  gbIorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperGlobalConsigneeRelationshipArgs = {
  globalConsigneeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperImporterRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  importerId?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperNlConsigneeRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  nlConsigneeId?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperNlCustomsBrokerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  nlCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperNlIorRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  nlIorId?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperSupplierRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperSystemArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperSystemsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryshipperTruckerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  truckerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperUkCustomsBrokerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  ukCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperUsConsigneeRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  usConsigneeId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperUsCustomsBrokerRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  usCustomsBrokerId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperUsIorRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  shipperId?: InputMaybe<Scalars['ID']>;
  usIorId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperUserArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryshipperUsersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryshippersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerystampDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerystampDocumentSignRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerystampDocumentSignRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerysubjectMatterExpertTeamArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerysubjectMatterExpertTeamOperatorUserRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']>;
  operatorUserId?: InputMaybe<Scalars['ID']>;
  subjectMatterExpertTeamId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerysubjectMatterExpertTeamsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerysubmitDisTransactionArgs = {
  id: Scalars['ID'];
};


export type QuerysupplierArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerysupplierSpreadsheetPreviewArgs = {
  input: SupplierSpreadsheetPreviewInput;
};


export type QuerysuppliersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerytableFilterArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerytableFiltersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryteamArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryteamsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerytemplateDocumentSignRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerytemplateDocumentSignRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerytradeAdvisoryRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerytradeAdvisoryRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QuerytruckerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QuerytruckersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryukCustomsBrokerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryukCustomsBrokersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryukHsArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryukHssArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryupdateCbp5106TransactionArgs = {
  id: Scalars['ID'];
};


export type QueryupdateCbpEntryStatementTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryupsertCbpMidTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryusCargoReleaseDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusCbp5106DocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusCbp7501DocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusCbp7512DocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusConsigneeArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusConsigneesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusConsumptionEntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusConsumptionEntryArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusCustomsBrokerArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusCustomsBrokersArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusDrawbackClaimArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusDrawbackClaimDocumentGenerationRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusDrawbackClaimsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusHtsArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusHtssArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusInBondArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusInBondsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusIorArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusIorActivationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusIorActivationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusIorContinuousBondRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusIorContinuousBondRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusIorsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusIsfArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusIsfsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusPostSummaryCorrectionArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusPostSummaryCorrectionsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusPrincipalAdCvdCaseArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryusPrincipalAdCvdCasesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusType86EntriesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryusType86EntryArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryuserReleaseNoteViewArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryuserReleaseNoteViewsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryvalidateIdentifierNumberArgs = {
  identifier: Scalars['String'];
  identifierType: IdentifierType;
};


export type QueryvalidateUsCommercialInvoicesArgs = {
  idInput?: InputMaybe<IdInput>;
  input?: InputMaybe<Scalars['JSONObject']>;
  inputWorkOrderType?: InputMaybe<Scalars['String']>;
};


export type QueryvalidateUsConsumptionEntryArgs = {
  idInput?: InputMaybe<IdInput>;
  input: UpdateUsConsumptionEntryInput;
  transactionInput?: InputMaybe<UsConsumptionEntryTransactionInput>;
  transactionType: UsConsumptionEntryConfirmationTransactionType;
};


export type QueryvalidateUsConsumptionEntryReleaseArgs = {
  idInput?: InputMaybe<IdInput>;
  input: UpdateUsConsumptionEntryInput;
};


export type QueryvalidateUsIsfArgs = {
  idInput: IdInput;
  input?: InputMaybe<UpdateUsIsfInput>;
};


export type QueryvalidateUsPostSummaryCorrectionArgs = {
  idInput?: InputMaybe<IdInput>;
  input: UpdateUsPostSummaryCorrectionInput;
  transactionType: UsPostSummaryCorrectionConfirmationTransactionType;
};


export type QueryvalidateUsType86Args = {
  idInput?: InputMaybe<IdInput>;
  input: UpdateUsType86EntryInput;
};


export type QueryvalidateWorkOrderTaskArgs = {
  taskId: Scalars['ID'];
  taskType: Scalars['String'];
  version: Scalars['Int'];
};


export type QueryworkOrderArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderConfirmationArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderConfirmationsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryworkOrderDocumentProcessingRequestArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderDocumentProcessingRequestsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryworkOrderGroupArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderGroupsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryworkOrderMilestoneArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderStateMachineArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderStateMachinesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryworkOrderTaskArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderTaskDefinitionArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderTaskDefinitionsArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryworkOrderTaskEscalationMessageArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryworkOrderTaskEscalationMessagesArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryworkOrderTasksArgs = {
  identifiers: Array<IdOptionalVersionInput>;
};


export type QueryxbtShipperProfileArgs = {
  program?: InputMaybe<XbtProgram>;
  xbtShipperId: Scalars['String'];
};

/** Input parameters to query US CBP AdCvd Case data. User has to either provide criteriaQueryInput OR caseNumbers */
export type QueryAdCvdCaseCbpInput = {
  /** Case numbers in the CBP AD/CVD case number query request. */
  caseNumbers?: InputMaybe<Array<Scalars['QueryCaseNumber']>>;
  /** AD/CVD case criteria query input: need to provide at least one field */
  criteriaQueryInput?: InputMaybe<AdCvdCaseCriteriaQueryInput>;
};

/** The payload returned from triggering the Transaction. */
export type QueryAdCvdCaseCbpPayload = {
  __typename?: 'QueryAdCvdCaseCbpPayload';
  /** The Transaction. */
  transaction: QueryAdCvdCaseCbpTransaction;
};

/** The US CBP ABI transaction for a list of AdCvd Case number and other criterias. */
export type QueryAdCvdCaseCbpTransaction = Record & {
  __typename?: 'QueryAdCvdCaseCbpTransaction';
  /** Case numbers in the CBP AD/CVD case number query request. */
  caseNumbers?: Maybe<Array<Scalars['QueryCaseNumber']>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** AD/CVD case criteria query input: need to provide at least one field */
  criteriaQueryInput?: Maybe<AdCvdCaseCriteriaQuery>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Standalone AMS query input */
export type QueryAmsInput = {
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReferenceInput>;
};

/** The payload returned from triggering the Transaction. */
export type QueryAmsPayload = {
  __typename?: 'QueryAmsPayload';
  /** The Transaction. */
  transaction: QueryAmsTransaction;
};

export type QueryAmsTransaction = Record & {
  __typename?: 'QueryAmsTransaction';
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReference>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Query AMS input for UsConsumptionEntry. */
export type QueryAmsUsConsumptionEntryInput = {
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReferenceInput>;
};

/** The payload returned from triggering the Transaction. */
export type QueryAmsUsConsumptionEntryPayload = {
  __typename?: 'QueryAmsUsConsumptionEntryPayload';
  /** The Transaction. */
  transaction: QueryAmsUsConsumptionEntryTransaction;
};

export type QueryAmsUsConsumptionEntryTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'QueryAmsUsConsumptionEntryTransaction';
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReference>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Query AMS input for UsInBond */
export type QueryAmsUsInBondInput = {
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReferenceInput>;
};

/** The payload returned from triggering the Transaction. */
export type QueryAmsUsInBondPayload = {
  __typename?: 'QueryAmsUsInBondPayload';
  /** The Transaction. */
  transaction: QueryAmsUsInBondTransaction;
};

export type QueryAmsUsInBondTransaction = Record & UsInBondCbpTransaction & {
  __typename?: 'QueryAmsUsInBondTransaction';
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReference>;
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US In-Bond */
  usInBond: UsInBond;
  /** The record's version */
  version: Scalars['Int'];
};

/** Query AMS input for UsIsf */
export type QueryAmsUsIsfInput = {
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReferenceInput>;
};

/** The payload returned from triggering the Transaction. */
export type QueryAmsUsIsfPayload = {
  __typename?: 'QueryAmsUsIsfPayload';
  /** The Transaction. */
  transaction: QueryAmsUsIsfTransaction;
};

export type QueryAmsUsIsfTransaction = Record & UsIsfCbpTransaction & {
  __typename?: 'QueryAmsUsIsfTransaction';
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReference>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US ISF */
  usIsf: UsIsf;
  /** The record's version */
  version: Scalars['Int'];
};

/** Query AMS input for UsType86Entry. */
export type QueryAmsUsType86EntryInput = {
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReferenceInput>;
};

/** The payload returned from triggering the Transaction. */
export type QueryAmsUsType86EntryPayload = {
  __typename?: 'QueryAmsUsType86EntryPayload';
  /** The Transaction. */
  transaction: QueryAmsUsType86EntryTransaction;
};

export type QueryAmsUsType86EntryTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'QueryAmsUsType86EntryTransaction';
  /** List of query code in AMS query that is sent to CBP */
  amsQueryReferences: Array<AmsQueryReference>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type 86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Input parameters to QueryCarrierCodeCbp transaction. */
export type QueryCarrierCodeCbpCreateInput = {
  /** Transaction API to query CBP by Carrier Code. */
  carrierCode: Scalars['SCACCode'];
};

/** The payload returned from triggering the Transaction. */
export type QueryCarrierCodeCbpPayload = {
  __typename?: 'QueryCarrierCodeCbpPayload';
  /** The Transaction. */
  transaction: QueryCarrierCodeCbpTransaction;
};

/** The US CBP ABI transaction for query by Carrier Code. */
export type QueryCarrierCodeCbpTransaction = Record & {
  __typename?: 'QueryCarrierCodeCbpTransaction';
  /** Transaction API to query CBP by Carrier Code. */
  carrierCode: Scalars['SCACCode'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type QueryCbpAdCvdCaseTransaction = QueryAdCvdCaseCbpTransaction;

/** Input parameters to create queryCbpByIorNumber transaction. */
export type QueryCbpByIorNumberCreateInput = {
  /** US IOR number being queried. */
  iorNumber: Scalars['UsIorNumberValue'];
};

/** The payload returned from triggering the Transaction. */
export type QueryCbpByIorNumberPayload = {
  __typename?: 'QueryCbpByIorNumberPayload';
  /** The Transaction. */
  transaction: QueryCbpByIorNumberTransaction;
};

/** The US CBP ABI transaction for query by IOR number. */
export type QueryCbpByIorNumberTransaction = Record & {
  __typename?: 'QueryCbpByIorNumberTransaction';
  /** CBP response for query by IOR number. */
  cbpResponse?: Maybe<UsIorNumberQueryResponse>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** US IOR number being queried. */
  iorNumber: Scalars['UsIorNumberValue'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Input parameters to update queryCbpByIorNumber transaction. */
export type QueryCbpByIorNumberUpdateInput = {
  /** CBP response for query by IOR number. */
  cbpResponse: UsIorNumberQueryResponseInput;
};

export type QueryCbpCarrierCodeTransaction = QueryCarrierCodeCbpTransaction;

export type QueryCbpEntryNumberTransaction = QueryEntryNumberCbpTransaction;

export type QueryCbpEntrySummaryTransaction = QueryUsConsumptionEntrySummaryCbpTransaction | QueryUsPostSummaryCorrectionCbpTransaction;

export type QueryCbpFirmsCodeTransaction = QueryFirmsCodeCbpTransaction;

export type QueryCbpHtsTransaction = QueryHtsCbpTransaction;

export type QueryCbpIorTransaction = QueryCbpByIorNumberTransaction | QueryUsConsigneeCbpTransaction | QueryUsIorCbpTransaction;

export type QueryChannelConnectionStatusInput = {
  /** Minutes of history to look back for connection status. */
  historyMinutes?: InputMaybe<Scalars['Float']>;
  /** Exchange message type. */
  messageType: ExchangeMessageType;
  /** Channel receiver. */
  receiver: MessagingPartner;
  /** Channel sender. */
  sender: MessagingPartner;
};

/** The output payload for query operations on channel connection status. */
export type QueryChannelConnectionStatusPayload = {
  __typename?: 'QueryChannelConnectionStatusPayload';
  /** Current connection status. */
  status: ConnectionStatus;
  /** An array of connection status updates. */
  statusHistory: Array<ConnectionStatusUpdate>;
};

/** Input parameters to QueryEntryNumberCbp transaction. */
export type QueryEntryNumberCbpCreateInput = {
  /** Transaction API to query CBP by Entry Number. */
  entryNumber: Scalars['UsEntryNumber'];
};

/** The payload returned from triggering the Transaction. */
export type QueryEntryNumberCbpPayload = {
  __typename?: 'QueryEntryNumberCbpPayload';
  /** The Transaction. */
  transaction: QueryEntryNumberCbpTransaction;
};

/** The US CBP ABI transaction for query by Entry Number. */
export type QueryEntryNumberCbpTransaction = Record & {
  __typename?: 'QueryEntryNumberCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Transaction API to query CBP by Entry Number. */
  entryNumber: Scalars['UsEntryNumber'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Input parameters to QueryFirmsCodeCbp transaction. */
export type QueryFirmsCodeCbpCreateInput = {
  /** Transaction API to query CBP by FIRMS Code. */
  firmsCode: Scalars['String'];
};

/** The payload returned from triggering the Transaction. */
export type QueryFirmsCodeCbpPayload = {
  __typename?: 'QueryFirmsCodeCbpPayload';
  /** The Transaction. */
  transaction: QueryFirmsCodeCbpTransaction;
};

/** The US CBP ABI transaction for query by FIRMS Code. */
export type QueryFirmsCodeCbpTransaction = Record & {
  __typename?: 'QueryFirmsCodeCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Transaction API to query CBP by FIRMS Code. */
  firmsCode: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Input parameters to query US CBP HTS data. */
export type QueryHtsCbpInput = {
  /** The CBP query is effective as of the date provided. If excluded the query is effective as of the time of the query. */
  asOfDate?: InputMaybe<Scalars['Date']>;
  /** Smaller HTS value in the CBP query range. */
  fromHts: Scalars['HtsNumber'];
  /** The larger HTS value in the CBP query range. If excluded will only query for the fromHts value. */
  toHts?: InputMaybe<Scalars['HtsNumber']>;
};

/** The payload returned from triggering the Transaction. */
export type QueryHtsCbpPayload = {
  __typename?: 'QueryHtsCbpPayload';
  /** The Transaction. */
  transaction: QueryHtsCbpTransaction;
};

/** The US CBP ABI transaction for a range of HTS numbers. */
export type QueryHtsCbpTransaction = Record & {
  __typename?: 'QueryHtsCbpTransaction';
  /** The CBP query is effective as of the date provided. If excluded the query is effective as of the time of the query. */
  asOfDate?: Maybe<Scalars['Date']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Smaller HTS value in the CBP query range. */
  fromHts: Scalars['HtsNumber'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The larger HTS value in the CBP query range. If excluded will only query for the fromHts value. */
  toHts?: Maybe<Scalars['HtsNumber']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type QueryUsConsigneeCbpPayload = {
  __typename?: 'QueryUsConsigneeCbpPayload';
  /** The Transaction. */
  transaction: QueryUsConsigneeCbpTransaction;
};

/** The US CBP ABI transaction for querying the bond profile of a US Consignee. */
export type QueryUsConsigneeCbpTransaction = Record & UsConsigneeCbpTransaction & {
  __typename?: 'QueryUsConsigneeCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consignee */
  usConsignee: UsConsignee;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type QueryUsConsumptionEntrySummaryCbpPayload = {
  __typename?: 'QueryUsConsumptionEntrySummaryCbpPayload';
  /** The Transaction. */
  transaction: QueryUsConsumptionEntrySummaryCbpTransaction;
};

/** The US CBP ABI transaction to query a US Consumption Entry Summary,CATAIR appCode: JC/JD. */
export type QueryUsConsumptionEntrySummaryCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'QueryUsConsumptionEntrySummaryCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** The actions to take after receviing a response from CBP. */
export enum QueryUsIorCbpAction {
  CHARGE_IF_BOND = 'CHARGE_IF_BOND',
  MATCH_ADDRESSES = 'MATCH_ADDRESSES'
}

/** A UsIorContinuousBondRequest ID can be provided to charge a continuous bond */
export type QueryUsIorCbpChargeContinuousBond = {
  __typename?: 'QueryUsIorCbpChargeContinuousBond';
  /** The unique ID of a usIorContinuousBondRequest */
  usIorContinuousBondRequestId: Scalars['ID'];
};

/** A UsIorContinuousBondRequest ID can be provided to charge a continuous bond */
export type QueryUsIorCbpChargeContinuousBondInput = {
  /** The unique ID of a usIorContinuousBondRequest */
  usIorContinuousBondRequestId: Scalars['ID'];
};

/** QueryUsIorCbpChargeContinuousBond can be provided to charge a continuous bond */
export type QueryUsIorCbpCreateInput = {
  /** A UsIorContinuousBondRequest ID can be provided to charge a continuous bond */
  chargeContinuousBond?: InputMaybe<QueryUsIorCbpChargeContinuousBondInput>;
  /** Optional tags to add to the transaction */
  tags?: InputMaybe<Array<TagInput>>;
};

/** The payload returned from triggering the Transaction. */
export type QueryUsIorCbpPayload = {
  __typename?: 'QueryUsIorCbpPayload';
  /** The Transaction. */
  transaction: QueryUsIorCbpTransaction;
};

/** The US CBP ABI transaction for querying the bond profile of a US IOR. */
export type QueryUsIorCbpTransaction = Record & UsIorCbpTransaction & {
  __typename?: 'QueryUsIorCbpTransaction';
  /** The actions to take after receviing a response from CBP. */
  actions?: Maybe<Array<QueryUsIorCbpAction>>;
  /** A UsIorContinuousBondRequest ID can be provided to charge a continuous bond */
  chargeContinuousBond?: Maybe<QueryUsIorCbpChargeContinuousBond>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US IOR */
  usIor: UsIor;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type QueryUsPostSummaryCorrectionCbpPayload = {
  __typename?: 'QueryUsPostSummaryCorrectionCbpPayload';
  /** The Transaction. */
  transaction: QueryUsPostSummaryCorrectionCbpTransaction;
};

/** The US CBP ABI transaction to query a US Consumption Entry Summary,CATAIR appCode: JC/JD. */
export type QueryUsPostSummaryCorrectionCbpTransaction = Record & UsPostSummaryCorrectionCbpTransaction & {
  __typename?: 'QueryUsPostSummaryCorrectionCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usPostSummaryCorrection: UsPostSummaryCorrection;
  /** The record's version */
  version: Scalars['Int'];
};

export type QueryUsType86EntryCbpReleaseTransaction = QueryUsType86EntryReleaseCbpTransaction;

/** The payload returned from triggering the Transaction. */
export type QueryUsType86EntryReleaseCbpPayload = {
  __typename?: 'QueryUsType86EntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: QueryUsType86EntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to query a US Type86 Entry Release, CATAIR appCode: SE/SX. */
export type QueryUsType86EntryReleaseCbpTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'QueryUsType86EntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Answers to the questions on Form FDA-2877 Used by: FDA (Radiation Emitting Products) */
export type RadiationDeclaration = {
  __typename?: 'RadiationDeclaration';
  /** FDA Affirmation of Compliance Code for Form FDA-2877 */
  complianceCode?: Maybe<UsFdaRadiationDeclarationComplianceCode>;
  /** Radiation question 1 on Form FDA-2877 */
  declarationCode?: Maybe<Scalars['String']>;
  /** EPRC Accession Number */
  eprcAccessionNumber?: Maybe<Scalars['String']>;
  /** EPRC Annual Report Accession Number */
  eprcAnnualReportAccessionNumber?: Maybe<Scalars['String']>;
  /** Radiation question 2 on Form FDA-2877 */
  reasonCode?: Maybe<Scalars['String']>;
};

/** FDA Affirmation of Compliance Code for Form FDA-2877 */
export type RadiationDeclarationComplianceCodeInput = {
  /** FDA Affirmation of Compliance Code for Form FDA-2877 */
  type: UsFdaRadiationDeclarationComplianceCodeType;
  /** Value of the AOC */
  value: Scalars['String'];
};

/** Answers to the questions on Form FDA-2877 Used by: FDA (Radiation Emitting Products) */
export type RadiationDeclarationInput = {
  /** FDA Affirmation of Compliance Code for Form FDA-2877 */
  complianceCode?: InputMaybe<RadiationDeclarationComplianceCodeInput>;
  /** Radiation question 1 on Form FDA-2877 */
  declarationCode?: InputMaybe<Scalars['String']>;
  /** EPRC Accession Number */
  eprcAccessionNumber?: InputMaybe<Scalars['String']>;
  /** EPRC Annual Report Accession Number */
  eprcAnnualReportAccessionNumber?: InputMaybe<Scalars['String']>;
  /** Radiation question 2 on Form FDA-2877 */
  reasonCode?: InputMaybe<Scalars['String']>;
};

/** The basic rating enum */
export enum RatingEnum {
  NOT_RATED = 'NOT_RATED',
  THUMBS_DOWN = 'THUMBS_DOWN',
  THUMBS_UP = 'THUMBS_UP'
}

/** The Reason For Export e.g. STOCK_TRANSFER */
export enum ReasonForExport {
  STOCK_TRANSFER = 'STOCK_TRANSFER'
}

export type ReassignWorkOrderTaskPayload = {
  __typename?: 'ReassignWorkOrderTaskPayload';
  /** The result of triggering event for reassignWorkOrderTask */
  result: Scalars['Boolean'];
};

export type RecommendationResult = {
  confidenceScore: Scalars['Float'];
  timestamp: Scalars['DateTime__patched_over_by_INLT'];
};

export type Record = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type RecordAction = {
  __typename?: 'RecordAction';
  /** External client */
  client?: Maybe<ExternalClient>;
  /** Optional reason code and text describing the change */
  reason?: Maybe<RecordActionReason>;
  /** Details on the request causing the change. */
  request?: Maybe<RecordActionRequestInfo>;
  /** The source of a Client's mutation to the CBMS graph. Either an Internal System, like an Authority or Workflow, an Internal Website, like the App or Importsign, or a Client System, like XBTMS. */
  source: RecordActionSource;
  /** Time of action */
  time: Scalars['DateTime'];
};

/** Optional reason code and text describing the change */
export type RecordActionReason = {
  __typename?: 'RecordActionReason';
  /** A code representing the type of action */
  code?: Maybe<Scalars['String']>;
  /** Text associated with the action */
  text?: Maybe<Scalars['String']>;
};

export type RecordActionReasonInput = {
  /** A code representing the type of action */
  code?: InputMaybe<Scalars['String']>;
  /** Text associated with the action */
  text?: InputMaybe<Scalars['String']>;
};

/** Details on the request causing the change. */
export type RecordActionRequestInfo = {
  __typename?: 'RecordActionRequestInfo';
  /** IP address of the client. */
  ipAddress?: Maybe<Scalars['String']>;
  /** Origin of the client. */
  origin?: Maybe<Scalars['String']>;
  /** Request ID of the action. */
  requestId?: Maybe<Scalars['String']>;
  /** User Agent of the client. */
  userAgent?: Maybe<Scalars['String']>;
};

/** The source of a Client's mutation to the CBMS graph. Either an Internal System, like an Authority or Workflow, an Internal Website, like the App or Importsign, or a Client System, like XBTMS. */
export type RecordActionSource = {
  /** A string representing the version of the Client's source system. */
  version?: Maybe<Scalars['String']>;
};

export type RecordSearchTableRow = {
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type RecordToDocuments = {
  /** The list of document ids associated with the record */
  documentIds: Array<Scalars['ID']>;
  /** The record associated with the documents that are being downloaded */
  recordId: Scalars['String'];
};

/** Record Type */
export enum RecordType {
  ADCVD_CASE = 'ADCVD_CASE',
  AD_CVD_CASE = 'AD_CVD_CASE',
  ASSIGNMENT_TEAM = 'ASSIGNMENT_TEAM',
  ASSIGNMENT_TEAM_OPERATOR_USER_RELATIONSHIP = 'ASSIGNMENT_TEAM_OPERATOR_USER_RELATIONSHIP',
  ASSIGNMENT_TEAM_STATIC_MAPPING = 'ASSIGNMENT_TEAM_STATIC_MAPPING',
  AUDIT_LOG = 'AUDIT_LOG',
  AUTHENTICATION_TOKEN = 'AUTHENTICATION_TOKEN',
  BROKER = 'BROKER',
  BULK_CHARGES_UPLOAD_REQUEST = 'BULK_CHARGES_UPLOAD_REQUEST',
  BULK_COMPLIANCE_UPLOAD_REQUEST = 'BULK_COMPLIANCE_UPLOAD_REQUEST',
  BULK_MILESTONE_UPLOAD_REQUEST = 'BULK_MILESTONE_UPLOAD_REQUEST',
  BULK_PRODUCT_UPLOAD_TEMPLATE_DOCUMENT_GENERATION_REQUEST = 'BULK_PRODUCT_UPLOAD_TEMPLATE_DOCUMENT_GENERATION_REQUEST',
  BUSINESS_SUPPORT_TEAM = 'BUSINESS_SUPPORT_TEAM',
  BUSINESS_SUPPORT_TEAM_OPERATOR_USER_RELATIONSHIP = 'BUSINESS_SUPPORT_TEAM_OPERATOR_USER_RELATIONSHIP',
  CASE_CATEGORY_CONFIG = 'CASE_CATEGORY_CONFIG',
  CHANGELOG = 'CHANGELOG',
  CLASSIFICATION = 'CLASSIFICATION',
  COMMODITY_GROUP = 'COMMODITY_GROUP',
  CUSTOMS_AGENT = 'CUSTOMS_AGENT',
  CUSTOMS_DECLARATION = 'CUSTOMS_DECLARATION',
  CUSTOM_DOMAIN = 'CUSTOM_DOMAIN',
  DELIVERY_ORDER = 'DELIVERY_ORDER',
  DELIVERY_ORDER_DOCUMENT_GENERATION_REQUEST = 'DELIVERY_ORDER_DOCUMENT_GENERATION_REQUEST',
  DE_CONSIGNEE = 'DE_CONSIGNEE',
  DE_CUSTOMS_BROKER = 'DE_CUSTOMS_BROKER',
  DE_CUSTOMS_ENTRY = 'DE_CUSTOMS_ENTRY',
  DE_IOR = 'DE_IOR',
  DE_IOR_ACTIVATION = 'DE_IOR_ACTIVATION',
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_TEMPLATE = 'DOCUMENT_TEMPLATE',
  DPS_RECORD = 'DPS_RECORD',
  ERROR_DEFINITION = 'ERROR_DEFINITION',
  EU_HS = 'EU_HS',
  EXCHANGE_MESSAGE = 'EXCHANGE_MESSAGE',
  FACILITY = 'FACILITY',
  FEATURE_FLAG = 'FEATURE_FLAG',
  FORWARDER = 'FORWARDER',
  FORWARDER_SYSTEM = 'FORWARDER_SYSTEM',
  FORWARDER_USER = 'FORWARDER_USER',
  FR_CONSIGNEE = 'FR_CONSIGNEE',
  FR_CUSTOMS_BROKER = 'FR_CUSTOMS_BROKER',
  FR_CUSTOMS_ENTRY = 'FR_CUSTOMS_ENTRY',
  FR_IOR = 'FR_IOR',
  FR_IOR_ACTIVATION = 'FR_IOR_ACTIVATION',
  GB_CONSIGNEE = 'GB_CONSIGNEE',
  GB_CUSTOMS_ENTRY = 'GB_CUSTOMS_ENTRY',
  GB_IOR = 'GB_IOR',
  GB_IOR_ACTIVATION = 'GB_IOR_ACTIVATION',
  GENERIC_DOCUMENT_GENERATION_REQUEST = 'GENERIC_DOCUMENT_GENERATION_REQUEST',
  GLOBAL_CONSIGNEE = 'GLOBAL_CONSIGNEE',
  HTS = 'HTS',
  IMPORTER = 'IMPORTER',
  IMPORTER_ENTITY = 'IMPORTER_ENTITY',
  IMPORTER_ENTITY_ACTIVATION = 'IMPORTER_ENTITY_ACTIVATION',
  IMPORTER_IMPORTER_ENTITY_RELATIONSHIP = 'IMPORTER_IMPORTER_ENTITY_RELATIONSHIP',
  IMPORT_PRODUCTS_FROM_BULK_UPLOAD_REQUEST = 'IMPORT_PRODUCTS_FROM_BULK_UPLOAD_REQUEST',
  IMPORT_PRODUCTS_FROM_CUSTOMS_ENTRIES_REQUEST = 'IMPORT_PRODUCTS_FROM_CUSTOMS_ENTRIES_REQUEST',
  INVOICE = 'INVOICE',
  INVOICE_CREDIT_NOTE = 'INVOICE_CREDIT_NOTE',
  INVOICE_CREDIT_NOTE_DOCUMENT_GENERATION_REQUEST = 'INVOICE_CREDIT_NOTE_DOCUMENT_GENERATION_REQUEST',
  INVOICE_DOCUMENT_GENERATION_REQUEST = 'INVOICE_DOCUMENT_GENERATION_REQUEST',
  INVOICE_LINES_REQUEST = 'INVOICE_LINES_REQUEST',
  INVOICE_PAYMENT = 'INVOICE_PAYMENT',
  IN_BOND_NOTES_DOCUMENT_GENERATION_REQUEST = 'IN_BOND_NOTES_DOCUMENT_GENERATION_REQUEST',
  MEMO = 'MEMO',
  NL_CONSIGNEE = 'NL_CONSIGNEE',
  NL_CUSTOMS_BROKER = 'NL_CUSTOMS_BROKER',
  NL_CUSTOMS_ENTRY = 'NL_CUSTOMS_ENTRY',
  NL_IOR = 'NL_IOR',
  NL_IOR_ACTIVATION = 'NL_IOR_ACTIVATION',
  ONBOARDING_REQUEST = 'ONBOARDING_REQUEST',
  OPERATOR = 'OPERATOR',
  OPERATOR_SYSTEM = 'OPERATOR_SYSTEM',
  OPERATOR_USER = 'OPERATOR_USER',
  PAYABLE_INVOICE = 'PAYABLE_INVOICE',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  PRODUCT = 'PRODUCT',
  PROGRAM = 'PROGRAM',
  RELEASE_NOTE = 'RELEASE_NOTE',
  REPORT_RECONCILIATION_REQUEST = 'REPORT_RECONCILIATION_REQUEST',
  SHIPMENT = 'SHIPMENT',
  SHIPMENT_COMMERCIAL_INVOICE_DETAIL = 'SHIPMENT_COMMERCIAL_INVOICE_DETAIL',
  SHIPMENT_DOCUMENT_PROCESSING_REQUEST = 'SHIPMENT_DOCUMENT_PROCESSING_REQUEST',
  SHIPPER = 'SHIPPER',
  SHIPPER_BROKER_RELATIONSHIP = 'SHIPPER_BROKER_RELATIONSHIP',
  SHIPPER_CUSTOMS_AGENT_RELATIONSHIP = 'SHIPPER_CUSTOMS_AGENT_RELATIONSHIP',
  SHIPPER_DE_CONSIGNEE_RELATIONSHIP = 'SHIPPER_DE_CONSIGNEE_RELATIONSHIP',
  SHIPPER_DE_CUSTOMS_BROKER_RELATIONSHIP = 'SHIPPER_DE_CUSTOMS_BROKER_RELATIONSHIP',
  SHIPPER_DE_IOR_RELATIONSHIP = 'SHIPPER_DE_IOR_RELATIONSHIP',
  SHIPPER_FACILITY_RELATIONSHIP = 'SHIPPER_FACILITY_RELATIONSHIP',
  SHIPPER_FORWARDER_RELATIONSHIP = 'SHIPPER_FORWARDER_RELATIONSHIP',
  SHIPPER_FR_CONSIGNEE_RELATIONSHIP = 'SHIPPER_FR_CONSIGNEE_RELATIONSHIP',
  SHIPPER_FR_CUSTOMS_BROKER_RELATIONSHIP = 'SHIPPER_FR_CUSTOMS_BROKER_RELATIONSHIP',
  SHIPPER_FR_IOR_RELATIONSHIP = 'SHIPPER_FR_IOR_RELATIONSHIP',
  SHIPPER_GB_CONSIGNEE_RELATIONSHIP = 'SHIPPER_GB_CONSIGNEE_RELATIONSHIP',
  SHIPPER_GB_IOR_RELATIONSHIP = 'SHIPPER_GB_IOR_RELATIONSHIP',
  SHIPPER_GLOBAL_CONSIGNEE_RELATIONSHIP = 'SHIPPER_GLOBAL_CONSIGNEE_RELATIONSHIP',
  SHIPPER_IMPORTER_RELATIONSHIP = 'SHIPPER_IMPORTER_RELATIONSHIP',
  SHIPPER_NL_CONSIGNEE_RELATIONSHIP = 'SHIPPER_NL_CONSIGNEE_RELATIONSHIP',
  SHIPPER_NL_CUSTOMS_BROKER_RELATIONSHIP = 'SHIPPER_NL_CUSTOMS_BROKER_RELATIONSHIP',
  SHIPPER_NL_IOR_RELATIONSHIP = 'SHIPPER_NL_IOR_RELATIONSHIP',
  SHIPPER_SUPPLIER_RELATIONSHIP = 'SHIPPER_SUPPLIER_RELATIONSHIP',
  SHIPPER_SYSTEM = 'SHIPPER_SYSTEM',
  SHIPPER_TRUCKER_RELATIONSHIP = 'SHIPPER_TRUCKER_RELATIONSHIP',
  SHIPPER_UK_CUSTOMS_BROKER_RELATIONSHIP = 'SHIPPER_UK_CUSTOMS_BROKER_RELATIONSHIP',
  SHIPPER_USER = 'SHIPPER_USER',
  SHIPPER_US_CONSIGNEE_RELATIONSHIP = 'SHIPPER_US_CONSIGNEE_RELATIONSHIP',
  SHIPPER_US_CUSTOMS_BROKER_RELATIONSHIP = 'SHIPPER_US_CUSTOMS_BROKER_RELATIONSHIP',
  SHIPPER_US_IOR_RELATIONSHIP = 'SHIPPER_US_IOR_RELATIONSHIP',
  STAMP_DOCUMENT_GENERATION_REQUEST = 'STAMP_DOCUMENT_GENERATION_REQUEST',
  STAMP_DOCUMENT_SIGN_REQUEST = 'STAMP_DOCUMENT_SIGN_REQUEST',
  SUBJECT_MATTER_EXPERT_TEAM = 'SUBJECT_MATTER_EXPERT_TEAM',
  SUBJECT_MATTER_EXPERT_TEAM_OPERATOR_USER_RELATIONSHIP = 'SUBJECT_MATTER_EXPERT_TEAM_OPERATOR_USER_RELATIONSHIP',
  SUPPLIER = 'SUPPLIER',
  TABLE_FILTER = 'TABLE_FILTER',
  TEAM = 'TEAM',
  TEMPLATE_DOCUMENT_SIGN_REQUEST = 'TEMPLATE_DOCUMENT_SIGN_REQUEST',
  TRUCKER = 'TRUCKER',
  UK_CUSTOMS_BROKER = 'UK_CUSTOMS_BROKER',
  UK_HS = 'UK_HS',
  USER_RELEASE_NOTE_VIEW = 'USER_RELEASE_NOTE_VIEW',
  US_CARGO_RELEASE_DOCUMENT_GENERATION_REQUEST = 'US_CARGO_RELEASE_DOCUMENT_GENERATION_REQUEST',
  US_CBP_5106_DOCUMENT_GENERATION_REQUEST = 'US_CBP_5106_DOCUMENT_GENERATION_REQUEST',
  US_CBP_7501_DOCUMENT_GENERATION_REQUEST = 'US_CBP_7501_DOCUMENT_GENERATION_REQUEST',
  US_CBP_7512_DOCUMENT_GENERATION_REQUEST = 'US_CBP_7512_DOCUMENT_GENERATION_REQUEST',
  US_CONSIGNEE = 'US_CONSIGNEE',
  US_CONSUMPTION_ENTRY = 'US_CONSUMPTION_ENTRY',
  US_CUSTOMS_BROKER = 'US_CUSTOMS_BROKER',
  US_DRAWBACK_CLAIM = 'US_DRAWBACK_CLAIM',
  US_HTS = 'US_HTS',
  US_IN_BOND = 'US_IN_BOND',
  US_IOR = 'US_IOR',
  US_IOR_ACTIVATION = 'US_IOR_ACTIVATION',
  US_IOR_CONTINUOUS_BOND_REQUEST = 'US_IOR_CONTINUOUS_BOND_REQUEST',
  US_ISF = 'US_ISF',
  US_POST_SUMMARY_CORRECTION = 'US_POST_SUMMARY_CORRECTION',
  US_PRINCIPAL_AD_CVD_CASE = 'US_PRINCIPAL_AD_CVD_CASE',
  US_TYPE86_ENTRY = 'US_TYPE86_ENTRY',
  WORK_ORDER_CONFIRMATION = 'WORK_ORDER_CONFIRMATION',
  WORK_ORDER_DOCUMENT_PROCESSING_REQUEST = 'WORK_ORDER_DOCUMENT_PROCESSING_REQUEST',
  WORK_ORDER_GROUP = 'WORK_ORDER_GROUP',
  WORK_ORDER_MILESTONE = 'WORK_ORDER_MILESTONE',
  WORK_ORDER_STATE_MACHINE = 'WORK_ORDER_STATE_MACHINE',
  WORK_ORDER_TASK = 'WORK_ORDER_TASK',
  WORK_ORDER_TASK_DEFINITION = 'WORK_ORDER_TASK_DEFINITION',
  WORK_ORDER_TASK_ESCALATION_MESSAGE = 'WORK_ORDER_TASK_ESCALATION_MESSAGE'
}

/** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
export type Reference = {
  __typename?: 'Reference';
  /** The error code of processing failure for the reference */
  errorCode?: Maybe<EntryReferenceErrorCode>;
  /** The processing status of the reference number */
  processingStatus?: Maybe<EntryReferenceProcessingStatus>;
  /** The type of reference */
  type?: Maybe<ReferenceType>;
  /** The reference value */
  value: Scalars['String'];
};

/** The error code of processing failure for the reference */
export type ReferenceErrorCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<EntryReferenceErrorCode>>;
};

export type ReferenceInput = {
  /** The error code of processing failure for the reference */
  errorCode?: InputMaybe<EntryReferenceErrorCode>;
  /** The processing status of the reference number */
  processingStatus?: InputMaybe<EntryReferenceProcessingStatus>;
  /** The type of reference */
  type?: InputMaybe<ReferenceType>;
  /** The reference value */
  value: Scalars['String'];
};

/** A number used to refer to a shipment, customs declartion, or other work order. */
export type ReferenceNumber = {
  __typename?: 'ReferenceNumber';
  /** Reference number type. */
  type: ReferenceNumberType;
  /** Reference nubmer value. */
  value: Scalars['String'];
};

/** A number used to refer to a shipment, customs declartion, or other work order. */
export type ReferenceNumberInput = {
  /** Reference number type. */
  type: ReferenceNumberType;
  /** Reference nubmer value. */
  value: Scalars['String'];
};

/** The type of reference number */
export enum ReferenceNumberType {
  AIR_WAYBILL_NUMBER = 'AIR_WAYBILL_NUMBER',
  BILL_OF_LADING_NUMBER = 'BILL_OF_LADING_NUMBER',
  BOOKING_ID = 'BOOKING_ID',
  BUSINESS_UNIT_ID = 'BUSINESS_UNIT_ID',
  CLIENT_ID = 'CLIENT_ID',
  CONTAINER_NUMBER = 'CONTAINER_NUMBER',
  DAILY_STATEMENT_NUMBER = 'DAILY_STATEMENT_NUMBER',
  HOUSE_AIR_WAYBILL_NUMBER = 'HOUSE_AIR_WAYBILL_NUMBER',
  HOUSE_BILL_OF_LADING_NUMBER = 'HOUSE_BILL_OF_LADING_NUMBER',
  MASTER_AIR_WAYBILL_NUMBER = 'MASTER_AIR_WAYBILL_NUMBER',
  MASTER_BILL_OF_LADING_NUMBER = 'MASTER_BILL_OF_LADING_NUMBER',
  PO_NUMBER = 'PO_NUMBER',
  REFERENCE_NUMBER = 'REFERENCE_NUMBER',
  SHIPMENT_ID = 'SHIPMENT_ID',
  US_CBP_ENTRY_NUMBER = 'US_CBP_ENTRY_NUMBER',
  US_CBP_IN_BOND_NUMBER = 'US_CBP_IN_BOND_NUMBER',
  US_CBP_ISF_NUMBER = 'US_CBP_ISF_NUMBER',
  US_CONSUMPTION_ENTRY_ID = 'US_CONSUMPTION_ENTRY_ID'
}

/** The processing status of the reference number */
export type ReferenceProcessingStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<EntryReferenceProcessingStatus>>;
};

/** The type of reference */
export enum ReferenceType {
  IMPORT_ENTRY_NUMBER = 'IMPORT_ENTRY_NUMBER'
}

/** The type of reference */
export type ReferenceTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ReferenceType>>;
};

/** The primary entity used to represent a Reimbursement. */
export type Reimbursement = Record & {
  __typename?: 'Reimbursement';
  /** The line item charge amount */
  amount: Scalars['Float'];
  /** The client reference number */
  clientNumber?: Maybe<Scalars['String']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Invoice Id */
  invoiceId: Scalars['ID'];
  /** Line item id associate with this reimbursement */
  lineId: Scalars['Float'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** QBO number */
  qboNumber?: Maybe<Scalars['ID']>;
  /** The reimburse amount */
  reimbursementAmount: Scalars['Float'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The type of reimbursement */
  type: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The work order group id associated with the reimbursement */
  workOrderGroupId?: Maybe<Scalars['ID']>;
};

export type ReimbursementLineInput = {
  /** Invoice Id */
  invoiceId: Scalars['ID'];
  /** Line item id associate with this reimbursement */
  lineId: Scalars['Float'];
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** The reimburse amount */
  reimbursementAmount: Scalars['Float'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** The output payload for mutation operations encapsulating an Reimbursement.  */
export type ReimbursementPayload = {
  __typename?: 'ReimbursementPayload';
  /** The latest reimbursement after mutation */
  reimbursements: Array<Reimbursement>;
};

export type ReleaseNote = Record & {
  __typename?: 'ReleaseNote';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The description of the release note, supports markdown and hyperlinks. */
  description: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The countries for which the release note should be shown */
  targetCountries: Array<Scalars['String']>;
  /** Number of thumbs down reactions. */
  thumbsDown: Scalars['Int'];
  /** Number of thumbs up reactions. */
  thumbsUp: Scalars['Int'];
  /** The title of the release note. */
  title: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ReleaseNoteEdge = ConnectionEdge & {
  __typename?: 'ReleaseNoteEdge';
  cursor: Scalars['ID'];
  node: ReleaseNote;
};

export type ReleaseNoteSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Release Note's description. */
  description?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The target countries for the Release Note. */
  targetCountries?: InputMaybe<Array<Scalars['String']>>;
  /** The Release Note's title. */
  title?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** The Release Note's table search row. */
export type ReleaseNoteSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ReleaseNoteSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The description of the releaseNote */
  description: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Array of country codes for the release note. */
  targetCountries: Array<Scalars['String']>;
  /** The title of the release note. */
  title: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ReleaseNotesConnection = Connection & {
  __typename?: 'ReleaseNotesConnection';
  edges: Array<ReleaseNoteEdge>;
  nodes: Array<ReleaseNote>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The payload returned from triggering the Transaction. */
export type ReplaceUsConsumptionEntryReleaseCbpPayload = {
  __typename?: 'ReplaceUsConsumptionEntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: ReplaceUsConsumptionEntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to replace a US Consumption Entry Release, CATAIR appCode: SE/SX. */
export type ReplaceUsConsumptionEntryReleaseCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'ReplaceUsConsumptionEntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type ReplaceUsType86EntryReleaseCbpPayload = {
  __typename?: 'ReplaceUsType86EntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: ReplaceUsType86EntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to replace a US Type86 Entry Release, CATAIR appCode: SE/SX. */
export type ReplaceUsType86EntryReleaseCbpTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'ReplaceUsType86EntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

export type ReportReconciliation = {
  __typename?: 'ReportReconciliation';
  /** The document associated with the report  */
  document: Document;
  /** The exception during report reconciliation */
  processingExceptions?: Maybe<Array<ReportReconciliationProcessingException>>;
  /** The exception during report processing */
  reconciliationExceptions?: Maybe<Array<ReportReconciliationException>>;
  /** The statistics values of report */
  statistics?: Maybe<Array<ReportReconciliationStatistics>>;
  /** The status of the report */
  status: ReportReconciliationStatus;
  /** The type of the report */
  type: ReportReconciliationType;
};

export type ReportReconciliationException = {
  __typename?: 'ReportReconciliationException';
  /** The comments of the exception that can be modified by operator */
  comments?: Maybe<Scalars['String']>;
  /** The description of the exception */
  description: Scalars['String'];
  /** The exception reference of report reconciliation */
  references?: Maybe<Array<ReportReconciliationExceptionReference>>;
  /** The row number of exception occured in report */
  rowNumber?: Maybe<Scalars['Float']>;
  /** The severity of the exception */
  severity?: Maybe<Scalars['Int']>;
  /** reconciliation exception status for the line */
  status?: Maybe<ReportReconciliationExceptionStatus>;
  /** reconciliation exception type for the line */
  type: ReportReconciliationExceptionType;
};

export type ReportReconciliationExceptionInput = {
  /** The comments of the exception that can be modified by operator */
  comments?: InputMaybe<Scalars['String']>;
  /** The description of the exception */
  description: Scalars['String'];
  /** The exception reference of report reconciliation */
  references?: InputMaybe<Array<ExceptionReferenceInput>>;
  /** The row number of exception occured in report */
  rowNumber?: InputMaybe<Scalars['Float']>;
  /** The severity of the exception */
  severity?: InputMaybe<Scalars['Int']>;
  /** reconciliation exception status for the line */
  status?: InputMaybe<ReportReconciliationExceptionStatus>;
  /** reconciliation exception type for the line */
  type: ReportReconciliationExceptionType;
};

export type ReportReconciliationExceptionReference = {
  __typename?: 'ReportReconciliationExceptionReference';
  /** The qualifer of the reconciliation exception reference type */
  qualifer?: Maybe<ReportReconciliationExceptionReferenceQualifer>;
  /** The reference id of reconciliation exception reference */
  refId?: Maybe<Scalars['ID']>;
  /** The reconciliation exception reference type for the report row */
  type: ReportReconciliationExceptionReferenceType;
  /** The value of the reconciliation exception reference */
  value?: Maybe<Scalars['String']>;
};

/** Report Reconciliatioin Exception reference Qualifer */
export enum ReportReconciliationExceptionReferenceQualifer {
  AUTHORIZATION_DATE = 'AUTHORIZATION_DATE',
  ENTRY_DUTY_AMOUNT = 'ENTRY_DUTY_AMOUNT',
  FINAL_DAILY_STATEMENT_DATE = 'FINAL_DAILY_STATEMENT_DATE',
  FINAL_PERIODIC_STATEMENT_DATE = 'FINAL_PERIODIC_STATEMENT_DATE',
  INVOICE_AMOUNT = 'INVOICE_AMOUNT',
  PRINT_DATE = 'PRINT_DATE',
  RELEASE_DATE = 'RELEASE_DATE',
  STATEMENT_DUTY_AMOUNT = 'STATEMENT_DUTY_AMOUNT'
}

/** Report Reconciliatioin Exception reference Type */
export enum ReportReconciliationExceptionReferenceType {
  CBMS_VALUE = 'CBMS_VALUE',
  DAILY_STATEMENT_NUMBER = 'DAILY_STATEMENT_NUMBER',
  ENTRY_NUMBER = 'ENTRY_NUMBER',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  PERIODIC_STATEMENT_NUMBER = 'PERIODIC_STATEMENT_NUMBER',
  REPORT_VALUE = 'REPORT_VALUE',
  US_CONSUMPTION_ENTRY_ID = 'US_CONSUMPTION_ENTRY_ID'
}

/** Report Reconciliation Exception Status */
export enum ReportReconciliationExceptionStatus {
  RESOLVED = 'RESOLVED',
  UNRESOLVED = 'UNRESOLVED'
}

/** Report Reconciliation Exception Type */
export enum ReportReconciliationExceptionType {
  AUTHORIZATION_DATE_PRINT_DATE_MISMTACH = 'AUTHORIZATION_DATE_PRINT_DATE_MISMTACH',
  AUTHORIZATION_TIME_FINAL_DAILY_STATEMENT_TIME_MISMATCH = 'AUTHORIZATION_TIME_FINAL_DAILY_STATEMENT_TIME_MISMATCH',
  AUTHORIZED_DATE_MISMATCH = 'AUTHORIZED_DATE_MISMATCH',
  DEBIT_INVOICE_MISMATCH = 'DEBIT_INVOICE_MISMATCH',
  ENTRY_INVOICE_DUTY_MISMATCH = 'ENTRY_INVOICE_DUTY_MISMATCH',
  ENTRY_MISSING_INVOICE = 'ENTRY_MISSING_INVOICE',
  FINAL_DAILY_STATEMENT_DATE_MISMATCH = 'FINAL_DAILY_STATEMENT_DATE_MISMATCH',
  FINAL_PERIODIC_MONTHLY_STATEMENT_DATE_MISMATCH = 'FINAL_PERIODIC_MONTHLY_STATEMENT_DATE_MISMATCH',
  PRINT_DATE_INCORRECT = 'PRINT_DATE_INCORRECT',
  RELEASE_DATE_FINAL_PERIODIC_MONTHLY_STATEMENT_DATE_MISMATCH = 'RELEASE_DATE_FINAL_PERIODIC_MONTHLY_STATEMENT_DATE_MISMATCH',
  RELEASE_DATE_MISMATCH = 'RELEASE_DATE_MISMATCH',
  STATEMENT_NOT_FOUND = 'STATEMENT_NOT_FOUND',
  STATEMENT_NUMBER_NOT_FOUND = 'STATEMENT_NUMBER_NOT_FOUND',
  TOTAL_DEBIT_STATEMENT_MISMATCH = 'TOTAL_DEBIT_STATEMENT_MISMATCH'
}

export type ReportReconciliationInput = {
  /** The document associated with the report  */
  document: IdInput;
  /** The exception during report reconciliation */
  processingExceptions?: InputMaybe<Array<ReportReconciliationProcessingExceptionInput>>;
  /** The exception during report processing */
  reconciliationExceptions?: InputMaybe<Array<ReportReconciliationExceptionInput>>;
  /** The statistics values of report */
  statistics?: InputMaybe<Array<ReportReconciliationStatisticsInput>>;
  /** The status of the report */
  status?: InputMaybe<ReportReconciliationStatus>;
  /** The type of the report */
  type: ReportReconciliationType;
};

export type ReportReconciliationProcessingException = {
  __typename?: 'ReportReconciliationProcessingException';
  /** The description of the exception */
  description: Scalars['String'];
  /** Processing exception type for the report */
  type: ReportReconciliationProcessingExceptionType;
};

export type ReportReconciliationProcessingExceptionInput = {
  /** The description of the exception */
  description: Scalars['String'];
  /** Processing exception type for the report */
  type: ReportReconciliationProcessingExceptionType;
};

/** Report Reconciliation Processing Exception Type */
export enum ReportReconciliationProcessingExceptionType {
  FILE_FORMAT_NOT_SUPPORTED = 'FILE_FORMAT_NOT_SUPPORTED',
  MISSING_COLUMN = 'MISSING_COLUMN'
}

/** The primary entity used to represent a report reconciliation result. */
export type ReportReconciliationRequest = Record & {
  __typename?: 'ReportReconciliationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The records of report reconciliation */
  reports: Array<ReportReconciliation>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ReportReconciliationRequestSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The status of the report */
  status?: InputMaybe<ReportReconciliationStatus>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The type of the report */
  type?: InputMaybe<ReportReconciliationType>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Report Reconciliation search table row */
export type ReportReconciliationRequestSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ReportReconciliationRequestSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The name of the report */
  fileName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The number of exceptions in report */
  numberOfExceptions?: Maybe<Array<Scalars['Int']>>;
  /** The number of rows in report */
  numberOfRows?: Maybe<Array<Scalars['Int']>>;
  /** The current status of the report */
  status: Array<Scalars['String']>;
  /** The type of the report */
  type: Array<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ReportReconciliationStatistics = {
  __typename?: 'ReportReconciliationStatistics';
  /** report statisics type */
  type: ReportReconciliationStatisticsType;
  /** The statisitcs value of report */
  value: Scalars['String'];
};

export type ReportReconciliationStatisticsInput = {
  /** report statisics type */
  type: ReportReconciliationStatisticsType;
  /** The statisitcs value of report */
  value: Scalars['String'];
};

/** Report Reconciliation Statisics Type */
export enum ReportReconciliationStatisticsType {
  NUMBER_OF_CBMS_ENTRIES = 'NUMBER_OF_CBMS_ENTRIES',
  NUMBER_OF_INLT_ENTRIES = 'NUMBER_OF_INLT_ENTRIES',
  TOTAL_ROWS = 'TOTAL_ROWS'
}

/** Report Reconciliation Status */
export enum ReportReconciliationStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED'
}

/** Report Reconciliation Type */
export enum ReportReconciliationType {
  US_REV_103_REPORT = 'US_REV_103_REPORT',
  US_WELLS_FARGO_REPORT = 'US_WELLS_FARGO_REPORT'
}

/** Input parameters to request a CBP assigned number. */
export type RequestUsIorCbpAssignedNumberInput = {
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons: Array<UsIorCbpAssignedNumberReason>;
};

/** The payload returned from triggering the Transaction. */
export type RequestUsIorCbpAssignedNumberPayload = {
  __typename?: 'RequestUsIorCbpAssignedNumberPayload';
  /** The Transaction. */
  transaction: RequestUsIorCbpAssignedNumberTransaction;
};

/** The US CBP ABI transaction for requesting a CBP Assigned number for a US IOR */
export type RequestUsIorCbpAssignedNumberTransaction = Record & UsIorCbpTransaction & {
  __typename?: 'RequestUsIorCbpAssignedNumberTransaction';
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons: Array<UsIorCbpAssignedNumberReason>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US IOR */
  usIor: UsIor;
  /** The record's version */
  version: Scalars['Int'];
};

/** The type of designation for a data element */
export enum RequiredDesignation {
  CONDITIONAL = 'CONDITIONAL',
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL'
}

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** The email password was reset for */
  email: Scalars['String'];
};

/** Reason for task resolution. */
export enum ResolutionReasonCode {
  ESCALATE_TO_PROPER_POC = 'ESCALATE_TO_PROPER_POC',
  OTHER = 'OTHER',
  SOP_RESOURCE_PROVIDED = 'SOP_RESOURCE_PROVIDED',
  SOP_UPDATE_REQUESTED = 'SOP_UPDATE_REQUESTED',
  TEMPORARY_SYSTEM_ISSUE = 'TEMPORARY_SYSTEM_ISSUE'
}

export type ResolveWorkOrderTaskEscalationPayload = {
  __typename?: 'ResolveWorkOrderTaskEscalationPayload';
  /** The updated Work Order Task with the resolved escalation. */
  workOrderTask: WorkOrderTask;
};

export type ResponsibleGovernmentAgency = {
  __typename?: 'ResponsibleGovernmentAgency';
  /** Identification of the government agency, responsible for regulatory and statutory obligations. */
  identification?: Maybe<Scalars['String']>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry?: Maybe<Scalars['String']>;
  /** Code specifying the role of a party. */
  role?: Maybe<Scalars['String']>;
};

export type ResponsibleGovernmentAgencyInput = {
  /** Identification of the government agency, responsible for regulatory and statutory obligations. */
  identification?: InputMaybe<Scalars['String']>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry?: InputMaybe<Scalars['String']>;
  /** Code specifying the role of a party. */
  role?: InputMaybe<Scalars['String']>;
};

export type ReviewCustomsEntryInput = {
  /** The documents attached to the email */
  attachDocuments?: InputMaybe<Array<IdInput>>;
  /** The documents that need more information noted in this inquiry */
  clarifyDocuments?: InputMaybe<Array<IdInput>>;
  /** The description for this inquiry */
  description?: InputMaybe<Scalars['String']>;
  /** The ProductLevelInquiries for this inquiry */
  productLevelInquiries?: InputMaybe<Array<ProductLevelInquiryInput>>;
  /** The WorkOrderInquiryReasonCodes for this inquiry */
  reasonCodes?: InputMaybe<Array<WorkOrderInquiryReasonCode>>;
  /** The requested documents (documents currently missing) noted in this inquiry */
  requestDocuments?: InputMaybe<Array<DocumentTag>>;
  /** The review status for the Customs Entry */
  result: CustomsEntryReviewStatus;
  /** The task that is blocked by this inquiry. If a task is not provided the most recent in progress task (if there is one in progress) will be marked blocked by this inquiry */
  task?: InputMaybe<IdInput>;
};

export type ReviewCustomsEntryPayload = {
  __typename?: 'ReviewCustomsEntryPayload';
  /** The reviewed Customs Entry. */
  record: CustomsEntry;
};

/** InvoiceLinesRequest review status */
export enum ReviewStatus {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PENDING_REVIEW = 'PENDING_REVIEW'
}

export type ReviewWorkOrderConfirmationPayload = {
  __typename?: 'ReviewWorkOrderConfirmationPayload';
  /** The reviewed work order confirmation. */
  workOrderConfirmation: WorkOrderConfirmation;
};

/** Case role assignment patterns */
export enum RoleAssignmentPattern {
  OPERATOR_USER_WORKLOAD = 'OPERATOR_USER_WORKLOAD',
  SHIPPER_OPERATOR_USER_STATIC_MAPPING = 'SHIPPER_OPERATOR_USER_STATIC_MAPPING',
  WORK_ORDER_TASK_ASSIGNEE = 'WORK_ORDER_TASK_ASSIGNEE'
}

export type SaveBackConfiguration = {
  __typename?: 'SaveBackConfiguration';
  enabled: Scalars['Boolean'];
};

export type SaveBackConfigurationInput = {
  enabled: Scalars['Boolean'];
};

export type ScacSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['SCACCode']>>;
};

export type Seal = {
  __typename?: 'Seal';
  /** Identification of a seal affixed to a piece of transport equipment by number. */
  identification?: Maybe<Scalars['String']>;
  /** Code specifying the type of seal applied on a unit of transport equipment. */
  type?: Maybe<Scalars['String']>;
};

export type SealInput = {
  /** Identification of a seal affixed to a piece of transport equipment by number. */
  identification?: InputMaybe<Scalars['String']>;
  /** Code specifying the type of seal applied on a unit of transport equipment. */
  type?: InputMaybe<Scalars['String']>;
};

export type SearchAdCvdCaseInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AdCvdCaseSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAdCvdCasePayload = {
  __typename?: 'SearchAdCvdCasePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<AdCvdCase>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchAdCvdCaseTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AdCvdCaseSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAdCvdCaseTablePayload = {
  __typename?: 'SearchAdCvdCaseTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<AdCvdCaseSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchAllImportersByNamePayload = {
  __typename?: 'SearchAllImportersByNamePayload';
  importers: Array<ImporterNameAndId>;
};

export type SearchAssignmentTeamInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AssignmentTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAssignmentTeamPayload = {
  __typename?: 'SearchAssignmentTeamPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<AssignmentTeam>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchAssignmentTeamStaticMappingInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AssignmentTeamStaticMappingSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAssignmentTeamStaticMappingPayload = {
  __typename?: 'SearchAssignmentTeamStaticMappingPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<AssignmentTeamStaticMapping>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchAssignmentTeamStaticMappingTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AssignmentTeamStaticMappingSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAssignmentTeamStaticMappingTablePayload = {
  __typename?: 'SearchAssignmentTeamStaticMappingTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<AssignmentTeamStaticMappingSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchAssignmentTeamTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AssignmentTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAssignmentTeamTablePayload = {
  __typename?: 'SearchAssignmentTeamTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<AssignmentTeamSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchAuditLogInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<AuditLogSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchAuditLogPayload = {
  __typename?: 'SearchAuditLogPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<AuditLog>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBrokerPayload = {
  __typename?: 'SearchBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Broker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBrokerTablePayload = {
  __typename?: 'SearchBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<BrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchBulkChargesUploadRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BulkChargesUploadRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBulkChargesUploadRequestPayload = {
  __typename?: 'SearchBulkChargesUploadRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<BulkChargesUploadRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchBulkChargesUploadRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BulkChargesUploadRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBulkChargesUploadRequestTablePayload = {
  __typename?: 'SearchBulkChargesUploadRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<BulkChargesUploadRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchBulkComplianceUploadRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BulkComplianceUploadRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBulkComplianceUploadRequestPayload = {
  __typename?: 'SearchBulkComplianceUploadRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<BulkComplianceUploadRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchBulkComplianceUploadRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BulkComplianceUploadRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBulkComplianceUploadRequestTablePayload = {
  __typename?: 'SearchBulkComplianceUploadRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<BulkComplianceUploadRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchBulkMilestoneUploadRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BulkMilestoneUploadRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBulkMilestoneUploadRequestPayload = {
  __typename?: 'SearchBulkMilestoneUploadRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<BulkMilestoneUploadRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchBulkMilestoneUploadRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BulkMilestoneUploadRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBulkMilestoneUploadRequestTablePayload = {
  __typename?: 'SearchBulkMilestoneUploadRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<BulkMilestoneUploadRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchBusinessSupportTeamInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BusinessSupportTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBusinessSupportTeamPayload = {
  __typename?: 'SearchBusinessSupportTeamPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<BusinessSupportTeam>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchBusinessSupportTeamTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<BusinessSupportTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchBusinessSupportTeamTablePayload = {
  __typename?: 'SearchBusinessSupportTeamTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<BusinessSupportTeamSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchCaseCategoryConfigInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CaseCategoryConfigSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCaseCategoryConfigPayload = {
  __typename?: 'SearchCaseCategoryConfigPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CaseCategoryConfig>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchChangelogInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ChangelogSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchChangelogPayload = {
  __typename?: 'SearchChangelogPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Changelog>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCommodityGroupInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CommodityGroupSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCommodityGroupPayload = {
  __typename?: 'SearchCommodityGroupPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CommodityGroup>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCommodityGroupTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CommodityGroupSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCommodityGroupTablePayload = {
  __typename?: 'SearchCommodityGroupTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<CommodityGroupSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

/** Search Criteria foor the record field */
export type SearchCriteriaInput = {
  /** Search operator for the record field */
  operator: SearchOperators;
  /** Search values for the record field */
  values: SearchValuesInput;
};

/** Search Criteria foor the record field */
export type SearchCriteriaObject = {
  __typename?: 'SearchCriteriaObject';
  /** Search operator for the record field */
  operator: SearchOperators;
  /** Search values for the record field */
  values: SearchValuesObject;
};

export type SearchCursorPaginationInput = {
  /** Exclusive starting cursor, meaning it includes results after the cursor. Set as the endCursor of the previous paginated response. */
  afterCursor?: InputMaybe<Scalars['ID']>;
  /** Maximum number of results to return. Default is unlimited up to the maximum dataset size of 1MB. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type SearchCustomDomainInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomDomainCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomDomainPayload = {
  __typename?: 'SearchCustomDomainPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CustomDomain>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCustomsAgentInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsAgentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsAgentPayload = {
  __typename?: 'SearchCustomsAgentPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CustomsAgent>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCustomsAgentTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsAgentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsAgentTablePayload = {
  __typename?: 'SearchCustomsAgentTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<CustomsAgentSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchCustomsBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsBrokerPayload = {
  __typename?: 'SearchCustomsBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CustomsBroker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCustomsBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsBrokerTablePayload = {
  __typename?: 'SearchCustomsBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsCustomsBrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchCustomsDeclarationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsDeclarationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsDeclarationPayload = {
  __typename?: 'SearchCustomsDeclarationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CustomsDeclaration>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCustomsDeclarationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsDeclarationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsDeclarationTablePayload = {
  __typename?: 'SearchCustomsDeclarationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<CustomsDeclarationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchCustomsEntriesInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsEntriesPayload = {
  __typename?: 'SearchCustomsEntriesPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<CustomsEntry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchCustomsEntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<CustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchCustomsEntryTablePayload = {
  __typename?: 'SearchCustomsEntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<CustomsEntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDeConsigneeInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeConsigneePayload = {
  __typename?: 'SearchDeConsigneePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DeConsignee>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDeConsigneeTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeConsigneeTablePayload = {
  __typename?: 'SearchDeConsigneeTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DeConsigneeSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDeCustomsBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeCustomsBrokerPayload = {
  __typename?: 'SearchDeCustomsBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DeCustomsBroker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDeCustomsBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeCustomsBrokerTablePayload = {
  __typename?: 'SearchDeCustomsBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DeCustomsBrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDeCustomsEntryInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeCustomsEntryPayload = {
  __typename?: 'SearchDeCustomsEntryPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DeCustomsEntry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDeCustomsEntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeCustomsEntryTablePayload = {
  __typename?: 'SearchDeCustomsEntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DeCustomsEntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDeIorActivationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeIorActivationPayload = {
  __typename?: 'SearchDeIorActivationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DeIorActivation>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDeIorActivationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeIorActivationTablePayload = {
  __typename?: 'SearchDeIorActivationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DeIorActivationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDeIorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeIorPayload = {
  __typename?: 'SearchDeIorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DeIor>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDeIorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeIorTablePayload = {
  __typename?: 'SearchDeIorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DeIorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDecoratedProductInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ProductSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDecoratedProductTablePayload = {
  __typename?: 'SearchDecoratedProductTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DecoratedProductSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDeliveryOrderInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeliveryOrderSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeliveryOrderPayload = {
  __typename?: 'SearchDeliveryOrderPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DeliveryOrder>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDeliveryOrderTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DeliveryOrderSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDeliveryOrderTablePayload = {
  __typename?: 'SearchDeliveryOrderTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DeliveryOrderSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDocumentInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DocumentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDocumentPayload = {
  __typename?: 'SearchDocumentPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Document>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDocumentTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DocumentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDocumentTablePayload = {
  __typename?: 'SearchDocumentTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DocumentSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDocumentTemplateInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DocumentTemplateSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDocumentTemplatePayload = {
  __typename?: 'SearchDocumentTemplatePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DocumentTemplate>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDocumentTemplateTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DocumentTemplateSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDocumentTemplateTablePayload = {
  __typename?: 'SearchDocumentTemplateTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DocumentTemplateSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchDpsRecordInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DpsRecordSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDpsRecordPayload = {
  __typename?: 'SearchDpsRecordPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<DpsRecord>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchDpsRecordTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<DpsRecordSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchDpsRecordTablePayload = {
  __typename?: 'SearchDpsRecordTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<DpsRecordSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchErrorDefinitionInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ErrorDefinitionSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchErrorDefinitionPayload = {
  __typename?: 'SearchErrorDefinitionPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ErrorDefinition>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchEuHsInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<EuHsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchEuHsPayload = {
  __typename?: 'SearchEuHsPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<EuHs>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchEuHsTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<EuHsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchEuHsTablePayload = {
  __typename?: 'SearchEuHsTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<EuHsSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchExchangeMessageInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ExchangeMessageSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchExchangeMessagePayload = {
  __typename?: 'SearchExchangeMessagePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ExchangeMessage>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchExchangeMessageTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ExchangeMessageSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchExchangeMessageTablePayload = {
  __typename?: 'SearchExchangeMessageTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ExchangeMessageSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchExternalSystemInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ExternalSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchExternalSystemPayload = {
  __typename?: 'SearchExternalSystemPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ExternalSystem>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchExternalSystemTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ExternalSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchExternalSystemTablePayload = {
  __typename?: 'SearchExternalSystemTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ExternalSystemSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchFacilityInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FacilitySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFacilityPayload = {
  __typename?: 'SearchFacilityPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Facility>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchFacilityTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FacilitySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFacilityTablePayload = {
  __typename?: 'SearchFacilityTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<FacilitySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchForwarderInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ForwarderSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchForwarderPayload = {
  __typename?: 'SearchForwarderPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Forwarder>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchForwarderSystemInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ForwarderSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchForwarderSystemPayload = {
  __typename?: 'SearchForwarderSystemPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ForwarderSystem>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchForwarderSystemTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ForwarderSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchForwarderSystemTablePayload = {
  __typename?: 'SearchForwarderSystemTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ForwarderSystemSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchForwarderTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ForwarderSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchForwarderTablePayload = {
  __typename?: 'SearchForwarderTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ForwarderSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchForwarderUserInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ForwarderUserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchForwarderUserPayload = {
  __typename?: 'SearchForwarderUserPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ForwarderUser>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchForwarderUserTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ForwarderUserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchForwarderUserTablePayload = {
  __typename?: 'SearchForwarderUserTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ForwarderUserSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchFrConsigneeInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrConsigneePayload = {
  __typename?: 'SearchFrConsigneePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<FrConsignee>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchFrConsigneeTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrConsigneeTablePayload = {
  __typename?: 'SearchFrConsigneeTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<FrConsigneeSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchFrCustomsBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrCustomsBrokerPayload = {
  __typename?: 'SearchFrCustomsBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<FrCustomsBroker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchFrCustomsBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrCustomsBrokerTablePayload = {
  __typename?: 'SearchFrCustomsBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<FrCustomsBrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchFrCustomsEntryInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrCustomsEntryPayload = {
  __typename?: 'SearchFrCustomsEntryPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<FrCustomsEntry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchFrCustomsEntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrCustomsEntryTablePayload = {
  __typename?: 'SearchFrCustomsEntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<FrCustomsEntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchFrIorActivationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrIorActivationPayload = {
  __typename?: 'SearchFrIorActivationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<FrIorActivation>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchFrIorActivationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrIorActivationTablePayload = {
  __typename?: 'SearchFrIorActivationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<FrIorActivationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchFrIorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrIorPayload = {
  __typename?: 'SearchFrIorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<FrIor>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchFrIorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<FrIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchFrIorTablePayload = {
  __typename?: 'SearchFrIorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<FrIorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchGbConsigneeInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbConsigneePayload = {
  __typename?: 'SearchGbConsigneePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<GbConsignee>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchGbConsigneeTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbConsigneeTablePayload = {
  __typename?: 'SearchGbConsigneeTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<GbConsigneeSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchGbCustomsEntryInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbCustomsEntryPayload = {
  __typename?: 'SearchGbCustomsEntryPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<GbCustomsEntry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchGbCustomsEntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbCustomsEntryTablePayload = {
  __typename?: 'SearchGbCustomsEntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<GbCustomsEntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchGbIorActivationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbIorActivationPayload = {
  __typename?: 'SearchGbIorActivationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<GbIorActivation>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchGbIorActivationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbIorActivationTablePayload = {
  __typename?: 'SearchGbIorActivationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<GbIorActivationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchGbIorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbIorPayload = {
  __typename?: 'SearchGbIorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<GbIor>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchGbIorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GbIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGbIorTablePayload = {
  __typename?: 'SearchGbIorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<GbIorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchGlobalConsigneeInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GlobalConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGlobalConsigneePayload = {
  __typename?: 'SearchGlobalConsigneePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<GlobalConsignee>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchGlobalConsigneeTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<GlobalConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchGlobalConsigneeTablePayload = {
  __typename?: 'SearchGlobalConsigneeTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<GlobalConsigneeSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchHtsInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<HtsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchHtsPayload = {
  __typename?: 'SearchHtsPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Hts>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchHtsTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<HtsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchHtsTablePayload = {
  __typename?: 'SearchHtsTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<HtsSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchImporterEntityActivationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ImporterEntityActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchImporterEntityActivationPayload = {
  __typename?: 'SearchImporterEntityActivationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ImporterEntityActivation>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchImporterEntityActivationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ImporterEntityActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchImporterEntityActivationTablePayload = {
  __typename?: 'SearchImporterEntityActivationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ImporterEntityActivationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchImporterEntityInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ImporterEntitySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchImporterEntityPayload = {
  __typename?: 'SearchImporterEntityPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ImporterEntity>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchImporterEntityTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ImporterEntitySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchImporterEntityTablePayload = {
  __typename?: 'SearchImporterEntityTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ImporterEntitySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchImporterInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ImporterSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchImporterPayload = {
  __typename?: 'SearchImporterPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Importer>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchImporterTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ImporterSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchImporterTablePayload = {
  __typename?: 'SearchImporterTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ImporterSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchInvoiceCreditNoteInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoiceCreditNoteSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoiceCreditNotePayload = {
  __typename?: 'SearchInvoiceCreditNotePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<InvoiceCreditNote>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchInvoiceCreditNoteTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoiceCreditNoteSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoiceCreditNoteTablePayload = {
  __typename?: 'SearchInvoiceCreditNoteTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<InvoiceCreditNoteSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchInvoiceInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoiceSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoiceLinesRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoiceLinesRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoiceLinesRequestPayload = {
  __typename?: 'SearchInvoiceLinesRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<InvoiceLinesRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchInvoicePayload = {
  __typename?: 'SearchInvoicePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Invoice>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchInvoicePaymentInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoicePaymentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoicePaymentPayload = {
  __typename?: 'SearchInvoicePaymentPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<InvoicePayment>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchInvoicePaymentTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoicePaymentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoicePaymentTablePayload = {
  __typename?: 'SearchInvoicePaymentTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<InvoicePaymentSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchInvoiceTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<InvoiceSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchInvoiceTablePayload = {
  __typename?: 'SearchInvoiceTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<InvoiceSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchMemoInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<MemoSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchMemoPayload = {
  __typename?: 'SearchMemoPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Memo>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchMemoTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<MemoSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchMemoTablePayload = {
  __typename?: 'SearchMemoTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<MemoSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchNlConsigneeInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlConsigneePayload = {
  __typename?: 'SearchNlConsigneePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<NlConsignee>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchNlConsigneeTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlConsigneeTablePayload = {
  __typename?: 'SearchNlConsigneeTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<NlConsigneeSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchNlCustomsBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlCustomsBrokerPayload = {
  __typename?: 'SearchNlCustomsBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<NlCustomsBroker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchNlCustomsBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlCustomsBrokerTablePayload = {
  __typename?: 'SearchNlCustomsBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<NlCustomsBrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchNlCustomsEntryInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlCustomsEntryPayload = {
  __typename?: 'SearchNlCustomsEntryPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<NlCustomsEntry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchNlCustomsEntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlCustomsEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlCustomsEntryTablePayload = {
  __typename?: 'SearchNlCustomsEntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<NlCustomsEntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchNlIorActivationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlIorActivationPayload = {
  __typename?: 'SearchNlIorActivationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<NlIorActivation>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchNlIorActivationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlIorActivationTablePayload = {
  __typename?: 'SearchNlIorActivationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<NlIorActivationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchNlIorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlIorPayload = {
  __typename?: 'SearchNlIorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<NlIor>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchNlIorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<NlIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchNlIorTablePayload = {
  __typename?: 'SearchNlIorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<NlIorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchOnboardingRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OnboardingRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOnboardingRequestPayload = {
  __typename?: 'SearchOnboardingRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<OnboardingRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchOnboardingRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OnboardingRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOnboardingRequestTablePayload = {
  __typename?: 'SearchOnboardingRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<OnboardingRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchOperatorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OperatorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOperatorPayload = {
  __typename?: 'SearchOperatorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Operator>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchOperatorSystemInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OperatorSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOperatorSystemPayload = {
  __typename?: 'SearchOperatorSystemPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<OperatorSystem>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchOperatorSystemTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OperatorSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOperatorSystemTablePayload = {
  __typename?: 'SearchOperatorSystemTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<OperatorSystemSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchOperatorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OperatorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOperatorTablePayload = {
  __typename?: 'SearchOperatorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<OperatorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchOperatorUserInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OperatorUserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOperatorUserPayload = {
  __typename?: 'SearchOperatorUserPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<OperatorUser>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchOperatorUserTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<OperatorUserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchOperatorUserTablePayload = {
  __typename?: 'SearchOperatorUserTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<OperatorUserSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

/** Record Search Operators */
export enum SearchOperators {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE',
  BETWEEN = 'BETWEEN',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  ENDS_WITH = 'ENDS_WITH',
  EQUALS = 'EQUALS',
  EXISTS = 'EXISTS',
  GREATER_THAN = 'GREATER_THAN',
  INCLUDES = 'INCLUDES',
  LESS_THAN = 'LESS_THAN',
  NOT_BETWEEN = 'NOT_BETWEEN',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_ONE_OF = 'NOT_ONE_OF',
  ONE_OF = 'ONE_OF',
  STARTS_WITH = 'STARTS_WITH'
}

/** Captures the pagination details for the search table results */
export type SearchPagination = {
  __typename?: 'SearchPagination';
  /** The initial offset or the page number for which search results were returned. */
  pageNumber?: Maybe<Scalars['Int']>;
  /** The number of records fetched. */
  pageSize?: Maybe<Scalars['Int']>;
  /** The total number of pages. */
  totalPages?: Maybe<Scalars['Int']>;
};

/** Captures the pagination details for the search request */
export type SearchPaginationInput = {
  /** The initial offset or the page number for which search results are to be returned. Defaults to 1 (first page). */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /** The maximum number of records to be fetched. Defaults to 20. */
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type SearchPartyInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<PartySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchPartyPayload = {
  __typename?: 'SearchPartyPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Party>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchPartyTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<PartySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchPartyTablePayload = {
  __typename?: 'SearchPartyTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<PartySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchPayableInvoiceInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<PayableInvoiceSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchPayableInvoicePayload = {
  __typename?: 'SearchPayableInvoicePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<PayableInvoice>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchPayableInvoiceTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<PayableInvoiceSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchPayableInvoiceTablePayload = {
  __typename?: 'SearchPayableInvoiceTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<PayableInvoiceSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchProcessingErrorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ProcessingErrorSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchProcessingErrorPayload = {
  __typename?: 'SearchProcessingErrorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ProcessingError>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchProcessingErrorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ProcessingErrorSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchProcessingErrorTablePayload = {
  __typename?: 'SearchProcessingErrorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ProcessingErrorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchProductInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ProductSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchProductPayload = {
  __typename?: 'SearchProductPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Product>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchProductTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ProductSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchProductTablePayload = {
  __typename?: 'SearchProductTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ProductSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchReleaseNoteInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ReleaseNoteSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchReleaseNotePayload = {
  __typename?: 'SearchReleaseNotePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ReleaseNote>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchReleaseNoteTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ReleaseNoteSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchReleaseNoteTablePayload = {
  __typename?: 'SearchReleaseNoteTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ReleaseNoteSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchReportReconciliationRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ReportReconciliationRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchReportReconciliationRequestPayload = {
  __typename?: 'SearchReportReconciliationRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ReportReconciliationRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchReportReconciliationRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ReportReconciliationRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchReportReconciliationRequestTablePayload = {
  __typename?: 'SearchReportReconciliationRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ReportReconciliationRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchShipmentCommercialInvoiceDetailInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipmentCommercialInvoiceDetailSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipmentCommercialInvoiceDetailPayload = {
  __typename?: 'SearchShipmentCommercialInvoiceDetailPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ShipmentCommercialInvoiceDetail>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchShipmentCommercialInvoiceDetailTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipmentCommercialInvoiceDetailSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipmentCommercialInvoiceDetailTablePayload = {
  __typename?: 'SearchShipmentCommercialInvoiceDetailTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ShipmentCommercialInvoiceDetailSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchShipmentDocumentProcessingRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipmentDocumentProcessingRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipmentDocumentProcessingRequestPayload = {
  __typename?: 'SearchShipmentDocumentProcessingRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ShipmentDocumentProcessingRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchShipmentDocumentProcessingRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipmentDocumentProcessingRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipmentDocumentProcessingRequestTablePayload = {
  __typename?: 'SearchShipmentDocumentProcessingRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ShipmentDocumentProcessingRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchShipmentInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipmentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipmentPayload = {
  __typename?: 'SearchShipmentPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Shipment>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchShipmentTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipmentSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipmentTablePayload = {
  __typename?: 'SearchShipmentTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ShipmentSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchShipperInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipperSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipperPayload = {
  __typename?: 'SearchShipperPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Shipper>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchShipperSystemInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipperSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipperSystemPayload = {
  __typename?: 'SearchShipperSystemPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ShipperSystem>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchShipperSystemTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipperSystemSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipperSystemTablePayload = {
  __typename?: 'SearchShipperSystemTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ShipperSystemSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchShipperTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipperSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipperTablePayload = {
  __typename?: 'SearchShipperTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ShipperSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchShipperUserInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipperUserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipperUserPayload = {
  __typename?: 'SearchShipperUserPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<ShipperUser>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchShipperUserTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<ShipperUserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchShipperUserTablePayload = {
  __typename?: 'SearchShipperUserTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<ShipperUserSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

/** Captures the sorting options the search results */
export type SearchSortingOption = {
  /** The name of the field on which the sorting is to applied. */
  field: Scalars['String'];
  /** The order to sort the results. Defaults to ascending */
  order?: InputMaybe<SortOrder>;
};

export type SearchStampDocumentSignRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<StampDocumentSignRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchStampDocumentSignRequestPayload = {
  __typename?: 'SearchStampDocumentSignRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<StampDocumentSignRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchStampDocumentSignRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<StampDocumentSignRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchStampDocumentSignRequestTablePayload = {
  __typename?: 'SearchStampDocumentSignRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<StampDocumentSignRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchSubjectMatterExpertTeamInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<SubjectMatterExpertTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchSubjectMatterExpertTeamPayload = {
  __typename?: 'SearchSubjectMatterExpertTeamPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<SubjectMatterExpertTeam>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchSubjectMatterExpertTeamTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<SubjectMatterExpertTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchSubjectMatterExpertTeamTablePayload = {
  __typename?: 'SearchSubjectMatterExpertTeamTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<SubjectMatterExpertTeamSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchSupplierInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<SupplierSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchSupplierPayload = {
  __typename?: 'SearchSupplierPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Supplier>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchSupplierTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<SupplierSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchSupplierTablePayload = {
  __typename?: 'SearchSupplierTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<SupplierSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchTableFilterInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TableFilterSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTableFilterPayload = {
  __typename?: 'SearchTableFilterPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<TableFilter>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchTableFilterTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TableFilterSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTableFilterTablePayload = {
  __typename?: 'SearchTableFilterTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<TableFilterSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchTeamInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTeamPayload = {
  __typename?: 'SearchTeamPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Team>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchTeamTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTeamTablePayload = {
  __typename?: 'SearchTeamTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<TeamSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchTemplateDocumentSignRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TemplateDocumentSignRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTemplateDocumentSignRequestPayload = {
  __typename?: 'SearchTemplateDocumentSignRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<TemplateDocumentSignRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchTemplateDocumentSignRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TemplateDocumentSignRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTemplateDocumentSignRequestTablePayload = {
  __typename?: 'SearchTemplateDocumentSignRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<TemplateDocumentSignRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchTradeAdvisoryRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TradeAdvisoryRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTradeAdvisoryRequestPayload = {
  __typename?: 'SearchTradeAdvisoryRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<TradeAdvisoryRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchTradeAdvisoryRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TradeAdvisoryRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTradeAdvisoryRequestTablePayload = {
  __typename?: 'SearchTradeAdvisoryRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<TradeAdvisoryRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchTruckerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TruckerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTruckerPayload = {
  __typename?: 'SearchTruckerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<Trucker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchTruckerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<TruckerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchTruckerTablePayload = {
  __typename?: 'SearchTruckerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<TruckerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUkCustomsBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UkCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUkCustomsBrokerPayload = {
  __typename?: 'SearchUkCustomsBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UkCustomsBroker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUkCustomsBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UkCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUkCustomsBrokerTablePayload = {
  __typename?: 'SearchUkCustomsBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UkCustomsBrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUkHsInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UkHsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUkHsPayload = {
  __typename?: 'SearchUkHsPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UkHs>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUkHsTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UkHsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUkHsTablePayload = {
  __typename?: 'SearchUkHsTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UkHsSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsConsigneeInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsConsigneePayload = {
  __typename?: 'SearchUsConsigneePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsConsignee>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsConsigneeTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsConsigneeSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsConsigneeTablePayload = {
  __typename?: 'SearchUsConsigneeTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsConsigneeSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsConsumptionEntryInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsConsumptionEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsConsumptionEntryPayload = {
  __typename?: 'SearchUsConsumptionEntryPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsConsumptionEntry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsConsumptionEntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsConsumptionEntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsConsumptionEntryTablePayload = {
  __typename?: 'SearchUsConsumptionEntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsConsumptionEntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsCustomsBrokerInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsCustomsBrokerPayload = {
  __typename?: 'SearchUsCustomsBrokerPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsCustomsBroker>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsCustomsBrokerTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsCustomsBrokerSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsCustomsBrokerTablePayload = {
  __typename?: 'SearchUsCustomsBrokerTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsCustomsBrokerSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsDrawbackClaimInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsDrawbackClaimSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsDrawbackClaimPayload = {
  __typename?: 'SearchUsDrawbackClaimPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsDrawbackClaim>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsDrawbackClaimTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsDrawbackClaimSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsDrawbackClaimTablePayload = {
  __typename?: 'SearchUsDrawbackClaimTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsDrawbackClaimSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsHtsInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsHtsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsHtsPayload = {
  __typename?: 'SearchUsHtsPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsHts>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsHtsTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsHtsSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsHtsTablePayload = {
  __typename?: 'SearchUsHtsTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsHtsSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsInBondInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsInBondSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsInBondPayload = {
  __typename?: 'SearchUsInBondPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsInBond>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsInBondTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsInBondSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsInBondTablePayload = {
  __typename?: 'SearchUsInBondTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsInBondSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsIorActivationInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIorActivationPayload = {
  __typename?: 'SearchUsIorActivationPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsIorActivation>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsIorActivationTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIorActivationSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIorActivationTablePayload = {
  __typename?: 'SearchUsIorActivationTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsIorActivationSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsIorContinuousBondRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIorContinuousBondRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIorContinuousBondRequestPayload = {
  __typename?: 'SearchUsIorContinuousBondRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsIorContinuousBondRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsIorContinuousBondRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIorContinuousBondRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIorContinuousBondRequestTablePayload = {
  __typename?: 'SearchUsIorContinuousBondRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsIorContinuousBondRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsIorInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIorPayload = {
  __typename?: 'SearchUsIorPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsIor>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsIorTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIorSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIorTablePayload = {
  __typename?: 'SearchUsIorTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsIorSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsIsfInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIsfSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIsfPayload = {
  __typename?: 'SearchUsIsfPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsIsf>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsIsfTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsIsfSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsIsfTablePayload = {
  __typename?: 'SearchUsIsfTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsIsfSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsPostSummaryCorrectionInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsPostSummaryCorrectionSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsPostSummaryCorrectionPayload = {
  __typename?: 'SearchUsPostSummaryCorrectionPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsPostSummaryCorrection>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsPostSummaryCorrectionTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsPostSummaryCorrectionSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsPostSummaryCorrectionTablePayload = {
  __typename?: 'SearchUsPostSummaryCorrectionTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsPostSummaryCorrectionSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsPrincipalAdCvdCaseInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsPrincipalAdCvdCaseSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsPrincipalAdCvdCasePayload = {
  __typename?: 'SearchUsPrincipalAdCvdCasePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsPrincipalAdCvdCase>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsPrincipalAdCvdCaseTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsPrincipalAdCvdCaseSearchCriteria>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsPrincipalAdCvdCaseTablePayload = {
  __typename?: 'SearchUsPrincipalAdCvdCaseTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsPrincipalAdCvdCaseSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUsType86EntryInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsType86EntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsType86EntryPayload = {
  __typename?: 'SearchUsType86EntryPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UsType86Entry>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUsType86EntryTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UsType86EntrySearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUsType86EntryTablePayload = {
  __typename?: 'SearchUsType86EntryTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UsType86EntrySearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUserInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUserPayload = {
  __typename?: 'SearchUserPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<User>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUserReleaseNoteViewInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UserReleaseNoteViewSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUserReleaseNoteViewPayload = {
  __typename?: 'SearchUserReleaseNoteViewPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UserReleaseNoteView>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUserReleaseNoteViewTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UserReleaseNoteViewSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUserReleaseNoteViewTablePayload = {
  __typename?: 'SearchUserReleaseNoteViewTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UserReleaseNoteViewSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUserTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UserSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUserTablePayload = {
  __typename?: 'SearchUserTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UserSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchUserTeamInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UserTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUserTeamPayload = {
  __typename?: 'SearchUserTeamPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<UserTeam>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchUserTeamTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<UserTeamSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchUserTeamTablePayload = {
  __typename?: 'SearchUserTeamTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<UserTeamSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

/** Search values to be applied on the record field */
export type SearchValuesInput = {
  /** Search max value for the record field */
  maxValue?: InputMaybe<Scalars['Float']>;
  /** Search min value for the record field */
  minValue?: InputMaybe<Scalars['Float']>;
  /** Search range values for the record field */
  rangeValue?: InputMaybe<Array<Scalars['String']>>;
  /** Search value for the record field */
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** Search values to be applied on the record field */
export type SearchValuesObject = {
  __typename?: 'SearchValuesObject';
  /** Search max value for the record field */
  maxValue?: Maybe<Scalars['Float']>;
  /** Search min value for the record field */
  minValue?: Maybe<Scalars['Float']>;
  /** Search range values for the record field */
  rangeValue?: Maybe<Array<Scalars['String']>>;
  /** Search value for the record field */
  value?: Maybe<Array<Scalars['String']>>;
};

export type SearchWorkOrderDocumentProcessingRequestInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderDocumentProcessingRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderDocumentProcessingRequestPayload = {
  __typename?: 'SearchWorkOrderDocumentProcessingRequestPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrderDocumentProcessingRequest>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderDocumentProcessingRequestTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderDocumentProcessingRequestSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderDocumentProcessingRequestTablePayload = {
  __typename?: 'SearchWorkOrderDocumentProcessingRequestTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderDocumentProcessingRequestSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchWorkOrderGroupInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderGroupSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderGroupPayload = {
  __typename?: 'SearchWorkOrderGroupPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrderGroup>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderGroupTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderGroupSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderGroupTablePayload = {
  __typename?: 'SearchWorkOrderGroupTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderGroupSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchWorkOrderInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderPayload = {
  __typename?: 'SearchWorkOrderPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrder>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderStateMachineInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderStateMachineSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderStateMachinePayload = {
  __typename?: 'SearchWorkOrderStateMachinePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrderStateMachine>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderStateMachineTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderStateMachineSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderStateMachineTablePayload = {
  __typename?: 'SearchWorkOrderStateMachineTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderStateMachineSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchWorkOrderTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTablePayload = {
  __typename?: 'SearchWorkOrderTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchWorkOrderTaskDefinitionInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderTaskSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTaskDefinitionPayload = {
  __typename?: 'SearchWorkOrderTaskDefinitionPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrderTaskDefinition>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderTaskDefinitionTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderTaskSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTaskDefinitionTablePayload = {
  __typename?: 'SearchWorkOrderTaskDefinitionTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderTaskSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchWorkOrderTaskEscalationMessageInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderTaskEscalationMessageSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTaskEscalationMessagePayload = {
  __typename?: 'SearchWorkOrderTaskEscalationMessagePayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrderTaskEscalationMessage>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderTaskEscalationMessageTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderTaskEscalationMessageSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTaskEscalationMessageTablePayload = {
  __typename?: 'SearchWorkOrderTaskEscalationMessageTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderTaskEscalationMessageSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

export type SearchWorkOrderTaskInput = {
  /** The cursor details indicating how to paginate the results. Used if querying by a GSI field. */
  cursorPaginationInfo?: InputMaybe<SearchCursorPaginationInput>;
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderTaskSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTaskPayload = {
  __typename?: 'SearchWorkOrderTaskPayload';
  /** The cursor based pagination details. Only set if querying by a GSI field. */
  cursorPaginationInfo?: Maybe<CursorPagination>;
  /** The details indicating how the results were paginated. Not set if querying by a GSI field. */
  paginationInfo?: Maybe<SearchPagination>;
  /** The records matching the search criteria. */
  results: Array<WorkOrderTask>;
  /** The total number of hits returned by the search. Not set if querying by a GSI field. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type SearchWorkOrderTaskTableInput = {
  /** The details indicating how to paginate the results. */
  paginationOptions?: InputMaybe<SearchPaginationInput>;
  /** The fields and their values used to search exchange messages. OR operator would be applied if multiple values are provided for a field, whereas AND operator would be used for results across different fields. */
  searchCriteria?: InputMaybe<WorkOrderTaskSearchCriteriaInput>;
  /** The field and order to sort the results on. Add multiple to break potential ties. They are evaulated in the order provided. */
  sortOptions?: InputMaybe<Array<SearchSortingOption>>;
};

export type SearchWorkOrderTaskTablePayload = {
  __typename?: 'SearchWorkOrderTaskTablePayload';
  /** The details indicating how the results were paginated. */
  paginationInfo: SearchPagination;
  /** The rows matching the search criteria. */
  results: Array<WorkOrderTaskSearchTableRow>;
  /** The total number of hits returned by the search. */
  totalResults: Scalars['Int'];
};

/** Section 301 Exclusion control. */
export type Section301Exclusion = {
  __typename?: 'Section301Exclusion';
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** End (expiration) date for HTS control. */
  endDate?: Maybe<Scalars['Date']>;
  /** The countries of origin subject to the Section 301 Exclusion requirement. */
  include?: Maybe<Array<Scalars['CountryCode']>>;
  /** Start (effective) date for HTS control. */
  startDate?: Maybe<Scalars['Date']>;
};

export type Section301ExclusionInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** End (expiration) date for HTS control. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The countries of origin subject to the Section 301 Exclusion requirement. */
  include?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** Start (effective) date for HTS control. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Input parameters to send documents to 3p. */
export type SendWorkOrderDocumentsTo3pInput = {
  /** Documents that will be submitted. */
  documents: Array<IdInput>;
};

/** The payload returned from triggering the Transaction. */
export type SendWorkOrderDocumentsTo3pPayload = {
  __typename?: 'SendWorkOrderDocumentsTo3pPayload';
  /** The Transaction. */
  transaction: SendWorkOrderDocumentsTo3pTransaction;
};

/** The 3P transaction to send documents. */
export type SendWorkOrderDocumentsTo3pTransaction = Record & WorkOrderTransaction & {
  __typename?: 'SendWorkOrderDocumentsTo3pTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Documents that will be submitted. */
  documents: Array<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The Work Order */
  workOrder: WorkOrder;
};

/** Input parameters to send documents to external systems. */
export type SendWorkOrderDocumentsToExternalSystemInput = {
  /** Documents that will be submitted. */
  documents: Array<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** The payload returned from triggering the Transaction. */
export type SendWorkOrderDocumentsToExternalSystemPayload = {
  __typename?: 'SendWorkOrderDocumentsToExternalSystemPayload';
  /** The Transaction. */
  transaction: SendWorkOrderDocumentsToExternalSystemTransaction;
};

/** The transaction to send documents to external systems. */
export type SendWorkOrderDocumentsToExternalSystemTransaction = Record & WorkOrderTransaction & {
  __typename?: 'SendWorkOrderDocumentsToExternalSystemTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Documents that will be submitted. */
  documents: Array<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The Work Order */
  workOrder: WorkOrder;
};

/** Custom service level agreement for a work order type */
export type ServiceLevelAgreement = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
};

/** The type of the service */
export enum ServiceType {
  CUSTOMS_CLEARANCE = 'CUSTOMS_CLEARANCE',
  CUSTOMS_DUTIES = 'CUSTOMS_DUTIES',
  PORT_BROKERING = 'PORT_BROKERING'
}

export type ServiceTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ServiceType>>;
};

export type Shipment = Record & {
  __typename?: 'Shipment';
  /** Badges related to a shipment e.g. HOT, PREMIUM */
  badges?: Maybe<Array<ShipmentBadge>>;
  /** Buyer is the party that buys the goods from overseas sellers. Name and address are required. */
  buyer?: Maybe<ShipmentBuyer>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** Represents if the customer is to be charged for creating the shipment manually */
  chargeManualCreationFee?: Maybe<Scalars['Boolean']>;
  /** The client's identifier for the shipment */
  clientIdentifier?: Maybe<Scalars['ShipmentClientIdentifier']>;
  /** Client references for the shipment: booking id, shipment id etc */
  clientReferences?: Maybe<ClientReferences>;
  /** Consolidator is the party responsible for consolidation of the goods. Name and address are required. */
  consolidator?: Maybe<ShipmentConsolidator>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the Shipment. This is an eventually consistent query. */
  documents: Array<Document>;
  /** External document references. */
  externalDocumentReferences?: Maybe<Array<ExternalDocumentReference>>;
  /** References to this shipment in external integrations. */
  externalIntegrationReferences?: Maybe<Array<ShipmentExternalIntegrationReference>>;
  /** The freight forwarders related to the Shipment. */
  forwarders?: Maybe<Array<ShipmentForwarder>>;
  /** Shipment's Friendly ID */
  friendlyId: Scalars['ID'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Represents the different legs that make up a shipment. */
  legs: Array<ShipmentLeg>;
  /** Manufacturers associated with the shipment. Name and address are required. */
  manufacturers?: Maybe<Array<ShipmentManufacturer>>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Service type for AMP2.0 bookings, defaults to STANDARD for non-AMP2.0 bookings */
  placementType?: Maybe<PlacementType>;
  /** Preferred duty charge party type */
  preferredDutyCollectPartyType?: Maybe<PreferredDutyCollectPartyType>;
  /** Each provided WorkOrderType will be created automatically when the shipment is created/updated */
  requestedWorkOrders?: Maybe<Array<WorkOrderType>>;
  /** Sellers are indicated as the sellers of the goods. Name and address are required. */
  sellers?: Maybe<Array<ShipmentSeller>>;
  /** Destination associated with the shipment. */
  shipTo?: Maybe<ShipmentShipTo>;
  /** Shipper is the party responsible for the shipment. */
  shipper: ShipmentShipper;
  /** The status of a shipment e.g. ACTIVE, CANCELED */
  status?: Maybe<ShipmentStatus>;
  /** Container stuffing location associated with the shipment. Name and address are required. */
  stuffingLocation?: Maybe<ShipmentStuffingLocation>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** Work order group associated with the shipment. */
  workOrderGroup: WorkOrderGroup;
};


export type ShipmentdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Badge of a shipment e.g. HOT, PREMIUM */
export enum ShipmentBadge {
  HOT = 'HOT',
  PREMIUM = 'PREMIUM'
}

export type ShipmentBadgeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ShipmentBadge>>;
};

export type ShipmentBuyer = {
  __typename?: 'ShipmentBuyer';
  /** Party address */
  address?: Maybe<Address>;
  /** Buyer party info which is stored in the record */
  buyer?: Maybe<Facility>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** EORI (Economic Operators Registration and Identification number) */
  eori?: Maybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: Maybe<Scalars['SupportedCountryVatNumber']>;
};

export type ShipmentBuyerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Buyer party info which is stored in the record */
  buyer?: InputMaybe<IdInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** EORI (Economic Operators Registration and Identification number) */
  eori?: InputMaybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: InputMaybe<Scalars['SupportedCountryVatNumber']>;
};

export type ShipmentCommercialInvoice = {
  __typename?: 'ShipmentCommercialInvoice';
  /** The total assist of the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** Captures the compliance details of items/lines part of the commercial invoice. */
  complianceDetails?: Maybe<Array<ShipmentComplianceDetail>>;
  /** Conveyance associated with the particular commercial invoice. */
  conveyance?: Maybe<ShippingConveyance>;
  /** External document references. */
  externalDocumentReferences?: Maybe<Array<ExternalDocumentReference>>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: Maybe<Cost>;
  /** Invoice Number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: Maybe<Scalars['Int']>;
  /** Reason For Export */
  reasonsForExport?: Maybe<Array<ReasonForExport>>;
  /** Sellers are indicated as the sellers of the goods. Name and address are required. */
  seller?: Maybe<ShipmentSeller>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: Maybe<Cost>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: Maybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: Maybe<Array<TermsOfSale>>;
  /** The total value of the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type ShipmentCommercialInvoiceDetail = Record & {
  __typename?: 'ShipmentCommercialInvoiceDetail';
  /** List of invoices with their items and compliance details. */
  commercialInvoices?: Maybe<Array<ShipmentCommercialInvoice>>;
  /** Shipment commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines. */
  commercialInvoicesReference?: Maybe<ShipmentCommercialInvoicesReference>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the ShipmentCommercialInvoiceDetail. This is an eventually consistent query. */
  documents: Array<Document>;
  /** External document references. */
  externalDocumentReferences?: Maybe<Array<ExternalDocumentReference>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The shipment leg index. */
  legIndex: Scalars['Int'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The shipment associated with this record. */
  shipment: Shipment;
  /** The source that caused the shipment commercial invoice to be updated */
  source?: Maybe<ShipmentCommercialInvoiceSource>;
  /** The status of shipment commercial invoice detail */
  status: ShipmentCommercialInvoiceDetailStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type ShipmentCommercialInvoiceDetaildocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ShipmentCommercialInvoiceDetailEdge = ConnectionEdge & {
  __typename?: 'ShipmentCommercialInvoiceDetailEdge';
  cursor: Scalars['ID'];
  node: ShipmentCommercialInvoiceDetail;
};

export type ShipmentCommercialInvoiceDetailInput = {
  /** List of invoices with their items and compliance details. */
  commercialInvoices?: InputMaybe<Array<ShipmentCommercialInvoiceInput>>;
  /** Shipment commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines. */
  commercialInvoicesReference?: InputMaybe<ShipmentCommercialInvoicesReferenceInput>;
  /** External document references. */
  externalDocumentReferences?: InputMaybe<Array<ExternalDocumentReferenceInput>>;
  /** The shipment leg index. */
  legIndex?: InputMaybe<Scalars['Int']>;
  /** The source that caused the shipment commercial invoice to be updated */
  source?: InputMaybe<ShipmentCommercialInvoiceSourceInput>;
  /** The status of shipment commercial invoice detail */
  status?: InputMaybe<ShipmentCommercialInvoiceDetailStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Shipment Commercial Invoice Detail Search Criteria Input */
export type ShipmentCommercialInvoiceDetailSearchCriteriaInput = {
  /** Client booking id. */
  bookingId?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The importer of record's ID. */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The importer of record's name. */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The shipment ID. */
  shipmentId?: InputMaybe<IdSearchCriteriaInput>;
  /** The status of a shipment e.g. ACTIVE, CANCELED */
  shipmentStatus?: InputMaybe<ShipmentStatusSearchCriteriaInput>;
  /** The shipper's ID. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The shipper's name. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** The status of shipment commercial invoice detail */
  status?: InputMaybe<ShipmentCommercialInvoiceDetailStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Shipment Commercial Invoice Detail Search Table Row */
export type ShipmentCommercialInvoiceDetailSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ShipmentCommercialInvoiceDetailSearchTableRow';
  /** Client booking id. */
  bookingId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The importer of record's ID. */
  iorId?: Maybe<Scalars['ID']>;
  /** The importer of record's name. */
  iorName?: Maybe<Scalars['String']>;
  /** The shipment leg index. */
  legIndex?: Maybe<Scalars['Int']>;
  /** The shipment ID. */
  shipmentId?: Maybe<Scalars['ID']>;
  /** The status of a shipment e.g. ACTIVE, CANCELED */
  shipmentStatus?: Maybe<Scalars['String']>;
  /** The shipper's ID. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The shipper's name. */
  shipperName?: Maybe<Scalars['String']>;
  /** The status of shipment commercial invoice detail */
  status?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** The status of shipment commercial invoice detail */
export enum ShipmentCommercialInvoiceDetailStatus {
  COMPLETED = 'COMPLETED',
  EXTRACTION_FAILED = 'EXTRACTION_FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED',
  VALIDATION_FAILED = 'VALIDATION_FAILED'
}

/** The status of shipment commercial invoice detail */
export type ShipmentCommercialInvoiceDetailStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ShipmentCommercialInvoiceDetailStatus>>;
};

export type ShipmentCommercialInvoiceDetailsConnection = Connection & {
  __typename?: 'ShipmentCommercialInvoiceDetailsConnection';
  edges: Array<ShipmentCommercialInvoiceDetailEdge>;
  nodes: Array<ShipmentCommercialInvoiceDetail>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipmentCommercialInvoiceInput = {
  /** The total assist of the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** Captures the compliance details of items/lines part of the commercial invoice. */
  complianceDetails?: InputMaybe<Array<ShipmentComplianceDetailInput>>;
  /** Conveyance associated with the particular commercial invoice. */
  conveyance?: InputMaybe<ShippingConveyanceInput>;
  /** External document references. */
  externalDocumentReferences?: InputMaybe<Array<ExternalDocumentReferenceInput>>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Insurance costs for all items in an invoice */
  insuranceCost?: InputMaybe<CostInput>;
  /** Invoice Number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Number of units of the specified load type */
  loadCount?: InputMaybe<Scalars['Int']>;
  /** Reason For Export */
  reasonsForExport?: InputMaybe<Array<ReasonForExport>>;
  /** Sellers are indicated as the sellers of the goods. Name and address are required. */
  seller?: InputMaybe<ShipmentSellerInput>;
  /** Shipping costs for all items in an invoice */
  shippingCost?: InputMaybe<CostInput>;
  /** Split Invoice is a boolean field which defines if the particular invoice is a part of split shipment */
  splitInvoice?: InputMaybe<Scalars['Boolean']>;
  /** Terms of Sale */
  termsOfSale?: InputMaybe<Array<TermsOfSale>>;
  /** The total value of the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type ShipmentCommercialInvoiceSource = {
  __typename?: 'ShipmentCommercialInvoiceSource';
  /** The source provider that caused the commercial invoice to be updated */
  provider?: Maybe<ShipmentCommercialInvoiceSourceProvider>;
};

export type ShipmentCommercialInvoiceSourceInput = {
  /** The source provider that caused the commercial invoice to be updated */
  provider?: InputMaybe<ShipmentCommercialInvoiceSourceProvider>;
};

/** The source provider that caused the commercial invoice to be updated */
export enum ShipmentCommercialInvoiceSourceProvider {
  DOCUMENT_EXTRACTION = 'DOCUMENT_EXTRACTION',
  PROCHECK = 'PROCHECK'
}

export type ShipmentCommercialInvoicesReference = {
  __typename?: 'ShipmentCommercialInvoicesReference';
  /** The S3 Link to download shipment commercial invoices from. */
  downloadLink: Scalars['String'];
  /** The shipment commercial invoices S3 reference/path. */
  referenceKey: Scalars['String'];
};

export type ShipmentCommercialInvoicesReferenceInput = {
  /** The shipment commercial invoices S3 reference/path. */
  referenceKey: Scalars['String'];
};

/** Captures the compliance details of items/lines part of the commercial invoice. */
export type ShipmentComplianceDetail = {
  __typename?: 'ShipmentComplianceDetail';
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: Maybe<Array<Scalars['ID']>>;
  /** Total number of cartons. */
  cartonCount?: Maybe<Scalars['Int']>;
  /** Captures the compliance reference of item/line, if to be sourced from an external system. */
  complianceDetailsReference?: Maybe<ExternalComplianceReference>;
  /** Containers associated with the particular product. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Description of the product encompassed within the shipment. */
  description?: Maybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: Maybe<Volume>;
  /** Gross weight is equal to product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** Manufacturer associated with the shipment product. */
  manufacturer?: Maybe<ShipmentProductManufacturer>;
  /** The materials the Product contains. */
  materials?: Maybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: Maybe<Weight>;
  /** The origin of the product encompassed within the shipment. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** The purchase order (PO) number of the line item */
  poNumber?: Maybe<Scalars['String']>;
  /** The quantity of the item shipped as part of the commercial invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The tariff information associated with the product */
  tariffs?: Maybe<Array<ShipmentTariff>>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
  /** The value of assist of single unit of a product. */
  unitAssist?: Maybe<Cost>;
  /** The percentage of assist of single unit of a product. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The value of single unit of a product. */
  unitValue?: Maybe<Cost>;
};

export type ShipmentComplianceDetailInput = {
  /** Box Ids in which the particular product is being stored while being shipped. */
  boxIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Total number of cartons. */
  cartonCount?: InputMaybe<Scalars['Int']>;
  /** Captures the compliance reference of item/line, if to be sourced from an external system. */
  complianceDetailsReference?: InputMaybe<ExternalComplianceReferenceInput>;
  /** Containers associated with the particular product. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Description of the product encompassed within the shipment. */
  description?: InputMaybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: InputMaybe<VolumeInput>;
  /** Gross weight is equal to product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** Manufacturer associated with the shipment product. */
  manufacturer?: InputMaybe<ShipmentProductManufacturerInput>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: InputMaybe<WeightInput>;
  /** The origin of the product encompassed within the shipment. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** The purchase order (PO) number of the line item */
  poNumber?: InputMaybe<Scalars['String']>;
  /** The quantity of the item shipped as part of the commercial invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The tariff information associated with the product */
  tariffs?: InputMaybe<Array<ShipmentTariffInput>>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
  /** The value of assist of single unit of a product. */
  unitAssist?: InputMaybe<CostInput>;
  /** The percentage of assist of single unit of a product. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The value of single unit of a product. */
  unitValue?: InputMaybe<CostInput>;
};

export type ShipmentConsolidator = {
  __typename?: 'ShipmentConsolidator';
  /** Party address */
  address?: Maybe<Address>;
  /** Consolidator party info which is stored in the record */
  consolidator?: Maybe<Consolidator>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentConsolidatorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Consolidator party info which is stored in the record */
  consolidator?: InputMaybe<IdInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipmentDocumentProcessingRequest = Record & {
  __typename?: 'ShipmentDocumentProcessingRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Shipment processing request documents. */
  documents?: Maybe<Array<ShipmentProcessingRequestDocument>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status values for tracking document processing status for a shipment */
  status?: Maybe<ShipmentDocumentProcessingStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipmentDocumentProcessingRequestEdge = ConnectionEdge & {
  __typename?: 'ShipmentDocumentProcessingRequestEdge';
  cursor: Scalars['ID'];
  node: ShipmentDocumentProcessingRequest;
};

export type ShipmentDocumentProcessingRequestSearchCriteriaInput = {
  /** The shipment commercial invoice detail id. */
  ShipmentCommercialInvoiceDetailId?: InputMaybe<IdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** External document references. */
  externalDocumentReferencesId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment ID. */
  shipmentId?: InputMaybe<IdSearchCriteriaInput>;
  /** Status values for tracking document processing status for a shipment */
  status?: InputMaybe<ShipmentDocumentProcessingStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Shipment Document Processing Request Search Table Row */
export type ShipmentDocumentProcessingRequestSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ShipmentDocumentProcessingRequestSearchTableRow';
  /** The shipment commercial invoice detail id. */
  ShipmentCommercialInvoiceDetailId?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The shipment ID. */
  shipmentId?: Maybe<Scalars['ID']>;
  /** The status of a shipment e.g. ACTIVE, CANCELED */
  shipmentStatus?: Maybe<Scalars['String']>;
  /** Status values for tracking document processing status for a shipment */
  status?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ShipmentDocumentProcessingRequestsConnection = Connection & {
  __typename?: 'ShipmentDocumentProcessingRequestsConnection';
  edges: Array<ShipmentDocumentProcessingRequestEdge>;
  nodes: Array<ShipmentDocumentProcessingRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Status values for tracking document processing status for a shipment */
export enum ShipmentDocumentProcessingStatus {
  COMPLETED = 'COMPLETED',
  EXTRACTION_COMPLETED = 'EXTRACTION_COMPLETED',
  EXTRACTION_FAILED = 'EXTRACTION_FAILED',
  EXTRACTION_IN_PROGRESS = 'EXTRACTION_IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  VALIDATION_IN_PROGRESS = 'VALIDATION_IN_PROGRESS',
  VALIDATION_SUCCEEDED = 'VALIDATION_SUCCEEDED'
}

export type ShipmentDocumentProcessingStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ShipmentDocumentProcessingStatus>>;
};

export type ShipmentEdge = ConnectionEdge & {
  __typename?: 'ShipmentEdge';
  cursor: Scalars['ID'];
  node: Shipment;
};

export type ShipmentExternalIntegrationReference = {
  __typename?: 'ShipmentExternalIntegrationReference';
  /** The external client we have developed an integration with. */
  externalIntegrationPartner: ExternalIntegrationPartner;
  /** The type of the external integration. */
  externalIntegrationType: ExternalIntegrationType;
  /** A unique ID for the record within the external reference. */
  id: Scalars['ID'];
  /** A version tracker for the external reference record in CBMS. */
  version?: Maybe<Scalars['String']>;
};

export type ShipmentExternalIntegrationReferenceInput = {
  /** The external client we have developed an integration with. */
  externalIntegrationPartner: ExternalIntegrationPartner;
  /** The type of the external integration. */
  externalIntegrationType: ExternalIntegrationType;
  /** A unique ID for the record within the external reference. */
  id: Scalars['ID'];
  /** A version tracker for the external reference record in CBMS. */
  version?: InputMaybe<Scalars['String']>;
};

export type ShipmentForwarder = {
  __typename?: 'ShipmentForwarder';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Forwarder party info which is stored in the record */
  forwarder?: Maybe<Forwarder>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: Maybe<Scalars['SCACCode']>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentForwarderInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Forwarder party info which is stored in the record */
  forwarder?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<Scalars['SCACCode']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipmentLeg = {
  __typename?: 'ShipmentLeg';
  /** Arrival of shipment leg. */
  arrival?: Maybe<ShipmentLegArrival>;
  /** Detail of shipment commercial invoices including List of invoices with their items and compliance details. */
  commercialInvoiceDetail?: Maybe<ShipmentCommercialInvoiceDetail>;
  /** List of invoices with their items and compliance details. */
  commercialInvoices?: Maybe<Array<ShipmentCommercialInvoice>>;
  /** Consignee is the party shown on the bill of lading or air waybill to whom the shipment is consigned */
  consignee?: Maybe<ShipmentLegConsignee>;
  /** Containers associated with the shipment. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Conveyance associated with the shipment. */
  conveyance?: Maybe<ShippingConveyance>;
  /** Departure of the shipment leg. */
  departure?: Maybe<ShipmentLegDeparture>;
  /** Identification number of the commercial invoices for the purchase orders. */
  invoiceNumbers?: Maybe<Array<Scalars['String']>>;
  /** Import of Record associated with the shipment */
  ior?: Maybe<ShipmentLegIor>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the shipment. */
  masterBills?: Maybe<Array<MasterBill>>;
  /** Mode of transportation */
  modeOfTransport: ModeOfTransport;
  /**
   * Purchase order (PO) number(s) associated with the shipment.
   * @deprecated Deprecated 7/7/21 in favor of using the work order group's tags with TagKey === PO_NUMBER
   */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** Date by which all the regulatory clearances are expected to be completed. For example, in US this can mean the date by which this shipment will get FCC clearance for Devices shipments. */
  regulatoryReadyDate?: Maybe<Scalars['DateTime']>;
  /** Name of the service used for international transportation leg of the shipment. For e.g. EXX_PREMIUM */
  transportationServiceName?: Maybe<Scalars['String']>;
};

export type ShipmentLegArrival = {
  __typename?: 'ShipmentLegArrival';
  /** Arrival country of the shipment leg. */
  country: Scalars['CountryCode'];
  /** CustomsBroker associated with the ShipmentLegArrival. */
  customsBroker?: Maybe<ShipmentLegCustomsBroker>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** The port where cargo is discharged in arrival country. */
  portOfUnlading?: Maybe<PortCode>;
  /** Arrival time of the shipment leg. */
  time?: Maybe<Scalars['DateTime']>;
};

export type ShipmentLegArrivalInput = {
  /** Arrival country of the shipment leg. */
  country: Scalars['CountryCode'];
  /** CustomsBroker associated with the ShipmentLegArrival. */
  customsBroker?: InputMaybe<ShipmentLegCustomsBrokerInput>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** The port where cargo is discharged in arrival country. */
  portOfUnlading?: InputMaybe<PortCodeInput>;
  /** Arrival time of the shipment leg. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type ShipmentLegConsignee = {
  __typename?: 'ShipmentLegConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Consignee party info which is stored in the record */
  consignee?: Maybe<Consignee>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Importer of Record Number */
  iorNumber?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentLegConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Consignee party info which is stored in the record */
  consignee?: InputMaybe<IdInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Importer of Record Number */
  iorNumber?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipmentLegCustomsBroker = {
  __typename?: 'ShipmentLegCustomsBroker';
  /** CustomsBroker party info. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentLegCustomsBrokerInput = {
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipmentLegDeparture = {
  __typename?: 'ShipmentLegDeparture';
  /** Departure country of the shipment leg. */
  country?: Maybe<Scalars['CountryCode']>;
  /** CustomsBroker associated with the ShipmentLegDeparture. */
  customsBroker?: Maybe<ShipmentLegCustomsBroker>;
  /** The port where shipment gets loaded in departure country. */
  portOfLading?: Maybe<PortCode>;
  /** Departure time of the shipment leg. */
  time?: Maybe<Scalars['DateTime']>;
};

export type ShipmentLegDepartureInput = {
  /** Departure country of the shipment leg. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** CustomsBroker associated with the ShipmentLegDeparture. */
  customsBroker?: InputMaybe<ShipmentLegCustomsBrokerInput>;
  /** The port where shipment gets loaded in departure country. */
  portOfLading?: InputMaybe<PortCodeInput>;
  /** Departure time of the shipment leg. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type ShipmentLegInput = {
  /** Arrival of shipment leg. */
  arrival?: InputMaybe<ShipmentLegArrivalInput>;
  /** Detail of shipment commercial invoices including List of invoices with their items and compliance details. */
  commercialInvoiceDetail?: InputMaybe<ShipmentCommercialInvoiceDetailInput>;
  /** List of invoices with their items and compliance details. */
  commercialInvoices?: InputMaybe<Array<ShipmentCommercialInvoiceInput>>;
  /** Consignee is the party shown on the bill of lading or air waybill to whom the shipment is consigned */
  consignee?: InputMaybe<ShipmentLegConsigneeInput>;
  /** Containers associated with the shipment. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance associated with the shipment. */
  conveyance?: InputMaybe<ShippingConveyanceInput>;
  /** Departure of the shipment leg. */
  departure?: InputMaybe<ShipmentLegDepartureInput>;
  /** Identification number of the commercial invoices for the purchase orders. */
  invoiceNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Import of Record associated with the shipment */
  ior?: InputMaybe<ShipmentLegIorInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the shipment. */
  masterBills?: InputMaybe<Array<MasterBillInput>>;
  /** Mode of transportation */
  modeOfTransport: ModeOfTransport;
  /** Purchase order (PO) number(s) associated with the shipment. Will be stored in the work order group's tags. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Date by which all the regulatory clearances are expected to be completed. For example, in US this can mean the date by which this shipment will get FCC clearance for Devices shipments. */
  regulatoryReadyDate?: InputMaybe<Scalars['DateTime']>;
  /** Name of the service used for international transportation leg of the shipment. For e.g. EXX_PREMIUM */
  transportationServiceName?: InputMaybe<Scalars['String']>;
};

export type ShipmentLegIor = {
  __typename?: 'ShipmentLegIor';
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Ior party info which is stored in the record */
  ior?: Maybe<Ior>;
  /** Importer of Record Number */
  iorNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCode?: Maybe<Scalars['VendorCode']>;
};

export type ShipmentLegIorInput = {
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Ior party info which is stored in the record */
  ior?: InputMaybe<IdInput>;
  /** Importer of Record Number */
  iorNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCode?: InputMaybe<Scalars['VendorCode']>;
};

export type ShipmentManufacturer = {
  __typename?: 'ShipmentManufacturer';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Manufacturer party info which is stored in the record */
  manufacturer?: Maybe<Supplier>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentManufacturerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Manufacturer party info which is stored in the record */
  manufacturer?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipmentProcessingRequestDocument = {
  __typename?: 'ShipmentProcessingRequestDocument';
  /** External document references. */
  documentTags?: Maybe<Array<DocumentTag>>;
  /** External document references. */
  externalDocumentReference?: Maybe<ExternalDocumentReference>;
  /** Extraction results provided in form of reference. */
  extractionReference?: Maybe<ExtractionReference>;
  /** Reason for extraction failure */
  failureReason?: Maybe<Scalars['String']>;
  /** Processing status of the document */
  status?: Maybe<ShipmentDocumentProcessingStatus>;
};

export type ShipmentProcessingRequestDocumentInput = {
  /** External document references. */
  documentTags?: InputMaybe<Array<DocumentTag>>;
  /** External document references. */
  externalDocumentReference?: InputMaybe<ExternalDocumentReferenceInput>;
  /** Extraction results provided in form of reference. */
  extractionReference?: InputMaybe<ExtractionReferenceInput>;
  /** Reason for extraction failure */
  failureReason?: InputMaybe<Scalars['String']>;
  /** Processing status of the document */
  status?: InputMaybe<ShipmentDocumentProcessingStatus>;
};

/** Captures the manufacture details of a product encompassed within the shipment. */
export type ShipmentProductManufacturer = {
  __typename?: 'ShipmentProductManufacturer';
  /** The address of manufacturer of product encompassed within the shipment. */
  address?: Maybe<Address>;
  /** The name of manufacturer of product encompassed within the shipment. */
  name?: Maybe<Scalars['String']>;
};

export type ShipmentProductManufacturerInput = {
  /** The address of manufacturer of product encompassed within the shipment. */
  address?: InputMaybe<AddressInput>;
  /** The name of manufacturer of product encompassed within the shipment. */
  name?: InputMaybe<Scalars['String']>;
};

export type ShipmentSearchCriteriaInput = {
  /** The agent's name. */
  agent?: InputMaybe<TextSearchCriteriaInput>;
  /** Badges related to a shipment e.g. HOT, PREMIUM */
  badge?: InputMaybe<ShipmentBadgeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipment commercial invoice detail id. */
  commercialInvoiceDetailId?: InputMaybe<IdSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** The container number. */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The broker's ID. */
  customsBrokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The broker's name. */
  customsBrokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the Delivery Order for this shipment */
  deliveryOrderDeadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The status for the Delivery Order for this shipment */
  deliveryOrderStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The deadline for the entry for this shipment */
  entryDeadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The status for the entry for this shipment */
  entryStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<UsCbpEntryTypeCodeSearchCriteriaInput>;
  /** The arrival time for the shipment */
  eta?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The country code from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The country name from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The Forwarder's ID. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Forwarder's name. */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Shipment's Friendly ID */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number. */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Date of the import */
  importDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the In-Bond for this shipment */
  inBondDeadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** In-bond number */
  inBondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The status for the In-Bond for this shipment */
  inBondStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The importer of record's name. */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The deadline for the ISF for this shipment */
  isfDeadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The status for the ISF for this shipment */
  isfStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The latest milestone on this shipment */
  latestMilestone?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number. */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Mode Of Transport. */
  modeOfTransport?: InputMaybe<ModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Booking ID of the original booking corresponding to split booking in AMP2.0 project */
  originalBookingId?: InputMaybe<TextSearchCriteriaInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDisposition?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Service type for AMP2.0 bookings, defaults to STANDARD for non-AMP2.0 bookings */
  placementType?: InputMaybe<PlacementTypeSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the shipment. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port where shipment gets loaded in departure country. */
  portOfLadingName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port where cargo is discharged in arrival country. */
  portOfUnladingName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** Product Details like Product ID:Version:Quantity */
  productDetail?: InputMaybe<TextSearchCriteriaInput>;
  /** The release status of the entry */
  releaseDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDisposition?: InputMaybe<TextSearchCriteriaInput>;
  /** The release status of the entry */
  releaseStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The shipper's ID. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The shipper's name. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** The status of a shipment e.g. ACTIVE, CANCELED */
  status?: InputMaybe<ShipmentStatusSearchCriteriaInput>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The work order group's ID. If set, no other criteria can be set. */
  workOrderGroupId?: InputMaybe<IdIndexSearchCriteriaInput>;
};

/** Represents search tables in the UI. */
export type ShipmentSearchTableRow = RecordSearchTableRow & {
  __typename?: 'ShipmentSearchTableRow';
  /** The agent's name. */
  agent?: Maybe<Scalars['String']>;
  /** Badges related to a shipment e.g. HOT, PREMIUM */
  badge?: Maybe<Array<ShipmentBadge>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** The shipment commercial invoice detail id. */
  commercialInvoiceDetailId?: Maybe<Scalars['ID']>;
  /** The container number. */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The brokers's Id. */
  customsBrokerId?: Maybe<Scalars['ID']>;
  /** The broker's name. */
  customsBrokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The deadline for the Delivery Order for this shipment */
  deliveryOrderDeadline?: Maybe<Scalars['String']>;
  /** The status for the Delivery Order for this shipment */
  deliveryOrderStatus?: Maybe<Scalars['String']>;
  /** The deadline for the entry for this shipment */
  entryDeadline?: Maybe<Scalars['String']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** The status for the entry for this shipment */
  entryStatus?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: Maybe<Scalars['String']>;
  /** The country code from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country name from which the articles were shipped to the destination country having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: Maybe<Scalars['String']>;
  /** The forwarder's name. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Shipment's Friendly ID */
  friendlyId: Scalars['ID'];
  /** House bill of lading number. */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Date of the import */
  importDate?: Maybe<Scalars['String']>;
  /** The deadline for the In-Bond for this shipment */
  inBondDeadline?: Maybe<Scalars['String']>;
  /** In-bond number */
  inBondNumber?: Maybe<Array<Scalars['String']>>;
  /** The status for the In-Bond for this shipment */
  inBondStatus?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The importer of record's name. */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** The deadline for the ISF for this shipment */
  isfDeadline?: Maybe<Scalars['String']>;
  /** The status for the ISF for this shipment */
  isfStatus?: Maybe<Scalars['String']>;
  /** The latest milestone on this shipment */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<Array<LoadType>>;
  /** Master bill of lading number. */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The Mode Of Transport. */
  modeOfTransport?: Maybe<Array<Scalars['String']>>;
  /** Booking ID of the original booking corresponding to split booking in AMP2.0 project */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDisposition?: Maybe<Array<Scalars['String']>>;
  /** Service type for AMP2.0 bookings, defaults to STANDARD for non-AMP2.0 bookings */
  placementType?: Maybe<PlacementType>;
  /** Purchase order (PO) number(s) associated with the shipment. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port where shipment gets loaded in departure country. */
  portOfLadingName?: Maybe<Scalars['String']>;
  /** The port where cargo is discharged in arrival country. */
  portOfUnladingName?: Maybe<Scalars['String']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: Maybe<Scalars['String']>;
  /** Product Details like Product ID:Version:Quantity */
  productDetail?: Maybe<Array<Scalars['String']>>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: Maybe<Scalars['String']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDisposition?: Maybe<Array<Scalars['String']>>;
  /** The release status of the entry */
  releaseStatus?: Maybe<Scalars['String']>;
  /** The shipper's name. */
  shipperName: Scalars['String'];
  /** The status of a shipment e.g. ACTIVE, CANCELED */
  status?: Maybe<Scalars['String']>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ShipmentSeller = {
  __typename?: 'ShipmentSeller';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** EORI (Economic Operators Registration and Identification number) */
  eori?: Maybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Seller party info which is stored in the record */
  seller?: Maybe<Supplier>;
  tags?: Maybe<Array<Tag>>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: Maybe<Scalars['SupportedCountryVatNumber']>;
};

export type ShipmentSellerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** EORI (Economic Operators Registration and Identification number) */
  eori?: InputMaybe<Scalars['SupportedCountryEori']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Seller party info which is stored in the record */
  seller?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /**
   * Unique number that identifies a taxable person (business) or non-taxable legal
   * entity that is registered for VAT.
   */
  vatNumber?: InputMaybe<Scalars['SupportedCountryVatNumber']>;
};

export type ShipmentShipTo = {
  __typename?: 'ShipmentShipTo';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** ShipTo party info which is stored in the record */
  shipTo?: Maybe<Facility>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentShipToInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** ShipTo party info which is stored in the record */
  shipTo?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipmentShipper = {
  __typename?: 'ShipmentShipper';
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Shipper party info which is stored in the record */
  shipper: Shipper;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentShipperInput = {
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Shipper party info which is stored in the record */
  shipper: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
};

/** The status of a shipment e.g. ACTIVE, CANCELED */
export enum ShipmentStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED'
}

/** The status of a shipment e.g. ACTIVE, CANCELED */
export type ShipmentStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ShipmentStatus>>;
};

export type ShipmentStuffingLocation = {
  __typename?: 'ShipmentStuffingLocation';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** StuffingLocation party info which is stored in the record */
  stuffingLocation?: Maybe<StuffingLocation>;
  tags?: Maybe<Array<Tag>>;
};

export type ShipmentStuffingLocationInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** StuffingLocation party info which is stored in the record */
  stuffingLocation?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Captures the shipment tariff information of the product. */
export type ShipmentTariff = {
  __typename?: 'ShipmentTariff';
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
};

export type ShipmentTariffInput = {
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
};

/** Work Order search results for shipment work order types. */
export type ShipmentWorkOrderSearchTableRow = {
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type ShipmentsConnection = Connection & {
  __typename?: 'ShipmentsConnection';
  edges: Array<ShipmentEdge>;
  nodes: Array<Shipment>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type Shipper = Account & BillingParty & Customer & Party & ProductOwner & Record & {
  __typename?: 'Shipper';
  /** Account details */
  accountDetails?: Maybe<AccountDetails>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Billing related details. */
  billingDetails?: Maybe<BillingDetails>;
  /** A Broker linked to this Shipper */
  broker: ShipperBrokerRelationship;
  /** Brokers linked to this Shipper. */
  brokers: ShipperBrokersConnection;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** A Customs Agent linked to this Shipper */
  customsAgent: ShipperCustomsAgentRelationship;
  /** Customs Agents linked to this Shipper. */
  customsAgents: ShipperCustomsAgentsConnection;
  /** A DE Consignee linked to this Shipper */
  deConsignee: ShipperDeConsigneeRelationship;
  /** DE Consignees linked to this Shipper. */
  deConsignees: ShipperDeConsigneesConnection;
  /** A De Customs Broker linked to this Shipper */
  deCustomsBroker: ShipperDeCustomsBrokerRelationship;
  /** De Customs Brokers linked to this Shipper. */
  deCustomsBrokers: ShipperDeCustomsBrokersConnection;
  /** A DE IOR linked to this Shipper */
  deIor: ShipperDeIorRelationship;
  /** DE IORs linked to this Shipper. */
  deIors: ShipperDeIorsConnection;
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: Maybe<CustomerDefaultWorkOrdersConfig>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the Shipper. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Facilitys linked to this Shipper. */
  facilities: ShipperFacilitysConnection;
  /** A Facility linked to this Shipper */
  facility: ShipperFacilityRelationship;
  /** A Freight Forwarder linked to this Shipper */
  forwarder: ShipperForwarderRelationship;
  /** Freight Forwarders linked to this Shipper. */
  forwarders: ShipperForwardersConnection;
  /** A FR Consignee linked to this Shipper */
  frConsignee: ShipperFrConsigneeRelationship;
  /** FR Consignees linked to this Shipper. */
  frConsignees: ShipperFrConsigneesConnection;
  /** A FR Customs Broker linked to this Shipper */
  frCustomsBroker: ShipperFrCustomsBrokerRelationship;
  /** FR Customs Brokers linked to this Shipper. */
  frCustomsBrokers: ShipperFrCustomsBrokersConnection;
  /** A FR IOR linked to this Shipper */
  frIor: ShipperFrIorRelationship;
  /** FR IORs linked to this Shipper. */
  frIors: ShipperFrIorsConnection;
  /** Friendly ID generated by CBMS */
  friendlyId: Scalars['ID'];
  /** A GB Consignee linked to this Shipper */
  gbConsignee: ShipperGbConsigneeRelationship;
  /** GB Consignees linked to this Shipper. */
  gbConsignees: ShipperGbConsigneesConnection;
  /** A GB IOR linked to this Shipper */
  gbIor: ShipperGbIorRelationship;
  /** GB IORs linked to this Shipper. */
  gbIors: ShipperGbIorsConnection;
  /** A Global Consignee linked to this Shipper */
  globalConsignee: ShipperGlobalConsigneeRelationship;
  /** Global Consignees linked to this Shipper. */
  globalConsignees: ShipperGlobalConsigneesConnection;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** A Importer linked to this Shipper */
  importer: ShipperImporterRelationship;
  /** Importers linked to this Shipper. */
  importers: ShipperImportersConnection;
  /** The Forwarder that has invited this Shipper to the CBMS platform. */
  invitingParty?: Maybe<Forwarder>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** A NL Consignee linked to this Shipper */
  nlConsignee: ShipperNlConsigneeRelationship;
  /** NL Consignees linked to this Shipper. */
  nlConsignees: ShipperNlConsigneesConnection;
  /** A NL Customs Broker linked to this Shipper */
  nlCustomsBroker: ShipperNlCustomsBrokerRelationship;
  /** NL Customs Brokers linked to this Shipper. */
  nlCustomsBrokers: ShipperNlCustomsBrokersConnection;
  /** A NL IOR linked to this Shipper */
  nlIor: ShipperNlIorRelationship;
  /** NL IORs linked to this Shipper. */
  nlIors: ShipperNlIorsConnection;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** The configuration for this party's product library */
  productLibraryConfiguration?: Maybe<ProductLibraryConfiguration>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: Maybe<CustomerSelfFiledWorkOrdersConfig>;
  /** An array of seller details coming from an external source */
  shipperExternallySourcedDetails?: Maybe<Array<ShipperExternallySourcedDetails>>;
  /** The status of a Shipper e.g. ACTIVE, CANCELED */
  status?: Maybe<ShipperStatus>;
  /** A Supplier linked to this Shipper */
  supplier: ShipperSupplierRelationship;
  /** Suppliers linked to this Shipper. */
  suppliers: ShipperSuppliersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** A Trucker linked to this Shipper */
  trucker: ShipperTruckerRelationship;
  /** Truckers linked to this Shipper. */
  truckers: ShipperTruckersConnection;
  /** A UK Customs Broker linked to this Shipper */
  ukCustomsBroker: ShipperUkCustomsBrokerRelationship;
  /** UK Customs Brokers linked to this Shipper. */
  ukCustomsBrokers: ShipperUkCustomsBrokersConnection;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** A US Consignee linked to this Shipper */
  usConsignee: ShipperUsConsigneeRelationship;
  /** US Consignees linked to this Shipper. */
  usConsignees: ShipperUsConsigneesConnection;
  /** A US Customs Broker linked to this Shipper */
  usCustomsBroker: ShipperUsCustomsBrokerRelationship;
  /** US Customs Brokers linked to this Shipper. */
  usCustomsBrokers: ShipperUsCustomsBrokersConnection;
  /** A US IOR linked to this Shipper */
  usIor: ShipperUsIorRelationship;
  /** US IORs linked to this Shipper. */
  usIors: ShipperUsIorsConnection;
  /** The record's version */
  version: Scalars['Int'];
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: Maybe<ShipperWorkOrderConfig>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: Maybe<Array<ShipperWorkOrderConfirmationConfiguration>>;
};


export type ShipperbrokerArgs = {
  brokerId: Scalars['ID'];
};


export type ShipperbrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippercustomsAgentArgs = {
  customsAgentId: Scalars['ID'];
};


export type ShippercustomsAgentsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperdeConsigneeArgs = {
  deConsigneeId: Scalars['ID'];
};


export type ShipperdeConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperdeCustomsBrokerArgs = {
  deCustomsBrokerId: Scalars['ID'];
};


export type ShipperdeCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperdeIorArgs = {
  deIorId: Scalars['ID'];
};


export type ShipperdeIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ShipperfacilitiesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperfacilityArgs = {
  facilityId: Scalars['ID'];
};


export type ShipperforwarderArgs = {
  forwarderId: Scalars['ID'];
};


export type ShipperforwardersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperfrConsigneeArgs = {
  frConsigneeId: Scalars['ID'];
};


export type ShipperfrConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperfrCustomsBrokerArgs = {
  frCustomsBrokerId: Scalars['ID'];
};


export type ShipperfrCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperfrIorArgs = {
  frIorId: Scalars['ID'];
};


export type ShipperfrIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippergbConsigneeArgs = {
  gbConsigneeId: Scalars['ID'];
};


export type ShippergbConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippergbIorArgs = {
  gbIorId: Scalars['ID'];
};


export type ShippergbIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperglobalConsigneeArgs = {
  globalConsigneeId: Scalars['ID'];
};


export type ShipperglobalConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperimporterArgs = {
  importerId: Scalars['ID'];
};


export type ShipperimportersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ShippernlConsigneeArgs = {
  nlConsigneeId: Scalars['ID'];
};


export type ShippernlConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippernlCustomsBrokerArgs = {
  nlCustomsBrokerId: Scalars['ID'];
};


export type ShippernlCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippernlIorArgs = {
  nlIorId: Scalars['ID'];
};


export type ShippernlIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippersupplierArgs = {
  supplierId: Scalars['ID'];
};


export type ShippersuppliersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShippertruckerArgs = {
  truckerId: Scalars['ID'];
};


export type ShippertruckersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperukCustomsBrokerArgs = {
  ukCustomsBrokerId: Scalars['ID'];
};


export type ShipperukCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperusConsigneeArgs = {
  usConsigneeId: Scalars['ID'];
};


export type ShipperusConsigneesArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperusCustomsBrokerArgs = {
  usCustomsBrokerId: Scalars['ID'];
};


export type ShipperusCustomsBrokersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};


export type ShipperusIorArgs = {
  usIorId: Scalars['ID'];
};


export type ShipperusIorsArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type ShipperBrokerEdge = ConnectionEdge & {
  __typename?: 'ShipperBrokerEdge';
  cursor: Scalars['ID'];
  /** The linked Broker. */
  node?: Maybe<Broker>;
  /** The data on the link between the Shipper and Broker. */
  relationship?: Maybe<ShipperBrokerRelationship>;
};

export type ShipperBrokerRelationship = Record & {
  __typename?: 'ShipperBrokerRelationship';
  /** The linked Broker. */
  broker: Broker;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperBrokersConnection = Connection & {
  __typename?: 'ShipperBrokersConnection';
  edges: Array<ShipperBrokerEdge>;
  nodes: Array<Broker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperCustomsAgentEdge = ConnectionEdge & {
  __typename?: 'ShipperCustomsAgentEdge';
  cursor: Scalars['ID'];
  /** The linked Customs Agent. */
  node?: Maybe<CustomsAgent>;
  /** The data on the link between the Shipper and Customs Agent. */
  relationship?: Maybe<ShipperCustomsAgentRelationship>;
};

export type ShipperCustomsAgentRelationship = Record & {
  __typename?: 'ShipperCustomsAgentRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The linked Customs Agent. */
  customsAgent: CustomsAgent;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperCustomsAgentsConnection = Connection & {
  __typename?: 'ShipperCustomsAgentsConnection';
  edges: Array<ShipperCustomsAgentEdge>;
  nodes: Array<CustomsAgent>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperCustomsDeclarationConfig = CustomerCustomsDeclarationConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperCustomsDeclarationConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ShipperCustomsDeclarationConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ShipperDeConsigneeEdge = ConnectionEdge & {
  __typename?: 'ShipperDeConsigneeEdge';
  cursor: Scalars['ID'];
  /** The linked DE Consignee. */
  node?: Maybe<DeConsignee>;
  /** The data on the link between the Shipper and DE Consignee. */
  relationship?: Maybe<ShipperDeConsigneeRelationship>;
};

export type ShipperDeConsigneeRelationship = Record & {
  __typename?: 'ShipperDeConsigneeRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The linked DE Consignee. */
  deConsignee: DeConsignee;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperDeConsigneesConnection = Connection & {
  __typename?: 'ShipperDeConsigneesConnection';
  edges: Array<ShipperDeConsigneeEdge>;
  nodes: Array<DeConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperDeCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'ShipperDeCustomsBrokerEdge';
  cursor: Scalars['ID'];
  /** The linked De Customs Broker. */
  node?: Maybe<DeCustomsBroker>;
  /** The data on the link between the Shipper and De Customs Broker. */
  relationship?: Maybe<ShipperDeCustomsBrokerRelationship>;
};

export type ShipperDeCustomsBrokerRelationship = Record & {
  __typename?: 'ShipperDeCustomsBrokerRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The linked De Customs Broker. */
  deCustomsBroker: DeCustomsBroker;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperDeCustomsBrokersConnection = Connection & {
  __typename?: 'ShipperDeCustomsBrokersConnection';
  edges: Array<ShipperDeCustomsBrokerEdge>;
  nodes: Array<DeCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperDeCustomsEntryConfig = CustomerDeCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperDeCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ShipperDeCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ShipperDeIorEdge = ConnectionEdge & {
  __typename?: 'ShipperDeIorEdge';
  cursor: Scalars['ID'];
  /** The linked DE IOR. */
  node?: Maybe<DeIor>;
  /** The data on the link between the Shipper and DE IOR. */
  relationship?: Maybe<ShipperDeIorRelationship>;
};

export type ShipperDeIorRelationship = Record & {
  __typename?: 'ShipperDeIorRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The linked DE IOR. */
  deIor: DeIor;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperDeIorsConnection = Connection & {
  __typename?: 'ShipperDeIorsConnection';
  edges: Array<ShipperDeIorEdge>;
  nodes: Array<DeIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperDeliveryOrderConfig = CustomerDeliveryOrderConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperDeliveryOrderConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** A boolean field indicating if a delivery order is required for a shipper once an entry has been released */
  required?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<DeliveryOrderServiceLevelAgreement>>;
};

export type ShipperDeliveryOrderConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** A boolean field indicating if a delivery order is required for a shipper once an entry has been released */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<DeliveryOrderServiceLevelAgreementInput>>;
};

export type ShipperEdge = ConnectionEdge & {
  __typename?: 'ShipperEdge';
  cursor: Scalars['ID'];
  node: Shipper;
};

/** External source of details for a shipper */
export enum ShipperExternalDetailsSource {
  AFT = 'AFT'
}

/** Details about seller/shipper fetched from an external source */
export type ShipperExternallySourcedDetails = {
  __typename?: 'ShipperExternallySourcedDetails';
  /** Seller/Shipper Id (External Reference Id) */
  externalReferenceId: Scalars['String'];
  /** Seller/Shipper Friendly Name */
  friendlyName?: Maybe<Scalars['String']>;
  /** Seller/Shipper Legal Name */
  legalName: Scalars['String'];
  /** Seller/Shipper MarketPlace Id */
  marketPlaceId: Scalars['String'];
  /** Source of this data point */
  source?: Maybe<ShipperExternalDetailsSource>;
};

/** Details about seller/shipper fetched from an external source */
export type ShipperExternallySourcedDetailsInput = {
  /** Seller/Shipper Id (External Reference Id) */
  externalReferenceId: Scalars['String'];
  /** Seller/Shipper Friendly Name */
  friendlyName?: InputMaybe<Scalars['String']>;
  /** Seller/Shipper Legal Name */
  legalName: Scalars['String'];
  /** Seller/Shipper MarketPlace Id */
  marketPlaceId: Scalars['String'];
  /** Source of this data point */
  source?: InputMaybe<ShipperExternalDetailsSource>;
};

export type ShipperFacilityEdge = ConnectionEdge & {
  __typename?: 'ShipperFacilityEdge';
  cursor: Scalars['ID'];
  /** The linked Facility. */
  node?: Maybe<Facility>;
  /** The data on the link between the Shipper and Facility. */
  relationship?: Maybe<ShipperFacilityRelationship>;
};

export type ShipperFacilityRelationship = Record & {
  __typename?: 'ShipperFacilityRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked Facility. */
  facility: Facility;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperFacilitysConnection = Connection & {
  __typename?: 'ShipperFacilitysConnection';
  edges: Array<ShipperFacilityEdge>;
  nodes: Array<Facility>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperForwarderEdge = ConnectionEdge & {
  __typename?: 'ShipperForwarderEdge';
  cursor: Scalars['ID'];
  /** The linked Freight Forwarder. */
  node?: Maybe<Forwarder>;
  /** The data on the link between the Shipper and Freight Forwarder. */
  relationship?: Maybe<ShipperForwarderRelationship>;
};

export type ShipperForwarderRelationship = Record & {
  __typename?: 'ShipperForwarderRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked Freight Forwarder. */
  forwarder: Forwarder;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperForwardersConnection = Connection & {
  __typename?: 'ShipperForwardersConnection';
  edges: Array<ShipperForwarderEdge>;
  nodes: Array<Forwarder>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperFrConsigneeEdge = ConnectionEdge & {
  __typename?: 'ShipperFrConsigneeEdge';
  cursor: Scalars['ID'];
  /** The linked FR Consignee. */
  node?: Maybe<FrConsignee>;
  /** The data on the link between the Shipper and FR Consignee. */
  relationship?: Maybe<ShipperFrConsigneeRelationship>;
};

export type ShipperFrConsigneeRelationship = Record & {
  __typename?: 'ShipperFrConsigneeRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked FR Consignee. */
  frConsignee: FrConsignee;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperFrConsigneesConnection = Connection & {
  __typename?: 'ShipperFrConsigneesConnection';
  edges: Array<ShipperFrConsigneeEdge>;
  nodes: Array<FrConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperFrCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'ShipperFrCustomsBrokerEdge';
  cursor: Scalars['ID'];
  /** The linked FR Customs Broker. */
  node?: Maybe<FrCustomsBroker>;
  /** The data on the link between the Shipper and FR Customs Broker. */
  relationship?: Maybe<ShipperFrCustomsBrokerRelationship>;
};

export type ShipperFrCustomsBrokerRelationship = Record & {
  __typename?: 'ShipperFrCustomsBrokerRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked FR Customs Broker. */
  frCustomsBroker: FrCustomsBroker;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperFrCustomsBrokersConnection = Connection & {
  __typename?: 'ShipperFrCustomsBrokersConnection';
  edges: Array<ShipperFrCustomsBrokerEdge>;
  nodes: Array<FrCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperFrCustomsEntryConfig = CustomerFrCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperFrCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ShipperFrCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ShipperFrIorEdge = ConnectionEdge & {
  __typename?: 'ShipperFrIorEdge';
  cursor: Scalars['ID'];
  /** The linked FR IOR. */
  node?: Maybe<FrIor>;
  /** The data on the link between the Shipper and FR IOR. */
  relationship?: Maybe<ShipperFrIorRelationship>;
};

export type ShipperFrIorRelationship = Record & {
  __typename?: 'ShipperFrIorRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked FR IOR. */
  frIor: FrIor;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperFrIorsConnection = Connection & {
  __typename?: 'ShipperFrIorsConnection';
  edges: Array<ShipperFrIorEdge>;
  nodes: Array<FrIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperGbConsigneeEdge = ConnectionEdge & {
  __typename?: 'ShipperGbConsigneeEdge';
  cursor: Scalars['ID'];
  /** The linked GB Consignee. */
  node?: Maybe<GbConsignee>;
  /** The data on the link between the Shipper and GB Consignee. */
  relationship?: Maybe<ShipperGbConsigneeRelationship>;
};

export type ShipperGbConsigneeRelationship = Record & {
  __typename?: 'ShipperGbConsigneeRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked GB Consignee. */
  gbConsignee: GbConsignee;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperGbConsigneesConnection = Connection & {
  __typename?: 'ShipperGbConsigneesConnection';
  edges: Array<ShipperGbConsigneeEdge>;
  nodes: Array<GbConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperGbCustomsEntryConfig = CustomerGbCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperGbCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ShipperGbCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ShipperGbIorEdge = ConnectionEdge & {
  __typename?: 'ShipperGbIorEdge';
  cursor: Scalars['ID'];
  /** The linked GB IOR. */
  node?: Maybe<GbIor>;
  /** The data on the link between the Shipper and GB IOR. */
  relationship?: Maybe<ShipperGbIorRelationship>;
};

export type ShipperGbIorRelationship = Record & {
  __typename?: 'ShipperGbIorRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked GB IOR. */
  gbIor: GbIor;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperGbIorsConnection = Connection & {
  __typename?: 'ShipperGbIorsConnection';
  edges: Array<ShipperGbIorEdge>;
  nodes: Array<GbIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperGlobalConsigneeEdge = ConnectionEdge & {
  __typename?: 'ShipperGlobalConsigneeEdge';
  cursor: Scalars['ID'];
  /** The linked Global Consignee. */
  node?: Maybe<GlobalConsignee>;
  /** The data on the link between the Shipper and Global Consignee. */
  relationship?: Maybe<ShipperGlobalConsigneeRelationship>;
};

export type ShipperGlobalConsigneeRelationship = Record & {
  __typename?: 'ShipperGlobalConsigneeRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The linked Global Consignee. */
  globalConsignee: GlobalConsignee;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperGlobalConsigneesConnection = Connection & {
  __typename?: 'ShipperGlobalConsigneesConnection';
  edges: Array<ShipperGlobalConsigneeEdge>;
  nodes: Array<GlobalConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperImporterEdge = ConnectionEdge & {
  __typename?: 'ShipperImporterEdge';
  cursor: Scalars['ID'];
  /** The linked Importer. */
  node?: Maybe<Importer>;
  /** The data on the link between the Shipper and Importer. */
  relationship?: Maybe<ShipperImporterRelationship>;
};

export type ShipperImporterRelationship = Record & {
  __typename?: 'ShipperImporterRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Importer. */
  importer: Importer;
  /** The shipper role on the Importer */
  role?: Maybe<ShipperImporterRole>;
  /** The linked Shipper. */
  shipper: Shipper;
  /** Importer~Shipper relationship status */
  status?: Maybe<ImporterShipperRelationshipStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperImporterRelationshipInput = {
  /** The shipper role on the Importer */
  role?: InputMaybe<ShipperImporterRole>;
  /** Importer~Shipper relationship status */
  status?: InputMaybe<ImporterShipperRelationshipStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Shippers role on Importer */
export enum ShipperImporterRole {
  CONSUMER = 'CONSUMER',
  OWNER = 'OWNER'
}

export type ShipperImportersConnection = Connection & {
  __typename?: 'ShipperImportersConnection';
  edges: Array<ShipperImporterEdge>;
  nodes: Array<Importer>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperNlConsigneeEdge = ConnectionEdge & {
  __typename?: 'ShipperNlConsigneeEdge';
  cursor: Scalars['ID'];
  /** The linked NL Consignee. */
  node?: Maybe<NlConsignee>;
  /** The data on the link between the Shipper and NL Consignee. */
  relationship?: Maybe<ShipperNlConsigneeRelationship>;
};

export type ShipperNlConsigneeRelationship = Record & {
  __typename?: 'ShipperNlConsigneeRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked NL Consignee. */
  nlConsignee: NlConsignee;
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperNlConsigneesConnection = Connection & {
  __typename?: 'ShipperNlConsigneesConnection';
  edges: Array<ShipperNlConsigneeEdge>;
  nodes: Array<NlConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperNlCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'ShipperNlCustomsBrokerEdge';
  cursor: Scalars['ID'];
  /** The linked NL Customs Broker. */
  node?: Maybe<NlCustomsBroker>;
  /** The data on the link between the Shipper and NL Customs Broker. */
  relationship?: Maybe<ShipperNlCustomsBrokerRelationship>;
};

export type ShipperNlCustomsBrokerRelationship = Record & {
  __typename?: 'ShipperNlCustomsBrokerRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked NL Customs Broker. */
  nlCustomsBroker: NlCustomsBroker;
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperNlCustomsBrokersConnection = Connection & {
  __typename?: 'ShipperNlCustomsBrokersConnection';
  edges: Array<ShipperNlCustomsBrokerEdge>;
  nodes: Array<NlCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperNlCustomsEntryConfig = CustomerNlCustomsEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperNlCustomsEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<CustomsEntryServiceLevelAgreement>>;
};

export type ShipperNlCustomsEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<CustomsEntryServiceLevelAgreementInput>>;
};

export type ShipperNlIorEdge = ConnectionEdge & {
  __typename?: 'ShipperNlIorEdge';
  cursor: Scalars['ID'];
  /** The linked NL IOR. */
  node?: Maybe<NlIor>;
  /** The data on the link between the Shipper and NL IOR. */
  relationship?: Maybe<ShipperNlIorRelationship>;
};

export type ShipperNlIorRelationship = Record & {
  __typename?: 'ShipperNlIorRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked NL IOR. */
  nlIor: NlIor;
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperNlIorsConnection = Connection & {
  __typename?: 'ShipperNlIorsConnection';
  edges: Array<ShipperNlIorEdge>;
  nodes: Array<NlIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The party's AR customer id */
  arCustomerId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Country code (ISO 3166) that the AR customer has been onboarded to */
  arOnboardingCountry?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Customs Broker's ID */
  customsBrokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** Customs Broker's name */
  customsBrokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Shipper's friendly ID */
  friendlyId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the party that invited this party to CBMS. */
  invitingPartyId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The status of a Shipper e.g. ACTIVE, CANCELED */
  status?: InputMaybe<ShipperStatusSearchCriteriaInput>;
  /** The party's subscription plan */
  subscriptionPlan?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type ShipperSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'ShipperSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** The party's AR customer id */
  arCustomerId?: Maybe<Scalars['String']>;
  /** Country code (ISO 3166) that the AR customer has been onboarded to */
  arOnboardingCountry?: Maybe<Array<Scalars['CountryCode']>>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Customs Broker's ID */
  customsBrokerId?: Maybe<Array<Scalars['ID']>>;
  /** Customs Broker's name */
  customsBrokerName?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Forwarder's ID */
  forwarderId?: Maybe<Array<Scalars['ID']>>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Shipper's friendly ID */
  friendlyId?: Maybe<Scalars['ID']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The ID of the party that invited this party to CBMS. */
  invitingPartyId?: Maybe<Scalars['ID']>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The status of a Shipper e.g. ACTIVE, CANCELED */
  status?: Maybe<Scalars['String']>;
  /** The party's subscription plan */
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** The status of a Shipper e.g. ACTIVE, CANCELED */
export enum ShipperStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED'
}

/** The status of a Shipper e.g. ACTIVE, CANCELED */
export type ShipperStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<ShipperStatus>>;
};

export type ShipperSupplierEdge = ConnectionEdge & {
  __typename?: 'ShipperSupplierEdge';
  cursor: Scalars['ID'];
  /** The linked Supplier. */
  node?: Maybe<Supplier>;
  /** The data on the link between the Shipper and Supplier. */
  relationship?: Maybe<ShipperSupplierRelationship>;
};

export type ShipperSupplierRelationship = Record & {
  __typename?: 'ShipperSupplierRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The parties are related */
  related?: Maybe<Scalars['Boolean']>;
  /** The linked Shipper. */
  shipper: Shipper;
  /** The linked Supplier. */
  supplier: Supplier;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperSupplierRelationshipInput = {
  /** The parties are related */
  related?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type ShipperSuppliersConnection = Connection & {
  __typename?: 'ShipperSuppliersConnection';
  edges: Array<ShipperSupplierEdge>;
  nodes: Array<Supplier>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** External Client's Shipper System */
export type ShipperSystem = ExternalClient & ExternalSystem & Record & {
  __typename?: 'ShipperSystem';
  /** API Authorization Details. */
  authorization?: Maybe<ApiAuthorization>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration: ExternalSystemAwsIntegrationDetails;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: Maybe<ExternalSystemIntegrationDetails>;
  /** Unique ID */
  id: Scalars['ID'];
  /** External client name. */
  name: Scalars['String'];
  /** Notification preferences for the external system. */
  notifications: Array<ExternalSystemNotificationPreference>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Shipper associated with the system. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** URL to recieve events via webhook. */
  webhookUrl?: Maybe<Scalars['URL']>;
};

export type ShipperSystemEdge = ConnectionEdge & {
  __typename?: 'ShipperSystemEdge';
  cursor: Scalars['ID'];
  node: ShipperSystem;
};

export type ShipperSystemSearchCriteriaInput = {
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: InputMaybe<AwsAccountIdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Notification preference for external system */
  externalSystemNotificationTypes?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The AWS IAM Role Name assumed by the External System to sign requests to the CBMS API. */
  iamRoleName?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External System. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** External Client's Shipper System */
export type ShipperSystemSearchTableRow = ExternalSystemSearchTableRow & RecordSearchTableRow & {
  __typename?: 'ShipperSystemSearchTableRow';
  /** AWS Account id of the External System which is granted permission to call CBMS API. */
  accountId?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the External System. */
  name?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ShipperSystemsConnection = Connection & {
  __typename?: 'ShipperSystemsConnection';
  edges: Array<ShipperSystemEdge>;
  nodes: Array<ShipperSystem>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperTruckerEdge = ConnectionEdge & {
  __typename?: 'ShipperTruckerEdge';
  cursor: Scalars['ID'];
  /** The linked Trucker. */
  node?: Maybe<Trucker>;
  /** The data on the link between the Shipper and Trucker. */
  relationship?: Maybe<ShipperTruckerRelationship>;
};

export type ShipperTruckerRelationship = Record & {
  __typename?: 'ShipperTruckerRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The linked Trucker. */
  trucker: Trucker;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperTruckersConnection = Connection & {
  __typename?: 'ShipperTruckersConnection';
  edges: Array<ShipperTruckerEdge>;
  nodes: Array<Trucker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperUkCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'ShipperUkCustomsBrokerEdge';
  cursor: Scalars['ID'];
  /** The linked UK Customs Broker. */
  node?: Maybe<UkCustomsBroker>;
  /** The data on the link between the Shipper and UK Customs Broker. */
  relationship?: Maybe<ShipperUkCustomsBrokerRelationship>;
};

export type ShipperUkCustomsBrokerRelationship = Record & {
  __typename?: 'ShipperUkCustomsBrokerRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The linked UK Customs Broker. */
  ukCustomsBroker: UkCustomsBroker;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperUkCustomsBrokersConnection = Connection & {
  __typename?: 'ShipperUkCustomsBrokersConnection';
  edges: Array<ShipperUkCustomsBrokerEdge>;
  nodes: Array<UkCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperUsConsigneeEdge = ConnectionEdge & {
  __typename?: 'ShipperUsConsigneeEdge';
  cursor: Scalars['ID'];
  /** The linked US Consignee. */
  node?: Maybe<UsConsignee>;
  /** The data on the link between the Shipper and US Consignee. */
  relationship?: Maybe<ShipperUsConsigneeRelationship>;
};

export type ShipperUsConsigneeRelationship = Record & {
  __typename?: 'ShipperUsConsigneeRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The linked US Consignee. */
  usConsignee: UsConsignee;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperUsConsigneesConnection = Connection & {
  __typename?: 'ShipperUsConsigneesConnection';
  edges: Array<ShipperUsConsigneeEdge>;
  nodes: Array<UsConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperUsConsumptionEntryConfig = CustomerUsConsumptionEntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperUsConsumptionEntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsConsumptionEntryServiceLevelAgreement>>;
};

export type ShipperUsConsumptionEntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsConsumptionEntryServiceLevelAgreementInput>>;
};

export type ShipperUsCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'ShipperUsCustomsBrokerEdge';
  cursor: Scalars['ID'];
  /** The linked US Customs Broker. */
  node?: Maybe<UsCustomsBroker>;
  /** The data on the link between the Shipper and US Customs Broker. */
  relationship?: Maybe<ShipperUsCustomsBrokerRelationship>;
};

export type ShipperUsCustomsBrokerRelationship = Record & {
  __typename?: 'ShipperUsCustomsBrokerRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The linked US Customs Broker. */
  usCustomsBroker: UsCustomsBroker;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperUsCustomsBrokersConnection = Connection & {
  __typename?: 'ShipperUsCustomsBrokersConnection';
  edges: Array<ShipperUsCustomsBrokerEdge>;
  nodes: Array<UsCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperUsIorContinuousBondRequestConfig = CustomerUsIorContinuousBondRequestConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperUsIorContinuousBondRequestConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsIorContinuousBondRequestServiceLevelAgreement>>;
};

export type ShipperUsIorContinuousBondRequestConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsIorContinuousBondRequestServiceLevelAgreementInput>>;
};

export type ShipperUsIorEdge = ConnectionEdge & {
  __typename?: 'ShipperUsIorEdge';
  cursor: Scalars['ID'];
  /** The linked US IOR. */
  node?: Maybe<UsIor>;
  /** The data on the link between the Shipper and US IOR. */
  relationship?: Maybe<ShipperUsIorRelationship>;
};

export type ShipperUsIorRelationship = Record & {
  __typename?: 'ShipperUsIorRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Shipper. */
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The linked US IOR. */
  usIor: UsIor;
  /** The record's version */
  version: Scalars['Int'];
};

export type ShipperUsIorsConnection = Connection & {
  __typename?: 'ShipperUsIorsConnection';
  edges: Array<ShipperUsIorEdge>;
  nodes: Array<UsIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShipperUsIsfConfig = CustomerUsIsfConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperUsIsfConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsIsfServiceLevelAgreement>>;
};

export type ShipperUsIsfConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsIsfServiceLevelAgreementInput>>;
};

export type ShipperUsType86EntryConfig = CustomerUsType86EntryConfig & CustomerWorkOrderConfigDetails & {
  __typename?: 'ShipperUsType86EntryConfig';
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: Maybe<Array<AutoSetReadyRequirements>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: Maybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: Maybe<Array<UsType86EntryServiceLevelAgreement>>;
};

export type ShipperUsType86EntryConfigInput = {
  /** Pre-requisites for auto marking the entries as ready */
  autoSetReadyRequirements?: InputMaybe<Array<AutoSetReadyRequirementsInput>>;
  /** A boolean value to show if customer wants to auto set this work order type to READY status on creation */
  autoSetReadyStatus?: InputMaybe<Scalars['Boolean']>;
  /** Custom SLA for the work order */
  serviceLevelAgreements?: InputMaybe<Array<UsType86EntryServiceLevelAgreementInput>>;
};

/** User of a Shipper. */
export type ShipperUser = ExternalClient & Record & User & {
  __typename?: 'ShipperUser';
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: Maybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: Maybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: Maybe<Scalars['Boolean']>;
  /** User details from the Cognito User Pool. */
  cognito?: Maybe<CognitoUserDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the ShipperUser. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Identity information provided by an external IDP such as Auth Portal */
  identity?: Maybe<Identity>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: Maybe<Scalars['Boolean']>;
  /** Link returned to the user after they have created a new account, granting the ability to reset their password and login for the first time. */
  loginLink?: Maybe<Scalars['URL']>;
  /** A mobile phone number. */
  mobilePhone?: Maybe<Phone>;
  /** External client name. */
  name: Scalars['String'];
  /** The shipper's notification preferences. */
  notifications: Array<ShipperUserNotificationPreference>;
  /** A office phone number. */
  officePhone?: Maybe<Phone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The shipper's permission. */
  permissions?: Maybe<ShipperUserPermissions>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: Maybe<Scalars['Boolean']>;
  shipper: Shipper;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The teams the user is on */
  teams?: Maybe<Array<Team>>;
  /** Title of the user */
  title: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** User of a Shipper. */
export type ShipperUserdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ShipperUserBulkChargesUploadRequestPermission = {
  __typename?: 'ShipperUserBulkChargesUploadRequestPermission';
  /** The name of permission. */
  name: ShipperUserBulkChargesUploadRequestPermissionName;
};

export enum ShipperUserBulkChargesUploadRequestPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ShipperUserBulkChargesUploadRequestPermissionNameInput = {
  /** The name of permission. */
  name: ShipperUserBulkChargesUploadRequestPermissionName;
};

export type ShipperUserBulkComplianceUploadRequestPermission = {
  __typename?: 'ShipperUserBulkComplianceUploadRequestPermission';
  /** The name of permission. */
  name: ShipperUserBulkComplianceUploadRequestPermissionName;
};

export type ShipperUserBulkComplianceUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserBulkComplianceUploadRequestPermissionName;
};

export enum ShipperUserBulkComplianceUploadRequestPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ShipperUserBulkMilestoneUploadRequestPermission = {
  __typename?: 'ShipperUserBulkMilestoneUploadRequestPermission';
  /** The name of permission. */
  name: ShipperUserBulkMilestoneUploadRequestPermissionName;
};

export type ShipperUserBulkMilestoneUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserBulkMilestoneUploadRequestPermissionName;
};

export enum ShipperUserBulkMilestoneUploadRequestPermissionName {
  NO_ACCESS = 'NO_ACCESS'
}

export type ShipperUserBulkProductUploadTemplateDocumentGenerationRequestPermission = {
  __typename?: 'ShipperUserBulkProductUploadTemplateDocumentGenerationRequestPermission';
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserBulkProductUploadTemplateDocumentGenerationRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserCompanyPermission = {
  __typename?: 'ShipperUserCompanyPermission';
  /** The name of permission. */
  name: ShipperUserCompanyPermissionName;
};

export type ShipperUserCompanyPermissionInput = {
  /** The name of permission. */
  name: ShipperUserCompanyPermissionName;
};

export enum ShipperUserCompanyPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserCustomsAgentPermission = {
  __typename?: 'ShipperUserCustomsAgentPermission';
  /** The name of permission. */
  name: ShipperUserCustomsAgentPermissionName;
};

export type ShipperUserCustomsAgentPermissionInput = {
  /** The name of permission. */
  name: ShipperUserCustomsAgentPermissionName;
};

export enum ShipperUserCustomsAgentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserCustomsBrokerPermission = {
  __typename?: 'ShipperUserCustomsBrokerPermission';
  /** The name of permission. */
  name: ShipperUserCustomsBrokerPermissionName;
};

export type ShipperUserCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: ShipperUserCustomsBrokerPermissionName;
};

export enum ShipperUserCustomsBrokerPermissionName {
  READ = 'READ'
}

export type ShipperUserDeCustomsEntryPermission = {
  __typename?: 'ShipperUserDeCustomsEntryPermission';
  /** The name of permission. */
  name: ShipperUserDeCustomsEntryPermissionName;
};

export type ShipperUserDeCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ShipperUserDeCustomsEntryPermissionName;
};

export enum ShipperUserDeCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserDeliveryOrderPermission = {
  __typename?: 'ShipperUserDeliveryOrderPermission';
  /** The name of permission. */
  name: ShipperUserDeliveryOrderPermissionName;
};

export type ShipperUserDeliveryOrderPermissionInput = {
  /** The name of permission. */
  name: ShipperUserDeliveryOrderPermissionName;
};

export enum ShipperUserDeliveryOrderPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserDocumentPermission = {
  __typename?: 'ShipperUserDocumentPermission';
  /** The name of permission. */
  name: ShipperUserDocumentPermissionName;
};

export type ShipperUserDocumentPermissionInput = {
  /** The name of permission. */
  name: ShipperUserDocumentPermissionName;
};

export enum ShipperUserDocumentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserDocumentTemplatePermission = {
  __typename?: 'ShipperUserDocumentTemplatePermission';
  /** The name of permission. */
  name: ShipperUserDocumentTemplatePermissionName;
};

export type ShipperUserDocumentTemplatePermissionInput = {
  /** The name of permission. */
  name: ShipperUserDocumentTemplatePermissionName;
};

export enum ShipperUserDocumentTemplatePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserEdge = ConnectionEdge & {
  __typename?: 'ShipperUserEdge';
  cursor: Scalars['ID'];
  node: ShipperUser;
};

export type ShipperUserFacilityPermission = {
  __typename?: 'ShipperUserFacilityPermission';
  /** The name of permission. */
  name: ShipperUserFacilityPermissionName;
};

export type ShipperUserFacilityPermissionInput = {
  /** The name of permission. */
  name: ShipperUserFacilityPermissionName;
};

export enum ShipperUserFacilityPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserForwarderPermission = {
  __typename?: 'ShipperUserForwarderPermission';
  /** The name of permission. */
  name: ShipperUserForwarderPermissionName;
};

export type ShipperUserForwarderPermissionInput = {
  /** The name of permission. */
  name: ShipperUserForwarderPermissionName;
};

export enum ShipperUserForwarderPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserFrCustomsEntryPermission = {
  __typename?: 'ShipperUserFrCustomsEntryPermission';
  /** The name of permission. */
  name: ShipperUserFrCustomsEntryPermissionName;
};

export type ShipperUserFrCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ShipperUserFrCustomsEntryPermissionName;
};

export enum ShipperUserFrCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserGbCustomsEntryPermission = {
  __typename?: 'ShipperUserGbCustomsEntryPermission';
  /** The name of permission. */
  name: ShipperUserGbCustomsEntryPermissionName;
};

export type ShipperUserGbCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ShipperUserGbCustomsEntryPermissionName;
};

export enum ShipperUserGbCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserImportProductsFromBulkUploadRequestPermission = {
  __typename?: 'ShipperUserImportProductsFromBulkUploadRequestPermission';
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserImportProductsFromBulkUploadRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserImportProductsFromCustomsEntriesRequestPermission = {
  __typename?: 'ShipperUserImportProductsFromCustomsEntriesRequestPermission';
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserImportProductsFromCustomsEntriesRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserImporterEntityPermission = {
  __typename?: 'ShipperUserImporterEntityPermission';
  /** The name of permission. */
  name: ShipperUserImporterEntityPermissionName;
};

export type ShipperUserImporterEntityPermissionInput = {
  /** The name of permission. */
  name: ShipperUserImporterEntityPermissionName;
};

export enum ShipperUserImporterEntityPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserImporterPermission = {
  __typename?: 'ShipperUserImporterPermission';
  /** The name of permission. */
  name: ShipperUserImporterPermissionName;
};

export type ShipperUserImporterPermissionInput = {
  /** The name of permission. */
  name: ShipperUserImporterPermissionName;
};

export enum ShipperUserImporterPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserInvoiceLinesRequestPermission = {
  __typename?: 'ShipperUserInvoiceLinesRequestPermission';
  /** The name of permission. */
  name: ShipperUserInvoiceLinesRequestPermissionName;
};

export type ShipperUserInvoiceLinesRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserInvoiceLinesRequestPermissionName;
};

export enum ShipperUserInvoiceLinesRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserInvoicePermission = {
  __typename?: 'ShipperUserInvoicePermission';
  /** The name of permission. */
  name: ShipperUserInvoicePermissionName;
};

export type ShipperUserInvoicePermissionInput = {
  /** The name of permission. */
  name: ShipperUserInvoicePermissionName;
};

export enum ShipperUserInvoicePermissionName {
  READ = 'READ'
}

export type ShipperUserNlCustomsEntryPermission = {
  __typename?: 'ShipperUserNlCustomsEntryPermission';
  /** The name of permission. */
  name: ShipperUserNlCustomsEntryPermissionName;
};

export type ShipperUserNlCustomsEntryPermissionInput = {
  /** The name of permission. */
  name: ShipperUserNlCustomsEntryPermissionName;
};

export enum ShipperUserNlCustomsEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

/** The notification method for a shipper user. */
export enum ShipperUserNotificationMethod {
  CBMS_WEBSITE = 'CBMS_WEBSITE',
  EMAIL = 'EMAIL'
}

export type ShipperUserNotificationPreference = {
  __typename?: 'ShipperUserNotificationPreference';
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<ShipperUserNotificationMethod>;
  /** The type of the notification. */
  type: ShipperUserNotificationType;
};

export type ShipperUserNotificationPreferenceInput = {
  /** The allowed method of delivery for the notification. */
  deliveryMethods: Array<ShipperUserNotificationMethod>;
  /** The type of the notification. */
  type: ShipperUserNotificationType;
};

/** The notification type for a shipper user. */
export enum ShipperUserNotificationType {
  BULK_DOCUMENT_DOWNLOAD = 'BULK_DOCUMENT_DOWNLOAD',
  DAILY_STATEMENT = 'DAILY_STATEMENT',
  DO_ISSUED = 'DO_ISSUED',
  ENTRY_CONFIRMATION = 'ENTRY_CONFIRMATION',
  FDA_NOTICE = 'FDA_NOTICE',
  FDA_NOTICE_CLEARED = 'FDA_NOTICE_CLEARED',
  INQUIRE_IOR_DOCUMENT = 'INQUIRE_IOR_DOCUMENT',
  INQUIRE_SHIPMENT_DOCUMENT = 'INQUIRE_SHIPMENT_DOCUMENT',
  IOR_ACTIVATED = 'IOR_ACTIVATED',
  MONTHLY_DUTY_REPORT = 'MONTHLY_DUTY_REPORT',
  MONTHLY_STATEMENT = 'MONTHLY_STATEMENT',
  PMS_APPROVED = 'PMS_APPROVED',
  POA_REMINDER = 'POA_REMINDER',
  REJECT_IOR_DOCUMENT = 'REJECT_IOR_DOCUMENT',
  REJECT_SHIPMENT_DOCUMENT = 'REJECT_SHIPMENT_DOCUMENT',
  REQUEST_SHIPMENT_DOCUMENTS = 'REQUEST_SHIPMENT_DOCUMENTS',
  SHIPMENT_CANCELED = 'SHIPMENT_CANCELED',
  SHIPMENT_CREATED = 'SHIPMENT_CREATED',
  SHIPMENT_CREATED_NO_ACTION = 'SHIPMENT_CREATED_NO_ACTION',
  SHIPMENT_FORWARDER_TAGGED = 'SHIPMENT_FORWARDER_TAGGED',
  SHIPMENT_UPDATED = 'SHIPMENT_UPDATED',
  TRUCKER_NOTES = 'TRUCKER_NOTES',
  USER_INVITED = 'USER_INVITED',
  USER_INVITE_ACCEPTED = 'USER_INVITE_ACCEPTED',
  US_CONSUMPTION_ENTRY_CBP_EXAM = 'US_CONSUMPTION_ENTRY_CBP_EXAM',
  US_CONSUMPTION_ENTRY_CBP_HOLD = 'US_CONSUMPTION_ENTRY_CBP_HOLD',
  US_CONSUMPTION_ENTRY_CBP_RELEASE = 'US_CONSUMPTION_ENTRY_CBP_RELEASE',
  US_CONSUMPTION_ENTRY_FILED = 'US_CONSUMPTION_ENTRY_FILED',
  US_CONSUMPTION_ENTRY_PGA_HOLD = 'US_CONSUMPTION_ENTRY_PGA_HOLD',
  US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_CONSUMPTION_ENTRY_PGA_REJECTED = 'US_CONSUMPTION_ENTRY_PGA_REJECTED',
  US_CONSUMPTION_ENTRY_PGA_RELEASE = 'US_CONSUMPTION_ENTRY_PGA_RELEASE',
  US_CONSUMPTION_ENTRY_REVISED = 'US_CONSUMPTION_ENTRY_REVISED',
  US_CONTINUOUS_BOND_ONBOARDING = 'US_CONTINUOUS_BOND_ONBOARDING',
  US_IN_BOND_ARRIVED = 'US_IN_BOND_ARRIVED',
  US_IN_BOND_AUTHORIZED = 'US_IN_BOND_AUTHORIZED',
  US_IN_BOND_BILL_ARRIVED = 'US_IN_BOND_BILL_ARRIVED',
  US_IN_BOND_BILL_EXPORTED = 'US_IN_BOND_BILL_EXPORTED',
  US_IN_BOND_CONTAINER_ARRIVED = 'US_IN_BOND_CONTAINER_ARRIVED',
  US_IN_BOND_CONTAINER_EXPORTED = 'US_IN_BOND_CONTAINER_EXPORTED',
  US_IN_BOND_DIVERSION = 'US_IN_BOND_DIVERSION',
  US_IN_BOND_TRANSFERRED = 'US_IN_BOND_TRANSFERRED',
  US_IOR_ADDRESS_MISMATCH = 'US_IOR_ADDRESS_MISMATCH',
  US_ISF_BILL_MATCH = 'US_ISF_BILL_MATCH',
  US_ISF_FILED = 'US_ISF_FILED',
  US_ISF_NO_BILL_MATCH = 'US_ISF_NO_BILL_MATCH',
  US_ISF_REJECTED = 'US_ISF_REJECTED',
  US_POST_SUMMARY_CORRECTION_APPROVED = 'US_POST_SUMMARY_CORRECTION_APPROVED',
  US_POST_SUMMARY_CORRECTION_CREATED = 'US_POST_SUMMARY_CORRECTION_CREATED',
  US_POST_SUMMARY_CORRECTION_FILED = 'US_POST_SUMMARY_CORRECTION_FILED',
  US_POST_SUMMARY_CORRECTION_REJECTED = 'US_POST_SUMMARY_CORRECTION_REJECTED',
  US_POST_SUMMARY_CORRECTION_SUBMITTED = 'US_POST_SUMMARY_CORRECTION_SUBMITTED',
  US_TYPE86_ENTRY_CBP_EXAM = 'US_TYPE86_ENTRY_CBP_EXAM',
  US_TYPE86_ENTRY_CBP_HOLD = 'US_TYPE86_ENTRY_CBP_HOLD',
  US_TYPE86_ENTRY_CBP_RELEASE = 'US_TYPE86_ENTRY_CBP_RELEASE',
  US_TYPE86_ENTRY_FILED = 'US_TYPE86_ENTRY_FILED',
  US_TYPE86_ENTRY_PGA_HOLD = 'US_TYPE86_ENTRY_PGA_HOLD',
  US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_TYPE86_ENTRY_PGA_REJECTED = 'US_TYPE86_ENTRY_PGA_REJECTED',
  US_TYPE86_ENTRY_PGA_RELEASE = 'US_TYPE86_ENTRY_PGA_RELEASE',
  WORK_ORDER_GROUP_INVOICE_CREATED = 'WORK_ORDER_GROUP_INVOICE_CREATED',
  WORK_ORDER_GROUP_INVOICE_VOIDED = 'WORK_ORDER_GROUP_INVOICE_VOIDED'
}

export type ShipperUserPermissions = {
  __typename?: 'ShipperUserPermissions';
  /** The Shipper's permission to bulkChargesUploadRequest. */
  bulkChargesUploadRequest?: Maybe<Array<ShipperUserBulkChargesUploadRequestPermission>>;
  /** The Shipper's permission to bulkComplianceUploadRequest. */
  bulkComplianceUploadRequest?: Maybe<Array<ShipperUserBulkComplianceUploadRequestPermission>>;
  /** The Shipper's permission to bulkMilestoneUploadRequest. */
  bulkMilestoneUploadRequest?: Maybe<Array<ShipperUserBulkMilestoneUploadRequestPermission>>;
  /** The Shipper's permission to BulkProductUploadTemplateDocumentGenerationRequest. */
  bulkProductUploadTemplateDocumentGenerationRequest?: Maybe<Array<ShipperUserBulkProductUploadTemplateDocumentGenerationRequestPermission>>;
  /** The Shipper's permission to Shipper. */
  company?: Maybe<Array<ShipperUserCompanyPermission>>;
  /** The Shipper's permission to CustomsAgent. */
  customsAgent?: Maybe<Array<ShipperUserCustomsAgentPermission>>;
  /** The Shipper's permission to CustomsBroker. */
  customsBroker?: Maybe<Array<ShipperUserCustomsBrokerPermission>>;
  /** The Shipper's permission to DeCustomsEntry. */
  deCustomsEntry?: Maybe<Array<ShipperUserDeCustomsEntryPermission>>;
  /** The Shipper's permission to DeliveryOrder. */
  deliveryOrder?: Maybe<Array<ShipperUserDeliveryOrderPermission>>;
  /** The Shipper's permission to Document. */
  document?: Maybe<Array<ShipperUserDocumentPermission>>;
  /** The Shipper's permission to DocumentTemplate. */
  documentTemplate?: Maybe<Array<ShipperUserDocumentTemplatePermission>>;
  /** The Shipper's permission to Facility. */
  facility?: Maybe<Array<ShipperUserFacilityPermission>>;
  /** The Shipper's permission to Forwarder. */
  forwarder?: Maybe<Array<ShipperUserForwarderPermission>>;
  /** The Shipper's permission to FrCustomsEntry. */
  frCustomsEntry?: Maybe<Array<ShipperUserFrCustomsEntryPermission>>;
  /** The Shipper's permission to GbCustomsEntry. */
  gbCustomsEntry?: Maybe<Array<ShipperUserGbCustomsEntryPermission>>;
  /** The Shipper's permission to ImportProductsFromBulkUploadRequest. */
  importProductsFromBulkUploadRequest?: Maybe<Array<ShipperUserImportProductsFromBulkUploadRequestPermission>>;
  /** The Shipper's permission to ImportProductsFromCustomsEntriesRequest. */
  importProductsFromCustomsEntriesRequest?: Maybe<Array<ShipperUserImportProductsFromCustomsEntriesRequestPermission>>;
  /** The Shipper's permission to Importer. */
  importer?: Maybe<Array<ShipperUserImporterPermission>>;
  /** The Shipper's permission to ImporterEntity. */
  importerEntity?: Maybe<Array<ShipperUserImporterEntityPermission>>;
  /** The Shipper's permission to Invoice. */
  invoice?: Maybe<Array<ShipperUserInvoicePermission>>;
  /** The Shipper's permission to InvoiceLinesRequest. */
  invoiceLinesRequest?: Maybe<Array<ShipperUserInvoiceLinesRequestPermission>>;
  /** The Shipper's permission to NlCustomsEntry. */
  nlCustomsEntry?: Maybe<Array<ShipperUserNlCustomsEntryPermission>>;
  /** The Shipper's permission to Product. */
  product?: Maybe<Array<ShipperUserProductPermission>>;
  /** The Shipper's permission to ReleaseNote. */
  releaseNote?: Maybe<Array<ShipperUserReleaseNotePermission>>;
  /** The Shipper's permission to Shipment. */
  shipment?: Maybe<Array<ShipperUserShipmentPermission>>;
  /** The Shipper's permission to User. */
  shipperUser?: Maybe<Array<ShipperUserShipperUserPermission>>;
  /** The Shipper's permission to Supplier. */
  supplier?: Maybe<Array<ShipperUserSupplierPermission>>;
  /** The Shipper's permission to Trucker. */
  trucker?: Maybe<Array<ShipperUserSupplierPermission>>;
  /** The Shipper's permission to UsConsignee. */
  usConsignee?: Maybe<Array<ShipperUserUsConsigneePermission>>;
  /** The Shipper's permission to UsConsumptionEntry. */
  usConsumptionEntry?: Maybe<Array<ShipperUserUsConsumptionEntryPermission>>;
  /** The Shipper's permission to UsCustomsBroker. */
  usCustomsBroker?: Maybe<Array<ShipperUserUsCustomsBrokerPermission>>;
  /** The Shipper's permission to UsDrawbackClaim. */
  usDrawbackClaim?: Maybe<Array<ShipperUserUsDrawbackClaimPermission>>;
  /** The Shipper's permission to UsInBond. */
  usInBond?: Maybe<Array<ShipperUserUsInBondPermission>>;
  /** The Shipper's permission to UsIor. */
  usIor?: Maybe<Array<ShipperUserUsIorPermission>>;
  /** The Shipper's permission to UsIorActivation. */
  usIorActivation?: Maybe<Array<ShipperUserUsIorActivationPermission>>;
  /** The Shipper's permission to UsIorContinuousBondRequest. */
  usIorContinuousBondRequest?: Maybe<Array<ShipperUserUsIorContinuousBondRequestPermission>>;
  /** The Shipper's permission to UsIsf. */
  usIsf?: Maybe<Array<ShipperUserUsIsfPermission>>;
  /** The Shipper's permission to UsPostSummaryCorrection. */
  usPostSummaryCorrection?: Maybe<Array<ShipperUserPostSummaryCorrectionPermission>>;
  /** The Shipper's permission to UsType86Entry. */
  usType86Entry?: Maybe<Array<ShipperUserUsType86EntryPermission>>;
  /** The Shipper's permission to UserReleaseNoteView. */
  userReleaseNoteView?: Maybe<Array<ShipperUserUserReleaseNoteViewPermission>>;
};

export type ShipperUserPermissionsInput = {
  /** The Shipper's permission to bulkChargesUploadRequest. */
  bulkChargesUploadRequest?: InputMaybe<Array<ShipperUserBulkChargesUploadRequestPermissionNameInput>>;
  /** The Shipper's permission to bulkComplianceUploadRequest. */
  bulkComplianceUploadRequest?: InputMaybe<Array<ShipperUserBulkComplianceUploadRequestPermissionInput>>;
  /** The Shipper's permission to bulkMilestoneUploadRequest. */
  bulkMilestoneUploadRequest?: InputMaybe<Array<ShipperUserBulkMilestoneUploadRequestPermissionInput>>;
  /** The Shipper's permission to BulkProductUploadTemplateDocumentGenerationRequest. */
  bulkProductUploadTemplateDocumentGenerationRequest?: InputMaybe<Array<ShipperUserBulkProductUploadTemplateDocumentGenerationRequestPermissionInput>>;
  /** The Shipper's permission to Shipper. */
  company?: InputMaybe<Array<ShipperUserCompanyPermissionInput>>;
  /** The Shipper's permission to CustomsAgent. */
  customsAgent?: InputMaybe<Array<ShipperUserCustomsAgentPermissionInput>>;
  /** The Shipper's permission to CustomsBroker. */
  customsBroker?: InputMaybe<Array<ShipperUserCustomsBrokerPermissionInput>>;
  /** The Shipper's permission to DeCustomsEntry. */
  deCustomsEntry?: InputMaybe<Array<ShipperUserDeCustomsEntryPermissionInput>>;
  /** The Shipper's permission to DeliveryOrder. */
  deliveryOrder?: InputMaybe<Array<ShipperUserDeliveryOrderPermissionInput>>;
  /** The Shipper's permission to Document. */
  document?: InputMaybe<Array<ShipperUserDocumentPermissionInput>>;
  /** The Shipper's permission to DocumentTemplate. */
  documentTemplate?: InputMaybe<Array<ShipperUserDocumentTemplatePermissionInput>>;
  /** The Shipper's permission to Facility. */
  facility?: InputMaybe<Array<ShipperUserFacilityPermissionInput>>;
  /** The Shipper's permission to Forwarder. */
  forwarder?: InputMaybe<Array<ShipperUserForwarderPermissionInput>>;
  /** The Shipper's permission to FrCustomsEntry. */
  frCustomsEntry?: InputMaybe<Array<ShipperUserFrCustomsEntryPermissionInput>>;
  /** The Shipper's permission to GbCustomsEntry. */
  gbCustomsEntry?: InputMaybe<Array<ShipperUserGbCustomsEntryPermissionInput>>;
  /** The Shipper's permission to ImportProductsFromBulkUploadRequest. */
  importProductsFromBulkUploadRequest?: InputMaybe<Array<ShipperUserImportProductsFromBulkUploadRequestPermissionInput>>;
  /** The Shipper's permission to ImportProductsFromCustomsEntriesRequest. */
  importProductsFromCustomsEntriesRequest?: InputMaybe<Array<ShipperUserImportProductsFromCustomsEntriesRequestPermissionInput>>;
  /** The Shipper's permission to Importer. */
  importer?: InputMaybe<Array<ShipperUserImporterPermissionInput>>;
  /** The Shipper's permission to ImporterEntity. */
  importerEntity?: InputMaybe<Array<ShipperUserImporterEntityPermissionInput>>;
  /** The Shipper's permission to Invoice. */
  invoice?: InputMaybe<Array<ShipperUserInvoicePermissionInput>>;
  /** The Shipper's permission to InvoiceLinesRequest. */
  invoiceLinesRequest?: InputMaybe<Array<ShipperUserInvoiceLinesRequestPermissionInput>>;
  /** The Shipper's permission to NlCustomsEntry. */
  nlCustomsEntry?: InputMaybe<Array<ShipperUserNlCustomsEntryPermissionInput>>;
  /** The Shipper's permission to Product. */
  product?: InputMaybe<Array<ShipperUserProductPermissionInput>>;
  /** The Shipper's permission to ReleaseNote. */
  releaseNote?: InputMaybe<Array<ShipperUserReleaseNotePermissionInput>>;
  /** The Shipper's permission to Shipment. */
  shipment?: InputMaybe<Array<ShipperUserShipmentPermissionInput>>;
  /** The Shipper's permission to User. */
  shipperUser?: InputMaybe<Array<ShipperUserShipperUserPermissionInput>>;
  /** The Shipper's permission to Supplier. */
  supplier?: InputMaybe<Array<ShipperUserSupplierPermissionInput>>;
  /** The Shipper's permission to Trucker. */
  trucker?: InputMaybe<Array<ShipperUserSupplierPermissionInput>>;
  /** The Shipper's permission to UsConsignee. */
  usConsignee?: InputMaybe<Array<ShipperUserUsConsigneePermissionInput>>;
  /** The Shipper's permission to UsConsumptionEntry. */
  usConsumptionEntry?: InputMaybe<Array<ShipperUserUsConsumptionEntryPermissionInput>>;
  /** The Shipper's permission to UsCustomsBroker. */
  usCustomsBroker?: InputMaybe<Array<ShipperUserUsCustomsBrokerPermissionInput>>;
  /** The Shipper's permission to UsDrawbackClaim. */
  usDrawbackClaim?: InputMaybe<Array<ShipperUserUsDrawbackClaimPermissionInput>>;
  /** The Shipper's permission to UsInBond. */
  usInBond?: InputMaybe<Array<ShipperUserUsInBondPermissionInput>>;
  /** The Shipper's permission to UsIor. */
  usIor?: InputMaybe<Array<ShipperUserUsIorPermissionInput>>;
  /** The Shipper's permission to UsIorActivation. */
  usIorActivation?: InputMaybe<Array<ShipperUserUsIorActivationPermissionInput>>;
  /** The Shipper's permission to UsIorContinuousBondRequest. */
  usIorContinuousBondRequest?: InputMaybe<Array<ShipperUserUsIorContinuousBondRequestPermissionInput>>;
  /** The Shipper's permission to UsIsf. */
  usIsf?: InputMaybe<Array<ShipperUserUsIsfPermissionInput>>;
  /** The Shipper's permission to UsPostSummaryCorrection. */
  usPostSummaryCorrection?: InputMaybe<Array<ShipperUserPostSummaryCorrectionPermissionInput>>;
  /** The Shipper's permission to UsType86Entry. */
  usType86Entry?: InputMaybe<Array<ShipperUserUsType86EntryPermissionInput>>;
  /** The Shipper's permission to UserReleaseNoteView. */
  userReleaseNoteView?: InputMaybe<Array<ShipperUserUserReleaseNoteViewPermissionInput>>;
};

export type ShipperUserPostSummaryCorrectionPermission = {
  __typename?: 'ShipperUserPostSummaryCorrectionPermission';
  /** The name of permission. */
  name: ShipperUserUsPostSummaryCorrectionPermissionName;
};

export type ShipperUserPostSummaryCorrectionPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsPostSummaryCorrectionPermissionName;
};

export type ShipperUserProductPermission = {
  __typename?: 'ShipperUserProductPermission';
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export type ShipperUserProductPermissionInput = {
  /** The name of permission. */
  name: ShipperUserProductPermissionName;
};

export enum ShipperUserProductPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserReleaseNotePermission = {
  __typename?: 'ShipperUserReleaseNotePermission';
  /** The name of permission. */
  name: ShipperUserReleaseNotePermissionName;
};

export type ShipperUserReleaseNotePermissionInput = {
  /** The name of permission. */
  name: ShipperUserReleaseNotePermissionName;
};

export enum ShipperUserReleaseNotePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserSearchCriteriaInput = {
  /** The User's Cognito Identity ID. */
  cognitoId?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's email. */
  email?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Whether or not a User is logged in. */
  loggedIn?: InputMaybe<BooleanSearchCriteriaInput>;
  /** The name of the User. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Shipper's ID. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Shipper's name. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The IDs of the teams the user is on */
  teamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the teams the user is on */
  teamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The title of the User. */
  title?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's unique identifier provided by an IDP. */
  userIdentifier?: InputMaybe<IdIndexSearchCriteriaInput>;
};

/** Shipper user's table search row. */
export type ShipperUserSearchTableRow = RecordSearchTableRow & UserSearchTableRow & {
  __typename?: 'ShipperUserSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The User's email. */
  email?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether or not a User is logged in. */
  loggedIn?: Maybe<Scalars['Boolean']>;
  /** Whether or not a User has Multi-Factor Authentication (MFA) enabled. */
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  /** The name of the User. */
  name?: Maybe<Scalars['String']>;
  /** The shipper's name. */
  shipperName?: Maybe<Scalars['String']>;
  /** The IDs of the teams the user is on */
  teamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the teams the user is on */
  teamName?: Maybe<Array<Scalars['String']>>;
  /** The title of the User. */
  title?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type ShipperUserShipmentPermission = {
  __typename?: 'ShipperUserShipmentPermission';
  /** The name of permission. */
  name: ShipperUserShipmentPermissionName;
};

export type ShipperUserShipmentPermissionInput = {
  /** The name of permission. */
  name: ShipperUserShipmentPermissionName;
};

export enum ShipperUserShipmentPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserShipperUserPermission = {
  __typename?: 'ShipperUserShipperUserPermission';
  /** The name of permission. */
  name: ShipperUserShipperUserPermissionName;
};

export type ShipperUserShipperUserPermissionInput = {
  /** The name of permission. */
  name: ShipperUserShipperUserPermissionName;
};

export enum ShipperUserShipperUserPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserSupplierPermission = {
  __typename?: 'ShipperUserSupplierPermission';
  /** The name of permission. */
  name: ShipperUserSupplierPermissionName;
};

export type ShipperUserSupplierPermissionInput = {
  /** The name of permission. */
  name: ShipperUserSupplierPermissionName;
};

export enum ShipperUserSupplierPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsConsigneePermission = {
  __typename?: 'ShipperUserUsConsigneePermission';
  /** The name of permission. */
  name: ShipperUserUsConsigneePermissionName;
};

export type ShipperUserUsConsigneePermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsConsigneePermissionName;
};

export enum ShipperUserUsConsigneePermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsConsumptionEntryPermission = {
  __typename?: 'ShipperUserUsConsumptionEntryPermission';
  /** The name of permission. */
  name: ShipperUserUsConsumptionEntryPermissionName;
};

export type ShipperUserUsConsumptionEntryPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsConsumptionEntryPermissionName;
};

export enum ShipperUserUsConsumptionEntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsCustomsBrokerPermission = {
  __typename?: 'ShipperUserUsCustomsBrokerPermission';
  /** The name of permission. */
  name: ShipperUserUsCustomsBrokerPermissionName;
};

export type ShipperUserUsCustomsBrokerPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsCustomsBrokerPermissionName;
};

export enum ShipperUserUsCustomsBrokerPermissionName {
  READ = 'READ'
}

export type ShipperUserUsDrawbackClaimPermission = {
  __typename?: 'ShipperUserUsDrawbackClaimPermission';
  /** The name of permission. */
  name: ShipperUserUsDrawbackClaimPermissionName;
};

export type ShipperUserUsDrawbackClaimPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsDrawbackClaimPermissionName;
};

export enum ShipperUserUsDrawbackClaimPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsInBondPermission = {
  __typename?: 'ShipperUserUsInBondPermission';
  /** The name of permission. */
  name: ShipperUserUsInBondPermissionName;
};

export type ShipperUserUsInBondPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsInBondPermissionName;
};

export enum ShipperUserUsInBondPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  IN_BOND_DELETE_BILL_CBP_TRANSACTION = 'IN_BOND_DELETE_BILL_CBP_TRANSACTION',
  IN_BOND_DELETE_CBP_TRANSACTION = 'IN_BOND_DELETE_CBP_TRANSACTION',
  IN_BOND_SUBMIT_ACTION_CBP_TRANSACTION = 'IN_BOND_SUBMIT_ACTION_CBP_TRANSACTION',
  IN_BOND_SUBMIT_CBP_TRANSACTION = 'IN_BOND_SUBMIT_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsIorActivationPermission = {
  __typename?: 'ShipperUserUsIorActivationPermission';
  /** The name of permission. */
  name: ShipperUserUsIorActivationPermissionName;
};

export type ShipperUserUsIorActivationPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsIorActivationPermissionName;
};

export enum ShipperUserUsIorActivationPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsIorContinuousBondRequestPermission = {
  __typename?: 'ShipperUserUsIorContinuousBondRequestPermission';
  /** The name of permission. */
  name: ShipperUserUsIorContinuousBondRequestPermissionName;
};

export type ShipperUserUsIorContinuousBondRequestPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsIorContinuousBondRequestPermissionName;
};

export enum ShipperUserUsIorContinuousBondRequestPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsIorPermission = {
  __typename?: 'ShipperUserUsIorPermission';
  /** The name of permission. */
  name: ShipperUserUsIorPermissionName;
};

export type ShipperUserUsIorPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsIorPermissionName;
};

export enum ShipperUserUsIorPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsIsfPermission = {
  __typename?: 'ShipperUserUsIsfPermission';
  /** The name of permission. */
  name: ShipperUserUsIsfPermissionName;
};

export type ShipperUserUsIsfPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsIsfPermissionName;
};

export enum ShipperUserUsIsfPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  CREATE_CBP_TRANSACTION = 'CREATE_CBP_TRANSACTION',
  DELETE = 'DELETE',
  DELETE_CBP_TRANSACTION = 'DELETE_CBP_TRANSACTION',
  READ = 'READ',
  UPDATE = 'UPDATE',
  UPDATE_CBP_TRANSACTION = 'UPDATE_CBP_TRANSACTION'
}

export enum ShipperUserUsPostSummaryCorrectionPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUsType86EntryPermission = {
  __typename?: 'ShipperUserUsType86EntryPermission';
  /** The name of permission. */
  name: ShipperUserUsType86EntryPermissionName;
};

export type ShipperUserUsType86EntryPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUsType86EntryPermissionName;
};

export enum ShipperUserUsType86EntryPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUserUserReleaseNoteViewPermission = {
  __typename?: 'ShipperUserUserReleaseNoteViewPermission';
  /** The name of permission. */
  name: ShipperUserUserReleaseNoteViewPermissionName;
};

export type ShipperUserUserReleaseNoteViewPermissionInput = {
  /** The name of permission. */
  name: ShipperUserUserReleaseNoteViewPermissionName;
};

export enum ShipperUserUserReleaseNoteViewPermissionName {
  ADMIN = 'ADMIN',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type ShipperUsersConnection = Connection & {
  __typename?: 'ShipperUsersConnection';
  edges: Array<ShipperUserEdge>;
  nodes: Array<ShipperUser>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** WorkOrderConfig for the shipper */
export type ShipperWorkOrderConfig = CustomerWorkOrderConfig & {
  __typename?: 'ShipperWorkOrderConfig';
  /** Configuration of Customs Declaration for the customer */
  customsDeclaration?: Maybe<ShipperCustomsDeclarationConfig>;
  /** Configuration of De Customs Entry for the customer */
  deCustomsEntry?: Maybe<ShipperDeCustomsEntryConfig>;
  /** Configuration of delivery order for the customer */
  deliveryOrder?: Maybe<ShipperDeliveryOrderConfig>;
  /** Configuration of Fr Customs Entry for the customer */
  frCustomsEntry?: Maybe<ShipperFrCustomsEntryConfig>;
  /** Configuration of Gb Customs Entry for the customer */
  gbCustomsEntry?: Maybe<ShipperGbCustomsEntryConfig>;
  /** Configuration of Nl Customs Entry for the customer */
  nlCustomsEntry?: Maybe<ShipperNlCustomsEntryConfig>;
  /** Configuration of US Consumption Entry for the customer */
  usConsumptionEntry?: Maybe<ShipperUsConsumptionEntryConfig>;
  /** Configuration of US IOR Continuous Bond Request for the customer */
  usIorContinuousBondRequest?: Maybe<ShipperUsIorContinuousBondRequestConfig>;
  /** Configuration of US Isf for the customer */
  usIsf?: Maybe<ShipperUsIsfConfig>;
  /** Configuration of US Type86 Entry for the customer */
  usType86Entry?: Maybe<ShipperUsType86EntryConfig>;
};

/** WorkOrderConfig for the shipper */
export type ShipperWorkOrderConfigInput = {
  /** Configuration of Customs Declaration for the customer */
  customsDeclaration?: InputMaybe<ShipperCustomsDeclarationConfigInput>;
  /** Configuration of De Customs Entry for the customer */
  deCustomsEntry?: InputMaybe<ShipperDeCustomsEntryConfigInput>;
  /** Configuration of delivery order for the customer */
  deliveryOrder?: InputMaybe<ShipperDeliveryOrderConfigInput>;
  /** Configuration of Fr Customs Entry for the customer */
  frCustomsEntry?: InputMaybe<ShipperFrCustomsEntryConfigInput>;
  /** Configuration of Gb Customs Entry for the customer */
  gbCustomsEntry?: InputMaybe<ShipperGbCustomsEntryConfigInput>;
  /** Configuration of Nl Customs Entry for the customer */
  nlCustomsEntry?: InputMaybe<ShipperNlCustomsEntryConfigInput>;
  /** Configuration of US Consumption Entry for the customer */
  usConsumptionEntry?: InputMaybe<ShipperUsConsumptionEntryConfigInput>;
  /** Configuration of US IOR Continuous Bond Request for the customer */
  usIorContinuousBondRequest?: InputMaybe<ShipperUsIorContinuousBondRequestConfigInput>;
  /** Configuration of US Isf for the customer */
  usIsf?: InputMaybe<ShipperUsIsfConfigInput>;
  /** Configuration of US Type86 Entry for the customer */
  usType86Entry?: InputMaybe<ShipperUsType86EntryConfigInput>;
};

/** Work Order Confirmation Configuration Details. */
export type ShipperWorkOrderConfirmationConfiguration = CustomerWorkOrderConfirmationConfiguration & {
  __typename?: 'ShipperWorkOrderConfirmationConfiguration';
  /** Duration of minutes to wait for the response until auto approve. Never auto approve if not defined. */
  approveAfterMinutes?: Maybe<Scalars['Int']>;
  /** Documents to send along with entry summary confirmation request so the client more information about the entry. */
  includedDocuments?: Maybe<Array<DocumentTag>>;
  /** Whether the shipper is allowed to override its forwarder's work order confirmation configuration. */
  overrideForwarderConfig?: Maybe<Scalars['Boolean']>;
  /** Rules for work order confirmation setting. Always request confirmation if not defined. */
  ruleGroup?: Maybe<BusinessRuleGroup>;
  /** Type of work order associated with the confirmation. */
  workOrderType: WorkOrderType;
};

export type ShippersConnection = Connection & {
  __typename?: 'ShippersConnection';
  edges: Array<ShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type ShippingContainer = {
  __typename?: 'ShippingContainer';
  /** Container description */
  description?: Maybe<Scalars['ContainerDescription']>;
  /** Container external id */
  externalId?: Maybe<Scalars['String']>;
  /** Total container length, in feet. */
  length?: Maybe<Scalars['Float']>;
  /** Container number */
  number?: Maybe<Scalars['String']>;
  /** Type of container used in PGA. Refrigerated or Not Refrigerated */
  pgaType?: Maybe<PgaContainerType>;
  /** Quantity inside of container. It should be the lowest external packaing unit, which is carton quantity. */
  quantity?: Maybe<Scalars['Float']>;
  /** Seal number associated to container */
  seal?: Maybe<Scalars['String']>;
  /** Container type */
  type?: Maybe<Scalars['String']>;
  /** Volume of container in CU_METER */
  volume?: Maybe<Scalars['Float']>;
  /** Weight of container in KG */
  weight?: Maybe<Scalars['Float']>;
};

export type ShippingContainerInput = {
  /** Container description */
  description?: InputMaybe<Scalars['ContainerDescription']>;
  /** Container external id */
  externalId?: InputMaybe<Scalars['String']>;
  /** Total container length, in feet. */
  length?: InputMaybe<Scalars['Float']>;
  /** Container number */
  number?: InputMaybe<Scalars['String']>;
  /** Type of container used in PGA. Refrigerated or Not Refrigerated */
  pgaType?: InputMaybe<PgaContainerType>;
  /** Quantity inside of container. It should be the lowest external packaing unit, which is carton quantity. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** Seal number associated to container */
  seal?: InputMaybe<Scalars['String']>;
  /** Container type */
  type?: InputMaybe<Scalars['String']>;
  /** Volume of container in CU_METER */
  volume?: InputMaybe<Scalars['Float']>;
  /** Weight of container in KG */
  weight?: InputMaybe<Scalars['Float']>;
};

export type ShippingConveyance = {
  __typename?: 'ShippingConveyance';
  /** Whether the goods are containerized. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['ConveyanceName']>;
  /** The gross volume of the shipment in CU_METER. */
  grossVolume?: Maybe<Scalars['Float']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
};

export type ShippingConveyanceInput = {
  /** Whether the goods are containerized. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['ConveyanceName']>;
  /** The gross volume of the shipment in CU_METER. */
  grossVolume?: InputMaybe<Scalars['Float']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type Signature = {
  __typename?: 'Signature';
  /** Signature image */
  image: Document;
  /** printed name for the signature */
  printedName: Scalars['String'];
};

export type SignatureInput = {
  /** Signature image */
  image: IdInput;
  /** printed name for the signature */
  printedName: Scalars['String'];
};

/** Skill level of operator users which will be assigned by managers */
export enum SkillLevel {
  ADVANCED = 'ADVANCED',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE'
}

/** Skill level of operator user. */
export type SkillLevelSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<SkillLevel>>;
};

export type SnsDetails = {
  __typename?: 'SnsDetails';
  /** Subscriber Details */
  subscribers: Array<SnsSubscriber>;
  /** SNS Topic */
  topic: Scalars['SnsArn'];
};

export type SnsDetailsInput = {
  /** Subscriber Details */
  subscribers: Array<SnsSubscriberInput>;
  /** SNS Topic */
  topic: Scalars['SnsArn'];
};

export type SnsSubscriber = {
  __typename?: 'SnsSubscriber';
  /** sns endpoint subscribed to the SNS topic */
  endpoint?: Maybe<Scalars['String']>;
  /** Protocol to use for sns subscription endpoint */
  protocol: SnsSubscriberProtocol;
};

export type SnsSubscriberInput = {
  /** sns endpoint subscribed to the SNS topic */
  endpoint?: InputMaybe<Scalars['String']>;
  /** Protocol to use for sns subscription endpoint */
  protocol: SnsSubscriberProtocol;
};

/** Protocol for SNS subscriber endpoint */
export enum SnsSubscriberProtocol {
  HTTP = 'HTTP',
  HTTPS = 'HTTPS'
}

/** Order for sorting results. */
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Source channel identifier */
export enum SourceChannel {
  SELLER_CENTRAL = 'SELLER_CENTRAL',
  SHIPPER_CENTRAL = 'SHIPPER_CENTRAL'
}

/** Source portal identifier */
export enum SourcePortal {
  AMAZON_SUPPLY_CHAIN_SERVICES = 'AMAZON_SUPPLY_CHAIN_SERVICES',
  SELLER_CENTRAL = 'SELLER_CENTRAL'
}

/** Special Program Indicator https://dataweb.usitc.gov/tariff/programs. */
export type Spi = {
  __typename?: 'Spi';
  /** Unique ID for HTS component. */
  chargeId?: Maybe<Scalars['String']>;
  /** Code used on the entry Line. */
  code: Scalars['String'];
  /** Country of origin SPI is valid for. */
  country?: Maybe<Scalars['CountryCode']>;
  /** End (expiration) date for HTS component. */
  endDate?: Maybe<Scalars['Date']>;
  /** Group of countries the SPI is valid for. */
  group?: Maybe<Scalars['String']>;
  /** Title of the tariff program. */
  name?: Maybe<Scalars['String']>;
  /** Note related to HTS component. */
  note?: Maybe<Scalars['String']>;
  /** Start (effective) date for HTS component. */
  startDate?: Maybe<Scalars['Date']>;
};

export type SpiInput = {
  /** Unique ID for HTS component. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Code used on the entry Line. */
  code: Scalars['String'];
  /** End (expiration) date for HTS component. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Note related to HTS component. */
  note?: InputMaybe<Scalars['String']>;
  /** Start (effective) date for HTS component. */
  startDate?: InputMaybe<Scalars['Date']>;
};

/** Specifies the action that should be taken when parsing spreadsheet data. */
export enum SpreadsheetActionType {
  MERGE = 'MERGE',
  OVERWRITE = 'OVERWRITE',
  SKIP = 'SKIP'
}

/** Co-ordinates of the position in document where stamp needs to be added. */
export type StampCoordinates = {
  __typename?: 'StampCoordinates';
  /** X coordinate of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  xCoordinate: Scalars['Int'];
  /** Y coordinate of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  yCoordinate: Scalars['Int'];
};

/** Co-ordinates of the position in document where stamp needs to be added. */
export type StampCoordinatesInput = {
  /** X coordinate of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  xCoordinate: Scalars['Int'];
  /** Y coordinate of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  yCoordinate: Scalars['Int'];
};

/** Details about the position in the input document where stamped will be added. */
export type StampDimensions = {
  __typename?: 'StampDimensions';
  /** The height of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  height: Scalars['Int'];
  /** The width of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  width: Scalars['Int'];
};

/** Details about the position in the input document where stamped will be added. */
export type StampDimensionsInput = {
  /** The height of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  height: Scalars['Int'];
  /** The width of the stamp in pt(point) format, 1 pt = 1/72 inch. */
  width: Scalars['Int'];
};

/** Create stamp document generation request. */
export type StampDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'StampDocumentGenerationRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** The StampDocumentSignRequest associated with this StampDocumentGenerationRequest. */
  documentSignRequest?: Maybe<StampDocumentSignRequest>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  sourceDocument: Document;
  /** Stamps that needs to added in the document. */
  stamps: Array<DocumentStamp>;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Stamp document sign request. */
export type StampDocumentSignRequest = DocumentSignRequest & Record & {
  __typename?: 'StampDocumentSignRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The sign request expires after the designated amount of minutes. */
  expireAfterMinutes: Scalars['Int'];
  /** The UTC date & time the request will expire. */
  expireTime: Scalars['DateTime'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Data related to the document signature. */
  signature?: Maybe<DocumentSignature>;
  /** The coordinates associated with the document signature. */
  signaturePositions: Array<DocumentSignaturePosition>;
  /** Information about when & where the document sign request was signed. */
  signed?: Maybe<RecordAction>;
  signedDocument?: Maybe<Document>;
  /** Birth date of officer signing the document */
  signerBirthDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Name of officer signing the document. */
  signerName?: Maybe<Scalars['String']>;
  /** Title of officer signing the document. */
  signerTitle?: Maybe<Scalars['String']>;
  sourceDocument: Document;
  /** Status of Document Sign Request */
  status: DocumentSignRequestStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The link provided to clients with the purpose of signing. */
  url: Scalars['String'];
  /** The record's version */
  version: Scalars['Int'];
};

export type StampDocumentSignRequestEdge = ConnectionEdge & {
  __typename?: 'StampDocumentSignRequestEdge';
  cursor: Scalars['ID'];
  node: StampDocumentSignRequest;
};

/** Stamp document sign request search criteria input. */
export type StampDocumentSignRequestSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The document tags. */
  documentTags?: InputMaybe<DocumentTagSearchCritieraInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The document signature types. */
  method?: InputMaybe<DocumentSignatureMethodSearchCritieraInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The id of the signed document associated with the sign request. */
  signedDocumentId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was signed. */
  signedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The name of the user the request was signed by.  */
  signerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the source document associated with the sign request. */
  sourceDocumentId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The document sign request's status. */
  status?: InputMaybe<DocumentSignRequestStatusSearchCritieraInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Stamp document sign request search table row. */
export type StampDocumentSignRequestSearchTableRow = {
  __typename?: 'StampDocumentSignRequestSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The document tags. */
  documentTags?: Maybe<Array<DocumentTag>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The document signature types. */
  method?: Maybe<DocumentSignatureMethod>;
  /** The ID of the signed document. */
  signedDocumentId?: Maybe<Scalars['ID']>;
  /** The time the Record was signed. */
  signedTime?: Maybe<Scalars['DateTime']>;
  /** The name of the user the request was signed by.  */
  signerName?: Maybe<Scalars['String']>;
  /** The ID of the source document. */
  sourceDocumentId: Scalars['ID'];
  /** The document sign request's status. */
  status: DocumentSignRequestStatus;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type StampDocumentSignRequestsConnection = Connection & {
  __typename?: 'StampDocumentSignRequestsConnection';
  edges: Array<StampDocumentSignRequestEdge>;
  nodes: Array<StampDocumentSignRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type StuffingLocation = Facility | Supplier;

export type SubPoaLinks = {
  __typename?: 'SubPoaLinks';
  /** JSON object of captured field values to replace the document template's placeholder variables with. */
  additionalFields: Scalars['JSONObject'];
  /** Link to the signed Master POA document */
  masterPoaLink: Scalars['String'];
  /** ID of the sign request for Sub POA */
  subPoaId: Scalars['String'];
  /** Link to the sign request for Sub POA */
  subPoaLink: Scalars['String'];
};

/** Used to specify categories if this is a SME role */
export enum SubjectMatterCategory {
  AD_CVD = 'AD_CVD',
  CLASSIFICATION = 'CLASSIFICATION',
  COO_FTA = 'COO_FTA',
  MULTIPLE_ISSUES = 'MULTIPLE_ISSUES',
  PGA = 'PGA',
  VALUATION = 'VALUATION'
}

export type SubjectMatterExpertTeam = Record & UserTeam & {
  __typename?: 'SubjectMatterExpertTeam';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Team's customs broker */
  customsBroker?: Maybe<CustomsBroker>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The User Team's name */
  name: Scalars['String'];
  operator: Operator;
  /** A Operator User linked to this SubjectMatterExpertTeam */
  operatorUser: SubjectMatterExpertTeamOperatorUserRelationship;
  /** Operator Users linked to this Subject Matter Expert Team. */
  operatorUsers: SubjectMatterExpertTeamOperatorUsersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type SubjectMatterExpertTeamoperatorUserArgs = {
  operatorUserId: Scalars['ID'];
};


export type SubjectMatterExpertTeamoperatorUsersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type SubjectMatterExpertTeamEdge = ConnectionEdge & {
  __typename?: 'SubjectMatterExpertTeamEdge';
  cursor: Scalars['ID'];
  node: SubjectMatterExpertTeam;
};

export type SubjectMatterExpertTeamMemberInput = {
  /** The Subject Matter Expert user's expertise categories */
  expertiseCategories: Array<ExpertiseCategoryInput>;
  /** The User's unique ID */
  userId: Scalars['ID'];
};

export type SubjectMatterExpertTeamOperatorUserEdge = ConnectionEdge & {
  __typename?: 'SubjectMatterExpertTeamOperatorUserEdge';
  cursor: Scalars['ID'];
  /** The linked Operator User. */
  node?: Maybe<OperatorUser>;
  /** The data on the link between the Subject Matter Expert Team and Operator User. */
  relationship?: Maybe<SubjectMatterExpertTeamOperatorUserRelationship>;
};

export type SubjectMatterExpertTeamOperatorUserRelationship = Record & {
  __typename?: 'SubjectMatterExpertTeamOperatorUserRelationship';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The Subject Matter Expert user's expertise categories */
  expertiseCategories: Array<ExpertiseCategory>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The linked Operator User. */
  operatorUser: OperatorUser;
  /** The linked Subject Matter Expert Team. */
  subjectMatterExpertTeam: SubjectMatterExpertTeam;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type SubjectMatterExpertTeamOperatorUserRelationshipBase = Record & {
  __typename?: 'SubjectMatterExpertTeamOperatorUserRelationshipBase';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The Subject Matter Expert user's expertise categories */
  expertiseCategories: Array<ExpertiseCategory>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type SubjectMatterExpertTeamOperatorUserRelationshipInput = {
  /** The Subject Matter Expert user's expertise categories */
  expertiseCategories: Array<ExpertiseCategoryInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type SubjectMatterExpertTeamOperatorUsersConnection = Connection & {
  __typename?: 'SubjectMatterExpertTeamOperatorUsersConnection';
  edges: Array<SubjectMatterExpertTeamOperatorUserEdge>;
  nodes: Array<OperatorUser>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type SubjectMatterExpertTeamSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of customs broker linked to this SME team */
  customsBrokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Customs Broker's name linked to this SME team */
  customsBrokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The User Team's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Operator's name */
  operatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type SubjectMatterExpertTeamSearchTableRow = RecordSearchTableRow & UserTeamSearchTableRow & {
  __typename?: 'SubjectMatterExpertTeamSearchTableRow';
  /** The expert of this category */
  adCvd?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  agricultureAndPreparedProducts?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  aphis?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  apparelFootwearAndTextiles?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  automotiveAndAerospace?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  baseMetals?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  classification?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  consumerProductsAndMassMerchandising?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  cooFta?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of customs broker linked to this SME team */
  customsBrokerId?: Maybe<Scalars['ID']>;
  /** The Customs Broker's name linked to this SME team */
  customsBrokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The expert of this category */
  electronics?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  epa?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  fda?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  fws?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The expert of this category */
  industrialAndManufacturingMaterials?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  machinery?: Maybe<Array<Scalars['String']>>;
  /** The number of members on this SME team */
  memberCount: Scalars['Int'];
  /** The expert of this category */
  multipleIssues?: Maybe<Array<Scalars['String']>>;
  /** The User Team's name */
  name?: Maybe<Scalars['String']>;
  /** The expert of this category */
  nhtsa?: Maybe<Array<Scalars['String']>>;
  /** The Operator that owns this Record */
  operatorId: Scalars['String'];
  /** The Operator's name */
  operatorName: Scalars['String'];
  /** The expert of this category */
  petroleumNaturalGasAndMinerals?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  pga?: Maybe<Array<Scalars['String']>>;
  /** The expert of this category */
  pharmaceuticalsHealthAndChemicals?: Maybe<Array<Scalars['String']>>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** The expert of this category */
  valuation?: Maybe<Array<Scalars['String']>>;
  /** Version */
  version: Scalars['Int'];
};

export type SubjectMatterExpertTeamsConnection = Connection & {
  __typename?: 'SubjectMatterExpertTeamsConnection';
  edges: Array<SubjectMatterExpertTeamEdge>;
  nodes: Array<SubjectMatterExpertTeam>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Used to specify categories if this is a SME role */
export type SubjectMatterProperty = {
  __typename?: 'SubjectMatterProperty';
  /** Used to specify categories if this is a SME role */
  category: SubjectMatterCategory;
  /** Used to specify sub categories if this is a SME role */
  subCategories: Array<SubjectMatterSubCategory>;
};

/** Used to specify categories if this is a SME role */
export type SubjectMatterPropertyInput = {
  /** Used to specify categories if this is a SME role */
  category: SubjectMatterCategory;
  /** Used to specify sub categories if this is a SME role */
  subCategories: Array<SubjectMatterSubCategory>;
};

/** Used to specify sub categories if this is a SME role */
export enum SubjectMatterSubCategory {
  AGRICULTURE_AND_PREPARED_PRODUCTS = 'AGRICULTURE_AND_PREPARED_PRODUCTS',
  APHIS = 'APHIS',
  APPAREL_FOOTWEAR_AND_TEXTILES = 'APPAREL_FOOTWEAR_AND_TEXTILES',
  AUTOMOTIVE_AND_AEROSPACE = 'AUTOMOTIVE_AND_AEROSPACE',
  BASE_METALS = 'BASE_METALS',
  CONSUMER_PRODUCTS_AND_MASS_MERCHANDISING = 'CONSUMER_PRODUCTS_AND_MASS_MERCHANDISING',
  ELECTRONICS = 'ELECTRONICS',
  EPA = 'EPA',
  FDA = 'FDA',
  FWS = 'FWS',
  INDUSTRIAL_AND_MANUFACTURING_MATERIALS = 'INDUSTRIAL_AND_MANUFACTURING_MATERIALS',
  MACHINERY = 'MACHINERY',
  NHTSA = 'NHTSA',
  PETROLEUM_NATURAL_GAS_AND_MINERALS = 'PETROLEUM_NATURAL_GAS_AND_MINERALS',
  PHARMACEUTICALS_HEALTH_AND_CHEMICALS = 'PHARMACEUTICALS_HEALTH_AND_CHEMICALS'
}

export type SubmitComplianceRecommendationRequestInput = {
  requests: Array<ComplianceRecommendationRequest>;
};

export type SubmitDisTransaction = SubmitUsConsumptionEntryDisTransaction | SubmitUsDrawbackClaimDisTransaction | SubmitUsType86EntryDisTransaction;

export type SubmitForwarderMailFromPayload = {
  __typename?: 'SubmitForwarderMailFromPayload';
  /** Forwarder with updated mailFrom field. */
  forwarder: Forwarder;
};

/** The US CBP ABI transaction to submit a US In-Bond, CATAIR appCode: QP(actionCode: A)/QT. */
export type SubmitInBondCbpInput = {
  /** The index of the CbpInBondBill in the bills array of the CbpInBond the transaction is being created for. If we provide a cbpInBondBillIndex, the transaction is for that specific bill */
  cbpInBondBillIndex?: InputMaybe<Scalars['Int']>;
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type SubmitInBondCbpPayload = {
  __typename?: 'SubmitInBondCbpPayload';
  /** The Transaction. */
  transaction: SubmitInBondCbpTransaction;
};

/** The US CBP ABI transaction to submit a US In-Bond, CATAIR appCode: QP(actionCode: A)/QT. */
export type SubmitInBondCbpTransaction = Record & UsInBondCbpTransaction & {
  __typename?: 'SubmitInBondCbpTransaction';
  /** The index of the CbpInBondBill in the bills array of the CbpInBond the transaction is being created for. If we provide a cbpInBondBillIndex, the transaction is for that specific bill */
  cbpInBondBillIndex?: Maybe<Scalars['Int']>;
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US In-Bond */
  usInBond: UsInBond;
  /** The record's version */
  version: Scalars['Int'];
};

/** Create input parameters to send DIS documents for usEntry. */
export type SubmitUsConsumptionEntryDisInput = {
  /** List of documents that is sent to CBP */
  documents: Array<DocumentImageSystemDocumentInput>;
};

/** The payload returned from triggering the Transaction. */
export type SubmitUsConsumptionEntryDisPayload = {
  __typename?: 'SubmitUsConsumptionEntryDisPayload';
  /** The Transaction. */
  transaction: SubmitUsConsumptionEntryDisTransaction;
};

export type SubmitUsConsumptionEntryDisTransaction = Record & UsConsumptionEntryDisTransaction & {
  __typename?: 'SubmitUsConsumptionEntryDisTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** List of documents that is sent to CBP */
  documents: Array<DocumentImageSystemDocument>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  typeName: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Create input parameters to send DIS documents for usDrawbackClaim. */
export type SubmitUsDrawbackClaimDisInput = {
  /** List of documents that is sent to CBP */
  documents: Array<DocumentImageSystemDocumentInput>;
};

/** The payload returned from triggering the Transaction. */
export type SubmitUsDrawbackClaimDisPayload = {
  __typename?: 'SubmitUsDrawbackClaimDisPayload';
  /** The Transaction. */
  transaction: SubmitUsDrawbackClaimDisTransaction;
};

export type SubmitUsDrawbackClaimDisTransaction = Record & UsDrawbackClaimDisTransaction & {
  __typename?: 'SubmitUsDrawbackClaimDisTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** List of documents that is sent to CBP */
  documents: Array<DocumentImageSystemDocument>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  typeName: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Drawback Claim */
  usDrawbackClaim: UsDrawbackClaim;
  /** The record's version */
  version: Scalars['Int'];
};

/** Create input parameters to send DIS documents for usType86Entry. */
export type SubmitUsType86EntryDisInput = {
  /** List of documents that is sent to CBP */
  documents: Array<DocumentImageSystemDocumentInput>;
};

/** The payload returned from triggering the Transaction. */
export type SubmitUsType86EntryDisPayload = {
  __typename?: 'SubmitUsType86EntryDisPayload';
  /** The Transaction. */
  transaction: SubmitUsType86EntryDisTransaction;
};

export type SubmitUsType86EntryDisTransaction = Record & UsType86EntryDisTransaction & {
  __typename?: 'SubmitUsType86EntryDisTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** List of documents that is sent to CBP */
  documents: Array<DocumentImageSystemDocument>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  typeName: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Onboarding request subscription plan details. */
export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  /** The subscription plan payment period preference. */
  payTimePreference?: Maybe<SubscriptionPaymentPeriod>;
  /** Payment method. eg: Credit Card, Check. */
  paymentMethod?: Maybe<PaymentMethod>;
  /** The program plan with the Operator. */
  subscriptionPlan?: Maybe<SubscriptionPlan>;
};

/** Onboarding request subscription plan details. */
export type SubscriptionDetailsInput = {
  /** The subscription plan payment period preference. */
  payTimePreference?: InputMaybe<SubscriptionPaymentPeriod>;
  /** Payment method. eg: Credit Card, Check. */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** The program plan with the Operator. */
  subscriptionPlan?: InputMaybe<SubscriptionPlan>;
};

/** Subscription plan payment period reference with the customer. */
export enum SubscriptionPaymentPeriod {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY'
}

/** Subscription plan with the operator. */
export enum SubscriptionPlan {
  BASIC = 'BASIC',
  ENTERPRISE = 'ENTERPRISE',
  LITE = 'LITE',
  PRO = 'PRO'
}

export type SupplementalField = {
  __typename?: 'SupplementalField';
  /** INLT code for field used in the API (see PGAInput) */
  code: Scalars['String'];
  /** Description of field, including logic for conditional requirement */
  description?: Maybe<Scalars['String']>;
  /** If type is not a scalar, the sub-fields of the type */
  fields?: Maybe<Array<SupplementalField>>;
  /** Whether the field is a list of types */
  list?: Maybe<Scalars['Boolean']>;
  /** The name of the supplemental field */
  name?: Maybe<Scalars['String']>;
  /** Whether the field is Mandatory, Conditional, or Optional */
  required: RequiredDesignation;
  /** INLT type used in GraphQL schema */
  type: Scalars['String'];
};

export type Supplier = Party & Record & {
  __typename?: 'Supplier';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Compliance details for customs purposes. */
  complianceDetails?: Maybe<SupplierComplianceDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the Supplier. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this Supplier */
  shipper: ShipperSupplierRelationship;
  /** Shipper connection used to paginate results. */
  shippers: SupplierShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type SupplierdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SuppliermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SuppliershipperArgs = {
  shipperId: Scalars['ID'];
};


export type SuppliershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

/** The transaction representing a Supplier related request and response to US CBP via ABI. */
export type SupplierCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  supplier: Supplier;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type SupplierComplianceDetails = {
  __typename?: 'SupplierComplianceDetails';
  /** Supplier related US customs compliance details. */
  us?: Maybe<SupplierUsComplianceDetails>;
};

export type SupplierComplianceDetailsInput = {
  /** Supplier related US customs compliance details. */
  us?: InputMaybe<SupplierUsComplianceDetailsInput>;
};

export type SupplierEdge = ConnectionEdge & {
  __typename?: 'SupplierEdge';
  cursor: Scalars['ID'];
  node: Supplier;
};

export type SupplierSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** A Manufacturer Identification code derived by US CBP from the name and address of the party. */
  mid?: InputMaybe<UsCbpMidSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type SupplierSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'SupplierSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /**  A Manufacturer Identification code derived by US CBP from the name and address of the party. */
  mid?: Maybe<Scalars['UsCbpMid']>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type SupplierShipperEdge = ConnectionEdge & {
  __typename?: 'SupplierShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Supplier. */
  relationship: ShipperSupplierRelationship;
};

export type SupplierShippersConnection = Connection & {
  __typename?: 'SupplierShippersConnection';
  edges: Array<SupplierShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type SupplierSpreadsheetPreviewInput = {
  /** A map of the CBMS column name to column letter in the spreadsheet (e.g. { "name": "A" } where "name" is the label for column "A" in the spreadsheet). */
  columns: Scalars['JSONObject'];
  /** Indicates the behavior that the API should emulate when deciding how to handle record duplicates. */
  duplicateAction: SpreadsheetActionType;
  /** Indicates whether the spreadsheet contains headers or not. */
  hasHeaders?: InputMaybe<Scalars['Boolean']>;
  /** Rows of spreadsheet data contained in the uploaded spreadsheet (e.g. { "A": "123" } where "A" is column "A"). */
  rows: Array<Scalars['JSONObject']>;
  /** The shipper related to the records being uploaded in the spreadsheet. */
  shipper: IdInput;
};

export type SupplierSpreadsheetPreviewPayload = {
  __typename?: 'SupplierSpreadsheetPreviewPayload';
  /** A preview of the number of unique records that will be created in CBMS based on the data contained in the spreadsheet. */
  numberOfCreates: Scalars['Int'];
  /** A preview of the number of unique records that will be updated in CBMS based on the data contained in the spreadsheet. */
  numberOfMerges: Scalars['Int'];
  /** The number of records that that will fallback to the CBMS record if it is already owned by the shipper in CBMS. */
  numberOfOverwrites: Scalars['Int'];
  /** The number of rows in the uploaded spreadsheet that were skipped due to missing information. */
  numberOfSkips: Scalars['Int'];
  /** Total number of records uploaded in the spreadsheet. */
  numberOfUploadedRecords: Scalars['Int'];
  /** An array of objects containing data from the uploaded spreadsheet. All objects in this array are unique depending on the record type. */
  spreadsheetRows: Array<Scalars['JSONObject']>;
  /** An array of objects containing data from the uploaded spreadsheet. May or may not contain duplicate data depending on what was uploaded. */
  spreadsheetRowsWithDuplicates: Array<Scalars['JSONObject']>;
  /** An object that contains arrays of errors we may have encountered while processing the spreadsheet. */
  warnings: Scalars['JSONObject'];
};

export type SupplierUsComplianceDetails = {
  __typename?: 'SupplierUsComplianceDetails';
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: Maybe<Scalars['String']>;
  /** A Manufacturer IDentification code derived by US CBP from the name and address of the party. */
  mid?: Maybe<Scalars['UsCbpMid']>;
};

export type SupplierUsComplianceDetailsInput = {
  /** An FDA Establishment Identification (FEI) number is issued by FDA to track inspections of the regulated establishment or facility. */
  feiNumber?: InputMaybe<Scalars['String']>;
  /** A Manufacturer IDentification code derived by US CBP from the name and address of the party. */
  mid?: InputMaybe<Scalars['UsCbpMid']>;
};

export type SuppliersConnection = Connection & {
  __typename?: 'SuppliersConnection';
  edges: Array<SupplierEdge>;
  nodes: Array<Supplier>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** APIs that Andra externalised for its clients */
export enum SupportedAndraAPI {
  BatchBindDoc = 'BatchBindDoc',
  BatchUpdateDocAttributes = 'BatchUpdateDocAttributes',
  CreateS3PresignedURL = 'CreateS3PresignedURL',
  GenerateDoc = 'GenerateDoc',
  GetDocDetail = 'GetDocDetail',
  GetDocsProfile = 'GetDocsProfile',
  GetDocsReadiness = 'GetDocsReadiness',
  SearchDocs = 'SearchDocs',
  SearchDocsReadiness = 'SearchDocsReadiness',
  StampDocument = 'StampDocument',
  UpdateDocAttributes = 'UpdateDocAttributes'
}

/** APIs that DMS externalised for its clients */
export enum SupportedDMSAPI {
  ClassifyDocumentType = 'ClassifyDocumentType',
  CreateDocument = 'CreateDocument',
  CreateDocumentDownloadS3Url = 'CreateDocumentDownloadS3Url',
  CreateDocumentVersionDownloadS3Url = 'CreateDocumentVersionDownloadS3Url',
  CreateUploadS3Url = 'CreateUploadS3Url',
  ExtractDocument = 'ExtractDocument',
  GenerateDocument = 'GenerateDocument',
  GenerateDocumentESignUrl = 'GenerateDocumentESignUrl',
  GetDocument = 'GetDocument',
  GetDocumentVersion = 'GetDocumentVersion',
  IdSearchDocuments = 'IdSearchDocuments',
  QuerySearchDocuments = 'QuerySearchDocuments',
  SearchDocuments = 'SearchDocuments',
  UpdateDocument = 'UpdateDocument'
}

/** APIs that GSS Account Linking externalised for its clients */
export enum SupportedGssAccountLinkingAPI {
  AddSubscriptionsToPartnerV2 = 'AddSubscriptionsToPartnerV2',
  GetAGLPartnerMappingData = 'GetAGLPartnerMappingData',
  GetLinkedShipperId = 'GetLinkedShipperId'
}

/** Details related to the party who agrees to be responsible for the debt or obligation of another party to the Customs. */
export type Surety = {
  __typename?: 'Surety';
  /** The code assigned to the surety by the customs authority (e.g., 3-digit code assigned by CBP). */
  code: Scalars['String'];
  /** The name of the party who agrees to be responsible for the debt or obligation of another. */
  name?: Maybe<Scalars['String']>;
};

/** Details related to the party who agrees to be responsible for the debt or obligation of another party to the Customs. */
export type SuretyInput = {
  /** The code assigned to the surety by the customs authority (e.g., 3-digit code assigned by CBP). */
  code: Scalars['String'];
  /** The name of the party who agrees to be responsible for the debt or obligation of another. */
  name?: InputMaybe<Scalars['String']>;
};

/** The enum merge of InternalSystemName, ClientSystemName, InternalWebsiteName. */
export enum SystemType {
  APP = 'APP',
  AS2_ADAPTER = 'AS2_ADAPTER',
  AUDIT_LOG_AUTHORITY = 'AUDIT_LOG_AUTHORITY',
  AUDIT_LOG_WORKFLOW = 'AUDIT_LOG_WORKFLOW',
  CARGOWISE_ADAPTER = 'CARGOWISE_ADAPTER',
  CARGOWISE_WORKFLOW = 'CARGOWISE_WORKFLOW',
  CLIENT_AUTHORITY = 'CLIENT_AUTHORITY',
  CLIENT_WORKFLOW = 'CLIENT_WORKFLOW',
  CUSTOM_DOMAIN_AUTHORITY = 'CUSTOM_DOMAIN_AUTHORITY',
  CUSTOM_DOMAIN_WORKFLOW = 'CUSTOM_DOMAIN_WORKFLOW',
  DEV_TOOLS = 'DEV_TOOLS',
  DOCUMENTATION = 'DOCUMENTATION',
  DOCUMENT_AUTHORITY = 'DOCUMENT_AUTHORITY',
  DOCUMENT_GENERATION_WORKFLOW = 'DOCUMENT_GENERATION_WORKFLOW',
  DOCUMENT_INGEST_WORKFLOW = 'DOCUMENT_INGEST_WORKFLOW',
  DOCUMENT_SIGN_WORKFLOW = 'DOCUMENT_SIGN_WORKFLOW',
  ERROR_AUTHORITY = 'ERROR_AUTHORITY',
  ERROR_WORKFLOW = 'ERROR_WORKFLOW',
  EXTERNAL_GATEWAY = 'EXTERNAL_GATEWAY',
  FINANCE_AUTHORITY = 'FINANCE_AUTHORITY',
  FINANCE_WORKFLOW = 'FINANCE_WORKFLOW',
  FORWARDER_SYSTEM = 'FORWARDER_SYSTEM',
  GATEWAY = 'GATEWAY',
  GTNEXUS_WORKFLOW = 'GTNEXUS_WORKFLOW',
  IMPORTSIGN = 'IMPORTSIGN',
  LAMBDA_LAYERS = 'LAMBDA_LAYERS',
  LEGACY_DATA_MIGRATION = 'LEGACY_DATA_MIGRATION',
  LEGACY_INLT = 'LEGACY_INLT',
  LIVE_PIPELINE = 'LIVE_PIPELINE',
  MARKETING = 'MARKETING',
  MESSAGE_EXCHANGE_AUTHORITY = 'MESSAGE_EXCHANGE_AUTHORITY',
  MESSAGE_EXCHANGE_LISTENER = 'MESSAGE_EXCHANGE_LISTENER',
  MESSAGE_EXCHANGE_WORKFLOW = 'MESSAGE_EXCHANGE_WORKFLOW',
  MQ_ADAPTER = 'MQ_ADAPTER',
  NOTIFICATION_WORKFLOW = 'NOTIFICATION_WORKFLOW',
  PARTY_AUTHORITY = 'PARTY_AUTHORITY',
  PARTY_WORKFLOW = 'PARTY_WORKFLOW',
  PRODUCT_AUTHORITY = 'PRODUCT_AUTHORITY',
  PRODUCT_WORKFLOW = 'PRODUCT_WORKFLOW',
  QBO_ADAPTER = 'QBO_ADAPTER',
  SEARCH_SERVICE = 'SEARCH_SERVICE',
  SFTP_ADAPTER = 'SFTP_ADAPTER',
  SHARED = 'SHARED',
  SHIPMENT_AUTHORITY = 'SHIPMENT_AUTHORITY',
  SHIPMENT_WORKFLOW = 'SHIPMENT_WORKFLOW',
  TRADE_DATA_AUTHORITY = 'TRADE_DATA_AUTHORITY',
  TRADE_DATA_WORKFLOW = 'TRADE_DATA_WORKFLOW',
  VYOS_VPN = 'VYOS_VPN',
  WORK_ORDER_AUTHORITY = 'WORK_ORDER_AUTHORITY',
  WORK_ORDER_MESSAGE_WORKFLOW = 'WORK_ORDER_MESSAGE_WORKFLOW',
  WORK_ORDER_MILESTONE_WORKFLOW = 'WORK_ORDER_MILESTONE_WORKFLOW',
  WORK_ORDER_WORKFLOW = 'WORK_ORDER_WORKFLOW'
}

/** The table filter saved by a user. */
export type TableFilter = Record & {
  __typename?: 'TableFilter';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Name of the custom filter */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The type of the record table */
  recordTable: Scalars['String'];
  /** Custom table filter search criterias */
  tableFilterCriteria: Array<TableFilterCriterionObject>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** Record table visible columns */
  visibleColumns?: Maybe<Array<Scalars['String']>>;
};

/** Table Filter Criteria */
export type TableFilterCriterionInput = {
  /** The record field applicable for search criteria */
  field: Scalars['String'];
  /** The search criteria for the record field */
  searchCriteria: SearchCriteriaInput;
};

/** Table Filter Criteria */
export type TableFilterCriterionObject = {
  __typename?: 'TableFilterCriterionObject';
  /** The record field applicable for search criteria */
  field: Scalars['String'];
  /** The search criteria for the record field */
  searchCriteria: SearchCriteriaObject;
};

export type TableFilterEdge = ConnectionEdge & {
  __typename?: 'TableFilterEdge';
  cursor: Scalars['ID'];
  node: TableFilter;
};

export type TableFilterSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Filter name. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Operator's name. */
  operatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record table filter is applied on. */
  recordTable?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type TableFilterSearchTableRow = {
  __typename?: 'TableFilterSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Custom filter's name. */
  name?: Maybe<Scalars['String']>;
  /** The ID of operator. */
  operatorId?: Maybe<Scalars['ID']>;
  /** The operator's name. */
  operatorName?: Maybe<Scalars['String']>;
  /** The Record table filter is applied on. */
  recordTable?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type TableFiltersConnection = Connection & {
  __typename?: 'TableFiltersConnection';
  edges: Array<TableFilterEdge>;
  nodes: Array<TableFilter>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Represents a tag which can be used by clients to tag documents with their own identifiers */
export type Tag = {
  __typename?: 'Tag';
  /** The key name for the tag. */
  key: Scalars['String'];
  /** The value of corresponding to the key. */
  value: Scalars['String'];
};

/** Represents a tag which can be used by clients to tag documents with their own identifiers */
export type TagInput = {
  /** The key name for the tag. */
  key: Scalars['String'];
  /** The value of corresponding to the key. */
  value: Scalars['String'];
};

export type TagSearchCriteriaInput = {
  /** The operator applied for the given values. Defaults to equals. */
  operator?: InputMaybe<KeywordSearchOperator>;
  /** The values to be searched for the field. */
  values?: InputMaybe<Array<TagInput>>;
};

export type TariffFlagDisclaimRecommendation = ComplianceRecommendation & {
  __typename?: 'TariffFlagDisclaimRecommendation';
  availability: Scalars['String'];
  result?: Maybe<RecommendationResult>;
  tariffFlagCode: Scalars['String'];
};

export type TariffFlagDisclaimRecommendationResult = RecommendationResult & {
  __typename?: 'TariffFlagDisclaimRecommendationResult';
  confidenceScore: Scalars['Float'];
  disclaimerCode?: Maybe<Scalars['String']>;
  isEligible: Scalars['Boolean'];
  timestamp: Scalars['DateTime__patched_over_by_INLT'];
};

export type TariffFlagDisclaimSubmission = {
  __typename?: 'TariffFlagDisclaimSubmission';
  results: Array<ComplianceRecommendationSubmissionResult>;
};

export type TaskConfig = {
  __typename?: 'TaskConfig';
  /** Experience score of the operators to handle different work order task */
  experienceScore?: Maybe<Scalars['Int']>;
  /** Shipment modes of transport assigned to this user for a given work order task definition */
  modesOfTransport?: Maybe<Array<ModeOfTransport>>;
  /** Time percentage can vary from 0 meaning NOT eligible to 100 meaning fully eligible for a task. A time percentage would be configured by the team admin to denote the amount of time an operator user will spend for a given work order task */
  timePercentage: Scalars['Percentage'];
  /** Verticals assigned to this user for a given work order task definition */
  usCbpIndustryVerticals?: Maybe<Array<Vertical>>;
  /** Work order authority task definition reference */
  workOrderTaskDefinition: WorkOrderTaskDefinition;
};

export type TaskConfigInput = {
  /** Experience score of the operators to handle different work order task */
  experienceScore?: InputMaybe<Scalars['Int']>;
  /** Shipment modes of transport assigned to this user for a given work order task definition */
  modesOfTransport?: InputMaybe<Array<ModeOfTransport>>;
  /** Time percentage can vary from 0 meaning NOT eligible to 100 meaning fully eligible for a task. A time percentage would be configured by the team admin to denote the amount of time an operator user will spend for a given work order task */
  timePercentage: Scalars['Percentage'];
  /** Verticals assigned to this user for a given work order task definition */
  usCbpIndustryVerticals?: InputMaybe<Array<Vertical>>;
  /** Work order authority task definition reference */
  workOrderTaskDefinition: IdInput;
};

export type TaskEscalationDetails = {
  __typename?: 'TaskEscalationDetails';
  /** Details about this escalation */
  details: Scalars['String'];
  /** Operator user who escalated the task */
  escalatedBy: OperatorUser;
  /** Time at which task was escalated */
  escalatedTime: Scalars['DateTime'];
  /** Operator user to whom task is escalated */
  escalatedTo: OperatorUser;
  /** Reason for task esclation */
  escalationReasons: TaskEscalationReasons;
  /** Type of escalation */
  escalationType: WorkOrderTaskEscalationType;
};

export type TaskEscalationDetailsInput = {
  /** Details about this escalation */
  details: Scalars['String'];
  /** Operator user who escalated the task */
  escalatedBy: IdInput;
  /** Time at which task was escalated */
  escalatedTime: Scalars['DateTime'];
  /** Operator user to whom task is escalated */
  escalatedTo: IdInput;
  /** Reason for task esclation */
  escalationReasons: TaskEscalationReasonsInput;
  /** Type of escalation */
  escalationType: WorkOrderTaskEscalationType;
};

export type TaskEscalationReasons = {
  __typename?: 'TaskEscalationReasons';
  /** Escalation reason  category */
  reasonCategory: EscalationReasonCategory;
  /** Escalation reason sub category */
  reasonSubCategory?: Maybe<EscalationReasonSubCategory>;
};

export type TaskEscalationReasonsInput = {
  /** Escalation reason  category */
  reasonCategory: EscalationReasonCategory;
  /** Escalation reason sub category */
  reasonSubCategory?: InputMaybe<EscalationReasonSubCategory>;
};

export type TaskEscalationReplyDetails = {
  __typename?: 'TaskEscalationReplyDetails';
  /** Details about the reply on this escalation */
  details: Scalars['String'];
  /** Operator user who replied to the escalation */
  repliedBy: OperatorUser;
  /** Time at which the operator replied */
  replyTime: Scalars['DateTime'];
};

export type TaskEscalationReplyDetailsInput = {
  /** Details about the reply on this escalation */
  details: Scalars['String'];
  /** Operator user who replied to the escalation */
  repliedBy: IdInput;
  /** Time at which the operator replied */
  replyTime: Scalars['DateTime'];
};

export type TaskEscalationReplyPayload = {
  __typename?: 'TaskEscalationReplyPayload';
  /** The updated Work Order Task with the resolved escalation. */
  workOrderTask: WorkOrderTask;
};

export type TaskResolutionDetails = {
  __typename?: 'TaskResolutionDetails';
  /** Details about this resolution */
  details: Scalars['String'];
  /** Reason for task resolution. */
  resolutionReasons: Array<ResolutionReasonCode>;
  /** Time at which task was resolved */
  resolutionTime: Scalars['DateTime'];
  /** Operator user who resolved the task */
  resolvedBy: OperatorUser;
};

export type TaskResolutionDetailsInput = {
  /** Details about this resolution */
  details: Scalars['String'];
  /** Reason for task resolution. */
  resolutionReasons: Array<ResolutionReasonCode>;
  /** Time at which task was resolved */
  resolutionTime: Scalars['DateTime'];
  /** Operator user who resolved the task */
  resolvedBy: IdInput;
};

export type TaxBase = {
  __typename?: 'TaxBase';
  /** Amount on which a duty, tax, or fee will be assessed. */
  adValoremTaxBase?: Maybe<Cost>;
  /** Quantity specifying the amount on which duty or tax or fee will be assessed. */
  specificTaxBase?: Maybe<Quantity>;
  /** Amount calculated/separate tax of duties and/or taxes for each tax base, for the cases when more than one tax base per tax type exist. */
  tax?: Maybe<Cost>;
  /** Rate of duty, tax, or fee applicable to commodities or of tax applicable to services. */
  taxRate?: Maybe<Scalars['Float']>;
};

export type TaxBaseInput = {
  /** Amount on which a duty, tax, or fee will be assessed. */
  adValoremTaxBase?: InputMaybe<CostInput>;
  /** Quantity specifying the amount on which duty or tax or fee will be assessed. */
  specificTaxBase?: InputMaybe<QuantityInput>;
  /** Amount calculated/separate tax of duties and/or taxes for each tax base, for the cases when more than one tax base per tax type exist. */
  tax?: InputMaybe<CostInput>;
  /** Rate of duty, tax, or fee applicable to commodities or of tax applicable to services. */
  taxRate?: InputMaybe<Scalars['Float']>;
};

export type Team = Record & {
  __typename?: 'Team';
  /** The Account this Team belongs to. */
  account: Account;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the Team. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Team name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type TeamdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TeamEdge = ConnectionEdge & {
  __typename?: 'TeamEdge';
  cursor: Scalars['ID'];
  node: Team;
};

export type TeamSearchCriteriaInput = {
  /** The Account this Team belongs to. */
  accountId?: InputMaybe<IdSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Team name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type TeamSearchTableRow = RecordSearchTableRow & {
  __typename?: 'TeamSearchTableRow';
  /** The Account this Team belongs to. */
  accountId?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Team name */
  name?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type TeamsConnection = Connection & {
  __typename?: 'TeamsConnection';
  edges: Array<TeamEdge>;
  nodes: Array<Team>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Document template sign request. */
export type TemplateDocumentSignRequest = DocumentSignRequest & Record & {
  __typename?: 'TemplateDocumentSignRequest';
  /** JSON with additional fields defined by the document template. */
  additionalFields?: Maybe<Scalars['JSONObject']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The sign request expires after the designated amount of minutes. */
  expireAfterMinutes: Scalars['Int'];
  /** The UTC date & time the request will expire. */
  expireTime: Scalars['DateTime'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Data related to the document signature. */
  signature?: Maybe<DocumentSignature>;
  /** Information about when & where the document sign request was signed. */
  signed?: Maybe<RecordAction>;
  signedDocument?: Maybe<Document>;
  /** Birth date of officer signing the document */
  signerBirthDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Name of officer signing the document. */
  signerName?: Maybe<Scalars['String']>;
  /** Title of officer signing the document. */
  signerTitle?: Maybe<Scalars['String']>;
  /** Status of Document Sign Request */
  status: DocumentSignRequestStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Document template assocated with the sign request. */
  template: DocumentTemplate;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The link provided to clients with the purpose of signing. */
  url: Scalars['String'];
  /** The record's version */
  version: Scalars['Int'];
};

export type TemplateDocumentSignRequestEdge = ConnectionEdge & {
  __typename?: 'TemplateDocumentSignRequestEdge';
  cursor: Scalars['ID'];
  node: TemplateDocumentSignRequest;
};

/** Template document sign request search criteria input. */
export type TemplateDocumentSignRequestSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The document tags. */
  documentTags?: InputMaybe<DocumentTagSearchCritieraInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The document signature types. */
  method?: InputMaybe<DocumentSignatureMethodSearchCritieraInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The id of the signed document associated with the sign request. */
  signedDocumentId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was signed. */
  signedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The name of the user the request was signed by.  */
  signerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The document sign request's status. */
  status?: InputMaybe<DocumentSignRequestStatusSearchCritieraInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The id of the document template associated with the sign request. */
  templateId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The version of the document template associated with the sign request. */
  templateVersion?: InputMaybe<IntSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** Template document sign request search table row. */
export type TemplateDocumentSignRequestSearchTableRow = {
  __typename?: 'TemplateDocumentSignRequestSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The document tags. */
  documentTags?: Maybe<Array<DocumentTag>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The document signature types. */
  method?: Maybe<DocumentSignatureMethod>;
  /** The ID of the signed document. */
  signedDocumentId?: Maybe<Scalars['ID']>;
  /** The time the Record was signed. */
  signedTime?: Maybe<Scalars['DateTime']>;
  /** The name of the user the request was signed by.  */
  signerName?: Maybe<Scalars['String']>;
  /** The document sign request's status. */
  status: DocumentSignRequestStatus;
  /** The id of the document associated with the sign request. */
  templateId: Scalars['ID'];
  /** The version of the document template associated with the sign request. */
  templateVersion: Scalars['Int'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type TemplateDocumentSignRequestsConnection = Connection & {
  __typename?: 'TemplateDocumentSignRequestsConnection';
  edges: Array<TemplateDocumentSignRequestEdge>;
  nodes: Array<TemplateDocumentSignRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Defines the format of the template */
export enum TemplateType {
  CORPORATE_CERTIFICATION = 'CORPORATE_CERTIFICATION',
  DIRECT_POWER_OF_ATTORNEY = 'DIRECT_POWER_OF_ATTORNEY',
  EXTERNAL_SUB_POWER_OF_ATTORNEY = 'EXTERNAL_SUB_POWER_OF_ATTORNEY',
  MASTER_POWER_OF_ATTORNEY = 'MASTER_POWER_OF_ATTORNEY',
  SUB_POWER_OF_ATTORNEY = 'SUB_POWER_OF_ATTORNEY',
  SUB_POWER_OF_ATTORNEY_AUTHORITY = 'SUB_POWER_OF_ATTORNEY_AUTHORITY'
}

/** The terms of Sale e.g. DAP */
export enum TermsOfSale {
  DAP = 'DAP'
}

/** Laboratory test report information */
export type TestReport = {
  __typename?: 'TestReport';
  /** Access key for the test report URL */
  accessKey?: Maybe<Scalars['String']>;
  /** Test report ID */
  reportId?: Maybe<Scalars['String']>;
  /** URL to access the test report */
  reportUrl?: Maybe<Scalars['String']>;
};

/** Laboratory test report information */
export type TestReportInput = {
  /** Access key for the test report URL */
  accessKey?: InputMaybe<Scalars['String']>;
  /** Test report ID */
  reportId?: InputMaybe<Scalars['String']>;
  /** URL to access the test report */
  reportUrl?: InputMaybe<Scalars['String']>;
};

export type TextSearchCriteriaInput = {
  /** The Operators available for text search criteria. */
  operator: TextSearchOperator;
  /** The values of the text search criteria. Required for operators with the exception of the "Exist" type operators. Value of length 1 is required for "Equals" type operators. */
  values?: InputMaybe<Array<Scalars['TextSearchCriteriaInputValue']>>;
};

/** Operators used for text based search operations. */
export enum TextSearchOperator {
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  ENDS_WITH = 'ENDS_WITH',
  EQUALS = 'EQUALS',
  EXISTS = 'EXISTS',
  INCLUDES = 'INCLUDES',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_ONE_OF = 'NOT_ONE_OF',
  ONE_OF = 'ONE_OF',
  STARTS_WITH = 'STARTS_WITH'
}

/** Text based document stamp details. */
export type TextStamp = {
  __typename?: 'TextStamp';
  /** Stamp in plain text format. */
  data: Scalars['String'];
  /** Font size of the text stamp, default value: 12 pt. */
  fontSize?: Maybe<Scalars['Int']>;
  /** Maximum width of the text after which text wraps to next line. */
  maxWidth?: Maybe<Scalars['Int']>;
  /** Positions where text needs to be stamped in document. */
  stampPositions: Array<TextStampPosition>;
};

/** Details about the position in the input document where text will be stamped. */
export type TextStampInput = {
  /** Stamp in plain text format. */
  data: Scalars['String'];
  /** Font size of the text stamp, default value: 12 pt. */
  fontSize?: InputMaybe<Scalars['Int']>;
  /** Maximum width of the text after which text wraps to next line. */
  maxWidth?: InputMaybe<Scalars['Int']>;
  /** Positions where text needs to be stamped in document. */
  stampPositions: Array<TextStampPositionInput>;
};

/** Details about the position in the input document where text will be stamped. */
export type TextStampPosition = {
  __typename?: 'TextStampPosition';
  /** Co-ordinates of the position in the document where stamp needs to be added. For PDF, the co-ordinates are relative to bottom-left corner of pdf. */
  coordinates: StampCoordinates;
  /** The page number of the document which needs to be stamped. */
  pageNumber: Scalars['Int'];
};

/** Details about the position in the input document where text will be stamped. */
export type TextStampPositionInput = {
  /** Co-ordinates of the position in the document where stamp needs to be added. For PDF, the co-ordinates are relative to bottom-left corner of pdf. */
  coordinates: StampCoordinatesInput;
  /** The page number of the document which needs to be stamped. */
  pageNumber: Scalars['Int'];
};

/** The Time Zone for the entity */
export enum TimeZone {
  AMERICA_CHICAGO = 'AMERICA_CHICAGO',
  AMERICA_DENVER = 'AMERICA_DENVER',
  AMERICA_LOS_ANGELES = 'AMERICA_LOS_ANGELES',
  AMERICA_NEW_YORK = 'AMERICA_NEW_YORK',
  ASIA_SHANGHAI = 'ASIA_SHANGHAI',
  EUROPE_BERLIN = 'EUROPE_BERLIN',
  EUROPE_LONDON = 'EUROPE_LONDON',
  EUROPE_MADRID = 'EUROPE_MADRID',
  EUROPE_PARIS = 'EUROPE_PARIS',
  EUROPE_ROME = 'EUROPE_ROME',
  UTC = 'UTC'
}

export type TimezoneSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<TimeZone>>;
};

export type ToggleAssumedUserPayload = {
  __typename?: 'ToggleAssumedUserPayload';
  /** The operatorUser after toggling assumedUser. */
  operatorUser: OperatorUser;
};

export type TradeAdvisoryRequest = {
  __typename?: 'TradeAdvisoryRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Exchange message ID for tracking email status */
  exchangeMessageId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The product owner (shipper or forwarder) that owns this trade advisory request */
  owner?: Maybe<ProductOwner>;
  /** List of products for trade advisory consultation */
  products?: Maybe<Array<Product>>;
  /** Additional details about the trade advisory request */
  requestDetails?: Maybe<Scalars['String']>;
  /** Trade advisory request identifier */
  requestId: Scalars['String'];
  /** Selected trade advisory service type */
  selectedService: TradeAdvisoryRequestService;
  /** Current status of the trade advisory request */
  status: TradeAdvisoryRequestStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type TradeAdvisoryRequestEdge = ConnectionEdge & {
  __typename?: 'TradeAdvisoryRequestEdge';
  cursor: Scalars['ID'];
  node: TradeAdvisoryRequest;
};

export type TradeAdvisoryRequestSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  owner?: InputMaybe<IdSearchCriteriaInput>;
  requestId?: InputMaybe<TextSearchCriteriaInput>;
  status?: InputMaybe<TradeAdvisoryRequestStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type TradeAdvisoryRequestSearchTableRow = {
  __typename?: 'TradeAdvisoryRequestSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  owner?: Maybe<ProductOwner>;
  requestId: Scalars['String'];
  status: TradeAdvisoryRequestStatus;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export enum TradeAdvisoryRequestService {
  AUDIT = 'AUDIT',
  GENERAL_EXPERTISE = 'GENERAL_EXPERTISE',
  HTS_HS_CLASSIFICATION = 'HTS_HS_CLASSIFICATION',
  SHIPMENT_SUPPORT = 'SHIPMENT_SUPPORT'
}

export enum TradeAdvisoryRequestStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export type TradeAdvisoryRequestStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<TradeAdvisoryRequestStatus>>;
};

export type TradeAdvisoryRequestsConnection = Connection & {
  __typename?: 'TradeAdvisoryRequestsConnection';
  edges: Array<TradeAdvisoryRequestEdge>;
  nodes: Array<TradeAdvisoryRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type TradeDataCodes = {
  __typename?: 'TradeDataCodes';
  /** A presigned GET URL to the object */
  link: Scalars['Url'];
  /** The latest version ID of the object */
  versionId: Scalars['ID'];
};

export type TradeTerms = {
  __typename?: 'TradeTerms';
  /** Code specifying the delivery or transport terms. */
  condition?: Maybe<Scalars['String']>;
};

export type TradeTermsInput = {
  /** Code specifying the delivery or transport terms. */
  condition?: InputMaybe<Scalars['String']>;
};

export type TranslatedBusinessLicense = {
  __typename?: 'TranslatedBusinessLicense';
  /** Translated business address from license */
  address?: Maybe<AddressV2>;
  /** Translated business name from license */
  name?: Maybe<Scalars['String']>;
};

export type TranslatedBusinessLicenseInput = {
  /** Translated business address from license */
  address?: InputMaybe<AddressV2Input>;
  /** Translated business name from license */
  name?: InputMaybe<Scalars['String']>;
};

export type TransportContractDocument = {
  __typename?: 'TransportContractDocument';
  /** Identification of the document evidencing a transport contract by reference number. */
  identification?: Maybe<Scalars['String']>;
  /** Indicator that the goods in the transport contract document are being cleared through multiple declarations. */
  split?: Maybe<Scalars['Boolean']>;
  /** Code specifying the type of a document evidencing a transport contract. */
  type?: Maybe<TransportContractDocumentType>;
};

export type TransportContractDocumentInput = {
  /** Identification of the document evidencing a transport contract by reference number. */
  identification?: InputMaybe<Scalars['String']>;
  /** Indicator that the goods in the transport contract document are being cleared through multiple declarations. */
  split?: InputMaybe<Scalars['Boolean']>;
  /** Code specifying the type of a document evidencing a transport contract. */
  type?: InputMaybe<TransportContractDocumentType>;
};

/** Code specifying the type of a document evidencing a transport contract. */
export enum TransportContractDocumentType {
  HOUSE_BILL_OF_LADING = 'HOUSE_BILL_OF_LADING',
  HOUSE_WAYBILL = 'HOUSE_WAYBILL',
  MASTER_BILL_OF_LADING = 'MASTER_BILL_OF_LADING'
}

export type TransportEquipment = {
  __typename?: 'TransportEquipment';
  /** Details related to the transport between a consignor and a consignee as specified in the transport contract document. */
  fullness?: Maybe<LoadType>;
  /** Identification of the equipment (e.g. unit load device by marks, letters, and/or numbers). */
  identification?: Maybe<Scalars['String']>;
  /** Registered name of the equipment used to transport the cargo. */
  name?: Maybe<Scalars['String']>;
  /** Seals affixed to the transport equipment. */
  seal?: Maybe<Array<Seal>>;
  /** Quantity specifying the number of seals affixed. */
  sealsAffixed?: Maybe<Scalars['Float']>;
  /** Volume of container */
  volume?: Maybe<Volume>;
  /** Weight of container */
  weight?: Maybe<Weight>;
};

export type TransportEquipmentInput = {
  /** Details related to the transport between a consignor and a consignee as specified in the transport contract document. */
  fullness?: InputMaybe<LoadType>;
  /** Identification of the equipment (e.g. unit load device by marks, letters, and/or numbers). */
  identification?: InputMaybe<Scalars['String']>;
  /** Registered name of the equipment used to transport the cargo. */
  name?: InputMaybe<Scalars['String']>;
  /** Seals affixed to the transport equipment. */
  seal?: InputMaybe<Array<SealInput>>;
  /** Quantity specifying the number of seals affixed. */
  sealsAffixed?: InputMaybe<Scalars['Float']>;
  /** Volume of container */
  volume?: InputMaybe<VolumeInput>;
  /** Weight of container */
  weight?: InputMaybe<WeightInput>;
};

export type Trucker = Party & Record & {
  __typename?: 'Trucker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** A CBP Assigned Importer of Record number. */
  cain?: Maybe<Scalars['CbpAssignedNumber']>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** A point of contact for trucker dispatch */
  dispatchPointOfContact?: Maybe<PointOfContact>;
  /** The documents associated with the Trucker. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: Maybe<Scalars['SCACCode']>;
  /** A Shipper linked to this Trucker */
  shipper: ShipperTruckerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: TruckerShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type TruckerdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type TruckermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type TruckershipperArgs = {
  shipperId: Scalars['ID'];
};


export type TruckershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type TruckerEdge = ConnectionEdge & {
  __typename?: 'TruckerEdge';
  cursor: Scalars['ID'];
  node: Trucker;
};

export type TruckerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<EmployeeIdentificationNumberSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<ScacSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type TruckerSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'TruckerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: Maybe<Scalars['SCACCode']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type TruckerShipperEdge = ConnectionEdge & {
  __typename?: 'TruckerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and Trucker. */
  relationship: ShipperTruckerRelationship;
};

export type TruckerShippersConnection = Connection & {
  __typename?: 'TruckerShippersConnection';
  edges: Array<TruckerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type TruckersConnection = Connection & {
  __typename?: 'TruckersConnection';
  edges: Array<TruckerEdge>;
  nodes: Array<Trucker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UCR = {
  __typename?: 'UCR';
  /** Identification of the number assigned by a declarant such as a trader reference or a carrier reference. */
  traderAssignedReference?: Maybe<Scalars['String']>;
};

export type UCRInput = {
  /** Identification of the number assigned by a declarant such as a trader reference or a carrier reference. */
  traderAssignedReference?: InputMaybe<Scalars['String']>;
};

export type UkCustomsBroker = CustomsBroker & Party & Record & {
  __typename?: 'UkCustomsBroker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['UkEori'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this UK Customs Broker */
  shipper: ShipperUkCustomsBrokerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: UkCustomsBrokerShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type UkCustomsBrokermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UkCustomsBrokershipperArgs = {
  shipperId: Scalars['ID'];
};


export type UkCustomsBrokershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type UkCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'UkCustomsBrokerEdge';
  cursor: Scalars['ID'];
  node: UkCustomsBroker;
};

export type UkCustomsBrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<UkEoriSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type UkCustomsBrokerSearchTableRow = {
  __typename?: 'UkCustomsBrokerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori: Scalars['UkEori'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UkCustomsBrokerShipperEdge = ConnectionEdge & {
  __typename?: 'UkCustomsBrokerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and UK Customs Broker. */
  relationship: ShipperUkCustomsBrokerRelationship;
};

export type UkCustomsBrokerShippersConnection = Connection & {
  __typename?: 'UkCustomsBrokerShippersConnection';
  edges: Array<UkCustomsBrokerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UkCustomsBrokersConnection = Connection & {
  __typename?: 'UkCustomsBrokersConnection';
  edges: Array<UkCustomsBrokerEdge>;
  nodes: Array<UkCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
export type UkEoriSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UkEori']>>;
};

/** Represents a United Kingdom Harmonized System record */
export type UkHs = Hs & Record & {
  __typename?: 'UkHs';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Hierarchical description combining parent HS descriptions with current record description */
  description?: Maybe<HsDescription>;
  /** Effective descriptions */
  descriptions?: Maybe<Array<HsDescription>>;
  /** Ending effective date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Main duty rates */
  mainDutyRates?: Maybe<Array<HsRate>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Beginning effective date. */
  startDate?: Maybe<Scalars['Date']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


/** Represents a United Kingdom Harmonized System record */
export type UkHsdescriptionArgs = {
  cultureCode?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
};

export type UkHsEdge = ConnectionEdge & {
  __typename?: 'UkHsEdge';
  cursor: Scalars['ID'];
  node: UkHs;
};

export type UkHsSearchCriteria = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The effective end date. */
  endDate?: InputMaybe<DateSearchCriteriaInput>;
  /** HS number type. */
  hsNumberType?: InputMaybe<HsNumberTypeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** HS number. */
  number?: InputMaybe<TextSearchCriteriaInput>;
  /** The effective start date. */
  startDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** UK HS search results. */
export type UkHsSearchTableRow = HsSearchTableRow & RecordSearchTableRow & {
  __typename?: 'UkHsSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The effective end date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type. */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** HTS number. */
  number: Scalars['HtsNumber'];
  /** The effective start date. */
  startDate?: Maybe<Scalars['Date']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UkHssConnection = Connection & {
  __typename?: 'UkHssConnection';
  edges: Array<UkHsEdge>;
  nodes: Array<UkHs>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UkIorActivationBroker = {
  __typename?: 'UkIorActivationBroker';
  /** UK Customs Broker */
  customsBroker: UkCustomsBroker;
};

export type UkIorActivationBrokerInput = {
  /** ID of the UK Customs Broker */
  customsBroker: IdInput;
};

export type UnblockShipmentInquiriesPayload = {
  __typename?: 'UnblockShipmentInquiriesPayload';
  /** Shipment details after the inquiry has been resolved */
  record: Shipment;
};

export type UnblockWorkOrderPayload = {
  __typename?: 'UnblockWorkOrderPayload';
  /** The updated Work Order. */
  workOrder: WorkOrder;
};

/** Payload returned from the uncancelShipment mutation. */
export type UncancelShipmentPayload = {
  __typename?: 'UncancelShipmentPayload';
  record: Shipment;
};

/** Payload returned from the uncancelShipper mutation. */
export type UncancelShipperPayload = {
  __typename?: 'UncancelShipperPayload';
  record: Shipper;
};

/** Payload returned from the uncancelUsIor mutation. */
export type UncancelUsIorPayload = {
  __typename?: 'UncancelUsIorPayload';
  record: UsIor;
};

/** Payload returned from the uncancelWorkOrderGroup mutation. */
export type UncancelWorkOrderGroupPayload = {
  __typename?: 'UncancelWorkOrderGroupPayload';
  record: WorkOrderGroup;
};

/** Payload returned from the uncancelWorkOrder mutation. */
export type UncancelWorkOrderPayload = {
  __typename?: 'UncancelWorkOrderPayload';
  record: WorkOrder;
};

/** Payload returned from the uncancelWorkOrderTask mutation. */
export type UncancelWorkOrderTaskPayload = {
  __typename?: 'UncancelWorkOrderTaskPayload';
  record: WorkOrderTask;
};

/** Represents a US CBP Anti-Dumping or Countervailing Duty Case. */
export type UpdateAdCvdCaseInput = {
  /** Official Case name */
  bondOrCash?: InputMaybe<Array<CaseBondOrCashInput>>;
  /** The country of origin where the Case applies */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Effective date */
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  /** AD/CVD Case event history */
  events?: InputMaybe<Array<CaseEventInput>>;
  /** AD/CVD Case liquidation suspension history */
  liquidationSuspensions?: InputMaybe<Array<CaseLiquidationSuspensionInput>>;
  /** The manufacturer the Case applies to */
  manufacturerName?: InputMaybe<Scalars['String']>;
  /** Official Case name */
  name?: InputMaybe<Scalars['String']>;
  /** AD/CVD Case duty rates */
  rates?: InputMaybe<Array<CaseRateInput>>;
  /** Link to the scope decision of the case */
  scopeUrl?: InputMaybe<Scalars['Url']>;
  /** The seller (foreign exporter) the Case applies to */
  sellerName?: InputMaybe<Scalars['String']>;
  /** Status of Case */
  status?: InputMaybe<AdCvdCaseStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** AD/CVD Case Tariff */
  tariffs?: InputMaybe<Array<CaseTariffInput>>;
};

/** Payload returned from the updateAdCvdCase mutation. */
export type UpdateAdCvdCasePayload = {
  __typename?: 'UpdateAdCvdCasePayload';
  record: AdCvdCase;
};

export type UpdateAssignmentTeamInput = {
  /** The type of this assignment team */
  assignmentTeamTypes?: InputMaybe<Array<AssignmentTeamType>>;
  /** The backup team for this assignment team */
  backupTeam?: InputMaybe<IdInput>;
  /** The case attributes for this assignment team */
  caseAttributes?: InputMaybe<Array<AssignmentTeamCaseAttributesInput>>;
  /** Team's customs broker */
  customsBroker?: InputMaybe<IdInput>;
  /** Additonal input for the assignment team and operator user relationship */
  members?: InputMaybe<Array<AssignmentTeamMemberInput>>;
  /** The User Team's name */
  name?: InputMaybe<Scalars['String']>;
  /** The associated SME team for this assignment team */
  subjectMatterExpertTeam?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The verticals this assignment team is responsible for */
  verticals?: InputMaybe<Array<AssignmentTeamVerticalInput>>;
  /** The work order task types associated with this assignment team */
  workOrderTaskTypes?: InputMaybe<Array<WorkOrderTaskType>>;
  /** The work order types associated with this assignment team */
  workOrderTypes?: InputMaybe<Array<WorkOrderType>>;
};

/** The payload returned from the updateAssignmentTeamOperatorUserRelationship mutation. */
export type UpdateAssignmentTeamOperatorUserRelationshipPayload = {
  __typename?: 'UpdateAssignmentTeamOperatorUserRelationshipPayload';
  /** The updated relationship between the Assignment Team and Operator User Records. */
  relationship: AssignmentTeamOperatorUserRelationship;
};

/** Payload returned from the updateAssignmentTeam mutation. */
export type UpdateAssignmentTeamPayload = {
  __typename?: 'UpdateAssignmentTeamPayload';
  record: AssignmentTeam;
};

/** Update Assignment Team Static Mapping Input */
export type UpdateAssignmentTeamStaticMappingInput = {
  /** The assignment team for the mapping. */
  assignmentTeam: IdInput;
  /** The mapped operator in this assignment team. */
  member: IdInput;
  /** The entity reference to which the member is being mapped to. e.g., if the memberAssignedToType is XBT_SHIPPER_ID, then this field should be the xbtShipperId in format of string. */
  memberAssignedToReference: Scalars['String'];
  /** The type of member being assigned (e.g., "XBT_SHIPPER_ID"). */
  memberAssignedToType: MemberAssignedToType;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateAssignmentTeamStaticMapping mutation. */
export type UpdateAssignmentTeamStaticMappingPayload = {
  __typename?: 'UpdateAssignmentTeamStaticMappingPayload';
  record: AssignmentTeamStaticMapping;
};

/** Update authentication token input */
export type UpdateAuthenticationTokenInput = {
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateAuthenticationToken mutation. */
export type UpdateAuthenticationTokenPayload = {
  __typename?: 'UpdateAuthenticationTokenPayload';
  record: AuthenticationToken;
};

export type UpdateBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Code specifying the capacity in which the agent is acting. */
  function?: InputMaybe<Scalars['String']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Code specifying the issuing country of the party's identifiers.  Complies to ISO 3166-1 alpha 2. */
  identificationIssuingCountry?: InputMaybe<Scalars['CountryCode']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Code specifying where quality assurance level of the agent should be used. */
  qualityAssurance?: InputMaybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the updateBroker mutation. */
export type UpdateBrokerPayload = {
  __typename?: 'UpdateBrokerPayload';
  record: Broker;
};

export type UpdateBulkChargesUploadRequestInput = {
  /** All the records and their failure reasons in the request */
  results?: InputMaybe<Array<BulkChargesUploaderResultInput>>;
  /**  The status of BulkUpload Request */
  status?: InputMaybe<BulkUploadStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Total number of failed rows */
  totalFailures?: InputMaybe<Scalars['Int']>;
  /** Total number of creation requests in the document */
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** Payload returned from the updateBulkChargesUploadRequest mutation. */
export type UpdateBulkChargesUploadRequestPayload = {
  __typename?: 'UpdateBulkChargesUploadRequestPayload';
  record: BulkChargesUploadRequest;
};

export type UpdateBulkComplianceUploadRequestInput = {
  /** All the records and their failure reasons in the request */
  results?: InputMaybe<Array<BulkComplianceUploaderResultInput>>;
  /**  The status of BulkUpload Request */
  status?: InputMaybe<BulkUploadStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Total number of failed rows */
  totalFailures?: InputMaybe<Scalars['Int']>;
  /** Total number of creation requests in the document */
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** Payload returned from the updateBulkComplianceUploadRequest mutation. */
export type UpdateBulkComplianceUploadRequestPayload = {
  __typename?: 'UpdateBulkComplianceUploadRequestPayload';
  record: BulkComplianceUploadRequest;
};

export type UpdateBulkMilestoneUploadRequestInput = {
  /** All the records and their failure reasons in the request */
  results?: InputMaybe<Array<BulkMilestoneUploaderResultInput>>;
  /**  The status of BulkUpload Request */
  status?: InputMaybe<BulkUploadStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Total number of failed rows */
  totalFailures?: InputMaybe<Scalars['Int']>;
  /** Total number of creation requests in the document */
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** Payload returned from the updateBulkMilestoneUploadRequest mutation. */
export type UpdateBulkMilestoneUploadRequestPayload = {
  __typename?: 'UpdateBulkMilestoneUploadRequestPayload';
  record: BulkMilestoneUploadRequest;
};

export type UpdateBulkProductUploadTemplateDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateBulkProductUploadTemplateDocumentGenerationRequestWithDocumentIdPayload';
  record: BulkProductUploadTemplateDocumentGenerationRequest;
};

export type UpdateBusinessSupportTeamInput = {
  /** The members belonging to this support team */
  members?: InputMaybe<Array<BusinessSupportTeamMemberInput>>;
  /** The User Team's name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** The payload returned from the updateBusinessSupportTeamOperatorUserRelationship mutation. */
export type UpdateBusinessSupportTeamOperatorUserRelationshipPayload = {
  __typename?: 'UpdateBusinessSupportTeamOperatorUserRelationshipPayload';
  /** The updated relationship between the Business Support Team and Operator User Records. */
  relationship: BusinessSupportTeamOperatorUserRelationship;
};

/** Payload returned from the updateBusinessSupportTeam mutation. */
export type UpdateBusinessSupportTeamPayload = {
  __typename?: 'UpdateBusinessSupportTeamPayload';
  record: BusinessSupportTeam;
};

/** Update Case Category Config Input */
export type UpdateCaseCategoryConfigInput = {
  /** Assignment team access configuration */
  assignmentTeamAccess: Array<AssignmentTeamAccessInput>;
  /** Auto assignment configuration */
  autoAssignmentConfig?: InputMaybe<Array<AutoAssignmentConfigInput>>;
  /** The unique case category id */
  caseCategoryId: Scalars['ID'];
  /** Manual assignment teams */
  manualAssignmentTeams?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Work order types associated with the case category */
  workOrderTypes?: InputMaybe<Array<WorkOrderType>>;
};

/** Payload returned from the updateCaseCategoryConfig mutation. */
export type UpdateCaseCategoryConfigPayload = {
  __typename?: 'UpdateCaseCategoryConfigPayload';
  record: CaseCategoryConfig;
};

export type UpdateCbp5106Transaction = CreateUsConsigneeCbp5106Transaction | CreateUsIorCbp5106Transaction | RequestUsIorCbpAssignedNumberTransaction | UpdateUsConsigneeCbp5106Transaction | UpdateUsIorCbp5106Transaction;

export type UpdateCbpEntryStatementTransaction = UpdateUsConsumptionEntryStatementCbpTransaction;

export type UpdateCommodityGroupInput = {
  /** The description of the commodities part of this group */
  description?: InputMaybe<Scalars['String']>;
  /** Hts chapters associated with this commodity group */
  htsChapters?: InputMaybe<Array<Scalars['String']>>;
  /** The name of the commodity group */
  name?: InputMaybe<Scalars['String']>;
  /** PGAs associated with this commodity group */
  pgas?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateCommodityGroup mutation. */
export type UpdateCommodityGroupPayload = {
  __typename?: 'UpdateCommodityGroupPayload';
  record: CommodityGroup;
};

/** The input payload used to update a Custom Domain. */
export type UpdateCustomDomainInput = {
  /** The Content Distribution Network for the Custom Domain. */
  cdn?: InputMaybe<CustomDomainCdnInput>;
  /** The SSL certificate. */
  certificate?: InputMaybe<CustomDomainCertificateInput>;
  /** The tab title */
  tabTitle?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateCustomDomain mutation. */
export type UpdateCustomDomainPayload = {
  __typename?: 'UpdateCustomDomainPayload';
  record: CustomDomain;
};

export type UpdateCustomsAgentInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the updateCustomsAgent mutation. */
export type UpdateCustomsAgentPayload = {
  __typename?: 'UpdateCustomsAgentPayload';
  record: CustomsAgent;
};

export type UpdateCustomsDeclarationInput = {
  /** Details related to the party authorized to act on behalf of another party. */
  agent?: InputMaybe<Array<IdInput>>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** Reference for large goodsItem data stored in S3. */
  goodsItemReference?: InputMaybe<GoodsItemReferenceInput>;
  /** Details related to the movement and the handling of goods shipped together on one or more means of transport between original consignor and final consignee. */
  goodsShipment?: InputMaybe<Array<GoodsShipmentInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Identification of a specific document. */
  identification?: InputMaybe<Scalars['String']>;
  /** Amount indicating the total of all invoice amounts in a single declaration. */
  invoice?: InputMaybe<Scalars['Float']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateCustomsDeclaration mutation. */
export type UpdateCustomsDeclarationPayload = {
  __typename?: 'UpdateCustomsDeclarationPayload';
  record: CustomsDeclaration;
};

export type UpdateCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker?: InputMaybe<CustomsEntryCustomsBrokerInput>;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<CustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: InputMaybe<Array<Scalars['ImportEntryNumber']>>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<CustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<CustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

export type UpdateCustomsEntryPayload = {
  __typename?: 'UpdateCustomsEntryPayload';
  /** The updated Customs Entry. */
  record: CustomsEntry;
};

export type UpdateDeConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateDeConsignee mutation. */
export type UpdateDeConsigneePayload = {
  __typename?: 'UpdateDeConsigneePayload';
  record: DeConsignee;
};

export type UpdateDeCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['DeEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the updateDeCustomsBroker mutation. */
export type UpdateDeCustomsBrokerPayload = {
  __typename?: 'UpdateDeCustomsBrokerPayload';
  record: DeCustomsBroker;
};

export type UpdateDeCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker?: InputMaybe<DeCustomsEntryCustomsBrokerInput>;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<DeCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<DeCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<DeCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the updateDeCustomsEntry mutation. */
export type UpdateDeCustomsEntryPayload = {
  __typename?: 'UpdateDeCustomsEntryPayload';
  record: DeCustomsEntry;
};

export type UpdateDeIorActivationInput = {
  /** DE Customs Broker associated with the activation. */
  broker: DeIorActivationBrokerInput;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** DE IOR to be activated. */
  ior?: InputMaybe<DeIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateDeIorActivation mutation. */
export type UpdateDeIorActivationPayload = {
  __typename?: 'UpdateDeIorActivationPayload';
  record: DeIorActivation;
};

/** Update DeIor activation status api input. */
export type UpdateDeIorActivationStatusInput = {
  /** Broker representation for the Importer. */
  brokerRepresentation?: InputMaybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: IdInput;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: InputMaybe<ExternalBrokerReferenceInput>;
  /** External Importer references. */
  externalIorReferences?: InputMaybe<Array<ExternalIorReferenceInput>>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type UpdateDeIorActivationStatusPayload = {
  __typename?: 'UpdateDeIorActivationStatusPayload';
  /** The updated DeIor */
  deIor: DeIor;
};

export type UpdateDeIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['DeEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['DeVatNumber']>;
};

/** Payload returned from the updateDeIor mutation. */
export type UpdateDeIorPayload = {
  __typename?: 'UpdateDeIorPayload';
  record: DeIor;
};

export type UpdateDeliveryOrderDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateDeliveryOrderDocumentGenerationRequestWithDocumentIdPayload';
  /** Delivery Order Document Generation Request with the document id. */
  record: DeliveryOrderDocumentGenerationRequest;
};

export type UpdateDeliveryOrderInput = {
  /** bill to party info. */
  billTo?: InputMaybe<IdInput>;
  /** Containers associated with the delivery order. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Destination Location */
  destination?: InputMaybe<DeliveryOrderDestinationInput>;
  /** The details of the optional email notifications */
  email?: InputMaybe<DeliveryOrderEmailInfoInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Details about the pick up  */
  pickup?: InputMaybe<DeliveryOrderPickupInput>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The Trucker carrying the goods */
  trucker?: InputMaybe<DeliveryOrderTruckerInput>;
};

/** Payload returned from the updateDeliveryOrder mutation. */
export type UpdateDeliveryOrderPayload = {
  __typename?: 'UpdateDeliveryOrderPayload';
  record: DeliveryOrder;
};

/** Update document input */
export type UpdateDocumentInput = {
  /** Set on new documents once they have been through a ClamAV anti-virus scan. */
  antivirusScanStatus?: InputMaybe<DocumentAntivirusScanStatus>;
  /** Defines the type of content within the document, also known as the MIME type (e.g. text/html). Will be inferred from the file extension if not provided. */
  contentType?: InputMaybe<Scalars['DocumentContentType']>;
  /** Captures all instances of the document being submitted electronically to U.S. Customs via DIS. */
  disSubmissions?: InputMaybe<Array<DisSubmissionInput>>;
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags?: InputMaybe<Array<DocumentTag>>;
  /** The expiration date of the document. */
  expirationDate?: InputMaybe<Scalars['Date']>;
  /** External document reference. */
  externalDocumentReference?: InputMaybe<ExternalDocumentReferenceInput>;
  /** Extracted document content. */
  extractedDocumentContent?: InputMaybe<ExtractedDocumentContentInput>;
  /** Name of the document. */
  fileName?: InputMaybe<Scalars['String']>;
  /** Indicates if a document is password protected. */
  passwordStatus?: InputMaybe<DocumentPasswordStatus>;
  /** A public document is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for document objects to prevent duplication. */
  sha1?: InputMaybe<Scalars['String']>;
  /** The size of the document in bytes. */
  size?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateDocument mutation. */
export type UpdateDocumentPayload = {
  __typename?: 'UpdateDocumentPayload';
  record: Document;
};

export type UpdateDocumentPreviewStatusInput = {
  /** If not set, previewStatus will change to PENDING_UPLOAD and the preview.uploadLink URL will be returned. */
  previewStatus?: InputMaybe<MutableDocumentPreviewStatus>;
};

export type UpdateDocumentPreviewStatusPayload = {
  __typename?: 'UpdateDocumentPreviewStatusPayload';
  record: Document;
};

/** Update DocumentTemplate input. */
export type UpdateDocumentTemplateInput = {
  /** The template HTML */
  html?: InputMaybe<Scalars['String']>;
  /** The JSON representation of the template HTML. */
  jsonHtml?: InputMaybe<Scalars['JSONObject']>;
  /** The name of the template. */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateDocumentTemplate mutation. */
export type UpdateDocumentTemplatePayload = {
  __typename?: 'UpdateDocumentTemplatePayload';
  record: DocumentTemplate;
};

export type UpdateDocumentTemplateStatusPayload = {
  __typename?: 'UpdateDocumentTemplateStatusPayload';
  /** Document Template. */
  record: DocumentTemplate;
};

export type UpdateDpsRecordInput = {
  /** Current DPS screening status */
  dpsStatus?: InputMaybe<DpsStatusInput>;
  /** Unique identifier for the entity being screened. */
  entityId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for this screening session. */
  entityScreeningId?: InputMaybe<Scalars['String']>;
  /** Version number of the entity being screened. */
  entityVersion?: InputMaybe<Scalars['Float']>;
  /** Error message if DPS screening failed (optional). */
  errorMessage?: InputMaybe<Scalars['String']>;
  /** Resolution details for the DPS screening result (optional). */
  resolution?: InputMaybe<DpsResolutionInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateDpsRecord mutation. */
export type UpdateDpsRecordPayload = {
  __typename?: 'UpdateDpsRecordPayload';
  record: DpsRecord;
};

export type UpdateErrorDefinitionInput = {
  /** The description of what the error is but can also include an SOP. */
  description: Scalars['String'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateErrorDefinition mutation. */
export type UpdateErrorDefinitionPayload = {
  __typename?: 'UpdateErrorDefinitionPayload';
  record: ErrorDefinition;
};

export type UpdateEuHsInput = {
  /** Effective descriptions with locale support */
  descriptions?: InputMaybe<Array<HsDescriptionInput>>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: InputMaybe<HsNumberType>;
  /** Main duty rates */
  mainDutyRates?: InputMaybe<Array<HsRateInput>>;
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateEuHs mutation. */
export type UpdateEuHsPayload = {
  __typename?: 'UpdateEuHsPayload';
  record: EuHs;
};

export type UpdateEuUkCustomsDeclarationPayload = {
  __typename?: 'UpdateEuUkCustomsDeclarationPayload';
  /** The updated Customs Declaration. */
  record: CustomsDeclaration;
};

export type UpdateExcelTemplateDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateExcelTemplateDocumentGenerationRequestWithDocumentIdPayload';
  record: ExcelTemplateDocumentGenerationRequest;
};

/** The input used to update an ExchangeMessage (only used to update tags and assigned work order IDs currently). */
export type UpdateExchangeMessageInput = {
  /** Additional metadata for Email ExchangeMessages. */
  inboxMetadata?: InputMaybe<InboxMetadataInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateExchangeMessage mutation. */
export type UpdateExchangeMessagePayload = {
  __typename?: 'UpdateExchangeMessagePayload';
  record: ExchangeMessage;
};

export type UpdateFacilityInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Compliance details for customs purposes. */
  complianceDetails?: InputMaybe<FacilityComplianceDetailsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** A point of contact for receiving goods */
  receivingPointOfContact?: InputMaybe<PointOfContactInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateFacility mutation. */
export type UpdateFacilityPayload = {
  __typename?: 'UpdateFacilityPayload';
  record: Facility;
};

/** Update FeatureFlag Input */
export type UpdateFeatureFlagInput = {
  /** Additional attributes for the feature flag. */
  attributes?: InputMaybe<Array<AttributeInput>>;
  /** The cleanup reminder date for the feature flag. */
  cleanupReminderDate?: InputMaybe<Scalars['DateTime']>;
  /** AWS AppConfig deployment strategy */
  deploymentStrategy?: InputMaybe<DeploymentStrategy>;
  /** The dial-up percentage for the feature flag. */
  dialUpPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Whether the feature flag is enabled. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The name of the feature flag. */
  featureFlagName: Scalars['String'];
  /** MCM identifier */
  mcmId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateFeatureFlag mutation. */
export type UpdateFeatureFlagPayload = {
  __typename?: 'UpdateFeatureFlagPayload';
  record: FeatureFlag;
};

export type UpdateForwarderInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Billing related details. */
  billingDetails?: InputMaybe<BillingDetailsInput>;
  /** Forwarder Cargowise One integration details. */
  cargowise?: InputMaybe<ForwarderCargowiseIntegrationDetailsInput>;
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: InputMaybe<CustomerDefaultWorkOrdersConfigInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Features disabled for forwarder. */
  disabledFeatures?: InputMaybe<ForwarderDisabledFeaturesInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References to this external system in external integrations. */
  externalIntegrationReferences?: InputMaybe<Array<PartyExternalIntegrationReferenceInput>>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The Party that has invited this Party to the CBMS platform. */
  invitingParty?: InputMaybe<IdInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** Indicates whether the forwarder overrides ior POA - Direct or Master/Sub. */
  poaMethod?: InputMaybe<POAMethod>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The configuration for this party's product library */
  productLibraryConfiguration?: InputMaybe<ProductLibraryConfigurationInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<Scalars['SCACCode']>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: InputMaybe<CustomerSelfFiledWorkOrdersConfigInput>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  /** Indicates whether the forwarder supports importing personal effects. */
  supportsPersonalEffects?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: InputMaybe<ForwarderWorkOrderConfigInput>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: InputMaybe<Array<ForwarderWorkOrderConfirmationConfigurationInput>>;
};

/** Payload returned from the updateForwarder mutation. */
export type UpdateForwarderPayload = {
  __typename?: 'UpdateForwarderPayload';
  record: Forwarder;
};

/** Update ForwarderSystem Input */
export type UpdateForwarderSystemInput = {
  /** API Authorization Details. */
  authorization?: InputMaybe<ApiAuthorizationInput>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration?: InputMaybe<ExternalSystemAwsIntegrationDetailsInput>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: InputMaybe<ExternalSystemIntegrationDetailsInput>;
  /** External client name. */
  name?: InputMaybe<Scalars['String']>;
  /** Notification preferences for the external system. */
  notifications?: InputMaybe<Array<ExternalSystemNotificationPreferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** URL to recieve events via webhook. */
  webhookUrl?: InputMaybe<Scalars['URL']>;
};

/** Payload returned from the updateForwarderSystem mutation. */
export type UpdateForwarderSystemPayload = {
  __typename?: 'UpdateForwarderSystemPayload';
  record: ForwarderSystem;
};

/** Update Forwarder User Input */
export type UpdateForwarderUserInput = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: InputMaybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: InputMaybe<Scalars['Boolean']>;
  /** Forwarder User Cargowise One integration details. */
  cargowise?: InputMaybe<ForwarderUserCargowiseIntegrationDetailsInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References to this forwarder user in external integrations. */
  externalIntegrationReferences?: InputMaybe<Array<ExternalIntegrationReferenceInput>>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: InputMaybe<Scalars['Boolean']>;
  /** A mobile phone number. */
  mobilePhone?: InputMaybe<PhoneInput>;
  /** External client name. */
  name?: InputMaybe<Scalars['String']>;
  /** The forwarder's notification preferences. */
  notifications?: InputMaybe<Array<ForwarderUserNotificationPreferenceInput>>;
  /** A office phone number. */
  officePhone?: InputMaybe<PhoneInput>;
  /** The forwarder's permission. */
  permissions?: InputMaybe<ForwarderUserPermissionsInput>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The teams the user is on */
  teams?: InputMaybe<Array<IdInput>>;
  /** Title of the user */
  title?: InputMaybe<Scalars['String']>;
};

/** Payload returned from the updateForwarderUser mutation. */
export type UpdateForwarderUserPayload = {
  __typename?: 'UpdateForwarderUserPayload';
  record: ForwarderUser;
};

export type UpdateFrConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateFrConsignee mutation. */
export type UpdateFrConsigneePayload = {
  __typename?: 'UpdateFrConsigneePayload';
  record: FrConsignee;
};

export type UpdateFrCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['FrEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the updateFrCustomsBroker mutation. */
export type UpdateFrCustomsBrokerPayload = {
  __typename?: 'UpdateFrCustomsBrokerPayload';
  record: FrCustomsBroker;
};

export type UpdateFrCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker?: InputMaybe<FrCustomsEntryCustomsBrokerInput>;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<FrCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<FrCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<FrCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the updateFrCustomsEntry mutation. */
export type UpdateFrCustomsEntryPayload = {
  __typename?: 'UpdateFrCustomsEntryPayload';
  record: FrCustomsEntry;
};

export type UpdateFrIorActivationInput = {
  /** FR Customs Broker associated with the activation. */
  broker: FrIorActivationBrokerInput;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** FR IOR to be activated. */
  ior?: InputMaybe<FrIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateFrIorActivation mutation. */
export type UpdateFrIorActivationPayload = {
  __typename?: 'UpdateFrIorActivationPayload';
  record: FrIorActivation;
};

/** Update FrIor activation status api input. */
export type UpdateFrIorActivationStatusInput = {
  /** Broker representation for the Importer. */
  brokerRepresentation?: InputMaybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: IdInput;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: InputMaybe<ExternalBrokerReferenceInput>;
  /** External Importer references. */
  externalIorReferences?: InputMaybe<Array<ExternalIorReferenceInput>>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type UpdateFrIorActivationStatusPayload = {
  __typename?: 'UpdateFrIorActivationStatusPayload';
  /** The updated FrIor */
  frIor: FrIor;
};

export type UpdateFrIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['FrEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['FrVatNumber']>;
};

/** Payload returned from the updateFrIor mutation. */
export type UpdateFrIorPayload = {
  __typename?: 'UpdateFrIorPayload';
  record: FrIor;
};

export type UpdateGbConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateGbConsignee mutation. */
export type UpdateGbConsigneePayload = {
  __typename?: 'UpdateGbConsigneePayload';
  record: GbConsignee;
};

export type UpdateGbCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker?: InputMaybe<GbCustomsEntryCustomsBrokerInput>;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<GbCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** 18-char alphanumeric identification number assigned by HMRC to uniquely identify each customs declaration for importing goods into UK.  Also known as Movement Reference Number(MRN).  A shipment can have multiple IENs if it is split. */
  importEntryNumbers?: InputMaybe<Array<Scalars['ImportEntryNumber']>>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<GbCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<GbCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the updateGbCustomsEntry mutation. */
export type UpdateGbCustomsEntryPayload = {
  __typename?: 'UpdateGbCustomsEntryPayload';
  record: GbCustomsEntry;
};

export type UpdateGbIorActivationInput = {
  /** GB Customs Broker associated with the activation. */
  broker: UkIorActivationBrokerInput;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** GB IOR to be activated. */
  ior?: InputMaybe<GbIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateGbIorActivation mutation. */
export type UpdateGbIorActivationPayload = {
  __typename?: 'UpdateGbIorActivationPayload';
  record: GbIorActivation;
};

/** Update GbIor activation status api input. */
export type UpdateGbIorActivationStatusInput = {
  /** Broker representation for the Importer. */
  brokerRepresentation?: InputMaybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: IdInput;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: InputMaybe<ExternalBrokerReferenceInput>;
  /** External Importer references. */
  externalIorReferences?: InputMaybe<Array<ExternalIorReferenceInput>>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type UpdateGbIorActivationStatusPayload = {
  __typename?: 'UpdateGbIorActivationStatusPayload';
  /** The updated GbIor */
  gbIor: GbIor;
};

export type UpdateGbIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['GbEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['GbVatNumber']>;
};

/** Payload returned from the updateGbIor mutation. */
export type UpdateGbIorPayload = {
  __typename?: 'UpdateGbIorPayload';
  record: GbIor;
};

export type UpdateGenericDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateGenericDocumentGenerationRequestWithDocumentIdPayload';
  /** Generic Document Generation Request with the document id. */
  record: GenericDocumentGenerationRequest;
};

export type UpdateGlobalConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Code specifying the issuing country of the identification. */
  identificationIssuingCountry: Scalars['CountryCode'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateGlobalConsignee mutation. */
export type UpdateGlobalConsigneePayload = {
  __typename?: 'UpdateGlobalConsigneePayload';
  record: GlobalConsignee;
};

export type UpdateHtmlDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateHtmlDocumentGenerationRequestWithDocumentIdPayload';
  /** HTML Document Generation Request with the document ID. */
  record: HtmlDocumentGenerationRequest;
};

export type UpdateHtsInput = {
  /** May be subject to anti-dumping duties. */
  ad?: InputMaybe<Scalars['Boolean']>;
  /** Anti-dumping and Countervailing duty (ADD/CVD) active case Ids */
  adCvdCases?: InputMaybe<Array<IdInput>>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additional?: InputMaybe<Array<AdditionalHtsInput>>;
  /** Additional Tariff may be required. */
  additionalHTS?: InputMaybe<Scalars['Boolean']>;
  /** The additional HTS number that may be required. */
  additionalHtsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additionalHtssApplicable?: InputMaybe<Array<AdditionalHtsInput>>;
  /** The effective end date provided by ACE CATAIR. It may differ from the top-level endDate. */
  cbpEndDate?: InputMaybe<Scalars['Date']>;
  /** The effective start date provided by ACE CATAIR. It may differ from the top-level startDate. */
  cbpStartDate?: InputMaybe<Scalars['Date']>;
  /** Compliance notes */
  complianceNotes?: InputMaybe<Array<HtsComplianceNoteInput>>;
  /** May be subject to countervailing duties. */
  cv?: InputMaybe<Scalars['Boolean']>;
  /** Longer description of Tariff. */
  description?: InputMaybe<Scalars['String']>;
  /** Descriptions of Tariff. */
  descriptions?: InputMaybe<Array<HtsDescriptionInput>>;
  /** Duty code */
  duty?: InputMaybe<Scalars['String']>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Fees required, also used for taxes. */
  fees?: InputMaybe<Array<HtsFeeInput>>;
  /** Is HS number fully qualified. */
  fullyQualified?: InputMaybe<Scalars['Boolean']>;
  /** Country of origin codes not permitted to use with the Generalized System of Preferences SPI (A*). */
  gspExcluded?: InputMaybe<Array<Scalars['String']>>;
  /** HS number type */
  hsNumberType?: InputMaybe<HsNumberType>;
  /** License data potentially required on an entry. */
  license?: InputMaybe<HtsLicenseInput>;
  /** License code required on Line. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** Column one rate object used to calculate duty that may apply to HS during different time intervals. */
  mainDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Partner Government Agency data potentially required on an entry. */
  pga?: InputMaybe<Array<PgaRequirementInput>>;
  /** May be subject to a quota. */
  quota?: InputMaybe<Scalars['Boolean']>;
  /** Rate object used to calculate duty. */
  rate?: InputMaybe<HtsRateInput>;
  /** Restrictions on HTS number usage. */
  restriction?: InputMaybe<HtsRestrictionInput>;
  /** Column two rate object used to calculate duty that may apply to HS during different time intervals. */
  secondaryDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Special Program Indicators available to use, subject to country of origin. */
  spi?: InputMaybe<Array<SpiInput>>;
  /** Special rates based on different SPIs. */
  spiRates?: InputMaybe<Array<HtsSpiRateInput>>;
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Description of Tariff. */
  text?: InputMaybe<Scalars['String']>;
  /** Textile code. */
  textile?: InputMaybe<Scalars['String']>;
  /** Truncated description of Tariff. */
  truncatedDescription?: InputMaybe<Scalars['String']>;
  /** Required unit of measure reporting quantities. */
  uom?: InputMaybe<Array<Scalars['String']>>;
};

/** Payload returned from the updateHts mutation. */
export type UpdateHtsPayload = {
  __typename?: 'UpdateHtsPayload';
  record: Hts;
};

export type UpdateImportProductsFromBulkUploadRequestInput = {
  /** The details to be reviewed by the user when determining whether or not to accept or reject the bulk upload processing. */
  confirmationDetails?: InputMaybe<ProductBulkUploadConfirmationDetailsInput>;
  /** The current status for the processing of this confirmable upload request */
  status?: InputMaybe<ConfirmableBulkUploadStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateImportProductsFromBulkUploadRequest mutation. */
export type UpdateImportProductsFromBulkUploadRequestPayload = {
  __typename?: 'UpdateImportProductsFromBulkUploadRequestPayload';
  record: ImportProductsFromBulkUploadRequest;
};

export type UpdateImportProductsFromCustomsEntriesRequestInput = {
  /** Customs entries created this many days before today will be included in the list which creates product records. */
  createdDaysAgo?: InputMaybe<Scalars['Float']>;
  /** The status of the processing for this request. Will be updated with either COMPLETED or FAILED accordingly. */
  status?: InputMaybe<ImportProductsStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateImportProductsFromCustomsEntriesRequest mutation. */
export type UpdateImportProductsFromCustomsEntriesRequestPayload = {
  __typename?: 'UpdateImportProductsFromCustomsEntriesRequestPayload';
  record: ImportProductsFromCustomsEntriesRequest;
};

export type UpdateImporterEntityActivationInput = {
  /** Broker associated with the activation. */
  broker?: InputMaybe<IdInput>;
  /** Code specifying the country of this importer entity activation. It uses ISO 3166 standard. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Importer Entity activation request in a given country. */
  importerEntity?: InputMaybe<IdOptionalVersionInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** US Importer of Record reference. */
  usIor?: InputMaybe<IdOptionalVersionInput>;
};

/** Payload returned from the updateImporterEntityActivation mutation. */
export type UpdateImporterEntityActivationPayload = {
  __typename?: 'UpdateImporterEntityActivationPayload';
  record: ImporterEntityActivation;
};

export type UpdateImporterEntityInput = {
  /** Activation input. */
  activations?: InputMaybe<Array<UpsertImporterEntityActivationInput>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** A list of the Importer's customs bonds for importing in the country. */
  bonds?: InputMaybe<CustomsBondsInput>;
  /** Country Code in which importer entity is operating. */
  countryCode: Scalars['CountryCode'];
  /** Importer Entity's country specific data. */
  countrySpecificData?: InputMaybe<CountrySpecificDataInput>;
  /** Identifier for DocReadiness status of IE in ShipDocs system */
  docReadinessId?: InputMaybe<Scalars['String']>;
  /** The code for the Importer's expected import volume in the country. */
  entriesPerYearCode?: InputMaybe<EntriesPerYear>;
  /** Importer Entity entry summary email addresses. */
  entrySummaryContactEmails?: InputMaybe<Array<Scalars['Email']>>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References provided by external client. */
  externalClientReferences?: InputMaybe<Array<Scalars['String']>>;
  /** A list of external validation results for this ImporterEntity's identifiers. */
  externalValidations?: InputMaybe<Array<ExternalValidationInput>>;
  /** Indicate whether the importer entity has imported before. */
  hasImportedBefore?: InputMaybe<Scalars['Boolean']>;
  /** Indicate whether the IOR entity has own duty and tax account. */
  hasOwnDutyAndTaxAccount?: InputMaybe<Scalars['Boolean']>;
  /** Importer country exclusive identifiers list. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Indicate whether the IOR entity is a resident importer. */
  isResident?: InputMaybe<Scalars['Boolean']>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: InputMaybe<Scalars['Boolean']>;
  /** Importer Entity point of contact. */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** Details of Programs associated with the Importer Entity. */
  program?: InputMaybe<Array<ProgramDetailsInput>>;
  /** Source channel identifier */
  sourceChannel?: InputMaybe<SourceChannel>;
  /** Source portal identifier */
  sourcePortal?: InputMaybe<SourcePortal>;
  /** The status of the Importer Entity. */
  status?: InputMaybe<ImporterEntityStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateImporterEntity mutation. */
export type UpdateImporterEntityPayload = {
  __typename?: 'UpdateImporterEntityPayload';
  record: ImporterEntity;
};

export type UpdateImporterInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The description of the Importer's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<GlobalBusinessStructure>;
  /** Importer business website */
  businessWebsite?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Identifier for DocReadiness status of Importer in ShipDocs system */
  docReadinessId?: InputMaybe<Scalars['String']>;
  /** Importer Level Doc Readinesses */
  docReadinesses?: InputMaybe<Array<ImporterDocReadinessInput>>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** References provided by external client. */
  externalClientReferences?: InputMaybe<Array<Scalars['String']>>;
  /** Extracted business license data */
  extractedBusinessLicense?: InputMaybe<ExtractedBusinessLicenseInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the Importer */
  industry?: InputMaybe<Vertical>;
  /** The legal representative of the Importer */
  legalRepresentative?: InputMaybe<PointOfContactInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Identifiers of customers with ownership of IOR */
  owners?: InputMaybe<Array<ImporterOwnerInput>>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The secondary officer of the Importer */
  secondaryOfficer?: InputMaybe<PointOfContactInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** translated business license data */
  translatedBusinessLicense?: InputMaybe<TranslatedBusinessLicenseInput>;
};

/** Payload returned from the updateImporter mutation. */
export type UpdateImporterPayload = {
  __typename?: 'UpdateImporterPayload';
  record: Importer;
};

export type UpdateInBondNotesDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateInBondNotesDocumentGenerationRequestWithDocumentIdPayload';
  /** InBondNotes Document Generation Request with the document id. */
  record: InBondNotesDocumentGenerationRequest;
};

export type UpdateInvoiceCreditNoteDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateInvoiceCreditNoteDocumentGenerationRequestWithDocumentIdPayload';
  /** Invoice credit note document generation request with the document id */
  record: InvoiceCreditNoteDocumentGenerationRequest;
};

export type UpdateInvoiceCreditNoteInput = {
  /** The time that the credit note was applied by AR */
  creditTime?: InputMaybe<Scalars['DateTime']>;
  /** Context behind the purpose of the credit note */
  description?: InputMaybe<Scalars['String']>;
  /** The current working status of the credit note */
  status?: InputMaybe<InvoiceCreditNoteStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateInvoiceCreditNote mutation. */
export type UpdateInvoiceCreditNotePayload = {
  __typename?: 'UpdateInvoiceCreditNotePayload';
  record: InvoiceCreditNote;
};

export type UpdateInvoiceDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateInvoiceDocumentGenerationRequestWithDocumentIdPayload';
  /** Invoice Document Generation Request with the document id. */
  record: InvoiceDocumentGenerationRequest;
};

export type UpdateInvoiceInput = {
  /** Accounting System details */
  accountingSystemDetails?: InputMaybe<AccountingSystemDetailInput>;
  /** Billing party details of bill to party. */
  billToParty?: InputMaybe<IdVersionInput>;
  /** The sending history of the invoice */
  deliveries?: InputMaybe<Array<InvoiceDeliveryInput>>;
  /**  The due date of the invoice */
  dueTime?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  The time of the invoicing */
  invoicedTime?: InputMaybe<Scalars['DateTime']>;
  /** The individual charges on the invoice */
  lines?: InputMaybe<Array<InvoiceLineInput>>;
  /**  The payment method for this invoice */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** The current status of the invoice */
  status?: InputMaybe<InvoiceStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The work order group details associated with Invoice if invoice type is work order group */
  workOrderGroup?: InputMaybe<IdInput>;
};

export type UpdateInvoiceLinesRequestInput = {
  /** Accounting type of the Invoice Lines Request */
  accountingType?: InputMaybe<AccountingType>;
  /** Status of the Accounts Payable (AP) associated with the Invoice Lines Request */
  accountsPayableStatus?: InputMaybe<AccountsPayableStatus>;
  /** The party details used for subscription invoice line request. */
  billToParty?: InputMaybe<IdInput>;
  /** The documents associated with the InvoiceLinesRequest. */
  documents?: InputMaybe<Array<IdInput>>;
  /** An optional dueDate that will be used rather than the default configuration */
  dueDate?: InputMaybe<Scalars['Date']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** External references associated with the claim */
  externalReference?: InputMaybe<ExternalFinanceReferenceInput>;
  /** Flag to determine if invoice is ready to generate. */
  invoiceImmediately?: InputMaybe<Scalars['Boolean']>;
  /** Lines that need to add to the invoice. */
  lines?: InputMaybe<Array<InvoiceRequestLineInput>>;
  /** The operation to apply (e.g. amend) on lines of the InvoiceLinesRequest for an invoice. */
  operation?: InputMaybe<InvoiceLinesRequestOperation>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: InputMaybe<Scalars['SCACCode']>;
  /** InvoiceLinesRequest review status */
  reviewStatus?: InputMaybe<ReviewStatus>;
  /** Service types of the Invoice Lines Request */
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  /** Source of the Invoice Lines Request */
  source?: InputMaybe<InvoiceLinesRequestSource>;
  /** Status of the Invoice Lines Request */
  status?: InputMaybe<InvoiceLinesRequestStatus>;
  /** Status reason for review status */
  statusReason?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The type of invoice line request. */
  type?: InputMaybe<InvoiceType>;
  /** The work order details associated with invoice line request.  */
  workOrder?: InputMaybe<IdInput>;
};

/** Payload returned from the updateInvoiceLinesRequest mutation. */
export type UpdateInvoiceLinesRequestPayload = {
  __typename?: 'UpdateInvoiceLinesRequestPayload';
  record: InvoiceLinesRequest;
};

/** Payload returned from the updateInvoice mutation. */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  record: Invoice;
};

export type UpdateInvoicePaymentInput = {
  /** Accounting System details */
  accountingSystemDetail?: InputMaybe<AccountingSystemDetailInput>;
  /** Billing party details of customer. */
  customer?: InputMaybe<IdVersionInput>;
  /** Invoice paid time */
  paidTime?: InputMaybe<Scalars['DateTime']>;
  /** Payment method */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** The reference number for the payment received. For example, Check # for a check. */
  referenceNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Indicates the total amount of the payment. This includes the total of all the transactions. */
  totalAmount?: InputMaybe<CostInput>;
  /** The individual payment line on the invoice payment */
  transactions?: InputMaybe<Array<InvoicePaymentTransactionInput>>;
  /** Indicates the amount that has not been applied to pay amounts owed for sales transactions. This amount is total payment amount - the sum of applied payments. The unapplied amount can be applied for future invoices which belongs to the same customer. */
  unappliedAmount?: InputMaybe<CostInput>;
};

/** Payload returned from the updateInvoicePayment mutation. */
export type UpdateInvoicePaymentPayload = {
  __typename?: 'UpdateInvoicePaymentPayload';
  record: InvoicePayment;
};

/** Update memo input */
export type UpdateMemoInput = {
  /** Indicates if the memo should be visible to other parties. If isPublic is not true (by default), then only users with the same Account (forwarder/operator/shipper) can see it. Otherwise, both customers and operators can see the memo. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The text contained within the memo. */
  text?: InputMaybe<Scalars['String']>;
};

/** Payload returned from the updateMemo mutation. */
export type UpdateMemoPayload = {
  __typename?: 'UpdateMemoPayload';
  record: Memo;
};

export type UpdateNlConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateNlConsignee mutation. */
export type UpdateNlConsigneePayload = {
  __typename?: 'UpdateNlConsigneePayload';
  record: NlConsignee;
};

export type UpdateNlCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['NlEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the updateNlCustomsBroker mutation. */
export type UpdateNlCustomsBrokerPayload = {
  __typename?: 'UpdateNlCustomsBrokerPayload';
  record: NlCustomsBroker;
};

export type UpdateNlCustomsEntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<CustomsEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<WorkOrderBadge>>;
  /** Customs Broker associated with this entry. */
  broker?: InputMaybe<NlCustomsEntryCustomsBrokerInput>;
  /** Consignee associated with this entry. */
  consignee?: InputMaybe<NlCustomsEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Conveyance information. */
  conveyance?: InputMaybe<CustomsEntryConveyanceInput>;
  /** Departure information. */
  departure?: InputMaybe<CustomsEntryDepartureInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<NlCustomsEntryCommercialInvoiceInput>>;
  /** IOR associated with this entry. */
  ior?: InputMaybe<NlCustomsEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<CustomsEntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Purchase order (PO) number(s) associated with the entry. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** References associated with an entry alongside its processing status and error codes e.g. ien, etc */
  references?: InputMaybe<Array<ReferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to customs authority. */
  totalAssist?: InputMaybe<Scalars['Float']>;
  /** The total value of the merchandise reported to customs authority. */
  totalValue?: InputMaybe<Scalars['Float']>;
};

/** Payload returned from the updateNlCustomsEntry mutation. */
export type UpdateNlCustomsEntryPayload = {
  __typename?: 'UpdateNlCustomsEntryPayload';
  record: NlCustomsEntry;
};

export type UpdateNlIorActivationInput = {
  /** NL Customs Broker associated with the activation. */
  broker: NlIorActivationBrokerInput;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** NL IOR to be activated. */
  ior?: InputMaybe<NlIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateNlIorActivation mutation. */
export type UpdateNlIorActivationPayload = {
  __typename?: 'UpdateNlIorActivationPayload';
  record: NlIorActivation;
};

/** Update NlIor activation status api input. */
export type UpdateNlIorActivationStatusInput = {
  /** Broker representation for the Importer. */
  brokerRepresentation?: InputMaybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: IdInput;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: InputMaybe<ExternalBrokerReferenceInput>;
  /** External Importer references. */
  externalIorReferences?: InputMaybe<Array<ExternalIorReferenceInput>>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type UpdateNlIorActivationStatusPayload = {
  __typename?: 'UpdateNlIorActivationStatusPayload';
  /** The updated NlIor */
  nlIor: NlIor;
};

export type UpdateNlIorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** The structure of the business. */
  businessStructure?: InputMaybe<BusinessStructure>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['NlEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. A VAT (value added tax) number is required to import goods into the EU or UK. It is unique per country */
  vatNumber?: InputMaybe<Scalars['NlVatNumber']>;
};

/** Payload returned from the updateNlIor mutation. */
export type UpdateNlIorPayload = {
  __typename?: 'UpdateNlIorPayload';
  record: NlIor;
};

/** Update Onboarding Request Input */
export type UpdateOnboardingRequestInput = {
  /** Avartar document (aka profile picture). */
  avatarDoc?: InputMaybe<IdInput>;
  /** Company related details. */
  companyDetails?: InputMaybe<CompanyDetailsInput>;
  /** Onboarding status. */
  onboardingStatus?: InputMaybe<OnboardingStatus>;
  /** Onboarding customer profile. */
  profileDetails?: InputMaybe<ProfileDetailsInput>;
  /** Onboarding customer subscription plan details. */
  subscriptionDetails?: InputMaybe<SubscriptionDetailsInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateOnboardingRequest mutation. */
export type UpdateOnboardingRequestPayload = {
  __typename?: 'UpdateOnboardingRequestPayload';
  record: OnboardingRequest;
};

export type UpdateOperatorInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateOperator mutation. */
export type UpdateOperatorPayload = {
  __typename?: 'UpdateOperatorPayload';
  record: Operator;
};

/** Update OperatorSystem Input */
export type UpdateOperatorSystemInput = {
  /** API Authorization Details. */
  authorization?: InputMaybe<ApiAuthorizationInput>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration?: InputMaybe<ExternalSystemAwsIntegrationDetailsInput>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: InputMaybe<ExternalSystemIntegrationDetailsInput>;
  /** External client name. */
  name?: InputMaybe<Scalars['String']>;
  /** Notification preferences for the external system. */
  notifications?: InputMaybe<Array<ExternalSystemNotificationPreferenceInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** URL to recieve events via webhook. */
  webhookUrl?: InputMaybe<Scalars['URL']>;
};

/** Payload returned from the updateOperatorSystem mutation. */
export type UpdateOperatorSystemPayload = {
  __typename?: 'UpdateOperatorSystemPayload';
  record: OperatorSystem;
};

/** Update Operator User Input */
export type UpdateOperatorUserInput = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: InputMaybe<Scalars['DateTime']>;
  assignmentConfig?: InputMaybe<AssignmentConfigInput>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: InputMaybe<Scalars['Boolean']>;
  /** CustomsBroker party info. */
  customsBroker?: InputMaybe<IdInput>;
  /** Daily work order task completion goal set by managers */
  dailyGoal?: InputMaybe<Scalars['Int']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: InputMaybe<Scalars['Boolean']>;
  /** A mobile phone number. */
  mobilePhone?: InputMaybe<PhoneInput>;
  /** External client name. */
  name?: InputMaybe<Scalars['String']>;
  /** The operator's notification preferences. */
  notifications?: InputMaybe<Array<OperatorUserNotificationPreferenceInput>>;
  /** A office phone number. */
  officePhone?: InputMaybe<PhoneInput>;
  /** The operator's permission. */
  permissions?: InputMaybe<OperatorUserPermissionsInput>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: InputMaybe<Scalars['Boolean']>;
  /** Skill level of operator users which will be assigned by managers */
  skillLevel?: InputMaybe<SkillLevel>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Used to specify the teamProperties of OperatorUser */
  teamProperties?: InputMaybe<Array<OperatorUserTeamPropertyInput>>;
  /** The teams the user is on */
  teams?: InputMaybe<Array<IdInput>>;
  /** Title of the user */
  title?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<UserWorkingHoursInput>;
};

/** Payload returned from the updateOperatorUser mutation. */
export type UpdateOperatorUserPayload = {
  __typename?: 'UpdateOperatorUserPayload';
  record: OperatorUser;
};

export type UpdatePayableInvoiceInput = {
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** External references associated with the invoice */
  externalReference?: InputMaybe<ExternalFinanceReferenceInput>;
  /** The Scac code of the party to whom payment is to be made */
  payeeScac?: InputMaybe<Scalars['SCACCode']>;
  /** The current status of the invoice */
  status?: InputMaybe<PayableInvoiceStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updatePayableInvoice mutation. */
export type UpdatePayableInvoicePayload = {
  __typename?: 'UpdatePayableInvoicePayload';
  record: PayableInvoice;
};

export type UpdateProcessingErrorInput = {
  /** The status of the error. */
  status: ProcessingErrorStatus;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateProcessingError mutation. */
export type UpdateProcessingErrorPayload = {
  __typename?: 'UpdateProcessingErrorPayload';
  record: ProcessingError;
};

export type UpdateProductInput = {
  /** The ASIN for this product */
  asin?: InputMaybe<Scalars['String']>;
  /** Client identifier for the product (eg, sku, asin, etc). */
  clientIdentifier?: InputMaybe<Scalars['String']>;
  /** Client identifier Version for the product (eg, sku, asin, etc). */
  clientIdentifierVersion?: InputMaybe<Scalars['Int']>;
  /** Compliance details for importing the product, per country. */
  complianceDetails?: InputMaybe<ProductComplianceDetailsInput>;
  /** The country for which this product originates from - its manufacturing country. This field is used to determine product uniqueness. */
  countryOfOrigin?: InputMaybe<Scalars['CountryCode']>;
  /** The dimensions of the product. */
  dimensions?: InputMaybe<DimensionsInput>;
  /** Global Trade Item Number for the product. */
  gtin?: InputMaybe<Scalars['GTIN']>;
  ior?: InputMaybe<ProductIorInput>;
  /** Details of a product per locale.  */
  localizedDetails?: InputMaybe<Array<LocalizedProductDetailInput>>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Additional product notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Units per packing. */
  packingUnits?: InputMaybe<Scalars['Float']>;
  /** Set of additional secondary identifiers that the client might want to associate with the product (eg: ASIN). */
  secondaryIdentifiers?: InputMaybe<Array<ProductSecondaryIdentifierInput>>;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status?: InputMaybe<ProductStatus>;
  /** The Supplier(s) who manufacturer or sell the Product. */
  supplier?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Universal Product Code for the product. */
  upc?: InputMaybe<Scalars['String']>;
  /** The weight of the product */
  weight?: InputMaybe<WeightInput>;
};

/** Payload returned from the updateProduct mutation. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  record: Product;
};

export type UpdateProgramInput = {
  /** List of associated Customs Brokers under this program. */
  brokers: Array<IdInput>;
  /** The country codes associated with this program (e.g., US, GB, IN). */
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  /** The name of the program (e.g., CRIS). */
  programName?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateProgram mutation. */
export type UpdateProgramPayload = {
  __typename?: 'UpdateProgramPayload';
  record: Program;
};

/** Update Release Note Input */
export type UpdateReleaseNoteInput = {
  /** The description of the release note, supports markdown and hyperlinks. */
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The countries for which the release note should be shown */
  targetCountries?: InputMaybe<Array<Scalars['String']>>;
  /** Number of thumbs down reactions. */
  thumbsDown?: Scalars['Int'];
  /** Number of thumbs up reactions. */
  thumbsUp?: Scalars['Int'];
  /** The title of the release note. */
  title?: InputMaybe<Scalars['String']>;
};

/** Payload returned from the updateReleaseNote mutation. */
export type UpdateReleaseNotePayload = {
  __typename?: 'UpdateReleaseNotePayload';
  record: ReleaseNote;
};

export type UpdateReportReconciliationRequestInput = {
  /** The records create input of report reconciliation */
  reports?: InputMaybe<Array<ReportReconciliationInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateReportReconciliationRequest mutation. */
export type UpdateReportReconciliationRequestPayload = {
  __typename?: 'UpdateReportReconciliationRequestPayload';
  record: ReportReconciliationRequest;
};

export type UpdateShipmentCommercialInvoiceDetailInput = {
  /** List of invoices with their items and compliance details. */
  commercialInvoices?: InputMaybe<Array<ShipmentCommercialInvoiceInput>>;
  /** Shipment commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines. */
  commercialInvoicesReference?: InputMaybe<ShipmentCommercialInvoicesReferenceInput>;
  /** External document references. */
  externalDocumentReferences?: InputMaybe<Array<ExternalDocumentReferenceInput>>;
  /** The shipment leg index. */
  legIndex?: InputMaybe<Scalars['Int']>;
  /** The shipment associated with this record. */
  shipment?: InputMaybe<IdInput>;
  /** The source that caused the shipment commercial invoice to be updated */
  source?: InputMaybe<ShipmentCommercialInvoiceSourceInput>;
  /** The status of shipment commercial invoice detail */
  status?: InputMaybe<ShipmentCommercialInvoiceDetailStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateShipmentCommercialInvoiceDetail mutation. */
export type UpdateShipmentCommercialInvoiceDetailPayload = {
  __typename?: 'UpdateShipmentCommercialInvoiceDetailPayload';
  record: ShipmentCommercialInvoiceDetail;
};

export type UpdateShipmentDocumentProcessingRequestInput = {
  /** Shipment processing request documents. */
  documents?: InputMaybe<Array<ShipmentProcessingRequestDocumentInput>>;
  /** Status values for tracking document processing status for a shipment */
  status?: InputMaybe<ShipmentDocumentProcessingStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateShipmentDocumentProcessingRequest mutation. */
export type UpdateShipmentDocumentProcessingRequestPayload = {
  __typename?: 'UpdateShipmentDocumentProcessingRequestPayload';
  record: ShipmentDocumentProcessingRequest;
};

export type UpdateShipmentInput = {
  /** Badges related to a shipment e.g. HOT, PREMIUM */
  badges?: InputMaybe<Array<ShipmentBadge>>;
  /** Buyer is the party that buys the goods from overseas sellers. Name and address are required. */
  buyer?: InputMaybe<ShipmentBuyerInput>;
  /** The client's identifier for the shipment */
  clientIdentifier?: InputMaybe<Scalars['ShipmentClientIdentifier']>;
  /** Client references for the shipment: booking id, shipment id etc */
  clientReferences?: InputMaybe<ClientReferencesInput>;
  /** Consolidator is the party responsible for consolidation of the goods. Name and address are required. */
  consolidator?: InputMaybe<ShipmentConsolidatorInput>;
  /** External document references. */
  externalDocumentReferences?: InputMaybe<Array<ExternalDocumentReferenceInput>>;
  /** References to this shipment in external integrations. */
  externalIntegrationReferences?: InputMaybe<Array<ShipmentExternalIntegrationReferenceInput>>;
  /** The freight forwarders related to the Shipment. */
  forwarders?: InputMaybe<Array<ShipmentForwarderInput>>;
  /** Represents the different legs that make up a shipment. */
  legs?: InputMaybe<Array<ShipmentLegInput>>;
  /** Manufacturers associated with the shipment. Name and address are required. */
  manufacturers?: InputMaybe<Array<ShipmentManufacturerInput>>;
  /** Service type for AMP2.0 bookings, defaults to STANDARD for non-AMP2.0 bookings */
  placementType?: InputMaybe<PlacementType>;
  /** Preferred duty charge party type */
  preferredDutyCollectPartyType?: InputMaybe<PreferredDutyCollectPartyType>;
  /** Each provided WorkOrderType will be created automatically when the shipment is created/updated */
  requestedWorkOrders?: InputMaybe<Array<WorkOrderType>>;
  /** Sellers are indicated as the sellers of the goods. Name and address are required. */
  sellers?: InputMaybe<Array<ShipmentSellerInput>>;
  /** Destination associated with the shipment. */
  shipTo?: InputMaybe<ShipmentShipToInput>;
  /** Shipper is the party responsible for the shipment. */
  shipper?: InputMaybe<ShipmentShipperInput>;
  /** Container stuffing location associated with the shipment. Name and address are required. */
  stuffingLocation?: InputMaybe<ShipmentStuffingLocationInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateShipment mutation. */
export type UpdateShipmentPayload = {
  __typename?: 'UpdateShipmentPayload';
  record: Shipment;
};

/** The payload returned from the updateShipperImporterRelationship mutation. */
export type UpdateShipperImporterRelationshipPayload = {
  __typename?: 'UpdateShipperImporterRelationshipPayload';
  /** The updated relationship between the Shipper and Importer Records. */
  relationship: ShipperImporterRelationship;
};

export type UpdateShipperInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Billing related details. */
  billingDetails?: InputMaybe<BillingDetailsInput>;
  /** The cofiguration dictating the work orders to be generated by default (out of those which apply) for each mode of transportation per geography. */
  defaultWorkOrdersConfig?: InputMaybe<CustomerDefaultWorkOrdersConfigInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The Party that has invited this Party to the CBMS platform. */
  invitingParty?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The configuration for this party's product library */
  productLibraryConfiguration?: InputMaybe<ProductLibraryConfigurationInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The cofiguration dictating the work orders filed by the party themselves per geography. */
  selfFiledWorkOrdersConfig?: InputMaybe<CustomerSelfFiledWorkOrdersConfigInput>;
  /** An array of seller details coming from an external source */
  shipperExternallySourcedDetails?: InputMaybe<Array<ShipperExternallySourcedDetailsInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Configuration based on different work order types for this customer */
  workOrderConfig?: InputMaybe<ShipperWorkOrderConfigInput>;
  /** Work Order Confirmation Configuration Details. */
  workOrderConfirmationConfigurations?: InputMaybe<Array<WorkOrderConfirmConfigurationDetailsInput>>;
};

/** Payload returned from the updateShipper mutation. */
export type UpdateShipperPayload = {
  __typename?: 'UpdateShipperPayload';
  record: Shipper;
};

/** The payload returned from the updateShipperSupplierRelationship mutation. */
export type UpdateShipperSupplierRelationshipPayload = {
  __typename?: 'UpdateShipperSupplierRelationshipPayload';
  /** The updated relationship between the Shipper and Supplier Records. */
  relationship: ShipperSupplierRelationship;
};

/** Update ShipperSystem Input */
export type UpdateShipperSystemInput = {
  /** API Authorization Details. */
  authorization?: InputMaybe<ApiAuthorizationInput>;
  /** Details related to the AWS integration between CBMS and the External System. */
  awsIntegration?: InputMaybe<ExternalSystemAwsIntegrationDetailsInput>;
  /** Configuration for non-AWS integrations */
  externalIntegration?: InputMaybe<ExternalSystemIntegrationDetailsInput>;
  /** External client name. */
  name?: InputMaybe<Scalars['String']>;
  /** Notification preferences for the external system. */
  notifications?: InputMaybe<Array<ExternalSystemNotificationPreferenceInput>>;
  /** Shipper associated with the system. */
  shipper: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** URL to recieve events via webhook. */
  webhookUrl?: InputMaybe<Scalars['URL']>;
};

/** Payload returned from the updateShipperSystem mutation. */
export type UpdateShipperSystemPayload = {
  __typename?: 'UpdateShipperSystemPayload';
  record: ShipperSystem;
};

/** Update ShipperUser Input */
export type UpdateShipperUserInput = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: InputMaybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: InputMaybe<Scalars['Boolean']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: InputMaybe<Scalars['Boolean']>;
  /** A mobile phone number. */
  mobilePhone?: InputMaybe<PhoneInput>;
  /** External client name. */
  name?: InputMaybe<Scalars['String']>;
  /** The shipper's notification preferences. */
  notifications?: InputMaybe<Array<ShipperUserNotificationPreferenceInput>>;
  /** A office phone number. */
  officePhone?: InputMaybe<PhoneInput>;
  /** The shipper's permission. */
  permissions?: InputMaybe<ShipperUserPermissionsInput>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The teams the user is on */
  teams?: InputMaybe<Array<IdInput>>;
  /** Title of the user */
  title?: InputMaybe<Scalars['String']>;
};

/** Payload returned from the updateShipperUser mutation. */
export type UpdateShipperUserPayload = {
  __typename?: 'UpdateShipperUserPayload';
  record: ShipperUser;
};

export type UpdateStampDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateStampDocumentGenerationRequestWithDocumentIdPayload';
  /** Stamp Document Generation Request with the document id. */
  record: StampDocumentGenerationRequest;
};

/** Update Stamp document sign request input. */
export type UpdateStampDocumentSignRequestInput = {
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The sign request expires after the designated amount of minutes. If not set default is 1 year. */
  expireMinutes?: InputMaybe<Scalars['Int']>;
  /** Name of officer signing the document. */
  signerName?: InputMaybe<Scalars['String']>;
  /** Title of officer signing the document. */
  signerTitle?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateStampDocumentSignRequest mutation. */
export type UpdateStampDocumentSignRequestPayload = {
  __typename?: 'UpdateStampDocumentSignRequestPayload';
  record: StampDocumentSignRequest;
};

export type UpdateStampDocumentSignRequestWithSignaturePayload = {
  __typename?: 'UpdateStampDocumentSignRequestWithSignaturePayload';
  /** Stamp document sign request. */
  record: StampDocumentSignRequest;
};

export type UpdateStampDocumentSignRequestWithSignedDocumentPayload = {
  __typename?: 'UpdateStampDocumentSignRequestWithSignedDocumentPayload';
  /** Stamp document sign request. */
  record: StampDocumentSignRequest;
};

export type UpdateSubjectMatterExpertTeamInput = {
  /** Team's customs broker */
  customsBroker?: InputMaybe<IdInput>;
  /** Additonal input for the SME team and operator user relationship */
  members?: InputMaybe<Array<SubjectMatterExpertTeamMemberInput>>;
  /** The User Team's name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** The payload returned from the updateSubjectMatterExpertTeamOperatorUserRelationship mutation. */
export type UpdateSubjectMatterExpertTeamOperatorUserRelationshipPayload = {
  __typename?: 'UpdateSubjectMatterExpertTeamOperatorUserRelationshipPayload';
  /** The updated relationship between the Subject Matter Expert Team and Operator User Records. */
  relationship: SubjectMatterExpertTeamOperatorUserRelationship;
};

/** Payload returned from the updateSubjectMatterExpertTeam mutation. */
export type UpdateSubjectMatterExpertTeamPayload = {
  __typename?: 'UpdateSubjectMatterExpertTeamPayload';
  record: SubjectMatterExpertTeam;
};

export type UpdateSupplierInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Compliance details for customs purposes. */
  complianceDetails?: InputMaybe<SupplierComplianceDetailsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateSupplier mutation. */
export type UpdateSupplierPayload = {
  __typename?: 'UpdateSupplierPayload';
  record: Supplier;
};

/** Update Table Filter input */
export type UpdateTableFilterInput = {
  /** Name of the custom filter */
  name?: InputMaybe<Scalars['String']>;
  /** Custom table filter search criterias */
  tableFilterCriteria?: InputMaybe<Array<TableFilterCriterionInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Record table visible columns */
  visibleColumns?: InputMaybe<Array<Scalars['String']>>;
};

/** Payload returned from the updateTableFilter mutation. */
export type UpdateTableFilterPayload = {
  __typename?: 'UpdateTableFilterPayload';
  record: TableFilter;
};

export type UpdateTeamInput = {
  /** Team name */
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateTeam mutation. */
export type UpdateTeamPayload = {
  __typename?: 'UpdateTeamPayload';
  record: Team;
};

/** Update Document template sign request input. */
export type UpdateTemplateDocumentSignRequestInput = {
  /** Labels to classify the type of document (e.g. Bill of Lading). */
  documentTags: Array<DocumentTag>;
  /** The sign request expires after the designated amount of minutes. If not set default is 1 year. */
  expireMinutes?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateTemplateDocumentSignRequest mutation. */
export type UpdateTemplateDocumentSignRequestPayload = {
  __typename?: 'UpdateTemplateDocumentSignRequestPayload';
  record: TemplateDocumentSignRequest;
};

/** Update template document sign request with signature input */
export type UpdateTemplateDocumentSignRequestWithSignatureInput = {
  /** JSON object of captured field values to replace the document template's placeholder variables with. */
  additionalFields: Scalars['JSONObject'];
  /** The unique ID of a Record */
  id: Scalars['ID'];
  /** Data related to the document signature. */
  signature: DocumentSignatureInput;
  /** Birth date of officer signing the document */
  signerBirthDate?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Name of officer signing the document. */
  signerName: Scalars['String'];
  /** Title of officer signing the document. */
  signerTitle: Scalars['String'];
  /** Version of a Record. */
  version: Scalars['Int'];
};

export type UpdateTemplateDocumentSignRequestWithSignaturePayload = {
  __typename?: 'UpdateTemplateDocumentSignRequestWithSignaturePayload';
  /** Template document sign request. */
  record: TemplateDocumentSignRequest;
};

export type UpdateTemplateDocumentSignRequestWithSignedDocumentPayload = {
  __typename?: 'UpdateTemplateDocumentSignRequestWithSignedDocumentPayload';
  /** Template document sign request. */
  record: TemplateDocumentSignRequest;
};

/** Input to update document sign requests with signatures. */
export type UpdateTemplateDocumentSignRequestsWithSignaturesInput = {
  /** Update inputs for template document sign requests with signatures. */
  inputs: Array<UpdateTemplateDocumentSignRequestWithSignatureInput>;
};

export type UpdateTemplateDocumentSignRequestsWithSignaturesPayload = {
  __typename?: 'UpdateTemplateDocumentSignRequestsWithSignaturesPayload';
  /** The updated template document sign requests. */
  records: Array<TemplateDocumentSignRequest>;
};

export type UpdateTradeAdvisoryRequestInput = {
  /** Exchange message ID for tracking email status */
  exchangeMessageId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TradeAdvisoryRequestStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateTradeAdvisoryRequest mutation. */
export type UpdateTradeAdvisoryRequestPayload = {
  __typename?: 'UpdateTradeAdvisoryRequestPayload';
  record: TradeAdvisoryRequest;
};

export type UpdateTruckerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** A CBP Assigned Importer of Record number. */
  cain?: InputMaybe<Scalars['CbpAssignedNumber']>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** A point of contact for trucker dispatch */
  dispatchPointOfContact?: InputMaybe<PointOfContactInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code */
  scac?: InputMaybe<Scalars['SCACCode']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateTrucker mutation. */
export type UpdateTruckerPayload = {
  __typename?: 'UpdateTruckerPayload';
  record: Trucker;
};

export type UpdateUkCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Economic Operators Registration and Identification number. Businesses and people wishing to trade must use the EORI number as an identification number in all customs procedures when exchanging information with Customs administrations. The EORI number exists out of two parts: 1. the country code of the issuing Member State; followed by 2. a code or number that is unique in the Member State */
  eori?: InputMaybe<Scalars['UkEori']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the updateUkCustomsBroker mutation. */
export type UpdateUkCustomsBrokerPayload = {
  __typename?: 'UpdateUkCustomsBrokerPayload';
  record: UkCustomsBroker;
};

export type UpdateUkHsInput = {
  /** Effective descriptions */
  descriptions?: InputMaybe<Array<HsDescriptionInput>>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** HS number type */
  hsNumberType?: InputMaybe<HsNumberType>;
  /** Main duty rates */
  mainDutyRates?: InputMaybe<Array<HsRateInput>>;
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateUkHs mutation. */
export type UpdateUkHsPayload = {
  __typename?: 'UpdateUkHsPayload';
  record: UkHs;
};

export type UpdateUsCargoReleaseDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateUsCargoReleaseDocumentGenerationRequestWithDocumentIdPayload';
  /** Us Cargo Release Document Generation Request with the document id. */
  record: UsCargoReleaseDocumentGenerationRequest;
};

export type UpdateUsCbp5106DocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateUsCbp5106DocumentGenerationRequestWithDocumentIdPayload';
  /** Us Cbp 5106 Document Generation Request with the document id. */
  record: UsCbp5106DocumentGenerationRequest;
};

export type UpdateUsCbp7501DocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateUsCbp7501DocumentGenerationRequestWithDocumentIdPayload';
  /** Us Cbp 7501 Document Generation Request with the document id. */
  record: UsCbp7501DocumentGenerationRequest;
};

export type UpdateUsCbp7512DocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateUsCbp7512DocumentGenerationRequestWithDocumentIdPayload';
  /** Us Cbp 7512 Document Generation Request with the document id. */
  record: UsCbp7512DocumentGenerationRequest;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsConsigneeCbp5106Payload = {
  __typename?: 'UpdateUsConsigneeCbp5106Payload';
  /** The Transaction. */
  transaction: UpdateUsConsigneeCbp5106Transaction;
};

/** The US CBP ABI transaction for updating the 5106 profile of a US Consignee. */
export type UpdateUsConsigneeCbp5106Transaction = Record & UsConsigneeCbpTransaction & {
  __typename?: 'UpdateUsConsigneeCbp5106Transaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consignee */
  usConsignee: UsConsignee;
  /** The record's version */
  version: Scalars['Int'];
};

export type UpdateUsConsigneeInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: InputMaybe<UsCbp5106BankDetailsInput>;
  /** A description of the Importer's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructure>;
  /** Error details of the latest US CBP 5106 rejection. */
  cbp5106RejectionReasons?: InputMaybe<Array<UsCbp5106RejectedReasonInput>>;
  /** The mailing address type. */
  cbpMailingAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** If an IOR number is requested from CBP, set it to true */
  cbpNumberHelp?: InputMaybe<Scalars['Boolean']>;
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons?: InputMaybe<Array<UsIorCbpAssignedNumberReason>>;
  /** The physical address type. */
  cbpPhysicalAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** The US IOR's status with CBP. */
  cbpStatus?: InputMaybe<UsIorCbpStatus>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: InputMaybe<UsCbp5106EntriesPerYearCode>;
  /** Business establishment details on the Importer's US CBP 5106 form. */
  establishment?: InputMaybe<UsCbp5106EstablishmentDetailsInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: InputMaybe<Array<UsCbp5106IndividualInput>>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** An officer of the company authorized to assign power of attorney. */
  officer?: InputMaybe<PointOfContactInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: InputMaybe<Array<UsCbpImporterProgramCode>>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: InputMaybe<Array<UsCbp5106RelatedBusinessInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the updateUsConsignee mutation. */
export type UpdateUsConsigneePayload = {
  __typename?: 'UpdateUsConsigneePayload';
  record: UsConsignee;
};

export type UpdateUsConsumptionEntryInput = {
  /** Accelerate the liquidation of the entry. */
  acceleratedLiquidation?: InputMaybe<Scalars['Boolean']>;
  /** The reason for amending the entry. */
  amendmentReason?: InputMaybe<UsConsumptionEntryAmendmentReason>;
  /** Arrival information */
  arrival?: InputMaybe<UsConsumptionEntryArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<UsConsumptionEntryBadge>>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  /** US Buyer associated with this entry. */
  buyer?: InputMaybe<UsConsumptionEntryBuyerInput>;
  /** Provided reason for canceling the entry with CBP. */
  cbpCancellationReason?: InputMaybe<DeleteUsCbpEntryReleaseReason>;
  cbpCharges?: InputMaybe<UsCbpEntryChargesInput>;
  cbpLiquidatedCharges?: InputMaybe<UsCbpEntryLiquidatedChargesInput>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** Indicates census warning status of the US entry summary. */
  censusHeaderStatus?: InputMaybe<UsCbpEntryCensusHeaderStatusCode>;
  /** CBP collection date */
  collectionDate?: InputMaybe<Scalars['String']>;
  /** CBP collection status */
  collectionStatus?: InputMaybe<Scalars['String']>;
  /** US Consignee associated with this entry. */
  consignee?: InputMaybe<UsConsumptionEntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Indicates the control status of the US entry summary. */
  controlStatus?: InputMaybe<UsCbpEntryControlStatusCode>;
  /** Conveyance information. */
  conveyance?: InputMaybe<UsConsumptionEntryConveyanceInput>;
  /** CBP entry Daily Statement. */
  dailyStatement?: InputMaybe<UsCbpEntryDailyStatementInput>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Departure information. */
  departure?: InputMaybe<UsConsumptionEntryDepartureInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** Exam details associated with the entry. */
  exam?: InputMaybe<UsConsumptionEntryExamInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Indicates the filing timeliness of the US entry summary. */
  filingTimeliness?: InputMaybe<UsCbpEntryFilingTimeliness>;
  /** Indicates whether immediate delivery is enabled for the entry. */
  immediateDeliveryIndicator?: InputMaybe<UsCbpEntryReleaseImmediateDelivery>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<UsConsumptionEntryCommercialInvoiceInput>>;
  /** Commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines */
  invoicesReference?: InputMaybe<UsConsumptionEntryCommercialInvoicesReferenceInput>;
  /** US IOR associated with this entry. */
  ior?: InputMaybe<UsConsumptionEntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine if CBMS authorized payment within 10 business days of most recent cargo release date */
  isTimelyPayment?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<UsConsumptionEntryMasterBillInput>>;
  /** How the imported merchandise will be used. */
  merchandiseUse?: InputMaybe<UsCbpEntryMerchandiseUse>;
  /** CBP entry payment type */
  paymentType?: InputMaybe<Scalars['UsCbpEntryPaymentType']>;
  /** CBP entry Periodic Monthly Statement. */
  periodicMonthlyStatement?: InputMaybe<UsCbpEntryPeriodicMonthlyStatementInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDispositions?: InputMaybe<Array<UsCbpEntryPgaDispositionInput>>;
  /** The placement type for UsConsumptionEntry */
  placementType?: InputMaybe<PlacementType>;
  /** Purchase order (PO) number(s) associated with the work order. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Date by which other regulatory clearances are completed. For example, FCC for Devices shipments. This impacts the work order deadline and entry submission. */
  regulatoryReadyDate?: InputMaybe<Scalars['DateTime']>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: InputMaybe<Scalars['Date']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDispositions?: InputMaybe<Array<UsCbpEntryReleaseDispositionInput>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReasons?: InputMaybe<Array<UsCbpEntryReleaseRejectionReasonInput>>;
  /** Replacement number associated with delete release from cbp */
  releaseReplacementNumber?: InputMaybe<Scalars['String']>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: InputMaybe<UsCbpEntryReleaseStatus>;
  /** US Entry single transaction bond details. */
  singleTransactionBond?: InputMaybe<UsEntrySingleTransactionBondInput>;
  /** Indicates how to release split shipments. */
  splitShipmentReleaseMethod?: InputMaybe<UsCbpSplitShipmentReleaseMethod>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotification?: InputMaybe<UsCbpEntryNotificationInput>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReasons?: InputMaybe<Array<UsCbpEntrySummaryRejectionReasonInput>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<UsCbpEntrySummaryStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to US CBP. */
  totalAssist?: InputMaybe<Scalars['UsDollars']>;
  /** Sum of all invoice product lines count, useful in task estimation. */
  totalInvoiceLineCount?: InputMaybe<Scalars['Int']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the updateUsConsumptionEntry mutation. */
export type UpdateUsConsumptionEntryPayload = {
  __typename?: 'UpdateUsConsumptionEntryPayload';
  record: UsConsumptionEntry;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsConsumptionEntryPgaCbpPayload = {
  __typename?: 'UpdateUsConsumptionEntryPgaCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsConsumptionEntryPgaCbpTransaction;
};

/** The US CBP ABI transaction to update a US Consumption Entry PGA, CATAIR appCode: CA/CC. */
export type UpdateUsConsumptionEntryPgaCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'UpdateUsConsumptionEntryPgaCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsConsumptionEntryReleaseCbpPayload = {
  __typename?: 'UpdateUsConsumptionEntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsConsumptionEntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to update a US Consumption Entry Release, CATAIR appCode: SE/SX. */
export type UpdateUsConsumptionEntryReleaseCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'UpdateUsConsumptionEntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Input parameters to submit an update statement request to US CBP. */
export type UpdateUsConsumptionEntryStatementCbpInput = {
  /** CBP entry payment type */
  paymentType: Scalars['UsCbpEntryPaymentType'];
  /** The month set by the Broker that the CBP Periodic Monthly Statement will be generated. */
  pmsMonth?: InputMaybe<Scalars['Month']>;
  /** The date set by the Broker that the CBP Preliminary Daily Statement will be generated. */
  printDate?: InputMaybe<Scalars['Date']>;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsConsumptionEntryStatementCbpPayload = {
  __typename?: 'UpdateUsConsumptionEntryStatementCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsConsumptionEntryStatementCbpTransaction;
};

/** The US CBP ABI transaction to update a US Consumption Entry Statment, CATAIR appCode: SU/SQ. */
export type UpdateUsConsumptionEntryStatementCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'UpdateUsConsumptionEntryStatementCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** CBP entry payment type */
  paymentType: Scalars['UsCbpEntryPaymentType'];
  /** The month set by the Broker that the CBP Periodic Monthly Statement will be generated. */
  pmsMonth?: Maybe<Scalars['Month']>;
  /** The date set by the Broker that the CBP Preliminary Daily Statement will be generated. */
  printDate?: Maybe<Scalars['Date']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

export type UpdateUsCustomsBrokerInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<Array<IdInput>>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: InputMaybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes */
  filerCode?: InputMaybe<Scalars['UsCbpFilerCode']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: InputMaybe<BrokerIorActivationConfigInput>;
  /** Logo for the party */
  logo?: InputMaybe<IdInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Signature Details for the party */
  signature?: InputMaybe<SignatureInput>;
  tags?: InputMaybe<Array<TagInput>>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<Array<IdInput>>;
};

/** Payload returned from the updateUsCustomsBroker mutation. */
export type UpdateUsCustomsBrokerPayload = {
  __typename?: 'UpdateUsCustomsBrokerPayload';
  record: UsCustomsBroker;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsDrawbackClaimCbpPayload = {
  __typename?: 'UpdateUsDrawbackClaimCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsDrawbackClaimCbpTransaction;
};

/** The US CBP ABI transaction to update a US Drawback Claim, CATAIR appcode: DE/DX. */
export type UpdateUsDrawbackClaimCbpTransaction = Record & UsDrawbackClaimCbpTransaction & {
  __typename?: 'UpdateUsDrawbackClaimCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Drawback Claim */
  usDrawbackClaim: UsDrawbackClaim;
  /** The record's version */
  version: Scalars['Int'];
};

export type UpdateUsDrawbackClaimDocumentGenerationRequestWithDocumentIdPayload = {
  __typename?: 'UpdateUsDrawbackClaimDocumentGenerationRequestWithDocumentIdPayload';
  /** Us Drawback Document Generation Request with the document id. */
  record: UsDrawbackClaimDocumentGenerationRequest;
};

export type UpdateUsDrawbackClaimInput = {
  /** Export Entries should match the CBP Data. */
  TFTEAExportDestroyArticles?: InputMaybe<Array<UsDrawbackClaimExportDestroyArticleInput>>;
  /** Requesting Accelerated Payment and Bond is required. If filing a Drawback claim with the Accelerated Payment Request Indicator, please be informed that accelerated refunds will be paid on the first successfully accepted version of the claim without bond related errors. If updates are made to the claimed amount after the first successfully accepted version, the updated amount will be paid upon liquidation. */
  acceleratedPayment?: InputMaybe<Scalars['Boolean']>;
  /** Bond Details */
  bond?: InputMaybe<UsDrawbackClaimBondInput>;
  /** An indication that the bond has been waived in accordance with regulation. */
  bondWaiverIndicator?: InputMaybe<Scalars['Boolean']>;
  /** A code explaining the reason the bond has been waived in accordance with regulation(s). */
  bondWaiverReasonCode?: InputMaybe<Scalars['UsBondWaiverReasonCode']>;
  /** US Customs Broker associated with this entry. */
  broker?: InputMaybe<UsDrawbackClaimBrokerInput>;
  /** The broker reference number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  /** List of rejection reasons */
  cbpRejectionReasons?: InputMaybe<Array<UsCbpDrawbackClaimRejectionReasonInput>>;
  /** Drawback Claim CBP Status */
  cbpStatus?: InputMaybe<UsCbpDrawbackClaimStatus>;
  /** Claimant */
  claimant?: InputMaybe<UsIorNumberInput>;
  /** Drawback Claim reference for Imports, TFTEAExportDestroyArticles and cbpRejectionReasons. */
  drawbackClaimReference?: InputMaybe<DrawbackClaimReferenceInput>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: InputMaybe<Scalars['String']>;
  /** The drawback provision code. */
  drawbackProvision?: InputMaybe<Scalars['UsDrawbackProvisionCode']>;
  /** Import Entries should match the CBP Data. */
  imports?: InputMaybe<Array<UsDrawbackClaimImportInput>>;
  /** For Core and TFTEA Drawback, the approval letter must be provided or provide the date of the OTW application submission to CBP on company letterhead and upload it to DIS. Use the following format: “The OTW application was filed on [date] at the port of [insert port name].” */
  oneTimeWaiverIndicator?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Waiver Prior Notice. */
  waiverPriorNotice?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the updateUsDrawbackClaim mutation. */
export type UpdateUsDrawbackClaimPayload = {
  __typename?: 'UpdateUsDrawbackClaimPayload';
  record: UsDrawbackClaim;
};

export type UpdateUsHtsInput = {
  /** May be subject to anti-dumping duties. */
  ad?: InputMaybe<Scalars['Boolean']>;
  /** Anti-dumping and Countervailing duty (ADD/CVD) active case Ids */
  adCvdCases?: InputMaybe<Array<IdInput>>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additional?: InputMaybe<Array<AdditionalHtsInput>>;
  /** Additional Tariff may be required. */
  additionalHTS?: InputMaybe<Scalars['Boolean']>;
  /** The additional HTS number that may be required. */
  additionalHtsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additionalHtssApplicable?: InputMaybe<Array<AdditionalHtsInput>>;
  /** The type of HTS when used as an additional tariff. */
  additionalTariffType?: InputMaybe<AdditionalHtsType>;
  /** The effective end date provided by ACE CATAIR. It may differ from the top-level endDate. */
  cbpEndDate?: InputMaybe<Scalars['Date']>;
  /** The effective start date provided by ACE CATAIR. It may differ from the top-level startDate. */
  cbpStartDate?: InputMaybe<Scalars['Date']>;
  /** Compliance notes */
  complianceNotes?: InputMaybe<Array<HtsComplianceNoteInput>>;
  /** May be subject to countervailing duties. */
  cv?: InputMaybe<Scalars['Boolean']>;
  /** Longer description of Tariff. */
  description?: InputMaybe<Scalars['String']>;
  /** Descriptions of Tariff. */
  descriptions?: InputMaybe<Array<HtsDescriptionInput>>;
  /** Duty code */
  duty?: InputMaybe<Scalars['String']>;
  /** Ending effective date. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Fees required, also used for taxes. */
  fees?: InputMaybe<Array<HtsFeeInput>>;
  /** Is HS number fully qualified. */
  fullyQualified?: InputMaybe<Scalars['Boolean']>;
  /** Country of origin codes not permitted to use with the Generalized System of Preferences SPI (A*). */
  gspExcluded?: InputMaybe<Array<Scalars['String']>>;
  /** HS number type */
  hsNumberType?: InputMaybe<HsNumberType>;
  /** License data potentially required on an entry. */
  license?: InputMaybe<HtsLicenseInput>;
  /** License code required on Line. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** Column one rate object used to calculate duty that may apply to HS during different time intervals. */
  mainDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Partner Government Agency data potentially required on an entry. */
  pga?: InputMaybe<Array<PgaRequirementInput>>;
  /** 7 digit US Principal ADD and CVD cases */
  principalAdCvdCases?: InputMaybe<Array<IdInput>>;
  /** May be subject to a quota. */
  quota?: InputMaybe<Scalars['Boolean']>;
  /** Rate object used to calculate duty. */
  rate?: InputMaybe<HtsRateInput>;
  /** Restrictions on HTS number usage. */
  restriction?: InputMaybe<HtsRestrictionInput>;
  /** Column two rate object used to calculate duty that may apply to HS during different time intervals. */
  secondaryDutyRates?: InputMaybe<Array<HtsRateInput>>;
  /** Section 301 Exclusion */
  section301Exclusion?: InputMaybe<Section301ExclusionInput>;
  /** Special Program Indicators available to use, subject to country of origin. */
  spi?: InputMaybe<Array<SpiInput>>;
  /** Special rates based on different SPIs. */
  spiRates?: InputMaybe<Array<HtsSpiRateInput>>;
  /** Beginning effective date. */
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Description of Tariff. */
  text?: InputMaybe<Scalars['String']>;
  /** Textile code. */
  textile?: InputMaybe<Scalars['String']>;
  /** Section 301 (Trump Tariffs) list number. */
  trumpList?: InputMaybe<Scalars['TrumpList']>;
  /** Truncated description of Tariff. */
  truncatedDescription?: InputMaybe<Scalars['String']>;
  /** Required unit of measure reporting quantities. */
  uom?: InputMaybe<Array<Scalars['String']>>;
};

/** Payload returned from the updateUsHts mutation. */
export type UpdateUsHtsPayload = {
  __typename?: 'UpdateUsHtsPayload';
  record: UsHts;
};

export type UpdateUsInBondInput = {
  /** The arrival information */
  arrival?: InputMaybe<UsInBondArrivalInput>;
  /** The badges associated with this entry. */
  badges?: InputMaybe<Array<UsInBondBadge>>;
  /** The collection of CbpInBonds for the UsInBond work order */
  cbpInBonds?: InputMaybe<Array<CbpInBondInput>>;
  /** Consignee associated with this UsInBond. */
  consignee?: InputMaybe<UsInBondConsigneeInput>;
  /** The container numbers for the UsInBond */
  containerNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** The conveyance information */
  conveyance?: InputMaybe<UsInBondConveyanceInput>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** The departure information */
  departure?: InputMaybe<UsInBondDepartureInput>;
  /** The date of entry for the UsInBond */
  entryDate?: InputMaybe<Scalars['Date']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** IOR associated with this UsInBond. */
  ior?: InputMaybe<UsInBondIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the shipment. */
  masterBills?: InputMaybe<Array<UsInBondMasterBillInput>>;
  /** The mode of transport for the shipment */
  modeOfTransport: ModeOfTransport;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateUsInBond mutation. */
export type UpdateUsInBondPayload = {
  __typename?: 'UpdateUsInBondPayload';
  record: UsInBond;
};

export type UpdateUsIorActivationInput = {
  /** US Customs Broker associated with the activation. */
  broker: UsIorActivationBrokerInput;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** US IOR to be activated. */
  ior?: InputMaybe<UsIorActivationIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateUsIorActivation mutation. */
export type UpdateUsIorActivationPayload = {
  __typename?: 'UpdateUsIorActivationPayload';
  record: UsIorActivation;
};

export type UpdateUsIorActivationStatusPayload = {
  __typename?: 'UpdateUsIorActivationStatusPayload';
  /** The updated UsIor */
  usIor: UsIor;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsIorCbp5106Payload = {
  __typename?: 'UpdateUsIorCbp5106Payload';
  /** The Transaction. */
  transaction: UpdateUsIorCbp5106Transaction;
};

/** The US CBP ABI transaction for updating the 5106 profile of a US IOR */
export type UpdateUsIorCbp5106Transaction = Record & UsIorCbpTransaction & {
  __typename?: 'UpdateUsIorCbp5106Transaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US IOR */
  usIor: UsIor;
  /** The record's version */
  version: Scalars['Int'];
};

export type UpdateUsIorContinuousBondRequestInput = {
  /** The amount of the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  bondAmount?: InputMaybe<Scalars['UsDollars']>;
  /** The date that the bond can start to be used for US customs entry filings. */
  bondEffectiveDate?: InputMaybe<Scalars['Date']>;
  /** The unique number identifying the usIor's customs bond. */
  bondNumber?: InputMaybe<Scalars['String']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  bondSuretyCode?: InputMaybe<Scalars['String']>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Estimated duties, taxes, and fees paid in the next 12 months (used to determine if it will exceed $500,000). */
  nextYearShippingValueEstimate?: InputMaybe<Scalars['UsDollars']>;
  /** Estimated duties, taxes, and fees paid in the pervious 12 months (used to determine if it will exceed $500,000). */
  previousYearShippingValueEstimate?: InputMaybe<Scalars['UsDollars']>;
  /** A short description of each product being imported. */
  productDescriptions?: InputMaybe<Array<Scalars['String']>>;
  /** The country codes from which goods originate. */
  productOriginCountryCodes?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** The ARN of the dacia schedule for the renewal. The `cancelUsIorContinuousBondRequestRenewal` mutation must be used to cancel it. */
  renewalScheduleArn?: InputMaybe<Scalars['String']>;
  /** The amount requested for the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  requestedBondAmount?: InputMaybe<Scalars['UsDollars']>;
  /** Bond risk details for the continuous bond */
  risk?: InputMaybe<UsIorContinuousBondRequestBondRiskInput>;
  /** The Shipper associated with the UsIorContinuousBondRequest. Returns the latest version. */
  shipper: IdInput;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  /** Reference number provided by the surety and sent back in the BS ABI message. This can be used to tie this ABI message to the initial bond request. */
  suretyReferenceNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The UsIor associated with the UsIorContinuousBondRequest. Returns the latest version. */
  usIor: IdInput;
  /** Whether incentive pricing should be used on this continuous bond */
  useIncentivePricing?: InputMaybe<Scalars['Boolean']>;
};

/** Payload returned from the updateUsIorContinuousBondRequest mutation. */
export type UpdateUsIorContinuousBondRequestPayload = {
  __typename?: 'UpdateUsIorContinuousBondRequestPayload';
  record: UsIorContinuousBondRequest;
};

export type UpdateUsIorInput = {
  /** Indicate whether the filer is paying duties to U.S CBP using ACH(Automated Clearinghouse) Credit method or not. */
  achCredit?: InputMaybe<Scalars['Boolean']>;
  /** Activation status of US IOR. */
  activationStatus?: InputMaybe<UsIorActivationStatus>;
  /** Activation time of US IOR. */
  activationTime?: InputMaybe<Scalars['DateTime']>;
  /** Activations of US IOR. */
  activations?: InputMaybe<Array<UsIorActivationDetailsInput>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: InputMaybe<UsCbp5106BankDetailsInput>;
  /** Information collected when the importer applies for a bond through Amazon. */
  bondApplicationInformation?: InputMaybe<BondApplicationInformationInput>;
  /** A description of the Importer's business */
  businessDescription?: InputMaybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructure>;
  /** Importer business website */
  businessWebsite?: InputMaybe<Scalars['String']>;
  /** Error details of the latest US CBP 5106 rejection. */
  cbp5106RejectionReasons?: InputMaybe<Array<UsCbp5106RejectedReasonInput>>;
  /** The mailing address type. */
  cbpMailingAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** If an IOR number is requested from CBP, set it to true */
  cbpNumberHelp?: InputMaybe<Scalars['Boolean']>;
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons?: InputMaybe<Array<UsIorCbpAssignedNumberReason>>;
  /** The physical address type. */
  cbpPhysicalAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** The US IOR's status with CBP. */
  cbpStatus?: InputMaybe<UsIorCbpStatus>;
  /** Details for manifest confidentiality */
  confidentiality?: InputMaybe<UsIorConfidentialityInput>;
  /** A list of the IOR's continuous customs bonds. */
  continuousBonds?: InputMaybe<UsContinuousCustomsBondsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Identifier for DocReadiness status of Importer in ShipDocs system */
  docReadinessId?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: InputMaybe<UsCbp5106EntriesPerYearCode>;
  /** US IOR entry summary email addresses. */
  entrySummaryContactEmails?: InputMaybe<Array<Scalars['Email']>>;
  /** Business establishment details on the Importer's US CBP 5106 form. */
  establishment?: InputMaybe<UsCbp5106EstablishmentDetailsInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Is it the first time the Importer of Record has been used in the US? */
  firstTimeStatus?: InputMaybe<UsIorFirstTimeStatus>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** The linked Importer. */
  importer?: InputMaybe<IdInput>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: InputMaybe<Array<UsCbp5106IndividualInput>>;
  /** The industry of the IOR */
  industry?: InputMaybe<Vertical>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Indicate whether the IOR is a resident importer. */
  isResident?: InputMaybe<Scalars['Boolean']>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: InputMaybe<Scalars['Boolean']>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Non resident signing officer email. */
  nrccOfficerEmail?: InputMaybe<Scalars['Email']>;
  /** An officer of the company authorized to assign power of attorney. */
  officer?: InputMaybe<PointOfContactInput>;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber?: InputMaybe<Scalars['UsCbpPayerUnitNumber']>;
  /** Payment terms offered to US IOR */
  paymentTerms?: InputMaybe<UsIorPaymentTerms>;
  /** A US IOR individual's personal effects information. */
  personalEffects?: InputMaybe<UsIorPersonalEffectsInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** Time at which the PMS was activated. This is not null only when pmsRequestedTime is not null and pmsStatus === ACTIVE */
  pmsActivationTime?: InputMaybe<Scalars['DateTime']>;
  /** Time at which the PMS activation Request was sent. */
  pmsRequestedTime?: InputMaybe<Scalars['DateTime']>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: InputMaybe<UsIorPmsStatus>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: InputMaybe<POAMethod>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** The US IORs preferred payment method on an entry */
  preferredCbpEntryPaymentMethod?: InputMaybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: InputMaybe<Array<UsCbpImporterProgramCode>>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: InputMaybe<Array<UsCbp5106RelatedBusinessInput>>;
  /** Source channel identifier */
  sourceChannel?: InputMaybe<SourceChannel>;
  /** Source portal identifier */
  sourcePortal?: InputMaybe<SourcePortal>;
  /** The status of a US Ior e.g. ACTIVE, CANCELED */
  status?: InputMaybe<UsIorStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCodes?: InputMaybe<Array<Scalars['VendorCode']>>;
};

/** Payload returned from the updateUsIor mutation. */
export type UpdateUsIorPayload = {
  __typename?: 'UpdateUsIorPayload';
  record: UsIor;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsIsfCbpPayload = {
  __typename?: 'UpdateUsIsfCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsIsfCbpTransaction;
};

/** The US CBP ABI transaction to update a US ISF, CATAIR appcode: SF/SN. */
export type UpdateUsIsfCbpTransaction = Record & UsIsfCbpTransaction & {
  __typename?: 'UpdateUsIsfCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US ISF */
  usIsf: UsIsf;
  /** The record's version */
  version: Scalars['Int'];
};

export type UpdateUsIsfInput = {
  /** Estimated time of shipment arrival */
  arrivalTime?: InputMaybe<Scalars['Date']>;
  /** Booking party when file ISF 5 */
  bookingParty?: InputMaybe<UsIsfBookingPartyInput>;
  /** The ISF buyer */
  buyer?: InputMaybe<UsIsfBuyerInput>;
  /** Isf status from Cbp */
  cbpStatus?: InputMaybe<UsIsfCbpStatus>;
  /** CBP type code includes ISF type and shipment type */
  cbpTypeCode?: InputMaybe<UsIsfCbpTypeCodeInput>;
  /** The ISF consignee */
  consignee?: InputMaybe<UsIsfConsigneeInput>;
  /** The ISF consolidator */
  consolidator?: InputMaybe<UsIsfConsolidatorInput>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Informal shipment details */
  informal?: InputMaybe<UsIsfInformalDetailsInput>;
  /** Us IOR associated with this ISF */
  ior?: InputMaybe<UsIsfIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Isf number */
  isfNumber?: InputMaybe<Scalars['UsIsfNumber']>;
  /** CBP ISF type code */
  isfType?: IsfType;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Manufactures associated with this isf */
  manufacturers?: InputMaybe<Array<UsIsfManufacturerInput>>;
  /** Masterbill information */
  masterBills?: InputMaybe<Array<UsIsfMasterBillInput>>;
  /** Delivery place of the shipment, this is needed for ISF-5 */
  placeOfDelivery?: InputMaybe<Scalars['String']>;
  /** Code for port of unlading, this is needed for ISF-5 */
  portOfUnladingCode?: InputMaybe<Scalars['String']>;
  /** The ISF sellers */
  sellers?: InputMaybe<Array<UsIsfSellerInput>>;
  /** The ISF ship to party */
  shipTo?: InputMaybe<UsIsfShipToInput>;
  /** CBP ISF Shipment type code */
  shipmentTypeCode?: InputMaybe<UsIsfShipmentTypeCode>;
  /** US ISF single transaction bond details. */
  singleTransactionBond?: InputMaybe<UsIsfSingleTransactionBondInput>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  /** The ISF stuffing location */
  stuffingLocation?: InputMaybe<UsIsfStuffingLocationInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateUsIsf mutation. */
export type UpdateUsIsfPayload = {
  __typename?: 'UpdateUsIsfPayload';
  record: UsIsf;
};

export type UpdateUsPostSummaryCorrectionInput = {
  /** Accelerate the liquidation of the entry. */
  acceleratedLiquidation?: InputMaybe<Scalars['Boolean']>;
  /** The reason for amending the entry. */
  amendmentReason?: InputMaybe<UsPostSummaryCorrectionAmendmentReason>;
  /** Arrival information */
  arrival?: InputMaybe<UsPostSummaryCorrectionArrivalInput>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  cbpCharges?: InputMaybe<UsCbpEntryChargesInput>;
  cbpLiquidatedCharges?: InputMaybe<UsCbpEntryLiquidatedChargesInput>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** US Consignee associated with this entry. */
  consignee?: InputMaybe<UsPostSummaryCorrectionConsigneeInput>;
  /** Conveyance information. */
  conveyance?: InputMaybe<UsPostSummaryCorrectionConveyanceInput>;
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Departure information. */
  departure?: InputMaybe<UsPostSummaryCorrectionDepartureInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** A text line of the PSC filing explanation. */
  explanation?: InputMaybe<Scalars['String']>;
  /** A code that identifies the reason that the submitted header data is being changed for a PSC */
  headerReasons?: InputMaybe<Array<Scalars['UsPostSummaryCorrectionHeaderReason']>>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<UsPostSummaryCorrectionCommercialInvoiceInput>>;
  /** US IOR associated with this entry. */
  ior?: InputMaybe<UsPostSummaryCorrectionIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<UsPostSummaryCorrectionMasterBillInput>>;
  /** How the imported merchandise will be used. */
  merchandiseUse?: InputMaybe<UsCbpEntryMerchandiseUse>;
  /** Purchase order (PO) number(s) associated with the work order. */
  poNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** US Entry single transaction bond details. */
  singleTransactionBond?: InputMaybe<UsEntrySingleTransactionBondInput>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotification?: InputMaybe<UsCbpEntryNotificationInput>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReasons?: InputMaybe<Array<UsCbpEntrySummaryRejectionReasonInput>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<UsCbpEntrySummaryStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total assist of the merchandise reported to US CBP. */
  totalAssist?: InputMaybe<Scalars['UsDollars']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the updateUsPostSummaryCorrection mutation. */
export type UpdateUsPostSummaryCorrectionPayload = {
  __typename?: 'UpdateUsPostSummaryCorrectionPayload';
  record: UsPostSummaryCorrection;
};

/** Represents a US CBP Anti-Dumping or Countervailing Duty Case. */
export type UpdateUsPrincipalAdCvdCaseInput = {
  /** Full 10-digit case numbers */
  fullCaseNumbers?: InputMaybe<Array<CaseReferenceInput>>;
  /** Official Case name */
  name?: InputMaybe<Scalars['String']>;
  /** Link to the scope decision of the case */
  scopeUrl?: InputMaybe<Scalars['Url']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateUsPrincipalAdCvdCase mutation. */
export type UpdateUsPrincipalAdCvdCasePayload = {
  __typename?: 'UpdateUsPrincipalAdCvdCasePayload';
  record: UsPrincipalAdCvdCase;
};

export type UpdateUsType86EntryInput = {
  /** Arrival information */
  arrival?: InputMaybe<UsType86EntryArrivalInput>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<Scalars['String']>;
  /** US Buyer associated with this entry. */
  buyer?: InputMaybe<UsType86EntryBuyerInput>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** Indicates census warning status of the US entry release. */
  censusHeaderStatus?: InputMaybe<UsCbpEntryCensusHeaderStatusCode>;
  /** CBP collection status */
  collectionStatus?: InputMaybe<Scalars['String']>;
  /** US Consignee associated with this entry. */
  consignee?: InputMaybe<UsType86EntryConsigneeInput>;
  /** Containers associated with the entry. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Indicates the control status of the US entry release. */
  controlStatus?: InputMaybe<UsCbpEntryControlStatusCode>;
  /** Conveyance information. */
  conveyance?: InputMaybe<UsType86EntryConveyanceInput>;
  /** Departure information. */
  departure?: InputMaybe<UsType86EntryDepartureInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** The estimated CBP charges if this entry had been filed as a US Consumption Entry */
  estimatedCustomsChargedSaved?: InputMaybe<UsCbpEntryChargesInput>;
  /** Exam details associated with the entry. */
  exam?: InputMaybe<UsType86EntryExamInput>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Indicates the filing timeliness of the US entry release. */
  filingTimeliness?: InputMaybe<UsCbpEntryFilingTimeliness>;
  /** Optional field to set freight forwarders associated w/ a work order group when creating a Work Order "on-the-fly" (without a pre-existing work order group or shipment). */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The Work Order Group to which to the Work Order belongs. */
  group?: InputMaybe<IdInput>;
  /** Commercial invoices declared on the entry. */
  invoices?: InputMaybe<Array<UsType86EntryCommercialInvoiceInput>>;
  /** US IOR associated with this entry. */
  ior?: InputMaybe<UsType86EntryIorInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: InputMaybe<Array<UsType86EntryMasterBillInput>>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDispositions?: InputMaybe<Array<UsCbpEntryPgaDispositionInput>>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: InputMaybe<Scalars['Date']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDispositions?: InputMaybe<Array<UsCbpEntryReleaseDispositionInput>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReasons?: InputMaybe<Array<UsCbpEntryReleaseRejectionReasonInput>>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: InputMaybe<UsCbpEntryReleaseStatus>;
  /** Indicates how to release split shipments. */
  splitShipmentReleaseMethod?: InputMaybe<UsCbpSplitShipmentReleaseMethod>;
  tags?: InputMaybe<Array<TagInput>>;
  /** The total value of the merchandise reported to US CBP. */
  totalAssist?: InputMaybe<Scalars['UsDollars']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: InputMaybe<Scalars['UsDollars']>;
};

/** Payload returned from the updateUsType86Entry mutation. */
export type UpdateUsType86EntryPayload = {
  __typename?: 'UpdateUsType86EntryPayload';
  record: UsType86Entry;
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsType86EntryPgaCbpPayload = {
  __typename?: 'UpdateUsType86EntryPgaCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsType86EntryPgaCbpTransaction;
};

/** The US CBP ABI transaction to update a US Type86 Entry PGA, CATAIR appCode: CA/CC. */
export type UpdateUsType86EntryPgaCbpTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'UpdateUsType86EntryPgaCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** The payload returned from triggering the Transaction. */
export type UpdateUsType86EntryReleaseCbpPayload = {
  __typename?: 'UpdateUsType86EntryReleaseCbpPayload';
  /** The Transaction. */
  transaction: UpdateUsType86EntryReleaseCbpTransaction;
};

/** The US CBP ABI transaction to update a US Type86 Entry Release, CATAIR appCode: SE/SX. */
export type UpdateUsType86EntryReleaseCbpTransaction = Record & UsType86EntryCbpTransaction & {
  __typename?: 'UpdateUsType86EntryReleaseCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Type86 Entry */
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Update User Release Note View Input */
export type UpdateUserReleaseNoteViewInput = {
  /** The rating given to the release note by the user. */
  rating?: InputMaybe<RatingEnum>;
  /** The ID of the viewed release note. */
  releaseNote: IdInput;
  tags?: InputMaybe<Array<TagInput>>;
  /** The user who viewed the release note. */
  user: IdInput;
};

/** Payload returned from the updateUserReleaseNoteView mutation. */
export type UpdateUserReleaseNoteViewPayload = {
  __typename?: 'UpdateUserReleaseNoteViewPayload';
  record: UserReleaseNoteView;
};

export type UpdateWorkOrderDocumentProcessingRequestInput = {
  /** WorkOrder processing request documents. */
  documents?: InputMaybe<Array<WorkOrderProcessingRequestDocumentInput>>;
  /** Status values for tracking document processing status for a workOrder */
  status?: InputMaybe<WorkOrderDocumentProcessingStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateWorkOrderDocumentProcessingRequest mutation. */
export type UpdateWorkOrderDocumentProcessingRequestPayload = {
  __typename?: 'UpdateWorkOrderDocumentProcessingRequestPayload';
  record: WorkOrderDocumentProcessingRequest;
};

export type UpdateWorkOrderGroupInput = {
  /** The Customs Broker associated with the Group of Work Orders. Returns the latest version. */
  customsBroker?: InputMaybe<IdInput>;
  /** The Forwarders associated with the Group of Work Orders. Returns the latest version. */
  forwarders?: InputMaybe<Array<WorkOrderGroupForwarderInput>>;
  /** The Shipper associated with the Group of Work Orders. Returns the latest version. */
  shipper?: InputMaybe<IdInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateWorkOrderGroup mutation. */
export type UpdateWorkOrderGroupPayload = {
  __typename?: 'UpdateWorkOrderGroupPayload';
  record: WorkOrderGroup;
};

export type UpdateWorkOrderGroupStatusPayload = {
  __typename?: 'UpdateWorkOrderGroupStatusPayload';
  /** A group of Work Orders performed together. */
  workOrderGroup: WorkOrderGroup;
};

export type UpdateWorkOrderInput = {
  /** Deadline for the Work Order to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<Scalars['Boolean']>;
  /** Current state of the Work Order. */
  state?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The Work Order's status. */
  status?: InputMaybe<WorkOrderStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type UpdateWorkOrderPayload = {
  __typename?: 'UpdateWorkOrderPayload';
  /** The updated Work Order. */
  workOrder: WorkOrder;
};

/** A State Machine composed of the states and tasks required to execute a Work Order. */
export type UpdateWorkOrderStateMachineInput = {
  /** The countries the state machine supports. If not provided, all countries are supported. */
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']>>;
  /** The Customs Brokers the state machine supports. */
  customsBrokers?: InputMaybe<Array<IdInput>>;
  /** Description of the Work Order State Machine. */
  description?: InputMaybe<Scalars['String']>;
  /** The Forwarders associated with the state machine. Returns the latest version. */
  forwarders?: InputMaybe<Array<IdInput>>;
  /** The mode of transports the state machine supports. If not provided, all mode of transports are supported. */
  modeOfTransports?: InputMaybe<Array<ModeOfTransport>>;
  /** Name of the Work Order State Machine */
  name?: InputMaybe<Scalars['String']>;
  /** The Placement Type of the state machine */
  placementType?: InputMaybe<PlacementType>;
  /** The starting state. */
  start?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The steps of the task. */
  states?: InputMaybe<Array<WorkOrderStateInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  workOrderType?: InputMaybe<WorkOrderType>;
};

/** Payload returned from the updateWorkOrderStateMachine mutation. */
export type UpdateWorkOrderStateMachinePayload = {
  __typename?: 'UpdateWorkOrderStateMachinePayload';
  record: WorkOrderStateMachine;
};

/** The definition for a Work Order Task */
export type UpdateWorkOrderTaskDefinitionInput = {
  /** The custom fields definitions */
  customFields?: InputMaybe<Array<WorkOrderTaskCustomFieldDefinitionInput>>;
  /** Overview of the task */
  description?: InputMaybe<Scalars['String']>;
  /** Estimated time in minutes to complete the task by an operator user. Defaulted to 15 mins */
  estimatedDuration?: InputMaybe<Scalars['Int']>;
  /** Whether this work order task is an exception task outside of the normal task workflow. */
  isException?: InputMaybe<Scalars['Boolean']>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: InputMaybe<SkillLevel>;
  /** Name of the task */
  name?: InputMaybe<Scalars['String']>;
  /** The steps of the task. */
  steps?: InputMaybe<Array<WorkOrderTaskDefinitionStepInput>>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateWorkOrderTaskDefinition mutation. */
export type UpdateWorkOrderTaskDefinitionPayload = {
  __typename?: 'UpdateWorkOrderTaskDefinitionPayload';
  record: WorkOrderTaskDefinition;
};

export type UpdateWorkOrderTaskEscalationMessageInput = {
  /** Details about the task escalation */
  escalationDetails?: InputMaybe<TaskEscalationDetailsInput>;
  /** Details about the task escalation replies */
  replyDetails?: InputMaybe<Array<TaskEscalationReplyDetailsInput>>;
  /** Details about the task resolution */
  resolutionDetails?: InputMaybe<TaskResolutionDetailsInput>;
  tags?: InputMaybe<Array<TagInput>>;
};

/** Payload returned from the updateWorkOrderTaskEscalationMessage mutation. */
export type UpdateWorkOrderTaskEscalationMessagePayload = {
  __typename?: 'UpdateWorkOrderTaskEscalationMessagePayload';
  record: WorkOrderTaskEscalationMessage;
};

export type UpdateWorkOrderTaskInput = {
  /** The User assigned to this Work Order Task. Returns the version at the time of assignment. */
  assignee?: InputMaybe<IdInput>;
  /** The associated assignment team for the task. */
  assignmentTeam?: InputMaybe<IdInput>;
  /** The custom fields  */
  customFields?: InputMaybe<Array<WorkOrderTaskCustomFieldInput>>;
  /** Deadline for the Work Order Task to be completed. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** All the empty fields in the current work order task */
  emptyFieldsNames?: InputMaybe<Array<Scalars['String']>>;
  /** Work order task escalation details. */
  escalations?: InputMaybe<Array<WorkOrderTaskEscalationInput>>;
  /** The estimatedDuration of one work order task, calculated in minutes */
  estimatedDuration?: InputMaybe<Scalars['Float']>;
  /** Work order task execution result. */
  executionResult?: InputMaybe<WorkOrderTaskExecutionResultInput>;
  /** Force Update flag to skip update task validation. */
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: InputMaybe<SkillLevel>;
  /** The work order task's status. */
  status?: InputMaybe<WorkOrderTaskStatus>;
  /** The reason for work order task status. */
  statusReason?: InputMaybe<WorkOrderTaskStatusReason>;
  /** The work order task's sub status. */
  subStatus?: InputMaybe<WorkOrderTaskSubStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Work order task team. */
  teamId?: InputMaybe<Scalars['ID']>;
};

/** Payload returned from the updateWorkOrderTask mutation. */
export type UpdateWorkOrderTaskPayload = {
  __typename?: 'UpdateWorkOrderTaskPayload';
  record: WorkOrderTask;
};

export type UpsertCbpMidTransaction = UpsertSupplierCbpMidTransaction;

/** Input object to add a new broker activation request or update activation status in an ImporterEntity. */
export type UpsertImporterEntityActivationInput = {
  /** Broker representation for the Importer. */
  brokerRepresentation?: InputMaybe<BrokerRepresentation>;
  /** CustomsBroker party info. */
  customsBroker: IdInput;
  /** Broker reference for the client/external system to be stored in CBMS. */
  externalBrokerReference?: InputMaybe<ExternalBrokerReferenceInput>;
  /** External Importer references. */
  externalIorReferences?: InputMaybe<Array<ExternalIorReferenceInput>>;
  /** Reasons for broker rejecting the Importer. */
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  /** Importer activation status. */
  status: ActivationStatus;
};

export type UpsertImporterEntityActivationPayload = {
  __typename?: 'UpsertImporterEntityActivationPayload';
  /** The updated ImporterEntity */
  importerEntity: ImporterEntity;
};

export type UpsertProductInput = {
  /** The ASIN for this product */
  asin?: InputMaybe<Scalars['String']>;
  /** Client identifier for the product (eg, sku, asin, etc). */
  clientIdentifier?: InputMaybe<Scalars['String']>;
  /** Client identifier Version for the product (eg, sku, asin, etc). */
  clientIdentifierVersion?: InputMaybe<Scalars['Int']>;
  /** Compliance details for importing the product, per country. */
  complianceDetails?: InputMaybe<ProductComplianceDetailsInput>;
  /** The country for which this product originates from - its manufacturing country. This field is used to determine product uniqueness. */
  countryOfOrigin?: InputMaybe<Scalars['CountryCode']>;
  /** The dimensions of the product. */
  dimensions?: InputMaybe<DimensionsInput>;
  /** Global Trade Item Number for the product. */
  gtin?: InputMaybe<Scalars['GTIN']>;
  /** Optional unique ID of a record. */
  id?: InputMaybe<Scalars['ID']>;
  ior?: InputMaybe<ProductIorInput>;
  /** Details of a product per locale.  */
  localizedDetails?: InputMaybe<Array<LocalizedProductDetailInput>>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Additional product notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Units per packing. */
  packingUnits?: InputMaybe<Scalars['Float']>;
  /** Set of additional secondary identifiers that the client might want to associate with the product (eg: ASIN). */
  secondaryIdentifiers?: InputMaybe<Array<ProductSecondaryIdentifierInput>>;
  /** The identifier of shipper importing the product. */
  shipper?: InputMaybe<IdInput>;
  /** Describes if the product is currently being shipped by the shipper. This will determine if the shipper continues to get notifications on the product when its updated. If the status is INTERNAL, it will only be shown in Operations view. */
  status?: InputMaybe<ProductStatus>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Universal Product Code for the product. */
  upc?: InputMaybe<Scalars['String']>;
  /** Optional version of a record. */
  version?: InputMaybe<Scalars['Int']>;
  /** The weight of the product */
  weight?: InputMaybe<WeightInput>;
};

/** The payload returned from triggering the Transaction. */
export type UpsertSupplierCbpMidPayload = {
  __typename?: 'UpsertSupplierCbpMidPayload';
  /** The Transaction. */
  transaction: UpsertSupplierCbpMidTransaction;
};

/** The US CBP ABI transaction for creating or updating Supplier's MID. */
export type UpsertSupplierCbpMidTransaction = Record & SupplierCbpTransaction & {
  __typename?: 'UpsertSupplierCbpMidTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Supplier */
  supplier: Supplier;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type UpsertSupplierInput = {
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: InputMaybe<Array<AddressV2Input>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: InputMaybe<AddressesInput>;
  /** Party alternate name */
  alternateName?: InputMaybe<Scalars['String']>;
  /** Compliance details for customs purposes. */
  complianceDetails?: InputMaybe<SupplierComplianceDetailsInput>;
  /** Party description */
  description?: InputMaybe<Scalars['String']>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party email */
  email?: InputMaybe<Scalars['Email']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<Scalars['String']>;
  /** Optional unique ID of a record. */
  id?: InputMaybe<Scalars['ID']>;
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: InputMaybe<Array<PartyIdentificationInput>>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The Operator that owns this Record. The server will attempt to infer the Operator by the Client if not provided explicitly. */
  operator?: InputMaybe<IdInput>;
  /** Party phone number */
  phone?: InputMaybe<PhoneInput>;
  /** A point of contact at the party's organization */
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: InputMaybe<Scalars['String']>;
  /** The Shippers related to this Party. The server will attempt to create Shipper-Party relationship once created. */
  shippers?: InputMaybe<Array<IdInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  /** Optional version of a record. */
  version?: InputMaybe<Scalars['Int']>;
};

/** Input parameters to submit an upsert entry request to US CBP. */
export type UpsertUsConsumptionEntrySummaryCbpInput = {
  /** Whether to generate draft entry summary 7501 document after the transaction to CBP. */
  isDraft7501Required?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether this transaction should also update the entry release with US CBP. */
  upsertRelease?: InputMaybe<Scalars['Boolean']>;
};

/** The payload returned from triggering the Transaction. */
export type UpsertUsConsumptionEntrySummaryCbpPayload = {
  __typename?: 'UpsertUsConsumptionEntrySummaryCbpPayload';
  /** The Transaction. */
  transaction: UpsertUsConsumptionEntrySummaryCbpTransaction;
};

/** The US CBP ABI transaction to upsert a US Consumption Entry Summary, CATAIR appCode: AE/AX, actionCode: A */
export type UpsertUsConsumptionEntrySummaryCbpTransaction = Record & UsConsumptionEntryCbpTransaction & {
  __typename?: 'UpsertUsConsumptionEntrySummaryCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether to generate draft entry summary 7501 document after the transaction to CBP. */
  isDraft7501Required?: Maybe<Scalars['Boolean']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** Indicates whether this transaction should also update the entry release with US CBP. */
  upsertRelease?: Maybe<Scalars['Boolean']>;
  /** The US Consumption Entry */
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

/** Input parameters to submit an upsert entry request to US CBP. */
export type UpsertUsPostSummaryCorrectionCbpInput = {
  /** Whether to generate draft entry summary 7501 document after the transaction to CBP. */
  isDraft7501Required?: InputMaybe<Scalars['Boolean']>;
};

/** The payload returned from triggering the Transaction. */
export type UpsertUsPostSummaryCorrectionCbpPayload = {
  __typename?: 'UpsertUsPostSummaryCorrectionCbpPayload';
  /** The Transaction. */
  transaction: UpsertUsPostSummaryCorrectionCbpTransaction;
};

/** The US CBP ABI transaction to upsert a US Consumption Entry Summary, CATAIR appCode: AE/AX, actionCode: A */
export type UpsertUsPostSummaryCorrectionCbpTransaction = Record & UsPostSummaryCorrectionCbpTransaction & {
  __typename?: 'UpsertUsPostSummaryCorrectionCbpTransaction';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether to generate draft entry summary 7501 document after the transaction to CBP. */
  isDraft7501Required?: Maybe<Scalars['Boolean']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The US Consumption Entry */
  usPostSummaryCorrection: UsPostSummaryCorrection;
  /** The record's version */
  version: Scalars['Int'];
};

/** Defines the content of a payload containing URLs. */
export type UrlContent = {
  __typename?: 'UrlContent';
  /** The url to fetch the document payload present only if the payload is present (already uploaded) */
  downloadLink?: Maybe<Scalars['URL']>;
  /** The url to upload the document payload present only if the payload is pending upload. */
  uploadLink?: Maybe<Scalars['URL']>;
};

/** Defines the content of a payload containing URLs. */
export type UrlPreview = {
  __typename?: 'UrlPreview';
  /** The url to fetch the document preview only if the preview is present (already uploaded) */
  downloadLink?: Maybe<Scalars['URL']>;
  /** The url to upload the document preview only if the preview is pending upload. */
  uploadLink?: Maybe<Scalars['URL']>;
};

export type UsAluminumRequirements = {
  __typename?: 'UsAluminumRequirements';
  /** Alumnium country of cast. */
  aluminumCountryOfCast?: Maybe<Scalars['CountryCode']>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: Maybe<Scalars['String']>;
  /** Aluminum primary country of smelt. May be N/A if this field is not applicable. */
  aluminumPrimaryCountryOfSmelt?: Maybe<Scalars['CountryCodeOrNotApplicable']>;
  /** Aluminum secondary country of smelt.  May be N/A if this field is not applicable. */
  aluminumSecondaryCountryOfSmelt?: Maybe<Scalars['CountryCodeOrNotApplicable']>;
  /** Is secondary (recycled) aluminum content only. */
  secondaryAluminumOnly?: Maybe<Scalars['Boolean']>;
};

export type UsAluminumRequirementsInput = {
  /** Alumnium country of cast. */
  aluminumCountryOfCast?: InputMaybe<Scalars['CountryCode']>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Aluminum primary country of smelt. May be N/A if this field is not applicable. */
  aluminumPrimaryCountryOfSmelt?: InputMaybe<Scalars['CountryCodeOrNotApplicable']>;
  /** Aluminum secondary country of smelt.  May be N/A if this field is not applicable. */
  aluminumSecondaryCountryOfSmelt?: InputMaybe<Scalars['CountryCodeOrNotApplicable']>;
  /** Is secondary (recycled) aluminum content only. */
  secondaryAluminumOnly?: InputMaybe<Scalars['Boolean']>;
};

/** The structure of the US business. */
export enum UsBusinessStructure {
  CORPORATION = 'CORPORATION',
  FOREIGN_GOVERNMENT = 'FOREIGN_GOVERNMENT',
  INDIVIDUAL = 'INDIVIDUAL',
  LLC = 'LLC',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
  STATE_GOVERNMENT = 'STATE_GOVERNMENT',
  US_GOVERNMENT = 'US_GOVERNMENT'
}

/** The structure of the US business. */
export type UsBusinessStructureSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsBusinessStructure>>;
};

export type UsCargoReleaseActionInfo = {
  __typename?: 'UsCargoReleaseActionInfo';
  /** TODO */
  code?: Maybe<Scalars['ReleaseDispositionCode']>;
  /** TODO */
  time?: Maybe<Scalars['DateTime']>;
};

export type UsCargoReleaseActionInput = {
  /** TODO */
  code?: InputMaybe<Scalars['ReleaseDispositionCode']>;
  /** TODO */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type UsCargoReleaseBillDispositionInfo = {
  __typename?: 'UsCargoReleaseBillDispositionInfo';
  /** Bill disposition code. */
  code?: Maybe<Scalars['ReleaseBillDispositionCode']>;
  /** Quantity entered in customs. */
  customEnteredQuantity?: Maybe<Quantity>;
  /** Full bill number associated with the cargo release. */
  fullBillNumber: Scalars['String'];
  inBondInfo?: Maybe<UsCargoReleaseInBondInfo>;
  /** Quantity manifested. */
  manifestedQuantity?: Maybe<Quantity>;
  /** Bill disposition message. */
  message?: Maybe<Scalars['String']>;
  /** Date and time of bill disposition. */
  time?: Maybe<Scalars['DateTime']>;
};

export type UsCargoReleaseBillDispositionInfoInput = {
  /** Bill disposition code. */
  code?: InputMaybe<Scalars['ReleaseBillDispositionCode']>;
  /** Quantity entered in customs. */
  customEnteredQuantity?: InputMaybe<QuantityInput>;
  /** Full bill number associated with the cargo release. */
  fullBillNumber: Scalars['String'];
  inBondInfo?: InputMaybe<UsCargoReleaseInBondInfoInput>;
  /** Quantity manifested. */
  manifestedQuantity?: InputMaybe<QuantityInput>;
  /** Bill disposition message. */
  message?: InputMaybe<Scalars['String']>;
  /** Date and time of bill disposition. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type UsCargoReleaseBrokerInfo = {
  __typename?: 'UsCargoReleaseBrokerInfo';
  address: Address;
  /** The broker's email. */
  email?: Maybe<Scalars['Email']>;
  name: Scalars['String'];
  phone: Phone;
};

export type UsCargoReleaseBrokerInfoInput = {
  address: AddressInput;
  /** The broker's email. */
  email?: InputMaybe<Scalars['Email']>;
  name: Scalars['String'];
  phone: PhoneInput;
};

export type UsCargoReleaseDispositionInfo = {
  __typename?: 'UsCargoReleaseDispositionInfo';
  action: UsCargoReleaseActionInfo;
  /** Release disposition message. */
  message?: Maybe<Scalars['String']>;
  releaseInfo: UsCargoReleaseInfo;
};

export type UsCargoReleaseDispositionInfoInput = {
  action: UsCargoReleaseActionInput;
  /** Release disposition message. */
  message?: InputMaybe<Scalars['String']>;
  releaseInfo: UsCargoReleaseInfoInput;
};

/** US UsCargoRelease document generation request. */
export type UsCargoReleaseDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'UsCargoReleaseDocumentGenerationRequest';
  /** Cargo arrival date. */
  arrivalTime?: Maybe<Scalars['DateTime']>;
  /** Bill disposition associated with the cargo release. */
  billDispositions: Array<UsCargoReleaseBillDispositionInfo>;
  /** Broker associated with cargo release. */
  broker: UsCargoReleaseBrokerInfo;
  /** Carrier code (SCAC) associated with the cargo release. */
  carrierCode: Scalars['SCACCode'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Entry information associated with the cargo release. */
  entry: UsCargoReleaseEntryInfo;
  /** FirmsCode associated with the cargo release. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Importer associated with cargo release. */
  importer?: Maybe<UsCargoReleaseImporterInfo>;
  /** Inlt shipment id associated with the cargo release. */
  inltShipmentId?: Maybe<Scalars['String']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Release disposition associated with the cargo release. */
  releaseDispositions: Array<UsCargoReleaseDispositionInfo>;
  /** Shipment associated with cargo release */
  shipment: UsCargoReleaseShipmentInfo;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The shipment's voyage, flight, or trip number associated with the cargo release. */
  tripNumber?: Maybe<Scalars['String']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The name of the vessel associated with the cargo release. */
  vesselName?: Maybe<Scalars['String']>;
};

export type UsCargoReleaseEntryInfo = {
  __typename?: 'UsCargoReleaseEntryInfo';
  /** EntryCodeType associated with the cargo release. */
  code?: Maybe<Scalars['UsCbpEntryTypeCode']>;
  /** EntryNumber associated with the cargo release. */
  number: Scalars['String'];
};

export type UsCargoReleaseEntryInfoInput = {
  /** EntryCodeType associated with the cargo release. */
  code?: InputMaybe<Scalars['UsCbpEntryTypeCode']>;
  /** EntryNumber associated with the cargo release. */
  number: Scalars['String'];
};

export type UsCargoReleaseImporterInfo = {
  __typename?: 'UsCargoReleaseImporterInfo';
  id: Scalars['ID'];
};

export type UsCargoReleaseImporterInfoInput = {
  id: Scalars['ID'];
};

export type UsCargoReleaseInBondInfo = {
  __typename?: 'UsCargoReleaseInBondInfo';
  /** In-Bond transit number. */
  itNumber: Scalars['String'];
  /** Quantity associated with the in-bond */
  quantity: Quantity;
};

export type UsCargoReleaseInBondInfoInput = {
  /** In-Bond transit number. */
  itNumber: Scalars['String'];
  /** Quantity associated with the in-bond */
  quantity: QuantityInput;
};

export type UsCargoReleaseInfo = {
  __typename?: 'UsCargoReleaseInfo';
  /** The origin code of cargo release. */
  originCode?: Maybe<Scalars['ReleaseOriginCode']>;
  /** The time of cargo release. */
  time: Scalars['DateTime'];
};

export type UsCargoReleaseInfoInput = {
  /** The origin code of cargo release. */
  originCode?: InputMaybe<Scalars['ReleaseOriginCode']>;
  /** The time of cargo release. */
  time: Scalars['DateTime'];
};

export type UsCargoReleaseShipmentInfo = {
  __typename?: 'UsCargoReleaseShipmentInfo';
  id: Scalars['ID'];
};

export type UsCargoReleaseShipmentInfoInput = {
  id: Scalars['ID'];
};

export type UsCbp5106AddressType = {
  __typename?: 'UsCbp5106AddressType';
  /** The type of address. */
  code: UsCbp5106AddressTypeCode;
  /** An explanation of the address type, required if code is OTHER. */
  explanation?: Maybe<Scalars['String']>;
};

/** The type of address. */
export enum UsCbp5106AddressTypeCode {
  BUSINESS_SERVICE_CENTER = 'BUSINESS_SERVICE_CENTER',
  CORPORATE_OFFICE = 'CORPORATE_OFFICE',
  OFFICE_BUILDING = 'OFFICE_BUILDING',
  OTHER = 'OTHER',
  POST_OFFICE_BOX = 'POST_OFFICE_BOX',
  RESIDENCE = 'RESIDENCE',
  RETAIL_LOCATION = 'RETAIL_LOCATION',
  WAREHOUSE = 'WAREHOUSE'
}

export type UsCbp5106AddressTypeInput = {
  /** The type of address. */
  code: UsCbp5106AddressTypeCode;
  /** An explanation of the address type, required if code is OTHER. */
  explanation?: InputMaybe<Scalars['String']>;
};

/** Bank information of the IOR on the US CBP 5106 */
export type UsCbp5106BankDetails = {
  __typename?: 'UsCbp5106BankDetails';
  /** The city where the bank is located. */
  city?: Maybe<Scalars['String']>;
  /** The country where the bank is located. */
  countryCode?: Maybe<Scalars['String']>;
  /** The name of the primary banking institution associated with the Importer. */
  name?: Maybe<Scalars['String']>;
  /** The bank's routing number. */
  routingNumber?: Maybe<Scalars['String']>;
  /** The state where the bank is located. */
  stateCode?: Maybe<Scalars['String']>;
};

/** Bank information of the IOR on the US CBP 5106 */
export type UsCbp5106BankDetailsInput = {
  /** The city where the bank is located. */
  city?: InputMaybe<Scalars['String']>;
  /** The country where the bank is located. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The name of the primary banking institution associated with the Importer. */
  name?: InputMaybe<Scalars['String']>;
  /** The bank's routing number. */
  routingNumber?: InputMaybe<Scalars['String']>;
  /** The state where the bank is located. */
  stateCode?: InputMaybe<Scalars['String']>;
};

/** US Cbp5106 document generation request. */
export type UsCbp5106DocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'UsCbp5106DocumentGenerationRequest';
  /** IOR addresses */
  addresses: Addresses;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: Maybe<UsCbp5106BankDetails>;
  /** Description of IOR's business */
  businessDescription?: Maybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: Maybe<UsBusinessStructure>;
  /** The mailing address type. */
  cbpMailingAddressType: UsCbp5106AddressType;
  /** The physical address type. */
  cbpPhysicalAddressType?: Maybe<UsCbp5106AddressType>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** A trade name, trading name, or business name is a pseudonym used by companies that do not operate under their registered company name. */
  doingBusinessAs?: Maybe<Scalars['String']>;
  /** IOR DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** IOR email */
  email?: Maybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: Maybe<UsCbp5106EntriesPerYearCode>;
  /** IOR web site */
  fax?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: Maybe<Array<UsCbp5106Individual>>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<UsIorNumber>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: Maybe<Scalars['String']>;
  /** IOR name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** IOR phone number */
  phone?: Maybe<Phone>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: Maybe<Array<UsCbpImporterProgramCode>>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: Maybe<Array<UsCbp5106RelatedBusiness>>;
  /** Date on which this document is signed */
  signerDate: Scalars['String'];
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** IOR web site */
  website?: Maybe<Scalars['String']>;
};

/** The code for the IOR's expected import volume. */
export enum UsCbp5106EntriesPerYearCode {
  DO_NOT_INTEND_TO_IMPORT = 'DO_NOT_INTEND_TO_IMPORT',
  FIVE_TO_TWENTY_FIVE = 'FIVE_TO_TWENTY_FIVE',
  INFREQUENT_PERSONAL_SHIPMENTS = 'INFREQUENT_PERSONAL_SHIPMENTS',
  ONE_TO_FOUR = 'ONE_TO_FOUR',
  TWENTY_FIVE_OR_MORE = 'TWENTY_FIVE_OR_MORE'
}

/** Business establishment details on the Importer's US CBP 5106 form. */
export type UsCbp5106EstablishmentDetails = {
  __typename?: 'UsCbp5106EstablishmentDetails';
  /** The country code where the Importer's Certificate or Articles of Incorporation was filed. This will be used as the importer’s Certificate or Articles of Incorporation locator ID. */
  countryCode?: Maybe<Scalars['String']>;
  /** The state code where the Importer’s Certificate or Articles of Incorporation was filed.This will be used as the importer’sCertificate or Articles of Incorporation locator ID. */
  stateCode?: Maybe<Scalars['String']>;
  /** The year the company was established. */
  year?: Maybe<Scalars['Year']>;
};

/** Business establishment details on the Importer's US CBP 5106 form. */
export type UsCbp5106EstablishmentDetailsInput = {
  /** The country code where the Importer's Certificate or Articles of Incorporation was filed. This will be used as the importer’s Certificate or Articles of Incorporation locator ID. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The state code where the Importer’s Certificate or Articles of Incorporation was filed.This will be used as the importer’sCertificate or Articles of Incorporation locator ID. */
  stateCode?: InputMaybe<Scalars['String']>;
  /** The year the company was established. */
  year?: InputMaybe<Scalars['Year']>;
};

/** Details of an individual member of the IOR reported on the US CBP form 5106. */
export type UsCbp5106Individual = {
  __typename?: 'UsCbp5106Individual';
  /** A contact email address. */
  email?: Maybe<Scalars['Email']>;
  /** The point of contact's name. */
  name: Scalars['String'];
  /** The individual's social security number. */
  passport?: Maybe<Passport>;
  /** A contact phone number. */
  phone?: Maybe<Phone>;
  /** The individual's social security number. */
  socialSecurityNumber?: Maybe<Scalars['SocialSecurityNumber']>;
  /** The official title of the point of contact. */
  title?: Maybe<Scalars['String']>;
  /** The User associated with the point of contact. */
  user?: Maybe<User>;
};

/** Details of an individual member of the IOR reported on the US CBP form 5106. */
export type UsCbp5106IndividualInput = {
  /** A contact email address. */
  email?: InputMaybe<Scalars['Email']>;
  /** The point of contact's name. */
  name: Scalars['String'];
  /** The individual's social security number. */
  passport?: InputMaybe<PassportInput>;
  /** A contact phone number. */
  phone?: InputMaybe<PhoneInput>;
  /** The individual's social security number. */
  socialSecurityNumber?: InputMaybe<Scalars['SocialSecurityNumber']>;
  /** The official title of the point of contact. */
  title?: InputMaybe<Scalars['String']>;
  /** The User associated with the point of contact. */
  user?: InputMaybe<IdInput>;
};

/** Error details of the latest US CBP 5106 rejection. */
export type UsCbp5106RejectedReason = {
  __typename?: 'UsCbp5106RejectedReason';
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Error details of the latest US CBP 5106 rejection. */
export type UsCbp5106RejectedReasonInput = {
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
export type UsCbp5106RelatedBusiness = {
  __typename?: 'UsCbp5106RelatedBusiness';
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<UsIorNumber>;
  /** The name of the seperate related business. */
  name: Scalars['String'];
  /** Indicates if the IOR's related business is current or previous. */
  type: UsCbp5106RelatedBusinessType;
};

/** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
export type UsCbp5106RelatedBusinessInput = {
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** The name of the seperate related business. */
  name: Scalars['String'];
  /** Indicates if the IOR's related business is current or previous. */
  type: UsCbp5106RelatedBusinessType;
};

/** Indicates if the IOR's related business is current or previous. */
export enum UsCbp5106RelatedBusinessType {
  CURRENT = 'CURRENT',
  PREVIOUS = 'PREVIOUS'
}

export type UsCbp7501AdditionalDeclaration = {
  __typename?: 'UsCbp7501AdditionalDeclaration';
  /** Additional declaration information. */
  information: Scalars['String'];
  /** Additional declaration type code */
  typeCode: Scalars['AdditionalDeclarationTypeCode'];
};

export type UsCbp7501AdditionalDeclarationInput = {
  /** Additional declaration information. */
  information: Scalars['String'];
  /** Additional declaration type code */
  typeCode: Scalars['AdditionalDeclarationTypeCode'];
};

export type UsCbp7501BillInfo = {
  __typename?: 'UsCbp7501BillInfo';
  number: Scalars['String'];
};

export type UsCbp7501BillInfoInput = {
  number: Scalars['String'];
};

export type UsCbp7501BrokerInfo = {
  __typename?: 'UsCbp7501BrokerInfo';
  /** Broker's address. */
  address: Address;
  /** The broker's file number. */
  fileNumber?: Maybe<Scalars['String']>;
  /** The name. */
  name: Scalars['String'];
  phone: Phone;
};

export type UsCbp7501BrokerInfoInput = {
  /** Broker's address. */
  address: AddressInput;
  /** The broker's file number. */
  fileNumber?: InputMaybe<Scalars['String']>;
  /** The name. */
  name: Scalars['String'];
  phone: PhoneInput;
};

export type UsCbp7501ConsigneeInfo = {
  __typename?: 'UsCbp7501ConsigneeInfo';
  /** Consignee's address. */
  address?: Maybe<Address>;
  /** The consignee's importer of record number. */
  iorNumber: Scalars['UsIorNumberValue'];
  /** Indicate whether the consignee number is the same as IOR Number. */
  isSameAsIor: Scalars['Boolean'];
  /** The name. */
  name: Scalars['String'];
};

export type UsCbp7501ConsigneeInfoInput = {
  /** Consignee's address. */
  address?: InputMaybe<AddressInput>;
  /** The consignee's importer of record number. */
  iorNumber: Scalars['UsIorNumberValue'];
  /** Indicate whether the consignee number is the same as IOR Number. */
  isSameAsIor: Scalars['Boolean'];
  /** The name. */
  name: Scalars['String'];
};

export type UsCbp7501DeclarantInfo = {
  __typename?: 'UsCbp7501DeclarantInfo';
  /** The declarant's name. */
  name: Scalars['String'];
  /** The name of the signing the declaration. */
  signee: Scalars['String'];
  /** The declarant's title. */
  title: Scalars['String'];
};

export type UsCbp7501DeclarantInfoInput = {
  /** The declarant's name. */
  name: Scalars['String'];
  /** The name of the signing the declaration. */
  signee: Scalars['String'];
  /** The declarant's title. */
  title: Scalars['String'];
};

/** US Cbp7501 document generation request. */
export type UsCbp7501DocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'UsCbp7501DocumentGenerationRequest';
  /** The 1-digit code representing bond type. */
  bondType?: Maybe<Scalars['String']>;
  /** The broker associated with the cbp 7501. */
  broker: UsCbp7501BrokerInfo;
  /** Consignee related fields required to generate UsCbp7501 document. */
  consignee: UsCbp7501ConsigneeInfo;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** Entry details associated with the cbp 7501. */
  entry: UsCbp7501EntryInfo;
  /** Export information associated with cbp 7501. */
  export: UsCbp7501ExportInfo;
  /** Facilities Information and Resources Management code. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** 'Schedule K' foreign port for the merchandise arriving by vessel. */
  foreignPortOfLading?: Maybe<Scalars['String']>;
  /** Where the entry summary serves as entry/entry summary, record the pier or site where the goods are available for examination.  For air shipments, record the flight number.  Where the Facilities Information and Resources Management (FIRMS) codes are available, they must be used in lieu of pier/site. */
  goNumber?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Import information associated with cbp 7501. */
  import: UsCbp7501ImportInfo;
  /** The importer associated with the cbp 7501. */
  importer: UsCbp7501ImporterInfo;
  /** In-Bond information associated with cbp 7501. */
  inBond?: Maybe<UsCbp7501InBondInfo>;
  /** Line items associated with cbp 7501. */
  invoices?: Maybe<Array<UsCbp7501InvoiceInfo>>;
  /** Whether the entry has been accepted by CBP. Considered it draft if not set. */
  isCertified?: Maybe<Scalars['Boolean']>;
  /** Manifest information associated with cbp 7501. */
  manifests: Array<UsCbp7501ManifestInfo>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Signing information associated with the cbp 7501. */
  sign: UsCbp7501SignInfo;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Date on which the entry summary is filed with CBP. */
  summaryTime?: Maybe<Scalars['DateTime']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. */
  suretyNumber?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Summary of duty, tax, and fee of all the line items. */
  totalCosts: UsCbp7501TotalCostInfo;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsCbp7501Duty = {
  __typename?: 'UsCbp7501Duty';
  amount: Cost;
  /** The duty rate. */
  rate: Scalars['String'];
};

export type UsCbp7501DutyInput = {
  amount: CostInput;
  /** The duty rate. */
  rate: Scalars['String'];
};

export type UsCbp7501EntryInfo = {
  __typename?: 'UsCbp7501EntryInfo';
  /** Indicate whether it is Periodic Monthly Statement. */
  isPms?: Maybe<Scalars['Boolean']>;
  /** Indicate if it is Post-entry Summary Correction. */
  isPsc?: Maybe<Scalars['Boolean']>;
  /** Mode of transportation by which the imported merchandise entered the U.S. port of arrival from the last foreign country */
  motCode: Scalars['MOTCode'];
  /** EntryNumber associated with the cbp 7501. */
  number: Scalars['String'];
  /** US port code utilizing the Schedule D, Customs District and Port Codes, listed in Annex C of the HTS. The port is where the merchandise was entered under an entry or released under an immediate delivery permit. */
  portCode: Scalars['String'];
  /** The date when goods are released, except for immediate delivery, quota goods, or where the filer requests another date prior to release. */
  time?: Maybe<Scalars['DateTime']>;
  /** EntryCodeType associated with the cbp 7501. */
  type: Scalars['UsCbpEntryTypeCode'];
};

export type UsCbp7501EntryInfoInput = {
  /** Indicate whether it is Periodic Monthly Statement. */
  isPms?: InputMaybe<Scalars['Boolean']>;
  /** Indicate if it is Post-entry Summary Correction. */
  isPsc?: InputMaybe<Scalars['Boolean']>;
  /** Mode of transportation by which the imported merchandise entered the U.S. port of arrival from the last foreign country */
  motCode: Scalars['MOTCode'];
  /** EntryNumber associated with the cbp 7501. */
  number: Scalars['String'];
  /** US port code utilizing the Schedule D, Customs District and Port Codes, listed in Annex C of the HTS. The port is where the merchandise was entered under an entry or released under an immediate delivery permit. */
  portCode: Scalars['String'];
  /** The date when goods are released, except for immediate delivery, quota goods, or where the filer requests another date prior to release. */
  time?: InputMaybe<Scalars['DateTime']>;
  /** EntryCodeType associated with the cbp 7501. */
  type: Scalars['UsCbpEntryTypeCode'];
};

export type UsCbp7501ExportInfo = {
  __typename?: 'UsCbp7501ExportInfo';
  /** Exporting country. */
  countryCode: Scalars['CountryCode'];
  /** Time on which the carrier departed the last port in the exporting country. */
  time: Scalars['DateTime'];
};

export type UsCbp7501ExportInfoInput = {
  /** Exporting country. */
  countryCode: Scalars['CountryCode'];
  /** Time on which the carrier departed the last port in the exporting country. */
  time: Scalars['DateTime'];
};

export type UsCbp7501Fee = {
  __typename?: 'UsCbp7501Fee';
  amount: Cost;
  /** Fee class code. */
  classCode: Scalars['UsConsumptionEntryFeeCode'];
  /** Fee class type. */
  classType: Scalars['String'];
  rate: Scalars['String'];
};

export type UsCbp7501FeeInfoInput = {
  /** Total estimated duty paid, excluding AD/CVD. */
  duty: CostInput;
  /** Summary of all the other fee. */
  feeSummary: Array<UsCbp7501FeeSummaryInput>;
  /** Total estimated AD/CVD or other fees, charges or exactions paid, excluding AD/CVD amounts that were bonded. */
  otherFee: CostInput;
  /** Total estimated tax paid, including any amount deferred. */
  tax: CostInput;
  /** The sum of duty, tax, and other fees. */
  total: CostInput;
  /** Sum of entered assists from all line items. */
  totalEnteredAssist?: InputMaybe<CostInput>;
  /** Sum of entered values from all line items. */
  totalEnteredValue: CostInput;
};

export type UsCbp7501FeeInput = {
  amount: CostInput;
  /** Fee class code. */
  classCode: Scalars['UsConsumptionEntryFeeCode'];
  /** Fee class type. */
  classType: Scalars['String'];
  rate: Scalars['String'];
};

export type UsCbp7501FeeSummary = {
  __typename?: 'UsCbp7501FeeSummary';
  amount: Cost;
  /** Fee class code. */
  classCode: Scalars['UsConsumptionEntryFeeCode'];
};

export type UsCbp7501FeeSummaryInput = {
  amount: CostInput;
  /** Fee class code. */
  classCode: Scalars['UsConsumptionEntryFeeCode'];
};

export type UsCbp7501ForeignCurrency = {
  __typename?: 'UsCbp7501ForeignCurrency';
  /** Foreign currency conversion factor. */
  conversionFactor: Scalars['Float'];
  /** The original amount expressed in foreign currency */
  originalAmount: Cost;
};

export type UsCbp7501ForeignCurrencyInput = {
  /** Foreign currency conversion factor. */
  conversionFactor: Scalars['Float'];
  /** The original amount expressed in foreign currency */
  originalAmount: CostInput;
};

export type UsCbp7501ImportInfo = {
  __typename?: 'UsCbp7501ImportInfo';
  /** For merchandise arriving in the U.S. by vessel, record the name of the vessel that transported the merchandise from the foreign port of lading to the first U.S. port of unlading. */
  carrier?: Maybe<Scalars['String']>;
  /** The US 2-letter state code of the shipments final destination */
  destinationStateCode?: Maybe<Scalars['CountrySubdivisionCode']>;
  /** Time in which the merchandise arrived within the U.S. port limits. For merchandise arriving in the U.S. by vessel, arrival with intent to unlade. */
  time: Scalars['DateTime'];
  /**  US port code where the merchandise was unladen from the vessel, aircraft or train. For any other transportation, leave blank. */
  usPortOfUnlading?: Maybe<Scalars['UsCbpPortCode']>;
};

export type UsCbp7501ImportInfoInput = {
  /** For merchandise arriving in the U.S. by vessel, record the name of the vessel that transported the merchandise from the foreign port of lading to the first U.S. port of unlading. */
  carrier?: InputMaybe<Scalars['String']>;
  /** The US 2-letter state code of the shipments final destination */
  destinationStateCode?: InputMaybe<Scalars['CountrySubdivisionCode']>;
  /** Time in which the merchandise arrived within the U.S. port limits. For merchandise arriving in the U.S. by vessel, arrival with intent to unlade. */
  time: Scalars['DateTime'];
  /**  US port code where the merchandise was unladen from the vessel, aircraft or train. For any other transportation, leave blank. */
  usPortOfUnlading?: InputMaybe<Scalars['UsCbpPortCode']>;
};

export type UsCbp7501ImporterInfo = {
  __typename?: 'UsCbp7501ImporterInfo';
  /** Importer's address. */
  address: Address;
  /** The importer's file number. */
  fileNumber?: Maybe<Scalars['String']>;
  /** The importer's number. */
  iorNumber: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
};

export type UsCbp7501ImporterInfoInput = {
  /** Importer's address. */
  address: AddressInput;
  /** The importer's file number. */
  fileNumber?: InputMaybe<Scalars['String']>;
  /** The importer's number. */
  iorNumber: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
};

export type UsCbp7501InBondInfo = {
  __typename?: 'UsCbp7501InBondInfo';
  time: Scalars['DateTime'];
};

export type UsCbp7501InBondInfoInput = {
  time: Scalars['DateTime'];
};

export type UsCbp7501InvoiceAdjustment = {
  __typename?: 'UsCbp7501InvoiceAdjustment';
  /** Amount after adjustment. */
  adjustedAmount: Cost;
  /** Adjustment information. */
  adjustments: Array<UsConsumptionEntryCommercialInvoiceAdjustment>;
  /** Amount before adjustment. */
  unadjustedAmount: Cost;
};

export type UsCbp7501InvoiceAdjustmentInput = {
  /** Amount after adjustment. */
  adjustedAmount: CostInput;
  /** Adjustment information. */
  adjustments: Array<UsConsumptionEntryCommercialInvoiceAdjustmentInput>;
  /** Amount before adjustment. */
  unadjustedAmount: CostInput;
};

export type UsCbp7501InvoiceInfo = {
  __typename?: 'UsCbp7501InvoiceInfo';
  /** Invoice adjustment. Not required if no adjustments are made/applied in the invoice. */
  adjustmentInfo?: Maybe<UsCbp7501InvoiceAdjustment>;
  /** Foreign currency information in case the currency used in invoice is not USD. */
  foreignCurrency?: Maybe<UsCbp7501ForeignCurrency>;
  /** The line items. */
  lineItems: Array<UsCbp7501LineItemInfo>;
  /** The invoice number. */
  number: Scalars['String'];
  /** Sum of entered assists from all line items within an invoice. */
  totalEnteredAssist?: Maybe<Cost>;
};

export type UsCbp7501InvoiceInfoInput = {
  /** Invoice adjustment. Not required if no adjustments are made/applied in the invoice. */
  adjustmentInfo?: InputMaybe<UsCbp7501InvoiceAdjustmentInput>;
  /** Foreign currency information in case the currency used in invoice is not USD. */
  foreignCurrency?: InputMaybe<UsCbp7501ForeignCurrencyInput>;
  /** The line items. */
  lineItems: Array<UsCbp7501LineItemInfoInput>;
  /** The invoice number. */
  number: Scalars['String'];
  /** Sum of entered assists from all line items within an invoice. */
  totalEnteredAssist?: InputMaybe<CostInput>;
};

export type UsCbp7501LineItemInfo = {
  __typename?: 'UsCbp7501LineItemInfo';
  /** Anti-dumping duty */
  adDuty?: Maybe<UsCbp7501ProtectionDutyInfo>;
  /** Additional declaration information associated with the line item. */
  additionalDeclaration?: Maybe<UsCbp7501AdditionalDeclaration>;
  /** The textile category for each separate line, as applicable. */
  categoryNumber?: Maybe<Scalars['String']>;
  /** Record the aggregate cost in U.S. dollars of freight, insurance and all other charges, costs and expenses incurred while bringing the merchandise from alongside the carrier at the port of exportation in the country of exportation and placing it alongside the carrier at the first U.S. port of entry.  Do not include U.S. import duties. */
  charge: Cost;
  /** CBP Claim code. */
  claimCode?: Maybe<Scalars['String']>;
  /** Countervailing duty */
  cvdDuty?: Maybe<UsCbp7501ProtectionDutyInfo>;
  /** The description of the merchandise. */
  description: Scalars['String'];
  /** Duty paid, excluding AD/CVD. */
  duty?: Maybe<UsCbp7501Duty>;
  /** Total assist in whole U.S. dollars rounded off to the nearest whole dollar. */
  enteredAssist?: Maybe<Cost>;
  /** Total entered value in whole U.S. dollars rounded off to the nearest whole dollar. */
  enteredValue: Cost;
  /** Identify any other fee, charge or exaction that applies. */
  fees?: Maybe<Array<UsCbp7501Fee>>;
  /** Gross weight of the item in kilograms. */
  grossWeight: Quantity;
  /** Indicate transaction was between related parties for CBP to aware of special pricing or arrangements. */
  isRelatedParty: Scalars['Boolean'];
  /** License number with format defined by licenseCode. */
  licenseNumber?: Maybe<Scalars['String']>;
  /** The manifest quantity reported on the B/L or AWB. */
  manifestedQuantity?: Maybe<Quantity>;
  /** The manufacturer identification code derived by US CBP. */
  mid: Scalars['UsCbpMid'];
  /** The origin of the line item. */
  origin?: Maybe<Scalars['String']>;
  /** TODO */
  pnNumber?: Maybe<Scalars['String']>;
  /** Tariff on the line item. */
  tariffs: Array<UsCbp7501TariffInfo>;
  /** Taxes paid, including any amount deferred. */
  taxes?: Maybe<Array<UsCbp7501Tax>>;
};

export type UsCbp7501LineItemInfoInput = {
  /** Anti-dumping duty */
  adDuty?: InputMaybe<UsCbp7501ProtectionDutyInfoInput>;
  /** Additional declaration information associated with the line item. */
  additionalDeclaration?: InputMaybe<UsCbp7501AdditionalDeclarationInput>;
  /** The textile category for each separate line, as applicable. */
  categoryNumber?: InputMaybe<Scalars['String']>;
  /** Record the aggregate cost in U.S. dollars of freight, insurance and all other charges, costs and expenses incurred while bringing the merchandise from alongside the carrier at the port of exportation in the country of exportation and placing it alongside the carrier at the first U.S. port of entry.  Do not include U.S. import duties. */
  charge: CostInput;
  /** CBP Claim code. */
  claimCode?: InputMaybe<Scalars['String']>;
  /** Countervailing duty */
  cvdDuty?: InputMaybe<UsCbp7501ProtectionDutyInfoInput>;
  /** The description of the merchandise. */
  description: Scalars['String'];
  /** Duty paid, excluding AD/CVD. */
  duty?: InputMaybe<UsCbp7501DutyInput>;
  /** Total assist in whole U.S. dollars rounded off to the nearest whole dollar. */
  enteredAssist?: InputMaybe<CostInput>;
  /** Total entered value in whole U.S. dollars rounded off to the nearest whole dollar. */
  enteredValue: CostInput;
  /** Identify any other fee, charge or exaction that applies. */
  fees?: InputMaybe<Array<UsCbp7501FeeInput>>;
  /** Gross weight of the item in kilograms. */
  grossWeight: QuantityInput;
  /** Indicate transaction was between related parties for CBP to aware of special pricing or arrangements. */
  isRelatedParty: Scalars['Boolean'];
  /** License number with format defined by licenseCode. */
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** The manifest quantity reported on the B/L or AWB. */
  manifestedQuantity?: InputMaybe<QuantityInput>;
  /** The manufacturer identification code derived by US CBP. */
  mid: Scalars['UsCbpMid'];
  /** The origin of the line item. */
  origin?: InputMaybe<Scalars['String']>;
  /** TODO */
  pnNumber?: InputMaybe<Scalars['String']>;
  /** Tariff on the line item. */
  tariffs: Array<UsCbp7501TariffInfoInput>;
  /** Taxes paid, including any amount deferred. */
  taxes?: InputMaybe<Array<UsCbp7501TaxInput>>;
};

export type UsCbp7501ManifestInBondInfo = {
  __typename?: 'UsCbp7501ManifestInBondInfo';
  number: Scalars['String'];
};

export type UsCbp7501ManifestInBondInfoInput = {
  number: Scalars['String'];
};

export type UsCbp7501ManifestInfo = {
  __typename?: 'UsCbp7501ManifestInfo';
  /** House bill associated with the manifest. */
  houseBill?: Maybe<UsCbp7501BillInfo>;
  /** In-Bond information associated with cbp 7501. */
  inBond?: Maybe<UsCbp7501ManifestInBondInfo>;
  /** Master bill associated with the manifest. */
  masterBill?: Maybe<UsCbp7501BillInfo>;
  /** Manifested quantity. */
  quantity: Quantity;
};

export type UsCbp7501ManifestInfoInput = {
  /** House bill associated with the manifest. */
  houseBill?: InputMaybe<UsCbp7501BillInfoInput>;
  /** In-Bond information associated with cbp 7501. */
  inBond?: InputMaybe<UsCbp7501ManifestInBondInfoInput>;
  /** Master bill associated with the manifest. */
  masterBill?: InputMaybe<UsCbp7501BillInfoInput>;
  /** Manifested quantity. */
  quantity: QuantityInput;
};

export type UsCbp7501ProtectionDutyInfo = {
  __typename?: 'UsCbp7501ProtectionDutyInfo';
  amount: Cost;
  /** AD/CVD case number as assigned by the Department of Commerce, International Trade Administration */
  caseNumber: Scalars['String'];
  /** The rate. */
  rate: Scalars['String'];
  suretyNumber: Scalars['String'];
};

export type UsCbp7501ProtectionDutyInfoInput = {
  amount: CostInput;
  /** AD/CVD case number as assigned by the Department of Commerce, International Trade Administration */
  caseNumber: Scalars['String'];
  /** The rate. */
  rate: Scalars['String'];
  suretyNumber: Scalars['String'];
};

export type UsCbp7501SignInfo = {
  __typename?: 'UsCbp7501SignInfo';
  /** The declarant who signs cbp 7501. */
  declarant: UsCbp7501DeclarantInfo;
  /** Time on which obtained from the CBP Form 7512, TACM, or AMS MIB. */
  time: Scalars['DateTime'];
};

export type UsCbp7501SignInfoInput = {
  /** The declarant who signs cbp 7501. */
  declarant: UsCbp7501DeclarantInfoInput;
  /** Time on which obtained from the CBP Form 7512, TACM, or AMS MIB. */
  time: Scalars['DateTime'];
};

export type UsCbp7501TariffInfo = {
  __typename?: 'UsCbp7501TariffInfo';
  /** The description of the tariff. */
  description: Scalars['String'];
  htsDuty: UsCbp7501Duty;
  /** The HTS Number of the tariff. */
  htsNumber: Scalars['HtsNumber'];
  /** The quantities in the specified unit of measure, and show the unit of measure after the net quantity figure */
  quantities?: Maybe<Array<Quantity>>;
};

export type UsCbp7501TariffInfoInput = {
  /** The description of the tariff. */
  description: Scalars['String'];
  htsDuty: UsCbp7501DutyInput;
  /** The HTS Number of the tariff. */
  htsNumber: Scalars['HtsNumber'];
  /** The quantities in the specified unit of measure, and show the unit of measure after the net quantity figure */
  quantities?: InputMaybe<Array<QuantityInput>>;
};

export type UsCbp7501Tax = {
  __typename?: 'UsCbp7501Tax';
  amount: Cost;
  /** Tax class code. */
  classCode: Scalars['TaxClassCode'];
  /** Tax class type. */
  classType: Scalars['String'];
  /** Craft Beverage Modernization Act. Indicates if the imported good is alcohol. */
  isCbma: Scalars['Boolean'];
  /** The rate. */
  rate: Scalars['String'];
};

export type UsCbp7501TaxInput = {
  amount: CostInput;
  /** Tax class code. */
  classCode: Scalars['TaxClassCode'];
  /** Tax class type. */
  classType: Scalars['String'];
  /** Craft Beverage Modernization Act. Indicates if the imported good is alcohol. */
  isCbma: Scalars['Boolean'];
  /** The rate. */
  rate: Scalars['String'];
};

export type UsCbp7501TotalCostInfo = {
  __typename?: 'UsCbp7501TotalCostInfo';
  /** Total estimated duty paid, excluding AD/CVD. */
  duty: Cost;
  /** Summary of all the other fee. */
  feeSummary: Array<UsCbp7501FeeSummary>;
  /** Total estimated AD/CVD or other fees, charges or exactions paid, excluding AD/CVD amounts that were bonded. */
  otherFee: Cost;
  /** Total estimated tax paid, including any amount deferred. */
  tax: Cost;
  /** The sum of duty, tax, and other fees. */
  total: Cost;
  /** Sum of entered assists from all line items. */
  totalEnteredAssist?: Maybe<Cost>;
  /** Sum of entered values from all line items. */
  totalEnteredValue: Cost;
};

export type UsCbp7512BillInfo = {
  __typename?: 'UsCbp7512BillInfo';
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  number?: Maybe<Scalars['String']>;
  /** When adding an in-bond to an existing Bill of Lading, this field is used when the in-bond quantity is less than the full Bill quantity of the previously transmitted Bill of Lading. If not provided, the in-bond quantity will automatically be assumed to be full Bill quantity. */
  quantity?: Maybe<Scalars['Float']>;
};

export type UsCbp7512BillInfoInput = {
  /** The master/sub bill number combo as "masterBillNo/houseBillNo" */
  number?: InputMaybe<Scalars['String']>;
  /** When adding an in-bond to an existing Bill of Lading, this field is used when the in-bond quantity is less than the full Bill quantity of the previously transmitted Bill of Lading. If not provided, the in-bond quantity will automatically be assumed to be full Bill quantity. */
  quantity?: InputMaybe<Scalars['Float']>;
};

export type UsCbp7512CarrierInfo = {
  __typename?: 'UsCbp7512CarrierInfo';
  /** The CBP Assigned number of the bonded carrier of the CbpInBond */
  cain?: Maybe<Scalars['CbpAssignedNumber']>;
  /** The EIN number of the bonded carrier of the CbpInBond */
  ein?: Maybe<Scalars['EmployeeIdentificationNumber']>;
  /** The name of the Trucker carrying the goods for the CbpInBond. */
  name?: Maybe<Scalars['String']>;
};

export type UsCbp7512CarrierInfoInput = {
  /** The CBP Assigned number of the bonded carrier of the CbpInBond */
  cain?: InputMaybe<Scalars['CbpAssignedNumber']>;
  /** The EIN number of the bonded carrier of the CbpInBond */
  ein?: InputMaybe<Scalars['EmployeeIdentificationNumber']>;
  /** The name of the Trucker carrying the goods for the CbpInBond. */
  name?: InputMaybe<Scalars['String']>;
};

export type UsCbp7512ConsigneeInfo = {
  __typename?: 'UsCbp7512ConsigneeInfo';
  /** The UsConsignee address associated with the CbpInBond. */
  address?: Maybe<Address>;
  /** The UsConsignee name associated with the CbpInBond. */
  name?: Maybe<Scalars['String']>;
};

export type UsCbp7512ConsigneeInfoInput = {
  /** The UsConsignee address associated with the CbpInBond. */
  address?: InputMaybe<AddressInput>;
  /** The UsConsignee name associated with the CbpInBond. */
  name?: InputMaybe<Scalars['String']>;
};

/** US Cbp7512 document generation request. */
export type UsCbp7512DocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'UsCbp7512DocumentGenerationRequest';
  /** The associated bills of lading for this CbpInBond */
  bills?: Maybe<Array<UsCbp7512BillInfo>>;
  /** The carrier information for the CbpInBond */
  carrier?: Maybe<UsCbp7512CarrierInfo>;
  /** The type of in-bond movement */
  cbpInBondEntryType?: Maybe<CbpInBondEntryType>;
  /** The INLT CBP in-bond Number identifying the in-bond movement, a 9 digit number made up of an 8 digit "base" number followed by a "check" digit */
  cbpInBondNumber?: Maybe<Scalars['InltUsInBondNumber']>;
  /** The UsConsignee associated with the CbpInBond. Returns the latest version. */
  consignee?: Maybe<UsCbp7512ConsigneeInfo>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** The port of destination for a T&E ‘62’ or IE ‘63’ entries. */
  foreignPortOfDestination?: Maybe<Scalars['UsCbpForeignPortCode']>;
  /** The FIRMS code representing where the goods are at right now */
  goodsNowAt?: Maybe<Scalars['FirmsCode']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Importer related fields required to generate UsCbp7512 document. */
  importer?: Maybe<UsCbp7512ImporterInfo>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The previous CbpInBond information */
  previousCbpInBond?: Maybe<UsCbp7512PreviousCbpInBondInfo>;
  /** Shipment related fields required to generate UsCbp7512 document. */
  shipment?: Maybe<UsCbp7512ShipmentInfo>;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The port of termination for an IT ‘61’ entry, or the port of exportation for a T&E ‘62’ entry, or the port of arrival for an IT ‘63’entry. */
  usPortOfDestination?: Maybe<Scalars['UsCbpPortCode']>;
  /** The value of the goods in whole dollars of the in-bond movement. Twenty dollars per kilo may be used if the value is unknown. */
  valueOfGoods?: Maybe<Scalars['UsDollars']>;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsCbp7512ImporterInfo = {
  __typename?: 'UsCbp7512ImporterInfo';
  /** The importer's number. */
  iorNumber?: Maybe<Scalars['UsIorNumberValue']>;
  /** The name of the Importer associated with the CbpInBond. */
  name?: Maybe<Scalars['String']>;
};

export type UsCbp7512ImporterInfoInput = {
  /** The importer's number. */
  iorNumber?: InputMaybe<Scalars['UsIorNumberValue']>;
  /** The name of the Importer associated with the CbpInBond. */
  name?: InputMaybe<Scalars['String']>;
};

export type UsCbp7512PreviousCbpInBondInfo = {
  __typename?: 'UsCbp7512PreviousCbpInBondInfo';
  /** The previous CbpInBond date */
  date?: Maybe<Scalars['Date']>;
  /** The previous CbpInBond US In-Bond number */
  number?: Maybe<Scalars['UsInBondNumber']>;
  /** The previous CbpInBond origin port */
  port?: Maybe<Scalars['UsCbpPortCode']>;
};

export type UsCbp7512PreviousCbpInBondInfoInput = {
  /** The previous CbpInBond date */
  date?: InputMaybe<Scalars['Date']>;
  /** The previous CbpInBond US In-Bond number */
  number?: InputMaybe<Scalars['UsInBondNumber']>;
  /** The previous CbpInBond origin port */
  port?: InputMaybe<Scalars['UsCbpPortCode']>;
};

export type UsCbp7512ShipmentArrivalInfo = {
  __typename?: 'UsCbp7512ShipmentArrivalInfo';
  /** The port where cargo is discharged in arrival country. */
  portOfUnlading?: Maybe<Scalars['UsCbpPortCode']>;
  /** Arrival time of the shipment. */
  time?: Maybe<Scalars['DateTime']>;
};

export type UsCbp7512ShipmentArrivalInfoInput = {
  /** The port where cargo is discharged in arrival country. */
  portOfUnlading?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** Arrival time of the shipment. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type UsCbp7512ShipmentConveyanceInfo = {
  __typename?: 'UsCbp7512ShipmentConveyanceInfo';
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
};

export type UsCbp7512ShipmentConveyanceInfoInput = {
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
};

export type UsCbp7512ShipmentDepartureInfo = {
  __typename?: 'UsCbp7512ShipmentDepartureInfo';
  /** Departure country of the shipment leg. */
  country?: Maybe<Scalars['CountryCode']>;
  /** The port where shipment gets loaded in departure country. */
  portOfLading?: Maybe<Scalars['UsCbpForeignPortCode']>;
  /** Departure time of the shipment leg. */
  time?: Maybe<Scalars['DateTime']>;
};

export type UsCbp7512ShipmentDepartureInfoInput = {
  /** Departure country of the shipment leg. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** The port where shipment gets loaded in departure country. */
  portOfLading?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
  /** Departure time of the shipment leg. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type UsCbp7512ShipmentInfo = {
  __typename?: 'UsCbp7512ShipmentInfo';
  /** Shipment arrival info that is used in the usCbp7512 document */
  arrival?: Maybe<UsCbp7512ShipmentArrivalInfo>;
  /** Shipment conveyance info that is used in the usCbp7512 document */
  conveyance?: Maybe<UsCbp7512ShipmentConveyanceInfo>;
  /** Shipment departure info that is used in the usCbp7512 document */
  departure?: Maybe<UsCbp7512ShipmentDepartureInfo>;
};

export type UsCbp7512ShipmentInfoInput = {
  /** Shipment arrival info that is used in the usCbp7512 document */
  arrival?: InputMaybe<UsCbp7512ShipmentArrivalInfoInput>;
  /** Shipment conveyance info that is used in the usCbp7512 document */
  conveyance?: InputMaybe<UsCbp7512ShipmentConveyanceInfoInput>;
  /** Shipment departure info that is used in the usCbp7512 document */
  departure?: InputMaybe<UsCbp7512ShipmentDepartureInfoInput>;
};

/** Error details of the latest US CBP Drawback Claim (DE) rejection. */
export type UsCbpDrawbackClaimRejectionReason = {
  __typename?: 'UsCbpDrawbackClaimRejectionReason';
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Error details of the latest US CBP Drawback Claim (DE) rejection. */
export type UsCbpDrawbackClaimRejectionReasonInput = {
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Status of the Drawback Claim (DE) filing with CBP. */
export enum UsCbpDrawbackClaimStatus {
  FILED = 'FILED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type UsCbpDrawbackClaimStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpDrawbackClaimStatus>>;
};

/** Indicates census warning status of the US entry summary. */
export enum UsCbpEntryCensusHeaderStatusCode {
  ALL_CENSUS_WARNING_RESOLVED = 'ALL_CENSUS_WARNING_RESOLVED',
  AT_LEAST_ONE_CENSUS_WARNING_UNRESOLVED = 'AT_LEAST_ONE_CENSUS_WARNING_UNRESOLVED',
  NO_CENSUS_WARNING = 'NO_CENSUS_WARNING'
}

export type UsCbpEntryCharges = {
  __typename?: 'UsCbpEntryCharges';
  /** Countervailing duties owed to US CBP. */
  adDuties?: Maybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: Maybe<Scalars['UsDollars']>;
  /** Duties owed to US CBP. */
  duties?: Maybe<Scalars['UsDollars']>;
  /** List of fees and details owed to US CBP. */
  feeDetails?: Maybe<Array<FeeDetail>>;
  /** Fees owed to US CBP. */
  fees?: Maybe<Scalars['UsDollars']>;
  /** List of fees owed to US CBP. */
  feesList?: Maybe<Array<UsCbpEntryFeeCharge>>;
  /** Taxes owed to US CBP. */
  taxes?: Maybe<Scalars['UsDollars']>;
  /** List of taxes owed to US CBP. */
  taxesList?: Maybe<Array<UsCbpEntryTaxCharge>>;
};

export type UsCbpEntryChargesInput = {
  /** Countervailing duties owed to US CBP. */
  adDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Duties owed to US CBP. */
  duties?: InputMaybe<Scalars['UsDollars']>;
  /** List of fees and details owed to US CBP. */
  feeDetails?: InputMaybe<Array<FeeDetailInput>>;
  /** Fees owed to US CBP. */
  fees?: InputMaybe<Scalars['UsDollars']>;
  /** List of fees owed to US CBP. */
  feesList?: InputMaybe<Array<UsCbpEntryFeeChargeInput>>;
  /** Taxes owed to US CBP. */
  taxes?: InputMaybe<Scalars['UsDollars']>;
  /** List of taxes owed to US CBP. */
  taxesList?: InputMaybe<Array<UsCbpEntryTaxChargeInput>>;
};

/** Indicates the control status of the US entry summary. */
export enum UsCbpEntryControlStatusCode {
  ACE = 'ACE',
  CBP = 'CBP',
  TRADE = 'TRADE'
}

export type UsCbpEntryDailyStatement = {
  __typename?: 'UsCbpEntryDailyStatement';
  /** The time the CBP Preliminary Daily Statement Debit Authorization occurred successfully. */
  authorizationTime?: Maybe<Scalars['DateTime']>;
  /** The time the CBP Final Daily Statement was generated. */
  finalGeneratedTime?: Maybe<Scalars['DateTime']>;
  /** The CBP Daily Statement number. */
  number?: Maybe<Scalars['String']>;
  /** The time the CBP Preliminary Daily Statement was generated. */
  preliminaryGeneratedTime?: Maybe<Scalars['DateTime']>;
  /** The date set by the Broker that the CBP Preliminary Daily Statement will be generated. */
  printDate?: Maybe<Scalars['Date']>;
};

export type UsCbpEntryDailyStatementInput = {
  /** The time the CBP Preliminary Daily Statement Debit Authorization occurred successfully. */
  authorizationTime?: InputMaybe<Scalars['DateTime']>;
  /** The time the CBP Final Daily Statement was generated. */
  finalGeneratedTime?: InputMaybe<Scalars['DateTime']>;
  /** The CBP Daily Statement number. */
  number?: InputMaybe<Scalars['String']>;
  /** The time the CBP Preliminary Daily Statement was generated. */
  preliminaryGeneratedTime?: InputMaybe<Scalars['DateTime']>;
  /** The date set by the Broker that the CBP Preliminary Daily Statement will be generated. */
  printDate?: InputMaybe<Scalars['Date']>;
};

/** The status of the exam being conducted on the entry. */
export enum UsCbpEntryExamStatus {
  AT_CFS_ON_HOLD = 'AT_CFS_ON_HOLD',
  AT_CFS_PENDING_EXAM_TRANSFER = 'AT_CFS_PENDING_EXAM_TRANSFER',
  AT_EXAM_SITE_PENDING_EXAM = 'AT_EXAM_SITE_PENDING_EXAM',
  AT_FUMIGATION_SITE = 'AT_FUMIGATION_SITE',
  CBP_HOLD_AT_CES = 'CBP_HOLD_AT_CES',
  CES_DEVANNING = 'CES_DEVANNING',
  CLEARED_FOR_PICKUP_1USG = 'CLEARED_FOR_PICKUP_1USG',
  EXAM_COMPLETED = 'EXAM_COMPLETED',
  EXAM_IN_PROGRESS = 'EXAM_IN_PROGRESS',
  EXAM_OUT_GATE = 'EXAM_OUT_GATE',
  ON_VESSEL = 'ON_VESSEL',
  PENDING_PICKUP_AT_TERMINAL = 'PENDING_PICKUP_AT_TERMINAL',
  SPECIAL_EXCEPTION_COMPLETED = 'SPECIAL_EXCEPTION_COMPLETED',
  SPECIAL_EXCEPTION_DESTRUCTION = 'SPECIAL_EXCEPTION_DESTRUCTION',
  SPECIAL_EXCEPTION_DESTRUCTION_COMPLETED = 'SPECIAL_EXCEPTION_DESTRUCTION_COMPLETED',
  SPECIAL_EXCEPTION_DETAINED = 'SPECIAL_EXCEPTION_DETAINED',
  SPECIAL_EXCEPTION_EXPORT = 'SPECIAL_EXCEPTION_EXPORT',
  SPECIAL_EXCEPTION_EXPORT_COMPLETED = 'SPECIAL_EXCEPTION_EXPORT_COMPLETED',
  SPECIAL_EXCEPTION_PARTIAL_RELEASE = 'SPECIAL_EXCEPTION_PARTIAL_RELEASE',
  SPECIAL_EXCEPTION_RECONDITIONING = 'SPECIAL_EXCEPTION_RECONDITIONING',
  SPECIAL_EXCEPTION_RECONDITIONING_COMPLETED = 'SPECIAL_EXCEPTION_RECONDITIONING_COMPLETED',
  SPECIAL_EXCEPTION_SEIZED = 'SPECIAL_EXCEPTION_SEIZED',
  TERMINAL_OUT_GATE = 'TERMINAL_OUT_GATE'
}

/** The specific type of exam conducted on the entry. */
export enum UsCbpEntryExamSubType {
  AQI = 'AQI',
  BILL_HOLD = 'BILL_HOLD',
  CET = 'CET',
  CPSC_EXAM = 'CPSC_EXAM',
  DOCUMENT_REQUEST = 'DOCUMENT_REQUEST',
  EPA_EXAM = 'EPA_EXAM',
  EPA_REVIEW = 'EPA_REVIEW',
  FDA_EXAM = 'FDA_EXAM',
  FDA_HOLD = 'FDA_HOLD',
  FUMIGATION = 'FUMIGATION',
  ISF_HOLD = 'ISF_HOLD',
  MET = 'MET',
  NII = 'NII',
  OTHER_PGA_EXAM = 'OTHER_PGA_EXAM',
  TAILGATE = 'TAILGATE',
  TRADE = 'TRADE',
  UFLPA = 'UFLPA'
}

/** The type of the exam conducted on the entry. */
export enum UsCbpEntryExamType {
  INTENSIVE = 'INTENSIVE',
  NON_INTENSIVE = 'NON_INTENSIVE',
  PGA = 'PGA'
}

export type UsCbpEntryFeeCharge = {
  __typename?: 'UsCbpEntryFeeCharge';
  type: UsCbpEntryFeeType;
  value: Scalars['UsDollars'];
};

export type UsCbpEntryFeeChargeInput = {
  type: UsCbpEntryFeeType;
  value: Scalars['UsDollars'];
};

export enum UsCbpEntryFeeType {
  AVOCADO_FEE = 'AVOCADO_FEE',
  BEEF_FEE = 'BEEF_FEE',
  BLUEBERRY_FEE = 'BLUEBERRY_FEE',
  COFFEE_IMPORTS_TO_PUERTO_RICO = 'COFFEE_IMPORTS_TO_PUERTO_RICO',
  COTTON_FEE = 'COTTON_FEE',
  DAIRY_PRODUCT_FEE = 'DAIRY_PRODUCT_FEE',
  DUTIABLE_MAIL_FEE = 'DUTIABLE_MAIL_FEE',
  FORMAL_MERCHANDISE_PROCESSING_FEE = 'FORMAL_MERCHANDISE_PROCESSING_FEE',
  HARBOR_MAINTENANCE_FEE = 'HARBOR_MAINTENANCE_FEE',
  HONEY_FEE = 'HONEY_FEE',
  INFORMAL_MERCHANDISE_PROCESSING_FEE = 'INFORMAL_MERCHANDISE_PROCESSING_FEE',
  LIME_FEE = 'LIME_FEE',
  MANGO_FEE = 'MANGO_FEE',
  MANUAL_ENTRY_SURCHARGE = 'MANUAL_ENTRY_SURCHARGE',
  MUSHROOM_FEE = 'MUSHROOM_FEE',
  PORK_FEE = 'PORK_FEE',
  POTATO_FEE = 'POTATO_FEE',
  RASPBERRY_FEE = 'RASPBERRY_FEE',
  SHEEP_FEE = 'SHEEP_FEE',
  SORGHUM_FEE = 'SORGHUM_FEE',
  SUGAR_FEE = 'SUGAR_FEE',
  WATERMELON_FEE = 'WATERMELON_FEE'
}

/** Indicates the filing timeliness of the US entry summary. */
export enum UsCbpEntryFilingTimeliness {
  ON_TIME = 'ON_TIME',
  OVER_10_DAYS_LATE = 'OVER_10_DAYS_LATE',
  OVER_30_DAYS_LATE = 'OVER_30_DAYS_LATE',
  OVER_60_DAYS_LATE = 'OVER_60_DAYS_LATE'
}

export type UsCbpEntryLineCharges = {
  __typename?: 'UsCbpEntryLineCharges';
  /** Countervailing duties owed to US CBP. */
  adDuties?: Maybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: Maybe<Scalars['UsDollars']>;
  /** Duties owed to US CBP. */
  duties?: Maybe<Scalars['UsDollars']>;
  /** List of fees and details owed to US CBP. */
  feeDetails?: Maybe<Array<FeeDetail>>;
  /** Fees owed to US CBP. */
  fees?: Maybe<Scalars['UsDollars']>;
  /** Taxes owed to US CBP. */
  taxes?: Maybe<Scalars['UsDollars']>;
};

export type UsCbpEntryLineFeeOption = {
  __typename?: 'UsCbpEntryLineFeeOption';
  disclaim?: Maybe<Scalars['Boolean']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<UsCbpEntryLineFeeType>;
};

export type UsCbpEntryLineFeeOptionInput = {
  disclaim?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<UsCbpEntryLineFeeType>;
};

export enum UsCbpEntryLineFeeType {
  AVOCADO_FEE = 'AVOCADO_FEE',
  BEEF_FEE = 'BEEF_FEE',
  BLUEBERRY_FEE = 'BLUEBERRY_FEE',
  COFFEE_IMPORTS_TO_PUERTO_RICO = 'COFFEE_IMPORTS_TO_PUERTO_RICO',
  COTTON_FEE = 'COTTON_FEE',
  DAIRY_PRODUCT_FEE = 'DAIRY_PRODUCT_FEE',
  FORMAL_MERCHANDISE_PROCESSING_FEE = 'FORMAL_MERCHANDISE_PROCESSING_FEE',
  HARBOR_MAINTENANCE_FEE = 'HARBOR_MAINTENANCE_FEE',
  HONEY_FEE = 'HONEY_FEE',
  LIME_FEE = 'LIME_FEE',
  MANGO_FEE = 'MANGO_FEE',
  MUSHROOM_FEE = 'MUSHROOM_FEE',
  PORK_FEE = 'PORK_FEE',
  POTATO_FEE = 'POTATO_FEE',
  RASPBERRY_FEE = 'RASPBERRY_FEE',
  SHEEP_FEE = 'SHEEP_FEE',
  SORGHUM_FEE = 'SORGHUM_FEE',
  SUGAR_FEE = 'SUGAR_FEE',
  WATERMELON_FEE = 'WATERMELON_FEE'
}

export enum UsCbpEntryLineRulingType {
  BINDING_RULING = 'BINDING_RULING',
  PRE_APPROVAL_NUMBER = 'PRE_APPROVAL_NUMBER',
  PRE_CLASSIFICATION_NUMBER = 'PRE_CLASSIFICATION_NUMBER'
}

export type UsCbpEntryLineTaxOption = {
  __typename?: 'UsCbpEntryLineTaxOption';
  defer?: Maybe<Scalars['Boolean']>;
  disclaim?: Maybe<Scalars['Boolean']>;
  /** Custom tax rate provided by the filer. */
  rate?: Maybe<Scalars['Float']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<UsCbpEntryTaxType>;
};

export type UsCbpEntryLineTaxOptionInput = {
  defer?: InputMaybe<Scalars['Boolean']>;
  disclaim?: InputMaybe<Scalars['Boolean']>;
  /** Custom tax rate provided by the filer. */
  rate?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<UsCbpEntryTaxType>;
};

export type UsCbpEntryLiquidatedCharges = {
  __typename?: 'UsCbpEntryLiquidatedCharges';
  /** Countervailing duties owed to US CBP. */
  adDuties?: Maybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: Maybe<Scalars['UsDollars']>;
  /** Date when entry is liquidated. */
  date?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Duties owed to US CBP. */
  duties?: Maybe<Scalars['UsDollars']>;
  /** List of fees and details owed to US CBP. */
  feeDetails?: Maybe<Array<FeeDetail>>;
  /** Fees owed to US CBP. */
  fees?: Maybe<Scalars['UsDollars']>;
  /** List of fees owed to US CBP. */
  feesList?: Maybe<Array<UsCbpEntryFeeCharge>>;
  /** Taxes owed to US CBP. */
  taxes?: Maybe<Scalars['UsDollars']>;
  /** List of taxes owed to US CBP. */
  taxesList?: Maybe<Array<UsCbpEntryTaxCharge>>;
};

export type UsCbpEntryLiquidatedChargesInput = {
  /** Countervailing duties owed to US CBP. */
  adDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Date when entry is liquidated. */
  date?: InputMaybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Duties owed to US CBP. */
  duties?: InputMaybe<Scalars['UsDollars']>;
  /** List of fees and details owed to US CBP. */
  feeDetails?: InputMaybe<Array<FeeDetailInput>>;
  /** Fees owed to US CBP. */
  fees?: InputMaybe<Scalars['UsDollars']>;
  /** List of fees owed to US CBP. */
  feesList?: InputMaybe<Array<UsCbpEntryFeeChargeInput>>;
  /** Taxes owed to US CBP. */
  taxes?: InputMaybe<Scalars['UsDollars']>;
  /** List of taxes owed to US CBP. */
  taxesList?: InputMaybe<Array<UsCbpEntryTaxChargeInput>>;
};

/** How the imported merchandise will be used. */
export enum UsCbpEntryMerchandiseUse {
  COMMERCIAL = 'COMMERCIAL',
  PERSONAL = 'PERSONAL',
  SAMPLE = 'SAMPLE'
}

/** The mode of transport for the goods being entered. */
export enum UsCbpEntryModeOfTransport {
  AIR = 'AIR',
  MAIL = 'MAIL',
  OCEAN = 'OCEAN',
  RAIL = 'RAIL',
  TRUCK = 'TRUCK'
}

/** The mode of transport for the goods being entered. */
export type UsCbpEntryModeOfTransportSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntryModeOfTransport>>;
};

/** A notification from US CBP via an ABI UC message. */
export type UsCbpEntryNotificationInput = {
  /** The CBP user who initiated the action or request. */
  cbpOfficer?: InputMaybe<UsCbpEntrySummaryNotificationOfficerInput>;
  cbpTeam?: InputMaybe<Scalars['String']>;
  /** Remarks provided by the CBP user to further explain the action or request. */
  remarks: Scalars['String'];
  type: UsCbpEntrySummaryNotificationType;
};

export type UsCbpEntryPeriodicMonthlyStatement = {
  __typename?: 'UsCbpEntryPeriodicMonthlyStatement';
  /** The time the CBP Final Periodic Monthly Statement was generated. */
  finalGeneratedTime?: Maybe<Scalars['DateTime']>;
  /** The month set by the Broker that the CBP Periodic Monthly Statement will be generated. */
  month?: Maybe<Scalars['Month']>;
  /** The CBP Periodic Monthly Statement number. */
  number?: Maybe<Scalars['String']>;
  /** The time the CBP Preliminary Periodic Monthly Statement was generated. */
  preliminaryGeneratedTime?: Maybe<Scalars['DateTime']>;
};

export type UsCbpEntryPeriodicMonthlyStatementInput = {
  /** The time the CBP Final Periodic Monthly Statement was generated. */
  finalGeneratedTime?: InputMaybe<Scalars['DateTime']>;
  /** The month set by the Broker that the CBP Periodic Monthly Statement will be generated. */
  month?: InputMaybe<Scalars['Month']>;
  /** The CBP Periodic Monthly Statement number. */
  number?: InputMaybe<Scalars['String']>;
  /** The time the CBP Preliminary Periodic Monthly Statement was generated. */
  preliminaryGeneratedTime?: InputMaybe<Scalars['DateTime']>;
};

/** Disposition code of a US CBP PGA from the latest SO ABI message. */
export type UsCbpEntryPgaDisposition = {
  __typename?: 'UsCbpEntryPgaDisposition';
  /** The Partner Government Agency code. */
  code: UsPgaCode;
  /** The PGA header status. */
  status: UsPgaHeaderStatus;
};

/** Disposition code of a US CBP PGA from the latest SO ABI message. */
export type UsCbpEntryPgaDispositionInput = {
  /** The Partner Government Agency code. */
  code: UsPgaCode;
  /** The PGA header status. */
  status: UsPgaHeaderStatus;
};

/** Disposition code of the latest US CBP Release Status (SO) ABI message. */
export type UsCbpEntryReleaseDisposition = {
  __typename?: 'UsCbpEntryReleaseDisposition';
  /** The relevent bill of lading number. */
  billNumber?: Maybe<Scalars['String']>;
  /** The release disposition code. */
  code: Scalars['String'];
};

/** Disposition code of the latest US CBP Release Status (SO) ABI message. */
export type UsCbpEntryReleaseDispositionInput = {
  /** The relevent bill of lading number. */
  billNumber?: InputMaybe<Scalars['String']>;
  /** The release disposition code. */
  code: Scalars['String'];
};

/** Indicates whether immediate delivery is enabled for the entry. */
export enum UsCbpEntryReleaseImmediateDelivery {
  ENABLED = 'ENABLED',
  NOT_ENABLED = 'NOT_ENABLED'
}

/** Indicates whether immediate delivery is enabled for the entry. */
export type UsCbpEntryReleaseImmediateDeliverySearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntryReleaseImmediateDelivery>>;
};

/** Error details of the latest US CBP Entry Release (SE) rejection. */
export type UsCbpEntryReleaseRejectionReason = {
  __typename?: 'UsCbpEntryReleaseRejectionReason';
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Error details of the latest US CBP Entry Release (SE) rejection. */
export type UsCbpEntryReleaseRejectionReasonInput = {
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Status of the Entry Release (SE) filing with CBP. */
export enum UsCbpEntryReleaseStatus {
  DELETED = 'DELETED',
  EXAMINED = 'EXAMINED',
  FILED = 'FILED',
  HELD = 'HELD',
  REJECTED = 'REJECTED',
  RELEASED = 'RELEASED',
  SUBMITTED = 'SUBMITTED'
}

/** Status of the Entry Release (SE) filing with CBP. */
export type UsCbpEntryReleaseStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntryReleaseStatus>>;
};

/** A notification from US CBP via an ABI UC message. */
export type UsCbpEntrySummaryNotification = {
  __typename?: 'UsCbpEntrySummaryNotification';
  /** The CBP user who initiated the action or request. */
  cbpOfficer?: Maybe<UsCbpEntrySummaryNotificationOfficer>;
  cbpTeam?: Maybe<Scalars['String']>;
  /** Remarks provided by the CBP user to further explain the action or request. */
  remarks: Scalars['String'];
  type: UsCbpEntrySummaryNotificationType;
};

/** The CBP user who initiated the action or request. */
export type UsCbpEntrySummaryNotificationOfficer = {
  __typename?: 'UsCbpEntrySummaryNotificationOfficer';
  name: Scalars['String'];
};

/** The CBP user who initiated the action or request. */
export type UsCbpEntrySummaryNotificationOfficerInput = {
  name: Scalars['String'];
};

/** A notification from US CBP via an ABI UC message. */
export type UsCbpEntrySummaryNotificationSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntrySummaryNotificationType>>;
};

/** The type of notification received from US CBP via an ABI UC message. */
export enum UsCbpEntrySummaryNotificationType {
  ACE_ENTRY_SUMMARY_INACTIVATED = 'ACE_ENTRY_SUMMARY_INACTIVATED',
  DETENTION_CANCELED = 'DETENTION_CANCELED',
  DOCUMENT_RECEIPT_ACKNOWLEDGEMENT = 'DOCUMENT_RECEIPT_ACKNOWLEDGEMENT',
  ENTRY_DETAINED = 'ENTRY_DETAINED',
  ENTRY_SUMMARY_CANCELED = 'ENTRY_SUMMARY_CANCELED',
  ENTRY_SUMMARY_REJECTED = 'ENTRY_SUMMARY_REJECTED',
  PGA_PROCESSING_STATUS_INFORMATION = 'PGA_PROCESSING_STATUS_INFORMATION',
  PSC_PRESENTED_BY_ANOTHER_FILER = 'PSC_PRESENTED_BY_ANOTHER_FILER',
  PSC_REVERTED = 'PSC_REVERTED',
  QUOTA_ACCEPTED = 'QUOTA_ACCEPTED',
  REQUEST_FOR_ELECTRONIC_INVOICE_DATA_ONLY = 'REQUEST_FOR_ELECTRONIC_INVOICE_DATA_ONLY',
  REQUEST_FOR_ENTRY_SUMMARY_PACKAGE = 'REQUEST_FOR_ENTRY_SUMMARY_PACKAGE',
  REQUEST_FOR_SPECIFIC_DOCUMENTS = 'REQUEST_FOR_SPECIFIC_DOCUMENTS',
  TIB_EXTENSION_DENIED = 'TIB_EXTENSION_DENIED'
}

/** Error details of the latest US CBP Entry Summary (AE) rejection. */
export type UsCbpEntrySummaryRejectionReason = {
  __typename?: 'UsCbpEntrySummaryRejectionReason';
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Error details of the latest US CBP Entry Summary (AE) rejection. */
export type UsCbpEntrySummaryRejectionReasonInput = {
  /** The code of the rejection error. */
  code: Scalars['String'];
  /** The name of the rejection error. */
  name: Scalars['String'];
};

/** Status of the Entry Summary (AE) filing with CBP. */
export enum UsCbpEntrySummaryStatus {
  DELETED = 'DELETED',
  FILED = 'FILED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

/** Status of the Entry Summary (AE) filing with CBP. */
export type UsCbpEntrySummaryStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsCbpEntrySummaryStatus>>;
};

export type UsCbpEntryTariffCharges = {
  __typename?: 'UsCbpEntryTariffCharges';
  /** Countervailing duties owed to US CBP. */
  adDuties?: Maybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: Maybe<Scalars['UsDollars']>;
  /** Duties owed to US CBP. */
  duties?: Maybe<Scalars['UsDollars']>;
  /** Rate for duty */
  dutydisplay: Scalars['String'];
  /** List of fees and details owed to US CBP. */
  feeDetails?: Maybe<Array<FeeDetail>>;
  /** Fees owed to US CBP. */
  fees?: Maybe<Scalars['UsDollars']>;
  /** Taxes owed to US CBP. */
  taxes?: Maybe<Scalars['UsDollars']>;
};

export type UsCbpEntryTariffChargesInput = {
  /** Countervailing duties owed to US CBP. */
  adDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Duties owed to US CBP. */
  duties?: InputMaybe<Scalars['UsDollars']>;
  /** Rate for duty */
  dutydisplay: Scalars['String'];
  /** List of fees and details owed to US CBP. */
  feeDetails?: InputMaybe<Array<FeeDetailInput>>;
  /** Fees owed to US CBP. */
  fees?: InputMaybe<Scalars['UsDollars']>;
  /** Taxes owed to US CBP. */
  taxes?: InputMaybe<Scalars['UsDollars']>;
};

export type UsCbpEntryTaxCharge = {
  __typename?: 'UsCbpEntryTaxCharge';
  type: UsCbpEntryTaxType;
  value: Scalars['UsDollars'];
};

export type UsCbpEntryTaxChargeInput = {
  type: UsCbpEntryTaxType;
  value: Scalars['UsDollars'];
};

export enum UsCbpEntryTaxType {
  DISTILLED_SPIRIT_TAX = 'DISTILLED_SPIRIT_TAX',
  OTHER_TAX = 'OTHER_TAX',
  TOBACCO_TAX = 'TOBACCO_TAX',
  WINE_TAX = 'WINE_TAX'
}

export type UsCbpEntryTypeCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsCbpEntryTypeCode']>>;
};

/** A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes */
export type UsCbpFilerCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsCbpFilerCode']>>;
};

export type UsCbpForeignPortCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsCbpForeignPortCode']>>;
};

/** The code for a US CBP Importer Program. */
export enum UsCbpImporterProgramCode {
  AEO = 'AEO',
  CTPAT = 'CTPAT',
  ISA = 'ISA',
  PIP = 'PIP'
}

export type UsCbpLineChargesInput = {
  /** Countervailing duties owed to US CBP. */
  adDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Countervailing duties owed to US CBP. */
  cvDuties?: InputMaybe<Scalars['UsDollars']>;
  /** Duties owed to US CBP. */
  duties?: InputMaybe<Scalars['UsDollars']>;
  /** List of fees and details owed to US CBP. */
  feeDetails?: InputMaybe<Array<FeeDetailInput>>;
  /** Fees owed to US CBP. */
  fees?: InputMaybe<Scalars['UsDollars']>;
  /** Taxes owed to US CBP. */
  taxes?: InputMaybe<Scalars['UsDollars']>;
};

export type UsCbpMidSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsCbpMid']>>;
};

export type UsCbpPortCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsCbpPortCode']>>;
};

/** Indicates how to release split shipments. */
export enum UsCbpSplitShipmentReleaseMethod {
  HOLD_ALL = 'HOLD_ALL',
  INCREMENTAL = 'INCREMENTAL'
}

export type UsComplianceDetailsInput = {
  /** True if this product disclaims an AD case */
  adDisclaimed?: InputMaybe<Scalars['Boolean']>;
  /** True if this product disclaims an CV case */
  cvDisclaimed?: InputMaybe<Scalars['Boolean']>;
  /** All fees disclaimed */
  disclaimAllFees?: InputMaybe<Scalars['Boolean']>;
  /** All taxes disclaimed */
  disclaimAllTaxes?: InputMaybe<Scalars['Boolean']>;
  /** Disclaimed fees */
  disclaimedFees?: InputMaybe<Array<UsCbpEntryLineFeeType>>;
  /** Disclaimed taxes */
  disclaimedTaxes?: InputMaybe<Array<UsCbpEntryTaxType>>;
  /** HTS numbers associated with line */
  htsNumbers: Array<Scalars['HtsNumber']>;
  /** The origin country code */
  originCountryCode: Scalars['CountryCode'];
  /** Value per unit of product */
  unitValue: CostInput;
};

export type UsConsignee = Consignee & Party & Record & {
  __typename?: 'UsConsignee';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: Maybe<UsCbp5106BankDetails>;
  /** A description of the Importer's business */
  businessDescription?: Maybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: Maybe<UsBusinessStructure>;
  /** Error details of the latest US CBP 5106 rejection. */
  cbp5106RejectionReasons?: Maybe<Array<UsCbp5106RejectedReason>>;
  /** The mailing address type. */
  cbpMailingAddressType?: Maybe<UsCbp5106AddressType>;
  /** If an IOR number is requested from CBP, set it to true */
  cbpNumberHelp?: Maybe<Scalars['Boolean']>;
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons?: Maybe<Array<UsIorCbpAssignedNumberReason>>;
  /** The physical address type. */
  cbpPhysicalAddressType?: Maybe<UsCbp5106AddressType>;
  /** The US IOR's status with CBP. */
  cbpStatus?: Maybe<UsIorCbpStatus>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The documents associated with the US Consignee. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: Maybe<UsCbp5106EntriesPerYearCode>;
  /** Business establishment details on the Importer's US CBP 5106 form. */
  establishment?: Maybe<UsCbp5106EstablishmentDetails>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: Maybe<Array<UsCbp5106Individual>>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<UsIorNumber>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: Maybe<Scalars['String']>;
  /** Party name */
  name: Scalars['String'];
  /** An officer of the company authorized to assign power of attorney. */
  officer?: Maybe<PointOfContact>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: Maybe<Array<UsCbpImporterProgramCode>>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: Maybe<Array<UsCbp5106RelatedBusiness>>;
  /** A Shipper linked to this US Consignee */
  shipper: ShipperUsConsigneeRelationship;
  /** Shipper connection used to paginate results. */
  shippers: UsConsigneeShippersConnection;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: Maybe<Scalars['Boolean']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsConsigneedocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsConsigneememosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsConsigneeshipperArgs = {
  shipperId: Scalars['ID'];
};


export type UsConsigneeshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

/** The transaction representing a US Consignee realted request and response to US CBP via ABI. */
export type UsConsigneeCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usConsignee: UsConsignee;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsConsigneeEdge = ConnectionEdge & {
  __typename?: 'UsConsigneeEdge';
  cursor: Scalars['ID'];
  node: UsConsignee;
};

export type UsConsigneeSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Importer of Record ID for the Consignee. */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Importer of Record for the Consignee. */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The IOR Number. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

export type UsConsigneeSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'UsConsigneeSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Importer of Record Id for the Consignee. */
  iorId?: Maybe<Array<Scalars['String']>>;
  /** The Importer of Record for the Consignee. */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** The IOR Number. */
  iorNumber?: Maybe<Scalars['UsIorNumberValue']>;
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UsConsigneeShipperEdge = ConnectionEdge & {
  __typename?: 'UsConsigneeShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and US Consignee. */
  relationship: ShipperUsConsigneeRelationship;
};

export type UsConsigneeShippersConnection = Connection & {
  __typename?: 'UsConsigneeShippersConnection';
  edges: Array<UsConsigneeShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsConsigneesConnection = Connection & {
  __typename?: 'UsConsigneesConnection';
  edges: Array<UsConsigneeEdge>;
  nodes: Array<UsConsignee>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsConsumptionEntriesConnection = Connection & {
  __typename?: 'UsConsumptionEntriesConnection';
  edges: Array<UsConsumptionEntryEdge>;
  nodes: Array<UsConsumptionEntry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsConsumptionEntry = Record & WorkOrder & {
  __typename?: 'UsConsumptionEntry';
  /** Accelerate the liquidation of the entry. */
  acceleratedLiquidation?: Maybe<Scalars['Boolean']>;
  /** The reason for amending the entry. */
  amendmentReason?: Maybe<UsConsumptionEntryAmendmentReason>;
  /** Arrival information */
  arrival?: Maybe<UsConsumptionEntryArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<UsConsumptionEntryBadge>>;
  /** US Customs Broker associated with this entry. */
  broker: UsConsumptionEntryBroker;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** US Buyer associated with this entry. */
  buyer?: Maybe<UsConsumptionEntryBuyer>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** Provided reason for canceling the entry with CBP. */
  cbpCancellationReason?: Maybe<DeleteUsCbpEntryReleaseReason>;
  cbpCharges?: Maybe<UsCbpEntryCharges>;
  cbpLiquidatedCharges?: Maybe<UsCbpEntryLiquidatedCharges>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: Maybe<Scalars['String']>;
  /** Indicates census warning status of the US entry summary. */
  censusHeaderStatus?: Maybe<UsCbpEntryCensusHeaderStatusCode>;
  /** CBP collection date */
  collectionDate?: Maybe<Scalars['String']>;
  /** CBP collection status */
  collectionStatus?: Maybe<Scalars['String']>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** US Consignee associated with this entry. */
  consignee?: Maybe<UsConsumptionEntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Indicates the control status of the US entry summary. */
  controlStatus?: Maybe<UsCbpEntryControlStatusCode>;
  /** Conveyance information. */
  conveyance: UsConsumptionEntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** CBP entry Daily Statement. */
  dailyStatement?: Maybe<UsCbpEntryDailyStatement>;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<UsConsumptionEntryDeparture>;
  /** The documents associated with the US Consumption Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['UsCbpEntryTypeCode']>;
  /** Exam details associated with the entry. */
  exam?: Maybe<UsConsumptionEntryExam>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Indicates the filing timeliness of the US entry summary. */
  filingTimeliness?: Maybe<UsCbpEntryFilingTimeliness>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** Indicates whether immediate delivery is enabled for the entry. */
  immediateDeliveryIndicator?: Maybe<UsCbpEntryReleaseImmediateDelivery>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<UsConsumptionEntryCommercialInvoice>>;
  /** Commercial invoices provided in form of reference, employed for invoices with an extensive array of product lines */
  invoicesReference?: Maybe<UsConsumptionEntryCommercialInvoicesReference>;
  /** US IOR associated with this entry. */
  ior?: Maybe<UsConsumptionEntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Flag to determine if CBMS authorized payment within 10 business days of most recent cargo release date */
  isTimelyPayment?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<UsConsumptionEntryMasterBill>>;
  /** How the imported merchandise will be used. */
  merchandiseUse?: Maybe<UsCbpEntryMerchandiseUse>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** CBP entry payment type */
  paymentType?: Maybe<Scalars['UsCbpEntryPaymentType']>;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** CBP entry Periodic Monthly Statement. */
  periodicMonthlyStatement?: Maybe<UsCbpEntryPeriodicMonthlyStatement>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDispositions?: Maybe<Array<UsCbpEntryPgaDisposition>>;
  /** The placement type for UsConsumptionEntry */
  placementType?: Maybe<PlacementType>;
  /** Purchase order (PO) number(s) associated with the work order. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** Date by which other regulatory clearances are completed. For example, FCC for Devices shipments. This impacts the work order deadline and entry submission. */
  regulatoryReadyDate?: Maybe<Scalars['DateTime']>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: Maybe<Scalars['Date']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDispositions?: Maybe<Array<UsCbpEntryReleaseDisposition>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReasons?: Maybe<Array<UsCbpEntryReleaseRejectionReason>>;
  /** Replacement number associated with delete release from cbp */
  releaseReplacementNumber?: Maybe<Scalars['String']>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: Maybe<UsCbpEntryReleaseStatus>;
  /** US Entry single transaction bond details. */
  singleTransactionBond?: Maybe<UsEntrySingleTransactionBond>;
  /** Indicates how to release split shipments. */
  splitShipmentReleaseMethod?: Maybe<UsCbpSplitShipmentReleaseMethod>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotification?: Maybe<UsCbpEntrySummaryNotification>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReasons?: Maybe<Array<UsCbpEntrySummaryRejectionReason>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: Maybe<UsCbpEntrySummaryStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to US CBP. */
  totalAssist?: Maybe<Scalars['UsDollars']>;
  /** Sum of all invoice product lines count, useful in task estimation. */
  totalInvoiceLineCount?: Maybe<Scalars['Int']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: Maybe<Scalars['UsDollars']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsConsumptionEntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** The reason for amending the entry. */
export enum UsConsumptionEntryAmendmentReason {
  HTS_NOT_PROVIDED_AND_CLIENT_DISAGREED_WITH_BROKER_CLASSIFICATION = 'HTS_NOT_PROVIDED_AND_CLIENT_DISAGREED_WITH_BROKER_CLASSIFICATION',
  HTS_PROVIDED_AND_CLIENT_DISAGREED_AFTER_REVIEWING_ENTRY_SUMMARY = 'HTS_PROVIDED_AND_CLIENT_DISAGREED_AFTER_REVIEWING_ENTRY_SUMMARY',
  INCORRECT_DOCUMENTATION = 'INCORRECT_DOCUMENTATION',
  INCORRECT_PIECE_COUNT_ENTERED = 'INCORRECT_PIECE_COUNT_ENTERED',
  MISSING_COMMERCIAL_INVOICE = 'MISSING_COMMERCIAL_INVOICE',
  OTHER_CLERICAL_ERROR = 'OTHER_CLERICAL_ERROR',
  TAKING_ENTRY_OFF_STATEMENT = 'TAKING_ENTRY_OFF_STATEMENT'
}

export type UsConsumptionEntryArrival = {
  __typename?: 'UsConsumptionEntryArrival';
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: Maybe<Scalars['FirmsCode']>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** A General Order number. */
  goNumber?: Maybe<Scalars['String']>;
  /** The date the shipment physically arrives in the US. */
  importDate?: Maybe<Scalars['Date']>;
  /** Data relating to an IT In-Bond movement for the shipment */
  inBond?: Maybe<UsConsumptionEntryInBondInfo>;
  /** The shipment's US port of unlading. */
  portOfUnladingCode?: Maybe<Scalars['UsCbpPortCode']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: Maybe<Scalars['FirmsCode']>;
  /** The US 2-letter state code of the shipment's final destination. */
  usDestinationStateCode?: Maybe<Scalars['UsStateCode']>;
};

export type UsConsumptionEntryArrivalInput = {
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: InputMaybe<Scalars['FirmsCode']>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** A General Order number. */
  goNumber?: InputMaybe<Scalars['String']>;
  /** The date the shipment physically arrives in the US. */
  importDate?: InputMaybe<Scalars['Date']>;
  /** Data relating to an IT In-Bond movement for the shipment */
  inBond?: InputMaybe<UsConsumptionEntryInBondInfoInput>;
  /** The shipment's US port of unlading. */
  portOfUnladingCode?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: InputMaybe<Scalars['FirmsCode']>;
  /** The US 2-letter state code of the shipment's final destination. */
  usDestinationStateCode?: InputMaybe<Scalars['UsStateCode']>;
};

/** The Us Consumption Entry badge. Example: Hot */
export enum UsConsumptionEntryBadge {
  BIXD = 'BIXD',
  CBAM = 'CBAM',
  DG = 'DG',
  HOT = 'HOT',
  MULTIVAT = 'MULTIVAT',
  PREMIUM = 'PREMIUM',
  REFILE = 'REFILE'
}

/** The Us Consumption Entry badge. Example: Hot */
export type UsConsumptionEntryBadgeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsConsumptionEntryBadge>>;
};

export type UsConsumptionEntryBroker = {
  __typename?: 'UsConsumptionEntryBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsConsumptionEntryPointOfContact>;
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsConsumptionEntryBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsConsumptionEntryPointOfContactInput>;
  /** US Customs Broker */
  usCustomsBroker: IdInput;
};

export type UsConsumptionEntryBuyer = {
  __typename?: 'UsConsumptionEntryBuyer';
  /** Party address */
  address?: Maybe<Address>;
  /** buyer party info */
  buyer?: Maybe<Facility>;
  /** Buyer DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Buyer Employer Identification Number */
  ein?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsConsumptionEntryPointOfContact>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** If the Buyer DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
};

export type UsConsumptionEntryBuyerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id and version input of buyer */
  buyer?: InputMaybe<IdVersionInput>;
  /** Buyer DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Buyer Employer Identification Number */
  ein?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsConsumptionEntryPointOfContactInput>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** If the Buyer DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

/** The transaction representing a US Consumption Entry realted request and response to US CBP via ABI. */
export type UsConsumptionEntryCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsConsumptionEntryCensusWarning = BaseEntryWarning & {
  __typename?: 'UsConsumptionEntryCensusWarning';
  /** The override codes apply to the census warning condition */
  overrideCode?: Maybe<CensusOverrideCode>;
  /** The warning code from CBP */
  warningCode?: Maybe<WarningCode>;
  /** The source of warnings */
  warningSource?: Maybe<WarningSource>;
  /** The status of warning from CBP */
  warningStatus?: Maybe<WarningStatus>;
};

export type UsConsumptionEntryCensusWarningInput = {
  /** The override codes apply to the census warning condition */
  overrideCode?: InputMaybe<CensusOverrideCode>;
  /** The warning code from CBP */
  warningCode?: InputMaybe<WarningCode>;
  /** The source of warnings */
  warningSource?: InputMaybe<WarningSourceInput>;
  /** The status of warning from CBP */
  warningStatus?: InputMaybe<WarningStatus>;
};

export type UsConsumptionEntryCommercialInvoice = {
  __typename?: 'UsConsumptionEntryCommercialInvoice';
  /** A pro-rated adjustment to the Commercial Invoice line item values. */
  adjustments?: Maybe<Array<UsConsumptionEntryCommercialInvoiceAdjustment>>;
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<UsConsumptionEntryProduct>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<UsConsumptionEntrySupplier>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

/** A pro-rated adjustment to the Commercial Invoice line item values. */
export type UsConsumptionEntryCommercialInvoiceAdjustment = {
  __typename?: 'UsConsumptionEntryCommercialInvoiceAdjustment';
  /** The reason for the adjustment. */
  description: Scalars['String'];
  /** The type of commercial invoice adjustment. */
  type: UsConsumptionEntryCommercialInvoiceAdjustmentType;
  /** The amount of the adjustment. */
  value: Cost;
};

/** A pro-rated adjustment to the Commercial Invoice line item values. */
export type UsConsumptionEntryCommercialInvoiceAdjustmentInput = {
  /** The reason for the adjustment. */
  description: Scalars['String'];
  /** The type of commercial invoice adjustment. */
  type: UsConsumptionEntryCommercialInvoiceAdjustmentType;
  /** The amount of the adjustment. */
  value: CostInput;
};

/** The type of U.S. entry commercial invoice adjustment. */
export enum UsConsumptionEntryCommercialInvoiceAdjustmentType {
  ADD = 'ADD',
  SUBTRACT = 'SUBTRACT'
}

export type UsConsumptionEntryCommercialInvoiceInput = {
  /** A pro-rated adjustment to the Commercial Invoice line item values. */
  adjustments?: InputMaybe<Array<UsConsumptionEntryCommercialInvoiceAdjustmentInput>>;
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<UsConsumptionEntryProductInput>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<UsConsumptionEntrySupplierInput>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type UsConsumptionEntryCommercialInvoicesReference = {
  __typename?: 'UsConsumptionEntryCommercialInvoicesReference';
  /** Invoices S3 Link to download invoices from */
  downloadLink: Scalars['String'];
  /** Invoices S3 Reference/path */
  referenceKey: Scalars['String'];
};

export type UsConsumptionEntryCommercialInvoicesReferenceInput = {
  /** Invoices S3 Reference/path */
  referenceKey: Scalars['String'];
};

/** The usConsumptionEntry confirmation transaction type */
export enum UsConsumptionEntryConfirmationTransactionType {
  REPLACE_US_CONSUMPTION_ENTRY_RELEASE_CBP = 'REPLACE_US_CONSUMPTION_ENTRY_RELEASE_CBP',
  UPDATE_US_CONSUMPTION_ENTRY_PGA_CBP = 'UPDATE_US_CONSUMPTION_ENTRY_PGA_CBP',
  UPDATE_US_CONSUMPTION_ENTRY_RELEASE_CBP = 'UPDATE_US_CONSUMPTION_ENTRY_RELEASE_CBP',
  UPSERT_US_CONSUMPTION_ENTRY_SUMMARY_CBP = 'UPSERT_US_CONSUMPTION_ENTRY_SUMMARY_CBP'
}

export type UsConsumptionEntryConsignee = {
  __typename?: 'UsConsumptionEntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsConsumptionEntryPointOfContact>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** TRUE if the DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
  /** UsConsignee details */
  usConsignee?: Maybe<UsConsignee>;
};

export type UsConsumptionEntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsConsumptionEntryPointOfContactInput>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** TRUE if the DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
  /** Id version of the Consignee */
  usConsignee?: InputMaybe<IdVersionInput>;
};

export type UsConsumptionEntryConveyance = {
  __typename?: 'UsConsumptionEntryConveyance';
  /** Whether the goods are containerized. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: UsCbpEntryModeOfTransport;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
};

export type UsConsumptionEntryConveyanceInput = {
  /** Whether the goods are containerized. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: UsCbpEntryModeOfTransport;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type UsConsumptionEntryDeparture = {
  __typename?: 'UsConsumptionEntryDeparture';
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['Date']>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingCode?: Maybe<Scalars['UsCbpForeignPortCode']>;
};

export type UsConsumptionEntryDepartureInput = {
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<Scalars['Date']>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingCode?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
};

export type UsConsumptionEntryDii = {
  __typename?: 'UsConsumptionEntryDii';
  /** Customs agent address */
  address?: Maybe<Address>;
  /** The customs agent record */
  customsAgent?: Maybe<CustomsAgent>;
  /** Customs agent name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
};

export type UsConsumptionEntryDiiInput = {
  /** Customs agent address */
  address?: InputMaybe<AddressInput>;
  /** The customs agent record */
  customsAgent?: InputMaybe<IdVersionInput>;
  /** Customs agent name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
};

export type UsConsumptionEntryDisTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usConsumptionEntry: UsConsumptionEntry;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsConsumptionEntryEdge = ConnectionEdge & {
  __typename?: 'UsConsumptionEntryEdge';
  cursor: Scalars['ID'];
  node: UsConsumptionEntry;
};

export type UsConsumptionEntryExam = {
  __typename?: 'UsConsumptionEntryExam';
  /** Containers associated with the exam. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Last date the LSP was notified on. */
  lspNotifiedDate?: Maybe<Scalars['Date']>;
  /** Firms code associated with the exam site. */
  site?: Maybe<Scalars['FirmsCode']>;
  /** The status of the exam being conducted on the entry. */
  status?: Maybe<UsCbpEntryExamStatus>;
  /** The specific type of exam conducted on the entry. */
  subType?: Maybe<UsCbpEntryExamSubType>;
  /** The type of the exam conducted on the entry. */
  type?: Maybe<UsCbpEntryExamType>;
};

export type UsConsumptionEntryExamInput = {
  /** Containers associated with the exam. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Last date the LSP was notified on. */
  lspNotifiedDate?: InputMaybe<Scalars['Date']>;
  /** Firms code associated with the exam site. */
  site?: InputMaybe<Scalars['FirmsCode']>;
  /** The status of the exam being conducted on the entry. */
  status?: InputMaybe<UsCbpEntryExamStatus>;
  /** The specific type of exam conducted on the entry. */
  subType?: InputMaybe<UsCbpEntryExamSubType>;
  /** The type of the exam conducted on the entry. */
  type?: InputMaybe<UsCbpEntryExamType>;
};

export type UsConsumptionEntryFacility = {
  __typename?: 'UsConsumptionEntryFacility';
  /** Party address */
  address?: Maybe<Address>;
  /** The Facility record. */
  facility?: Maybe<Facility>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsConsumptionEntryPointOfContact>;
};

export type UsConsumptionEntryFacilityInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** The Facility record. */
  facility?: InputMaybe<IdVersionInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsConsumptionEntryPointOfContactInput>;
};

export type UsConsumptionEntryFsvp = {
  __typename?: 'UsConsumptionEntryFsvp';
  /** Customs agent address */
  address?: Maybe<Address>;
  /** The customs agent record */
  customsAgent?: Maybe<CustomsAgent>;
  /** Customs agent DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Customs agent name */
  name?: Maybe<Scalars['String']>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** If the customs agent DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
};

export type UsConsumptionEntryFsvpInput = {
  /** Customs agent address */
  address?: InputMaybe<AddressInput>;
  /** The customs agent record */
  customsAgent?: InputMaybe<IdVersionInput>;
  /** Customs agent DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Customs agent name */
  name?: InputMaybe<Scalars['String']>;
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** If the customs agent DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

export type UsConsumptionEntryHouseBill = {
  __typename?: 'UsConsumptionEntryHouseBill';
  /** In-bond number associated w/ the bill. */
  inBondNumber?: Maybe<Scalars['String']>;
  /** Indicates that the bill number is not in AMS. */
  nonAMS?: Maybe<Scalars['Boolean']>;
  /** House Bill number */
  number?: Maybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: Maybe<Scalars['Int']>;
};

export type UsConsumptionEntryHouseBillInput = {
  /** In-bond number associated w/ the bill. */
  inBondNumber?: InputMaybe<Scalars['String']>;
  /** Indicates that the bill number is not in AMS. */
  nonAMS?: InputMaybe<Scalars['Boolean']>;
  /** House Bill number */
  number?: InputMaybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: InputMaybe<Scalars['Int']>;
};

/** IT In-bond data for a shipment. */
export type UsConsumptionEntryInBondInfo = {
  __typename?: 'UsConsumptionEntryInBondInfo';
  /** The estimated (or actual) entry date. */
  estimatedEntryDate?: Maybe<Scalars['Date']>;
  /** The date that the in-bond associated with the shipment initiated. */
  initiationDate?: Maybe<Scalars['Date']>;
  /** The shipment's US port of entry. */
  portOfEntryCode?: Maybe<Scalars['UsCbpPortCode']>;
};

/** IT In-bond data for a shipment. */
export type UsConsumptionEntryInBondInfoInput = {
  /** The estimated (or actual) entry date. */
  estimatedEntryDate?: InputMaybe<Scalars['Date']>;
  /** The date that the in-bond associated with the shipment initiated. */
  initiationDate?: InputMaybe<Scalars['Date']>;
  /** The shipment's US port of entry. */
  portOfEntryCode?: InputMaybe<Scalars['UsCbpPortCode']>;
};

/** Milestone name which triggers UsConsumptionEntry invoice. */
export enum UsConsumptionEntryInvoiceTriggerMilestoneName {
  CARGO_RELEASE = 'CARGO_RELEASE',
  ENTRY_FILED = 'ENTRY_FILED'
}

export type UsConsumptionEntryIor = {
  __typename?: 'UsConsumptionEntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber?: Maybe<Scalars['UsCbpPayerUnitNumber']>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: Maybe<UsIorPmsStatus>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsConsumptionEntryPointOfContact>;
  /** The US IORs preferred payment method on an entry */
  preferredPaymentMethod?: Maybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** TRUE if the DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
  /** UsIor details */
  usIor: UsIor;
};

export type UsConsumptionEntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber?: InputMaybe<Scalars['UsCbpPayerUnitNumber']>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: InputMaybe<UsIorPmsStatus>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsConsumptionEntryPointOfContactInput>;
  /** The US IORs preferred payment method on an entry */
  preferredPaymentMethod?: InputMaybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** TRUE if the DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
  /** Id version of the IOR */
  usIor: IdVersionInput;
};

export type UsConsumptionEntryLine = {
  __typename?: 'UsConsumptionEntryLine';
  /** The Anti-Dumping Case record. */
  adCase?: Maybe<AdCvdCase>;
  /** The Anti-Dumping Case record. */
  adCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: Maybe<Cost>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: Maybe<UsAluminumRequirements>;
  /** The dollar assist of the line item reported to US CBP. */
  assist?: Maybe<Scalars['UsDollars']>;
  cbpCharges?: Maybe<UsCbpEntryLineCharges>;
  /** The census warnings from CBP */
  censusWarnings?: Maybe<Array<UsConsumptionEntryCensusWarning>>;
  /** The Countervailing Case record. */
  cvCase?: Maybe<AdCvdCase>;
  /** The Countervailing Case record. */
  cvCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: Maybe<Cost>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: Maybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: Maybe<Scalars['Boolean']>;
  /** Additional tariff duty rate for EU C/O */
  euAdditionalDutyRate?: Maybe<Scalars['Float']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  feeOptions?: Maybe<Array<UsCbpEntryLineFeeOption>>;
  /** Importer has Non-Reimbursement Certificate on file with CBP */
  isNrbsOnFile?: Maybe<Scalars['Boolean']>;
  /** The license code. */
  licenseCode?: Maybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: Maybe<Scalars['String']>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<UsConsumptionEntrySupplier>;
  /** Record number of Non-Reimbursement Certificate on file with CBP */
  nrbsRecordNumber?: Maybe<Scalars['UsNrbsRecordNumber']>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** The purchase order (PO) number of the line item */
  poNumber?: Maybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: Maybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: Maybe<UsProductEntryLineRuling>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: Maybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: Maybe<UsSteelRequirements>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<UsConsumptionEntryTariff>>;
  taxOptions?: Maybe<Array<UsCbpEntryLineTaxOption>>;
  /** The dollar value of the line item reported to US CBP. */
  value?: Maybe<Scalars['UsDollars']>;
};

export type UsConsumptionEntryLineInput = {
  /** The Anti-Dumping Case record. */
  adCase?: InputMaybe<IdInput>;
  /** The Anti-Dumping Case record. */
  adCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: InputMaybe<CostInput>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: InputMaybe<UsAluminumRequirementsInput>;
  /** The dollar assist of the line item reported to US CBP. */
  assist?: InputMaybe<Scalars['UsDollars']>;
  cbpCharges?: InputMaybe<UsCbpLineChargesInput>;
  /** The census warnings from CBP */
  censusWarnings?: InputMaybe<Array<UsConsumptionEntryCensusWarningInput>>;
  /** The Countervailing Case record. */
  cvCase?: InputMaybe<IdInput>;
  /** The Countervailing Case record. */
  cvCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: InputMaybe<CostInput>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: InputMaybe<Scalars['Boolean']>;
  /** Additional tariff duty rate for EU C/O */
  euAdditionalDutyRate?: InputMaybe<Scalars['Float']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  feeOptions?: InputMaybe<Array<UsCbpEntryLineFeeOptionInput>>;
  /** Importer has Non-Reimbursement Certificate on file with CBP */
  isNrbsOnFile?: InputMaybe<Scalars['Boolean']>;
  /** The license code. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<UsConsumptionEntrySupplierInput>;
  /** Record number of Non-Reimbursement Certificate on file with CBP */
  nrbsRecordNumber?: InputMaybe<Scalars['UsNrbsRecordNumber']>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** The purchase order (PO) number of the line item */
  poNumber?: InputMaybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: InputMaybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: InputMaybe<UsProductEntryLineRulingInput>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: InputMaybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: InputMaybe<UsSteelRequirementsInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<UsConsumptionEntryTariffInput>>;
  taxOptions?: InputMaybe<Array<UsCbpEntryLineTaxOptionInput>>;
  /** The dollar value of the line item reported to US CBP. */
  value?: InputMaybe<Scalars['UsDollars']>;
};

export type UsConsumptionEntryMasterBill = {
  __typename?: 'UsConsumptionEntryMasterBill';
  /** Array of house bills */
  houseBills?: Maybe<Array<UsConsumptionEntryHouseBill>>;
  /** Master Bill number */
  number?: Maybe<Scalars['String']>;
};

export type UsConsumptionEntryMasterBillInput = {
  /** Array of house bills */
  houseBills?: InputMaybe<Array<UsConsumptionEntryHouseBillInput>>;
  /** Master Bill number */
  number?: InputMaybe<Scalars['String']>;
};

/** Data requirements reported to a US CBP Partner Government Agency. */
export type UsConsumptionEntryPga = {
  __typename?: 'UsConsumptionEntryPga';
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: Maybe<Scalars['String']>;
  /** A distinct and legible mark, properly applied with a freeze brand, hot iron, or other method, and easily visible on the live animal and on the carcass before skinning. Used by APHIS. */
  animalBrand?: Maybe<Scalars['String']>;
  /** Number that characterizes the commercial product or component. Used by: APHIS */
  aphProductCode?: Maybe<Scalars['String']>;
  /** APHIS VS 17-32. Application for Inspection and Dipping. */
  applicationForInspectionAndDipping?: Maybe<Lpco>;
  /** Category code for weapons. Used by: ATF */
  atfCategory?: Maybe<Scalars['AtfCategoryCode']>;
  /** A permit that authorizes the importation of firearms, ammunitions, and implements of war into the United States or any possession thereof, except for certain exempt importations presecribed in 27 CFR parts 447, 478 and 479. Used by: ATF */
  atfImportPermit?: Maybe<Lpco>;
  /** Registered importers of firearms, ammunition firearms parts or implements of war other, than sporting shotguns, shotgun shells, or shotgun parts, must also register under the Arms Export Control Act of 1976. Used by: ATF */
  atfImporterRegistration?: Maybe<Lpco>;
  /** Identification method often used on aves (birds). Used by APHIS. */
  band?: Maybe<Scalars['String']>;
  /** Cut Flowers Bouquet Grouping Code. Used by APHIS. */
  bouquetGroupingCode?: Maybe<Scalars['String']>;
  /** APHIS BRS Acknowledgement letter */
  brsAcknowledgementLetter?: Maybe<Lpco>;
  /** APHIS BRS Notification. */
  brsNotification?: Maybe<Lpco>;
  /** Chemical Abstract Service Number. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  casNumber?: Maybe<Scalars['String']>;
  /** Commodity category code used to further describe the reported item. Used by: APHIS, NHTSA, ATF */
  categoryCode?: Maybe<Scalars['String']>;
  /** Category type code used to describe the reported item. Used by: APHIS. */
  categoryTypeCode?: Maybe<Scalars['String']>;
  /** US TTB Certificate of Label Approval Number Used by: TTB */
  certificateOfLabelApproval?: Maybe<UsTtbCertificateOfLabelApproval>;
  /** Certificate of Origin. Used by APHIS. */
  certificateOfOrigin?: Maybe<Lpco>;
  /** PGA source and processing data Used by: APHIS, FDA */
  characteristics?: Maybe<Array<CommodityCharacteristic>>;
  /** Chemical Abstract Service Numbers. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  chemicalAbstractServiceNumbers?: Maybe<Array<Scalars['String']>>;
  /** This number corresponds to the box number from DOT HS-7 Required by: NHTSA */
  conformanceDeclaration?: Maybe<Scalars['String']>;
  /** Constituent elements of the product/component. Required for: APHIS (Lacey Act), DEA. Used by: FWS. Optional for: EPA, FDA */
  constituentElements?: Maybe<Array<ConstituentElement>>;
  /** APHIS PPQ587-41. Permit to Import Plants and Plant Products Regulated by 7CFR319.41 (Indian Corn or Maize, Broomcorn, etc.) */
  cornPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-8. Permit to Import Plants and Plant Products Regulated by 7CFR319.8 (Foreign Cotton or Covers) */
  cottonPermit?: Maybe<Lpco>;
  /** Crop Grower. Supplier type. Required for Cut flowers (Category Type Code AP0800). Used by APHIS. */
  cropGrower?: Maybe<UsConsumptionEntrySupplier>;
  /** APHIS VS 17-29. Declaration of Importation. */
  declarationOfImportation?: Maybe<Lpco>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the US manufacturer. Should always be the domestic firm registration number associated with the U.S. manufacturer and not the foreign manufacturer. Used by: FDA (medical devices) */
  deviceDomesticManufacturer?: Maybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the exporter who exports or offers for export to the United States (U.S.), a device manufactured or processed by another individual, partnership, corporation or association in a foreign country, as well as devices originally manufactured in the United States. Used by: FDA (medical devices) */
  deviceForeignExporter?: Maybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the foreign manufacturer. Should always be the foreign firm registration number associated with the foreign manufacturer and not the US specifications developer. Used by: FDA (medical devices) */
  deviceForeignManufacturer?: Maybe<Scalars['String']>;
  /** Defines whether a radiation emitting product is a finished product or just a component */
  deviceForm?: Maybe<UsFdaRadiationEmittingDeviceForm>;
  /** Device Initial Importer. Where the IOR is a US entity, DII will default to the IOR. If the IOR is a non-resident, then ops will have to select the DII. */
  deviceInitialImporter?: Maybe<UsConsumptionEntryDii>;
  /** Device Listing Number provided by CDRH Used by: FDA (medical devices) */
  deviceListingNumber?: Maybe<Scalars['String']>;
  /** Device Premarket Approval Number or Device Premarket Notification Number (510(K))/DeNovo number issued by CDRH (Center for Devices and Radiological Health) or CBER. This also includes Humanitarian Device Exemption (HDE). Premarket number should always be the number that is on the listing record. Used by: FDA (medical devices) */
  devicePremarketNumber?: Maybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: Maybe<UsPgaDisclaimerCode>;
  /** APHIS 7040B/7040C. Import Permit for Dogs. */
  dogsPermit?: Maybe<Lpco>;
  /** Department of Transportation conformance bond. Used by: NHTSA */
  dotBond?: Maybe<DotBond>;
  /** The placement of the driver's seat in a vehicle Used by: NHTSA */
  driveSide?: Maybe<VehicleDriveSide>;
  /** New Drug (NDA), Abbreviated New Drug (AND/ANDA), or Therapeutic Biologic Application Number issued by CBER or CDER. Used by: FDA (drugs) */
  drugApplicationNumber?: Maybe<Scalars['String']>;
  /** Defines whether a drug is an active pharmaceutical ingredient (API) / bulk drug substance, or a finished drug form (e.g. tablet, capsule, solution). */
  drugForm?: Maybe<UsFdaDrugForm>;
  /** Drug Listing Number (DLS), for a bulk Active Pharmaceutical Ingredient (API), or National Drug Code (NDC), for finished drugs, issued by FDA. The first segment of numbers is the labeler code. This number identifies the manufacturer of the product. Declare without dashes. Used by: FDA (drugs) */
  drugListingNumber?: Maybe<Scalars['String']>;
  /** Drug Registration Number issued by Center for Drug Evaluation and Research (CDER), Center for Veterinary Medicine (CVM), or Center for Biologics Evaluation and Research (CBER) for the manufacturer. The Federal Food, Drug, and Cosmetic Act (FFD&C) requires most establishments that manufacturer, prepare, propagate, compound, or process a drug or drugs, to register with the FDA. Currently, the establishment registration number is the Dun & Bradstreet Data Universal Numbering System number (DUNS) for CDER and CVM. The establishment registration number can be the FDA Establishment Identification (FEI) or DUNS for CBER. Used by: FDA (drugs)   */
  drugRegistrationNumber?: Maybe<Scalars['String']>;
  /** Device (Electrode) Lead Wire or Patient Cable, used when importing electrode lead wires, patient cables, or devices that use them. The affirmation indicates either (1) the device shipment does not contain any pre-wired electrodes, electrode lead wires, or patient (transducer) cables, or (2) any pre-wired electrodes, electrode lead wires or patient cables comply with 21 CFR 898, Performance Standard for Electrode Lead Wires and Patient Cables. Used by: FDA (medical devices) */
  electrode?: Maybe<Scalars['Boolean']>;
  /** The two-letter ISO country code that identifies the Importer’s Embassy Used by: NHTSA */
  embassyCountryCode?: Maybe<Scalars['CountryCode']>;
  /** EPA Vehicles and Engines Engine Power Rating Used by: EPA */
  enginePowerRating?: Maybe<Quantity>;
  /** Engine data. Used by: EPA */
  engines?: Maybe<Array<UsPgaEngine>>;
  /** See https://www.epa.gov/compliance/pesticide-establishment-registration-and-reporting Used by: EPA */
  epaProducerEstablishmentNumber?: Maybe<Lpco>;
  /** The EPA Reg. No. of a product for primary registrants consists of two set of numbers separated by a hyphen, for example EPA Reg. No. 12345-12. The first set of numbers refers to the registrant’s company identification number, and the second set of numbers represents the product number. Used by: EPA */
  epaRegistrationNumber?: Maybe<Lpco>;
  /** EPA Vehicles and Engines Test Group Name/Number Used by: EPA */
  epaTestGroup?: Maybe<Scalars['String']>;
  /** The FDA product code of the product/component. Required by: FDA */
  fdaProductCode?: Maybe<Scalars['String']>;
  /** A license or permit issued to anyone who wishes to transport, ship, and cause to be transported, or receive explosives materials under 27 CFR 555.41. Used by: ATF */
  federalExplosiveLicense?: Maybe<Lpco>;
  /** Federal firearms license issued under the provisions of the Gun Control Act (GCA) to manufacture, import or  in firearms and/or ammunition. Used by: ATF */
  federalFirearmsLicense?: Maybe<Lpco>;
  /** Food Canning Establishment Number (FCE) that identifies a site-specific manufacturer of acidified and/or low-acid canned food products. Form FDA 2541 is  used for the manufacturing firm registration. See the SID and VOL Affirmation Code definitions below Used by: FDA (LACF/AF food) */
  foodCanningEstablishmentNumber?: Maybe<Scalars['String']>;
  /** Food container dimensions. Required by: FDA (LACF and AF Food) */
  foodContainerDimensions?: Maybe<Dimensions>;
  foodFacilityRegistration?: Maybe<UsFdaFoodFacilityRegistration>;
  /** Acidified & Low-Acid Canned Foods (LACF/AF) Volume. May be used to communicate the container volume and unit of measure of an Acidified Food (AF) or Low-Acid Food (LACF) product that is packaged in a container that does not have a traditional size/dimension. The filer should verify with the importer whether  the container size/dimensions or volume were supplied to FDA by the manufacturer. Use of this field instead of the Container Size/Dimension, when  Container Size/Dimension is part of the scheduled process, will result in a failure of the automated data base look-up. Used by: FDA (LACF/AF food) */
  foodVolume?: Maybe<Scalars['String']>;
  /** The foreign certificate for imported distilled spirits and wine. Used by: TTB */
  foreignCertificate?: Maybe<Lpco>;
  /** APHIS PPQ 203. Foreign Site Certificate of Inspection and/or treatment. */
  foreignSiteCertificateOfInspection?: Maybe<Lpco>;
  /** Foreign Supplier Verification Program Importer. Where the IOR is a US entity, FSVP will default to the IOR. If the IOR is a non-resident, then ops will have to select the FSVP. */
  foreignSupplierVerificationProgram?: Maybe<UsConsumptionEntryFsvp>;
  /** APHIS PPQ587-56. Permit to Import Plants and Plant Products Regulated by 7CFR319.56 (Fruits and Vegetables). */
  fruitsAndVegetablesPermit?: Maybe<Lpco>;
  /** A NHTSA-assigned code identifying the glazing manufacturer. Formatted N or NN or NNN or NNNN (e.g., 1234) Used by: NHTSA */
  glazingManufacturerCode?: Maybe<Scalars['String']>;
  /** GS1 Global Product Classification Brick Code (GPCB). An 8-digit number designating a set of products with similar characteristics as defined by GS1 at http://www.gs1.org/gsmp/kc/gpc. Used by APHIS. */
  globalProductClassificationBrickCode?: Maybe<Scalars['String']>;
  /** APHIS BRS 2000. Application for Permit or Courtesy Permit for Movement or Release of Genetically Engineered Organisms. */
  gmoPermit?: Maybe<Lpco>;
  /** Health Certificate. Used by APHIS. */
  healthCertificate?: Maybe<Lpco>;
  /** Device Impact Resistance Lens Certification, used to certify that the filer has, on hand, the test results or a certificate that shows that the product has met the standards for impact resistance lenses. FDA has the authority to ask for copies of the actual test results. Each batch within the shipment must have its own test results. Used by: FDA (medical devices) */
  impactResistanceLensCertification?: Maybe<Scalars['Boolean']>;
  /** APHIS 2006. Importation of Veterinary Biological Products. */
  importationOfVeterinaryBiologicalProducts?: Maybe<Lpco>;
  /** Data pertaining to an inspection. Used by: APHIS, FWS */
  inspection?: Maybe<UsPgaInspection>;
  /** The intended use code of the product/component. Required by: APHIS, FDA, EPA Used by: FWS */
  intendedUse?: Maybe<Scalars['String']>;
  /** Describes the intended use of the product/component. Used by: FWS */
  intendedUseDescription?: Maybe<Scalars['String']>;
  /** Investigational New Drug Application Number issued by CBER or CDER. Investigational drugs are new drugs intended solely for investigational use by  experts qualified by scientific training and experiences to investigate the safety and effectiveness of drugs. The Federal Food, Drug, and Cosmetic Act (FFD&C) Act requires that a drug be the subject of an approved marketing application before it is transported or distributed across state lines (including import). A sponsor who wants to ship the investigational drug to clinical investigators must seek an exemption from that legal requirement. Used by: FDA (investigational new drugs) */
  investigationNewDrugApplicationNumber?: Maybe<Scalars['String']>;
  /** Investigational Device Exemption Number issued by CBER or CDRH. Devices that qualified experts use on human subjects, to conduct investigations of their safety and effectiveness, are considered investigational devices. For devices destined for non-significant risk study (NSR), an Institutional Review Boards(IRB) letter affirming NSR must be provided to FDA. In such case, provide 'NSR'. Used by: FDA (medical devices) */
  investigationalDeviceExemptionNumber?: Maybe<Scalars['String']>;
  /** The importer is an original manufacturer of motor vehicles (or a wholly owned subsidiary thereof) that is certified to conform to all applicable Federal Motor Vehicle Safety Standards (FMVSS). Use on the public roads must be authorized specifically. [591.6(f )(1) or (2)]; Used by: NHTSA */
  iorIsVehicleManufacturer?: Maybe<Scalars['Boolean']>;
  /** Internal Revenue Code (IRC) registry number for the distilled spirits plant, bonded wine cellar, or brewery. Used by: TTB */
  ircRegistryNumber?: Maybe<Lpco>;
  /** Indicates that information should be treated as confidential. Used by: DEA, FWS */
  isConfidentialInformation?: Maybe<Scalars['Boolean']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) Used by: APHIS, EPA, NHTSA, FWS */
  isImageSubmitted?: Maybe<Scalars['Boolean']>;
  /** Identifies Toxic Substance Control Act positive or negative certification. Positive – I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA. Negative – I certify that all chemicals in this shipment are not subject to TSCA. Used by: EPA */
  isTscaCompliant?: Maybe<Scalars['Boolean']>;
  /** The unique identity for the item. Used by: APHIS */
  itemIdentity?: Maybe<ItemIdentity>;
  /** APHIS PPQ587-75. Permit to Import Plants and Plant Products Regulated by 7CFR319.75 (Khapra Beetle). */
  khapraBeetlePermit?: Maybe<Lpco>;
  /** The tariffs associated Independent Third Party Laboratory or Clinical Site. Required for investigational drugs. Required by: FDA (investigational new drugs) */
  laboratory?: Maybe<UsConsumptionEntryFacility>;
  /** The type of laboratory. Required by: FDA (investigational new drugs) */
  laboratoryTypeCode?: Maybe<UsFdaLaboratoryType>;
  /** Live Animal Tag Ranges. Used by APHIS. */
  liveAnimalTagRanges?: Maybe<Array<LiveAnimalTagRange>>;
  /** Live Animal Tag. Used by APHIS. */
  liveAnimalTags?: Maybe<Array<Scalars['String']>>;
  /** APHIS VS 17-135. Permit to Import Live Animals. */
  liveAnimalsPermit?: Maybe<Lpco>;
  /** Manufacturer assigned lot number for the product. Required by: FDA (prior notice LACF/AF food, infant formula) */
  lotNumber?: Maybe<Scalars['String']>;
  /** LPCO Authorized Party. Location type. Required if at least one LPCO is used. Used by APHIS. */
  lpcoAuthorizedParty?: Maybe<UsConsumptionEntryFacility>;
  /** Location of the manufacture date of the vehicle or engine. Used by: EPA */
  manufactureDateLocation?: Maybe<Scalars['String']>;
  /** Meat Certificate. Meat Certificate required by APHIS/FSIS to document sanitary condition and wholesomeness of animal or meat products. (Note: Meat and Sanitary Certificates can be “one and the same”). */
  meatCertificate?: Maybe<Lpco>;
  /** Microchip. Used by APHIS. */
  microchip?: Maybe<Scalars['String']>;
  /** NMFS Tag Number. The individual tag number of the fish. Used by APHIS. */
  nmfsTagNumber?: Maybe<Scalars['String']>;
  /** Free form information found in box 18 of EPA Form 3540-01. Required if EPA Registration number not provided. */
  noticeOfArrival?: Maybe<Scalars['String']>;
  /** USDA APHIS PPQ Notice Of Arrival */
  noticeOfArrivalPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-37. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Nursery Stock, Plants, Roots, Bulbs, Seeds). */
  nurseryPlantsPermit?: Maybe<Lpco>;
  /** Offical Animal Number. Unique number given by a national authority to identify an animal individually. Used by APHIS. */
  officialAnimalNumber?: Maybe<Scalars['String']>;
  /** Original country where routing to the US began. Required for: APHIS Used by: FWS */
  originCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Packaging associated with a PGA. Required if subject to FDA Prior Notice or a Performance Standard Used by: FDA, APHIS, EPA */
  packaging?: Maybe<Array<Quantity>>;
  /** Quantity of cigarette tubes or papers. Used by: TTB */
  paperOrTubeQuantity?: Maybe<Scalars['Int']>;
  /** Two-letter ISO country code of the country that issued the passport. Used by: NHTSA */
  passportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Government issued passport number to certify the identity and nationality of the person importing the product. Used by: NHTSA */
  passportNumber?: Maybe<Scalars['String']>;
  /** Pesticide Control Number Used by: EPA */
  pcNumber?: Maybe<Scalars['String']>;
  /** Subject to a performance standard: FDA */
  performanceStandard?: Maybe<Scalars['Boolean']>;
  /** A letter issued by NHTSA permitting a nonconforming vehicle to be imported pursuant to 49 CFR 591.5(j) or 591(I). Formatted as NN-NNNN-NNNN. Used by: NHTSA */
  permissionLetter?: Maybe<Lpco>;
  /** Permitted Destination. Location type. Required if a Veterinary Biologics product (Category Code 307). Used by APHIS. */
  permittedDestination?: Maybe<UsConsumptionEntryFacility>;
  /** Phytosanitary Certificate. Phytosanitary certificate required by APHIS to document the cleanliness (pest and disease) of Plant products. */
  phytosanitaryCertificate?: Maybe<Lpco>;
  /** APHIS PPQ 526. Permit to Move Live Plant Pests or Noxious Weeds. */
  plantPestsPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-37CAN. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Canadian-Origin). */
  plantsOfCanadianOriginPermit?: Maybe<Lpco>;
  /** The name of the political subunit, e.g. state, province, or region through which goods are routed between the country of original departure and the country of final destination. Used by: APHIS */
  politicalSubunitName?: Maybe<Scalars['String']>;
  /** APHIS PPQ 546. Post-entry Quarantine Permit. */
  postEntryQuarantinePermit?: Maybe<Lpco>;
  /** US FDA Prior Notice data requirements. */
  priorNotice?: Maybe<UsFdaPriorNotice>;
  /** Code indicating the specific PGA processing requirements for which the data set is related. */
  processingCode?: Maybe<Scalars['String']>;
  /** A code indicating the type of product number used to characterize the product or component. Used by: APHIS */
  productQualifierCode?: Maybe<Scalars['String']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: Maybe<Scalars['String']>;
  /** APHIS PPQ 588. Permit to Import Prohibited Plant Material For Research Purposes. */
  prohibitedPlantForResearchPermit?: Maybe<Lpco>;
  /** APHIS PPQ 621. Protected Plant Permit to Engage in the Business of Importing, Exporting, or Re-exporting Terrestrial Plants or Plant Products that are Protected and Regulated by 50CFR17.12 or 50CFR23.23 (CITES: Threatened or Endangered Species). */
  protectedPlantPermit?: Maybe<Lpco>;
  /** Rabies Vaccination Certificate. Used by APHIS. */
  rabiesVaccinationCertifcate?: Maybe<Lpco>;
  radiationDeclaration?: Maybe<RadiationDeclaration>;
  /** Rail car numbers Used by: FDA (prior notice food arriving via rail/containerized rail.) */
  railCarNumbers?: Maybe<Array<Scalars['String']>>;
  /** Country that has refused the shipment. Used by: FDA */
  refusalCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Number assigned by NHTSA to a person or business entity specially registered with NHTSA as an importer of nonconforming motor vehicles pursuant to 49 CFR Part 592. Formatted as A-NN-NNN. Used by: NHTSA */
  registeredImporterNumber?: Maybe<Lpco>;
  /** Radio Frequency Identification. Used by APHIS. */
  rfid?: Maybe<Scalars['String']>;
  /** APHIS PPQ587-55. Permit to Import Plants and Plant Products Regulated by 7CFR319.55 (Rice). */
  ricePermit?: Maybe<Lpco>;
  /** LACF/AF Submission/Scheduled Process Identifier Number (SID) Used by: FDA (LACF/AF food) */
  scheduleIdentifierNumber?: Maybe<Scalars['String']>;
  /** APHIS Seed Analysis Certificate (PPQ Form 925, CFIA Form 5289, CFIA Form 5309 or similar form) */
  seedAnalysisCertificate?: Maybe<Lpco>;
  /** Country from where the product/component shipped. Required by: FDA (Food subject to Prior Notice) */
  shipmentCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Slaughter Number. Unique number given by a slaughterhouse to an animal or a group of animals of the same breed. Used by APHIS. */
  slaughterNumber?: Maybe<Scalars['String']>;
  /** APHIS PPQ 525B. Soil Permit. */
  soilPermit?: Maybe<Lpco>;
  /** PGA source and processing data Used by: APHIS, FDA */
  source?: Maybe<UsPgaSource>;
  /** USDA APHIS VS STAT Documents (Statements) (e.g. Manufacturer’s Statement, Owner/Importer Statements, Producer Statements) */
  statementsPermit?: Maybe<Lpco>;
  /** The storage location of the vehicle or engine. Used by: EPA */
  storageLocation?: Maybe<UsConsumptionEntryFacility>;
  /** APHIS PPQ587-15. Permit to Import Plants and Plant Products Regulated by 7CFR319.15 (Sugarcane) */
  sugarcanePermit?: Maybe<Lpco>;
  /** Taxonomic Serial Number (TSN). A unique serial number assigned to a taxonomic unit by the Integrated Taxonomic Informational System at http://www.itis.gov. Used by APHIS. */
  taxonomicSerialNumber?: Maybe<Scalars['String']>;
  /** APHIS PPQ 585. Permit to Import Timber or Timber Products */
  timberPermit?: Maybe<Lpco>;
  /** A NHTSA-assigned code identifying the tire manufacturer. Formatted ANAN or ANANAN (e.g., 1B or ABC) Used by: NHTSA */
  tireManufacturerCode?: Maybe<Scalars['String']>;
  /** The Trade Name of the product/component. Used by: EPA, FDA, NHTSA */
  tradeName?: Maybe<Scalars['String']>;
  /** Country through which goods or passengers are routed between the country of original departure and final destination. Used by: APHIS */
  transitCountryCode?: Maybe<Scalars['CountryCode']>;
  /** APHIS PPQ 586. Permit to Transit Plants and/or Plant Products, Plant Pests, and/or Associated Soil. */
  transitPlantsPermit?: Maybe<Lpco>;
  /** Country where goods are to be or have been transferred from one means of transport to another during the course of one transport operation. Used by: APHIS */
  transshipmentCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Treatment Certificate. Used by APHIS. */
  treatmentCertificate?: Maybe<Lpco>;
  /** TTB-issued permit number indicating the IRC-bonded facility, manufacturer, or export warehouse proprietor. Used by: TTB */
  ttbFacilityPermitNumber?: Maybe<Lpco>;
  /** The importer's permit number assigned by TTB Used by: TTB */
  ttbImporterPermitNumber?: Maybe<Lpco>;
  /** UN Standard Products and Services Code (UNSPSC) Commodity Code. An 8-digit number designating a set of products with similar characteristics as defined by the United Nations at http://www.unspsc.org. Used by APHIS. */
  unpscCommodityCode?: Maybe<Scalars['String']>;
  /** Vehicle data. Used by: EPA, NHT */
  vehicle?: Maybe<UsPgaVehicle>;
  /** NHTSA-assigned number to identify a vehicle that is not certified to the Federal motor vehicle safety standards as being eligible for importation by a registered importer under a DOT conformance bond pursuant to 49 CFR Part 591.5(f). Formatted as AAA-NNN. */
  vehicleEligibilityNumber?: Maybe<Lpco>;
  /** APHIS VS 16-6A. Veterinary Permit to Import Controlled Materials and Organisms and Vectors. */
  veterinaryPermitToImportControlledMaterials?: Maybe<Lpco>;
  /** EPA Vehicles and Engines Bond Exemption Used by: EPA */
  vneBondExemptionNumber?: Maybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number Used by: EPA */
  vneBondNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number Used by: EPA */
  vneExemptionNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code Used by: EPA */
  vneImportCode?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code Used by: EPA */
  vneIndustryCode?: Maybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. Used by: EPA */
  vneOtherExemptionRegulation?: Maybe<Scalars['String']>;
  /** Measurements of the weapon(s) being imported. Used by: ATF */
  weaponMeasurements?: Maybe<WeaponMeasurements>;
};

/** Data requirements reported to a US CBP Partner Government Agency. */
export type UsConsumptionEntryPgaInput = {
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: InputMaybe<Scalars['String']>;
  /** A distinct and legible mark, properly applied with a freeze brand, hot iron, or other method, and easily visible on the live animal and on the carcass before skinning. Used by APHIS. */
  animalBrand?: InputMaybe<Scalars['String']>;
  /** Number that characterizes the commercial product or component. Used by: APHIS */
  aphProductCode?: InputMaybe<Scalars['String']>;
  /** APHIS VS 17-32. Application for Inspection and Dipping. */
  applicationForInspectionAndDipping?: InputMaybe<LpcoInput>;
  /** Category code for weapons. Used by: ATF */
  atfCategory?: InputMaybe<Scalars['AtfCategoryCode']>;
  /** A permit that authorizes the importation of firearms, ammunitions, and implements of war into the United States or any possession thereof, except for certain exempt importations presecribed in 27 CFR parts 447, 478 and 479. Used by: ATF */
  atfImportPermit?: InputMaybe<LpcoInput>;
  /** Registered importers of firearms, ammunition firearms parts or implements of war other, than sporting shotguns, shotgun shells, or shotgun parts, must also register under the Arms Export Control Act of 1976. Used by: ATF */
  atfImporterRegistration?: InputMaybe<LpcoInput>;
  /** Identification method often used on aves (birds). Used by APHIS. */
  band?: InputMaybe<Scalars['String']>;
  /** Cut Flowers Bouquet Grouping Code. Used by APHIS. */
  bouquetGroupingCode?: InputMaybe<Scalars['String']>;
  /** APHIS BRS Acknowledgement letter */
  brsAcknowledgementLetter?: InputMaybe<LpcoInput>;
  /** APHIS BRS Notification. */
  brsNotification?: InputMaybe<LpcoInput>;
  /** Chemical Abstract Service Number. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  casNumber?: InputMaybe<Scalars['String']>;
  /** Commodity category code used to further describe the reported item. Used by: APHIS, NHTSA, ATF */
  categoryCode?: InputMaybe<Scalars['String']>;
  /** Category type code used to describe the reported item. Used by: APHIS. */
  categoryTypeCode?: InputMaybe<Scalars['String']>;
  /** US TTB Certificate of Label Approval Number Used by: TTB */
  certificateOfLabelApproval?: InputMaybe<UsTtbCertificateOfLabelApprovalInput>;
  /** Certificate of Origin. Used by APHIS. */
  certificateOfOrigin?: InputMaybe<LpcoInput>;
  /** PGA source and processing data Used by: APHIS, FDA */
  characteristics?: InputMaybe<Array<CommodityCharacteristicInput>>;
  /** Chemical Abstract Service Numbers. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  chemicalAbstractServiceNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** This number corresponds to the box number from DOT HS-7 Required by: NHTSA */
  conformanceDeclaration?: InputMaybe<Scalars['String']>;
  /** Constituent elements of the product/component. Required for: APHIS (Lacey Act), DEA. Used by: FWS. Optional for: EPA, FDA */
  constituentElements?: InputMaybe<Array<ConstituentElementInput>>;
  /** APHIS PPQ587-41. Permit to Import Plants and Plant Products Regulated by 7CFR319.41 (Indian Corn or Maize, Broomcorn, etc.) */
  cornPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-8. Permit to Import Plants and Plant Products Regulated by 7CFR319.8 (Foreign Cotton or Covers) */
  cottonPermit?: InputMaybe<LpcoInput>;
  /** Crop Grower. Supplier type. Required for Cut flowers (Category Type Code AP0800). Used by APHIS. */
  cropGrower?: InputMaybe<UsConsumptionEntrySupplierInput>;
  /** APHIS VS 17-29. Declaration of Importation. */
  declarationOfImportation?: InputMaybe<LpcoInput>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the US manufacturer. Should always be the domestic firm registration number associated with the U.S. manufacturer and not the foreign manufacturer. Used by: FDA (medical devices) */
  deviceDomesticManufacturer?: InputMaybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the exporter who exports or offers for export to the United States (U.S.), a device manufactured or processed by another individual, partnership, corporation or association in a foreign country, as well as devices originally manufactured in the United States. Used by: FDA (medical devices) */
  deviceForeignExporter?: InputMaybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the foreign manufacturer. Should always be the foreign firm registration number associated with the foreign manufacturer and not the US specifications developer. Used by: FDA (medical devices) */
  deviceForeignManufacturer?: InputMaybe<Scalars['String']>;
  /** Defines whether a radiation emitting product is a finished product or just a component */
  deviceForm?: InputMaybe<UsFdaRadiationEmittingDeviceForm>;
  /** Device Initial Importer. Where the IOR is a US entity, DII will default to the IOR. If the IOR is a non-resident, then ops will have to select the DII. */
  deviceInitialImporter?: InputMaybe<UsConsumptionEntryDiiInput>;
  /** Device Listing Number provided by CDRH Used by: FDA (medical devices) */
  deviceListingNumber?: InputMaybe<Scalars['String']>;
  /** Device Premarket Approval Number or Device Premarket Notification Number (510(K))/DeNovo number issued by CDRH (Center for Devices and Radiological Health) or CBER. This also includes Humanitarian Device Exemption (HDE). Premarket number should always be the number that is on the listing record. Used by: FDA (medical devices) */
  devicePremarketNumber?: InputMaybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: InputMaybe<UsPgaDisclaimerCode>;
  /** APHIS 7040B/7040C. Import Permit for Dogs. */
  dogsPermit?: InputMaybe<LpcoInput>;
  /** Department of Transportation conformance bond. Used by: NHTSA */
  dotBond?: InputMaybe<DotBondInput>;
  /** The placement of the driver's seat in a vehicle Used by: NHTSA */
  driveSide?: InputMaybe<VehicleDriveSide>;
  /** New Drug (NDA), Abbreviated New Drug (AND/ANDA), or Therapeutic Biologic Application Number issued by CBER or CDER. Used by: FDA (drugs) */
  drugApplicationNumber?: InputMaybe<Scalars['String']>;
  /** Defines whether a drug is an active pharmaceutical ingredient (API) / bulk drug substance, or a finished drug form (e.g. tablet, capsule, solution). */
  drugForm?: InputMaybe<UsFdaDrugForm>;
  /** Drug Listing Number (DLS), for a bulk Active Pharmaceutical Ingredient (API), or National Drug Code (NDC), for finished drugs, issued by FDA. The first segment of numbers is the labeler code. This number identifies the manufacturer of the product. Declare without dashes. Used by: FDA (drugs) */
  drugListingNumber?: InputMaybe<Scalars['String']>;
  /** Drug Registration Number issued by Center for Drug Evaluation and Research (CDER), Center for Veterinary Medicine (CVM), or Center for Biologics Evaluation and Research (CBER) for the manufacturer. The Federal Food, Drug, and Cosmetic Act (FFD&C) requires most establishments that manufacturer, prepare, propagate, compound, or process a drug or drugs, to register with the FDA. Currently, the establishment registration number is the Dun & Bradstreet Data Universal Numbering System number (DUNS) for CDER and CVM. The establishment registration number can be the FDA Establishment Identification (FEI) or DUNS for CBER. Used by: FDA (drugs)   */
  drugRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** Device (Electrode) Lead Wire or Patient Cable, used when importing electrode lead wires, patient cables, or devices that use them. The affirmation indicates either (1) the device shipment does not contain any pre-wired electrodes, electrode lead wires, or patient (transducer) cables, or (2) any pre-wired electrodes, electrode lead wires or patient cables comply with 21 CFR 898, Performance Standard for Electrode Lead Wires and Patient Cables. Used by: FDA (medical devices) */
  electrode?: InputMaybe<Scalars['Boolean']>;
  /** The two-letter ISO country code that identifies the Importer’s Embassy Used by: NHTSA */
  embassyCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** EPA Vehicles and Engines Engine Power Rating Used by: EPA */
  enginePowerRating?: InputMaybe<QuantityInput>;
  /** Engine data. Used by: EPA */
  engines?: InputMaybe<Array<UsPgaEngineInput>>;
  /** See https://www.epa.gov/compliance/pesticide-establishment-registration-and-reporting Used by: EPA */
  epaProducerEstablishmentNumber?: InputMaybe<LpcoInput>;
  /** The EPA Reg. No. of a product for primary registrants consists of two set of numbers separated by a hyphen, for example EPA Reg. No. 12345-12. The first set of numbers refers to the registrant’s company identification number, and the second set of numbers represents the product number. Used by: EPA */
  epaRegistrationNumber?: InputMaybe<LpcoInput>;
  /** EPA Vehicles and Engines Test Group Name/Number Used by: EPA */
  epaTestGroup?: InputMaybe<Scalars['String']>;
  /** The FDA product code of the product/component. Required by: FDA */
  fdaProductCode?: InputMaybe<Scalars['String']>;
  /** A license or permit issued to anyone who wishes to transport, ship, and cause to be transported, or receive explosives materials under 27 CFR 555.41. Used by: ATF */
  federalExplosiveLicense?: InputMaybe<LpcoInput>;
  /** Federal firearms license issued under the provisions of the Gun Control Act (GCA) to manufacture, import or  in firearms and/or ammunition. Used by: ATF */
  federalFirearmsLicense?: InputMaybe<LpcoInput>;
  /** Food Canning Establishment Number (FCE) that identifies a site-specific manufacturer of acidified and/or low-acid canned food products. Form FDA 2541 is  used for the manufacturing firm registration. See the SID and VOL Affirmation Code definitions below Used by: FDA (LACF/AF food) */
  foodCanningEstablishmentNumber?: InputMaybe<Scalars['String']>;
  /** Food container dimensions. Required by: FDA (LACF and AF Food) */
  foodContainerDimensions?: InputMaybe<DimensionsInput>;
  foodFacilityRegistration?: InputMaybe<UsFdaFoodFacilityRegistrationInput>;
  /** Acidified & Low-Acid Canned Foods (LACF/AF) Volume. May be used to communicate the container volume and unit of measure of an Acidified Food (AF) or Low-Acid Food (LACF) product that is packaged in a container that does not have a traditional size/dimension. The filer should verify with the importer whether  the container size/dimensions or volume were supplied to FDA by the manufacturer. Use of this field instead of the Container Size/Dimension, when  Container Size/Dimension is part of the scheduled process, will result in a failure of the automated data base look-up. Used by: FDA (LACF/AF food) */
  foodVolume?: InputMaybe<Scalars['String']>;
  /** The foreign certificate for imported distilled spirits and wine. Used by: TTB */
  foreignCertificate?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 203. Foreign Site Certificate of Inspection and/or treatment. */
  foreignSiteCertificateOfInspection?: InputMaybe<LpcoInput>;
  /** Foreign Supplier Verification Program Importer. Where the IOR is a US entity, FSVP will default to the IOR. If the IOR is a non-resident, then ops will have to select the FSVP. */
  foreignSupplierVerificationProgram?: InputMaybe<UsConsumptionEntryFsvpInput>;
  /** APHIS PPQ587-56. Permit to Import Plants and Plant Products Regulated by 7CFR319.56 (Fruits and Vegetables). */
  fruitsAndVegetablesPermit?: InputMaybe<LpcoInput>;
  /** A NHTSA-assigned code identifying the glazing manufacturer. Formatted N or NN or NNN or NNNN (e.g., 1234) Used by: NHTSA */
  glazingManufacturerCode?: InputMaybe<Scalars['String']>;
  /** GS1 Global Product Classification Brick Code (GPCB). An 8-digit number designating a set of products with similar characteristics as defined by GS1 at http://www.gs1.org/gsmp/kc/gpc. Used by APHIS. */
  globalProductClassificationBrickCode?: InputMaybe<Scalars['String']>;
  /** APHIS BRS 2000. Application for Permit or Courtesy Permit for Movement or Release of Genetically Engineered Organisms. */
  gmoPermit?: InputMaybe<LpcoInput>;
  /** Health Certificate. Used by APHIS. */
  healthCertificate?: InputMaybe<LpcoInput>;
  /** Device Impact Resistance Lens Certification, used to certify that the filer has, on hand, the test results or a certificate that shows that the product has met the standards for impact resistance lenses. FDA has the authority to ask for copies of the actual test results. Each batch within the shipment must have its own test results. Used by: FDA (medical devices) */
  impactResistanceLensCertification?: InputMaybe<Scalars['Boolean']>;
  /** APHIS 2006. Importation of Veterinary Biological Products. */
  importationOfVeterinaryBiologicalProducts?: InputMaybe<LpcoInput>;
  /** Data pertaining to an inspection. Used by: APHIS, FWS */
  inspection?: InputMaybe<UsPgaInspectionInput>;
  /** The intended use code of the product/component. Required by: APHIS, FDA, EPA Used by: FWS */
  intendedUse?: InputMaybe<Scalars['String']>;
  /** Describes the intended use of the product/component. Used by: FWS */
  intendedUseDescription?: InputMaybe<Scalars['String']>;
  /** Investigational New Drug Application Number issued by CBER or CDER. Investigational drugs are new drugs intended solely for investigational use by  experts qualified by scientific training and experiences to investigate the safety and effectiveness of drugs. The Federal Food, Drug, and Cosmetic Act (FFD&C) Act requires that a drug be the subject of an approved marketing application before it is transported or distributed across state lines (including import). A sponsor who wants to ship the investigational drug to clinical investigators must seek an exemption from that legal requirement. Used by: FDA (investigational new drugs) */
  investigationNewDrugApplicationNumber?: InputMaybe<Scalars['String']>;
  /** Investigational Device Exemption Number issued by CBER or CDRH. Devices that qualified experts use on human subjects, to conduct investigations of their safety and effectiveness, are considered investigational devices. For devices destined for non-significant risk study (NSR), an Institutional Review Boards(IRB) letter affirming NSR must be provided to FDA. In such case, provide 'NSR'. Used by: FDA (medical devices) */
  investigationalDeviceExemptionNumber?: InputMaybe<Scalars['String']>;
  /** The importer is an original manufacturer of motor vehicles (or a wholly owned subsidiary thereof) that is certified to conform to all applicable Federal Motor Vehicle Safety Standards (FMVSS). Use on the public roads must be authorized specifically. [591.6(f )(1) or (2)]; Used by: NHTSA */
  iorIsVehicleManufacturer?: InputMaybe<Scalars['Boolean']>;
  /** Internal Revenue Code (IRC) registry number for the distilled spirits plant, bonded wine cellar, or brewery. Used by: TTB */
  ircRegistryNumber?: InputMaybe<LpcoInput>;
  /** Indicates that information should be treated as confidential. Used by: DEA, FWS */
  isConfidentialInformation?: InputMaybe<Scalars['Boolean']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) Used by: APHIS, EPA, NHTSA, FWS */
  isImageSubmitted?: InputMaybe<Scalars['Boolean']>;
  /** Identifies Toxic Substance Control Act positive or negative certification. Positive – I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA. Negative – I certify that all chemicals in this shipment are not subject to TSCA. Used by: EPA */
  isTscaCompliant?: InputMaybe<Scalars['Boolean']>;
  /** The unique identity for the item. Used by: APHIS */
  itemIdentity?: InputMaybe<ItemIdentityInput>;
  /** APHIS PPQ587-75. Permit to Import Plants and Plant Products Regulated by 7CFR319.75 (Khapra Beetle). */
  khapraBeetlePermit?: InputMaybe<LpcoInput>;
  /** The tariffs associated Independent Third Party Laboratory or Clinical Site. Required for investigational drugs. Required by: FDA (investigational new drugs) */
  laboratory?: InputMaybe<UsConsumptionEntryFacilityInput>;
  /** The type of laboratory. Required by: FDA (investigational new drugs) */
  laboratoryTypeCode?: InputMaybe<UsFdaLaboratoryType>;
  /** Live Animal Tag Ranges. Used by APHIS. */
  liveAnimalTagRanges?: InputMaybe<Array<LiveAnimalTagRangeInput>>;
  /** Live Animal Tag. Used by APHIS. */
  liveAnimalTags?: InputMaybe<Array<Scalars['String']>>;
  /** APHIS VS 17-135. Permit to Import Live Animals. */
  liveAnimalsPermit?: InputMaybe<LpcoInput>;
  /** Manufacturer assigned lot number for the product. Required by: FDA (prior notice LACF/AF food, infant formula) */
  lotNumber?: InputMaybe<Scalars['String']>;
  /** LPCO Authorized Party. Location type. Required if at least one LPCO is used. Used by APHIS. */
  lpcoAuthorizedParty?: InputMaybe<UsConsumptionEntryFacilityInput>;
  /** Location of the manufacture date of the vehicle or engine. Used by: EPA */
  manufactureDateLocation?: InputMaybe<Scalars['String']>;
  /** Meat Certificate. Meat Certificate required by APHIS/FSIS to document sanitary condition and wholesomeness of animal or meat products. (Note: Meat and Sanitary Certificates can be “one and the same”). */
  meatCertificate?: InputMaybe<LpcoInput>;
  /** Microchip. Used by APHIS. */
  microchip?: InputMaybe<Scalars['String']>;
  /** NMFS Tag Number. The individual tag number of the fish. Used by APHIS. */
  nmfsTagNumber?: InputMaybe<Scalars['String']>;
  /** Free form information found in box 18 of EPA Form 3540-01. Required if EPA Registration number not provided. */
  noticeOfArrival?: InputMaybe<Scalars['String']>;
  /** USDA APHIS PPQ Notice Of Arrival */
  noticeOfArrivalPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-37. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Nursery Stock, Plants, Roots, Bulbs, Seeds). */
  nurseryPlantsPermit?: InputMaybe<LpcoInput>;
  /** Offical Animal Number. Unique number given by a national authority to identify an animal individually. Used by APHIS. */
  officialAnimalNumber?: InputMaybe<Scalars['String']>;
  /** Original country where routing to the US began. Required for: APHIS Used by: FWS */
  originCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Packaging associated with a PGA. Required if subject to FDA Prior Notice or a Performance Standard Used by: FDA, APHIS, EPA */
  packaging?: InputMaybe<Array<QuantityInput>>;
  /** Quantity of cigarette tubes or papers. Used by: TTB */
  paperOrTubeQuantity?: InputMaybe<Scalars['Int']>;
  /** Two-letter ISO country code of the country that issued the passport. Used by: NHTSA */
  passportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Government issued passport number to certify the identity and nationality of the person importing the product. Used by: NHTSA */
  passportNumber?: InputMaybe<Scalars['String']>;
  /** Pesticide Control Number Used by: EPA */
  pcNumber?: InputMaybe<Scalars['String']>;
  /** Subject to a performance standard: FDA */
  performanceStandard?: InputMaybe<Scalars['Boolean']>;
  /** A letter issued by NHTSA permitting a nonconforming vehicle to be imported pursuant to 49 CFR 591.5(j) or 591(I). Formatted as NN-NNNN-NNNN. Used by: NHTSA */
  permissionLetter?: InputMaybe<LpcoInput>;
  /** Permitted Destination. Location type. Required if a Veterinary Biologics product (Category Code 307). Used by APHIS. */
  permittedDestination?: InputMaybe<UsConsumptionEntryFacilityInput>;
  /** Phytosanitary Certificate. Phytosanitary certificate required by APHIS to document the cleanliness (pest and disease) of Plant products. */
  phytosanitaryCertificate?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 526. Permit to Move Live Plant Pests or Noxious Weeds. */
  plantPestsPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-37CAN. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Canadian-Origin). */
  plantsOfCanadianOriginPermit?: InputMaybe<LpcoInput>;
  /** The name of the political subunit, e.g. state, province, or region through which goods are routed between the country of original departure and the country of final destination. Used by: APHIS */
  politicalSubunitName?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 546. Post-entry Quarantine Permit. */
  postEntryQuarantinePermit?: InputMaybe<LpcoInput>;
  /** US FDA Prior Notice data requirements. */
  priorNotice?: InputMaybe<UsFdaPriorNoticeInput>;
  /** Code indicating the specific PGA processing requirements for which the data set is related. */
  processingCode?: InputMaybe<Scalars['String']>;
  /** A code indicating the type of product number used to characterize the product or component. Used by: APHIS */
  productQualifierCode?: InputMaybe<Scalars['String']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 588. Permit to Import Prohibited Plant Material For Research Purposes. */
  prohibitedPlantForResearchPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 621. Protected Plant Permit to Engage in the Business of Importing, Exporting, or Re-exporting Terrestrial Plants or Plant Products that are Protected and Regulated by 50CFR17.12 or 50CFR23.23 (CITES: Threatened or Endangered Species). */
  protectedPlantPermit?: InputMaybe<LpcoInput>;
  /** Rabies Vaccination Certificate. Used by APHIS. */
  rabiesVaccinationCertifcate?: InputMaybe<LpcoInput>;
  radiationDeclaration?: InputMaybe<RadiationDeclarationInput>;
  /** Rail car numbers Used by: FDA (prior notice food arriving via rail/containerized rail.) */
  railCarNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Country that has refused the shipment. Used by: FDA */
  refusalCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Number assigned by NHTSA to a person or business entity specially registered with NHTSA as an importer of nonconforming motor vehicles pursuant to 49 CFR Part 592. Formatted as A-NN-NNN. Used by: NHTSA */
  registeredImporterNumber?: InputMaybe<LpcoInput>;
  /** Radio Frequency Identification. Used by APHIS. */
  rfid?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ587-55. Permit to Import Plants and Plant Products Regulated by 7CFR319.55 (Rice). */
  ricePermit?: InputMaybe<LpcoInput>;
  /** LACF/AF Submission/Scheduled Process Identifier Number (SID) Used by: FDA (LACF/AF food) */
  scheduleIdentifierNumber?: InputMaybe<Scalars['String']>;
  /** APHIS Seed Analysis Certificate (PPQ Form 925, CFIA Form 5289, CFIA Form 5309 or similar form) */
  seedAnalysisCertificate?: InputMaybe<LpcoInput>;
  /** Country from where the product/component shipped. Required by: FDA (Food subject to Prior Notice) */
  shipmentCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Slaughter Number. Unique number given by a slaughterhouse to an animal or a group of animals of the same breed. Used by APHIS. */
  slaughterNumber?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 525B. Soil Permit. */
  soilPermit?: InputMaybe<LpcoInput>;
  /** PGA source and processing data Used by: APHIS, FDA */
  source?: InputMaybe<UsPgaSourceInput>;
  /** USDA APHIS VS STAT Documents (Statements) (e.g. Manufacturer’s Statement, Owner/Importer Statements, Producer Statements) */
  statementsPermit?: InputMaybe<LpcoInput>;
  /** The storage location of the vehicle or engine. Used by: EPA */
  storageLocation?: InputMaybe<UsConsumptionEntryFacilityInput>;
  /** APHIS PPQ587-15. Permit to Import Plants and Plant Products Regulated by 7CFR319.15 (Sugarcane) */
  sugarcanePermit?: InputMaybe<LpcoInput>;
  /** Taxonomic Serial Number (TSN). A unique serial number assigned to a taxonomic unit by the Integrated Taxonomic Informational System at http://www.itis.gov. Used by APHIS. */
  taxonomicSerialNumber?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 585. Permit to Import Timber or Timber Products */
  timberPermit?: InputMaybe<LpcoInput>;
  /** A NHTSA-assigned code identifying the tire manufacturer. Formatted ANAN or ANANAN (e.g., 1B or ABC) Used by: NHTSA */
  tireManufacturerCode?: InputMaybe<Scalars['String']>;
  /** The Trade Name of the product/component. Used by: EPA, FDA, NHTSA */
  tradeName?: InputMaybe<Scalars['String']>;
  /** Country through which goods or passengers are routed between the country of original departure and final destination. Used by: APHIS */
  transitCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** APHIS PPQ 586. Permit to Transit Plants and/or Plant Products, Plant Pests, and/or Associated Soil. */
  transitPlantsPermit?: InputMaybe<LpcoInput>;
  /** Country where goods are to be or have been transferred from one means of transport to another during the course of one transport operation. Used by: APHIS */
  transshipmentCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Treatment Certificate. Used by APHIS. */
  treatmentCertificate?: InputMaybe<LpcoInput>;
  /** TTB-issued permit number indicating the IRC-bonded facility, manufacturer, or export warehouse proprietor. Used by: TTB */
  ttbFacilityPermitNumber?: InputMaybe<LpcoInput>;
  /** The importer's permit number assigned by TTB Used by: TTB */
  ttbImporterPermitNumber?: InputMaybe<LpcoInput>;
  /** UN Standard Products and Services Code (UNSPSC) Commodity Code. An 8-digit number designating a set of products with similar characteristics as defined by the United Nations at http://www.unspsc.org. Used by APHIS. */
  unpscCommodityCode?: InputMaybe<Scalars['String']>;
  /** Vehicle data. Used by: EPA, NHT */
  vehicle?: InputMaybe<UsPgaVehicleInput>;
  /** NHTSA-assigned number to identify a vehicle that is not certified to the Federal motor vehicle safety standards as being eligible for importation by a registered importer under a DOT conformance bond pursuant to 49 CFR Part 591.5(f). Formatted as AAA-NNN. */
  vehicleEligibilityNumber?: InputMaybe<LpcoInput>;
  /** APHIS VS 16-6A. Veterinary Permit to Import Controlled Materials and Organisms and Vectors. */
  veterinaryPermitToImportControlledMaterials?: InputMaybe<LpcoInput>;
  /** EPA Vehicles and Engines Bond Exemption Used by: EPA */
  vneBondExemptionNumber?: InputMaybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number Used by: EPA */
  vneBondNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number Used by: EPA */
  vneExemptionNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code Used by: EPA */
  vneImportCode?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code Used by: EPA */
  vneIndustryCode?: InputMaybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. Used by: EPA */
  vneOtherExemptionRegulation?: InputMaybe<Scalars['String']>;
  /** Measurements of the weapon(s) being imported. Used by: ATF */
  weaponMeasurements?: InputMaybe<WeaponMeasurementsInput>;
};

export type UsConsumptionEntryPgaRequirements = {
  __typename?: 'UsConsumptionEntryPgaRequirements';
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM3?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM4?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM6?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM7?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM8?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  ATF?: Maybe<UsConsumptionEntryPga>;
  /** Fields relevant to US CPSC program. */
  CP1?: Maybe<UsCpscPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DE1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP2?: Maybe<UsConsumptionEntryPga>;
  /** Fields relevant to EPA VNE programs. */
  EP3?: Maybe<VehiclesAndEnginesUsPgaProgram>;
  /** Fields relevant to EPA VNE programs. */
  EP4?: Maybe<VehiclesAndEnginesUsPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP5?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP6?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP7?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP8?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD3?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD4?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS3?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS4?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW3?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM3?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM4?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM5?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM6?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM8?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB1?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB2?: Maybe<UsConsumptionEntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB3?: Maybe<UsConsumptionEntryPga>;
};

export type UsConsumptionEntryPgaRequirementsInput = {
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM3?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM4?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM6?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM7?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM8?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  ATF?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Fields relevant to US CPSC program. */
  CP1?: InputMaybe<UsCpscPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DE1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Fields relevant to EPA VNE programs. */
  EP3?: InputMaybe<VehiclesAndEnginesUsPgaProgramInput>;
  /** Fields relevant to EPA VNE programs. */
  EP4?: InputMaybe<VehiclesAndEnginesUsPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP5?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP6?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP7?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP8?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD3?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD4?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS3?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS4?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW3?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM3?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM4?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM5?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM6?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM8?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB1?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB2?: InputMaybe<UsConsumptionEntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB3?: InputMaybe<UsConsumptionEntryPgaInput>;
};

export type UsConsumptionEntryPointOfContact = {
  __typename?: 'UsConsumptionEntryPointOfContact';
  /** A contact email address. */
  email?: Maybe<Scalars['Email']>;
  /** The point of contact's name. */
  name?: Maybe<Scalars['String']>;
  /** A contact phone number. */
  phone?: Maybe<Phone>;
};

export type UsConsumptionEntryPointOfContactInput = {
  /** A contact email address. */
  email?: InputMaybe<Scalars['Email']>;
  /** The point of contact's name. */
  name?: InputMaybe<Scalars['String']>;
  /** A contact phone number. */
  phone?: InputMaybe<PhoneInput>;
};

export type UsConsumptionEntryProduct = {
  __typename?: 'UsConsumptionEntryProduct';
  /** Total number of cartons. */
  cartonCount?: Maybe<Scalars['Int']>;
  /** Client identifier for the product (eg, sku, asin, etc). This should be provided only if a product record was not provided. If product is provided, use product.clientIdentifier instead. */
  clientIdentifier?: Maybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: Maybe<Volume>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** Line items within the Product. */
  lines?: Maybe<Array<UsConsumptionEntryLine>>;
  /** The materials the Product contains. */
  materials?: Maybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: Maybe<Weight>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type UsConsumptionEntryProductInput = {
  /** Total number of cartons. */
  cartonCount?: InputMaybe<Scalars['Int']>;
  /** Client identifier for the product (eg, sku, asin, etc). This should be provided only if a product record was not provided. If product is provided, use product.clientIdentifier instead. */
  clientIdentifier?: InputMaybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: InputMaybe<VolumeInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<UsConsumptionEntryLineInput>>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: InputMaybe<WeightInput>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type UsConsumptionEntrySearchCriteriaInput = {
  /** The Us Consumption Entry badge. Example: Hot */
  badge?: InputMaybe<UsConsumptionEntryBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Bond number provided by CBP */
  bondNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  bondReferenceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** CBP collection status */
  collectionStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The CBP Daily Statement number. */
  dailyStatementNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<UsCbpEntryTypeCodeSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Indicates whether immediate delivery is enabled for the entry. */
  immediateDeliveryIndicator?: InputMaybe<UsCbpEntryReleaseImmediateDeliverySearchCriteriaInput>;
  /** The date the shipment physically arrives in the US. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** In-bond number */
  inBondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<UsCbpEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The CBP Periodic Monthly Statement number. */
  periodicStatementNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDisposition?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's US port of unlading. */
  portOfUnladingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDisposition?: InputMaybe<TextSearchCriteriaInput>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReason?: InputMaybe<TextSearchCriteriaInput>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: InputMaybe<UsCbpEntryReleaseStatusSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotificationType?: InputMaybe<UsCbpEntrySummaryNotificationSearchCriteriaInput>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReason?: InputMaybe<TextSearchCriteriaInput>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<UsCbpEntrySummaryStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Total of all invoice product line count */
  totalInvoiceLineCount?: InputMaybe<IntSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** TBD */
export type UsConsumptionEntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsConsumptionEntrySearchTableRow';
  /** The Us Consumption Entry badge. Example: Hot */
  badge?: Maybe<Array<UsConsumptionEntryBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Bond number provided by CBP */
  bondNumber?: Maybe<Scalars['String']>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** CBP collection status */
  collectionStatus?: Maybe<Scalars['String']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The CBP Daily Statement number. */
  dailyStatementNumber?: Maybe<Scalars['String']>;
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  examSite?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Indicates whether immediate delivery is enabled for the entry. */
  immediateDeliveryIndicator?: Maybe<Scalars['String']>;
  /** The date the shipment physically arrives in the US. */
  importDate?: Maybe<Scalars['String']>;
  /** In-bond number */
  inBondNumber?: Maybe<Array<Scalars['String']>>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The CBP Periodic Monthly Statement number. */
  periodicStatementNumber?: Maybe<Scalars['String']>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDisposition?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingName?: Maybe<Scalars['String']>;
  /** The shipment's US port of unlading. */
  portOfUnladingName?: Maybe<Scalars['String']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: Maybe<Scalars['String']>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: Maybe<Scalars['String']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDisposition?: Maybe<Array<Scalars['String']>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReason?: Maybe<Array<Scalars['String']>>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: Maybe<Scalars['String']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** A notification from US CBP via an ABI UC message. */
  summaryNotificationType?: Maybe<UsCbpEntrySummaryNotificationType>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReason?: Maybe<Array<Scalars['String']>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: Maybe<Scalars['String']>;
  /** Sum of all invoice product lines count, useful in task estimation. */
  totalInvoiceLineCount?: Maybe<Scalars['Int']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsConsumptionEntryServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'UsConsumptionEntryServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: Maybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: Maybe<UsConsumptionEntryServiceLevelAgreementMatchingCriteria>;
};

export type UsConsumptionEntryServiceLevelAgreementInput = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: InputMaybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: InputMaybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: InputMaybe<UsConsumptionEntryServiceLevelAgreementMatchingCriteriaInput>;
};

export type UsConsumptionEntryServiceLevelAgreementMatchingCriteria = {
  __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria';
  /** Badges specified by an SLA */
  badges?: Maybe<Array<UsConsumptionEntryBadge>>;
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: Maybe<Array<ModeOfTransport>>;
};

export type UsConsumptionEntryServiceLevelAgreementMatchingCriteriaInput = {
  /** Badges specified by an SLA */
  badges?: InputMaybe<Array<UsConsumptionEntryBadge>>;
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: InputMaybe<Array<ModeOfTransport>>;
};

export type UsConsumptionEntrySupplier = {
  __typename?: 'UsConsumptionEntrySupplier';
  /** Party address */
  address?: Maybe<Address>;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  mid?: Maybe<Scalars['UsCbpMid']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsConsumptionEntryPointOfContact>;
  /** The manufacturer is related with the importer. */
  related?: Maybe<Scalars['Boolean']>;
  /** The Supplier record. */
  supplier?: Maybe<Supplier>;
};

export type UsConsumptionEntrySupplierInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  mid?: InputMaybe<Scalars['UsCbpMid']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsConsumptionEntryPointOfContactInput>;
  /** The manufacturer is related with the importer. */
  related?: InputMaybe<Scalars['Boolean']>;
  /** The Supplier record. */
  supplier?: InputMaybe<IdVersionInput>;
};

export type UsConsumptionEntryTariff = {
  __typename?: 'UsConsumptionEntryTariff';
  /** Duties owed to US CBP for this tariff. */
  charges?: Maybe<UsCbpEntryTariffCharges>;
  /** Additional optional PGA requirements. */
  extraPgaFlags?: Maybe<Array<UsPgaFlag>>;
  /** The HTS record. */
  hts?: Maybe<UsHts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Partner Government Agency data requirements. */
  pga?: Maybe<UsConsumptionEntryPgaRequirements>;
  /** The description of the tariff reported to the PGA. */
  pgaDescription?: Maybe<UsTariffPgaDescription>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type UsConsumptionEntryTariffInput = {
  /** Duties owed to US CBP for this tariff. */
  charges?: InputMaybe<UsCbpEntryTariffChargesInput>;
  /** Additional optional PGA requirements. */
  extraPgaFlags?: InputMaybe<Array<UsPgaFlag>>;
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Partner Government Agency data requirements. */
  pga?: InputMaybe<UsConsumptionEntryPgaRequirementsInput>;
  /** The description of the tariff reported to the PGA. */
  pgaDescription?: InputMaybe<UsTariffPgaDescriptionInput>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type UsConsumptionEntryTransactionInput = {
  /** Whether or not the transaction should upsertRelease */
  upsertRelease?: InputMaybe<Scalars['Boolean']>;
};

/** A US IOR's continuous customs bond. */
export type UsContinuousCustomsBond = {
  __typename?: 'UsContinuousCustomsBond';
  /** The amount of coverage the bond provides. */
  amount: Scalars['UsDollars'];
  /** The effective date of the importer's customs bond. */
  effectiveDate: Scalars['Date'];
  /** The unique number identifying the importer's customs bond. */
  number: Scalars['String'];
  /** The renewal date of the importer's customs bond. */
  renewalDate?: Maybe<Scalars['Date']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  suretyCode: Scalars['String'];
  /** The termination date of the importer's customs bond. */
  terminationDate?: Maybe<Scalars['Date']>;
  /** The CBP type code of the bond. */
  typeCode: Scalars['String'];
};

/** A US IOR's continuous customs bond. */
export type UsContinuousCustomsBondInput = {
  /** The amount of coverage the bond provides. */
  amount: Scalars['UsDollars'];
  /** The effective date of the importer's customs bond. */
  effectiveDate: Scalars['Date'];
  /** The unique number identifying the importer's customs bond. */
  number: Scalars['String'];
  /** The renewal date of the importer's customs bond. */
  renewalDate?: InputMaybe<Scalars['Date']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  suretyCode: Scalars['String'];
  /** The termination date of the importer's customs bond. */
  terminationDate?: InputMaybe<Scalars['Date']>;
  /** The CBP type code of the bond. */
  typeCode: Scalars['String'];
};

/** Past, present, and future US CPB continuous bond information. */
export type UsContinuousCustomsBonds = {
  __typename?: 'UsContinuousCustomsBonds';
  /** A continuous yet to take effect. */
  future?: Maybe<UsContinuousCustomsBond>;
  /** A list of continuous bonds no longer active. */
  past?: Maybe<Array<UsContinuousCustomsBond>>;
  /** The active continuous bond. */
  present?: Maybe<UsContinuousCustomsBond>;
};

/** Past, present, and future US CPB continuous bond information. */
export type UsContinuousCustomsBondsInput = {
  /** A continuous yet to take effect. */
  future?: InputMaybe<UsContinuousCustomsBondInput>;
  /** A list of continuous bonds no longer active. */
  past?: InputMaybe<Array<UsContinuousCustomsBondInput>>;
  /** The active continuous bond. */
  present?: InputMaybe<UsContinuousCustomsBondInput>;
};

/** US CPSC PGA Program for eFiling */
export type UsCpscPgaProgram = {
  __typename?: 'UsCpscPgaProgram';
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: Maybe<Scalars['String']>;
  /** Certificate declaration indicating certification status (PG22) */
  certificateDeclaration?: Maybe<CertificateDeclaration>;
  /** Certificate type - CPC (Children's Product) or GCC (General Certificate) */
  certificateType?: Maybe<CpscCertificateType>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: Maybe<UsPgaDisclaimerCode>;
  /** Global Identifier (GTIN/UPC) */
  globalIdentifier?: Maybe<GlobalProductIdentifier>;
  /** Intended use of the product/component */
  intendedUseDetails?: Maybe<IntendedUse>;
  /** Items array - Empty for DISCLAIM, populated for FULL/REF processing types */
  items?: Maybe<Array<CpscItem>>;
  /** CPSC processing type for the product */
  processingType: CpscProcessingType;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: Maybe<Scalars['String']>;
};

/** US CPSC PGA Program for eFiling */
export type UsCpscPgaProgramInput = {
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: InputMaybe<Scalars['String']>;
  /** Certificate declaration indicating certification status (PG22) */
  certificateDeclaration?: InputMaybe<CertificateDeclarationInput>;
  /** Certificate type - CPC (Children's Product) or GCC (General Certificate) */
  certificateType?: InputMaybe<CpscCertificateType>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: InputMaybe<UsPgaDisclaimerCode>;
  /** Global Identifier (GTIN/UPC) */
  globalIdentifier?: InputMaybe<GlobalProductIdentifierInput>;
  /** Intended use of the product/component */
  intendedUseDetails?: InputMaybe<IntendedUseInput>;
  /** Items array - Empty for DISCLAIM, populated for FULL/REF processing types */
  items?: InputMaybe<Array<CpscItemInput>>;
  /** CPSC processing type for the product */
  processingType: CpscProcessingType;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: InputMaybe<Scalars['String']>;
};

export type UsCustomsBroker = CustomsBroker & Party & Record & {
  __typename?: 'UsCustomsBroker';
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Assignment teams working with the broker */
  assignmentTeams?: Maybe<Array<AssignmentTeam>>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** The document sign request associated with the US Customs Broker. This is an eventually consistent query. */
  documentSignRequests: Array<DocumentSignRequest>;
  /** The documents associated with the US Customs Broker. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein: Scalars['EmployeeIdentificationNumber'];
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** Entity name of the broker. */
  entityName?: Maybe<BrokerEntityName>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes */
  filerCode: Scalars['UsCbpFilerCode'];
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** Broker-level configurations relating to IOR activations involving this broker. */
  iorActivationConfig?: Maybe<BrokerIorActivationConfig>;
  /** Logo for the party */
  logo?: Maybe<Document>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** Party name */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** A Shipper linked to this US Customs Broker */
  shipper: ShipperUsCustomsBrokerRelationship;
  /** Shipper connection used to paginate results. */
  shippers: UsCustomsBrokerShippersConnection;
  /** Signature Details for the party */
  signature?: Maybe<Signature>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** User teams working with the broker */
  userTeams?: Maybe<Array<UserTeams>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsCustomsBrokerdocumentSignRequestsArgs = {
  statuses?: InputMaybe<Array<DocumentSignRequestStatus>>;
};


export type UsCustomsBrokerdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsCustomsBrokermemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsCustomsBrokershipperArgs = {
  shipperId: Scalars['ID'];
};


export type UsCustomsBrokershippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type UsCustomsBrokerEdge = ConnectionEdge & {
  __typename?: 'UsCustomsBrokerEdge';
  cursor: Scalars['ID'];
  node: UsCustomsBroker;
};

export type UsCustomsBrokerSearchCriteriaInput = {
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** Assignment teams working with the broker */
  assignmentTeams?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** A business's EIN number provided by the IRS. */
  ein?: InputMaybe<EmployeeIdentificationNumberSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes */
  filerCode?: InputMaybe<UsCbpFilerCodeSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** User teams working with the broker */
  userTeams?: InputMaybe<IdSearchCriteriaInput>;
};

export type UsCustomsBrokerSearchTableRow = {
  __typename?: 'UsCustomsBrokerSearchTableRow';
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** A business's EIN number provided by the IRS. */
  ein: Scalars['EmployeeIdentificationNumber'];
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** A 3 character Filer Code representing a US Customs Broker with CBP. The official list maintined by US CBP is at https://www.cbp.gov/trade/document/report/filer-codes */
  filerCode: Scalars['UsCbpFilerCode'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Party's name */
  name: Scalars['String'];
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UsCustomsBrokerShipperEdge = ConnectionEdge & {
  __typename?: 'UsCustomsBrokerShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and US Customs Broker. */
  relationship: ShipperUsCustomsBrokerRelationship;
};

export type UsCustomsBrokerShippersConnection = Connection & {
  __typename?: 'UsCustomsBrokerShippersConnection';
  edges: Array<UsCustomsBrokerShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsCustomsBrokersConnection = Connection & {
  __typename?: 'UsCustomsBrokersConnection';
  edges: Array<UsCustomsBrokerEdge>;
  nodes: Array<UsCustomsBroker>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsCustomsFililingIneligibility = {
  __typename?: 'UsCustomsFililingIneligibility';
  /** Condition(s) that failed when determining eligibility for filing type */
  failedConditions: Array<UsFilingTypeEligibilityConditionName>;
  /** Ineligible filing type given the input */
  filingType: UsFilingType;
};

export type UsCustomsFilingClassification = {
  __typename?: 'UsCustomsFilingClassification';
  /** Recommended filing type given the input */
  filingType: UsFilingType;
};

/** Indicates action covered by drawback claim */
export enum UsDrawbackActionIndicator {
  DESTROYED = 'DESTROYED',
  EXPORTED = 'EXPORTED',
  FTZ = 'FTZ',
  GOVERNMENT_MAIL = 'GOVERNMENT_MAIL',
  LADEN_AS_SUPPLIES = 'LADEN_AS_SUPPLIES',
  MAIL_SHIPMENT = 'MAIL_SHIPMENT',
  MANUFACTURED = 'MANUFACTURED',
  TRANSPORT = 'TRANSPORT',
  VESSEL_OR_AIRCRAFTS = 'VESSEL_OR_AIRCRAFTS'
}

export type UsDrawbackClaim = Record & WorkOrder & {
  __typename?: 'UsDrawbackClaim';
  /** Export Entries should match the CBP Data. */
  TFTEAExportDestroyArticles?: Maybe<Array<UsDrawbackClaimExportDestroyArticle>>;
  /** Requesting Accelerated Payment and Bond is required. If filing a Drawback claim with the Accelerated Payment Request Indicator, please be informed that accelerated refunds will be paid on the first successfully accepted version of the claim without bond related errors. If updates are made to the claimed amount after the first successfully accepted version, the updated amount will be paid upon liquidation. */
  acceleratedPayment?: Maybe<Scalars['Boolean']>;
  /** Bond Details */
  bond?: Maybe<UsDrawbackClaimBond>;
  /** An indication that the bond has been waived in accordance with regulation. */
  bondWaiverIndicator?: Maybe<Scalars['Boolean']>;
  /** A code explaining the reason the bond has been waived in accordance with regulation(s). */
  bondWaiverReasonCode?: Maybe<Scalars['UsBondWaiverReasonCode']>;
  /** US Customs Broker associated with this entry. */
  broker?: Maybe<UsDrawbackClaimBroker>;
  /** The broker reference number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** List of rejection reasons */
  cbpRejectionReasons?: Maybe<Array<UsCbpDrawbackClaimRejectionReason>>;
  /** Drawback Claim CBP Status */
  cbpStatus?: Maybe<UsCbpDrawbackClaimStatus>;
  /** Claimant */
  claimant?: Maybe<UsIorNumber>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the US Drawback Claim. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Drawback Claim reference for Imports, TFTEAExportDestroyArticles and cbpRejectionReasons. */
  drawbackClaimReference?: Maybe<DrawbackClaimReference>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: Maybe<Scalars['String']>;
  /** The drawback provision code. */
  drawbackProvision?: Maybe<Scalars['UsDrawbackProvisionCode']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** Import Entries should match the CBP Data. */
  imports?: Maybe<Array<UsDrawbackClaimImport>>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** For Core and TFTEA Drawback, the approval letter must be provided or provide the date of the OTW application submission to CBP on company letterhead and upload it to DIS. Use the following format: “The OTW application was filed on [date] at the port of [insert port name].” */
  oneTimeWaiverIndicator?: Maybe<Scalars['Boolean']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** Waiver Prior Notice. */
  waiverPriorNotice?: Maybe<Scalars['Boolean']>;
};


export type UsDrawbackClaimdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UsDrawbackClaimBond = {
  __typename?: 'UsDrawbackClaimBond';
  /** Bond number */
  accountNumber?: Maybe<Scalars['String']>;
  /** The $ amount of coverage. */
  amount?: Maybe<Scalars['Int']>;
  /** Bond number provided by CBP */
  bondNumber?: Maybe<Scalars['String']>;
  /** An indication of the type of bond coverage required for the accelerated payment of duties, fees, and taxes, when required. */
  bondType?: Maybe<Scalars['UsBondTypeCode']>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Bond surety code */
  suretyCode?: Maybe<Scalars['String']>;
};

export type UsDrawbackClaimBondInput = {
  /** Bond number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** The $ amount of coverage. */
  amount?: InputMaybe<Scalars['Int']>;
  /** Bond number provided by CBP */
  bondNumber?: InputMaybe<Scalars['String']>;
  /** An indication of the type of bond coverage required for the accelerated payment of duties, fees, and taxes, when required. */
  bondType?: InputMaybe<Scalars['UsBondTypeCode']>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  referenceNumber?: InputMaybe<Scalars['String']>;
  /** Bond surety code */
  suretyCode?: InputMaybe<Scalars['String']>;
};

export type UsDrawbackClaimBroker = {
  __typename?: 'UsDrawbackClaimBroker';
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsDrawbackClaimBrokerInfoInput = {
  address: AddressInput;
  /** The broker's email. */
  email?: InputMaybe<Scalars['Email']>;
  name: Scalars['String'];
  phone: PhoneInput;
};

export type UsDrawbackClaimBrokerInput = {
  /** ID of the US Customs Broker */
  usCustomsBroker: IdInput;
};

/** The transaction representing a US Drawback Claim related request and response to US CBP via ABI. */
export type UsDrawbackClaimCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usDrawbackClaim: UsDrawbackClaim;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsDrawbackClaimClassification = {
  __typename?: 'UsDrawbackClaimClassification';
  /** Provide a description of the imported merchandise */
  articleDescriptionText?: Maybe<Scalars['String']>;
  /** A numeric code from the Harmonized Tariff Schedule that describes/classifies the article.  */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Quantities as describes in import document. */
  quantities?: Maybe<Array<UsDrawbackClaimQuantity>>;
};

export type UsDrawbackClaimClassificationInput = {
  /** Provide a description of the imported merchandise */
  articleDescriptionText?: InputMaybe<Scalars['String']>;
  /** A numeric code from the Harmonized Tariff Schedule that describes/classifies the article.  */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Quantities as describes in import document. */
  quantities?: InputMaybe<Array<UsDrawbackClaimQuantityInput>>;
};

export type UsDrawbackClaimDisTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usDrawbackClaim: UsDrawbackClaim;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsDrawbackClaimDocumentBond = {
  __typename?: 'UsDrawbackClaimDocumentBond';
  /** STB Account Number */
  accountNumber?: Maybe<Scalars['String']>;
  /** The $ amount of coverage. */
  amount?: Maybe<Scalars['Int']>;
  /** An indication of the type of bond coverage required for the accelerated payment of duties, fees, and taxes, when required. */
  bondType?: Maybe<Scalars['UsBondTypeCode']>;
  /** Bond surety code */
  suretyCode?: Maybe<Scalars['String']>;
};

export type UsDrawbackClaimDocumentBrokerInfo = {
  __typename?: 'UsDrawbackClaimDocumentBrokerInfo';
  address: Address;
  /** The broker's email. */
  email?: Maybe<Scalars['Email']>;
  name: Scalars['String'];
  phone: Phone;
};

/** Us Drawback Claim document generation request. */
export type UsDrawbackClaimDocumentGenerationRequest = DocumentGenerationRequest & Record & {
  __typename?: 'UsDrawbackClaimDocumentGenerationRequest';
  /** Broker associated with US Drawback Claim. */
  bond: UsDrawbackClaimDocumentBond;
  /** Broker associated with US Drawback Claim. */
  broker: UsDrawbackClaimDocumentBrokerInfo;
  /** List of rejection reasons */
  cbpRejectionReasons?: Maybe<Array<UsDrawbackClaimDocumentRejectionReason>>;
  /** Drawback Claim CBP Status */
  cbpStatus?: Maybe<UsDrawbackClaimDocumentStatus>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Document associated with the document generation request. */
  document?: Maybe<Document>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: Maybe<Scalars['String']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Date on which the Drawback Claim Response is received. */
  responseReceiveDate?: Maybe<Scalars['DateTime']>;
  /** Status of Document Generation Request */
  status: DocumentGenerationStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

/** Error details of the latest US CBP Drawback Claim (DE) rejection. */
export type UsDrawbackClaimDocumentRejectionReason = {
  __typename?: 'UsDrawbackClaimDocumentRejectionReason';
  /** The rejection reason code */
  code: Scalars['String'];
  /** The rejection reason */
  reason: Scalars['String'];
};

/** Status of the Drawback Claim (DE) filing with CBP. */
export enum UsDrawbackClaimDocumentStatus {
  FILED = 'FILED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type UsDrawbackClaimEdge = ConnectionEdge & {
  __typename?: 'UsDrawbackClaimEdge';
  cursor: Scalars['ID'];
  node: UsDrawbackClaim;
};

export type UsDrawbackClaimExportDestroyArticle = {
  __typename?: 'UsDrawbackClaimExportDestroyArticle';
  /** Provide a description of the exported merchandise */
  articleDescriptionText?: Maybe<Scalars['String']>;
  /** Carrier code on the bill of lading. */
  billOfLadingCarrierCode?: Maybe<Scalars['String']>;
  /** Country of Ultimate Destination. */
  countryOfUltimateDestination?: Maybe<Scalars['CountryCode']>;
  /** Export/Destroy Date. */
  exportDestroyDate?: Maybe<Scalars['Date']>;
  /** Export/Destroy Indicator. */
  exportDestroyIndicator?: Maybe<UsDrawbackExportDestroyIndicator>;
  /** A numeric code from the Harmonized Tariff Schedule that describes/classifies the article. */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Import Tracking Identification Number is unique identifier within Drawback */
  importTrackingIdentificationNumbers?: Maybe<Array<Scalars['Int']>>;
  /** Record the name of the firm or individual who exported/destroyed/transferred the article. */
  nameOfExporterDestroyer?: Maybe<Scalars['String']>;
  /** Notice of Intent Grouping is optional. Refer to current policy for guidance as it’s relates to CBP Form 7553. */
  noticeOfIntentIndicator?: Maybe<Scalars['Boolean']>;
  /** Record the quantity (as shown on the import invoice) of the designated merchandise or drawback product used for the exported or destroyed article. Four decimal places are implied. */
  quantity?: Maybe<Scalars['Float']>;
  /** List the export bill of lading or invoice number of the shipping document to evidence exportation */
  uniqueIdentifierNumber?: Maybe<Scalars['String']>;
  /** A unit of measure code that corresponds to the Quantity */
  unitOfMeasureCode?: Maybe<Scalars['UsDrawbackUnitOfMeasureCode']>;
};

export type UsDrawbackClaimExportDestroyArticleInput = {
  /** Provide a description of the exported merchandise */
  articleDescriptionText?: InputMaybe<Scalars['String']>;
  /** Carrier code on the bill of lading. */
  billOfLadingCarrierCode?: InputMaybe<Scalars['String']>;
  /** Country of Ultimate Destination. */
  countryOfUltimateDestination?: InputMaybe<Scalars['CountryCode']>;
  /** Export/Destroy Date. */
  exportDestroyDate?: InputMaybe<Scalars['Date']>;
  /** Export/Destroy Indicator. */
  exportDestroyIndicator?: InputMaybe<UsDrawbackExportDestroyIndicator>;
  /** A numeric code from the Harmonized Tariff Schedule that describes/classifies the article. */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Import Tracking Identification Number is unique identifier within Drawback */
  importTrackingIdentificationNumbers?: InputMaybe<Array<Scalars['Int']>>;
  /** Record the name of the firm or individual who exported/destroyed/transferred the article. */
  nameOfExporterDestroyer?: InputMaybe<Scalars['String']>;
  /** Notice of Intent Grouping is optional. Refer to current policy for guidance as it’s relates to CBP Form 7553. */
  noticeOfIntentIndicator?: InputMaybe<Scalars['Boolean']>;
  /** Record the quantity (as shown on the import invoice) of the designated merchandise or drawback product used for the exported or destroyed article. Four decimal places are implied. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** List the export bill of lading or invoice number of the shipping document to evidence exportation */
  uniqueIdentifierNumber?: InputMaybe<Scalars['String']>;
  /** A unit of measure code that corresponds to the Quantity */
  unitOfMeasureCode?: InputMaybe<Scalars['UsDrawbackUnitOfMeasureCode']>;
};

export type UsDrawbackClaimImport = {
  __typename?: 'UsDrawbackClaimImport';
  /** Indicate the code that applies to the actions covered by this drawback claim. */
  actionIndicator: UsDrawbackActionIndicator;
  /** CBP ES Line Number. Not allowed in 1313 D. */
  cbpEntrySummaryLineNumber?: Maybe<Scalars['Int']>;
  /** HTS Classification for the line entry as describes in import document. */
  classifications: Array<UsDrawbackClaimClassification>;
  /** Drawback Accounting Method */
  drawbackAccountingMethodCode: Scalars['UsDrawbackAccountingMethodCode'];
  /** Drawback Eligible or Certificate of Delivery (CD) on file Refer to current policy for guidance relates to CBP Form 7552. */
  drawbackEligible?: Maybe<Scalars['Boolean']>;
  /** Unique Number portion of Import Entry Summary you are designating. */
  entryNumber?: Maybe<Scalars['UsEntryNumber']>;
  /** Import Tracking Identification Number is unique identifier within Drawback */
  importTrackingIdentificationNumber?: Maybe<Scalars['Int']>;
  /** Revenues claimed. */
  revenuesClaimed: Array<UsDrawbackClaimRevenue>;
};

export type UsDrawbackClaimImportInput = {
  /** Indicate the code that applies to the actions covered by this drawback claim. */
  actionIndicator: UsDrawbackActionIndicator;
  /** CBP ES Line Number. Not allowed in 1313 D. */
  cbpEntrySummaryLineNumber?: InputMaybe<Scalars['Int']>;
  /** HTS Classification for the line entry as describes in import document. */
  classifications: Array<UsDrawbackClaimClassificationInput>;
  /** Drawback Accounting Method */
  drawbackAccountingMethodCode: Scalars['UsDrawbackAccountingMethodCode'];
  /** Drawback Eligible or Certificate of Delivery (CD) on file Refer to current policy for guidance relates to CBP Form 7552. */
  drawbackEligible?: InputMaybe<Scalars['Boolean']>;
  /** Unique Number portion of Import Entry Summary you are designating. */
  entryNumber?: InputMaybe<Scalars['UsEntryNumber']>;
  /** Import Tracking Identification Number is unique identifier within Drawback */
  importTrackingIdentificationNumber?: InputMaybe<Scalars['Int']>;
  /** Revenues claimed. */
  revenuesClaimed: Array<UsDrawbackClaimRevenueInput>;
};

export type UsDrawbackClaimQuantity = {
  __typename?: 'UsDrawbackClaimQuantity';
  /** Record the quantity (as shown on the import invoice) of the designated merchandise or drawback product used for the exported or destroyed article. Four decimal places are implied. */
  allowableQuantity?: Maybe<Scalars['Float']>;
  /** The value of the imported merchandise is the per unit value based on the customs (invoice) value of the imported merchandise upon entry into the United States. Four decimal places are implied. */
  enteredValuePerUnit: Scalars['Float'];
  /** Record the quantity (as shown on the import invoice) of the designated merchandise or drawback product used for the exported or destroyed article. Four decimal places are implied. */
  quantity: Scalars['Float'];
  /** The substituted value per unit (SVU) is determined based on the provision under which TFTEA substitution drawback is claimed and is only reported when a “lesser of rule” is applicable to the claim per 19 U.S.C. 1313(l). Four decimal places are implied. */
  subsitutedValuePerUnit?: Maybe<Scalars['Float']>;
  /** A unit of measure code that corresponds to the Quantity */
  unitOfMeasureCode: Scalars['UsDrawbackUnitOfMeasureCode'];
};

export type UsDrawbackClaimQuantityInput = {
  /** Record the quantity (as shown on the import invoice) of the designated merchandise or drawback product used for the exported or destroyed article. Four decimal places are implied. */
  allowableQuantity?: InputMaybe<Scalars['Float']>;
  /** The value of the imported merchandise is the per unit value based on the customs (invoice) value of the imported merchandise upon entry into the United States. Four decimal places are implied. */
  enteredValuePerUnit: Scalars['Float'];
  /** Record the quantity (as shown on the import invoice) of the designated merchandise or drawback product used for the exported or destroyed article. Four decimal places are implied. */
  quantity: Scalars['Float'];
  /** The substituted value per unit (SVU) is determined based on the provision under which TFTEA substitution drawback is claimed and is only reported when a “lesser of rule” is applicable to the claim per 19 U.S.C. 1313(l). Four decimal places are implied. */
  subsitutedValuePerUnit?: InputMaybe<Scalars['Float']>;
  /** A unit of measure code that corresponds to the Quantity */
  unitOfMeasureCode: Scalars['UsDrawbackUnitOfMeasureCode'];
};

/** Error details of the latest US CBP Drawback Claim (DE) rejection. */
export type UsDrawbackClaimRejectionReasonInput = {
  /** The rejection reason code */
  code: Scalars['String'];
  /** The rejection reason */
  reason: Scalars['String'];
};

export type UsDrawbackClaimRevenue = {
  __typename?: 'UsDrawbackClaimRevenue';
  /** CBP accounting classification code representing a specific fee type. */
  accountingClassCode: Scalars['UsDrawbackAccountingClassCode'];
  /** The claim amount is the actual amount of the refund claimed in U.S. dollars and cents (calculated to two decimal places). */
  calculatedAmount: Scalars['UsDollars'];
  /** The claim amount is the actual amount of the refund claimed in U.S. dollars and cents (calculated to two decimal places). */
  claimAmount: Scalars['UsDollars'];
};

export type UsDrawbackClaimRevenueInput = {
  /** CBP accounting classification code representing a specific fee type. */
  accountingClassCode: Scalars['UsDrawbackAccountingClassCode'];
  /** The claim amount is the actual amount of the refund claimed in U.S. dollars and cents (calculated to two decimal places). */
  calculatedAmount: Scalars['UsDollars'];
  /** The claim amount is the actual amount of the refund claimed in U.S. dollars and cents (calculated to two decimal places). */
  claimAmount: Scalars['UsDollars'];
};

export type UsDrawbackClaimSearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The broker reference number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** UsDrawbackClaim Cbp Status */
  cbpStatus?: InputMaybe<UsCbpDrawbackClaimStatusSearchCriteriaInput>;
  /** Claimant Id */
  claimant?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The drawback provision code. */
  drawbackProvision?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Entry Number */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Import Entry Number */
  importEntryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Import HTS Number */
  importHTSNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

export type UsDrawbackClaimSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsDrawbackClaimSearchTableRow';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The broker reference number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** UsDrawbackClaim Cbp Status */
  cbpStatus?: Maybe<Scalars['String']>;
  /** Claimant Id */
  claimant?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The code for the U.S. port that the Drawback Claim is being filed. */
  drawbackFilingPortCode?: Maybe<Scalars['String']>;
  /** The drawback provision code. */
  drawbackProvision?: Maybe<Scalars['String']>;
  /** Entry Number */
  entryNumber?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Import Entry Number */
  importEntryNumber?: Maybe<Array<Scalars['String']>>;
  /** Import HTS Number */
  importHTSNumber?: Maybe<Array<Scalars['String']>>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsDrawbackClaimsConnection = Connection & {
  __typename?: 'UsDrawbackClaimsConnection';
  edges: Array<UsDrawbackClaimEdge>;
  nodes: Array<UsDrawbackClaim>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsDrawbackDocumentClaimBondInput = {
  /** STB Account Number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** The $ amount of coverage. */
  amount?: InputMaybe<Scalars['Int']>;
  /** An indication of the type of bond coverage required for the accelerated payment of duties, fees, and taxes, when required. */
  bondType?: InputMaybe<Scalars['UsBondTypeCode']>;
  /** Bond surety code */
  suretyCode?: InputMaybe<Scalars['String']>;
};

/** Indicates imports subsequantly destroyed or exported. */
export enum UsDrawbackExportDestroyIndicator {
  DESTROYED = 'DESTROYED',
  EXPORTED = 'EXPORTED'
}

export type UsEntrySingleTransactionBond = {
  __typename?: 'UsEntrySingleTransactionBond';
  /** Bond number */
  accountNumber?: Maybe<Scalars['String']>;
  /** The $ amount of coverage. */
  amount?: Maybe<Scalars['Int']>;
  /** Bond number provided by CBP */
  bondNumber?: Maybe<Scalars['String']>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Bond surety code */
  suretyCode?: Maybe<Scalars['String']>;
};

export type UsEntrySingleTransactionBondInput = {
  /** Bond number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** The $ amount of coverage. */
  amount?: InputMaybe<Scalars['Int']>;
  /** Bond number provided by CBP */
  bondNumber?: InputMaybe<Scalars['String']>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  referenceNumber?: InputMaybe<Scalars['String']>;
  /** Bond surety code */
  suretyCode?: InputMaybe<Scalars['String']>;
};

export enum UsFdaDrugForm {
  API = 'API',
  FINISHED = 'FINISHED'
}

export type UsFdaFoodFacilityRegistration = {
  __typename?: 'UsFdaFoodFacilityRegistration';
  /** FDA Prior Notice (PN) Manufacturer Food Processing Facility Registration Exemption. Used by: FDA (prior notice food) */
  exemption?: Maybe<FoodFacilityRegistrationExemption>;
  /** FDA Prior Notice (PN) Manufacturer Food Processing Facility Registration Number. Used by: FDA (prior notice food) */
  number?: Maybe<Scalars['String']>;
};

export type UsFdaFoodFacilityRegistrationInput = {
  /** FDA Prior Notice (PN) Manufacturer Food Processing Facility Registration Exemption. Used by: FDA (prior notice food) */
  exemption?: InputMaybe<FoodFacilityRegistrationExemption>;
  /** FDA Prior Notice (PN) Manufacturer Food Processing Facility Registration Number. Used by: FDA (prior notice food) */
  number?: InputMaybe<Scalars['String']>;
};

export enum UsFdaLaboratoryType {
  ITL = 'ITL',
  LAB = 'LAB'
}

export type UsFdaPriorNotice = {
  __typename?: 'UsFdaPriorNotice';
  /** Whether the FDA prior-notice (PN) are not applicable to the product/component. Used by: FDA */
  conditionsNotApplicable?: Maybe<Scalars['Boolean']>;
  /** The Prior Notice Confirmation Number if PN requirements have previously been met. Used by: FDA */
  confirmationNumber?: Maybe<Scalars['String']>;
};

export type UsFdaPriorNoticeInput = {
  /** Whether the FDA prior-notice (PN) are not applicable to the product/component. Used by: FDA */
  conditionsNotApplicable?: InputMaybe<Scalars['Boolean']>;
  /** The Prior Notice Confirmation Number if PN requirements have previously been met. Used by: FDA */
  confirmationNumber?: InputMaybe<Scalars['String']>;
};

/** FDA Affirmation of Compliance Code for Form FDA-2877 */
export type UsFdaRadiationDeclarationComplianceCode = {
  __typename?: 'UsFdaRadiationDeclarationComplianceCode';
  /** FDA Affirmation of Compliance Code for Form FDA-2877 */
  type: UsFdaRadiationDeclarationComplianceCodeType;
  /** Value of the AOC */
  value: Scalars['String'];
};

/** FDA Affirmation of Compliance Code for Form FDA-2877 */
export enum UsFdaRadiationDeclarationComplianceCodeType {
  RA1 = 'RA1',
  RA2 = 'RA2',
  RA3 = 'RA3',
  RA4 = 'RA4',
  RA5 = 'RA5',
  RA6 = 'RA6',
  RA7 = 'RA7',
  RB1 = 'RB1',
  RB2 = 'RB2',
  RC1 = 'RC1',
  RC2 = 'RC2',
  RD1 = 'RD1',
  RD2 = 'RD2',
  RD3 = 'RD3'
}

export enum UsFdaRadiationEmittingDeviceForm {
  COMPONENT = 'COMPONENT',
  FINISHED = 'FINISHED'
}

/** Type of filing with US CBP */
export enum UsFilingType {
  US_CONSUMPTION_ENTRY = 'US_CONSUMPTION_ENTRY',
  US_TYPE86_ENTRY = 'US_TYPE86_ENTRY'
}

/** Name of condition used to determine eligibility for a filing type */
export enum UsFilingTypeEligibilityConditionName {
  HAS_AD_CVD_CASE = 'HAS_AD_CVD_CASE',
  HAS_FEES = 'HAS_FEES',
  HAS_NO_AD_CVD_CASE = 'HAS_NO_AD_CVD_CASE',
  HAS_NO_FEES = 'HAS_NO_FEES',
  IS_NOT_TYPE_86_ELIGIBLE = 'IS_NOT_TYPE_86_ELIGIBLE',
  IS_TYPE_86_ELIGIBLE = 'IS_TYPE_86_ELIGIBLE',
  TOTAL_SHIPMENT_VALUE_GREATER_THAN_DE_MINIMIS = 'TOTAL_SHIPMENT_VALUE_GREATER_THAN_DE_MINIMIS',
  TOTAL_SHIPMENT_VALUE_LESS_THAN_OR_EQUAL_TO_DE_MINIMIS = 'TOTAL_SHIPMENT_VALUE_LESS_THAN_OR_EQUAL_TO_DE_MINIMIS'
}

export type UsHts = Hs & Record & {
  __typename?: 'UsHts';
  /** May be subject to anti-dumping duties. */
  ad?: Maybe<Scalars['Boolean']>;
  /** Anti-dumping and Countervailing duty (ADD/CVD) active case Ids */
  adCvdCases?: Maybe<Array<AdCvdCase>>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additional?: Maybe<Array<AdditionalHts>>;
  /** Additional Tariff may be required. */
  additionalHTS?: Maybe<Scalars['Boolean']>;
  /** The additional HTS number that may be required. */
  additionalHtsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Additional HTS number requirements. Typically added as the first Tariff of a Line. */
  additionalHtssApplicable?: Maybe<Array<AdditionalHts>>;
  /** The type of HTS when used as an additional tariff. */
  additionalTariffType?: Maybe<AdditionalHtsType>;
  /** The effective end date provided by ACE CATAIR. It may differ from the top-level endDate. */
  cbpEndDate?: Maybe<Scalars['Date']>;
  /** The effective start date provided by ACE CATAIR. It may differ from the top-level startDate. */
  cbpStartDate?: Maybe<Scalars['Date']>;
  /** Compliance notes */
  complianceNotes?: Maybe<Array<HtsComplianceNote>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** May be subject to countervailing duties. */
  cv?: Maybe<Scalars['Boolean']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Longer description of Tariff. */
  description?: Maybe<Scalars['String']>;
  /** Descriptions of Tariff. */
  descriptions?: Maybe<Array<HtsDescription>>;
  /** Ending effective date. */
  endDate?: Maybe<Scalars['Date']>;
  /** Fees required, also used for taxes. */
  fees?: Maybe<Array<HtsFee>>;
  /** Country of origin codes not permitted to use with the Generalized System of Preferences SPI (A*). */
  gspExcluded?: Maybe<Array<Scalars['String']>>;
  /** HS number type */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** License data potentially required on an entry. */
  license?: Maybe<HtsLicense>;
  /** License code required on Line. */
  licenseCode?: Maybe<Scalars['String']>;
  /** License name required on Line */
  licenseName?: Maybe<Scalars['String']>;
  /** Column one rate object used to calculate duty that may apply to HS during different time intervals. */
  mainDutyRates?: Maybe<Array<HtsRate>>;
  /** Represents a HS number. */
  number: Scalars['HtsNumber'];
  /** Partner Government Agency data potentially required on an entry. */
  pga?: Maybe<Array<PgaRequirement>>;
  principalAdCvdCases?: Maybe<Array<UsPrincipalAdCvdCase>>;
  /** May be subject to a quota. */
  quota?: Maybe<Scalars['Boolean']>;
  /** Rate object used to calculate duty. */
  rate?: Maybe<HtsRate>;
  /** Duty computation code. */
  rateCode?: Maybe<Scalars['String']>;
  /** Readable duty calculation formula. */
  rateString?: Maybe<Scalars['String']>;
  /** Restrictions on HTS number usage. */
  restriction?: Maybe<HtsRestriction>;
  /** Column two rate object used to calculate duty that may apply to HS during different time intervals. */
  secondaryDutyRates?: Maybe<Array<HtsRate>>;
  /** Section 301 Exclusion */
  section301Exclusion?: Maybe<Section301Exclusion>;
  /** Special Program Indicators available to use, subject to country of origin. */
  spi?: Maybe<Array<Spi>>;
  /** Special rates based on different SPIs. */
  spiRates?: Maybe<Array<HtsSpiRate>>;
  /** Beginning effective date. */
  startDate?: Maybe<Scalars['Date']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Description of Tariff. */
  text?: Maybe<Scalars['String']>;
  /** Textile code. */
  textile?: Maybe<Scalars['String']>;
  /** Section 301 (Trump Tariffs) list number. */
  trumpList?: Maybe<Scalars['TrumpList']>;
  /** Truncated description of Tariff. */
  truncatedDescription?: Maybe<Scalars['String']>;
  /** Required unit of measure reporting quantities. */
  uom?: Maybe<Array<Scalars['String']>>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsHtsadditionalHtssApplicableArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']>;
};

export type UsHtsEdge = ConnectionEdge & {
  __typename?: 'UsHtsEdge';
  cursor: Scalars['ID'];
  node: UsHts;
};

export type UsHtsSearchCriteria = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The effective end date. */
  endDate?: InputMaybe<DateSearchCriteriaInput>;
  /** HS number type. */
  hsNumberType?: InputMaybe<HsNumberTypeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** HS number. */
  number?: InputMaybe<TextSearchCriteriaInput>;
  /** The effective start date. */
  startDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** UsHts search table row. */
export type UsHtsSearchTableRow = HsSearchTableRow & HtsSearchTableRow & RecordSearchTableRow & {
  __typename?: 'UsHtsSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The effective end date. */
  endDate?: Maybe<Scalars['Date']>;
  /** HS number type. */
  hsNumberType?: Maybe<HsNumberType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** HTS number. */
  number: Scalars['HtsNumber'];
  /** The effective start date. */
  startDate?: Maybe<Scalars['Date']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UsHtssConnection = Connection & {
  __typename?: 'UsHtssConnection';
  edges: Array<UsHtsEdge>;
  nodes: Array<UsHts>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsInBond = Record & WorkOrder & {
  __typename?: 'UsInBond';
  /** The arrival information */
  arrival?: Maybe<UsInBondArrival>;
  /** The badges associated with this entry. */
  badges?: Maybe<Array<UsInBondBadge>>;
  /** US Customs Broker associated with this UsInBond. */
  broker: UsInBondBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The collection of CbpInBonds for the UsInBond work order */
  cbpInBonds: Array<CbpInBond>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Consignee associated with this UsInBond. */
  consignee?: Maybe<UsInBondConsignee>;
  /** The container numbers for the UsInBond */
  containerNumbers?: Maybe<Array<Scalars['String']>>;
  /** The conveyance information */
  conveyance?: Maybe<UsInBondConveyance>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The departure information */
  departure?: Maybe<UsInBondDeparture>;
  /** The documents associated with the US In-Bond. This is an eventually consistent query. */
  documents: Array<Document>;
  /** The date of entry for the UsInBond */
  entryDate?: Maybe<Scalars['Date']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** IOR associated with this UsInBond. */
  ior?: Maybe<UsInBondIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the shipment. */
  masterBills?: Maybe<Array<UsInBondMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The mode of transport for the shipment */
  modeOfTransport: ModeOfTransport;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsInBonddocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UsInBondArrival = {
  __typename?: 'UsInBondArrival';
  /** The port where cargo is discharged in arrival country. */
  portOfUnlading?: Maybe<Scalars['UsCbpPortCode']>;
  /** Arrival time of the shipment. */
  time?: Maybe<Scalars['DateTime']>;
};

export type UsInBondArrivalInput = {
  /** The port where cargo is discharged in arrival country. */
  portOfUnlading?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** Arrival time of the shipment. */
  time?: InputMaybe<Scalars['DateTime']>;
};

/** The US InBond badge. Example: Hot */
export enum UsInBondBadge {
  BIXD = 'BIXD',
  CBAM = 'CBAM',
  DG = 'DG',
  HOT = 'HOT',
  MULTIVAT = 'MULTIVAT',
  PREMIUM = 'PREMIUM',
  REFILE = 'REFILE'
}

/** The US InBond badge. Example: Hot */
export type UsInBondBadgeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsInBondBadge>>;
};

export type UsInBondBroker = {
  __typename?: 'UsInBondBroker';
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsInBondBrokerInput = {
  /** ID of the US Customs Broker */
  usCustomsBroker: IdInput;
};

/** The transaction representing a US In-Bond related request and response to US CBP via ABI. */
export type UsInBondCbpTransaction = {
  /** The index of the CbpInBond in the cbpInBonds array of the UsInBond the transaction is being created for. */
  cbpInBondIndex: Scalars['Int'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usInBond: UsInBond;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsInBondConsignee = {
  __typename?: 'UsInBondConsignee';
  /** Party addresses */
  addresses?: Maybe<Addresses>;
  /** The name of the UsConsignee. */
  name?: Maybe<Scalars['String']>;
  /** UsConsignee details */
  usConsignee: UsConsignee;
};

export type UsInBondConsigneeInput = {
  /** Party addresses */
  addresses?: InputMaybe<AddressesInput>;
  /** The name of the UsConsignee. */
  name?: InputMaybe<Scalars['String']>;
  /** Id version of the UsConsignee */
  usConsignee: IdVersionInput;
};

export type UsInBondConveyance = {
  __typename?: 'UsInBondConveyance';
  /** Whether the goods are containerized. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
};

export type UsInBondConveyanceInput = {
  /** Whether the goods are containerized. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type UsInBondDeparture = {
  __typename?: 'UsInBondDeparture';
  /** Departure country of the shipment leg. */
  country?: Maybe<Scalars['CountryCode']>;
  /** The port where shipment gets loaded in departure country. */
  portOfLading?: Maybe<Scalars['UsCbpForeignPortCode']>;
  /** Departure time of the shipment leg. */
  time?: Maybe<Scalars['DateTime']>;
};

export type UsInBondDepartureInput = {
  /** Departure country of the shipment leg. */
  country?: InputMaybe<Scalars['CountryCode']>;
  /** The port where shipment gets loaded in departure country. */
  portOfLading?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
  /** Departure time of the shipment leg. */
  time?: InputMaybe<Scalars['DateTime']>;
};

export type UsInBondEdge = ConnectionEdge & {
  __typename?: 'UsInBondEdge';
  cursor: Scalars['ID'];
  node: UsInBond;
};

export type UsInBondHouseBill = {
  __typename?: 'UsInBondHouseBill';
  /** House bill number */
  number?: Maybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: Maybe<Scalars['Int']>;
};

export type UsInBondHouseBillInput = {
  /** House bill number */
  number?: InputMaybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UsInBondIor = {
  __typename?: 'UsInBondIor';
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<UsIorNumber>;
  /** The name of the usIor. */
  name?: Maybe<Scalars['String']>;
  /** UsIor details */
  usIor: UsIor;
};

export type UsInBondIorInput = {
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** The name of the usIor. */
  name?: InputMaybe<Scalars['String']>;
  /** Id version of the IOR */
  usIor: IdVersionInput;
};

export type UsInBondMasterBill = {
  __typename?: 'UsInBondMasterBill';
  /** Array of house bills */
  houseBills?: Maybe<Array<UsInBondHouseBill>>;
  /** Master bill number */
  number?: Maybe<Scalars['String']>;
};

export type UsInBondMasterBillInput = {
  /** Array of house bills */
  houseBills?: InputMaybe<Array<UsInBondHouseBillInput>>;
  /** Master bill number */
  number?: InputMaybe<Scalars['String']>;
};

/** The INLT CBP in-bond Number identifying the in-bond movement, a 9 digit number made up of an 8 digit "base" number followed by a "check" digit */
export type UsInBondNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsInBondNumber']>>;
};

export type UsInBondPayload = {
  __typename?: 'UsInBondPayload';
  /** The updated UsInBond */
  usInBond: UsInBond;
};

export type UsInBondSearchCriteriaInput = {
  /** The US InBond badge. Example: Hot */
  badge?: InputMaybe<UsInBondBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The SCAC code for the carrier of the CbpInBond */
  carrierCode?: InputMaybe<ScacSearchCriteriaInput>;
  /** The EIN number of the bonded carrier of the CbpInBond */
  carrierEin?: InputMaybe<EmployeeIdentificationNumberSearchCriteriaInput>;
  /** The Trucker ID carrying the goods for the CbpInBond. */
  carrierTruckerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Trucker name carrying the goods for the CbpInBond. */
  carrierTruckerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The UsConsignee ID associated with the CbpInBond. */
  cbpInBondConsigneeId?: InputMaybe<IdSearchCriteriaInput>;
  /** The UsConsignee name associated with the CbpInBond. */
  cbpInBondConsigneeName?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the CbpInBond */
  cbpInBondModeOfTransport?: InputMaybe<ModeOfTransportSearchCriteriaInput>;
  /** The status of the CbpInBond */
  cbpInBondStatus?: InputMaybe<CbpInBondStatusSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The UsConsignee ID */
  consigneeId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the UsConsignee */
  consigneeName?: InputMaybe<TextSearchCriteriaInput>;
  /** The container numbers for the UsInBond */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Departure country of the shipment leg. */
  departureCountry?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The date of entry for the UsInBond */
  entryDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The type of in-bond movement */
  entryType?: InputMaybe<CbpInBondEntryTypeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The port of destination for a T&E ‘62’ or IE ‘63’ entries. */
  foreignPortOfDestination?: InputMaybe<UsCbpForeignPortCodeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** The FIRMS code representing where the goods are at right now */
  goodsNowAt?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The importing conveyance arrival port for the CbpInBond */
  importingConveyanceArrivalPort?: InputMaybe<UsCbpPortCodeSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bills associated with the shipment. */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the shipment */
  modeOfTransport?: InputMaybe<ModeOfTransportSearchCriteriaInput>;
  /** The INLT CBP in-bond Number identifying the in-bond movement, a 9 digit number made up of an 8 digit "base" number followed by a "check" digit */
  number?: InputMaybe<UsInBondNumberSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The port where shipment gets loaded in departure country. */
  portOfLadingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The port where cargo is discharged in arrival country. */
  portOfUnladingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The port of termination for an IT ‘61’ entry, or the port of exportation for a T&E ‘62’ entry, or the port of arrival for an IT ‘63’entry. */
  usPortOfDestination?: InputMaybe<UsCbpPortCodeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** UsInBond search result */
export type UsInBondSearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsInBondSearchTableRow';
  /** The US InBond badge. Example: Hot */
  badge?: Maybe<Array<UsInBondBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The SCAC code for the carrier of the CbpInBond */
  carrierCode?: Maybe<Array<Scalars['SCACCode']>>;
  /** The EIN number of the bonded carrier of the CbpInBond */
  carrierEin?: Maybe<Array<Scalars['EmployeeIdentificationNumber']>>;
  /** The Trucker ID carrying the goods for the CbpInBond. */
  carrierTruckerId?: Maybe<Array<Scalars['ID']>>;
  /** The Trucker name carrying the goods for the CbpInBond. */
  carrierTruckerName?: Maybe<Array<Scalars['String']>>;
  /** The UsConsignee ID associated with the CbpInBond. */
  cbpInBondConsigneeId?: Maybe<Array<Scalars['ID']>>;
  /** The UsConsignee name associated with the CbpInBond. */
  cbpInBondConsigneeName?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the CbpInBond */
  cbpInBondModeOfTransport?: Maybe<Array<ModeOfTransport>>;
  /** The status of the CbpInBond */
  cbpInBondStatus?: Maybe<Array<CbpInBondStatus>>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** The UsConsignee ID */
  consigneeId?: Maybe<Scalars['ID']>;
  /** The name of the UsConsignee */
  consigneeName?: Maybe<Scalars['String']>;
  /** The container numbers for the UsInBond */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Departure country of the shipment leg. */
  departureCountry?: Maybe<Scalars['CountryCode']>;
  /** The date of entry for the UsInBond */
  entryDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** The type of in-bond movement */
  entryType?: Maybe<Array<CbpInBondEntryType>>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The port of destination for a T&E ‘62’ or IE ‘63’ entries. */
  foreignPortOfDestination?: Maybe<Array<Scalars['UsCbpForeignPortCode']>>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** The FIRMS code representing where the goods are at right now */
  goodsNowAt?: Maybe<Array<Scalars['FirmsCode']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The importing conveyance arrival port for the CbpInBond */
  importingConveyanceArrivalPort?: Maybe<Array<Scalars['UsCbpPortCode']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<Scalars['UsIorNumberValue']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the shipment. */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the shipment */
  modeOfTransport?: Maybe<ModeOfTransport>;
  /** The INLT CBP in-bond Number identifying the in-bond movement, a 9 digit number made up of an 8 digit "base" number followed by a "check" digit */
  number?: Maybe<Array<Scalars['UsInBondNumber']>>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The port where shipment gets loaded in departure country. */
  portOfLadingName?: Maybe<Scalars['UsCbpForeignPortCode']>;
  /** The port where cargo is discharged in arrival country. */
  portOfUnladingName?: Maybe<Scalars['UsCbpPortCode']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** The port of termination for an IT ‘61’ entry, or the port of exportation for a T&E ‘62’ entry, or the port of arrival for an IT ‘63’entry. */
  usPortOfDestination?: Maybe<Array<Scalars['UsCbpPortCode']>>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsInBondServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'UsInBondServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: Maybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: Maybe<UsInBondServiceLevelAgreementMatchingCriteria>;
};

export type UsInBondServiceLevelAgreementMatchingCriteria = {
  __typename?: 'UsInBondServiceLevelAgreementMatchingCriteria';
  /** Badges specified by an SLA */
  badges?: Maybe<Array<UsInBondBadge>>;
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: Maybe<Array<ModeOfTransport>>;
};

export type UsInBondsConnection = Connection & {
  __typename?: 'UsInBondsConnection';
  edges: Array<UsInBondEdge>;
  nodes: Array<UsInBond>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsIor = Ior & Party & Record & {
  __typename?: 'UsIor';
  /** Indicate whether the filer is paying duties to U.S CBP using ACH(Automated Clearinghouse) Credit method or not. */
  achCredit?: Maybe<Scalars['Boolean']>;
  /** Activation status of US IOR. */
  activationStatus?: Maybe<UsIorActivationStatus>;
  /** Activation time of US IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** Activations of US IOR. */
  activations?: Maybe<Array<UsIorActivationDetails>>;
  /** List of addresses (WCO Data Model v4.0.0 compliant). */
  addressList?: Maybe<Array<AddressV2>>;
  /** Party addresses, note: this field is maintained for backward schema compatibility, clients should use 'addressList' field instead of this field */
  addresses?: Maybe<Addresses>;
  /** Party alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** Bank information of the IOR on the US CBP 5106 */
  bank?: Maybe<UsCbp5106BankDetails>;
  /** Information collected when the importer applies for a bond through Amazon. */
  bondApplicationInformation?: Maybe<BondApplicationInformation>;
  /** A description of the Importer's business */
  businessDescription?: Maybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: Maybe<UsBusinessStructure>;
  /** Importer business website */
  businessWebsite?: Maybe<Scalars['String']>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** Error details of the latest US CBP 5106 rejection. */
  cbp5106RejectionReasons?: Maybe<Array<UsCbp5106RejectedReason>>;
  /** The mailing address type. */
  cbpMailingAddressType?: Maybe<UsCbp5106AddressType>;
  /** If an IOR number is requested from CBP, set it to true */
  cbpNumberHelp?: Maybe<Scalars['Boolean']>;
  /** Reason(s) for requesting a CBP assigned number for a US IOR. */
  cbpNumberReasons?: Maybe<Array<UsIorCbpAssignedNumberReason>>;
  /** The physical address type. */
  cbpPhysicalAddressType?: Maybe<UsCbp5106AddressType>;
  /** The US IOR's status with CBP. */
  cbpStatus?: Maybe<UsIorCbpStatus>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Details for manifest confidentiality */
  confidentiality?: Maybe<UsIorConfidentialityDetails>;
  /** A list of the IOR's continuous customs bonds. */
  continuousBonds?: Maybe<UsContinuousCustomsBonds>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Party description */
  description?: Maybe<Scalars['String']>;
  /** Identifier for DocReadiness status of Importer in ShipDocs system */
  docReadinessId?: Maybe<Scalars['String']>;
  /** The document sign request associated with the US IOR. This is an eventually consistent query. */
  documentSignRequests: Array<DocumentSignRequest>;
  /** The documents associated with the US IOR. This is an eventually consistent query. */
  documents: Array<Document>;
  /** DPS record for this usIor */
  dpsRecord?: Maybe<DpsRecord>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party email */
  email?: Maybe<Scalars['Email']>;
  /** The code for the IOR's expected import volume. */
  entriesPerYearCode?: Maybe<UsCbp5106EntriesPerYearCode>;
  /** US IOR entry summary email addresses. */
  entrySummaryContactEmails?: Maybe<Array<Scalars['Email']>>;
  /** Business establishment details on the Importer's US CBP 5106 form. */
  establishment?: Maybe<UsCbp5106EstablishmentDetails>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Is it the first time the Importer of Record has been used in the US? */
  firstTimeStatus?: Maybe<UsIorFirstTimeStatus>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Party identifiers list such as vat number, duns etc. */
  identifiers?: Maybe<Array<PartyIdentification>>;
  /** The linked Importer. */
  importer?: Maybe<Importer>;
  /** Details of up to 3 individual members of the IOR reported on the US CBP form 5106. */
  individuals?: Maybe<Array<UsCbp5106Individual>>;
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<UsIorNumber>;
  /** Indicate whether the IOR is a resident importer. */
  isResident?: Maybe<Scalars['Boolean']>;
  /** Has the IOR submitted before */
  isSubmittedBefore?: Maybe<Scalars['Boolean']>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** A 6-digit North American Industry Classification Systems code unique to the importer. */
  naics?: Maybe<Scalars['String']>;
  /** Party name */
  name: Scalars['String'];
  /** Used for tracking systems or users that have interacted with the IOR record. These entities are candidates that might be notified about events related to the IOR. */
  notifyClientList?: Maybe<Array<Scalars['ID']>>;
  /** Non resident signing officer email. */
  nrccOfficerEmail?: Maybe<Scalars['Email']>;
  /** An officer of the company authorized to assign power of attorney. */
  officer?: Maybe<PointOfContact>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The unique payer unit number assigned by CPB to each direct ACH payer. See https://help.inlt.com/customs-brokerage/how-to-pay-your-duties-directly-to-customs-and-border-protection. */
  payerUnitNumber?: Maybe<Scalars['UsCbpPayerUnitNumber']>;
  /** Payment terms offered to US IOR */
  paymentTerms?: Maybe<UsIorPaymentTerms>;
  /** Details of the payment terms update */
  paymentTermsUpdated?: Maybe<RecordAction>;
  /** A US IOR individual's personal effects information. */
  personalEffects?: Maybe<UsIorPersonalEffects>;
  /** Party phone number */
  phone?: Maybe<Phone>;
  /** Time at which the PMS was activated. This is not null only when pmsRequestedTime is not null and pmsStatus === ACTIVE */
  pmsActivationTime?: Maybe<Scalars['DateTime']>;
  /** Time at which the PMS activation Request was sent. */
  pmsRequestedTime?: Maybe<Scalars['DateTime']>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: Maybe<UsIorPmsStatus>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: Maybe<POAMethod>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** The US IORs preferred payment method on an entry */
  preferredCbpEntryPaymentMethod?: Maybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** The US CBP Importer Programs the IOR participates in. */
  programCodes?: Maybe<Array<UsCbpImporterProgramCode>>;
  /** A public party is visible to all users and can be used by all organizations */
  public?: Maybe<Scalars['String']>;
  /** Details of a current or previous separate business related to IOR reported on the US CBP form 5106. */
  relatedBusinesses?: Maybe<Array<UsCbp5106RelatedBusiness>>;
  /** A Shipper linked to this US IOR */
  shipper: ShipperUsIorRelationship;
  /** Shipper connection used to paginate results. */
  shippers: UsIorShippersConnection;
  /** Source channel identifier */
  sourceChannel?: Maybe<SourceChannel>;
  /** Source portal identifier */
  sourcePortal?: Maybe<SourcePortal>;
  /** The status of a US Ior e.g. ACTIVE, CANCELED */
  status?: Maybe<UsIorStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** If a DUNS number is required for customs filing but is not known, set to true. */
  unknownDuns?: Maybe<Scalars['Boolean']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCodes?: Maybe<Array<Scalars['VendorCode']>>;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsIordocumentSignRequestsArgs = {
  statuses?: InputMaybe<Array<DocumentSignRequestStatus>>;
};


export type UsIordocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsIormemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsIorshipperArgs = {
  shipperId: Scalars['ID'];
};


export type UsIorshippersArgs = {
  input?: InputMaybe<CursorPaginationInput>;
};

export type UsIorActivation = Record & WorkOrder & {
  __typename?: 'UsIorActivation';
  /** US Customs Broker associated with the activation. */
  broker: UsIorActivationBroker;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the US IOR Activation . This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** US IOR to be activated. */
  ior?: Maybe<UsIorActivationIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsIorActivationdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UsIorActivationBroker = {
  __typename?: 'UsIorActivationBroker';
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsIorActivationBrokerInput = {
  /** ID of the US Customs Broker */
  usCustomsBroker?: InputMaybe<IdInput>;
};

export type UsIorActivationDetails = {
  __typename?: 'UsIorActivationDetails';
  /** Ior activation details. */
  activated?: Maybe<RecordAction>;
  /** Customs broker who activated the Ior. */
  customsBroker: UsCustomsBroker;
  /** Ior rejection details. */
  rejected?: Maybe<RecordAction>;
  /** Reasons for broker rejecting the Ior. */
  rejectionReasons?: Maybe<Array<BrokerRejectionReason>>;
  /** Ior activation status. */
  status?: Maybe<ActivationStatus>;
};

export type UsIorActivationDetailsInput = {
  /** Customs broker who activated the Ior. */
  customsBroker: IdInput;
  /** Reasons for broker rejecting the Ior. */
  rejectionReasons?: InputMaybe<Array<BrokerRejectionReason>>;
  /** Ior activation status. */
  status?: InputMaybe<ActivationStatus>;
};

export type UsIorActivationEdge = ConnectionEdge & {
  __typename?: 'UsIorActivationEdge';
  cursor: Scalars['ID'];
  node: UsIorActivation;
};

export type UsIorActivationIor = {
  __typename?: 'UsIorActivationIor';
  /** UsIor details */
  usIor: UsIor;
};

export type UsIorActivationIorInput = {
  /** Id and optional version of the IOR */
  usIor: IdOptionalVersionInput;
};

export type UsIorActivationSearchCriteriaInput = {
  /** Activation status of US IOR. */
  activationStatus?: InputMaybe<UsIorActivationStatusSearchCriteriaInput>;
  /** Activation time of US IOR. */
  activationTime?: InputMaybe<DateSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** US IOR's bond Anniversary date. */
  bondAnniversary?: InputMaybe<DateSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructureSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The US IOR's status with CBP */
  cbpStatus?: InputMaybe<UsIorCbpStatusSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The IOR ID */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Ior Name */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The IOR Number. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** US IOR is currently in bond or not */
  isBond?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The US IORs preferred payment method on an entry */
  paymentMethod?: InputMaybe<UsIorCbpEntryPreferredPaymentMethodSearchCriteriaInput>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: InputMaybe<UsIorPmsStatusSearchCriteriaInput>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: InputMaybe<POAMethodSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** US IOR Activation search result */
export type UsIorActivationSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsIorActivationSearchTableRow';
  /** Activation status of US IOR. */
  activationStatus?: Maybe<UsIorActivationStatus>;
  /** Activation time of US IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** US IOR's bond anniversary date. */
  bondAnniversary?: Maybe<Scalars['Date']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The structure of the US business. */
  businessStructure?: Maybe<UsBusinessStructure>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The US IOR's status with CBP. */
  cbpStatus?: Maybe<UsIorCbpStatus>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The industry of the IOR */
  industry?: Maybe<Vertical>;
  /** The IOR ID */
  iorId?: Maybe<Scalars['ID']>;
  /** Ior Name */
  iorName?: Maybe<Scalars['String']>;
  /** The IOR Number. */
  iorNumber?: Maybe<Scalars['UsIorNumberValue']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** US IOR is currently in bond or not */
  isBond?: Maybe<Scalars['String']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The US IORs preferred payment method on an entry */
  paymentMethod?: Maybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: Maybe<UsIorPmsStatus>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: Maybe<POAMethod>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

/** Activation status of UsIor */
export enum UsIorActivationStatus {
  ACTIVATED = 'ACTIVATED',
  DELETED = 'DELETED',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  PENDING_CERT = 'PENDING_CERT',
  PENDING_DIRECT = 'PENDING_DIRECT',
  PENDING_DIRECT_CERT = 'PENDING_DIRECT_CERT',
  PENDING_INQUIRY = 'PENDING_INQUIRY',
  PENDING_MASTER = 'PENDING_MASTER',
  PENDING_MASTER_CERT = 'PENDING_MASTER_CERT',
  PENDING_MASTER_SUB = 'PENDING_MASTER_SUB',
  PENDING_MASTER_SUB_CERT = 'PENDING_MASTER_SUB_CERT',
  PENDING_SUB = 'PENDING_SUB',
  PENDING_SUB_CERT = 'PENDING_SUB_CERT',
  REJECTED = 'REJECTED'
}

/** The type industry of the Ior. */
export type UsIorActivationStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIorActivationStatus>>;
};

export type UsIorActivationsConnection = Connection & {
  __typename?: 'UsIorActivationsConnection';
  edges: Array<UsIorActivationEdge>;
  nodes: Array<UsIorActivation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Reason for requesting a CBP Assigned Number for a US IOR. */
export enum UsIorCbpAssignedNumberReason {
  HAS_SSN_NEEDS_CBP = 'HAS_SSN_NEEDS_CBP',
  NOT_US_RESIDENT = 'NOT_US_RESIDENT',
  NO_IRS = 'NO_IRS',
  NO_IRS_OR_SSN = 'NO_IRS_OR_SSN',
  NO_SSN = 'NO_SSN'
}

/** The US IORs preferred payment method on an entry */
export enum UsIorCbpEntryPreferredPaymentMethod {
  CHECK = 'CHECK',
  DAILY_STATEMENT = 'DAILY_STATEMENT',
  DIRECT_DAILY_STATEMENT = 'DIRECT_DAILY_STATEMENT',
  DIRECT_PERIODIC_MONTHLY_STATEMENT = 'DIRECT_PERIODIC_MONTHLY_STATEMENT',
  INDIRECT_DAILY_STATEMENT = 'INDIRECT_DAILY_STATEMENT',
  INDIRECT_PERIODIC_MONTHLY_STATEMENT = 'INDIRECT_PERIODIC_MONTHLY_STATEMENT',
  PERIODIC_MONTHLY_STATEMENT = 'PERIODIC_MONTHLY_STATEMENT'
}

/** The US IORs preferred payment method on an entry */
export type UsIorCbpEntryPreferredPaymentMethodSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIorCbpEntryPreferredPaymentMethod>>;
};

/** The US IOR's status with CBP. */
export enum UsIorCbpStatus {
  ACTIVE_NO_BOND = 'ACTIVE_NO_BOND',
  ACTIVE_WITH_BOND = 'ACTIVE_WITH_BOND',
  INACTIVE = 'INACTIVE',
  NOT_ON_FILE = 'NOT_ON_FILE',
  VOIDED = 'VOIDED'
}

/** The US IOR's status with CBP. */
export type UsIorCbpStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIorCbpStatus>>;
};

/** The transaction representing a US IOR related request and response to US CBP via ABI. */
export type UsIorCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usIor: UsIor;
  /** The record's version */
  version: Scalars['Int'];
};

/** Details for manifest confidentiality */
export type UsIorConfidentialityDetails = {
  __typename?: 'UsIorConfidentialityDetails';
  /** Time at which the Manifest Confidentiality was activated. */
  approvalTime?: Maybe<Scalars['DateTime']>;
  /** manifest confidentiality status is active for two years and can be renewed 60-90 days prior to expiration date. This field is the last date when the status can be active */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Time at which the Manifest Confidentiality was requested. */
  requestedTime?: Maybe<Scalars['DateTime']>;
  /** The US IOR's Manifest Confidentiality Status */
  status?: Maybe<UsIorConfidentialityStatus>;
};

/** Details for manifest confidentiality */
export type UsIorConfidentialityInput = {
  /** Time at which the Manifest Confidentiality was activated. */
  approvalTime?: InputMaybe<Scalars['DateTime']>;
  /** manifest confidentiality status is active for two years and can be renewed 60-90 days prior to expiration date. This field is the last date when the status can be active */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /** Time at which the Manifest Confidentiality was requested. */
  requestedTime?: InputMaybe<Scalars['DateTime']>;
  /** The US IOR's Manifest Confidentiality Status */
  status?: InputMaybe<UsIorConfidentialityStatus>;
};

/** The US IOR's enrollment status in the CBP Manifest Confidentiality program. */
export enum UsIorConfidentialityStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type UsIorContinuousBondRequest = Record & WorkOrder & {
  __typename?: 'UsIorContinuousBondRequest';
  /** The amount of the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  bondAmount?: Maybe<Scalars['UsDollars']>;
  /** The date that the bond can start to be used for US customs entry filings. */
  bondEffectiveDate?: Maybe<Scalars['Date']>;
  /** The unique number identifying the usIor's customs bond. */
  bondNumber?: Maybe<Scalars['String']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  bondSuretyCode?: Maybe<Scalars['String']>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the US IOR Continuous Bond Request. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** Estimated duties, taxes, and fees paid in the next 12 months (used to determine if it will exceed $500,000). */
  nextYearShippingValueEstimate?: Maybe<Scalars['UsDollars']>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Estimated duties, taxes, and fees paid in the pervious 12 months (used to determine if it will exceed $500,000). */
  previousYearShippingValueEstimate?: Maybe<Scalars['UsDollars']>;
  /** A short description of each product being imported. */
  productDescriptions?: Maybe<Array<Scalars['String']>>;
  /** The country codes from which goods originate. */
  productOriginCountryCodes?: Maybe<Array<Scalars['CountryCode']>>;
  /** A RecordAction signifying when the renewal was requested to be canceled */
  renewalCanceled?: Maybe<RecordAction>;
  /** The ARN of the dacia schedule for the renewal. The `cancelUsIorContinuousBondRequestRenewal` mutation must be used to cancel it. */
  renewalScheduleArn?: Maybe<Scalars['String']>;
  /** The amount requested for the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  requestedBondAmount?: Maybe<Scalars['UsDollars']>;
  /** Bond risk details for the continuous bond */
  risk?: Maybe<UsIorContinuousBondRequestBondRisk>;
  /** The Shipper associated with the UsIorContinuousBondRequest. Returns the latest version. */
  shipper: Shipper;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Reference number provided by the surety and sent back in the BS ABI message. This can be used to tie this ABI message to the initial bond request. */
  suretyReferenceNumber?: Maybe<Scalars['String']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The UsIor associated with the UsIorContinuousBondRequest. Returns the latest version. */
  usIor: UsIor;
  /** Whether incentive pricing should be used on this continuous bond */
  useIncentivePricing?: Maybe<Scalars['Boolean']>;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsIorContinuousBondRequestdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UsIorContinuousBondRequestBondRisk = {
  __typename?: 'UsIorContinuousBondRequestBondRisk';
  /** Whether the product list contains alcohol */
  alcohol?: Maybe<Scalars['Boolean']>;
  /** Whether the product list contains electric cigarettes */
  ecig?: Maybe<Scalars['Boolean']>;
  /** Whether the product list contains honey */
  honey?: Maybe<Scalars['Boolean']>;
  /** Whether the product list contains human */
  human?: Maybe<Scalars['Boolean']>;
  /** Whether the product list contains tobacco */
  tobacco?: Maybe<Scalars['Boolean']>;
  /** The type of risk for the continuous bond */
  type: Scalars['String'];
};

export type UsIorContinuousBondRequestBondRiskInput = {
  /** Whether the product list contains alcohol */
  alcohol?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product list contains electric cigarettes */
  ecig?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product list contains honey */
  honey?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product list contains human */
  human?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product list contains tobacco */
  tobacco?: InputMaybe<Scalars['Boolean']>;
  /** The type of risk for the continuous bond */
  type: Scalars['String'];
};

export type UsIorContinuousBondRequestEdge = ConnectionEdge & {
  __typename?: 'UsIorContinuousBondRequestEdge';
  cursor: Scalars['ID'];
  node: UsIorContinuousBondRequest;
};

export type UsIorContinuousBondRequestSearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The amount of the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  bondAmount?: InputMaybe<TextSearchCriteriaInput>;
  /** The unique number identifying the usIor's customs bond. */
  bondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  bondSuretyCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Importer of Record number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** A short description of each product being imported. */
  productDescription?: InputMaybe<TextSearchCriteriaInput>;
  /** The country codes from which goods originate. */
  productOriginCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** Renewal canceled date of the bond associated with this work order */
  renewalCanceledDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Renewal date of the bond associated with this work order */
  renewalDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Renewal scheduled (Y/N) for the bond associated with this work order */
  renewalScheduled?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** Reference number provided by the surety and sent back in the BS ABI message. This can be used to tie this ABI message to the initial bond request. */
  suretyReferenceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Termination date of the bond associated with this work order */
  terminationDate?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The UsIor ID associated with the UsIorContinuousBondRequest. */
  usIorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The UsIor name associated with the UsIorContinuousBondRequest. */
  usIorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Whether incentive pricing should be used on this continuous bond */
  useIncentivePricingIndicator?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

export type UsIorContinuousBondRequestSearchTableRow = RecordSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsIorContinuousBondRequestSearchTableRow';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The amount of the importer's customs bond. More info: https://help.cbp.gov/app/answers/detail/a_id/276/related/1 */
  bondAmount?: Maybe<Scalars['String']>;
  /** The unique number identifying the usIor's customs bond. */
  bondNumber?: Maybe<Scalars['String']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  bondSuretyCode?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Importer of Record number registered with US CBP. */
  iorNumber?: Maybe<Scalars['UsIorNumberValue']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** A short description of each product being imported. */
  productDescription?: Maybe<Array<Scalars['String']>>;
  /** The country codes from which goods originate. */
  productOriginCountryCode?: Maybe<Array<Scalars['CountryCode']>>;
  /** Renewal canceled date of the bond associated with this work order */
  renewalCanceledDate?: Maybe<Scalars['DateTime']>;
  /** Renewal date of the bond associated with this work order */
  renewalDate?: Maybe<Scalars['DateTime']>;
  /** Renewal scheduled (Y/N) for the bond associated with this work order */
  renewalScheduled?: Maybe<Scalars['String']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** Reference number provided by the surety and sent back in the BS ABI message. This can be used to tie this ABI message to the initial bond request. */
  suretyReferenceNumber?: Maybe<Scalars['String']>;
  /** Termination date of the bond associated with this work order */
  terminationDate?: Maybe<Scalars['DateTime']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** The UsIor ID associated with the UsIorContinuousBondRequest. */
  usIorId?: Maybe<Scalars['ID']>;
  /** The UsIor name associated with the UsIorContinuousBondRequest. */
  usIorName?: Maybe<Scalars['String']>;
  /** Whether incentive pricing should be used on this continuous bond */
  useIncentivePricingIndicator?: Maybe<Scalars['String']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsIorContinuousBondRequestServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
};

export type UsIorContinuousBondRequestServiceLevelAgreementInput = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: InputMaybe<Scalars['Float']>;
};

export type UsIorContinuousBondRequestsConnection = Connection & {
  __typename?: 'UsIorContinuousBondRequestsConnection';
  edges: Array<UsIorContinuousBondRequestEdge>;
  nodes: Array<UsIorContinuousBondRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsIorEdge = ConnectionEdge & {
  __typename?: 'UsIorEdge';
  cursor: Scalars['ID'];
  node: UsIor;
};

/** Is it the first time the Importer of Record has been used in the US? */
export enum UsIorFirstTimeStatus {
  NO = 'NO',
  UNKNOWN = 'UNKNOWN',
  YES = 'YES'
}

/** Importer of Record Number registered with US CBP. */
export type UsIorNumber = {
  __typename?: 'UsIorNumber';
  /** Can be an Employee Identification Number, Social Security Number, or a CBP Assigned Number. */
  type: UsIorNumberType;
  /** The IOR Number. */
  value: Scalars['UsIorNumberValue'];
};

/** Importer of Record Number registered with US CBP. */
export type UsIorNumberInput = {
  /** Can be an Employee Identification Number, Social Security Number, or a CBP Assigned Number. */
  type: UsIorNumberType;
  /** The IOR Number. */
  value: Scalars['UsIorNumberValue'];
};

/** CBP response for US Ior Number query. */
export type UsIorNumberQueryResponse = {
  __typename?: 'UsIorNumberQueryResponse';
  /** Us Ior number query response addresses. */
  addresses?: Maybe<UsIorNumberQueryResponseAddresses>;
  /** The US IOR's status with CBP. */
  cbpStatus: UsIorCbpStatus;
  /** Impoter/consignee CEE(Centers of Excellence and Expertise) data. */
  cee?: Maybe<UsIorNumberQueryResponseCeeDetails>;
  /** A list of continuous bonds. */
  continuousBonds?: Maybe<Array<UsIorNumberQueryResponseContinuousBond>>;
  /** Full legal name of importer/consignee. */
  fullLegalName?: Maybe<Scalars['String']>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber: UsIorNumber;
  /** Name of importer/consignee on CBP file */
  name?: Maybe<Scalars['String']>;
  /** Name associated with nameQualifierCode */
  nameLine2?: Maybe<Scalars['String']>;
  /** A code of DBA (doing business as), DIV (Division), or AKA (also known as) */
  nameQualifierCode?: Maybe<Scalars['String']>;
  /** A code of DBA (doing business as), DIV (Division), or AKA (also known as) */
  nameQualilfierCode?: Maybe<Scalars['String']>;
  /** An indication that the importer is approved for participation in Periodic Monthly Statements: Y/N */
  pmsStatus?: Maybe<Scalars['String']>;
};

/** Us Ior number query response address type. */
export type UsIorNumberQueryResponseAddress = {
  __typename?: 'UsIorNumberQueryResponseAddress';
  /** Address line 1. */
  address1?: Maybe<Scalars['String']>;
  /** Address line 2. */
  address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town of the address. */
  city?: Maybe<Scalars['String']>;
  /** The country code of the address as defined in ISO 3166-1 alpha-2. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** The zip or postal code of the address. */
  postalCode?: Maybe<Scalars['String']>;
  /** The province, state, or district of the address as defined in ISO 3166-2. */
  stateCode?: Maybe<Scalars['String']>;
};

export type UsIorNumberQueryResponseAddressInput = {
  /** Address line 1. */
  address1?: InputMaybe<Scalars['String']>;
  /** Address line 2. */
  address2?: InputMaybe<Scalars['String']>;
  /** The name of the city, district, village, or town of the address. */
  city?: InputMaybe<Scalars['String']>;
  /** The country code of the address as defined in ISO 3166-1 alpha-2. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The zip or postal code of the address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The province, state, or district of the address as defined in ISO 3166-2. */
  stateCode?: InputMaybe<Scalars['String']>;
};

/** Us Ior number query response addresses. */
export type UsIorNumberQueryResponseAddresses = {
  __typename?: 'UsIorNumberQueryResponseAddresses';
  /** A mailing address */
  mailing?: Maybe<UsIorNumberQueryResponseAddress>;
  /** The address of a physical location */
  physical?: Maybe<UsIorNumberQueryResponseAddress>;
};

export type UsIorNumberQueryResponseAddressesInput = {
  /** A mailing address */
  mailing?: InputMaybe<UsIorNumberQueryResponseAddressInput>;
  /** The address of a physical location */
  physical?: InputMaybe<UsIorNumberQueryResponseAddressInput>;
};

/** Impoter/consignee CEE(Centers of Excellence and Expertise) data. */
export type UsIorNumberQueryResponseCeeDetails = {
  __typename?: 'UsIorNumberQueryResponseCeeDetails';
  /** Center Identifier assigned to importer/consignee. */
  id?: Maybe<Scalars['String']>;
  /** Descriptive name associated with the Center Identifier */
  name?: Maybe<Scalars['String']>;
};

export type UsIorNumberQueryResponseCeeDetailsInput = {
  /** Center Identifier assigned to importer/consignee. */
  id?: InputMaybe<Scalars['String']>;
  /** Descriptive name associated with the Center Identifier */
  name?: InputMaybe<Scalars['String']>;
};

/** Continuous bond details in response for query by Us Ior Number. */
export type UsIorNumberQueryResponseContinuousBond = {
  __typename?: 'UsIorNumberQueryResponseContinuousBond';
  /** The amount of coverage the bond provides. */
  amount: Scalars['UsDollars'];
  /** The effective date of the importer's customs bond. */
  effectiveDate: Scalars['Date'];
  /** The unique number identifying the importer's customs bond. */
  number: Scalars['String'];
  /** The code representing the district/pot where the bond was filed. */
  portCode?: Maybe<Scalars['String']>;
  /** The renewal date of the importer's customs bond. */
  renewalDate?: Maybe<Scalars['Date']>;
  /** An indicator of the liability sufficiency of the bond for this importer. Blank for an existing importer with no associated bonds. Y/N */
  sufficiencyIndicator?: Maybe<Scalars['String']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  suretyCode: Scalars['String'];
  /** The termination date of the importer's customs bond. */
  terminationDate?: Maybe<Scalars['Date']>;
  /** The CBP type code of the bond. */
  typeCode: Scalars['String'];
  /** An indication of the status for bond user in IOR number query response. */
  userStatusIndicator?: Maybe<BondUserStatusIndicator>;
  /** Date the bond user (the importer being queried) was, or will be, no longer active (a valid user) on this bond */
  userTerminationDate?: Maybe<Scalars['Date']>;
};

export type UsIorNumberQueryResponseContinuousBondInput = {
  /** The amount of coverage the bond provides. */
  amount: Scalars['UsDollars'];
  /** The effective date of the importer's customs bond. */
  effectiveDate: Scalars['Date'];
  /** The unique number identifying the importer's customs bond. */
  number: Scalars['String'];
  /** The code representing the district/pot where the bond was filed. */
  portCode?: InputMaybe<Scalars['String']>;
  /** The renewal date of the importer's customs bond. */
  renewalDate?: InputMaybe<Scalars['Date']>;
  /** An indicator of the liability sufficiency of the bond for this importer. Blank for an existing importer with no associated bonds. Y/N */
  sufficiencyIndicator?: InputMaybe<Scalars['String']>;
  /** The 3-digit code assigned to the surety of the importer's customs bond by CBP. List of active sureties: https://www.cbp.gov/document/forms/surety-names-and-codes-0 */
  suretyCode: Scalars['String'];
  /** The termination date of the importer's customs bond. */
  terminationDate?: InputMaybe<Scalars['Date']>;
  /** The CBP type code of the bond. */
  typeCode: Scalars['String'];
  /** An indication of the status for bond user in IOR number query response. */
  userStatusIndicator?: InputMaybe<BondUserStatusIndicator>;
  /** Date the bond user (the importer being queried) was, or will be, no longer active (a valid user) on this bond */
  userTerminationDate?: InputMaybe<Scalars['Date']>;
};

/** Input for CBP response for US Ior Number query. */
export type UsIorNumberQueryResponseInput = {
  /** Us Ior number query response addresses. */
  addresses?: InputMaybe<UsIorNumberQueryResponseAddressesInput>;
  /** The US IOR's status with CBP. */
  cbpStatus: UsIorCbpStatus;
  /** Impoter/consignee CEE(Centers of Excellence and Expertise) data. */
  cee?: InputMaybe<UsIorNumberQueryResponseCeeDetailsInput>;
  /** A list of continuous bonds. */
  continuousBonds?: InputMaybe<Array<UsIorNumberQueryResponseContinuousBondInput>>;
  /** Full legal name of importer/consignee. */
  fullLegalName?: InputMaybe<Scalars['String']>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber: UsIorNumberInput;
  /** Name of importer/consignee on CBP file */
  name?: InputMaybe<Scalars['String']>;
  /** Name associated with nameQualifierCode */
  nameLine2?: InputMaybe<Scalars['String']>;
  /** A code of DBA (doing business as), DIV (Division), or AKA (also known as) */
  nameQualifierCode?: InputMaybe<Scalars['String']>;
  /** A code of DBA (doing business as), DIV (Division), or AKA (also known as) */
  nameQualilfierCode?: InputMaybe<Scalars['String']>;
  /** An indication that the importer is approved for participation in Periodic Monthly Statements: Y/N */
  pmsStatus?: InputMaybe<Scalars['String']>;
};

/** The type of UsIorNumber */
export enum UsIorNumberType {
  CBP = 'CBP',
  EIN = 'EIN',
  SSN = 'SSN'
}

export type UsIorNumberValueSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsIorNumberValue']>>;
};

/** Payment terms offered to US IOR */
export enum UsIorPaymentTerms {
  DAILY_STATEMENT = 'DAILY_STATEMENT',
  PMS = 'PMS',
  PREPAID = 'PREPAID'
}

/** Payment terms offered to US IOR */
export type UsIorPaymentTermsSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIorPaymentTerms>>;
};

/** A US IOR individual's personal effects information. */
export type UsIorPersonalEffects = {
  __typename?: 'UsIorPersonalEffects';
  /** The individual's birth date. */
  birthDate?: Maybe<Scalars['Date']>;
  /** The individual's last foreign address. */
  lastForeign?: Maybe<Address>;
  /** The individual's new US address. */
  newUs?: Maybe<Address>;
  /** The individual's passport information. */
  passport?: Maybe<Passport>;
};

/** A US IOR individual's personal effects information. */
export type UsIorPersonalEffectsInput = {
  /** The individual's birth date. */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** The individual's last foreign address. */
  lastForeign?: InputMaybe<AddressInput>;
  /** The individual's new US address. */
  newUs?: InputMaybe<AddressInput>;
  /** The individual's passport information. */
  passport?: InputMaybe<PassportInput>;
};

/** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
export enum UsIorPmsStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

/** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
export type UsIorPmsStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIorPmsStatus>>;
};

export type UsIorSearchCriteriaInput = {
  /** Activation status of US IOR. */
  activationStatus?: InputMaybe<UsIorActivationStatusSearchCriteriaInput>;
  /** Activation time of US IOR. */
  activationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party's alternate name */
  alternateName?: InputMaybe<TextSearchCriteriaInput>;
  /** US IOR's bond Anniversary date. */
  bondAnniversary?: InputMaybe<DateSearchCriteriaInput>;
  /** US IOR's bond expiration date. */
  bondExpirationDate?: InputMaybe<DateSearchCriteriaInput>;
  /** US IOR's bond Anniversary date. */
  bondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The structure of the US business. */
  businessStructure?: InputMaybe<UsBusinessStructureSearchCriteriaInput>;
  /** The US IOR's status with CBP */
  cbpStatus?: InputMaybe<UsIorCbpStatusSearchCriteriaInput>;
  /** Party's city */
  city?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's country */
  countryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Party DUNS number */
  duns?: InputMaybe<DunsSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Forwarder's ID */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Forwarder's name */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** Global logistics profile ID equivalent to the Partner Account enrollment entity ID */
  globalLogisticsProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** US IOR is currently in bond or not */
  hasActiveBond?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Importer's ID */
  importerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The type industry of the Ior. */
  industry?: InputMaybe<VerticalSearchCriteriaInput>;
  /** The IOR Number. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Party's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The US IORs preferred payment method on an entry */
  paymentMethod?: InputMaybe<UsIorCbpEntryPreferredPaymentMethodSearchCriteriaInput>;
  /** Payment terms offered to US IOR */
  paymentTerms?: InputMaybe<UsIorPaymentTermsSearchCriteriaInput>;
  /** Time at which the payment update action was made */
  paymentTermsUpdatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: InputMaybe<UsIorPmsStatusSearchCriteriaInput>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: InputMaybe<POAMethodSearchCriteriaInput>;
  /** Party's postal code */
  postalCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Shipper's ID */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Shipper's name */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Party's state */
  stateName?: InputMaybe<TextSearchCriteriaInput>;
  /** The status of a US Ior e.g. ACTIVE, CANCELED */
  status?: InputMaybe<UsIorStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCodes?: InputMaybe<VendorCodeSearchCriteriaInput>;
};

export type UsIorSearchTableRow = PartySearchTableRow & RecordSearchTableRow & {
  __typename?: 'UsIorSearchTableRow';
  /** Activation status of US IOR. */
  activationStatus?: Maybe<UsIorActivationStatus>;
  /** Activation time of US IOR. */
  activationTime?: Maybe<Scalars['DateTime']>;
  /** Party's alternate name */
  alternateName?: Maybe<Scalars['String']>;
  /** US IOR's bond anniversary date. */
  bondAnniversary?: Maybe<Scalars['Date']>;
  /** US IOR's bond expiration date. */
  bondExpirationDate?: Maybe<Scalars['Date']>;
  /** US IOR's bond number. */
  bondNumber?: Maybe<Array<Scalars['String']>>;
  /** The structure of the US business. */
  businessStructure?: Maybe<UsBusinessStructure>;
  /** The US IOR's status with CBP */
  cbpStatus?: Maybe<UsIorCbpStatus>;
  /** Party's city */
  city?: Maybe<Scalars['String']>;
  /** Party's country */
  countryName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Forwarder's name */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** US IOR is currently in bond or not */
  hasActiveBond?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Importer's ID */
  importerId?: Maybe<Scalars['ID']>;
  /** The type industry of the Ior. */
  industry?: Maybe<Vertical>;
  /** The IOR Number. */
  iorNumber?: Maybe<Scalars['UsIorNumberValue']>;
  /** Party's name */
  name: Scalars['String'];
  /** The US IORs preferred payment method on an entry */
  paymentMethod?: Maybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** Payment terms offered to US IOR */
  paymentTerms?: Maybe<UsIorPaymentTerms>;
  /** Time at which the payment update action was made */
  paymentTermsUpdatedTime: Scalars['DateTime'];
  /** The US IOR's enrollment status in the CBP Periodic Monthly Statement program. */
  pmsStatus?: Maybe<UsIorPmsStatus>;
  /** Power of Attorney Method - Direct or Master/Sub. */
  poaMethod?: Maybe<POAMethod>;
  /** Party's postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper's ID */
  shipperId?: Maybe<Array<Scalars['ID']>>;
  /** Shipper's name */
  shipperName?: Maybe<Array<Scalars['String']>>;
  /** Party's state */
  stateName?: Maybe<Scalars['String']>;
  /** The status of a US Ior e.g. ACTIVE, CANCELED */
  status?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
  vendorCodes?: Maybe<Array<Scalars['VendorCode']>>;
  /** Version */
  version: Scalars['Int'];
};

export type UsIorShipperEdge = ConnectionEdge & {
  __typename?: 'UsIorShipperEdge';
  cursor: Scalars['ID'];
  /** The linked Shipper. */
  node: Shipper;
  /** The data on the link between the Shipper and US IOR. */
  relationship: ShipperUsIorRelationship;
};

export type UsIorShippersConnection = Connection & {
  __typename?: 'UsIorShippersConnection';
  edges: Array<UsIorShipperEdge>;
  nodes: Array<Shipper>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The status of a US Ior e.g. ACTIVE, CANCELED */
export enum UsIorStatus {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  DEACTIVATED = 'DEACTIVATED',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  PENDING_BROKER_VETTING = 'PENDING_BROKER_VETTING',
  PENDING_ESIGN = 'PENDING_ESIGN',
  PENDING_INTERNAL_VETTING = 'PENDING_INTERNAL_VETTING',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  SUBMITTED = 'SUBMITTED'
}

/** The status of a US Ior e.g. ACTIVE, CANCELED */
export type UsIorStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIorStatus>>;
};

export type UsIorsConnection = Connection & {
  __typename?: 'UsIorsConnection';
  edges: Array<UsIorEdge>;
  nodes: Array<UsIor>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsIsf = Record & WorkOrder & {
  __typename?: 'UsIsf';
  /** Estimated time of shipment arrival */
  arrivalTime?: Maybe<Scalars['Date']>;
  /** Booking party when file ISF 5 */
  bookingParty?: Maybe<UsIsfBookingParty>;
  /** US Customs Broker associated with this ISF. */
  broker: UsIsfBroker;
  /** The ISF buyer */
  buyer?: Maybe<UsIsfBuyer>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** Isf status from Cbp */
  cbpStatus?: Maybe<UsIsfCbpStatus>;
  /** CBP type code includes ISF type and shipment type */
  cbpTypeCode?: Maybe<UsIsfCbpTypeCode>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** The ISF consignee */
  consignee?: Maybe<UsIsfConsignee>;
  /** The ISF consolidator */
  consolidator?: Maybe<UsIsfConsolidator>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the US ISF. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** Informal shipment details */
  informal?: Maybe<UsIsfInformalDetails>;
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Us IOR associated with this ISF */
  ior?: Maybe<UsIsfIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Isf number */
  isfNumber?: Maybe<Scalars['UsIsfNumber']>;
  /** CBP ISF type code */
  isfType: IsfType;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Manufactures associated with this isf */
  manufacturers?: Maybe<Array<UsIsfManufacturer>>;
  /** Masterbill information */
  masterBills?: Maybe<Array<UsIsfMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Delivery place of the shipment, this is needed for ISF-5 */
  placeOfDelivery?: Maybe<Scalars['String']>;
  /** Code for port of unlading, this is needed for ISF-5 */
  portOfUnladingCode?: Maybe<Scalars['String']>;
  /** The ISF sellers */
  sellers?: Maybe<Array<UsIsfSeller>>;
  /** The ISF ship to party */
  shipTo?: Maybe<UsIsfShipTo>;
  /** CBP ISF Shipment type code */
  shipmentTypeCode?: Maybe<UsIsfShipmentTypeCode>;
  /** US ISF single transaction bond details. */
  singleTransactionBond?: Maybe<UsIsfSingleTransactionBond>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** The ISF stuffing location */
  stuffingLocation?: Maybe<UsIsfStuffingLocation>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsIsfdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UsIsfBookingParty = {
  __typename?: 'UsIsfBookingParty';
  /** Party address */
  address?: Maybe<Address>;
  /** Booking party can be either Forwarder or Supplier */
  bookingParty?: Maybe<BookingParty>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type UsIsfBookingPartyInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id and version of the booking party */
  bookingParty?: InputMaybe<IdVersionInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type UsIsfBroker = {
  __typename?: 'UsIsfBroker';
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsIsfBrokerInput = {
  /** ID of the US Customs Broker */
  usCustomsBroker?: InputMaybe<IdInput>;
};

export type UsIsfBuyer = {
  __typename?: 'UsIsfBuyer';
  /** Party address */
  address?: Maybe<Address>;
  /** buyer party info */
  buyer?: Maybe<Facility>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Buyer Employer Identification Number */
  ein?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
};

export type UsIsfBuyerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id and version input of buyer */
  buyer?: InputMaybe<IdVersionInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Buyer Employer Identification Number */
  ein?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
};

export type UsIsfCbpShipmentCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIsfShipmentTypeCode>>;
};

/** The status of the ISF (SF) filing with CBP. */
export enum UsIsfCbpStatus {
  DELETED = 'DELETED',
  FILED = 'FILED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type UsIsfCbpStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<UsIsfCbpStatus>>;
};

/** The transaction representing a US ISF realted request and response to US CBP via ABI. */
export type UsIsfCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usIsf: UsIsf;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsIsfCbpTypeCode = {
  __typename?: 'UsIsfCbpTypeCode';
  /** Isf type code */
  isfType: IsfType;
  /** Shipment Type code */
  shipmentTypeCode?: Maybe<UsIsfShipmentTypeCode>;
};

export type UsIsfCbpTypeCodeInput = {
  /** Isf type code */
  isfType?: IsfType;
  /** Shipment Type code */
  shipmentTypeCode?: InputMaybe<UsIsfShipmentTypeCode>;
};

export type UsIsfConsignee = {
  __typename?: 'UsIsfConsignee';
  /**  Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Flag to determine is party is individual */
  isIndividual?: Maybe<Scalars['Boolean']>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** Consignee party info */
  usConsignee?: Maybe<UsConsignee>;
};

export type UsIsfConsigneeInput = {
  /**  Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Flag to determine is party is individual */
  isIndividual?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Id version of consignee */
  usConsignee?: InputMaybe<IdVersionInput>;
};

export type UsIsfConsolidator = {
  __typename?: 'UsIsfConsolidator';
  /** Party address */
  address?: Maybe<Address>;
  /** Consolidator can be either facility or supplier */
  consolidator?: Maybe<Consolidator>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
};

export type UsIsfConsolidatorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id and version of the consolidator */
  consolidator?: InputMaybe<IdVersionInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
};

export type UsIsfEdge = ConnectionEdge & {
  __typename?: 'UsIsfEdge';
  cursor: Scalars['ID'];
  node: UsIsf;
};

export type UsIsfHouseBill = {
  __typename?: 'UsIsfHouseBill';
  /** Bill Match status of the bill. */
  billMatchStatus?: Maybe<BillMatchStatus>;
  /** House Bill number */
  number: Scalars['String'];
};

export type UsIsfHouseBillInput = {
  /** Bill Match status of the bill. */
  billMatchStatus?: InputMaybe<BillMatchStatus>;
  /** House Bill number */
  number: Scalars['String'];
};

export type UsIsfInformalDetails = {
  __typename?: 'UsIsfInformalDetails';
  /** Estimated quantity of the goods */
  estimatedQuantity: Quantity;
  /** Estimated value of the goods */
  estimatedValue: Cost;
  /** Estimated weight of the goods */
  estimatedWeight: Weight;
};

export type UsIsfInformalDetailsInput = {
  /** Estimated quantity of the goods */
  estimatedQuantity: QuantityInput;
  /** Estimated value of the goods */
  estimatedValue: CostInput;
  /** Estimated weight of the goods */
  estimatedWeight: WeightInput;
};

export type UsIsfIor = {
  __typename?: 'UsIsfIor';
  /**  Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Name of the IOR */
  name?: Maybe<Scalars['String']>;
  /** The individual's passport */
  passport?: Maybe<Passport>;
  /** UsIor details */
  usIor?: Maybe<UsIor>;
};

export type UsIsfIorInput = {
  /**  Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Name of the IOR */
  name?: InputMaybe<Scalars['String']>;
  /** The individual's passport */
  passport?: InputMaybe<PassportInput>;
  /** Id version of the IOR */
  usIor?: InputMaybe<IdVersionInput>;
};

export type UsIsfManufacturer = {
  __typename?: 'UsIsfManufacturer';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** product details */
  products?: Maybe<Array<UsIsfProduct>>;
  /** Supplier details */
  supplier?: Maybe<Supplier>;
};

export type UsIsfManufacturerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Product id and version */
  products?: InputMaybe<Array<UsIsfProductInput>>;
  /** Supplier id and version */
  supplier?: InputMaybe<IdVersionInput>;
};

export type UsIsfMasterBill = {
  __typename?: 'UsIsfMasterBill';
  /** Bill Match status of the bill. */
  billMatchStatus?: Maybe<BillMatchStatus>;
  /** Array of house bills */
  houseBills?: Maybe<Array<UsIsfHouseBill>>;
  /** Master bill number */
  number?: Maybe<Scalars['String']>;
};

export type UsIsfMasterBillInput = {
  /** Bill Match status of the bill. */
  billMatchStatus?: InputMaybe<BillMatchStatus>;
  /** Array of house bills */
  houseBills?: InputMaybe<Array<UsIsfHouseBillInput>>;
  /** Master bill number */
  number?: InputMaybe<Scalars['String']>;
};

export type UsIsfNumberSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['UsIsfNumber']>>;
};

export type UsIsfProduct = {
  __typename?: 'UsIsfProduct';
  /** The hts number associate with this product */
  htsNumber?: Maybe<Scalars['String']>;
  /** The origin country code of the product */
  originCountryCode?: Maybe<Scalars['CountryCode']>;
  /** product */
  product?: Maybe<Product>;
};

export type UsIsfProductInput = {
  /** The hts number associate with this product */
  htsNumber?: InputMaybe<Scalars['String']>;
  /** The origin country code of the product */
  originCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Id and version of the product */
  product?: InputMaybe<IdVersionInput>;
};

export type UsIsfSearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Bond number provided by CBP */
  bondNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  bondReferenceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** Buyer name */
  buyerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Isf Cbp status */
  cbpStatus?: InputMaybe<UsIsfCbpStatusSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Consolidator name */
  consolidatorName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Isf number */
  isfNumber?: InputMaybe<UsIsfNumberSearchCriteriaInput>;
  /** Isf Type */
  isfType?: InputMaybe<UsIsfTypeSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Manufacture name */
  manufactureName?: InputMaybe<TextSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Place of delivery */
  placeOfDelivery?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Port of unlading code */
  portOfUnladingCode?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Seller name */
  sellerName?: InputMaybe<TextSearchCriteriaInput>;
  /** Ship to name */
  shipToName?: InputMaybe<TextSearchCriteriaInput>;
  /** Isf shipment type code */
  shipmentTypeCode?: InputMaybe<UsIsfCbpShipmentCodeSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** StuffingLocation name */
  stuffingLocationName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** TBD */
export type UsIsfSearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsIsfSearchTableRow';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Bond number provided by CBP */
  bondNumber?: Maybe<Scalars['String']>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** Buyer name */
  buyerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** Isf Cbp status */
  cbpStatus?: Maybe<Scalars['String']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** Consolidator name */
  consolidatorName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Isf number */
  isfNumber?: Maybe<Scalars['String']>;
  /** Isf Type */
  isfType?: Maybe<Scalars['String']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Manufacture name */
  manufactureName?: Maybe<Array<Scalars['String']>>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Place of delivery */
  placeOfDelivery?: Maybe<Scalars['String']>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** Port of unlading code */
  portOfUnladingCode?: Maybe<Scalars['String']>;
  /** Seller name */
  sellerName?: Maybe<Array<Scalars['String']>>;
  /** Ship to name */
  shipToName?: Maybe<Scalars['String']>;
  /** Isf shipment type code */
  shipmentTypeCode?: Maybe<Scalars['String']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** StuffingLocation name */
  stuffingLocationName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsIsfSeller = {
  __typename?: 'UsIsfSeller';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Seller details */
  seller?: Maybe<Supplier>;
};

export type UsIsfSellerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party Employer Identification Number */
  ein?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Seller details */
  seller?: InputMaybe<IdVersionInput>;
};

export type UsIsfServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'UsIsfServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
};

export type UsIsfServiceLevelAgreementInput = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: InputMaybe<Scalars['Float']>;
};

export type UsIsfShipTo = {
  __typename?: 'UsIsfShipTo';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party firms code */
  firmsCode?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  shipTo?: Maybe<Facility>;
};

export type UsIsfShipToInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party firms code */
  firmsCode?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<IdVersionInput>;
};

/** Valid values for shipment type code while file ISF */
export enum UsIsfShipmentTypeCode {
  HHG_PE = 'HHG_PE',
  INFORMAL = 'INFORMAL',
  STANDARD = 'STANDARD'
}

export type UsIsfSingleTransactionBond = {
  __typename?: 'UsIsfSingleTransactionBond';
  /** Bond number provided by CBP */
  bondNumber?: Maybe<Scalars['String']>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Bond surety code */
  suretyCode?: Maybe<Scalars['String']>;
};

export type UsIsfSingleTransactionBondInput = {
  /** Bond number provided by CBP */
  bondNumber?: InputMaybe<Scalars['String']>;
  /** Reference number provided by the surety and sent back in the BS ABI message */
  referenceNumber?: InputMaybe<Scalars['String']>;
  /** Bond surety code */
  suretyCode?: InputMaybe<Scalars['String']>;
};

export type UsIsfStuffingLocation = {
  __typename?: 'UsIsfStuffingLocation';
  /** Party address */
  address?: Maybe<Address>;
  /** Party DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Stuffing location details */
  stuffingLocation?: Maybe<StuffingLocation>;
};

export type UsIsfStuffingLocationInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Id version of suffing location */
  stuffingLocation?: InputMaybe<IdVersionInput>;
};

export type UsIsfTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<IsfType>>;
};

export type UsIsfsConnection = Connection & {
  __typename?: 'UsIsfsConnection';
  edges: Array<UsIsfEdge>;
  nodes: Array<UsIsf>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export enum UsPgaCode {
  ACE = 'ACE',
  AMS = 'AMS',
  APH = 'APH',
  ATF = 'ATF',
  BIS = 'BIS',
  BLS = 'BLS',
  BTS = 'BTS',
  CBC = 'CBC',
  CBP = 'CBP',
  CDC = 'CDC',
  CGD = 'CGD',
  CPS = 'CPS',
  DCM = 'DCM',
  DEA = 'DEA',
  DEE = 'DEE',
  DTC = 'DTC',
  ECO = 'ECO',
  EIA = 'EIA',
  EPA = 'EPA',
  ETA = 'ETA',
  EXI = 'EXI',
  FAA = 'FAA',
  FAS = 'FAS',
  FCC = 'FCC',
  FCN = 'FCN',
  FDA = 'FDA',
  FHA = 'FHA',
  FMC = 'FMC',
  FMS = 'FMS',
  FSI = 'FSI',
  FTZ = 'FTZ',
  FWS = 'FWS',
  GIP = 'GIP',
  ICE = 'ICE',
  IDV = 'IDV',
  IRS = 'IRS',
  MAR = 'MAR',
  NHT = 'NHT',
  NMF = 'NMF',
  NRC = 'NRC',
  OFA = 'OFA',
  OFE = 'OFE',
  OFM = 'OFM',
  OGC = 'OGC',
  OLM = 'OLM',
  OMC = 'OMC',
  OTX = 'OTX',
  PHM = 'PHM',
  TRP = 'TRP',
  TSA = 'TSA',
  TTB = 'TTB',
  UTC = 'UTC'
}

export enum UsPgaDisclaimerCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type UsPgaEngine = {
  __typename?: 'UsPgaEngine';
  /** Engine Manufacture Month. Used by: EPA */
  manufactureMonth?: Maybe<Scalars['Month']>;
  /** Engine Model Number. Used by: EPA */
  model?: Maybe<Scalars['String']>;
  /** Engine Model Year (YYYY). Used by: EPA */
  modelYear?: Maybe<Scalars['Year']>;
  /** Engine Serial Number(s). Used by: EPA */
  serialNumbers?: Maybe<Array<Scalars['String']>>;
};

export type UsPgaEngineInput = {
  /** Engine Manufacture Month. Used by: EPA */
  manufactureMonth?: InputMaybe<Scalars['Month']>;
  /** Engine Model Number. Used by: EPA */
  model?: InputMaybe<Scalars['String']>;
  /** Engine Model Year (YYYY). Used by: EPA */
  modelYear?: InputMaybe<Scalars['Year']>;
  /** Engine Serial Number(s). Used by: EPA */
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export enum UsPgaFlag {
  AL1 = 'AL1',
  AL2 = 'AL2',
  AM1 = 'AM1',
  AM2 = 'AM2',
  AM3 = 'AM3',
  AM4 = 'AM4',
  AM6 = 'AM6',
  AM7 = 'AM7',
  AM8 = 'AM8',
  AQ1 = 'AQ1',
  AQ2 = 'AQ2',
  CP1 = 'CP1',
  DE1 = 'DE1',
  DT1 = 'DT1',
  DT2 = 'DT2',
  EP1 = 'EP1',
  EP2 = 'EP2',
  EP3 = 'EP3',
  EP4 = 'EP4',
  EP5 = 'EP5',
  EP6 = 'EP6',
  EP7 = 'EP7',
  EP8 = 'EP8',
  FD1 = 'FD1',
  FD2 = 'FD2',
  FD3 = 'FD3',
  FD4 = 'FD4',
  FS3 = 'FS3',
  FS4 = 'FS4',
  FW1 = 'FW1',
  FW2 = 'FW2',
  FW3 = 'FW3',
  NM1 = 'NM1',
  NM2 = 'NM2',
  NM3 = 'NM3',
  NM4 = 'NM4',
  NM5 = 'NM5',
  NM6 = 'NM6',
  NM8 = 'NM8',
  OM1 = 'OM1',
  OM2 = 'OM2',
  TB1 = 'TB1',
  TB2 = 'TB2',
  TB3 = 'TB3'
}

export enum UsPgaHeaderStatus {
  DATA_REJECTED_PER_PGA_REVIEW = 'DATA_REJECTED_PER_PGA_REVIEW',
  DATA_UNDER_PGA_REVIEW = 'DATA_UNDER_PGA_REVIEW',
  HOLD_INTACT = 'HOLD_INTACT',
  MAY_PROCEED = 'MAY_PROCEED',
  PENDING = 'PENDING'
}

export type UsPgaInspection = {
  __typename?: 'UsPgaInspection';
  /** CBP Port code location of scheduled inspection. Required for APHIS if inspectionStatus is S or I. Required for FWS for processing code EDS if the inspection is taking place at a port. Otherwise, use locationLOCODE. */
  cbpPortCode?: Maybe<Scalars['UsCbpPortCode']>;
  /** Requested or scheduled Date of Inspection, or Date of Previous  Inspection/Laboratory Testing, or Arrival Date. Used by APHIS, FWS. */
  date?: Maybe<Scalars['DateTime']>;
  /** UNLOCODE location of previously performed inspection, or scheduled inspection. Required for APHIS if inspectionStatus is P. Required for FWS for processing code EDS if the inspection is not taking place at a port. Otherwise, use locationPort. */
  locationCode?: Maybe<Scalars['UnLocode']>;
  /** Inspection/Laboratory Testing Status. Either I, P, or S required for APHIS. Code I is required for FWS if processing code is EDS. */
  status?: Maybe<UsPgaInspectionStatus>;
};

export type UsPgaInspectionInput = {
  /** CBP Port code location of scheduled inspection. Required for APHIS if inspectionStatus is S or I. Required for FWS for processing code EDS if the inspection is taking place at a port. Otherwise, use locationLOCODE. */
  cbpPortCode?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** Requested or scheduled Date of Inspection, or Date of Previous  Inspection/Laboratory Testing, or Arrival Date. Used by APHIS, FWS. */
  date?: InputMaybe<Scalars['DateTime']>;
  /** UNLOCODE location of previously performed inspection, or scheduled inspection. Required for APHIS if inspectionStatus is P. Required for FWS for processing code EDS if the inspection is not taking place at a port. Otherwise, use locationPort. */
  locationCode?: InputMaybe<Scalars['UnLocode']>;
  /** Inspection/Laboratory Testing Status. Either I, P, or S required for APHIS. Code I is required for FWS if processing code is EDS. */
  status?: InputMaybe<UsPgaInspectionStatus>;
};

export enum UsPgaInspectionStatus {
  A = 'A',
  F = 'F',
  I = 'I',
  L = 'L',
  P = 'P',
  R = 'R',
  S = 'S'
}

/** PGA source and processing data */
export type UsPgaSource = {
  __typename?: 'UsPgaSource';
  /** The source country code of the line item. Used by APHIS, DEA, FWS. */
  countryCode?: Maybe<Scalars['CountryCode']>;
  /** The source geographic location of the line item. Used by APHIS, FWS. */
  geographicLocation?: Maybe<Scalars['String']>;
  /** Text describing the processing methods. Required if processingTypeCode is other.Used by APHIS. */
  processingDescription?: Maybe<Scalars['String']>;
  /** The date when the processing for the product ended. This includes the harvesting vessel trip end date. Used by APHIS. */
  processingEndDate?: Maybe<Scalars['DateTime']>;
  /** The date when the processing for the product started. This includes the harvesting vessel trip begin date. Used by APHIS. */
  processingStartDate?: Maybe<Scalars['DateTime']>;
  /** The code identifying the method of processing used to make the product. This  includes the harvesting vessels fishing gear. Used by APHIS and EPA. */
  processingTypeCode?: Maybe<Scalars['UsPgaProcessingTypeCodes']>;
  /** The type of source country. Used by APHIS, NHTSA, DEA, FWS. */
  sourceCountryType?: Maybe<Scalars['UsPgaSourceTypeCode']>;
};

/** PGA source and processing data */
export type UsPgaSourceInput = {
  /** The source country code of the line item. Used by APHIS, DEA, FWS. */
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The source geographic location of the line item. Used by APHIS, FWS. */
  geographicLocation?: InputMaybe<Scalars['String']>;
  /** Text describing the processing methods. Required if processingTypeCode is other.Used by APHIS. */
  processingDescription?: InputMaybe<Scalars['String']>;
  /** The date when the processing for the product ended. This includes the harvesting vessel trip end date. Used by APHIS. */
  processingEndDate?: InputMaybe<Scalars['DateTime']>;
  /** The date when the processing for the product started. This includes the harvesting vessel trip begin date. Used by APHIS. */
  processingStartDate?: InputMaybe<Scalars['DateTime']>;
  /** The code identifying the method of processing used to make the product. This  includes the harvesting vessels fishing gear. Used by APHIS and EPA. */
  processingTypeCode?: InputMaybe<Scalars['UsPgaProcessingTypeCodes']>;
  /** The type of source country. Used by APHIS, NHTSA, DEA, FWS. */
  sourceCountryType?: InputMaybe<Scalars['UsPgaSourceTypeCode']>;
};

export type UsPgaVehicle = {
  __typename?: 'UsPgaVehicle';
  /** Vehicle Manufacture Month. Used by: EPA, NHT */
  manufactureMonth?: Maybe<Scalars['Month']>;
  /** Vehicle Model Number. Used by: EPA, NHT */
  model?: Maybe<Scalars['String']>;
  /** Vehicle Model Year (YYYY). Used by: EPA, NHT */
  modelYear?: Maybe<Scalars['Year']>;
  /** Vehicle Serial Number(s). Used by: EPA, NHT */
  serialNumbers?: Maybe<Array<Scalars['String']>>;
  /** Vehicle Identification Number(s) (VIN). Used by: EPA, NHT */
  vehicleIdentificationNumbers?: Maybe<Array<Scalars['String']>>;
};

export type UsPgaVehicleInput = {
  /** Vehicle Manufacture Month. Used by: EPA, NHT */
  manufactureMonth?: InputMaybe<Scalars['Month']>;
  /** Vehicle Model Number. Used by: EPA, NHT */
  model?: InputMaybe<Scalars['String']>;
  /** Vehicle Model Year (YYYY). Used by: EPA, NHT */
  modelYear?: InputMaybe<Scalars['Year']>;
  /** Vehicle Serial Number(s). Used by: EPA, NHT */
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Vehicle Identification Number(s) (VIN). Used by: EPA, NHT */
  vehicleIdentificationNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export type UsPostSummaryCorrection = Record & WorkOrder & {
  __typename?: 'UsPostSummaryCorrection';
  /** Accelerate the liquidation of the entry. */
  acceleratedLiquidation?: Maybe<Scalars['Boolean']>;
  /** The reason for amending the entry. */
  amendmentReason?: Maybe<UsPostSummaryCorrectionAmendmentReason>;
  /** Arrival information */
  arrival?: Maybe<UsPostSummaryCorrectionArrival>;
  /** US Customs Broker associated with this entry. */
  broker: UsPostSummaryCorrectionBroker;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  cbpCharges?: Maybe<UsCbpEntryCharges>;
  cbpLiquidatedCharges?: Maybe<UsCbpEntryLiquidatedCharges>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: Maybe<Scalars['String']>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** US Consignee associated with this entry. */
  consignee?: Maybe<UsPostSummaryCorrectionConsignee>;
  /** Conveyance information. */
  conveyance: UsPostSummaryCorrectionConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<UsPostSummaryCorrectionDeparture>;
  /** The documents associated with the US Post Summary Correction. This is an eventually consistent query. */
  documents: Array<Document>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['UsCbpEntryTypeCode']>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** A text line of the PSC filing explanation. */
  explanation?: Maybe<Scalars['String']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** A code that identifies the reason that the submitted header data is being changed for a PSC */
  headerReasons?: Maybe<Array<Scalars['UsPostSummaryCorrectionHeaderReason']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<UsPostSummaryCorrectionCommercialInvoice>>;
  /** US IOR associated with this entry. */
  ior?: Maybe<UsPostSummaryCorrectionIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<UsPostSummaryCorrectionMasterBill>>;
  /** How the imported merchandise will be used. */
  merchandiseUse?: Maybe<UsCbpEntryMerchandiseUse>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Purchase order (PO) number(s) associated with the work order. */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** US Entry single transaction bond details. */
  singleTransactionBond?: Maybe<UsEntrySingleTransactionBond>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotification?: Maybe<UsCbpEntrySummaryNotification>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReasons?: Maybe<Array<UsCbpEntrySummaryRejectionReason>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: Maybe<UsCbpEntrySummaryStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total assist of the merchandise reported to US CBP. */
  totalAssist?: Maybe<Scalars['UsDollars']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: Maybe<Scalars['UsDollars']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsPostSummaryCorrectiondocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** The reason for amending the post summary correction. */
export enum UsPostSummaryCorrectionAmendmentReason {
  HTS_NOT_PROVIDED_AND_CLIENT_DISAGREED_WITH_BROKER_CLASSIFICATION = 'HTS_NOT_PROVIDED_AND_CLIENT_DISAGREED_WITH_BROKER_CLASSIFICATION',
  HTS_PROVIDED_AND_CLIENT_DISAGREED_AFTER_REVIEWING_ENTRY_SUMMARY = 'HTS_PROVIDED_AND_CLIENT_DISAGREED_AFTER_REVIEWING_ENTRY_SUMMARY',
  INCORRECT_DOCUMENTATION = 'INCORRECT_DOCUMENTATION',
  INCORRECT_PIECE_COUNT_ENTERED = 'INCORRECT_PIECE_COUNT_ENTERED',
  MISSING_COMMERCIAL_INVOICE = 'MISSING_COMMERCIAL_INVOICE',
  OTHER_CLERICAL_ERROR = 'OTHER_CLERICAL_ERROR'
}

export type UsPostSummaryCorrectionArrival = {
  __typename?: 'UsPostSummaryCorrectionArrival';
  /** The date the shipment physically arrives in the US. */
  importDate?: Maybe<Scalars['Date']>;
  /** Data relating to an IT In-Bond movement for the shipment */
  inBond?: Maybe<UsPostSummaryCorrectionInBondInfo>;
  /** The shipment's US port of unlading. */
  portOfUnladingCode?: Maybe<Scalars['UsCbpPortCode']>;
  /** The US 2-letter state code of the shipment's final destination. */
  usDestinationStateCode?: Maybe<Scalars['UsStateCode']>;
};

export type UsPostSummaryCorrectionArrivalInput = {
  /** The date the shipment physically arrives in the US. */
  importDate?: InputMaybe<Scalars['Date']>;
  /** Data relating to an IT In-Bond movement for the shipment */
  inBond?: InputMaybe<UsPostSummaryCorrectionInBondInfoInput>;
  /** The shipment's US port of unlading. */
  portOfUnladingCode?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The US 2-letter state code of the shipment's final destination. */
  usDestinationStateCode?: InputMaybe<Scalars['UsStateCode']>;
};

export type UsPostSummaryCorrectionBroker = {
  __typename?: 'UsPostSummaryCorrectionBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsPostSummaryCorrectionPointOfContact>;
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsPostSummaryCorrectionBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsPostSummaryCorrectionPointOfContactInput>;
  /** US Customs Broker */
  usCustomsBroker: IdInput;
};

/** The transaction representing a US Consumption Entry realted request and response to US CBP via ABI. */
export type UsPostSummaryCorrectionCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usPostSummaryCorrection: UsPostSummaryCorrection;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsPostSummaryCorrectionCommercialInvoice = {
  __typename?: 'UsPostSummaryCorrectionCommercialInvoice';
  /** A pro-rated adjustment to the Commercial Invoice line item values. */
  adjustments?: Maybe<Array<UsConsumptionEntryCommercialInvoiceAdjustment>>;
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: Maybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<UsPostSummaryCorrectionProduct>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<UsPostSummaryCorrectionSupplier>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type UsPostSummaryCorrectionCommercialInvoiceInput = {
  /** A pro-rated adjustment to the Commercial Invoice line item values. */
  adjustments?: InputMaybe<Array<UsConsumptionEntryCommercialInvoiceAdjustmentInput>>;
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Incoterm of the shipment. Defines the division of cost and risk between buyer and seller. */
  incoterm?: InputMaybe<Scalars['String']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<UsPostSummaryCorrectionProductInput>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<UsPostSummaryCorrectionSupplierInput>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

/** The usPostSummaryCorrection confirmation transaction type */
export enum UsPostSummaryCorrectionConfirmationTransactionType {
  UPSERT_US_POST_SUMMARY_CORRECTION_SUMMARY_CBP = 'UPSERT_US_POST_SUMMARY_CORRECTION_SUMMARY_CBP'
}

export type UsPostSummaryCorrectionConsignee = {
  __typename?: 'UsPostSummaryCorrectionConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** UsConsignee details */
  usConsignee?: Maybe<UsConsignee>;
};

export type UsPostSummaryCorrectionConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Id version of the Consignee */
  usConsignee?: InputMaybe<IdVersionInput>;
};

export type UsPostSummaryCorrectionConveyance = {
  __typename?: 'UsPostSummaryCorrectionConveyance';
  /** Whether the goods are containerized. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: UsCbpEntryModeOfTransport;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
};

export type UsPostSummaryCorrectionConveyanceInput = {
  /** Whether the goods are containerized. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: UsCbpEntryModeOfTransport;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type UsPostSummaryCorrectionDeparture = {
  __typename?: 'UsPostSummaryCorrectionDeparture';
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['Date']>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingCode?: Maybe<Scalars['UsCbpForeignPortCode']>;
};

export type UsPostSummaryCorrectionDepartureInput = {
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<Scalars['Date']>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingCode?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
};

export type UsPostSummaryCorrectionEdge = ConnectionEdge & {
  __typename?: 'UsPostSummaryCorrectionEdge';
  cursor: Scalars['ID'];
  node: UsPostSummaryCorrection;
};

export type UsPostSummaryCorrectionHouseBill = {
  __typename?: 'UsPostSummaryCorrectionHouseBill';
  /** In-bond number associated w/ the bill. */
  inBondNumber?: Maybe<Scalars['String']>;
  /** House Bill number */
  number?: Maybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: Maybe<Scalars['Int']>;
};

export type UsPostSummaryCorrectionHouseBillInput = {
  /** In-bond number associated w/ the bill. */
  inBondNumber?: InputMaybe<Scalars['String']>;
  /** House Bill number */
  number?: InputMaybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: InputMaybe<Scalars['Int']>;
};

/** IT In-bond data for a shipment. */
export type UsPostSummaryCorrectionInBondInfo = {
  __typename?: 'UsPostSummaryCorrectionInBondInfo';
  /** The estimated (or actual) entry date. */
  estimatedEntryDate?: Maybe<Scalars['Date']>;
  /** The date that the in-bond associated with the shipment initiated. */
  initiationDate?: Maybe<Scalars['Date']>;
  /** The shipment's US port of entry. */
  portOfEntryCode?: Maybe<Scalars['UsCbpPortCode']>;
};

/** IT In-bond data for a shipment. */
export type UsPostSummaryCorrectionInBondInfoInput = {
  /** The estimated (or actual) entry date. */
  estimatedEntryDate?: InputMaybe<Scalars['Date']>;
  /** The date that the in-bond associated with the shipment initiated. */
  initiationDate?: InputMaybe<Scalars['Date']>;
  /** The shipment's US port of entry. */
  portOfEntryCode?: InputMaybe<Scalars['UsCbpPortCode']>;
};

export type UsPostSummaryCorrectionIor = {
  __typename?: 'UsPostSummaryCorrectionIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** UsIor details */
  usIor: UsIor;
};

export type UsPostSummaryCorrectionIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Id version of the IOR */
  usIor: IdVersionInput;
};

export type UsPostSummaryCorrectionLine = {
  __typename?: 'UsPostSummaryCorrectionLine';
  /** The Anti-Dumping Case record. */
  adCase?: Maybe<AdCvdCase>;
  /** The Anti-Dumping Case record. */
  adCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: Maybe<Cost>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: Maybe<UsAluminumRequirements>;
  /** The dollar assist of the line item reported to US CBP. */
  assist?: Maybe<Scalars['UsDollars']>;
  cbpCharges?: Maybe<UsCbpEntryLineCharges>;
  /** The Countervailing Case record. */
  cvCase?: Maybe<AdCvdCase>;
  /** The Countervailing Case record. */
  cvCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: Maybe<Cost>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: Maybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: Maybe<Scalars['Boolean']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  feeOptions?: Maybe<Array<UsCbpEntryLineFeeOption>>;
  /** Importer has Non-Reimbursement Certificate on file with CBP */
  isNrbsOnFile?: Maybe<Scalars['Boolean']>;
  /** The license code. */
  licenseCode?: Maybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: Maybe<Scalars['String']>;
  /** A code that identifies the reason that the submitted line data is being changed for a PSC. */
  lineReasons?: Maybe<Array<Scalars['UsPostSummaryCorrectionLineReason']>>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<UsPostSummaryCorrectionSupplier>;
  /** Record number of Non-Reimbursement Certificate on file with CBP */
  nrbsRecordNumber?: Maybe<Scalars['UsNrbsRecordNumber']>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** The purchase order (PO) number of the line item */
  poNumber?: Maybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: Maybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: Maybe<UsProductEntryLineRuling>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: Maybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: Maybe<UsSteelRequirements>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<UsPostSummaryCorrectionTariff>>;
  taxOptions?: Maybe<Array<UsCbpEntryLineTaxOption>>;
  /** The dollar value of the line item reported to US CBP. */
  value?: Maybe<Scalars['UsDollars']>;
};

export type UsPostSummaryCorrectionLineInput = {
  /** The Anti-Dumping Case record. */
  adCase?: InputMaybe<IdInput>;
  /** The Anti-Dumping Case record. */
  adCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: InputMaybe<CostInput>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: InputMaybe<UsAluminumRequirementsInput>;
  /** The dollar assist of the line item reported to US CBP. */
  assist?: InputMaybe<Scalars['UsDollars']>;
  cbpCharges?: InputMaybe<UsCbpLineChargesInput>;
  /** The Countervailing Case record. */
  cvCase?: InputMaybe<IdInput>;
  /** The Countervailing Case record. */
  cvCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: InputMaybe<CostInput>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: InputMaybe<Scalars['Boolean']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  feeOptions?: InputMaybe<Array<UsCbpEntryLineFeeOptionInput>>;
  /** Importer has Non-Reimbursement Certificate on file with CBP */
  isNrbsOnFile?: InputMaybe<Scalars['Boolean']>;
  /** The license code. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** A code that identifies the reason that the submitted line data is being changed for a PSC. */
  lineReasons?: InputMaybe<Array<Scalars['UsPostSummaryCorrectionLineReason']>>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<UsPostSummaryCorrectionSupplierInput>;
  /** Record number of Non-Reimbursement Certificate on file with CBP */
  nrbsRecordNumber?: InputMaybe<Scalars['UsNrbsRecordNumber']>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** The purchase order (PO) number of the line item */
  poNumber?: InputMaybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: InputMaybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: InputMaybe<UsProductEntryLineRulingInput>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: InputMaybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: InputMaybe<UsSteelRequirementsInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<UsPostSummaryCorrectionTariffInput>>;
  taxOptions?: InputMaybe<Array<UsCbpEntryLineTaxOptionInput>>;
  /** The dollar value of the line item reported to US CBP. */
  value?: InputMaybe<Scalars['UsDollars']>;
};

export type UsPostSummaryCorrectionMasterBill = {
  __typename?: 'UsPostSummaryCorrectionMasterBill';
  /** Array of house bills */
  houseBills?: Maybe<Array<UsPostSummaryCorrectionHouseBill>>;
  /** Master Bill number */
  number?: Maybe<Scalars['String']>;
};

export type UsPostSummaryCorrectionMasterBillInput = {
  /** Array of house bills */
  houseBills?: InputMaybe<Array<UsPostSummaryCorrectionHouseBillInput>>;
  /** Master Bill number */
  number?: InputMaybe<Scalars['String']>;
};

export type UsPostSummaryCorrectionPointOfContact = {
  __typename?: 'UsPostSummaryCorrectionPointOfContact';
  /** A contact email address. */
  email?: Maybe<Scalars['Email']>;
  /** The point of contact's name. */
  name?: Maybe<Scalars['String']>;
  /** A contact phone number. */
  phone?: Maybe<Phone>;
};

export type UsPostSummaryCorrectionPointOfContactInput = {
  /** A contact email address. */
  email?: InputMaybe<Scalars['Email']>;
  /** The point of contact's name. */
  name?: InputMaybe<Scalars['String']>;
  /** A contact phone number. */
  phone?: InputMaybe<PhoneInput>;
};

export type UsPostSummaryCorrectionProduct = {
  __typename?: 'UsPostSummaryCorrectionProduct';
  /** Total number of cartons. */
  cartonCount?: Maybe<Scalars['Int']>;
  /** Client identifier for the product (eg, sku, asin, etc). This should be provided only if a product record was not provided. If product is provided, use product.clientIdentifier instead. */
  clientIdentifier?: Maybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: Maybe<Volume>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** Line items within the Product. */
  lines?: Maybe<Array<UsPostSummaryCorrectionLine>>;
  /** The materials the Product contains. */
  materials?: Maybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: Maybe<Weight>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type UsPostSummaryCorrectionProductInput = {
  /** Total number of cartons. */
  cartonCount?: InputMaybe<Scalars['Int']>;
  /** Client identifier for the product (eg, sku, asin, etc). This should be provided only if a product record was not provided. If product is provided, use product.clientIdentifier instead. */
  clientIdentifier?: InputMaybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: InputMaybe<VolumeInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<UsPostSummaryCorrectionLineInput>>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: InputMaybe<WeightInput>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type UsPostSummaryCorrectionSearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<UsCbpEntryTypeCodeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the US. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** In-bond number */
  inBondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<UsCbpEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's US port of unlading. */
  portOfUnladingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** A notification from US CBP via an ABI UC message. */
  summaryNotificationType?: InputMaybe<UsCbpEntrySummaryNotificationSearchCriteriaInput>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReason?: InputMaybe<TextSearchCriteriaInput>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: InputMaybe<UsCbpEntrySummaryStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** TBD */
export type UsPostSummaryCorrectionSearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsPostSummaryCorrectionSearchTableRow';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the US. */
  importDate?: Maybe<Scalars['String']>;
  /** In-bond number */
  inBondNumber?: Maybe<Array<Scalars['String']>>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingName?: Maybe<Scalars['String']>;
  /** The shipment's US port of unlading. */
  portOfUnladingName?: Maybe<Scalars['String']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** A notification from US CBP via an ABI UC message. */
  summaryNotificationType?: Maybe<UsCbpEntrySummaryNotificationType>;
  /** Error details of the latest US CBP Entry Summary (AE) rejection. */
  summaryRejectionReason?: Maybe<Array<Scalars['String']>>;
  /** Status of the Entry Summary (AE) filing with CBP. */
  summaryStatus?: Maybe<Scalars['String']>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsPostSummaryCorrectionSupplier = {
  __typename?: 'UsPostSummaryCorrectionSupplier';
  /** Party address */
  address?: Maybe<Address>;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  mid?: Maybe<Scalars['UsCbpMid']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The manufacturer is related with the importer. */
  related?: Maybe<Scalars['Boolean']>;
  /** The Supplier record. */
  supplier?: Maybe<Supplier>;
};

export type UsPostSummaryCorrectionSupplierInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  mid?: InputMaybe<Scalars['UsCbpMid']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The manufacturer is related with the importer. */
  related?: InputMaybe<Scalars['Boolean']>;
  /** The Supplier record. */
  supplier?: InputMaybe<IdVersionInput>;
};

export type UsPostSummaryCorrectionTariff = {
  __typename?: 'UsPostSummaryCorrectionTariff';
  /** Duties owed to US CBP for this tariff. */
  charges?: Maybe<UsCbpEntryTariffCharges>;
  /** The HTS record. */
  hts?: Maybe<UsHts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type UsPostSummaryCorrectionTariffInput = {
  /** Duties owed to US CBP for this tariff. */
  charges?: InputMaybe<UsCbpEntryTariffChargesInput>;
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type UsPostSummaryCorrectionsConnection = Connection & {
  __typename?: 'UsPostSummaryCorrectionsConnection';
  edges: Array<UsPostSummaryCorrectionEdge>;
  nodes: Array<UsPostSummaryCorrection>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Represents a US CBP Anti-Dumping or Countervailing Duty Case. */
export type UsPrincipalAdCvdCase = Record & {
  __typename?: 'UsPrincipalAdCvdCase';
  adCvdCases?: Maybe<Array<AdCvdCase>>;
  /** The country of origin where the Case applies */
  countryCode: Scalars['CountryCode'];
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Full 10-digit case numbers */
  fullCaseNumbers?: Maybe<Array<CaseReference>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Official Case name */
  name?: Maybe<Scalars['String']>;
  /** Principal AD/CVD Case number */
  principalCaseNumber: Scalars['UsPrincipalCaseNumber'];
  /** Link to the scope decision of the case */
  scopeUrl?: Maybe<Scalars['Url']>;
  status: UsPrincipalAdCvdCaseStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsPrincipalAdCvdCaseEdge = ConnectionEdge & {
  __typename?: 'UsPrincipalAdCvdCaseEdge';
  cursor: Scalars['ID'];
  node: UsPrincipalAdCvdCase;
};

export type UsPrincipalAdCvdCaseSearchCriteria = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Principal AD/CVD Case number */
  principalCaseNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** US Principal AdCvdCase search table row. */
export type UsPrincipalAdCvdCaseSearchTableRow = RecordSearchTableRow & {
  __typename?: 'UsPrincipalAdCvdCaseSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Principal AD/CVD Case number */
  principalCaseNumber: Scalars['UsPrincipalCaseNumber'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

/** Status for a US Principal AdCvdCase. */
export enum UsPrincipalAdCvdCaseStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type UsPrincipalAdCvdCasesConnection = Connection & {
  __typename?: 'UsPrincipalAdCvdCasesConnection';
  edges: Array<UsPrincipalAdCvdCaseEdge>;
  nodes: Array<UsPrincipalAdCvdCase>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsProductEntryLineRuling = {
  __typename?: 'UsProductEntryLineRuling';
  /** The administrative number assigned by CBP to a binding ruling or a ruling under the pre-importation review program (PIRP). */
  number?: Maybe<Scalars['String']>;
  /** The type of ruling number. */
  type?: Maybe<UsCbpEntryLineRulingType>;
};

export type UsProductEntryLineRulingInput = {
  /** The administrative number assigned by CBP to a binding ruling or a ruling under the pre-importation review program (PIRP). */
  number?: InputMaybe<Scalars['String']>;
  /** The type of ruling number. */
  type?: InputMaybe<UsCbpEntryLineRulingType>;
};

/** US-specific data for importers including CBP-related information. */
export type UsSpecificData = {
  __typename?: 'UsSpecificData';
  /** Whether ACH credit payment method is used. */
  achCredit?: Maybe<Scalars['Boolean']>;
  /** Bank details for the importer. */
  bank?: Maybe<UsCbp5106BankDetails>;
  /** CBP 5106 rejection reasons. */
  cbp5106RejectionReasons?: Maybe<Array<UsCbp5106RejectedReason>>;
  /** CBP mailing address classification. */
  cbpMailingAddressType?: Maybe<UsCbp5106AddressType>;
  /** Reasons for requesting CBP assigned number. */
  cbpNumberReasons?: Maybe<Array<UsIorCbpAssignedNumberReason>>;
  /** CBP physical address classification. */
  cbpPhysicalAddressType?: Maybe<UsCbp5106AddressType>;
  /** CBP status of the US IOR. */
  cbpStatus?: Maybe<UsIorCbpStatus>;
  /** Confidentiality details. */
  confidentiality?: Maybe<UsIorConfidentialityDetails>;
  /** Business establishment details. */
  establishment?: Maybe<UsCbp5106EstablishmentDetails>;
  /** Individual members reported on CBP form 5106. */
  individuals?: Maybe<Array<UsCbp5106Individual>>;
  /** CBP payer unit number. */
  payerUnitNumber?: Maybe<Scalars['UsCbpPayerUnitNumber']>;
  /** Payment terms offered to US IOR. */
  paymentTerms?: Maybe<UsIorPaymentTerms>;
  /** Payment terms update record action. */
  paymentTermsUpdated?: Maybe<RecordAction>;
  /** Personal effects information for individuals. */
  personalEffects?: Maybe<UsIorPersonalEffects>;
  /** Time at which the PMS was activated. */
  pmsActivationTime?: Maybe<Scalars['DateTime']>;
  /** Time at which the PMS activation request was sent. */
  pmsRequestedTime?: Maybe<Scalars['DateTime']>;
  /** PMS status. */
  pmsStatus?: Maybe<UsIorPmsStatus>;
  /** Preferred CBP entry payment method. */
  preferredCbpEntryPaymentMethod?: Maybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** CBP importer program codes. */
  programCodes?: Maybe<Array<UsCbpImporterProgramCode>>;
  /** Related businesses reported on CBP form 5106. */
  relatedBusinesses?: Maybe<Array<UsCbp5106RelatedBusiness>>;
};

/** US-specific data for importers including CBP-related information. */
export type UsSpecificDataInput = {
  /** Whether ACH credit payment method is used. */
  achCredit?: InputMaybe<Scalars['Boolean']>;
  /** Bank details for the importer. */
  bank?: InputMaybe<UsCbp5106BankDetailsInput>;
  /** CBP 5106 rejection reasons. */
  cbp5106RejectionReasons?: InputMaybe<Array<UsCbp5106RejectedReasonInput>>;
  /** CBP mailing address classification. */
  cbpMailingAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** Reasons for requesting CBP assigned number. */
  cbpNumberReasons?: InputMaybe<Array<UsIorCbpAssignedNumberReason>>;
  /** CBP physical address classification. */
  cbpPhysicalAddressType?: InputMaybe<UsCbp5106AddressTypeInput>;
  /** CBP status of the US IOR. */
  cbpStatus?: InputMaybe<UsIorCbpStatus>;
  /** Confidentiality details. */
  confidentiality?: InputMaybe<UsIorConfidentialityInput>;
  /** Business establishment details. */
  establishment?: InputMaybe<UsCbp5106EstablishmentDetailsInput>;
  /** Individual members reported on CBP form 5106. */
  individuals?: InputMaybe<Array<UsCbp5106IndividualInput>>;
  /** CBP payer unit number. */
  payerUnitNumber?: InputMaybe<Scalars['UsCbpPayerUnitNumber']>;
  /** Payment terms offered to US IOR. */
  paymentTerms?: InputMaybe<UsIorPaymentTerms>;
  /** Personal effects information for individuals. */
  personalEffects?: InputMaybe<UsIorPersonalEffectsInput>;
  /** Time at which the PMS was activated. */
  pmsActivationTime?: InputMaybe<Scalars['DateTime']>;
  /** Time at which the PMS activation request was sent. */
  pmsRequestedTime?: InputMaybe<Scalars['DateTime']>;
  /** PMS status. */
  pmsStatus?: InputMaybe<UsIorPmsStatus>;
  /** Preferred CBP entry payment method. */
  preferredCbpEntryPaymentMethod?: InputMaybe<UsIorCbpEntryPreferredPaymentMethod>;
  /** CBP importer program codes. */
  programCodes?: InputMaybe<Array<UsCbpImporterProgramCode>>;
  /** Related businesses reported on CBP form 5106. */
  relatedBusinesses?: InputMaybe<Array<UsCbp5106RelatedBusinessInput>>;
};

export type UsSteelRequirements = {
  __typename?: 'UsSteelRequirements';
  /** Is derivative steel product of Mexico only */
  derivativeSteelProductOfMexicoOnly?: Maybe<Scalars['Boolean']>;
  /** Steel country of melt and pour. For products melted/poured in the U.S., report "US" */
  steelCountryOfMeltAndPour?: Maybe<Scalars['CountryCode']>;
};

export type UsSteelRequirementsInput = {
  /** Is derivative steel product of Mexico only */
  derivativeSteelProductOfMexicoOnly?: InputMaybe<Scalars['Boolean']>;
  /** Steel country of melt and pour. For products melted/poured in the U.S., report "US" */
  steelCountryOfMeltAndPour?: InputMaybe<Scalars['CountryCode']>;
};

export type UsTariffPgaDescription = {
  __typename?: 'UsTariffPgaDescription';
  /** Whether the product description sent to the PGA is the same as the CBP description. */
  sameAsCbp?: Maybe<Scalars['Boolean']>;
  /** The text of the description. */
  text?: Maybe<Scalars['String']>;
};

export type UsTariffPgaDescriptionInput = {
  /** Whether the product description sent to the PGA is the same as the CBP description. */
  sameAsCbp?: InputMaybe<Scalars['Boolean']>;
  /** The text of the description. */
  text?: InputMaybe<Scalars['String']>;
};

export type UsTtbCertificateOfLabelApproval = {
  __typename?: 'UsTtbCertificateOfLabelApproval';
  /** Indicates the reason for exemption from LPCO. See Appendix PGA for valid codes. */
  exemptionCode?: Maybe<LpcoExemptionCode>;
  /** Identifies the Certificate of Label Approval number(s) (COLAs). */
  numbers?: Maybe<Array<Scalars['String']>>;
};

export type UsTtbCertificateOfLabelApprovalInput = {
  /** Indicates the reason for exemption from LPCO. See Appendix PGA for valid codes. */
  exemptionCode?: InputMaybe<LpcoExemptionCode>;
  /** Identifies the Certificate of Label Approval number(s) (COLAs). */
  numbers?: InputMaybe<Array<Scalars['String']>>;
};

export type UsType86EntriesConnection = Connection & {
  __typename?: 'UsType86EntriesConnection';
  edges: Array<UsType86EntryEdge>;
  nodes: Array<UsType86Entry>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UsType86Entry = Record & WorkOrder & {
  __typename?: 'UsType86Entry';
  /** Arrival information */
  arrival?: Maybe<UsType86EntryArrival>;
  /** US Customs Broker associated with this entry. */
  broker: UsType86EntryBroker;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** US Buyer associated with this entry. */
  buyer?: Maybe<UsType86EntryBuyer>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** CBP Team assigned to the entry. */
  cbpTeam?: Maybe<Scalars['String']>;
  /** Indicates census warning status of the US entry release. */
  censusHeaderStatus?: Maybe<UsCbpEntryCensusHeaderStatusCode>;
  /** CBP collection status */
  collectionStatus?: Maybe<Scalars['String']>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** US Consignee associated with this entry. */
  consignee?: Maybe<UsType86EntryConsignee>;
  /** Containers associated with the entry. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Indicates the control status of the US entry release. */
  controlStatus?: Maybe<UsCbpEntryControlStatusCode>;
  /** Conveyance information. */
  conveyance: UsType86EntryConveyance;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Departure information. */
  departure?: Maybe<UsType86EntryDeparture>;
  /** The documents associated with the US Type 86 Entry. This is an eventually consistent query. */
  documents: Array<Document>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['UsCbpEntryTypeCode']>;
  /** The estimated CBP charges if this entry had been filed as a US Consumption Entry */
  estimatedCustomsChargedSaved?: Maybe<UsCbpEntryCharges>;
  /** Exam details associated with the entry. */
  exam?: Maybe<UsType86EntryExam>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Indicates the filing timeliness of the US entry release. */
  filingTimeliness?: Maybe<UsCbpEntryFilingTimeliness>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Commercial invoices declared on the entry. */
  invoices?: Maybe<Array<UsType86EntryCommercialInvoice>>;
  /** US IOR associated with this entry. */
  ior?: Maybe<UsType86EntryIor>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bills associated with the entry. */
  masterBills?: Maybe<Array<UsType86EntryMasterBill>>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDispositions?: Maybe<Array<UsCbpEntryPgaDisposition>>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: Maybe<Scalars['Date']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDispositions?: Maybe<Array<UsCbpEntryReleaseDisposition>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReasons?: Maybe<Array<UsCbpEntryReleaseRejectionReason>>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: Maybe<UsCbpEntryReleaseStatus>;
  /** Indicates how to release split shipments. */
  splitShipmentReleaseMethod?: Maybe<UsCbpSplitShipmentReleaseMethod>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** The total value of the merchandise reported to US CBP. */
  totalAssist?: Maybe<Scalars['UsDollars']>;
  /** The total value of the merchandise reported to US CBP. */
  totalValue?: Maybe<Scalars['UsDollars']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type UsType86EntrydocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UsType86EntryArrival = {
  __typename?: 'UsType86EntryArrival';
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: Maybe<Scalars['FirmsCode']>;
  /** A General Order number. */
  goNumber?: Maybe<Scalars['String']>;
  /** The date the shipment physically arrives in the US. */
  importDate?: Maybe<Scalars['Date']>;
  /** Data relating to an IT In-Bond movement for the shipment */
  inBond?: Maybe<UsType86EntryInBondInfo>;
  /** The shipment's US port of unlading. */
  portOfUnladingCode?: Maybe<Scalars['UsCbpPortCode']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: Maybe<Scalars['FirmsCode']>;
  /** The US 2-letter state code of the shipment's final destination. */
  usDestinationStateCode?: Maybe<Scalars['UsStateCode']>;
};

export type UsType86EntryArrivalInput = {
  /** The FIRMS code of the container freight station (CFS) or terminal at the port of entry. */
  firmsCode?: InputMaybe<Scalars['FirmsCode']>;
  /** A General Order number. */
  goNumber?: InputMaybe<Scalars['String']>;
  /** The date the shipment physically arrives in the US. */
  importDate?: InputMaybe<Scalars['Date']>;
  /** Data relating to an IT In-Bond movement for the shipment */
  inBond?: InputMaybe<UsType86EntryInBondInfoInput>;
  /** The shipment's US port of unlading. */
  portOfUnladingCode?: InputMaybe<Scalars['UsCbpPortCode']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: InputMaybe<Scalars['FirmsCode']>;
  /** The US 2-letter state code of the shipment's final destination. */
  usDestinationStateCode?: InputMaybe<Scalars['UsStateCode']>;
};

export type UsType86EntryBroker = {
  __typename?: 'UsType86EntryBroker';
  /** Party address */
  address?: Maybe<Address>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: Maybe<UsType86EntryPointOfContact>;
  /** US Customs Broker */
  usCustomsBroker: UsCustomsBroker;
};

export type UsType86EntryBrokerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** Point of contact for US CBP to use */
  pointOfContact?: InputMaybe<UsType86EntryPointOfContactInput>;
  /** US Customs Broker */
  usCustomsBroker: IdInput;
};

export type UsType86EntryBuyer = {
  __typename?: 'UsType86EntryBuyer';
  /** Party address */
  address?: Maybe<Address>;
  /** buyer party info */
  buyer?: Maybe<Facility>;
  /** Buyer DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Buyer Employer Identification Number */
  ein?: Maybe<Scalars['String']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: Maybe<UsType86EntryPointOfContact>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** If the Buyer DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
};

export type UsType86EntryBuyerInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Id and version input of buyer */
  buyer?: InputMaybe<IdVersionInput>;
  /** Buyer DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Buyer Employer Identification Number */
  ein?: InputMaybe<Scalars['String']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: InputMaybe<UsType86EntryPointOfContactInput>;
  /** Flag to determine if buyer is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** If the Buyer DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

/** The transaction represents a US Type 86 Entry related request and response to US CBP via ABI. */
export type UsType86EntryCbpTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsType86EntryCommercialInvoice = {
  __typename?: 'UsType86EntryCommercialInvoice';
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: Maybe<Cost>;
  /** The currency rate used when converting to USD. */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Products on the Commercial Invoice */
  products?: Maybe<Array<UsType86EntryProduct>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: Maybe<UsType86EntrySupplier>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: Maybe<Cost>;
};

export type UsType86EntryCommercialInvoiceInput = {
  /** The total assist of the lines on the Commercial Invoice. */
  assist?: InputMaybe<CostInput>;
  /** The currency rate used when converting to USD. */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Products on the Commercial Invoice */
  products?: InputMaybe<Array<UsType86EntryProductInput>>;
  /** The Seller of the products on the Commercial Invoice. */
  seller?: InputMaybe<UsType86EntrySupplierInput>;
  /** The total value of the lines on the Commercial Invoice. */
  value?: InputMaybe<CostInput>;
};

export type UsType86EntryConsignee = {
  __typename?: 'UsType86EntryConsignee';
  /** Party address */
  address?: Maybe<Address>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: Maybe<UsType86EntryPointOfContact>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** UsConsignee details */
  usConsignee?: Maybe<UsConsignee>;
};

export type UsType86EntryConsigneeInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: InputMaybe<UsType86EntryPointOfContactInput>;
  /** Flag to determine if consignee is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** Id version of the Consignee */
  usConsignee?: InputMaybe<IdVersionInput>;
};

export type UsType86EntryConveyance = {
  __typename?: 'UsType86EntryConveyance';
  /** Whether the goods are containerized. */
  containerized?: Maybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: Maybe<Scalars['Float']>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: UsCbpEntryModeOfTransport;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
};

export type UsType86EntryConveyanceInput = {
  /** Whether the goods are containerized. */
  containerized?: InputMaybe<Scalars['Boolean']>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<Scalars['String']>;
  /** The gross weight of the shipment in KG. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: UsCbpEntryModeOfTransport;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<Scalars['String']>;
};

export type UsType86EntryDeparture = {
  __typename?: 'UsType86EntryDeparture';
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['Date']>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingCode?: Maybe<Scalars['UsCbpForeignPortCode']>;
};

export type UsType86EntryDepartureInput = {
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<Scalars['Date']>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingCode?: InputMaybe<Scalars['UsCbpForeignPortCode']>;
};

export type UsType86EntryDii = {
  __typename?: 'UsType86EntryDii';
  /** Customs agent address */
  address?: Maybe<Address>;
  /** The customs agent record */
  customsAgent?: Maybe<CustomsAgent>;
  /** Customs agent name */
  name?: Maybe<Scalars['String']>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
};

export type UsType86EntryDiiInput = {
  /** Customs agent address */
  address?: InputMaybe<AddressInput>;
  /** The customs agent record */
  customsAgent?: InputMaybe<IdVersionInput>;
  /** Customs agent name */
  name?: InputMaybe<Scalars['String']>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
};

export type UsType86EntryDisTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  usType86Entry: UsType86Entry;
  /** The record's version */
  version: Scalars['Int'];
};

export type UsType86EntryEdge = ConnectionEdge & {
  __typename?: 'UsType86EntryEdge';
  cursor: Scalars['ID'];
  node: UsType86Entry;
};

export type UsType86EntryExam = {
  __typename?: 'UsType86EntryExam';
  /** Containers associated with the exam. */
  containers?: Maybe<Array<ShippingContainer>>;
  /** Last date the LSP was notified on. */
  lspNotifiedDate?: Maybe<Scalars['Date']>;
  /** Firms code associated with the exam site. */
  site?: Maybe<Scalars['FirmsCode']>;
  /** The status of the exam being conducted on the entry. */
  status?: Maybe<UsCbpEntryExamStatus>;
  /** The specific type of exam conducted on the entry. */
  subType?: Maybe<UsCbpEntryExamSubType>;
  /** The type of the exam conducted on the entry. */
  type?: Maybe<UsCbpEntryExamType>;
};

export type UsType86EntryExamInput = {
  /** Containers associated with the exam. */
  containers?: InputMaybe<Array<ShippingContainerInput>>;
  /** Last date the LSP was notified on. */
  lspNotifiedDate?: InputMaybe<Scalars['Date']>;
  /** Firms code associated with the exam site. */
  site?: InputMaybe<Scalars['FirmsCode']>;
  /** The status of the exam being conducted on the entry. */
  status?: InputMaybe<UsCbpEntryExamStatus>;
  /** The specific type of exam conducted on the entry. */
  subType?: InputMaybe<UsCbpEntryExamSubType>;
  /** The type of the exam conducted on the entry. */
  type?: InputMaybe<UsCbpEntryExamType>;
};

export type UsType86EntryFacility = {
  __typename?: 'UsType86EntryFacility';
  /** Party address */
  address?: Maybe<Address>;
  /** The Facility record. */
  facility?: Maybe<Facility>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: Maybe<UsType86EntryPointOfContact>;
};

export type UsType86EntryFacilityInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** The Facility record. */
  facility?: InputMaybe<IdVersionInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: InputMaybe<UsType86EntryPointOfContactInput>;
};

export type UsType86EntryFsvp = {
  __typename?: 'UsType86EntryFsvp';
  /** Customs agent address */
  address?: Maybe<Address>;
  /** The customs agent record */
  customsAgent?: Maybe<CustomsAgent>;
  /** Customs agent DUNS number */
  duns?: Maybe<Scalars['DUNS']>;
  /** Customs agent name */
  name?: Maybe<Scalars['String']>;
  /** A point of contact at the party's organization */
  pointOfContact?: Maybe<PointOfContact>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: Maybe<Scalars['Boolean']>;
  /** If the customs agent DUNS number is unknown */
  unknownDuns?: Maybe<Scalars['Boolean']>;
};

export type UsType86EntryFsvpInput = {
  /** Customs agent address */
  address?: InputMaybe<AddressInput>;
  /** The customs agent record */
  customsAgent?: InputMaybe<IdVersionInput>;
  /** Customs agent DUNS number */
  duns?: InputMaybe<Scalars['DUNS']>;
  /** Customs agent name */
  name?: InputMaybe<Scalars['String']>;
  pointOfContact?: InputMaybe<PointOfContactInput>;
  /** Flag to determine if customs agent is the same as IOR */
  sameAsIor?: InputMaybe<Scalars['Boolean']>;
  /** If the customs agent DUNS number is unknown */
  unknownDuns?: InputMaybe<Scalars['Boolean']>;
};

export type UsType86EntryHouseBill = {
  __typename?: 'UsType86EntryHouseBill';
  /** In-bond number associated w/ the bill. */
  inBondNumber?: Maybe<Scalars['String']>;
  /** House Bill number */
  number?: Maybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: Maybe<Scalars['Int']>;
};

export type UsType86EntryHouseBillInput = {
  /** In-bond number associated w/ the bill. */
  inBondNumber?: InputMaybe<Scalars['String']>;
  /** House Bill number */
  number?: InputMaybe<Scalars['String']>;
  /** Integer quantity of the bill, aka Piece Count. */
  quantity?: InputMaybe<Scalars['Int']>;
};

/** IT In-bond data for a shipment. */
export type UsType86EntryInBondInfo = {
  __typename?: 'UsType86EntryInBondInfo';
  /** The estimated (or actual) entry date. */
  estimatedEntryDate?: Maybe<Scalars['Date']>;
  /** The date that the in-bond associated with the shipment initiated. */
  initiationDate?: Maybe<Scalars['Date']>;
  /** The shipment's US port of entry. */
  portOfEntryCode?: Maybe<Scalars['UsCbpPortCode']>;
};

/** IT In-bond data for a shipment. */
export type UsType86EntryInBondInfoInput = {
  /** The estimated (or actual) entry date. */
  estimatedEntryDate?: InputMaybe<Scalars['Date']>;
  /** The date that the in-bond associated with the shipment initiated. */
  initiationDate?: InputMaybe<Scalars['Date']>;
  /** The shipment's US port of entry. */
  portOfEntryCode?: InputMaybe<Scalars['UsCbpPortCode']>;
};

export type UsType86EntryIor = {
  __typename?: 'UsType86EntryIor';
  /** Party address */
  address?: Maybe<Address>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: Maybe<UsIorNumber>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: Maybe<UsType86EntryPointOfContact>;
  /** UsIor details */
  usIor: UsIor;
};

export type UsType86EntryIorInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<UsIorNumberInput>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: InputMaybe<UsType86EntryPointOfContactInput>;
  /** Id version of the IOR */
  usIor: IdVersionInput;
};

export type UsType86EntryLine = {
  __typename?: 'UsType86EntryLine';
  /** The Anti-Dumping Case record. */
  adCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: Maybe<Cost>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: Maybe<UsAluminumRequirements>;
  /** The dollar assist of the line item reported to US CBP. */
  assist?: Maybe<Scalars['UsDollars']>;
  /** The Countervailing Case record. */
  cvCaseNumber?: Maybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: Maybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: Maybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: Maybe<Cost>;
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: Maybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: Maybe<Scalars['Boolean']>;
  /** External reference for the Product Line. */
  externalReference?: Maybe<ExternalComplianceReference>;
  feeOptions?: Maybe<Array<UsCbpEntryLineFeeOption>>;
  /** The license code. */
  licenseCode?: Maybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: Maybe<Scalars['String']>;
  /** The manufacturer of the line item. */
  manufacturer?: Maybe<UsType86EntrySupplier>;
  /** The origin of the line item. */
  origin?: Maybe<ProductEntryLineOrigin>;
  /** The purchase order (PO) number of the line item */
  poNumber?: Maybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: Maybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: Maybe<UsProductEntryLineRuling>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: Maybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: Maybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: Maybe<UsSteelRequirements>;
  /** Tariffs on the line item. */
  tariffs?: Maybe<Array<UsType86EntryTariff>>;
  taxOptions?: Maybe<Array<UsCbpEntryLineTaxOption>>;
  /** The dollar value of the line item reported to US CBP. */
  value?: Maybe<Scalars['UsDollars']>;
};

export type UsType86EntryLineInput = {
  /** The Anti-Dumping Case record. */
  adCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for anti-dumping case */
  adDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Anti-Dumping duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  adPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Anti-Dumping duties. Defaults to the line value. */
  adValue?: InputMaybe<CostInput>;
  /** An alumnium exclusion number. */
  aluminumExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for aluminum products. */
  aluminumRequirements?: InputMaybe<UsAluminumRequirementsInput>;
  /** The dollar assist of the line item reported to US CBP. */
  assist?: InputMaybe<Scalars['UsDollars']>;
  /** The Countervailing Case record. */
  cvCaseNumber?: InputMaybe<Scalars['String']>;
  /** Disclaimer code for countervailing case */
  cvDisclaimerCode?: InputMaybe<AdCvdDisclaimerCode>;
  /** Whether the Countervailing duties will be paid with cash or from a bond. Defaults to cash if not provided. */
  cvPaymentMethod?: InputMaybe<AdCvdCasePaymentMethod>;
  /** Special value to be used for calculating Countervailing duties. Defaults to the line value. */
  cvValue?: InputMaybe<CostInput>;
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the product line contains aluminum. */
  doesNotContainAluminum?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product line contains steel. */
  doesNotContainSteel?: InputMaybe<Scalars['Boolean']>;
  /** External reference for the Product Line. */
  externalReference?: InputMaybe<ExternalComplianceReferenceInput>;
  feeOptions?: InputMaybe<Array<UsCbpEntryLineFeeOptionInput>>;
  /** The license code. */
  licenseCode?: InputMaybe<Scalars['String']>;
  /** The identifier/number for the applicable license, certificate, or permit for the tariff. */
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** The manufacturer of the line item. */
  manufacturer?: InputMaybe<UsType86EntrySupplierInput>;
  /** The origin of the line item. */
  origin?: InputMaybe<ProductEntryLineOriginInput>;
  /** The purchase order (PO) number of the line item */
  poNumber?: InputMaybe<Scalars['String']>;
  /** A code that further identifies a product or request. */
  productClaimCode?: InputMaybe<Scalars['String']>;
  /** Line item ruling details. */
  ruling?: InputMaybe<UsProductEntryLineRulingInput>;
  /** A code indicating if a tariff number is subject to a special program. */
  spi?: InputMaybe<Scalars['UsSpecialProgramIndicator']>;
  /** A steel exclusion number. */
  steelExclusionNumber?: InputMaybe<Scalars['String']>;
  /** Additional reporting requirements for steel products. */
  steelRequirements?: InputMaybe<UsSteelRequirementsInput>;
  /** Tariffs on the line item. */
  tariffs?: InputMaybe<Array<UsType86EntryTariffInput>>;
  taxOptions?: InputMaybe<Array<UsCbpEntryLineTaxOptionInput>>;
  /** The dollar value of the line item reported to US CBP. */
  value?: InputMaybe<Scalars['UsDollars']>;
};

export type UsType86EntryMasterBill = {
  __typename?: 'UsType86EntryMasterBill';
  /** Indicates whether bill of lading is matched to an AMS bill of lading */
  billOnFile?: Maybe<Scalars['Boolean']>;
  /** Array of house bills */
  houseBills?: Maybe<Array<UsType86EntryHouseBill>>;
  /** Master Bill number */
  number?: Maybe<Scalars['String']>;
};

export type UsType86EntryMasterBillInput = {
  /** Indicates whether bill of lading is matched to an AMS bill of lading */
  billOnFile?: InputMaybe<Scalars['Boolean']>;
  /** Array of house bills */
  houseBills?: InputMaybe<Array<UsType86EntryHouseBillInput>>;
  /** Master Bill number */
  number?: InputMaybe<Scalars['String']>;
};

/** Data requirements reported to a US CBP Partner Government Agency. */
export type UsType86EntryPga = {
  __typename?: 'UsType86EntryPga';
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: Maybe<Scalars['String']>;
  /** A distinct and legible mark, properly applied with a freeze brand, hot iron, or other method, and easily visible on the live animal and on the carcass before skinning. Used by APHIS. */
  animalBrand?: Maybe<Scalars['String']>;
  /** Number that characterizes the commercial product or component. Used by: APHIS */
  aphProductCode?: Maybe<Scalars['String']>;
  /** APHIS VS 17-32. Application for Inspection and Dipping. */
  applicationForInspectionAndDipping?: Maybe<Lpco>;
  /** Category code for weapons. Used by: ATF */
  atfCategory?: Maybe<Scalars['AtfCategoryCode']>;
  /** A permit that authorizes the importation of firearms, ammunitions, and implements of war into the United States or any possession thereof, except for certain exempt importations presecribed in 27 CFR parts 447, 478 and 479. Used by: ATF */
  atfImportPermit?: Maybe<Lpco>;
  /** Registered importers of firearms, ammunition firearms parts or implements of war other, than sporting shotguns, shotgun shells, or shotgun parts, must also register under the Arms Export Control Act of 1976. Used by: ATF */
  atfImporterRegistration?: Maybe<Lpco>;
  /** Identification method often used on aves (birds). Used by APHIS. */
  band?: Maybe<Scalars['String']>;
  /** Cut Flowers Bouquet Grouping Code. Used by APHIS. */
  bouquetGroupingCode?: Maybe<Scalars['String']>;
  /** APHIS BRS Acknowledgement letter */
  brsAcknowledgementLetter?: Maybe<Lpco>;
  /** APHIS BRS Notification. */
  brsNotification?: Maybe<Lpco>;
  /** Chemical Abstract Service Number. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  casNumber?: Maybe<Scalars['String']>;
  /** Commodity category code used to further describe the reported item. Used by: APHIS, NHTSA, ATF */
  categoryCode?: Maybe<Scalars['String']>;
  /** Category type code used to describe the reported item. Used by: APHIS. */
  categoryTypeCode?: Maybe<Scalars['String']>;
  /** US TTB Certificate of Label Approval Number Used by: TTB */
  certificateOfLabelApproval?: Maybe<UsTtbCertificateOfLabelApproval>;
  /** Certificate of Origin. Used by APHIS. */
  certificateOfOrigin?: Maybe<Lpco>;
  /** PGA source and processing data Used by: APHIS, FDA */
  characteristics?: Maybe<Array<CommodityCharacteristic>>;
  /** Chemical Abstract Service Numbers. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  chemicalAbstractServiceNumbers?: Maybe<Array<Scalars['String']>>;
  /** This number corresponds to the box number from DOT HS-7 Required by: NHTSA */
  conformanceDeclaration?: Maybe<Scalars['String']>;
  /** Constituent elements of the product/component. Required for: APHIS (Lacey Act), DEA. Used by: FWS. Optional for: EPA, FDA */
  constituentElements?: Maybe<Array<ConstituentElement>>;
  /** APHIS PPQ587-41. Permit to Import Plants and Plant Products Regulated by 7CFR319.41 (Indian Corn or Maize, Broomcorn, etc.) */
  cornPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-8. Permit to Import Plants and Plant Products Regulated by 7CFR319.8 (Foreign Cotton or Covers) */
  cottonPermit?: Maybe<Lpco>;
  /** Crop Grower. Supplier type. Required for Cut flowers (Category Type Code AP0800). Used by APHIS. */
  cropGrower?: Maybe<UsType86EntrySupplier>;
  /** APHIS VS 17-29. Declaration of Importation. */
  declarationOfImportation?: Maybe<Lpco>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the US manufacturer. Should always be the domestic firm registration number associated with the U.S. manufacturer and not the foreign manufacturer. Used by: FDA (medical devices) */
  deviceDomesticManufacturer?: Maybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the exporter who exports or offers for export to the United States (U.S.), a device manufactured or processed by another individual, partnership, corporation or association in a foreign country, as well as devices originally manufactured in the United States. Used by: FDA (medical devices) */
  deviceForeignExporter?: Maybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the foreign manufacturer. Should always be the foreign firm registration number associated with the foreign manufacturer and not the US specifications developer. Used by: FDA (medical devices) */
  deviceForeignManufacturer?: Maybe<Scalars['String']>;
  /** Defines whether a radiation emitting product is a finished product or just a component */
  deviceForm?: Maybe<UsFdaRadiationEmittingDeviceForm>;
  /** Device Initial Importer. Where the IOR is a US entity, DII will default to the IOR. If the IOR is a non-resident, then ops will have to select the DII. */
  deviceInitialImporter?: Maybe<UsType86EntryDii>;
  /** Device Listing Number provided by CDRH Used by: FDA (medical devices) */
  deviceListingNumber?: Maybe<Scalars['String']>;
  /** Device Premarket Approval Number or Device Premarket Notification Number (510(K))/DeNovo number issued by CDRH (Center for Devices and Radiological Health) or CBER. This also includes Humanitarian Device Exemption (HDE). Premarket number should always be the number that is on the listing record. Used by: FDA (medical devices) */
  devicePremarketNumber?: Maybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: Maybe<UsPgaDisclaimerCode>;
  /** APHIS 7040B/7040C. Import Permit for Dogs. */
  dogsPermit?: Maybe<Lpco>;
  /** Department of Transportation conformance bond. Used by: NHTSA */
  dotBond?: Maybe<DotBond>;
  /** The placement of the driver's seat in a vehicle Used by: NHTSA */
  driveSide?: Maybe<VehicleDriveSide>;
  /** New Drug (NDA), Abbreviated New Drug (AND/ANDA), or Therapeutic Biologic Application Number issued by CBER or CDER. Used by: FDA (drugs) */
  drugApplicationNumber?: Maybe<Scalars['String']>;
  /** Defines whether a drug is an active pharmaceutical ingredient (API) / bulk drug substance, or a finished drug form (e.g. tablet, capsule, solution). */
  drugForm?: Maybe<UsFdaDrugForm>;
  /** Drug Listing Number (DLS), for a bulk Active Pharmaceutical Ingredient (API), or National Drug Code (NDC), for finished drugs, issued by FDA. The first segment of numbers is the labeler code. This number identifies the manufacturer of the product. Declare without dashes. Used by: FDA (drugs) */
  drugListingNumber?: Maybe<Scalars['String']>;
  /** Drug Registration Number issued by Center for Drug Evaluation and Research (CDER), Center for Veterinary Medicine (CVM), or Center for Biologics Evaluation and Research (CBER) for the manufacturer. The Federal Food, Drug, and Cosmetic Act (FFD&C) requires most establishments that manufacturer, prepare, propagate, compound, or process a drug or drugs, to register with the FDA. Currently, the establishment registration number is the Dun & Bradstreet Data Universal Numbering System number (DUNS) for CDER and CVM. The establishment registration number can be the FDA Establishment Identification (FEI) or DUNS for CBER. Used by: FDA (drugs)   */
  drugRegistrationNumber?: Maybe<Scalars['String']>;
  /** Device (Electrode) Lead Wire or Patient Cable, used when importing electrode lead wires, patient cables, or devices that use them. The affirmation indicates either (1) the device shipment does not contain any pre-wired electrodes, electrode lead wires, or patient (transducer) cables, or (2) any pre-wired electrodes, electrode lead wires or patient cables comply with 21 CFR 898, Performance Standard for Electrode Lead Wires and Patient Cables. Used by: FDA (medical devices) */
  electrode?: Maybe<Scalars['Boolean']>;
  /** The two-letter ISO country code that identifies the Importer’s Embassy Used by: NHTSA */
  embassyCountryCode?: Maybe<Scalars['CountryCode']>;
  /** EPA Vehicles and Engines Engine Power Rating Used by: EPA */
  enginePowerRating?: Maybe<Quantity>;
  /** Engine data. Used by: EPA */
  engines?: Maybe<Array<UsPgaEngine>>;
  /** See https://www.epa.gov/compliance/pesticide-establishment-registration-and-reporting Used by: EPA */
  epaProducerEstablishmentNumber?: Maybe<Lpco>;
  /** The EPA Reg. No. of a product for primary registrants consists of two set of numbers separated by a hyphen, for example EPA Reg. No. 12345-12. The first set of numbers refers to the registrant’s company identification number, and the second set of numbers represents the product number. Used by: EPA */
  epaRegistrationNumber?: Maybe<Lpco>;
  /** EPA Vehicles and Engines Test Group Name/Number Used by: EPA */
  epaTestGroup?: Maybe<Scalars['String']>;
  /** The FDA product code of the product/component. Required by: FDA */
  fdaProductCode?: Maybe<Scalars['String']>;
  /** A license or permit issued to anyone who wishes to transport, ship, and cause to be transported, or receive explosives materials under 27 CFR 555.41. Used by: ATF */
  federalExplosiveLicense?: Maybe<Lpco>;
  /** Federal firearms license issued under the provisions of the Gun Control Act (GCA) to manufacture, import or  in firearms and/or ammunition. Used by: ATF */
  federalFirearmsLicense?: Maybe<Lpco>;
  /** Food Canning Establishment Number (FCE) that identifies a site-specific manufacturer of acidified and/or low-acid canned food products. Form FDA 2541 is  used for the manufacturing firm registration. See the SID and VOL Affirmation Code definitions below Used by: FDA (LACF/AF food) */
  foodCanningEstablishmentNumber?: Maybe<Scalars['String']>;
  /** Food container dimensions. Required by: FDA (LACF and AF Food) */
  foodContainerDimensions?: Maybe<Dimensions>;
  foodFacilityRegistration?: Maybe<UsFdaFoodFacilityRegistration>;
  /** Acidified & Low-Acid Canned Foods (LACF/AF) Volume. May be used to communicate the container volume and unit of measure of an Acidified Food (AF) or Low-Acid Food (LACF) product that is packaged in a container that does not have a traditional size/dimension. The filer should verify with the importer whether  the container size/dimensions or volume were supplied to FDA by the manufacturer. Use of this field instead of the Container Size/Dimension, when  Container Size/Dimension is part of the scheduled process, will result in a failure of the automated data base look-up. Used by: FDA (LACF/AF food) */
  foodVolume?: Maybe<Scalars['String']>;
  /** The foreign certificate for imported distilled spirits and wine. Used by: TTB */
  foreignCertificate?: Maybe<Lpco>;
  /** APHIS PPQ 203. Foreign Site Certificate of Inspection and/or treatment. */
  foreignSiteCertificateOfInspection?: Maybe<Lpco>;
  /** Foreign Supplier Verification Program Importer. Where the IOR is a US entity, FSVP will default to the IOR. If the IOR is a non-resident, then ops will have to select the FSVP. */
  foreignSupplierVerificationProgram?: Maybe<UsType86EntryFsvp>;
  /** APHIS PPQ587-56. Permit to Import Plants and Plant Products Regulated by 7CFR319.56 (Fruits and Vegetables). */
  fruitsAndVegetablesPermit?: Maybe<Lpco>;
  /** A NHTSA-assigned code identifying the glazing manufacturer. Formatted N or NN or NNN or NNNN (e.g., 1234) Used by: NHTSA */
  glazingManufacturerCode?: Maybe<Scalars['String']>;
  /** GS1 Global Product Classification Brick Code (GPCB). An 8-digit number designating a set of products with similar characteristics as defined by GS1 at http://www.gs1.org/gsmp/kc/gpc. Used by APHIS. */
  globalProductClassificationBrickCode?: Maybe<Scalars['String']>;
  /** APHIS BRS 2000. Application for Permit or Courtesy Permit for Movement or Release of Genetically Engineered Organisms. */
  gmoPermit?: Maybe<Lpco>;
  /** Health Certificate. Used by APHIS. */
  healthCertificate?: Maybe<Lpco>;
  /** Device Impact Resistance Lens Certification, used to certify that the filer has, on hand, the test results or a certificate that shows that the product has met the standards for impact resistance lenses. FDA has the authority to ask for copies of the actual test results. Each batch within the shipment must have its own test results. Used by: FDA (medical devices) */
  impactResistanceLensCertification?: Maybe<Scalars['Boolean']>;
  /** APHIS 2006. Importation of Veterinary Biological Products. */
  importationOfVeterinaryBiologicalProducts?: Maybe<Lpco>;
  /** Data pertaining to an inspection. Used by: APHIS, FWS */
  inspection?: Maybe<UsPgaInspection>;
  /** The intended use code of the product/component. Required by: APHIS, FDA, EPA Used by: FWS */
  intendedUse?: Maybe<Scalars['String']>;
  /** Describes the intended use of the product/component. Used by: FWS */
  intendedUseDescription?: Maybe<Scalars['String']>;
  /** Investigational New Drug Application Number issued by CBER or CDER. Investigational drugs are new drugs intended solely for investigational use by  experts qualified by scientific training and experiences to investigate the safety and effectiveness of drugs. The Federal Food, Drug, and Cosmetic Act (FFD&C) Act requires that a drug be the subject of an approved marketing application before it is transported or distributed across state lines (including import). A sponsor who wants to ship the investigational drug to clinical investigators must seek an exemption from that legal requirement. Used by: FDA (investigational new drugs) */
  investigationNewDrugApplicationNumber?: Maybe<Scalars['String']>;
  /** Investigational Device Exemption Number issued by CBER or CDRH. Devices that qualified experts use on human subjects, to conduct investigations of their safety and effectiveness, are considered investigational devices. For devices destined for non-significant risk study (NSR), an Institutional Review Boards(IRB) letter affirming NSR must be provided to FDA. In such case, provide 'NSR'. Used by: FDA (medical devices) */
  investigationalDeviceExemptionNumber?: Maybe<Scalars['String']>;
  /** The importer is an original manufacturer of motor vehicles (or a wholly owned subsidiary thereof) that is certified to conform to all applicable Federal Motor Vehicle Safety Standards (FMVSS). Use on the public roads must be authorized specifically. [591.6(f )(1) or (2)]; Used by: NHTSA */
  iorIsVehicleManufacturer?: Maybe<Scalars['Boolean']>;
  /** Internal Revenue Code (IRC) registry number for the distilled spirits plant, bonded wine cellar, or brewery. Used by: TTB */
  ircRegistryNumber?: Maybe<Lpco>;
  /** Indicates that information should be treated as confidential. Used by: DEA, FWS */
  isConfidentialInformation?: Maybe<Scalars['Boolean']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) Used by: APHIS, EPA, NHTSA, FWS */
  isImageSubmitted?: Maybe<Scalars['Boolean']>;
  /** Identifies Toxic Substance Control Act positive or negative certification. Positive – I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA. Negative – I certify that all chemicals in this shipment are not subject to TSCA. Used by: EPA */
  isTscaCompliant?: Maybe<Scalars['Boolean']>;
  /** The unique identity for the item. Used by: APHIS */
  itemIdentity?: Maybe<ItemIdentity>;
  /** APHIS PPQ587-75. Permit to Import Plants and Plant Products Regulated by 7CFR319.75 (Khapra Beetle). */
  khapraBeetlePermit?: Maybe<Lpco>;
  /** The tariffs associated Independent Third Party Laboratory or Clinical Site. Required for investigational drugs. Required by: FDA (investigational new drugs) */
  laboratory?: Maybe<UsType86EntryFacility>;
  /** The type of laboratory. Required by: FDA (investigational new drugs) */
  laboratoryTypeCode?: Maybe<UsFdaLaboratoryType>;
  /** Live Animal Tag Ranges. Used by APHIS. */
  liveAnimalTagRanges?: Maybe<Array<LiveAnimalTagRange>>;
  /** Live Animal Tag. Used by APHIS. */
  liveAnimalTags?: Maybe<Array<Scalars['String']>>;
  /** APHIS VS 17-135. Permit to Import Live Animals. */
  liveAnimalsPermit?: Maybe<Lpco>;
  /** Manufacturer assigned lot number for the product. Required by: FDA (prior notice LACF/AF food, infant formula) */
  lotNumber?: Maybe<Scalars['String']>;
  /** LPCO Authorized Party. Location type. Required if at least one LPCO is used. Used by APHIS. */
  lpcoAuthorizedParty?: Maybe<UsType86EntryFacility>;
  /** Location of the manufacture date of the vehicle or engine. Used by: EPA */
  manufactureDateLocation?: Maybe<Scalars['String']>;
  /** Meat Certificate. Meat Certificate required by APHIS/FSIS to document sanitary condition and wholesomeness of animal or meat products. (Note: Meat and Sanitary Certificates can be “one and the same”). */
  meatCertificate?: Maybe<Lpco>;
  /** Microchip. Used by APHIS. */
  microchip?: Maybe<Scalars['String']>;
  /** NMFS Tag Number. The individual tag number of the fish. Used by APHIS. */
  nmfsTagNumber?: Maybe<Scalars['String']>;
  /** Free form information found in box 18 of EPA Form 3540-01. Required if EPA Registration number not provided. */
  noticeOfArrival?: Maybe<Scalars['String']>;
  /** USDA APHIS PPQ Notice Of Arrival */
  noticeOfArrivalPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-37. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Nursery Stock, Plants, Roots, Bulbs, Seeds). */
  nurseryPlantsPermit?: Maybe<Lpco>;
  /** Offical Animal Number. Unique number given by a national authority to identify an animal individually. Used by APHIS. */
  officialAnimalNumber?: Maybe<Scalars['String']>;
  /** Original country where routing to the US began. Required for: APHIS Used by: FWS */
  originCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Packaging associated with a PGA. Required if subject to FDA Prior Notice or a Performance Standard Used by: FDA, APHIS, EPA */
  packaging?: Maybe<Array<Quantity>>;
  /** Quantity of cigarette tubes or papers. Used by: TTB */
  paperOrTubeQuantity?: Maybe<Scalars['Int']>;
  /** Two-letter ISO country code of the country that issued the passport. Used by: NHTSA */
  passportCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Government issued passport number to certify the identity and nationality of the person importing the product. Used by: NHTSA */
  passportNumber?: Maybe<Scalars['String']>;
  /** Pesticide Control Number Used by: EPA */
  pcNumber?: Maybe<Scalars['String']>;
  /** Subject to a performance standard: FDA */
  performanceStandard?: Maybe<Scalars['Boolean']>;
  /** A letter issued by NHTSA permitting a nonconforming vehicle to be imported pursuant to 49 CFR 591.5(j) or 591(I). Formatted as NN-NNNN-NNNN. Used by: NHTSA */
  permissionLetter?: Maybe<Lpco>;
  /** Permitted Destination. Location type. Required if a Veterinary Biologics product (Category Code 307). Used by APHIS. */
  permittedDestination?: Maybe<UsType86EntryFacility>;
  /** Phytosanitary Certificate. Phytosanitary certificate required by APHIS to document the cleanliness (pest and disease) of Plant products. */
  phytosanitaryCertificate?: Maybe<Lpco>;
  /** APHIS PPQ 526. Permit to Move Live Plant Pests or Noxious Weeds. */
  plantPestsPermit?: Maybe<Lpco>;
  /** APHIS PPQ587-37CAN. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Canadian-Origin). */
  plantsOfCanadianOriginPermit?: Maybe<Lpco>;
  /** The name of the political subunit, e.g. state, province, or region through which goods are routed between the country of original departure and the country of final destination. Used by: APHIS */
  politicalSubunitName?: Maybe<Scalars['String']>;
  /** APHIS PPQ 546. Post-entry Quarantine Permit. */
  postEntryQuarantinePermit?: Maybe<Lpco>;
  /** US FDA Prior Notice data requirements. */
  priorNotice?: Maybe<UsFdaPriorNotice>;
  /** Code indicating the specific PGA processing requirements for which the data set is related. */
  processingCode?: Maybe<Scalars['String']>;
  /** A code indicating the type of product number used to characterize the product or component. Used by: APHIS */
  productQualifierCode?: Maybe<Scalars['String']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: Maybe<Scalars['String']>;
  /** APHIS PPQ 588. Permit to Import Prohibited Plant Material For Research Purposes. */
  prohibitedPlantForResearchPermit?: Maybe<Lpco>;
  /** APHIS PPQ 621. Protected Plant Permit to Engage in the Business of Importing, Exporting, or Re-exporting Terrestrial Plants or Plant Products that are Protected and Regulated by 50CFR17.12 or 50CFR23.23 (CITES: Threatened or Endangered Species). */
  protectedPlantPermit?: Maybe<Lpco>;
  /** Rabies Vaccination Certificate. Used by APHIS. */
  rabiesVaccinationCertifcate?: Maybe<Lpco>;
  radiationDeclaration?: Maybe<RadiationDeclaration>;
  /** Rail car numbers Used by: FDA (prior notice food arriving via rail/containerized rail.) */
  railCarNumbers?: Maybe<Array<Scalars['String']>>;
  /** Country that has refused the shipment. Used by: FDA */
  refusalCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Number assigned by NHTSA to a person or business entity specially registered with NHTSA as an importer of nonconforming motor vehicles pursuant to 49 CFR Part 592. Formatted as A-NN-NNN. Used by: NHTSA */
  registeredImporterNumber?: Maybe<Lpco>;
  /** Radio Frequency Identification. Used by APHIS. */
  rfid?: Maybe<Scalars['String']>;
  /** APHIS PPQ587-55. Permit to Import Plants and Plant Products Regulated by 7CFR319.55 (Rice). */
  ricePermit?: Maybe<Lpco>;
  /** LACF/AF Submission/Scheduled Process Identifier Number (SID) Used by: FDA (LACF/AF food) */
  scheduleIdentifierNumber?: Maybe<Scalars['String']>;
  /** APHIS Seed Analysis Certificate (PPQ Form 925, CFIA Form 5289, CFIA Form 5309 or similar form) */
  seedAnalysisCertificate?: Maybe<Lpco>;
  /** Country from where the product/component shipped. Required by: FDA (Food subject to Prior Notice) */
  shipmentCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Slaughter Number. Unique number given by a slaughterhouse to an animal or a group of animals of the same breed. Used by APHIS. */
  slaughterNumber?: Maybe<Scalars['String']>;
  /** APHIS PPQ 525B. Soil Permit. */
  soilPermit?: Maybe<Lpco>;
  /** PGA source and processing data Used by: APHIS, FDA */
  source?: Maybe<UsPgaSource>;
  /** USDA APHIS VS STAT Documents (Statements) (e.g. Manufacturer’s Statement, Owner/Importer Statements, Producer Statements) */
  statementsPermit?: Maybe<Lpco>;
  /** The storage location of the vehicle or engine. Used by: EPA */
  storageLocation?: Maybe<UsType86EntryFacility>;
  /** APHIS PPQ587-15. Permit to Import Plants and Plant Products Regulated by 7CFR319.15 (Sugarcane) */
  sugarcanePermit?: Maybe<Lpco>;
  /** Taxonomic Serial Number (TSN). A unique serial number assigned to a taxonomic unit by the Integrated Taxonomic Informational System at http://www.itis.gov. Used by APHIS. */
  taxonomicSerialNumber?: Maybe<Scalars['String']>;
  /** APHIS PPQ 585. Permit to Import Timber or Timber Products */
  timberPermit?: Maybe<Lpco>;
  /** A NHTSA-assigned code identifying the tire manufacturer. Formatted ANAN or ANANAN (e.g., 1B or ABC) Used by: NHTSA */
  tireManufacturerCode?: Maybe<Scalars['String']>;
  /** The Trade Name of the product/component. Used by: EPA, FDA, NHTSA */
  tradeName?: Maybe<Scalars['String']>;
  /** Country through which goods or passengers are routed between the country of original departure and final destination. Used by: APHIS */
  transitCountryCode?: Maybe<Scalars['CountryCode']>;
  /** APHIS PPQ 586. Permit to Transit Plants and/or Plant Products, Plant Pests, and/or Associated Soil. */
  transitPlantsPermit?: Maybe<Lpco>;
  /** Country where goods are to be or have been transferred from one means of transport to another during the course of one transport operation. Used by: APHIS */
  transshipmentCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Treatment Certificate. Used by APHIS. */
  treatmentCertificate?: Maybe<Lpco>;
  /** TTB-issued permit number indicating the IRC-bonded facility, manufacturer, or export warehouse proprietor. Used by: TTB */
  ttbFacilityPermitNumber?: Maybe<Lpco>;
  /** The importer's permit number assigned by TTB Used by: TTB */
  ttbImporterPermitNumber?: Maybe<Lpco>;
  /** UN Standard Products and Services Code (UNSPSC) Commodity Code. An 8-digit number designating a set of products with similar characteristics as defined by the United Nations at http://www.unspsc.org. Used by APHIS. */
  unpscCommodityCode?: Maybe<Scalars['String']>;
  /** Vehicle data. Used by: EPA, NHT */
  vehicle?: Maybe<UsPgaVehicle>;
  /** NHTSA-assigned number to identify a vehicle that is not certified to the Federal motor vehicle safety standards as being eligible for importation by a registered importer under a DOT conformance bond pursuant to 49 CFR Part 591.5(f). Formatted as AAA-NNN. */
  vehicleEligibilityNumber?: Maybe<Lpco>;
  /** APHIS VS 16-6A. Veterinary Permit to Import Controlled Materials and Organisms and Vectors. */
  veterinaryPermitToImportControlledMaterials?: Maybe<Lpco>;
  /** EPA Vehicles and Engines Bond Exemption Used by: EPA */
  vneBondExemptionNumber?: Maybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number Used by: EPA */
  vneBondNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number Used by: EPA */
  vneExemptionNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code Used by: EPA */
  vneImportCode?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code Used by: EPA */
  vneIndustryCode?: Maybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. Used by: EPA */
  vneOtherExemptionRegulation?: Maybe<Scalars['String']>;
  /** Measurements of the weapon(s) being imported. Used by: ATF */
  weaponMeasurements?: Maybe<WeaponMeasurements>;
};

/** Data requirements reported to a US CBP Partner Government Agency. */
export type UsType86EntryPgaInput = {
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: InputMaybe<Scalars['String']>;
  /** A distinct and legible mark, properly applied with a freeze brand, hot iron, or other method, and easily visible on the live animal and on the carcass before skinning. Used by APHIS. */
  animalBrand?: InputMaybe<Scalars['String']>;
  /** Number that characterizes the commercial product or component. Used by: APHIS */
  aphProductCode?: InputMaybe<Scalars['String']>;
  /** APHIS VS 17-32. Application for Inspection and Dipping. */
  applicationForInspectionAndDipping?: InputMaybe<LpcoInput>;
  /** Category code for weapons. Used by: ATF */
  atfCategory?: InputMaybe<Scalars['AtfCategoryCode']>;
  /** A permit that authorizes the importation of firearms, ammunitions, and implements of war into the United States or any possession thereof, except for certain exempt importations presecribed in 27 CFR parts 447, 478 and 479. Used by: ATF */
  atfImportPermit?: InputMaybe<LpcoInput>;
  /** Registered importers of firearms, ammunition firearms parts or implements of war other, than sporting shotguns, shotgun shells, or shotgun parts, must also register under the Arms Export Control Act of 1976. Used by: ATF */
  atfImporterRegistration?: InputMaybe<LpcoInput>;
  /** Identification method often used on aves (birds). Used by APHIS. */
  band?: InputMaybe<Scalars['String']>;
  /** Cut Flowers Bouquet Grouping Code. Used by APHIS. */
  bouquetGroupingCode?: InputMaybe<Scalars['String']>;
  /** APHIS BRS Acknowledgement letter */
  brsAcknowledgementLetter?: InputMaybe<LpcoInput>;
  /** APHIS BRS Notification. */
  brsNotification?: InputMaybe<LpcoInput>;
  /** Chemical Abstract Service Number. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  casNumber?: InputMaybe<Scalars['String']>;
  /** Commodity category code used to further describe the reported item. Used by: APHIS, NHTSA, ATF */
  categoryCode?: InputMaybe<Scalars['String']>;
  /** Category type code used to describe the reported item. Used by: APHIS. */
  categoryTypeCode?: InputMaybe<Scalars['String']>;
  /** US TTB Certificate of Label Approval Number Used by: TTB */
  certificateOfLabelApproval?: InputMaybe<UsTtbCertificateOfLabelApprovalInput>;
  /** Certificate of Origin. Used by APHIS. */
  certificateOfOrigin?: InputMaybe<LpcoInput>;
  /** PGA source and processing data Used by: APHIS, FDA */
  characteristics?: InputMaybe<Array<CommodityCharacteristicInput>>;
  /** Chemical Abstract Service Numbers. See https://ofmpub.epa.gov/sor_internet/registry/substreg/searchandretrieve/searchbylist/search.do?search=&searchCriteria.substanceList=100&searchCriteria.substanceType=-1 Used by: EPA */
  chemicalAbstractServiceNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** This number corresponds to the box number from DOT HS-7 Required by: NHTSA */
  conformanceDeclaration?: InputMaybe<Scalars['String']>;
  /** Constituent elements of the product/component. Required for: APHIS (Lacey Act), DEA. Used by: FWS. Optional for: EPA, FDA */
  constituentElements?: InputMaybe<Array<ConstituentElementInput>>;
  /** APHIS PPQ587-41. Permit to Import Plants and Plant Products Regulated by 7CFR319.41 (Indian Corn or Maize, Broomcorn, etc.) */
  cornPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-8. Permit to Import Plants and Plant Products Regulated by 7CFR319.8 (Foreign Cotton or Covers) */
  cottonPermit?: InputMaybe<LpcoInput>;
  /** Crop Grower. Supplier type. Required for Cut flowers (Category Type Code AP0800). Used by APHIS. */
  cropGrower?: InputMaybe<UsType86EntrySupplierInput>;
  /** APHIS VS 17-29. Declaration of Importation. */
  declarationOfImportation?: InputMaybe<LpcoInput>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the US manufacturer. Should always be the domestic firm registration number associated with the U.S. manufacturer and not the foreign manufacturer. Used by: FDA (medical devices) */
  deviceDomesticManufacturer?: InputMaybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the exporter who exports or offers for export to the United States (U.S.), a device manufactured or processed by another individual, partnership, corporation or association in a foreign country, as well as devices originally manufactured in the United States. Used by: FDA (medical devices) */
  deviceForeignExporter?: InputMaybe<Scalars['String']>;
  /** Device registration number (or owner operator number if registration number is not yet assigned) issued by CDRH for the foreign manufacturer. Should always be the foreign firm registration number associated with the foreign manufacturer and not the US specifications developer. Used by: FDA (medical devices) */
  deviceForeignManufacturer?: InputMaybe<Scalars['String']>;
  /** Defines whether a radiation emitting product is a finished product or just a component */
  deviceForm?: InputMaybe<UsFdaRadiationEmittingDeviceForm>;
  /** Device Initial Importer. Where the IOR is a US entity, DII will default to the IOR. If the IOR is a non-resident, then ops will have to select the DII. */
  deviceInitialImporter?: InputMaybe<UsType86EntryDiiInput>;
  /** Device Listing Number provided by CDRH Used by: FDA (medical devices) */
  deviceListingNumber?: InputMaybe<Scalars['String']>;
  /** Device Premarket Approval Number or Device Premarket Notification Number (510(K))/DeNovo number issued by CDRH (Center for Devices and Radiological Health) or CBER. This also includes Humanitarian Device Exemption (HDE). Premarket number should always be the number that is on the listing record. Used by: FDA (medical devices) */
  devicePremarketNumber?: InputMaybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: InputMaybe<UsPgaDisclaimerCode>;
  /** APHIS 7040B/7040C. Import Permit for Dogs. */
  dogsPermit?: InputMaybe<LpcoInput>;
  /** Department of Transportation conformance bond. Used by: NHTSA */
  dotBond?: InputMaybe<DotBondInput>;
  /** The placement of the driver's seat in a vehicle Used by: NHTSA */
  driveSide?: InputMaybe<VehicleDriveSide>;
  /** New Drug (NDA), Abbreviated New Drug (AND/ANDA), or Therapeutic Biologic Application Number issued by CBER or CDER. Used by: FDA (drugs) */
  drugApplicationNumber?: InputMaybe<Scalars['String']>;
  /** Defines whether a drug is an active pharmaceutical ingredient (API) / bulk drug substance, or a finished drug form (e.g. tablet, capsule, solution). */
  drugForm?: InputMaybe<UsFdaDrugForm>;
  /** Drug Listing Number (DLS), for a bulk Active Pharmaceutical Ingredient (API), or National Drug Code (NDC), for finished drugs, issued by FDA. The first segment of numbers is the labeler code. This number identifies the manufacturer of the product. Declare without dashes. Used by: FDA (drugs) */
  drugListingNumber?: InputMaybe<Scalars['String']>;
  /** Drug Registration Number issued by Center for Drug Evaluation and Research (CDER), Center for Veterinary Medicine (CVM), or Center for Biologics Evaluation and Research (CBER) for the manufacturer. The Federal Food, Drug, and Cosmetic Act (FFD&C) requires most establishments that manufacturer, prepare, propagate, compound, or process a drug or drugs, to register with the FDA. Currently, the establishment registration number is the Dun & Bradstreet Data Universal Numbering System number (DUNS) for CDER and CVM. The establishment registration number can be the FDA Establishment Identification (FEI) or DUNS for CBER. Used by: FDA (drugs)   */
  drugRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** Device (Electrode) Lead Wire or Patient Cable, used when importing electrode lead wires, patient cables, or devices that use them. The affirmation indicates either (1) the device shipment does not contain any pre-wired electrodes, electrode lead wires, or patient (transducer) cables, or (2) any pre-wired electrodes, electrode lead wires or patient cables comply with 21 CFR 898, Performance Standard for Electrode Lead Wires and Patient Cables. Used by: FDA (medical devices) */
  electrode?: InputMaybe<Scalars['Boolean']>;
  /** The two-letter ISO country code that identifies the Importer’s Embassy Used by: NHTSA */
  embassyCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** EPA Vehicles and Engines Engine Power Rating Used by: EPA */
  enginePowerRating?: InputMaybe<QuantityInput>;
  /** Engine data. Used by: EPA */
  engines?: InputMaybe<Array<UsPgaEngineInput>>;
  /** See https://www.epa.gov/compliance/pesticide-establishment-registration-and-reporting Used by: EPA */
  epaProducerEstablishmentNumber?: InputMaybe<LpcoInput>;
  /** The EPA Reg. No. of a product for primary registrants consists of two set of numbers separated by a hyphen, for example EPA Reg. No. 12345-12. The first set of numbers refers to the registrant’s company identification number, and the second set of numbers represents the product number. Used by: EPA */
  epaRegistrationNumber?: InputMaybe<LpcoInput>;
  /** EPA Vehicles and Engines Test Group Name/Number Used by: EPA */
  epaTestGroup?: InputMaybe<Scalars['String']>;
  /** The FDA product code of the product/component. Required by: FDA */
  fdaProductCode?: InputMaybe<Scalars['String']>;
  /** A license or permit issued to anyone who wishes to transport, ship, and cause to be transported, or receive explosives materials under 27 CFR 555.41. Used by: ATF */
  federalExplosiveLicense?: InputMaybe<LpcoInput>;
  /** Federal firearms license issued under the provisions of the Gun Control Act (GCA) to manufacture, import or  in firearms and/or ammunition. Used by: ATF */
  federalFirearmsLicense?: InputMaybe<LpcoInput>;
  /** Food Canning Establishment Number (FCE) that identifies a site-specific manufacturer of acidified and/or low-acid canned food products. Form FDA 2541 is  used for the manufacturing firm registration. See the SID and VOL Affirmation Code definitions below Used by: FDA (LACF/AF food) */
  foodCanningEstablishmentNumber?: InputMaybe<Scalars['String']>;
  /** Food container dimensions. Required by: FDA (LACF and AF Food) */
  foodContainerDimensions?: InputMaybe<DimensionsInput>;
  foodFacilityRegistration?: InputMaybe<UsFdaFoodFacilityRegistrationInput>;
  /** Acidified & Low-Acid Canned Foods (LACF/AF) Volume. May be used to communicate the container volume and unit of measure of an Acidified Food (AF) or Low-Acid Food (LACF) product that is packaged in a container that does not have a traditional size/dimension. The filer should verify with the importer whether  the container size/dimensions or volume were supplied to FDA by the manufacturer. Use of this field instead of the Container Size/Dimension, when  Container Size/Dimension is part of the scheduled process, will result in a failure of the automated data base look-up. Used by: FDA (LACF/AF food) */
  foodVolume?: InputMaybe<Scalars['String']>;
  /** The foreign certificate for imported distilled spirits and wine. Used by: TTB */
  foreignCertificate?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 203. Foreign Site Certificate of Inspection and/or treatment. */
  foreignSiteCertificateOfInspection?: InputMaybe<LpcoInput>;
  /** Foreign Supplier Verification Program Importer. Where the IOR is a US entity, FSVP will default to the IOR. If the IOR is a non-resident, then ops will have to select the FSVP. */
  foreignSupplierVerificationProgram?: InputMaybe<UsType86EntryFsvpInput>;
  /** APHIS PPQ587-56. Permit to Import Plants and Plant Products Regulated by 7CFR319.56 (Fruits and Vegetables). */
  fruitsAndVegetablesPermit?: InputMaybe<LpcoInput>;
  /** A NHTSA-assigned code identifying the glazing manufacturer. Formatted N or NN or NNN or NNNN (e.g., 1234) Used by: NHTSA */
  glazingManufacturerCode?: InputMaybe<Scalars['String']>;
  /** GS1 Global Product Classification Brick Code (GPCB). An 8-digit number designating a set of products with similar characteristics as defined by GS1 at http://www.gs1.org/gsmp/kc/gpc. Used by APHIS. */
  globalProductClassificationBrickCode?: InputMaybe<Scalars['String']>;
  /** APHIS BRS 2000. Application for Permit or Courtesy Permit for Movement or Release of Genetically Engineered Organisms. */
  gmoPermit?: InputMaybe<LpcoInput>;
  /** Health Certificate. Used by APHIS. */
  healthCertificate?: InputMaybe<LpcoInput>;
  /** Device Impact Resistance Lens Certification, used to certify that the filer has, on hand, the test results or a certificate that shows that the product has met the standards for impact resistance lenses. FDA has the authority to ask for copies of the actual test results. Each batch within the shipment must have its own test results. Used by: FDA (medical devices) */
  impactResistanceLensCertification?: InputMaybe<Scalars['Boolean']>;
  /** APHIS 2006. Importation of Veterinary Biological Products. */
  importationOfVeterinaryBiologicalProducts?: InputMaybe<LpcoInput>;
  /** Data pertaining to an inspection. Used by: APHIS, FWS */
  inspection?: InputMaybe<UsPgaInspectionInput>;
  /** The intended use code of the product/component. Required by: APHIS, FDA, EPA Used by: FWS */
  intendedUse?: InputMaybe<Scalars['String']>;
  /** Describes the intended use of the product/component. Used by: FWS */
  intendedUseDescription?: InputMaybe<Scalars['String']>;
  /** Investigational New Drug Application Number issued by CBER or CDER. Investigational drugs are new drugs intended solely for investigational use by  experts qualified by scientific training and experiences to investigate the safety and effectiveness of drugs. The Federal Food, Drug, and Cosmetic Act (FFD&C) Act requires that a drug be the subject of an approved marketing application before it is transported or distributed across state lines (including import). A sponsor who wants to ship the investigational drug to clinical investigators must seek an exemption from that legal requirement. Used by: FDA (investigational new drugs) */
  investigationNewDrugApplicationNumber?: InputMaybe<Scalars['String']>;
  /** Investigational Device Exemption Number issued by CBER or CDRH. Devices that qualified experts use on human subjects, to conduct investigations of their safety and effectiveness, are considered investigational devices. For devices destined for non-significant risk study (NSR), an Institutional Review Boards(IRB) letter affirming NSR must be provided to FDA. In such case, provide 'NSR'. Used by: FDA (medical devices) */
  investigationalDeviceExemptionNumber?: InputMaybe<Scalars['String']>;
  /** The importer is an original manufacturer of motor vehicles (or a wholly owned subsidiary thereof) that is certified to conform to all applicable Federal Motor Vehicle Safety Standards (FMVSS). Use on the public roads must be authorized specifically. [591.6(f )(1) or (2)]; Used by: NHTSA */
  iorIsVehicleManufacturer?: InputMaybe<Scalars['Boolean']>;
  /** Internal Revenue Code (IRC) registry number for the distilled spirits plant, bonded wine cellar, or brewery. Used by: TTB */
  ircRegistryNumber?: InputMaybe<LpcoInput>;
  /** Indicates that information should be treated as confidential. Used by: DEA, FWS */
  isConfidentialInformation?: InputMaybe<Scalars['Boolean']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) Used by: APHIS, EPA, NHTSA, FWS */
  isImageSubmitted?: InputMaybe<Scalars['Boolean']>;
  /** Identifies Toxic Substance Control Act positive or negative certification. Positive – I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA. Negative – I certify that all chemicals in this shipment are not subject to TSCA. Used by: EPA */
  isTscaCompliant?: InputMaybe<Scalars['Boolean']>;
  /** The unique identity for the item. Used by: APHIS */
  itemIdentity?: InputMaybe<ItemIdentityInput>;
  /** APHIS PPQ587-75. Permit to Import Plants and Plant Products Regulated by 7CFR319.75 (Khapra Beetle). */
  khapraBeetlePermit?: InputMaybe<LpcoInput>;
  /** The tariffs associated Independent Third Party Laboratory or Clinical Site. Required for investigational drugs. Required by: FDA (investigational new drugs) */
  laboratory?: InputMaybe<UsType86EntryFacilityInput>;
  /** The type of laboratory. Required by: FDA (investigational new drugs) */
  laboratoryTypeCode?: InputMaybe<UsFdaLaboratoryType>;
  /** Live Animal Tag Ranges. Used by APHIS. */
  liveAnimalTagRanges?: InputMaybe<Array<LiveAnimalTagRangeInput>>;
  /** Live Animal Tag. Used by APHIS. */
  liveAnimalTags?: InputMaybe<Array<Scalars['String']>>;
  /** APHIS VS 17-135. Permit to Import Live Animals. */
  liveAnimalsPermit?: InputMaybe<LpcoInput>;
  /** Manufacturer assigned lot number for the product. Required by: FDA (prior notice LACF/AF food, infant formula) */
  lotNumber?: InputMaybe<Scalars['String']>;
  /** LPCO Authorized Party. Location type. Required if at least one LPCO is used. Used by APHIS. */
  lpcoAuthorizedParty?: InputMaybe<UsType86EntryFacilityInput>;
  /** Location of the manufacture date of the vehicle or engine. Used by: EPA */
  manufactureDateLocation?: InputMaybe<Scalars['String']>;
  /** Meat Certificate. Meat Certificate required by APHIS/FSIS to document sanitary condition and wholesomeness of animal or meat products. (Note: Meat and Sanitary Certificates can be “one and the same”). */
  meatCertificate?: InputMaybe<LpcoInput>;
  /** Microchip. Used by APHIS. */
  microchip?: InputMaybe<Scalars['String']>;
  /** NMFS Tag Number. The individual tag number of the fish. Used by APHIS. */
  nmfsTagNumber?: InputMaybe<Scalars['String']>;
  /** Free form information found in box 18 of EPA Form 3540-01. Required if EPA Registration number not provided. */
  noticeOfArrival?: InputMaybe<Scalars['String']>;
  /** USDA APHIS PPQ Notice Of Arrival */
  noticeOfArrivalPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-37. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Nursery Stock, Plants, Roots, Bulbs, Seeds). */
  nurseryPlantsPermit?: InputMaybe<LpcoInput>;
  /** Offical Animal Number. Unique number given by a national authority to identify an animal individually. Used by APHIS. */
  officialAnimalNumber?: InputMaybe<Scalars['String']>;
  /** Original country where routing to the US began. Required for: APHIS Used by: FWS */
  originCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Packaging associated with a PGA. Required if subject to FDA Prior Notice or a Performance Standard Used by: FDA, APHIS, EPA */
  packaging?: InputMaybe<Array<QuantityInput>>;
  /** Quantity of cigarette tubes or papers. Used by: TTB */
  paperOrTubeQuantity?: InputMaybe<Scalars['Int']>;
  /** Two-letter ISO country code of the country that issued the passport. Used by: NHTSA */
  passportCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Government issued passport number to certify the identity and nationality of the person importing the product. Used by: NHTSA */
  passportNumber?: InputMaybe<Scalars['String']>;
  /** Pesticide Control Number Used by: EPA */
  pcNumber?: InputMaybe<Scalars['String']>;
  /** Subject to a performance standard: FDA */
  performanceStandard?: InputMaybe<Scalars['Boolean']>;
  /** A letter issued by NHTSA permitting a nonconforming vehicle to be imported pursuant to 49 CFR 591.5(j) or 591(I). Formatted as NN-NNNN-NNNN. Used by: NHTSA */
  permissionLetter?: InputMaybe<LpcoInput>;
  /** Permitted Destination. Location type. Required if a Veterinary Biologics product (Category Code 307). Used by APHIS. */
  permittedDestination?: InputMaybe<UsType86EntryFacilityInput>;
  /** Phytosanitary Certificate. Phytosanitary certificate required by APHIS to document the cleanliness (pest and disease) of Plant products. */
  phytosanitaryCertificate?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 526. Permit to Move Live Plant Pests or Noxious Weeds. */
  plantPestsPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ587-37CAN. Permit to Import Plants and Plant Products Regulated by 7CFR319.37 (Canadian-Origin). */
  plantsOfCanadianOriginPermit?: InputMaybe<LpcoInput>;
  /** The name of the political subunit, e.g. state, province, or region through which goods are routed between the country of original departure and the country of final destination. Used by: APHIS */
  politicalSubunitName?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 546. Post-entry Quarantine Permit. */
  postEntryQuarantinePermit?: InputMaybe<LpcoInput>;
  /** US FDA Prior Notice data requirements. */
  priorNotice?: InputMaybe<UsFdaPriorNoticeInput>;
  /** Code indicating the specific PGA processing requirements for which the data set is related. */
  processingCode?: InputMaybe<Scalars['String']>;
  /** A code indicating the type of product number used to characterize the product or component. Used by: APHIS */
  productQualifierCode?: InputMaybe<Scalars['String']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 588. Permit to Import Prohibited Plant Material For Research Purposes. */
  prohibitedPlantForResearchPermit?: InputMaybe<LpcoInput>;
  /** APHIS PPQ 621. Protected Plant Permit to Engage in the Business of Importing, Exporting, or Re-exporting Terrestrial Plants or Plant Products that are Protected and Regulated by 50CFR17.12 or 50CFR23.23 (CITES: Threatened or Endangered Species). */
  protectedPlantPermit?: InputMaybe<LpcoInput>;
  /** Rabies Vaccination Certificate. Used by APHIS. */
  rabiesVaccinationCertifcate?: InputMaybe<LpcoInput>;
  radiationDeclaration?: InputMaybe<RadiationDeclarationInput>;
  /** Rail car numbers Used by: FDA (prior notice food arriving via rail/containerized rail.) */
  railCarNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Country that has refused the shipment. Used by: FDA */
  refusalCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Number assigned by NHTSA to a person or business entity specially registered with NHTSA as an importer of nonconforming motor vehicles pursuant to 49 CFR Part 592. Formatted as A-NN-NNN. Used by: NHTSA */
  registeredImporterNumber?: InputMaybe<LpcoInput>;
  /** Radio Frequency Identification. Used by APHIS. */
  rfid?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ587-55. Permit to Import Plants and Plant Products Regulated by 7CFR319.55 (Rice). */
  ricePermit?: InputMaybe<LpcoInput>;
  /** LACF/AF Submission/Scheduled Process Identifier Number (SID) Used by: FDA (LACF/AF food) */
  scheduleIdentifierNumber?: InputMaybe<Scalars['String']>;
  /** APHIS Seed Analysis Certificate (PPQ Form 925, CFIA Form 5289, CFIA Form 5309 or similar form) */
  seedAnalysisCertificate?: InputMaybe<LpcoInput>;
  /** Country from where the product/component shipped. Required by: FDA (Food subject to Prior Notice) */
  shipmentCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Slaughter Number. Unique number given by a slaughterhouse to an animal or a group of animals of the same breed. Used by APHIS. */
  slaughterNumber?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 525B. Soil Permit. */
  soilPermit?: InputMaybe<LpcoInput>;
  /** PGA source and processing data Used by: APHIS, FDA */
  source?: InputMaybe<UsPgaSourceInput>;
  /** USDA APHIS VS STAT Documents (Statements) (e.g. Manufacturer’s Statement, Owner/Importer Statements, Producer Statements) */
  statementsPermit?: InputMaybe<LpcoInput>;
  /** The storage location of the vehicle or engine. Used by: EPA */
  storageLocation?: InputMaybe<UsType86EntryFacilityInput>;
  /** APHIS PPQ587-15. Permit to Import Plants and Plant Products Regulated by 7CFR319.15 (Sugarcane) */
  sugarcanePermit?: InputMaybe<LpcoInput>;
  /** Taxonomic Serial Number (TSN). A unique serial number assigned to a taxonomic unit by the Integrated Taxonomic Informational System at http://www.itis.gov. Used by APHIS. */
  taxonomicSerialNumber?: InputMaybe<Scalars['String']>;
  /** APHIS PPQ 585. Permit to Import Timber or Timber Products */
  timberPermit?: InputMaybe<LpcoInput>;
  /** A NHTSA-assigned code identifying the tire manufacturer. Formatted ANAN or ANANAN (e.g., 1B or ABC) Used by: NHTSA */
  tireManufacturerCode?: InputMaybe<Scalars['String']>;
  /** The Trade Name of the product/component. Used by: EPA, FDA, NHTSA */
  tradeName?: InputMaybe<Scalars['String']>;
  /** Country through which goods or passengers are routed between the country of original departure and final destination. Used by: APHIS */
  transitCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** APHIS PPQ 586. Permit to Transit Plants and/or Plant Products, Plant Pests, and/or Associated Soil. */
  transitPlantsPermit?: InputMaybe<LpcoInput>;
  /** Country where goods are to be or have been transferred from one means of transport to another during the course of one transport operation. Used by: APHIS */
  transshipmentCountryCode?: InputMaybe<Scalars['CountryCode']>;
  /** Treatment Certificate. Used by APHIS. */
  treatmentCertificate?: InputMaybe<LpcoInput>;
  /** TTB-issued permit number indicating the IRC-bonded facility, manufacturer, or export warehouse proprietor. Used by: TTB */
  ttbFacilityPermitNumber?: InputMaybe<LpcoInput>;
  /** The importer's permit number assigned by TTB Used by: TTB */
  ttbImporterPermitNumber?: InputMaybe<LpcoInput>;
  /** UN Standard Products and Services Code (UNSPSC) Commodity Code. An 8-digit number designating a set of products with similar characteristics as defined by the United Nations at http://www.unspsc.org. Used by APHIS. */
  unpscCommodityCode?: InputMaybe<Scalars['String']>;
  /** Vehicle data. Used by: EPA, NHT */
  vehicle?: InputMaybe<UsPgaVehicleInput>;
  /** NHTSA-assigned number to identify a vehicle that is not certified to the Federal motor vehicle safety standards as being eligible for importation by a registered importer under a DOT conformance bond pursuant to 49 CFR Part 591.5(f). Formatted as AAA-NNN. */
  vehicleEligibilityNumber?: InputMaybe<LpcoInput>;
  /** APHIS VS 16-6A. Veterinary Permit to Import Controlled Materials and Organisms and Vectors. */
  veterinaryPermitToImportControlledMaterials?: InputMaybe<LpcoInput>;
  /** EPA Vehicles and Engines Bond Exemption Used by: EPA */
  vneBondExemptionNumber?: InputMaybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number Used by: EPA */
  vneBondNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number Used by: EPA */
  vneExemptionNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code Used by: EPA */
  vneImportCode?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code Used by: EPA */
  vneIndustryCode?: InputMaybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. Used by: EPA */
  vneOtherExemptionRegulation?: InputMaybe<Scalars['String']>;
  /** Measurements of the weapon(s) being imported. Used by: ATF */
  weaponMeasurements?: InputMaybe<WeaponMeasurementsInput>;
};

export type UsType86EntryPgaRequirements = {
  __typename?: 'UsType86EntryPgaRequirements';
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM3?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM4?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM6?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM7?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM8?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  ATF?: Maybe<UsType86EntryPga>;
  /** Fields relevant to US CPSC program. */
  CP1?: Maybe<UsCpscPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DE1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP2?: Maybe<UsType86EntryPga>;
  /** Fields relevant to EPA VNE programs. */
  EP3?: Maybe<VehiclesAndEnginesUsPgaProgram>;
  /** Fields relevant to EPA VNE programs. */
  EP4?: Maybe<VehiclesAndEnginesUsPgaProgram>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP5?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP6?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP7?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP8?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD3?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD4?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS3?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS4?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW3?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM3?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM4?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM5?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM6?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM8?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB1?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB2?: Maybe<UsType86EntryPga>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB3?: Maybe<UsType86EntryPga>;
};

export type UsType86EntryPgaRequirementsInput = {
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AL2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM3?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM4?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM6?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM7?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AM8?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  AQ2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  ATF?: InputMaybe<UsType86EntryPgaInput>;
  /** Fields relevant to US CPSC program. */
  CP1?: InputMaybe<UsCpscPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DE1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  DT2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP2?: InputMaybe<UsType86EntryPgaInput>;
  /** Fields relevant to EPA VNE programs. */
  EP3?: InputMaybe<VehiclesAndEnginesUsPgaProgramInput>;
  /** Fields relevant to EPA VNE programs. */
  EP4?: InputMaybe<VehiclesAndEnginesUsPgaProgramInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP5?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP6?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP7?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  EP8?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD3?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FD4?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS3?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FS4?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  FW3?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM3?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM4?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM5?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM6?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  NM8?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  OM2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB1?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB2?: InputMaybe<UsType86EntryPgaInput>;
  /** Data requirements reported to a US CBP Partner Government Agency. */
  TB3?: InputMaybe<UsType86EntryPgaInput>;
};

export type UsType86EntryPointOfContact = {
  __typename?: 'UsType86EntryPointOfContact';
  /** A contact email address. */
  email?: Maybe<Scalars['Email']>;
  /** The point of contact's name. */
  name?: Maybe<Scalars['String']>;
  /** A contact phone number. */
  phone?: Maybe<Phone>;
};

export type UsType86EntryPointOfContactInput = {
  /** A contact email address. */
  email?: InputMaybe<Scalars['Email']>;
  /** The point of contact's name. */
  name?: InputMaybe<Scalars['String']>;
  /** A contact phone number. */
  phone?: InputMaybe<PhoneInput>;
};

export type UsType86EntryProduct = {
  __typename?: 'UsType86EntryProduct';
  /** Total number of cartons. */
  cartonCount?: Maybe<Scalars['Int']>;
  /** Client identifier for the product (eg, sku, asin, etc). This should be provided only if a product record was not provided. If product is provided, use product.clientIdentifier instead. */
  clientIdentifier?: Maybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: Maybe<Volume>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: Maybe<Weight>;
  /** Line items within the Product. */
  lines?: Maybe<Array<UsType86EntryLine>>;
  /** The materials the Product contains. */
  materials?: Maybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: Maybe<Weight>;
  /** The Product record used on this entry. */
  product?: Maybe<Product>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: Maybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: Maybe<Cost>;
  /** The total value of the Product. */
  totalValue?: Maybe<Cost>;
};

export type UsType86EntryProductInput = {
  /** Total number of cartons. */
  cartonCount?: InputMaybe<Scalars['Int']>;
  /** Client identifier for the product (eg, sku, asin, etc). This should be provided only if a product record was not provided. If product is provided, use product.clientIdentifier instead. */
  clientIdentifier?: InputMaybe<Scalars['String']>;
  /** Gross volume is total volume of all units of product. */
  grossVolume?: InputMaybe<VolumeInput>;
  /** GrossWeight is equal to  product Weight + pallet/cardboard weights. */
  grossWeight?: InputMaybe<WeightInput>;
  /** Line items within the Product. */
  lines?: InputMaybe<Array<UsType86EntryLineInput>>;
  /** The materials the Product contains. */
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** Weight of the product without any packing. */
  netWeight?: InputMaybe<WeightInput>;
  /** The Product record used on this entry. */
  product?: InputMaybe<IdVersionInput>;
  /** Quantity of the product on the Commercial Invoice. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The total assist of the Product. */
  totalAssist?: InputMaybe<CostInput>;
  /** The total value of the Product. */
  totalValue?: InputMaybe<CostInput>;
};

export type UsType86EntrySearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: InputMaybe<KeywordSearchCriteriaInput>;
  /** CBP collection status */
  collectionStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** Container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** US CBP entry type code. */
  entryType?: InputMaybe<UsCbpEntryTypeCodeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: InputMaybe<CountryCodeSearchCriteriaInput>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryName?: InputMaybe<TextSearchCriteriaInput>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: InputMaybe<DateSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The date the shipment physically arrives in the US. */
  importDate?: InputMaybe<DateSearchCriteriaInput>;
  /** In-bond number */
  inBondNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Commercial Invoice number */
  invoiceNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the ior linked to the work order */
  iorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the ior linked to the work order */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Importer of Record Number registered with US CBP */
  iorNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport?: InputMaybe<UsCbpEntryModeOfTransportSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDisposition?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The shipment's US port of unlading. */
  portOfUnladingName?: InputMaybe<TextSearchCriteriaInput>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDisposition?: InputMaybe<TextSearchCriteriaInput>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReason?: InputMaybe<TextSearchCriteriaInput>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: InputMaybe<UsCbpEntryReleaseStatusSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** TBD */
export type UsType86EntrySearchTableRow = RecordSearchTableRow & ShipmentWorkOrderSearchTableRow & WorkOrderSearchTableRow & {
  __typename?: 'UsType86EntrySearchTableRow';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The client's identifier for the work order's shipment */
  clientIdentifier?: Maybe<Scalars['ID']>;
  /** CBP collection status */
  collectionStatus?: Maybe<Scalars['String']>;
  /** Container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The name of the conveyance or vessel. */
  conveyanceName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** US CBP entry type code. */
  entryType?: Maybe<Scalars['String']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryCode?: Maybe<Scalars['String']>;
  /** The country from which the articles were shipped to the U.S. having last been a part of the commerce of that country. */
  exportCountryName?: Maybe<Scalars['String']>;
  /** The date that the exporting vessel departed the last port in the exporting country. */
  exportDate?: Maybe<Scalars['String']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** The friendly ID for the work order's shipment */
  friendlyId?: Maybe<Scalars['ID']>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The date the shipment physically arrives in the US. */
  importDate?: Maybe<Scalars['String']>;
  /** In-bond number */
  inBondNumber?: Maybe<Array<Scalars['String']>>;
  /** Commercial Invoice number */
  invoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the ior linked to the work order */
  iorId?: Maybe<Scalars['ID']>;
  /** The name of the ior linked to the work order */
  iorName?: Maybe<Scalars['String']>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** The mode of transport for the goods being entered. */
  modeOfTransport: Scalars['String'];
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** Disposition code of a US CBP PGA from the latest SO ABI message. */
  pgaDisposition?: Maybe<Array<Scalars['String']>>;
  /** Purchase order (PO) number(s) associated with the work order. Will be stored in the work order group's tags. */
  poNumber?: Maybe<Array<Scalars['String']>>;
  /** The CBP Schedule K Code representing the shipment's foreign port of lading. */
  portOfLadingName?: Maybe<Scalars['String']>;
  /** The shipment's US port of unlading. */
  portOfUnladingName?: Maybe<Scalars['String']>;
  /** The FIRMS code of the selected CBP Centralized Exam Site, used if shipment is subject to an exam. */
  preferredExamSite?: Maybe<Scalars['String']>;
  /** The CBP determined release date of the cargo. */
  releaseDate?: Maybe<Scalars['String']>;
  /** Disposition code of the latest US CBP Release Status (SO) ABI message. */
  releaseDisposition?: Maybe<Array<Scalars['String']>>;
  /** Error details of the latest US CBP Entry Release (SE) rejection. */
  releaseRejectionReason?: Maybe<Array<Scalars['String']>>;
  /** Status of the Entry Release (SE) filing with CBP. */
  releaseStatus?: Maybe<Scalars['String']>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The shipment's voyage, flight, or trip number. */
  tripNumber?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type UsType86EntryServiceLevelAgreement = ServiceLevelAgreement & {
  __typename?: 'UsType86EntryServiceLevelAgreement';
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: Maybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: Maybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: Maybe<UsType86EntryServiceLevelAgreementMatchingCriteria>;
};

export type UsType86EntryServiceLevelAgreementInput = {
  /** The maximum number of business hours after the work order is marked ready that it will take to be completed. If this is set, calendarDaysBeforeArrival should not be set */
  businessHoursAfterReady?: InputMaybe<Scalars['Float']>;
  /** The number of calendar days before the shipment arrives by which the entry will be filed. If this is set, businessHoursAfterReady should not be set. */
  calendarDaysBeforeArrival?: InputMaybe<Scalars['Float']>;
  /** Conditions that must be met in order for the SLA to be applicable. */
  matchingCriteria?: InputMaybe<UsType86EntryServiceLevelAgreementMatchingCriteriaInput>;
};

export type UsType86EntryServiceLevelAgreementMatchingCriteria = {
  __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria';
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: Maybe<Array<ModeOfTransport>>;
};

export type UsType86EntryServiceLevelAgreementMatchingCriteriaInput = {
  /** Mode of Transport specified by an SLA */
  modesOfTransport?: InputMaybe<Array<ModeOfTransport>>;
};

export type UsType86EntrySupplier = {
  __typename?: 'UsType86EntrySupplier';
  /** Party address */
  address?: Maybe<Address>;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  mid?: Maybe<Scalars['UsCbpMid']>;
  /** Party name */
  name?: Maybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: Maybe<UsType86EntryPointOfContact>;
  /** The manufacturer is related with the importer. */
  related?: Maybe<Scalars['Boolean']>;
  /** The Supplier record. */
  supplier?: Maybe<Supplier>;
};

export type UsType86EntrySupplierInput = {
  /** Party address */
  address?: InputMaybe<AddressInput>;
  /**
   * A Manufacturer IDentification code derived by US CBP from the name and address of the party. See https://www.cbp.gov/sites/default/files/documents/3550-055_3.pdf
   * Validation regex: /^[A-Z0-9]+$/
   */
  mid?: InputMaybe<Scalars['UsCbpMid']>;
  /** Party name */
  name?: InputMaybe<Scalars['String']>;
  /** The details of point of contact that will be used by US CBP */
  pointOfContact?: InputMaybe<UsType86EntryPointOfContactInput>;
  /** The manufacturer is related with the importer. */
  related?: InputMaybe<Scalars['Boolean']>;
  /** The Supplier record. */
  supplier?: InputMaybe<IdVersionInput>;
};

export type UsType86EntryTariff = {
  __typename?: 'UsType86EntryTariff';
  /** Duties owed to US CBP for this tariff. */
  charges?: Maybe<UsCbpEntryTariffCharges>;
  /** Additional optional PGA requirements. */
  extraPgaFlags?: Maybe<Array<UsPgaFlag>>;
  /** The HTS record. */
  hts?: Maybe<UsHts>;
  /** HTS Number */
  htsNumber?: Maybe<Scalars['HtsNumber']>;
  /** Partner Government Agency data requirements. */
  pga?: Maybe<UsType86EntryPgaRequirements>;
  /** The description of the tariff reported to the PGA. */
  pgaDescription?: Maybe<UsTariffPgaDescription>;
  /** The unit assist value of a tariff. */
  unitAssist?: Maybe<Cost>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: Maybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: Maybe<Array<Quantity>>;
  /** The unit value of a tariff. */
  unitValue?: Maybe<Cost>;
};

export type UsType86EntryTariffInput = {
  /** Duties owed to US CBP for this tariff. */
  charges?: InputMaybe<UsCbpEntryTariffChargesInput>;
  /** Additional optional PGA requirements. */
  extraPgaFlags?: InputMaybe<Array<UsPgaFlag>>;
  /** The HTS record. */
  hts?: InputMaybe<IdVersionInput>;
  /** HTS Number */
  htsNumber?: InputMaybe<Scalars['HtsNumber']>;
  /** Partner Government Agency data requirements. */
  pga?: InputMaybe<UsType86EntryPgaRequirementsInput>;
  /** The description of the tariff reported to the PGA. */
  pgaDescription?: InputMaybe<UsTariffPgaDescriptionInput>;
  /** The unit assist value of a tariff. */
  unitAssist?: InputMaybe<CostInput>;
  /** The unit assist percentage of a tariff. */
  unitAssistPercentage?: InputMaybe<Scalars['Percentage']>;
  /** The primary, secondary, and tertiary reporting quantities of a tariff per product quantity. */
  unitReportingQuantities?: InputMaybe<Array<QuantityInput>>;
  /** The unit value of a tariff. */
  unitValue?: InputMaybe<CostInput>;
};

export type User = {
  /** Date representing the last version of the App the user has seen. */
  appLastVersionSeen?: Maybe<Scalars['DateTime']>;
  /** Avatar url (aka profile picture). */
  avatarUrl?: Maybe<Scalars['URL']>;
  /** Whether the user is away or not. */
  away?: Maybe<Scalars['Boolean']>;
  /** User details from the Cognito User Pool. */
  cognito?: Maybe<CognitoUserDetails>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Email address of the user */
  email: Scalars['Email'];
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Identity information provided by an external IDP such as Auth Portal */
  identity?: Maybe<Identity>;
  /** The flag that indicate if notification should be sent to only user who created/edit shipments/work orders. */
  limitNotifications?: Maybe<Scalars['Boolean']>;
  /** Link returned to the user after they have created a new account, granting the ability to reset their password and login for the first time. */
  loginLink?: Maybe<Scalars['URL']>;
  /** A mobile phone number. */
  mobilePhone?: Maybe<Phone>;
  /** External client name. */
  name: Scalars['String'];
  /** A office phone number. */
  officePhone?: Maybe<Phone>;
  /** Whether the user is the root user of the party it belongs to. */
  root?: Maybe<Scalars['Boolean']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The teams the user is on */
  teams?: Maybe<Array<Team>>;
  /** Title of the user */
  title: Scalars['String'];
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type UserContext = AuthenticationContext & {
  __typename?: 'UserContext';
  /** Hash used for intercom */
  intercomHash?: Maybe<Scalars['String']>;
  /** The user details */
  user?: Maybe<User>;
};

/** A record of a user viewing a release note */
export type UserReleaseNoteView = Record & {
  __typename?: 'UserReleaseNoteView';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The rating given to the release note by the user. */
  rating?: Maybe<RatingEnum>;
  /** The ID of the viewed release note. */
  releaseNote: ReleaseNote;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The user who viewed the release note. */
  user: User;
  /** The record's version */
  version: Scalars['Int'];
};

export type UserReleaseNoteViewEdge = ConnectionEdge & {
  __typename?: 'UserReleaseNoteViewEdge';
  cursor: Scalars['ID'];
  node: UserReleaseNoteView;
};

/** Search criteria for User Release Note Views */
export type UserReleaseNoteViewSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The rating given to the release note by the user. */
  rating?: InputMaybe<RatingEnum>;
  /** The ID of the viewed release note. */
  releaseNoteId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the user who viewed the release note. */
  userId?: InputMaybe<IdSearchCriteriaInput>;
};

/** Search table row for User Release Note Views */
export type UserReleaseNoteViewSearchTableRow = {
  __typename?: 'UserReleaseNoteViewSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The rating given to the release note by the user. */
  rating?: Maybe<RatingEnum>;
  /** The Id of the viewed release note. */
  releaseNoteId: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** The Id of the user who viewed the release note. */
  userId: Scalars['String'];
  /** Version */
  version: Scalars['Int'];
};

export type UserReleaseNoteViewsConnection = Connection & {
  __typename?: 'UserReleaseNoteViewsConnection';
  edges: Array<UserReleaseNoteViewEdge>;
  nodes: Array<UserReleaseNoteView>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type UserSearchCriteriaInput = {
  /** The User's Cognito Identity ID. */
  cognitoId?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's email. */
  email?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Whether or not a User is logged in. */
  loggedIn?: InputMaybe<BooleanSearchCriteriaInput>;
  /** The name of the User. */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The IDs of the teams the user is on */
  teamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the teams the user is on */
  teamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The title of the User. */
  title?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The User's unique identifier provided by an IDP. */
  userIdentifier?: InputMaybe<IdIndexSearchCriteriaInput>;
};

/** User search results. */
export type UserSearchTableRow = {
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The User's email. */
  email?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether or not a User is logged in. */
  loggedIn?: Maybe<Scalars['Boolean']>;
  /** Whether or not a User has Multi-Factor Authentication (MFA) enabled. */
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  /** The name of the User. */
  name?: Maybe<Scalars['String']>;
  /** The IDs of the teams the user is on */
  teamId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the teams the user is on */
  teamName?: Maybe<Array<Scalars['String']>>;
  /** The title of the User. */
  title?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UserTeam = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The User Team's name */
  name: Scalars['String'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type UserTeamSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The User Team's name */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** The User Team search results. */
export type UserTeamSearchTableRow = {
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The User Team's name */
  name?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type UserTeams = AssignmentTeam | BusinessSupportTeam;

/** Working hours for a given day */
export type UserWorkDay = {
  __typename?: 'UserWorkDay';
  /** End time for the given day */
  end?: Maybe<Scalars['DateTime']>;
  /** Start time for the given day */
  start?: Maybe<Scalars['DateTime']>;
  /** Boolean indicating whether or not the user works that day */
  works?: Maybe<Scalars['Boolean']>;
};

/** Working hours for a given day */
export type UserWorkDayInput = {
  /** End time for the given day */
  end?: InputMaybe<Scalars['DateTime']>;
  /** Start time for the given day */
  start?: InputMaybe<Scalars['DateTime']>;
  /** Boolean indicating whether or not the user works that day */
  works?: InputMaybe<Scalars['Boolean']>;
};

/** Working hours broken down by day */
export type UserWorkingHours = {
  __typename?: 'UserWorkingHours';
  /** Working hours for Friday */
  friday?: Maybe<UserWorkDay>;
  /** Working hours for Monday */
  monday?: Maybe<UserWorkDay>;
  /** Working hours for Saturday */
  saturday?: Maybe<UserWorkDay>;
  /** Working hours for Sunday */
  sunday?: Maybe<UserWorkDay>;
  /** Working hours for Thursday */
  thursday?: Maybe<UserWorkDay>;
  /** Working hours for Tuesday */
  tuesday?: Maybe<UserWorkDay>;
  /** Working hours for Wednesday */
  wednesday?: Maybe<UserWorkDay>;
};

/** Working hours broken down by day */
export type UserWorkingHoursInput = {
  /** Working hours for Friday */
  friday?: InputMaybe<UserWorkDayInput>;
  /** Working hours for Monday */
  monday?: InputMaybe<UserWorkDayInput>;
  /** Working hours for Saturday */
  saturday?: InputMaybe<UserWorkDayInput>;
  /** Working hours for Sunday */
  sunday?: InputMaybe<UserWorkDayInput>;
  /** Working hours for Thursday */
  thursday?: InputMaybe<UserWorkDayInput>;
  /** Working hours for Tuesday */
  tuesday?: InputMaybe<UserWorkDayInput>;
  /** Working hours for Wednesday */
  wednesday?: InputMaybe<UserWorkDayInput>;
};

/** An error produced when attempting to validate the US commercial invoices data. */
export type ValidateUsCommercialInvoicesError = {
  __typename?: 'ValidateUsCommercialInvoicesError';
  /** The message of the validation error. */
  message: Scalars['String'];
  /** The path of the validation error. */
  path?: Maybe<Array<Scalars['String']>>;
  /** The type of the validation error. */
  type: ValidationErrorType;
};

/** Payload returned from validateUsCommercialInvoicesData query. */
export type ValidateUsCommercialInvoicesPayload = {
  __typename?: 'ValidateUsCommercialInvoicesPayload';
  /** The validation errors. */
  errors: Array<ValidateUsCommercialInvoicesError>;
};

/** Payload returned from validateUsConsumptionEntry query */
export type ValidateUsConsumptionEntryPayload = {
  __typename?: 'ValidateUsConsumptionEntryPayload';
  /** Anti-dumping duty */
  adDuty: Scalars['Float'];
  /** The amendment information */
  amendment: Amendment;
  /** Documents providing the client more information */
  confirmationDocs?: Maybe<Array<DocumentTag>>;
  /** Whether or not confirmation is required */
  confirmationRequired: Scalars['Boolean'];
  /** Countervailing duty */
  cvDuty: Scalars['Float'];
  /** The sum of duties, taxes, and fees */
  dutiesFees: Scalars['Float'];
  /** The entry type code */
  entryType: Scalars['String'];
  /** Whether or not a single entry bond is needed */
  needsSingleEntryBond?: Maybe<Scalars['Boolean']>;
  /** The type of risk for the bond */
  riskType?: Maybe<Scalars['String']>;
  /** The bond value */
  stbAmount?: Maybe<Scalars['Float']>;
  /** Total value of invoices including adjustments */
  totalValue: Scalars['Float'];
  /** The warnings produced when validating */
  warnings: Array<ValidateUsConsumptionEntryWarning>;
};

/** Payload returned from validateUsConsumptionEntryRelease query */
export type ValidateUsConsumptionEntryReleasePayload = {
  __typename?: 'ValidateUsConsumptionEntryReleasePayload';
  /** The entry type code */
  entryType: Scalars['String'];
  /** The type of risk for the bond */
  riskType?: Maybe<Scalars['String']>;
  /** The bond value */
  stbAmount?: Maybe<Scalars['Float']>;
  /** Total value of invoices including adjustments */
  totalValue: Scalars['Float'];
  /** The warnings produced when validating */
  warnings: Array<ValidateUsConsumptionEntryReleaseWarning>;
};

/** A warning produced when attempting to validate the usConsumptionEntryRelease */
export type ValidateUsConsumptionEntryReleaseWarning = {
  __typename?: 'ValidateUsConsumptionEntryReleaseWarning';
  /** The message to be displayed to the user for the warning type */
  message: Scalars['String'];
  /** The type of warning */
  type: Scalars['String'];
};

/** A warning produced when attempting to validate the UsConsumptionEntry */
export type ValidateUsConsumptionEntryWarning = {
  __typename?: 'ValidateUsConsumptionEntryWarning';
  /** The message to be displayed to the user for the warning type */
  message: Scalars['String'];
  /** The type of warning */
  type: Scalars['String'];
};

/** Validation result for UsIsf. */
export type ValidateUsIsfPayload = {
  __typename?: 'ValidateUsIsfPayload';
  /** The warnings produced when validating */
  warnings: Array<ValidateUsIsfWarning>;
};

/** A warning produced when validating UsIsf data */
export type ValidateUsIsfWarning = {
  __typename?: 'ValidateUsIsfWarning';
  /** The message to be displayed to the user for the warning type */
  message: Scalars['String'];
  /** The type of warning */
  type: Scalars['String'];
};

/** Payload returned from validateUsPostSummaryCorrection query */
export type ValidateUsPostSummaryCorrectionPayload = {
  __typename?: 'ValidateUsPostSummaryCorrectionPayload';
  /** Anti-dumping duty */
  adDuty: Scalars['Float'];
  /** Countervailing duty */
  cvDuty: Scalars['Float'];
  /** The sum of duties, taxes, and fees */
  dutiesFees: Scalars['Float'];
  /** The entry type code */
  entryType: Scalars['String'];
  /** Whether or not a single entry bond is needed */
  needsSingleEntryBond?: Maybe<Scalars['Boolean']>;
  /** The type of risk for the bond */
  riskType?: Maybe<Scalars['String']>;
  /** The bond value */
  stbAmount?: Maybe<Scalars['Float']>;
  /** Total value of invoices including adjustments */
  totalValue: Scalars['Float'];
  /** The warnings produced when validating */
  warnings: Array<ValidateUsPostSummaryCorrectionWarning>;
};

/** A warning produced when attempting to validate the UsPostSummaryCorrection */
export type ValidateUsPostSummaryCorrectionWarning = {
  __typename?: 'ValidateUsPostSummaryCorrectionWarning';
  /** The message to be displayed to the user for the warning type */
  message: Scalars['String'];
  /** The type of warning */
  type: Scalars['String'];
};

/** Payload returned from validateUsType86Entry query */
export type ValidateUsType86EntryPayload = {
  __typename?: 'ValidateUsType86EntryPayload';
  /** The warnings produced when validating */
  warnings: Array<ValidateUsType86EntryWarning>;
};

/** A warning produced when attempting to validate the UsType86Entry */
export type ValidateUsType86EntryWarning = {
  __typename?: 'ValidateUsType86EntryWarning';
  /** The message to be displayed to the user for the warning type */
  message: Scalars['String'];
  /** The type of warning */
  type: Scalars['String'];
};

/** Result of task validation */
export type ValidateWorkOrderTaskPayload = {
  __typename?: 'ValidateWorkOrderTaskPayload';
  /** Validation errors (if present) */
  errors?: Maybe<Scalars['JSONObject']>;
};

/** The type of the validation error. */
export enum ValidationErrorType {
  GENERAL = 'GENERAL',
  MISSING_FIELD = 'MISSING_FIELD'
}

export type ValuationAdjustment = {
  __typename?: 'ValuationAdjustment';
  /** Code specifying the type of WTO valuation agreement addition article 8: Price influence, Royalties, Assists, Proceeds, Commissions. */
  addition?: Maybe<Scalars['String']>;
  /** Amount by which the monetary valuation was adjusted. */
  amount?: Maybe<Cost>;
  /** Percentage adjustment made to the valuation. */
  percentage?: Maybe<Scalars['Float']>;
};

export type ValuationAdjustmentInput = {
  /** Code specifying the type of WTO valuation agreement addition article 8: Price influence, Royalties, Assists, Proceeds, Commissions. */
  addition?: InputMaybe<Scalars['String']>;
  /** Amount by which the monetary valuation was adjusted. */
  amount?: InputMaybe<CostInput>;
  /** Percentage adjustment made to the valuation. */
  percentage?: InputMaybe<Scalars['Float']>;
};

export enum VehicleDriveSide {
  LEFT = 'LEFT',
  NONE = 'NONE',
  RIGHT = 'RIGHT'
}

export type VehiclesAndEnginesUsPgaProgram = {
  __typename?: 'VehiclesAndEnginesUsPgaProgram';
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: Maybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: Maybe<UsPgaDisclaimerCode>;
  /** EPA Vehicles and Engines Engine Power Rating */
  enginePowerRating?: Maybe<Quantity>;
  /** Engine data */
  engines?: Maybe<Array<UsPgaEngine>>;
  /** EPA Vehicles and Engines Test Group Name/Number */
  epaTestGroup?: Maybe<Scalars['String']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) */
  isImageSubmitted?: Maybe<Scalars['Boolean']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Regulatory Category */
  regulatoryCategory?: Maybe<VneRegulatoryCategory>;
  /** Vehicle data */
  vehicle?: Maybe<UsPgaVehicle>;
  /** EPA Vehicles and Engines Bond Exemption */
  vneBondExemptionNumber?: Maybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number */
  vneBondNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number */
  vneExemptionNumber?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code */
  vneImportCode?: Maybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code */
  vneIndustryCode?: Maybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. */
  vneOtherExemptionRegulation?: Maybe<Scalars['String']>;
};

export type VehiclesAndEnginesUsPgaProgramInput = {
  /** Code indicating the Partner Government Agency the data is reported to. */
  agencyCode?: InputMaybe<Scalars['String']>;
  /** Code indicating the reason data is not being provided. */
  disclaimerCode?: InputMaybe<UsPgaDisclaimerCode>;
  /** EPA Vehicles and Engines Engine Power Rating */
  enginePowerRating?: InputMaybe<QuantityInput>;
  /** Engine data */
  engines?: InputMaybe<Array<UsPgaEngineInput>>;
  /** EPA Vehicles and Engines Test Group Name/Number */
  epaTestGroup?: InputMaybe<Scalars['String']>;
  /** Identifies whether an image has been submitted via CBP Document Image System (DIS) */
  isImageSubmitted?: InputMaybe<Scalars['Boolean']>;
  /** Code indicating the specific PGA program requirements for which the data set is related. */
  programCode?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Regulatory Category */
  regulatoryCategory?: InputMaybe<VneRegulatoryCategory>;
  /** Vehicle data */
  vehicle?: InputMaybe<UsPgaVehicleInput>;
  /** EPA Vehicles and Engines Bond Exemption */
  vneBondExemptionNumber?: InputMaybe<VneBondExemptionStatusCode>;
  /** EPA Vehicles and Engines NAIC Bond Policy Number */
  vneBondNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Exemption Number */
  vneExemptionNumber?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Import Code */
  vneImportCode?: InputMaybe<Scalars['String']>;
  /** EPA Vehicles and Engines Industry Code */
  vneIndustryCode?: InputMaybe<VneIndustryCode>;
  /** EPA Vehicles and Engines Regulation Cited for other exemption. Required if 25 is provided for vneImportCode. */
  vneOtherExemptionRegulation?: InputMaybe<Scalars['String']>;
};

/** mDDP vendor code - a 5 character alphanumeric identifier associated with a Port of Entry. */
export type VendorCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's scalar values to be searched for. */
  values?: InputMaybe<Array<Scalars['VendorCode']>>;
};

/** The type industry of the Ior. */
export enum Vertical {
  AGRICULTURE_PREP = 'AGRICULTURE_PREP',
  APPAREL_TEXTILES = 'APPAREL_TEXTILES',
  AUTOMOTIVE_AERO = 'AUTOMOTIVE_AERO',
  BASE_METALS = 'BASE_METALS',
  CONSUMER_MERCHANDISE = 'CONSUMER_MERCHANDISE',
  ELECTRONICS = 'ELECTRONICS',
  INDUSTRIAL_MANUFACTURING = 'INDUSTRIAL_MANUFACTURING',
  MACHINE = 'MACHINE',
  PETRO_GAS_MINERALS = 'PETRO_GAS_MINERALS',
  PHARMA_HEALTH_CHEM = 'PHARMA_HEALTH_CHEM'
}

/** The type industry of the Ior. */
export type VerticalSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<Vertical>>;
};

export enum VneBondExemptionStatusCode {
  E1N = 'E1N',
  E1Y = 'E1Y'
}

export enum VneIndustryCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J'
}

/** EPA Vehicles and Engines Regulatory Category */
export enum VneRegulatoryCategory {
  HEAVY_DUTY_HIGHWAY_AND_NON_ROAD = 'HEAVY_DUTY_HIGHWAY_AND_NON_ROAD',
  LIGHT_DUTY_ON_ROAD = 'LIGHT_DUTY_ON_ROAD'
}

/** Represents the volume of a product. */
export type Volume = {
  __typename?: 'Volume';
  /** Represents the unit of measure. */
  unit: VolumeUnit;
  /** Represents the measure (value). */
  value: Scalars['Float'];
};

/** Represents the volume of a product. */
export type VolumeInput = {
  /** Represents the unit of measure. */
  unit: VolumeUnit;
  /** Represents the measure (value). */
  value: Scalars['Float'];
};

/** Represents the unit of measure for volume. */
export enum VolumeUnit {
  CBM = 'CBM'
}

/** The warning code from CBP */
export enum WarningCode {
  CODE_27A = 'CODE_27A',
  CODE_27B = 'CODE_27B',
  CODE_27C = 'CODE_27C',
  CODE_27D = 'CODE_27D',
  CODE_27F = 'CODE_27F',
  CODE_27G = 'CODE_27G',
  CODE_27H = 'CODE_27H',
  CODE_27I = 'CODE_27I',
  CODE_27J = 'CODE_27J',
  CODE_27M = 'CODE_27M',
  CODE_27P = 'CODE_27P',
  CODE_27Q = 'CODE_27Q',
  CODE_28E = 'CODE_28E'
}

export type WarningSource = {
  __typename?: 'WarningSource';
  /** RequestId from the source of warnings  */
  requestId: Scalars['String'];
  /** Timestamp from the source of warnings */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type WarningSourceInput = {
  /** RequestId from the source of warnings  */
  requestId: Scalars['String'];
  /** Timestamp from the source of warnings */
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

/** The status of warning from CBP */
export enum WarningStatus {
  ACTIVE = 'ACTIVE',
  RESOLVED = 'RESOLVED'
}

export type WeaponMeasurements = {
  __typename?: 'WeaponMeasurements';
  /** Firearm barrel length. Used by: ATF */
  barrelLength?: Maybe<Dimension>;
  /** Firearm gauge size. Used by: ATF */
  caliberGaugeSize?: Maybe<Scalars['String']>;
  /** Overall length of the firearm, part, or implement of war. Used by: ATF */
  overallLength?: Maybe<Dimension>;
};

export type WeaponMeasurementsInput = {
  /** Firearm barrel length. Used by: ATF */
  barrelLength?: InputMaybe<DimensionInput>;
  /** Firearm gauge size. Used by: ATF */
  caliberGaugeSize?: InputMaybe<Scalars['String']>;
  /** Overall length of the firearm, part, or implement of war. Used by: ATF */
  overallLength?: InputMaybe<DimensionInput>;
};

/** Represents the weight of an object. */
export type Weight = {
  __typename?: 'Weight';
  /** Represents the unit of measure. */
  unit: WeightUnit;
  /** Represents the measure (value). */
  value: Scalars['Float'];
};

/** Represents the weight of an object. */
export type WeightInput = {
  /** Represents the unit of measure. */
  unit: WeightUnit;
  /** Represents the measure (value). */
  value: Scalars['Float'];
};

/** Represents the unit of measure for weight. */
export enum WeightUnit {
  KILOGRAM = 'KILOGRAM',
  POUNDS = 'POUNDS'
}

export type WorkOrder = {
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** The Work Order's confirmations */
  confirmations: Array<WorkOrderConfirmation>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Deadline for the Work Order to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the WorkOrder. This is an eventually consistent query. */
  documents: Array<Document>;
  /** Record's expiration time. On expiration, record will be permanently deleted. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** Group to which to the work order belongs. Returns the latest version. */
  group: WorkOrderGroup;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Work Order's inquiries */
  inquiries: Array<WorkOrderInquiry>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** The Work Order's milestones */
  milestones: Array<WorkOrderMilestone>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** WorkOrder Fields that are pending udpate */
  pendingUpdates: Array<WorkOrderPendingUpdate>;
  /** Current state of the Work Order. */
  state?: Maybe<Scalars['WorkOrderStateName']>;
  /** The Work Order State Machine this Work Order executes. Returns the version of the State Machine when the Work Order was created. */
  stateMachine: WorkOrderStateMachine;
  /** The Work Order's status. */
  status: WorkOrderStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Tasks associated w/ the work order. Returns the latest version of each. */
  tasks: Array<WorkOrderTask>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};


export type WorkOrderdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Work Order badge. Example: Hot */
export enum WorkOrderBadge {
  BIXD = 'BIXD',
  CBAM = 'CBAM',
  DG = 'DG',
  HOT = 'HOT',
  MULTIVAT = 'MULTIVAT',
  PREMIUM = 'PREMIUM',
  REFILE = 'REFILE'
}

/** Work Order badge. Example: Hot */
export type WorkOrderBadgeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderBadge>>;
};

/** The blocked reason code for the work order */
export enum WorkOrderBlockedReasonCode {
  CUSTOMS_DECLARATION_INCORRECT_ARRIVAL_NOTICE = 'CUSTOMS_DECLARATION_INCORRECT_ARRIVAL_NOTICE',
  CUSTOMS_DECLARATION_INCORRECT_BILL_OF_LADING = 'CUSTOMS_DECLARATION_INCORRECT_BILL_OF_LADING',
  CUSTOMS_DECLARATION_INCORRECT_BIS_PRODUCT_REGISTRATION = 'CUSTOMS_DECLARATION_INCORRECT_BIS_PRODUCT_REGISTRATION',
  CUSTOMS_DECLARATION_INCORRECT_COMMERCIAL_INVOICE = 'CUSTOMS_DECLARATION_INCORRECT_COMMERCIAL_INVOICE',
  CUSTOMS_DECLARATION_INCORRECT_DOCUMENT = 'CUSTOMS_DECLARATION_INCORRECT_DOCUMENT',
  CUSTOMS_DECLARATION_INCORRECT_DSN_LIST = 'CUSTOMS_DECLARATION_INCORRECT_DSN_LIST',
  CUSTOMS_DECLARATION_INCORRECT_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER = 'CUSTOMS_DECLARATION_INCORRECT_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER',
  CUSTOMS_DECLARATION_INCORRECT_EQUIPMENT_TYPE_APPROVAL = 'CUSTOMS_DECLARATION_INCORRECT_EQUIPMENT_TYPE_APPROVAL',
  CUSTOMS_DECLARATION_INCORRECT_E_CHALLAN = 'CUSTOMS_DECLARATION_INCORRECT_E_CHALLAN',
  CUSTOMS_DECLARATION_INCORRECT_IMPORT_FILE = 'CUSTOMS_DECLARATION_INCORRECT_IMPORT_FILE',
  CUSTOMS_DECLARATION_INCORRECT_IMPORT_PERMIT = 'CUSTOMS_DECLARATION_INCORRECT_IMPORT_PERMIT',
  CUSTOMS_DECLARATION_INCORRECT_INSPECTION_REPORT = 'CUSTOMS_DECLARATION_INCORRECT_INSPECTION_REPORT',
  CUSTOMS_DECLARATION_INCORRECT_OTHER_PGA_DOCUMENT = 'CUSTOMS_DECLARATION_INCORRECT_OTHER_PGA_DOCUMENT',
  CUSTOMS_DECLARATION_INCORRECT_PACKING_LIST = 'CUSTOMS_DECLARATION_INCORRECT_PACKING_LIST',
  CUSTOMS_DECLARATION_INCORRECT_PRODUCT_INFORMATION = 'CUSTOMS_DECLARATION_INCORRECT_PRODUCT_INFORMATION',
  CUSTOMS_DECLARATION_INCORRECT_PROFORMA_INVOICE = 'CUSTOMS_DECLARATION_INCORRECT_PROFORMA_INVOICE',
  CUSTOMS_DECLARATION_INCORRECT_TESTING_CERTIFICATE = 'CUSTOMS_DECLARATION_INCORRECT_TESTING_CERTIFICATE',
  CUSTOMS_DECLARATION_MISSING_ARRIVAL_NOTICE = 'CUSTOMS_DECLARATION_MISSING_ARRIVAL_NOTICE',
  CUSTOMS_DECLARATION_MISSING_BILL_OF_LADING = 'CUSTOMS_DECLARATION_MISSING_BILL_OF_LADING',
  CUSTOMS_DECLARATION_MISSING_BIS_PRODUCT_REGISTRATION = 'CUSTOMS_DECLARATION_MISSING_BIS_PRODUCT_REGISTRATION',
  CUSTOMS_DECLARATION_MISSING_COMMERCIAL_INVOICE = 'CUSTOMS_DECLARATION_MISSING_COMMERCIAL_INVOICE',
  CUSTOMS_DECLARATION_MISSING_DOCUMENT = 'CUSTOMS_DECLARATION_MISSING_DOCUMENT',
  CUSTOMS_DECLARATION_MISSING_DSN_LIST = 'CUSTOMS_DECLARATION_MISSING_DSN_LIST',
  CUSTOMS_DECLARATION_MISSING_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER = 'CUSTOMS_DECLARATION_MISSING_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER',
  CUSTOMS_DECLARATION_MISSING_EQUIPMENT_TYPE_APPROVAL = 'CUSTOMS_DECLARATION_MISSING_EQUIPMENT_TYPE_APPROVAL',
  CUSTOMS_DECLARATION_MISSING_E_CHALLAN = 'CUSTOMS_DECLARATION_MISSING_E_CHALLAN',
  CUSTOMS_DECLARATION_MISSING_IMPORT_FILE = 'CUSTOMS_DECLARATION_MISSING_IMPORT_FILE',
  CUSTOMS_DECLARATION_MISSING_IMPORT_PERMIT = 'CUSTOMS_DECLARATION_MISSING_IMPORT_PERMIT',
  CUSTOMS_DECLARATION_MISSING_INSPECTION_REPORT = 'CUSTOMS_DECLARATION_MISSING_INSPECTION_REPORT',
  CUSTOMS_DECLARATION_MISSING_OTHER_PGA_DOCUMENT = 'CUSTOMS_DECLARATION_MISSING_OTHER_PGA_DOCUMENT',
  CUSTOMS_DECLARATION_MISSING_PACKING_LIST = 'CUSTOMS_DECLARATION_MISSING_PACKING_LIST',
  CUSTOMS_DECLARATION_MISSING_PRODUCT_INFORMATION = 'CUSTOMS_DECLARATION_MISSING_PRODUCT_INFORMATION',
  CUSTOMS_DECLARATION_MISSING_PRODUCT_LIST = 'CUSTOMS_DECLARATION_MISSING_PRODUCT_LIST',
  CUSTOMS_DECLARATION_MISSING_PROFORMA_INVOICE = 'CUSTOMS_DECLARATION_MISSING_PROFORMA_INVOICE',
  CUSTOMS_DECLARATION_MISSING_TESTING_CERTIFICATE = 'CUSTOMS_DECLARATION_MISSING_TESTING_CERTIFICATE',
  CUSTOMS_DECLARATION_OTHER_PROBLEMS = 'CUSTOMS_DECLARATION_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_ADDITIONAL_INFORMATION_NEEDED = 'EU_CUSTOMS_ENTRY_ADDITIONAL_INFORMATION_NEEDED',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_EORI = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_EORI',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_VAT = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_VAT',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_MISSING_DATA = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_MISSING_DATA',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_CLASSIFICATION = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_CLASSIFICATION',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_EORI = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_EORI',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_INCOTERMS = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_INCOTERMS',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VALUE = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VALUE',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VAT = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VAT',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_MISSING_DATA = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_MISSING_DATA',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_EORI_NUMBER_INACCURATE = 'EU_CUSTOMS_ENTRY_EORI_NUMBER_INACCURATE',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_DETAILS = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_DETAILS',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_DETAILS = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_DETAILS',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_MISSING = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_MISSING',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_DATA = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_DATA',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_EORI = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_EORI',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_VAT = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_VAT',
  EU_CUSTOMS_ENTRY_PACKING_LIST_MISSING_DATA = 'EU_CUSTOMS_ENTRY_PACKING_LIST_MISSING_DATA',
  EU_CUSTOMS_ENTRY_PACKING_LIST_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_PACKING_LIST_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_MISSING = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_MISSING',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_UNPAID_DUTY = 'EU_CUSTOMS_ENTRY_UNPAID_DUTY',
  EU_CUSTOMS_ENTRY_VAT_NUMBER_INACCURATE = 'EU_CUSTOMS_ENTRY_VAT_NUMBER_INACCURATE',
  IMPORTER_ACTIVATION_MISSING_BUSINESS_LICENSE = 'IMPORTER_ACTIVATION_MISSING_BUSINESS_LICENSE',
  IMPORTER_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY = 'IMPORTER_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY',
  IMPORTER_ACTIVATION_MISSING_IMPORTER_AGENT = 'IMPORTER_ACTIVATION_MISSING_IMPORTER_AGENT',
  IMPORTER_ACTIVATION_MISSING_PRODUCT_LIST = 'IMPORTER_ACTIVATION_MISSING_PRODUCT_LIST',
  IMPORTER_ENTITY_ACTIVATION_MISSING_BUSINESS_REGISTRATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_BUSINESS_REGISTRATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_CONTINUOUS_BOND = 'IMPORTER_ENTITY_ACTIVATION_MISSING_CONTINUOUS_BOND',
  IMPORTER_ENTITY_ACTIVATION_MISSING_CORPORATE_CERTIFICATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_CORPORATE_CERTIFICATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_MISSING_OFFICER_VERIFICATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_OFFICER_VERIFICATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_PMS_APPLICATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_PMS_APPLICATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_SOI_SCREENING = 'IMPORTER_ENTITY_ACTIVATION_MISSING_SOI_SCREENING',
  IMPORTER_ENTITY_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_OTHER_DATA_MISSING = 'IMPORTER_ENTITY_ACTIVATION_OTHER_DATA_MISSING',
  IMPORTER_ENTITY_ACTIVATION_REJECT_CORPORATE_CERTIFICATION = 'IMPORTER_ENTITY_ACTIVATION_REJECT_CORPORATE_CERTIFICATION',
  IMPORTER_ENTITY_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY',
  PENDING_ENTRY_SUMMARY_CONFIRMATION = 'PENDING_ENTRY_SUMMARY_CONFIRMATION',
  SUSPENDED_PAYEE_ACCOUNT = 'SUSPENDED_PAYEE_ACCOUNT',
  US_CONSUMPTION_ENTRY_AD_CVD_INQUIRY = 'US_CONSUMPTION_ENTRY_AD_CVD_INQUIRY',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_APHIS_CORE_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_APHIS_CORE_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_LACEY_ACT_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_LACEY_ACT_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO',
  US_CONSUMPTION_ENTRY_BOL_MISMATCH = 'US_CONSUMPTION_ENTRY_BOL_MISMATCH',
  US_CONSUMPTION_ENTRY_BOND_ISSUE = 'US_CONSUMPTION_ENTRY_BOND_ISSUE',
  US_CONSUMPTION_ENTRY_CANCELLED_FACILITY_REGISTRATION = 'US_CONSUMPTION_ENTRY_CANCELLED_FACILITY_REGISTRATION',
  US_CONSUMPTION_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE = 'US_CONSUMPTION_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE',
  US_CONSUMPTION_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT = 'US_CONSUMPTION_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT',
  US_CONSUMPTION_ENTRY_CBMS_SYSTEM_ISSUE = 'US_CONSUMPTION_ENTRY_CBMS_SYSTEM_ISSUE',
  US_CONSUMPTION_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_CONTINUOUS_BOND_TERMINATED = 'US_CONSUMPTION_ENTRY_CONTINUOUS_BOND_TERMINATED',
  US_CONSUMPTION_ENTRY_CPSC_EXAM = 'US_CONSUMPTION_ENTRY_CPSC_EXAM',
  US_CONSUMPTION_ENTRY_CPSC_HOLD = 'US_CONSUMPTION_ENTRY_CPSC_HOLD',
  US_CONSUMPTION_ENTRY_EPA_EXAM = 'US_CONSUMPTION_ENTRY_EPA_EXAM',
  US_CONSUMPTION_ENTRY_EPA_MISSING_PESTICIDES_INFO = 'US_CONSUMPTION_ENTRY_EPA_MISSING_PESTICIDES_INFO',
  US_CONSUMPTION_ENTRY_EPA_MISSING_TSCA_INFO = 'US_CONSUMPTION_ENTRY_EPA_MISSING_TSCA_INFO',
  US_CONSUMPTION_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO = 'US_CONSUMPTION_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO',
  US_CONSUMPTION_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY = 'US_CONSUMPTION_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY',
  US_CONSUMPTION_ENTRY_ESV_FAILURE = 'US_CONSUMPTION_ENTRY_ESV_FAILURE',
  US_CONSUMPTION_ENTRY_FDA_EXAM = 'US_CONSUMPTION_ENTRY_FDA_EXAM',
  US_CONSUMPTION_ENTRY_FDA_LINE_HOLD = 'US_CONSUMPTION_ENTRY_FDA_LINE_HOLD',
  US_CONSUMPTION_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_BIOLOGICS_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_BIOLOGICS_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_COSMETICS_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_COSMETICS_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_DRUG_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_DRUG_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_FOODS_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_FOODS_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_TOBACCO_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_TOBACCO_INFO',
  US_CONSUMPTION_ENTRY_FOREIGN_EXPORTER_UNKNOWN = 'US_CONSUMPTION_ENTRY_FOREIGN_EXPORTER_UNKNOWN',
  US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED = 'US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED',
  US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED = 'US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED',
  US_CONSUMPTION_ENTRY_FWS_MISSING_FWS_DOCUMENTATION = 'US_CONSUMPTION_ENTRY_FWS_MISSING_FWS_DOCUMENTATION',
  US_CONSUMPTION_ENTRY_INCORRECT_HTS_CODE = 'US_CONSUMPTION_ENTRY_INCORRECT_HTS_CODE',
  US_CONSUMPTION_ENTRY_INVALID_CATEGORY_CODE = 'US_CONSUMPTION_ENTRY_INVALID_CATEGORY_CODE',
  US_CONSUMPTION_ENTRY_INVALID_COUNTRY_OF_PRODUCTION = 'US_CONSUMPTION_ENTRY_INVALID_COUNTRY_OF_PRODUCTION',
  US_CONSUMPTION_ENTRY_INVALID_DII = 'US_CONSUMPTION_ENTRY_INVALID_DII',
  US_CONSUMPTION_ENTRY_INVALID_PNC_NUMBER = 'US_CONSUMPTION_ENTRY_INVALID_PNC_NUMBER',
  US_CONSUMPTION_ENTRY_INVALID_PRODUCT_CODE = 'US_CONSUMPTION_ENTRY_INVALID_PRODUCT_CODE',
  US_CONSUMPTION_ENTRY_INVOICE_IS_NOT_IN_ENGLISH = 'US_CONSUMPTION_ENTRY_INVOICE_IS_NOT_IN_ENGLISH',
  US_CONSUMPTION_ENTRY_IOR_SANCTIONED = 'US_CONSUMPTION_ENTRY_IOR_SANCTIONED',
  US_CONSUMPTION_ENTRY_LINE_HOLD = 'US_CONSUMPTION_ENTRY_LINE_HOLD',
  US_CONSUMPTION_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY = 'US_CONSUMPTION_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY',
  US_CONSUMPTION_ENTRY_MANUAL_HOLD_SEE_MEMO = 'US_CONSUMPTION_ENTRY_MANUAL_HOLD_SEE_MEMO',
  US_CONSUMPTION_ENTRY_MFGR_CODE_UNKNOWN = 'US_CONSUMPTION_ENTRY_MFGR_CODE_UNKNOWN',
  US_CONSUMPTION_ENTRY_MISMATCH_IN_REGISTRATION = 'US_CONSUMPTION_ENTRY_MISMATCH_IN_REGISTRATION',
  US_CONSUMPTION_ENTRY_MISSING_AD_CVD_NON_REIMBURSEMENT_CERTIFICATE = 'US_CONSUMPTION_ENTRY_MISSING_AD_CVD_NON_REIMBURSEMENT_CERTIFICATE',
  US_CONSUMPTION_ENTRY_MISSING_CONTAINER_INFO = 'US_CONSUMPTION_ENTRY_MISSING_CONTAINER_INFO',
  US_CONSUMPTION_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA = 'US_CONSUMPTION_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA',
  US_CONSUMPTION_ENTRY_MISSING_CURRENCY = 'US_CONSUMPTION_ENTRY_MISSING_CURRENCY',
  US_CONSUMPTION_ENTRY_MISSING_EXTENDED_COST = 'US_CONSUMPTION_ENTRY_MISSING_EXTENDED_COST',
  US_CONSUMPTION_ENTRY_MISSING_FIRMS_CODE = 'US_CONSUMPTION_ENTRY_MISSING_FIRMS_CODE',
  US_CONSUMPTION_ENTRY_MISSING_GROSS_WEIGHT = 'US_CONSUMPTION_ENTRY_MISSING_GROSS_WEIGHT',
  US_CONSUMPTION_ENTRY_MISSING_HOUSE_BILL = 'US_CONSUMPTION_ENTRY_MISSING_HOUSE_BILL',
  US_CONSUMPTION_ENTRY_MISSING_HTS_REPORTING_QUANTITY = 'US_CONSUMPTION_ENTRY_MISSING_HTS_REPORTING_QUANTITY',
  US_CONSUMPTION_ENTRY_MISSING_IT_INFO = 'US_CONSUMPTION_ENTRY_MISSING_IT_INFO',
  US_CONSUMPTION_ENTRY_MISSING_LINE_QUANTITY = 'US_CONSUMPTION_ENTRY_MISSING_LINE_QUANTITY',
  US_CONSUMPTION_ENTRY_MISSING_MASTER_BILL = 'US_CONSUMPTION_ENTRY_MISSING_MASTER_BILL',
  US_CONSUMPTION_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO = 'US_CONSUMPTION_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO',
  US_CONSUMPTION_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS = 'US_CONSUMPTION_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS',
  US_CONSUMPTION_ENTRY_MISSING_REQUIRED_NET_WEIGHT = 'US_CONSUMPTION_ENTRY_MISSING_REQUIRED_NET_WEIGHT',
  US_CONSUMPTION_ENTRY_MISSING_UNIT_COST = 'US_CONSUMPTION_ENTRY_MISSING_UNIT_COST',
  US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA = 'US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA',
  US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES = 'US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES',
  US_CONSUMPTION_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION = 'US_CONSUMPTION_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION',
  US_CONSUMPTION_ENTRY_NEED_INTENDED_USE_OF_PRODUCT = 'US_CONSUMPTION_ENTRY_NEED_INTENDED_USE_OF_PRODUCT',
  US_CONSUMPTION_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM = 'US_CONSUMPTION_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM',
  US_CONSUMPTION_ENTRY_NEED_PRODUCT_DESCRIPTION = 'US_CONSUMPTION_ENTRY_NEED_PRODUCT_DESCRIPTION',
  US_CONSUMPTION_ENTRY_NHTSA_MISSING_HS7 = 'US_CONSUMPTION_ENTRY_NHTSA_MISSING_HS7',
  US_CONSUMPTION_ENTRY_NOT_DEPARTED_ORIGIN = 'US_CONSUMPTION_ENTRY_NOT_DEPARTED_ORIGIN',
  US_CONSUMPTION_ENTRY_NO_BILL_MATCH = 'US_CONSUMPTION_ENTRY_NO_BILL_MATCH',
  US_CONSUMPTION_ENTRY_OTHER_ADD_COMMENT = 'US_CONSUMPTION_ENTRY_OTHER_ADD_COMMENT',
  US_CONSUMPTION_ENTRY_OTHER_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_OTHER_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_OTHER_PGA_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_OTHER_PGA_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_PAYMENT_PENDING_CBP_REVIEW = 'US_CONSUMPTION_ENTRY_PAYMENT_PENDING_CBP_REVIEW',
  US_CONSUMPTION_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW = 'US_CONSUMPTION_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW',
  US_CONSUMPTION_ENTRY_PENDING_BUG_FIX = 'US_CONSUMPTION_ENTRY_PENDING_BUG_FIX',
  US_CONSUMPTION_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER = 'US_CONSUMPTION_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER',
  US_CONSUMPTION_ENTRY_PENDING_DATA_FIX = 'US_CONSUMPTION_ENTRY_PENDING_DATA_FIX',
  US_CONSUMPTION_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG = 'US_CONSUMPTION_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG',
  US_CONSUMPTION_ENTRY_PIECE_COUNT_DISCREPANCY = 'US_CONSUMPTION_ENTRY_PIECE_COUNT_DISCREPANCY',
  US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED = 'US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED',
  US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED = 'US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED',
  US_CONSUMPTION_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_REGISTRATION_NOT_ON_FILE = 'US_CONSUMPTION_ENTRY_REGISTRATION_NOT_ON_FILE',
  US_CONSUMPTION_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH = 'US_CONSUMPTION_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH',
  US_CONSUMPTION_ENTRY_SUMMARY_DELETED_OR_REPLACED = 'US_CONSUMPTION_ENTRY_SUMMARY_DELETED_OR_REPLACED',
  US_CONSUMPTION_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED = 'US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED',
  US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING = 'US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING',
  US_CONSUMPTION_ENTRY_TTB_MISSING_BEER_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_BEER_INFO',
  US_CONSUMPTION_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO',
  US_CONSUMPTION_ENTRY_TTB_MISSING_TOBACCO_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_TOBACCO_INFO',
  US_CONSUMPTION_ENTRY_TTB_MISSING_WINE_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_WINE_INFO',
  US_IN_BOND_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT = 'US_IN_BOND_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT',
  US_IN_BOND_COMMERCIAL_INVOICE_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING = 'US_IN_BOND_COMMERCIAL_INVOICE_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING',
  US_IN_BOND_MANIFESTED_QUANTITY_DISCREPANCY = 'US_IN_BOND_MANIFESTED_QUANTITY_DISCREPANCY',
  US_IN_BOND_MISSING_BONDED_CARRIER_CODE = 'US_IN_BOND_MISSING_BONDED_CARRIER_CODE',
  US_IN_BOND_MISSING_BONDED_CARRIER_TAX_ID = 'US_IN_BOND_MISSING_BONDED_CARRIER_TAX_ID',
  US_IN_BOND_MISSING_CONSIGNEE = 'US_IN_BOND_MISSING_CONSIGNEE',
  US_IN_BOND_MISSING_CONTAINER_INFO = 'US_IN_BOND_MISSING_CONTAINER_INFO',
  US_IN_BOND_MISSING_CURRENCY = 'US_IN_BOND_MISSING_CURRENCY',
  US_IN_BOND_MISSING_FIRMS_CODE = 'US_IN_BOND_MISSING_FIRMS_CODE',
  US_IN_BOND_MISSING_HOUSE_BILL = 'US_IN_BOND_MISSING_HOUSE_BILL',
  US_IN_BOND_MISSING_MASTER_BILL = 'US_IN_BOND_MISSING_MASTER_BILL',
  US_IN_BOND_MISSING_PORT_OF_UNLADING_ENTRY_INFO = 'US_IN_BOND_MISSING_PORT_OF_UNLADING_ENTRY_INFO',
  US_IN_BOND_MISSING_PREVIOUS_IN_BOND_DATE = 'US_IN_BOND_MISSING_PREVIOUS_IN_BOND_DATE',
  US_IN_BOND_MISSING_PREVIOUS_IN_BOND_NUMBER = 'US_IN_BOND_MISSING_PREVIOUS_IN_BOND_NUMBER',
  US_IN_BOND_MISSING_PREVIOUS_IN_BOND_ORIGIN_PORT = 'US_IN_BOND_MISSING_PREVIOUS_IN_BOND_ORIGIN_PORT',
  US_IN_BOND_MISSING_TOTAL_VALUE = 'US_IN_BOND_MISSING_TOTAL_VALUE',
  US_IN_BOND_TRANSPORTATION_INFO_OTHER_DATA_MISSING = 'US_IN_BOND_TRANSPORTATION_INFO_OTHER_DATA_MISSING',
  US_IOR_ACTIVATION_MISSING_BUSINESS_REGISTRATION = 'US_IOR_ACTIVATION_MISSING_BUSINESS_REGISTRATION',
  US_IOR_ACTIVATION_MISSING_CONTINUOUS_BOND = 'US_IOR_ACTIVATION_MISSING_CONTINUOUS_BOND',
  US_IOR_ACTIVATION_MISSING_CORPORATE_CERTIFICATION = 'US_IOR_ACTIVATION_MISSING_CORPORATE_CERTIFICATION',
  US_IOR_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_MISSING_OFFICER_VERIFICATION = 'US_IOR_ACTIVATION_MISSING_OFFICER_VERIFICATION',
  US_IOR_ACTIVATION_MISSING_PMS_APPLICATION = 'US_IOR_ACTIVATION_MISSING_PMS_APPLICATION',
  US_IOR_ACTIVATION_MISSING_SOI_SCREENING = 'US_IOR_ACTIVATION_MISSING_SOI_SCREENING',
  US_IOR_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_OTHER_DATA_MISSING = 'US_IOR_ACTIVATION_OTHER_DATA_MISSING',
  US_IOR_ACTIVATION_REJECT_CORPORATE_CERTIFICATION = 'US_IOR_ACTIVATION_REJECT_CORPORATE_CERTIFICATION',
  US_IOR_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY',
  US_ISF_INFORMATION_NOT_IN_ENGLISH = 'US_ISF_INFORMATION_NOT_IN_ENGLISH',
  US_ISF_INVALID_BOND = 'US_ISF_INVALID_BOND',
  US_ISF_INVALID_HTS_CODE = 'US_ISF_INVALID_HTS_CODE',
  US_ISF_IOR_MISMATCH = 'US_ISF_IOR_MISMATCH',
  US_ISF_MISSING_ASI_FORM = 'US_ISF_MISSING_ASI_FORM',
  US_ISF_MISSING_ASI_INFO = 'US_ISF_MISSING_ASI_INFO',
  US_ISF_MISSING_COUNTRY_OF_ORIGION = 'US_ISF_MISSING_COUNTRY_OF_ORIGION',
  US_ISF_MISSING_HTS_CODE = 'US_ISF_MISSING_HTS_CODE',
  US_ISF_MISSING_ISF_FORM = 'US_ISF_MISSING_ISF_FORM',
  US_ISF_MISSING_ISF_INFO = 'US_ISF_MISSING_ISF_INFO',
  US_ISF_MISSING_MBL_OR_HBL = 'US_ISF_MISSING_MBL_OR_HBL',
  US_ISF_MISSING_SELLER_OR_MANUFACTURER_INFO = 'US_ISF_MISSING_SELLER_OR_MANUFACTURER_INFO',
  US_ISF_OTHER_DATA_MISSING = 'US_ISF_OTHER_DATA_MISSING',
  US_ISF_TECH_ISSUES = 'US_ISF_TECH_ISSUES',
  US_TYPE86_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_APHIS_CORE_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_APHIS_CORE_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_LACEY_ACT_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_LACEY_ACT_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO',
  US_TYPE86_ENTRY_BOL_MISMATCH = 'US_TYPE86_ENTRY_BOL_MISMATCH',
  US_TYPE86_ENTRY_BOND_ISSUE = 'US_TYPE86_ENTRY_BOND_ISSUE',
  US_TYPE86_ENTRY_CANCELLED_FACILITY_REGISTRATION = 'US_TYPE86_ENTRY_CANCELLED_FACILITY_REGISTRATION',
  US_TYPE86_ENTRY_CARGO_RELEASE_DELETED_OR_REPLACED = 'US_TYPE86_ENTRY_CARGO_RELEASE_DELETED_OR_REPLACED',
  US_TYPE86_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE = 'US_TYPE86_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE',
  US_TYPE86_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT = 'US_TYPE86_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT',
  US_TYPE86_ENTRY_CBMS_SYSTEM_ISSUE = 'US_TYPE86_ENTRY_CBMS_SYSTEM_ISSUE',
  US_TYPE86_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_CONTINUOUS_BOND_TERMINATED = 'US_TYPE86_ENTRY_CONTINUOUS_BOND_TERMINATED',
  US_TYPE86_ENTRY_CPSC_EXAM = 'US_TYPE86_ENTRY_CPSC_EXAM',
  US_TYPE86_ENTRY_CPSC_HOLD = 'US_TYPE86_ENTRY_CPSC_HOLD',
  US_TYPE86_ENTRY_EPA_EXAM = 'US_TYPE86_ENTRY_EPA_EXAM',
  US_TYPE86_ENTRY_EPA_MISSING_PESTICIDES_INFO = 'US_TYPE86_ENTRY_EPA_MISSING_PESTICIDES_INFO',
  US_TYPE86_ENTRY_EPA_MISSING_TSCA_INFO = 'US_TYPE86_ENTRY_EPA_MISSING_TSCA_INFO',
  US_TYPE86_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO = 'US_TYPE86_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO',
  US_TYPE86_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY = 'US_TYPE86_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY',
  US_TYPE86_ENTRY_ESV_FAILURE = 'US_TYPE86_ENTRY_ESV_FAILURE',
  US_TYPE86_ENTRY_FDA_EXAM = 'US_TYPE86_ENTRY_FDA_EXAM',
  US_TYPE86_ENTRY_FDA_LINE_HOLD = 'US_TYPE86_ENTRY_FDA_LINE_HOLD',
  US_TYPE86_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_BIOLOGICS_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_BIOLOGICS_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_COSMETICS_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_COSMETICS_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_DRUG_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_DRUG_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_FOODS_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_FOODS_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_TOBACCO_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_TOBACCO_INFO',
  US_TYPE86_ENTRY_FOREIGN_EXPORTER_UNKNOWN = 'US_TYPE86_ENTRY_FOREIGN_EXPORTER_UNKNOWN',
  US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED = 'US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED',
  US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED = 'US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED',
  US_TYPE86_ENTRY_FWS_MISSING_FWS_DOCUMENTATION = 'US_TYPE86_ENTRY_FWS_MISSING_FWS_DOCUMENTATION',
  US_TYPE86_ENTRY_INCORRECT_HTS_CODE = 'US_TYPE86_ENTRY_INCORRECT_HTS_CODE',
  US_TYPE86_ENTRY_INVALID_CATEGORY_CODE = 'US_TYPE86_ENTRY_INVALID_CATEGORY_CODE',
  US_TYPE86_ENTRY_INVALID_COUNTRY_OF_PRODUCTION = 'US_TYPE86_ENTRY_INVALID_COUNTRY_OF_PRODUCTION',
  US_TYPE86_ENTRY_INVALID_DII = 'US_TYPE86_ENTRY_INVALID_DII',
  US_TYPE86_ENTRY_INVALID_PNC_NUMBER = 'US_TYPE86_ENTRY_INVALID_PNC_NUMBER',
  US_TYPE86_ENTRY_INVALID_PRODUCT_CODE = 'US_TYPE86_ENTRY_INVALID_PRODUCT_CODE',
  US_TYPE86_ENTRY_INVOICE_IS_NOT_IN_ENGLISH = 'US_TYPE86_ENTRY_INVOICE_IS_NOT_IN_ENGLISH',
  US_TYPE86_ENTRY_IOR_SANCTIONED = 'US_TYPE86_ENTRY_IOR_SANCTIONED',
  US_TYPE86_ENTRY_LINE_HOLD = 'US_TYPE86_ENTRY_LINE_HOLD',
  US_TYPE86_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY = 'US_TYPE86_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY',
  US_TYPE86_ENTRY_MANUAL_HOLD_SEE_MEMO = 'US_TYPE86_ENTRY_MANUAL_HOLD_SEE_MEMO',
  US_TYPE86_ENTRY_MFGR_CODE_UNKNOWN = 'US_TYPE86_ENTRY_MFGR_CODE_UNKNOWN',
  US_TYPE86_ENTRY_MISMATCH_IN_REGISTRATION = 'US_TYPE86_ENTRY_MISMATCH_IN_REGISTRATION',
  US_TYPE86_ENTRY_MISSING_CONTAINER_INFO = 'US_TYPE86_ENTRY_MISSING_CONTAINER_INFO',
  US_TYPE86_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA = 'US_TYPE86_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA',
  US_TYPE86_ENTRY_MISSING_CURRENCY = 'US_TYPE86_ENTRY_MISSING_CURRENCY',
  US_TYPE86_ENTRY_MISSING_EXTENDED_COST = 'US_TYPE86_ENTRY_MISSING_EXTENDED_COST',
  US_TYPE86_ENTRY_MISSING_FIRMS_CODE = 'US_TYPE86_ENTRY_MISSING_FIRMS_CODE',
  US_TYPE86_ENTRY_MISSING_GROSS_WEIGHT = 'US_TYPE86_ENTRY_MISSING_GROSS_WEIGHT',
  US_TYPE86_ENTRY_MISSING_HOUSE_BILL = 'US_TYPE86_ENTRY_MISSING_HOUSE_BILL',
  US_TYPE86_ENTRY_MISSING_HTS_REPORTING_QUANTITY = 'US_TYPE86_ENTRY_MISSING_HTS_REPORTING_QUANTITY',
  US_TYPE86_ENTRY_MISSING_IT_INFO = 'US_TYPE86_ENTRY_MISSING_IT_INFO',
  US_TYPE86_ENTRY_MISSING_LINE_QUANTITY = 'US_TYPE86_ENTRY_MISSING_LINE_QUANTITY',
  US_TYPE86_ENTRY_MISSING_MASTER_BILL = 'US_TYPE86_ENTRY_MISSING_MASTER_BILL',
  US_TYPE86_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO = 'US_TYPE86_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO',
  US_TYPE86_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS = 'US_TYPE86_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS',
  US_TYPE86_ENTRY_MISSING_REQUIRED_NET_WEIGHT = 'US_TYPE86_ENTRY_MISSING_REQUIRED_NET_WEIGHT',
  US_TYPE86_ENTRY_MISSING_UNIT_COST = 'US_TYPE86_ENTRY_MISSING_UNIT_COST',
  US_TYPE86_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA = 'US_TYPE86_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA',
  US_TYPE86_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES = 'US_TYPE86_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES',
  US_TYPE86_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION = 'US_TYPE86_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION',
  US_TYPE86_ENTRY_NEED_INTENDED_USE_OF_PRODUCT = 'US_TYPE86_ENTRY_NEED_INTENDED_USE_OF_PRODUCT',
  US_TYPE86_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM = 'US_TYPE86_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM',
  US_TYPE86_ENTRY_NEED_PRODUCT_DESCRIPTION = 'US_TYPE86_ENTRY_NEED_PRODUCT_DESCRIPTION',
  US_TYPE86_ENTRY_NHTSA_MISSING_HS7 = 'US_TYPE86_ENTRY_NHTSA_MISSING_HS7',
  US_TYPE86_ENTRY_NOT_DEPARTED_ORIGIN = 'US_TYPE86_ENTRY_NOT_DEPARTED_ORIGIN',
  US_TYPE86_ENTRY_NO_BILL_MATCH = 'US_TYPE86_ENTRY_NO_BILL_MATCH',
  US_TYPE86_ENTRY_OTHER_ADD_COMMENT = 'US_TYPE86_ENTRY_OTHER_ADD_COMMENT',
  US_TYPE86_ENTRY_OTHER_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_OTHER_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_OTHER_PGA_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_OTHER_PGA_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_PAYMENT_PENDING_CBP_REVIEW = 'US_TYPE86_ENTRY_PAYMENT_PENDING_CBP_REVIEW',
  US_TYPE86_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW = 'US_TYPE86_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW',
  US_TYPE86_ENTRY_PENDING_BUG_FIX = 'US_TYPE86_ENTRY_PENDING_BUG_FIX',
  US_TYPE86_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER = 'US_TYPE86_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER',
  US_TYPE86_ENTRY_PENDING_DATA_FIX = 'US_TYPE86_ENTRY_PENDING_DATA_FIX',
  US_TYPE86_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG = 'US_TYPE86_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG',
  US_TYPE86_ENTRY_PIECE_COUNT_DISCREPANCY = 'US_TYPE86_ENTRY_PIECE_COUNT_DISCREPANCY',
  US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED = 'US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED',
  US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED = 'US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED',
  US_TYPE86_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_REGISTRATION_NOT_ON_FILE = 'US_TYPE86_ENTRY_REGISTRATION_NOT_ON_FILE',
  US_TYPE86_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH = 'US_TYPE86_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH',
  US_TYPE86_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED = 'US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED',
  US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING = 'US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING',
  US_TYPE86_ENTRY_TTB_MISSING_BEER_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_BEER_INFO',
  US_TYPE86_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO',
  US_TYPE86_ENTRY_TTB_MISSING_TOBACCO_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_TOBACCO_INFO',
  US_TYPE86_ENTRY_TTB_MISSING_WINE_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_WINE_INFO'
}

/** The blocked reason code for the work order */
export type WorkOrderBlockedReasonCodeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderBlockedReasonCode>>;
};

/** Work Order Confirmation Configuration Details. */
export type WorkOrderConfirmConfigurationDetailsInput = {
  /** Duration of minutes to wait for the response until auto approve. Never auto approve if not defined. */
  approveAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** Documents to send along with entry summary confirmation request so the client more information about the entry. */
  includedDocuments?: InputMaybe<Array<DocumentTag>>;
  /** Whether the shipper is allowed to override its forwarder's work order confirmation configuration. */
  overrideForwarderConfig?: InputMaybe<Scalars['Boolean']>;
  /** Rules for work order confirmation setting. Always request confirmation if not defined. */
  ruleGroup?: InputMaybe<BusinessRuleGroupInput>;
  /** Type of work order associated with the confirmation. */
  workOrderType: WorkOrderType;
};

/** Confirmation  to customer on work order before transaction. */
export type WorkOrderConfirmation = Record & {
  __typename?: 'WorkOrderConfirmation';
  /** Additional comments for dispute if client provides it. */
  additionalComments?: Maybe<Scalars['String']>;
  /** Time for auto-create transaction if still waiting for the customers confirmation. */
  approvalCutOffTime?: Maybe<Scalars['DateTime']>;
  /** If not approved after approveAfterMinutes, auto approve the confirmation and file the transaction. */
  approveAfterMinutes?: Maybe<Scalars['Int']>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Reason for dispute if client provides it. */
  disputedReason?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Type of source reviewed the work order confirmation. */
  reviewSource?: Maybe<WorkOrderConfirmationReviewSourceType>;
  /** Record to track the approve action. */
  reviewed?: Maybe<RecordAction>;
  /** The client approval status of work order confirmation. */
  status?: Maybe<WorkOrderConfirmationApprovalStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Transaction to be performed once the confirmation is approved. */
  transaction?: Maybe<WorkOrderConfirmationTransaction>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The Work Order this Confirmation belongs to. */
  workOrder: WorkOrder;
};

/** The client approval status of work order confirmation. */
export enum WorkOrderConfirmationApprovalStatus {
  APPROVED = 'APPROVED',
  DISPUTED = 'DISPUTED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  VOID = 'VOID'
}

export type WorkOrderConfirmationEdge = ConnectionEdge & {
  __typename?: 'WorkOrderConfirmationEdge';
  cursor: Scalars['ID'];
  node: WorkOrderConfirmation;
};

/** The client response to the work order confirmation. */
export enum WorkOrderConfirmationReviewApprovalStatus {
  APPROVED = 'APPROVED',
  DISPUTED = 'DISPUTED',
  EXPIRED = 'EXPIRED'
}

/** Type of source reviewed the work order confirmation. */
export enum WorkOrderConfirmationReviewSourceType {
  APP_FORWARDER = 'APP_FORWARDER',
  APP_OPERATOR = 'APP_OPERATOR',
  APP_SHIPPER = 'APP_SHIPPER',
  AUTO_CONFIRMED = 'AUTO_CONFIRMED',
  DOCUMENT_EVENT = 'DOCUMENT_EVENT',
  LINK = 'LINK'
}

/** Transaction to be performed once the confirmation is approved. */
export type WorkOrderConfirmationTransaction = {
  __typename?: 'WorkOrderConfirmationTransaction';
  /** Details for creating specific transaction. */
  input?: Maybe<Scalars['JSONObject']>;
  /** Type of the transaction. */
  type: WorkOrderConfirmationTransactionType;
};

/** Transaction to be performed once the confirmation is approved. */
export type WorkOrderConfirmationTransactionInput = {
  /** Details for creating specific transaction. */
  input?: InputMaybe<Scalars['JSONObject']>;
  /** Type of the transaction. */
  type: WorkOrderConfirmationTransactionType;
};

/** WorkOrderConfirmationTransactionType */
export enum WorkOrderConfirmationTransactionType {
  REPLACE_US_CONSUMPTION_ENTRY_RELEASE_CBP = 'REPLACE_US_CONSUMPTION_ENTRY_RELEASE_CBP',
  UPDATE_US_CONSUMPTION_ENTRY_PGA_CBP = 'UPDATE_US_CONSUMPTION_ENTRY_PGA_CBP',
  UPDATE_US_CONSUMPTION_ENTRY_RELEASE_CBP = 'UPDATE_US_CONSUMPTION_ENTRY_RELEASE_CBP',
  UPSERT_US_CONSUMPTION_ENTRY_SUMMARY_CBP = 'UPSERT_US_CONSUMPTION_ENTRY_SUMMARY_CBP',
  UPSERT_US_POST_SUMMARY_CORRECTION_SUMMARY_CBP = 'UPSERT_US_POST_SUMMARY_CORRECTION_SUMMARY_CBP'
}

export type WorkOrderConfirmationsConnection = Connection & {
  __typename?: 'WorkOrderConfirmationsConnection';
  edges: Array<WorkOrderConfirmationEdge>;
  nodes: Array<WorkOrderConfirmation>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type WorkOrderDocumentExtractionReference = {
  __typename?: 'WorkOrderDocumentExtractionReference';
  /** The S3 Link to download extracted results. */
  downloadLink: Scalars['String'];
  /** The workOrder document extraction S3 reference/path. */
  referenceKey: Scalars['String'];
};

export type WorkOrderDocumentExtractionReferenceInput = {
  /** The workOrder document extraction S3 reference/path. */
  referenceKey: Scalars['String'];
};

export type WorkOrderDocumentProcessingRequest = Record & {
  __typename?: 'WorkOrderDocumentProcessingRequest';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** WorkOrder processing request documents. */
  documents?: Maybe<Array<WorkOrderProcessingRequestDocument>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Status values for tracking document processing status for a workOrder */
  status?: Maybe<WorkOrderDocumentProcessingStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
};

export type WorkOrderDocumentProcessingRequestEdge = ConnectionEdge & {
  __typename?: 'WorkOrderDocumentProcessingRequestEdge';
  cursor: Scalars['ID'];
  node: WorkOrderDocumentProcessingRequest;
};

export type WorkOrderDocumentProcessingRequestSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Id of the CBMS document */
  documentId?: InputMaybe<IdSearchCriteriaInput>;
  /** External document references. */
  externalDocumentReferencesId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Status values for tracking document processing status for a workOrder */
  status?: InputMaybe<WorkOrderDocumentProcessingStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The workOrder ID. */
  workOrderId?: InputMaybe<IdSearchCriteriaInput>;
};

/** WorkOrder Document Processing Request Search Table Row */
export type WorkOrderDocumentProcessingRequestSearchTableRow = RecordSearchTableRow & {
  __typename?: 'WorkOrderDocumentProcessingRequestSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** WorkOrder processing request - processed documents. */
  documentId?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Status values for tracking document processing status for a workOrder */
  status?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The workOrder ID. */
  workOrderId?: Maybe<Scalars['ID']>;
};

export type WorkOrderDocumentProcessingRequestsConnection = Connection & {
  __typename?: 'WorkOrderDocumentProcessingRequestsConnection';
  edges: Array<WorkOrderDocumentProcessingRequestEdge>;
  nodes: Array<WorkOrderDocumentProcessingRequest>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Status values for tracking document processing status for a workOrder */
export enum WorkOrderDocumentProcessingStatus {
  EXTRACTION_COMPLETED = 'EXTRACTION_COMPLETED',
  EXTRACTION_FAILED = 'EXTRACTION_FAILED',
  EXTRACTION_IN_PROGRESS = 'EXTRACTION_IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export type WorkOrderDocumentProcessingStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderDocumentProcessingStatus>>;
};

/** A group of Work Orders performed together. */
export type WorkOrderGroup = Record & {
  __typename?: 'WorkOrderGroup';
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** Changelogs associated with the record. */
  changelogs?: Maybe<Array<Changelog>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The Customs Broker associated with the Group of Work Orders. Returns the latest version. */
  customsBroker?: Maybe<CustomsBroker>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** The documents associated with the WorkOrderGroup. This is an eventually consistent query. */
  documents: Array<Document>;
  /** The Forwarders associated with the Group of Work Orders. Returns the latest version. */
  forwarders?: Maybe<Array<WorkOrderGroupForwarder>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The invoices associated with the WorkOrderGroup. This is an eventually consistent query. */
  invoices?: Maybe<Array<Invoice>>;
  /** Business notes associated with the record. This is an eventually consistent query. */
  memos: Array<Memo>;
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The payable invoices associated with the WorkOrderGroup. This is an eventually consistent query. */
  payableInvoices?: Maybe<Array<PayableInvoice>>;
  /** The Shipment associated with the WorkOrderGroup. This is an eventually consistent query. */
  shipment?: Maybe<Shipment>;
  /** The Shipper associated with the Group of Work Orders. Returns the latest version. */
  shipper?: Maybe<Shipper>;
  /** The Work Order Group's status. */
  status: WorkOrderGroupStatus;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** Work Orders within the group. */
  workOrders: Array<WorkOrder>;
};


/** A group of Work Orders performed together. */
export type WorkOrderGroupdocumentsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** A group of Work Orders performed together. */
export type WorkOrderGroupmemosArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type WorkOrderGroupEdge = ConnectionEdge & {
  __typename?: 'WorkOrderGroupEdge';
  cursor: Scalars['ID'];
  node: WorkOrderGroup;
};

export type WorkOrderGroupForwarder = {
  __typename?: 'WorkOrderGroupForwarder';
  forwarder: Forwarder;
};

export type WorkOrderGroupForwarderInput = {
  forwarder: IdInput;
};

export type WorkOrderGroupSearchCriteriaInput = {
  /** The id of the broker linked to this WOG. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the forwarder linked to this WOG. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the shipper linked to this WOG. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** Work order group status */
  status?: InputMaybe<WorkOrderGroupStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the workOrder linked to this WOG. */
  workOrderId?: InputMaybe<IdSearchCriteriaInput>;
};

/** TBD */
export type WorkOrderGroupSearchTableRow = RecordSearchTableRow & {
  __typename?: 'WorkOrderGroupSearchTableRow';
  /** The id of the broker linked to this WOG. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The id of the forwarder linked to this WOG. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The id of the shipper linked to this WOG. */
  shipperId?: Maybe<Scalars['ID']>;
  /** Work order group status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the workOrder linked to this WOG. */
  workOrderId?: Maybe<Scalars['ID']>;
};

/** The Work Order Group's status. */
export enum WorkOrderGroupStatus {
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

/** The Work Order Group's status. */
export type WorkOrderGroupStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderGroupStatus>>;
};

export type WorkOrderGroupsConnection = Connection & {
  __typename?: 'WorkOrderGroupsConnection';
  edges: Array<WorkOrderGroupEdge>;
  nodes: Array<WorkOrderGroup>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type WorkOrderInquiry = {
  __typename?: 'WorkOrderInquiry';
  /** The documents attached to the email */
  attachDocuments: Array<Document>;
  /** The documents that need more information noted in this inquiry */
  clarifyDocuments: Array<Document>;
  /** The description for this inquiry */
  description?: Maybe<Scalars['String']>;
  /** The WorkOrderMilestone created as a result of this inquiry */
  milestone: WorkOrderMilestone;
  /** The ProductLevelInquiries for this inquiry */
  productLevelInquiries?: Maybe<Array<ProductLevelInquiry>>;
  /** The WorkOrderInquiryReasonCodes for this inquiry */
  reasonCodes?: Maybe<Array<WorkOrderInquiryReasonCode>>;
  /** The requested documents (documents currently missing) noted in this inquiry */
  requestDocuments: Array<DocumentTag>;
  /** The task that is blocked by this inquiry. If a task is not provided the most recent in progress task (if there is one in progress) will be marked blocked by this inquiry */
  task?: Maybe<WorkOrderTask>;
};

/** The reason code for the work order inquiry */
export enum WorkOrderInquiryReasonCode {
  CUSTOMS_DECLARATION_INCORRECT_ARRIVAL_NOTICE = 'CUSTOMS_DECLARATION_INCORRECT_ARRIVAL_NOTICE',
  CUSTOMS_DECLARATION_INCORRECT_BILL_OF_LADING = 'CUSTOMS_DECLARATION_INCORRECT_BILL_OF_LADING',
  CUSTOMS_DECLARATION_INCORRECT_BIS_PRODUCT_REGISTRATION = 'CUSTOMS_DECLARATION_INCORRECT_BIS_PRODUCT_REGISTRATION',
  CUSTOMS_DECLARATION_INCORRECT_COMMERCIAL_INVOICE = 'CUSTOMS_DECLARATION_INCORRECT_COMMERCIAL_INVOICE',
  CUSTOMS_DECLARATION_INCORRECT_DOCUMENT = 'CUSTOMS_DECLARATION_INCORRECT_DOCUMENT',
  CUSTOMS_DECLARATION_INCORRECT_DSN_LIST = 'CUSTOMS_DECLARATION_INCORRECT_DSN_LIST',
  CUSTOMS_DECLARATION_INCORRECT_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER = 'CUSTOMS_DECLARATION_INCORRECT_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER',
  CUSTOMS_DECLARATION_INCORRECT_EQUIPMENT_TYPE_APPROVAL = 'CUSTOMS_DECLARATION_INCORRECT_EQUIPMENT_TYPE_APPROVAL',
  CUSTOMS_DECLARATION_INCORRECT_E_CHALLAN = 'CUSTOMS_DECLARATION_INCORRECT_E_CHALLAN',
  CUSTOMS_DECLARATION_INCORRECT_IMPORT_FILE = 'CUSTOMS_DECLARATION_INCORRECT_IMPORT_FILE',
  CUSTOMS_DECLARATION_INCORRECT_IMPORT_PERMIT = 'CUSTOMS_DECLARATION_INCORRECT_IMPORT_PERMIT',
  CUSTOMS_DECLARATION_INCORRECT_INSPECTION_REPORT = 'CUSTOMS_DECLARATION_INCORRECT_INSPECTION_REPORT',
  CUSTOMS_DECLARATION_INCORRECT_OTHER_PGA_DOCUMENT = 'CUSTOMS_DECLARATION_INCORRECT_OTHER_PGA_DOCUMENT',
  CUSTOMS_DECLARATION_INCORRECT_PACKING_LIST = 'CUSTOMS_DECLARATION_INCORRECT_PACKING_LIST',
  CUSTOMS_DECLARATION_INCORRECT_PRODUCT_INFORMATION = 'CUSTOMS_DECLARATION_INCORRECT_PRODUCT_INFORMATION',
  CUSTOMS_DECLARATION_INCORRECT_PROFORMA_INVOICE = 'CUSTOMS_DECLARATION_INCORRECT_PROFORMA_INVOICE',
  CUSTOMS_DECLARATION_INCORRECT_TESTING_CERTIFICATE = 'CUSTOMS_DECLARATION_INCORRECT_TESTING_CERTIFICATE',
  CUSTOMS_DECLARATION_MISSING_ARRIVAL_NOTICE = 'CUSTOMS_DECLARATION_MISSING_ARRIVAL_NOTICE',
  CUSTOMS_DECLARATION_MISSING_BILL_OF_LADING = 'CUSTOMS_DECLARATION_MISSING_BILL_OF_LADING',
  CUSTOMS_DECLARATION_MISSING_BIS_PRODUCT_REGISTRATION = 'CUSTOMS_DECLARATION_MISSING_BIS_PRODUCT_REGISTRATION',
  CUSTOMS_DECLARATION_MISSING_COMMERCIAL_INVOICE = 'CUSTOMS_DECLARATION_MISSING_COMMERCIAL_INVOICE',
  CUSTOMS_DECLARATION_MISSING_DOCUMENT = 'CUSTOMS_DECLARATION_MISSING_DOCUMENT',
  CUSTOMS_DECLARATION_MISSING_DSN_LIST = 'CUSTOMS_DECLARATION_MISSING_DSN_LIST',
  CUSTOMS_DECLARATION_MISSING_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER = 'CUSTOMS_DECLARATION_MISSING_DUTY_PAYMENT_UNDER_PROTEST_INTIMATION_LETTER',
  CUSTOMS_DECLARATION_MISSING_EQUIPMENT_TYPE_APPROVAL = 'CUSTOMS_DECLARATION_MISSING_EQUIPMENT_TYPE_APPROVAL',
  CUSTOMS_DECLARATION_MISSING_E_CHALLAN = 'CUSTOMS_DECLARATION_MISSING_E_CHALLAN',
  CUSTOMS_DECLARATION_MISSING_IMPORT_FILE = 'CUSTOMS_DECLARATION_MISSING_IMPORT_FILE',
  CUSTOMS_DECLARATION_MISSING_IMPORT_PERMIT = 'CUSTOMS_DECLARATION_MISSING_IMPORT_PERMIT',
  CUSTOMS_DECLARATION_MISSING_INSPECTION_REPORT = 'CUSTOMS_DECLARATION_MISSING_INSPECTION_REPORT',
  CUSTOMS_DECLARATION_MISSING_OTHER_PGA_DOCUMENT = 'CUSTOMS_DECLARATION_MISSING_OTHER_PGA_DOCUMENT',
  CUSTOMS_DECLARATION_MISSING_PACKING_LIST = 'CUSTOMS_DECLARATION_MISSING_PACKING_LIST',
  CUSTOMS_DECLARATION_MISSING_PRODUCT_INFORMATION = 'CUSTOMS_DECLARATION_MISSING_PRODUCT_INFORMATION',
  CUSTOMS_DECLARATION_MISSING_PRODUCT_LIST = 'CUSTOMS_DECLARATION_MISSING_PRODUCT_LIST',
  CUSTOMS_DECLARATION_MISSING_PROFORMA_INVOICE = 'CUSTOMS_DECLARATION_MISSING_PROFORMA_INVOICE',
  CUSTOMS_DECLARATION_MISSING_TESTING_CERTIFICATE = 'CUSTOMS_DECLARATION_MISSING_TESTING_CERTIFICATE',
  CUSTOMS_DECLARATION_OTHER_PROBLEMS = 'CUSTOMS_DECLARATION_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_ADDITIONAL_INFORMATION_NEEDED = 'EU_CUSTOMS_ENTRY_ADDITIONAL_INFORMATION_NEEDED',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_EORI = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_EORI',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_VAT = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_INCORRECT_VAT',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_MISSING_DATA = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_MISSING_DATA',
  EU_CUSTOMS_ENTRY_BILL_OF_LADING_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_BILL_OF_LADING_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_CLASSIFICATION = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_CLASSIFICATION',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_EORI = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_EORI',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_INCOTERMS = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_INCOTERMS',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VALUE = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VALUE',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VAT = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_INCORRECT_VAT',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_MISSING_DATA = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_MISSING_DATA',
  EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_COMMERCIAL_INVOICES_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_EORI_NUMBER_INACCURATE = 'EU_CUSTOMS_ENTRY_EORI_NUMBER_INACCURATE',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_DETAILS = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_DETAILS',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_FTA_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_DETAILS = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_DETAILS',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_GSP_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_MISSING = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_MISSING',
  EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_IMPORT_CONTROL_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_DATA = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_DATA',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_EORI = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_EORI',
  EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_VAT = 'EU_CUSTOMS_ENTRY_PACKING_LIST_INCORRECT_VAT',
  EU_CUSTOMS_ENTRY_PACKING_LIST_MISSING_DATA = 'EU_CUSTOMS_ENTRY_PACKING_LIST_MISSING_DATA',
  EU_CUSTOMS_ENTRY_PACKING_LIST_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_PACKING_LIST_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT_ENTITY = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_INCORRECT_ENTITY',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_MISSING = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_MISSING',
  EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_OTHER_PROBLEMS = 'EU_CUSTOMS_ENTRY_REGULATORY_DOCUMENTS_OTHER_PROBLEMS',
  EU_CUSTOMS_ENTRY_UNPAID_DUTY = 'EU_CUSTOMS_ENTRY_UNPAID_DUTY',
  EU_CUSTOMS_ENTRY_VAT_NUMBER_INACCURATE = 'EU_CUSTOMS_ENTRY_VAT_NUMBER_INACCURATE',
  IMPORTER_ACTIVATION_MISSING_BUSINESS_LICENSE = 'IMPORTER_ACTIVATION_MISSING_BUSINESS_LICENSE',
  IMPORTER_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY = 'IMPORTER_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY',
  IMPORTER_ACTIVATION_MISSING_IMPORTER_AGENT = 'IMPORTER_ACTIVATION_MISSING_IMPORTER_AGENT',
  IMPORTER_ACTIVATION_MISSING_PRODUCT_LIST = 'IMPORTER_ACTIVATION_MISSING_PRODUCT_LIST',
  IMPORTER_ENTITY_ACTIVATION_MISSING_BUSINESS_REGISTRATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_BUSINESS_REGISTRATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_CONTINUOUS_BOND = 'IMPORTER_ENTITY_ACTIVATION_MISSING_CONTINUOUS_BOND',
  IMPORTER_ENTITY_ACTIVATION_MISSING_CORPORATE_CERTIFICATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_CORPORATE_CERTIFICATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_MISSING_OFFICER_VERIFICATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_OFFICER_VERIFICATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_PMS_APPLICATION = 'IMPORTER_ENTITY_ACTIVATION_MISSING_PMS_APPLICATION',
  IMPORTER_ENTITY_ACTIVATION_MISSING_SOI_SCREENING = 'IMPORTER_ENTITY_ACTIVATION_MISSING_SOI_SCREENING',
  IMPORTER_ENTITY_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_OTHER_DATA_MISSING = 'IMPORTER_ENTITY_ACTIVATION_OTHER_DATA_MISSING',
  IMPORTER_ENTITY_ACTIVATION_REJECT_CORPORATE_CERTIFICATION = 'IMPORTER_ENTITY_ACTIVATION_REJECT_CORPORATE_CERTIFICATION',
  IMPORTER_ENTITY_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY',
  IMPORTER_ENTITY_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY = 'IMPORTER_ENTITY_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY',
  US_CONSUMPTION_ENTRY_AD_CVD_INQUIRY = 'US_CONSUMPTION_ENTRY_AD_CVD_INQUIRY',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_APHIS_CORE_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_APHIS_CORE_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_LACEY_ACT_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_LACEY_ACT_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO',
  US_CONSUMPTION_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO = 'US_CONSUMPTION_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO',
  US_CONSUMPTION_ENTRY_BOL_MISMATCH = 'US_CONSUMPTION_ENTRY_BOL_MISMATCH',
  US_CONSUMPTION_ENTRY_BOND_ISSUE = 'US_CONSUMPTION_ENTRY_BOND_ISSUE',
  US_CONSUMPTION_ENTRY_CANCELLED_FACILITY_REGISTRATION = 'US_CONSUMPTION_ENTRY_CANCELLED_FACILITY_REGISTRATION',
  US_CONSUMPTION_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE = 'US_CONSUMPTION_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE',
  US_CONSUMPTION_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT = 'US_CONSUMPTION_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT',
  US_CONSUMPTION_ENTRY_CBMS_SYSTEM_ISSUE = 'US_CONSUMPTION_ENTRY_CBMS_SYSTEM_ISSUE',
  US_CONSUMPTION_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_CONTINUOUS_BOND_TERMINATED = 'US_CONSUMPTION_ENTRY_CONTINUOUS_BOND_TERMINATED',
  US_CONSUMPTION_ENTRY_CPSC_EXAM = 'US_CONSUMPTION_ENTRY_CPSC_EXAM',
  US_CONSUMPTION_ENTRY_CPSC_HOLD = 'US_CONSUMPTION_ENTRY_CPSC_HOLD',
  US_CONSUMPTION_ENTRY_EPA_EXAM = 'US_CONSUMPTION_ENTRY_EPA_EXAM',
  US_CONSUMPTION_ENTRY_EPA_MISSING_PESTICIDES_INFO = 'US_CONSUMPTION_ENTRY_EPA_MISSING_PESTICIDES_INFO',
  US_CONSUMPTION_ENTRY_EPA_MISSING_TSCA_INFO = 'US_CONSUMPTION_ENTRY_EPA_MISSING_TSCA_INFO',
  US_CONSUMPTION_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO = 'US_CONSUMPTION_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO',
  US_CONSUMPTION_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY = 'US_CONSUMPTION_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY',
  US_CONSUMPTION_ENTRY_ESV_FAILURE = 'US_CONSUMPTION_ENTRY_ESV_FAILURE',
  US_CONSUMPTION_ENTRY_FDA_EXAM = 'US_CONSUMPTION_ENTRY_FDA_EXAM',
  US_CONSUMPTION_ENTRY_FDA_LINE_HOLD = 'US_CONSUMPTION_ENTRY_FDA_LINE_HOLD',
  US_CONSUMPTION_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_BIOLOGICS_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_BIOLOGICS_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_COSMETICS_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_COSMETICS_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_DRUG_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_DRUG_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_FOODS_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_FOODS_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO',
  US_CONSUMPTION_ENTRY_FDA_MISSING_TOBACCO_INFO = 'US_CONSUMPTION_ENTRY_FDA_MISSING_TOBACCO_INFO',
  US_CONSUMPTION_ENTRY_FOREIGN_EXPORTER_UNKNOWN = 'US_CONSUMPTION_ENTRY_FOREIGN_EXPORTER_UNKNOWN',
  US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED = 'US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED',
  US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED = 'US_CONSUMPTION_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED',
  US_CONSUMPTION_ENTRY_FWS_MISSING_FWS_DOCUMENTATION = 'US_CONSUMPTION_ENTRY_FWS_MISSING_FWS_DOCUMENTATION',
  US_CONSUMPTION_ENTRY_INCORRECT_HTS_CODE = 'US_CONSUMPTION_ENTRY_INCORRECT_HTS_CODE',
  US_CONSUMPTION_ENTRY_INVALID_CATEGORY_CODE = 'US_CONSUMPTION_ENTRY_INVALID_CATEGORY_CODE',
  US_CONSUMPTION_ENTRY_INVALID_COUNTRY_OF_PRODUCTION = 'US_CONSUMPTION_ENTRY_INVALID_COUNTRY_OF_PRODUCTION',
  US_CONSUMPTION_ENTRY_INVALID_DII = 'US_CONSUMPTION_ENTRY_INVALID_DII',
  US_CONSUMPTION_ENTRY_INVALID_PNC_NUMBER = 'US_CONSUMPTION_ENTRY_INVALID_PNC_NUMBER',
  US_CONSUMPTION_ENTRY_INVALID_PRODUCT_CODE = 'US_CONSUMPTION_ENTRY_INVALID_PRODUCT_CODE',
  US_CONSUMPTION_ENTRY_INVOICE_IS_NOT_IN_ENGLISH = 'US_CONSUMPTION_ENTRY_INVOICE_IS_NOT_IN_ENGLISH',
  US_CONSUMPTION_ENTRY_IOR_SANCTIONED = 'US_CONSUMPTION_ENTRY_IOR_SANCTIONED',
  US_CONSUMPTION_ENTRY_LINE_HOLD = 'US_CONSUMPTION_ENTRY_LINE_HOLD',
  US_CONSUMPTION_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY = 'US_CONSUMPTION_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY',
  US_CONSUMPTION_ENTRY_MANUAL_HOLD_SEE_MEMO = 'US_CONSUMPTION_ENTRY_MANUAL_HOLD_SEE_MEMO',
  US_CONSUMPTION_ENTRY_MFGR_CODE_UNKNOWN = 'US_CONSUMPTION_ENTRY_MFGR_CODE_UNKNOWN',
  US_CONSUMPTION_ENTRY_MISMATCH_IN_REGISTRATION = 'US_CONSUMPTION_ENTRY_MISMATCH_IN_REGISTRATION',
  US_CONSUMPTION_ENTRY_MISSING_AD_CVD_NON_REIMBURSEMENT_CERTIFICATE = 'US_CONSUMPTION_ENTRY_MISSING_AD_CVD_NON_REIMBURSEMENT_CERTIFICATE',
  US_CONSUMPTION_ENTRY_MISSING_CONTAINER_INFO = 'US_CONSUMPTION_ENTRY_MISSING_CONTAINER_INFO',
  US_CONSUMPTION_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA = 'US_CONSUMPTION_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA',
  US_CONSUMPTION_ENTRY_MISSING_CURRENCY = 'US_CONSUMPTION_ENTRY_MISSING_CURRENCY',
  US_CONSUMPTION_ENTRY_MISSING_EXTENDED_COST = 'US_CONSUMPTION_ENTRY_MISSING_EXTENDED_COST',
  US_CONSUMPTION_ENTRY_MISSING_FIRMS_CODE = 'US_CONSUMPTION_ENTRY_MISSING_FIRMS_CODE',
  US_CONSUMPTION_ENTRY_MISSING_GROSS_WEIGHT = 'US_CONSUMPTION_ENTRY_MISSING_GROSS_WEIGHT',
  US_CONSUMPTION_ENTRY_MISSING_HOUSE_BILL = 'US_CONSUMPTION_ENTRY_MISSING_HOUSE_BILL',
  US_CONSUMPTION_ENTRY_MISSING_HTS_REPORTING_QUANTITY = 'US_CONSUMPTION_ENTRY_MISSING_HTS_REPORTING_QUANTITY',
  US_CONSUMPTION_ENTRY_MISSING_IT_INFO = 'US_CONSUMPTION_ENTRY_MISSING_IT_INFO',
  US_CONSUMPTION_ENTRY_MISSING_LINE_QUANTITY = 'US_CONSUMPTION_ENTRY_MISSING_LINE_QUANTITY',
  US_CONSUMPTION_ENTRY_MISSING_MASTER_BILL = 'US_CONSUMPTION_ENTRY_MISSING_MASTER_BILL',
  US_CONSUMPTION_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO = 'US_CONSUMPTION_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO',
  US_CONSUMPTION_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS = 'US_CONSUMPTION_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS',
  US_CONSUMPTION_ENTRY_MISSING_REQUIRED_NET_WEIGHT = 'US_CONSUMPTION_ENTRY_MISSING_REQUIRED_NET_WEIGHT',
  US_CONSUMPTION_ENTRY_MISSING_UNIT_COST = 'US_CONSUMPTION_ENTRY_MISSING_UNIT_COST',
  US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA = 'US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA',
  US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES = 'US_CONSUMPTION_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES',
  US_CONSUMPTION_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION = 'US_CONSUMPTION_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION',
  US_CONSUMPTION_ENTRY_NEED_INTENDED_USE_OF_PRODUCT = 'US_CONSUMPTION_ENTRY_NEED_INTENDED_USE_OF_PRODUCT',
  US_CONSUMPTION_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM = 'US_CONSUMPTION_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM',
  US_CONSUMPTION_ENTRY_NEED_PRODUCT_DESCRIPTION = 'US_CONSUMPTION_ENTRY_NEED_PRODUCT_DESCRIPTION',
  US_CONSUMPTION_ENTRY_NHTSA_MISSING_HS7 = 'US_CONSUMPTION_ENTRY_NHTSA_MISSING_HS7',
  US_CONSUMPTION_ENTRY_NOT_DEPARTED_ORIGIN = 'US_CONSUMPTION_ENTRY_NOT_DEPARTED_ORIGIN',
  US_CONSUMPTION_ENTRY_NO_BILL_MATCH = 'US_CONSUMPTION_ENTRY_NO_BILL_MATCH',
  US_CONSUMPTION_ENTRY_OTHER_ADD_COMMENT = 'US_CONSUMPTION_ENTRY_OTHER_ADD_COMMENT',
  US_CONSUMPTION_ENTRY_OTHER_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_OTHER_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_OTHER_PGA_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_OTHER_PGA_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_PAYMENT_PENDING_CBP_REVIEW = 'US_CONSUMPTION_ENTRY_PAYMENT_PENDING_CBP_REVIEW',
  US_CONSUMPTION_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW = 'US_CONSUMPTION_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW',
  US_CONSUMPTION_ENTRY_PENDING_BUG_FIX = 'US_CONSUMPTION_ENTRY_PENDING_BUG_FIX',
  US_CONSUMPTION_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER = 'US_CONSUMPTION_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER',
  US_CONSUMPTION_ENTRY_PENDING_DATA_FIX = 'US_CONSUMPTION_ENTRY_PENDING_DATA_FIX',
  US_CONSUMPTION_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG = 'US_CONSUMPTION_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG',
  US_CONSUMPTION_ENTRY_PIECE_COUNT_DISCREPANCY = 'US_CONSUMPTION_ENTRY_PIECE_COUNT_DISCREPANCY',
  US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED = 'US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED',
  US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED = 'US_CONSUMPTION_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED',
  US_CONSUMPTION_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_REGISTRATION_NOT_ON_FILE = 'US_CONSUMPTION_ENTRY_REGISTRATION_NOT_ON_FILE',
  US_CONSUMPTION_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH = 'US_CONSUMPTION_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH',
  US_CONSUMPTION_ENTRY_SUMMARY_DELETED_OR_REPLACED = 'US_CONSUMPTION_ENTRY_SUMMARY_DELETED_OR_REPLACED',
  US_CONSUMPTION_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING = 'US_CONSUMPTION_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING',
  US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED = 'US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED',
  US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING = 'US_CONSUMPTION_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING',
  US_CONSUMPTION_ENTRY_TTB_MISSING_BEER_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_BEER_INFO',
  US_CONSUMPTION_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO',
  US_CONSUMPTION_ENTRY_TTB_MISSING_TOBACCO_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_TOBACCO_INFO',
  US_CONSUMPTION_ENTRY_TTB_MISSING_WINE_INFO = 'US_CONSUMPTION_ENTRY_TTB_MISSING_WINE_INFO',
  US_IN_BOND_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT = 'US_IN_BOND_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT',
  US_IN_BOND_COMMERCIAL_INVOICE_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING = 'US_IN_BOND_COMMERCIAL_INVOICE_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING',
  US_IN_BOND_MANIFESTED_QUANTITY_DISCREPANCY = 'US_IN_BOND_MANIFESTED_QUANTITY_DISCREPANCY',
  US_IN_BOND_MISSING_BONDED_CARRIER_CODE = 'US_IN_BOND_MISSING_BONDED_CARRIER_CODE',
  US_IN_BOND_MISSING_BONDED_CARRIER_TAX_ID = 'US_IN_BOND_MISSING_BONDED_CARRIER_TAX_ID',
  US_IN_BOND_MISSING_CONSIGNEE = 'US_IN_BOND_MISSING_CONSIGNEE',
  US_IN_BOND_MISSING_CONTAINER_INFO = 'US_IN_BOND_MISSING_CONTAINER_INFO',
  US_IN_BOND_MISSING_CURRENCY = 'US_IN_BOND_MISSING_CURRENCY',
  US_IN_BOND_MISSING_FIRMS_CODE = 'US_IN_BOND_MISSING_FIRMS_CODE',
  US_IN_BOND_MISSING_HOUSE_BILL = 'US_IN_BOND_MISSING_HOUSE_BILL',
  US_IN_BOND_MISSING_MASTER_BILL = 'US_IN_BOND_MISSING_MASTER_BILL',
  US_IN_BOND_MISSING_PORT_OF_UNLADING_ENTRY_INFO = 'US_IN_BOND_MISSING_PORT_OF_UNLADING_ENTRY_INFO',
  US_IN_BOND_MISSING_PREVIOUS_IN_BOND_DATE = 'US_IN_BOND_MISSING_PREVIOUS_IN_BOND_DATE',
  US_IN_BOND_MISSING_PREVIOUS_IN_BOND_NUMBER = 'US_IN_BOND_MISSING_PREVIOUS_IN_BOND_NUMBER',
  US_IN_BOND_MISSING_PREVIOUS_IN_BOND_ORIGIN_PORT = 'US_IN_BOND_MISSING_PREVIOUS_IN_BOND_ORIGIN_PORT',
  US_IN_BOND_MISSING_TOTAL_VALUE = 'US_IN_BOND_MISSING_TOTAL_VALUE',
  US_IN_BOND_TRANSPORTATION_INFO_OTHER_DATA_MISSING = 'US_IN_BOND_TRANSPORTATION_INFO_OTHER_DATA_MISSING',
  US_IOR_ACTIVATION_MISSING_BUSINESS_REGISTRATION = 'US_IOR_ACTIVATION_MISSING_BUSINESS_REGISTRATION',
  US_IOR_ACTIVATION_MISSING_CONTINUOUS_BOND = 'US_IOR_ACTIVATION_MISSING_CONTINUOUS_BOND',
  US_IOR_ACTIVATION_MISSING_CORPORATE_CERTIFICATION = 'US_IOR_ACTIVATION_MISSING_CORPORATE_CERTIFICATION',
  US_IOR_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_MISSING_DIRECT_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_MISSING_MASTER_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_MISSING_OFFICER_VERIFICATION = 'US_IOR_ACTIVATION_MISSING_OFFICER_VERIFICATION',
  US_IOR_ACTIVATION_MISSING_PMS_APPLICATION = 'US_IOR_ACTIVATION_MISSING_PMS_APPLICATION',
  US_IOR_ACTIVATION_MISSING_SOI_SCREENING = 'US_IOR_ACTIVATION_MISSING_SOI_SCREENING',
  US_IOR_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_MISSING_SUB_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_OTHER_DATA_MISSING = 'US_IOR_ACTIVATION_OTHER_DATA_MISSING',
  US_IOR_ACTIVATION_REJECT_CORPORATE_CERTIFICATION = 'US_IOR_ACTIVATION_REJECT_CORPORATE_CERTIFICATION',
  US_IOR_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_REJECT_DIRECT_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_REJECT_MASTER_POWER_OF_ATTORNEY',
  US_IOR_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY = 'US_IOR_ACTIVATION_REJECT_SUB_POWER_OF_ATTORNEY',
  US_ISF_INFORMATION_NOT_IN_ENGLISH = 'US_ISF_INFORMATION_NOT_IN_ENGLISH',
  US_ISF_INVALID_BOND = 'US_ISF_INVALID_BOND',
  US_ISF_INVALID_HTS_CODE = 'US_ISF_INVALID_HTS_CODE',
  US_ISF_IOR_MISMATCH = 'US_ISF_IOR_MISMATCH',
  US_ISF_MISSING_ASI_FORM = 'US_ISF_MISSING_ASI_FORM',
  US_ISF_MISSING_ASI_INFO = 'US_ISF_MISSING_ASI_INFO',
  US_ISF_MISSING_COUNTRY_OF_ORIGION = 'US_ISF_MISSING_COUNTRY_OF_ORIGION',
  US_ISF_MISSING_HTS_CODE = 'US_ISF_MISSING_HTS_CODE',
  US_ISF_MISSING_ISF_FORM = 'US_ISF_MISSING_ISF_FORM',
  US_ISF_MISSING_ISF_INFO = 'US_ISF_MISSING_ISF_INFO',
  US_ISF_MISSING_MBL_OR_HBL = 'US_ISF_MISSING_MBL_OR_HBL',
  US_ISF_MISSING_SELLER_OR_MANUFACTURER_INFO = 'US_ISF_MISSING_SELLER_OR_MANUFACTURER_INFO',
  US_ISF_OTHER_DATA_MISSING = 'US_ISF_OTHER_DATA_MISSING',
  US_ISF_TECH_ISSUES = 'US_ISF_TECH_ISSUES',
  US_TYPE86_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_ANIMAL_PRODUCTS_AND_BYPRODUCTS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_APHIS_CORE_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_APHIS_CORE_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_CUT_FLOWERS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_FRUITS_AND_VEGETABLES_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_GENETICALLY_ENGINEERED_ORGANISMS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_LACEY_ACT_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_LACEY_ACT_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_LIVE_ANIMALS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_MISCELLANEOUS_AND_PROCESSED_PRODUCTS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_PROPAGATIVE_MATERIAL_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_RELATED_ANIMAL_PRODUCTS_INFO',
  US_TYPE86_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO = 'US_TYPE86_ENTRY_APHIS_MISSING_SEEDS_NOT_FOR_PLANTING_INFO',
  US_TYPE86_ENTRY_BOL_MISMATCH = 'US_TYPE86_ENTRY_BOL_MISMATCH',
  US_TYPE86_ENTRY_BOND_ISSUE = 'US_TYPE86_ENTRY_BOND_ISSUE',
  US_TYPE86_ENTRY_CANCELLED_FACILITY_REGISTRATION = 'US_TYPE86_ENTRY_CANCELLED_FACILITY_REGISTRATION',
  US_TYPE86_ENTRY_CARGO_RELEASE_DELETED_OR_REPLACED = 'US_TYPE86_ENTRY_CARGO_RELEASE_DELETED_OR_REPLACED',
  US_TYPE86_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE = 'US_TYPE86_ENTRY_CARRIER_NOT_A_KNOWN_IATA_CODE',
  US_TYPE86_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT = 'US_TYPE86_ENTRY_CARTON_COUNT_DOES_NOT_MATCH_PIECE_COUNT',
  US_TYPE86_ENTRY_CBMS_SYSTEM_ISSUE = 'US_TYPE86_ENTRY_CBMS_SYSTEM_ISSUE',
  US_TYPE86_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_COMMERCIAL_INVOICES_AND_PACKING_LIST_DATA_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_CONTINUOUS_BOND_TERMINATED = 'US_TYPE86_ENTRY_CONTINUOUS_BOND_TERMINATED',
  US_TYPE86_ENTRY_CPSC_EXAM = 'US_TYPE86_ENTRY_CPSC_EXAM',
  US_TYPE86_ENTRY_CPSC_HOLD = 'US_TYPE86_ENTRY_CPSC_HOLD',
  US_TYPE86_ENTRY_EPA_EXAM = 'US_TYPE86_ENTRY_EPA_EXAM',
  US_TYPE86_ENTRY_EPA_MISSING_PESTICIDES_INFO = 'US_TYPE86_ENTRY_EPA_MISSING_PESTICIDES_INFO',
  US_TYPE86_ENTRY_EPA_MISSING_TSCA_INFO = 'US_TYPE86_ENTRY_EPA_MISSING_TSCA_INFO',
  US_TYPE86_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO = 'US_TYPE86_ENTRY_EPA_MISSING_VEHICLES_AND_ENGINES_INFO',
  US_TYPE86_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY = 'US_TYPE86_ENTRY_EST_ENTRY_DUTY_GREATER_THAN_STMT_DUTY',
  US_TYPE86_ENTRY_ESV_FAILURE = 'US_TYPE86_ENTRY_ESV_FAILURE',
  US_TYPE86_ENTRY_FDA_EXAM = 'US_TYPE86_ENTRY_FDA_EXAM',
  US_TYPE86_ENTRY_FDA_LINE_HOLD = 'US_TYPE86_ENTRY_FDA_LINE_HOLD',
  US_TYPE86_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_ANIMAL_DRUGS_AND_DEVICES_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_BIOLOGICS_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_BIOLOGICS_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_COSMETICS_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_COSMETICS_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_DRUG_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_DRUG_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_FOODS_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_FOODS_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_MEDICAL_DEVICE_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_RADIATION_EMITTING_DEVICE_INFO',
  US_TYPE86_ENTRY_FDA_MISSING_TOBACCO_INFO = 'US_TYPE86_ENTRY_FDA_MISSING_TOBACCO_INFO',
  US_TYPE86_ENTRY_FOREIGN_EXPORTER_UNKNOWN = 'US_TYPE86_ENTRY_FOREIGN_EXPORTER_UNKNOWN',
  US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED = 'US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_MANUFACTURER_NOT_LISTED',
  US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED = 'US_TYPE86_ENTRY_FULL_NAME_AND_ADDRESS_OF_SELLING_PARTY_NOT_LISTED',
  US_TYPE86_ENTRY_FWS_MISSING_FWS_DOCUMENTATION = 'US_TYPE86_ENTRY_FWS_MISSING_FWS_DOCUMENTATION',
  US_TYPE86_ENTRY_INCORRECT_HTS_CODE = 'US_TYPE86_ENTRY_INCORRECT_HTS_CODE',
  US_TYPE86_ENTRY_INVALID_CATEGORY_CODE = 'US_TYPE86_ENTRY_INVALID_CATEGORY_CODE',
  US_TYPE86_ENTRY_INVALID_COUNTRY_OF_PRODUCTION = 'US_TYPE86_ENTRY_INVALID_COUNTRY_OF_PRODUCTION',
  US_TYPE86_ENTRY_INVALID_DII = 'US_TYPE86_ENTRY_INVALID_DII',
  US_TYPE86_ENTRY_INVALID_PNC_NUMBER = 'US_TYPE86_ENTRY_INVALID_PNC_NUMBER',
  US_TYPE86_ENTRY_INVALID_PRODUCT_CODE = 'US_TYPE86_ENTRY_INVALID_PRODUCT_CODE',
  US_TYPE86_ENTRY_INVOICE_IS_NOT_IN_ENGLISH = 'US_TYPE86_ENTRY_INVOICE_IS_NOT_IN_ENGLISH',
  US_TYPE86_ENTRY_IOR_SANCTIONED = 'US_TYPE86_ENTRY_IOR_SANCTIONED',
  US_TYPE86_ENTRY_LINE_HOLD = 'US_TYPE86_ENTRY_LINE_HOLD',
  US_TYPE86_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY = 'US_TYPE86_ENTRY_MANIFESTED_QUANTITY_DISCREPANCY',
  US_TYPE86_ENTRY_MANUAL_HOLD_SEE_MEMO = 'US_TYPE86_ENTRY_MANUAL_HOLD_SEE_MEMO',
  US_TYPE86_ENTRY_MFGR_CODE_UNKNOWN = 'US_TYPE86_ENTRY_MFGR_CODE_UNKNOWN',
  US_TYPE86_ENTRY_MISMATCH_IN_REGISTRATION = 'US_TYPE86_ENTRY_MISMATCH_IN_REGISTRATION',
  US_TYPE86_ENTRY_MISSING_CONTAINER_INFO = 'US_TYPE86_ENTRY_MISSING_CONTAINER_INFO',
  US_TYPE86_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA = 'US_TYPE86_ENTRY_MISSING_COUNTRY_OF_ORIGIN_DATA',
  US_TYPE86_ENTRY_MISSING_CURRENCY = 'US_TYPE86_ENTRY_MISSING_CURRENCY',
  US_TYPE86_ENTRY_MISSING_EXTENDED_COST = 'US_TYPE86_ENTRY_MISSING_EXTENDED_COST',
  US_TYPE86_ENTRY_MISSING_FIRMS_CODE = 'US_TYPE86_ENTRY_MISSING_FIRMS_CODE',
  US_TYPE86_ENTRY_MISSING_GROSS_WEIGHT = 'US_TYPE86_ENTRY_MISSING_GROSS_WEIGHT',
  US_TYPE86_ENTRY_MISSING_HOUSE_BILL = 'US_TYPE86_ENTRY_MISSING_HOUSE_BILL',
  US_TYPE86_ENTRY_MISSING_HTS_REPORTING_QUANTITY = 'US_TYPE86_ENTRY_MISSING_HTS_REPORTING_QUANTITY',
  US_TYPE86_ENTRY_MISSING_IT_INFO = 'US_TYPE86_ENTRY_MISSING_IT_INFO',
  US_TYPE86_ENTRY_MISSING_LINE_QUANTITY = 'US_TYPE86_ENTRY_MISSING_LINE_QUANTITY',
  US_TYPE86_ENTRY_MISSING_MASTER_BILL = 'US_TYPE86_ENTRY_MISSING_MASTER_BILL',
  US_TYPE86_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO = 'US_TYPE86_ENTRY_MISSING_PORT_OF_UNLADING_ENTRY_INFO',
  US_TYPE86_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS = 'US_TYPE86_ENTRY_MISSING_PRODUCT_CLASSIFICATIONS',
  US_TYPE86_ENTRY_MISSING_REQUIRED_NET_WEIGHT = 'US_TYPE86_ENTRY_MISSING_REQUIRED_NET_WEIGHT',
  US_TYPE86_ENTRY_MISSING_UNIT_COST = 'US_TYPE86_ENTRY_MISSING_UNIT_COST',
  US_TYPE86_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA = 'US_TYPE86_ENTRY_MSNG_OR_INVLD_CONST_ELEMENT_QTY_PER_PGA',
  US_TYPE86_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES = 'US_TYPE86_ENTRY_MSNG_OR_INVLD_SCIENT_SPECIES',
  US_TYPE86_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION = 'US_TYPE86_ENTRY_MULTIPLE_DETAILS_REQUIRED_FOR_CLASSIFICATION',
  US_TYPE86_ENTRY_NEED_INTENDED_USE_OF_PRODUCT = 'US_TYPE86_ENTRY_NEED_INTENDED_USE_OF_PRODUCT',
  US_TYPE86_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM = 'US_TYPE86_ENTRY_NEED_MATERIAL_COMPOSITION_OF_ITEM',
  US_TYPE86_ENTRY_NEED_PRODUCT_DESCRIPTION = 'US_TYPE86_ENTRY_NEED_PRODUCT_DESCRIPTION',
  US_TYPE86_ENTRY_NHTSA_MISSING_HS7 = 'US_TYPE86_ENTRY_NHTSA_MISSING_HS7',
  US_TYPE86_ENTRY_NOT_DEPARTED_ORIGIN = 'US_TYPE86_ENTRY_NOT_DEPARTED_ORIGIN',
  US_TYPE86_ENTRY_NO_BILL_MATCH = 'US_TYPE86_ENTRY_NO_BILL_MATCH',
  US_TYPE86_ENTRY_OTHER_ADD_COMMENT = 'US_TYPE86_ENTRY_OTHER_ADD_COMMENT',
  US_TYPE86_ENTRY_OTHER_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_OTHER_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_OTHER_PGA_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_OTHER_PGA_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_PAYMENT_PENDING_CBP_REVIEW = 'US_TYPE86_ENTRY_PAYMENT_PENDING_CBP_REVIEW',
  US_TYPE86_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW = 'US_TYPE86_ENTRY_PAYMENT_PENDING_FINANCE_REVIEW',
  US_TYPE86_ENTRY_PENDING_BUG_FIX = 'US_TYPE86_ENTRY_PENDING_BUG_FIX',
  US_TYPE86_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER = 'US_TYPE86_ENTRY_PENDING_CONSIGNEE_EIN_NUMBER',
  US_TYPE86_ENTRY_PENDING_DATA_FIX = 'US_TYPE86_ENTRY_PENDING_DATA_FIX',
  US_TYPE86_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG = 'US_TYPE86_ENTRY_PGA_DATA_MISSING_PER_PGA_FLAG',
  US_TYPE86_ENTRY_PIECE_COUNT_DISCREPANCY = 'US_TYPE86_ENTRY_PIECE_COUNT_DISCREPANCY',
  US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED = 'US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_DELAYED',
  US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED = 'US_TYPE86_ENTRY_PRE_ALERT_DOCUMENTS_NOT_RECEIVED',
  US_TYPE86_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_PRODUCT_DATA_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_REGISTRATION_NOT_ON_FILE = 'US_TYPE86_ENTRY_REGISTRATION_NOT_ON_FILE',
  US_TYPE86_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH = 'US_TYPE86_ENTRY_REPORTED_SURETY_OR_BOND_SURETY_MISMATCH',
  US_TYPE86_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING = 'US_TYPE86_ENTRY_TRANSPORTATION_INFO_OTHER_DATA_MISSING',
  US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED = 'US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_NOT_ALLOWED',
  US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING = 'US_TYPE86_ENTRY_TRFF_ADJUSTMENT_HTS_OR_EXCLSN_MISSING',
  US_TYPE86_ENTRY_TTB_MISSING_BEER_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_BEER_INFO',
  US_TYPE86_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_DISTILLED_SPIRITS_INFO',
  US_TYPE86_ENTRY_TTB_MISSING_TOBACCO_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_TOBACCO_INFO',
  US_TYPE86_ENTRY_TTB_MISSING_WINE_INFO = 'US_TYPE86_ENTRY_TTB_MISSING_WINE_INFO'
}

/** A significant Work Order event. */
export type WorkOrderMilestone = Milestone & Record & {
  __typename?: 'WorkOrderMilestone';
  /** If it is true, we allow duplicate milestones. If not, we should not allow duplicate milestones creation */
  allowDuplicate: Scalars['Boolean'];
  /** An event code representing the milestone. */
  codes: Array<MilestoneEventCode>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The location where the milestone occured. */
  location?: Maybe<MilestoneLocation>;
  /** The name of the milestone */
  name: WorkOrderMilestoneName;
  /** The real time the milestone occured, possibly before its creation in the system. Defaults to the time of creation. */
  occurenceTime: Scalars['PreciseDateTime'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** A number used to refer to a shipment, customs declartion, or other work order. */
  referenceNumbers: Array<ReferenceNumber>;
  /** The source which triggered the milestone, can be CBP, any Partner Government Agency, or system generated. */
  source?: Maybe<Scalars['WorkOrderMilestoneSource']>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The Work Order this milestone belongs to. */
  workOrder: WorkOrder;
};

export type WorkOrderMilestoneEdge = ConnectionEdge & {
  __typename?: 'WorkOrderMilestoneEdge';
  cursor: Scalars['ID'];
  node: WorkOrderMilestone;
};

/** The name of the milestone */
export enum WorkOrderMilestoneName {
  AMS_QUERY_SUCCESS = 'AMS_QUERY_SUCCESS',
  ASN_DATA_RECEIVED = 'ASN_DATA_RECEIVED',
  BIXD_WORK_ORDER_CLASSIFIED = 'BIXD_WORK_ORDER_CLASSIFIED',
  BIXD_WORK_ORDER_DECLASSIFIED = 'BIXD_WORK_ORDER_DECLASSIFIED',
  CBAM_WORK_ORDER_CLASSIFIED = 'CBAM_WORK_ORDER_CLASSIFIED',
  CBAM_WORK_ORDER_DECLASSIFIED = 'CBAM_WORK_ORDER_DECLASSIFIED',
  COMMERCIAL_INVOICE_DATA_RECEIVED = 'COMMERCIAL_INVOICE_DATA_RECEIVED',
  CUSTOMS_DECLARATION_APPROVED_DOCUMENTS_UPLOADED = 'CUSTOMS_DECLARATION_APPROVED_DOCUMENTS_UPLOADED',
  CUSTOMS_DECLARATION_BROKER_ERROR_EXCEPTION_TASK_COMPLETED = 'CUSTOMS_DECLARATION_BROKER_ERROR_EXCEPTION_TASK_COMPLETED',
  CUSTOMS_DECLARATION_BROKER_ERROR_EXCEPTION_TASK_CREATED = 'CUSTOMS_DECLARATION_BROKER_ERROR_EXCEPTION_TASK_CREATED',
  CUSTOMS_DECLARATION_BROKER_HOLD_CLASSIFICATION = 'CUSTOMS_DECLARATION_BROKER_HOLD_CLASSIFICATION',
  CUSTOMS_DECLARATION_BROKER_HOLD_COMMERCIAL_DOC_ISSUE = 'CUSTOMS_DECLARATION_BROKER_HOLD_COMMERCIAL_DOC_ISSUE',
  CUSTOMS_DECLARATION_BROKER_HOLD_FREIGHT_CHARGES_ISSUE = 'CUSTOMS_DECLARATION_BROKER_HOLD_FREIGHT_CHARGES_ISSUE',
  CUSTOMS_DECLARATION_BROKER_HOLD_OTHER = 'CUSTOMS_DECLARATION_BROKER_HOLD_OTHER',
  CUSTOMS_DECLARATION_BROKER_HOLD_SELLER_DETAILS = 'CUSTOMS_DECLARATION_BROKER_HOLD_SELLER_DETAILS',
  CUSTOMS_DECLARATION_BROKER_HOLD_VALUATION = 'CUSTOMS_DECLARATION_BROKER_HOLD_VALUATION',
  CUSTOMS_DECLARATION_BROKER_OVERRIDDEN = 'CUSTOMS_DECLARATION_BROKER_OVERRIDDEN',
  CUSTOMS_DECLARATION_CANCELED = 'CUSTOMS_DECLARATION_CANCELED',
  CUSTOMS_DECLARATION_CHARGE_APPROVAL = 'CUSTOMS_DECLARATION_CHARGE_APPROVAL',
  CUSTOMS_DECLARATION_CHARGE_REJECTION = 'CUSTOMS_DECLARATION_CHARGE_REJECTION',
  CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_DOCUMENT_INSPECTION = 'CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_DOCUMENT_INSPECTION',
  CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_CLASSIFICATION = 'CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_CLASSIFICATION',
  CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_GENERAL = 'CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_GENERAL',
  CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_SELLER_DETAILS = 'CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_SELLER_DETAILS',
  CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_VALUATION = 'CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_HOLD_VALUATION',
  CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_PHYSICAL_INSPECTION = 'CUSTOMS_DECLARATION_CUSTOMS_AUTHORITY_PHYSICAL_INSPECTION',
  CUSTOMS_DECLARATION_CUSTOMS_HOLD_CHANGE_ISSUE = 'CUSTOMS_DECLARATION_CUSTOMS_HOLD_CHANGE_ISSUE',
  CUSTOMS_DECLARATION_CUSTOMS_INSPECTION = 'CUSTOMS_DECLARATION_CUSTOMS_INSPECTION',
  CUSTOMS_DECLARATION_CUSTOMS_REQUESTED_AMENDMENTS_TASK_COMPLETED = 'CUSTOMS_DECLARATION_CUSTOMS_REQUESTED_AMENDMENTS_TASK_COMPLETED',
  CUSTOMS_DECLARATION_CUSTOMS_REQUESTED_AMENDMENTS_TASK_CREATED = 'CUSTOMS_DECLARATION_CUSTOMS_REQUESTED_AMENDMENTS_TASK_CREATED',
  CUSTOMS_DECLARATION_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_COMPLETED = 'CUSTOMS_DECLARATION_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_COMPLETED',
  CUSTOMS_DECLARATION_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_CREATED = 'CUSTOMS_DECLARATION_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_CREATED',
  CUSTOMS_DECLARATION_DELAY_EARLY_CONTAINER_ARRIVAL = 'CUSTOMS_DECLARATION_DELAY_EARLY_CONTAINER_ARRIVAL',
  CUSTOMS_DECLARATION_DELAY_LATE_PRE_ALERT = 'CUSTOMS_DECLARATION_DELAY_LATE_PRE_ALERT',
  CUSTOMS_DECLARATION_DELAY_LCL_CONSOLIDATION = 'CUSTOMS_DECLARATION_DELAY_LCL_CONSOLIDATION',
  CUSTOMS_DECLARATION_DELAY_OTHER = 'CUSTOMS_DECLARATION_DELAY_OTHER',
  CUSTOMS_DECLARATION_DOCUMENTS_REVIEWED = 'CUSTOMS_DECLARATION_DOCUMENTS_REVIEWED',
  CUSTOMS_DECLARATION_DOCUMENT_UPLOADED = 'CUSTOMS_DECLARATION_DOCUMENT_UPLOADED',
  CUSTOMS_DECLARATION_DUTY_CONFIRMATION_REQUESTED = 'CUSTOMS_DECLARATION_DUTY_CONFIRMATION_REQUESTED',
  CUSTOMS_DECLARATION_DUTY_CONFIRMED = 'CUSTOMS_DECLARATION_DUTY_CONFIRMED',
  CUSTOMS_DECLARATION_DUTY_DISPUTED = 'CUSTOMS_DECLARATION_DUTY_DISPUTED',
  CUSTOMS_DECLARATION_DUTY_PAYMENT_REQUIRED = 'CUSTOMS_DECLARATION_DUTY_PAYMENT_REQUIRED',
  CUSTOMS_DECLARATION_EXAM_GATE_IN = 'CUSTOMS_DECLARATION_EXAM_GATE_IN',
  CUSTOMS_DECLARATION_EXAM_GATE_OUT = 'CUSTOMS_DECLARATION_EXAM_GATE_OUT',
  CUSTOMS_DECLARATION_FILED = 'CUSTOMS_DECLARATION_FILED',
  CUSTOMS_DECLARATION_FREIGHT_COSTS_MISSING = 'CUSTOMS_DECLARATION_FREIGHT_COSTS_MISSING',
  CUSTOMS_DECLARATION_GENERAL_HOLD = 'CUSTOMS_DECLARATION_GENERAL_HOLD',
  CUSTOMS_DECLARATION_GOODS_DESTROYED = 'CUSTOMS_DECLARATION_GOODS_DESTROYED',
  CUSTOMS_DECLARATION_GOODS_RETURNED = 'CUSTOMS_DECLARATION_GOODS_RETURNED',
  CUSTOMS_DECLARATION_GOODS_SEIZED = 'CUSTOMS_DECLARATION_GOODS_SEIZED',
  CUSTOMS_DECLARATION_HOLD_LOG_ISSUE = 'CUSTOMS_DECLARATION_HOLD_LOG_ISSUE',
  CUSTOMS_DECLARATION_HOLD_PIN_ISSUE = 'CUSTOMS_DECLARATION_HOLD_PIN_ISSUE',
  CUSTOMS_DECLARATION_HOLD_RELABELLING = 'CUSTOMS_DECLARATION_HOLD_RELABELLING',
  CUSTOMS_DECLARATION_NEW_BROKER_ASSIGNED = 'CUSTOMS_DECLARATION_NEW_BROKER_ASSIGNED',
  CUSTOMS_DECLARATION_NON_CUSTOMS_AUTHORITY_HOLD = 'CUSTOMS_DECLARATION_NON_CUSTOMS_AUTHORITY_HOLD',
  CUSTOMS_DECLARATION_PAYMENT_AUTHORIZED = 'CUSTOMS_DECLARATION_PAYMENT_AUTHORIZED',
  CUSTOMS_DECLARATION_PAYMENT_REQUEST = 'CUSTOMS_DECLARATION_PAYMENT_REQUEST',
  CUSTOMS_DECLARATION_READY_FOR_PICKUP = 'CUSTOMS_DECLARATION_READY_FOR_PICKUP',
  CUSTOMS_DECLARATION_RELEASE = 'CUSTOMS_DECLARATION_RELEASE',
  CUSTOMS_DECLARATION_RRO_RELEASE = 'CUSTOMS_DECLARATION_RRO_RELEASE',
  CUSTOMS_DECLARATION_SELLER_REQUESTED_AMENDMENTS_TASK_COMPLETED = 'CUSTOMS_DECLARATION_SELLER_REQUESTED_AMENDMENTS_TASK_COMPLETED',
  CUSTOMS_DECLARATION_SELLER_REQUESTED_AMENDMENTS_TASK_CREATED = 'CUSTOMS_DECLARATION_SELLER_REQUESTED_AMENDMENTS_TASK_CREATED',
  CUSTOMS_DECLARATION_STARTED = 'CUSTOMS_DECLARATION_STARTED',
  CUSTOMS_DECLARATION_SUBMITTED = 'CUSTOMS_DECLARATION_SUBMITTED',
  CUSTOMS_DECLARATION_UNCANCELED = 'CUSTOMS_DECLARATION_UNCANCELED',
  CUSTOMS_ENTRY_AT_CFS_ON_HOLD = 'CUSTOMS_ENTRY_AT_CFS_ON_HOLD',
  CUSTOMS_ENTRY_AT_CFS_PENDING_EXAM_TRANSFER = 'CUSTOMS_ENTRY_AT_CFS_PENDING_EXAM_TRANSFER',
  CUSTOMS_ENTRY_AT_FUMIGATION_SITE = 'CUSTOMS_ENTRY_AT_FUMIGATION_SITE',
  CUSTOMS_ENTRY_BROKER_ERROR_EXCEPTION_TASK_COMPLETED = 'CUSTOMS_ENTRY_BROKER_ERROR_EXCEPTION_TASK_COMPLETED',
  CUSTOMS_ENTRY_BROKER_ERROR_EXCEPTION_TASK_CREATED = 'CUSTOMS_ENTRY_BROKER_ERROR_EXCEPTION_TASK_CREATED',
  CUSTOMS_ENTRY_BROKER_HOLD_CLASSIFICATION = 'CUSTOMS_ENTRY_BROKER_HOLD_CLASSIFICATION',
  CUSTOMS_ENTRY_BROKER_HOLD_COMMERCIAL_DOC_ISSUE = 'CUSTOMS_ENTRY_BROKER_HOLD_COMMERCIAL_DOC_ISSUE',
  CUSTOMS_ENTRY_BROKER_HOLD_FREIGHT_CHARGES_ISSUE = 'CUSTOMS_ENTRY_BROKER_HOLD_FREIGHT_CHARGES_ISSUE',
  CUSTOMS_ENTRY_BROKER_HOLD_OTHER = 'CUSTOMS_ENTRY_BROKER_HOLD_OTHER',
  CUSTOMS_ENTRY_BROKER_HOLD_SELLER_DETAILS = 'CUSTOMS_ENTRY_BROKER_HOLD_SELLER_DETAILS',
  CUSTOMS_ENTRY_BROKER_HOLD_VALUATION = 'CUSTOMS_ENTRY_BROKER_HOLD_VALUATION',
  CUSTOMS_ENTRY_BROKER_OVERRIDDEN = 'CUSTOMS_ENTRY_BROKER_OVERRIDDEN',
  CUSTOMS_ENTRY_CBP_HOLD_AT_CES = 'CUSTOMS_ENTRY_CBP_HOLD_AT_CES',
  CUSTOMS_ENTRY_CES_DEVANNING = 'CUSTOMS_ENTRY_CES_DEVANNING',
  CUSTOMS_ENTRY_CLEARED_FOR_PICKUP = 'CUSTOMS_ENTRY_CLEARED_FOR_PICKUP',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_DOCUMENT_INSPECTION = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_DOCUMENT_INSPECTION',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_CLASSIFICATION = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_CLASSIFICATION',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_GENERAL = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_GENERAL',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_SELLER_DETAILS = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_SELLER_DETAILS',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_VALUATION = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_HOLD_VALUATION',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_PHYSICAL_INSPECTION = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_PHYSICAL_INSPECTION',
  CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_TS_HOLD = 'CUSTOMS_ENTRY_CUSTOMS_AUTHORITY_TS_HOLD',
  CUSTOMS_ENTRY_CUSTOMS_HOLD_CHANGE_ISSUE = 'CUSTOMS_ENTRY_CUSTOMS_HOLD_CHANGE_ISSUE',
  CUSTOMS_ENTRY_CUSTOMS_REQUESTED_AMENDMENTS_TASK_COMPLETED = 'CUSTOMS_ENTRY_CUSTOMS_REQUESTED_AMENDMENTS_TASK_COMPLETED',
  CUSTOMS_ENTRY_CUSTOMS_REQUESTED_AMENDMENTS_TASK_CREATED = 'CUSTOMS_ENTRY_CUSTOMS_REQUESTED_AMENDMENTS_TASK_CREATED',
  CUSTOMS_ENTRY_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_COMPLETED = 'CUSTOMS_ENTRY_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_COMPLETED',
  CUSTOMS_ENTRY_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_CREATED = 'CUSTOMS_ENTRY_CUSTOMS_SYSTEM_ERROR_EXCEPTION_TASK_CREATED',
  CUSTOMS_ENTRY_DELAY_EARLY_CONTAINER_ARRIVAL = 'CUSTOMS_ENTRY_DELAY_EARLY_CONTAINER_ARRIVAL',
  CUSTOMS_ENTRY_DELAY_LATE_PRE_ALERT = 'CUSTOMS_ENTRY_DELAY_LATE_PRE_ALERT',
  CUSTOMS_ENTRY_DELAY_LCL_CONSOLIDATION = 'CUSTOMS_ENTRY_DELAY_LCL_CONSOLIDATION',
  CUSTOMS_ENTRY_DELAY_OTHER = 'CUSTOMS_ENTRY_DELAY_OTHER',
  CUSTOMS_ENTRY_DELETED = 'CUSTOMS_ENTRY_DELETED',
  CUSTOMS_ENTRY_DOCUMENTS_REVIEWED = 'CUSTOMS_ENTRY_DOCUMENTS_REVIEWED',
  CUSTOMS_ENTRY_DUTY_CONFIRMATION_REQUESTED = 'CUSTOMS_ENTRY_DUTY_CONFIRMATION_REQUESTED',
  CUSTOMS_ENTRY_DUTY_CONFIRMED = 'CUSTOMS_ENTRY_DUTY_CONFIRMED',
  CUSTOMS_ENTRY_DUTY_DISPUTED = 'CUSTOMS_ENTRY_DUTY_DISPUTED',
  CUSTOMS_ENTRY_FILED = 'CUSTOMS_ENTRY_FILED',
  CUSTOMS_ENTRY_GOODS_DESTROYED = 'CUSTOMS_ENTRY_GOODS_DESTROYED',
  CUSTOMS_ENTRY_GOODS_RETURNED = 'CUSTOMS_ENTRY_GOODS_RETURNED',
  CUSTOMS_ENTRY_GOODS_SEIZED = 'CUSTOMS_ENTRY_GOODS_SEIZED',
  CUSTOMS_ENTRY_HOLD_LOG_ISSUE = 'CUSTOMS_ENTRY_HOLD_LOG_ISSUE',
  CUSTOMS_ENTRY_HOLD_PIN_ISSUE = 'CUSTOMS_ENTRY_HOLD_PIN_ISSUE',
  CUSTOMS_ENTRY_HOLD_RELABELLING = 'CUSTOMS_ENTRY_HOLD_RELABELLING',
  CUSTOMS_ENTRY_NEW_BROKER_ASSIGNED = 'CUSTOMS_ENTRY_NEW_BROKER_ASSIGNED',
  CUSTOMS_ENTRY_NON_CUSTOMS_AUTHORITY_HOLD = 'CUSTOMS_ENTRY_NON_CUSTOMS_AUTHORITY_HOLD',
  CUSTOMS_ENTRY_ONE_USG = 'CUSTOMS_ENTRY_ONE_USG',
  CUSTOMS_ENTRY_ON_VESSEL = 'CUSTOMS_ENTRY_ON_VESSEL',
  CUSTOMS_ENTRY_PAYMENT_AUTHORIZED = 'CUSTOMS_ENTRY_PAYMENT_AUTHORIZED',
  CUSTOMS_ENTRY_PAYMENT_BLOCKED = 'CUSTOMS_ENTRY_PAYMENT_BLOCKED',
  CUSTOMS_ENTRY_PAYMENT_REQUEST = 'CUSTOMS_ENTRY_PAYMENT_REQUEST',
  CUSTOMS_ENTRY_PENDING_PICKUP_AT_TERMINAL = 'CUSTOMS_ENTRY_PENDING_PICKUP_AT_TERMINAL',
  CUSTOMS_ENTRY_RELEASE = 'CUSTOMS_ENTRY_RELEASE',
  CUSTOMS_ENTRY_RRO_RELEASE = 'CUSTOMS_ENTRY_RRO_RELEASE',
  CUSTOMS_ENTRY_SELLER_REQUESTED_AMENDMENTS_TASK_COMPLETED = 'CUSTOMS_ENTRY_SELLER_REQUESTED_AMENDMENTS_TASK_COMPLETED',
  CUSTOMS_ENTRY_SELLER_REQUESTED_AMENDMENTS_TASK_CREATED = 'CUSTOMS_ENTRY_SELLER_REQUESTED_AMENDMENTS_TASK_CREATED',
  CUSTOMS_ENTRY_SHIPMENT_REFERENCE_ADDED = 'CUSTOMS_ENTRY_SHIPMENT_REFERENCE_ADDED',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_COMPLETED = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_COMPLETED',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_DESTRUCTION = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_DESTRUCTION',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_DESTRUCTION_COMPLETED = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_DESTRUCTION_COMPLETED',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_DETAINED = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_DETAINED',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_EXPORT = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_EXPORT',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_EXPORT_COMPLETED = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_EXPORT_COMPLETED',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_PARTIAL_RELEASE = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_PARTIAL_RELEASE',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_RECONDITIONING = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_RECONDITIONING',
  CUSTOMS_ENTRY_SPECIAL_EXCEPTION_RECONDITIONING_COMPLETED = 'CUSTOMS_ENTRY_SPECIAL_EXCEPTION_RECONDITIONING_COMPLETED',
  CUSTOMS_ENTRY_SPLIT_INVOICE_ADDED = 'CUSTOMS_ENTRY_SPLIT_INVOICE_ADDED',
  CUSTOMS_ENTRY_STARTED = 'CUSTOMS_ENTRY_STARTED',
  CUSTOMS_ENTRY_TERMINAL_OUT_GATE = 'CUSTOMS_ENTRY_TERMINAL_OUT_GATE',
  CUSTOMS_EXAM_IN_GATE = 'CUSTOMS_EXAM_IN_GATE',
  CUSTOMS_EXAM_OUT_GATE = 'CUSTOMS_EXAM_OUT_GATE',
  CUSTOMS_SELLER_DUTY_INVOICE_ISSUED = 'CUSTOMS_SELLER_DUTY_INVOICE_ISSUED',
  CUSTOMS_SELLER_DUTY_RECEIVED = 'CUSTOMS_SELLER_DUTY_RECEIVED',
  DELIVERY_ORDER_CANCELED = 'DELIVERY_ORDER_CANCELED',
  DELIVERY_ORDER_CREATED = 'DELIVERY_ORDER_CREATED',
  DELIVERY_ORDER_ISSUED = 'DELIVERY_ORDER_ISSUED',
  DELIVERY_ORDER_UNCANCELED = 'DELIVERY_ORDER_UNCANCELED',
  DE_CUSTOMS_ENTRY_CANCELED = 'DE_CUSTOMS_ENTRY_CANCELED',
  DE_CUSTOMS_ENTRY_UNCANCELED = 'DE_CUSTOMS_ENTRY_UNCANCELED',
  DE_IOR_ACTIVATION_CANCELED = 'DE_IOR_ACTIVATION_CANCELED',
  DE_IOR_ACTIVATION_UNCANCELED = 'DE_IOR_ACTIVATION_UNCANCELED',
  DIS_SUBMITTED = 'DIS_SUBMITTED',
  DOCUMENT_EXTRACTION_COMPLETE = 'DOCUMENT_EXTRACTION_COMPLETE',
  DOCUMENT_EXTRACTION_FAILED = 'DOCUMENT_EXTRACTION_FAILED',
  DOCUMENT_EXTRACTION_REQUESTED = 'DOCUMENT_EXTRACTION_REQUESTED',
  DPS_SCREENING_PENDING = 'DPS_SCREENING_PENDING',
  ESCALATED_TO_SME = 'ESCALATED_TO_SME',
  ESCALATED_TO_TEAM_LEAD = 'ESCALATED_TO_TEAM_LEAD',
  ESCALATION_RESOLVED = 'ESCALATION_RESOLVED',
  EXAM_TRUCKER_NOTIFIED = 'EXAM_TRUCKER_NOTIFIED',
  FINAL_CUSTOMS_ENTRY_DOCUMENT_UPLOADED = 'FINAL_CUSTOMS_ENTRY_DOCUMENT_UPLOADED',
  FR_CUSTOMS_ENTRY_CANCELED = 'FR_CUSTOMS_ENTRY_CANCELED',
  FR_CUSTOMS_ENTRY_UNCANCELED = 'FR_CUSTOMS_ENTRY_UNCANCELED',
  FR_IOR_ACTIVATION_CANCELED = 'FR_IOR_ACTIVATION_CANCELED',
  FR_IOR_ACTIVATION_UNCANCELED = 'FR_IOR_ACTIVATION_UNCANCELED',
  GB_CUSTOMS_ENTRY_CANCELED = 'GB_CUSTOMS_ENTRY_CANCELED',
  GB_CUSTOMS_ENTRY_UNCANCELED = 'GB_CUSTOMS_ENTRY_UNCANCELED',
  GB_IOR_ACTIVATION_CANCELED = 'GB_IOR_ACTIVATION_CANCELED',
  GB_IOR_ACTIVATION_UNCANCELED = 'GB_IOR_ACTIVATION_UNCANCELED',
  HOT_WORK_ORDER_REQUESTED = 'HOT_WORK_ORDER_REQUESTED',
  IMPORTER_ENTITY_ACTIVATED = 'IMPORTER_ENTITY_ACTIVATED',
  IOR_ACTIVATED = 'IOR_ACTIVATED',
  IOR_REJECTED = 'IOR_REJECTED',
  MULTIVAT_WORK_ORDER_CLASSIFIED = 'MULTIVAT_WORK_ORDER_CLASSIFIED',
  MULTIVAT_WORK_ORDER_DECLASSIFIED = 'MULTIVAT_WORK_ORDER_DECLASSIFIED',
  NL_CUSTOMS_ENTRY_CANCELED = 'NL_CUSTOMS_ENTRY_CANCELED',
  NL_CUSTOMS_ENTRY_UNCANCELED = 'NL_CUSTOMS_ENTRY_UNCANCELED',
  NL_IOR_ACTIVATION_CANCELED = 'NL_IOR_ACTIVATION_CANCELED',
  NL_IOR_ACTIVATION_UNCANCELED = 'NL_IOR_ACTIVATION_UNCANCELED',
  REGULATORY_CONTACT_CLOSED = 'REGULATORY_CONTACT_CLOSED',
  REGULATORY_CONTACT_EXPIRED = 'REGULATORY_CONTACT_EXPIRED',
  REGULATORY_CONTACT_IOR_RESPONSE_UPLOADED = 'REGULATORY_CONTACT_IOR_RESPONSE_UPLOADED',
  REGULATORY_CONTACT_KNOWN_VIOLATION = 'REGULATORY_CONTACT_KNOWN_VIOLATION',
  REGULATORY_CONTACT_PENDING_INVESTIGATION = 'REGULATORY_CONTACT_PENDING_INVESTIGATION',
  REGULATORY_CONTACT_PENDING_IOR_RESPONSE = 'REGULATORY_CONTACT_PENDING_IOR_RESPONSE',
  REGULATORY_CONTACT_PENDING_PAYMENT = 'REGULATORY_CONTACT_PENDING_PAYMENT',
  REGULATORY_CONTACT_PENDING_PETITION = 'REGULATORY_CONTACT_PENDING_PETITION',
  REGULATORY_CONTACT_PENDING_PETITION_RESULTS = 'REGULATORY_CONTACT_PENDING_PETITION_RESULTS',
  REGULATORY_CONTACT_PENDING_SUPPLEMENTAL_PETITION = 'REGULATORY_CONTACT_PENDING_SUPPLEMENTAL_PETITION',
  REGULATORY_CONTACT_PENDING_SUPPLEMENTAL_PETITION_RESULTS = 'REGULATORY_CONTACT_PENDING_SUPPLEMENTAL_PETITION_RESULTS',
  US_CONSUMPTION_ENTRY_CANCELED = 'US_CONSUMPTION_ENTRY_CANCELED',
  US_CONSUMPTION_ENTRY_CBP_EXAM = 'US_CONSUMPTION_ENTRY_CBP_EXAM',
  US_CONSUMPTION_ENTRY_CBP_HOLD = 'US_CONSUMPTION_ENTRY_CBP_HOLD',
  US_CONSUMPTION_ENTRY_CBP_NOTIFICATION = 'US_CONSUMPTION_ENTRY_CBP_NOTIFICATION',
  US_CONSUMPTION_ENTRY_CBP_RELEASE = 'US_CONSUMPTION_ENTRY_CBP_RELEASE',
  US_CONSUMPTION_ENTRY_CENSUS_WARNINGS = 'US_CONSUMPTION_ENTRY_CENSUS_WARNINGS',
  US_CONSUMPTION_ENTRY_CENSUS_WARNINGS_RESOLVED = 'US_CONSUMPTION_ENTRY_CENSUS_WARNINGS_RESOLVED',
  US_CONSUMPTION_ENTRY_CLEARED_FOR_PICKUP = 'US_CONSUMPTION_ENTRY_CLEARED_FOR_PICKUP',
  US_CONSUMPTION_ENTRY_CREATED = 'US_CONSUMPTION_ENTRY_CREATED',
  US_CONSUMPTION_ENTRY_DAILY_STATEMENT_AUTHORIZED = 'US_CONSUMPTION_ENTRY_DAILY_STATEMENT_AUTHORIZED',
  US_CONSUMPTION_ENTRY_DAILY_STATEMENT_FAILURE = 'US_CONSUMPTION_ENTRY_DAILY_STATEMENT_FAILURE',
  US_CONSUMPTION_ENTRY_DAILY_STATEMENT_FINALIZED = 'US_CONSUMPTION_ENTRY_DAILY_STATEMENT_FINALIZED',
  US_CONSUMPTION_ENTRY_DAILY_STATEMENT_NUMBER_ADDED = 'US_CONSUMPTION_ENTRY_DAILY_STATEMENT_NUMBER_ADDED',
  US_CONSUMPTION_ENTRY_DAILY_STATEMENT_NUMBER_REMOVED = 'US_CONSUMPTION_ENTRY_DAILY_STATEMENT_NUMBER_REMOVED',
  US_CONSUMPTION_ENTRY_DELETED = 'US_CONSUMPTION_ENTRY_DELETED',
  US_CONSUMPTION_ENTRY_DUTY_CONFIRMATION_REQUESTED = 'US_CONSUMPTION_ENTRY_DUTY_CONFIRMATION_REQUESTED',
  US_CONSUMPTION_ENTRY_DUTY_CONFIRMED = 'US_CONSUMPTION_ENTRY_DUTY_CONFIRMED',
  US_CONSUMPTION_ENTRY_DUTY_DISPUTED = 'US_CONSUMPTION_ENTRY_DUTY_DISPUTED',
  US_CONSUMPTION_ENTRY_FILED = 'US_CONSUMPTION_ENTRY_FILED',
  US_CONSUMPTION_ENTRY_FLIPPED_TO_US_TYPE86_ENTRY = 'US_CONSUMPTION_ENTRY_FLIPPED_TO_US_TYPE86_ENTRY',
  US_CONSUMPTION_ENTRY_LIQUIDATED = 'US_CONSUMPTION_ENTRY_LIQUIDATED',
  US_CONSUMPTION_ENTRY_LIQUIDATION_EXTENDED = 'US_CONSUMPTION_ENTRY_LIQUIDATION_EXTENDED',
  US_CONSUMPTION_ENTRY_LIQUIDATION_SUSPENDED = 'US_CONSUMPTION_ENTRY_LIQUIDATION_SUSPENDED',
  US_CONSUMPTION_ENTRY_MONTHLY_STATEMENT_FINALIZED = 'US_CONSUMPTION_ENTRY_MONTHLY_STATEMENT_FINALIZED',
  US_CONSUMPTION_ENTRY_ONE_USG = 'US_CONSUMPTION_ENTRY_ONE_USG',
  US_CONSUMPTION_ENTRY_PAYMENT_AUTHORIZED = 'US_CONSUMPTION_ENTRY_PAYMENT_AUTHORIZED',
  US_CONSUMPTION_ENTRY_PAYMENT_FAILURE = 'US_CONSUMPTION_ENTRY_PAYMENT_FAILURE',
  US_CONSUMPTION_ENTRY_PAYMENT_MISSED_ACTIONED = 'US_CONSUMPTION_ENTRY_PAYMENT_MISSED_ACTIONED',
  US_CONSUMPTION_ENTRY_PAYMENT_MISSED_FIRST_STRIKE = 'US_CONSUMPTION_ENTRY_PAYMENT_MISSED_FIRST_STRIKE',
  US_CONSUMPTION_ENTRY_PAYMENT_MISSED_SECOND_STRIKE = 'US_CONSUMPTION_ENTRY_PAYMENT_MISSED_SECOND_STRIKE',
  US_CONSUMPTION_ENTRY_PGA_HOLD = 'US_CONSUMPTION_ENTRY_PGA_HOLD',
  US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_CONSUMPTION_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_CONSUMPTION_ENTRY_PGA_REJECTED = 'US_CONSUMPTION_ENTRY_PGA_REJECTED',
  US_CONSUMPTION_ENTRY_PGA_RELEASE = 'US_CONSUMPTION_ENTRY_PGA_RELEASE',
  US_CONSUMPTION_ENTRY_PMS_PAYMENT_MISSED_ACTIONED = 'US_CONSUMPTION_ENTRY_PMS_PAYMENT_MISSED_ACTIONED',
  US_CONSUMPTION_ENTRY_PREPAID_INVOICE_CREATED = 'US_CONSUMPTION_ENTRY_PREPAID_INVOICE_CREATED',
  US_CONSUMPTION_ENTRY_PREPAID_INVOICE_PAID = 'US_CONSUMPTION_ENTRY_PREPAID_INVOICE_PAID',
  US_CONSUMPTION_ENTRY_REJECTED = 'US_CONSUMPTION_ENTRY_REJECTED',
  US_CONSUMPTION_ENTRY_RELEASE_FILED = 'US_CONSUMPTION_ENTRY_RELEASE_FILED',
  US_CONSUMPTION_ENTRY_RELEASE_REJECTED = 'US_CONSUMPTION_ENTRY_RELEASE_REJECTED',
  US_CONSUMPTION_ENTRY_RELEASE_SUBMITTED = 'US_CONSUMPTION_ENTRY_RELEASE_SUBMITTED',
  US_CONSUMPTION_ENTRY_RE_LIQUIDATED = 'US_CONSUMPTION_ENTRY_RE_LIQUIDATED',
  US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_FAILED = 'US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_FAILED',
  US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_PENDING_REVIEW = 'US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_PENDING_REVIEW',
  US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_REQUESTED = 'US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_REQUESTED',
  US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_SUCCEEDED = 'US_CONSUMPTION_ENTRY_SINGLE_ENTRY_BOND_ACQUISITION_SUCCEEDED',
  US_CONSUMPTION_ENTRY_SKIPPED = 'US_CONSUMPTION_ENTRY_SKIPPED',
  US_CONSUMPTION_ENTRY_STARTED = 'US_CONSUMPTION_ENTRY_STARTED',
  US_CONSUMPTION_ENTRY_STATEMENT_DATE_CALCULATION_ERROR = 'US_CONSUMPTION_ENTRY_STATEMENT_DATE_CALCULATION_ERROR',
  US_CONSUMPTION_ENTRY_STATEMENT_PAID = 'US_CONSUMPTION_ENTRY_STATEMENT_PAID',
  US_CONSUMPTION_ENTRY_SUBMITTED = 'US_CONSUMPTION_ENTRY_SUBMITTED',
  US_CONSUMPTION_ENTRY_UFLPA_WARNING = 'US_CONSUMPTION_ENTRY_UFLPA_WARNING',
  US_CONSUMPTION_ENTRY_UNCANCELED = 'US_CONSUMPTION_ENTRY_UNCANCELED',
  US_DRAWBACK_CLAIM_CANCELED = 'US_DRAWBACK_CLAIM_CANCELED',
  US_DRAWBACK_CLAIM_UNCANCELED = 'US_DRAWBACK_CLAIM_UNCANCELED',
  US_DRAWBACK_CREATED = 'US_DRAWBACK_CREATED',
  US_DRAWBACK_DELETED = 'US_DRAWBACK_DELETED',
  US_DRAWBACK_FILED = 'US_DRAWBACK_FILED',
  US_DRAWBACK_REJECTED = 'US_DRAWBACK_REJECTED',
  US_DRAWBACK_SUBMITTED = 'US_DRAWBACK_SUBMITTED',
  US_IN_BOND_ARRIVED = 'US_IN_BOND_ARRIVED',
  US_IN_BOND_AUTHORIZED = 'US_IN_BOND_AUTHORIZED',
  US_IN_BOND_BILL_ARRIVED = 'US_IN_BOND_BILL_ARRIVED',
  US_IN_BOND_BILL_EXPORTED = 'US_IN_BOND_BILL_EXPORTED',
  US_IN_BOND_CANCELED = 'US_IN_BOND_CANCELED',
  US_IN_BOND_CLOSED = 'US_IN_BOND_CLOSED',
  US_IN_BOND_CONTAINER_ARRIVED = 'US_IN_BOND_CONTAINER_ARRIVED',
  US_IN_BOND_CONTAINER_EXPORTED = 'US_IN_BOND_CONTAINER_EXPORTED',
  US_IN_BOND_CREATED = 'US_IN_BOND_CREATED',
  US_IN_BOND_DELETED = 'US_IN_BOND_DELETED',
  US_IN_BOND_DIVERSION = 'US_IN_BOND_DIVERSION',
  US_IN_BOND_EXPORTED = 'US_IN_BOND_EXPORTED',
  US_IN_BOND_REJECTED = 'US_IN_BOND_REJECTED',
  US_IN_BOND_SUBMITTED = 'US_IN_BOND_SUBMITTED',
  US_IN_BOND_TRANSFERRED = 'US_IN_BOND_TRANSFERRED',
  US_IN_BOND_UNCANCELED = 'US_IN_BOND_UNCANCELED',
  US_IOR_ACTIVATION_CANCELED = 'US_IOR_ACTIVATION_CANCELED',
  US_IOR_ACTIVATION_CORPORATE_CERTIFICATION_SIGNED = 'US_IOR_ACTIVATION_CORPORATE_CERTIFICATION_SIGNED',
  US_IOR_ACTIVATION_DIRECT_POWER_OF_ATTORNEY_SIGNED = 'US_IOR_ACTIVATION_DIRECT_POWER_OF_ATTORNEY_SIGNED',
  US_IOR_ACTIVATION_IOR_ACTIVATED = 'US_IOR_ACTIVATION_IOR_ACTIVATED',
  US_IOR_ACTIVATION_MASTER_POWER_OF_ATTORNEY_SIGNED = 'US_IOR_ACTIVATION_MASTER_POWER_OF_ATTORNEY_SIGNED',
  US_IOR_ACTIVATION_SUB_POWER_OF_ATTORNEY_SIGNED = 'US_IOR_ACTIVATION_SUB_POWER_OF_ATTORNEY_SIGNED',
  US_IOR_ACTIVATION_UNCANCELED = 'US_IOR_ACTIVATION_UNCANCELED',
  US_IOR_CONTINUOUS_BOND_REQUEST_ACQUISITION_FAILED = 'US_IOR_CONTINUOUS_BOND_REQUEST_ACQUISITION_FAILED',
  US_IOR_CONTINUOUS_BOND_REQUEST_ACQUISITION_REQUESTED = 'US_IOR_CONTINUOUS_BOND_REQUEST_ACQUISITION_REQUESTED',
  US_IOR_CONTINUOUS_BOND_REQUEST_ACQUISITION_SUCCEEDED = 'US_IOR_CONTINUOUS_BOND_REQUEST_ACQUISITION_SUCCEEDED',
  US_IOR_CONTINUOUS_BOND_REQUEST_CANCELED = 'US_IOR_CONTINUOUS_BOND_REQUEST_CANCELED',
  US_IOR_CONTINUOUS_BOND_REQUEST_CHARGE_BOND_FAILED = 'US_IOR_CONTINUOUS_BOND_REQUEST_CHARGE_BOND_FAILED',
  US_IOR_CONTINUOUS_BOND_REQUEST_CHARGE_BOND_REQUESTED = 'US_IOR_CONTINUOUS_BOND_REQUEST_CHARGE_BOND_REQUESTED',
  US_IOR_CONTINUOUS_BOND_REQUEST_CHARGE_BOND_SUCCEEDED = 'US_IOR_CONTINUOUS_BOND_REQUEST_CHARGE_BOND_SUCCEEDED',
  US_IOR_CONTINUOUS_BOND_REQUEST_PENDING_REVIEW = 'US_IOR_CONTINUOUS_BOND_REQUEST_PENDING_REVIEW',
  US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_ATTEMPTED = 'US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_ATTEMPTED',
  US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_CANCELED = 'US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_CANCELED',
  US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_FAILED = 'US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_FAILED',
  US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_SUCCEEDED = 'US_IOR_CONTINUOUS_BOND_REQUEST_RENEWAL_SUCCEEDED',
  US_IOR_CONTINUOUS_BOND_REQUEST_UNCANCELED = 'US_IOR_CONTINUOUS_BOND_REQUEST_UNCANCELED',
  US_ISF_AUTO_UPDATE_SUCCEEDED = 'US_ISF_AUTO_UPDATE_SUCCEEDED',
  US_ISF_BILL_MATCH = 'US_ISF_BILL_MATCH',
  US_ISF_BOND_ACQUISITION_FAILED = 'US_ISF_BOND_ACQUISITION_FAILED',
  US_ISF_BOND_ACQUISITION_PENDING_REVIEW = 'US_ISF_BOND_ACQUISITION_PENDING_REVIEW',
  US_ISF_BOND_ACQUISITION_REQUESTED = 'US_ISF_BOND_ACQUISITION_REQUESTED',
  US_ISF_BOND_ACQUISITION_SUCCEEDED = 'US_ISF_BOND_ACQUISITION_SUCCEEDED',
  US_ISF_BOND_CLOSURE_FAILED = 'US_ISF_BOND_CLOSURE_FAILED',
  US_ISF_BOND_CLOSURE_REQUESTED = 'US_ISF_BOND_CLOSURE_REQUESTED',
  US_ISF_BOND_CLOSURE_SUCCEEDED = 'US_ISF_BOND_CLOSURE_SUCCEEDED',
  US_ISF_CANCELED = 'US_ISF_CANCELED',
  US_ISF_CREATED = 'US_ISF_CREATED',
  US_ISF_DELETED = 'US_ISF_DELETED',
  US_ISF_FILED = 'US_ISF_FILED',
  US_ISF_NOT_AUTO_UPDATED_BECAUSE_VESSEL_ARRIVED = 'US_ISF_NOT_AUTO_UPDATED_BECAUSE_VESSEL_ARRIVED',
  US_ISF_NO_BILL_MATCH_NOT_ON_FILE = 'US_ISF_NO_BILL_MATCH_NOT_ON_FILE',
  US_ISF_REJECTED = 'US_ISF_REJECTED',
  US_ISF_SKIPPED = 'US_ISF_SKIPPED',
  US_ISF_SUBMITTED = 'US_ISF_SUBMITTED',
  US_ISF_UNCANCELED = 'US_ISF_UNCANCELED',
  US_POST_SUMMARY_CORRECTION_CANCELED = 'US_POST_SUMMARY_CORRECTION_CANCELED',
  US_POST_SUMMARY_CORRECTION_CBP_NOTIFICATION = 'US_POST_SUMMARY_CORRECTION_CBP_NOTIFICATION',
  US_POST_SUMMARY_CORRECTION_CREATED = 'US_POST_SUMMARY_CORRECTION_CREATED',
  US_POST_SUMMARY_CORRECTION_FILED = 'US_POST_SUMMARY_CORRECTION_FILED',
  US_POST_SUMMARY_CORRECTION_LIQUIDATED = 'US_POST_SUMMARY_CORRECTION_LIQUIDATED',
  US_POST_SUMMARY_CORRECTION_LIQUIDATION_EXTENDED = 'US_POST_SUMMARY_CORRECTION_LIQUIDATION_EXTENDED',
  US_POST_SUMMARY_CORRECTION_LIQUIDATION_SUSPENDED = 'US_POST_SUMMARY_CORRECTION_LIQUIDATION_SUSPENDED',
  US_POST_SUMMARY_CORRECTION_REJECTED = 'US_POST_SUMMARY_CORRECTION_REJECTED',
  US_POST_SUMMARY_CORRECTION_RE_LIQUIDATED = 'US_POST_SUMMARY_CORRECTION_RE_LIQUIDATED',
  US_POST_SUMMARY_CORRECTION_STARTED = 'US_POST_SUMMARY_CORRECTION_STARTED',
  US_POST_SUMMARY_CORRECTION_SUBMITTED = 'US_POST_SUMMARY_CORRECTION_SUBMITTED',
  US_POST_SUMMARY_CORRECTION_UNCANCELED = 'US_POST_SUMMARY_CORRECTION_UNCANCELED',
  US_TYPE86_ENTRY_BILL_NOT_ON_FILE = 'US_TYPE86_ENTRY_BILL_NOT_ON_FILE',
  US_TYPE86_ENTRY_BILL_ON_FILE = 'US_TYPE86_ENTRY_BILL_ON_FILE',
  US_TYPE86_ENTRY_CANCELED = 'US_TYPE86_ENTRY_CANCELED',
  US_TYPE86_ENTRY_CBP_EXAM = 'US_TYPE86_ENTRY_CBP_EXAM',
  US_TYPE86_ENTRY_CBP_HOLD = 'US_TYPE86_ENTRY_CBP_HOLD',
  US_TYPE86_ENTRY_CBP_RELEASE = 'US_TYPE86_ENTRY_CBP_RELEASE',
  US_TYPE86_ENTRY_CLEARED_FOR_PICKUP = 'US_TYPE86_ENTRY_CLEARED_FOR_PICKUP',
  US_TYPE86_ENTRY_CREATED = 'US_TYPE86_ENTRY_CREATED',
  US_TYPE86_ENTRY_DELETED = 'US_TYPE86_ENTRY_DELETED',
  US_TYPE86_ENTRY_FILED = 'US_TYPE86_ENTRY_FILED',
  US_TYPE86_ENTRY_FLIPPED_TO_US_CONSUMPTION_ENTRY = 'US_TYPE86_ENTRY_FLIPPED_TO_US_CONSUMPTION_ENTRY',
  US_TYPE86_ENTRY_ONE_USG = 'US_TYPE86_ENTRY_ONE_USG',
  US_TYPE86_ENTRY_PGA_HOLD = 'US_TYPE86_ENTRY_PGA_HOLD',
  US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED = 'US_TYPE86_ENTRY_PGA_MAY_PROCEED_RESCINDED',
  US_TYPE86_ENTRY_PGA_REJECTED = 'US_TYPE86_ENTRY_PGA_REJECTED',
  US_TYPE86_ENTRY_PGA_RELEASE = 'US_TYPE86_ENTRY_PGA_RELEASE',
  US_TYPE86_ENTRY_REJECTED = 'US_TYPE86_ENTRY_REJECTED',
  US_TYPE86_ENTRY_SUBMITTED = 'US_TYPE86_ENTRY_SUBMITTED',
  US_TYPE86_ENTRY_UNCANCELED = 'US_TYPE86_ENTRY_UNCANCELED',
  WORK_ORDER_ASSIGNED = 'WORK_ORDER_ASSIGNED',
  WORK_ORDER_BLOCKED = 'WORK_ORDER_BLOCKED',
  WORK_ORDER_COMPLETE = 'WORK_ORDER_COMPLETE',
  WORK_ORDER_INQUIRY_RESOLVED = 'WORK_ORDER_INQUIRY_RESOLVED',
  WORK_ORDER_PENDING_INQUIRY = 'WORK_ORDER_PENDING_INQUIRY',
  WORK_ORDER_READY = 'WORK_ORDER_READY',
  WORK_ORDER_REPLACED = 'WORK_ORDER_REPLACED'
}

/** Work order milestone name search criteria. */
export type WorkOrderMilestoneNameSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderMilestoneName>>;
};

export type WorkOrderMilestonesConnection = Connection & {
  __typename?: 'WorkOrderMilestonesConnection';
  edges: Array<WorkOrderMilestoneEdge>;
  nodes: Array<WorkOrderMilestone>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type WorkOrderPendingUpdate = {
  __typename?: 'WorkOrderPendingUpdate';
  /** Confidence score of WorkOrder Pending Update Field. */
  confidenceScore?: Maybe<Scalars['Float']>;
  /** The Data Source Type. */
  dataSource?: Maybe<DataSourceType>;
  /** occurrence time of WorkOrder Pending Update Field. */
  occurrenceTime: Scalars['DateTime'];
  /** Path of WorkOrder Pending Update Field. */
  path?: Maybe<Scalars['String']>;
  /** Value of WorkOrder Pending Update Field. */
  value?: Maybe<Scalars['Any']>;
};

export type WorkOrderPendingUpdateInput = {
  /** Confidence score of WorkOrder Pending Update Field. */
  confidenceScore?: InputMaybe<Scalars['Float']>;
  /** The Data Source Type. */
  dataSource?: InputMaybe<DataSourceType>;
  /** occurrence time of WorkOrder Pending Update Field. */
  occurrenceTime: Scalars['DateTime'];
  /** Path of WorkOrder Pending Update Field. */
  path?: InputMaybe<Scalars['String']>;
  /** Value of WorkOrder Pending Update Field. */
  value?: InputMaybe<Scalars['Any']>;
};

export type WorkOrderPresignedUrlResponse = {
  __typename?: 'WorkOrderPresignedUrlResponse';
  /** The reference of the file to be uploaded using uploadLink. Act as a only reference for client and CBMS to identify the uploaded file with uploadLink */
  referenceKey: Scalars['String'];
  /** The S3 presigned upload link to allow work order data to be uploaded in S3 */
  uploadLink: Scalars['String'];
};

export type WorkOrderProcessingRequestDocument = {
  __typename?: 'WorkOrderProcessingRequestDocument';
  /** Id of the CBMS Documents  */
  documentId?: Maybe<Scalars['ID']>;
  /** Documents Tags */
  documentTags?: Maybe<Array<DocumentTag>>;
  /** External document references. */
  externalDocumentReference?: Maybe<ExternalDocumentReference>;
  /** Extraction results provided in form of reference. */
  extractionReference?: Maybe<WorkOrderDocumentExtractionReference>;
  /** Reason for extraction failure */
  failureReason?: Maybe<Scalars['String']>;
  /** Status of WorkOrderDocumentProcessing Request */
  status?: Maybe<WorkOrderDocumentProcessingStatus>;
};

export type WorkOrderProcessingRequestDocumentInput = {
  /** Id of the CBMS Documents  */
  documentId?: InputMaybe<Scalars['ID']>;
  /** Documents Tags */
  documentTags?: InputMaybe<Array<DocumentTag>>;
  /** External document references. */
  externalDocumentReference?: InputMaybe<ExternalDocumentReferenceInput>;
  /** Extraction results provided in form of reference. */
  extractionReference?: InputMaybe<WorkOrderDocumentExtractionReferenceInput>;
  /** Reason for extraction failure */
  failureReason?: InputMaybe<Scalars['String']>;
  /** Status of WorkOrderDocumentProcessing Request */
  status?: InputMaybe<WorkOrderDocumentProcessingStatus>;
};

export type WorkOrderSearchCriteriaInput = {
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** The id of the broker linked to the work order. */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to the work order. */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The broker number used by the broker to identify the entry. */
  brokerNumber?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The deadline for the work order. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The time the Record is expected to be expired. */
  expirationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: InputMaybe<IdSearchCriteriaInput>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: InputMaybe<BooleanSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the shipper linked to the work order. */
  shipperId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the shipper linked to the work order. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order status */
  status?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order's group. */
  workOrderGroupId?: InputMaybe<KeywordSearchCriteriaInput>;
};

/** Work Order search results. */
export type WorkOrderSearchTableRow = {
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** The id of the broker linked to the work order. */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to the work order. */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** Work order deadline */
  deadline?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The arrival time for the shipment */
  eta?: Maybe<Scalars['String']>;
  /** The time the Record is expected to be expired. */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /** The ids of the forwarder linked to the work order. */
  forwarderId?: Maybe<Scalars['ID']>;
  /** The names of the forwarder linked to the work order. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Flag for whether the work order was auto marked ready. */
  isAutoSetReady?: Maybe<Scalars['Boolean']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** Payable invoice numbers linked to the work order group (skips void, pending_void and deleted invoices) */
  payableInvoiceNumber?: Maybe<Array<Scalars['String']>>;
  /** The id of the shipper linked to the work order. */
  shipperId?: Maybe<Scalars['ID']>;
  /** The name of the shipper linked to the work order. */
  shipperName?: Maybe<Scalars['String']>;
  /** Work order status */
  status: Scalars['String'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order's group. */
  workOrderGroupId?: Maybe<Scalars['String']>;
};

export type WorkOrderState = {
  __typename?: 'WorkOrderState';
  /** Description of the state. */
  description: Scalars['String'];
  /** Designates this state as a terminal state. Only one of 'next' and 'end' can be used in a state. */
  end?: Maybe<Scalars['Boolean']>;
  /** The name of the state. */
  name: Scalars['WorkOrderStateName'];
  /** The name of the next state. Only one of 'next' and 'end' can be used in a state. */
  next?: Maybe<Scalars['WorkOrderStateName']>;
  /** The task definition to execute during this state. Can only be used with the 'TASK' WorkOrderStateType. */
  taskDefinition: WorkOrderTaskDefinition;
  /** The state's type. */
  type: WorkOrderStateType;
};

export type WorkOrderStateInput = {
  /** Description of the state. */
  description: Scalars['String'];
  /** Designates this state as a terminal state. Only one of 'next' and 'end' can be used in a state. */
  end?: InputMaybe<Scalars['Boolean']>;
  /** The name of the state. */
  name: Scalars['WorkOrderStateName'];
  /** The name of the next state. Only one of 'next' and 'end' can be used in a state. */
  next?: InputMaybe<Scalars['WorkOrderStateName']>;
  /** The task definition to execute during this state. Can only be used with the 'TASK' WorkOrderStateType. */
  taskDefinition: IdInput;
  /** The state's type. */
  type: WorkOrderStateType;
};

/** A State Machine composed of the states and tasks required to execute a Work Order. */
export type WorkOrderStateMachine = Record & {
  __typename?: 'WorkOrderStateMachine';
  /** The countries the state machine supports. If not provided, all countries are supported. */
  countryCodes?: Maybe<Array<Scalars['CountryCode']>>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The Customs Brokers the state machine supports. */
  customsBrokers?: Maybe<Array<CustomsBroker>>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Description of the Work Order State Machine. */
  description: Scalars['String'];
  /** The Forwarders associated with the state machine. Returns the latest version. */
  forwarders?: Maybe<Array<Forwarder>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The mode of transports the state machine supports. If not provided, all mode of transports are supported. */
  modeOfTransports?: Maybe<Array<ModeOfTransport>>;
  /** Name of the Work Order State Machine */
  name: Scalars['String'];
  /** The Operator of the State Machine. Returns the latest version. */
  operator: Operator;
  /** The Placement Type of the state machine */
  placementType?: Maybe<PlacementType>;
  /** The starting state. */
  start: Scalars['WorkOrderStateName'];
  /** The steps of the task. */
  states: Array<WorkOrderState>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  workOrderType: WorkOrderType;
};

export type WorkOrderStateMachineEdge = ConnectionEdge & {
  __typename?: 'WorkOrderStateMachineEdge';
  cursor: Scalars['ID'];
  node: WorkOrderStateMachine;
};

export type WorkOrderStateMachineSearchCriteriaInput = {
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The ID of the operator to which the state machine belongs. If set, no other criteria can be set. */
  operatorId?: InputMaybe<IdIndexSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
};

/** TBD */
export type WorkOrderStateMachineSearchTableRow = RecordSearchTableRow & {
  __typename?: 'WorkOrderStateMachineSearchTableRow';
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
};

export type WorkOrderStateMachinesConnection = Connection & {
  __typename?: 'WorkOrderStateMachinesConnection';
  edges: Array<WorkOrderStateMachineEdge>;
  nodes: Array<WorkOrderStateMachine>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The state's type */
export enum WorkOrderStateType {
  TASK = 'TASK'
}

/** The Work Order's status. */
export enum WorkOrderStatus {
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  READY = 'READY',
  REPLACED = 'REPLACED'
}

/** The Work Order's status. */
export type WorkOrderStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderStatus>>;
};

/** A Task performed as part of a Work Order */
export type WorkOrderTask = Record & {
  __typename?: 'WorkOrderTask';
  /** The User assigned to this Work Order Task. Returns the version at the time of assignment. */
  assignee?: Maybe<OperatorUser>;
  /** The associated assignment team for the task. */
  assignmentTeam?: Maybe<AssignmentTeam>;
  /** A RecordAction signifying when the record was requested to be canceled */
  canceled?: Maybe<RecordAction>;
  /** When the task was completed */
  completed?: Maybe<RecordAction>;
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The custom fields  */
  customFields?: Maybe<Array<WorkOrderTaskCustomField>>;
  /** Deadline for the Work Order Task to be completed. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** The Work Order Task Definition this Task was created from. */
  definition: WorkOrderTaskDefinition;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** All the empty fields in the current work order task */
  emptyFieldsNames?: Maybe<Array<Scalars['String']>>;
  /** Work order task escalation details. */
  escalations?: Maybe<Array<WorkOrderTaskEscalation>>;
  /** The estimatedDuration of one work order task, calculated in minutes */
  estimatedDuration?: Maybe<Scalars['Float']>;
  /** Work order task execution result. */
  executionResult?: Maybe<WorkOrderTaskExecutionResult>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether this work order task is an exception task outside of the normal task workflow. */
  isException?: Maybe<Scalars['Boolean']>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: Maybe<SkillLevel>;
  /** Name of the task */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** When the task was started */
  started?: Maybe<RecordAction>;
  /** The work order task's status. */
  status: WorkOrderTaskStatus;
  /** The reason for work order task status. */
  statusReason?: Maybe<WorkOrderTaskStatusReason>;
  /** Steps of the task */
  steps: Array<WorkOrderTaskStep>;
  /** The work order task's sub status. */
  subStatus?: Maybe<WorkOrderTaskSubStatus>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** The statistics of a Work Order Task */
  taskStatistics?: Maybe<WorkOrderTaskStatistics>;
  /** Work order task team. */
  teamId?: Maybe<Scalars['ID']>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The Work Order this task belongs to. */
  workOrder: WorkOrder;
  workOrderType: WorkOrderType;
};

export type WorkOrderTaskAssignmentRequestPayload = {
  __typename?: 'WorkOrderTaskAssignmentRequestPayload';
  /** Tasks assignment from support team */
  isSupportTeamAssignment?: Maybe<Scalars['Boolean']>;
  /** Operator Id */
  operatorUserId: Scalars['ID'];
  /** Operator user version */
  operatorUserVersion: Scalars['Int'];
  /** Operator user request time */
  requestTime?: Maybe<Scalars['DateTime']>;
  /** Operator user skill level */
  skillLevel?: Maybe<SkillLevel>;
  /** Work Order Tasks */
  workOrderTasks?: Maybe<Array<WorkOrderTask>>;
};

export type WorkOrderTaskBlockedTimeInterval = {
  __typename?: 'WorkOrderTaskBlockedTimeInterval';
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<WorkOrderBlockedReasonCode>;
  /** A time interval when this task is blocked. Calculated in seconds. */
  interval?: Maybe<Scalars['Float']>;
};

export type WorkOrderTaskCustomField = {
  __typename?: 'WorkOrderTaskCustomField';
  /** The value when custom field type is Boolean */
  booleanValue?: Maybe<Scalars['Boolean']>;
  /** Type of work order task custom field */
  customFieldType: WorkOrderTaskCustomFieldType;
  /** The value when custom field type is Date */
  dateValue?: Maybe<Scalars['String']>;
  /** The options for an enum field */
  enumOptions?: Maybe<Array<Scalars['String']>>;
  /** The selected options for an enum */
  enumValues?: Maybe<Array<Scalars['String']>>;
  /** The label for the custom field */
  label: Scalars['String'];
  /** The value when custom field type is a record type */
  recordId?: Maybe<Scalars['String']>;
  /** The value when custom field type is Text */
  textValue?: Maybe<Scalars['String']>;
};

export type WorkOrderTaskCustomFieldDefinition = {
  __typename?: 'WorkOrderTaskCustomFieldDefinition';
  /** Type of work order task custom field */
  customFieldType: WorkOrderTaskCustomFieldType;
  /** The options for an enum field */
  enumOptions?: Maybe<Array<Scalars['String']>>;
  /** The label for the custom field */
  label: Scalars['String'];
};

export type WorkOrderTaskCustomFieldDefinitionInput = {
  /** Type of work order task custom field */
  customFieldType: WorkOrderTaskCustomFieldType;
  /** The options for an enum field */
  enumOptions?: InputMaybe<Array<Scalars['String']>>;
  /** The label for the custom field */
  label: Scalars['String'];
};

export type WorkOrderTaskCustomFieldInput = {
  /** The value when custom field type is Boolean */
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  /** Type of work order task custom field */
  customFieldType: WorkOrderTaskCustomFieldType;
  /** The value when custom field type is Date */
  dateValue?: InputMaybe<Scalars['String']>;
  /** The options for an enum field */
  enumOptions?: InputMaybe<Array<Scalars['String']>>;
  /** The selected options for an enum */
  enumValues?: InputMaybe<Array<Scalars['String']>>;
  /** The label for the custom field */
  label: Scalars['String'];
  /** The value when custom field type is a record type */
  recordId?: InputMaybe<Scalars['String']>;
  /** The value when custom field type is Text */
  textValue?: InputMaybe<Scalars['String']>;
};

/** Type of work order task custom field */
export enum WorkOrderTaskCustomFieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  Enum = 'Enum',
  Text = 'Text',
  Trucker = 'Trucker'
}

/** The definition for a Work Order Task */
export type WorkOrderTaskDefinition = Record & {
  __typename?: 'WorkOrderTaskDefinition';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** The custom fields definitions */
  customFields?: Maybe<Array<WorkOrderTaskCustomFieldDefinition>>;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Overview of the task */
  description: Scalars['String'];
  /** Estimated time in minutes to complete the task by an operator user. Defaulted to 15 mins */
  estimatedDuration?: Maybe<Scalars['Int']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether this work order task is an exception task outside of the normal task workflow. */
  isException?: Maybe<Scalars['Boolean']>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: Maybe<SkillLevel>;
  /** Name of the task */
  name: Scalars['String'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** The steps of the task. */
  steps: Array<WorkOrderTaskDefinitionStep>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The type of work order task to be completed. */
  workOrderTaskType: WorkOrderTaskType;
  /** The type of Work Order this task is used on. */
  workOrderType: WorkOrderType;
};

export type WorkOrderTaskDefinitionEdge = ConnectionEdge & {
  __typename?: 'WorkOrderTaskDefinitionEdge';
  cursor: Scalars['ID'];
  node: WorkOrderTaskDefinition;
};

export type WorkOrderTaskDefinitionStep = {
  __typename?: 'WorkOrderTaskDefinitionStep';
  /** Longer description of the step. */
  description?: Maybe<Scalars['String']>;
  /** Whether this work order step is to be completed by system. If true, operators will not be able to modify completion of this step via the UI. */
  isCompletedBySystem?: Maybe<Scalars['Boolean']>;
  /** Used when finalizing the completion of a work order task by operators via the UI. If a work order step with isFinal = true is marked as completed, it means that the work order task is completed. */
  isFinalConfirmation?: Maybe<Scalars['Boolean']>;
  /** A short name for the step. */
  name: Scalars['String'];
};

export type WorkOrderTaskDefinitionStepInput = {
  /** Longer description of the step. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether this work order step is to be completed by system. If true, operators will not be able to modify completion of this step via the UI. */
  isCompletedBySystem?: InputMaybe<Scalars['Boolean']>;
  /** Used when finalizing the completion of a work order task by operators via the UI. If a work order step with isFinal = true is marked as completed, it means that the work order task is completed. */
  isFinalConfirmation?: InputMaybe<Scalars['Boolean']>;
  /** A short name for the step. */
  name: Scalars['String'];
};

export type WorkOrderTaskDefinitionsConnection = Connection & {
  __typename?: 'WorkOrderTaskDefinitionsConnection';
  edges: Array<WorkOrderTaskDefinitionEdge>;
  nodes: Array<WorkOrderTaskDefinition>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

export type WorkOrderTaskEdge = ConnectionEdge & {
  __typename?: 'WorkOrderTaskEdge';
  cursor: Scalars['ID'];
  node: WorkOrderTask;
};

export type WorkOrderTaskEscalation = {
  __typename?: 'WorkOrderTaskEscalation';
  /** Details about the task escalation */
  escalationDetails?: Maybe<TaskEscalationDetails>;
  /** Details about the task escalation replies */
  replyDetails?: Maybe<Array<TaskEscalationReplyDetails>>;
  /** Details about the task resolution */
  resolutionDetails?: Maybe<TaskResolutionDetails>;
};

export type WorkOrderTaskEscalationInput = {
  /** Details about the task escalation */
  escalationDetails?: InputMaybe<TaskEscalationDetailsInput>;
  /** Details about the task resolution */
  resolutionDetails?: InputMaybe<TaskResolutionDetailsInput>;
};

/** Work Order Task Escalation Message */
export type WorkOrderTaskEscalationMessage = Record & {
  __typename?: 'WorkOrderTaskEscalationMessage';
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Details about the task escalation */
  escalationDetails?: Maybe<TaskEscalationDetails>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The Operator that owns this Record. */
  operator: Operator;
  /** Details about the task escalation replies */
  replyDetails?: Maybe<Array<TaskEscalationReplyDetails>>;
  /** Details about the task resolution */
  resolutionDetails?: Maybe<TaskResolutionDetails>;
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  /** The Work Order Task this escalation message belongs to. */
  workOrderTask: WorkOrderTask;
};

export type WorkOrderTaskEscalationMessageEdge = ConnectionEdge & {
  __typename?: 'WorkOrderTaskEscalationMessageEdge';
  cursor: Scalars['ID'];
  node: WorkOrderTaskEscalationMessage;
};

export type WorkOrderTaskEscalationMessageSearchCriteriaInput = {
  /** All details in escalation message */
  allDetails?: InputMaybe<TextSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to this task */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to this task */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** Operator user id who escalated the task */
  escalatedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Operator user name who escalated the task */
  escalatedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** Escalated to user id */
  escalatedToId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Operator user to whom task is escalated */
  escalatedToName?: InputMaybe<TextSearchCriteriaInput>;
  /** Details about this escalation */
  escalationDetails?: InputMaybe<TextSearchCriteriaInput>;
  /** Escalation reason category */
  escalationReason?: InputMaybe<EscalationReasonCategoryTypeSearchCriteriaInput>;
  /** Escalation reason sub category */
  escalationSubReason?: InputMaybe<EscalationReasonSubCategoryTypeSearchCriteriaInput>;
  /** Type of escalation */
  escalationType?: InputMaybe<EscalatationTypeSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Operator that owns this Record. */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** Operator user ids who replied to the escalation */
  replyById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Operator user names who replied to the escalation */
  replyByName?: InputMaybe<TextSearchCriteriaInput>;
  /** Details about the replys on this escalation */
  replyDetails?: InputMaybe<TextSearchCriteriaInput>;
  /** Details about this resolution */
  resolutionDetails?: InputMaybe<TextSearchCriteriaInput>;
  /** Reason for task resolution. */
  resolutionReason?: InputMaybe<EscalationResolutionReasonTypeSearchCriteriaInput>;
  /** Operator user id who resolved the task */
  resolvedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** Operator user name who resolved the task */
  resolvedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the associated SME team for this escalation's task */
  subjectMatterExpertTeamId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the associated SME team for this escalation's task */
  subjectMatterExpertTeamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The type of work order task to be completed. */
  workOrderTaskType?: InputMaybe<WorkOrderTaskTypeSearchCriteriaInput>;
};

export type WorkOrderTaskEscalationMessageSearchTableRow = RecordSearchTableRow & {
  __typename?: 'WorkOrderTaskEscalationMessageSearchTableRow';
  /** All details in escalation message */
  allDetails?: Maybe<Array<Scalars['String']>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['ID']>;
  /** The id of the broker linked to this task */
  brokerId?: Maybe<Scalars['ID']>;
  /** The name of the broker linked to this task */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** Operator user id who escalated the task */
  escalatedById?: Maybe<Scalars['ID']>;
  /** Operator user name who escalated the task */
  escalatedByName?: Maybe<Scalars['String']>;
  /** Escalated to user id */
  escalatedToId?: Maybe<Scalars['ID']>;
  /** Operator user to whom task is escalated */
  escalatedToName?: Maybe<Scalars['String']>;
  /** Details about this escalation */
  escalationDetails?: Maybe<Scalars['String']>;
  /** Escalation reason category */
  escalationReason?: Maybe<EscalationReasonCategory>;
  /** Escalation reason sub category */
  escalationSubReason?: Maybe<EscalationReasonSubCategory>;
  /** Type of escalation */
  escalationType?: Maybe<WorkOrderTaskEscalationType>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Operator user ids who replied to the escalation */
  replyById?: Maybe<Array<Scalars['ID']>>;
  /** Operator user names who replied to the escalation */
  replyByName?: Maybe<Array<Scalars['String']>>;
  /** Details about the replys on this escalation */
  replyDetails?: Maybe<Array<Scalars['String']>>;
  /** Details about this resolution */
  resolutionDetails?: Maybe<Scalars['String']>;
  /** Reason for task resolution. */
  resolutionReason?: Maybe<Array<ResolutionReasonCode>>;
  /** Operator user id who resolved the task */
  resolvedById?: Maybe<Scalars['ID']>;
  /** Operator user name who resolved the task */
  resolvedByName?: Maybe<Scalars['String']>;
  /** The id of the associated SME team for this escalation's task */
  subjectMatterExpertTeamId?: Maybe<Scalars['ID']>;
  /** The name of the associated SME team for this escalation's task */
  subjectMatterExpertTeamName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The type of work order task to be completed. */
  workOrderTaskType?: Maybe<WorkOrderTaskType>;
};

export type WorkOrderTaskEscalationMessagesConnection = Connection & {
  __typename?: 'WorkOrderTaskEscalationMessagesConnection';
  edges: Array<WorkOrderTaskEscalationMessageEdge>;
  nodes: Array<WorkOrderTaskEscalationMessage>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** Type of entity the task is escalated to. */
export enum WorkOrderTaskEscalationType {
  ESCALATED_TO_SUBJECT_MATTER_EXPERT = 'ESCALATED_TO_SUBJECT_MATTER_EXPERT',
  ESCALATED_TO_TEAM_LEAD = 'ESCALATED_TO_TEAM_LEAD'
}

export type WorkOrderTaskExecutionResult = {
  __typename?: 'WorkOrderTaskExecutionResult';
  /** Time of completion of execution */
  completedTime?: Maybe<Scalars['DateTime']>;
  /** Task schedule details. */
  currentScheduleDetails?: Maybe<WorkOrderTaskScheduleDetails>;
  /** Task execution errors. */
  errors?: Maybe<Scalars['JSONObject']>;
  /** Last updated time of execution */
  lastUpdatedTime?: Maybe<Scalars['DateTime']>;
  /** Task execution status. */
  status: WorkOrderTaskExecutionStatus;
};

export type WorkOrderTaskExecutionResultInput = {
  /** Time of completion of execution */
  completedTime?: InputMaybe<Scalars['DateTime']>;
  /** Task schedule details. */
  currentScheduleDetails?: InputMaybe<WorkOrderTaskScheduleDetailsInput>;
  /** Task execution errors. */
  errors?: InputMaybe<Scalars['JSONObject']>;
  /** Last updated time of execution */
  lastUpdatedTime?: InputMaybe<Scalars['DateTime']>;
  /** Task execution status. */
  status: WorkOrderTaskExecutionStatus;
};

/** Work order task execution status. */
export enum WorkOrderTaskExecutionStatus {
  ASSIGNED_TO_OPERATOR_USER = 'ASSIGNED_TO_OPERATOR_USER',
  AUTO_EXECUTED = 'AUTO_EXECUTED',
  AUTO_EXECUTION_FAILED = 'AUTO_EXECUTION_FAILED',
  SCHEDULED = 'SCHEDULED',
  UNASSIGNED = 'UNASSIGNED'
}

export type WorkOrderTaskScheduleDetails = {
  __typename?: 'WorkOrderTaskScheduleDetails';
  /** Schedule creation time */
  createdTime: Scalars['DateTime'];
  /** Unique id of the schedule (eg ARN of DACIA schedule) */
  scheduleId?: Maybe<Scalars['String']>;
  /** Time at which execution is scheduled for i.e., time for trigger */
  scheduledAtTime: Scalars['DateTime'];
  /** Index of the scheduling out of the configured sequence */
  schedulingSequenceIndex: Scalars['Int'];
};

export type WorkOrderTaskScheduleDetailsInput = {
  /** Schedule creation time */
  createdTime: Scalars['DateTime'];
  /** Unique id of the schedule (eg ARN of DACIA schedule) */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Time at which execution is scheduled for i.e., time for trigger */
  scheduledAtTime: Scalars['DateTime'];
  /** Index of the scheduling out of the configured sequence */
  schedulingSequenceIndex: Scalars['Int'];
};

export type WorkOrderTaskSearchCriteriaInput = {
  /** The id of the assignee to whom this task has been assigned. */
  assigneeId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the assignee to whom this task has been assigned. */
  assigneeName?: InputMaybe<TextSearchCriteriaInput>;
  /** Work Order badge. Example: Hot */
  badge?: InputMaybe<WorkOrderBadgeSearchCriteriaInput>;
  /** The blocked reason code for the work order */
  blockedReason?: InputMaybe<WorkOrderBlockedReasonCodeSearchCriteriaInput>;
  /** Client booking id */
  bookingId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The id of the broker linked to this task */
  brokerId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the broker linked to this task */
  brokerName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was canceled. */
  canceledTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of client that completed the task. */
  completedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of client that completed the task. */
  completedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time at which the task completed. */
  completedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The container external id. */
  containerExternalId?: InputMaybe<TextSearchCriteriaInput>;
  /** The container number */
  containerNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the External Client the Record was created by. */
  createdById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was created by. */
  createdByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was created. */
  createdTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the operator by whom this task is currently escalated. */
  currentlyEscalatedById?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the operator by whom this task is currently escalated. */
  currentlyEscalatedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the operator to whom this task is currently escalated. */
  currentlyEscalatedToId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the operator to whom this task is currently escalated. */
  currentlyEscalatedToName?: InputMaybe<TextSearchCriteriaInput>;
  /** The IOR's status with customs authorities (e.g., CBP for US, HMRC for GB) */
  customsStatus?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The deadline for this task. */
  deadline?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was deleted. */
  deletedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: InputMaybe<TextSearchCriteriaInput>;
  /** The ID of the operators to whom this task has been escalated. */
  escalatedToId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the operators to whom this task has been escalated. */
  escalatedToName?: InputMaybe<TextSearchCriteriaInput>;
  /** The estimated time of arrival for the shipment related to this work order task. */
  estimatedTimeOfArrival?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Last date the LSP was notified on. */
  examLspNotifiedDate?: InputMaybe<DateSearchCriteriaInput>;
  /** Firms code associated with the exam site. */
  examSite?: InputMaybe<FirmsCodeSearchCriteriaInput>;
  /** The status of the exam being conducted on the entry. */
  examStatus?: InputMaybe<ExamStatusSearchCriteriaInput>;
  /** The specific type of exam conducted on the entry. */
  examSubType?: InputMaybe<ExamSubTypeSearchCriteriaInput>;
  /** The type of the exam conducted on the entry. */
  examType?: InputMaybe<ExamTypeSearchCriteriaInput>;
  /** The forwarders associated with the shipment for this work order task. */
  forwarderName?: InputMaybe<TextSearchCriteriaInput>;
  /** House bill of lading number */
  houseBill?: InputMaybe<TextSearchCriteriaInput>;
  /** The Record's ID. */
  id?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The related IOR's ID. */
  iorId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** IOR or Importer Entity identifiers (e.g., tax IDs, registration numbers) */
  iorIdentifiers?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The Importers of Record associated with the shipment for this work order task. */
  iorName?: InputMaybe<TextSearchCriteriaInput>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: InputMaybe<UsIorNumberValueSearchCriteriaInput>;
  /** Flag to denote the exception Work Order Task */
  isException?: InputMaybe<BooleanSearchCriteriaInput>;
  /** The latest time this task was escalated. */
  lastEscalationTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The ID of the operator who last replied. */
  lastRepliedById?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the operator who last replied. */
  lastRepliedByName?: InputMaybe<TextSearchCriteriaInput>;
  /** The latest time this task was replied at. */
  lastReplyTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The latest time this task's escalation was resolved. */
  lastResolutionTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: InputMaybe<WorkOrderMilestoneNameSearchCriteriaInput>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: InputMaybe<LoadTypeSearchCriteriaInput>;
  /** Master bill of lading number */
  masterBill?: InputMaybe<TextSearchCriteriaInput>;
  /** Work order task team. */
  minimumSkillRequired?: InputMaybe<MinimumSkillRequiredSearchCriteriaInput>;
  /** The mode of transport of the shipment linked to this task */
  modeOfTransport?: InputMaybe<ModeOfTransportSearchCriteriaInput>;
  /** The name of the task */
  name?: InputMaybe<TextSearchCriteriaInput>;
  /** The id of the operator linked to this task */
  operatorId?: InputMaybe<IdSearchCriteriaInput>;
  /** The related shipper's name. */
  shipperName?: InputMaybe<TextSearchCriteriaInput>;
  /** The related shipper's global logistics profile ID. */
  shipperProfileId?: InputMaybe<KeywordSearchCriteriaInput>;
  /** The status of the work order task */
  status?: InputMaybe<WorkOrderTaskStatusSearchCriteriaInput>;
  /** The sub status of the work order task */
  subStatus?: InputMaybe<WorkOrderTaskSubStatusSearchCriteriaInput>;
  /** The search criteria for tags. Functionality currently not available for table search. */
  tags?: InputMaybe<TagSearchCriteriaInput>;
  /** Work order task team. */
  teamId?: InputMaybe<IdSearchCriteriaInput>;
  /** The name of the team with which this task has been associated. */
  teamName?: InputMaybe<TextSearchCriteriaInput>;
  /** The time the Record was last updated. */
  updatedTime?: InputMaybe<DateTimeSearchCriteriaInput>;
  /** The id of the work order linked to this task */
  workOrderId?: InputMaybe<IdSearchCriteriaInput>;
  /** Status of the work order linked to the task */
  workOrderStatus?: InputMaybe<WorkOrderStatusSearchCriteriaInput>;
  /** The id of the task definition linked to this task */
  workOrderTaskDefinitionId?: InputMaybe<IdSearchCriteriaInput>;
  /** The type of work order task to be completed. */
  workOrderTaskType?: InputMaybe<WorkOrderTaskTypeSearchCriteriaInput>;
  /** The type of work order this task belongs to. */
  workOrderType?: InputMaybe<WorkOrderTypeSearchCriteriaInput>;
};

export type WorkOrderTaskSearchTableRow = RecordSearchTableRow & {
  __typename?: 'WorkOrderTaskSearchTableRow';
  /** The id of the assignee to whom this task has been assgined. */
  assigneeId?: Maybe<Scalars['ID']>;
  /** The name of the assignee to whom this task has been assigned. */
  assigneeName?: Maybe<Scalars['String']>;
  /** Work Order badge. Example: Hot */
  badge?: Maybe<Array<WorkOrderBadge>>;
  /** The blocked reason code for the work order */
  blockedReason?: Maybe<Array<WorkOrderBlockedReasonCode>>;
  /** Client booking id */
  bookingId?: Maybe<Scalars['String']>;
  /** The id of the broker linked to this task */
  brokerId: Scalars['ID'];
  /** The name of the broker linked to this task */
  brokerName?: Maybe<Scalars['String']>;
  /** The ID of the External Client the Record was canceled by. */
  canceledById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was canceled by. */
  canceledByName?: Maybe<Scalars['String']>;
  /** The time the Record was canceled. */
  canceledTime?: Maybe<Scalars['DateTime']>;
  /** The id of client that completed the task. */
  completedById?: Maybe<Scalars['ID']>;
  /** The name of client that completed the task. */
  completedByName?: Maybe<Scalars['String']>;
  /** The time at which the task completed. */
  completedTime?: Maybe<Scalars['DateTime']>;
  /** The container number */
  containerNumber?: Maybe<Array<Scalars['String']>>;
  /** The ID of the External Client the Record was created by. */
  createdById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was created by. */
  createdByName?: Maybe<Scalars['String']>;
  /** The time the Record was created. */
  createdTime: Scalars['DateTime'];
  /** The ID of the operator by whom this task is currently escalated. */
  currentlyEscalatedById?: Maybe<Scalars['ID']>;
  /** The name of the operator by whom this task is currently escalated. */
  currentlyEscalatedByName?: Maybe<Scalars['String']>;
  /** The ID of the operator to whom this task is currently escalated. */
  currentlyEscalatedToId?: Maybe<Scalars['ID']>;
  /** The name of the operator to whom this task is currently escalated. */
  currentlyEscalatedToName?: Maybe<Scalars['String']>;
  /** The IOR's status with customs authorities (e.g., CBP for US, HMRC for GB) */
  customsStatus?: Maybe<Scalars['String']>;
  /** The deadline for this task. */
  deadline?: Maybe<Scalars['DateTime']>;
  /** The ID of the External Client the Record was deleted by. */
  deletedById?: Maybe<Scalars['ID']>;
  /** The name of the External Client the Record was deleted by. */
  deletedByName?: Maybe<Scalars['String']>;
  /** The time the Record was deleted. */
  deletedTime?: Maybe<Scalars['DateTime']>;
  /** The entry number used by CBP to identify the entry. */
  entryNumber?: Maybe<Scalars['String']>;
  /** The IDs of the operators to whom this task has been escalated. */
  escalatedToId?: Maybe<Array<Scalars['ID']>>;
  /** The names of the operators to whom this task has been escalated. */
  escalatedToName?: Maybe<Array<Scalars['String']>>;
  /** The estimated time of arrival for the shipment related to this work order task. */
  estimatedTimeOfArrival?: Maybe<Scalars['DateTime']>;
  /** Last date the LSP was notified on. */
  examLspNotifiedDate?: Maybe<Scalars['DateTime__patched_over_by_INLT']>;
  /** Firms code associated with the exam site. */
  examSite?: Maybe<Scalars['String']>;
  /** The status of the exam being conducted on the entry. */
  examStatus?: Maybe<UsCbpEntryExamStatus>;
  /** The specific type of exam conducted on the entry. */
  examSubType?: Maybe<UsCbpEntryExamSubType>;
  /** The type of the exam conducted on the entry. */
  examType?: Maybe<UsCbpEntryExamType>;
  /** The forwarders associated with the shipment for this work order task. */
  forwarderName?: Maybe<Array<Scalars['String']>>;
  /** House bill of lading number */
  houseBill?: Maybe<Array<Scalars['String']>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The related IOR's ID. */
  iorId?: Maybe<Scalars['String']>;
  /** IOR or Importer Entity identifiers (e.g., tax IDs, registration numbers) */
  iorIdentifiers?: Maybe<Array<Scalars['String']>>;
  /** The Importers of Record associated with the shipment for this work order task. */
  iorName?: Maybe<Array<Scalars['String']>>;
  /** Importer of Record Number registered with US CBP. */
  iorNumber?: Maybe<Array<Scalars['UsIorNumberValue']>>;
  /** Flag to denote the exception Work Order Task */
  isException?: Maybe<Scalars['Boolean']>;
  /** The latest time this task was escalated. */
  lastEscalationTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the operator who last replied. */
  lastRepliedById?: Maybe<Scalars['ID']>;
  /** The name of the operator who last replied. */
  lastRepliedByName?: Maybe<Scalars['String']>;
  /** The latest time this task was replied at. */
  lastReplyTime?: Maybe<Scalars['DateTime']>;
  /** The latest time this task's escalation was resolved. */
  lastResolutionTime?: Maybe<Scalars['DateTime']>;
  /** Status of the entry, determined by the latest milestone. */
  latestMilestone?: Maybe<Scalars['String']>;
  /** The Load Type e.g. FCL, LCL */
  loadType?: Maybe<LoadType>;
  /** Master bill of lading number */
  masterBill?: Maybe<Array<Scalars['String']>>;
  /** Minimum Skill Level of Operator required to complete the task. */
  minimumSkillRequired?: Maybe<SkillLevel>;
  /** The mode of transport of the shipment linked to this task */
  modeOfTransport?: Maybe<Array<Scalars['String']>>;
  /** The name of the task */
  name: Scalars['String'];
  /** The related shipper's name. */
  shipperName?: Maybe<Scalars['String']>;
  /** The related shipper's global logistics profile ID. */
  shipperProfileId?: Maybe<Scalars['String']>;
  /** The status of the work order task */
  status: WorkOrderTaskStatus;
  /** The sub status of the work order task */
  subStatus?: Maybe<WorkOrderTaskSubStatus>;
  /** Work order task team. */
  teamId?: Maybe<Scalars['ID']>;
  /** The name of the team with which this task has been associated. */
  teamName?: Maybe<Scalars['String']>;
  /** The time the Record was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
  /** Version */
  version: Scalars['Int'];
  /** The id of the work order linked to this task */
  workOrderId: Scalars['ID'];
  /** Status of the work order linked to the task */
  workOrderStatus: WorkOrderStatus;
  /** The type of work order task to be completed. */
  workOrderTaskType: WorkOrderTaskType;
  /** The type of work order this task belongs to. */
  workOrderType: WorkOrderType;
};

export type WorkOrderTaskStatistics = {
  __typename?: 'WorkOrderTaskStatistics';
  /** The cumulated time interval when this task is actively in progress. Calculated in seconds. */
  activelyInProgressTimeInterval?: Maybe<Scalars['Float']>;
  /** The time interval when this task is assigned but not yet in progress. Calculated in seconds. */
  assignedTimeInterval?: Maybe<Scalars['Float']>;
  /** A list of time intervals by blocked reason code when this task is blocked. Calculated in seconds. */
  blockedReasonTimeIntervals?: Maybe<Array<WorkOrderTaskBlockedTimeInterval>>;
  /** The cumulated time interval when this task is blocked. Calculated in seconds. */
  blockedTimeInterval?: Maybe<Scalars['Float']>;
  /** A list of time intervals when this task is escalated. Calculated in seconds. */
  escalationTimeIntervals?: Maybe<Array<Scalars['Float']>>;
  /** An indicator of whether this task hits the SLA. */
  hitSla?: Maybe<Scalars['Boolean']>;
  /** The time interval when this task is not assigned. Calculated in seconds. */
  notAssignedTimeInterval?: Maybe<Scalars['Float']>;
  /** The cumulated time interval when this task is passively in progress. Calculated in seconds. */
  passivelyInProgressTimeInterval?: Maybe<Scalars['Float']>;
};

/** The work order task's status. */
export enum WorkOrderTaskStatus {
  ASSIGNED = 'ASSIGNED',
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  ESCALATED = 'ESCALATED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_ASSIGNED = 'NOT_ASSIGNED'
}

/** The reason for work order task status. */
export enum WorkOrderTaskStatusReason {
  APPROVED_CONFIRMATION = 'APPROVED_CONFIRMATION',
  DISPUTED_CONFIRMATION = 'DISPUTED_CONFIRMATION',
  PAYER_ACTIVE = 'PAYER_ACTIVE',
  PAYER_SUSPENDED = 'PAYER_SUSPENDED',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  PENDING_PAYMENT = 'PENDING_PAYMENT'
}

/** The work order task's status. */
export type WorkOrderTaskStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderTaskStatus>>;
};

export type WorkOrderTaskStep = EmbeddedRecord & {
  __typename?: 'WorkOrderTaskStep';
  /** When the step was completed */
  completed?: Maybe<RecordAction>;
  /** Information relating to the creation of the Embedded Record */
  created: RecordAction;
  /** Longer description of the step. */
  description?: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether this work order step is to be completed by system. If true, operators will not be able to mark this with via UI. */
  isCompletedBySystem?: Maybe<Scalars['Boolean']>;
  /** Used when finalizing the completion of a work order task by operators via the UI. If a work order step with isFinal = true is marked as completed, it means that the work order task is completed. */
  isFinalConfirmation?: Maybe<Scalars['Boolean']>;
  /** A short name for the step. */
  name: Scalars['String'];
  /** Information relating to the last update of the Embedded Record */
  updated: RecordAction;
};

/** The work order task's sub status. */
export enum WorkOrderTaskSubStatus {
  ACTIVELY_IN_PROGRESS = 'ACTIVELY_IN_PROGRESS',
  PASSIVELY_IN_PROGRESS = 'PASSIVELY_IN_PROGRESS',
  PENDING_INFORMATION = 'PENDING_INFORMATION'
}

/** The work order task's sub status. */
export type WorkOrderTaskSubStatusSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderTaskSubStatus>>;
};

/** The type of work order task to be completed. */
export enum WorkOrderTaskType {
  ACE_SYSTEM_ERROR_EXCEPTION = 'ACE_SYSTEM_ERROR_EXCEPTION',
  ACQUIRE_US_IOR_CONTINUOUS_BOND = 'ACQUIRE_US_IOR_CONTINUOUS_BOND',
  AMS_EXCEPTION = 'AMS_EXCEPTION',
  AMS_QUERY = 'AMS_QUERY',
  BROKER_TEAM_VETTING_TASK = 'BROKER_TEAM_VETTING_TASK',
  CUSTOMS_DECLARATION_BUILD_TRANSPORTATION_AND_INVOICE = 'CUSTOMS_DECLARATION_BUILD_TRANSPORTATION_AND_INVOICE',
  CUSTOMS_DECLARATION_DOCUMENT_REVIEW = 'CUSTOMS_DECLARATION_DOCUMENT_REVIEW',
  CUSTOMS_DECLARATION_DOWNLOAD_POST_RELEASE_DOCUMENT = 'CUSTOMS_DECLARATION_DOWNLOAD_POST_RELEASE_DOCUMENT',
  CUSTOMS_DECLARATION_DRAFT_ENTRY_CONFIRMATION = 'CUSTOMS_DECLARATION_DRAFT_ENTRY_CONFIRMATION',
  CUSTOMS_DECLARATION_DUTY_CHARGE_EXCEPTION = 'CUSTOMS_DECLARATION_DUTY_CHARGE_EXCEPTION',
  CUSTOMS_DECLARATION_FILING = 'CUSTOMS_DECLARATION_FILING',
  CUSTOMS_DECLARATION_POST_ENTRY_FINAL_SUBMISSION = 'CUSTOMS_DECLARATION_POST_ENTRY_FINAL_SUBMISSION',
  CUSTOMS_DECLARATION_POST_ENTRY_PACKET_EXCHANGE = 'CUSTOMS_DECLARATION_POST_ENTRY_PACKET_EXCHANGE',
  CUSTOMS_DECLARATION_PRE_ENTRY_PACKET_EXCHANGE = 'CUSTOMS_DECLARATION_PRE_ENTRY_PACKET_EXCHANGE',
  CUSTOMS_DECLARATION_UPLOAD_DRAFT_ENTRY_DOCUMENT = 'CUSTOMS_DECLARATION_UPLOAD_DRAFT_ENTRY_DOCUMENT',
  CUSTOMS_DECLARATION_UPLOAD_DUTIES = 'CUSTOMS_DECLARATION_UPLOAD_DUTIES',
  CUSTOMS_DECLARATION_UPLOAD_ECHALLAN = 'CUSTOMS_DECLARATION_UPLOAD_ECHALLAN',
  CUSTOMS_DECLARATION_UPLOAD_FINAL_CHARGES = 'CUSTOMS_DECLARATION_UPLOAD_FINAL_CHARGES',
  CUSTOMS_DECLARATION_UPLOAD_FINAL_ENTRY_DOCUMENT = 'CUSTOMS_DECLARATION_UPLOAD_FINAL_ENTRY_DOCUMENT',
  DELIVERY_ORDER_CREATION = 'DELIVERY_ORDER_CREATION',
  DESTINATION_TEAM_VETTING_TASK = 'DESTINATION_TEAM_VETTING_TASK',
  DE_CUSTOMS_ENTRY_REVIEW_DOCUMENTS = 'DE_CUSTOMS_ENTRY_REVIEW_DOCUMENTS',
  DE_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT = 'DE_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT',
  DE_CUSTOMS_ENTRY_UPLOAD_DUTIES = 'DE_CUSTOMS_ENTRY_UPLOAD_DUTIES',
  DE_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES = 'DE_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES',
  DE_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT = 'DE_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT',
  DE_IOR_ACTIVATION = 'DE_IOR_ACTIVATION',
  EU_CUSTOMS_ENTRY_BROKER_ERROR_EXCEPTION = 'EU_CUSTOMS_ENTRY_BROKER_ERROR_EXCEPTION',
  EU_CUSTOMS_ENTRY_CUSTOMS_REQUESTED_AMENDMENTS = 'EU_CUSTOMS_ENTRY_CUSTOMS_REQUESTED_AMENDMENTS',
  EU_CUSTOMS_ENTRY_CUSTOMS_SYSTEM_ERROR_EXCEPTION = 'EU_CUSTOMS_ENTRY_CUSTOMS_SYSTEM_ERROR_EXCEPTION',
  EU_CUSTOMS_ENTRY_SELLER_REQUESTED_AMENDMENTS = 'EU_CUSTOMS_ENTRY_SELLER_REQUESTED_AMENDMENTS',
  FR_CUSTOMS_ENTRY_REVIEW_DOCUMENTS = 'FR_CUSTOMS_ENTRY_REVIEW_DOCUMENTS',
  FR_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT = 'FR_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT',
  FR_CUSTOMS_ENTRY_UPLOAD_DUTIES = 'FR_CUSTOMS_ENTRY_UPLOAD_DUTIES',
  FR_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES = 'FR_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES',
  FR_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT = 'FR_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT',
  FR_IOR_ACTIVATION = 'FR_IOR_ACTIVATION',
  GB_CUSTOMS_ENTRY_REVIEW_DOCUMENTS = 'GB_CUSTOMS_ENTRY_REVIEW_DOCUMENTS',
  GB_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT = 'GB_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT',
  GB_CUSTOMS_ENTRY_UPLOAD_DUTIES = 'GB_CUSTOMS_ENTRY_UPLOAD_DUTIES',
  GB_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES = 'GB_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES',
  GB_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT = 'GB_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT',
  GB_IOR_ACTIVATION = 'GB_IOR_ACTIVATION',
  IMPORTER_ACTIVATION = 'IMPORTER_ACTIVATION',
  IMPORTER_ENTITY_ACTIVATION = 'IMPORTER_ENTITY_ACTIVATION',
  IMPORTER_REVIEW = 'IMPORTER_REVIEW',
  NL_CUSTOMS_ENTRY_REVIEW_DOCUMENTS = 'NL_CUSTOMS_ENTRY_REVIEW_DOCUMENTS',
  NL_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT = 'NL_CUSTOMS_ENTRY_UPLOAD_DRAFT_ENTRY_DOCUMENT',
  NL_CUSTOMS_ENTRY_UPLOAD_DUTIES = 'NL_CUSTOMS_ENTRY_UPLOAD_DUTIES',
  NL_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES = 'NL_CUSTOMS_ENTRY_UPLOAD_FINAL_CHARGES',
  NL_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT = 'NL_CUSTOMS_ENTRY_UPLOAD_FINAL_ENTRY_DOCUMENT',
  NL_IOR_ACTIVATION = 'NL_IOR_ACTIVATION',
  ORIGIN_TEAM_VETTING_TASK = 'ORIGIN_TEAM_VETTING_TASK',
  US_CONSUMPTION_ENTRY_AUTO_FLIP_EXCEPTION = 'US_CONSUMPTION_ENTRY_AUTO_FLIP_EXCEPTION',
  US_CONSUMPTION_ENTRY_BUILD_INVOICE = 'US_CONSUMPTION_ENTRY_BUILD_INVOICE',
  US_CONSUMPTION_ENTRY_BUILD_TRANSPORTATION_AND_INVOICE = 'US_CONSUMPTION_ENTRY_BUILD_TRANSPORTATION_AND_INVOICE',
  US_CONSUMPTION_ENTRY_CARGO_RELEASE_EXCEPTION = 'US_CONSUMPTION_ENTRY_CARGO_RELEASE_EXCEPTION',
  US_CONSUMPTION_ENTRY_CBP_CANCELLATION = 'US_CONSUMPTION_ENTRY_CBP_CANCELLATION',
  US_CONSUMPTION_ENTRY_CBP_EXAM = 'US_CONSUMPTION_ENTRY_CBP_EXAM',
  US_CONSUMPTION_ENTRY_CBP_HOLD = 'US_CONSUMPTION_ENTRY_CBP_HOLD',
  US_CONSUMPTION_ENTRY_CENSUS_WARNING = 'US_CONSUMPTION_ENTRY_CENSUS_WARNING',
  US_CONSUMPTION_ENTRY_COMPLETE_INVOICE = 'US_CONSUMPTION_ENTRY_COMPLETE_INVOICE',
  US_CONSUMPTION_ENTRY_COMPLETION_SUBMISSION = 'US_CONSUMPTION_ENTRY_COMPLETION_SUBMISSION',
  US_CONSUMPTION_ENTRY_CONSOLIDATION_COMPLETION = 'US_CONSUMPTION_ENTRY_CONSOLIDATION_COMPLETION',
  US_CONSUMPTION_ENTRY_DOCUMENT_TAGGING = 'US_CONSUMPTION_ENTRY_DOCUMENT_TAGGING',
  US_CONSUMPTION_ENTRY_EXCEPTION = 'US_CONSUMPTION_ENTRY_EXCEPTION',
  US_CONSUMPTION_ENTRY_FILING = 'US_CONSUMPTION_ENTRY_FILING',
  US_CONSUMPTION_ENTRY_LIQUIDATED_DAMAGES = 'US_CONSUMPTION_ENTRY_LIQUIDATED_DAMAGES',
  US_CONSUMPTION_ENTRY_NOTICE_OF_ACTION_TAKEN = 'US_CONSUMPTION_ENTRY_NOTICE_OF_ACTION_TAKEN',
  US_CONSUMPTION_ENTRY_NOTICE_OF_PROPOSED_ACTION = 'US_CONSUMPTION_ENTRY_NOTICE_OF_PROPOSED_ACTION',
  US_CONSUMPTION_ENTRY_PAYMENT_PROCESSING_EXCEPTION = 'US_CONSUMPTION_ENTRY_PAYMENT_PROCESSING_EXCEPTION',
  US_CONSUMPTION_ENTRY_PGA_EXCEPTION = 'US_CONSUMPTION_ENTRY_PGA_EXCEPTION',
  US_CONSUMPTION_ENTRY_PGA_HOLD = 'US_CONSUMPTION_ENTRY_PGA_HOLD',
  US_CONSUMPTION_ENTRY_PGA_REJECTION = 'US_CONSUMPTION_ENTRY_PGA_REJECTION',
  US_CONSUMPTION_ENTRY_POST_SUMMARY_CORRECTION = 'US_CONSUMPTION_ENTRY_POST_SUMMARY_CORRECTION',
  US_CONSUMPTION_ENTRY_PROTEST = 'US_CONSUMPTION_ENTRY_PROTEST',
  US_CONSUMPTION_ENTRY_REQUEST_FOR_INFORMATION = 'US_CONSUMPTION_ENTRY_REQUEST_FOR_INFORMATION',
  US_CONSUMPTION_ENTRY_REVISION = 'US_CONSUMPTION_ENTRY_REVISION',
  US_CONSUMPTION_ENTRY_SHIPMENT_INFO = 'US_CONSUMPTION_ENTRY_SHIPMENT_INFO',
  US_CONSUMPTION_ENTRY_SPLIT_COMPLETION_SUBMISSION = 'US_CONSUMPTION_ENTRY_SPLIT_COMPLETION_SUBMISSION',
  US_CONSUMPTION_ENTRY_STATEMENT_DATE_CALCULATION_EXCEPTION = 'US_CONSUMPTION_ENTRY_STATEMENT_DATE_CALCULATION_EXCEPTION',
  US_CONSUMPTION_ENTRY_STATEMENT_PROCESSING_EXCEPTION = 'US_CONSUMPTION_ENTRY_STATEMENT_PROCESSING_EXCEPTION',
  US_DRAWBACK_CLAIM_FILING = 'US_DRAWBACK_CLAIM_FILING',
  US_IN_BOND_FILING = 'US_IN_BOND_FILING',
  US_IOR_ACTIVATION = 'US_IOR_ACTIVATION',
  US_IOR_CONTINUOUS_BOND_CHARGE_BOND_RENEWAL_EXCEPTION = 'US_IOR_CONTINUOUS_BOND_CHARGE_BOND_RENEWAL_EXCEPTION',
  US_IOR_CONTINUOUS_BOND_VERIFY_RENEWAL_EXCEPTION = 'US_IOR_CONTINUOUS_BOND_VERIFY_RENEWAL_EXCEPTION',
  US_ISF_EXCEPTION = 'US_ISF_EXCEPTION',
  US_ISF_FILING = 'US_ISF_FILING',
  US_POST_SUMMARY_CORRECTION_FILING = 'US_POST_SUMMARY_CORRECTION_FILING',
  US_TYPE86_ENTRY_AUTO_FLIP_EXCEPTION = 'US_TYPE86_ENTRY_AUTO_FLIP_EXCEPTION',
  US_TYPE86_ENTRY_CBP_EXAM = 'US_TYPE86_ENTRY_CBP_EXAM',
  US_TYPE86_ENTRY_CBP_HOLD = 'US_TYPE86_ENTRY_CBP_HOLD',
  US_TYPE86_ENTRY_COMPLETION_AND_SUBMISSION = 'US_TYPE86_ENTRY_COMPLETION_AND_SUBMISSION',
  US_TYPE86_ENTRY_EXCEPTION = 'US_TYPE86_ENTRY_EXCEPTION',
  US_TYPE86_ENTRY_PGA_EXCEPTION = 'US_TYPE86_ENTRY_PGA_EXCEPTION',
  US_TYPE86_ENTRY_PGA_HOLD = 'US_TYPE86_ENTRY_PGA_HOLD'
}

/** The type of work order task to be completed. */
export type WorkOrderTaskTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderTaskType>>;
};

export type WorkOrderTasksConnection = Connection & {
  __typename?: 'WorkOrderTasksConnection';
  edges: Array<WorkOrderTaskEdge>;
  nodes: Array<WorkOrderTask>;
  /** https://graphql.org/learn/pagination/#complete-connection-model */
  pageInfo: CursorPagination;
};

/** The transaction represents a Work Order related request and response */
export type WorkOrderTransaction = {
  /** Information relating to the creation of the Record */
  created: RecordAction;
  /** Information relating to the deletion of the Record */
  deleted?: Maybe<RecordAction>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Arbitrary tags added to the record */
  tags: Array<Tag>;
  /** Information relating to the last update of the Record */
  updated: RecordAction;
  /** The record's version */
  version: Scalars['Int'];
  workOrder: WorkOrder;
};

/** The type of Work Order. */
export enum WorkOrderType {
  CustomsDeclaration = 'CustomsDeclaration',
  DeCustomsEntry = 'DeCustomsEntry',
  DeIorActivation = 'DeIorActivation',
  DeliveryOrder = 'DeliveryOrder',
  FrCustomsEntry = 'FrCustomsEntry',
  FrIorActivation = 'FrIorActivation',
  GbCustomsEntry = 'GbCustomsEntry',
  GbIorActivation = 'GbIorActivation',
  ImporterEntityActivation = 'ImporterEntityActivation',
  NlCustomsEntry = 'NlCustomsEntry',
  NlIorActivation = 'NlIorActivation',
  UsConsumptionEntry = 'UsConsumptionEntry',
  UsDrawbackClaim = 'UsDrawbackClaim',
  UsInBond = 'UsInBond',
  UsIorActivation = 'UsIorActivation',
  UsIorContinuousBondRequest = 'UsIorContinuousBondRequest',
  UsIsf = 'UsIsf',
  UsPostSummaryCorrection = 'UsPostSummaryCorrection',
  UsType86Entry = 'UsType86Entry'
}

export type WorkOrderTypeSearchCriteriaInput = {
  /** Operators available when searcing for number data types. */
  operator: KeywordSearchOperator;
  /** The field's enum values to be searched for. */
  values?: InputMaybe<Array<WorkOrderType>>;
};

export type XbtBusinessId = {
  __typename?: 'XbtBusinessId';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum XbtProgram {
  CUSTOMS_BROKER = 'CUSTOMS_BROKER',
  FREIGHT = 'FREIGHT',
  IMPORTER = 'IMPORTER',
  SMALL_PARCEL = 'SMALL_PARCEL'
}

export type XbtShipperProfile = {
  __typename?: 'XbtShipperProfile';
  activated?: Maybe<Scalars['Boolean']>;
  aspects?: Maybe<Array<Scalars['JSONObject']>>;
  businessId?: Maybe<XbtBusinessId>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['String']>;
  programProfileByType?: Maybe<Scalars['JSONObject']>;
  submitted?: Maybe<Scalars['Boolean']>;
  timeCreated?: Maybe<Scalars['Float']>;
  timeModified?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

export type XbtShipperProfilePayload = {
  __typename?: 'XbtShipperProfilePayload';
  error?: Maybe<Scalars['String']>;
  response?: Maybe<XbtShipperProfile>;
};

export type getShipmentComplianceDetailsPayload = {
  __typename?: 'getShipmentComplianceDetailsPayload';
  /** compliance Details in the commercial invoice */
  complianceDetails?: Maybe<Array<ShipmentComplianceDetail>>;
  /** if empty then there is no more data. if this has a value then use it in the subsequent call */
  nextCursor?: Maybe<Scalars['String']>;
};

export type ActivateUserMutationVariables = Exact<{
  linkHash: Scalars['String'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'ActivateUserPayload', success: boolean } };

export type GetWorkOrderWithMilestonesQueryVariables = Exact<{
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
}>;


export type GetWorkOrderWithMilestonesQuery = { __typename?: 'Query', workOrder: { __typename?: 'CustomsDeclaration', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'CustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'DeCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'DeIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'DeliveryOrder', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'FrCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'FrIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'GbCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'GbIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'ImporterEntityActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'NlCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'NlIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsConsumptionEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsDrawbackClaim', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsInBond', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsIorContinuousBondRequest', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsIsf', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsPostSummaryCorrection', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } | { __typename?: 'UsType86Entry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, version: number, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }> } };

export type UpdateExchangeMessageMutationVariables = Exact<{
  version: Scalars['Int'];
  id: Scalars['ID'];
  input: UpdateExchangeMessageInput;
}>;


export type UpdateExchangeMessageMutation = { __typename?: 'Mutation', updateExchangeMessage: { __typename?: 'UpdateExchangeMessagePayload', record: { __typename?: 'ExchangeMessage', id: string } } };

export type UpdateDocumentMutationVariables = Exact<{
  version: Scalars['Int'];
  id: Scalars['ID'];
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'UpdateDocumentPayload', record: { __typename?: 'Document', id: string } } };

export type UsConsumptionEntryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UsConsumptionEntryQuery = { __typename?: 'Query', usConsumptionEntry: { __typename?: 'UsConsumptionEntry', group: { __typename?: 'WorkOrderGroup', id: string, shipment?: { __typename?: 'Shipment', id: string } | null } } };

export type queryChannelConnectionStatusQueryVariables = Exact<{
  input: QueryChannelConnectionStatusInput;
}>;


export type queryChannelConnectionStatusQuery = { __typename?: 'Query', queryChannelConnectionStatus: { __typename?: 'QueryChannelConnectionStatusPayload', status: ConnectionStatus, statusHistory: Array<{ __typename?: 'ConnectionStatusUpdate', status: string, time: any }> } };

export type createOneMutationVariables = Exact<{
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderMilestoneInput;
}>;


export type createOneMutation = { __typename?: 'Mutation', createWorkOrderMilestone: { __typename?: 'CreateWorkOrderMilestonePayload', record: { __typename?: 'WorkOrderMilestone', id: string, version: number } } };

export type GetCpscCitationCodesPresignedUrlQueryVariables = Exact<{
  codeType: CpscCitationCodeType;
}>;


export type GetCpscCitationCodesPresignedUrlQuery = { __typename?: 'Query', getCpscCitationCodesPresignedUrl: { __typename?: 'CpscCitationCodeUrlResponse', url: string, codeType: CpscCitationCodeType, expiresIn: number } };

export type adjustmentFieldsFragment = { __typename?: 'UsConsumptionEntryCommercialInvoiceAdjustment', type: UsConsumptionEntryCommercialInvoiceAdjustmentType, description: string, value: { __typename?: 'Cost', value: number, currency: any } };

export type InvoiceSummaryFragment = { __typename?: 'UsConsumptionEntryCommercialInvoice', invoiceNumber?: string | null, currencyRate?: number | null, assist?: { __typename?: 'Cost', value: number } | null, value?: { __typename?: 'Cost', value: number, currency: any } | null };

export type createWorkOrderTaskMutationVariables = Exact<{
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderTaskInput;
}>;


export type createWorkOrderTaskMutation = { __typename?: 'Mutation', createWorkOrderTask: { __typename?: 'CreateWorkOrderTaskPayload', record: { __typename?: 'WorkOrderTask', id: string } } };

export type SearchTruckersQueryVariables = Exact<{
  input: SearchTruckerInput;
}>;


export type SearchTruckersQuery = { __typename?: 'Query', searchTruckers: { __typename?: 'SearchTruckerPayload', results: Array<{ __typename?: 'Trucker', name: string, scac?: any | null, id: string }> } };

export type GetOperatorUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOperatorUserQuery = { __typename?: 'Query', operatorUser: { __typename?: 'OperatorUser', id: string, name: string } };

export type ReplyWorkOrderTaskEscalationMutationVariables = Exact<{
  input: TaskEscalationReplyDetailsInput;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type ReplyWorkOrderTaskEscalationMutation = { __typename?: 'Mutation', replyWorkOrderTaskEscalation: { __typename?: 'TaskEscalationReplyPayload', workOrderTask: { __typename?: 'WorkOrderTask', id: string } } };

export type searchUsHtssQueryVariables = Exact<{
  input: SearchUsHtsInput;
}>;


export type searchUsHtssQuery = { __typename?: 'Query', searchUsHtss: { __typename?: 'SearchUsHtsPayload', results: Array<{ __typename?: 'UsHts', id: string, version: number, number: any, additionalHtssApplicable?: Array<{ __typename?: 'AdditionalHts', number: string, type?: AdditionalHtsType | null, startDate?: any | null, exportGroup?: string | null, additionalTypeDescription?: string | null }> | null }> } };

export type addressFieldsFragment = { __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null };

type addressesFields_Broker_Fragment = { __typename?: 'Broker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_CustomsAgent_Fragment = { __typename?: 'CustomsAgent', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_DeConsignee_Fragment = { __typename?: 'DeConsignee', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_DeCustomsBroker_Fragment = { __typename?: 'DeCustomsBroker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_DeIor_Fragment = { __typename?: 'DeIor', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Facility_Fragment = { __typename?: 'Facility', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Forwarder_Fragment = { __typename?: 'Forwarder', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_FrConsignee_Fragment = { __typename?: 'FrConsignee', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_FrCustomsBroker_Fragment = { __typename?: 'FrCustomsBroker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_FrIor_Fragment = { __typename?: 'FrIor', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_GbConsignee_Fragment = { __typename?: 'GbConsignee', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_GbIor_Fragment = { __typename?: 'GbIor', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_GlobalConsignee_Fragment = { __typename?: 'GlobalConsignee', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Importer_Fragment = { __typename?: 'Importer', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_NlConsignee_Fragment = { __typename?: 'NlConsignee', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_NlCustomsBroker_Fragment = { __typename?: 'NlCustomsBroker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_NlIor_Fragment = { __typename?: 'NlIor', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Operator_Fragment = { __typename?: 'Operator', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Shipper_Fragment = { __typename?: 'Shipper', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Supplier_Fragment = { __typename?: 'Supplier', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_Trucker_Fragment = { __typename?: 'Trucker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_UkCustomsBroker_Fragment = { __typename?: 'UkCustomsBroker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_UsConsignee_Fragment = { __typename?: 'UsConsignee', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_UsCustomsBroker_Fragment = { __typename?: 'UsCustomsBroker', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type addressesFields_UsIor_Fragment = { __typename?: 'UsIor', addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

export type addressesFieldsFragment = addressesFields_Broker_Fragment | addressesFields_CustomsAgent_Fragment | addressesFields_DeConsignee_Fragment | addressesFields_DeCustomsBroker_Fragment | addressesFields_DeIor_Fragment | addressesFields_Facility_Fragment | addressesFields_Forwarder_Fragment | addressesFields_FrConsignee_Fragment | addressesFields_FrCustomsBroker_Fragment | addressesFields_FrIor_Fragment | addressesFields_GbConsignee_Fragment | addressesFields_GbIor_Fragment | addressesFields_GlobalConsignee_Fragment | addressesFields_Importer_Fragment | addressesFields_NlConsignee_Fragment | addressesFields_NlCustomsBroker_Fragment | addressesFields_NlIor_Fragment | addressesFields_Operator_Fragment | addressesFields_Shipper_Fragment | addressesFields_Supplier_Fragment | addressesFields_Trucker_Fragment | addressesFields_UkCustomsBroker_Fragment | addressesFields_UsConsignee_Fragment | addressesFields_UsCustomsBroker_Fragment | addressesFields_UsIor_Fragment;

export type phoneFieldsFragment = { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null };

export type recordActionFieldsFragment = { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null };

type recordFields_ActionInBondCbpTransaction_Fragment = { __typename?: 'ActionInBondCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AdCvdCase_Fragment = { __typename?: 'AdCvdCase', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AssignmentTeam_Fragment = { __typename?: 'AssignmentTeam', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AssignmentTeamOperatorUserRelationship_Fragment = { __typename?: 'AssignmentTeamOperatorUserRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AssignmentTeamOperatorUserRelationshipBase_Fragment = { __typename?: 'AssignmentTeamOperatorUserRelationshipBase', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AssignmentTeamStaticMapping_Fragment = { __typename?: 'AssignmentTeamStaticMapping', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AuthenticationToken_Fragment = { __typename?: 'AuthenticationToken', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_AuthorizeUsCbpEntryDailyStatementDebitTransaction_Fragment = { __typename?: 'AuthorizeUsCbpEntryDailyStatementDebitTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Broker_Fragment = { __typename?: 'Broker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BulkChargesUploadRequest_Fragment = { __typename?: 'BulkChargesUploadRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BulkComplianceUploadRequest_Fragment = { __typename?: 'BulkComplianceUploadRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BulkMilestoneUploadRequest_Fragment = { __typename?: 'BulkMilestoneUploadRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BulkProductUploadTemplateDocumentGenerationRequest_Fragment = { __typename?: 'BulkProductUploadTemplateDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BusinessSupportTeam_Fragment = { __typename?: 'BusinessSupportTeam', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BusinessSupportTeamOperatorUserRelationship_Fragment = { __typename?: 'BusinessSupportTeamOperatorUserRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_BusinessSupportTeamOperatorUserRelationshipBase_Fragment = { __typename?: 'BusinessSupportTeamOperatorUserRelationshipBase', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CaseCategoryConfig_Fragment = { __typename?: 'CaseCategoryConfig', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Changelog_Fragment = { __typename?: 'Changelog', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CommodityGroup_Fragment = { __typename?: 'CommodityGroup', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CreateUsConsigneeCbp5106Transaction_Fragment = { __typename?: 'CreateUsConsigneeCbp5106Transaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CreateUsConsumptionEntryReleaseCbpTransaction_Fragment = { __typename?: 'CreateUsConsumptionEntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CreateUsDrawbackClaimCbpTransaction_Fragment = { __typename?: 'CreateUsDrawbackClaimCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CreateUsIorCbp5106Transaction_Fragment = { __typename?: 'CreateUsIorCbp5106Transaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CreateUsIsfCbpTransaction_Fragment = { __typename?: 'CreateUsIsfCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CreateUsType86EntryReleaseCbpTransaction_Fragment = { __typename?: 'CreateUsType86EntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CustomDomain_Fragment = { __typename?: 'CustomDomain', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CustomsAgent_Fragment = { __typename?: 'CustomsAgent', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CustomsDeclaration_Fragment = { __typename?: 'CustomsDeclaration', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_CustomsEntry_Fragment = { __typename?: 'CustomsEntry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeConsignee_Fragment = { __typename?: 'DeConsignee', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeCustomsBroker_Fragment = { __typename?: 'DeCustomsBroker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeCustomsEntry_Fragment = { __typename?: 'DeCustomsEntry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeIor_Fragment = { __typename?: 'DeIor', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeIorActivation_Fragment = { __typename?: 'DeIorActivation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeleteInBondBillCbpTransaction_Fragment = { __typename?: 'DeleteInBondBillCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeleteInBondCbpTransaction_Fragment = { __typename?: 'DeleteInBondCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeleteUsConsumptionEntryReleaseCbpTransaction_Fragment = { __typename?: 'DeleteUsConsumptionEntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeleteUsConsumptionEntrySummaryCbpTransaction_Fragment = { __typename?: 'DeleteUsConsumptionEntrySummaryCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeleteUsIsfCbpTransaction_Fragment = { __typename?: 'DeleteUsIsfCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeleteUsType86EntryReleaseCbpTransaction_Fragment = { __typename?: 'DeleteUsType86EntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeliveryOrder_Fragment = { __typename?: 'DeliveryOrder', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DeliveryOrderDocumentGenerationRequest_Fragment = { __typename?: 'DeliveryOrderDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Document_Fragment = { __typename?: 'Document', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DocumentTemplate_Fragment = { __typename?: 'DocumentTemplate', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_DpsRecord_Fragment = { __typename?: 'DpsRecord', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ErrorDefinition_Fragment = { __typename?: 'ErrorDefinition', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_EuHs_Fragment = { __typename?: 'EuHs', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ExcelTemplateDocumentGenerationRequest_Fragment = { __typename?: 'ExcelTemplateDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ExchangeMessage_Fragment = { __typename?: 'ExchangeMessage', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Facility_Fragment = { __typename?: 'Facility', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_FeatureFlag_Fragment = { __typename?: 'FeatureFlag', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Forwarder_Fragment = { __typename?: 'Forwarder', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ForwarderSystem_Fragment = { __typename?: 'ForwarderSystem', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ForwarderUser_Fragment = { __typename?: 'ForwarderUser', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_FrConsignee_Fragment = { __typename?: 'FrConsignee', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_FrCustomsBroker_Fragment = { __typename?: 'FrCustomsBroker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_FrCustomsEntry_Fragment = { __typename?: 'FrCustomsEntry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_FrIor_Fragment = { __typename?: 'FrIor', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_FrIorActivation_Fragment = { __typename?: 'FrIorActivation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_GbConsignee_Fragment = { __typename?: 'GbConsignee', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_GbCustomsEntry_Fragment = { __typename?: 'GbCustomsEntry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_GbIor_Fragment = { __typename?: 'GbIor', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_GbIorActivation_Fragment = { __typename?: 'GbIorActivation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_GenericDocumentGenerationRequest_Fragment = { __typename?: 'GenericDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_GlobalConsignee_Fragment = { __typename?: 'GlobalConsignee', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_HtmlDocumentGenerationRequest_Fragment = { __typename?: 'HtmlDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Importer_Fragment = { __typename?: 'Importer', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ImporterEntity_Fragment = { __typename?: 'ImporterEntity', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ImporterEntityActivation_Fragment = { __typename?: 'ImporterEntityActivation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ImporterImporterEntityRelationship_Fragment = { __typename?: 'ImporterImporterEntityRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_InBondNotesDocumentGenerationRequest_Fragment = { __typename?: 'InBondNotesDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Invoice_Fragment = { __typename?: 'Invoice', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_InvoiceCreditNote_Fragment = { __typename?: 'InvoiceCreditNote', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_InvoiceCreditNoteDocumentGenerationRequest_Fragment = { __typename?: 'InvoiceCreditNoteDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_InvoiceDocumentGenerationRequest_Fragment = { __typename?: 'InvoiceDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_InvoiceLinesRequest_Fragment = { __typename?: 'InvoiceLinesRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_InvoicePayment_Fragment = { __typename?: 'InvoicePayment', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Memo_Fragment = { __typename?: 'Memo', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_NlConsignee_Fragment = { __typename?: 'NlConsignee', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_NlCustomsBroker_Fragment = { __typename?: 'NlCustomsBroker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_NlCustomsEntry_Fragment = { __typename?: 'NlCustomsEntry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_NlIor_Fragment = { __typename?: 'NlIor', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_NlIorActivation_Fragment = { __typename?: 'NlIorActivation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_OnboardingRequest_Fragment = { __typename?: 'OnboardingRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Operator_Fragment = { __typename?: 'Operator', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_OperatorSystem_Fragment = { __typename?: 'OperatorSystem', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_OperatorUser_Fragment = { __typename?: 'OperatorUser', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_PayableInvoice_Fragment = { __typename?: 'PayableInvoice', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ProcessingError_Fragment = { __typename?: 'ProcessingError', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Product_Fragment = { __typename?: 'Product', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Program_Fragment = { __typename?: 'Program', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryAdCvdCaseCbpTransaction_Fragment = { __typename?: 'QueryAdCvdCaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryAmsTransaction_Fragment = { __typename?: 'QueryAmsTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryAmsUsConsumptionEntryTransaction_Fragment = { __typename?: 'QueryAmsUsConsumptionEntryTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryAmsUsInBondTransaction_Fragment = { __typename?: 'QueryAmsUsInBondTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryAmsUsIsfTransaction_Fragment = { __typename?: 'QueryAmsUsIsfTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryAmsUsType86EntryTransaction_Fragment = { __typename?: 'QueryAmsUsType86EntryTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryCarrierCodeCbpTransaction_Fragment = { __typename?: 'QueryCarrierCodeCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryCbpByIorNumberTransaction_Fragment = { __typename?: 'QueryCbpByIorNumberTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryEntryNumberCbpTransaction_Fragment = { __typename?: 'QueryEntryNumberCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryFirmsCodeCbpTransaction_Fragment = { __typename?: 'QueryFirmsCodeCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryHtsCbpTransaction_Fragment = { __typename?: 'QueryHtsCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryUsConsigneeCbpTransaction_Fragment = { __typename?: 'QueryUsConsigneeCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryUsConsumptionEntrySummaryCbpTransaction_Fragment = { __typename?: 'QueryUsConsumptionEntrySummaryCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryUsIorCbpTransaction_Fragment = { __typename?: 'QueryUsIorCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryUsPostSummaryCorrectionCbpTransaction_Fragment = { __typename?: 'QueryUsPostSummaryCorrectionCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_QueryUsType86EntryReleaseCbpTransaction_Fragment = { __typename?: 'QueryUsType86EntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Reimbursement_Fragment = { __typename?: 'Reimbursement', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ReleaseNote_Fragment = { __typename?: 'ReleaseNote', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ReplaceUsConsumptionEntryReleaseCbpTransaction_Fragment = { __typename?: 'ReplaceUsConsumptionEntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ReplaceUsType86EntryReleaseCbpTransaction_Fragment = { __typename?: 'ReplaceUsType86EntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ReportReconciliationRequest_Fragment = { __typename?: 'ReportReconciliationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_RequestUsIorCbpAssignedNumberTransaction_Fragment = { __typename?: 'RequestUsIorCbpAssignedNumberTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SendWorkOrderDocumentsTo3pTransaction_Fragment = { __typename?: 'SendWorkOrderDocumentsTo3pTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SendWorkOrderDocumentsToExternalSystemTransaction_Fragment = { __typename?: 'SendWorkOrderDocumentsToExternalSystemTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Shipment_Fragment = { __typename?: 'Shipment', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipmentCommercialInvoiceDetail_Fragment = { __typename?: 'ShipmentCommercialInvoiceDetail', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipmentDocumentProcessingRequest_Fragment = { __typename?: 'ShipmentDocumentProcessingRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Shipper_Fragment = { __typename?: 'Shipper', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperBrokerRelationship_Fragment = { __typename?: 'ShipperBrokerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperCustomsAgentRelationship_Fragment = { __typename?: 'ShipperCustomsAgentRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperDeConsigneeRelationship_Fragment = { __typename?: 'ShipperDeConsigneeRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperDeCustomsBrokerRelationship_Fragment = { __typename?: 'ShipperDeCustomsBrokerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperDeIorRelationship_Fragment = { __typename?: 'ShipperDeIorRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperFacilityRelationship_Fragment = { __typename?: 'ShipperFacilityRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperForwarderRelationship_Fragment = { __typename?: 'ShipperForwarderRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperFrConsigneeRelationship_Fragment = { __typename?: 'ShipperFrConsigneeRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperFrCustomsBrokerRelationship_Fragment = { __typename?: 'ShipperFrCustomsBrokerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperFrIorRelationship_Fragment = { __typename?: 'ShipperFrIorRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperGbConsigneeRelationship_Fragment = { __typename?: 'ShipperGbConsigneeRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperGbIorRelationship_Fragment = { __typename?: 'ShipperGbIorRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperGlobalConsigneeRelationship_Fragment = { __typename?: 'ShipperGlobalConsigneeRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperImporterRelationship_Fragment = { __typename?: 'ShipperImporterRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperNlConsigneeRelationship_Fragment = { __typename?: 'ShipperNlConsigneeRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperNlCustomsBrokerRelationship_Fragment = { __typename?: 'ShipperNlCustomsBrokerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperNlIorRelationship_Fragment = { __typename?: 'ShipperNlIorRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperSupplierRelationship_Fragment = { __typename?: 'ShipperSupplierRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperSystem_Fragment = { __typename?: 'ShipperSystem', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperTruckerRelationship_Fragment = { __typename?: 'ShipperTruckerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperUkCustomsBrokerRelationship_Fragment = { __typename?: 'ShipperUkCustomsBrokerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperUsConsigneeRelationship_Fragment = { __typename?: 'ShipperUsConsigneeRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperUsCustomsBrokerRelationship_Fragment = { __typename?: 'ShipperUsCustomsBrokerRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperUsIorRelationship_Fragment = { __typename?: 'ShipperUsIorRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_ShipperUser_Fragment = { __typename?: 'ShipperUser', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_StampDocumentGenerationRequest_Fragment = { __typename?: 'StampDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_StampDocumentSignRequest_Fragment = { __typename?: 'StampDocumentSignRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubjectMatterExpertTeam_Fragment = { __typename?: 'SubjectMatterExpertTeam', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubjectMatterExpertTeamOperatorUserRelationship_Fragment = { __typename?: 'SubjectMatterExpertTeamOperatorUserRelationship', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubjectMatterExpertTeamOperatorUserRelationshipBase_Fragment = { __typename?: 'SubjectMatterExpertTeamOperatorUserRelationshipBase', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubmitInBondCbpTransaction_Fragment = { __typename?: 'SubmitInBondCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubmitUsConsumptionEntryDisTransaction_Fragment = { __typename?: 'SubmitUsConsumptionEntryDisTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubmitUsDrawbackClaimDisTransaction_Fragment = { __typename?: 'SubmitUsDrawbackClaimDisTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_SubmitUsType86EntryDisTransaction_Fragment = { __typename?: 'SubmitUsType86EntryDisTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Supplier_Fragment = { __typename?: 'Supplier', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_TableFilter_Fragment = { __typename?: 'TableFilter', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Team_Fragment = { __typename?: 'Team', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_TemplateDocumentSignRequest_Fragment = { __typename?: 'TemplateDocumentSignRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_Trucker_Fragment = { __typename?: 'Trucker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UkCustomsBroker_Fragment = { __typename?: 'UkCustomsBroker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UkHs_Fragment = { __typename?: 'UkHs', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsConsigneeCbp5106Transaction_Fragment = { __typename?: 'UpdateUsConsigneeCbp5106Transaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsConsumptionEntryPgaCbpTransaction_Fragment = { __typename?: 'UpdateUsConsumptionEntryPgaCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsConsumptionEntryReleaseCbpTransaction_Fragment = { __typename?: 'UpdateUsConsumptionEntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsConsumptionEntryStatementCbpTransaction_Fragment = { __typename?: 'UpdateUsConsumptionEntryStatementCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsDrawbackClaimCbpTransaction_Fragment = { __typename?: 'UpdateUsDrawbackClaimCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsIorCbp5106Transaction_Fragment = { __typename?: 'UpdateUsIorCbp5106Transaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsIsfCbpTransaction_Fragment = { __typename?: 'UpdateUsIsfCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsType86EntryPgaCbpTransaction_Fragment = { __typename?: 'UpdateUsType86EntryPgaCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpdateUsType86EntryReleaseCbpTransaction_Fragment = { __typename?: 'UpdateUsType86EntryReleaseCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpsertSupplierCbpMidTransaction_Fragment = { __typename?: 'UpsertSupplierCbpMidTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpsertUsConsumptionEntrySummaryCbpTransaction_Fragment = { __typename?: 'UpsertUsConsumptionEntrySummaryCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UpsertUsPostSummaryCorrectionCbpTransaction_Fragment = { __typename?: 'UpsertUsPostSummaryCorrectionCbpTransaction', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsCargoReleaseDocumentGenerationRequest_Fragment = { __typename?: 'UsCargoReleaseDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsCbp5106DocumentGenerationRequest_Fragment = { __typename?: 'UsCbp5106DocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsCbp7501DocumentGenerationRequest_Fragment = { __typename?: 'UsCbp7501DocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsCbp7512DocumentGenerationRequest_Fragment = { __typename?: 'UsCbp7512DocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsConsignee_Fragment = { __typename?: 'UsConsignee', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsConsumptionEntry_Fragment = { __typename?: 'UsConsumptionEntry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsCustomsBroker_Fragment = { __typename?: 'UsCustomsBroker', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsDrawbackClaim_Fragment = { __typename?: 'UsDrawbackClaim', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsDrawbackClaimDocumentGenerationRequest_Fragment = { __typename?: 'UsDrawbackClaimDocumentGenerationRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsHts_Fragment = { __typename?: 'UsHts', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsInBond_Fragment = { __typename?: 'UsInBond', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsIor_Fragment = { __typename?: 'UsIor', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsIorActivation_Fragment = { __typename?: 'UsIorActivation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsIorContinuousBondRequest_Fragment = { __typename?: 'UsIorContinuousBondRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsIsf_Fragment = { __typename?: 'UsIsf', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsPostSummaryCorrection_Fragment = { __typename?: 'UsPostSummaryCorrection', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsPrincipalAdCvdCase_Fragment = { __typename?: 'UsPrincipalAdCvdCase', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UsType86Entry_Fragment = { __typename?: 'UsType86Entry', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_UserReleaseNoteView_Fragment = { __typename?: 'UserReleaseNoteView', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderConfirmation_Fragment = { __typename?: 'WorkOrderConfirmation', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderDocumentProcessingRequest_Fragment = { __typename?: 'WorkOrderDocumentProcessingRequest', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderGroup_Fragment = { __typename?: 'WorkOrderGroup', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderMilestone_Fragment = { __typename?: 'WorkOrderMilestone', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderStateMachine_Fragment = { __typename?: 'WorkOrderStateMachine', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderTask_Fragment = { __typename?: 'WorkOrderTask', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderTaskDefinition_Fragment = { __typename?: 'WorkOrderTaskDefinition', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

type recordFields_WorkOrderTaskEscalationMessage_Fragment = { __typename?: 'WorkOrderTaskEscalationMessage', id: string, version: number, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

export type recordFieldsFragment = recordFields_ActionInBondCbpTransaction_Fragment | recordFields_AdCvdCase_Fragment | recordFields_AssignmentTeam_Fragment | recordFields_AssignmentTeamOperatorUserRelationship_Fragment | recordFields_AssignmentTeamOperatorUserRelationshipBase_Fragment | recordFields_AssignmentTeamStaticMapping_Fragment | recordFields_AuthenticationToken_Fragment | recordFields_AuthorizeUsCbpEntryDailyStatementDebitTransaction_Fragment | recordFields_Broker_Fragment | recordFields_BulkChargesUploadRequest_Fragment | recordFields_BulkComplianceUploadRequest_Fragment | recordFields_BulkMilestoneUploadRequest_Fragment | recordFields_BulkProductUploadTemplateDocumentGenerationRequest_Fragment | recordFields_BusinessSupportTeam_Fragment | recordFields_BusinessSupportTeamOperatorUserRelationship_Fragment | recordFields_BusinessSupportTeamOperatorUserRelationshipBase_Fragment | recordFields_CaseCategoryConfig_Fragment | recordFields_Changelog_Fragment | recordFields_CommodityGroup_Fragment | recordFields_CreateUsConsigneeCbp5106Transaction_Fragment | recordFields_CreateUsConsumptionEntryReleaseCbpTransaction_Fragment | recordFields_CreateUsDrawbackClaimCbpTransaction_Fragment | recordFields_CreateUsIorCbp5106Transaction_Fragment | recordFields_CreateUsIsfCbpTransaction_Fragment | recordFields_CreateUsType86EntryReleaseCbpTransaction_Fragment | recordFields_CustomDomain_Fragment | recordFields_CustomsAgent_Fragment | recordFields_CustomsDeclaration_Fragment | recordFields_CustomsEntry_Fragment | recordFields_DeConsignee_Fragment | recordFields_DeCustomsBroker_Fragment | recordFields_DeCustomsEntry_Fragment | recordFields_DeIor_Fragment | recordFields_DeIorActivation_Fragment | recordFields_DeleteInBondBillCbpTransaction_Fragment | recordFields_DeleteInBondCbpTransaction_Fragment | recordFields_DeleteUsConsumptionEntryReleaseCbpTransaction_Fragment | recordFields_DeleteUsConsumptionEntrySummaryCbpTransaction_Fragment | recordFields_DeleteUsIsfCbpTransaction_Fragment | recordFields_DeleteUsType86EntryReleaseCbpTransaction_Fragment | recordFields_DeliveryOrder_Fragment | recordFields_DeliveryOrderDocumentGenerationRequest_Fragment | recordFields_Document_Fragment | recordFields_DocumentTemplate_Fragment | recordFields_DpsRecord_Fragment | recordFields_ErrorDefinition_Fragment | recordFields_EuHs_Fragment | recordFields_ExcelTemplateDocumentGenerationRequest_Fragment | recordFields_ExchangeMessage_Fragment | recordFields_Facility_Fragment | recordFields_FeatureFlag_Fragment | recordFields_Forwarder_Fragment | recordFields_ForwarderSystem_Fragment | recordFields_ForwarderUser_Fragment | recordFields_FrConsignee_Fragment | recordFields_FrCustomsBroker_Fragment | recordFields_FrCustomsEntry_Fragment | recordFields_FrIor_Fragment | recordFields_FrIorActivation_Fragment | recordFields_GbConsignee_Fragment | recordFields_GbCustomsEntry_Fragment | recordFields_GbIor_Fragment | recordFields_GbIorActivation_Fragment | recordFields_GenericDocumentGenerationRequest_Fragment | recordFields_GlobalConsignee_Fragment | recordFields_HtmlDocumentGenerationRequest_Fragment | recordFields_Importer_Fragment | recordFields_ImporterEntity_Fragment | recordFields_ImporterEntityActivation_Fragment | recordFields_ImporterImporterEntityRelationship_Fragment | recordFields_InBondNotesDocumentGenerationRequest_Fragment | recordFields_Invoice_Fragment | recordFields_InvoiceCreditNote_Fragment | recordFields_InvoiceCreditNoteDocumentGenerationRequest_Fragment | recordFields_InvoiceDocumentGenerationRequest_Fragment | recordFields_InvoiceLinesRequest_Fragment | recordFields_InvoicePayment_Fragment | recordFields_Memo_Fragment | recordFields_NlConsignee_Fragment | recordFields_NlCustomsBroker_Fragment | recordFields_NlCustomsEntry_Fragment | recordFields_NlIor_Fragment | recordFields_NlIorActivation_Fragment | recordFields_OnboardingRequest_Fragment | recordFields_Operator_Fragment | recordFields_OperatorSystem_Fragment | recordFields_OperatorUser_Fragment | recordFields_PayableInvoice_Fragment | recordFields_ProcessingError_Fragment | recordFields_Product_Fragment | recordFields_Program_Fragment | recordFields_QueryAdCvdCaseCbpTransaction_Fragment | recordFields_QueryAmsTransaction_Fragment | recordFields_QueryAmsUsConsumptionEntryTransaction_Fragment | recordFields_QueryAmsUsInBondTransaction_Fragment | recordFields_QueryAmsUsIsfTransaction_Fragment | recordFields_QueryAmsUsType86EntryTransaction_Fragment | recordFields_QueryCarrierCodeCbpTransaction_Fragment | recordFields_QueryCbpByIorNumberTransaction_Fragment | recordFields_QueryEntryNumberCbpTransaction_Fragment | recordFields_QueryFirmsCodeCbpTransaction_Fragment | recordFields_QueryHtsCbpTransaction_Fragment | recordFields_QueryUsConsigneeCbpTransaction_Fragment | recordFields_QueryUsConsumptionEntrySummaryCbpTransaction_Fragment | recordFields_QueryUsIorCbpTransaction_Fragment | recordFields_QueryUsPostSummaryCorrectionCbpTransaction_Fragment | recordFields_QueryUsType86EntryReleaseCbpTransaction_Fragment | recordFields_Reimbursement_Fragment | recordFields_ReleaseNote_Fragment | recordFields_ReplaceUsConsumptionEntryReleaseCbpTransaction_Fragment | recordFields_ReplaceUsType86EntryReleaseCbpTransaction_Fragment | recordFields_ReportReconciliationRequest_Fragment | recordFields_RequestUsIorCbpAssignedNumberTransaction_Fragment | recordFields_SendWorkOrderDocumentsTo3pTransaction_Fragment | recordFields_SendWorkOrderDocumentsToExternalSystemTransaction_Fragment | recordFields_Shipment_Fragment | recordFields_ShipmentCommercialInvoiceDetail_Fragment | recordFields_ShipmentDocumentProcessingRequest_Fragment | recordFields_Shipper_Fragment | recordFields_ShipperBrokerRelationship_Fragment | recordFields_ShipperCustomsAgentRelationship_Fragment | recordFields_ShipperDeConsigneeRelationship_Fragment | recordFields_ShipperDeCustomsBrokerRelationship_Fragment | recordFields_ShipperDeIorRelationship_Fragment | recordFields_ShipperFacilityRelationship_Fragment | recordFields_ShipperForwarderRelationship_Fragment | recordFields_ShipperFrConsigneeRelationship_Fragment | recordFields_ShipperFrCustomsBrokerRelationship_Fragment | recordFields_ShipperFrIorRelationship_Fragment | recordFields_ShipperGbConsigneeRelationship_Fragment | recordFields_ShipperGbIorRelationship_Fragment | recordFields_ShipperGlobalConsigneeRelationship_Fragment | recordFields_ShipperImporterRelationship_Fragment | recordFields_ShipperNlConsigneeRelationship_Fragment | recordFields_ShipperNlCustomsBrokerRelationship_Fragment | recordFields_ShipperNlIorRelationship_Fragment | recordFields_ShipperSupplierRelationship_Fragment | recordFields_ShipperSystem_Fragment | recordFields_ShipperTruckerRelationship_Fragment | recordFields_ShipperUkCustomsBrokerRelationship_Fragment | recordFields_ShipperUsConsigneeRelationship_Fragment | recordFields_ShipperUsCustomsBrokerRelationship_Fragment | recordFields_ShipperUsIorRelationship_Fragment | recordFields_ShipperUser_Fragment | recordFields_StampDocumentGenerationRequest_Fragment | recordFields_StampDocumentSignRequest_Fragment | recordFields_SubjectMatterExpertTeam_Fragment | recordFields_SubjectMatterExpertTeamOperatorUserRelationship_Fragment | recordFields_SubjectMatterExpertTeamOperatorUserRelationshipBase_Fragment | recordFields_SubmitInBondCbpTransaction_Fragment | recordFields_SubmitUsConsumptionEntryDisTransaction_Fragment | recordFields_SubmitUsDrawbackClaimDisTransaction_Fragment | recordFields_SubmitUsType86EntryDisTransaction_Fragment | recordFields_Supplier_Fragment | recordFields_TableFilter_Fragment | recordFields_Team_Fragment | recordFields_TemplateDocumentSignRequest_Fragment | recordFields_Trucker_Fragment | recordFields_UkCustomsBroker_Fragment | recordFields_UkHs_Fragment | recordFields_UpdateUsConsigneeCbp5106Transaction_Fragment | recordFields_UpdateUsConsumptionEntryPgaCbpTransaction_Fragment | recordFields_UpdateUsConsumptionEntryReleaseCbpTransaction_Fragment | recordFields_UpdateUsConsumptionEntryStatementCbpTransaction_Fragment | recordFields_UpdateUsDrawbackClaimCbpTransaction_Fragment | recordFields_UpdateUsIorCbp5106Transaction_Fragment | recordFields_UpdateUsIsfCbpTransaction_Fragment | recordFields_UpdateUsType86EntryPgaCbpTransaction_Fragment | recordFields_UpdateUsType86EntryReleaseCbpTransaction_Fragment | recordFields_UpsertSupplierCbpMidTransaction_Fragment | recordFields_UpsertUsConsumptionEntrySummaryCbpTransaction_Fragment | recordFields_UpsertUsPostSummaryCorrectionCbpTransaction_Fragment | recordFields_UsCargoReleaseDocumentGenerationRequest_Fragment | recordFields_UsCbp5106DocumentGenerationRequest_Fragment | recordFields_UsCbp7501DocumentGenerationRequest_Fragment | recordFields_UsCbp7512DocumentGenerationRequest_Fragment | recordFields_UsConsignee_Fragment | recordFields_UsConsumptionEntry_Fragment | recordFields_UsCustomsBroker_Fragment | recordFields_UsDrawbackClaim_Fragment | recordFields_UsDrawbackClaimDocumentGenerationRequest_Fragment | recordFields_UsHts_Fragment | recordFields_UsInBond_Fragment | recordFields_UsIor_Fragment | recordFields_UsIorActivation_Fragment | recordFields_UsIorContinuousBondRequest_Fragment | recordFields_UsIsf_Fragment | recordFields_UsPostSummaryCorrection_Fragment | recordFields_UsPrincipalAdCvdCase_Fragment | recordFields_UsType86Entry_Fragment | recordFields_UserReleaseNoteView_Fragment | recordFields_WorkOrderConfirmation_Fragment | recordFields_WorkOrderDocumentProcessingRequest_Fragment | recordFields_WorkOrderGroup_Fragment | recordFields_WorkOrderMilestone_Fragment | recordFields_WorkOrderStateMachine_Fragment | recordFields_WorkOrderTask_Fragment | recordFields_WorkOrderTaskDefinition_Fragment | recordFields_WorkOrderTaskEscalationMessage_Fragment;

type partyFields_Broker_Fragment = { __typename?: 'Broker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_CustomsAgent_Fragment = { __typename?: 'CustomsAgent', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_DeConsignee_Fragment = { __typename?: 'DeConsignee', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_DeCustomsBroker_Fragment = { __typename?: 'DeCustomsBroker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_DeIor_Fragment = { __typename?: 'DeIor', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Facility_Fragment = { __typename?: 'Facility', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Forwarder_Fragment = { __typename?: 'Forwarder', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_FrConsignee_Fragment = { __typename?: 'FrConsignee', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_FrCustomsBroker_Fragment = { __typename?: 'FrCustomsBroker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_FrIor_Fragment = { __typename?: 'FrIor', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_GbConsignee_Fragment = { __typename?: 'GbConsignee', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_GbIor_Fragment = { __typename?: 'GbIor', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_GlobalConsignee_Fragment = { __typename?: 'GlobalConsignee', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Importer_Fragment = { __typename?: 'Importer', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_NlConsignee_Fragment = { __typename?: 'NlConsignee', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_NlCustomsBroker_Fragment = { __typename?: 'NlCustomsBroker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_NlIor_Fragment = { __typename?: 'NlIor', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Operator_Fragment = { __typename?: 'Operator', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Shipper_Fragment = { __typename?: 'Shipper', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Supplier_Fragment = { __typename?: 'Supplier', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_Trucker_Fragment = { __typename?: 'Trucker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_UkCustomsBroker_Fragment = { __typename?: 'UkCustomsBroker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_UsConsignee_Fragment = { __typename?: 'UsConsignee', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_UsCustomsBroker_Fragment = { __typename?: 'UsCustomsBroker', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

type partyFields_UsIor_Fragment = { __typename?: 'UsIor', name: string, alternateName?: string | null, description?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

export type partyFieldsFragment = partyFields_Broker_Fragment | partyFields_CustomsAgent_Fragment | partyFields_DeConsignee_Fragment | partyFields_DeCustomsBroker_Fragment | partyFields_DeIor_Fragment | partyFields_Facility_Fragment | partyFields_Forwarder_Fragment | partyFields_FrConsignee_Fragment | partyFields_FrCustomsBroker_Fragment | partyFields_FrIor_Fragment | partyFields_GbConsignee_Fragment | partyFields_GbIor_Fragment | partyFields_GlobalConsignee_Fragment | partyFields_Importer_Fragment | partyFields_NlConsignee_Fragment | partyFields_NlCustomsBroker_Fragment | partyFields_NlIor_Fragment | partyFields_Operator_Fragment | partyFields_Shipper_Fragment | partyFields_Supplier_Fragment | partyFields_Trucker_Fragment | partyFields_UkCustomsBroker_Fragment | partyFields_UsConsignee_Fragment | partyFields_UsCustomsBroker_Fragment | partyFields_UsIor_Fragment;

export type importerFieldsFragment = { __typename?: 'Importer', externalClientReferences?: Array<string> | null, id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, memos: Array<{ __typename?: 'Memo', text: string, isPublic?: boolean | null, id: string, version: number, operator: { __typename?: 'Operator', id: string }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, importerEntities: { __typename?: 'ImporterImporterEntitysConnection', nodes: Array<{ __typename?: 'ImporterEntity', id: string }> }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null };

export type ImporterFieldsFragment = { __typename?: 'Importer', id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, businessStructure?: GlobalBusinessStructure | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, type?: string | null, streetName?: string | null, postOfficeBox?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, legalRepresentative?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, secondaryOfficer?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, owners?: Array<{ __typename?: 'ImporterOwner', customerId?: string | null, type?: string | null }> | null, docReadinesses?: Array<{ __typename?: 'ImporterDocReadiness', id: string, programType?: ImporterDocReadinessProgramType | null }> | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> };

export type UpdateImporterRecordMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateImporterInput;
  version: Scalars['Int'];
}>;


export type UpdateImporterRecordMutation = { __typename?: 'Mutation', updateImporter: { __typename?: 'UpdateImporterPayload', record: { __typename?: 'Importer', id: string, version: number } } };

export type UpdateImporterEntityMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateImporterEntityInput;
  version: Scalars['Int'];
}>;


export type UpdateImporterEntityMutation = { __typename?: 'Mutation', updateImporterEntity: { __typename?: 'UpdateImporterEntityPayload', record: { __typename?: 'ImporterEntity', id: string, version: number } } };

export type UpdateUsIorMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateUsIorInput;
  version: Scalars['Int'];
}>;


export type UpdateUsIorMutation = { __typename?: 'Mutation', updateUsIor: { __typename?: 'UpdateUsIorPayload', record: { __typename?: 'UsIor', id: string, version: number } } };

export type ImporterDetailQueryVariables = Exact<{
  importerId: Scalars['ID'];
}>;


export type ImporterDetailQuery = { __typename?: 'Query', importer: { __typename?: 'Importer', id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, businessStructure?: GlobalBusinessStructure | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null, updated: { __typename?: 'RecordAction', time: any } } | null, usIor?: { __typename?: 'UsIor', id: string, version: number, status?: UsIorStatus | null, industry?: Vertical | null, cbpStatus?: UsIorCbpStatus | null, sourcePortal?: SourcePortal | null, sourceChannel?: SourceChannel | null, businessStructure?: UsBusinessStructure | null, activationStatus?: UsIorActivationStatus | null, payerUnitNumber?: any | null, pmsStatus?: UsIorPmsStatus | null, poaMethod?: POAMethod | null, isResident?: boolean | null, isSubmittedBefore?: boolean | null, docReadinessId?: string | null, cbp5106RejectionReasons?: Array<{ __typename?: 'UsCbp5106RejectedReason', code: string, name: string }> | null, updated: { __typename?: 'RecordAction', time: any }, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null, iorNumber?: { __typename?: 'UsIorNumber', value: any } | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null }> | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null } | null, bondApplicationInformation?: { __typename?: 'BondApplicationInformation', productDescription?: string | null, importsFrom?: string | null, expectedDutiesRange?: string | null, previousAnnualFeesRange?: string | null, customBondApplicationStatus?: string | null, supplementaryDutyFlagType?: string | null } | null, continuousBonds?: { __typename?: 'UsContinuousCustomsBonds', future?: { __typename?: 'UsContinuousCustomsBond', amount: any, effectiveDate: any, number: string, suretyCode: string, typeCode: string, renewalDate?: any | null, terminationDate?: any | null } | null, past?: Array<{ __typename?: 'UsContinuousCustomsBond', amount: any, effectiveDate: any, number: string, suretyCode: string, typeCode: string, renewalDate?: any | null, terminationDate?: any | null }> | null, present?: { __typename?: 'UsContinuousCustomsBond', amount: any, effectiveDate: any, number: string, suretyCode: string, typeCode: string, renewalDate?: any | null, terminationDate?: any | null } | null } | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null, updated: { __typename?: 'RecordAction', time: any } } | null, documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag>, deleted?: { __typename?: 'RecordAction', time: any } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, addresses?: { __typename?: 'Addresses', mailing?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null, physical?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null } | null, operator: { __typename?: 'Operator', id: string }, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, created: { __typename?: 'RecordAction', time: any }, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } | null, importerEntities: { __typename?: 'ImporterImporterEntitysConnection', nodes: Array<{ __typename?: 'ImporterEntity', id: string, version: number, sourcePortal?: SourcePortal | null, sourceChannel?: SourceChannel | null, countryCode: any, isResident?: boolean | null, isSubmittedBefore?: boolean | null, status?: ImporterEntityStatus | null, externalClientReferences?: Array<string> | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, updated: { __typename?: 'RecordAction', time: any }, bonds?: { __typename?: 'CustomsBonds', present?: { __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null } | null, past?: Array<{ __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null }> | null, future?: { __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, program?: Array<{ __typename?: 'ProgramDetails', docReadiness?: { __typename?: 'DocReadiness', id: string } | null }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null, user?: { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null } | null, activations?: Array<{ __typename?: 'ImporterEntityActivationDetails', status: ActivationStatus, activated?: { __typename?: 'RecordAction', time: any } | null, externalIorReferences?: Array<{ __typename?: 'ExternalIorReference', id: string, referenceType?: ExternalIorReferenceType | null, version?: string | null, documents?: Array<{ __typename?: 'ExternalIorDocumentReference', documentTag?: DocumentTag | null, externalReference: { __typename?: 'ExternalDocumentReference', externalReferenceType?: DocumentReferenceType | null, externalReferencePartition?: string | null, id: string, version?: string | null } }> | null }> | null, customsBroker: { __typename?: 'Broker', id: string } | { __typename?: 'DeCustomsBroker', id: string } | { __typename?: 'FrCustomsBroker', id: string } | { __typename?: 'NlCustomsBroker', id: string } | { __typename?: 'UkCustomsBroker', id: string } | { __typename?: 'UsCustomsBroker', id: string } }> | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null, updated: { __typename?: 'RecordAction', time: any } } | null, externalValidations?: Array<{ __typename?: 'ExternalValidation', validationDate: any, response: { __typename?: 'ExternalValidationResponse', validationResult: ExternalValidationResult, companyDetails?: { __typename?: 'CompanyInfo', name?: string | null } | null }, identification: { __typename?: 'PartyIdentification', identificationType: PartyIdentificationType } }> | null, importer?: { __typename?: 'Importer', id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, businessStructure?: GlobalBusinessStructure | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, type?: string | null, streetName?: string | null, postOfficeBox?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, legalRepresentative?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, secondaryOfficer?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, owners?: Array<{ __typename?: 'ImporterOwner', customerId?: string | null, type?: string | null }> | null, docReadinesses?: Array<{ __typename?: 'ImporterDocReadiness', id: string, programType?: ImporterDocReadinessProgramType | null }> | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } | null }> }, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, type?: string | null, streetName?: string | null, postOfficeBox?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, legalRepresentative?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, secondaryOfficer?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, owners?: Array<{ __typename?: 'ImporterOwner', customerId?: string | null, type?: string | null }> | null, docReadinesses?: Array<{ __typename?: 'ImporterDocReadiness', id: string, programType?: ImporterDocReadinessProgramType | null }> | null, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } };

export type SearchImportersQueryVariables = Exact<{
  input: SearchImporterInput;
}>;


export type SearchImportersQuery = { __typename?: 'Query', searchImporters: { __typename?: 'SearchImporterPayload', totalResults?: number | null, results: Array<{ __typename?: 'Importer', id: string, name: string, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, importerEntities: { __typename?: 'ImporterImporterEntitysConnection', nodes: Array<{ __typename?: 'ImporterEntity', countryCode: any }> }, usIor?: { __typename?: 'UsIor', id: string } | null }>, paginationInfo?: { __typename?: 'SearchPagination', pageNumber?: number | null, pageSize?: number | null, totalPages?: number | null } | null } };

export type SearchImporterTableQueryVariables = Exact<{
  input: SearchImporterTableInput;
}>;


export type SearchImporterTableQuery = { __typename?: 'Query', searchImporterTable: { __typename?: 'SearchImporterTablePayload', totalResults: number, results: Array<{ __typename?: 'ImporterSearchTableRow', id: string, name: string, countryName?: string | null }>, paginationInfo: { __typename?: 'SearchPagination', pageNumber?: number | null, pageSize?: number | null, totalPages?: number | null } } };

export type ImportersQueryVariables = Exact<{
  identifiers: Array<IdOptionalVersionInput> | IdOptionalVersionInput;
}>;


export type ImportersQuery = { __typename?: 'Query', importers: Array<{ __typename?: 'Importer', id: string, name: string, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, importerEntities: { __typename?: 'ImporterImporterEntitysConnection', nodes: Array<{ __typename?: 'ImporterEntity', countryCode: any }> }, usIor?: { __typename?: 'UsIor', id: string } | null }> };

export type InquireWorkOrderMutationVariables = Exact<{
  version: Scalars['Int'];
  input: InquireWorkOrderInput;
  id: Scalars['ID'];
}>;


export type InquireWorkOrderMutation = { __typename?: 'Mutation', inquireWorkOrder: { __typename?: 'InquireWorkOrderPayload', workOrder: { __typename?: 'CustomsDeclaration', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'CustomsEntry', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'DeCustomsEntry', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'DeIorActivation', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'DeliveryOrder', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'FrCustomsEntry', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'FrIorActivation', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'GbCustomsEntry', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'GbIorActivation', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'ImporterEntityActivation', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'NlCustomsEntry', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'NlIorActivation', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsConsumptionEntry', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsDrawbackClaim', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsInBond', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsIorActivation', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsIorContinuousBondRequest', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsIsf', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsPostSummaryCorrection', id: string, version: number, status: WorkOrderStatus } | { __typename?: 'UsType86Entry', id: string, version: number, status: WorkOrderStatus } } };

export type lineItemInfoFragmentFragment = { __typename?: 'UsConsumptionEntryLine', description?: string | null, poNumber?: string | null };

export type LinkActionMutationVariables = Exact<{
  hashKey: Scalars['String'];
}>;


export type LinkActionMutation = { __typename?: 'Mutation', linkAction: { __typename?: 'LinkActionPayload', type: LinkActions, message?: string | null } };

export type linkForwarderToUsIorMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  forwarderId: Scalars['ID'];
  customsBrokerId: Scalars['ID'];
  input: LinkForwarderToIorInput;
}>;


export type linkForwarderToUsIorMutation = { __typename?: 'Mutation', linkForwarderToUsIor: { __typename?: 'LinkForwarderToIorPayload', linked: boolean, templateDocumentSignRequest?: { __typename?: 'TemplateDocumentSignRequest', url: string, documentTags: Array<DocumentTag> } | null } };

export type fetchForwarderMailFromQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type fetchForwarderMailFromQuery = { __typename?: 'Query', fetchForwarderMailFrom: { __typename?: 'FetchForwarderMailFromPayload', emailVerificationStatus: string, dkimStatus: string, domainStatus: string, dns: Array<{ __typename?: 'DNSRecord', name: string, type: string, value: string }> } };

export type submitForwarderMailFromMutationVariables = Exact<{
  id: Scalars['ID'];
  fromSignature: Scalars['String'];
  fromTitle: Scalars['String'];
  fromEmail: Scalars['Email'];
}>;


export type submitForwarderMailFromMutation = { __typename?: 'Mutation', submitForwarderMailFrom: { __typename?: 'SubmitForwarderMailFromPayload', forwarder: { __typename?: 'Forwarder', id: string } } };

export type getWorkOrderForAnalysisBadgesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getWorkOrderForAnalysisBadgesQuery = { __typename?: 'Query', workOrder: { __typename?: 'CustomsDeclaration', id: string, status: WorkOrderStatus, version: number, customsDeclarationBadges?: Array<WorkOrderBadge> | null } | { __typename?: 'CustomsEntry', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'DeCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null } | { __typename?: 'DeIorActivation', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'DeliveryOrder', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'FrCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null } | { __typename?: 'FrIorActivation', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'GbCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null } | { __typename?: 'GbIorActivation', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'ImporterEntityActivation', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'NlCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null } | { __typename?: 'NlIorActivation', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsConsumptionEntry', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsDrawbackClaim', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsInBond', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsIorActivation', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsIorContinuousBondRequest', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsIsf', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsPostSummaryCorrection', id: string, status: WorkOrderStatus, version: number } | { __typename?: 'UsType86Entry', id: string, status: WorkOrderStatus, version: number } };

export type getOneWorkOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getOneWorkOrderQuery = { __typename?: 'Query', workOrder: { __typename?: 'CustomsDeclaration', id: string, status: WorkOrderStatus, version: number, customsDeclarationBadges?: Array<WorkOrderBadge> | null, goodsShipment?: Array<{ __typename?: 'GoodsShipment', importCountry?: Array<{ __typename?: 'ImportCountry', country?: any | null }> | null }> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'CustomsEntry', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'DeCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'DeIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'DeliveryOrder', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'FrCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'FrIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'GbCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'GbIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'ImporterEntityActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'NlCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'NlIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsConsumptionEntry', id: string, status: WorkOrderStatus, version: number, usConsumptionEntryBadges?: Array<UsConsumptionEntryBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsDrawbackClaim', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsInBond', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsIorContinuousBondRequest', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsIsf', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsPostSummaryCorrection', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } | { __typename?: 'UsType86Entry', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } }> | null } } };

export type WorkOrderForMarkReadyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkOrderForMarkReadyQuery = { __typename?: 'Query', workOrder: { __typename?: 'CustomsDeclaration', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'CustomsEntry', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'DeCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'DeIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'DeliveryOrder', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'FrCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'FrIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'GbCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'GbIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'ImporterEntityActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'NlCustomsEntry', id: string, status: WorkOrderStatus, version: number, euCustomsEntryBadges?: Array<WorkOrderBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'NlIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsConsumptionEntry', id: string, status: WorkOrderStatus, version: number, usConsumptionEntryReleaseStatus?: UsCbpEntryReleaseStatus | null, usConsumptionEntryBadges?: Array<UsConsumptionEntryBadge> | null, usConsumptionEntryArrival?: { __typename?: 'UsConsumptionEntryArrival', importDate?: any | null } | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsDrawbackClaim', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsInBond', id: string, status: WorkOrderStatus, version: number, usInBondBadges?: Array<UsInBondBadge> | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsIorActivation', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsIorContinuousBondRequest', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsIsf', id: string, status: WorkOrderStatus, version: number, usIsfCbpStatus?: UsIsfCbpStatus | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsPostSummaryCorrection', id: string, status: WorkOrderStatus, version: number, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } | { __typename?: 'UsType86Entry', id: string, status: WorkOrderStatus, version: number, usType86EntryReleaseStatus?: UsCbpEntryReleaseStatus | null, stateMachine: { __typename?: 'WorkOrderStateMachine', workOrderType: WorkOrderType }, group: { __typename?: 'WorkOrderGroup', documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag> }>, shipment?: { __typename?: 'Shipment', id: string, version: number, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, legs: Array<{ __typename?: 'ShipmentLeg', modeOfTransport: ModeOfTransport, arrival?: { __typename?: 'ShipmentLegArrival', time?: any | null } | null, ior?: { __typename?: 'ShipmentLegIor', ior?: { __typename?: 'DeIor' } | { __typename?: 'FrIor' } | { __typename?: 'GbIor' } | { __typename?: 'Importer' } | { __typename?: 'NlIor' } | { __typename?: 'UsIor', id: string, activationStatus?: UsIorActivationStatus | null, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null } | null } | null }> } | null, shipper?: { __typename?: 'Shipper', billingDetails?: { __typename?: 'BillingDetails', status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', tags: Array<{ __typename?: 'Tag', key: string, value: string }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null, customFees?: Array<{ __typename?: 'InvoiceFeeDetails', type: ChargeCode, value: { __typename?: 'Cost', value: number } }> | null } | null, workOrderConfig?: { __typename?: 'ForwarderWorkOrderConfig', usConsumptionEntry?: { __typename?: 'ForwarderUsConsumptionEntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsConsumptionEntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsConsumptionEntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null, badges?: Array<UsConsumptionEntryBadge> | null } | null }> | null } | null, usType86Entry?: { __typename?: 'ForwarderUsType86EntryConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsType86EntryServiceLevelAgreement', businessHoursAfterReady?: number | null, calendarDaysBeforeArrival?: number | null, matchingCriteria?: { __typename?: 'UsType86EntryServiceLevelAgreementMatchingCriteria', modesOfTransport?: Array<ModeOfTransport> | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'ForwarderDeliveryOrderConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'DeliveryOrderServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIsf?: { __typename?: 'ForwarderUsIsfConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIsfServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null, usIorContinuousBondRequest?: { __typename?: 'ForwarderUsIorContinuousBondRequestConfig', autoSetReadyStatus?: boolean | null, serviceLevelAgreements?: Array<{ __typename?: 'UsIorContinuousBondRequestServiceLevelAgreement', businessHoursAfterReady?: number | null }> | null } | null } | null } }> | null } } };

export type MigrateUserMutationVariables = Exact<{
  jwt: Scalars['String'];
}>;


export type MigrateUserMutation = { __typename?: 'Mutation', migrateUser: { __typename?: 'MigrateUserPayload', success: boolean } };

export type ExternalUserMigrationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ExternalUserMigrationQuery = { __typename?: 'Query', searchUsers: { __typename?: 'SearchUserPayload', results: Array<{ __typename?: 'ForwarderUser', id: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'OperatorUser', id: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'ShipperUser', id: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } };

export type searchInvoiceLinesRequestsQueryVariables = Exact<{
  input: SearchInvoiceLinesRequestInput;
}>;


export type searchInvoiceLinesRequestsQuery = { __typename?: 'Query', searchInvoiceLinesRequests: { __typename?: 'SearchInvoiceLinesRequestPayload', results: Array<{ __typename?: 'InvoiceLinesRequest', id: string, version: number, statusReason?: string | null, reviewStatus?: ReviewStatus | null, created: { __typename?: 'RecordAction', time: any }, lines?: Array<{ __typename?: 'InvoiceRequestLine', type?: ChargeCode | null, amount?: { __typename?: 'Cost', value: number, currency: any } | null }> | null }> } };

export type RedriveProcessingErrorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RedriveProcessingErrorMutation = { __typename?: 'Mutation', publishRedriveEventToErrorSource: { __typename?: 'PublishRedriveEventToErrorSourcePayload', id: string } };

export type shipmentStatusCountsQueryVariables = Exact<{
  examInput: SearchUsConsumptionEntryInput;
  holdInput: SearchUsConsumptionEntryInput;
  releasedInput: SearchUsConsumptionEntryInput;
}>;


export type shipmentStatusCountsQuery = { __typename?: 'Query', exam: { __typename?: 'SearchUsConsumptionEntryPayload', totalResults?: number | null }, hold: { __typename?: 'SearchUsConsumptionEntryPayload', totalResults?: number | null }, released: { __typename?: 'SearchUsConsumptionEntryPayload', totalResults?: number | null } };

export type GetInvoiceNumberQueryVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type GetInvoiceNumberQuery = { __typename?: 'Query', workOrder: { __typename?: 'CustomsDeclaration', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'CustomsEntry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'DeCustomsEntry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'DeIorActivation', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'DeliveryOrder', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'FrCustomsEntry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'FrIorActivation', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'GbCustomsEntry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'GbIorActivation', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'ImporterEntityActivation', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'NlCustomsEntry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'NlIorActivation', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsConsumptionEntry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsDrawbackClaim', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsInBond', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsIorActivation', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsIorContinuousBondRequest', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsIsf', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsPostSummaryCorrection', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } | { __typename?: 'UsType86Entry', group: { __typename?: 'WorkOrderGroup', invoices?: Array<{ __typename?: 'Invoice', number?: string | null }> | null } } };

export type GetLatestViewedReleaseNoteByUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetLatestViewedReleaseNoteByUserQuery = { __typename?: 'Query', getLatestViewedReleaseNoteByUser?: { __typename?: 'UserReleaseNoteView', id: string, created: { __typename?: 'RecordAction', time: any } } | null };

export type SearchReleaseNotesQueryVariables = Exact<{
  input: SearchReleaseNoteInput;
}>;


export type SearchReleaseNotesQuery = { __typename?: 'Query', searchReleaseNotes: { __typename?: 'SearchReleaseNotePayload', totalResults?: number | null, results: Array<{ __typename?: 'ReleaseNote', id: string, title: string, description: string, created: { __typename?: 'RecordAction', time: any } }> } };

export type GetLatestReleaseNoteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestReleaseNoteQuery = { __typename?: 'Query', getLatestReleaseNote?: { __typename?: 'ReleaseNote', id: string, title: string, description: string, created: { __typename?: 'RecordAction', time: any } } | null };

export type CreateUserReleaseNoteViewMutationVariables = Exact<{
  input: CreateUserReleaseNoteViewInput;
  idempotencyKey: Scalars['String'];
}>;


export type CreateUserReleaseNoteViewMutation = { __typename?: 'Mutation', createUserReleaseNoteView: { __typename?: 'CreateUserReleaseNoteViewPayload', record: { __typename?: 'UserReleaseNoteView', releaseNote: { __typename?: 'ReleaseNote', id: string }, user: { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperUser', id: string } } } };

export type ReleaseNoteFieldsFragment = { __typename?: 'ReleaseNote', id: string, title: string, description: string, targetCountries: Array<string>, thumbsUp: number, thumbsDown: number, version: number, created: { __typename?: 'RecordAction', time: any } };

export type GetReleaseNotesQueryVariables = Exact<{
  input: CursorPaginationInput;
}>;


export type GetReleaseNotesQuery = { __typename?: 'Query', allReleaseNotes: { __typename?: 'ReleaseNotesConnection', nodes: Array<{ __typename?: 'ReleaseNote', id: string, title: string, description: string, targetCountries: Array<string>, thumbsUp: number, thumbsDown: number, version: number, created: { __typename?: 'RecordAction', time: any } }>, pageInfo: { __typename?: 'CursorPagination', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } };

export type GetUserRatingsQueryVariables = Exact<{
  userId: Scalars['ID'];
  releaseNoteIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetUserRatingsQuery = { __typename?: 'Query', searchUserReleaseNoteViews: { __typename?: 'SearchUserReleaseNoteViewPayload', results: Array<{ __typename?: 'UserReleaseNoteView', id: string, rating?: RatingEnum | null, releaseNote: { __typename?: 'ReleaseNote', id: string } }> } };

export type UserReactsMutationVariables = Exact<{
  userId: Scalars['String'];
  releaseNoteId: Scalars['String'];
  rating: Scalars['String'];
}>;


export type UserReactsMutation = { __typename?: 'Mutation', userReacts: boolean };

export type CreateReleaseNoteMutationVariables = Exact<{
  input: CreateReleaseNoteInput;
  idempotencyKey: Scalars['String'];
}>;


export type CreateReleaseNoteMutation = { __typename?: 'Mutation', createReleaseNote: { __typename?: 'CreateReleaseNotePayload', record: { __typename?: 'ReleaseNote', id: string, title: string, description: string, targetCountries: Array<string>, thumbsUp: number, thumbsDown: number, version: number, created: { __typename?: 'RecordAction', time: any } } } };

export type UpdateReleaseNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateReleaseNoteInput;
  version: Scalars['Int'];
}>;


export type UpdateReleaseNoteMutation = { __typename?: 'Mutation', updateReleaseNote: { __typename?: 'UpdateReleaseNotePayload', record: { __typename?: 'ReleaseNote', id: string, title: string, description: string, targetCountries: Array<string>, thumbsUp: number, thumbsDown: number, version: number, created: { __typename?: 'RecordAction', time: any } } } };

export type DeleteReleaseNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type DeleteReleaseNoteMutation = { __typename?: 'Mutation', deleteReleaseNote: { __typename?: 'DeleteReleaseNotePayload', record: { __typename?: 'ReleaseNote', id: string } } };

export type ResolveWorkOrderTaskEscalationMutationVariables = Exact<{
  input: TaskResolutionDetailsInput;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type ResolveWorkOrderTaskEscalationMutation = { __typename?: 'Mutation', resolveWorkOrderTaskEscalation: { __typename?: 'ResolveWorkOrderTaskEscalationPayload', workOrderTask: { __typename?: 'WorkOrderTask', id: string } } };

export type SubmitUsConsumptionEntryDisMutationVariables = Exact<{
  idempotencyKey: Scalars['String'];
  input: SubmitUsConsumptionEntryDisInput;
  recordId: Scalars['ID'];
}>;


export type SubmitUsConsumptionEntryDisMutation = { __typename?: 'Mutation', submitUsConsumptionEntryDis: { __typename?: 'SubmitUsConsumptionEntryDisPayload', transaction: { __typename?: 'SubmitUsConsumptionEntryDisTransaction', id: string, version: number } } };

export type SubmitUsType86EntryDisMutationVariables = Exact<{
  idempotencyKey: Scalars['String'];
  input: SubmitUsType86EntryDisInput;
  recordId: Scalars['ID'];
}>;


export type SubmitUsType86EntryDisMutation = { __typename?: 'Mutation', submitUsType86EntryDis: { __typename?: 'SubmitUsType86EntryDisPayload', transaction: { __typename?: 'SubmitUsType86EntryDisTransaction', id: string, version: number } } };

export type CreateWorkOrderConfirmationMutationVariables = Exact<{
  idempotencyKey: Scalars['String'];
  input: CreateWorkOrderConfirmationInput;
}>;


export type CreateWorkOrderConfirmationMutation = { __typename?: 'Mutation', createWorkOrderConfirmation: { __typename?: 'CreateWorkOrderConfirmationPayload', record: { __typename?: 'WorkOrderConfirmation', id: string } } };

export type getWorkOrderQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
}>;


export type getWorkOrderQueryQuery = { __typename?: 'Query', workOrder: { __typename?: 'CustomsDeclaration', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'CustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'DeCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'DeIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'DeliveryOrder', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'FrCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'FrIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'GbCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'GbIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'ImporterEntityActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'NlCustomsEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'NlIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsConsumptionEntry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsDrawbackClaim', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsInBond', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsIorActivation', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsIorContinuousBondRequest', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsIsf', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsPostSummaryCorrection', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } | { __typename?: 'UsType86Entry', id: string, version: number, status: WorkOrderStatus, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, version: number, occurenceTime: any }> } };

export type SendWorkOrderDocumentsTo3pMutationVariables = Exact<{
  input: SendWorkOrderDocumentsTo3pInput;
  workOrderId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
}>;


export type SendWorkOrderDocumentsTo3pMutation = { __typename?: 'Mutation', sendWorkOrderDocumentsTo3p: { __typename?: 'SendWorkOrderDocumentsTo3pPayload', transaction: { __typename?: 'SendWorkOrderDocumentsTo3pTransaction', id: string } } };

export type toggleAssumedUserMutationVariables = Exact<{
  id: Scalars['ID'];
  assumedUser?: InputMaybe<IdInput>;
}>;


export type toggleAssumedUserMutation = { __typename?: 'Mutation', toggleAssumedUser: { __typename?: 'ToggleAssumedUserPayload', operatorUser: { __typename?: 'OperatorUser', id: string, assumedUser?: { __typename: 'ForwarderUser', id: string, name: string, root?: boolean | null, email: any } | { __typename: 'OperatorUser', id: string, name: string, root?: boolean | null, email: any } | { __typename: 'ShipperUser', id: string, name: string, root?: boolean | null, email: any } | null } } };

export type getAbiExchangeMessagesQueryVariables = Exact<{
  input: ExchangeMessageSearchCriteriaInput;
  searchPaginationInput: SearchPaginationInput;
}>;


export type getAbiExchangeMessagesQuery = { __typename?: 'Query', getAbiExchangeMessages: { __typename?: 'GetAbiPayload', paginationInfo: { __typename?: 'SearchPagination', pageSize?: number | null, totalPages?: number | null }, messages: Array<{ __typename?: 'AbiExchangeMessage', edi: string, json: any, key: string, time: any }> } };

export type UpdateUsConsumptionEntryStatementCbpMutationVariables = Exact<{
  idempotencyKey: Scalars['String'];
  input: UpdateUsConsumptionEntryStatementCbpInput;
  usConsumptionEntryId: Scalars['ID'];
}>;


export type UpdateUsConsumptionEntryStatementCbpMutation = { __typename?: 'Mutation', updateUsConsumptionEntryStatementCbp: { __typename?: 'UpdateUsConsumptionEntryStatementCbpPayload', transaction: { __typename?: 'UpdateUsConsumptionEntryStatementCbpTransaction', id: string, version: number, paymentType: any, pmsMonth?: any | null, printDate?: any | null } } };

export type ValidateUsConsumptionEntryReleaseQueryVariables = Exact<{
  idInput?: InputMaybe<IdInput>;
  input: UpdateUsConsumptionEntryInput;
}>;


export type ValidateUsConsumptionEntryReleaseQuery = { __typename?: 'Query', validateUsConsumptionEntryRelease: { __typename?: 'ValidateUsConsumptionEntryReleasePayload', entryType: string, totalValue: number, stbAmount?: number | null, riskType?: string | null, warnings: Array<{ __typename?: 'ValidateUsConsumptionEntryReleaseWarning', message: string, type: string }> } };

export type UpdateUsConsumptionEntryIDPMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpdateUsConsumptionEntryInput;
}>;


export type UpdateUsConsumptionEntryIDPMutation = { __typename?: 'Mutation', updateUsConsumptionEntry: { __typename?: 'UpdateUsConsumptionEntryPayload', record: { __typename?: 'UsConsumptionEntry', id: string, version: number, immediateDeliveryIndicator?: UsCbpEntryReleaseImmediateDelivery | null } } };

export type GetShipmentStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetShipmentStatusQuery = { __typename?: 'Query', shipment: { __typename?: 'Shipment', legs: Array<{ __typename?: 'ShipmentLeg', commercialInvoiceDetail?: { __typename?: 'ShipmentCommercialInvoiceDetail', status: ShipmentCommercialInvoiceDetailStatus } | null }> } };

export type brexitProductInfoFieldsCustomsDeclarationFragment = { __typename?: 'CustomsDeclaration', group: { __typename?: 'WorkOrderGroup', shipment?: { __typename?: 'Shipment', legs: Array<{ __typename?: 'ShipmentLeg', conveyance?: { __typename?: 'ShippingConveyance', grossWeight?: number | null } | null }> } | null }, goodsShipment?: Array<{ __typename?: 'GoodsShipment', importCountry?: Array<{ __typename?: 'ImportCountry', country?: any | null }> | null, goodsItem?: Array<{ __typename?: 'GoodsItem', goodsMeasure?: { __typename?: 'GoodsMeasure', tariff?: number | null } | null, commodity?: { __typename?: 'Commodity', product?: { __typename?: 'Product', clientIdentifier: string, clientIdentifierVersion?: number | null, secondaryIdentifiers?: Array<{ __typename?: 'ProductSecondaryIdentifier', type: ProductSecondaryIdentifierType, value: string }> | null } | null } | null }> | null }> | null };

export type GetWorkOrderTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkOrderTaskQuery = { __typename?: 'Query', workOrderTask: { __typename?: 'WorkOrderTask', id: string, version: number } };

export type SearchShipmentsByBookingQueryVariables = Exact<{
  input: SearchShipmentInput;
}>;


export type SearchShipmentsByBookingQuery = { __typename?: 'Query', searchShipments: { __typename?: 'SearchShipmentPayload', results: Array<{ __typename?: 'Shipment', id: string, version: number, legs: Array<{ __typename?: 'ShipmentLeg', commercialInvoiceDetail?: { __typename?: 'ShipmentCommercialInvoiceDetail', id: string, version: number, status: ShipmentCommercialInvoiceDetailStatus } | null }> }> } };

export type UpdateShipmentCommercialInvoiceDetailMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpdateShipmentCommercialInvoiceDetailInput;
}>;


export type UpdateShipmentCommercialInvoiceDetailMutation = { __typename?: 'Mutation', updateShipmentCommercialInvoiceDetail: { __typename?: 'UpdateShipmentCommercialInvoiceDetailPayload', record: { __typename?: 'ShipmentCommercialInvoiceDetail', id: string, version: number, status: ShipmentCommercialInvoiceDetailStatus } } };

export type SearchLargeEntryProductsQueryVariables = Exact<{
  input: SearchProductInput;
}>;


export type SearchLargeEntryProductsQuery = { __typename?: 'Query', searchProducts: { __typename?: 'SearchProductPayload', paginationInfo?: { __typename?: 'SearchPagination', totalPages?: number | null, pageNumber?: number | null } | null, results: Array<{ __typename?: 'Product', id: string, version: number, clientIdentifier: string, clientIdentifierVersion?: number | null, secondaryIdentifiers?: Array<{ __typename?: 'ProductSecondaryIdentifier', value: string, type: ProductSecondaryIdentifierType }> | null, weight?: { __typename?: 'Weight', value: number, unit: WeightUnit } | null, localizedDetails?: Array<{ __typename?: 'LocalizedProductDetail', description?: string | null }> | null }> } };

export type SearchLargeEntryAdCvdCasesQueryVariables = Exact<{
  input: SearchAdCvdCaseInput;
}>;


export type SearchLargeEntryAdCvdCasesQuery = { __typename?: 'Query', searchAdCvdCases: { __typename?: 'SearchAdCvdCasePayload', results: Array<{ __typename?: 'AdCvdCase', id: string, caseNumber: any, rates: Array<{ __typename?: 'CaseRate', effectiveDate: any, inactivatedDate?: any | null, addedDate: any, adValorem?: number | null, specific?: number | null, uom?: string | null, uomDescription?: string | null }>, bondOrCash: Array<{ __typename?: 'CaseBondOrCash', indicator: AdCvdCasePaymentOption, addedDate: any, effectiveDate: any }> }> } };

export type UsHtsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UsHtsQuery = { __typename?: 'Query', usHts: { __typename?: 'UsHts', id: string, version: number, number: any, startDate?: any | null, endDate?: any | null, description?: string | null, rateCode?: string | null, uom?: Array<string> | null, additionalHTS?: boolean | null, adCvdCases?: Array<{ __typename?: 'AdCvdCase', id: string }> | null, descriptions?: Array<{ __typename?: 'HtsDescription', startDate?: any | null, endDate?: any | null, text?: string | null }> | null, mainDutyRates?: Array<{ __typename?: 'HtsRate', rateCode?: string | null, adValorem?: number | null, specific?: number | null, other?: number | null, startDate?: any | null, endDate?: any | null }> | null, spiRates?: Array<{ __typename?: 'HtsSpiRate', code?: string | null, country?: any | null, rateCode?: string | null, adValorem?: number | null, other?: number | null, specific?: number | null, startDate?: any | null, endDate?: any | null }> | null, pga?: Array<{ __typename?: 'PgaRequirement', startDate?: any | null, endDate?: any | null, flag: any }> | null, additionalHtssApplicable?: Array<{ __typename?: 'AdditionalHts', type?: AdditionalHtsType | null, number: string, startDate?: any | null, endDate?: any | null, include?: Array<any> | null, exclude?: Array<any> | null }> | null, fees?: Array<{ __typename?: 'HtsFee', class?: string | null, rateCode?: string | null, required?: boolean | null, startDate?: any | null, endDate?: any | null, rate?: { __typename?: 'HtsRate', adValorem?: number | null, specific?: number | null, other?: number | null } | null }> | null } };

export type PhoneFragmentFragment = { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null };

export type TagFragmentFragment = { __typename?: 'Tag', key: string, value: string };

type SourceFragment_ClientSystem_Fragment = { __typename?: 'ClientSystem', clientSystemName: ClientSystemName };

type SourceFragment_InternalSystem_Fragment = { __typename?: 'InternalSystem', internalSystemName: InternalSystemName };

type SourceFragment_InternalWebsite_Fragment = { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName };

export type SourceFragmentFragment = SourceFragment_ClientSystem_Fragment | SourceFragment_InternalSystem_Fragment | SourceFragment_InternalWebsite_Fragment;

export type RequestFragmentFragment = { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null };

export type ReasonFragmentFragment = { __typename?: 'RecordActionReason', code?: string | null, text?: string | null };

export type RecordActionFieldsFragment = { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null };

export type DocumentFragmentFragment = { __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } };

export type OperatorReferenceFragmentFragment = { __typename?: 'Operator', id: string, version: number, name: string };

export type UserWorkingHoursFieldsFragment = { __typename?: 'UserWorkDay', start?: any | null, end?: any | null };

export type BillingDetailsFragmentFragment = { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null };

export type AuthenticationContextQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticationContextQuery = { __typename?: 'Query', authenticationContext: { __typename?: 'AuthenticationContextPayload', authenticatedUserContext?: { __typename?: 'FederatedUserContext', intercomHash?: string | null, user?: { __typename?: 'FederatedShipperUser', root?: boolean | null, operator: { __typename?: 'Operator', id: string }, shipper: { __typename?: 'Shipper', id: string } } | null } | { __typename?: 'UserContext', intercomHash?: string | null, user?: { __typename?: 'ForwarderUser', id: string, name: string, version: number, title: string, email: any, root?: boolean | null, appLastVersionSeen?: any | null, loginLink?: any | null, limitNotifications?: boolean | null, avatarUrl?: any | null, away?: boolean | null, operator: { __typename?: 'Operator', id: string, version: number, name: string }, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, forwarder: { __typename?: 'Forwarder', id: string, name: string, globalLogisticsProfileId?: string | null, poaMethod?: POAMethod | null, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, mailFrom?: { __typename?: 'ForwarderMailFrom', fromEmail: any, fromTitle: string, fromSignature: string } | null, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null } | null }, cargowise?: { __typename?: 'ForwarderUserCargowiseIntegrationDetails', cargowiseId: string } | null, forwarderUserPermissions?: { __typename?: 'ForwarderUserPermissions', document?: Array<{ __typename?: 'ForwarderUserDocumentPermission', name: ForwarderUserDocumentPermissionName }> | null, documentTemplate?: Array<{ __typename?: 'ForwarderUserDocumentTemplatePermission', name: ForwarderUserDocumentTemplatePermissionName }> | null, customsAgent?: Array<{ __typename?: 'ForwarderUserCustomsAgentPermission', name: ForwarderUserCustomsAgentPermissionName }> | null, facility?: Array<{ __typename?: 'ForwarderUserFacilityPermission', name: ForwarderUserFacilityPermissionName }> | null, shipper?: Array<{ __typename?: 'ForwarderUserShipperPermission', name: ForwarderUserShipperPermissionName }> | null, supplier?: Array<{ __typename?: 'ForwarderUserSupplierPermission', name: ForwarderUserSupplierPermissionName }> | null, trucker?: Array<{ __typename?: 'ForwarderUserSupplierPermission', name: ForwarderUserSupplierPermissionName }> | null, usConsignee?: Array<{ __typename?: 'ForwarderUserUsConsigneePermission', name: ForwarderUserUsConsigneePermissionName }> | null, usIor?: Array<{ __typename?: 'ForwarderUserUsIorPermission', name: ForwarderUserUsIorPermissionName }> | null, usConsumptionEntry?: Array<{ __typename?: 'ForwarderUserUsConsumptionEntryPermission', name: ForwarderUserUsConsumptionEntryPermissionName }> | null, usIsf?: Array<{ __typename?: 'ForwarderUserUsIsfPermission', name: ForwarderUserUsIsfPermissionName }> | null, invoice?: Array<{ __typename?: 'ForwarderUserInvoicePermission', name: ForwarderUserInvoicePermissionName }> | null, product?: Array<{ __typename?: 'ForwarderUserProductPermission', name: ForwarderUserProductPermissionName }> | null, shipment?: Array<{ __typename?: 'ForwarderUserShipmentPermission', name: ForwarderUserShipmentPermissionName }> | null, forwarderUser?: Array<{ __typename?: 'ForwarderUserForwarderUserPermission', name: ForwarderUserForwarderUserPermissionName }> | null, usInBond?: Array<{ __typename?: 'ForwarderUserUsInBondPermission', name: ForwarderUserUsInBondPermissionName }> | null, usCustomsBroker?: Array<{ __typename?: 'ForwarderUserUsCustomsBrokerPermission', name: ForwarderUserUsCustomsBrokerPermissionName }> | null, usIorContinuousBondRequest?: Array<{ __typename?: 'ForwarderUserUsIorContinuousBondRequestPermission', name: ForwarderUserUsIorContinuousBondRequestPermissionName }> | null, usIorActivation?: Array<{ __typename?: 'ForwarderUserUsIorActivationPermission', name: ForwarderUserUsIorActivationPermissionName }> | null, usPostSummaryCorrection?: Array<{ __typename?: 'ForwarderUserPostSummaryCorrectionPermission', name: ForwarderUserPostSummaryCorrectionPermissionName }> | null, usDrawbackClaim?: Array<{ __typename?: 'ForwarderUserUsDrawbackClaimPermission', name: ForwarderUserUsDrawbackClaimPermissionName }> | null, company?: Array<{ __typename?: 'ForwarderUserCompanyPermission', name: ForwarderUserCompanyPermissionName }> | null, deliveryOrder?: Array<{ __typename?: 'ForwarderUserDeliveryOrderPermission', name: ForwarderUserDeliveryOrderPermissionName }> | null, bulkMilestoneUploadRequest?: Array<{ __typename?: 'ForwarderUserBulkMilestoneUploadRequestPermission', name: ForwarderUserBulkMilestoneUploadRequestPermissionName }> | null, bulkChargesUploadRequest?: Array<{ __typename?: 'ForwarderUserBulkChargesUploadRequestPermission', name: ForwarderUserBulkChargesUploadRequestPermissionName }> | null, bulkComplianceUploadRequest?: Array<{ __typename?: 'ForwarderUserBulkComplianceUploadRequestPermission', name: ForwarderUserBulkComplianceUploadRequestPermissionName }> | null, releaseNote?: Array<{ __typename?: 'ForwarderUserReleaseNotePermission', name: ForwarderUserReleaseNotePermissionName }> | null, userReleaseNoteView?: Array<{ __typename?: 'ForwarderUserUserReleaseNoteViewPermission', name: ForwarderUserUserReleaseNoteViewPermissionName }> | null } | null, mobilePhone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, officePhone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, cognito?: { __typename?: 'CognitoUserDetails', sub: string, id?: string | null } | null, created: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, teams?: Array<{ __typename?: 'Team', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null } | { __typename?: 'OperatorUser', dailyGoal?: number | null, id: string, name: string, version: number, title: string, email: any, root?: boolean | null, appLastVersionSeen?: any | null, loginLink?: any | null, limitNotifications?: boolean | null, avatarUrl?: any | null, away?: boolean | null, operator: { __typename?: 'Operator', id: string, version: number, name: string }, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, customsBroker?: { __typename?: 'Broker', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'DeCustomsBroker', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'FrCustomsBroker', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'NlCustomsBroker', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'UkCustomsBroker', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'UsCustomsBroker', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, assumedUser?: { __typename?: 'ForwarderUser', id: string, name: string, root?: boolean | null, operator: { __typename?: 'Operator', id: string, version: number, name: string }, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, forwarder: { __typename?: 'Forwarder', id: string, name: string, globalLogisticsProfileId?: string | null, poaMethod?: POAMethod | null, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, mailFrom?: { __typename?: 'ForwarderMailFrom', fromEmail: any, fromTitle: string, fromSignature: string } | null, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null } | null }, cargowise?: { __typename?: 'ForwarderUserCargowiseIntegrationDetails', cargowiseId: string } | null, forwarderUserPermissions?: { __typename?: 'ForwarderUserPermissions', document?: Array<{ __typename?: 'ForwarderUserDocumentPermission', name: ForwarderUserDocumentPermissionName }> | null, documentTemplate?: Array<{ __typename?: 'ForwarderUserDocumentTemplatePermission', name: ForwarderUserDocumentTemplatePermissionName }> | null, customsAgent?: Array<{ __typename?: 'ForwarderUserCustomsAgentPermission', name: ForwarderUserCustomsAgentPermissionName }> | null, facility?: Array<{ __typename?: 'ForwarderUserFacilityPermission', name: ForwarderUserFacilityPermissionName }> | null, shipper?: Array<{ __typename?: 'ForwarderUserShipperPermission', name: ForwarderUserShipperPermissionName }> | null, supplier?: Array<{ __typename?: 'ForwarderUserSupplierPermission', name: ForwarderUserSupplierPermissionName }> | null, trucker?: Array<{ __typename?: 'ForwarderUserSupplierPermission', name: ForwarderUserSupplierPermissionName }> | null, usConsignee?: Array<{ __typename?: 'ForwarderUserUsConsigneePermission', name: ForwarderUserUsConsigneePermissionName }> | null, usIor?: Array<{ __typename?: 'ForwarderUserUsIorPermission', name: ForwarderUserUsIorPermissionName }> | null, usConsumptionEntry?: Array<{ __typename?: 'ForwarderUserUsConsumptionEntryPermission', name: ForwarderUserUsConsumptionEntryPermissionName }> | null, usIsf?: Array<{ __typename?: 'ForwarderUserUsIsfPermission', name: ForwarderUserUsIsfPermissionName }> | null, invoice?: Array<{ __typename?: 'ForwarderUserInvoicePermission', name: ForwarderUserInvoicePermissionName }> | null, product?: Array<{ __typename?: 'ForwarderUserProductPermission', name: ForwarderUserProductPermissionName }> | null, shipment?: Array<{ __typename?: 'ForwarderUserShipmentPermission', name: ForwarderUserShipmentPermissionName }> | null, forwarderUser?: Array<{ __typename?: 'ForwarderUserForwarderUserPermission', name: ForwarderUserForwarderUserPermissionName }> | null, usInBond?: Array<{ __typename?: 'ForwarderUserUsInBondPermission', name: ForwarderUserUsInBondPermissionName }> | null, usCustomsBroker?: Array<{ __typename?: 'ForwarderUserUsCustomsBrokerPermission', name: ForwarderUserUsCustomsBrokerPermissionName }> | null, usIorContinuousBondRequest?: Array<{ __typename?: 'ForwarderUserUsIorContinuousBondRequestPermission', name: ForwarderUserUsIorContinuousBondRequestPermissionName }> | null, usIorActivation?: Array<{ __typename?: 'ForwarderUserUsIorActivationPermission', name: ForwarderUserUsIorActivationPermissionName }> | null, usPostSummaryCorrection?: Array<{ __typename?: 'ForwarderUserPostSummaryCorrectionPermission', name: ForwarderUserPostSummaryCorrectionPermissionName }> | null, usDrawbackClaim?: Array<{ __typename?: 'ForwarderUserUsDrawbackClaimPermission', name: ForwarderUserUsDrawbackClaimPermissionName }> | null, company?: Array<{ __typename?: 'ForwarderUserCompanyPermission', name: ForwarderUserCompanyPermissionName }> | null, deliveryOrder?: Array<{ __typename?: 'ForwarderUserDeliveryOrderPermission', name: ForwarderUserDeliveryOrderPermissionName }> | null, bulkMilestoneUploadRequest?: Array<{ __typename?: 'ForwarderUserBulkMilestoneUploadRequestPermission', name: ForwarderUserBulkMilestoneUploadRequestPermissionName }> | null, bulkChargesUploadRequest?: Array<{ __typename?: 'ForwarderUserBulkChargesUploadRequestPermission', name: ForwarderUserBulkChargesUploadRequestPermissionName }> | null, bulkComplianceUploadRequest?: Array<{ __typename?: 'ForwarderUserBulkComplianceUploadRequestPermission', name: ForwarderUserBulkComplianceUploadRequestPermissionName }> | null, releaseNote?: Array<{ __typename?: 'ForwarderUserReleaseNotePermission', name: ForwarderUserReleaseNotePermissionName }> | null, userReleaseNoteView?: Array<{ __typename?: 'ForwarderUserUserReleaseNoteViewPermission', name: ForwarderUserUserReleaseNoteViewPermissionName }> | null } | null } | { __typename?: 'OperatorUser', id: string, name: string, root?: boolean | null } | { __typename?: 'ShipperUser', id: string, name: string, root?: boolean | null, operator: { __typename?: 'Operator', id: string, version: number, name: string }, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, shipper: { __typename?: 'Shipper', id: string, name: string, globalLogisticsProfileId?: string | null, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null } | null }, shipperUserPermissions?: { __typename?: 'ShipperUserPermissions', document?: Array<{ __typename?: 'ShipperUserDocumentPermission', name: ShipperUserDocumentPermissionName }> | null, documentTemplate?: Array<{ __typename?: 'ShipperUserDocumentTemplatePermission', name: ShipperUserDocumentTemplatePermissionName }> | null, customsAgent?: Array<{ __typename?: 'ShipperUserCustomsAgentPermission', name: ShipperUserCustomsAgentPermissionName }> | null, facility?: Array<{ __typename?: 'ShipperUserFacilityPermission', name: ShipperUserFacilityPermissionName }> | null, forwarder?: Array<{ __typename?: 'ShipperUserForwarderPermission', name: ShipperUserForwarderPermissionName }> | null, supplier?: Array<{ __typename?: 'ShipperUserSupplierPermission', name: ShipperUserSupplierPermissionName }> | null, trucker?: Array<{ __typename?: 'ShipperUserSupplierPermission', name: ShipperUserSupplierPermissionName }> | null, usConsignee?: Array<{ __typename?: 'ShipperUserUsConsigneePermission', name: ShipperUserUsConsigneePermissionName }> | null, usIor?: Array<{ __typename?: 'ShipperUserUsIorPermission', name: ShipperUserUsIorPermissionName }> | null, usConsumptionEntry?: Array<{ __typename?: 'ShipperUserUsConsumptionEntryPermission', name: ShipperUserUsConsumptionEntryPermissionName }> | null, usIsf?: Array<{ __typename?: 'ShipperUserUsIsfPermission', name: ShipperUserUsIsfPermissionName }> | null, invoice?: Array<{ __typename?: 'ShipperUserInvoicePermission', name: ShipperUserInvoicePermissionName }> | null, product?: Array<{ __typename?: 'ShipperUserProductPermission', name: ShipperUserProductPermissionName }> | null, shipment?: Array<{ __typename?: 'ShipperUserShipmentPermission', name: ShipperUserShipmentPermissionName }> | null, shipperUser?: Array<{ __typename?: 'ShipperUserShipperUserPermission', name: ShipperUserShipperUserPermissionName }> | null, usInBond?: Array<{ __typename?: 'ShipperUserUsInBondPermission', name: ShipperUserUsInBondPermissionName }> | null, usCustomsBroker?: Array<{ __typename?: 'ShipperUserUsCustomsBrokerPermission', name: ShipperUserUsCustomsBrokerPermissionName }> | null, usIorContinuousBondRequest?: Array<{ __typename?: 'ShipperUserUsIorContinuousBondRequestPermission', name: ShipperUserUsIorContinuousBondRequestPermissionName }> | null, company?: Array<{ __typename?: 'ShipperUserCompanyPermission', name: ShipperUserCompanyPermissionName }> | null, usIorActivation?: Array<{ __typename?: 'ShipperUserUsIorActivationPermission', name: ShipperUserUsIorActivationPermissionName }> | null, usPostSummaryCorrection?: Array<{ __typename?: 'ShipperUserPostSummaryCorrectionPermission', name: ShipperUserUsPostSummaryCorrectionPermissionName }> | null, usDrawbackClaim?: Array<{ __typename?: 'ShipperUserUsDrawbackClaimPermission', name: ShipperUserUsDrawbackClaimPermissionName }> | null, deliveryOrder?: Array<{ __typename?: 'ShipperUserDeliveryOrderPermission', name: ShipperUserDeliveryOrderPermissionName }> | null, bulkMilestoneUploadRequest?: Array<{ __typename?: 'ShipperUserBulkMilestoneUploadRequestPermission', name: ShipperUserBulkMilestoneUploadRequestPermissionName }> | null, bulkChargesUploadRequest?: Array<{ __typename?: 'ShipperUserBulkChargesUploadRequestPermission', name: ShipperUserBulkChargesUploadRequestPermissionName }> | null, bulkComplianceUploadRequest?: Array<{ __typename?: 'ShipperUserBulkComplianceUploadRequestPermission', name: ShipperUserBulkComplianceUploadRequestPermissionName }> | null, releaseNote?: Array<{ __typename?: 'ShipperUserReleaseNotePermission', name: ShipperUserReleaseNotePermissionName }> | null, userReleaseNoteView?: Array<{ __typename?: 'ShipperUserUserReleaseNoteViewPermission', name: ShipperUserUserReleaseNoteViewPermissionName }> | null } | null } | null, workingHours?: { __typename?: 'UserWorkingHours', sunday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null, monday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null, tuesday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null, wednesday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null, thursday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null, friday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null, saturday?: { __typename?: 'UserWorkDay', start?: any | null, end?: any | null } | null } | null, operatorUserPermissions?: { __typename?: 'OperatorUserPermissions', usIorActivation?: Array<{ __typename?: 'OperatorUserUsIorActivationPermission', name: OperatorUserUsIorActivationPermissionName }> | null, document?: Array<{ __typename?: 'OperatorUserDocumentPermission', name: OperatorUserDocumentPermissionName }> | null, documentTemplate?: Array<{ __typename?: 'OperatorUserDocumentTemplatePermission', name: OperatorUserDocumentTemplatePermissionName }> | null, customsAgent?: Array<{ __typename?: 'OperatorUserCustomsAgentPermission', name: OperatorUserCustomsAgentPermissionName }> | null, facility?: Array<{ __typename?: 'OperatorUserFacilityPermission', name: OperatorUserFacilityPermissionName }> | null, forwarder?: Array<{ __typename?: 'OperatorUserForwarderPermission', name: OperatorUserForwarderPermissionName }> | null, deCustomsEntry?: Array<{ __typename?: 'OperatorUserDeCustomsEntryPermission', name: OperatorUserDeCustomsEntryPermissionName }> | null, gbCustomsEntry?: Array<{ __typename?: 'OperatorUserGbCustomsEntryPermission', name: OperatorUserGbCustomsEntryPermissionName }> | null, nlCustomsEntry?: Array<{ __typename?: 'OperatorUserNlCustomsEntryPermission', name: OperatorUserNlCustomsEntryPermissionName }> | null, frCustomsEntry?: Array<{ __typename?: 'OperatorUserFrCustomsEntryPermission', name: OperatorUserFrCustomsEntryPermissionName }> | null, usType86Entry?: Array<{ __typename?: 'OperatorUserUsType86EntryPermission', name: OperatorUserUsType86EntryPermissionName }> | null, shipper?: Array<{ __typename?: 'OperatorUserShipperPermission', name: OperatorUserShipperPermissionName }> | null, supplier?: Array<{ __typename?: 'OperatorUserSupplierPermission', name: OperatorUserSupplierPermissionName }> | null, trucker?: Array<{ __typename?: 'OperatorUserSupplierPermission', name: OperatorUserSupplierPermissionName }> | null, usConsignee?: Array<{ __typename?: 'OperatorUserUsConsigneePermission', name: OperatorUserUsConsigneePermissionName }> | null, usIor?: Array<{ __typename?: 'OperatorUserUsIorPermission', name: OperatorUserUsIorPermissionName }> | null, gbIor?: Array<{ __typename?: 'OperatorUserGbIorPermission', name: OperatorUserGbIorPermissionName }> | null, deIor?: Array<{ __typename?: 'OperatorUserDeIorPermission', name: OperatorUserDeIorPermissionName }> | null, nlIor?: Array<{ __typename?: 'OperatorUserNlIorPermission', name: OperatorUserNlIorPermissionName }> | null, frIor?: Array<{ __typename?: 'OperatorUserFrIorPermission', name: OperatorUserFrIorPermissionName }> | null, usConsumptionEntry?: Array<{ __typename?: 'OperatorUserUsConsumptionEntryPermission', name: OperatorUserUsConsumptionEntryPermissionName }> | null, usPostSummaryCorrection?: Array<{ __typename?: 'OperatorUserUsPostSummaryCorrectionPermission', name: OperatorUserUsPostSummaryCorrectionPermissionName }> | null, usIsf?: Array<{ __typename?: 'OperatorUserUsIsfPermission', name: OperatorUserUsIsfPermissionName }> | null, invoice?: Array<{ __typename?: 'OperatorUserInvoicePermission', name: OperatorUserInvoicePermissionName }> | null, invoiceLinesRequest?: Array<{ __typename?: 'OperatorUserInvoiceLinesRequestPermission', name: OperatorUserInvoiceLinesRequestPermissionName }> | null, payableInvoice?: Array<{ __typename?: 'OperatorUserPayableInvoicePermission', name: OperatorUserPayableInvoicePermissionName }> | null, product?: Array<{ __typename?: 'OperatorUserProductPermission', name: OperatorUserProductPermissionName }> | null, shipment?: Array<{ __typename?: 'OperatorUserShipmentPermission', name: OperatorUserShipmentPermissionName }> | null, workOrderTask?: Array<{ __typename?: 'OperatorUserWorkOrderTaskPermission', name: OperatorUserWorkOrderTaskPermissionName }> | null, operatorUser?: Array<{ __typename?: 'OperatorUserOperatorUserPermission', name: OperatorUserOperatorUserPermissionName }> | null, reportReconciliationRequest?: Array<{ __typename?: 'OperatorUserReportReconciliationRequestPermission', name: OperatorUserReportReconciliationRequestPermissionName }> | null, usIorContinuousBondRequest?: Array<{ __typename?: 'OperatorUserUsIorContinuousBondRequestPermission', name: OperatorUserUsIorContinuousBondRequestPermissionName }> | null, usInBond?: Array<{ __typename?: 'OperatorUserUsInBondPermission', name: OperatorUserUsInBondPermissionName }> | null, usCustomsBroker?: Array<{ __typename?: 'OperatorUserUsCustomsBrokerPermission', name: OperatorUserUsCustomsBrokerPermissionName }> | null, usHts?: Array<{ __typename?: 'OperatorUserUsHtsPermission', name: OperatorUserUsHtsPermissionName }> | null, company?: Array<{ __typename?: 'OperatorUserCompanyPermission', name: OperatorUserCompanyPermissionName }> | null, usDrawbackClaim?: Array<{ __typename?: 'OperatorUserUsDrawbackClaimPermission', name: OperatorUserUsDrawbackClaimPermissionName }> | null, deliveryOrder?: Array<{ __typename?: 'OperatorUserDeliveryOrderPermission', name: OperatorUserDeliveryOrderPermissionName }> | null, gbIorActivation?: Array<{ __typename?: 'OperatorUserGbIorActivationPermission', name: OperatorUserGbIorActivationPermissionName }> | null, deIorActivation?: Array<{ __typename?: 'OperatorUserDeIorActivationPermission', name: OperatorUserDeIorActivationPermissionName }> | null, nlIorActivation?: Array<{ __typename?: 'OperatorUserNlIorActivationPermission', name: OperatorUserNlIorActivationPermissionName }> | null, frIorActivation?: Array<{ __typename?: 'OperatorUserFrIorActivationPermission', name: OperatorUserFrIorActivationPermissionName }> | null, gbConsignee?: Array<{ __typename?: 'OperatorUserGbConsigneePermission', name: OperatorUserGbConsigneePermissionName }> | null, ukCustomsBroker?: Array<{ __typename?: 'OperatorUserUkCustomsBrokerPermission', name: OperatorUserUkCustomsBrokerPermissionName }> | null, deConsignee?: Array<{ __typename?: 'OperatorUserDeConsigneePermission', name: OperatorUserDeConsigneePermissionName }> | null, nlConsignee?: Array<{ __typename?: 'OperatorUserNlConsigneePermission', name: OperatorUserNlConsigneePermissionName }> | null, nlCustomsBroker?: Array<{ __typename?: 'OperatorUserNlCustomsBrokerPermission', name: OperatorUserNlCustomsBrokerPermissionName }> | null, frConsignee?: Array<{ __typename?: 'OperatorUserFrConsigneePermission', name: OperatorUserFrConsigneePermissionName }> | null, frCustomsBroker?: Array<{ __typename?: 'OperatorUserFrCustomsBrokerPermission', name: OperatorUserFrCustomsBrokerPermissionName }> | null, deCustomsBroker?: Array<{ __typename?: 'OperatorUserDeCustomsBrokerPermission', name: OperatorUserDeCustomsBrokerPermissionName }> | null, assignmentTeam?: Array<{ __typename?: 'OperatorUserAssignmentTeamPermission', name: OperatorUserAssignmentTeamPermissionName }> | null, businessSupportTeam?: Array<{ __typename?: 'OperatorUserBusinessSupportTeamPermission', name: OperatorUserBusinessSupportTeamPermissionName }> | null, commodityGroup?: Array<{ __typename?: 'OperatorUserCommodityGroupPermission', name: OperatorUserCommodityGroupPermissionName }> | null, memo?: Array<{ __typename?: 'OperatorUserMemoPermission', name: OperatorUserMemoPermissionName }> | null, bulkMilestoneUploadRequest?: Array<{ __typename?: 'OperatorUserBulkMilestoneUploadRequestPermission', name: OperatorUserBulkMilestoneUploadRequestPermissionName }> | null, bulkChargesUploadRequest?: Array<{ __typename?: 'OperatorUserBulkChargesUploadRequestPermission', name: OperatorUserBulkChargesUploadRequestPermissionName }> | null, bulkComplianceUploadRequest?: Array<{ __typename?: 'OperatorUserBulkComplianceUploadRequestPermission', name: OperatorUserBulkComplianceUploadRequestPermissionName }> | null, exchangeMessage?: Array<{ __typename?: 'OperatorUserExchangeMessagePermission', name: OperatorUserExchangeMessagePermissionName }> | null, workOrderTaskEscalationMessage?: Array<{ __typename?: 'OperatorUserWorkOrderTaskEscalationMessagePermission', name: OperatorUserWorkOrderTaskEscalationMessagePermissionName }> | null, broker?: Array<{ __typename?: 'OperatorUserBrokerPermission', name: OperatorUserBrokerPermissionName }> | null, customsBroker?: Array<{ __typename?: 'OperatorUserCustomsBrokerPermission', name: OperatorUserCustomsBrokerPermissionName }> | null, customsDeclaration?: Array<{ __typename?: 'OperatorUserCustomsDeclarationPermission', name: OperatorUserCustomsDeclarationPermissionName }> | null, customsEntry?: Array<{ __typename?: 'OperatorUserCustomsEntryPermission', name: OperatorUserCustomsEntryPermissionName }> | null, importer?: Array<{ __typename?: 'OperatorUserImporterPermission', name: OperatorUserImporterPermissionName }> | null, globalConsignee?: Array<{ __typename?: 'OperatorUserGlobalConsigneePermission', name: OperatorUserGlobalConsigneePermissionName }> | null, importerEntity?: Array<{ __typename?: 'OperatorUserImporterEntityPermission', name: OperatorUserImporterEntityPermissionName }> | null, importerEntityActivation?: Array<{ __typename?: 'OperatorUserImporterEntityActivationPermission', name: OperatorUserImporterEntityActivationPermissionName }> | null, releaseNote?: Array<{ __typename?: 'OperatorUserReleaseNotePermission', name: OperatorUserReleaseNotePermissionName }> | null, userReleaseNoteView?: Array<{ __typename?: 'OperatorUserUserReleaseNoteViewPermission', name: OperatorUserUserReleaseNoteViewPermissionName }> | null } | null, assignmentTeams: { __typename?: 'OperatorUserAssignmentTeamsConnection', edges: Array<{ __typename?: 'OperatorUserAssignmentTeamEdge', node: { __typename?: 'AssignmentTeam', id: string, name: string, workOrderTaskTypes: Array<WorkOrderTaskType>, assignmentTeamTypes?: Array<AssignmentTeamType> | null, backupTeam?: { __typename?: 'AssignmentTeam', id: string } | null }, relationship: { __typename?: 'AssignmentTeamOperatorUserRelationship', roles: Array<OperatorUserTeamRole> } }>, nodes: Array<{ __typename?: 'AssignmentTeam', id: string }> }, subjectMatterExpertTeams: { __typename?: 'OperatorUserSubjectMatterExpertTeamsConnection', edges: Array<{ __typename?: 'OperatorUserSubjectMatterExpertTeamEdge', node: { __typename?: 'SubjectMatterExpertTeam', id: string } }> }, businessSupportTeams: { __typename?: 'OperatorUserBusinessSupportTeamsConnection', nodes: Array<{ __typename?: 'BusinessSupportTeam', id: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> }, mobilePhone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, officePhone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, cognito?: { __typename?: 'CognitoUserDetails', sub: string, id?: string | null } | null, created: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, teams?: Array<{ __typename?: 'Team', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null } | { __typename?: 'ShipperUser', id: string, name: string, version: number, title: string, email: any, root?: boolean | null, appLastVersionSeen?: any | null, loginLink?: any | null, limitNotifications?: boolean | null, avatarUrl?: any | null, away?: boolean | null, operator: { __typename?: 'Operator', id: string, version: number, name: string }, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, shipper: { __typename?: 'Shipper', id: string, name: string, globalLogisticsProfileId?: string | null, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag>, preview: { __typename?: 'UrlPreview', downloadLink?: any | null }, created: { __typename?: 'RecordAction', time: any } }>, billingDetails?: { __typename?: 'BillingDetails', subscriptionPlan?: SubscriptionPlan | null } | null }, shipperUserPermissions?: { __typename?: 'ShipperUserPermissions', document?: Array<{ __typename?: 'ShipperUserDocumentPermission', name: ShipperUserDocumentPermissionName }> | null, documentTemplate?: Array<{ __typename?: 'ShipperUserDocumentTemplatePermission', name: ShipperUserDocumentTemplatePermissionName }> | null, customsAgent?: Array<{ __typename?: 'ShipperUserCustomsAgentPermission', name: ShipperUserCustomsAgentPermissionName }> | null, facility?: Array<{ __typename?: 'ShipperUserFacilityPermission', name: ShipperUserFacilityPermissionName }> | null, forwarder?: Array<{ __typename?: 'ShipperUserForwarderPermission', name: ShipperUserForwarderPermissionName }> | null, supplier?: Array<{ __typename?: 'ShipperUserSupplierPermission', name: ShipperUserSupplierPermissionName }> | null, trucker?: Array<{ __typename?: 'ShipperUserSupplierPermission', name: ShipperUserSupplierPermissionName }> | null, usConsignee?: Array<{ __typename?: 'ShipperUserUsConsigneePermission', name: ShipperUserUsConsigneePermissionName }> | null, usIor?: Array<{ __typename?: 'ShipperUserUsIorPermission', name: ShipperUserUsIorPermissionName }> | null, usConsumptionEntry?: Array<{ __typename?: 'ShipperUserUsConsumptionEntryPermission', name: ShipperUserUsConsumptionEntryPermissionName }> | null, usIsf?: Array<{ __typename?: 'ShipperUserUsIsfPermission', name: ShipperUserUsIsfPermissionName }> | null, invoice?: Array<{ __typename?: 'ShipperUserInvoicePermission', name: ShipperUserInvoicePermissionName }> | null, product?: Array<{ __typename?: 'ShipperUserProductPermission', name: ShipperUserProductPermissionName }> | null, shipment?: Array<{ __typename?: 'ShipperUserShipmentPermission', name: ShipperUserShipmentPermissionName }> | null, shipperUser?: Array<{ __typename?: 'ShipperUserShipperUserPermission', name: ShipperUserShipperUserPermissionName }> | null, usInBond?: Array<{ __typename?: 'ShipperUserUsInBondPermission', name: ShipperUserUsInBondPermissionName }> | null, usCustomsBroker?: Array<{ __typename?: 'ShipperUserUsCustomsBrokerPermission', name: ShipperUserUsCustomsBrokerPermissionName }> | null, usIorContinuousBondRequest?: Array<{ __typename?: 'ShipperUserUsIorContinuousBondRequestPermission', name: ShipperUserUsIorContinuousBondRequestPermissionName }> | null, company?: Array<{ __typename?: 'ShipperUserCompanyPermission', name: ShipperUserCompanyPermissionName }> | null, usIorActivation?: Array<{ __typename?: 'ShipperUserUsIorActivationPermission', name: ShipperUserUsIorActivationPermissionName }> | null, usPostSummaryCorrection?: Array<{ __typename?: 'ShipperUserPostSummaryCorrectionPermission', name: ShipperUserUsPostSummaryCorrectionPermissionName }> | null, usDrawbackClaim?: Array<{ __typename?: 'ShipperUserUsDrawbackClaimPermission', name: ShipperUserUsDrawbackClaimPermissionName }> | null, deliveryOrder?: Array<{ __typename?: 'ShipperUserDeliveryOrderPermission', name: ShipperUserDeliveryOrderPermissionName }> | null, bulkMilestoneUploadRequest?: Array<{ __typename?: 'ShipperUserBulkMilestoneUploadRequestPermission', name: ShipperUserBulkMilestoneUploadRequestPermissionName }> | null, bulkChargesUploadRequest?: Array<{ __typename?: 'ShipperUserBulkChargesUploadRequestPermission', name: ShipperUserBulkChargesUploadRequestPermissionName }> | null, bulkComplianceUploadRequest?: Array<{ __typename?: 'ShipperUserBulkComplianceUploadRequestPermission', name: ShipperUserBulkComplianceUploadRequestPermissionName }> | null, releaseNote?: Array<{ __typename?: 'ShipperUserReleaseNotePermission', name: ShipperUserReleaseNotePermissionName }> | null, userReleaseNoteView?: Array<{ __typename?: 'ShipperUserUserReleaseNoteViewPermission', name: ShipperUserUserReleaseNoteViewPermissionName }> | null } | null, mobilePhone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, officePhone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, cognito?: { __typename?: 'CognitoUserDetails', sub: string, id?: string | null } | null, created: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename?: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename?: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename?: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, teams?: Array<{ __typename?: 'Team', id: string, name: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null } | null } | null } };

export type ReviewWorkOrderConfirmationMutationVariables = Exact<{
  id: Scalars['ID'];
  status: WorkOrderConfirmationReviewApprovalStatus;
  disputedReason?: InputMaybe<Scalars['String']>;
}>;


export type ReviewWorkOrderConfirmationMutation = { __typename?: 'Mutation', reviewWorkOrderConfirmation: { __typename?: 'ReviewWorkOrderConfirmationPayload', workOrderConfirmation: { __typename?: 'WorkOrderConfirmation', id: string, version: number, status?: WorkOrderConfirmationApprovalStatus | null } } };

export type CreateWorkOrderPresignedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateWorkOrderPresignedUrlMutation = { __typename?: 'Mutation', createWorkOrderPresignedUrl: { __typename?: 'WorkOrderPresignedUrlResponse', uploadLink: string, referenceKey: string } };

export type SearchCommodityGroupQueryVariables = Exact<{
  input: SearchCommodityGroupInput;
}>;


export type SearchCommodityGroupQuery = { __typename?: 'Query', searchCommodityGroups: { __typename?: 'SearchCommodityGroupPayload', results: Array<{ __typename?: 'CommodityGroup', id: string, name: string, description: string, htsChapters?: Array<string> | null, pgas?: Array<string> | null }> } };

export type ExchangeMessageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExchangeMessageQuery = { __typename?: 'Query', exchangeMessage: { __typename?: 'ExchangeMessage', id: string, version: number, sender: MessagingPartner, receiver: MessagingPartner, type: ExchangeMessageType, status: ExchangeMessageStatus, inboxMetadata?: { __typename?: 'InboxMetadata', from?: string | null, to?: Array<string> | null, subject?: string | null, body?: string | null, workOrderId?: string | null } | null, output?: { __typename?: 'ExchangeMessageContent', downloadLink?: any | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, documents: Array<{ __typename?: 'Document', id: string, version: number, fileName: string, extension: DocumentFileExtension, content: { __typename?: 'UrlContent', downloadLink?: any | null }, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null } };

export type ProcessingErrorDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProcessingErrorDetailQuery = { __typename?: 'Query', processingError: { __typename?: 'ProcessingError', id: string, name: string, source?: SystemType | null, message: string, status: ProcessingErrorStatus, created: { __typename?: 'RecordAction', time: any }, updated: { __typename?: 'RecordAction', time: any } } };

export type UpdateProcessingErrorMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpdateProcessingErrorInput;
}>;


export type UpdateProcessingErrorMutation = { __typename?: 'Mutation', updateProcessingError: { __typename?: 'UpdateProcessingErrorPayload', record: { __typename?: 'ProcessingError', id: string } } };

export type ImporterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImporterQuery = { __typename?: 'Query', importer: { __typename?: 'Importer', externalClientReferences?: Array<string> | null, id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, memos: Array<{ __typename?: 'Memo', text: string, isPublic?: boolean | null, id: string, version: number, operator: { __typename?: 'Operator', id: string }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, importerEntities: { __typename?: 'ImporterImporterEntitysConnection', nodes: Array<{ __typename?: 'ImporterEntity', id: string }> }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null, pointOfContact?: { __typename?: 'PointOfContact', name: string, title?: string | null, email?: any | null, phone?: { __typename?: 'Phone', country?: string | null, number: string, extension?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', type?: string | null, cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, line?: string | null, postCode?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, postOfficeBox?: string | null }> | null } };

export type UpdateImporterMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpdateImporterInput;
}>;


export type UpdateImporterMutation = { __typename?: 'Mutation', updateImporter: { __typename?: 'UpdateImporterPayload', record: { __typename?: 'Importer', id: string, version: number } } };

export type reassignWorkOrderTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type reassignWorkOrderTaskMutation = { __typename?: 'Mutation', reassignWorkOrderTask: { __typename?: 'ReassignWorkOrderTaskPayload', result: boolean } };

export type EscalateWorkOrderTaskMutationVariables = Exact<{
  input: WorkOrderTaskEscalationInput;
  taskId: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type EscalateWorkOrderTaskMutation = { __typename?: 'Mutation', escalateWorkOrderTask: { __typename?: 'EscalateWorkOrderTaskPayload', workOrderTask: { __typename?: 'WorkOrderTask', id: string, version: number } } };

export type memoRecordActionFieldsFragment = { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null };

export type memoFieldsFragment = { __typename?: 'Memo', text: string, isPublic?: boolean | null, id: string, version: number, operator: { __typename?: 'Operator', id: string }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

export type taskFieldsFragment = { __typename?: 'WorkOrderTask', name: string, workOrderType: WorkOrderType, status: WorkOrderTaskStatus, deadline?: any | null, id: string, version: number, assignee?: { __typename?: 'OperatorUser', id: string, name: string } | null, assignmentTeam?: { __typename?: 'AssignmentTeam', name: string, id: string, backupTeam?: { __typename?: 'AssignmentTeam', name: string, id: string } | null } | null, steps: Array<{ __typename?: 'WorkOrderTaskStep', id: string, name: string, description?: string | null, isCompletedBySystem?: boolean | null, isFinalConfirmation?: boolean | null, completed?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null }>, definition: { __typename?: 'WorkOrderTaskDefinition', id: string, estimatedDuration?: number | null, workOrderTaskType: WorkOrderTaskType }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

export type goodsShipmentFieldsFragment = { __typename?: 'GoodsShipment', importer?: Array<{ __typename?: 'DeIor', id: string, name: string } | { __typename?: 'FrIor', id: string, name: string } | { __typename?: 'GbIor', id: string, name: string } | { __typename?: 'Importer', id: string, name: string } | { __typename?: 'NlIor', id: string, name: string } | { __typename?: 'UsIor', id: string, name: string }> | null, importCountry?: Array<{ __typename?: 'ImportCountry', country?: any | null }> | null, exportCountry?: Array<{ __typename?: 'ExportCountry', country?: any | null }> | null, consignment?: Array<{ __typename?: 'Consignment', borderTransportationMean?: Array<{ __typename?: 'BorderTransportMeans', identificationType?: string | null, journey?: string | null, name?: string | null, arrival?: any | null, departure?: any | null, arrivalLocation?: Array<{ __typename?: 'ArrivalLocation', identification?: string | null }> | null, departureLocation?: Array<{ __typename?: 'DepartureLocation', identification?: string | null }> | null }> | null, transportContractDocument?: Array<{ __typename?: 'TransportContractDocument', identification?: string | null, type?: TransportContractDocumentType | null }> | null, transportEquipment?: Array<{ __typename?: 'TransportEquipment', fullness?: LoadType | null, identification?: string | null }> | null }> | null };

export type CustomsDeclarationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomsDeclarationQuery = { __typename?: 'Query', customsDeclaration: { __typename?: 'CustomsDeclaration', id: string, identification?: string | null, version: number, status: WorkOrderStatus, deadline?: any | null, badges?: Array<WorkOrderBadge> | null, canceled?: { __typename?: 'RecordAction', reason?: { __typename?: 'RecordActionReason', text?: string | null } | null } | null, operator: { __typename?: 'Operator', id: string }, confirmations: Array<{ __typename?: 'WorkOrderConfirmation', id: string, status?: WorkOrderConfirmationApprovalStatus | null }>, goodsShipment?: Array<{ __typename?: 'GoodsShipment', importCountry?: Array<{ __typename?: 'ImportCountry', country?: any | null }> | null, goodsItem?: Array<{ __typename?: 'GoodsItem', goodsMeasure?: { __typename?: 'GoodsMeasure', tariff?: number | null } | null, commodity?: { __typename?: 'Commodity', product?: { __typename?: 'Product', clientIdentifier: string, clientIdentifierVersion?: number | null, secondaryIdentifiers?: Array<{ __typename?: 'ProductSecondaryIdentifier', type: ProductSecondaryIdentifierType, value: string }> | null } | null } | null }> | null, importer?: Array<{ __typename?: 'DeIor', id: string, name: string } | { __typename?: 'FrIor', id: string, name: string } | { __typename?: 'GbIor', id: string, name: string } | { __typename?: 'Importer', id: string, name: string } | { __typename?: 'NlIor', id: string, name: string } | { __typename?: 'UsIor', id: string, name: string }> | null, exportCountry?: Array<{ __typename?: 'ExportCountry', country?: any | null }> | null, consignment?: Array<{ __typename?: 'Consignment', borderTransportationMean?: Array<{ __typename?: 'BorderTransportMeans', identificationType?: string | null, journey?: string | null, name?: string | null, arrival?: any | null, departure?: any | null, arrivalLocation?: Array<{ __typename?: 'ArrivalLocation', identification?: string | null }> | null, departureLocation?: Array<{ __typename?: 'DepartureLocation', identification?: string | null }> | null }> | null, transportContractDocument?: Array<{ __typename?: 'TransportContractDocument', identification?: string | null, type?: TransportContractDocumentType | null }> | null, transportEquipment?: Array<{ __typename?: 'TransportEquipment', fullness?: LoadType | null, identification?: string | null }> | null }> | null }> | null, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }>, tasks: Array<{ __typename?: 'WorkOrderTask', name: string, workOrderType: WorkOrderType, status: WorkOrderTaskStatus, deadline?: any | null, id: string, version: number, assignee?: { __typename?: 'OperatorUser', id: string, name: string } | null, assignmentTeam?: { __typename?: 'AssignmentTeam', name: string, id: string, backupTeam?: { __typename?: 'AssignmentTeam', name: string, id: string } | null } | null, steps: Array<{ __typename?: 'WorkOrderTaskStep', id: string, name: string, description?: string | null, isCompletedBySystem?: boolean | null, isFinalConfirmation?: boolean | null, completed?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null }>, definition: { __typename?: 'WorkOrderTaskDefinition', id: string, estimatedDuration?: number | null, workOrderTaskType: WorkOrderTaskType }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, group: { __typename?: 'WorkOrderGroup', id: string, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag> }>, customsBroker?: { __typename?: 'Broker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'DeCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'FrCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'NlCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'UkCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'UsCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', id: string, name: string, billingDetails?: { __typename?: 'BillingDetails', disbursement?: boolean | null, status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } }> | null, shipment?: { __typename?: 'Shipment', id: string, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, clientReferences?: { __typename?: 'ClientReferences', bookingId?: string | null } | null, legs: Array<{ __typename?: 'ShipmentLeg', transportationServiceName?: string | null, conveyance?: { __typename?: 'ShippingConveyance', grossWeight?: number | null } | null }> } | null, invoices?: Array<{ __typename?: 'Invoice', id: string }> | null, memos: Array<{ __typename?: 'Memo', text: string, isPublic?: boolean | null, id: string, version: number, operator: { __typename?: 'Operator', id: string }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, shipper?: { __typename?: 'Shipper', id: string, shipperExternallySourcedDetails?: Array<{ __typename?: 'ShipperExternallySourcedDetails', externalReferenceId: string }> | null, billingDetails?: { __typename?: 'BillingDetails', disbursement?: boolean | null, status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null } | null, memos: Array<{ __typename?: 'Memo', text: string, isPublic?: boolean | null, id: string, version: number, operator: { __typename?: 'Operator', id: string }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } | null } } };

export type UpdateCustomsDeclarationMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpdateCustomsDeclarationInput;
}>;


export type UpdateCustomsDeclarationMutation = { __typename?: 'Mutation', updateCustomsDeclaration: { __typename?: 'UpdateCustomsDeclarationPayload', record: { __typename?: 'CustomsDeclaration', id: string, tasks: Array<{ __typename?: 'WorkOrderTask', name: string, workOrderType: WorkOrderType, status: WorkOrderTaskStatus, deadline?: any | null, id: string, version: number, assignee?: { __typename?: 'OperatorUser', id: string, name: string } | null, assignmentTeam?: { __typename?: 'AssignmentTeam', name: string, id: string, backupTeam?: { __typename?: 'AssignmentTeam', name: string, id: string } | null } | null, steps: Array<{ __typename?: 'WorkOrderTaskStep', id: string, name: string, description?: string | null, isCompletedBySystem?: boolean | null, isFinalConfirmation?: boolean | null, completed?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null }>, definition: { __typename?: 'WorkOrderTaskDefinition', id: string, estimatedDuration?: number | null, workOrderTaskType: WorkOrderTaskType }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } } };

export type usIorFieldsFragment = { __typename?: 'UsIor', id: string, version: number, status?: UsIorStatus | null, industry?: Vertical | null, cbpStatus?: UsIorCbpStatus | null, sourcePortal?: SourcePortal | null, sourceChannel?: SourceChannel | null, businessStructure?: UsBusinessStructure | null, activationStatus?: UsIorActivationStatus | null, alternateName?: string | null, payerUnitNumber?: any | null, pmsStatus?: UsIorPmsStatus | null, poaMethod?: POAMethod | null, docReadinessId?: string | null, isResident?: boolean | null, isSubmittedBefore?: boolean | null, cbp5106RejectionReasons?: Array<{ __typename?: 'UsCbp5106RejectedReason', code: string, name: string }> | null, updated: { __typename?: 'RecordAction', time: any }, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null, iorNumber?: { __typename?: 'UsIorNumber', value: any } | null, establishment?: { __typename?: 'UsCbp5106EstablishmentDetails', stateCode?: string | null } | null, bondApplicationInformation?: { __typename?: 'BondApplicationInformation', productDescription?: string | null, importsFrom?: string | null, expectedDutiesRange?: string | null, previousAnnualFeesRange?: string | null, customBondApplicationStatus?: string | null, supplementaryDutyFlagType?: string | null } | null, continuousBonds?: { __typename?: 'UsContinuousCustomsBonds', present?: { __typename?: 'UsContinuousCustomsBond', amount: any, effectiveDate: any, number: string, suretyCode: string, typeCode: string, renewalDate?: any | null, terminationDate?: any | null } | null } | null, documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag>, deleted?: { __typename?: 'RecordAction', time: any } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, addresses?: { __typename?: 'Addresses', mailing?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null, physical?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null }> | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null } | null, operator: { __typename?: 'Operator', id: string }, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, created: { __typename?: 'RecordAction', time: any }, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> };

export type ImporterEntityActivationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImporterEntityActivationQuery = { __typename?: 'Query', importerEntityActivation: { __typename?: 'ImporterEntityActivation', id: string, version: number, status: WorkOrderStatus, deadline?: any | null, countryCode?: any | null, operator: { __typename?: 'Operator', id: string }, broker?: { __typename?: 'Broker', id: string } | { __typename?: 'DeCustomsBroker', id: string } | { __typename?: 'FrCustomsBroker', id: string } | { __typename?: 'NlCustomsBroker', id: string } | { __typename?: 'UkCustomsBroker', id: string } | { __typename?: 'UsCustomsBroker', id: string } | null, milestones: Array<{ __typename?: 'WorkOrderMilestone', id: string, name: WorkOrderMilestoneName, occurenceTime: any, source?: any | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, created: { __typename?: 'RecordAction', client?: { __typename?: 'ForwarderSystem', name: string } | { __typename?: 'ForwarderUser', name: string } | { __typename?: 'OperatorSystem', name: string } | { __typename?: 'OperatorUser', name: string } | { __typename?: 'ShipperSystem', name: string } | { __typename?: 'ShipperUser', name: string } | null } }>, inquiries: Array<{ __typename?: 'WorkOrderInquiry', reasonCodes?: Array<WorkOrderInquiryReasonCode> | null, requestDocuments: Array<DocumentTag>, description?: string | null, clarifyDocuments: Array<{ __typename?: 'Document', id: string, fileName: string, extension: DocumentFileExtension }>, attachDocuments: Array<{ __typename?: 'Document', id: string, fileName: string, extension: DocumentFileExtension }>, milestone: { __typename?: 'WorkOrderMilestone', id: string }, task?: { __typename?: 'WorkOrderTask', id: string } | null }>, tasks: Array<{ __typename?: 'WorkOrderTask', name: string, workOrderType: WorkOrderType, status: WorkOrderTaskStatus, deadline?: any | null, id: string, version: number, assignee?: { __typename?: 'OperatorUser', id: string, name: string } | null, assignmentTeam?: { __typename?: 'AssignmentTeam', id: string, name: string, backupTeam?: { __typename?: 'AssignmentTeam', id: string, name: string } | null } | null, steps: Array<{ __typename?: 'WorkOrderTaskStep', id: string, name: string, description?: string | null, isCompletedBySystem?: boolean | null, isFinalConfirmation?: boolean | null, completed?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null }>, definition: { __typename?: 'WorkOrderTaskDefinition', id: string, estimatedDuration?: number | null, workOrderTaskType: WorkOrderTaskType }, created: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, updated: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null }, deleted?: { __typename?: 'RecordAction', time: any, source: { __typename: 'ClientSystem', clientSystemName: ClientSystemName } | { __typename: 'InternalSystem', internalSystemName: InternalSystemName } | { __typename: 'InternalWebsite', internalWebsiteName: InternalWebsiteName }, reason?: { __typename?: 'RecordActionReason', code?: string | null, text?: string | null } | null, client?: { __typename?: 'ForwarderSystem', id: string } | { __typename?: 'ForwarderUser', id: string } | { __typename?: 'OperatorSystem', id: string } | { __typename?: 'OperatorUser', id: string } | { __typename?: 'ShipperSystem', id: string } | { __typename?: 'ShipperUser', id: string } | null, request?: { __typename?: 'RecordActionRequestInfo', ipAddress?: string | null, userAgent?: string | null, requestId?: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, group: { __typename?: 'WorkOrderGroup', id: string, documents: Array<{ __typename?: 'Document', documentTags: Array<DocumentTag> }>, customsBroker?: { __typename?: 'Broker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'DeCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'FrCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'NlCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'UkCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | { __typename?: 'UsCustomsBroker', tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, forwarders?: Array<{ __typename?: 'WorkOrderGroupForwarder', forwarder: { __typename?: 'Forwarder', id: string, name: string, billingDetails?: { __typename?: 'BillingDetails', disbursement?: boolean | null, status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null } | null } }> | null, shipment?: { __typename?: 'Shipment', id: string, preferredDutyCollectPartyType?: PreferredDutyCollectPartyType | null, clientReferences?: { __typename?: 'ClientReferences', bookingId?: string | null } | null, legs: Array<{ __typename?: 'ShipmentLeg', transportationServiceName?: string | null }> } | null, invoices?: Array<{ __typename?: 'Invoice', id: string }> | null, shipper?: { __typename?: 'Shipper', id: string, shipperExternallySourcedDetails?: Array<{ __typename?: 'ShipperExternallySourcedDetails', externalReferenceId: string }> | null, billingDetails?: { __typename?: 'BillingDetails', disbursement?: boolean | null, status?: BillingPartyAccountStatus | null, subscriptionPlan?: SubscriptionPlan | null } | null } | null }, usIor?: { __typename?: 'UsIor', id: string, version: number, status?: UsIorStatus | null, industry?: Vertical | null, cbpStatus?: UsIorCbpStatus | null, sourcePortal?: SourcePortal | null, sourceChannel?: SourceChannel | null, businessStructure?: UsBusinessStructure | null, activationStatus?: UsIorActivationStatus | null, alternateName?: string | null, payerUnitNumber?: any | null, pmsStatus?: UsIorPmsStatus | null, poaMethod?: POAMethod | null, docReadinessId?: string | null, isResident?: boolean | null, isSubmittedBefore?: boolean | null, importer?: { __typename?: 'Importer', id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, businessStructure?: GlobalBusinessStructure | null, usIor?: { __typename?: 'UsIor', id: string, version: number, status?: UsIorStatus | null, industry?: Vertical | null, cbpStatus?: UsIorCbpStatus | null, sourcePortal?: SourcePortal | null, sourceChannel?: SourceChannel | null, businessStructure?: UsBusinessStructure | null, activationStatus?: UsIorActivationStatus | null, alternateName?: string | null, payerUnitNumber?: any | null, pmsStatus?: UsIorPmsStatus | null, poaMethod?: POAMethod | null, docReadinessId?: string | null, isResident?: boolean | null, isSubmittedBefore?: boolean | null, cbp5106RejectionReasons?: Array<{ __typename?: 'UsCbp5106RejectedReason', code: string, name: string }> | null, updated: { __typename?: 'RecordAction', time: any }, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null, iorNumber?: { __typename?: 'UsIorNumber', value: any } | null, establishment?: { __typename?: 'UsCbp5106EstablishmentDetails', stateCode?: string | null } | null, bondApplicationInformation?: { __typename?: 'BondApplicationInformation', productDescription?: string | null, importsFrom?: string | null, expectedDutiesRange?: string | null, previousAnnualFeesRange?: string | null, customBondApplicationStatus?: string | null, supplementaryDutyFlagType?: string | null } | null, continuousBonds?: { __typename?: 'UsContinuousCustomsBonds', present?: { __typename?: 'UsContinuousCustomsBond', amount: any, effectiveDate: any, number: string, suretyCode: string, typeCode: string, renewalDate?: any | null, terminationDate?: any | null } | null } | null, documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag>, deleted?: { __typename?: 'RecordAction', time: any } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, addresses?: { __typename?: 'Addresses', mailing?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null, physical?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null }> | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null } | null, operator: { __typename?: 'Operator', id: string }, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, created: { __typename?: 'RecordAction', time: any }, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, type?: string | null, streetName?: string | null, postOfficeBox?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, legalRepresentative?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, secondaryOfficer?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, owners?: Array<{ __typename?: 'ImporterOwner', customerId?: string | null, type?: string | null }> | null, docReadinesses?: Array<{ __typename?: 'ImporterDocReadiness', id: string, programType?: ImporterDocReadinessProgramType | null }> | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } | null, cbp5106RejectionReasons?: Array<{ __typename?: 'UsCbp5106RejectedReason', code: string, name: string }> | null, updated: { __typename?: 'RecordAction', time: any }, activations?: Array<{ __typename?: 'UsIorActivationDetails', status?: ActivationStatus | null, customsBroker: { __typename?: 'UsCustomsBroker', id: string } }> | null, iorNumber?: { __typename?: 'UsIorNumber', value: any } | null, establishment?: { __typename?: 'UsCbp5106EstablishmentDetails', stateCode?: string | null } | null, bondApplicationInformation?: { __typename?: 'BondApplicationInformation', productDescription?: string | null, importsFrom?: string | null, expectedDutiesRange?: string | null, previousAnnualFeesRange?: string | null, customBondApplicationStatus?: string | null, supplementaryDutyFlagType?: string | null } | null, continuousBonds?: { __typename?: 'UsContinuousCustomsBonds', present?: { __typename?: 'UsContinuousCustomsBond', amount: any, effectiveDate: any, number: string, suretyCode: string, typeCode: string, renewalDate?: any | null, terminationDate?: any | null } | null } | null, documents: Array<{ __typename?: 'Document', id: string, documentTags: Array<DocumentTag>, deleted?: { __typename?: 'RecordAction', time: any } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, addresses?: { __typename?: 'Addresses', mailing?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null, physical?: { __typename?: 'Address', address?: string | null, countryCode?: any | null, postalCode?: string | null, city?: string | null, stateCode?: string | null } | null } | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null }> | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null } | null, operator: { __typename?: 'Operator', id: string }, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, created: { __typename?: 'RecordAction', time: any }, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } | null, importerEntity?: { __typename?: 'ImporterEntity', id: string, version: number, sourcePortal?: SourcePortal | null, sourceChannel?: SourceChannel | null, countryCode: any, isResident?: boolean | null, isSubmittedBefore?: boolean | null, status?: ImporterEntityStatus | null, externalClientReferences?: Array<string> | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, updated: { __typename?: 'RecordAction', time: any }, bonds?: { __typename?: 'CustomsBonds', present?: { __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null } | null, past?: Array<{ __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null }> | null, future?: { __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, program?: Array<{ __typename?: 'ProgramDetails', docReadiness?: { __typename?: 'DocReadiness', id: string } | null }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null, user?: { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null } | null, activations?: Array<{ __typename?: 'ImporterEntityActivationDetails', status: ActivationStatus, activated?: { __typename?: 'RecordAction', time: any } | null, externalIorReferences?: Array<{ __typename?: 'ExternalIorReference', id: string, referenceType?: ExternalIorReferenceType | null, version?: string | null, documents?: Array<{ __typename?: 'ExternalIorDocumentReference', documentTag?: DocumentTag | null, externalReference: { __typename?: 'ExternalDocumentReference', externalReferenceType?: DocumentReferenceType | null, externalReferencePartition?: string | null, id: string, version?: string | null } }> | null }> | null, customsBroker: { __typename?: 'Broker', id: string } | { __typename?: 'DeCustomsBroker', id: string } | { __typename?: 'FrCustomsBroker', id: string } | { __typename?: 'NlCustomsBroker', id: string } | { __typename?: 'UkCustomsBroker', id: string } | { __typename?: 'UsCustomsBroker', id: string } }> | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, externalValidations?: Array<{ __typename?: 'ExternalValidation', validationDate: any, response: { __typename?: 'ExternalValidationResponse', validationResult: ExternalValidationResult, companyDetails?: { __typename?: 'CompanyInfo', name?: string | null } | null }, identification: { __typename?: 'PartyIdentification', identificationType: PartyIdentificationType } }> | null, importer?: { __typename?: 'Importer', id: string, version: number, name: string, alternateName?: string | null, description?: string | null, email?: any | null, businessStructure?: GlobalBusinessStructure | null, importerEntities: { __typename?: 'ImporterImporterEntitysConnection', nodes: Array<{ __typename?: 'ImporterEntity', id: string, version: number, countryCode: any, isResident?: boolean | null, isSubmittedBefore?: boolean | null, status?: ImporterEntityStatus | null, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, postOfficeBox?: string | null, streetName?: string | null, type?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, updated: { __typename?: 'RecordAction', time: any }, bonds?: { __typename?: 'CustomsBonds', present?: { __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null } | null, past?: Array<{ __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null }> | null, future?: { __typename?: 'CustomsBond', referenceIdentifier: string, typeCode: string, amount: any, effectiveDate: any, renewalDate?: any | null, terminationDate?: any | null, surety?: { __typename?: 'Surety', name?: string | null, code: string } | null } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, program?: Array<{ __typename?: 'ProgramDetails', docReadiness?: { __typename?: 'DocReadiness', id: string } | null }> | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', number: string, extension?: string | null, country?: string | null } | null } | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, externalValidations?: Array<{ __typename?: 'ExternalValidation', validationDate: any, response: { __typename?: 'ExternalValidationResponse', validationResult: ExternalValidationResult, companyDetails?: { __typename?: 'CompanyInfo', name?: string | null } | null }, identification: { __typename?: 'PartyIdentification', identificationType: PartyIdentificationType } }> | null }> }, addressList?: Array<{ __typename?: 'AddressV2', cityName?: string | null, country?: string | null, countrySubDivision?: string | null, countrySubDivisionName?: string | null, houseNumber?: string | null, houseNumberAddition?: string | null, line?: string | null, postCode?: string | null, type?: string | null, streetName?: string | null, postOfficeBox?: string | null, externalReference?: { __typename?: 'AddressReference', id: string, customerId?: string | null } | null }> | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null, pointOfContact?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, legalRepresentative?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, secondaryOfficer?: { __typename?: 'PointOfContact', email?: any | null, name: string, title?: string | null, phone?: { __typename?: 'Phone', country?: string | null, extension?: string | null, number: string } | null } | null, identifiers?: Array<{ __typename?: 'PartyIdentification', identification: string, identificationType: PartyIdentificationType }> | null, owners?: Array<{ __typename?: 'ImporterOwner', customerId?: string | null, type?: string | null }> | null, docReadinesses?: Array<{ __typename?: 'ImporterDocReadiness', id: string, programType?: ImporterDocReadinessProgramType | null }> | null, dpsRecord?: { __typename?: 'DpsRecord', id: string, version: number, overallDpsStatus?: string | null, dpsStatus?: { __typename?: 'DpsStatus', code: DpsStatusCode, time?: any | null } | null } | null, memos: Array<{ __typename?: 'Memo', id: string, version: number, text: string, isPublic?: boolean | null, created: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, updated: { __typename?: 'RecordAction', time: any, client?: { __typename?: 'ForwarderSystem', id: string, name: string } | { __typename?: 'ForwarderUser', id: string, name: string } | { __typename?: 'OperatorSystem', id: string, name: string } | { __typename?: 'OperatorUser', id: string, name: string } | { __typename?: 'ShipperSystem', id: string, name: string } | { __typename?: 'ShipperUser', id: string, name: string } | null }, deleted?: { __typename?: 'RecordAction', time: any } | null }> } | null } | null } };

export type UpdateImporterEntityActivationMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpdateImporterEntityActivationInput;
}>;


export type UpdateImporterEntityActivationMutation = { __typename?: 'Mutation', updateImporterEntityActivation: { __typename?: 'UpdateImporterEntityActivationPayload', record: { __typename?: 'ImporterEntityActivation', id: string, version: number } } };

export type upsertImporterEntityActivationMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  input: UpsertImporterEntityActivationInput;
}>;


export type upsertImporterEntityActivationMutation = { __typename?: 'Mutation', upsertImporterEntityActivation: { __typename?: 'UpsertImporterEntityActivationPayload', importerEntity: { __typename?: 'ImporterEntity', id: string, version: number } } };

export const adjustmentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"adjustmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsConsumptionEntryCommercialInvoiceAdjustment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<adjustmentFieldsFragment, unknown>;
export const InvoiceSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsConsumptionEntryCommercialInvoice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"currencyRate"}},{"kind":"Field","name":{"kind":"Name","value":"assist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<InvoiceSummaryFragment, unknown>;
export const recordActionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}}]} as unknown as DocumentNode<recordActionFieldsFragment, unknown>;
export const recordFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}}]} as unknown as DocumentNode<recordFieldsFragment, unknown>;
export const addressFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}}]} as unknown as DocumentNode<addressFieldsFragment, unknown>;
export const addressesFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}}]} as unknown as DocumentNode<addressesFieldsFragment, unknown>;
export const phoneFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}}]} as unknown as DocumentNode<phoneFieldsFragment, unknown>;
export const partyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"partyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressesFields"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}}]} as unknown as DocumentNode<partyFieldsFragment, unknown>;
export const memoRecordActionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoRecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}}]} as unknown as DocumentNode<memoRecordActionFieldsFragment, unknown>;
export const memoFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Memo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoRecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}}]} as unknown as DocumentNode<memoFieldsFragment, unknown>;
export const importerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"importerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Importer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"partyFields"}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalClientReferences"}},{"kind":"Field","name":{"kind":"Name","value":"importerEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoRecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"partyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressesFields"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Memo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<importerFieldsFragment, unknown>;
export const ImporterFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImporterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Importer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalRepresentative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryOfficer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessStructure"}},{"kind":"Field","name":{"kind":"Name","value":"docReadinesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<ImporterFieldsFragment, unknown>;
export const lineItemInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"lineItemInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsConsumptionEntryLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}}]}}]} as unknown as DocumentNode<lineItemInfoFragmentFragment, unknown>;
export const ReleaseNoteFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReleaseNoteFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetCountries"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbsUp"}},{"kind":"Field","name":{"kind":"Name","value":"thumbsDown"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]} as unknown as DocumentNode<ReleaseNoteFieldsFragment, unknown>;
export const brexitProductInfoFieldsCustomsDeclarationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"brexitProductInfoFieldsCustomsDeclaration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomsDeclaration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conveyance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodsShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodsItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goodsMeasure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tariff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"clientIdentifierVersion"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<brexitProductInfoFieldsCustomsDeclarationFragment, unknown>;
export const PhoneFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}}]} as unknown as DocumentNode<PhoneFragmentFragment, unknown>;
export const TagFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<TagFragmentFragment, unknown>;
export const SourceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SourceFragmentFragment, unknown>;
export const ReasonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReasonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionReason"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]} as unknown as DocumentNode<ReasonFragmentFragment, unknown>;
export const RequestFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionRequestInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]} as unknown as DocumentNode<RequestFragmentFragment, unknown>;
export const RecordActionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReasonFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReasonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionReason"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionRequestInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]} as unknown as DocumentNode<RecordActionFieldsFragment, unknown>;
export const DocumentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]} as unknown as DocumentNode<DocumentFragmentFragment, unknown>;
export const OperatorReferenceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatorReferenceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Operator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<OperatorReferenceFragmentFragment, unknown>;
export const UserWorkingHoursFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserWorkingHoursFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserWorkDay"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]} as unknown as DocumentNode<UserWorkingHoursFieldsFragment, unknown>;
export const BillingDetailsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}}]} as unknown as DocumentNode<BillingDetailsFragmentFragment, unknown>;
export const taskFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"taskFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"backupTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedBySystem"}},{"kind":"Field","name":{"kind":"Name","value":"isFinalConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTaskType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<taskFieldsFragment, unknown>;
export const goodsShipmentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"goodsShipmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoodsShipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"borderTransportationMean"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identificationType"}},{"kind":"Field","name":{"kind":"Name","value":"journey"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departure"}},{"kind":"Field","name":{"kind":"Name","value":"departureLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transportContractDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transportEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullness"}},{"kind":"Field","name":{"kind":"Name","value":"identification"}}]}}]}}]}}]} as unknown as DocumentNode<goodsShipmentFieldsFragment, unknown>;
export const usIorFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usIorFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsIor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"cbpStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePortal"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChannel"}},{"kind":"Field","name":{"kind":"Name","value":"cbp5106RejectionReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessStructure"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iorNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"payerUnitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pmsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"poaMethod"}},{"kind":"Field","name":{"kind":"Name","value":"establishment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docReadinessId"}},{"kind":"Field","name":{"kind":"Name","value":"bondApplicationInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDescription"}},{"kind":"Field","name":{"kind":"Name","value":"importsFrom"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDutiesRange"}},{"kind":"Field","name":{"kind":"Name","value":"previousAnnualFeesRange"}},{"kind":"Field","name":{"kind":"Name","value":"customBondApplicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryDutyFlagType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"continuousBonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"present"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"suretyCode"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isResident"}},{"kind":"Field","name":{"kind":"Name","value":"isSubmittedBefore"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<usIorFieldsFragment, unknown>;
export const ActivateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"linkHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkHash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ActivateUserMutation, ActivateUserMutationVariables>;
export const GetWorkOrderWithMilestonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderWithMilestones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"occurenceTime"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderWithMilestonesQuery, GetWorkOrderWithMilestonesQueryVariables>;
export const UpdateExchangeMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExchangeMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateExchangeMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExchangeMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExchangeMessageMutation, UpdateExchangeMessageMutationVariables>;
export const UpdateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UsConsumptionEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsConsumptionEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsConsumptionEntryQuery, UsConsumptionEntryQueryVariables>;
export const queryChannelConnectionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"queryChannelConnectionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryChannelConnectionStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryChannelConnectionStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<queryChannelConnectionStatusQuery, queryChannelConnectionStatusQueryVariables>;
export const createOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkOrderMilestoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkOrderMilestone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<createOneMutation, createOneMutationVariables>;
export const GetCpscCitationCodesPresignedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCpscCitationCodesPresignedUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CpscCitationCodeType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCpscCitationCodesPresignedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"codeType"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode<GetCpscCitationCodesPresignedUrlQuery, GetCpscCitationCodesPresignedUrlQueryVariables>;
export const createWorkOrderTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWorkOrderTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkOrderTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkOrderTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<createWorkOrderTaskMutation, createWorkOrderTaskMutationVariables>;
export const SearchTruckersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTruckers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchTruckerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTruckers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scac"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SearchTruckersQuery, SearchTruckersQueryVariables>;
export const GetOperatorUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetOperatorUserQuery, GetOperatorUserQueryVariables>;
export const ReplyWorkOrderTaskEscalationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplyWorkOrderTaskEscalation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskEscalationReplyDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replyWorkOrderTaskEscalation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ReplyWorkOrderTaskEscalationMutation, ReplyWorkOrderTaskEscalationMutationVariables>;
export const searchUsHtssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchUsHtss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUsHtsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUsHtss"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"additionalHtssApplicable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"exportGroup"}},{"kind":"Field","name":{"kind":"Name","value":"additionalTypeDescription"}}]}}]}}]}}]}}]} as unknown as DocumentNode<searchUsHtssQuery, searchUsHtssQueryVariables>;
export const UpdateImporterRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImporterRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImporterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateImporterRecordMutation, UpdateImporterRecordMutationVariables>;
export const UpdateImporterEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImporterEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImporterEntityInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImporterEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateImporterEntityMutation, UpdateImporterEntityMutationVariables>;
export const UpdateUsIorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUsIor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsIorInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsIor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUsIorMutation, UpdateUsIorMutationVariables>;
export const ImporterDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImporterDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"importerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"importerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImporterFields"}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"cbpStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePortal"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChannel"}},{"kind":"Field","name":{"kind":"Name","value":"cbp5106RejectionReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessStructure"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iorNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payerUnitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pmsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"poaMethod"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isResident"}},{"kind":"Field","name":{"kind":"Name","value":"isSubmittedBefore"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docReadinessId"}},{"kind":"Field","name":{"kind":"Name","value":"bondApplicationInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDescription"}},{"kind":"Field","name":{"kind":"Name","value":"importsFrom"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDutiesRange"}},{"kind":"Field","name":{"kind":"Name","value":"previousAnnualFeesRange"}},{"kind":"Field","name":{"kind":"Name","value":"customBondApplicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryDutyFlagType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"continuousBonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"future"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"suretyCode"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"past"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"suretyCode"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"present"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"suretyCode"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"importerEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePortal"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChannel"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"bonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"present"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"past"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"future"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isResident"}},{"kind":"Field","name":{"kind":"Name","value":"isSubmittedBefore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docReadiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalIorReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceType"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTag"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferencePartition"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalClientReferences"}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalValidations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationResult"}},{"kind":"Field","name":{"kind":"Name","value":"companyDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"identification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImporterFields"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImporterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Importer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalRepresentative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryOfficer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessStructure"}},{"kind":"Field","name":{"kind":"Name","value":"docReadinesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<ImporterDetailQuery, ImporterDetailQueryVariables>;
export const SearchImportersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchImporters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchImporterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchImporters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importerEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}}]} as unknown as DocumentNode<SearchImportersQuery, SearchImportersQueryVariables>;
export const SearchImporterTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchImporterTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchImporterTableInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchImporterTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}}]} as unknown as DocumentNode<SearchImporterTableQuery, SearchImporterTableQueryVariables>;
export const ImportersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Importers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifiers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdOptionalVersionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifiers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifiers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importerEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ImportersQuery, ImportersQueryVariables>;
export const InquireWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InquireWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InquireWorkOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquireWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<InquireWorkOrderMutation, InquireWorkOrderMutationVariables>;
export const LinkActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hashKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hashKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hashKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<LinkActionMutation, LinkActionMutationVariables>;
export const linkForwarderToUsIorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkForwarderToUsIor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forwarderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customsBrokerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkForwarderToIorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkForwarderToUsIor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"forwarderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forwarderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customsBrokerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customsBrokerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateDocumentSignRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linked"}}]}}]}}]} as unknown as DocumentNode<linkForwarderToUsIorMutation, linkForwarderToUsIorMutationVariables>;
export const fetchForwarderMailFromDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchForwarderMailFrom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchForwarderMailFrom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dkimStatus"}},{"kind":"Field","name":{"kind":"Name","value":"domainStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<fetchForwarderMailFromQuery, fetchForwarderMailFromQueryVariables>;
export const submitForwarderMailFromDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitForwarderMailFrom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromSignature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitForwarderMailFrom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromSignature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromSignature"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<submitForwarderMailFromMutation, submitForwarderMailFromMutationVariables>;
export const getWorkOrderForAnalysisBadgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorkOrderForAnalysisBadges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GbCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NlCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FrCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomsDeclaration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"customsDeclarationBadges"},"name":{"kind":"Name","value":"badges"}}]}}]}}]}}]} as unknown as DocumentNode<getWorkOrderForAnalysisBadgesQuery, getWorkOrderForAnalysisBadgesQueryVariables>;
export const getOneWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsConsumptionEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usConsumptionEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GbCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NlCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FrCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomsDeclaration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"customsDeclarationBadges"},"name":{"kind":"Name","value":"badges"}},{"kind":"Field","name":{"kind":"Name","value":"goodsShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateMachine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"preferredDutyCollectPartyType"}},{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modeOfTransport"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<getOneWorkOrderQuery, getOneWorkOrderQueryVariables>;
export const WorkOrderForMarkReadyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkOrderForMarkReady"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsConsumptionEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usConsumptionEntryReleaseStatus"},"name":{"kind":"Name","value":"releaseStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"usConsumptionEntryBadges"},"name":{"kind":"Name","value":"badges"}},{"kind":"Field","alias":{"kind":"Name","value":"usConsumptionEntryArrival"},"name":{"kind":"Name","value":"arrival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importDate"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsInBond"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usInBondBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsIsf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usIsfCbpStatus"},"name":{"kind":"Name","value":"cbpStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsType86Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usType86EntryReleaseStatus"},"name":{"kind":"Name","value":"releaseStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GbCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NlCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FrCustomsEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"euCustomsEntryBadges"},"name":{"kind":"Name","value":"badges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateMachine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"preferredDutyCollectPartyType"}},{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modeOfTransport"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ior"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ior"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsIor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSetReadyStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceLevelAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessHoursAfterReady"}},{"kind":"Field","name":{"kind":"Name","value":"calendarDaysBeforeArrival"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modesOfTransport"}},{"kind":"Field","name":{"kind":"Name","value":"badges"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usType86Entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSetReadyStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceLevelAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessHoursAfterReady"}},{"kind":"Field","name":{"kind":"Name","value":"calendarDaysBeforeArrival"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modesOfTransport"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSetReadyStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceLevelAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessHoursAfterReady"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIsf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSetReadyStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceLevelAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessHoursAfterReady"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorContinuousBondRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSetReadyStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceLevelAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessHoursAfterReady"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkOrderForMarkReadyQuery, WorkOrderForMarkReadyQueryVariables>;
export const MigrateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MigrateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jwt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migrateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jwt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jwt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<MigrateUserMutation, MigrateUserMutationVariables>;
export const ExternalUserMigrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalUserMigration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchCriteria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQUALS"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalUserMigrationQuery, ExternalUserMigrationQueryVariables>;
export const searchInvoiceLinesRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchInvoiceLinesRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchInvoiceLinesRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchInvoiceLinesRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"statusReason"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<searchInvoiceLinesRequestsQuery, searchInvoiceLinesRequestsQueryVariables>;
export const RedriveProcessingErrorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedriveProcessingError"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishRedriveEventToErrorSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RedriveProcessingErrorMutation, RedriveProcessingErrorMutationVariables>;
export const shipmentStatusCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"shipmentStatusCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"examInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUsConsumptionEntryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"holdInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUsConsumptionEntryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releasedInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUsConsumptionEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exam"},"name":{"kind":"Name","value":"searchUsConsumptionEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"examInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hold"},"name":{"kind":"Name","value":"searchUsConsumptionEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"holdInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"released"},"name":{"kind":"Name","value":"searchUsConsumptionEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releasedInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<shipmentStatusCountsQuery, shipmentStatusCountsQueryVariables>;
export const GetInvoiceNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoiceNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInvoiceNumberQuery, GetInvoiceNumberQueryVariables>;
export const GetLatestViewedReleaseNoteByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestViewedReleaseNoteByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLatestViewedReleaseNoteByUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestViewedReleaseNoteByUserQuery, GetLatestViewedReleaseNoteByUserQueryVariables>;
export const SearchReleaseNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchReleaseNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchReleaseNoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchReleaseNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<SearchReleaseNotesQuery, SearchReleaseNotesQueryVariables>;
export const GetLatestReleaseNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestReleaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLatestReleaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestReleaseNoteQuery, GetLatestReleaseNoteQueryVariables>;
export const CreateUserReleaseNoteViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserReleaseNoteView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserReleaseNoteViewInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserReleaseNoteView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserReleaseNoteViewMutation, CreateUserReleaseNoteViewMutationVariables>;
export const GetReleaseNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CursorPaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allReleaseNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReleaseNoteFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReleaseNoteFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetCountries"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbsUp"}},{"kind":"Field","name":{"kind":"Name","value":"thumbsDown"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]} as unknown as DocumentNode<GetReleaseNotesQuery, GetReleaseNotesQueryVariables>;
export const GetUserRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseNoteIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUserReleaseNoteViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchCriteria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQUALS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseNoteId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"ONE_OF"}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseNoteIds"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserRatingsQuery, GetUserRatingsQueryVariables>;
export const UserReactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserReacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseNoteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userReacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"releaseNoteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseNoteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}}]}]}}]} as unknown as DocumentNode<UserReactsMutation, UserReactsMutationVariables>;
export const CreateReleaseNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReleaseNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReleaseNoteInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReleaseNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetCountries"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbsUp"}},{"kind":"Field","name":{"kind":"Name","value":"thumbsDown"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReleaseNoteMutation, CreateReleaseNoteMutationVariables>;
export const UpdateReleaseNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReleaseNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReleaseNoteInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReleaseNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"targetCountries"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbsUp"}},{"kind":"Field","name":{"kind":"Name","value":"thumbsDown"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReleaseNoteMutation, UpdateReleaseNoteMutationVariables>;
export const DeleteReleaseNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReleaseNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReleaseNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteReleaseNoteMutation, DeleteReleaseNoteMutationVariables>;
export const ResolveWorkOrderTaskEscalationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResolveWorkOrderTaskEscalation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskResolutionDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveWorkOrderTaskEscalation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ResolveWorkOrderTaskEscalationMutation, ResolveWorkOrderTaskEscalationMutationVariables>;
export const SubmitUsConsumptionEntryDisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitUsConsumptionEntryDis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitUsConsumptionEntryDisInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitUsConsumptionEntryDis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"usConsumptionEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitUsConsumptionEntryDisTransaction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitUsConsumptionEntryDisMutation, SubmitUsConsumptionEntryDisMutationVariables>;
export const SubmitUsType86EntryDisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitUsType86EntryDis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitUsType86EntryDisInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitUsType86EntryDis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"usType86EntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitUsType86EntryDisTransaction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitUsType86EntryDisMutation, SubmitUsType86EntryDisMutationVariables>;
export const CreateWorkOrderConfirmationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkOrderConfirmation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkOrderConfirmationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkOrderConfirmation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateWorkOrderConfirmationMutation, CreateWorkOrderConfirmationMutationVariables>;
export const getWorkOrderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorkOrderQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"occurenceTime"}}]}}]}}]}}]} as unknown as DocumentNode<getWorkOrderQueryQuery, getWorkOrderQueryQueryVariables>;
export const SendWorkOrderDocumentsTo3pDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendWorkOrderDocumentsTo3p"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendWorkOrderDocumentsTo3pInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendWorkOrderDocumentsTo3p"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SendWorkOrderDocumentsTo3pMutation, SendWorkOrderDocumentsTo3pMutationVariables>;
export const toggleAssumedUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleAssumedUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assumedUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IdInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleAssumedUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"assumedUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assumedUser"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assumedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"root"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<toggleAssumedUserMutation, toggleAssumedUserMutationVariables>;
export const getAbiExchangeMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAbiExchangeMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExchangeMessageSearchCriteriaInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchPaginationInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchPaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAbiExchangeMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchPaginationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchPaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edi"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<getAbiExchangeMessagesQuery, getAbiExchangeMessagesQueryVariables>;
export const UpdateUsConsumptionEntryStatementCbpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUsConsumptionEntryStatementCbp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsConsumptionEntryStatementCbpInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usConsumptionEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsConsumptionEntryStatementCbp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"usConsumptionEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usConsumptionEntryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"pmsMonth"}},{"kind":"Field","name":{"kind":"Name","value":"printDate"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUsConsumptionEntryStatementCbpMutation, UpdateUsConsumptionEntryStatementCbpMutationVariables>;
export const ValidateUsConsumptionEntryReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateUsConsumptionEntryRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsConsumptionEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateUsConsumptionEntryRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"stbAmount"}},{"kind":"Field","name":{"kind":"Name","value":"riskType"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<ValidateUsConsumptionEntryReleaseQuery, ValidateUsConsumptionEntryReleaseQueryVariables>;
export const UpdateUsConsumptionEntryIDPDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUsConsumptionEntryIDP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsConsumptionEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsConsumptionEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"immediateDeliveryIndicator"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUsConsumptionEntryIDPMutation, UpdateUsConsumptionEntryIDPMutationVariables>;
export const GetShipmentStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShipmentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commercialInvoiceDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShipmentStatusQuery, GetShipmentStatusQueryVariables>;
export const GetWorkOrderTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderTaskQuery, GetWorkOrderTaskQueryVariables>;
export const SearchShipmentsByBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchShipmentsByBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchShipmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchShipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commercialInvoiceDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchShipmentsByBookingQuery, SearchShipmentsByBookingQueryVariables>;
export const UpdateShipmentCommercialInvoiceDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShipmentCommercialInvoiceDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShipmentCommercialInvoiceDetailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShipmentCommercialInvoiceDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShipmentCommercialInvoiceDetailMutation, UpdateShipmentCommercialInvoiceDetailMutationVariables>;
export const SearchLargeEntryProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLargeEntryProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"clientIdentifierVersion"}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchLargeEntryProductsQuery, SearchLargeEntryProductsQueryVariables>;
export const SearchLargeEntryAdCvdCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLargeEntryAdCvdCases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchAdCvdCaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAdCvdCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"inactivatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"addedDate"}},{"kind":"Field","name":{"kind":"Name","value":"adValorem"}},{"kind":"Field","name":{"kind":"Name","value":"specific"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"uomDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bondOrCash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator"}},{"kind":"Field","name":{"kind":"Name","value":"addedDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchLargeEntryAdCvdCasesQuery, SearchLargeEntryAdCvdCasesQueryVariables>;
export const UsHtsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsHts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usHts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"rateCode"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"additionalHTS"}},{"kind":"Field","name":{"kind":"Name","value":"adCvdCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainDutyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateCode"}},{"kind":"Field","name":{"kind":"Name","value":"adValorem"}},{"kind":"Field","name":{"kind":"Name","value":"specific"}},{"kind":"Field","name":{"kind":"Name","value":"other"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spiRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"rateCode"}},{"kind":"Field","name":{"kind":"Name","value":"adValorem"}},{"kind":"Field","name":{"kind":"Name","value":"other"}},{"kind":"Field","name":{"kind":"Name","value":"specific"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pga"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalHtssApplicable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"exclude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"}},{"kind":"Field","name":{"kind":"Name","value":"rateCode"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adValorem"}},{"kind":"Field","name":{"kind":"Name","value":"specific"}},{"kind":"Field","name":{"kind":"Name","value":"other"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsHtsQuery, UsHtsQueryVariables>;
export const AuthenticationContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthenticationContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticatedUserContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intercomHash"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FederatedUserContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FederatedShipperUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"root"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"root"}},{"kind":"Field","name":{"kind":"Name","value":"appLastVersionSeen"}},{"kind":"Field","name":{"kind":"Name","value":"loginLink"}},{"kind":"Field","name":{"kind":"Name","value":"limitNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"officePhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cognito"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatorUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatorReferenceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dailyGoal"}},{"kind":"Field","name":{"kind":"Name","value":"assumedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"root"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShipperUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatorReferenceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"globalLogisticsProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingDetailsFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"shipperUserPermissions"},"name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trucker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIsf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipperUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usInBond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorContinuousBondRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usPostSummaryCorrection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usDrawbackClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkMilestoneUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkChargesUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkComplianceUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReleaseNoteView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForwarderUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatorReferenceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"globalLogisticsProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"poaMethod"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"fromTitle"}},{"kind":"Field","name":{"kind":"Name","value":"fromSignature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingDetailsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargowise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargowiseId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"forwarderUserPermissions"},"name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trucker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIsf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarderUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usInBond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorContinuousBondRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usPostSummaryCorrection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usDrawbackClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkMilestoneUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkChargesUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkComplianceUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReleaseNoteView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sunday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thursday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"friday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saturday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserWorkingHoursFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorUserPermissions"},"name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deCustomsEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gbCustomsEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nlCustomsEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frCustomsEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usType86Entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trucker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gbIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nlIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usPostSummaryCorrection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIsf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLinesRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payableInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportReconciliationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorContinuousBondRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usInBond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usHts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usDrawbackClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gbIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nlIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gbConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ukCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nlConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nlCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessSupportTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkMilestoneUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkChargesUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkComplianceUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exchangeMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTaskEscalationMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsDeclaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importerEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importerEntityActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReleaseNoteView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"backupTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTaskTypes"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeamTypes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subjectMatterExpertTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessSupportTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagFragment"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShipperUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatorReferenceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"globalLogisticsProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingDetailsFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"shipperUserPermissions"},"name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trucker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIsf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipperUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usInBond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorContinuousBondRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usPostSummaryCorrection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usDrawbackClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkMilestoneUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkChargesUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkComplianceUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReleaseNoteView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForwarderUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatorReferenceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"globalLogisticsProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"poaMethod"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"fromTitle"}},{"kind":"Field","name":{"kind":"Name","value":"fromSignature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingDetailsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargowise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargowiseId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"forwarderUserPermissions"},"name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trucker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usConsumptionEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIsf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarderUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usInBond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usCustomsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorContinuousBondRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usIorActivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usPostSummaryCorrection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usDrawbackClaim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkMilestoneUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkChargesUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkComplianceUploadRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"releaseNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReleaseNoteView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReasonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionReason"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionRequestInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReasonFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatorReferenceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Operator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserWorkingHoursFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserWorkDay"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]} as unknown as DocumentNode<AuthenticationContextQuery, AuthenticationContextQueryVariables>;
export const ReviewWorkOrderConfirmationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewWorkOrderConfirmation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderConfirmationReviewApprovalStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disputedReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewWorkOrderConfirmation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"disputedReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disputedReason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderConfirmation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ReviewWorkOrderConfirmationMutation, ReviewWorkOrderConfirmationMutationVariables>;
export const CreateWorkOrderPresignedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkOrderPresignedUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkOrderPresignedUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadLink"}},{"kind":"Field","name":{"kind":"Name","value":"referenceKey"}}]}}]}}]} as unknown as DocumentNode<CreateWorkOrderPresignedUrlMutation, CreateWorkOrderPresignedUrlMutationVariables>;
export const SearchCommodityGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchCommodityGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCommodityGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchCommodityGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"htsChapters"}},{"kind":"Field","name":{"kind":"Name","value":"pgas"}}]}}]}}]}}]} as unknown as DocumentNode<SearchCommodityGroupQuery, SearchCommodityGroupQueryVariables>;
export const ExchangeMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExchangeMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"sender"}},{"kind":"Field","name":{"kind":"Name","value":"receiver"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"output"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ExchangeMessageQuery, ExchangeMessageQueryVariables>;
export const ProcessingErrorDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProcessingErrorDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processingError"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<ProcessingErrorDetailQuery, ProcessingErrorDetailQueryVariables>;
export const UpdateProcessingErrorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProcessingError"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProcessingErrorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProcessingError"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProcessingErrorMutation, UpdateProcessingErrorMutationVariables>;
export const ImporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Importer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"importerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"addressesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"partyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"addressesFields"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoRecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Memo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"importerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Importer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"partyFields"}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalClientReferences"}},{"kind":"Field","name":{"kind":"Name","value":"importerEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ImporterQuery, ImporterQueryVariables>;
export const UpdateImporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImporterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateImporterMutation, UpdateImporterMutationVariables>;
export const reassignWorkOrderTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reassignWorkOrderTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reassignWorkOrderTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"operatorUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"operatorUserVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<reassignWorkOrderTaskMutation, reassignWorkOrderTaskMutationVariables>;
export const EscalateWorkOrderTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EscalateWorkOrderTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTaskEscalationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"escalateWorkOrderTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<EscalateWorkOrderTaskMutation, EscalateWorkOrderTaskMutationVariables>;
export const CustomsDeclarationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomsDeclaration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customsDeclaration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"brexitProductInfoFieldsCustomsDeclaration"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"badges"}},{"kind":"Field","name":{"kind":"Name","value":"canceled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodsShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"goodsShipmentFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"occurenceTime"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"taskFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disbursement"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transportationServiceName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredDutyCollectPartyType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipperExternallySourcedDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalReferenceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disbursement"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoFields"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoRecordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"brexitProductInfoFieldsCustomsDeclaration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomsDeclaration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conveyance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodsShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodsItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goodsMeasure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tariff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"clientIdentifierVersion"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"goodsShipmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoodsShipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"borderTransportationMean"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identificationType"}},{"kind":"Field","name":{"kind":"Name","value":"journey"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departure"}},{"kind":"Field","name":{"kind":"Name","value":"departureLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transportContractDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transportEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullness"}},{"kind":"Field","name":{"kind":"Name","value":"identification"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"taskFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"backupTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedBySystem"}},{"kind":"Field","name":{"kind":"Name","value":"isFinalConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTaskType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"memoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Memo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"memoRecordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CustomsDeclarationQuery, CustomsDeclarationQueryVariables>;
export const UpdateCustomsDeclarationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomsDeclaration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomsDeclarationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomsDeclaration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"taskFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"taskFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"backupTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedBySystem"}},{"kind":"Field","name":{"kind":"Name","value":"isFinalConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTaskType"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomsDeclarationMutation, UpdateCustomsDeclarationMutationVariables>;
export const ImporterEntityActivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImporterEntityActivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importerEntityActivation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"occurenceTime"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasonCodes"}},{"kind":"Field","name":{"kind":"Name","value":"clarifyDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"backupTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedBySystem"}},{"kind":"Field","name":{"kind":"Name","value":"isFinalConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderTaskType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"forwarders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forwarder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disbursement"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transportationServiceName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredDutyCollectPartyType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipperExternallySourcedDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalReferenceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disbursement"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"usIorFields"}},{"kind":"Field","name":{"kind":"Name","value":"importer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImporterFields"}},{"kind":"Field","name":{"kind":"Name","value":"usIor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"usIorFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"importerEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePortal"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChannel"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"bonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"present"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"past"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"future"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isResident"}},{"kind":"Field","name":{"kind":"Name","value":"isSubmittedBefore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docReadiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalIorReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceType"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTag"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferencePartition"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalClientReferences"}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalValidations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationResult"}},{"kind":"Field","name":{"kind":"Name","value":"companyDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"identification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImporterFields"}},{"kind":"Field","name":{"kind":"Name","value":"importerEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"bonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"present"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"past"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"future"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"surety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isResident"}},{"kind":"Field","name":{"kind":"Name","value":"isSubmittedBefore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docReadiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalValidations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationResult"}},{"kind":"Field","name":{"kind":"Name","value":"companyDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"identification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationDate"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalSystemName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalWebsite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"internalWebsiteName"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientSystem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSystemName"},"name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recordActionFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usIorFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsIor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"cbpStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePortal"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChannel"}},{"kind":"Field","name":{"kind":"Name","value":"cbp5106RejectionReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessStructure"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customsBroker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iorNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"payerUnitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pmsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"poaMethod"}},{"kind":"Field","name":{"kind":"Name","value":"establishment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docReadinessId"}},{"kind":"Field","name":{"kind":"Name","value":"bondApplicationInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDescription"}},{"kind":"Field","name":{"kind":"Name","value":"importsFrom"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDutiesRange"}},{"kind":"Field","name":{"kind":"Name","value":"previousAnnualFeesRange"}},{"kind":"Field","name":{"kind":"Name","value":"customBondApplicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryDutyFlagType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"continuousBonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"present"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"suretyCode"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isResident"}},{"kind":"Field","name":{"kind":"Name","value":"isSubmittedBefore"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImporterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Importer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alternateName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"addressList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivision"}},{"kind":"Field","name":{"kind":"Name","value":"countrySubDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"postOfficeBox"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalRepresentative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryOfficer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identification"}},{"kind":"Field","name":{"kind":"Name","value":"identificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessStructure"}},{"kind":"Field","name":{"kind":"Name","value":"docReadinesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dpsRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"overallDpsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dpsStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<ImporterEntityActivationQuery, ImporterEntityActivationQueryVariables>;
export const UpdateImporterEntityActivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImporterEntityActivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImporterEntityActivationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImporterEntityActivation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateImporterEntityActivationMutation, UpdateImporterEntityActivationMutationVariables>;
export const upsertImporterEntityActivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertImporterEntityActivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertImporterEntityActivationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertImporterEntityActivation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importerEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<upsertImporterEntityActivationMutation, upsertImporterEntityActivationMutationVariables>;